var tF = Object.defineProperty;
var nF = (e, t, n) => t in e ? tF(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ln = (e, t, n) => nF(e, typeof t != "symbol" ? t + "" : t, n);
/**
* @vue/shared v3.4.33
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Lo(e, t) {
  const n = new Set(e.split(","));
  return (r) => n.has(r);
}
const On = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, gf = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], vr = () => {
}, rF = () => !1, ud = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), Xv = (e) => e.startsWith("onUpdate:"), Ln = Object.assign, QS = (e, t) => {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}, aF = Object.prototype.hasOwnProperty, pn = (e, t) => aF.call(e, t), St = Array.isArray, Hu = (e) => cd(e) === "[object Map]", wc = (e) => cd(e) === "[object Set]", SE = (e) => cd(e) === "[object Date]", oF = (e) => cd(e) === "[object RegExp]", Pt = (e) => typeof e == "function", Dn = (e) => typeof e == "string", ps = (e) => typeof e == "symbol", wn = (e) => e !== null && typeof e == "object", fg = (e) => (wn(e) || Pt(e)) && Pt(e.then) && Pt(e.catch), YO = Object.prototype.toString, cd = (e) => YO.call(e), JS = (e) => cd(e).slice(8, -1), qO = (e) => cd(e) === "[object Object]", e_ = (e) => Dn(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, yf = /* @__PURE__ */ Lo(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), iF = /* @__PURE__ */ Lo(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), dg = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, sF = /-(\w)/g, Ia = dg((e) => e.replace(sF, (t, n) => n ? n.toUpperCase() : "")), lF = /\B([A-Z])/g, na = dg(
  (e) => e.replace(lF, "-$1").toLowerCase()
), Kl = dg((e) => e.charAt(0).toUpperCase() + e.slice(1)), Ns = dg((e) => e ? `on${Kl(e)}` : ""), Ui = (e, t) => !Object.is(e, t), Ol = (e, ...t) => {
  for (let n = 0; n < e.length; n++)
    e[n](...t);
}, Mf = (e, t, n, r = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: r,
    value: n
  });
}, Zv = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, Qv = (e) => {
  const t = Dn(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let _E;
const t_ = () => _E || (_E = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {}), uF = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error", cF = /* @__PURE__ */ Lo(uF);
function _r(e) {
  if (St(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const r = e[n], a = Dn(r) ? hF(r) : _r(r);
      if (a)
        for (const o in a)
          t[o] = a[o];
    }
    return t;
  } else if (Dn(e) || wn(e))
    return e;
}
const fF = /;(?![^(]*\))/g, dF = /:([^]+)/, pF = /\/\*[^]*?\*\//g;
function hF(e) {
  const t = {};
  return e.replace(pF, "").split(fF).forEach((n) => {
    if (n) {
      const r = n.split(dF);
      r.length > 1 && (t[r[0].trim()] = r[1].trim());
    }
  }), t;
}
function vF(e) {
  let t = "";
  if (!e || Dn(e))
    return t;
  for (const n in e) {
    const r = e[n];
    if (Dn(r) || typeof r == "number") {
      const a = n.startsWith("--") ? n : na(n);
      t += `${a}:${r};`;
    }
  }
  return t;
}
function tn(e) {
  let t = "";
  if (Dn(e))
    t = e;
  else if (St(e))
    for (let n = 0; n < e.length; n++) {
      const r = tn(e[n]);
      r && (t += r + " ");
    }
  else if (wn(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
function XO(e) {
  if (!e) return null;
  let { class: t, style: n } = e;
  return t && !Dn(t) && (e.class = tn(t)), n && (e.style = _r(n)), e;
}
const mF = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot", gF = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view", yF = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics", xF = /* @__PURE__ */ Lo(mF), bF = /* @__PURE__ */ Lo(gF), wF = /* @__PURE__ */ Lo(yF), ZO = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", SF = /* @__PURE__ */ Lo(ZO), CE = /* @__PURE__ */ Lo(
  ZO + ",async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected"
);
function n_(e) {
  return !!e || e === "";
}
const _F = /* @__PURE__ */ Lo(
  "accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap"
), CF = /* @__PURE__ */ Lo(
  "xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan"
);
function EF(e) {
  if (e == null)
    return !1;
  const t = typeof e;
  return t === "string" || t === "number" || t === "boolean";
}
function TF(e, t) {
  if (e.length !== t.length) return !1;
  let n = !0;
  for (let r = 0; n && r < e.length; r++)
    n = Yl(e[r], t[r]);
  return n;
}
function Yl(e, t) {
  if (e === t) return !0;
  let n = SE(e), r = SE(t);
  if (n || r)
    return n && r ? e.getTime() === t.getTime() : !1;
  if (n = ps(e), r = ps(t), n || r)
    return e === t;
  if (n = St(e), r = St(t), n || r)
    return n && r ? TF(e, t) : !1;
  if (n = wn(e), r = wn(t), n || r) {
    if (!n || !r)
      return !1;
    const a = Object.keys(e).length, o = Object.keys(t).length;
    if (a !== o)
      return !1;
    for (const i in e) {
      const s = e.hasOwnProperty(i), l = t.hasOwnProperty(i);
      if (s && !l || !s && l || !Yl(e[i], t[i]))
        return !1;
    }
  }
  return String(e) === String(t);
}
function pg(e, t) {
  return e.findIndex((n) => Yl(n, t));
}
const QO = (e) => !!(e && e.__v_isRef === !0), Wt = (e) => Dn(e) ? e : e == null ? "" : St(e) || wn(e) && (e.toString === YO || !Pt(e.toString)) ? QO(e) ? Wt(e.value) : JSON.stringify(e, JO, 2) : String(e), JO = (e, t) => QO(t) ? JO(e, t.value) : Hu(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (n, [r, a], o) => (n[Z1(r, o) + " =>"] = a, n),
    {}
  )
} : wc(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((n) => Z1(n))
} : ps(t) ? Z1(t) : wn(t) && !St(t) && !qO(t) ? String(t) : t, Z1 = (e, t = "") => {
  var n;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    ps(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e
  );
};
/**
* @vue/reactivity v3.4.33
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function hs(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let To;
class r_ {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this.parent = To, !t && To && (this.index = (To.scopes || (To.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  run(t) {
    if (this._active) {
      const n = To;
      try {
        return To = this, t();
      } finally {
        To = n;
      }
    } else process.env.NODE_ENV !== "production" && hs("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    To = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    To = this.parent;
  }
  stop(t) {
    if (this._active) {
      let n, r;
      for (n = 0, r = this.effects.length; n < r; n++)
        this.effects[n].stop();
      for (n = 0, r = this.cleanups.length; n < r; n++)
        this.cleanups[n]();
      if (this.scopes)
        for (n = 0, r = this.scopes.length; n < r; n++)
          this.scopes[n].stop(!0);
      if (!this.detached && this.parent && !t) {
        const a = this.parent.scopes.pop();
        a && a !== this && (this.parent.scopes[this.index] = a, a.index = this.index);
      }
      this.parent = void 0, this._active = !1;
    }
  }
}
function hg(e) {
  return new r_(e);
}
function e9(e, t = To) {
  t && t.active && t.effects.push(e);
}
function fd() {
  return To;
}
function vg(e) {
  To ? To.cleanups.push(e) : process.env.NODE_ENV !== "production" && hs(
    "onScopeDispose() is called when there is no active effect scope to be associated with."
  );
}
let ju;
class Rf {
  constructor(t, n, r, a) {
    this.fn = t, this.trigger = n, this.scheduler = r, this.active = !0, this.deps = [], this._dirtyLevel = 4, this._trackId = 0, this._runnings = 0, this._shouldSchedule = !1, this._depsLength = 0, e9(this, a);
  }
  get dirty() {
    if (this._dirtyLevel === 2 || this._dirtyLevel === 3) {
      this._dirtyLevel = 1, nl();
      for (let t = 0; t < this._depsLength; t++) {
        const n = this.deps[t];
        if (n.computed && ($F(n.computed), this._dirtyLevel >= 4))
          break;
      }
      this._dirtyLevel === 1 && (this._dirtyLevel = 0), rl();
    }
    return this._dirtyLevel >= 4;
  }
  set dirty(t) {
    this._dirtyLevel = t ? 4 : 0;
  }
  run() {
    if (this._dirtyLevel = 0, !this.active)
      return this.fn();
    let t = jl, n = ju;
    try {
      return jl = !0, ju = this, this._runnings++, EE(this), this.fn();
    } finally {
      TE(this), this._runnings--, ju = n, jl = t;
    }
  }
  stop() {
    this.active && (EE(this), TE(this), this.onStop && this.onStop(), this.active = !1);
  }
}
function $F(e) {
  return e.value;
}
function EE(e) {
  e._trackId++, e._depsLength = 0;
}
function TE(e) {
  if (e.deps.length > e._depsLength) {
    for (let t = e._depsLength; t < e.deps.length; t++)
      t9(e.deps[t], e);
    e.deps.length = e._depsLength;
  }
}
function t9(e, t) {
  const n = e.get(t);
  n !== void 0 && t._trackId !== n && (e.delete(t), e.size === 0 && e.cleanup());
}
function OF(e, t) {
  e.effect instanceof Rf && (e = e.effect.fn);
  const n = new Rf(e, vr, () => {
    n.dirty && n.run();
  });
  t && (Ln(n, t), t.scope && e9(n, t.scope)), (!t || !t.lazy) && n.run();
  const r = n.run.bind(n);
  return r.effect = n, r;
}
function AF(e) {
  e.effect.stop();
}
let jl = !0, Vx = 0;
const n9 = [];
function nl() {
  n9.push(jl), jl = !1;
}
function rl() {
  const e = n9.pop();
  jl = e === void 0 ? !0 : e;
}
function a_() {
  Vx++;
}
function o_() {
  for (Vx--; !Vx && Ux.length; )
    Ux.shift()();
}
function r9(e, t, n) {
  var r;
  if (t.get(e) !== e._trackId) {
    t.set(e, e._trackId);
    const a = e.deps[e._depsLength];
    a !== t ? (a && t9(a, e), e.deps[e._depsLength++] = t) : e._depsLength++, process.env.NODE_ENV !== "production" && ((r = e.onTrack) == null || r.call(e, Ln({ effect: e }, n)));
  }
}
const Ux = [];
function a9(e, t, n) {
  var r;
  a_();
  for (const a of e.keys()) {
    let o;
    a._dirtyLevel < t && (o ?? (o = e.get(a) === a._trackId)) && (a._shouldSchedule || (a._shouldSchedule = a._dirtyLevel === 0), a._dirtyLevel = t), a._shouldSchedule && (o ?? (o = e.get(a) === a._trackId)) && (process.env.NODE_ENV !== "production" && ((r = a.onTrigger) == null || r.call(a, Ln({ effect: a }, n))), a.trigger(), (!a._runnings || a.allowRecurse) && a._dirtyLevel !== 2 && (a._shouldSchedule = !1, a.scheduler && Ux.push(a.scheduler)));
  }
  o_();
}
const o9 = (e, t) => {
  const n = /* @__PURE__ */ new Map();
  return n.cleanup = e, n.computed = t, n;
}, Jv = /* @__PURE__ */ new WeakMap(), Vu = Symbol(process.env.NODE_ENV !== "production" ? "iterate" : ""), zx = Symbol(process.env.NODE_ENV !== "production" ? "Map key iterate" : "");
function da(e, t, n) {
  if (jl && ju) {
    let r = Jv.get(e);
    r || Jv.set(e, r = /* @__PURE__ */ new Map());
    let a = r.get(n);
    a || r.set(n, a = o9(() => r.delete(n))), r9(
      ju,
      a,
      process.env.NODE_ENV !== "production" ? {
        target: e,
        type: t,
        key: n
      } : void 0
    );
  }
}
function os(e, t, n, r, a, o) {
  const i = Jv.get(e);
  if (!i)
    return;
  let s = [];
  if (t === "clear")
    s = [...i.values()];
  else if (n === "length" && St(e)) {
    const l = Number(r);
    i.forEach((u, c) => {
      (c === "length" || !ps(c) && c >= l) && s.push(u);
    });
  } else
    switch (n !== void 0 && s.push(i.get(n)), t) {
      case "add":
        St(e) ? e_(n) && s.push(i.get("length")) : (s.push(i.get(Vu)), Hu(e) && s.push(i.get(zx)));
        break;
      case "delete":
        St(e) || (s.push(i.get(Vu)), Hu(e) && s.push(i.get(zx)));
        break;
      case "set":
        Hu(e) && s.push(i.get(Vu));
        break;
    }
  a_();
  for (const l of s)
    l && a9(
      l,
      4,
      process.env.NODE_ENV !== "production" ? {
        target: e,
        type: t,
        key: n,
        newValue: r,
        oldValue: a,
        oldTarget: o
      } : void 0
    );
  o_();
}
function IF(e, t) {
  const n = Jv.get(e);
  return n && n.get(t);
}
const PF = /* @__PURE__ */ Lo("__proto__,__v_isRef,__isVue"), i9 = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(ps)
), $E = /* @__PURE__ */ DF();
function DF() {
  const e = {};
  return ["includes", "indexOf", "lastIndexOf"].forEach((t) => {
    e[t] = function(...n) {
      const r = At(this);
      for (let o = 0, i = this.length; o < i; o++)
        da(r, "get", o + "");
      const a = r[t](...n);
      return a === -1 || a === !1 ? r[t](...n.map(At)) : a;
    };
  }), ["push", "pop", "shift", "unshift", "splice"].forEach((t) => {
    e[t] = function(...n) {
      nl(), a_();
      const r = At(this)[t].apply(this, n);
      return o_(), rl(), r;
    };
  }), e;
}
function kF(e) {
  ps(e) || (e = String(e));
  const t = At(this);
  return da(t, "has", e), t.hasOwnProperty(e);
}
class s9 {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, r) {
    const a = this._isReadonly, o = this._isShallow;
    if (n === "__v_isReactive")
      return !a;
    if (n === "__v_isReadonly")
      return a;
    if (n === "__v_isShallow")
      return o;
    if (n === "__v_raw")
      return r === (a ? o ? h9 : p9 : o ? d9 : f9).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the reciever is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(r) ? t : void 0;
    const i = St(t);
    if (!a) {
      if (i && pn($E, n))
        return Reflect.get($E, n, r);
      if (n === "hasOwnProperty")
        return kF;
    }
    const s = Reflect.get(t, n, r);
    return (ps(n) ? i9.has(n) : PF(n)) || (a || da(t, "get", n), o) ? s : Ft(s) ? i && e_(n) ? s : s.value : wn(s) ? a ? ql(s) : Wn(s) : s;
  }
}
class l9 extends s9 {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, r, a) {
    let o = t[n];
    if (!this._isShallow) {
      const l = vs(o);
      if (!is(r) && !vs(r) && (o = At(o), r = At(r)), !St(t) && Ft(o) && !Ft(r))
        return l ? !1 : (o.value = r, !0);
    }
    const i = St(t) && e_(n) ? Number(n) < t.length : pn(t, n), s = Reflect.set(t, n, r, a);
    return t === At(a) && (i ? Ui(r, o) && os(t, "set", n, r, o) : os(t, "add", n, r)), s;
  }
  deleteProperty(t, n) {
    const r = pn(t, n), a = t[n], o = Reflect.deleteProperty(t, n);
    return o && r && os(t, "delete", n, void 0, a), o;
  }
  has(t, n) {
    const r = Reflect.has(t, n);
    return (!ps(n) || !i9.has(n)) && da(t, "has", n), r;
  }
  ownKeys(t) {
    return da(
      t,
      "iterate",
      St(t) ? "length" : Vu
    ), Reflect.ownKeys(t);
  }
}
class u9 extends s9 {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return process.env.NODE_ENV !== "production" && hs(
      `Set operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, n) {
    return process.env.NODE_ENV !== "production" && hs(
      `Delete operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const MF = /* @__PURE__ */ new l9(), RF = /* @__PURE__ */ new u9(), NF = /* @__PURE__ */ new l9(
  !0
), FF = /* @__PURE__ */ new u9(!0), i_ = (e) => e, mg = (e) => Reflect.getPrototypeOf(e);
function mh(e, t, n = !1, r = !1) {
  e = e.__v_raw;
  const a = At(e), o = At(t);
  n || (Ui(t, o) && da(a, "get", t), da(a, "get", o));
  const { has: i } = mg(a), s = r ? i_ : n ? s_ : U0;
  if (i.call(a, t))
    return s(e.get(t));
  if (i.call(a, o))
    return s(e.get(o));
  e !== a && e.get(t);
}
function gh(e, t = !1) {
  const n = this.__v_raw, r = At(n), a = At(e);
  return t || (Ui(e, a) && da(r, "has", e), da(r, "has", a)), e === a ? n.has(e) : n.has(e) || n.has(a);
}
function yh(e, t = !1) {
  return e = e.__v_raw, !t && da(At(e), "iterate", Vu), Reflect.get(e, "size", e);
}
function OE(e, t = !1) {
  !t && !is(e) && !vs(e) && (e = At(e));
  const n = At(this);
  return mg(n).has.call(n, e) || (n.add(e), os(n, "add", e, e)), this;
}
function AE(e, t, n = !1) {
  !n && !is(t) && !vs(t) && (t = At(t));
  const r = At(this), { has: a, get: o } = mg(r);
  let i = a.call(r, e);
  i ? process.env.NODE_ENV !== "production" && c9(r, a, e) : (e = At(e), i = a.call(r, e));
  const s = o.call(r, e);
  return r.set(e, t), i ? Ui(t, s) && os(r, "set", e, t, s) : os(r, "add", e, t), this;
}
function IE(e) {
  const t = At(this), { has: n, get: r } = mg(t);
  let a = n.call(t, e);
  a ? process.env.NODE_ENV !== "production" && c9(t, n, e) : (e = At(e), a = n.call(t, e));
  const o = r ? r.call(t, e) : void 0, i = t.delete(e);
  return a && os(t, "delete", e, void 0, o), i;
}
function PE() {
  const e = At(this), t = e.size !== 0, n = process.env.NODE_ENV !== "production" ? Hu(e) ? new Map(e) : new Set(e) : void 0, r = e.clear();
  return t && os(e, "clear", void 0, void 0, n), r;
}
function xh(e, t) {
  return function(r, a) {
    const o = this, i = o.__v_raw, s = At(i), l = t ? i_ : e ? s_ : U0;
    return !e && da(s, "iterate", Vu), i.forEach((u, c) => r.call(a, l(u), l(c), o));
  };
}
function bh(e, t, n) {
  return function(...r) {
    const a = this.__v_raw, o = At(a), i = Hu(o), s = e === "entries" || e === Symbol.iterator && i, l = e === "keys" && i, u = a[e](...r), c = n ? i_ : t ? s_ : U0;
    return !t && da(
      o,
      "iterate",
      l ? zx : Vu
    ), {
      // iterator protocol
      next() {
        const { value: f, done: d } = u.next();
        return d ? { value: f, done: d } : {
          value: s ? [c(f[0]), c(f[1])] : c(f),
          done: d
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function yl(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const n = t[0] ? `on key "${t[0]}" ` : "";
      hs(
        `${Kl(e)} operation ${n}failed: target is readonly.`,
        At(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function LF() {
  const e = {
    get(o) {
      return mh(this, o);
    },
    get size() {
      return yh(this);
    },
    has: gh,
    add: OE,
    set: AE,
    delete: IE,
    clear: PE,
    forEach: xh(!1, !1)
  }, t = {
    get(o) {
      return mh(this, o, !1, !0);
    },
    get size() {
      return yh(this);
    },
    has: gh,
    add(o) {
      return OE.call(this, o, !0);
    },
    set(o, i) {
      return AE.call(this, o, i, !0);
    },
    delete: IE,
    clear: PE,
    forEach: xh(!1, !0)
  }, n = {
    get(o) {
      return mh(this, o, !0);
    },
    get size() {
      return yh(this, !0);
    },
    has(o) {
      return gh.call(this, o, !0);
    },
    add: yl("add"),
    set: yl("set"),
    delete: yl("delete"),
    clear: yl("clear"),
    forEach: xh(!0, !1)
  }, r = {
    get(o) {
      return mh(this, o, !0, !0);
    },
    get size() {
      return yh(this, !0);
    },
    has(o) {
      return gh.call(this, o, !0);
    },
    add: yl("add"),
    set: yl("set"),
    delete: yl("delete"),
    clear: yl("clear"),
    forEach: xh(!0, !0)
  };
  return [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((o) => {
    e[o] = bh(o, !1, !1), n[o] = bh(o, !0, !1), t[o] = bh(o, !1, !0), r[o] = bh(
      o,
      !0,
      !0
    );
  }), [
    e,
    n,
    t,
    r
  ];
}
const [
  BF,
  HF,
  jF,
  VF
] = /* @__PURE__ */ LF();
function gg(e, t) {
  const n = t ? e ? VF : jF : e ? HF : BF;
  return (r, a, o) => a === "__v_isReactive" ? !e : a === "__v_isReadonly" ? e : a === "__v_raw" ? r : Reflect.get(
    pn(n, a) && a in r ? n : r,
    a,
    o
  );
}
const UF = {
  get: /* @__PURE__ */ gg(!1, !1)
}, zF = {
  get: /* @__PURE__ */ gg(!1, !0)
}, WF = {
  get: /* @__PURE__ */ gg(!0, !1)
}, GF = {
  get: /* @__PURE__ */ gg(!0, !0)
};
function c9(e, t, n) {
  const r = At(n);
  if (r !== n && t.call(e, r)) {
    const a = JS(e);
    hs(
      `Reactive ${a} contains both the raw and reactive versions of the same object${a === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const f9 = /* @__PURE__ */ new WeakMap(), d9 = /* @__PURE__ */ new WeakMap(), p9 = /* @__PURE__ */ new WeakMap(), h9 = /* @__PURE__ */ new WeakMap();
function KF(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function YF(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : KF(JS(e));
}
function Wn(e) {
  return vs(e) ? e : yg(
    e,
    !1,
    MF,
    UF,
    f9
  );
}
function v9(e) {
  return yg(
    e,
    !1,
    NF,
    zF,
    d9
  );
}
function ql(e) {
  return yg(
    e,
    !0,
    RF,
    WF,
    p9
  );
}
function Ri(e) {
  return yg(
    e,
    !0,
    FF,
    GF,
    h9
  );
}
function yg(e, t, n, r, a) {
  if (!wn(e))
    return process.env.NODE_ENV !== "production" && hs(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const o = a.get(e);
  if (o)
    return o;
  const i = YF(e);
  if (i === 0)
    return e;
  const s = new Proxy(
    e,
    i === 2 ? r : n
  );
  return a.set(e, s), s;
}
function ai(e) {
  return vs(e) ? ai(e.__v_raw) : !!(e && e.__v_isReactive);
}
function vs(e) {
  return !!(e && e.__v_isReadonly);
}
function is(e) {
  return !!(e && e.__v_isShallow);
}
function V0(e) {
  return e ? !!e.__v_raw : !1;
}
function At(e) {
  const t = e && e.__v_raw;
  return t ? At(t) : e;
}
function Hs(e) {
  return Object.isExtensible(e) && Mf(e, "__v_skip", !0), e;
}
const U0 = (e) => wn(e) ? Wn(e) : e, s_ = (e) => wn(e) ? ql(e) : e, qF = "Computed is still dirty after getter evaluation, likely because a computed is mutating its own dependency in its getter. State mutations in computed getters should be avoided.  Check the docs for more details: https://vuejs.org/guide/essentials/computed.html#getters-should-be-side-effect-free";
class m9 {
  constructor(t, n, r, a) {
    this.getter = t, this._setter = n, this.dep = void 0, this.__v_isRef = !0, this.__v_isReadonly = !1, this.effect = new Rf(
      () => t(this._value),
      () => xf(
        this,
        this.effect._dirtyLevel === 2 ? 2 : 3
      )
    ), this.effect.computed = this, this.effect.active = this._cacheable = !a, this.__v_isReadonly = r;
  }
  get value() {
    const t = At(this);
    return (!t._cacheable || t.effect.dirty) && Ui(t._value, t._value = t.effect.run()) && xf(t, 4), l_(t), t.effect._dirtyLevel >= 2 && (process.env.NODE_ENV !== "production" && this._warnRecursive && hs(qF, `

getter: `, this.getter), xf(t, 2)), t._value;
  }
  set value(t) {
    this._setter(t);
  }
  // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
  get _dirty() {
    return this.effect.dirty;
  }
  set _dirty(t) {
    this.effect.dirty = t;
  }
  // #endregion
}
function XF(e, t, n = !1) {
  let r, a;
  const o = Pt(e);
  o ? (r = e, a = process.env.NODE_ENV !== "production" ? () => {
    hs("Write operation failed: computed value is readonly");
  } : vr) : (r = e.get, a = e.set);
  const i = new m9(r, a, o || !a, n);
  return process.env.NODE_ENV !== "production" && t && !n && (i.effect.onTrack = t.onTrack, i.effect.onTrigger = t.onTrigger), i;
}
function l_(e) {
  var t;
  jl && ju && (e = At(e), r9(
    ju,
    (t = e.dep) != null ? t : e.dep = o9(
      () => e.dep = void 0,
      e instanceof m9 ? e : void 0
    ),
    process.env.NODE_ENV !== "production" ? {
      target: e,
      type: "get",
      key: "value"
    } : void 0
  ));
}
function xf(e, t = 4, n, r) {
  e = At(e);
  const a = e.dep;
  a && a9(
    a,
    t,
    process.env.NODE_ENV !== "production" ? {
      target: e,
      type: "set",
      key: "value",
      newValue: n,
      oldValue: r
    } : void 0
  );
}
function Ft(e) {
  return !!(e && e.__v_isRef === !0);
}
function ne(e) {
  return g9(e, !1);
}
function Be(e) {
  return g9(e, !0);
}
function g9(e, t) {
  return Ft(e) ? e : new ZF(e, t);
}
class ZF {
  constructor(t, n) {
    this.__v_isShallow = n, this.dep = void 0, this.__v_isRef = !0, this._rawValue = n ? t : At(t), this._value = n ? t : U0(t);
  }
  get value() {
    return l_(this), this._value;
  }
  set value(t) {
    const n = this.__v_isShallow || is(t) || vs(t);
    if (t = n ? t : At(t), Ui(t, this._rawValue)) {
      const r = this._rawValue;
      this._rawValue = t, this._value = n ? t : U0(t), xf(this, 4, t, r);
    }
  }
}
function y9(e) {
  xf(e, 4, process.env.NODE_ENV !== "production" ? e.value : void 0);
}
function U(e) {
  return Ft(e) ? e.value : e;
}
function QF(e) {
  return Pt(e) ? e() : U(e);
}
const JF = {
  get: (e, t, n) => U(Reflect.get(e, t, n)),
  set: (e, t, n, r) => {
    const a = e[t];
    return Ft(a) && !Ft(n) ? (a.value = n, !0) : Reflect.set(e, t, n, r);
  }
};
function u_(e) {
  return ai(e) ? e : new Proxy(e, JF);
}
class eL {
  constructor(t) {
    this.dep = void 0, this.__v_isRef = !0;
    const { get: n, set: r } = t(
      () => l_(this),
      () => xf(this)
    );
    this._get = n, this._set = r;
  }
  get value() {
    return this._get();
  }
  set value(t) {
    this._set(t);
  }
}
function xg(e) {
  return new eL(e);
}
function ac(e) {
  process.env.NODE_ENV !== "production" && !V0(e) && hs("toRefs() expects a reactive object but received a plain one.");
  const t = St(e) ? new Array(e.length) : {};
  for (const n in e)
    t[n] = x9(e, n);
  return t;
}
class tL {
  constructor(t, n, r) {
    this._object = t, this._key = n, this._defaultValue = r, this.__v_isRef = !0;
  }
  get value() {
    const t = this._object[this._key];
    return t === void 0 ? this._defaultValue : t;
  }
  set value(t) {
    this._object[this._key] = t;
  }
  get dep() {
    return IF(At(this._object), this._key);
  }
}
class nL {
  constructor(t) {
    this._getter = t, this.__v_isRef = !0, this.__v_isReadonly = !0;
  }
  get value() {
    return this._getter();
  }
}
function Tt(e, t, n) {
  return Ft(e) ? e : Pt(e) ? new nL(e) : wn(e) && arguments.length > 1 ? x9(e, t, n) : ne(e);
}
function x9(e, t, n) {
  const r = e[t];
  return Ft(r) ? r : new tL(e, t, n);
}
const rL = {
  GET: "get",
  HAS: "has",
  ITERATE: "iterate"
}, aL = {
  SET: "set",
  ADD: "add",
  DELETE: "delete",
  CLEAR: "clear"
};
/**
* @vue/runtime-core v3.4.33
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const Uu = [];
function f0(e) {
  Uu.push(e);
}
function d0() {
  Uu.pop();
}
let Q1 = !1;
function qe(e, ...t) {
  if (Q1) return;
  Q1 = !0, nl();
  const n = Uu.length ? Uu[Uu.length - 1].component : null, r = n && n.appContext.config.warnHandler, a = oL();
  if (r)
    ss(
      r,
      n,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((o) => {
          var i, s;
          return (s = (i = o.toString) == null ? void 0 : i.call(o)) != null ? s : JSON.stringify(o);
        }).join(""),
        n && n.proxy,
        a.map(
          ({ vnode: o }) => `at <${Og(n, o.type)}>`
        ).join(`
`),
        a
      ]
    );
  else {
    const o = [`[Vue warn]: ${e}`, ...t];
    a.length && o.push(`
`, ...iL(a)), console.warn(...o);
  }
  rl(), Q1 = !1;
}
function oL() {
  let e = Uu[Uu.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const n = t[0];
    n && n.vnode === e ? n.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const r = e.component && e.component.parent;
    e = r && r.vnode;
  }
  return t;
}
function iL(e) {
  const t = [];
  return e.forEach((n, r) => {
    t.push(...r === 0 ? [] : [`
`], ...sL(n));
  }), t;
}
function sL({ vnode: e, recurseCount: t }) {
  const n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, a = ` at <${Og(
    e.component,
    e.type,
    r
  )}`, o = ">" + n;
  return e.props ? [a, ...lL(e.props), o] : [a + o];
}
function lL(e) {
  const t = [], n = Object.keys(e);
  return n.slice(0, 3).forEach((r) => {
    t.push(...b9(r, e[r]));
  }), n.length > 3 && t.push(" ..."), t;
}
function b9(e, t, n) {
  return Dn(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : Ft(t) ? (t = b9(e, At(t.value), !0), n ? t : [`${e}=Ref<`, t, ">"]) : Pt(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = At(t), n ? t : [`${e}=`, t]);
}
function c_(e, t) {
  process.env.NODE_ENV !== "production" && e !== void 0 && (typeof e != "number" ? qe(`${t} is not a valid number - got ${JSON.stringify(e)}.`) : isNaN(e) && qe(`${t} is NaN - the duration expression might be incorrect.`));
}
const uL = {
  SETUP_FUNCTION: 0,
  0: "SETUP_FUNCTION",
  RENDER_FUNCTION: 1,
  1: "RENDER_FUNCTION",
  WATCH_GETTER: 2,
  2: "WATCH_GETTER",
  WATCH_CALLBACK: 3,
  3: "WATCH_CALLBACK",
  WATCH_CLEANUP: 4,
  4: "WATCH_CLEANUP",
  NATIVE_EVENT_HANDLER: 5,
  5: "NATIVE_EVENT_HANDLER",
  COMPONENT_EVENT_HANDLER: 6,
  6: "COMPONENT_EVENT_HANDLER",
  VNODE_HOOK: 7,
  7: "VNODE_HOOK",
  DIRECTIVE_HOOK: 8,
  8: "DIRECTIVE_HOOK",
  TRANSITION_HOOK: 9,
  9: "TRANSITION_HOOK",
  APP_ERROR_HANDLER: 10,
  10: "APP_ERROR_HANDLER",
  APP_WARN_HANDLER: 11,
  11: "APP_WARN_HANDLER",
  FUNCTION_REF: 12,
  12: "FUNCTION_REF",
  ASYNC_COMPONENT_LOADER: 13,
  13: "ASYNC_COMPONENT_LOADER",
  SCHEDULER: 14,
  14: "SCHEDULER",
  COMPONENT_UPDATE: 15,
  15: "COMPONENT_UPDATE"
}, bg = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update"
};
function ss(e, t, n, r) {
  try {
    return r ? e(...r) : e();
  } catch (a) {
    lu(a, t, n);
  }
}
function Ro(e, t, n, r) {
  if (Pt(e)) {
    const a = ss(e, t, n, r);
    return a && fg(a) && a.catch((o) => {
      lu(o, t, n);
    }), a;
  }
  if (St(e)) {
    const a = [];
    for (let o = 0; o < e.length; o++)
      a.push(Ro(e[o], t, n, r));
    return a;
  } else process.env.NODE_ENV !== "production" && qe(
    `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`
  );
}
function lu(e, t, n, r = !0) {
  const a = t ? t.vnode : null;
  if (t) {
    let o = t.parent;
    const i = t.proxy, s = process.env.NODE_ENV !== "production" ? bg[n] : `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; o; ) {
      const u = o.ec;
      if (u) {
        for (let c = 0; c < u.length; c++)
          if (u[c](e, i, s) === !1)
            return;
      }
      o = o.parent;
    }
    const l = t.appContext.config.errorHandler;
    if (l) {
      nl(), ss(
        l,
        null,
        10,
        [e, i, s]
      ), rl();
      return;
    }
  }
  cL(e, n, a, r);
}
function cL(e, t, n, r = !0) {
  if (process.env.NODE_ENV !== "production") {
    const a = bg[t];
    if (n && f0(n), qe(`Unhandled error${a ? ` during execution of ${a}` : ""}`), n && d0(), r)
      throw e;
    console.error(e);
  } else
    console.error(e);
}
let z0 = !1, Wx = !1;
const Ca = [];
let ts = 0;
const bf = [];
let Cl = null, Iu = 0;
const w9 = /* @__PURE__ */ Promise.resolve();
let f_ = null;
const fL = 100;
function nn(e) {
  const t = f_ || w9;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function dL(e) {
  let t = ts + 1, n = Ca.length;
  for (; t < n; ) {
    const r = t + n >>> 1, a = Ca[r], o = G0(a);
    o < e || o === e && a.pre ? t = r + 1 : n = r;
  }
  return t;
}
function Op(e) {
  (!Ca.length || !Ca.includes(
    e,
    z0 && e.allowRecurse ? ts + 1 : ts
  )) && (e.id == null ? Ca.push(e) : Ca.splice(dL(e.id), 0, e), S9());
}
function S9() {
  !z0 && !Wx && (Wx = !0, f_ = w9.then(_9));
}
function pL(e) {
  const t = Ca.indexOf(e);
  t > ts && Ca.splice(t, 1);
}
function W0(e) {
  St(e) ? bf.push(...e) : (!Cl || !Cl.includes(
    e,
    e.allowRecurse ? Iu + 1 : Iu
  )) && bf.push(e), S9();
}
function DE(e, t, n = z0 ? ts + 1 : 0) {
  for (process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()); n < Ca.length; n++) {
    const r = Ca[n];
    if (r && r.pre) {
      if (e && r.id !== e.uid || process.env.NODE_ENV !== "production" && d_(t, r))
        continue;
      Ca.splice(n, 1), n--, r();
    }
  }
}
function em(e) {
  if (bf.length) {
    const t = [...new Set(bf)].sort(
      (n, r) => G0(n) - G0(r)
    );
    if (bf.length = 0, Cl) {
      Cl.push(...t);
      return;
    }
    for (Cl = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), Iu = 0; Iu < Cl.length; Iu++) {
      const n = Cl[Iu];
      process.env.NODE_ENV !== "production" && d_(e, n) || n.active !== !1 && n();
    }
    Cl = null, Iu = 0;
  }
}
const G0 = (e) => e.id == null ? 1 / 0 : e.id, hL = (e, t) => {
  const n = G0(e) - G0(t);
  if (n === 0) {
    if (e.pre && !t.pre) return -1;
    if (t.pre && !e.pre) return 1;
  }
  return n;
};
function _9(e) {
  Wx = !1, z0 = !0, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), Ca.sort(hL);
  const t = process.env.NODE_ENV !== "production" ? (n) => d_(e, n) : vr;
  try {
    for (ts = 0; ts < Ca.length; ts++) {
      const n = Ca[ts];
      if (n && n.active !== !1) {
        if (process.env.NODE_ENV !== "production" && t(n))
          continue;
        ss(
          n,
          n.i,
          n.i ? 15 : 14
        );
      }
    }
  } finally {
    ts = 0, Ca.length = 0, em(e), z0 = !1, f_ = null, (Ca.length || bf.length) && _9(e);
  }
}
function d_(e, t) {
  if (!e.has(t))
    e.set(t, 1);
  else {
    const n = e.get(t);
    if (n > fL) {
      const r = t.i, a = r && X0(r.type);
      return lu(
        `Maximum recursive updates exceeded${a ? ` in component <${a}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
        null,
        10
      ), !0;
    } else
      e.set(t, n + 1);
  }
}
let Vl = !1;
const bv = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (t_().__VUE_HMR_RUNTIME__ = {
  createRecord: J1(C9),
  rerender: J1(gL),
  reload: J1(yL)
});
const oc = /* @__PURE__ */ new Map();
function vL(e) {
  const t = e.type.__hmrId;
  let n = oc.get(t);
  n || (C9(t, e.type), n = oc.get(t)), n.instances.add(e);
}
function mL(e) {
  oc.get(e.type.__hmrId).instances.delete(e);
}
function C9(e, t) {
  return oc.has(e) ? !1 : (oc.set(e, {
    initialDef: tm(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function tm(e) {
  return OA(e) ? e.__vccOpts : e;
}
function gL(e, t) {
  const n = oc.get(e);
  n && (n.initialDef.render = t, [...n.instances].forEach((r) => {
    t && (r.render = t, tm(r.type).render = t), r.renderCache = [], Vl = !0, r.effect.dirty = !0, r.update(), Vl = !1;
  }));
}
function yL(e, t) {
  const n = oc.get(e);
  if (!n) return;
  t = tm(t), kE(n.initialDef, t);
  const r = [...n.instances];
  for (let a = 0; a < r.length; a++) {
    const o = r[a], i = tm(o.type);
    let s = bv.get(i);
    s || (i !== n.initialDef && kE(i, t), bv.set(i, s = /* @__PURE__ */ new Set())), s.add(o), o.appContext.propsCache.delete(o.type), o.appContext.emitsCache.delete(o.type), o.appContext.optionsCache.delete(o.type), o.ceReload ? (s.add(o), o.ceReload(t.styles), s.delete(o)) : o.parent ? (o.parent.effect.dirty = !0, Op(() => {
      o.parent.update(), s.delete(o);
    })) : o.appContext.reload ? o.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    );
  }
  W0(() => {
    bv.clear();
  });
}
function kE(e, t) {
  Ln(e, t);
  for (const n in e)
    n !== "__file" && !(n in t) && delete e[n];
}
function J1(e) {
  return (t, n) => {
    try {
      return e(t, n);
    } catch (r) {
      console.error(r), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let Pi, qd = [], Gx = !1;
function Ap(e, ...t) {
  Pi ? Pi.emit(e, ...t) : Gx || qd.push({ event: e, args: t });
}
function p_(e, t) {
  var n, r;
  Pi = e, Pi ? (Pi.enabled = !0, qd.forEach(({ event: a, args: o }) => Pi.emit(a, ...o)), qd = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((r = (n = window.navigator) == null ? void 0 : n.userAgent) != null && r.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((o) => {
    p_(o, t);
  }), setTimeout(() => {
    Pi || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, Gx = !0, qd = []);
  }, 3e3)) : (Gx = !0, qd = []);
}
function xL(e, t) {
  Ap("app:init", e, t, {
    Fragment: dt,
    Text: Bi,
    Comment: tr,
    Static: Ul
  });
}
function bL(e) {
  Ap("app:unmount", e);
}
const Kx = /* @__PURE__ */ h_(
  "component:added"
  /* COMPONENT_ADDED */
), E9 = /* @__PURE__ */ h_(
  "component:updated"
  /* COMPONENT_UPDATED */
), wL = /* @__PURE__ */ h_(
  "component:removed"
  /* COMPONENT_REMOVED */
), SL = (e) => {
  Pi && typeof Pi.cleanupBuffer == "function" && // remove the component if it wasn't buffered
  !Pi.cleanupBuffer(e) && wL(e);
};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function h_(e) {
  return (t) => {
    Ap(
      e,
      t.appContext.app,
      t.uid,
      t.parent ? t.parent.uid : void 0,
      t
    );
  };
}
const _L = /* @__PURE__ */ T9(
  "perf:start"
  /* PERFORMANCE_START */
), CL = /* @__PURE__ */ T9(
  "perf:end"
  /* PERFORMANCE_END */
);
function T9(e) {
  return (t, n, r) => {
    Ap(e, t.appContext.app, t.uid, t, n, r);
  };
}
function EL(e, t, n) {
  Ap(
    "component:emit",
    e.appContext.app,
    e,
    t,
    n
  );
}
let mr = null, wg = null;
function K0(e) {
  const t = mr;
  return mr = e, wg = e && e.type.__scopeId || null, t;
}
function Xa(e) {
  wg = e;
}
function Za() {
  wg = null;
}
const TL = (e) => Fe;
function Fe(e, t = mr, n) {
  if (!t || e._n)
    return e;
  const r = (...a) => {
    r._d && ob(-1);
    const o = K0(t);
    let i;
    try {
      i = e(...a);
    } finally {
      K0(o), r._d && ob(1);
    }
    return process.env.NODE_ENV !== "production" && E9(t), i;
  };
  return r._n = !0, r._c = !0, r._d = !0, r;
}
function $9(e) {
  iF(e) && qe("Do not use built-in directive ids as custom directive id: " + e);
}
function Yn(e, t) {
  if (mr === null)
    return process.env.NODE_ENV !== "production" && qe("withDirectives can only be used inside render functions."), e;
  const n = Dp(mr), r = e.dirs || (e.dirs = []);
  for (let a = 0; a < t.length; a++) {
    let [o, i, s, l = On] = t[a];
    o && (Pt(o) && (o = {
      mounted: o,
      updated: o
    }), o.deep && Il(i), r.push({
      dir: o,
      instance: n,
      value: i,
      oldValue: void 0,
      arg: s,
      modifiers: l
    }));
  }
  return e;
}
function Ji(e, t, n, r) {
  const a = e.dirs, o = t && t.dirs;
  for (let i = 0; i < a.length; i++) {
    const s = a[i];
    o && (s.oldValue = o[i].value);
    let l = s.dir[r];
    l && (nl(), Ro(l, n, 8, [
      e.el,
      s,
      e,
      t
    ]), rl());
  }
}
const El = Symbol("_leaveCb"), wh = Symbol("_enterCb");
function v_() {
  const e = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return Lt(() => {
    e.isMounted = !0;
  }), Sn(() => {
    e.isUnmounting = !0;
  }), e;
}
const Uo = [Function, Array], m_ = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: Uo,
  onEnter: Uo,
  onAfterEnter: Uo,
  onEnterCancelled: Uo,
  // leave
  onBeforeLeave: Uo,
  onLeave: Uo,
  onAfterLeave: Uo,
  onLeaveCancelled: Uo,
  // appear
  onBeforeAppear: Uo,
  onAppear: Uo,
  onAfterAppear: Uo,
  onAppearCancelled: Uo
}, O9 = (e) => {
  const t = e.subTree;
  return t.component ? O9(t.component) : t;
}, $L = {
  name: "BaseTransition",
  props: m_,
  setup(e, { slots: t }) {
    const n = jn(), r = v_();
    return () => {
      const a = t.default && Sg(t.default(), !0);
      if (!a || !a.length)
        return;
      let o = a[0];
      if (a.length > 1) {
        let d = !1;
        for (const p of a)
          if (p.type !== tr) {
            if (process.env.NODE_ENV !== "production" && d) {
              qe(
                "<transition> can only be used on a single element or component. Use <transition-group> for lists."
              );
              break;
            }
            if (o = p, d = !0, process.env.NODE_ENV === "production") break;
          }
      }
      const i = At(e), { mode: s } = i;
      if (process.env.NODE_ENV !== "production" && s && s !== "in-out" && s !== "out-in" && s !== "default" && qe(`invalid <transition> mode: ${s}`), r.isLeaving)
        return ey(o);
      const l = ME(o);
      if (!l)
        return ey(o);
      let u = Nf(
        l,
        i,
        r,
        n,
        // #11061, ensure enterHooks is fresh after clone
        (d) => u = d
      );
      Xl(l, u);
      const c = n.subTree, f = c && ME(c);
      if (f && f.type !== tr && !Di(l, f) && O9(n).type !== tr) {
        const d = Nf(
          f,
          i,
          r,
          n
        );
        if (Xl(f, d), s === "out-in" && l.type !== tr)
          return r.isLeaving = !0, d.afterLeave = () => {
            r.isLeaving = !1, n.update.active !== !1 && (n.effect.dirty = !0, n.update());
          }, ey(o);
        s === "in-out" && l.type !== tr && (d.delayLeave = (p, v, h) => {
          const m = I9(
            r,
            f
          );
          m[String(f.key)] = f, p[El] = () => {
            v(), p[El] = void 0, delete u.delayedLeave;
          }, u.delayedLeave = h;
        });
      }
      return o;
    };
  }
}, A9 = $L;
function I9(e, t) {
  const { leavingVNodes: n } = e;
  let r = n.get(t.type);
  return r || (r = /* @__PURE__ */ Object.create(null), n.set(t.type, r)), r;
}
function Nf(e, t, n, r, a) {
  const {
    appear: o,
    mode: i,
    persisted: s = !1,
    onBeforeEnter: l,
    onEnter: u,
    onAfterEnter: c,
    onEnterCancelled: f,
    onBeforeLeave: d,
    onLeave: p,
    onAfterLeave: v,
    onLeaveCancelled: h,
    onBeforeAppear: m,
    onAppear: y,
    onAfterAppear: x,
    onAppearCancelled: g
  } = t, S = String(e.key), w = I9(n, e), _ = (C, T) => {
    C && Ro(
      C,
      r,
      9,
      T
    );
  }, b = (C, T) => {
    const O = T[1];
    _(C, T), St(C) ? C.every((I) => I.length <= 1) && O() : C.length <= 1 && O();
  }, E = {
    mode: i,
    persisted: s,
    beforeEnter(C) {
      let T = l;
      if (!n.isMounted)
        if (o)
          T = m || l;
        else
          return;
      C[El] && C[El](
        !0
        /* cancelled */
      );
      const O = w[S];
      O && Di(e, O) && O.el[El] && O.el[El](), _(T, [C]);
    },
    enter(C) {
      let T = u, O = c, I = f;
      if (!n.isMounted)
        if (o)
          T = y || u, O = x || c, I = g || f;
        else
          return;
      let k = !1;
      const B = C[wh] = (P) => {
        k || (k = !0, P ? _(I, [C]) : _(O, [C]), E.delayedLeave && E.delayedLeave(), C[wh] = void 0);
      };
      T ? b(T, [C, B]) : B();
    },
    leave(C, T) {
      const O = String(e.key);
      if (C[wh] && C[wh](
        !0
        /* cancelled */
      ), n.isUnmounting)
        return T();
      _(d, [C]);
      let I = !1;
      const k = C[El] = (B) => {
        I || (I = !0, T(), B ? _(h, [C]) : _(v, [C]), C[El] = void 0, w[O] === e && delete w[O]);
      };
      w[O] = e, p ? b(p, [C, k]) : k();
    },
    clone(C) {
      const T = Nf(
        C,
        t,
        n,
        r,
        a
      );
      return a && a(T), T;
    }
  };
  return E;
}
function ey(e) {
  if (dd(e))
    return e = Yr(e), e.children = null, e;
}
function ME(e) {
  if (!dd(e))
    return e;
  if (process.env.NODE_ENV !== "production" && e.component)
    return e.component.subTree;
  const { shapeFlag: t, children: n } = e;
  if (n) {
    if (t & 16)
      return n[0];
    if (t & 32 && Pt(n.default))
      return n.default();
  }
}
function Xl(e, t) {
  e.shapeFlag & 6 && e.component ? Xl(e.component.subTree, t) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
function Sg(e, t = !1, n) {
  let r = [], a = 0;
  for (let o = 0; o < e.length; o++) {
    let i = e[o];
    const s = n == null ? i.key : String(n) + String(i.key != null ? i.key : o);
    i.type === dt ? (i.patchFlag & 128 && a++, r = r.concat(
      Sg(i.children, t, s)
    )) : (t || i.type !== tr) && r.push(s != null ? Yr(i, { key: s }) : i);
  }
  if (a > 1)
    for (let o = 0; o < r.length; o++)
      r[o].patchFlag = -2;
  return r;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Me(e, t) {
  return Pt(e) ? (
    // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    Ln({ name: e.name }, t, { setup: e })
  ) : e;
}
const zu = (e) => !!e.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function OL(e) {
  Pt(e) && (e = { loader: e });
  const {
    loader: t,
    loadingComponent: n,
    errorComponent: r,
    delay: a = 200,
    timeout: o,
    // undefined = never times out
    suspensible: i = !0,
    onError: s
  } = e;
  let l = null, u, c = 0;
  const f = () => (c++, l = null, d()), d = () => {
    let p;
    return l || (p = l = t().catch((v) => {
      if (v = v instanceof Error ? v : new Error(String(v)), s)
        return new Promise((h, m) => {
          s(v, () => h(f()), () => m(v), c + 1);
        });
      throw v;
    }).then((v) => {
      if (p !== l && l)
        return l;
      if (process.env.NODE_ENV !== "production" && !v && qe(
        "Async component loader resolved to undefined. If you are using retry(), make sure to return its return value."
      ), v && (v.__esModule || v[Symbol.toStringTag] === "Module") && (v = v.default), process.env.NODE_ENV !== "production" && v && !wn(v) && !Pt(v))
        throw new Error(`Invalid async component load result: ${v}`);
      return u = v, v;
    }));
  };
  return /* @__PURE__ */ Me({
    name: "AsyncComponentWrapper",
    __asyncLoader: d,
    get __asyncResolved() {
      return u;
    },
    setup() {
      const p = Cr;
      if (u)
        return () => ty(u, p);
      const v = (x) => {
        l = null, lu(
          x,
          p,
          13,
          !r
        );
      };
      if (i && p.suspense || Pp)
        return d().then((x) => () => ty(x, p)).catch((x) => (v(x), () => r ? A(r, {
          error: x
        }) : null));
      const h = ne(!1), m = ne(), y = ne(!!a);
      return a && setTimeout(() => {
        y.value = !1;
      }, a), o != null && setTimeout(() => {
        if (!h.value && !m.value) {
          const x = new Error(
            `Async component timed out after ${o}ms.`
          );
          v(x), m.value = x;
        }
      }, o), d().then(() => {
        h.value = !0, p.parent && dd(p.parent.vnode) && (p.parent.effect.dirty = !0, Op(p.parent.update));
      }).catch((x) => {
        v(x), m.value = x;
      }), () => {
        if (h.value && u)
          return ty(u, p);
        if (m.value && r)
          return A(r, {
            error: m.value
          });
        if (n && !y.value)
          return A(n);
      };
    }
  });
}
function ty(e, t) {
  const { ref: n, props: r, children: a, ce: o } = t.vnode, i = A(e, r, a);
  return i.ref = n, i.ce = o, delete t.vnode.ce, i;
}
const dd = (e) => e.type.__isKeepAlive, AL = {
  name: "KeepAlive",
  // Marker for special handling inside the renderer. We are not using a ===
  // check directly on KeepAlive in the renderer, because importing it directly
  // would prevent it from being tree-shaken.
  __isKeepAlive: !0,
  props: {
    include: [String, RegExp, Array],
    exclude: [String, RegExp, Array],
    max: [String, Number]
  },
  setup(e, { slots: t }) {
    const n = jn(), r = n.ctx;
    if (!r.renderer)
      return () => {
        const x = t.default && t.default();
        return x && x.length === 1 ? x[0] : x;
      };
    const a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set();
    let i = null;
    process.env.NODE_ENV !== "production" && (n.__v_cache = a);
    const s = n.suspense, {
      renderer: {
        p: l,
        m: u,
        um: c,
        o: { createElement: f }
      }
    } = r, d = f("div");
    r.activate = (x, g, S, w, _) => {
      const b = x.component;
      u(x, g, S, 0, s), l(
        b.vnode,
        x,
        g,
        S,
        b,
        s,
        w,
        x.slotScopeIds,
        _
      ), Hr(() => {
        b.isDeactivated = !1, b.a && Ol(b.a);
        const E = x.props && x.props.onVnodeMounted;
        E && ro(E, b.parent, x);
      }, s), process.env.NODE_ENV !== "production" && Kx(b);
    }, r.deactivate = (x) => {
      const g = x.component;
      im(g.m), im(g.a), u(x, d, null, 1, s), Hr(() => {
        g.da && Ol(g.da);
        const S = x.props && x.props.onVnodeUnmounted;
        S && ro(S, g.parent, x), g.isDeactivated = !0;
      }, s), process.env.NODE_ENV !== "production" && Kx(g);
    };
    function p(x) {
      ny(x), c(x, n, s, !0);
    }
    function v(x) {
      a.forEach((g, S) => {
        const w = X0(g.type);
        w && (!x || !x(w)) && h(S);
      });
    }
    function h(x) {
      const g = a.get(x);
      !i || !Di(g, i) ? p(g) : i && ny(i), a.delete(x), o.delete(x);
    }
    He(
      () => [e.include, e.exclude],
      ([x, g]) => {
        x && v((S) => Xd(x, S)), g && v((S) => !Xd(g, S));
      },
      // prune post-render after `current` has been updated
      { flush: "post", deep: !0 }
    );
    let m = null;
    const y = () => {
      m != null && (rb(n.subTree.type) ? Hr(() => {
        a.set(m, Sh(n.subTree));
      }, n.subTree.suspense) : a.set(m, Sh(n.subTree)));
    };
    return Lt(y), Qa(y), Sn(() => {
      a.forEach((x) => {
        const { subTree: g, suspense: S } = n, w = Sh(g);
        if (x.type === w.type && x.key === w.key) {
          ny(w);
          const _ = w.component.da;
          _ && Hr(_, S);
          return;
        }
        p(x);
      });
    }), () => {
      if (m = null, !t.default)
        return null;
      const x = t.default(), g = x[0];
      if (x.length > 1)
        return process.env.NODE_ENV !== "production" && qe("KeepAlive should contain exactly one component child."), i = null, x;
      if (!ka(g) || !(g.shapeFlag & 4) && !(g.shapeFlag & 128))
        return i = null, g;
      let S = Sh(g);
      const w = S.type, _ = X0(
        zu(S) ? S.type.__asyncResolved || {} : w
      ), { include: b, exclude: E, max: C } = e;
      if (b && (!_ || !Xd(b, _)) || E && _ && Xd(E, _))
        return i = S, g;
      const T = S.key == null ? w : S.key, O = a.get(T);
      return S.el && (S = Yr(S), g.shapeFlag & 128 && (g.ssContent = S)), m = T, O ? (S.el = O.el, S.component = O.component, S.transition && Xl(S, S.transition), S.shapeFlag |= 512, o.delete(T), o.add(T)) : (o.add(T), C && o.size > parseInt(C, 10) && h(o.values().next().value)), S.shapeFlag |= 256, i = S, rb(g.type) ? g : S;
    };
  }
}, IL = AL;
function Xd(e, t) {
  return St(e) ? e.some((n) => Xd(n, t)) : Dn(e) ? e.split(",").includes(t) : oF(e) ? e.test(t) : !1;
}
function P9(e, t) {
  k9(e, "a", t);
}
function D9(e, t) {
  k9(e, "da", t);
}
function k9(e, t, n = Cr) {
  const r = e.__wdc || (e.__wdc = () => {
    let a = n;
    for (; a; ) {
      if (a.isDeactivated)
        return;
      a = a.parent;
    }
    return e();
  });
  if (_g(t, r, n), n) {
    let a = n.parent;
    for (; a && a.parent; )
      dd(a.parent.vnode) && PL(r, t, n, a), a = a.parent;
  }
}
function PL(e, t, n, r) {
  const a = _g(
    t,
    e,
    r,
    !0
    /* prepend */
  );
  Bo(() => {
    QS(r[t], a);
  }, n);
}
function ny(e) {
  e.shapeFlag &= -257, e.shapeFlag &= -513;
}
function Sh(e) {
  return e.shapeFlag & 128 ? e.ssContent : e;
}
function _g(e, t, n = Cr, r = !1) {
  if (n) {
    const a = n[e] || (n[e] = []), o = t.__weh || (t.__weh = (...i) => {
      nl();
      const s = lc(n), l = Ro(t, n, e, i);
      return s(), rl(), l;
    });
    return r ? a.unshift(o) : a.push(o), o;
  } else if (process.env.NODE_ENV !== "production") {
    const a = Ns(bg[e].replace(/ hook$/, ""));
    qe(
      `${a} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const al = (e) => (t, n = Cr) => {
  (!Pp || e === "sp") && _g(e, (...r) => t(...r), n);
}, g_ = al("bm"), Lt = al("m"), Cg = al("bu"), Qa = al("u"), Sn = al("bum"), Bo = al("um"), M9 = al("sp"), R9 = al(
  "rtg"
), N9 = al(
  "rtc"
);
function F9(e, t = Cr) {
  _g("ec", e, t);
}
const nm = "components", DL = "directives";
function Yx(e, t) {
  return x_(nm, e, !0, t) || e;
}
const y_ = Symbol.for("v-ndc");
function L9(e) {
  return Dn(e) ? x_(nm, e, !1) || e : e || y_;
}
function B9(e) {
  return x_(DL, e);
}
function x_(e, t, n = !0, r = !1) {
  const a = mr || Cr;
  if (a) {
    const o = a.type;
    if (e === nm) {
      const s = X0(
        o,
        !1
      );
      if (s && (s === t || s === Ia(t) || s === Kl(Ia(t))))
        return o;
    }
    const i = (
      // local registration
      // check instance[type] first which is resolved for options API
      RE(a[e] || o[e], t) || // global registration
      RE(a.appContext[e], t)
    );
    if (!i && r)
      return o;
    if (process.env.NODE_ENV !== "production" && n && !i) {
      const s = e === nm ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.` : "";
      qe(`Failed to resolve ${e.slice(0, -1)}: ${t}${s}`);
    }
    return i;
  } else process.env.NODE_ENV !== "production" && qe(
    `resolve${Kl(e.slice(0, -1))} can only be used in render() or setup().`
  );
}
function RE(e, t) {
  return e && (e[t] || e[Ia(t)] || e[Kl(Ia(t))]);
}
function Vn(e, t, n, r) {
  let a;
  const o = n && n[r];
  if (St(e) || Dn(e)) {
    a = new Array(e.length);
    for (let i = 0, s = e.length; i < s; i++)
      a[i] = t(e[i], i, void 0, o && o[i]);
  } else if (typeof e == "number") {
    process.env.NODE_ENV !== "production" && !Number.isInteger(e) && qe(`The v-for range expect an integer value but got ${e}.`), a = new Array(e);
    for (let i = 0; i < e; i++)
      a[i] = t(i + 1, i, void 0, o && o[i]);
  } else if (wn(e))
    if (e[Symbol.iterator])
      a = Array.from(
        e,
        (i, s) => t(i, s, void 0, o && o[s])
      );
    else {
      const i = Object.keys(e);
      a = new Array(i.length);
      for (let s = 0, l = i.length; s < l; s++) {
        const u = i[s];
        a[s] = t(e[u], u, s, o && o[s]);
      }
    }
  else
    a = [];
  return n && (n[r] = a), a;
}
function kL(e, t) {
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    if (St(r))
      for (let a = 0; a < r.length; a++)
        e[r[a].name] = r[a].fn;
    else r && (e[r.name] = r.key ? (...a) => {
      const o = r.fn(...a);
      return o && (o.key = r.key), o;
    } : r.fn);
  }
  return e;
}
function uo(e, t, n = {}, r, a) {
  if (mr.isCE || mr.parent && zu(mr.parent) && mr.parent.isCE)
    return t !== "default" && (n.name = t), A("slot", n, r && r());
  let o = e[t];
  process.env.NODE_ENV !== "production" && o && o.length > 1 && (qe(
    "SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template."
  ), o = () => []), o && o._c && (o._d = !1), Ce();
  const i = o && H9(o(n)), s = et(
    dt,
    {
      key: (n.key || // slot content array of a dynamic conditional slot may have a branch
      // key attached in the `createSlots` helper, respect that
      i && i.key || `_${t}`) + // #7256 force differentiate fallback content from actual content
      (!i && r ? "_fb" : "")
    },
    i || (r ? r() : []),
    i && e._ === 1 ? 64 : -2
  );
  return !a && s.scopeId && (s.slotScopeIds = [s.scopeId + "-s"]), o && o._c && (o._d = !0), s;
}
function H9(e) {
  return e.some((t) => ka(t) ? !(t.type === tr || t.type === dt && !H9(t.children)) : !0) ? e : null;
}
function ML(e, t) {
  const n = {};
  if (process.env.NODE_ENV !== "production" && !wn(e))
    return qe("v-on with no argument expects an object value."), n;
  for (const r in e)
    n[t && /[A-Z]/.test(r) ? `on:${r}` : Ns(r)] = e[r];
  return n;
}
const qx = (e) => e ? CA(e) ? Dp(e) : qx(e.parent) : null, Wu = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ Ln(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => process.env.NODE_ENV !== "production" ? Ri(e.props) : e.props,
    $attrs: (e) => process.env.NODE_ENV !== "production" ? Ri(e.attrs) : e.attrs,
    $slots: (e) => process.env.NODE_ENV !== "production" ? Ri(e.slots) : e.slots,
    $refs: (e) => process.env.NODE_ENV !== "production" ? Ri(e.refs) : e.refs,
    $parent: (e) => qx(e.parent),
    $root: (e) => qx(e.root),
    $emit: (e) => e.emit,
    $options: (e) => S_(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      e.effect.dirty = !0, Op(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = nn.bind(e.proxy)),
    $watch: (e) => $B.bind(e)
  })
), b_ = (e) => e === "_" || e === "$", ry = (e, t) => e !== On && !e.__isScriptSetup && pn(e, t), p0 = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: n, setupState: r, data: a, props: o, accessCache: i, type: s, appContext: l } = e;
    if (process.env.NODE_ENV !== "production" && t === "__isVue")
      return !0;
    let u;
    if (t[0] !== "$") {
      const p = i[t];
      if (p !== void 0)
        switch (p) {
          case 1:
            return r[t];
          case 2:
            return a[t];
          case 4:
            return n[t];
          case 3:
            return o[t];
        }
      else {
        if (ry(r, t))
          return i[t] = 1, r[t];
        if (a !== On && pn(a, t))
          return i[t] = 2, a[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (u = e.propsOptions[0]) && pn(u, t)
        )
          return i[t] = 3, o[t];
        if (n !== On && pn(n, t))
          return i[t] = 4, n[t];
        Xx && (i[t] = 0);
      }
    }
    const c = Wu[t];
    let f, d;
    if (c)
      return t === "$attrs" ? (da(e.attrs, "get", ""), process.env.NODE_ENV !== "production" && sm()) : process.env.NODE_ENV !== "production" && t === "$slots" && da(e, "get", t), c(e);
    if (
      // css module (injected by vue-loader)
      (f = s.__cssModules) && (f = f[t])
    )
      return f;
    if (n !== On && pn(n, t))
      return i[t] = 4, n[t];
    if (
      // global properties
      d = l.config.globalProperties, pn(d, t)
    )
      return d[t];
    process.env.NODE_ENV !== "production" && mr && (!Dn(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    t.indexOf("__v") !== 0) && (a !== On && b_(t[0]) && pn(a, t) ? qe(
      `Property ${JSON.stringify(
        t
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === mr && qe(
      `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, t, n) {
    const { data: r, setupState: a, ctx: o } = e;
    return ry(a, t) ? (a[t] = n, !0) : process.env.NODE_ENV !== "production" && a.__isScriptSetup && pn(a, t) ? (qe(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : r !== On && pn(r, t) ? (r[t] = n, !0) : pn(e.props, t) ? (process.env.NODE_ENV !== "production" && qe(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && qe(
      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(o, t, {
      enumerable: !0,
      configurable: !0,
      value: n
    }) : o[t] = n, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: a, propsOptions: o }
  }, i) {
    let s;
    return !!n[i] || e !== On && pn(e, i) || ry(t, i) || (s = o[0]) && pn(s, i) || pn(r, i) || pn(Wu, i) || pn(a.config.globalProperties, i);
  },
  defineProperty(e, t, n) {
    return n.get != null ? e._.accessCache[t] = 0 : pn(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
  }
};
process.env.NODE_ENV !== "production" && (p0.ownKeys = (e) => (qe(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
const RL = /* @__PURE__ */ Ln(
  {},
  p0,
  {
    get(e, t) {
      if (t !== Symbol.unscopables)
        return p0.get(e, t, e);
    },
    has(e, t) {
      const n = t[0] !== "_" && !cF(t);
      return process.env.NODE_ENV !== "production" && !n && p0.has(e, t) && qe(
        `Property ${JSON.stringify(
          t
        )} should not start with _ which is a reserved prefix for Vue internals.`
      ), n;
    }
  }
);
function NL(e) {
  const t = {};
  return Object.defineProperty(t, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => e
  }), Object.keys(Wu).forEach((n) => {
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !1,
      get: () => Wu[n](e),
      // intercepted by the proxy so no need for implementation,
      // but needed to prevent set errors
      set: vr
    });
  }), t;
}
function FL(e) {
  const {
    ctx: t,
    propsOptions: [n]
  } = e;
  n && Object.keys(n).forEach((r) => {
    Object.defineProperty(t, r, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[r],
      set: vr
    });
  });
}
function LL(e) {
  const { ctx: t, setupState: n } = e;
  Object.keys(At(n)).forEach((r) => {
    if (!n.__isScriptSetup) {
      if (b_(r[0])) {
        qe(
          `setup() return property ${JSON.stringify(
            r
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(t, r, {
        enumerable: !0,
        configurable: !0,
        get: () => n[r],
        set: vr
      });
    }
  });
}
const Sc = (e) => qe(
  `${e}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`
);
function BL() {
  return process.env.NODE_ENV !== "production" && Sc("defineProps"), null;
}
function HL() {
  return process.env.NODE_ENV !== "production" && Sc("defineEmits"), null;
}
function jL(e) {
  process.env.NODE_ENV !== "production" && Sc("defineExpose");
}
function VL(e) {
  process.env.NODE_ENV !== "production" && Sc("defineOptions");
}
function UL() {
  return process.env.NODE_ENV !== "production" && Sc("defineSlots"), null;
}
function zL() {
  process.env.NODE_ENV !== "production" && Sc("defineModel");
}
function WL(e, t) {
  return process.env.NODE_ENV !== "production" && Sc("withDefaults"), null;
}
function GL() {
  return j9().slots;
}
function w_() {
  return j9().attrs;
}
function j9() {
  const e = jn();
  return process.env.NODE_ENV !== "production" && !e && qe("useContext() called without active instance."), e.setupContext || (e.setupContext = $A(e));
}
function Y0(e) {
  return St(e) ? e.reduce(
    (t, n) => (t[n] = null, t),
    {}
  ) : e;
}
function KL(e, t) {
  const n = Y0(e);
  for (const r in t) {
    if (r.startsWith("__skip")) continue;
    let a = n[r];
    a ? St(a) || Pt(a) ? a = n[r] = { type: a, default: t[r] } : a.default = t[r] : a === null ? a = n[r] = { default: t[r] } : process.env.NODE_ENV !== "production" && qe(`props default key "${r}" has no corresponding declaration.`), a && t[`__skip_${r}`] && (a.skipFactory = !0);
  }
  return n;
}
function Zl(e, t) {
  return !e || !t ? e || t : St(e) && St(t) ? e.concat(t) : Ln({}, Y0(e), Y0(t));
}
function YL(e, t) {
  const n = {};
  for (const r in e)
    t.includes(r) || Object.defineProperty(n, r, {
      enumerable: !0,
      get: () => e[r]
    });
  return n;
}
function qL(e) {
  const t = jn();
  process.env.NODE_ENV !== "production" && !t && qe(
    "withAsyncContext called without active current instance. This is likely a bug."
  );
  let n = e();
  return lb(), fg(n) && (n = n.catch((r) => {
    throw lc(t), r;
  })), [n, () => lc(t)];
}
function XL() {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, n) => {
    e[n] ? qe(`${t} property "${n}" is already defined in ${e[n]}.`) : e[n] = t;
  };
}
let Xx = !0;
function ZL(e) {
  const t = S_(e), n = e.proxy, r = e.ctx;
  Xx = !1, t.beforeCreate && NE(t.beforeCreate, e, "bc");
  const {
    // state
    data: a,
    computed: o,
    methods: i,
    watch: s,
    provide: l,
    inject: u,
    // lifecycle
    created: c,
    beforeMount: f,
    mounted: d,
    beforeUpdate: p,
    updated: v,
    activated: h,
    deactivated: m,
    beforeDestroy: y,
    beforeUnmount: x,
    destroyed: g,
    unmounted: S,
    render: w,
    renderTracked: _,
    renderTriggered: b,
    errorCaptured: E,
    serverPrefetch: C,
    // public API
    expose: T,
    inheritAttrs: O,
    // assets
    components: I,
    directives: k,
    filters: B
  } = t, P = process.env.NODE_ENV !== "production" ? XL() : null;
  if (process.env.NODE_ENV !== "production") {
    const [M] = e.propsOptions;
    if (M)
      for (const H in M)
        P("Props", H);
  }
  if (u && QL(u, r, P), i)
    for (const M in i) {
      const H = i[M];
      Pt(H) ? (process.env.NODE_ENV !== "production" ? Object.defineProperty(r, M, {
        value: H.bind(n),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : r[M] = H.bind(n), process.env.NODE_ENV !== "production" && P("Methods", M)) : process.env.NODE_ENV !== "production" && qe(
        `Method "${M}" has type "${typeof H}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (a) {
    process.env.NODE_ENV !== "production" && !Pt(a) && qe(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const M = a.call(n, n);
    if (process.env.NODE_ENV !== "production" && fg(M) && qe(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !wn(M))
      process.env.NODE_ENV !== "production" && qe("data() should return an object.");
    else if (e.data = Wn(M), process.env.NODE_ENV !== "production")
      for (const H in M)
        P("Data", H), b_(H[0]) || Object.defineProperty(r, H, {
          configurable: !0,
          enumerable: !0,
          get: () => M[H],
          set: vr
        });
  }
  if (Xx = !0, o)
    for (const M in o) {
      const H = o[M], R = Pt(H) ? H.bind(n, n) : Pt(H.get) ? H.get.bind(n, n) : vr;
      process.env.NODE_ENV !== "production" && R === vr && qe(`Computed property "${M}" has no getter.`);
      const z = !Pt(H) && Pt(H.set) ? H.set.bind(n) : process.env.NODE_ENV !== "production" ? () => {
        qe(
          `Write operation failed: computed property "${M}" is readonly.`
        );
      } : vr, W = V({
        get: R,
        set: z
      });
      Object.defineProperty(r, M, {
        enumerable: !0,
        configurable: !0,
        get: () => W.value,
        set: (F) => W.value = F
      }), process.env.NODE_ENV !== "production" && P("Computed", M);
    }
  if (s)
    for (const M in s)
      V9(s[M], r, n, M);
  if (l) {
    const M = Pt(l) ? l.call(n) : l;
    Reflect.ownKeys(M).forEach((H) => {
      kt(H, M[H]);
    });
  }
  c && NE(c, e, "c");
  function N(M, H) {
    St(H) ? H.forEach((R) => M(R.bind(n))) : H && M(H.bind(n));
  }
  if (N(g_, f), N(Lt, d), N(Cg, p), N(Qa, v), N(P9, h), N(D9, m), N(F9, E), N(N9, _), N(R9, b), N(Sn, x), N(Bo, S), N(M9, C), St(T))
    if (T.length) {
      const M = e.exposed || (e.exposed = {});
      T.forEach((H) => {
        Object.defineProperty(M, H, {
          get: () => n[H],
          set: (R) => n[H] = R
        });
      });
    } else e.exposed || (e.exposed = {});
  w && e.render === vr && (e.render = w), O != null && (e.inheritAttrs = O), I && (e.components = I), k && (e.directives = k);
}
function QL(e, t, n = vr) {
  St(e) && (e = Zx(e));
  for (const r in e) {
    const a = e[r];
    let o;
    wn(a) ? "default" in a ? o = Ke(
      a.from || r,
      a.default,
      !0
    ) : o = Ke(a.from || r) : o = Ke(a), Ft(o) ? Object.defineProperty(t, r, {
      enumerable: !0,
      configurable: !0,
      get: () => o.value,
      set: (i) => o.value = i
    }) : t[r] = o, process.env.NODE_ENV !== "production" && n("Inject", r);
  }
}
function NE(e, t, n) {
  Ro(
    St(e) ? e.map((r) => r.bind(t.proxy)) : e.bind(t.proxy),
    t,
    n
  );
}
function V9(e, t, n, r) {
  const a = r.includes(".") ? dA(n, r) : () => n[r];
  if (Dn(e)) {
    const o = t[e];
    Pt(o) ? He(a, o) : process.env.NODE_ENV !== "production" && qe(`Invalid watch handler specified by key "${e}"`, o);
  } else if (Pt(e))
    He(a, e.bind(n));
  else if (wn(e))
    if (St(e))
      e.forEach((o) => V9(o, t, n, r));
    else {
      const o = Pt(e.handler) ? e.handler.bind(n) : t[e.handler];
      Pt(o) ? He(a, o, e) : process.env.NODE_ENV !== "production" && qe(`Invalid watch handler specified by key "${e.handler}"`, o);
    }
  else process.env.NODE_ENV !== "production" && qe(`Invalid watch option: "${r}"`, e);
}
function S_(e) {
  const t = e.type, { mixins: n, extends: r } = t, {
    mixins: a,
    optionsCache: o,
    config: { optionMergeStrategies: i }
  } = e.appContext, s = o.get(t);
  let l;
  return s ? l = s : !a.length && !n && !r ? l = t : (l = {}, a.length && a.forEach(
    (u) => rm(l, u, i, !0)
  ), rm(l, t, i)), wn(t) && o.set(t, l), l;
}
function rm(e, t, n, r = !1) {
  const { mixins: a, extends: o } = t;
  o && rm(e, o, n, !0), a && a.forEach(
    (i) => rm(e, i, n, !0)
  );
  for (const i in t)
    if (r && i === "expose")
      process.env.NODE_ENV !== "production" && qe(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const s = JL[i] || n && n[i];
      e[i] = s ? s(e[i], t[i]) : t[i];
    }
  return e;
}
const JL = {
  data: FE,
  props: LE,
  emits: LE,
  // objects
  methods: Zd,
  computed: Zd,
  // lifecycle
  beforeCreate: Ba,
  created: Ba,
  beforeMount: Ba,
  mounted: Ba,
  beforeUpdate: Ba,
  updated: Ba,
  beforeDestroy: Ba,
  beforeUnmount: Ba,
  destroyed: Ba,
  unmounted: Ba,
  activated: Ba,
  deactivated: Ba,
  errorCaptured: Ba,
  serverPrefetch: Ba,
  // assets
  components: Zd,
  directives: Zd,
  // watch
  watch: tB,
  // provide / inject
  provide: FE,
  inject: eB
};
function FE(e, t) {
  return t ? e ? function() {
    return Ln(
      Pt(e) ? e.call(this, this) : e,
      Pt(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function eB(e, t) {
  return Zd(Zx(e), Zx(t));
}
function Zx(e) {
  if (St(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++)
      t[e[n]] = e[n];
    return t;
  }
  return e;
}
function Ba(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function Zd(e, t) {
  return e ? Ln(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function LE(e, t) {
  return e ? St(e) && St(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : Ln(
    /* @__PURE__ */ Object.create(null),
    Y0(e),
    Y0(t ?? {})
  ) : t;
}
function tB(e, t) {
  if (!e) return t;
  if (!t) return e;
  const n = Ln(/* @__PURE__ */ Object.create(null), e);
  for (const r in t)
    n[r] = Ba(e[r], t[r]);
  return n;
}
function U9() {
  return {
    app: null,
    config: {
      isNativeTag: rF,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let nB = 0;
function rB(e, t) {
  return function(r, a = null) {
    Pt(r) || (r = Ln({}, r)), a != null && !wn(a) && (process.env.NODE_ENV !== "production" && qe("root props passed to app.mount() must be an object."), a = null);
    const o = U9(), i = /* @__PURE__ */ new WeakSet();
    let s = !1;
    const l = o.app = {
      _uid: nB++,
      _component: r,
      _props: a,
      _container: null,
      _context: o,
      _instance: null,
      version: db,
      get config() {
        return o.config;
      },
      set config(u) {
        process.env.NODE_ENV !== "production" && qe(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use(u, ...c) {
        return i.has(u) ? process.env.NODE_ENV !== "production" && qe("Plugin has already been applied to target app.") : u && Pt(u.install) ? (i.add(u), u.install(l, ...c)) : Pt(u) ? (i.add(u), u(l, ...c)) : process.env.NODE_ENV !== "production" && qe(
          'A plugin must either be a function or an object with an "install" function.'
        ), l;
      },
      mixin(u) {
        return o.mixins.includes(u) ? process.env.NODE_ENV !== "production" && qe(
          "Mixin has already been applied to target app" + (u.name ? `: ${u.name}` : "")
        ) : o.mixins.push(u), l;
      },
      component(u, c) {
        return process.env.NODE_ENV !== "production" && ub(u, o.config), c ? (process.env.NODE_ENV !== "production" && o.components[u] && qe(`Component "${u}" has already been registered in target app.`), o.components[u] = c, l) : o.components[u];
      },
      directive(u, c) {
        return process.env.NODE_ENV !== "production" && $9(u), c ? (process.env.NODE_ENV !== "production" && o.directives[u] && qe(`Directive "${u}" has already been registered in target app.`), o.directives[u] = c, l) : o.directives[u];
      },
      mount(u, c, f) {
        if (s)
          process.env.NODE_ENV !== "production" && qe(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          process.env.NODE_ENV !== "production" && u.__vue_app__ && qe(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const d = A(r, a);
          return d.appContext = o, f === !0 ? f = "svg" : f === !1 && (f = void 0), process.env.NODE_ENV !== "production" && (o.reload = () => {
            e(
              Yr(d),
              u,
              f
            );
          }), c && t ? t(d, u) : e(d, u, f), s = !0, l._container = u, u.__vue_app__ = l, process.env.NODE_ENV !== "production" && (l._instance = d.component, xL(l, db)), Dp(d.component);
        }
      },
      unmount() {
        s ? (e(null, l._container), process.env.NODE_ENV !== "production" && (l._instance = null, bL(l)), delete l._container.__vue_app__) : process.env.NODE_ENV !== "production" && qe("Cannot unmount an app that is not mounted.");
      },
      provide(u, c) {
        return process.env.NODE_ENV !== "production" && u in o.provides && qe(
          `App already provides property with key "${String(u)}". It will be overwritten with the new value.`
        ), o.provides[u] = c, l;
      },
      runWithContext(u) {
        const c = wf;
        wf = l;
        try {
          return u();
        } finally {
          wf = c;
        }
      }
    };
    return l;
  };
}
let wf = null;
function kt(e, t) {
  if (!Cr)
    process.env.NODE_ENV !== "production" && qe("provide() can only be used inside setup().");
  else {
    let n = Cr.provides;
    const r = Cr.parent && Cr.parent.provides;
    r === n && (n = Cr.provides = Object.create(r)), n[e] = t;
  }
}
function Ke(e, t, n = !1) {
  const r = Cr || mr;
  if (r || wf) {
    const a = r ? r.parent == null ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : wf._context.provides;
    if (a && e in a)
      return a[e];
    if (arguments.length > 1)
      return n && Pt(t) ? t.call(r && r.proxy) : t;
    process.env.NODE_ENV !== "production" && qe(`injection "${String(e)}" not found.`);
  } else process.env.NODE_ENV !== "production" && qe("inject() can only be used inside setup() or functional components.");
}
function z9() {
  return !!(Cr || mr || wf);
}
const W9 = {}, G9 = () => Object.create(W9), K9 = (e) => Object.getPrototypeOf(e) === W9;
function aB(e, t, n, r = !1) {
  const a = {}, o = G9();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), Y9(e, t, a, o);
  for (const i in e.propsOptions[0])
    i in a || (a[i] = void 0);
  process.env.NODE_ENV !== "production" && X9(t || {}, a, e), n ? e.props = r ? a : v9(a) : e.type.props ? e.props = a : e.props = o, e.attrs = o;
}
function oB(e) {
  for (; e; ) {
    if (e.type.__hmrId) return !0;
    e = e.parent;
  }
}
function iB(e, t, n, r) {
  const {
    props: a,
    attrs: o,
    vnode: { patchFlag: i }
  } = e, s = At(a), [l] = e.propsOptions;
  let u = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(process.env.NODE_ENV !== "production" && oB(e)) && (r || i > 0) && !(i & 16)
  ) {
    if (i & 8) {
      const c = e.vnode.dynamicProps;
      for (let f = 0; f < c.length; f++) {
        let d = c[f];
        if (Tg(e.emitsOptions, d))
          continue;
        const p = t[d];
        if (l)
          if (pn(o, d))
            p !== o[d] && (o[d] = p, u = !0);
          else {
            const v = Ia(d);
            a[v] = Qx(
              l,
              s,
              v,
              p,
              e,
              !1
            );
          }
        else
          p !== o[d] && (o[d] = p, u = !0);
      }
    }
  } else {
    Y9(e, t, a, o) && (u = !0);
    let c;
    for (const f in s)
      (!t || // for camelCase
      !pn(t, f) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((c = na(f)) === f || !pn(t, c))) && (l ? n && // for camelCase
      (n[f] !== void 0 || // for kebab-case
      n[c] !== void 0) && (a[f] = Qx(
        l,
        s,
        f,
        void 0,
        e,
        !0
      )) : delete a[f]);
    if (o !== s)
      for (const f in o)
        (!t || !pn(t, f)) && (delete o[f], u = !0);
  }
  u && os(e.attrs, "set", ""), process.env.NODE_ENV !== "production" && X9(t || {}, a, e);
}
function Y9(e, t, n, r) {
  const [a, o] = e.propsOptions;
  let i = !1, s;
  if (t)
    for (let l in t) {
      if (yf(l))
        continue;
      const u = t[l];
      let c;
      a && pn(a, c = Ia(l)) ? !o || !o.includes(c) ? n[c] = u : (s || (s = {}))[c] = u : Tg(e.emitsOptions, l) || (!(l in r) || u !== r[l]) && (r[l] = u, i = !0);
    }
  if (o) {
    const l = At(n), u = s || On;
    for (let c = 0; c < o.length; c++) {
      const f = o[c];
      n[f] = Qx(
        a,
        l,
        f,
        u[f],
        e,
        !pn(u, f)
      );
    }
  }
  return i;
}
function Qx(e, t, n, r, a, o) {
  const i = e[n];
  if (i != null) {
    const s = pn(i, "default");
    if (s && r === void 0) {
      const l = i.default;
      if (i.type !== Function && !i.skipFactory && Pt(l)) {
        const { propsDefaults: u } = a;
        if (n in u)
          r = u[n];
        else {
          const c = lc(a);
          r = u[n] = l.call(
            null,
            t
          ), c();
        }
      } else
        r = l;
    }
    i[
      0
      /* shouldCast */
    ] && (o && !s ? r = !1 : i[
      1
      /* shouldCastTrue */
    ] && (r === "" || r === na(n)) && (r = !0));
  }
  return r;
}
const sB = /* @__PURE__ */ new WeakMap();
function q9(e, t, n = !1) {
  const r = n ? sB : t.propsCache, a = r.get(e);
  if (a)
    return a;
  const o = e.props, i = {}, s = [];
  let l = !1;
  if (!Pt(e)) {
    const c = (f) => {
      l = !0;
      const [d, p] = q9(f, t, !0);
      Ln(i, d), p && s.push(...p);
    };
    !n && t.mixins.length && t.mixins.forEach(c), e.extends && c(e.extends), e.mixins && e.mixins.forEach(c);
  }
  if (!o && !l)
    return wn(e) && r.set(e, gf), gf;
  if (St(o))
    for (let c = 0; c < o.length; c++) {
      process.env.NODE_ENV !== "production" && !Dn(o[c]) && qe("props must be strings when using array syntax.", o[c]);
      const f = Ia(o[c]);
      BE(f) && (i[f] = On);
    }
  else if (o) {
    process.env.NODE_ENV !== "production" && !wn(o) && qe("invalid props options", o);
    for (const c in o) {
      const f = Ia(c);
      if (BE(f)) {
        const d = o[c], p = i[f] = St(d) || Pt(d) ? { type: d } : Ln({}, d);
        if (p) {
          const v = jE(Boolean, p.type), h = jE(String, p.type);
          p[
            0
            /* shouldCast */
          ] = v > -1, p[
            1
            /* shouldCastTrue */
          ] = h < 0 || v < h, (v > -1 || pn(p, "default")) && s.push(f);
        }
      }
    }
  }
  const u = [i, s];
  return wn(e) && r.set(e, u), u;
}
function BE(e) {
  return e[0] !== "$" && !yf(e) ? !0 : (process.env.NODE_ENV !== "production" && qe(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function Jx(e) {
  return e === null ? "null" : typeof e == "function" ? e.name || "" : typeof e == "object" && e.constructor && e.constructor.name || "";
}
function HE(e, t) {
  return Jx(e) === Jx(t);
}
function jE(e, t) {
  return St(t) ? t.findIndex((n) => HE(n, e)) : Pt(t) && HE(t, e) ? 0 : -1;
}
function X9(e, t, n) {
  const r = At(t), a = n.propsOptions[0];
  for (const o in a) {
    let i = a[o];
    i != null && lB(
      o,
      r[o],
      i,
      process.env.NODE_ENV !== "production" ? Ri(r) : r,
      !pn(e, o) && !pn(e, na(o))
    );
  }
}
function lB(e, t, n, r, a) {
  const { type: o, required: i, validator: s, skipCheck: l } = n;
  if (i && a) {
    qe('Missing required prop: "' + e + '"');
    return;
  }
  if (!(t == null && !i)) {
    if (o != null && o !== !0 && !l) {
      let u = !1;
      const c = St(o) ? o : [o], f = [];
      for (let d = 0; d < c.length && !u; d++) {
        const { valid: p, expectedType: v } = cB(t, c[d]);
        f.push(v || ""), u = p;
      }
      if (!u) {
        qe(fB(e, t, f));
        return;
      }
    }
    s && !s(t, r) && qe('Invalid prop: custom validator check failed for prop "' + e + '".');
  }
}
const uB = /* @__PURE__ */ Lo(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function cB(e, t) {
  let n;
  const r = Jx(t);
  if (uB(r)) {
    const a = typeof e;
    n = a === r.toLowerCase(), !n && a === "object" && (n = e instanceof t);
  } else r === "Object" ? n = wn(e) : r === "Array" ? n = St(e) : r === "null" ? n = e === null : n = e instanceof t;
  return {
    valid: n,
    expectedType: r
  };
}
function fB(e, t, n) {
  if (n.length === 0)
    return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
  let r = `Invalid prop: type check failed for prop "${e}". Expected ${n.map(Kl).join(" | ")}`;
  const a = n[0], o = JS(t), i = VE(t, a), s = VE(t, o);
  return n.length === 1 && UE(a) && !dB(a, o) && (r += ` with value ${i}`), r += `, got ${o} `, UE(o) && (r += `with value ${s}.`), r;
}
function VE(e, t) {
  return t === "String" ? `"${e}"` : t === "Number" ? `${Number(e)}` : `${e}`;
}
function UE(e) {
  return ["string", "number", "boolean"].some((n) => e.toLowerCase() === n);
}
function dB(...e) {
  return e.some((t) => t.toLowerCase() === "boolean");
}
const Z9 = (e) => e[0] === "_" || e === "$stable", __ = (e) => St(e) ? e.map(Ua) : [Ua(e)], pB = (e, t, n) => {
  if (t._n)
    return t;
  const r = Fe((...a) => (process.env.NODE_ENV !== "production" && Cr && (!n || n.root === Cr.root) && qe(
    `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), __(t(...a))), n);
  return r._c = !1, r;
}, Q9 = (e, t, n) => {
  const r = e._ctx;
  for (const a in e) {
    if (Z9(a)) continue;
    const o = e[a];
    if (Pt(o))
      t[a] = pB(a, o, r);
    else if (o != null) {
      process.env.NODE_ENV !== "production" && qe(
        `Non-function value encountered for slot "${a}". Prefer function slots for better performance.`
      );
      const i = __(o);
      t[a] = () => i;
    }
  }
}, J9 = (e, t) => {
  process.env.NODE_ENV !== "production" && !dd(e.vnode) && qe(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const n = __(t);
  e.slots.default = () => n;
}, eb = (e, t, n) => {
  for (const r in t)
    (n || r !== "_") && (e[r] = t[r]);
}, hB = (e, t, n) => {
  const r = e.slots = G9();
  if (e.vnode.shapeFlag & 32) {
    const a = t._;
    a ? (eb(r, t, n), n && Mf(r, "_", a, !0)) : Q9(t, r);
  } else t && J9(e, t);
}, vB = (e, t, n) => {
  const { vnode: r, slots: a } = e;
  let o = !0, i = On;
  if (r.shapeFlag & 32) {
    const s = t._;
    s ? process.env.NODE_ENV !== "production" && Vl ? (eb(a, t, n), os(e, "set", "$slots")) : n && s === 1 ? o = !1 : eb(a, t, n) : (o = !t.$stable, Q9(t, a)), i = t;
  } else t && (J9(e, t), i = { default: 1 });
  if (o)
    for (const s in a)
      !Z9(s) && i[s] == null && delete a[s];
};
function am(e, t, n, r, a = !1) {
  if (St(e)) {
    e.forEach(
      (d, p) => am(
        d,
        t && (St(t) ? t[p] : t),
        n,
        r,
        a
      )
    );
    return;
  }
  if (zu(r) && !a)
    return;
  const o = r.shapeFlag & 4 ? Dp(r.component) : r.el, i = a ? null : o, { i: s, r: l } = e;
  if (process.env.NODE_ENV !== "production" && !s) {
    qe(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const u = t && t.r, c = s.refs === On ? s.refs = {} : s.refs, f = s.setupState;
  if (u != null && u !== l && (Dn(u) ? (c[u] = null, pn(f, u) && (f[u] = null)) : Ft(u) && (u.value = null)), Pt(l))
    ss(l, s, 12, [i, c]);
  else {
    const d = Dn(l), p = Ft(l);
    if (d || p) {
      const v = () => {
        if (e.f) {
          const h = d ? pn(f, l) ? f[l] : c[l] : l.value;
          a ? St(h) && QS(h, o) : St(h) ? h.includes(o) || h.push(o) : d ? (c[l] = [o], pn(f, l) && (f[l] = c[l])) : (l.value = [o], e.k && (c[e.k] = l.value));
        } else d ? (c[l] = i, pn(f, l) && (f[l] = i)) : p ? (l.value = i, e.k && (c[e.k] = i)) : process.env.NODE_ENV !== "production" && qe("Invalid template ref type:", l, `(${typeof l})`);
      };
      i ? (v.id = -1, Hr(v, n)) : v();
    } else process.env.NODE_ENV !== "production" && qe("Invalid template ref type:", l, `(${typeof l})`);
  }
}
const eA = Symbol("_vte"), mB = (e) => e.__isTeleport, Gu = (e) => e && (e.disabled || e.disabled === ""), zE = (e) => typeof SVGElement < "u" && e instanceof SVGElement, WE = (e) => typeof MathMLElement == "function" && e instanceof MathMLElement, tb = (e, t) => {
  const n = e && e.to;
  if (Dn(n))
    if (t) {
      const r = t(n);
      return process.env.NODE_ENV !== "production" && !r && !Gu(e) && qe(
        `Failed to locate Teleport target with selector "${n}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`
      ), r;
    } else
      return process.env.NODE_ENV !== "production" && qe(
        "Current renderer does not support string target for Teleports. (missing querySelector renderer option)"
      ), null;
  else
    return process.env.NODE_ENV !== "production" && !n && !Gu(e) && qe(`Invalid Teleport target: ${n}`), n;
}, gB = {
  name: "Teleport",
  __isTeleport: !0,
  process(e, t, n, r, a, o, i, s, l, u) {
    const {
      mc: c,
      pc: f,
      pbc: d,
      o: { insert: p, querySelector: v, createText: h, createComment: m }
    } = u, y = Gu(t.props);
    let { shapeFlag: x, children: g, dynamicChildren: S } = t;
    if (process.env.NODE_ENV !== "production" && Vl && (l = !1, S = null), e == null) {
      const w = t.el = process.env.NODE_ENV !== "production" ? m("teleport start") : h(""), _ = t.anchor = process.env.NODE_ENV !== "production" ? m("teleport end") : h(""), b = t.target = tb(t.props, v), E = t.targetStart = h(""), C = t.targetAnchor = h("");
      p(w, n, r), p(_, n, r), E[eA] = C, b ? (p(E, b), p(C, b), i === "svg" || zE(b) ? i = "svg" : (i === "mathml" || WE(b)) && (i = "mathml")) : process.env.NODE_ENV !== "production" && !y && qe("Invalid Teleport target on mount:", b, `(${typeof b})`);
      const T = (O, I) => {
        x & 16 && c(
          g,
          O,
          I,
          a,
          o,
          i,
          s,
          l
        );
      };
      y ? T(n, _) : b && T(b, C);
    } else {
      t.el = e.el, t.targetStart = e.targetStart;
      const w = t.anchor = e.anchor, _ = t.target = e.target, b = t.targetAnchor = e.targetAnchor, E = Gu(e.props), C = E ? n : _, T = E ? w : b;
      if (i === "svg" || zE(_) ? i = "svg" : (i === "mathml" || WE(_)) && (i = "mathml"), S ? (d(
        e.dynamicChildren,
        S,
        C,
        a,
        o,
        i,
        s
      ), h0(e, t, !0)) : l || f(
        e,
        t,
        C,
        T,
        a,
        o,
        i,
        s,
        !1
      ), y)
        E ? t.props && e.props && t.props.to !== e.props.to && (t.props.to = e.props.to) : _h(
          t,
          n,
          w,
          u,
          1
        );
      else if ((t.props && t.props.to) !== (e.props && e.props.to)) {
        const O = t.target = tb(
          t.props,
          v
        );
        O ? _h(
          t,
          O,
          null,
          u,
          0
        ) : process.env.NODE_ENV !== "production" && qe(
          "Invalid Teleport target on update:",
          _,
          `(${typeof _})`
        );
      } else E && _h(
        t,
        _,
        b,
        u,
        1
      );
    }
    tA(t);
  },
  remove(e, t, n, { um: r, o: { remove: a } }, o) {
    const {
      shapeFlag: i,
      children: s,
      anchor: l,
      targetStart: u,
      targetAnchor: c,
      target: f,
      props: d
    } = e;
    if (f && (a(u), a(c)), o && a(l), i & 16) {
      const p = o || !Gu(d);
      for (let v = 0; v < s.length; v++) {
        const h = s[v];
        r(
          h,
          t,
          n,
          p,
          !!h.dynamicChildren
        );
      }
    }
  },
  move: _h,
  hydrate: yB
};
function _h(e, t, n, { o: { insert: r }, m: a }, o = 2) {
  o === 0 && r(e.targetAnchor, t, n);
  const { el: i, anchor: s, shapeFlag: l, children: u, props: c } = e, f = o === 2;
  if (f && r(i, t, n), (!f || Gu(c)) && l & 16)
    for (let d = 0; d < u.length; d++)
      a(
        u[d],
        t,
        n,
        2
      );
  f && r(s, t, n);
}
function yB(e, t, n, r, a, o, {
  o: { nextSibling: i, parentNode: s, querySelector: l }
}, u) {
  const c = t.target = tb(
    t.props,
    l
  );
  if (c) {
    const f = c._lpa || c.firstChild;
    if (t.shapeFlag & 16)
      if (Gu(t.props))
        t.anchor = u(
          i(e),
          t,
          s(e),
          n,
          r,
          a,
          o
        ), t.targetAnchor = f;
      else {
        t.anchor = i(e);
        let d = f;
        for (; d; )
          if (d = i(d), d && d.nodeType === 8 && d.data === "teleport anchor") {
            t.targetAnchor = d, c._lpa = t.targetAnchor && i(t.targetAnchor);
            break;
          }
        u(
          f,
          t,
          c,
          n,
          r,
          a,
          o
        );
      }
    tA(t);
  }
  return t.anchor && i(t.anchor);
}
const Eg = gB;
function tA(e) {
  const t = e.ctx;
  if (t && t.ut) {
    let n = e.children[0].el;
    for (; n && n !== e.targetAnchor; )
      n.nodeType === 1 && n.setAttribute("data-v-owner", t.uid), n = n.nextSibling;
    t.ut();
  }
}
let GE = !1;
const gu = () => {
  GE || (console.error("Hydration completed but contains mismatches."), GE = !0);
}, xB = (e) => e.namespaceURI.includes("svg") && e.tagName !== "foreignObject", bB = (e) => e.namespaceURI.includes("MathML"), Ch = (e) => {
  if (xB(e)) return "svg";
  if (bB(e)) return "mathml";
}, Dd = (e) => e.nodeType === 8;
function wB(e) {
  const {
    mt: t,
    p: n,
    o: {
      patchProp: r,
      createText: a,
      nextSibling: o,
      parentNode: i,
      remove: s,
      insert: l,
      createComment: u
    }
  } = e, c = (g, S) => {
    if (!S.hasChildNodes()) {
      process.env.NODE_ENV !== "production" && qe(
        "Attempting to hydrate existing markup but container is empty. Performing full mount instead."
      ), n(null, g, S), em(), S._vnode = g;
      return;
    }
    f(S.firstChild, g, null, null, null), em(), S._vnode = g;
  }, f = (g, S, w, _, b, E = !1) => {
    E = E || !!S.dynamicChildren;
    const C = Dd(g) && g.data === "[", T = () => h(
      g,
      S,
      w,
      _,
      b,
      C
    ), { type: O, ref: I, shapeFlag: k, patchFlag: B } = S;
    let P = g.nodeType;
    S.el = g, process.env.NODE_ENV !== "production" && (Mf(g, "__vnode", S, !0), Mf(g, "__vueParentComponent", w, !0)), B === -2 && (E = !1, S.dynamicChildren = null);
    let N = null;
    switch (O) {
      case Bi:
        P !== 3 ? S.children === "" ? (l(S.el = a(""), i(g), g), N = g) : N = T() : (g.data !== S.children && (process.env.NODE_ENV !== "production" && qe(
          "Hydration text mismatch in",
          g.parentNode,
          `
  - rendered on server: ${JSON.stringify(
            g.data
          )}
  - expected on client: ${JSON.stringify(S.children)}`
        ), gu(), g.data = S.children), N = o(g));
        break;
      case tr:
        x(g) ? (N = o(g), y(
          S.el = g.content.firstChild,
          g,
          w
        )) : P !== 8 || C ? N = T() : N = o(g);
        break;
      case Ul:
        if (C && (g = o(g), P = g.nodeType), P === 1 || P === 3) {
          N = g;
          const M = !S.children.length;
          for (let H = 0; H < S.staticCount; H++)
            M && (S.children += N.nodeType === 1 ? N.outerHTML : N.data), H === S.staticCount - 1 && (S.anchor = N), N = o(N);
          return C ? o(N) : N;
        } else
          T();
        break;
      case dt:
        C ? N = v(
          g,
          S,
          w,
          _,
          b,
          E
        ) : N = T();
        break;
      default:
        if (k & 1)
          (P !== 1 || S.type.toLowerCase() !== g.tagName.toLowerCase()) && !x(g) ? N = T() : N = d(
            g,
            S,
            w,
            _,
            b,
            E
          );
        else if (k & 6) {
          S.slotScopeIds = b;
          const M = i(g);
          if (C ? N = m(g) : Dd(g) && g.data === "teleport start" ? N = m(g, g.data, "teleport end") : N = o(g), t(
            S,
            M,
            null,
            w,
            _,
            Ch(M),
            E
          ), zu(S)) {
            let H;
            C ? (H = A(dt), H.anchor = N ? N.previousSibling : M.lastChild) : H = g.nodeType === 3 ? Jt("") : A("div"), H.el = g, S.component.subTree = H;
          }
        } else k & 64 ? P !== 8 ? N = T() : N = S.type.hydrate(
          g,
          S,
          w,
          _,
          b,
          E,
          e,
          p
        ) : k & 128 ? N = S.type.hydrate(
          g,
          S,
          w,
          _,
          Ch(i(g)),
          b,
          E,
          e,
          f
        ) : process.env.NODE_ENV !== "production" && qe("Invalid HostVNode type:", O, `(${typeof O})`);
    }
    return I != null && am(I, null, _, S), N;
  }, d = (g, S, w, _, b, E) => {
    E = E || !!S.dynamicChildren;
    const { type: C, props: T, patchFlag: O, shapeFlag: I, dirs: k, transition: B } = S, P = C === "input" || C === "option";
    if (process.env.NODE_ENV !== "production" || P || O !== -1) {
      k && Ji(S, null, w, "created");
      let N = !1;
      if (x(g)) {
        N = iA(_, B) && w && w.vnode.props && w.vnode.props.appear;
        const H = g.content.firstChild;
        N && B.beforeEnter(H), y(H, g, w), S.el = g = H;
      }
      if (I & 16 && // skip if element has innerHTML / textContent
      !(T && (T.innerHTML || T.textContent))) {
        let H = p(
          g.firstChild,
          S,
          g,
          w,
          _,
          b,
          E
        ), R = !1;
        for (; H; ) {
          process.env.NODE_ENV !== "production" && !R && (qe(
            "Hydration children mismatch on",
            g,
            `
Server rendered element contains more child nodes than client vdom.`
          ), R = !0), gu();
          const z = H;
          H = H.nextSibling, s(z);
        }
      } else I & 8 && g.textContent !== S.children && (process.env.NODE_ENV !== "production" && qe(
        "Hydration text content mismatch on",
        g,
        `
  - rendered on server: ${g.textContent}
  - expected on client: ${S.children}`
      ), gu(), g.textContent = S.children);
      if (T) {
        if (process.env.NODE_ENV !== "production" || P || !E || O & 48)
          for (const H in T)
            process.env.NODE_ENV !== "production" && // #11189 skip if this node has directives that have created hooks
            // as it could have mutated the DOM in any possible way
            !(k && k.some((R) => R.dir.created)) && SB(g, H, T[H], S, w) && gu(), (P && (H.endsWith("value") || H === "indeterminate") || ud(H) && !yf(H) || // force hydrate v-bind with .prop modifiers
            H[0] === ".") && r(g, H, null, T[H], void 0, w);
        else if (T.onClick)
          r(
            g,
            "onClick",
            null,
            T.onClick,
            void 0,
            w
          );
        else if (O & 4 && ai(T.style))
          for (const H in T.style) T.style[H];
      }
      let M;
      (M = T && T.onVnodeBeforeMount) && ro(M, w, S), k && Ji(S, null, w, "beforeMount"), ((M = T && T.onVnodeMounted) || k || N) && gA(() => {
        M && ro(M, w, S), N && B.enter(g), k && Ji(S, null, w, "mounted");
      }, _);
    }
    return g.nextSibling;
  }, p = (g, S, w, _, b, E, C) => {
    C = C || !!S.dynamicChildren;
    const T = S.children, O = T.length;
    let I = !1;
    for (let k = 0; k < O; k++) {
      const B = C ? T[k] : T[k] = Ua(T[k]), P = B.type === Bi;
      if (g) {
        if (P && !C) {
          let N = T[k + 1];
          N && (N = Ua(N)).type === Bi && (l(
            a(
              g.data.slice(B.children.length)
            ),
            w,
            o(g)
          ), g.data = B.children);
        }
        g = f(
          g,
          B,
          _,
          b,
          E,
          C
        );
      } else P && !B.children ? l(B.el = a(""), w) : (process.env.NODE_ENV !== "production" && !I && (qe(
        "Hydration children mismatch on",
        w,
        `
Server rendered element contains fewer child nodes than client vdom.`
      ), I = !0), gu(), n(
        null,
        B,
        w,
        null,
        _,
        b,
        Ch(w),
        E
      ));
    }
    return g;
  }, v = (g, S, w, _, b, E) => {
    const { slotScopeIds: C } = S;
    C && (b = b ? b.concat(C) : C);
    const T = i(g), O = p(
      o(g),
      S,
      T,
      w,
      _,
      b,
      E
    );
    return O && Dd(O) && O.data === "]" ? o(S.anchor = O) : (gu(), l(S.anchor = u("]"), T, O), O);
  }, h = (g, S, w, _, b, E) => {
    if (process.env.NODE_ENV !== "production" && qe(
      `Hydration node mismatch:
- rendered on server:`,
      g,
      g.nodeType === 3 ? "(text)" : Dd(g) && g.data === "[" ? "(start of fragment)" : "",
      `
- expected on client:`,
      S.type
    ), gu(), S.el = null, E) {
      const O = m(g);
      for (; ; ) {
        const I = o(g);
        if (I && I !== O)
          s(I);
        else
          break;
      }
    }
    const C = o(g), T = i(g);
    return s(g), n(
      null,
      S,
      T,
      C,
      w,
      _,
      Ch(T),
      b
    ), C;
  }, m = (g, S = "[", w = "]") => {
    let _ = 0;
    for (; g; )
      if (g = o(g), g && Dd(g) && (g.data === S && _++, g.data === w)) {
        if (_ === 0)
          return o(g);
        _--;
      }
    return g;
  }, y = (g, S, w) => {
    const _ = S.parentNode;
    _ && _.replaceChild(g, S);
    let b = w;
    for (; b; )
      b.vnode.el === S && (b.vnode.el = b.subTree.el = g), b = b.parent;
  }, x = (g) => g.nodeType === 1 && g.tagName.toLowerCase() === "template";
  return [c, f];
}
function SB(e, t, n, r, a) {
  let o, i, s, l;
  if (t === "class")
    s = e.getAttribute("class"), l = tn(n), _B(KE(s || ""), KE(l)) || (o = i = "class");
  else if (t === "style") {
    s = e.getAttribute("style") || "", l = Dn(n) ? n : vF(_r(n));
    const u = YE(s), c = YE(l);
    if (r.dirs)
      for (const { dir: f, value: d } of r.dirs)
        f.name === "show" && !d && c.set("display", "none");
    a && nA(a, r, c), CB(u, c) || (o = i = "style");
  } else (e instanceof SVGElement && CF(t) || e instanceof HTMLElement && (CE(t) || _F(t))) && (CE(t) ? (s = e.hasAttribute(t), l = n_(n)) : n == null ? (s = e.hasAttribute(t), l = !1) : (e.hasAttribute(t) ? s = e.getAttribute(t) : t === "value" && e.tagName === "TEXTAREA" ? s = e.value : s = !1, l = EF(n) ? String(n) : !1), s !== l && (o = "attribute", i = t));
  if (o) {
    const u = (d) => d === !1 ? "(not rendered)" : `${i}="${d}"`, c = `Hydration ${o} mismatch on`, f = `
  - rendered on server: ${u(s)}
  - expected on client: ${u(l)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
    return qe(c, e, f), !0;
  }
  return !1;
}
function KE(e) {
  return new Set(e.trim().split(/\s+/));
}
function _B(e, t) {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
}
function YE(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of e.split(";")) {
    let [r, a] = n.split(":");
    r = r.trim(), a = a && a.trim(), r && a && t.set(r, a);
  }
  return t;
}
function CB(e, t) {
  if (e.size !== t.size)
    return !1;
  for (const [n, r] of e)
    if (r !== t.get(n))
      return !1;
  return !0;
}
function nA(e, t, n) {
  const r = e.subTree;
  if (e.getCssVars && (t === r || r && r.type === dt && r.children.includes(t))) {
    const a = e.getCssVars();
    for (const o in a)
      n.set(`--${o}`, String(a[o]));
  }
  t === r && e.parent && nA(e.parent, e.vnode, n);
}
let kd, Al;
function Ds(e, t) {
  e.appContext.config.performance && om() && Al.mark(`vue-${t}-${e.uid}`), process.env.NODE_ENV !== "production" && _L(e, t, om() ? Al.now() : Date.now());
}
function ks(e, t) {
  if (e.appContext.config.performance && om()) {
    const n = `vue-${t}-${e.uid}`, r = n + ":end";
    Al.mark(r), Al.measure(
      `<${Og(e, e.type)}> ${t}`,
      n,
      r
    ), Al.clearMarks(n), Al.clearMarks(r);
  }
  process.env.NODE_ENV !== "production" && CL(e, t, om() ? Al.now() : Date.now());
}
function om() {
  return kd !== void 0 || (typeof window < "u" && window.performance ? (kd = !0, Al = window.performance) : kd = !1), kd;
}
function EB() {
  const e = [];
  if (process.env.NODE_ENV !== "production" && e.length) {
    const t = e.length > 1;
    console.warn(
      `Feature flag${t ? "s" : ""} ${e.join(", ")} ${t ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const Hr = gA;
function rA(e) {
  return oA(e);
}
function aA(e) {
  return oA(e, wB);
}
function oA(e, t) {
  EB();
  const n = t_();
  n.__VUE__ = !0, process.env.NODE_ENV !== "production" && p_(n.__VUE_DEVTOOLS_GLOBAL_HOOK__, n);
  const {
    insert: r,
    remove: a,
    patchProp: o,
    createElement: i,
    createText: s,
    createComment: l,
    setText: u,
    setElementText: c,
    parentNode: f,
    nextSibling: d,
    setScopeId: p = vr,
    insertStaticContent: v
  } = e, h = (j, J, ae, he = null, K = null, Z = null, se = void 0, me = null, xe = process.env.NODE_ENV !== "production" && Vl ? !1 : !!J.dynamicChildren) => {
    if (j === J)
      return;
    j && !Di(j, J) && (he = le(j), Y(j, K, Z, !0), j = null), J.patchFlag === -2 && (xe = !1, J.dynamicChildren = null);
    const { type: be, ref: Te, shapeFlag: Ie } = J;
    switch (be) {
      case Bi:
        m(j, J, ae, he);
        break;
      case tr:
        y(j, J, ae, he);
        break;
      case Ul:
        j == null ? x(J, ae, he, se) : process.env.NODE_ENV !== "production" && g(j, J, ae, se);
        break;
      case dt:
        k(
          j,
          J,
          ae,
          he,
          K,
          Z,
          se,
          me,
          xe
        );
        break;
      default:
        Ie & 1 ? _(
          j,
          J,
          ae,
          he,
          K,
          Z,
          se,
          me,
          xe
        ) : Ie & 6 ? B(
          j,
          J,
          ae,
          he,
          K,
          Z,
          se,
          me,
          xe
        ) : Ie & 64 || Ie & 128 ? be.process(
          j,
          J,
          ae,
          he,
          K,
          Z,
          se,
          me,
          xe,
          oe
        ) : process.env.NODE_ENV !== "production" && qe("Invalid VNode type:", be, `(${typeof be})`);
    }
    Te != null && K && am(Te, j && j.ref, Z, J || j, !J);
  }, m = (j, J, ae, he) => {
    if (j == null)
      r(
        J.el = s(J.children),
        ae,
        he
      );
    else {
      const K = J.el = j.el;
      J.children !== j.children && u(K, J.children);
    }
  }, y = (j, J, ae, he) => {
    j == null ? r(
      J.el = l(J.children || ""),
      ae,
      he
    ) : J.el = j.el;
  }, x = (j, J, ae, he) => {
    [j.el, j.anchor] = v(
      j.children,
      J,
      ae,
      he,
      j.el,
      j.anchor
    );
  }, g = (j, J, ae, he) => {
    if (J.children !== j.children) {
      const K = d(j.anchor);
      w(j), [J.el, J.anchor] = v(
        J.children,
        ae,
        K,
        he
      );
    } else
      J.el = j.el, J.anchor = j.anchor;
  }, S = ({ el: j, anchor: J }, ae, he) => {
    let K;
    for (; j && j !== J; )
      K = d(j), r(j, ae, he), j = K;
    r(J, ae, he);
  }, w = ({ el: j, anchor: J }) => {
    let ae;
    for (; j && j !== J; )
      ae = d(j), a(j), j = ae;
    a(J);
  }, _ = (j, J, ae, he, K, Z, se, me, xe) => {
    J.type === "svg" ? se = "svg" : J.type === "math" && (se = "mathml"), j == null ? b(
      J,
      ae,
      he,
      K,
      Z,
      se,
      me,
      xe
    ) : T(
      j,
      J,
      K,
      Z,
      se,
      me,
      xe
    );
  }, b = (j, J, ae, he, K, Z, se, me) => {
    let xe, be;
    const { props: Te, shapeFlag: Ie, transition: Ve, dirs: tt } = j;
    if (xe = j.el = i(
      j.type,
      Z,
      Te && Te.is,
      Te
    ), Ie & 8 ? c(xe, j.children) : Ie & 16 && C(
      j.children,
      xe,
      null,
      he,
      K,
      ay(j, Z),
      se,
      me
    ), tt && Ji(j, null, he, "created"), E(xe, j, j.scopeId, se, he), Te) {
      for (const Se in Te)
        Se !== "value" && !yf(Se) && o(xe, Se, null, Te[Se], Z, he);
      "value" in Te && o(xe, "value", null, Te.value, Z), (be = Te.onVnodeBeforeMount) && ro(be, he, j);
    }
    process.env.NODE_ENV !== "production" && (Mf(xe, "__vnode", j, !0), Mf(xe, "__vueParentComponent", he, !0)), tt && Ji(j, null, he, "beforeMount");
    const it = iA(K, Ve);
    it && Ve.beforeEnter(xe), r(xe, J, ae), ((be = Te && Te.onVnodeMounted) || it || tt) && Hr(() => {
      be && ro(be, he, j), it && Ve.enter(xe), tt && Ji(j, null, he, "mounted");
    }, K);
  }, E = (j, J, ae, he, K) => {
    if (ae && p(j, ae), he)
      for (let Z = 0; Z < he.length; Z++)
        p(j, he[Z]);
    if (K) {
      let Z = K.subTree;
      if (process.env.NODE_ENV !== "production" && Z.patchFlag > 0 && Z.patchFlag & 2048 && (Z = $g(Z.children) || Z), J === Z) {
        const se = K.vnode;
        E(
          j,
          se,
          se.scopeId,
          se.slotScopeIds,
          K.parent
        );
      }
    }
  }, C = (j, J, ae, he, K, Z, se, me, xe = 0) => {
    for (let be = xe; be < j.length; be++) {
      const Te = j[be] = me ? Tl(j[be]) : Ua(j[be]);
      h(
        null,
        Te,
        J,
        ae,
        he,
        K,
        Z,
        se,
        me
      );
    }
  }, T = (j, J, ae, he, K, Z, se) => {
    const me = J.el = j.el;
    process.env.NODE_ENV !== "production" && (me.__vnode = J);
    let { patchFlag: xe, dynamicChildren: be, dirs: Te } = J;
    xe |= j.patchFlag & 16;
    const Ie = j.props || On, Ve = J.props || On;
    let tt;
    if (ae && yu(ae, !1), (tt = Ve.onVnodeBeforeUpdate) && ro(tt, ae, J, j), Te && Ji(J, j, ae, "beforeUpdate"), ae && yu(ae, !0), process.env.NODE_ENV !== "production" && Vl && (xe = 0, se = !1, be = null), (Ie.innerHTML && Ve.innerHTML == null || Ie.textContent && Ve.textContent == null) && c(me, ""), be ? (O(
      j.dynamicChildren,
      be,
      me,
      ae,
      he,
      ay(J, K),
      Z
    ), process.env.NODE_ENV !== "production" && h0(j, J)) : se || R(
      j,
      J,
      me,
      null,
      ae,
      he,
      ay(J, K),
      Z,
      !1
    ), xe > 0) {
      if (xe & 16)
        I(me, Ie, Ve, ae, K);
      else if (xe & 2 && Ie.class !== Ve.class && o(me, "class", null, Ve.class, K), xe & 4 && o(me, "style", Ie.style, Ve.style, K), xe & 8) {
        const it = J.dynamicProps;
        for (let Se = 0; Se < it.length; Se++) {
          const ge = it[Se], pe = Ie[ge], De = Ve[ge];
          (De !== pe || ge === "value") && o(me, ge, pe, De, K, ae);
        }
      }
      xe & 1 && j.children !== J.children && c(me, J.children);
    } else !se && be == null && I(me, Ie, Ve, ae, K);
    ((tt = Ve.onVnodeUpdated) || Te) && Hr(() => {
      tt && ro(tt, ae, J, j), Te && Ji(J, j, ae, "updated");
    }, he);
  }, O = (j, J, ae, he, K, Z, se) => {
    for (let me = 0; me < J.length; me++) {
      const xe = j[me], be = J[me], Te = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        xe.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (xe.type === dt || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Di(xe, be) || // - In the case of a component, it could contain anything.
        xe.shapeFlag & 70) ? f(xe.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          ae
        )
      );
      h(
        xe,
        be,
        Te,
        null,
        he,
        K,
        Z,
        se,
        !0
      );
    }
  }, I = (j, J, ae, he, K) => {
    if (J !== ae) {
      if (J !== On)
        for (const Z in J)
          !yf(Z) && !(Z in ae) && o(
            j,
            Z,
            J[Z],
            null,
            K,
            he
          );
      for (const Z in ae) {
        if (yf(Z)) continue;
        const se = ae[Z], me = J[Z];
        se !== me && Z !== "value" && o(j, Z, me, se, K, he);
      }
      "value" in ae && o(j, "value", J.value, ae.value, K);
    }
  }, k = (j, J, ae, he, K, Z, se, me, xe) => {
    const be = J.el = j ? j.el : s(""), Te = J.anchor = j ? j.anchor : s("");
    let { patchFlag: Ie, dynamicChildren: Ve, slotScopeIds: tt } = J;
    process.env.NODE_ENV !== "production" && // #5523 dev root fragment may inherit directives
    (Vl || Ie & 2048) && (Ie = 0, xe = !1, Ve = null), tt && (me = me ? me.concat(tt) : tt), j == null ? (r(be, ae, he), r(Te, ae, he), C(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      J.children || [],
      ae,
      Te,
      K,
      Z,
      se,
      me,
      xe
    )) : Ie > 0 && Ie & 64 && Ve && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    j.dynamicChildren ? (O(
      j.dynamicChildren,
      Ve,
      ae,
      K,
      Z,
      se,
      me
    ), process.env.NODE_ENV !== "production" ? h0(j, J) : (
      // #2080 if the stable fragment has a key, it's a <template v-for> that may
      //  get moved around. Make sure all root level vnodes inherit el.
      // #2134 or if it's a component root, it may also get moved around
      // as the component is being moved.
      (J.key != null || K && J === K.subTree) && h0(
        j,
        J,
        !0
        /* shallow */
      )
    )) : R(
      j,
      J,
      ae,
      Te,
      K,
      Z,
      se,
      me,
      xe
    );
  }, B = (j, J, ae, he, K, Z, se, me, xe) => {
    J.slotScopeIds = me, j == null ? J.shapeFlag & 512 ? K.ctx.activate(
      J,
      ae,
      he,
      se,
      xe
    ) : P(
      J,
      ae,
      he,
      K,
      Z,
      se,
      xe
    ) : N(j, J, xe);
  }, P = (j, J, ae, he, K, Z, se) => {
    const me = j.component = _A(
      j,
      he,
      K
    );
    if (process.env.NODE_ENV !== "production" && me.type.__hmrId && vL(me), process.env.NODE_ENV !== "production" && (f0(j), Ds(me, "mount")), dd(j) && (me.ctx.renderer = oe), process.env.NODE_ENV !== "production" && Ds(me, "init"), EA(me, !1, se), process.env.NODE_ENV !== "production" && ks(me, "init"), me.asyncDep) {
      if (K && K.registerDep(me, M, se), !j.el) {
        const xe = me.subTree = A(tr);
        y(null, xe, J, ae);
      }
    } else
      M(
        me,
        j,
        J,
        ae,
        K,
        Z,
        se
      );
    process.env.NODE_ENV !== "production" && (d0(), ks(me, "mount"));
  }, N = (j, J, ae) => {
    const he = J.component = j.component;
    if (PB(j, J, ae))
      if (he.asyncDep && !he.asyncResolved) {
        process.env.NODE_ENV !== "production" && f0(J), H(he, J, ae), process.env.NODE_ENV !== "production" && d0();
        return;
      } else
        he.next = J, pL(he.update), he.effect.dirty = !0, he.update();
    else
      J.el = j.el, he.vnode = J;
  }, M = (j, J, ae, he, K, Z, se) => {
    const me = () => {
      if (j.isMounted) {
        let { next: Te, bu: Ie, u: Ve, parent: tt, vnode: it } = j;
        {
          const Ue = sA(j);
          if (Ue) {
            Te && (Te.el = it.el, H(j, Te, se)), Ue.asyncDep.then(() => {
              j.isUnmounted || me();
            });
            return;
          }
        }
        let Se = Te, ge;
        process.env.NODE_ENV !== "production" && f0(Te || j.vnode), yu(j, !1), Te ? (Te.el = it.el, H(j, Te, se)) : Te = it, Ie && Ol(Ie), (ge = Te.props && Te.props.onVnodeBeforeUpdate) && ro(ge, tt, Te, it), yu(j, !0), process.env.NODE_ENV !== "production" && Ds(j, "render");
        const pe = wv(j);
        process.env.NODE_ENV !== "production" && ks(j, "render");
        const De = j.subTree;
        j.subTree = pe, process.env.NODE_ENV !== "production" && Ds(j, "patch"), h(
          De,
          pe,
          // parent may have changed if it's in a teleport
          f(De.el),
          // anchor may have changed if it's in a fragment
          le(De),
          j,
          K,
          Z
        ), process.env.NODE_ENV !== "production" && ks(j, "patch"), Te.el = pe.el, Se === null && C_(j, pe.el), Ve && Hr(Ve, K), (ge = Te.props && Te.props.onVnodeUpdated) && Hr(
          () => ro(ge, tt, Te, it),
          K
        ), process.env.NODE_ENV !== "production" && E9(j), process.env.NODE_ENV !== "production" && d0();
      } else {
        let Te;
        const { el: Ie, props: Ve } = J, { bm: tt, m: it, parent: Se } = j, ge = zu(J);
        if (yu(j, !1), tt && Ol(tt), !ge && (Te = Ve && Ve.onVnodeBeforeMount) && ro(Te, Se, J), yu(j, !0), Ie && re) {
          const pe = () => {
            process.env.NODE_ENV !== "production" && Ds(j, "render"), j.subTree = wv(j), process.env.NODE_ENV !== "production" && ks(j, "render"), process.env.NODE_ENV !== "production" && Ds(j, "hydrate"), re(
              Ie,
              j.subTree,
              j,
              K,
              null
            ), process.env.NODE_ENV !== "production" && ks(j, "hydrate");
          };
          ge ? J.type.__asyncLoader().then(
            // note: we are moving the render call into an async callback,
            // which means it won't track dependencies - but it's ok because
            // a server-rendered async wrapper is already in resolved state
            // and it will never need to change.
            () => !j.isUnmounted && pe()
          ) : pe();
        } else {
          process.env.NODE_ENV !== "production" && Ds(j, "render");
          const pe = j.subTree = wv(j);
          process.env.NODE_ENV !== "production" && ks(j, "render"), process.env.NODE_ENV !== "production" && Ds(j, "patch"), h(
            null,
            pe,
            ae,
            he,
            j,
            K,
            Z
          ), process.env.NODE_ENV !== "production" && ks(j, "patch"), J.el = pe.el;
        }
        if (it && Hr(it, K), !ge && (Te = Ve && Ve.onVnodeMounted)) {
          const pe = J;
          Hr(
            () => ro(Te, Se, pe),
            K
          );
        }
        (J.shapeFlag & 256 || Se && zu(Se.vnode) && Se.vnode.shapeFlag & 256) && j.a && Hr(j.a, K), j.isMounted = !0, process.env.NODE_ENV !== "production" && Kx(j), J = ae = he = null;
      }
    }, xe = j.effect = new Rf(
      me,
      vr,
      () => Op(be),
      j.scope
      // track it in component's effect scope
    ), be = j.update = () => {
      xe.dirty && xe.run();
    };
    be.i = j, be.id = j.uid, yu(j, !0), process.env.NODE_ENV !== "production" && (xe.onTrack = j.rtc ? (Te) => Ol(j.rtc, Te) : void 0, xe.onTrigger = j.rtg ? (Te) => Ol(j.rtg, Te) : void 0), be();
  }, H = (j, J, ae) => {
    J.component = j;
    const he = j.vnode.props;
    j.vnode = J, j.next = null, iB(j, J.props, he, ae), vB(j, J.children, ae), nl(), DE(j), rl();
  }, R = (j, J, ae, he, K, Z, se, me, xe = !1) => {
    const be = j && j.children, Te = j ? j.shapeFlag : 0, Ie = J.children, { patchFlag: Ve, shapeFlag: tt } = J;
    if (Ve > 0) {
      if (Ve & 128) {
        W(
          be,
          Ie,
          ae,
          he,
          K,
          Z,
          se,
          me,
          xe
        );
        return;
      } else if (Ve & 256) {
        z(
          be,
          Ie,
          ae,
          he,
          K,
          Z,
          se,
          me,
          xe
        );
        return;
      }
    }
    tt & 8 ? (Te & 16 && ue(be, K, Z), Ie !== be && c(ae, Ie)) : Te & 16 ? tt & 16 ? W(
      be,
      Ie,
      ae,
      he,
      K,
      Z,
      se,
      me,
      xe
    ) : ue(be, K, Z, !0) : (Te & 8 && c(ae, ""), tt & 16 && C(
      Ie,
      ae,
      he,
      K,
      Z,
      se,
      me,
      xe
    ));
  }, z = (j, J, ae, he, K, Z, se, me, xe) => {
    j = j || gf, J = J || gf;
    const be = j.length, Te = J.length, Ie = Math.min(be, Te);
    let Ve;
    for (Ve = 0; Ve < Ie; Ve++) {
      const tt = J[Ve] = xe ? Tl(J[Ve]) : Ua(J[Ve]);
      h(
        j[Ve],
        tt,
        ae,
        null,
        K,
        Z,
        se,
        me,
        xe
      );
    }
    be > Te ? ue(
      j,
      K,
      Z,
      !0,
      !1,
      Ie
    ) : C(
      J,
      ae,
      he,
      K,
      Z,
      se,
      me,
      xe,
      Ie
    );
  }, W = (j, J, ae, he, K, Z, se, me, xe) => {
    let be = 0;
    const Te = J.length;
    let Ie = j.length - 1, Ve = Te - 1;
    for (; be <= Ie && be <= Ve; ) {
      const tt = j[be], it = J[be] = xe ? Tl(J[be]) : Ua(J[be]);
      if (Di(tt, it))
        h(
          tt,
          it,
          ae,
          null,
          K,
          Z,
          se,
          me,
          xe
        );
      else
        break;
      be++;
    }
    for (; be <= Ie && be <= Ve; ) {
      const tt = j[Ie], it = J[Ve] = xe ? Tl(J[Ve]) : Ua(J[Ve]);
      if (Di(tt, it))
        h(
          tt,
          it,
          ae,
          null,
          K,
          Z,
          se,
          me,
          xe
        );
      else
        break;
      Ie--, Ve--;
    }
    if (be > Ie) {
      if (be <= Ve) {
        const tt = Ve + 1, it = tt < Te ? J[tt].el : he;
        for (; be <= Ve; )
          h(
            null,
            J[be] = xe ? Tl(J[be]) : Ua(J[be]),
            ae,
            it,
            K,
            Z,
            se,
            me,
            xe
          ), be++;
      }
    } else if (be > Ve)
      for (; be <= Ie; )
        Y(j[be], K, Z, !0), be++;
    else {
      const tt = be, it = be, Se = /* @__PURE__ */ new Map();
      for (be = it; be <= Ve; be++) {
        const Mt = J[be] = xe ? Tl(J[be]) : Ua(J[be]);
        Mt.key != null && (process.env.NODE_ENV !== "production" && Se.has(Mt.key) && qe(
          "Duplicate keys found during update:",
          JSON.stringify(Mt.key),
          "Make sure keys are unique."
        ), Se.set(Mt.key, be));
      }
      let ge, pe = 0;
      const De = Ve - it + 1;
      let Ue = !1, Xe = 0;
      const ut = new Array(De);
      for (be = 0; be < De; be++) ut[be] = 0;
      for (be = tt; be <= Ie; be++) {
        const Mt = j[be];
        if (pe >= De) {
          Y(Mt, K, Z, !0);
          continue;
        }
        let yt;
        if (Mt.key != null)
          yt = Se.get(Mt.key);
        else
          for (ge = it; ge <= Ve; ge++)
            if (ut[ge - it] === 0 && Di(Mt, J[ge])) {
              yt = ge;
              break;
            }
        yt === void 0 ? Y(Mt, K, Z, !0) : (ut[yt - it] = be + 1, yt >= Xe ? Xe = yt : Ue = !0, h(
          Mt,
          J[yt],
          ae,
          null,
          K,
          Z,
          se,
          me,
          xe
        ), pe++);
      }
      const xt = Ue ? TB(ut) : gf;
      for (ge = xt.length - 1, be = De - 1; be >= 0; be--) {
        const Mt = it + be, yt = J[Mt], gt = Mt + 1 < Te ? J[Mt + 1].el : he;
        ut[be] === 0 ? h(
          null,
          yt,
          ae,
          gt,
          K,
          Z,
          se,
          me,
          xe
        ) : Ue && (ge < 0 || be !== xt[ge] ? F(yt, ae, gt, 2) : ge--);
      }
    }
  }, F = (j, J, ae, he, K = null) => {
    const { el: Z, type: se, transition: me, children: xe, shapeFlag: be } = j;
    if (be & 6) {
      F(j.component.subTree, J, ae, he);
      return;
    }
    if (be & 128) {
      j.suspense.move(J, ae, he);
      return;
    }
    if (be & 64) {
      se.move(j, J, ae, oe);
      return;
    }
    if (se === dt) {
      r(Z, J, ae);
      for (let Ie = 0; Ie < xe.length; Ie++)
        F(xe[Ie], J, ae, he);
      r(j.anchor, J, ae);
      return;
    }
    if (se === Ul) {
      S(j, J, ae);
      return;
    }
    if (he !== 2 && be & 1 && me)
      if (he === 0)
        me.beforeEnter(Z), r(Z, J, ae), Hr(() => me.enter(Z), K);
      else {
        const { leave: Ie, delayLeave: Ve, afterLeave: tt } = me, it = () => r(Z, J, ae), Se = () => {
          Ie(Z, () => {
            it(), tt && tt();
          });
        };
        Ve ? Ve(Z, it, Se) : Se();
      }
    else
      r(Z, J, ae);
  }, Y = (j, J, ae, he = !1, K = !1) => {
    const {
      type: Z,
      props: se,
      ref: me,
      children: xe,
      dynamicChildren: be,
      shapeFlag: Te,
      patchFlag: Ie,
      dirs: Ve,
      cacheIndex: tt
    } = j;
    if (Ie === -2 && (K = !1), me != null && am(me, null, ae, j, !0), tt != null && (J.renderCache[tt] = void 0), Te & 256) {
      J.ctx.deactivate(j);
      return;
    }
    const it = Te & 1 && Ve, Se = !zu(j);
    let ge;
    if (Se && (ge = se && se.onVnodeBeforeUnmount) && ro(ge, J, j), Te & 6)
      Q(j.component, ae, he);
    else {
      if (Te & 128) {
        j.suspense.unmount(ae, he);
        return;
      }
      it && Ji(j, null, J, "beforeUnmount"), Te & 64 ? j.type.remove(
        j,
        J,
        ae,
        oe,
        he
      ) : be && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !be.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (Z !== dt || Ie > 0 && Ie & 64) ? ue(
        be,
        J,
        ae,
        !1,
        !0
      ) : (Z === dt && Ie & 384 || !K && Te & 16) && ue(xe, J, ae), he && X(j);
    }
    (Se && (ge = se && se.onVnodeUnmounted) || it) && Hr(() => {
      ge && ro(ge, J, j), it && Ji(j, null, J, "unmounted");
    }, ae);
  }, X = (j) => {
    const { type: J, el: ae, anchor: he, transition: K } = j;
    if (J === dt) {
      process.env.NODE_ENV !== "production" && j.patchFlag > 0 && j.patchFlag & 2048 && K && !K.persisted ? j.children.forEach((se) => {
        se.type === tr ? a(se.el) : X(se);
      }) : q(ae, he);
      return;
    }
    if (J === Ul) {
      w(j);
      return;
    }
    const Z = () => {
      a(ae), K && !K.persisted && K.afterLeave && K.afterLeave();
    };
    if (j.shapeFlag & 1 && K && !K.persisted) {
      const { leave: se, delayLeave: me } = K, xe = () => se(ae, Z);
      me ? me(j.el, Z, xe) : xe();
    } else
      Z();
  }, q = (j, J) => {
    let ae;
    for (; j !== J; )
      ae = d(j), a(j), j = ae;
    a(J);
  }, Q = (j, J, ae) => {
    process.env.NODE_ENV !== "production" && j.type.__hmrId && mL(j);
    const { bum: he, scope: K, update: Z, subTree: se, um: me, m: xe, a: be } = j;
    im(xe), im(be), he && Ol(he), K.stop(), Z && (Z.active = !1, Y(se, j, J, ae)), me && Hr(me, J), Hr(() => {
      j.isUnmounted = !0;
    }, J), J && J.pendingBranch && !J.isUnmounted && j.asyncDep && !j.asyncResolved && j.suspenseId === J.pendingId && (J.deps--, J.deps === 0 && J.resolve()), process.env.NODE_ENV !== "production" && SL(j);
  }, ue = (j, J, ae, he = !1, K = !1, Z = 0) => {
    for (let se = Z; se < j.length; se++)
      Y(j[se], J, ae, he, K);
  }, le = (j) => {
    if (j.shapeFlag & 6)
      return le(j.component.subTree);
    if (j.shapeFlag & 128)
      return j.suspense.next();
    const J = d(j.anchor || j.el), ae = J && J[eA];
    return ae ? d(ae) : J;
  };
  let te = !1;
  const G = (j, J, ae) => {
    j == null ? J._vnode && Y(J._vnode, null, null, !0) : h(
      J._vnode || null,
      j,
      J,
      null,
      null,
      null,
      ae
    ), te || (te = !0, DE(), em(), te = !1), J._vnode = j;
  }, oe = {
    p: h,
    um: Y,
    m: F,
    r: X,
    mt: P,
    mc: C,
    pc: R,
    pbc: O,
    n: le,
    o: e
  };
  let L, re;
  return t && ([L, re] = t(
    oe
  )), {
    render: G,
    hydrate: L,
    createApp: rB(G, L)
  };
}
function ay({ type: e, props: t }, n) {
  return n === "svg" && e === "foreignObject" || n === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function yu({ effect: e, update: t }, n) {
  e.allowRecurse = t.allowRecurse = n;
}
function iA(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function h0(e, t, n = !1) {
  const r = e.children, a = t.children;
  if (St(r) && St(a))
    for (let o = 0; o < r.length; o++) {
      const i = r[o];
      let s = a[o];
      s.shapeFlag & 1 && !s.dynamicChildren && ((s.patchFlag <= 0 || s.patchFlag === 32) && (s = a[o] = Tl(a[o]), s.el = i.el), !n && s.patchFlag !== -2 && h0(i, s)), s.type === Bi && (s.el = i.el), process.env.NODE_ENV !== "production" && s.type === tr && !s.el && (s.el = i.el);
    }
}
function TB(e) {
  const t = e.slice(), n = [0];
  let r, a, o, i, s;
  const l = e.length;
  for (r = 0; r < l; r++) {
    const u = e[r];
    if (u !== 0) {
      if (a = n[n.length - 1], e[a] < u) {
        t[r] = a, n.push(r);
        continue;
      }
      for (o = 0, i = n.length - 1; o < i; )
        s = o + i >> 1, e[n[s]] < u ? o = s + 1 : i = s;
      u < e[n[o]] && (o > 0 && (t[r] = n[o - 1]), n[o] = r);
    }
  }
  for (o = n.length, i = n[o - 1]; o-- > 0; )
    n[o] = i, i = t[i];
  return n;
}
function sA(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : sA(t);
}
function im(e) {
  if (e)
    for (let t = 0; t < e.length; t++) e[t].active = !1;
}
const lA = Symbol.for("v-scx"), uA = () => {
  {
    const e = Ke(lA);
    return e || process.env.NODE_ENV !== "production" && qe(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function _n(e, t) {
  return Ip(e, null, t);
}
function cA(e, t) {
  return Ip(
    e,
    null,
    process.env.NODE_ENV !== "production" ? Ln({}, t, { flush: "post" }) : { flush: "post" }
  );
}
function fA(e, t) {
  return Ip(
    e,
    null,
    process.env.NODE_ENV !== "production" ? Ln({}, t, { flush: "sync" }) : { flush: "sync" }
  );
}
const Eh = {};
function He(e, t, n) {
  return process.env.NODE_ENV !== "production" && !Pt(t) && qe(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), Ip(e, t, n);
}
function Ip(e, t, {
  immediate: n,
  deep: r,
  flush: a,
  once: o,
  onTrack: i,
  onTrigger: s
} = On) {
  if (t && o) {
    const b = t;
    t = (...E) => {
      b(...E), _();
    };
  }
  process.env.NODE_ENV !== "production" && r !== void 0 && typeof r == "number" && qe(
    'watch() "deep" option with number value will be used as watch depth in future versions. Please use a boolean instead to avoid potential breakage.'
  ), process.env.NODE_ENV !== "production" && !t && (n !== void 0 && qe(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), r !== void 0 && qe(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), o !== void 0 && qe(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const l = (b) => {
    qe(
      "Invalid watch source: ",
      b,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, u = Cr, c = (b) => r === !0 ? b : (
    // for deep: false, only traverse root-level properties
    Il(b, r === !1 ? 1 : void 0)
  );
  let f, d = !1, p = !1;
  if (Ft(e) ? (f = () => e.value, d = is(e)) : ai(e) ? (f = () => c(e), d = !0) : St(e) ? (p = !0, d = e.some((b) => ai(b) || is(b)), f = () => e.map((b) => {
    if (Ft(b))
      return b.value;
    if (ai(b))
      return c(b);
    if (Pt(b))
      return ss(b, u, 2);
    process.env.NODE_ENV !== "production" && l(b);
  })) : Pt(e) ? t ? f = () => ss(e, u, 2) : f = () => (v && v(), Ro(
    e,
    u,
    3,
    [h]
  )) : (f = vr, process.env.NODE_ENV !== "production" && l(e)), t && r) {
    const b = f;
    f = () => Il(b());
  }
  let v, h = (b) => {
    v = S.onStop = () => {
      ss(b, u, 4), v = S.onStop = void 0;
    };
  }, m;
  if (Pp)
    if (h = vr, t ? n && Ro(t, u, 3, [
      f(),
      p ? [] : void 0,
      h
    ]) : f(), a === "sync") {
      const b = uA();
      m = b.__watcherHandles || (b.__watcherHandles = []);
    } else
      return vr;
  let y = p ? new Array(e.length).fill(Eh) : Eh;
  const x = () => {
    if (!(!S.active || !S.dirty))
      if (t) {
        const b = S.run();
        (r || d || (p ? b.some((E, C) => Ui(E, y[C])) : Ui(b, y))) && (v && v(), Ro(t, u, 3, [
          b,
          // pass undefined as the old value when it's changed for the first time
          y === Eh ? void 0 : p && y[0] === Eh ? [] : y,
          h
        ]), y = b);
      } else
        S.run();
  };
  x.allowRecurse = !!t;
  let g;
  a === "sync" ? g = x : a === "post" ? g = () => Hr(x, u && u.suspense) : (x.pre = !0, u && (x.id = u.uid), g = () => Op(x));
  const S = new Rf(f, vr, g), w = fd(), _ = () => {
    S.stop(), w && QS(w.effects, S);
  };
  return process.env.NODE_ENV !== "production" && (S.onTrack = i, S.onTrigger = s), t ? n ? x() : y = S.run() : a === "post" ? Hr(
    S.run.bind(S),
    u && u.suspense
  ) : S.run(), m && m.push(_), _;
}
function $B(e, t, n) {
  const r = this.proxy, a = Dn(e) ? e.includes(".") ? dA(r, e) : () => r[e] : e.bind(r, r);
  let o;
  Pt(t) ? o = t : (o = t.handler, n = t);
  const i = lc(this), s = Ip(a, o.bind(r), n);
  return i(), s;
}
function dA(e, t) {
  const n = t.split(".");
  return () => {
    let r = e;
    for (let a = 0; a < n.length && r; a++)
      r = r[n[a]];
    return r;
  };
}
function Il(e, t = 1 / 0, n) {
  if (t <= 0 || !wn(e) || e.__v_skip || (n = n || /* @__PURE__ */ new Set(), n.has(e)))
    return e;
  if (n.add(e), t--, Ft(e))
    Il(e.value, t, n);
  else if (St(e))
    for (let r = 0; r < e.length; r++)
      Il(e[r], t, n);
  else if (wc(e) || Hu(e))
    e.forEach((r) => {
      Il(r, t, n);
    });
  else if (qO(e)) {
    for (const r in e)
      Il(e[r], t, n);
    for (const r of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, r) && Il(e[r], t, n);
  }
  return e;
}
function Fr(e, t, n = On) {
  const r = jn();
  if (process.env.NODE_ENV !== "production" && !r)
    return qe("useModel() called without active instance."), ne();
  if (process.env.NODE_ENV !== "production" && !r.propsOptions[0][t])
    return qe(`useModel() called with prop "${t}" which is not declared.`), ne();
  const a = Ia(t), o = na(t), i = pA(e, t), s = xg((l, u) => {
    let c, f, d;
    return fA(() => {
      const p = e[t];
      Ui(c, p) && (c = p, u());
    }), {
      get() {
        return l(), n.get ? n.get(c) : c;
      },
      set(p) {
        if (!Ui(p, c))
          return;
        const v = r.vnode.props;
        v && // check if parent has passed v-model
        (t in v || a in v || o in v) && (`onUpdate:${t}` in v || `onUpdate:${a}` in v || `onUpdate:${o}` in v) || (c = p, u());
        const h = n.set ? n.set(p) : p;
        r.emit(`update:${t}`, h), p !== h && p !== f && h === d && u(), f = p, d = h;
      }
    };
  });
  return s[Symbol.iterator] = () => {
    let l = 0;
    return {
      next() {
        return l < 2 ? { value: l++ ? i || On : s, done: !1 } : { done: !0 };
      }
    };
  }, s;
}
const pA = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${Ia(t)}Modifiers`] || e[`${na(t)}Modifiers`];
function OB(e, t, ...n) {
  if (e.isUnmounted) return;
  const r = e.vnode.props || On;
  if (process.env.NODE_ENV !== "production") {
    const {
      emitsOptions: c,
      propsOptions: [f]
    } = e;
    if (c)
      if (!(t in c))
        (!f || !(Ns(t) in f)) && qe(
          `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${Ns(t)}" prop.`
        );
      else {
        const d = c[t];
        Pt(d) && (d(...n) || qe(
          `Invalid event arguments: event validation failed for event "${t}".`
        ));
      }
  }
  let a = n;
  const o = t.startsWith("update:"), i = o && pA(r, t.slice(7));
  if (i && (i.trim && (a = n.map((c) => Dn(c) ? c.trim() : c)), i.number && (a = n.map(Zv))), process.env.NODE_ENV !== "production" && EL(e, t, a), process.env.NODE_ENV !== "production") {
    const c = t.toLowerCase();
    c !== t && r[Ns(c)] && qe(
      `Event "${c}" is emitted in component ${Og(
        e,
        e.type
      )} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${na(
        t
      )}" instead of "${t}".`
    );
  }
  let s, l = r[s = Ns(t)] || // also try camelCase event handler (#2249)
  r[s = Ns(Ia(t))];
  !l && o && (l = r[s = Ns(na(t))]), l && Ro(
    l,
    e,
    6,
    a
  );
  const u = r[s + "Once"];
  if (u) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[s])
      return;
    e.emitted[s] = !0, Ro(
      u,
      e,
      6,
      a
    );
  }
}
function hA(e, t, n = !1) {
  const r = t.emitsCache, a = r.get(e);
  if (a !== void 0)
    return a;
  const o = e.emits;
  let i = {}, s = !1;
  if (!Pt(e)) {
    const l = (u) => {
      const c = hA(u, t, !0);
      c && (s = !0, Ln(i, c));
    };
    !n && t.mixins.length && t.mixins.forEach(l), e.extends && l(e.extends), e.mixins && e.mixins.forEach(l);
  }
  return !o && !s ? (wn(e) && r.set(e, null), null) : (St(o) ? o.forEach((l) => i[l] = null) : Ln(i, o), wn(e) && r.set(e, i), i);
}
function Tg(e, t) {
  return !e || !ud(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), pn(e, t[0].toLowerCase() + t.slice(1)) || pn(e, na(t)) || pn(e, t));
}
let nb = !1;
function sm() {
  nb = !0;
}
function wv(e) {
  const {
    type: t,
    vnode: n,
    proxy: r,
    withProxy: a,
    propsOptions: [o],
    slots: i,
    attrs: s,
    emit: l,
    render: u,
    renderCache: c,
    props: f,
    data: d,
    setupState: p,
    ctx: v,
    inheritAttrs: h
  } = e, m = K0(e);
  let y, x;
  process.env.NODE_ENV !== "production" && (nb = !1);
  try {
    if (n.shapeFlag & 4) {
      const w = a || r, _ = process.env.NODE_ENV !== "production" && p.__isScriptSetup ? new Proxy(w, {
        get(b, E, C) {
          return qe(
            `Property '${String(
              E
            )}' was accessed via 'this'. Avoid using 'this' in templates.`
          ), Reflect.get(b, E, C);
        }
      }) : w;
      y = Ua(
        u.call(
          _,
          w,
          c,
          process.env.NODE_ENV !== "production" ? Ri(f) : f,
          p,
          d,
          v
        )
      ), x = s;
    } else {
      const w = t;
      process.env.NODE_ENV !== "production" && s === f && sm(), y = Ua(
        w.length > 1 ? w(
          process.env.NODE_ENV !== "production" ? Ri(f) : f,
          process.env.NODE_ENV !== "production" ? {
            get attrs() {
              return sm(), Ri(s);
            },
            slots: i,
            emit: l
          } : { attrs: s, slots: i, emit: l }
        ) : w(
          process.env.NODE_ENV !== "production" ? Ri(f) : f,
          null
        )
      ), x = t.props ? s : AB(s);
    }
  } catch (w) {
    v0.length = 0, lu(w, e, 1), y = A(tr);
  }
  let g = y, S;
  if (process.env.NODE_ENV !== "production" && y.patchFlag > 0 && y.patchFlag & 2048 && ([g, S] = vA(y)), x && h !== !1) {
    const w = Object.keys(x), { shapeFlag: _ } = g;
    if (w.length) {
      if (_ & 7)
        o && w.some(Xv) && (x = IB(
          x,
          o
        )), g = Yr(g, x, !1, !0);
      else if (process.env.NODE_ENV !== "production" && !nb && g.type !== tr) {
        const b = Object.keys(s), E = [], C = [];
        for (let T = 0, O = b.length; T < O; T++) {
          const I = b[T];
          ud(I) ? Xv(I) || E.push(I[2].toLowerCase() + I.slice(3)) : C.push(I);
        }
        C.length && qe(
          `Extraneous non-props attributes (${C.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes.`
        ), E.length && qe(
          `Extraneous non-emits event listeners (${E.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return n.dirs && (process.env.NODE_ENV !== "production" && !qE(g) && qe(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), g = Yr(g, null, !1, !0), g.dirs = g.dirs ? g.dirs.concat(n.dirs) : n.dirs), n.transition && (process.env.NODE_ENV !== "production" && !qE(g) && qe(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), g.transition = n.transition), process.env.NODE_ENV !== "production" && S ? S(g) : y = g, K0(m), y;
}
const vA = (e) => {
  const t = e.children, n = e.dynamicChildren, r = $g(t, !1);
  if (r) {
    if (process.env.NODE_ENV !== "production" && r.patchFlag > 0 && r.patchFlag & 2048)
      return vA(r);
  } else return [e, void 0];
  const a = t.indexOf(r), o = n ? n.indexOf(r) : -1, i = (s) => {
    t[a] = s, n && (o > -1 ? n[o] = s : s.patchFlag > 0 && (e.dynamicChildren = [...n, s]));
  };
  return [Ua(r), i];
};
function $g(e, t = !0) {
  let n;
  for (let r = 0; r < e.length; r++) {
    const a = e[r];
    if (ka(a)) {
      if (a.type !== tr || a.children === "v-if") {
        if (n)
          return;
        if (n = a, process.env.NODE_ENV !== "production" && t && n.patchFlag > 0 && n.patchFlag & 2048)
          return $g(n.children);
      }
    } else
      return;
  }
  return n;
}
const AB = (e) => {
  let t;
  for (const n in e)
    (n === "class" || n === "style" || ud(n)) && ((t || (t = {}))[n] = e[n]);
  return t;
}, IB = (e, t) => {
  const n = {};
  for (const r in e)
    (!Xv(r) || !(r.slice(9) in t)) && (n[r] = e[r]);
  return n;
}, qE = (e) => e.shapeFlag & 7 || e.type === tr;
function PB(e, t, n) {
  const { props: r, children: a, component: o } = e, { props: i, children: s, patchFlag: l } = t, u = o.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (a || s) && Vl || t.dirs || t.transition)
    return !0;
  if (n && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return r ? XE(r, i, u) : !!i;
    if (l & 8) {
      const c = t.dynamicProps;
      for (let f = 0; f < c.length; f++) {
        const d = c[f];
        if (i[d] !== r[d] && !Tg(u, d))
          return !0;
      }
    }
  } else
    return (a || s) && (!s || !s.$stable) ? !0 : r === i ? !1 : r ? i ? XE(r, i, u) : !0 : !!i;
  return !1;
}
function XE(e, t, n) {
  const r = Object.keys(t);
  if (r.length !== Object.keys(e).length)
    return !0;
  for (let a = 0; a < r.length; a++) {
    const o = r[a];
    if (t[o] !== e[o] && !Tg(n, o))
      return !0;
  }
  return !1;
}
function C_({ vnode: e, parent: t }, n) {
  for (; t; ) {
    const r = t.subTree;
    if (r.suspense && r.suspense.activeBranch === e && (r.el = e.el), r === e)
      (e = t.vnode).el = n, t = t.parent;
    else
      break;
  }
}
const rb = (e) => e.__isSuspense;
let ab = 0;
const DB = {
  name: "Suspense",
  // In order to make Suspense tree-shakable, we need to avoid importing it
  // directly in the renderer. The renderer checks for the __isSuspense flag
  // on a vnode's type and calls the `process` method, passing in renderer
  // internals.
  __isSuspense: !0,
  process(e, t, n, r, a, o, i, s, l, u) {
    if (e == null)
      MB(
        t,
        n,
        r,
        a,
        o,
        i,
        s,
        l,
        u
      );
    else {
      if (o && o.deps > 0 && !e.suspense.isInFallback) {
        t.suspense = e.suspense, t.suspense.vnode = t, t.el = e.el;
        return;
      }
      RB(
        e,
        t,
        n,
        r,
        a,
        i,
        s,
        l,
        u
      );
    }
  },
  hydrate: NB,
  normalize: FB
}, kB = DB;
function q0(e, t) {
  const n = e.props && e.props[t];
  Pt(n) && n();
}
function MB(e, t, n, r, a, o, i, s, l) {
  const {
    p: u,
    o: { createElement: c }
  } = l, f = c("div"), d = e.suspense = mA(
    e,
    a,
    r,
    t,
    f,
    n,
    o,
    i,
    s,
    l
  );
  u(
    null,
    d.pendingBranch = e.ssContent,
    f,
    null,
    r,
    d,
    o,
    i
  ), d.deps > 0 ? (q0(e, "onPending"), q0(e, "onFallback"), u(
    null,
    e.ssFallback,
    t,
    n,
    r,
    null,
    // fallback tree will not have suspense context
    o,
    i
  ), Sf(d, e.ssFallback)) : d.resolve(!1, !0);
}
function RB(e, t, n, r, a, o, i, s, { p: l, um: u, o: { createElement: c } }) {
  const f = t.suspense = e.suspense;
  f.vnode = t, t.el = e.el;
  const d = t.ssContent, p = t.ssFallback, { activeBranch: v, pendingBranch: h, isInFallback: m, isHydrating: y } = f;
  if (h)
    f.pendingBranch = d, Di(d, h) ? (l(
      h,
      d,
      f.hiddenContainer,
      null,
      a,
      f,
      o,
      i,
      s
    ), f.deps <= 0 ? f.resolve() : m && (y || (l(
      v,
      p,
      n,
      r,
      a,
      null,
      // fallback tree will not have suspense context
      o,
      i,
      s
    ), Sf(f, p)))) : (f.pendingId = ab++, y ? (f.isHydrating = !1, f.activeBranch = h) : u(h, a, f), f.deps = 0, f.effects.length = 0, f.hiddenContainer = c("div"), m ? (l(
      null,
      d,
      f.hiddenContainer,
      null,
      a,
      f,
      o,
      i,
      s
    ), f.deps <= 0 ? f.resolve() : (l(
      v,
      p,
      n,
      r,
      a,
      null,
      // fallback tree will not have suspense context
      o,
      i,
      s
    ), Sf(f, p))) : v && Di(d, v) ? (l(
      v,
      d,
      n,
      r,
      a,
      f,
      o,
      i,
      s
    ), f.resolve(!0)) : (l(
      null,
      d,
      f.hiddenContainer,
      null,
      a,
      f,
      o,
      i,
      s
    ), f.deps <= 0 && f.resolve()));
  else if (v && Di(d, v))
    l(
      v,
      d,
      n,
      r,
      a,
      f,
      o,
      i,
      s
    ), Sf(f, d);
  else if (q0(t, "onPending"), f.pendingBranch = d, d.shapeFlag & 512 ? f.pendingId = d.component.suspenseId : f.pendingId = ab++, l(
    null,
    d,
    f.hiddenContainer,
    null,
    a,
    f,
    o,
    i,
    s
  ), f.deps <= 0)
    f.resolve();
  else {
    const { timeout: x, pendingId: g } = f;
    x > 0 ? setTimeout(() => {
      f.pendingId === g && f.fallback(p);
    }, x) : x === 0 && f.fallback(p);
  }
}
let ZE = !1;
function mA(e, t, n, r, a, o, i, s, l, u, c = !1) {
  process.env.NODE_ENV !== "production" && !ZE && (ZE = !0, console[console.info ? "info" : "log"](
    "<Suspense> is an experimental feature and its API will likely change."
  ));
  const {
    p: f,
    m: d,
    um: p,
    n: v,
    o: { parentNode: h, remove: m }
  } = u;
  let y;
  const x = LB(e);
  x && t && t.pendingBranch && (y = t.pendingId, t.deps++);
  const g = e.props ? Qv(e.props.timeout) : void 0;
  process.env.NODE_ENV !== "production" && c_(g, "Suspense timeout");
  const S = o, w = {
    vnode: e,
    parent: t,
    parentComponent: n,
    namespace: i,
    container: r,
    hiddenContainer: a,
    deps: 0,
    pendingId: ab++,
    timeout: typeof g == "number" ? g : -1,
    activeBranch: null,
    pendingBranch: null,
    isInFallback: !c,
    isHydrating: c,
    isUnmounted: !1,
    effects: [],
    resolve(_ = !1, b = !1) {
      if (process.env.NODE_ENV !== "production") {
        if (!_ && !w.pendingBranch)
          throw new Error(
            "suspense.resolve() is called without a pending branch."
          );
        if (w.isUnmounted)
          throw new Error(
            "suspense.resolve() is called on an already unmounted suspense boundary."
          );
      }
      const {
        vnode: E,
        activeBranch: C,
        pendingBranch: T,
        pendingId: O,
        effects: I,
        parentComponent: k,
        container: B
      } = w;
      let P = !1;
      w.isHydrating ? w.isHydrating = !1 : _ || (P = C && T.transition && T.transition.mode === "out-in", P && (C.transition.afterLeave = () => {
        O === w.pendingId && (d(
          T,
          B,
          o === S ? v(C) : o,
          0
        ), W0(I));
      }), C && (h(C.el) !== w.hiddenContainer && (o = v(C)), p(C, k, w, !0)), P || d(T, B, o, 0)), Sf(w, T), w.pendingBranch = null, w.isInFallback = !1;
      let N = w.parent, M = !1;
      for (; N; ) {
        if (N.pendingBranch) {
          N.effects.push(...I), M = !0;
          break;
        }
        N = N.parent;
      }
      !M && !P && W0(I), w.effects = [], x && t && t.pendingBranch && y === t.pendingId && (t.deps--, t.deps === 0 && !b && t.resolve()), q0(E, "onResolve");
    },
    fallback(_) {
      if (!w.pendingBranch)
        return;
      const { vnode: b, activeBranch: E, parentComponent: C, container: T, namespace: O } = w;
      q0(b, "onFallback");
      const I = v(E), k = () => {
        w.isInFallback && (f(
          null,
          _,
          T,
          I,
          C,
          null,
          // fallback tree will not have suspense context
          O,
          s,
          l
        ), Sf(w, _));
      }, B = _.transition && _.transition.mode === "out-in";
      B && (E.transition.afterLeave = k), w.isInFallback = !0, p(
        E,
        C,
        null,
        // no suspense so unmount hooks fire now
        !0
        // shouldRemove
      ), B || k();
    },
    move(_, b, E) {
      w.activeBranch && d(w.activeBranch, _, b, E), w.container = _;
    },
    next() {
      return w.activeBranch && v(w.activeBranch);
    },
    registerDep(_, b, E) {
      const C = !!w.pendingBranch;
      C && w.deps++;
      const T = _.vnode.el;
      _.asyncDep.catch((O) => {
        lu(O, _, 0);
      }).then((O) => {
        if (_.isUnmounted || w.isUnmounted || w.pendingId !== _.suspenseId)
          return;
        _.asyncResolved = !0;
        const { vnode: I } = _;
        process.env.NODE_ENV !== "production" && f0(I), cb(_, O, !1), T && (I.el = T);
        const k = !T && _.subTree.el;
        b(
          _,
          I,
          // component may have been moved before resolve.
          // if this is not a hydration, instance.subTree will be the comment
          // placeholder.
          h(T || _.subTree.el),
          // anchor will not be used if this is hydration, so only need to
          // consider the comment placeholder case.
          T ? null : v(_.subTree),
          w,
          i,
          E
        ), k && m(k), C_(_, I.el), process.env.NODE_ENV !== "production" && d0(), C && --w.deps === 0 && w.resolve();
      });
    },
    unmount(_, b) {
      w.isUnmounted = !0, w.activeBranch && p(
        w.activeBranch,
        n,
        _,
        b
      ), w.pendingBranch && p(
        w.pendingBranch,
        n,
        _,
        b
      );
    }
  };
  return w;
}
function NB(e, t, n, r, a, o, i, s, l) {
  const u = t.suspense = mA(
    t,
    r,
    n,
    e.parentNode,
    // eslint-disable-next-line no-restricted-globals
    document.createElement("div"),
    null,
    a,
    o,
    i,
    s,
    !0
  ), c = l(
    e,
    u.pendingBranch = t.ssContent,
    n,
    u,
    o,
    i
  );
  return u.deps === 0 && u.resolve(!1, !0), c;
}
function FB(e) {
  const { shapeFlag: t, children: n } = e, r = t & 32;
  e.ssContent = QE(
    r ? n.default : n
  ), e.ssFallback = r ? QE(n.fallback) : A(tr);
}
function QE(e) {
  let t;
  if (Pt(e)) {
    const n = ic && e._c;
    n && (e._d = !1, Ce()), e = e(), n && (e._d = !0, t = Oa, yA());
  }
  if (St(e)) {
    const n = $g(e);
    process.env.NODE_ENV !== "production" && !n && e.filter((r) => r !== y_).length > 0 && qe("<Suspense> slots expect a single root node."), e = n;
  }
  return e = Ua(e), t && !e.dynamicChildren && (e.dynamicChildren = t.filter((n) => n !== e)), e;
}
function gA(e, t) {
  t && t.pendingBranch ? St(e) ? t.effects.push(...e) : t.effects.push(e) : W0(e);
}
function Sf(e, t) {
  e.activeBranch = t;
  const { vnode: n, parentComponent: r } = e;
  let a = t.el;
  for (; !a && t.component; )
    t = t.component.subTree, a = t.el;
  n.el = a, r && r.subTree === n && (r.vnode.el = a, C_(r, a));
}
function LB(e) {
  const t = e.props && e.props.suspensible;
  return t != null && t !== !1;
}
const dt = Symbol.for("v-fgt"), Bi = Symbol.for("v-txt"), tr = Symbol.for("v-cmt"), Ul = Symbol.for("v-stc"), v0 = [];
let Oa = null;
function Ce(e = !1) {
  v0.push(Oa = e ? null : []);
}
function yA() {
  v0.pop(), Oa = v0[v0.length - 1] || null;
}
let ic = 1;
function ob(e) {
  ic += e, e < 0 && Oa && (Oa.hasOnce = !0);
}
function xA(e) {
  return e.dynamicChildren = ic > 0 ? Oa || gf : null, yA(), ic > 0 && Oa && Oa.push(e), e;
}
function rt(e, t, n, r, a, o) {
  return xA(
    ke(
      e,
      t,
      n,
      r,
      a,
      o,
      !0
    )
  );
}
function et(e, t, n, r, a) {
  return xA(
    A(
      e,
      t,
      n,
      r,
      a,
      !0
    )
  );
}
function ka(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Di(e, t) {
  if (process.env.NODE_ENV !== "production" && t.shapeFlag & 6 && e.component) {
    const n = bv.get(t.type);
    if (n && n.has(e.component))
      return e.shapeFlag &= -257, t.shapeFlag &= -513, !1;
  }
  return e.type === t.type && e.key === t.key;
}
let ib;
function BB(e) {
  ib = e;
}
const HB = (...e) => wA(
  ...ib ? ib(e, mr) : e
), bA = ({ key: e }) => e ?? null, Sv = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? Dn(e) || Ft(e) || Pt(e) ? { i: mr, r: e, k: t, f: !!n } : e : null);
function ke(e, t = null, n = null, r = 0, a = null, o = e === dt ? 0 : 1, i = !1, s = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && bA(t),
    ref: t && Sv(t),
    scopeId: wg,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: o,
    patchFlag: r,
    dynamicProps: a,
    dynamicChildren: null,
    appContext: null,
    ctx: mr
  };
  return s ? (T_(l, n), o & 128 && e.normalize(l)) : n && (l.shapeFlag |= Dn(n) ? 8 : 16), process.env.NODE_ENV !== "production" && l.key !== l.key && qe("VNode created with invalid key (NaN). VNode type:", l.type), ic > 0 && // avoid a block node from tracking itself
  !i && // has current parent block
  Oa && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (l.patchFlag > 0 || o & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  l.patchFlag !== 32 && Oa.push(l), l;
}
const A = process.env.NODE_ENV !== "production" ? HB : wA;
function wA(e, t = null, n = null, r = 0, a = null, o = !1) {
  if ((!e || e === y_) && (process.env.NODE_ENV !== "production" && !e && qe(`Invalid vnode type when creating vnode: ${e}.`), e = tr), ka(e)) {
    const s = Yr(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && T_(s, n), ic > 0 && !o && Oa && (s.shapeFlag & 6 ? Oa[Oa.indexOf(e)] = s : Oa.push(s)), s.patchFlag = -2, s;
  }
  if (OA(e) && (e = e.__vccOpts), t) {
    t = E_(t);
    let { class: s, style: l } = t;
    s && !Dn(s) && (t.class = tn(s)), wn(l) && (V0(l) && !St(l) && (l = Ln({}, l)), t.style = _r(l));
  }
  const i = Dn(e) ? 1 : rb(e) ? 128 : mB(e) ? 64 : wn(e) ? 4 : Pt(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && i & 4 && V0(e) && (e = At(e), qe(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), ke(
    e,
    t,
    n,
    r,
    a,
    i,
    o,
    !0
  );
}
function E_(e) {
  return e ? V0(e) || K9(e) ? Ln({}, e) : e : null;
}
function Yr(e, t, n = !1, r = !1) {
  const { props: a, ref: o, patchFlag: i, children: s, transition: l } = e, u = t ? sc(a || {}, t) : a, c = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: u,
    key: u && bA(u),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && o ? St(o) ? o.concat(Sv(t)) : [o, Sv(t)] : Sv(t)
    ) : o,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && i === -1 && St(s) ? s.map(SA) : s,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== dt ? i === -1 ? 16 : i | 16 : i,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: l,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && Yr(e.ssContent),
    ssFallback: e.ssFallback && Yr(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return l && r && Xl(
    c,
    l.clone(c)
  ), c;
}
function SA(e) {
  const t = Yr(e);
  return St(e.children) && (t.children = e.children.map(SA)), t;
}
function Jt(e = " ", t = 0) {
  return A(Bi, null, e, t);
}
function jB(e, t) {
  const n = A(Ul, null, e);
  return n.staticCount = t, n;
}
function bt(e = "", t = !1) {
  return t ? (Ce(), et(tr, null, e)) : A(tr, null, e);
}
function Ua(e) {
  return e == null || typeof e == "boolean" ? A(tr) : St(e) ? A(
    dt,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : typeof e == "object" ? Tl(e) : A(Bi, null, String(e));
}
function Tl(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : Yr(e);
}
function T_(e, t) {
  let n = 0;
  const { shapeFlag: r } = e;
  if (t == null)
    t = null;
  else if (St(t))
    n = 16;
  else if (typeof t == "object")
    if (r & 65) {
      const a = t.default;
      a && (a._c && (a._d = !1), T_(e, a()), a._c && (a._d = !0));
      return;
    } else {
      n = 32;
      const a = t._;
      !a && !K9(t) ? t._ctx = mr : a === 3 && mr && (mr.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else Pt(t) ? (t = { default: t, _ctx: mr }, n = 32) : (t = String(t), r & 64 ? (n = 16, t = [Jt(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function sc(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    for (const a in r)
      if (a === "class")
        t.class !== r.class && (t.class = tn([t.class, r.class]));
      else if (a === "style")
        t.style = _r([t.style, r.style]);
      else if (ud(a)) {
        const o = t[a], i = r[a];
        i && o !== i && !(St(o) && o.includes(i)) && (t[a] = o ? [].concat(o, i) : i);
      } else a !== "" && (t[a] = r[a]);
  }
  return t;
}
function ro(e, t, n, r = null) {
  Ro(e, t, 7, [
    n,
    r
  ]);
}
const VB = U9();
let UB = 0;
function _A(e, t, n) {
  const r = e.type, a = (t ? t.appContext : e.appContext) || VB, o = {
    uid: UB++,
    vnode: e,
    type: r,
    parent: t,
    appContext: a,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    scope: new r_(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(a.provides),
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: q9(r, a),
    emitsOptions: hA(r, a),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: On,
    // inheritAttrs
    inheritAttrs: r.inheritAttrs,
    // state
    ctx: On,
    data: On,
    props: On,
    attrs: On,
    slots: On,
    refs: On,
    setupState: On,
    setupContext: null,
    // suspense related
    suspense: n,
    suspenseId: n ? n.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return process.env.NODE_ENV !== "production" ? o.ctx = NL(o) : o.ctx = { _: o }, o.root = t ? t.root : o, o.emit = OB.bind(null, o), e.ce && e.ce(o), o;
}
let Cr = null;
const jn = () => Cr || mr;
let lm, sb;
{
  const e = t_(), t = (n, r) => {
    let a;
    return (a = e[n]) || (a = e[n] = []), a.push(r), (o) => {
      a.length > 1 ? a.forEach((i) => i(o)) : a[0](o);
    };
  };
  lm = t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => Cr = n
  ), sb = t(
    "__VUE_SSR_SETTERS__",
    (n) => Pp = n
  );
}
const lc = (e) => {
  const t = Cr;
  return lm(e), e.scope.on(), () => {
    e.scope.off(), lm(t);
  };
}, lb = () => {
  Cr && Cr.scope.off(), lm(null);
}, zB = /* @__PURE__ */ Lo("slot,component");
function ub(e, { isNativeTag: t }) {
  (zB(e) || t(e)) && qe(
    "Do not use built-in or reserved HTML elements as component id: " + e
  );
}
function CA(e) {
  return e.vnode.shapeFlag & 4;
}
let Pp = !1;
function EA(e, t = !1, n = !1) {
  t && sb(t);
  const { props: r, children: a } = e.vnode, o = CA(e);
  aB(e, r, o, t), hB(e, a, n);
  const i = o ? WB(e, t) : void 0;
  return t && sb(!1), i;
}
function WB(e, t) {
  var n;
  const r = e.type;
  if (process.env.NODE_ENV !== "production") {
    if (r.name && ub(r.name, e.appContext.config), r.components) {
      const o = Object.keys(r.components);
      for (let i = 0; i < o.length; i++)
        ub(o[i], e.appContext.config);
    }
    if (r.directives) {
      const o = Object.keys(r.directives);
      for (let i = 0; i < o.length; i++)
        $9(o[i]);
    }
    r.compilerOptions && $_() && qe(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, p0), process.env.NODE_ENV !== "production" && FL(e);
  const { setup: a } = r;
  if (a) {
    const o = e.setupContext = a.length > 1 ? $A(e) : null, i = lc(e);
    nl();
    const s = ss(
      a,
      e,
      0,
      [
        process.env.NODE_ENV !== "production" ? Ri(e.props) : e.props,
        o
      ]
    );
    if (rl(), i(), fg(s)) {
      if (s.then(lb, lb), t)
        return s.then((l) => {
          cb(e, l, t);
        }).catch((l) => {
          lu(l, e, 0);
        });
      if (e.asyncDep = s, process.env.NODE_ENV !== "production" && !e.suspense) {
        const l = (n = r.name) != null ? n : "Anonymous";
        qe(
          `Component <${l}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      cb(e, s, t);
  } else
    TA(e, t);
}
function cb(e, t, n) {
  Pt(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : wn(t) ? (process.env.NODE_ENV !== "production" && ka(t) && qe(
    "setup() should not return VNodes directly - return a render function instead."
  ), process.env.NODE_ENV !== "production" && (e.devtoolsRawSetupState = t), e.setupState = u_(t), process.env.NODE_ENV !== "production" && LL(e)) : process.env.NODE_ENV !== "production" && t !== void 0 && qe(
    `setup() should return an object. Received: ${t === null ? "null" : typeof t}`
  ), TA(e, n);
}
let m0, fb;
function GB(e) {
  m0 = e, fb = (t) => {
    t.render._rc && (t.withProxy = new Proxy(t.ctx, RL));
  };
}
const $_ = () => !m0;
function TA(e, t, n) {
  const r = e.type;
  if (!e.render) {
    if (!t && m0 && !r.render) {
      const a = r.template || S_(e).template;
      if (a) {
        process.env.NODE_ENV !== "production" && Ds(e, "compile");
        const { isCustomElement: o, compilerOptions: i } = e.appContext.config, { delimiters: s, compilerOptions: l } = r, u = Ln(
          Ln(
            {
              isCustomElement: o,
              delimiters: s
            },
            i
          ),
          l
        );
        r.render = m0(a, u), process.env.NODE_ENV !== "production" && ks(e, "compile");
      }
    }
    e.render = r.render || vr, fb && fb(e);
  }
  {
    const a = lc(e);
    nl();
    try {
      ZL(e);
    } finally {
      rl(), a();
    }
  }
  process.env.NODE_ENV !== "production" && !r.render && e.render === vr && !t && (!m0 && r.template ? qe(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
  ) : qe("Component is missing template or render function: ", r));
}
const JE = process.env.NODE_ENV !== "production" ? {
  get(e, t) {
    return sm(), da(e, "get", ""), e[t];
  },
  set() {
    return qe("setupContext.attrs is readonly."), !1;
  },
  deleteProperty() {
    return qe("setupContext.attrs is readonly."), !1;
  }
} : {
  get(e, t) {
    return da(e, "get", ""), e[t];
  }
};
function KB(e) {
  return new Proxy(e.slots, {
    get(t, n) {
      return da(e, "get", "$slots"), t[n];
    }
  });
}
function $A(e) {
  const t = (n) => {
    if (process.env.NODE_ENV !== "production" && (e.exposed && qe("expose() should be called only once per setup()."), n != null)) {
      let r = typeof n;
      r === "object" && (St(n) ? r = "array" : Ft(n) && (r = "ref")), r !== "object" && qe(
        `expose() should be passed a plain object, received ${r}.`
      );
    }
    e.exposed = n || {};
  };
  if (process.env.NODE_ENV !== "production") {
    let n, r;
    return Object.freeze({
      get attrs() {
        return n || (n = new Proxy(e.attrs, JE));
      },
      get slots() {
        return r || (r = KB(e));
      },
      get emit() {
        return (a, ...o) => e.emit(a, ...o);
      },
      expose: t
    });
  } else
    return {
      attrs: new Proxy(e.attrs, JE),
      slots: e.slots,
      emit: e.emit,
      expose: t
    };
}
function Dp(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(u_(Hs(e.exposed)), {
    get(t, n) {
      if (n in t)
        return t[n];
      if (n in Wu)
        return Wu[n](e);
    },
    has(t, n) {
      return n in t || n in Wu;
    }
  })) : e.proxy;
}
const YB = /(?:^|[-_])(\w)/g, qB = (e) => e.replace(YB, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function X0(e, t = !0) {
  return Pt(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Og(e, t, n = !1) {
  let r = X0(t);
  if (!r && t.__file) {
    const a = t.__file.match(/([^/\\]+)\.\w+$/);
    a && (r = a[1]);
  }
  if (!r && e && e.parent) {
    const a = (o) => {
      for (const i in o)
        if (o[i] === t)
          return i;
    };
    r = a(
      e.components || e.parent.type.components
    ) || a(e.appContext.components);
  }
  return r ? qB(r) : n ? "App" : "Anonymous";
}
function OA(e) {
  return Pt(e) && "__vccOpts" in e;
}
const V = (e, t) => {
  const n = XF(e, t, Pp);
  if (process.env.NODE_ENV !== "production") {
    const r = jn();
    r && r.appContext.config.warnRecursiveComputed && (n._warnRecursive = !0);
  }
  return n;
};
function Z0(e, t, n) {
  const r = arguments.length;
  return r === 2 ? wn(t) && !St(t) ? ka(t) ? A(e, null, [t]) : A(e, t) : A(e, null, t) : (r > 3 ? n = Array.prototype.slice.call(arguments, 2) : r === 3 && ka(n) && (n = [n]), A(e, t, n));
}
function AA() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, r = { style: "color:#eb2f96" }, a = {
    __vue_custom_formatter: !0,
    header(f) {
      return wn(f) ? f.__isVue ? ["div", e, "VueInstance"] : Ft(f) ? [
        "div",
        {},
        ["span", e, c(f)],
        "<",
        s(f.value),
        ">"
      ] : ai(f) ? [
        "div",
        {},
        ["span", e, is(f) ? "ShallowReactive" : "Reactive"],
        "<",
        s(f),
        `>${vs(f) ? " (readonly)" : ""}`
      ] : vs(f) ? [
        "div",
        {},
        ["span", e, is(f) ? "ShallowReadonly" : "Readonly"],
        "<",
        s(f),
        ">"
      ] : null : null;
    },
    hasBody(f) {
      return f && f.__isVue;
    },
    body(f) {
      if (f && f.__isVue)
        return [
          "div",
          {},
          ...o(f.$)
        ];
    }
  };
  function o(f) {
    const d = [];
    f.type.props && f.props && d.push(i("props", At(f.props))), f.setupState !== On && d.push(i("setup", f.setupState)), f.data !== On && d.push(i("data", At(f.data)));
    const p = l(f, "computed");
    p && d.push(i("computed", p));
    const v = l(f, "inject");
    return v && d.push(i("injected", v)), d.push([
      "div",
      {},
      [
        "span",
        {
          style: r.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: f }]
    ]), d;
  }
  function i(f, d) {
    return d = Ln({}, d), Object.keys(d).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        f
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(d).map((p) => [
          "div",
          {},
          ["span", r, p + ": "],
          s(d[p], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function s(f, d = !0) {
    return typeof f == "number" ? ["span", t, f] : typeof f == "string" ? ["span", n, JSON.stringify(f)] : typeof f == "boolean" ? ["span", r, f] : wn(f) ? ["object", { object: d ? At(f) : f }] : ["span", n, String(f)];
  }
  function l(f, d) {
    const p = f.type;
    if (Pt(p))
      return;
    const v = {};
    for (const h in f.ctx)
      u(p, h, d) && (v[h] = f.ctx[h]);
    return v;
  }
  function u(f, d, p) {
    const v = f[p];
    if (St(v) && v.includes(d) || wn(v) && d in v || f.extends && u(f.extends, d, p) || f.mixins && f.mixins.some((h) => u(h, d, p)))
      return !0;
  }
  function c(f) {
    return is(f) ? "ShallowRef" : f.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(a) : window.devtoolsFormatters = [a];
}
function XB(e, t, n, r) {
  const a = n[r];
  if (a && IA(a, e))
    return a;
  const o = t();
  return o.memo = e.slice(), o.cacheIndex = r, n[r] = o;
}
function IA(e, t) {
  const n = e.memo;
  if (n.length != t.length)
    return !1;
  for (let r = 0; r < n.length; r++)
    if (Ui(n[r], t[r]))
      return !1;
  return ic > 0 && Oa && Oa.push(e), !0;
}
const db = "3.4.33", la = process.env.NODE_ENV !== "production" ? qe : vr, ZB = bg, QB = (process.env.NODE_ENV, Pi), JB = (process.env.NODE_ENV, p_), eH = {
  createComponentInstance: _A,
  setupComponent: EA,
  renderComponentRoot: wv,
  setCurrentRenderingInstance: K0,
  isVNode: ka,
  normalizeVNode: Ua,
  getComponentPublicInstance: Dp
}, tH = eH, nH = null, rH = null, aH = null;
/**
* @vue/runtime-dom v3.4.33
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const oH = "http://www.w3.org/2000/svg", iH = "http://www.w3.org/1998/Math/MathML", Rs = typeof document < "u" ? document : null, e3 = Rs && /* @__PURE__ */ Rs.createElement("template"), sH = {
  insert: (e, t, n) => {
    t.insertBefore(e, n || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, n, r) => {
    const a = t === "svg" ? Rs.createElementNS(oH, e) : t === "mathml" ? Rs.createElementNS(iH, e) : n ? Rs.createElement(e, { is: n }) : Rs.createElement(e);
    return e === "select" && r && r.multiple != null && a.setAttribute("multiple", r.multiple), a;
  },
  createText: (e) => Rs.createTextNode(e),
  createComment: (e) => Rs.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => Rs.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, n, r, a, o) {
    const i = n ? n.previousSibling : t.lastChild;
    if (a && (a === o || a.nextSibling))
      for (; t.insertBefore(a.cloneNode(!0), n), !(a === o || !(a = a.nextSibling)); )
        ;
    else {
      e3.innerHTML = r === "svg" ? `<svg>${e}</svg>` : r === "mathml" ? `<math>${e}</math>` : e;
      const s = e3.content;
      if (r === "svg" || r === "mathml") {
        const l = s.firstChild;
        for (; l.firstChild; )
          s.appendChild(l.firstChild);
        s.removeChild(l);
      }
      t.insertBefore(s, n);
    }
    return [
      // first
      i ? i.nextSibling : t.firstChild,
      // last
      n ? n.previousSibling : t.lastChild
    ];
  }
}, xl = "transition", Md = "animation", Ff = Symbol("_vtc"), Ho = (e, { slots: t }) => Z0(A9, DA(e), t);
Ho.displayName = "Transition";
const PA = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, lH = Ho.props = /* @__PURE__ */ Ln(
  {},
  m_,
  PA
), xu = (e, t = []) => {
  St(e) ? e.forEach((n) => n(...t)) : e && e(...t);
}, t3 = (e) => e ? St(e) ? e.some((t) => t.length > 1) : e.length > 1 : !1;
function DA(e) {
  const t = {};
  for (const I in e)
    I in PA || (t[I] = e[I]);
  if (e.css === !1)
    return t;
  const {
    name: n = "v",
    type: r,
    duration: a,
    enterFromClass: o = `${n}-enter-from`,
    enterActiveClass: i = `${n}-enter-active`,
    enterToClass: s = `${n}-enter-to`,
    appearFromClass: l = o,
    appearActiveClass: u = i,
    appearToClass: c = s,
    leaveFromClass: f = `${n}-leave-from`,
    leaveActiveClass: d = `${n}-leave-active`,
    leaveToClass: p = `${n}-leave-to`
  } = e, v = uH(a), h = v && v[0], m = v && v[1], {
    onBeforeEnter: y,
    onEnter: x,
    onEnterCancelled: g,
    onLeave: S,
    onLeaveCancelled: w,
    onBeforeAppear: _ = y,
    onAppear: b = x,
    onAppearCancelled: E = g
  } = t, C = (I, k, B) => {
    _l(I, k ? c : s), _l(I, k ? u : i), B && B();
  }, T = (I, k) => {
    I._isLeaving = !1, _l(I, f), _l(I, p), _l(I, d), k && k();
  }, O = (I) => (k, B) => {
    const P = I ? b : x, N = () => C(k, I, B);
    xu(P, [k, N]), n3(() => {
      _l(k, I ? l : o), Ms(k, I ? c : s), t3(P) || r3(k, r, h, N);
    });
  };
  return Ln(t, {
    onBeforeEnter(I) {
      xu(y, [I]), Ms(I, o), Ms(I, i);
    },
    onBeforeAppear(I) {
      xu(_, [I]), Ms(I, l), Ms(I, u);
    },
    onEnter: O(!1),
    onAppear: O(!0),
    onLeave(I, k) {
      I._isLeaving = !0;
      const B = () => T(I, k);
      Ms(I, f), Ms(I, d), MA(), n3(() => {
        I._isLeaving && (_l(I, f), Ms(I, p), t3(S) || r3(I, r, m, B));
      }), xu(S, [I, B]);
    },
    onEnterCancelled(I) {
      C(I, !1), xu(g, [I]);
    },
    onAppearCancelled(I) {
      C(I, !0), xu(E, [I]);
    },
    onLeaveCancelled(I) {
      T(I), xu(w, [I]);
    }
  });
}
function uH(e) {
  if (e == null)
    return null;
  if (wn(e))
    return [oy(e.enter), oy(e.leave)];
  {
    const t = oy(e);
    return [t, t];
  }
}
function oy(e) {
  const t = Qv(e);
  return process.env.NODE_ENV !== "production" && c_(t, "<transition> explicit duration"), t;
}
function Ms(e, t) {
  t.split(/\s+/).forEach((n) => n && e.classList.add(n)), (e[Ff] || (e[Ff] = /* @__PURE__ */ new Set())).add(t);
}
function _l(e, t) {
  t.split(/\s+/).forEach((r) => r && e.classList.remove(r));
  const n = e[Ff];
  n && (n.delete(t), n.size || (e[Ff] = void 0));
}
function n3(e) {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
}
let cH = 0;
function r3(e, t, n, r) {
  const a = e._endId = ++cH, o = () => {
    a === e._endId && r();
  };
  if (n)
    return setTimeout(o, n);
  const { type: i, timeout: s, propCount: l } = kA(e, t);
  if (!i)
    return r();
  const u = i + "end";
  let c = 0;
  const f = () => {
    e.removeEventListener(u, d), o();
  }, d = (p) => {
    p.target === e && ++c >= l && f();
  };
  setTimeout(() => {
    c < l && f();
  }, s + 1), e.addEventListener(u, d);
}
function kA(e, t) {
  const n = window.getComputedStyle(e), r = (v) => (n[v] || "").split(", "), a = r(`${xl}Delay`), o = r(`${xl}Duration`), i = a3(a, o), s = r(`${Md}Delay`), l = r(`${Md}Duration`), u = a3(s, l);
  let c = null, f = 0, d = 0;
  t === xl ? i > 0 && (c = xl, f = i, d = o.length) : t === Md ? u > 0 && (c = Md, f = u, d = l.length) : (f = Math.max(i, u), c = f > 0 ? i > u ? xl : Md : null, d = c ? c === xl ? o.length : l.length : 0);
  const p = c === xl && /\b(transform|all)(,|$)/.test(
    r(`${xl}Property`).toString()
  );
  return {
    type: c,
    timeout: f,
    propCount: d,
    hasTransform: p
  };
}
function a3(e, t) {
  for (; e.length < t.length; )
    e = e.concat(e);
  return Math.max(...t.map((n, r) => o3(n) + o3(e[r])));
}
function o3(e) {
  return e === "auto" ? 0 : Number(e.slice(0, -1).replace(",", ".")) * 1e3;
}
function MA() {
  return document.body.offsetHeight;
}
function fH(e, t, n) {
  const r = e[Ff];
  r && (t = (t ? [t, ...r] : [...r]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
const um = Symbol("_vod"), RA = Symbol("_vsh"), ko = {
  beforeMount(e, { value: t }, { transition: n }) {
    e[um] = e.style.display === "none" ? "" : e.style.display, n && t ? n.beforeEnter(e) : Rd(e, t);
  },
  mounted(e, { value: t }, { transition: n }) {
    n && t && n.enter(e);
  },
  updated(e, { value: t, oldValue: n }, { transition: r }) {
    !t != !n && (r ? t ? (r.beforeEnter(e), Rd(e, !0), r.enter(e)) : r.leave(e, () => {
      Rd(e, !1);
    }) : Rd(e, t));
  },
  beforeUnmount(e, { value: t }) {
    Rd(e, t);
  }
};
process.env.NODE_ENV !== "production" && (ko.name = "show");
function Rd(e, t) {
  e.style.display = t ? e[um] : "none", e[RA] = !t;
}
function dH() {
  ko.getSSRProps = ({ value: e }) => {
    if (!e)
      return { style: { display: "none" } };
  };
}
const NA = Symbol(process.env.NODE_ENV !== "production" ? "CSS_VAR_TEXT" : "");
function pH(e) {
  const t = jn();
  if (!t) {
    process.env.NODE_ENV !== "production" && la("useCssVars is called without current active component instance.");
    return;
  }
  const n = t.ut = (a = e(t.proxy)) => {
    Array.from(
      document.querySelectorAll(`[data-v-owner="${t.uid}"]`)
    ).forEach((o) => hb(o, a));
  };
  process.env.NODE_ENV !== "production" && (t.getCssVars = () => e(t.proxy));
  const r = () => {
    const a = e(t.proxy);
    pb(t.subTree, a), n(a);
  };
  Lt(() => {
    cA(r);
    const a = new MutationObserver(r);
    a.observe(t.subTree.el.parentNode, { childList: !0 }), Bo(() => a.disconnect());
  });
}
function pb(e, t) {
  if (e.shapeFlag & 128) {
    const n = e.suspense;
    e = n.activeBranch, n.pendingBranch && !n.isHydrating && n.effects.push(() => {
      pb(n.activeBranch, t);
    });
  }
  for (; e.component; )
    e = e.component.subTree;
  if (e.shapeFlag & 1 && e.el)
    hb(e.el, t);
  else if (e.type === dt)
    e.children.forEach((n) => pb(n, t));
  else if (e.type === Ul) {
    let { el: n, anchor: r } = e;
    for (; n && (hb(n, t), n !== r); )
      n = n.nextSibling;
  }
}
function hb(e, t) {
  if (e.nodeType === 1) {
    const n = e.style;
    let r = "";
    for (const a in t)
      n.setProperty(`--${a}`, t[a]), r += `--${a}: ${t[a]};`;
    n[NA] = r;
  }
}
const hH = /(^|;)\s*display\s*:/;
function vH(e, t, n) {
  const r = e.style, a = Dn(n);
  let o = !1;
  if (n && !a) {
    if (t)
      if (Dn(t))
        for (const i of t.split(";")) {
          const s = i.slice(0, i.indexOf(":")).trim();
          n[s] == null && _v(r, s, "");
        }
      else
        for (const i in t)
          n[i] == null && _v(r, i, "");
    for (const i in n)
      i === "display" && (o = !0), _v(r, i, n[i]);
  } else if (a) {
    if (t !== n) {
      const i = r[NA];
      i && (n += ";" + i), r.cssText = n, o = hH.test(n);
    }
  } else t && e.removeAttribute("style");
  um in e && (e[um] = o ? r.display : "", e[RA] && (r.display = "none"));
}
const mH = /[^\\];\s*$/, i3 = /\s*!important$/;
function _v(e, t, n) {
  if (St(n))
    n.forEach((r) => _v(e, t, r));
  else if (n == null && (n = ""), process.env.NODE_ENV !== "production" && mH.test(n) && la(
    `Unexpected semicolon at the end of '${t}' style value: '${n}'`
  ), t.startsWith("--"))
    e.setProperty(t, n);
  else {
    const r = gH(e, t);
    i3.test(n) ? e.setProperty(
      na(r),
      n.replace(i3, ""),
      "important"
    ) : e[r] = n;
  }
}
const s3 = ["Webkit", "Moz", "ms"], iy = {};
function gH(e, t) {
  const n = iy[t];
  if (n)
    return n;
  let r = Ia(t);
  if (r !== "filter" && r in e)
    return iy[t] = r;
  r = Kl(r);
  for (let a = 0; a < s3.length; a++) {
    const o = s3[a] + r;
    if (o in e)
      return iy[t] = o;
  }
  return t;
}
const l3 = "http://www.w3.org/1999/xlink";
function u3(e, t, n, r, a, o = SF(t)) {
  r && t.startsWith("xlink:") ? n == null ? e.removeAttributeNS(l3, t.slice(6, t.length)) : e.setAttributeNS(l3, t, n) : n == null || o && !n_(n) ? e.removeAttribute(t) : e.setAttribute(
    t,
    o ? "" : ps(n) ? String(n) : n
  );
}
function yH(e, t, n, r) {
  if (t === "innerHTML" || t === "textContent") {
    if (n == null) return;
    e[t] = n;
    return;
  }
  const a = e.tagName;
  if (t === "value" && a !== "PROGRESS" && // custom elements may use _value internally
  !a.includes("-")) {
    const i = a === "OPTION" ? e.getAttribute("value") || "" : e.value, s = n == null ? "" : String(n);
    (i !== s || !("_value" in e)) && (e.value = s), n == null && e.removeAttribute(t), e._value = n;
    return;
  }
  let o = !1;
  if (n === "" || n == null) {
    const i = typeof e[t];
    i === "boolean" ? n = n_(n) : n == null && i === "string" ? (n = "", o = !0) : i === "number" && (n = 0, o = !0);
  }
  try {
    e[t] = n;
  } catch (i) {
    process.env.NODE_ENV !== "production" && !o && la(
      `Failed setting prop "${t}" on <${a.toLowerCase()}>: value ${n} is invalid.`,
      i
    );
  }
  o && e.removeAttribute(t);
}
function Ls(e, t, n, r) {
  e.addEventListener(t, n, r);
}
function xH(e, t, n, r) {
  e.removeEventListener(t, n, r);
}
const c3 = Symbol("_vei");
function bH(e, t, n, r, a = null) {
  const o = e[c3] || (e[c3] = {}), i = o[t];
  if (r && i)
    i.value = process.env.NODE_ENV !== "production" ? d3(r, t) : r;
  else {
    const [s, l] = wH(t);
    if (r) {
      const u = o[t] = CH(
        process.env.NODE_ENV !== "production" ? d3(r, t) : r,
        a
      );
      Ls(e, s, u, l);
    } else i && (xH(e, s, i, l), o[t] = void 0);
  }
}
const f3 = /(?:Once|Passive|Capture)$/;
function wH(e) {
  let t;
  if (f3.test(e)) {
    t = {};
    let r;
    for (; r = e.match(f3); )
      e = e.slice(0, e.length - r[0].length), t[r[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : na(e.slice(2)), t];
}
let sy = 0;
const SH = /* @__PURE__ */ Promise.resolve(), _H = () => sy || (SH.then(() => sy = 0), sy = Date.now());
function CH(e, t) {
  const n = (r) => {
    if (!r._vts)
      r._vts = Date.now();
    else if (r._vts <= n.attached)
      return;
    Ro(
      EH(r, n.value),
      t,
      5,
      [r]
    );
  };
  return n.value = e, n.attached = _H(), n;
}
function d3(e, t) {
  return Pt(e) || St(e) ? e : (la(
    `Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`
  ), vr);
}
function EH(e, t) {
  if (St(t)) {
    const n = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      n.call(e), e._stopped = !0;
    }, t.map(
      (r) => (a) => !a._stopped && r && r(a)
    );
  } else
    return t;
}
const p3 = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, TH = (e, t, n, r, a, o) => {
  const i = a === "svg";
  t === "class" ? fH(e, r, i) : t === "style" ? vH(e, n, r) : ud(t) ? Xv(t) || bH(e, t, n, r, o) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : $H(e, t, r, i)) ? (yH(e, t, r), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && u3(e, t, r, i, o, t !== "value")) : (t === "true-value" ? e._trueValue = r : t === "false-value" && (e._falseValue = r), u3(e, t, r, i));
};
function $H(e, t, n, r) {
  if (r)
    return !!(t === "innerHTML" || t === "textContent" || t in e && p3(t) && Pt(n));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const a = e.tagName;
    if (a === "IMG" || a === "VIDEO" || a === "CANVAS" || a === "SOURCE")
      return !1;
  }
  return p3(t) && Dn(n) ? !1 : t in e;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function FA(e, t, n) {
  const r = /* @__PURE__ */ Me(e, t);
  class a extends Ag {
    constructor(i) {
      super(r, i, n);
    }
  }
  return a.def = r, a;
}
/*! #__NO_SIDE_EFFECTS__ */
const OH = /* @__NO_SIDE_EFFECTS__ */ (e, t) => /* @__PURE__ */ FA(e, t, YA), AH = typeof HTMLElement < "u" ? HTMLElement : class {
};
class Ag extends AH {
  constructor(t, n = {}, r) {
    super(), this._def = t, this._props = n, this._instance = null, this._connected = !1, this._resolved = !1, this._numberProps = null, this._ob = null, this.shadowRoot && r ? r(this._createVNode(), this.shadowRoot) : (process.env.NODE_ENV !== "production" && this.shadowRoot && la(
      "Custom element has pre-rendered declarative shadow root but is not defined as hydratable. Use `defineSSRCustomElement`."
    ), this.attachShadow({ mode: "open" }), this._def.__asyncLoader || this._resolveProps(this._def));
  }
  connectedCallback() {
    this._connected = !0, this._instance || (this._resolved ? this._update() : this._resolveDef());
  }
  disconnectedCallback() {
    this._connected = !1, nn(() => {
      this._connected || (this._ob && (this._ob.disconnect(), this._ob = null), ms(null, this.shadowRoot), this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    this._resolved = !0;
    for (let r = 0; r < this.attributes.length; r++)
      this._setAttr(this.attributes[r].name);
    this._ob = new MutationObserver((r) => {
      for (const a of r)
        this._setAttr(a.attributeName);
    }), this._ob.observe(this, { attributes: !0 });
    const t = (r, a = !1) => {
      const { props: o, styles: i } = r;
      let s;
      if (o && !St(o))
        for (const l in o) {
          const u = o[l];
          (u === Number || u && u.type === Number) && (l in this._props && (this._props[l] = Qv(this._props[l])), (s || (s = /* @__PURE__ */ Object.create(null)))[Ia(l)] = !0);
        }
      this._numberProps = s, a && this._resolveProps(r), this._applyStyles(i), this._update();
    }, n = this._def.__asyncLoader;
    n ? n().then((r) => t(r, !0)) : t(this._def);
  }
  _resolveProps(t) {
    const { props: n } = t, r = St(n) ? n : Object.keys(n || {});
    for (const a of Object.keys(this))
      a[0] !== "_" && r.includes(a) && this._setProp(a, this[a], !0, !1);
    for (const a of r.map(Ia))
      Object.defineProperty(this, a, {
        get() {
          return this._getProp(a);
        },
        set(o) {
          this._setProp(a, o);
        }
      });
  }
  _setAttr(t) {
    let n = this.hasAttribute(t) ? this.getAttribute(t) : void 0;
    const r = Ia(t);
    this._numberProps && this._numberProps[r] && (n = Qv(n)), this._setProp(r, n, !1);
  }
  /**
   * @internal
   */
  _getProp(t) {
    return this._props[t];
  }
  /**
   * @internal
   */
  _setProp(t, n, r = !0, a = !0) {
    n !== this._props[t] && (this._props[t] = n, a && this._instance && this._update(), r && (n === !0 ? this.setAttribute(na(t), "") : typeof n == "string" || typeof n == "number" ? this.setAttribute(na(t), n + "") : n || this.removeAttribute(na(t))));
  }
  _update() {
    ms(this._createVNode(), this.shadowRoot);
  }
  _createVNode() {
    const t = A(this._def, Ln({}, this._props));
    return this._instance || (t.ce = (n) => {
      this._instance = n, n.isCE = !0, process.env.NODE_ENV !== "production" && (n.ceReload = (o) => {
        this._styles && (this._styles.forEach((i) => this.shadowRoot.removeChild(i)), this._styles.length = 0), this._applyStyles(o), this._instance = null, this._update();
      });
      const r = (o, i) => {
        this.dispatchEvent(
          new CustomEvent(o, {
            detail: i
          })
        );
      };
      n.emit = (o, ...i) => {
        r(o, i), na(o) !== o && r(na(o), i);
      };
      let a = this;
      for (; a = a && (a.parentNode || a.host); )
        if (a instanceof Ag) {
          n.parent = a._instance, n.provides = a._instance.provides;
          break;
        }
    }), t;
  }
  _applyStyles(t) {
    t && t.forEach((n) => {
      const r = document.createElement("style");
      r.textContent = n, this.shadowRoot.appendChild(r), process.env.NODE_ENV !== "production" && (this._styles || (this._styles = [])).push(r);
    });
  }
}
function IH(e = "$style") {
  {
    const t = jn();
    if (!t)
      return process.env.NODE_ENV !== "production" && la("useCssModule must be called inside setup()"), On;
    const n = t.type.__cssModules;
    if (!n)
      return process.env.NODE_ENV !== "production" && la("Current instance does not have CSS modules injected."), On;
    const r = n[e];
    return r || (process.env.NODE_ENV !== "production" && la(`Current instance does not have CSS module named "${e}".`), On);
  }
}
const LA = /* @__PURE__ */ new WeakMap(), BA = /* @__PURE__ */ new WeakMap(), cm = Symbol("_moveCb"), h3 = Symbol("_enterCb"), HA = {
  name: "TransitionGroup",
  props: /* @__PURE__ */ Ln({}, lH, {
    tag: String,
    moveClass: String
  }),
  setup(e, { slots: t }) {
    const n = jn(), r = v_();
    let a, o;
    return Qa(() => {
      if (!a.length)
        return;
      const i = e.moveClass || `${e.name || "v"}-move`;
      if (!RH(
        a[0].el,
        n.vnode.el,
        i
      ))
        return;
      a.forEach(DH), a.forEach(kH);
      const s = a.filter(MH);
      MA(), s.forEach((l) => {
        const u = l.el, c = u.style;
        Ms(u, i), c.transform = c.webkitTransform = c.transitionDuration = "";
        const f = u[cm] = (d) => {
          d && d.target !== u || (!d || /transform$/.test(d.propertyName)) && (u.removeEventListener("transitionend", f), u[cm] = null, _l(u, i));
        };
        u.addEventListener("transitionend", f);
      });
    }), () => {
      const i = At(e), s = DA(i);
      let l = i.tag || dt;
      if (a = [], o)
        for (let u = 0; u < o.length; u++) {
          const c = o[u];
          c.el && c.el instanceof Element && (a.push(c), Xl(
            c,
            Nf(
              c,
              s,
              r,
              n
            )
          ), LA.set(
            c,
            c.el.getBoundingClientRect()
          ));
        }
      o = t.default ? Sg(t.default()) : [];
      for (let u = 0; u < o.length; u++) {
        const c = o[u];
        c.key != null ? Xl(
          c,
          Nf(c, s, r, n)
        ) : process.env.NODE_ENV !== "production" && la("<TransitionGroup> children must be keyed.");
      }
      return A(l, null, o);
    };
  }
}, PH = (e) => delete e.mode;
HA.props;
const Ig = HA;
function DH(e) {
  const t = e.el;
  t[cm] && t[cm](), t[h3] && t[h3]();
}
function kH(e) {
  BA.set(e, e.el.getBoundingClientRect());
}
function MH(e) {
  const t = LA.get(e), n = BA.get(e), r = t.left - n.left, a = t.top - n.top;
  if (r || a) {
    const o = e.el.style;
    return o.transform = o.webkitTransform = `translate(${r}px,${a}px)`, o.transitionDuration = "0s", e;
  }
}
function RH(e, t, n) {
  const r = e.cloneNode(), a = e[Ff];
  a && a.forEach((s) => {
    s.split(/\s+/).forEach((l) => l && r.classList.remove(l));
  }), n.split(/\s+/).forEach((s) => s && r.classList.add(s)), r.style.display = "none";
  const o = t.nodeType === 1 ? t : t.parentNode;
  o.appendChild(r);
  const { hasTransform: i } = kA(r);
  return o.removeChild(r), i;
}
const Ql = (e) => {
  const t = e.props["onUpdate:modelValue"] || !1;
  return St(t) ? (n) => Ol(t, n) : t;
};
function NH(e) {
  e.target.composing = !0;
}
function v3(e) {
  const t = e.target;
  t.composing && (t.composing = !1, t.dispatchEvent(new Event("input")));
}
const oi = Symbol("_assign"), zi = {
  created(e, { modifiers: { lazy: t, trim: n, number: r } }, a) {
    e[oi] = Ql(a);
    const o = r || a.props && a.props.type === "number";
    Ls(e, t ? "change" : "input", (i) => {
      if (i.target.composing) return;
      let s = e.value;
      n && (s = s.trim()), o && (s = Zv(s)), e[oi](s);
    }), n && Ls(e, "change", () => {
      e.value = e.value.trim();
    }), t || (Ls(e, "compositionstart", NH), Ls(e, "compositionend", v3), Ls(e, "change", v3));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(e, { value: t }) {
    e.value = t ?? "";
  },
  beforeUpdate(e, { value: t, oldValue: n, modifiers: { lazy: r, trim: a, number: o } }, i) {
    if (e[oi] = Ql(i), e.composing) return;
    const s = (o || e.type === "number") && !/^0\d/.test(e.value) ? Zv(e.value) : e.value, l = t ?? "";
    s !== l && (document.activeElement === e && e.type !== "range" && (r && t === n || a && e.value.trim() === l) || (e.value = l));
  }
}, O_ = {
  // #4096 array checkboxes need to be deep traversed
  deep: !0,
  created(e, t, n) {
    e[oi] = Ql(n), Ls(e, "change", () => {
      const r = e._modelValue, a = Lf(e), o = e.checked, i = e[oi];
      if (St(r)) {
        const s = pg(r, a), l = s !== -1;
        if (o && !l)
          i(r.concat(a));
        else if (!o && l) {
          const u = [...r];
          u.splice(s, 1), i(u);
        }
      } else if (wc(r)) {
        const s = new Set(r);
        o ? s.add(a) : s.delete(a), i(s);
      } else
        i(VA(e, o));
    });
  },
  // set initial checked on mount to wait for true-value/false-value
  mounted: m3,
  beforeUpdate(e, t, n) {
    e[oi] = Ql(n), m3(e, t, n);
  }
};
function m3(e, { value: t, oldValue: n }, r) {
  e._modelValue = t, St(t) ? e.checked = pg(t, r.props.value) > -1 : wc(t) ? e.checked = t.has(r.props.value) : t !== n && (e.checked = Yl(t, VA(e, !0)));
}
const A_ = {
  created(e, { value: t }, n) {
    e.checked = Yl(t, n.props.value), e[oi] = Ql(n), Ls(e, "change", () => {
      e[oi](Lf(e));
    });
  },
  beforeUpdate(e, { value: t, oldValue: n }, r) {
    e[oi] = Ql(r), t !== n && (e.checked = Yl(t, r.props.value));
  }
}, jA = {
  // <select multiple> value need to be deep traversed
  deep: !0,
  created(e, { value: t, modifiers: { number: n } }, r) {
    const a = wc(t);
    Ls(e, "change", () => {
      const o = Array.prototype.filter.call(e.options, (i) => i.selected).map(
        (i) => n ? Zv(Lf(i)) : Lf(i)
      );
      e[oi](
        e.multiple ? a ? new Set(o) : o : o[0]
      ), e._assigning = !0, nn(() => {
        e._assigning = !1;
      });
    }), e[oi] = Ql(r);
  },
  // set value in mounted & updated because <select> relies on its children
  // <option>s.
  mounted(e, { value: t, modifiers: { number: n } }) {
    g3(e, t);
  },
  beforeUpdate(e, t, n) {
    e[oi] = Ql(n);
  },
  updated(e, { value: t, modifiers: { number: n } }) {
    e._assigning || g3(e, t);
  }
};
function g3(e, t, n) {
  const r = e.multiple, a = St(t);
  if (r && !a && !wc(t)) {
    process.env.NODE_ENV !== "production" && la(
      `<select multiple v-model> expects an Array or Set value for its binding, but got ${Object.prototype.toString.call(t).slice(8, -1)}.`
    );
    return;
  }
  for (let o = 0, i = e.options.length; o < i; o++) {
    const s = e.options[o], l = Lf(s);
    if (r)
      if (a) {
        const u = typeof l;
        u === "string" || u === "number" ? s.selected = t.some((c) => String(c) === String(l)) : s.selected = pg(t, l) > -1;
      } else
        s.selected = t.has(l);
    else if (Yl(Lf(s), t)) {
      e.selectedIndex !== o && (e.selectedIndex = o);
      return;
    }
  }
  !r && e.selectedIndex !== -1 && (e.selectedIndex = -1);
}
function Lf(e) {
  return "_value" in e ? e._value : e.value;
}
function VA(e, t) {
  const n = t ? "_trueValue" : "_falseValue";
  return n in e ? e[n] : t;
}
const UA = {
  created(e, t, n) {
    Th(e, t, n, null, "created");
  },
  mounted(e, t, n) {
    Th(e, t, n, null, "mounted");
  },
  beforeUpdate(e, t, n, r) {
    Th(e, t, n, r, "beforeUpdate");
  },
  updated(e, t, n, r) {
    Th(e, t, n, r, "updated");
  }
};
function zA(e, t) {
  switch (e) {
    case "SELECT":
      return jA;
    case "TEXTAREA":
      return zi;
    default:
      switch (t) {
        case "checkbox":
          return O_;
        case "radio":
          return A_;
        default:
          return zi;
      }
  }
}
function Th(e, t, n, r, a) {
  const i = zA(
    e.tagName,
    n.props && n.props.type
  )[a];
  i && i(e, t, n, r);
}
function FH() {
  zi.getSSRProps = ({ value: e }) => ({ value: e }), A_.getSSRProps = ({ value: e }, t) => {
    if (t.props && Yl(t.props.value, e))
      return { checked: !0 };
  }, O_.getSSRProps = ({ value: e }, t) => {
    if (St(e)) {
      if (t.props && pg(e, t.props.value) > -1)
        return { checked: !0 };
    } else if (wc(e)) {
      if (t.props && e.has(t.props.value))
        return { checked: !0 };
    } else if (e)
      return { checked: !0 };
  }, UA.getSSRProps = (e, t) => {
    if (typeof t.type != "string")
      return;
    const n = zA(
      // resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
      t.type.toUpperCase(),
      t.props && t.props.type
    );
    if (n.getSSRProps)
      return n.getSSRProps(e, t);
  };
}
const LH = ["ctrl", "shift", "alt", "meta"], BH = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, t) => LH.some((n) => e[`${n}Key`] && !t.includes(n))
}, ft = (e, t) => {
  const n = e._withMods || (e._withMods = {}), r = t.join(".");
  return n[r] || (n[r] = (a, ...o) => {
    for (let i = 0; i < t.length; i++) {
      const s = BH[t[i]];
      if (s && s(a, t)) return;
    }
    return e(a, ...o);
  });
}, HH = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
}, zt = (e, t) => {
  const n = e._withKeys || (e._withKeys = {}), r = t.join(".");
  return n[r] || (n[r] = (a) => {
    if (!("key" in a))
      return;
    const o = na(a.key);
    if (t.some((i) => i === o || HH[i] === o))
      return e(a);
  });
}, WA = /* @__PURE__ */ Ln({ patchProp: TH }, sH);
let g0, y3 = !1;
function GA() {
  return g0 || (g0 = rA(WA));
}
function KA() {
  return g0 = y3 ? g0 : aA(WA), y3 = !0, g0;
}
const ms = (...e) => {
  GA().render(...e);
}, YA = (...e) => {
  KA().hydrate(...e);
}, qA = (...e) => {
  const t = GA().createApp(...e);
  process.env.NODE_ENV !== "production" && (ZA(t), QA(t));
  const { mount: n } = t;
  return t.mount = (r) => {
    const a = JA(r);
    if (!a) return;
    const o = t._component;
    !Pt(o) && !o.render && !o.template && (o.template = a.innerHTML), a.innerHTML = "";
    const i = n(a, !1, XA(a));
    return a instanceof Element && (a.removeAttribute("v-cloak"), a.setAttribute("data-v-app", "")), i;
  }, t;
}, jH = (...e) => {
  const t = KA().createApp(...e);
  process.env.NODE_ENV !== "production" && (ZA(t), QA(t));
  const { mount: n } = t;
  return t.mount = (r) => {
    const a = JA(r);
    if (a)
      return n(a, !0, XA(a));
  }, t;
};
function XA(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function ZA(e) {
  Object.defineProperty(e.config, "isNativeTag", {
    value: (t) => xF(t) || bF(t) || wF(t),
    writable: !1
  });
}
function QA(e) {
  if ($_()) {
    const t = e.config.isCustomElement;
    Object.defineProperty(e.config, "isCustomElement", {
      get() {
        return t;
      },
      set() {
        la(
          "The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead."
        );
      }
    });
    const n = e.config.compilerOptions, r = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
    Object.defineProperty(e.config, "compilerOptions", {
      get() {
        return la(r), n;
      },
      set() {
        la(r);
      }
    });
  }
}
function JA(e) {
  if (Dn(e)) {
    const t = document.querySelector(e);
    return process.env.NODE_ENV !== "production" && !t && la(
      `Failed to mount app: mount target selector "${e}" returned null.`
    ), t;
  }
  return process.env.NODE_ENV !== "production" && window.ShadowRoot && e instanceof window.ShadowRoot && e.mode === "closed" && la(
    'mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'
  ), e;
}
let x3 = !1;
const VH = () => {
  x3 || (x3 = !0, FH(), dH());
};
/**
* vue v3.4.33
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function UH() {
  AA();
}
process.env.NODE_ENV !== "production" && UH();
const zH = () => {
  process.env.NODE_ENV !== "production" && la(
    'Runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
  );
}, WH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseTransition: A9,
  BaseTransitionPropsValidators: m_,
  Comment: tr,
  DeprecationTypes: aH,
  EffectScope: r_,
  ErrorCodes: uL,
  ErrorTypeStrings: ZB,
  Fragment: dt,
  KeepAlive: IL,
  ReactiveEffect: Rf,
  Static: Ul,
  Suspense: kB,
  Teleport: Eg,
  Text: Bi,
  TrackOpTypes: rL,
  Transition: Ho,
  TransitionGroup: Ig,
  TriggerOpTypes: aL,
  VueElement: Ag,
  assertNumber: c_,
  callWithAsyncErrorHandling: Ro,
  callWithErrorHandling: ss,
  camelize: Ia,
  capitalize: Kl,
  cloneVNode: Yr,
  compatUtils: rH,
  compile: zH,
  computed: V,
  createApp: qA,
  createBlock: et,
  createCommentVNode: bt,
  createElementBlock: rt,
  createElementVNode: ke,
  createHydrationRenderer: aA,
  createPropsRestProxy: YL,
  createRenderer: rA,
  createSSRApp: jH,
  createSlots: kL,
  createStaticVNode: jB,
  createTextVNode: Jt,
  createVNode: A,
  customRef: xg,
  defineAsyncComponent: OL,
  defineComponent: Me,
  defineCustomElement: FA,
  defineEmits: HL,
  defineExpose: jL,
  defineModel: zL,
  defineOptions: VL,
  defineProps: BL,
  defineSSRCustomElement: OH,
  defineSlots: UL,
  devtools: QB,
  effect: OF,
  effectScope: hg,
  getCurrentInstance: jn,
  getCurrentScope: fd,
  getTransitionRawChildren: Sg,
  guardReactiveProps: E_,
  h: Z0,
  handleError: lu,
  hasInjectionContext: z9,
  hydrate: YA,
  initCustomFormatter: AA,
  initDirectivesForSSR: VH,
  inject: Ke,
  isMemoSame: IA,
  isProxy: V0,
  isReactive: ai,
  isReadonly: vs,
  isRef: Ft,
  isRuntimeOnly: $_,
  isShallow: is,
  isVNode: ka,
  markRaw: Hs,
  mergeDefaults: KL,
  mergeModels: Zl,
  mergeProps: sc,
  nextTick: nn,
  normalizeClass: tn,
  normalizeProps: XO,
  normalizeStyle: _r,
  onActivated: P9,
  onBeforeMount: g_,
  onBeforeUnmount: Sn,
  onBeforeUpdate: Cg,
  onDeactivated: D9,
  onErrorCaptured: F9,
  onMounted: Lt,
  onRenderTracked: N9,
  onRenderTriggered: R9,
  onScopeDispose: vg,
  onServerPrefetch: M9,
  onUnmounted: Bo,
  onUpdated: Qa,
  openBlock: Ce,
  popScopeId: Za,
  provide: kt,
  proxyRefs: u_,
  pushScopeId: Xa,
  queuePostFlushCb: W0,
  reactive: Wn,
  readonly: ql,
  ref: ne,
  registerRuntimeCompiler: GB,
  render: ms,
  renderList: Vn,
  renderSlot: uo,
  resolveComponent: Yx,
  resolveDirective: B9,
  resolveDynamicComponent: L9,
  resolveFilter: nH,
  resolveTransitionHooks: Nf,
  setBlockTracking: ob,
  setDevtoolsHook: JB,
  setTransitionHooks: Xl,
  shallowReactive: v9,
  shallowReadonly: Ri,
  shallowRef: Be,
  ssrContextKey: lA,
  ssrUtils: tH,
  stop: AF,
  toDisplayString: Wt,
  toHandlerKey: Ns,
  toHandlers: ML,
  toRaw: At,
  toRef: Tt,
  toRefs: ac,
  toValue: QF,
  transformVNodeArgs: BB,
  triggerRef: y9,
  unref: U,
  useAttrs: w_,
  useCssModule: IH,
  useCssVars: pH,
  useModel: Fr,
  useSSRContext: uA,
  useSlots: GL,
  useTransitionState: v_,
  vModelCheckbox: O_,
  vModelDynamic: UA,
  vModelRadio: A_,
  vModelSelect: jA,
  vModelText: zi,
  vShow: ko,
  version: db,
  warn: la,
  watch: He,
  watchEffect: _n,
  watchPostEffect: cA,
  watchSyncEffect: fA,
  withAsyncContext: qL,
  withCtx: Fe,
  withDefaults: WL,
  withDirectives: Yn,
  withKeys: zt,
  withMemo: XB,
  withModifiers: ft,
  withScopeId: TL
}, Symbol.toStringTag, { value: "Module" }));
var e8 = !1;
function $h(e, t, n) {
  return Array.isArray(e) ? (e.length = Math.max(e.length, t), e.splice(t, 1, n), n) : (e[t] = n, n);
}
function ly(e, t) {
  if (Array.isArray(e)) {
    e.splice(t, 1);
    return;
  }
  delete e[t];
}
function GH() {
  return t8().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function t8() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const KH = typeof Proxy == "function", YH = "devtools-plugin:setup", qH = "plugin:settings:set";
let Uc, vb;
function XH() {
  var e;
  return Uc !== void 0 || (typeof window < "u" && window.performance ? (Uc = !0, vb = window.performance) : typeof globalThis < "u" && (!((e = globalThis.perf_hooks) === null || e === void 0) && e.performance) ? (Uc = !0, vb = globalThis.perf_hooks.performance) : Uc = !1), Uc;
}
function ZH() {
  return XH() ? vb.now() : Date.now();
}
class QH {
  constructor(t, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = n;
    const r = {};
    if (t.settings)
      for (const i in t.settings) {
        const s = t.settings[i];
        r[i] = s.defaultValue;
      }
    const a = `__vue-devtools-plugin-settings__${t.id}`;
    let o = Object.assign({}, r);
    try {
      const i = localStorage.getItem(a), s = JSON.parse(i);
      Object.assign(o, s);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return o;
      },
      setSettings(i) {
        try {
          localStorage.setItem(a, JSON.stringify(i));
        } catch {
        }
        o = i;
      },
      now() {
        return ZH();
      }
    }, n && n.on(qH, (i, s) => {
      i === this.plugin.id && this.fallbacks.setSettings(s);
    }), this.proxiedOn = new Proxy({}, {
      get: (i, s) => this.target ? this.target.on[s] : (...l) => {
        this.onQueue.push({
          method: s,
          args: l
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (i, s) => this.target ? this.target[s] : s === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(s) ? (...l) => (this.targetQueue.push({
        method: s,
        args: l,
        resolve: () => {
        }
      }), this.fallbacks[s](...l)) : (...l) => new Promise((u) => {
        this.targetQueue.push({
          method: s,
          args: l,
          resolve: u
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function n8(e, t) {
  const n = e, r = t8(), a = GH(), o = KH && n.enableEarlyProxy;
  if (a && (r.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !o))
    a.emit(YH, e, t);
  else {
    const i = o ? new QH(n, a) : null;
    (r.__VUE_DEVTOOLS_PLUGINS__ = r.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: t,
      proxy: i
    }), i && t(i.proxiedTarget);
  }
}
/*!
 * pinia v2.1.7
 * (c) 2023 Eduardo San Martin Morote
 * @license MIT
 */
let Qd;
const Q0 = (e) => Qd = e, r8 = process.env.NODE_ENV !== "production" ? Symbol("pinia") : (
  /* istanbul ignore next */
  Symbol()
);
function uc(e) {
  return e && typeof e == "object" && Object.prototype.toString.call(e) === "[object Object]" && typeof e.toJSON != "function";
}
var ls;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(ls || (ls = {}));
const Pg = typeof window < "u", y0 = (process.env.NODE_ENV !== "production" || !1) && process.env.NODE_ENV !== "test" && Pg, b3 = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof global == "object" && global.global === global ? global : typeof globalThis == "object" ? globalThis : { HTMLElement: null };
function JH(e, { autoBom: t = !1 } = {}) {
  return t && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob(["\uFEFF", e], { type: e.type }) : e;
}
function I_(e, t, n) {
  const r = new XMLHttpRequest();
  r.open("GET", e), r.responseType = "blob", r.onload = function() {
    i8(r.response, t, n);
  }, r.onerror = function() {
    console.error("could not download file");
  }, r.send();
}
function a8(e) {
  const t = new XMLHttpRequest();
  t.open("HEAD", e, !1);
  try {
    t.send();
  } catch {
  }
  return t.status >= 200 && t.status <= 299;
}
function Cv(e) {
  try {
    e.dispatchEvent(new MouseEvent("click"));
  } catch {
    const n = document.createEvent("MouseEvents");
    n.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(n);
  }
}
const Ev = typeof navigator == "object" ? navigator : { userAgent: "" }, o8 = /Macintosh/.test(Ev.userAgent) && /AppleWebKit/.test(Ev.userAgent) && !/Safari/.test(Ev.userAgent), i8 = Pg ? (
  // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView or mini program
  typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype && !o8 ? ej : (
    // Use msSaveOrOpenBlob as a second approach
    "msSaveOrOpenBlob" in Ev ? tj : (
      // Fallback to using FileReader and a popup
      nj
    )
  )
) : () => {
};
function ej(e, t = "download", n) {
  const r = document.createElement("a");
  r.download = t, r.rel = "noopener", typeof e == "string" ? (r.href = e, r.origin !== location.origin ? a8(r.href) ? I_(e, t, n) : (r.target = "_blank", Cv(r)) : Cv(r)) : (r.href = URL.createObjectURL(e), setTimeout(function() {
    URL.revokeObjectURL(r.href);
  }, 4e4), setTimeout(function() {
    Cv(r);
  }, 0));
}
function tj(e, t = "download", n) {
  if (typeof e == "string")
    if (a8(e))
      I_(e, t, n);
    else {
      const r = document.createElement("a");
      r.href = e, r.target = "_blank", setTimeout(function() {
        Cv(r);
      });
    }
  else
    navigator.msSaveOrOpenBlob(JH(e, n), t);
}
function nj(e, t, n, r) {
  if (r = r || open("", "_blank"), r && (r.document.title = r.document.body.innerText = "downloading..."), typeof e == "string")
    return I_(e, t, n);
  const a = e.type === "application/octet-stream", o = /constructor/i.test(String(b3.HTMLElement)) || "safari" in b3, i = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((i || a && o || o8) && typeof FileReader < "u") {
    const s = new FileReader();
    s.onloadend = function() {
      let l = s.result;
      if (typeof l != "string")
        throw r = null, new Error("Wrong reader.result type");
      l = i ? l : l.replace(/^data:[^;]*;/, "data:attachment/file;"), r ? r.location.href = l : location.assign(l), r = null;
    }, s.readAsDataURL(e);
  } else {
    const s = URL.createObjectURL(e);
    r ? r.location.assign(s) : location.href = s, r = null, setTimeout(function() {
      URL.revokeObjectURL(s);
    }, 4e4);
  }
}
function Vr(e, t) {
  const n = "🍍 " + e;
  typeof __VUE_DEVTOOLS_TOAST__ == "function" ? __VUE_DEVTOOLS_TOAST__(n, t) : t === "error" ? console.error(n) : t === "warn" ? console.warn(n) : console.log(n);
}
function P_(e) {
  return "_a" in e && "install" in e;
}
function s8() {
  if (!("clipboard" in navigator))
    return Vr("Your browser doesn't support the Clipboard API", "error"), !0;
}
function l8(e) {
  return e instanceof Error && e.message.toLowerCase().includes("document is not focused") ? (Vr('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', "warn"), !0) : !1;
}
async function rj(e) {
  if (!s8())
    try {
      await navigator.clipboard.writeText(JSON.stringify(e.state.value)), Vr("Global state copied to clipboard.");
    } catch (t) {
      if (l8(t))
        return;
      Vr("Failed to serialize the state. Check the console for more details.", "error"), console.error(t);
    }
}
async function aj(e) {
  if (!s8())
    try {
      u8(e, JSON.parse(await navigator.clipboard.readText())), Vr("Global state pasted from clipboard.");
    } catch (t) {
      if (l8(t))
        return;
      Vr("Failed to deserialize the state from clipboard. Check the console for more details.", "error"), console.error(t);
    }
}
async function oj(e) {
  try {
    i8(new Blob([JSON.stringify(e.state.value)], {
      type: "text/plain;charset=utf-8"
    }), "pinia-state.json");
  } catch (t) {
    Vr("Failed to export the state as JSON. Check the console for more details.", "error"), console.error(t);
  }
}
let $s;
function ij() {
  $s || ($s = document.createElement("input"), $s.type = "file", $s.accept = ".json");
  function e() {
    return new Promise((t, n) => {
      $s.onchange = async () => {
        const r = $s.files;
        if (!r)
          return t(null);
        const a = r.item(0);
        return t(a ? { text: await a.text(), file: a } : null);
      }, $s.oncancel = () => t(null), $s.onerror = n, $s.click();
    });
  }
  return e;
}
async function sj(e) {
  try {
    const n = await ij()();
    if (!n)
      return;
    const { text: r, file: a } = n;
    u8(e, JSON.parse(r)), Vr(`Global state imported from "${a.name}".`);
  } catch (t) {
    Vr("Failed to import the state from JSON. Check the console for more details.", "error"), console.error(t);
  }
}
function u8(e, t) {
  for (const n in t) {
    const r = e.state.value[n];
    r ? Object.assign(r, t[n]) : e.state.value[n] = t[n];
  }
}
function $i(e) {
  return {
    _custom: {
      display: e
    }
  };
}
const c8 = "🍍 Pinia (root)", mb = "_root";
function lj(e) {
  return P_(e) ? {
    id: mb,
    label: c8
  } : {
    id: e.$id,
    label: e.$id
  };
}
function uj(e) {
  if (P_(e)) {
    const n = Array.from(e._s.keys()), r = e._s;
    return {
      state: n.map((o) => ({
        editable: !0,
        key: o,
        value: e.state.value[o]
      })),
      getters: n.filter((o) => r.get(o)._getters).map((o) => {
        const i = r.get(o);
        return {
          editable: !1,
          key: o,
          value: i._getters.reduce((s, l) => (s[l] = i[l], s), {})
        };
      })
    };
  }
  const t = {
    state: Object.keys(e.$state).map((n) => ({
      editable: !0,
      key: n,
      value: e.$state[n]
    }))
  };
  return e._getters && e._getters.length && (t.getters = e._getters.map((n) => ({
    editable: !1,
    key: n,
    value: e[n]
  }))), e._customProperties.size && (t.customProperties = Array.from(e._customProperties).map((n) => ({
    editable: !0,
    key: n,
    value: e[n]
  }))), t;
}
function cj(e) {
  return e ? Array.isArray(e) ? e.reduce((t, n) => (t.keys.push(n.key), t.operations.push(n.type), t.oldValue[n.key] = n.oldValue, t.newValue[n.key] = n.newValue, t), {
    oldValue: {},
    keys: [],
    operations: [],
    newValue: {}
  }) : {
    operation: $i(e.type),
    key: $i(e.key),
    oldValue: e.oldValue,
    newValue: e.newValue
  } : {};
}
function fj(e) {
  switch (e) {
    case ls.direct:
      return "mutation";
    case ls.patchFunction:
      return "$patch";
    case ls.patchObject:
      return "$patch";
    default:
      return "unknown";
  }
}
let ff = !0;
const Tv = [], Tu = "pinia:mutations", xa = "pinia", { assign: dj } = Object, fm = (e) => "🍍 " + e;
function pj(e, t) {
  n8({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: Tv,
    app: e
  }, (n) => {
    typeof n.now != "function" && Vr("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html."), n.addTimelineLayer({
      id: Tu,
      label: "Pinia 🍍",
      color: 15064968
    }), n.addInspector({
      id: xa,
      label: "Pinia 🍍",
      icon: "storage",
      treeFilterPlaceholder: "Search stores",
      actions: [
        {
          icon: "content_copy",
          action: () => {
            rj(t);
          },
          tooltip: "Serialize and copy the state"
        },
        {
          icon: "content_paste",
          action: async () => {
            await aj(t), n.sendInspectorTree(xa), n.sendInspectorState(xa);
          },
          tooltip: "Replace the state with the content of your clipboard"
        },
        {
          icon: "save",
          action: () => {
            oj(t);
          },
          tooltip: "Save the state as a JSON file"
        },
        {
          icon: "folder_open",
          action: async () => {
            await sj(t), n.sendInspectorTree(xa), n.sendInspectorState(xa);
          },
          tooltip: "Import the state from a JSON file"
        }
      ],
      nodeActions: [
        {
          icon: "restore",
          tooltip: 'Reset the state (with "$reset")',
          action: (r) => {
            const a = t._s.get(r);
            a ? typeof a.$reset != "function" ? Vr(`Cannot reset "${r}" store because it doesn't have a "$reset" method implemented.`, "warn") : (a.$reset(), Vr(`Store "${r}" reset.`)) : Vr(`Cannot reset "${r}" store because it wasn't found.`, "warn");
          }
        }
      ]
    }), n.on.inspectComponent((r, a) => {
      const o = r.componentInstance && r.componentInstance.proxy;
      if (o && o._pStores) {
        const i = r.componentInstance.proxy._pStores;
        Object.values(i).forEach((s) => {
          r.instanceData.state.push({
            type: fm(s.$id),
            key: "state",
            editable: !0,
            value: s._isOptionsAPI ? {
              _custom: {
                value: At(s.$state),
                actions: [
                  {
                    icon: "restore",
                    tooltip: "Reset the state of this store",
                    action: () => s.$reset()
                  }
                ]
              }
            } : (
              // NOTE: workaround to unwrap transferred refs
              Object.keys(s.$state).reduce((l, u) => (l[u] = s.$state[u], l), {})
            )
          }), s._getters && s._getters.length && r.instanceData.state.push({
            type: fm(s.$id),
            key: "getters",
            editable: !1,
            value: s._getters.reduce((l, u) => {
              try {
                l[u] = s[u];
              } catch (c) {
                l[u] = c;
              }
              return l;
            }, {})
          });
        });
      }
    }), n.on.getInspectorTree((r) => {
      if (r.app === e && r.inspectorId === xa) {
        let a = [t];
        a = a.concat(Array.from(t._s.values())), r.rootNodes = (r.filter ? a.filter((o) => "$id" in o ? o.$id.toLowerCase().includes(r.filter.toLowerCase()) : c8.toLowerCase().includes(r.filter.toLowerCase())) : a).map(lj);
      }
    }), n.on.getInspectorState((r) => {
      if (r.app === e && r.inspectorId === xa) {
        const a = r.nodeId === mb ? t : t._s.get(r.nodeId);
        if (!a)
          return;
        a && (r.state = uj(a));
      }
    }), n.on.editInspectorState((r, a) => {
      if (r.app === e && r.inspectorId === xa) {
        const o = r.nodeId === mb ? t : t._s.get(r.nodeId);
        if (!o)
          return Vr(`store "${r.nodeId}" not found`, "error");
        const { path: i } = r;
        P_(o) ? i.unshift("state") : (i.length !== 1 || !o._customProperties.has(i[0]) || i[0] in o.$state) && i.unshift("$state"), ff = !1, r.set(o, i, r.state.value), ff = !0;
      }
    }), n.on.editComponentState((r) => {
      if (r.type.startsWith("🍍")) {
        const a = r.type.replace(/^🍍\s*/, ""), o = t._s.get(a);
        if (!o)
          return Vr(`store "${a}" not found`, "error");
        const { path: i } = r;
        if (i[0] !== "state")
          return Vr(`Invalid path for store "${a}":
${i}
Only state can be modified.`);
        i[0] = "$state", ff = !1, r.set(o, i, r.state.value), ff = !0;
      }
    });
  });
}
function hj(e, t) {
  Tv.includes(fm(t.$id)) || Tv.push(fm(t.$id)), n8({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: Tv,
    app: e,
    settings: {
      logStoreChanges: {
        label: "Notify about new/deleted stores",
        type: "boolean",
        defaultValue: !0
      }
      // useEmojis: {
      //   label: 'Use emojis in messages ⚡️',
      //   type: 'boolean',
      //   defaultValue: true,
      // },
    }
  }, (n) => {
    const r = typeof n.now == "function" ? n.now.bind(n) : Date.now;
    t.$onAction(({ after: i, onError: s, name: l, args: u }) => {
      const c = f8++;
      n.addTimelineEvent({
        layerId: Tu,
        event: {
          time: r(),
          title: "🛫 " + l,
          subtitle: "start",
          data: {
            store: $i(t.$id),
            action: $i(l),
            args: u
          },
          groupId: c
        }
      }), i((f) => {
        Ml = void 0, n.addTimelineEvent({
          layerId: Tu,
          event: {
            time: r(),
            title: "🛬 " + l,
            subtitle: "end",
            data: {
              store: $i(t.$id),
              action: $i(l),
              args: u,
              result: f
            },
            groupId: c
          }
        });
      }), s((f) => {
        Ml = void 0, n.addTimelineEvent({
          layerId: Tu,
          event: {
            time: r(),
            logType: "error",
            title: "💥 " + l,
            subtitle: "end",
            data: {
              store: $i(t.$id),
              action: $i(l),
              args: u,
              error: f
            },
            groupId: c
          }
        });
      });
    }, !0), t._customProperties.forEach((i) => {
      He(() => U(t[i]), (s, l) => {
        n.notifyComponentUpdate(), n.sendInspectorState(xa), ff && n.addTimelineEvent({
          layerId: Tu,
          event: {
            time: r(),
            title: "Change",
            subtitle: i,
            data: {
              newValue: s,
              oldValue: l
            },
            groupId: Ml
          }
        });
      }, { deep: !0 });
    }), t.$subscribe(({ events: i, type: s }, l) => {
      if (n.notifyComponentUpdate(), n.sendInspectorState(xa), !ff)
        return;
      const u = {
        time: r(),
        title: fj(s),
        data: dj({ store: $i(t.$id) }, cj(i)),
        groupId: Ml
      };
      s === ls.patchFunction ? u.subtitle = "⤵️" : s === ls.patchObject ? u.subtitle = "🧩" : i && !Array.isArray(i) && (u.subtitle = i.type), i && (u.data["rawEvent(s)"] = {
        _custom: {
          display: "DebuggerEvent",
          type: "object",
          tooltip: "raw DebuggerEvent[]",
          value: i
        }
      }), n.addTimelineEvent({
        layerId: Tu,
        event: u
      });
    }, { detached: !0, flush: "sync" });
    const a = t._hotUpdate;
    t._hotUpdate = Hs((i) => {
      a(i), n.addTimelineEvent({
        layerId: Tu,
        event: {
          time: r(),
          title: "🔥 " + t.$id,
          subtitle: "HMR update",
          data: {
            store: $i(t.$id),
            info: $i("HMR update")
          }
        }
      }), n.notifyComponentUpdate(), n.sendInspectorTree(xa), n.sendInspectorState(xa);
    });
    const { $dispose: o } = t;
    t.$dispose = () => {
      o(), n.notifyComponentUpdate(), n.sendInspectorTree(xa), n.sendInspectorState(xa), n.getSettings().logStoreChanges && Vr(`Disposed "${t.$id}" store 🗑`);
    }, n.notifyComponentUpdate(), n.sendInspectorTree(xa), n.sendInspectorState(xa), n.getSettings().logStoreChanges && Vr(`"${t.$id}" store installed 🆕`);
  });
}
let f8 = 0, Ml;
function w3(e, t, n) {
  const r = t.reduce((a, o) => (a[o] = At(e)[o], a), {});
  for (const a in r)
    e[a] = function() {
      const o = f8, i = n ? new Proxy(e, {
        get(...l) {
          return Ml = o, Reflect.get(...l);
        },
        set(...l) {
          return Ml = o, Reflect.set(...l);
        }
      }) : e;
      Ml = o;
      const s = r[a].apply(i, arguments);
      return Ml = void 0, s;
    };
}
function vj({ app: e, store: t, options: n }) {
  if (t.$id.startsWith("__hot:"))
    return;
  t._isOptionsAPI = !!n.state, w3(t, Object.keys(n.actions), t._isOptionsAPI);
  const r = t._hotUpdate;
  At(t)._hotUpdate = function(a) {
    r.apply(this, arguments), w3(t, Object.keys(a._hmrPayload.actions), !!t._isOptionsAPI);
  }, hj(
    e,
    // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
    t
  );
}
function mj() {
  const e = hg(!0), t = e.run(() => ne({}));
  let n = [], r = [];
  const a = Hs({
    install(o) {
      Q0(a), a._a = o, o.provide(r8, a), o.config.globalProperties.$pinia = a, y0 && pj(o, a), r.forEach((i) => n.push(i)), r = [];
    },
    use(o) {
      return !this._a && !e8 ? r.push(o) : n.push(o), this;
    },
    _p: n,
    // it's actually undefined here
    // @ts-expect-error
    _a: null,
    _e: e,
    _s: /* @__PURE__ */ new Map(),
    state: t
  });
  return y0 && typeof Proxy < "u" && a.use(vj), a;
}
function d8(e, t) {
  for (const n in t) {
    const r = t[n];
    if (!(n in e))
      continue;
    const a = e[n];
    uc(a) && uc(r) && !Ft(r) && !ai(r) ? e[n] = d8(a, r) : e[n] = r;
  }
  return e;
}
const p8 = () => {
};
function S3(e, t, n, r = p8) {
  e.push(t);
  const a = () => {
    const o = e.indexOf(t);
    o > -1 && (e.splice(o, 1), r());
  };
  return !n && fd() && vg(a), a;
}
function zc(e, ...t) {
  e.slice().forEach((n) => {
    n(...t);
  });
}
const gj = (e) => e();
function gb(e, t) {
  e instanceof Map && t instanceof Map && t.forEach((n, r) => e.set(r, n)), e instanceof Set && t instanceof Set && t.forEach(e.add, e);
  for (const n in t) {
    if (!t.hasOwnProperty(n))
      continue;
    const r = t[n], a = e[n];
    uc(a) && uc(r) && e.hasOwnProperty(n) && !Ft(r) && !ai(r) ? e[n] = gb(a, r) : e[n] = r;
  }
  return e;
}
const yj = process.env.NODE_ENV !== "production" ? Symbol("pinia:skipHydration") : (
  /* istanbul ignore next */
  Symbol()
);
function xj(e) {
  return !uc(e) || !e.hasOwnProperty(yj);
}
const { assign: Qo } = Object;
function _3(e) {
  return !!(Ft(e) && e.effect);
}
function C3(e, t, n, r) {
  const { state: a, actions: o, getters: i } = t, s = n.state.value[e];
  let l;
  function u() {
    !s && (process.env.NODE_ENV === "production" || !r) && (n.state.value[e] = a ? a() : {});
    const c = process.env.NODE_ENV !== "production" && r ? (
      // use ref() to unwrap refs inside state TODO: check if this is still necessary
      ac(ne(a ? a() : {}).value)
    ) : ac(n.state.value[e]);
    return Qo(c, o, Object.keys(i || {}).reduce((f, d) => (process.env.NODE_ENV !== "production" && d in c && console.warn(`[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${d}" in store "${e}".`), f[d] = Hs(V(() => {
      Q0(n);
      const p = n._s.get(e);
      return i[d].call(p, p);
    })), f), {}));
  }
  return l = yb(e, u, t, n, r, !0), l;
}
function yb(e, t, n = {}, r, a, o) {
  let i;
  const s = Qo({ actions: {} }, n);
  if (process.env.NODE_ENV !== "production" && !r._e.active)
    throw new Error("Pinia destroyed");
  const l = {
    deep: !0
    // flush: 'post',
  };
  process.env.NODE_ENV !== "production" && !e8 && (l.onTrigger = (T) => {
    u ? p = T : u == !1 && !b._hotUpdating && (Array.isArray(p) ? p.push(T) : console.error("🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug."));
  });
  let u, c, f = [], d = [], p;
  const v = r.state.value[e];
  !o && !v && (process.env.NODE_ENV === "production" || !a) && (r.state.value[e] = {});
  const h = ne({});
  let m;
  function y(T) {
    let O;
    u = c = !1, process.env.NODE_ENV !== "production" && (p = []), typeof T == "function" ? (T(r.state.value[e]), O = {
      type: ls.patchFunction,
      storeId: e,
      events: p
    }) : (gb(r.state.value[e], T), O = {
      type: ls.patchObject,
      payload: T,
      storeId: e,
      events: p
    });
    const I = m = Symbol();
    nn().then(() => {
      m === I && (u = !0);
    }), c = !0, zc(f, O, r.state.value[e]);
  }
  const x = o ? function() {
    const { state: O } = n, I = O ? O() : {};
    this.$patch((k) => {
      Qo(k, I);
    });
  } : (
    /* istanbul ignore next */
    process.env.NODE_ENV !== "production" ? () => {
      throw new Error(`🍍: Store "${e}" is built using the setup syntax and does not implement $reset().`);
    } : p8
  );
  function g() {
    i.stop(), f = [], d = [], r._s.delete(e);
  }
  function S(T, O) {
    return function() {
      Q0(r);
      const I = Array.from(arguments), k = [], B = [];
      function P(H) {
        k.push(H);
      }
      function N(H) {
        B.push(H);
      }
      zc(d, {
        args: I,
        name: T,
        store: b,
        after: P,
        onError: N
      });
      let M;
      try {
        M = O.apply(this && this.$id === e ? this : b, I);
      } catch (H) {
        throw zc(B, H), H;
      }
      return M instanceof Promise ? M.then((H) => (zc(k, H), H)).catch((H) => (zc(B, H), Promise.reject(H))) : (zc(k, M), M);
    };
  }
  const w = /* @__PURE__ */ Hs({
    actions: {},
    getters: {},
    state: [],
    hotState: h
  }), _ = {
    _p: r,
    // _s: scope,
    $id: e,
    $onAction: S3.bind(null, d),
    $patch: y,
    $reset: x,
    $subscribe(T, O = {}) {
      const I = S3(f, T, O.detached, () => k()), k = i.run(() => He(() => r.state.value[e], (B) => {
        (O.flush === "sync" ? c : u) && T({
          storeId: e,
          type: ls.direct,
          events: p
        }, B);
      }, Qo({}, l, O)));
      return I;
    },
    $dispose: g
  }, b = Wn(process.env.NODE_ENV !== "production" || y0 ? Qo(
    {
      _hmrPayload: w,
      _customProperties: Hs(/* @__PURE__ */ new Set())
      // devtools custom properties
    },
    _
    // must be added later
    // setupStore
  ) : _);
  r._s.set(e, b);
  const C = (r._a && r._a.runWithContext || gj)(() => r._e.run(() => (i = hg()).run(t)));
  for (const T in C) {
    const O = C[T];
    if (Ft(O) && !_3(O) || ai(O))
      process.env.NODE_ENV !== "production" && a ? $h(h.value, T, Tt(C, T)) : o || (v && xj(O) && (Ft(O) ? O.value = v[T] : gb(O, v[T])), r.state.value[e][T] = O), process.env.NODE_ENV !== "production" && w.state.push(T);
    else if (typeof O == "function") {
      const I = process.env.NODE_ENV !== "production" && a ? O : S(T, O);
      C[T] = I, process.env.NODE_ENV !== "production" && (w.actions[T] = O), s.actions[T] = O;
    } else process.env.NODE_ENV !== "production" && _3(O) && (w.getters[T] = o ? (
      // @ts-expect-error
      n.getters[T]
    ) : O, Pg && (C._getters || // @ts-expect-error: same
    (C._getters = Hs([]))).push(T));
  }
  if (Qo(b, C), Qo(At(b), C), Object.defineProperty(b, "$state", {
    get: () => process.env.NODE_ENV !== "production" && a ? h.value : r.state.value[e],
    set: (T) => {
      if (process.env.NODE_ENV !== "production" && a)
        throw new Error("cannot set hotState");
      y((O) => {
        Qo(O, T);
      });
    }
  }), process.env.NODE_ENV !== "production" && (b._hotUpdate = Hs((T) => {
    b._hotUpdating = !0, T._hmrPayload.state.forEach((O) => {
      if (O in b.$state) {
        const I = T.$state[O], k = b.$state[O];
        typeof I == "object" && uc(I) && uc(k) ? d8(I, k) : T.$state[O] = k;
      }
      $h(b, O, Tt(T.$state, O));
    }), Object.keys(b.$state).forEach((O) => {
      O in T.$state || ly(b, O);
    }), u = !1, c = !1, r.state.value[e] = Tt(T._hmrPayload, "hotState"), c = !0, nn().then(() => {
      u = !0;
    });
    for (const O in T._hmrPayload.actions) {
      const I = T[O];
      $h(b, O, S(O, I));
    }
    for (const O in T._hmrPayload.getters) {
      const I = T._hmrPayload.getters[O], k = o ? (
        // special handling of options api
        V(() => (Q0(r), I.call(b, b)))
      ) : I;
      $h(b, O, k);
    }
    Object.keys(b._hmrPayload.getters).forEach((O) => {
      O in T._hmrPayload.getters || ly(b, O);
    }), Object.keys(b._hmrPayload.actions).forEach((O) => {
      O in T._hmrPayload.actions || ly(b, O);
    }), b._hmrPayload = T._hmrPayload, b._getters = T._getters, b._hotUpdating = !1;
  })), y0) {
    const T = {
      writable: !0,
      configurable: !0,
      // avoid warning on devtools trying to display this property
      enumerable: !1
    };
    ["_p", "_hmrPayload", "_getters", "_customProperties"].forEach((O) => {
      Object.defineProperty(b, O, Qo({ value: b[O] }, T));
    });
  }
  return r._p.forEach((T) => {
    if (y0) {
      const O = i.run(() => T({
        store: b,
        app: r._a,
        pinia: r,
        options: s
      }));
      Object.keys(O || {}).forEach((I) => b._customProperties.add(I)), Qo(b, O);
    } else
      Qo(b, i.run(() => T({
        store: b,
        app: r._a,
        pinia: r,
        options: s
      })));
  }), process.env.NODE_ENV !== "production" && b.$state && typeof b.$state == "object" && typeof b.$state.constructor == "function" && !b.$state.constructor.toString().includes("[native code]") && console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${b.$id}".`), v && o && n.hydrate && n.hydrate(b.$state, v), u = !0, c = !0, b;
}
function kp(e, t, n) {
  let r, a;
  const o = typeof t == "function";
  if (typeof e == "string")
    r = e, a = o ? n : t;
  else if (a = e, r = e.id, process.env.NODE_ENV !== "production" && typeof r != "string")
    throw new Error('[🍍]: "defineStore()" must be passed a store id as its first argument.');
  function i(s, l) {
    const u = z9();
    if (s = // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    (process.env.NODE_ENV === "test" && Qd && Qd._testing ? null : s) || (u ? Ke(r8, null) : null), s && Q0(s), process.env.NODE_ENV !== "production" && !Qd)
      throw new Error(`[🍍]: "getActivePinia()" was called but there was no active Pinia. Are you trying to use a store before calling "app.use(pinia)"?
See https://pinia.vuejs.org/core-concepts/outside-component-usage.html for help.
This will fail in production.`);
    s = Qd, s._s.has(r) || (o ? yb(r, t, a, s) : C3(r, a, s), process.env.NODE_ENV !== "production" && (i._pinia = s));
    const c = s._s.get(r);
    if (process.env.NODE_ENV !== "production" && l) {
      const f = "__hot:" + r, d = o ? yb(f, t, a, s, !0) : C3(f, Qo({}, a), s, !0);
      l._hotUpdate(d), delete s.state.value[f], s._s.delete(f);
    }
    if (process.env.NODE_ENV !== "production" && Pg) {
      const f = jn();
      if (f && f.proxy && // avoid adding stores that are just built for hot module replacement
      !l) {
        const d = f.proxy, p = "_pStores" in d ? d._pStores : d._pStores = {};
        p[r] = c;
      }
    }
    return c;
  }
  return i.$id = r, i;
}
function Fn(e) {
  {
    e = At(e);
    const t = {};
    for (const n in e) {
      const r = e[n];
      (Ft(r) || ai(r)) && (t[n] = // ---
      Tt(e, n));
    }
    return t;
  }
}
const pd = kp("viewsStore", () => {
  const e = ne([]), t = ne(!1), n = ne(!1), r = ne({
    ptn: "nc_zj0l___Features",
    _ptn: "Features",
    ptype: "table",
    tn: "Features",
    _tn: "Features",
    table_meta: { hasNonDefaultViews: !0 },
    id: "vwn2u4gvtgud7vf1",
    source_id: "bi5j4j1az28tcjb",
    base_id: "p1xsf1p7utb2t32",
    fk_model_id: "mkoq0wps7erg5sp",
    title: "Features",
    type: 3,
    is_default: 1,
    show_system_fields: 0,
    lock_type: "collaborative",
    uuid: null,
    password: null,
    show: 1,
    order: 1,
    created_at: "2024-02-22 09:48:36+00:00",
    updated_at: "2024-03-05 08:44:26+00:00",
    meta: {},
    description: null,
    view: {
      fk_view_id: "vwn2u4gvtgud7vf1",
      source_id: "bi5j4j1az28tcjb",
      base_id: "p1xsf1p7utb2t32",
      uuid: null,
      created_at: "2024-02-22 09:48:36+00:00",
      updated_at: "2024-02-22 09:48:36+00:00",
      meta: null,
      row_height: 0
    },
    disabled: {
      owner: !1,
      creator: !1,
      viewer: !1,
      editor: !1,
      commenter: !1,
      guest: !1
    }
  }), a = ne(!1);
  return {
    // isLockedView,
    isViewsLoading: t,
    isViewDataLoading: n,
    isPaginationLoading: a,
    // loadViews,
    // recentViews,
    // allRecentViews,
    // views,
    activeView: r,
    // openedViewsTab,
    // onViewsTabChange,
    // sharedView,
    // viewsByTable,
    // activeViewTitleOrId,
    // navigateToView,
    // changeView,
    // removeFromRecentViews,
    activeSorts: e
    // activeNestedFilters,
    // isActiveViewLocked,
  };
});
var Ws = /* @__PURE__ */ ((e) => (e.SORT_RELOAD = "sort-reload", e.FILTER_RELOAD = "filter-reload", e.GROUP_BY_RELOAD = "group-by-reload", e.DATA_RELOAD = "data-reload", e.FIELD_RELOAD = "field-reload", e.FIELD_ADD = "field-add", e.MAPPED_BY_COLUMN_CHANGE = "mapped-by-column-change", e.CLEAR_NEW_ROW = "clear-new-row", e))(Ws || {}), h8 = /* @__PURE__ */ ((e) => (e.MYSQL = "mysql2", e.MSSQL = "mssql", e.PG = "pg", e.SQLITE = "sqlite3", e.VITESS = "vitess", e.SNOWFLAKE = "snowflake", e))(h8 || {}), $u = /* @__PURE__ */ ((e) => (e[e.NEXT = 0] = "NEXT", e[e.PREV = 1] = "PREV", e))($u || {}), xb = /* @__PURE__ */ ((e) => (e.COMPLETED = "completed", e.WAITING = "waiting", e.ACTIVE = "active", e.DELAYED = "delayed", e.FAILED = "failed", e.PAUSED = "paused", e.REFRESH = "refresh", e.CLOSE = "close", e))(xb || {});
function v8(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: bj } = Object.prototype, { getPrototypeOf: D_ } = Object, Dg = /* @__PURE__ */ ((e) => (t) => {
  const n = bj.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Gi = (e) => (e = e.toLowerCase(), (t) => Dg(t) === e), kg = (e) => (t) => typeof t === e, { isArray: hd } = Array, J0 = kg("undefined");
function wj(e) {
  return e !== null && !J0(e) && e.constructor !== null && !J0(e.constructor) && ii(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const m8 = Gi("ArrayBuffer");
function Sj(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && m8(e.buffer), t;
}
const _j = kg("string"), ii = kg("function"), g8 = kg("number"), Mg = (e) => e !== null && typeof e == "object", Cj = (e) => e === !0 || e === !1, $v = (e) => {
  if (Dg(e) !== "object")
    return !1;
  const t = D_(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Ej = Gi("Date"), Tj = Gi("File"), $j = Gi("Blob"), Oj = Gi("FileList"), Aj = (e) => Mg(e) && ii(e.pipe), Ij = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || ii(e.append) && ((t = Dg(e)) === "formdata" || // detect form-data instance
  t === "object" && ii(e.toString) && e.toString() === "[object FormData]"));
}, Pj = Gi("URLSearchParams"), [Dj, kj, Mj, Rj] = ["ReadableStream", "Request", "Response", "Headers"].map(Gi), Nj = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Mp(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, a;
  if (typeof e != "object" && (e = [e]), hd(e))
    for (r = 0, a = e.length; r < a; r++)
      t.call(null, e[r], r, e);
  else {
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
    let s;
    for (r = 0; r < i; r++)
      s = o[r], t.call(null, e[s], s, e);
  }
}
function y8(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, a;
  for (; r-- > 0; )
    if (a = n[r], t === a.toLowerCase())
      return a;
  return null;
}
const x8 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, b8 = (e) => !J0(e) && e !== x8;
function bb() {
  const { caseless: e } = b8(this) && this || {}, t = {}, n = (r, a) => {
    const o = e && y8(t, a) || a;
    $v(t[o]) && $v(r) ? t[o] = bb(t[o], r) : $v(r) ? t[o] = bb({}, r) : hd(r) ? t[o] = r.slice() : t[o] = r;
  };
  for (let r = 0, a = arguments.length; r < a; r++)
    arguments[r] && Mp(arguments[r], n);
  return t;
}
const Fj = (e, t, n, { allOwnKeys: r } = {}) => (Mp(t, (a, o) => {
  n && ii(a) ? e[o] = v8(a, n) : e[o] = a;
}, { allOwnKeys: r }), e), Lj = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Bj = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Hj = (e, t, n, r) => {
  let a, o, i;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      i = a[o], (!r || r(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = n !== !1 && D_(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, jj = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, Vj = (e) => {
  if (!e) return null;
  if (hd(e)) return e;
  let t = e.length;
  if (!g8(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Uj = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && D_(Uint8Array)), zj = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let a;
  for (; (a = r.next()) && !a.done; ) {
    const o = a.value;
    t.call(e, o[0], o[1]);
  }
}, Wj = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Gj = Gi("HTMLFormElement"), Kj = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, a) {
    return r.toUpperCase() + a;
  }
), E3 = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Yj = Gi("RegExp"), w8 = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Mp(n, (a, o) => {
    let i;
    (i = t(a, o, e)) !== !1 && (r[o] = i || a);
  }), Object.defineProperties(e, r);
}, qj = (e) => {
  w8(e, (t, n) => {
    if (ii(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (ii(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Xj = (e, t) => {
  const n = {}, r = (a) => {
    a.forEach((o) => {
      n[o] = !0;
    });
  };
  return hd(e) ? r(e) : r(String(e).split(t)), n;
}, Zj = () => {
}, Qj = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, uy = "abcdefghijklmnopqrstuvwxyz", T3 = "0123456789", S8 = {
  DIGIT: T3,
  ALPHA: uy,
  ALPHA_DIGIT: uy + uy.toUpperCase() + T3
}, Jj = (e = 16, t = S8.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function eV(e) {
  return !!(e && ii(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const tV = (e) => {
  const t = new Array(10), n = (r, a) => {
    if (Mg(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[a] = r;
        const o = hd(r) ? [] : {};
        return Mp(r, (i, s) => {
          const l = n(i, a + 1);
          !J0(l) && (o[s] = l);
        }), t[a] = void 0, o;
      }
    }
    return r;
  };
  return n(e, 0);
}, nV = Gi("AsyncFunction"), rV = (e) => e && (Mg(e) || ii(e)) && ii(e.then) && ii(e.catch), ze = {
  isArray: hd,
  isArrayBuffer: m8,
  isBuffer: wj,
  isFormData: Ij,
  isArrayBufferView: Sj,
  isString: _j,
  isNumber: g8,
  isBoolean: Cj,
  isObject: Mg,
  isPlainObject: $v,
  isReadableStream: Dj,
  isRequest: kj,
  isResponse: Mj,
  isHeaders: Rj,
  isUndefined: J0,
  isDate: Ej,
  isFile: Tj,
  isBlob: $j,
  isRegExp: Yj,
  isFunction: ii,
  isStream: Aj,
  isURLSearchParams: Pj,
  isTypedArray: Uj,
  isFileList: Oj,
  forEach: Mp,
  merge: bb,
  extend: Fj,
  trim: Nj,
  stripBOM: Lj,
  inherits: Bj,
  toFlatObject: Hj,
  kindOf: Dg,
  kindOfTest: Gi,
  endsWith: jj,
  toArray: Vj,
  forEachEntry: zj,
  matchAll: Wj,
  isHTMLForm: Gj,
  hasOwnProperty: E3,
  hasOwnProp: E3,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: w8,
  freezeMethods: qj,
  toObjectSet: Xj,
  toCamelCase: Kj,
  noop: Zj,
  toFiniteNumber: Qj,
  findKey: y8,
  global: x8,
  isContextDefined: b8,
  ALPHABET: S8,
  generateString: Jj,
  isSpecCompliantForm: eV,
  toJSONObject: tV,
  isAsyncFn: nV,
  isThenable: rV
};
function Qt(e, t, n, r, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), a && (this.response = a);
}
ze.inherits(Qt, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ze.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const _8 = Qt.prototype, C8 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  C8[e] = { value: e };
});
Object.defineProperties(Qt, C8);
Object.defineProperty(_8, "isAxiosError", { value: !0 });
Qt.from = (e, t, n, r, a, o) => {
  const i = Object.create(_8);
  return ze.toFlatObject(e, i, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), Qt.call(i, e.message, t, n, r, a), i.cause = e, i.name = e.name, o && Object.assign(i, o), i;
};
const aV = null;
function wb(e) {
  return ze.isPlainObject(e) || ze.isArray(e);
}
function E8(e) {
  return ze.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function $3(e, t, n) {
  return e ? e.concat(t).map(function(a, o) {
    return a = E8(a), !n && o ? "[" + a + "]" : a;
  }).join(n ? "." : "") : t;
}
function oV(e) {
  return ze.isArray(e) && !e.some(wb);
}
const iV = ze.toFlatObject(ze, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Rg(e, t, n) {
  if (!ze.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = ze.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, m) {
    return !ze.isUndefined(m[h]);
  });
  const r = n.metaTokens, a = n.visitor || c, o = n.dots, i = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && ze.isSpecCompliantForm(t);
  if (!ze.isFunction(a))
    throw new TypeError("visitor must be a function");
  function u(v) {
    if (v === null) return "";
    if (ze.isDate(v))
      return v.toISOString();
    if (!l && ze.isBlob(v))
      throw new Qt("Blob is not supported. Use a Buffer instead.");
    return ze.isArrayBuffer(v) || ze.isTypedArray(v) ? l && typeof Blob == "function" ? new Blob([v]) : Buffer.from(v) : v;
  }
  function c(v, h, m) {
    let y = v;
    if (v && !m && typeof v == "object") {
      if (ze.endsWith(h, "{}"))
        h = r ? h : h.slice(0, -2), v = JSON.stringify(v);
      else if (ze.isArray(v) && oV(v) || (ze.isFileList(v) || ze.endsWith(h, "[]")) && (y = ze.toArray(v)))
        return h = E8(h), y.forEach(function(g, S) {
          !(ze.isUndefined(g) || g === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? $3([h], S, o) : i === null ? h : h + "[]",
            u(g)
          );
        }), !1;
    }
    return wb(v) ? !0 : (t.append($3(m, h, o), u(v)), !1);
  }
  const f = [], d = Object.assign(iV, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: wb
  });
  function p(v, h) {
    if (!ze.isUndefined(v)) {
      if (f.indexOf(v) !== -1)
        throw Error("Circular reference detected in " + h.join("."));
      f.push(v), ze.forEach(v, function(y, x) {
        (!(ze.isUndefined(y) || y === null) && a.call(
          t,
          y,
          ze.isString(x) ? x.trim() : x,
          h,
          d
        )) === !0 && p(y, h ? h.concat(x) : [x]);
      }), f.pop();
    }
  }
  if (!ze.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), t;
}
function O3(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function k_(e, t) {
  this._pairs = [], e && Rg(e, this, t);
}
const T8 = k_.prototype;
T8.append = function(t, n) {
  this._pairs.push([t, n]);
};
T8.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, O3);
  } : O3;
  return this._pairs.map(function(a) {
    return n(a[0]) + "=" + n(a[1]);
  }, "").join("&");
};
function sV(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $8(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || sV, a = n && n.serialize;
  let o;
  if (a ? o = a(t, n) : o = ze.isURLSearchParams(t) ? t.toString() : new k_(t, n).toString(r), o) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class A3 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    ze.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const O8 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, lV = typeof URLSearchParams < "u" ? URLSearchParams : k_, uV = typeof FormData < "u" ? FormData : null, cV = typeof Blob < "u" ? Blob : null, fV = {
  isBrowser: !0,
  classes: {
    URLSearchParams: lV,
    FormData: uV,
    Blob: cV
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, M_ = typeof window < "u" && typeof document < "u", dV = ((e) => M_ && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), pV = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", hV = M_ && window.location.href || "http://localhost", vV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: M_,
  hasStandardBrowserEnv: dV,
  hasStandardBrowserWebWorkerEnv: pV,
  origin: hV
}, Symbol.toStringTag, { value: "Module" })), Hi = {
  ...vV,
  ...fV
};
function mV(e, t) {
  return Rg(e, new Hi.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, a, o) {
      return Hi.isNode && ze.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function gV(e) {
  return ze.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function yV(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const a = n.length;
  let o;
  for (r = 0; r < a; r++)
    o = n[r], t[o] = e[o];
  return t;
}
function A8(e) {
  function t(n, r, a, o) {
    let i = n[o++];
    if (i === "__proto__") return !0;
    const s = Number.isFinite(+i), l = o >= n.length;
    return i = !i && ze.isArray(a) ? a.length : i, l ? (ze.hasOwnProp(a, i) ? a[i] = [a[i], r] : a[i] = r, !s) : ((!a[i] || !ze.isObject(a[i])) && (a[i] = []), t(n, r, a[i], o) && ze.isArray(a[i]) && (a[i] = yV(a[i])), !s);
  }
  if (ze.isFormData(e) && ze.isFunction(e.entries)) {
    const n = {};
    return ze.forEachEntry(e, (r, a) => {
      t(gV(r), a, n, 0);
    }), n;
  }
  return null;
}
function xV(e, t, n) {
  if (ze.isString(e))
    try {
      return (t || JSON.parse)(e), ze.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const Rp = {
  transitional: O8,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", a = r.indexOf("application/json") > -1, o = ze.isObject(t);
    if (o && ze.isHTMLForm(t) && (t = new FormData(t)), ze.isFormData(t))
      return a ? JSON.stringify(A8(t)) : t;
    if (ze.isArrayBuffer(t) || ze.isBuffer(t) || ze.isStream(t) || ze.isFile(t) || ze.isBlob(t) || ze.isReadableStream(t))
      return t;
    if (ze.isArrayBufferView(t))
      return t.buffer;
    if (ze.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (o) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return mV(t, this.formSerializer).toString();
      if ((s = ze.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Rg(
          s ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return o || a ? (n.setContentType("application/json", !1), xV(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Rp.transitional, r = n && n.forcedJSONParsing, a = this.responseType === "json";
    if (ze.isResponse(t) || ze.isReadableStream(t))
      return t;
    if (t && ze.isString(t) && (r && !this.responseType || a)) {
      const i = !(n && n.silentJSONParsing) && a;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (i)
          throw s.name === "SyntaxError" ? Qt.from(s, Qt.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Hi.classes.FormData,
    Blob: Hi.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ze.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Rp.headers[e] = {};
});
const bV = ze.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), wV = (e) => {
  const t = {};
  let n, r, a;
  return e && e.split(`
`).forEach(function(i) {
    a = i.indexOf(":"), n = i.substring(0, a).trim().toLowerCase(), r = i.substring(a + 1).trim(), !(!n || t[n] && bV[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, I3 = Symbol("internals");
function Nd(e) {
  return e && String(e).trim().toLowerCase();
}
function Ov(e) {
  return e === !1 || e == null ? e : ze.isArray(e) ? e.map(Ov) : String(e);
}
function SV(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const _V = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function cy(e, t, n, r, a) {
  if (ze.isFunction(r))
    return r.call(this, t, n);
  if (a && (t = n), !!ze.isString(t)) {
    if (ze.isString(r))
      return t.indexOf(r) !== -1;
    if (ze.isRegExp(r))
      return r.test(t);
  }
}
function CV(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function EV(e, t) {
  const n = ze.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(a, o, i) {
        return this[r].call(this, t, a, o, i);
      },
      configurable: !0
    });
  });
}
class so {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const a = this;
    function o(s, l, u) {
      const c = Nd(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const f = ze.findKey(a, c);
      (!f || a[f] === void 0 || u === !0 || u === void 0 && a[f] !== !1) && (a[f || l] = Ov(s));
    }
    const i = (s, l) => ze.forEach(s, (u, c) => o(u, c, l));
    if (ze.isPlainObject(t) || t instanceof this.constructor)
      i(t, n);
    else if (ze.isString(t) && (t = t.trim()) && !_V(t))
      i(wV(t), n);
    else if (ze.isHeaders(t))
      for (const [s, l] of t.entries())
        o(l, s, r);
    else
      t != null && o(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = Nd(t), t) {
      const r = ze.findKey(this, t);
      if (r) {
        const a = this[r];
        if (!n)
          return a;
        if (n === !0)
          return SV(a);
        if (ze.isFunction(n))
          return n.call(this, a, r);
        if (ze.isRegExp(n))
          return n.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Nd(t), t) {
      const r = ze.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || cy(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let a = !1;
    function o(i) {
      if (i = Nd(i), i) {
        const s = ze.findKey(r, i);
        s && (!n || cy(r, r[s], s, n)) && (delete r[s], a = !0);
      }
    }
    return ze.isArray(t) ? t.forEach(o) : o(t), a;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, a = !1;
    for (; r--; ) {
      const o = n[r];
      (!t || cy(this, this[o], o, t, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(t) {
    const n = this, r = {};
    return ze.forEach(this, (a, o) => {
      const i = ze.findKey(r, o);
      if (i) {
        n[i] = Ov(a), delete n[o];
        return;
      }
      const s = t ? CV(o) : String(o).trim();
      s !== o && delete n[o], n[s] = Ov(a), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return ze.forEach(this, (r, a) => {
      r != null && r !== !1 && (n[a] = t && ze.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((a) => r.set(a)), r;
  }
  static accessor(t) {
    const r = (this[I3] = this[I3] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(i) {
      const s = Nd(i);
      r[s] || (EV(a, i), r[s] = !0);
    }
    return ze.isArray(t) ? t.forEach(o) : o(t), this;
  }
}
so.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ze.reduceDescriptors(so.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
ze.freezeMethods(so);
function fy(e, t) {
  const n = this || Rp, r = t || n, a = so.from(r.headers);
  let o = r.data;
  return ze.forEach(e, function(s) {
    o = s.call(n, o, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), o;
}
function I8(e) {
  return !!(e && e.__CANCEL__);
}
function vd(e, t, n) {
  Qt.call(this, e ?? "canceled", Qt.ERR_CANCELED, t, n), this.name = "CanceledError";
}
ze.inherits(vd, Qt, {
  __CANCEL__: !0
});
function P8(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new Qt(
    "Request failed with status code " + n.status,
    [Qt.ERR_BAD_REQUEST, Qt.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function TV(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function $V(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let a = 0, o = 0, i;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const u = Date.now(), c = r[o];
    i || (i = u), n[a] = l, r[a] = u;
    let f = o, d = 0;
    for (; f !== a; )
      d += n[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), u - i < t)
      return;
    const p = c && u - c;
    return p ? Math.round(d * 1e3 / p) : void 0;
  };
}
function OV(e, t) {
  let n = 0;
  const r = 1e3 / t;
  let a = null;
  return function() {
    const i = this === !0, s = Date.now();
    if (i || s - n > r)
      return a && (clearTimeout(a), a = null), n = s, e.apply(null, arguments);
    a || (a = setTimeout(() => (a = null, n = Date.now(), e.apply(null, arguments)), r - (s - n)));
  };
}
const dm = (e, t, n = 3) => {
  let r = 0;
  const a = $V(50, 250);
  return OV((o) => {
    const i = o.loaded, s = o.lengthComputable ? o.total : void 0, l = i - r, u = a(l), c = i <= s;
    r = i;
    const f = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: u || void 0,
      estimated: u && s && c ? (s - i) / u : void 0,
      event: o,
      lengthComputable: s != null
    };
    f[t ? "download" : "upload"] = !0, e(f);
  }, n);
}, AV = Hi.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function a(o) {
      let i = o;
      return t && (n.setAttribute("href", i), i = n.href), n.setAttribute("href", i), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = a(window.location.href), function(i) {
      const s = ze.isString(i) ? a(i) : i;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), IV = Hi.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, a, o) {
      const i = [e + "=" + encodeURIComponent(t)];
      ze.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), ze.isString(r) && i.push("path=" + r), ze.isString(a) && i.push("domain=" + a), o === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function PV(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function DV(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function D8(e, t) {
  return e && !PV(t) ? DV(e, t) : t;
}
const P3 = (e) => e instanceof so ? { ...e } : e;
function cc(e, t) {
  t = t || {};
  const n = {};
  function r(u, c, f) {
    return ze.isPlainObject(u) && ze.isPlainObject(c) ? ze.merge.call({ caseless: f }, u, c) : ze.isPlainObject(c) ? ze.merge({}, c) : ze.isArray(c) ? c.slice() : c;
  }
  function a(u, c, f) {
    if (ze.isUndefined(c)) {
      if (!ze.isUndefined(u))
        return r(void 0, u, f);
    } else return r(u, c, f);
  }
  function o(u, c) {
    if (!ze.isUndefined(c))
      return r(void 0, c);
  }
  function i(u, c) {
    if (ze.isUndefined(c)) {
      if (!ze.isUndefined(u))
        return r(void 0, u);
    } else return r(void 0, c);
  }
  function s(u, c, f) {
    if (f in t)
      return r(u, c);
    if (f in e)
      return r(void 0, u);
  }
  const l = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (u, c) => a(P3(u), P3(c), !0)
  };
  return ze.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const f = l[c] || a, d = f(e[c], t[c], c);
    ze.isUndefined(d) && f !== s || (n[c] = d);
  }), n;
}
const k8 = (e) => {
  const t = cc({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: a, xsrfCookieName: o, headers: i, auth: s } = t;
  t.headers = i = so.from(i), t.url = $8(D8(t.baseURL, t.url), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (ze.isFormData(n)) {
    if (Hi.hasStandardBrowserEnv || Hi.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((l = i.getContentType()) !== !1) {
      const [u, ...c] = l ? l.split(";").map((f) => f.trim()).filter(Boolean) : [];
      i.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if (Hi.hasStandardBrowserEnv && (r && ze.isFunction(r) && (r = r(t)), r || r !== !1 && AV(t.url))) {
    const u = a && o && IV.read(o);
    u && i.set(a, u);
  }
  return t;
}, kV = typeof XMLHttpRequest < "u", MV = kV && function(e) {
  return new Promise(function(n, r) {
    const a = k8(e);
    let o = a.data;
    const i = so.from(a.headers).normalize();
    let { responseType: s } = a, l;
    function u() {
      a.cancelToken && a.cancelToken.unsubscribe(l), a.signal && a.signal.removeEventListener("abort", l);
    }
    let c = new XMLHttpRequest();
    c.open(a.method.toUpperCase(), a.url, !0), c.timeout = a.timeout;
    function f() {
      if (!c)
        return;
      const p = so.from(
        "getAllResponseHeaders" in c && c.getAllResponseHeaders()
      ), h = {
        data: !s || s === "text" || s === "json" ? c.responseText : c.response,
        status: c.status,
        statusText: c.statusText,
        headers: p,
        config: e,
        request: c
      };
      P8(function(y) {
        n(y), u();
      }, function(y) {
        r(y), u();
      }, h), c = null;
    }
    "onloadend" in c ? c.onloadend = f : c.onreadystatechange = function() {
      !c || c.readyState !== 4 || c.status === 0 && !(c.responseURL && c.responseURL.indexOf("file:") === 0) || setTimeout(f);
    }, c.onabort = function() {
      c && (r(new Qt("Request aborted", Qt.ECONNABORTED, a, c)), c = null);
    }, c.onerror = function() {
      r(new Qt("Network Error", Qt.ERR_NETWORK, a, c)), c = null;
    }, c.ontimeout = function() {
      let v = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const h = a.transitional || O8;
      a.timeoutErrorMessage && (v = a.timeoutErrorMessage), r(new Qt(
        v,
        h.clarifyTimeoutError ? Qt.ETIMEDOUT : Qt.ECONNABORTED,
        a,
        c
      )), c = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in c && ze.forEach(i.toJSON(), function(v, h) {
      c.setRequestHeader(h, v);
    }), ze.isUndefined(a.withCredentials) || (c.withCredentials = !!a.withCredentials), s && s !== "json" && (c.responseType = a.responseType), typeof a.onDownloadProgress == "function" && c.addEventListener("progress", dm(a.onDownloadProgress, !0)), typeof a.onUploadProgress == "function" && c.upload && c.upload.addEventListener("progress", dm(a.onUploadProgress)), (a.cancelToken || a.signal) && (l = (p) => {
      c && (r(!p || p.type ? new vd(null, e, c) : p), c.abort(), c = null);
    }, a.cancelToken && a.cancelToken.subscribe(l), a.signal && (a.signal.aborted ? l() : a.signal.addEventListener("abort", l)));
    const d = TV(a.url);
    if (d && Hi.protocols.indexOf(d) === -1) {
      r(new Qt("Unsupported protocol " + d + ":", Qt.ERR_BAD_REQUEST, e));
      return;
    }
    c.send(o || null);
  });
}, RV = (e, t) => {
  let n = new AbortController(), r;
  const a = function(l) {
    if (!r) {
      r = !0, i();
      const u = l instanceof Error ? l : this.reason;
      n.abort(u instanceof Qt ? u : new vd(u instanceof Error ? u.message : u));
    }
  };
  let o = t && setTimeout(() => {
    a(new Qt(`timeout ${t} of ms exceeded`, Qt.ETIMEDOUT));
  }, t);
  const i = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((l) => {
      l && (l.removeEventListener ? l.removeEventListener("abort", a) : l.unsubscribe(a));
    }), e = null);
  };
  e.forEach((l) => l && l.addEventListener && l.addEventListener("abort", a));
  const { signal: s } = n;
  return s.unsubscribe = i, [s, () => {
    o && clearTimeout(o), o = null;
  }];
}, NV = function* (e, t) {
  let n = e.byteLength;
  if (!t || n < t) {
    yield e;
    return;
  }
  let r = 0, a;
  for (; r < n; )
    a = r + t, yield e.slice(r, a), r = a;
}, FV = async function* (e, t, n) {
  for await (const r of e)
    yield* NV(ArrayBuffer.isView(r) ? r : await n(String(r)), t);
}, D3 = (e, t, n, r, a) => {
  const o = FV(e, t, a);
  let i = 0;
  return new ReadableStream({
    type: "bytes",
    async pull(s) {
      const { done: l, value: u } = await o.next();
      if (l) {
        s.close(), r();
        return;
      }
      let c = u.byteLength;
      n && n(i += c), s.enqueue(new Uint8Array(u));
    },
    cancel(s) {
      return r(s), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, k3 = (e, t) => {
  const n = e != null;
  return (r) => setTimeout(() => t({
    lengthComputable: n,
    total: e,
    loaded: r
  }));
}, Ng = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", M8 = Ng && typeof ReadableStream == "function", Sb = Ng && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), LV = M8 && (() => {
  let e = !1;
  const t = new Request(Hi.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
})(), M3 = 64 * 1024, _b = M8 && !!(() => {
  try {
    return ze.isReadableStream(new Response("").body);
  } catch {
  }
})(), pm = {
  stream: _b && ((e) => e.body)
};
Ng && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !pm[t] && (pm[t] = ze.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new Qt(`Response type '${t}' is not supported`, Qt.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const BV = async (e) => {
  if (e == null)
    return 0;
  if (ze.isBlob(e))
    return e.size;
  if (ze.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (ze.isArrayBufferView(e))
    return e.byteLength;
  if (ze.isURLSearchParams(e) && (e = e + ""), ze.isString(e))
    return (await Sb(e)).byteLength;
}, HV = async (e, t) => {
  const n = ze.toFiniteNumber(e.getContentLength());
  return n ?? BV(t);
}, jV = Ng && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: a,
    cancelToken: o,
    timeout: i,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: u,
    headers: c,
    withCredentials: f = "same-origin",
    fetchOptions: d
  } = k8(e);
  u = u ? (u + "").toLowerCase() : "text";
  let [p, v] = a || o || i ? RV([a, o], i) : [], h, m;
  const y = () => {
    !h && setTimeout(() => {
      p && p.unsubscribe();
    }), h = !0;
  };
  let x;
  try {
    if (l && LV && n !== "get" && n !== "head" && (x = await HV(c, r)) !== 0) {
      let _ = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), b;
      ze.isFormData(r) && (b = _.headers.get("content-type")) && c.setContentType(b), _.body && (r = D3(_.body, M3, k3(
        x,
        dm(l)
      ), null, Sb));
    }
    ze.isString(f) || (f = f ? "cors" : "omit"), m = new Request(t, {
      ...d,
      signal: p,
      method: n.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: r,
      duplex: "half",
      withCredentials: f
    });
    let g = await fetch(m);
    const S = _b && (u === "stream" || u === "response");
    if (_b && (s || S)) {
      const _ = {};
      ["status", "statusText", "headers"].forEach((E) => {
        _[E] = g[E];
      });
      const b = ze.toFiniteNumber(g.headers.get("content-length"));
      g = new Response(
        D3(g.body, M3, s && k3(
          b,
          dm(s, !0)
        ), S && y, Sb),
        _
      );
    }
    u = u || "text";
    let w = await pm[ze.findKey(pm, u) || "text"](g, e);
    return !S && y(), v && v(), await new Promise((_, b) => {
      P8(_, b, {
        data: w,
        headers: so.from(g.headers),
        status: g.status,
        statusText: g.statusText,
        config: e,
        request: m
      });
    });
  } catch (g) {
    throw y(), g && g.name === "TypeError" && /fetch/i.test(g.message) ? Object.assign(
      new Qt("Network Error", Qt.ERR_NETWORK, e, m),
      {
        cause: g.cause || g
      }
    ) : Qt.from(g, g && g.code, e, m);
  }
}), Cb = {
  http: aV,
  xhr: MV,
  fetch: jV
};
ze.forEach(Cb, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const R3 = (e) => `- ${e}`, VV = (e) => ze.isFunction(e) || e === null || e === !1, R8 = {
  getAdapter: (e) => {
    e = ze.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const a = {};
    for (let o = 0; o < t; o++) {
      n = e[o];
      let i;
      if (r = n, !VV(n) && (r = Cb[(i = String(n)).toLowerCase()], r === void 0))
        throw new Qt(`Unknown adapter '${i}'`);
      if (r)
        break;
      a[i || "#" + o] = r;
    }
    if (!r) {
      const o = Object.entries(a).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? o.length > 1 ? `since :
` + o.map(R3).join(`
`) : " " + R3(o[0]) : "as no adapter specified";
      throw new Qt(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Cb
};
function dy(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new vd(null, e);
}
function N3(e) {
  return dy(e), e.headers = so.from(e.headers), e.data = fy.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), R8.getAdapter(e.adapter || Rp.adapter)(e).then(function(r) {
    return dy(e), r.data = fy.call(
      e,
      e.transformResponse,
      r
    ), r.headers = so.from(r.headers), r;
  }, function(r) {
    return I8(r) || (dy(e), r && r.response && (r.response.data = fy.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = so.from(r.response.headers))), Promise.reject(r);
  });
}
const N8 = "1.7.2", R_ = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  R_[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const F3 = {};
R_.transitional = function(t, n, r) {
  function a(o, i) {
    return "[Axios v" + N8 + "] Transitional option '" + o + "'" + i + (r ? ". " + r : "");
  }
  return (o, i, s) => {
    if (t === !1)
      throw new Qt(
        a(i, " has been removed" + (n ? " in " + n : "")),
        Qt.ERR_DEPRECATED
      );
    return n && !F3[i] && (F3[i] = !0, console.warn(
      a(
        i,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(o, i, s) : !0;
  };
};
function UV(e, t, n) {
  if (typeof e != "object")
    throw new Qt("options must be an object", Qt.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let a = r.length;
  for (; a-- > 0; ) {
    const o = r[a], i = t[o];
    if (i) {
      const s = e[o], l = s === void 0 || i(s, o, e);
      if (l !== !0)
        throw new Qt("option " + o + " must be " + l, Qt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new Qt("Unknown option " + o, Qt.ERR_BAD_OPTION);
  }
}
const Eb = {
  assertOptions: UV,
  validators: R_
}, bl = Eb.validators;
class Ku {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new A3(),
      response: new A3()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let a;
        Error.captureStackTrace ? Error.captureStackTrace(a = {}) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? o && !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + o) : r.stack = o;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = cc(this.defaults, n);
    const { transitional: r, paramsSerializer: a, headers: o } = n;
    r !== void 0 && Eb.assertOptions(r, {
      silentJSONParsing: bl.transitional(bl.boolean),
      forcedJSONParsing: bl.transitional(bl.boolean),
      clarifyTimeoutError: bl.transitional(bl.boolean)
    }, !1), a != null && (ze.isFunction(a) ? n.paramsSerializer = {
      serialize: a
    } : Eb.assertOptions(a, {
      encode: bl.function,
      serialize: bl.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = o && ze.merge(
      o.common,
      o[n.method]
    );
    o && ze.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (v) => {
        delete o[v];
      }
    ), n.headers = so.concat(i, o);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(n) === !1 || (l = l && h.synchronous, s.unshift(h.fulfilled, h.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(h) {
      u.push(h.fulfilled, h.rejected);
    });
    let c, f = 0, d;
    if (!l) {
      const v = [N3.bind(this), void 0];
      for (v.unshift.apply(v, s), v.push.apply(v, u), d = v.length, c = Promise.resolve(n); f < d; )
        c = c.then(v[f++], v[f++]);
      return c;
    }
    d = s.length;
    let p = n;
    for (f = 0; f < d; ) {
      const v = s[f++], h = s[f++];
      try {
        p = v(p);
      } catch (m) {
        h.call(this, m);
        break;
      }
    }
    try {
      c = N3.call(this, p);
    } catch (v) {
      return Promise.reject(v);
    }
    for (f = 0, d = u.length; f < d; )
      c = c.then(u[f++], u[f++]);
    return c;
  }
  getUri(t) {
    t = cc(this.defaults, t);
    const n = D8(t.baseURL, t.url);
    return $8(n, t.params, t.paramsSerializer);
  }
}
ze.forEach(["delete", "get", "head", "options"], function(t) {
  Ku.prototype[t] = function(n, r) {
    return this.request(cc(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
ze.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(o, i, s) {
      return this.request(cc(s || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: i
      }));
    };
  }
  Ku.prototype[t] = n(), Ku.prototype[t + "Form"] = n(!0);
});
class N_ {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const r = this;
    this.promise.then((a) => {
      if (!r._listeners) return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](a);
      r._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const i = new Promise((s) => {
        r.subscribe(s), o = s;
      }).then(a);
      return i.cancel = function() {
        r.unsubscribe(o);
      }, i;
    }, t(function(o, i, s) {
      r.reason || (r.reason = new vd(o, i, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new N_(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
}
function zV(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function WV(e) {
  return ze.isObject(e) && e.isAxiosError === !0;
}
const Tb = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Tb).forEach(([e, t]) => {
  Tb[t] = e;
});
function F8(e) {
  const t = new Ku(e), n = v8(Ku.prototype.request, t);
  return ze.extend(n, Ku.prototype, t, { allOwnKeys: !0 }), ze.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(a) {
    return F8(cc(e, a));
  }, n;
}
const lr = F8(Rp);
lr.Axios = Ku;
lr.CanceledError = vd;
lr.CancelToken = N_;
lr.isCancel = I8;
lr.VERSION = N8;
lr.toFormData = Rg;
lr.AxiosError = Qt;
lr.Cancel = lr.CanceledError;
lr.all = function(t) {
  return Promise.all(t);
};
lr.spread = zV;
lr.isAxiosError = WV;
lr.mergeConfig = cc;
lr.AxiosHeaders = so;
lr.formToJSON = (e) => A8(ze.isHTMLForm(e) ? new FormData(e) : e);
lr.getAdapter = R8.getAdapter;
lr.HttpStatusCode = Tb;
lr.default = lr;
class GV {
  constructor({
    securityWorker: t,
    secure: n,
    format: r,
    ...a
  } = {}) {
    ln(this, "instance");
    ln(this, "securityData", null);
    ln(this, "securityWorker");
    ln(this, "secure");
    ln(this, "format");
    ln(this, "setSecurityData", (t) => {
      this.securityData = t;
    });
    ln(this, "request", async ({
      secure: t,
      path: n,
      type: r,
      query: a,
      format: o,
      wrapped: i,
      body: s,
      ...l
    }) => {
      const u = (typeof t == "boolean" ? t : this.secure) && this.securityWorker && await this.securityWorker(this.securityData) || {}, c = this.mergeRequestParams(l, u), f = o || this.format || void 0;
      return r === "multipart/form-data" && s && s !== null && typeof s == "object" && (s = this.createFormData(s)), r === "text/plain" && s && s !== null && typeof s != "string" && (s = JSON.stringify(s)), this.instance.request({
        ...c,
        headers: {
          ...c.headers || {},
          ...r && r !== "multipart/form-data" ? { "Content-Type": r } : {}
        },
        params: a,
        responseType: f,
        data: s,
        url: n
      }).then((d) => i ? d : d.data);
    });
    this.instance = lr.create({
      ...a,
      baseURL: a.baseURL
    }), this.secure = n, this.format = r, this.securityWorker = t;
  }
  mergeRequestParams(t, n) {
    const r = t.method || n && n.method;
    return {
      ...this.instance.defaults,
      ...t,
      ...n || {},
      headers: {
        ...r && this.instance.defaults.headers[r.toLowerCase()] || {},
        ...t.headers || {},
        ...n && n.headers || {}
      }
    };
  }
  stringifyFormItem(t) {
    return typeof t == "object" && t !== null ? JSON.stringify(t) : `${t}`;
  }
  createFormData(t) {
    return Object.keys(t || {}).reduce((n, r) => {
      const a = t[r], o = a instanceof Array ? a : [a];
      for (const i of o) {
        const s = i instanceof Blob || i instanceof File;
        n.append(r, s ? i : this.stringifyFormItem(i));
      }
      return n;
    }, new FormData());
  }
}
class KV extends GV {
  constructor() {
    super(...arguments);
    ln(this, "userProfile", {
      /**
       * @description Update User Profile
       *
       * @tags User profile
       * @name Update
       * @summary Update User Profile
       * @request PATCH:/api/v1/user/profile
       * @response `200` `UserType`
       */
      update: (n, r = {}) => this.request({
        path: "/api/v1/user/profile",
        method: "PATCH",
        body: n,
        type: "application/json",
        ...r
      })
    });
    ln(this, "auth", {
      /**
       * @description Create a new user with provided email and password and first user is marked as super admin.
       *
       * @tags Auth
       * @name Signup
       * @summary Signup
       * @request POST:/api/v1/auth/user/signup
       * @response `200` `{
        \**
         * The signed JWT token for information exchange
         * @example eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6IndAbm9jb2RiLmNvbSIsImZpcnN0bmFtZSI6bnVsbCwibGFzdG5hbWUiOm51bGwsImlkIjoidXNfYjN4bzJpNDRueDV5OWwiLCJyb2xlcyI6Im9yZy1sZXZlbC1jcmVhdG9yLHN1cGVyIiwidG9rZW5fdmVyc2lvbiI6ImJmMTc3ZGUzYjk3YjAzMjY4YjU0NGZmMjMzNGU5YjFhMGUzYzgxM2NiYzliOTJkYWMwYmM5NTRiNmUzN2ZjMTJjYmFkNDM2NmIwYzExZTdjIiwiaWF0IjoxNjc4MDc4NDMyLCJleHAiOjE2NzgxMTQ0MzJ9.gzwp_svZlbA5PV_eawYV-9UFjZVjniy-tCDce16xrkI
         *\
        token?: string,
      
      }` OK
       * @response `400` `{
        msg?: string,
      
      }` Bad Request
       */
      signup: (n, r = {}) => this.request({
        path: "/api/v1/auth/user/signup",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      }),
      /**
       * @description Clear refresh token from the database and cookie.
       *
       * @tags Auth
       * @name Signout
       * @summary Signout
       * @request POST:/api/v1/auth/user/signout
       * @response `200` `{
        \**
         * Success Message
         * @example Signed out successfully
         *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      signout: (n = {}) => this.request({
        path: "/api/v1/auth/user/signout",
        method: "POST",
        format: "json",
        ...n
      }),
      /**
       * @description Authenticate existing user with their email and password. Successful login will return a JWT access-token.
       *
       * @tags Auth
       * @name Signin
       * @summary Signin
       * @request POST:/api/v1/auth/user/signin
       * @response `200` `{
        \**
         * The signed JWT token for information exchange
         * @example eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6IndAbm9jb2RiLmNvbSIsImZpcnN0bmFtZSI6bnVsbCwibGFzdG5hbWUiOm51bGwsImlkIjoidXNfYjN4bzJpNDRueDV5OWwiLCJyb2xlcyI6Im9yZy1sZXZlbC1jcmVhdG9yLHN1cGVyIiwidG9rZW5fdmVyc2lvbiI6ImJmMTc3ZGUzYjk3YjAzMjY4YjU0NGZmMjMzNGU5YjFhMGUzYzgxM2NiYzliOTJkYWMwYmM5NTRiNmUzN2ZjMTJjYmFkNDM2NmIwYzExZTdjIiwiaWF0IjoxNjc4MDc4NDMyLCJleHAiOjE2NzgxMTQ0MzJ9.gzwp_svZlbA5PV_eawYV-9UFjZVjniy-tCDce16xrkI
         *\
        token?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      signin: (n, r = {}) => this.request({
        path: "/api/v1/auth/user/signin",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      }),
      /**
       * @description Returns authenticated user info
       *
       * @tags Auth
       * @name Me
       * @summary Get User Info
       * @request GET:/api/v1/auth/user/me
       * @response `200` `UserInfoType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      me: (n, r = {}) => this.request({
        path: "/api/v1/auth/user/me",
        method: "GET",
        query: n,
        format: "json",
        ...r
      }),
      /**
       * @description Emails user with a reset url.
       *
       * @tags Auth
       * @name PasswordForgot
       * @summary Forget Password
       * @request POST:/api/v1/auth/password/forgot
       * @response `200` `{
        \**
         * Success Message
         * @example Please check your email to reset the password
         *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      passwordForgot: (n, r = {}) => this.request({
        path: "/api/v1/auth/password/forgot",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      }),
      /**
       * @description Change password of authenticated user with a new one.
       *
       * @tags Auth
       * @name PasswordChange
       * @summary Change Password
       * @request POST:/api/v1/auth/password/change
       * @response `200` `{
        \** Success Message *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      passwordChange: (n, r = {}) => this.request({
        path: "/api/v1/auth/password/change",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      }),
      /**
       * @description Validate password reset url token.
       *
       * @tags Auth
       * @name PasswordResetTokenValidate
       * @summary Verify Reset Token
       * @request POST:/api/v1/auth/token/validate/{token}
       * @response `200` `{
        \**
         * Success Message
         * @example Token has been validated successfully
         *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      passwordResetTokenValidate: (n, r = {}) => this.request({
        path: `/api/v1/auth/token/validate/${n}`,
        method: "POST",
        format: "json",
        ...r
      }),
      /**
       * @description Api for verifying email where token need to be passed which is shared to user email.
       *
       * @tags Auth
       * @name EmailValidate
       * @summary Verify Email
       * @request POST:/api/v1/auth/email/validate/{token}
       * @response `200` `{
        \**
         * Success Message
         * @example Email has been verified successfully
         *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      emailValidate: (n, r = {}) => this.request({
        path: `/api/v1/auth/email/validate/${n}`,
        method: "POST",
        format: "json",
        ...r
      }),
      /**
       * @description Update user password to new by using reset token.
       *
       * @tags Auth
       * @name PasswordReset
       * @summary Reset Password
       * @request POST:/api/v1/auth/password/reset/{token}
       * @response `200` `{
        \**
         * Success Message
         * @example Password has been reset successfully
         *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      passwordReset: (n, r, a = {}) => this.request({
        path: `/api/v1/auth/password/reset/${n}`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Creates a new refresh token and JWT auth token for the user. The refresh token is sent as a cookie, while the JWT auth token is included in the response body.
       *
       * @tags Auth
       * @name TokenRefresh
       * @summary Refresh Token
       * @request POST:/api/v1/auth/token/refresh
       * @response `200` `{
        \**
         * New JWT auth token for user
         * @example 96751db2d53fb834382b682268874a2ea9ee610e4d904e688d1513f11d3c30d62d36d9e05dec0d63
         *\
        token?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      tokenRefresh: (n = {}) => this.request({
        path: "/api/v1/auth/token/refresh",
        method: "POST",
        format: "json",
        ...n
      }),
      /**
       * @description List all users in the given base.
       *
       * @tags Auth
       * @name BaseUserList
       * @summary List Base Users
       * @request GET:/api/v1/db/meta/projects/{baseId}/users
       * @response `200` `{
        users?: {
        list: (UserType)[],
        \** Model for Paginated *\
        pageInfo: PaginatedType,
      
      },
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      baseUserList: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/users`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Create a user and add it to the given base
       *
       * @tags Auth
       * @name BaseUserAdd
       * @summary Create Base User
       * @request POST:/api/v1/db/meta/projects/{baseId}/users
       * @response `200` `{
        \**
         * Success Message for inviting single email
         * @example The user has been invited successfully
         *\
        msg?: string,
        \** @example 8354ddba-a769-4d64-8397-eccb2e2b3c06 *\
        invite_token?: string,
        error?: ({
        \** @example w@nocodb.com *\
        email?: string,
        \** @example <ERROR_MESSAGE> *\
        error?: string,
      
      })[],
        \** @example w@nocodb.com *\
        email?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      baseUserAdd: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/users`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Update a given user in a given base. Exclusive for Super Admin. Access with API Tokens will be blocked.
       *
       * @tags Auth
       * @name BaseUserUpdate
       * @summary Update Base User
       * @request PATCH:/api/v1/db/meta/projects/{baseId}/users/{userId}
       * @response `200` `{
        \**
         * Success Message
         * @example The user has been updated successfully
         *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      baseUserUpdate: (n, r, a, o = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/users/${r}`,
        method: "PATCH",
        body: a,
        type: "application/json",
        format: "json",
        ...o
      }),
      /**
       * @description Delete a given user in a given base. Exclusive for Super Admin. Access with API Tokens will be blocked.
       *
       * @tags Auth
       * @name BaseUserRemove
       * @summary Delete Base User
       * @request DELETE:/api/v1/db/meta/projects/{baseId}/users/{userId}
       * @response `200` `{
        \**
         * Success Message
         * @example The user has been updated successfully
         *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      baseUserRemove: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/users/${r}`,
        method: "DELETE",
        format: "json",
        ...a
      }),
      /**
       * @description Resend Invitation to a specific user
       *
       * @tags Auth
       * @name BaseUserResendInvite
       * @summary Resend User Invitation
       * @request POST:/api/v1/db/meta/projects/{baseId}/users/{userId}/resend-invite
       * @response `200` `{
        \**
         * Success Message
         * @example The invitation has been sent to the user
         *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      baseUserResendInvite: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/users/${r}/resend-invite`,
        method: "POST",
        format: "json",
        ...a
      })
    });
    ln(this, "orgTokens", {
      /**
       * @description List all organisation API tokens.  Access with API tokens will be blocked.
       *
       * @tags Org Tokens
       * @name List
       * @summary List Organisation API Tokens
       * @request GET:/api/v1/tokens
       * @response `200` `ApiTokenListType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      list: (n = {}) => this.request({
        path: "/api/v1/tokens",
        method: "GET",
        format: "json",
        ...n
      }),
      /**
       * @description Creat an organisation API token. Access with API tokens will be blocked.
       *
       * @tags Org Tokens
       * @name Create
       * @summary Create Organisation API Token
       * @request POST:/api/v1/tokens
       * @response `200` `ApiTokenType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      create: (n, r = {}) => this.request({
        path: "/api/v1/tokens",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      }),
      /**
       * @description Delete an organisation API token. Access with API tokens will be blocked.
       *
       * @tags Org Tokens
       * @name Delete
       * @summary Delete Organisation API Tokens
       * @request DELETE:/api/v1/tokens/{token}
       * @response `200` `number` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      delete: (n, r = {}) => this.request({
        path: `/api/v1/tokens/${n}`,
        method: "DELETE",
        format: "json",
        ...r
      })
    });
    ln(this, "orgLicense", {
      /**
       * @description Get the application license key. Exclusive for super admin.
       *
       * @tags Org License
       * @name Get
       * @summary Get App License
       * @request GET:/api/v1/license
       * @response `200` `{
        \** Application license key *\
        key?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      get: (n = {}) => this.request({
        path: "/api/v1/license",
        method: "GET",
        format: "json",
        ...n
      }),
      /**
       * @description Set the application license key. Exclusive for super admin.
       *
       * @tags Org License
       * @name Set
       * @summary Create App License
       * @request POST:/api/v1/license
       * @response `200` `{
        \** @example The license key has been saved *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      set: (n, r = {}) => this.request({
        path: "/api/v1/license",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      })
    });
    ln(this, "orgAppSettings", {
      /**
       * @description Get the application settings. Exclusive for super admin.
       *
       * @tags Org App Settings
       * @name Get
       * @summary Get App Settings
       * @request GET:/api/v1/app-settings
       * @response `200` `{
        \**
         * Status of invite only signup
         * @example true
         *\
        invite_only_signup?: boolean,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      get: (n = {}) => this.request({
        path: "/api/v1/app-settings",
        method: "GET",
        format: "json",
        ...n
      }),
      /**
       * @description Update the application settings. Exclusive for super admin.
       *
       * @tags Org App Settings
       * @name Set
       * @summary Create App Settings
       * @request POST:/api/v1/app-settings
       * @response `200` `{
        \** @example The app settings have been saved *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      set: (n, r = {}) => this.request({
        path: "/api/v1/app-settings",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      })
    });
    ln(this, "orgUsers", {
      /**
       * @description List all organisation users. Exclusive for Super Admin. Access with API Tokens will be blocked.
       *
       * @tags Org Users
       * @name List
       * @summary List Organisation Users
       * @request GET:/api/v1/users
       * @response `200` `UserListType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      list: (n = {}) => this.request({
        path: "/api/v1/users",
        method: "GET",
        format: "json",
        ...n
      }),
      /**
       * @description Create an organisation user. Exclusive for Super Admin. Access with API Tokens will be blocked.
       *
       * @tags Org Users
       * @name Add
       * @summary Create Organisation User
       * @request POST:/api/v1/users
       * @response `200` `{
        \** Invite Token *\
        invite_token?: string,
        \**
         * User email
         * @example user@example.com
         *\
        email?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      add: (n, r = {}) => this.request({
        path: "/api/v1/users",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      }),
      /**
       * @description Update an organisation user by User ID. Exclusive for Super Admin. Access with API Tokens will be blocked.
       *
       * @tags Org Users
       * @name Update
       * @summary Update Organisation User
       * @request PATCH:/api/v1/users/{userId}
       * @response `200` `{
        \** @example The user has been updated successfully *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      update: (n, r, a = {}) => this.request({
        path: `/api/v1/users/${n}`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Delete an organisation user by User ID. Exclusive for Super Admin. Access with API Tokens will be blocked.
       *
       * @tags Org Users
       * @name Delete
       * @summary Delete Organisation User
       * @request DELETE:/api/v1/users/{userId}
       * @response `200` `{
        \**
         * Sucess Message
         * @example The user has been deleted successfully
         *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      delete: (n, r = {}) => this.request({
        path: `/api/v1/users/${n}`,
        method: "DELETE",
        format: "json",
        ...r
      }),
      /**
       * @description Organisation User GetByUsername
       *
       * @tags Org users
       * @name GetByUsername
       * @summary Organisation User GetByUsername
       * @request GET:/api/v1/users/{username}
       * @response `200` `UserType` OK
       */
      getByUsername: (n, r = {}) => this.request({
        path: `/api/v1/users/${n}`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Resend Invitation to a specific user. Exclusive for Super Admin. Access with API Tokens will be blocked.
       *
       * @tags Org Users
       * @name ResendInvite
       * @summary Invite Organisation User
       * @request POST:/api/v1/users/{userId}/resend-invite
       * @response `200` `{
        \**
         * Success Message
         * @example The invitation has been sent to the target user
         *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      resendInvite: (n, r = {}) => this.request({
        path: `/api/v1/users/${n}/resend-invite`,
        method: "POST",
        format: "json",
        ...r
      }),
      /**
       * @description Create Organisation User Profile
       *
       * @tags Org users
       * @name ProfileCreate
       * @summary Organisation User Profile - Create
       * @request POST:/api/v1/users/{userId}/profile
       * @response `200` `void` OK
       */
      profileCreate: (n, r, a = {}) => this.request({
        path: `/api/v1/users/${n}/profile`,
        method: "POST",
        body: r,
        type: "application/json",
        ...a
      }),
      /**
       * @description Get Organisation User Profile
       *
       * @tags Org users
       * @name ProfileGet
       * @summary Organisation User Profile - Get
       * @request GET:/api/v1/users/{userId}/profile
       * @response `200` `void` OK
       */
      profileGet: (n, r = {}) => this.request({
        path: `/api/v1/users/${n}/profile`,
        method: "GET",
        ...r
      }),
      /**
       * @description Update Organisation User Profile
       *
       * @tags Org users
       * @name ProfileUpdate
       * @request PATCH:/api/v1/users/{userId}/profile
       * @response `200` `void` OK
       */
      profileUpdate: (n, r, a = {}) => this.request({
        path: `/api/v1/users/${n}/profile`,
        method: "PATCH",
        body: r,
        type: "application/json",
        ...a
      }),
      /**
       * @description Create Organisation User Follower Relationship (Follow)
       *
       * @tags Org users
       * @name FollowerCreate
       * @summary Organisation User Follower - Create
       * @request POST:/api/v1/users/{userId}/follower
       * @response `200` `void` OK
       */
      followerCreate: (n, r, a = {}) => this.request({
        path: `/api/v1/users/${n}/follower`,
        method: "POST",
        body: r,
        type: "application/json",
        ...a
      }),
      /**
       * @description List Organisation User Followers
       *
       * @tags Org users
       * @name FollowerList
       * @summary Organisation User Follower - List
       * @request GET:/api/v1/users/{userId}/follower
       * @response `200` `void` OK
       */
      followerList: (n, r, a = {}) => this.request({
        path: `/api/v1/users/${n}/follower`,
        method: "GET",
        body: r,
        type: "application/json",
        ...a
      }),
      /**
       * @description Delete Organisation User Follower Relationship (Unfollow)
       *
       * @tags Org users
       * @name FollowerDelete
       * @summary Organisation User Follower - Delete
       * @request DELETE:/api/v1/users/{userId}/follower
       * @response `200` `void` OK
       */
      followerDelete: (n, r, a = {}) => this.request({
        path: `/api/v1/users/${n}/follower`,
        method: "DELETE",
        body: r,
        type: "application/json",
        ...a
      }),
      /**
       * @description List Organisation User Following
       *
       * @tags Org users
       * @name FollowingList
       * @summary Organisation User Following - List
       * @request GET:/api/v1/users/{userId}/following
       * @response `200` `void` OK
       */
      followingList: (n, r = {}) => this.request({
        path: `/api/v1/users/${n}/following`,
        method: "GET",
        ...r
      }),
      /**
       * @description Check if Organisation User is following someone
       *
       * @tags Org users
       * @name IsFollowing
       * @summary Organisation User IsFollowing
       * @request GET:/api/v1/users/{userId}/isFollowing/{followerId}
       * @response `200` `void` OK
       */
      isFollowing: (n, r, a = {}) => this.request({
        path: `/api/v1/users/${n}/isFollowing/${r}`,
        method: "GET",
        ...a
      }),
      /**
       * @description Generate Password Reset Token for Organisation User. Exclusive for Super Admin. Access with API Tokens will be blocked.
       *
       * @tags Org Users
       * @name GeneratePasswordResetToken
       * @summary Generate Organisation User Password Reset Token
       * @request POST:/api/v1/users/{userId}/generate-reset-url
       * @response `200` `{
        \** Password Reset Token for the user *\
        reset_password_token?: string,
        \** Password Reset URL for the user *\
        reset_password_url?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      generatePasswordResetToken: (n, r = {}) => this.request({
        path: `/api/v1/users/${n}/generate-reset-url`,
        method: "POST",
        format: "json",
        ...r
      })
    });
    ln(this, "base", {
      /**
       * @description Get info such as node version, arch, platform, is docker, rootdb and package version of a given base
       *
       * @tags Base
       * @name MetaGet
       * @summary Get Base info
       * @request GET:/api/v1/db/meta/projects/{baseId}/info
       * @response `200` `{
        \**
         * Node version
         * @example v12.16.1
         *\
        Node?: string,
        \**
         * Architecture type
         * @example x64
         *\
        Arch?: string,
        \**
         * Platform type
         * @example linux
         *\
        Platform?: string,
        \**
         * Is docker
         * @example false
         *\
        Docker?: boolean,
        \**
         * Database type
         * @example postgres
         *\
        Database?: string,
        \**
         * Is base on rootdb
         * @example false
         *\
        ProjectOnRootDB?: boolean,
        \**
         * Root database type
         * @example postgres
         *\
        RootDB?: string,
        \**
         * Package version
         * @example 1.0.0
         *\
        PackageVersion?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      metaGet: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/info`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Hide / show views based on user role
       *
       * @tags Base
       * @name ModelVisibilityList
       * @summary Get UI ACL
       * @request GET:/api/v1/db/meta/projects/{baseId}/visibility-rules
       * @response `200` `(any)[]` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      modelVisibilityList: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/visibility-rules`,
        method: "GET",
        query: r,
        format: "json",
        ...a
      }),
      /**
       * @description Hide / show views based on user role
       *
       * @tags Base
       * @name ModelVisibilitySet
       * @summary Create UI ACL
       * @request POST:/api/v1/db/meta/projects/{baseId}/visibility-rules
       * @response `200` `{
        \** @example UI ACL has been created successfully *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      modelVisibilitySet: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/visibility-rules`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description List all base meta data
       *
       * @tags Base
       * @name List
       * @summary List Projects
       * @request GET:/api/v1/db/meta/projects/
       * @response `200` `ProjectListType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      list: (n = {}) => this.request({
        path: "/api/v1/db/meta/projects/",
        method: "GET",
        format: "json",
        ...n
      }),
      /**
       * @description Create a new base
       *
       * @tags Base
       * @name Create
       * @summary Create Base
       * @request POST:/api/v1/db/meta/projects/
       * @response `200` `BaseType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      create: (n, r = {}) => this.request({
        path: "/api/v1/db/meta/projects/",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      }),
      /**
       * @description Duplicate a base
       *
       * @tags Base
       * @name SourceDuplicate
       * @summary Duplicate Base Source
       * @request POST:/api/v1/db/meta/duplicate/{baseId}/{sourceId}
       * @response `200` `{
        name?: string,
        id?: string,
        base_id?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      sourceDuplicate: (n, r, a, o = {}) => this.request({
        path: `/api/v1/db/meta/duplicate/${n}/${a}`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...o
      }),
      /**
       * @description Duplicate a base
       *
       * @tags Base
       * @name Duplicate
       * @summary Duplicate Base
       * @request POST:/api/v1/db/meta/duplicate/{baseId}
       * @response `200` `{
        name?: string,
        id?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      duplicate: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/duplicate/${n}`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Get the info of a given base
       *
       * @tags Base
       * @name Read
       * @summary Get Base
       * @request GET:/api/v1/db/meta/projects/{baseId}
       * @response `200` `BaseType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      read: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Delete the given base
       *
       * @tags Base
       * @name Delete
       * @summary Delete Base
       * @request DELETE:/api/v1/db/meta/projects/{baseId}
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      delete: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}`,
        method: "DELETE",
        format: "json",
        ...r
      }),
      /**
       * @description Update the given base
       *
       * @tags Base
       * @name Update
       * @summary Update Base
       * @request PATCH:/api/v1/db/meta/projects/{baseId}
       * @response `200` `number` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      update: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * No description
       *
       * @tags Base
       * @name UserMetaUpdate
       * @summary Base user meta update
       * @request PATCH:/api/v1/db/meta/projects/{baseId}/user
       * @response `200` `void` OK
       */
      userMetaUpdate: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/user`,
        method: "PATCH",
        body: r,
        type: "application/json",
        ...a
      }),
      /**
       * @description Get Base Shared Base
       *
       * @tags Base
       * @name SharedBaseGet
       * @summary Get Base Shared Base
       * @request GET:/api/v1/db/meta/projects/{baseId}/shared
       * @response `200` `{
        \**
         * @format uuid
         * @example a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11
         *\
        uuid?: string,
        \** @format uri *\
        url?: string,
        \** @example viewer *\
        roles?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      sharedBaseGet: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/shared`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Delete Base Shared Base
       *
       * @tags Base
       * @name SharedBaseDisable
       * @summary Delete Base Shared Base
       * @request DELETE:/api/v1/db/meta/projects/{baseId}/shared
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      sharedBaseDisable: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/shared`,
        method: "DELETE",
        format: "json",
        ...r
      }),
      /**
       * @description Create Base Shared Base
       *
       * @tags Base
       * @name SharedBaseCreate
       * @summary Create Base Shared Base
       * @request POST:/api/v1/db/meta/projects/{baseId}/shared
       * @response `200` `{
        \** Model for StringOrNull *\
        uuid?: StringOrNullType,
        \** Model for StringOrNull *\
        roles?: StringOrNullType,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      sharedBaseCreate: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/shared`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Update Base Shared Base
       *
       * @tags Base
       * @name SharedBaseUpdate
       * @summary Update Base Shared Base
       * @request PATCH:/api/v1/db/meta/projects/{baseId}/shared
       * @response `200` `{
        \**
         * @format uuid
         * @example a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11
         *\
        uuid?: string,
        \** @format uri *\
        url?: string,
        \** @example viewer *\
        roles?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      sharedBaseUpdate: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/shared`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Calculate the Base Cost
       *
       * @tags Base
       * @name Cost
       * @summary Base Cost
       * @request GET:/api/v1/db/meta/projects/{baseId}/cost
       * @response `200` `object` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      cost: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/cost`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Synchronise the meta data difference between NC_DB and external data sources
       *
       * @tags Base
       * @name MetaDiffSync
       * @summary Sync Meta
       * @request POST:/api/v1/db/meta/projects/{baseId}/meta-diff
       * @response `200` `{
        \** @example The meta has been synchronized successfully *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      metaDiffSync: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/meta-diff`,
        method: "POST",
        format: "json",
        ...r
      }),
      /**
       * @description Get the meta data difference between NC_DB and external data sources
       *
       * @tags Base
       * @name MetaDiffGet
       * @summary Meta Diff
       * @request GET:/api/v1/db/meta/projects/{baseId}/meta-diff
       * @response `200` `({
        \**
         * Table Name
         * @example Table 1
         *\
        table_name?: string,
        \**
         * Source ID
         * @example ds_rrplkgy0pq1f3c
         *\
        source_id?: string,
        \**
         * Change Type
         * @example table
         *\
        type?: string,
        \** Detected Changes *\
        detectedChanges?: (object)[],
      
      })[]` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      metaDiffGet: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/meta-diff`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Check if a base contains empty and null filters. Used in `Show NULL and EMPTY in Filter` in Base Setting.
       *
       * @tags Base
       * @name HasEmptyOrNullFilters
       * @summary List Empty & Null Filter
       * @request GET:/api/v1/db/meta/projects/{baseId}/has-empty-or-null-filters
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      hasEmptyOrNullFilters: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/has-empty-or-null-filters`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description List all audit data in the given base
       *
       * @tags Base
       * @name AuditList
       * @summary List Audits in Base
       * @request GET:/api/v1/db/meta/projects/{baseId}/audits
       * @response `200` `{
        list: (AuditType)[],
        \** Model for Paginated *\
        pageInfo: PaginatedType,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      auditList: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/audits`,
        method: "GET",
        query: r,
        format: "json",
        ...a
      })
    });
    ln(this, "source", {
      /**
       * @description Get the source details of a given base
       *
       * @tags Source
       * @name Read
       * @summary Get Source
       * @request GET:/api/v1/db/meta/projects/{baseId}/bases/{sourceId}
       * @response `200` `SourceType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      read: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/bases/${r}`,
        method: "GET",
        format: "json",
        ...a
      }),
      /**
       * @description Delete the source details of a given base
       *
       * @tags Source
       * @name Delete
       * @summary Delete Source
       * @request DELETE:/api/v1/db/meta/projects/{baseId}/bases/{sourceId}
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      delete: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/bases/${r}`,
        method: "DELETE",
        format: "json",
        ...a
      }),
      /**
       * @description Update the source details of a given base
       *
       * @tags Source
       * @name Update
       * @summary Update Source
       * @request PATCH:/api/v1/db/meta/projects/{baseId}/bases/{sourceId}
       * @response `200` `object` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      update: (n, r, a, o = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/bases/${r}`,
        method: "PATCH",
        body: a,
        type: "application/json",
        format: "json",
        ...o
      }),
      /**
       * No description
       *
       * @tags Source
       * @name CreateSqlView
       * @summary Create sql view
       * @request POST:/api/v1/db/meta/projects/:baseId/bases/:sourceId/sqlView
       * @response `200` `object` OK
       */
      createSqlView: (n, r, a, o = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/bases/${r}/sqlView`,
        method: "POST",
        body: a,
        type: "application/json",
        format: "json",
        ...o
      }),
      /**
       * @description Get base source list
       *
       * @tags Source
       * @name List
       * @summary List Sources
       * @request GET:/api/v1/db/meta/projects/{baseId}/bases/
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      list: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/bases/`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Create a new source on a given base
       *
       * @tags Source
       * @name Create
       * @summary Create Source
       * @request POST:/api/v1/db/meta/projects/{baseId}/bases/
       * @response `200` `SourceType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      create: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/bases/`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * No description
       *
       * @tags Source
       * @name ShareErd
       * @summary share ERD view
       * @request POST:/api/v1/db/meta/projects/{baseId}/bases/{sourceId}/share/erd
       * @response `200` `SourceType` OK
       */
      shareErd: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/bases/${r}/share/erd`,
        method: "POST",
        format: "json",
        ...a
      }),
      /**
       * No description
       *
       * @tags Source
       * @name DisableShareErd
       * @request DELETE:/api/v1/db/meta/projects/{baseId}/bases/{sourceId}/share/erd
       * @response `200` `void` OK
       */
      disableShareErd: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/bases/${r}/share/erd`,
        method: "DELETE",
        ...a
      }),
      /**
       * @description List all tables in a given Base and Source
       *
       * @tags Source
       * @name TableList
       * @summary List Tables
       * @request GET:/api/v1/db/meta/projects/{baseId}/{sourceId}/tables
       * @response `200` `TableListType`
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      tableList: (n, r, a, o = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/${r}/tables`,
        method: "GET",
        query: a,
        ...o
      }),
      /**
       * @description Create a new table in a given Base and Source
       *
       * @tags Source
       * @name TableCreate
       * @summary Create Table
       * @request POST:/api/v1/db/meta/projects/{baseId}/{sourceId}/tables
       * @response `200` `TableType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      tableCreate: (n, r, a, o = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/${r}/tables`,
        method: "POST",
        body: a,
        type: "application/json",
        format: "json",
        ...o
      }),
      /**
       * @description Synchronise the meta data difference between NC_DB and external data sources in a given Source
       *
       * @tags Source
       * @name MetaDiffSync
       * @summary Synchronise Source Meta
       * @request POST:/api/v1/db/meta/projects/{baseId}/meta-diff/{sourceId}
       * @response `200` `{
        \** @example The source meta has been synchronized successfully *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      metaDiffSync: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/meta-diff/${r}`,
        method: "POST",
        format: "json",
        ...a
      }),
      /**
       * @description Get the meta data difference between NC_DB and external data sources in a given Source
       *
       * @tags Source
       * @name MetaDiffGet
       * @summary Source Meta Diff
       * @request GET:/api/v1/db/meta/projects/{baseId}/meta-diff/{sourceId}
       * @response `200` `({
        \**
         * Table Name
         * @example Table 1
         *\
        table_name?: string,
        \**
         * Source ID
         * @example ds_rrplkgy0pq1f3c
         *\
        source_id?: string,
        \**
         * Change Type
         * @example table
         *\
        type?: string,
        \** Detected Changes *\
        detectedChanges?: (object)[],
      
      })[]` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      metaDiffGet: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/meta-diff/${r}`,
        method: "GET",
        format: "json",
        ...a
      })
    });
    ln(this, "dbTable", {
      /**
       * @description Create a new table in a given base
       *
       * @tags DB Table
       * @name Create
       * @summary Create Table
       * @request POST:/api/v1/db/meta/projects/{baseId}/tables
       * @response `200` `TableType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      create: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/tables`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description List all tables in a given base
       *
       * @tags DB Table
       * @name List
       * @summary List Tables
       * @request GET:/api/v1/db/meta/projects/{baseId}/tables
       * @response `200` `TableListType`
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      list: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/tables`,
        method: "GET",
        query: r,
        ...a
      }),
      /**
       * @description Read the table meta data by the given table ID
       *
       * @tags DB Table
       * @name Read
       * @summary Read Table
       * @request GET:/api/v1/db/meta/tables/{tableId}
       * @response `200` `TableType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      read: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Update the table meta data by the given table ID
       *
       * @tags DB Table
       * @name Update
       * @summary Update Table
       * @request PATCH:/api/v1/db/meta/tables/{tableId}
       * @response `200` `{
        \** @example The table has been updated successfully *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      update: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Delete the table meta data by the given table ID
       *
       * @tags DB Table
       * @name Delete
       * @summary Delete Table
       * @request DELETE:/api/v1/db/meta/tables/{tableId}
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      delete: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}`,
        method: "DELETE",
        format: "json",
        ...r
      }),
      duplicate: (n, r, a, o = {}) => this.request({
        path: `/api/v1/db/meta/duplicate/${n}/table/${r}`,
        method: "POST",
        body: a,
        type: "application/json",
        format: "json",
        ...o
      }),
      duplicateColumn: (n, r, a, o = {}) => this.request({
        path: `/api/v1/db/meta/duplicate/${n}/column/${r}`,
        method: "POST",
        body: a,
        type: "application/json",
        format: "json",
        ...o
      }),
      /**
       * @description Update the order of the given Table
       *
       * @tags DB Table
       * @name Reorder
       * @summary Reorder Table
       * @request POST:/api/v1/db/meta/tables/{tableId}/reorder
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      reorder: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}/reorder`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      })
    });
    ln(this, "dbTableColumn", {
      /**
       * @description Create a new column in a given Table
       *
       * @tags DB Table Column
       * @name Create
       * @summary Create Column
       * @request POST:/api/v1/db/meta/tables/{tableId}/columns
       * @response `200` `void` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      create: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}/columns`,
        method: "POST",
        body: r,
        type: "application/json",
        ...a
      }),
      /**
       * @description Update the existing column by the given column ID
       *
       * @tags DB Table Column
       * @name Update
       * @summary Update Column
       * @request PATCH:/api/v1/db/meta/columns/{columnId}
       * @response `200` `ColumnType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      update: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/columns/${n}`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Delete the existing column by the given column ID
       *
       * @tags DB Table Column
       * @name Delete
       * @summary Delete Column
       * @request DELETE:/api/v1/db/meta/columns/{columnId}
       * @response `200` `void` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      delete: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/columns/${n}`,
        method: "DELETE",
        ...r
      }),
      /**
       * @description Get the existing column by the given column ID
       *
       * @tags DB Table Column
       * @name Get
       * @summary Get Column
       * @request GET:/api/v1/db/meta/columns/{columnId}
       * @response `200` `void` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      get: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/columns/${n}`,
        method: "GET",
        ...r
      }),
      /**
       * @description Set a primary value on a given column
       *
       * @tags DB Table Column
       * @name PrimaryColumnSet
       * @summary Create Primary Value
       * @request POST:/api/v1/db/meta/columns/{columnId}/primary
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      primaryColumnSet: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/columns/${n}/primary`,
        method: "POST",
        format: "json",
        ...r
      }),
      /**
       * @description Get columns hash for table
       *
       * @tags DB Table Column
       * @name Hash
       * @summary Get columns hash for table
       * @request GET:/api/v1/db/meta/tables/{tableId}/columns/hash
       * @response `200` `{
        \** Columns hash *\
        hash?: string,
      
      }` OK
       */
      hash: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}/columns/hash`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Bulk create-update-delete columns
       *
       * @tags DB Table Column
       * @name Bulk
       * @summary Bulk create-update-delete columns
       * @request POST:/api/v1/db/meta/tables/{tableId}/columns/bulk
       * @response `200` `{
        failedOps?: (any)[],
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      bulk: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}/columns/bulk`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      })
    });
    ln(this, "dbView", {
      /**
       * @description List all views in a given Table.
       *
       * @tags DB View
       * @name List
       * @summary List Views
       * @request GET:/api/v1/db/meta/tables/{tableId}/views
       * @response `200` `ViewListType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      list: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}/views`,
        method: "GET",
        format: "json",
        ...r
      }),
      update: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Delete the view with the given view Id.
       *
       * @tags DB View
       * @name Delete
       * @summary Delete View
       * @request DELETE:/api/v1/db/meta/views/{viewId}
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      delete: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}`,
        method: "DELETE",
        format: "json",
        ...r
      }),
      /**
       * @description Show All Columns in a given View
       *
       * @tags DB View
       * @name ShowAllColumn
       * @summary Show All Columns In View
       * @request POST:/api/v1/db/meta/views/{viewId}/show-all
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      showAllColumn: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}/show-all`,
        method: "POST",
        query: r,
        format: "json",
        ...a
      }),
      /**
       * @description Hide All Columns in a given View
       *
       * @tags DB View
       * @name HideAllColumn
       * @summary Hide All Columns In View
       * @request POST:/api/v1/db/meta/views/{viewId}/hide-all
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      hideAllColumn: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}/hide-all`,
        method: "POST",
        query: r,
        format: "json",
        ...a
      }),
      /**
       * @description Create a new grid view in a given Table
       *
       * @tags DB View
       * @name GridCreate
       * @summary Create Grid View
       * @request POST:/api/v1/db/meta/tables/{tableId}/grids
       * @response `200` `ViewType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      gridCreate: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}/grids`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Create a new form view in a given Table
       *
       * @tags DB View
       * @name FormCreate
       * @summary Create Form View
       * @request POST:/api/v1/db/meta/tables/{tableId}/forms
       * @response `200` `ViewType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      /**
       * @description Update Grid View
       *
       * @tags DB View
       * @name GridUpdate
       * @summary Update Grid View
       * @request PATCH:/api/v1/db/meta/grids/{viewId}
       * @response `200` `number` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      gridUpdate: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/grids/${n}`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description List all columns in the given Grid
       *
       * @tags DB View
       * @name GridColumnsList
       * @summary List Grid Columns
       * @request GET:/api/v1/db/meta/grids/{gridId}/grid-columns
       * @response `200` `(GridColumnType)[]` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      gridColumnsList: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/grids/${n}/grid-columns`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Update grid column(s) in the given Grid
       *
       * @tags DB View
       * @name GridColumnUpdate
       * @summary Update Grid Column
       * @request PATCH:/api/v1/db/meta/grid-columns/{columnId}
       * @response `200` `number` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      gridColumnUpdate: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/grid-columns/${n}`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      })
      /**
       * No description
       *
       * @tags DB View
       * @name GalleryCreate
       * @summary Create Gallery View
       * @request POST:/api/v1/db/meta/tables/{tableId}/galleries
       * @response `200` `ViewType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      /**
       * @description Get the Kanban View data by Kanban ID
       *
       * @tags DB View
       * @name KanbanRead
       * @summary Get Kanban View
       * @request GET:/api/v1/db/meta/kanbans/{kanbanViewId}
       * @response `200` `KanbanType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
    });
    ln(this, "dbViewShare", {
      /**
       * @description List all shared views in a given Table
       *
       * @tags DB View Share
       * @name List
       * @summary List Shared Views
       * @request GET:/api/v1/db/meta/tables/{tableId}/share
       * @response `200` `SharedViewListType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      list: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}/share`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Create a shared view in a given View..
       *
       * @tags DB View Share
       * @name Create
       * @summary Create Shared View
       * @request POST:/api/v1/db/meta/views/{viewId}/share
       * @response `200` `SharedViewReqType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      create: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}/share`,
        method: "POST",
        format: "json",
        ...r
      }),
      /**
       * @description Update a shared view in a given View..
       *
       * @tags DB View Share
       * @name Update
       * @summary Update Shared View
       * @request PATCH:/api/v1/db/meta/views/{viewId}/share
       * @response `200` `SharedViewType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      update: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}/share`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Delete a shared view in a given View.
       *
       * @tags DB View Share
       * @name Delete
       * @summary Delete Shared View
       * @request DELETE:/api/v1/db/meta/views/{viewId}/share
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      delete: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}/share`,
        method: "DELETE",
        format: "json",
        ...r
      })
    });
    ln(this, "dbViewColumn", {
      list: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}/columns`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Create a new column in a given View
       *
       * @tags DB View Column
       * @name Create
       * @summary Create Column in View
       * @request POST:/api/v1/db/meta/views/{viewId}/columns
       * @response `200` `ColumnType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      create: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}/columns`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Update a column in a View
       *
       * @tags DB View Column
       * @name Update
       * @summary Update View Column
       * @request PATCH:/api/v1/db/meta/views/{viewId}/columns/{columnId}
       * @response `200` `number` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      update: (n, r, a, o = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}/columns/${r}`,
        method: "PATCH",
        body: a,
        type: "application/json",
        format: "json",
        ...o
      })
    });
    ln(this, "dbTableSort", {
      list: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}/sorts`,
        method: "GET",
        format: "json",
        ...r
      }),
      create: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}/sorts`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Get the sort data by Sort ID
       *
       * @tags DB Table Sort
       * @name Get
       * @summary Get Sort
       * @request GET:/api/v1/db/meta/sorts/{sortId}
       * @response `200` `SortType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      get: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/sorts/${n}`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Update the sort data by Sort ID
       *
       * @tags DB Table Sort
       * @name Update
       * @summary Update Sort
       * @request PATCH:/api/v1/db/meta/sorts/{sortId}
       * @response `200` `number` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      update: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/sorts/${n}`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Delete the sort data by Sort ID
       *
       * @tags DB Table Sort
       * @name Delete
       * @summary Delete Sort
       * @request DELETE:/api/v1/db/meta/sorts/{sortId}
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      delete: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/sorts/${n}`,
        method: "DELETE",
        format: "json",
        ...r
      })
    });
    ln(this, "dbTableFilter", {
      read: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}/filters`,
        method: "GET",
        format: "json",
        ...r
      }),
      create: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/views/${n}/filters`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Get the filter data with a given Filter ID
       *
       * @tags DB Table Filter
       * @name Get
       * @summary Get Filter
       * @request GET:/api/v1/db/meta/filters/{filterId}
       * @response `200` `FilterType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      get: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/filters/${n}`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Update the filter data with a given Filter ID
       *
       * @tags DB Table Filter
       * @name Update
       * @summary Update Filter
       * @request PATCH:/api/v1/db/meta/filters/{filterId}
       * @response `200` `number` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      update: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/filters/${n}`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Delete the filter data with a given Filter ID
       *
       * @tags DB Table Filter
       * @name Delete
       * @summary Delete Filter
       * @request DELETE:/api/v1/db/meta/filters/{filterId}
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      delete: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/filters/${n}`,
        method: "DELETE",
        format: "json",
        ...r
      }),
      childrenRead: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/filters/${n}/children`,
        method: "GET",
        format: "json",
        ...r
      })
    });
    ln(this, "dbTableWebhookFilter", {
      /**
       * @description Get the filter data in a given Hook
       *
       * @tags DB Table Webhook Filter
       * @name Read
       * @summary Get Hook Filter
       * @request GET:/api/v1/db/meta/hooks/{hookId}/filters
       * @response `200` `FilterListType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      read: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/hooks/${n}/filters`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Create filter(s) in a given Hook
       *
       * @tags DB Table Webhook Filter
       * @name Create
       * @summary Create Hook Filter
       * @request POST:/api/v1/db/meta/hooks/{hookId}/filters
       * @response `200` `FilterType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      create: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/hooks/${n}/filters`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      })
    });
    ln(this, "dbTableWebhookLogs", {
      /**
       * @description List the log data in a given Hook
       *
       * @tags DB Table Webhook Logs
       * @name List
       * @summary List Hook Logs
       * @request GET:/api/v1/db/meta/hooks/{hookId}/logs
       * @response `200` `HookLogListType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      list: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/hooks/${n}/logs`,
        method: "GET",
        query: r,
        format: "json",
        ...a
      })
    });
    ln(this, "dbTableRow", {
      /**
       * @description List all table rows in a given table and base
       *
       * @tags DB Table Row
       * @name List
       * @summary List Table Rows
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}
       * @response `200` `{
        \** List of data objects *\
        list: (object)[],
        \** Paginated Info *\
        pageInfo: PaginatedType,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      list: (n, r, a, o, i = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}`,
        method: "GET",
        query: o,
        format: "json",
        ...i
      }),
      create: (n, r, a, o, i = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}`,
        method: "POST",
        body: o,
        type: "application/json",
        format: "json",
        ...i
      }),
      /**
       * @description Return the first result of the target Table Row
       *
       * @tags DB Table Row
       * @name FindOne
       * @summary Find One Table Row
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}/find-one
       * @response `200` `object` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      findOne: (n, r, a, o, i = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/find-one`,
        method: "GET",
        query: o,
        format: "json",
        ...i
      }),
      /**
       * @description Get the result grouped by the given query
       *
       * @tags DB Table Row
       * @name GroupBy
       * @summary Group By Table Row
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}/groupby
       * @response `200` `any` OK
       */
      groupBy: (n, r, a, o, i = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/groupby`,
        method: "GET",
        query: o,
        format: "json",
        ...i
      }),
      /**
       * @description Get the grouped data By Column ID. Used in Kanban View.
       *
       * @tags DB Table Row
       * @name GroupedDataList
       * @summary Table Group by Column
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}/group/{columnId}
       * @response `200` `(any)[]` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      groupedDataList: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/group/${o}`,
        method: "GET",
        query: i,
        format: "json",
        ...s
      }),
      read: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/${o}`,
        method: "GET",
        query: i,
        format: "json",
        ...s
      }),
      /**
       * @description Update the Table Row
       *
       * @tags DB Table Row
       * @name Update
       * @summary Update Table Row
       * @request PATCH:/api/v1/db/data/{orgs}/{baseName}/{tableName}/{rowId}
       * @response `200` `object` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      update: (n, r, a, o, i, s, l = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/${o}`,
        method: "PATCH",
        query: s,
        body: i,
        type: "application/json",
        format: "json",
        ...l
      }),
      delete: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/${o}`,
        method: "DELETE",
        query: i,
        format: "json",
        ...s
      }),
      /**
       * @description check row with provided primary key exists or not
       *
       * @tags DB Table Row
       * @name Exist
       * @summary Does Table Row Exist
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}/{rowId}/exist
       * @response `200` `number` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      exist: (n, r, a, o, i = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/${o}/exist`,
        method: "GET",
        format: "json",
        ...i
      }),
      bulkCreate: (n, r, a, o, i = {}) => this.request({
        path: `/api/v1/db/data/bulk/${n}/${r}/${a}`,
        method: "POST",
        body: o,
        type: "application/json",
        format: "json",
        ...i
      }),
      bulkUpdate: (n, r, a, o, i = {}) => this.request({
        path: `/api/v1/db/data/bulk/${n}/${r}/${a}`,
        method: "PATCH",
        body: o,
        type: "application/json",
        format: "json",
        ...i
      }),
      bulkDelete: (n, r, a, o, i = {}) => this.request({
        path: `/api/v1/db/data/bulk/${n}/${r}/${a}`,
        method: "DELETE",
        body: o,
        type: "application/json",
        format: "json",
        ...i
      }),
      bulkUpdateAll: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v1/db/data/bulk/${n}/${r}/${a}/all`,
        method: "PATCH",
        query: i,
        body: o,
        type: "application/json",
        format: "json",
        ...s
      }),
      bulkDeleteAll: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v1/db/data/bulk/${n}/${r}/${a}/all`,
        method: "DELETE",
        query: i,
        body: o,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Export Table View Rows by CSV or Excel
       *
       * @tags DB Table Row
       * @name CsvExport
       * @summary Export Table View Rows
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}/export/{type}
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      csvExport: (n, r, a, o, i = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/export/${o}`,
        method: "GET",
        wrapped: !0,
        ...i
      }),
      /**
       * @description List all nested relations rows
       *
       * @tags DB Table Row
       * @name NestedList
       * @summary List Nested Relations Rows
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}/{rowId}/{relationType}/{columnName}
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      nestedList: (n, r, a, o, i, s, l, u = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/${o}/${i}/${s}`,
        method: "GET",
        query: l,
        format: "json",
        ...u
      }),
      /**
       * @description Create a new nested relations row
       *
       * @tags DB Table Row
       * @name NestedAdd
       * @summary Create Nested Relations Row
       * @request POST:/api/v1/db/data/{orgs}/{baseName}/{tableName}/{rowId}/{relationType}/{columnName}/{refRowId}
       * @response `200` `{
        \** @example The relation data has been created successfully *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      nestedAdd: (n, r, a, o, i, s, l, u, c = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/${o}/${i}/${s}/${l}`,
        method: "POST",
        query: u,
        format: "json",
        ...c
      }),
      /**
       * @description Delete a new nested relations row
       *
       * @tags DB Table Row
       * @name NestedRemove
       * @summary Delete Nested Relations Row
       * @request DELETE:/api/v1/db/data/{orgs}/{baseName}/{tableName}/{rowId}/{relationType}/{columnName}/{refRowId}
       * @response `200` `{
        \** @example The relation data has been deleted successfully *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      nestedRemove: (n, r, a, o, i, s, l, u = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/${o}/${i}/${s}/${l}`,
        method: "DELETE",
        format: "json",
        ...u
      }),
      /**
       * @description Get the table rows but exculding the current record's children and parent
       *
       * @tags DB Table Row
       * @name NestedChildrenExcludedList
       * @summary Referenced Table Rows Excluding Current Record's Children / Parent
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}/{rowId}/{relationType}/{columnName}/exclude
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      nestedChildrenExcludedList: (n, r, a, o, i, s, l, u = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/${o}/${i}/${s}/exclude`,
        method: "GET",
        query: l,
        format: "json",
        ...u
      })
    });
    ln(this, "dbViewRow", {
      /**
       * @description Get the grouped data By Column ID. Used in Kanban View.
       *
       * @tags DB View Row
       * @name GroupedDataList
       * @summary Table Group by Column
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}/views/{viewName}/group/{columnId}
       * @response `200` `(any)[]` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      groupedDataList: (n, r, a, o, i, s, l = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/views/${o}/group/${i}`,
        method: "GET",
        query: s,
        format: "json",
        ...l
      }),
      list: (n, r, a, o, i = {}) => this.request({
        path: `/api/v1/db/data/noco/${n}/${r}/views/${a}`,
        method: "GET",
        query: o,
        format: "json",
        ...i
      }),
      create: (n, r, a, o, i = {}) => this.request({
        path: `/api/v1/db/data/noco/${n}/${r}/views/${a}`,
        method: "POST",
        body: o,
        type: "application/json",
        format: "json",
        ...i
      }),
      /**
       * @description Return the first result of table view rows with the given query
       *
       * @tags DB View Row
       * @name FindOne
       * @summary Find One Table View Row
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}/views/{viewName}/find-one
       * @response `200` `object` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      findOne: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/views/${o}/find-one`,
        method: "GET",
        query: i,
        format: "json",
        ...s
      }),
      /**
       * @description Get the table view rows grouped by the given query
       *
       * @tags DB View Row
       * @name GroupBy
       * @summary Group By Table View Row
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}/views/{viewName}/groupby
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      groupBy: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/views/${o}/groupby`,
        method: "GET",
        query: i,
        format: "json",
        ...s
      }),
      count: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/views/${o}/count`,
        method: "GET",
        query: i,
        format: "json",
        ...s
      }),
      /**
       * @description Get the target Table View Row
       *
       * @tags DB View Row
       * @name Read
       * @summary Get Table View Row
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}/views/{viewName}/{rowId}
       * @response `200` `object` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      read: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/views/${o}/${i}`,
        method: "GET",
        format: "json",
        ...s
      }),
      update: (n, r, a, o, i, s, l = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/views/${o}/${i}`,
        method: "PATCH",
        body: s,
        type: "application/json",
        format: "json",
        ...l
      }),
      delete: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/views/${o}/${i}`,
        method: "DELETE",
        format: "json",
        ...s
      }),
      /**
       * @description Check row with provided primary key exists or not
       *
       * @tags DB View Row
       * @name Exist
       * @summary Does Table View Row Exist
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}/views/{viewName}/{rowId}/exist
       * @response `201` `number` Created
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      exist: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/views/${o}/${i}/exist`,
        method: "GET",
        format: "json",
        ...s
      }),
      /**
       * @description Export Table View Rows by CSV or Excel
       *
       * @tags DB View Row
       * @name Export
       * @summary Export Table View Rows
       * @request GET:/api/v1/db/data/{orgs}/{baseName}/{tableName}/views/{viewName}/export/{type}
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      export: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v1/db/data/${n}/${r}/${a}/views/${o}/export/${i}`,
        method: "GET",
        wrapped: !0,
        ...s
      })
    });
    ln(this, "public", {
      /**
       * @description List Shared View Grouped Data
       *
       * @tags Public
       * @name GroupedDataList
       * @summary List Shared View Grouped Data
       * @request GET:/api/v1/db/public/shared-view/{sharedViewUuid}/group/{columnId}
       * @response `200` `({
        \** The Grouped Key *\
        key: string,
        \** the paginated result of the given key *\
        value: {
        \** List of the target data *\
        list: (object)[],
        \** Paginated Info *\
        pageInfo: PaginatedType,
      
      },
      
      })[]` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      groupedDataList: (n, r, a, o = {}) => this.request({
        path: `/api/v1/db/public/shared-view/${n}/group/${r}`,
        method: "GET",
        query: a,
        format: "json",
        ...o
      }),
      /**
       * @description List all shared view rows
       *
       * @tags Public
       * @name DataList
       * @summary List Shared View Rows
       * @request GET:/api/v1/db/public/shared-view/{sharedViewUuid}/rows
       * @response `200` `SharedViewListType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      dataList: (n, r, a = {}) => this.request({
        path: `/api/v1/db/public/shared-view/${n}/rows`,
        method: "GET",
        query: r,
        format: "json",
        ...a
      }),
      /**
       * @description Create a new row for the target shared view
       *
       * @tags Public
       * @name DataCreate
       * @summary Create Share View Row
       * @request POST:/api/v1/db/public/shared-view/{sharedViewUuid}/rows
       * @response `200` `object` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      dataCreate: (n, r, a = {}) => this.request({
        path: `/api/v1/db/public/shared-view/${n}/rows`,
        method: "POST",
        body: r,
        type: "multipart/form-data",
        format: "json",
        ...a
      }),
      /**
       * @description List all shared view rows grouped by a column
       *
       * @tags Public
       * @name DataGroupBy
       * @summary List Shared View Rows
       * @request GET:/api/v1/db/public/shared-view/{sharedViewUuid}/groupby
       * @response `200` `SharedViewListType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      dataGroupBy: (n, r, a = {}) => this.request({
        path: `/api/v1/db/public/shared-view/${n}/groupby`,
        method: "GET",
        query: r,
        format: "json",
        ...a
      }),
      /**
       * @description List all nested list data in a given shared view
       *
       * @tags Public
       * @name DataNestedList
       * @summary List Nested List Data
       * @request GET:/api/v1/db/public/shared-view/{sharedViewUuid}/rows/{rowId}/{relationType}/{columnName}
       * @response `200` `{
        \** List of data objects *\
        list: (object)[],
        \** Paginated info *\
        pageInfo: PaginatedType,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      dataNestedList: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v1/db/public/shared-view/${n}/rows/${r}/${a}/${o}`,
        method: "GET",
        query: i,
        format: "json",
        ...s
      }),
      /**
       * @description Export all rows in Share View in a CSV / Excel Format
       *
       * @tags Public
       * @name CsvExport
       * @summary Export Rows in Share View
       * @request GET:/api/v1/db/public/shared-view/{sharedViewUuid}/rows/export/{type}
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      csvExport: (n, r, a = {}) => this.request({
        path: `/api/v1/db/public/shared-view/${n}/rows/export/${r}`,
        method: "GET",
        wrapped: !0,
        ...a
      }),
      /**
       * @description List Nested Data Relation
       *
       * @tags Public
       * @name DataRelationList
       * @summary List Nested Data Relation
       * @request GET:/api/v1/db/public/shared-view/{sharedViewUuid}/nested/{columnName}
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      dataRelationList: (n, r, a, o = {}) => this.request({
        path: `/api/v1/db/public/shared-view/${n}/nested/${r}`,
        method: "GET",
        query: a,
        format: "json",
        ...o
      }),
      /**
       * @description Get Share Source Meta
       *
       * @tags Public
       * @name SharedBaseGet
       * @summary Get Share Source Meta
       * @request GET:/api/v1/db/public/shared-base/{sharedBaseUuid}/meta
       * @response `200` `{
        \** Base ID *\
        base_id?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      sharedBaseGet: (n, r = {}) => this.request({
        path: `/api/v1/db/public/shared-base/${n}/meta`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Get Share View Meta
       *
       * @tags Public
       * @name SharedViewMetaGet
       * @summary Get Share View Meta
       * @request GET:/api/v1/db/public/shared-view/{sharedViewUuid}/meta
       * @response `200` `(ViewType & {
        relatedMetas?: any,
        client?: string,
        source_id?: string,
        columns?: ((GridColumnType | FormColumnType | GalleryColumnType | (GridColumnType & FormColumnType & GalleryColumnType)) & ColumnType),
        \** Model for Table *\
        model?: TableType,
      
      } & {
        view?: (FormType | GridType | GalleryType | (FormType & GridType & GalleryType)),
      
      })` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      sharedViewMetaGet: (n, r = {}) => this.request({
        path: `/api/v1/db/public/shared-view/${n}/meta`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * No description
       *
       * @tags Public
       * @name SharedErdMetaGet
       * @request GET:/api/v1/db/public/shared-erd/{sharedErdUuid}/meta
       */
      sharedErdMetaGet: (n, r = {}) => this.request({
        path: `/api/v1/db/public/shared-erd/${n}/meta`,
        method: "GET",
        ...r
      })
    });
    ln(this, "utils", {
      /**
       * @description List all comments
       *
       * @tags Utils
       * @name CommentList
       * @summary List Comments in Audit
       * @request GET:/api/v1/db/meta/audits/comments
       * @response `200` `{
        list: (AuditType)[],
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      commentList: (n, r = {}) => this.request({
        path: "/api/v1/db/meta/audits/comments",
        method: "GET",
        query: n,
        format: "json",
        ...r
      }),
      /**
       * @description Create a new comment in a row. Logged in Audit.
       *
       * @tags Utils
       * @name CommentRow
       * @summary Comment Rows
       * @request POST:/api/v1/db/meta/audits/comments
       * @response `200` `AuditType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      commentRow: (n, r = {}) => this.request({
        path: "/api/v1/db/meta/audits/comments",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      }),
      /**
       * @description Update comment in Audit
       *
       * @tags Utils
       * @name CommentUpdate
       * @summary Update Comment in Audit
       * @request PATCH:/api/v1/db/meta/audits/{auditId}/comment
       * @response `200` `number` OK
       */
      commentUpdate: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/audits/${n}/comment`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Return the number of comments in the given query.
       *
       * @tags Utils
       * @name CommentCount
       * @summary Count Comments
       * @request GET:/api/v1/db/meta/audits/comments/count
       * @response `200` `({
        \**
         * The number of comments
         * @example 4
         *\
        count: string,
        \**
         * Row ID
         * @example 1
         *\
        row_id: string,
      
      })[]` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      commentCount: (n, r = {}) => this.request({
        path: "/api/v1/db/meta/audits/comments/count",
        method: "GET",
        query: n,
        format: "json",
        ...r
      }),
      /**
       * @description Update Audit Row
       *
       * @tags Utils
       * @name AuditRowUpdate
       * @summary Update Audit Row
       * @request POST:/api/v1/db/meta/audits/rows/{rowId}/update
       * @response `200` `AuditType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      auditRowUpdate: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/audits/rows/${n}/update`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Test the DB Connection
       *
       * @tags Utils
       * @name TestConnection
       * @summary Test DB Connection
       * @request POST:/api/v1/db/meta/connection/test
       * @response `200` `{
        code?: number,
        message?: string,
        data?: object,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      testConnection: (n, r = {}) => this.request({
        path: "/api/v1/db/meta/connection/test",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      }),
      /**
       * No description
       *
       * @tags Utils
       * @name SelectQuery
       * @request POST:/api/v1/db/meta/connection/select
       * @response `200` `any` OK
       */
      selectQuery: (n, r = {}) => this.request({
        path: "/api/v1/db/meta/connection/select",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      }),
      /**
       * @description Extract XC URL From JDBC and parse to connection config
       *
       * @tags Utils
       * @name UrlToConfig
       * @summary Convert JDBC URL to Config
       * @request POST:/api/v1/url_to_config
       * @response `200` `{
        \**
         * DB Type
         * @example mysql2
         *\
        client?: "mssql" | "mysql" | "mysql2" | "oracledb" | "pg" | "snowflake" | "sqlite3",
        \** Connection Config *\
        connection?: {
        \** DB User *\
        user?: string,
        \** DB Password *\
        password?: string,
        \** DB Name *\
        database?: string,
        \** DB Host *\
        host?: string,
        \** DB Host *\
        port?: string,
      
      },
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      urlToConfig: (n, r = {}) => this.request({
        path: "/api/v1/url_to_config",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      }),
      /**
       * @description Get the application info such as authType, defaultLimit, version and etc.
       *
       * @tags Utils
       * @name AppInfo
       * @summary Get App Info
       * @request GET:/api/v1/db/meta/nocodb/info
       * @response `200` `{
        authType?: string,
        baseHasAdmin?: boolean,
        firstUser?: boolean,
        type?: string,
        googleAuthEnabled?: boolean,
        githubAuthEnabled?: boolean,
        oneClick?: boolean,
        connectToExternalDB?: boolean,
        version?: string,
        defaultLimit?: number,
        ncMin?: boolean,
        teleEnabled?: boolean,
        auditEnabled?: boolean,
        ncSiteUrl?: string,
        ee?: boolean,
        ncAttachmentFieldSize?: number,
        ncMaxAttachmentsAllowed?: number,
        isCloud?: boolean,
        \** @example OFF *\
        automationLogLevel?: "OFF" | "ERROR" | "ALL",
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      appInfo: (n = {}) => this.request({
        path: "/api/v1/db/meta/nocodb/info",
        method: "GET",
        format: "json",
        ...n
      }),
      /**
       * @description Generic Axios Call
       *
       * @tags Utils
       * @name AxiosRequestMake
       * @summary Axios Request
       * @request POST:/api/v1/db/meta/axiosRequestMake
       * @response `200` `object` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      axiosRequestMake: (n, r = {}) => this.request({
        path: "/api/v1/db/meta/axiosRequestMake",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      }),
      /**
       * @description Get the application version
       *
       * @tags Utils
       * @name AppVersion
       * @summary Get App Version
       * @request GET:/api/v1/version
       * @response `200` `{
        \**
         * Current NocoDB Version
         * @example 0.104.0
         *\
        currentVersion?: string,
        \**
         * Latest Release Version
         * @example 0.105.3
         *\
        releaseVersion?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      appVersion: (n = {}) => this.request({
        path: "/api/v1/version",
        method: "GET",
        format: "json",
        ...n
      }),
      /**
       * @description Get Application Health Status
       *
       * @tags Utils
       * @name AppHealth
       * @summary Get Application Health Status
       * @request GET:/api/v1/health
       * @response `200` `{
        \** @example OK *\
        message?: string,
        \** @example 1678702175755 *\
        timestamp?: string,
        \** @example 1618.996877834 *\
        uptime?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      appHealth: (n = {}) => this.request({
        path: "/api/v1/health",
        method: "GET",
        format: "json",
        ...n
      }),
      /**
       * @description Get Aggregated Meta Info such as tableCount, dbViewCount, viewCount and etc.
       *
       * @tags Utils
       * @name AggregatedMetaInfo
       * @summary Get Aggregated Meta Info
       * @request GET:/api/v1/aggregated-meta-info
       * @response `200` `{
        baseCount?: number,
        bases?: ({
        tableCount?: {
        \** Table Count *\
        table?: number,
        \** View Count *\
        view?: number,
      
      },
        \** External Base *\
        external?: boolean,
        viewCount?: {
        \** Form Count *\
        formCount?: number,
        \** Grid Count *\
        gridCount?: number,
        \** Gallery Count *\
        galleryCount?: number,
        \** Kanban Count *\
        kanbanCount?: number,
        \** Total View Count *\
        total?: number,
        \** Shared Form Count *\
        sharedFormCount?: number,
        \** Shared Grid Count *\
        sharedGridCount?: number,
        \** Shared Gallery Count *\
        sharedGalleryCount?: number,
        \** Shared Kanban Count *\
        sharedKanbanCount?: number,
        \** Shared Total View Count *\
        sharedTotal?: number,
        \** Shared Locked View Count *\
        sharedLockedCount?: number,
      
      },
        \** Webhook Count *\
        webhookCount?: number,
        \** Filter Count *\
        filterCount?: number,
        \** Sort Count *\
        sortCount?: number,
        \** Row Count *\
        rowCount?: ({
        TotalRecords?: string,
      
      })[],
        \** Total base user Count *\
        userCount?: number,
      
      })[],
        \** Total user Count *\
        userCount?: number,
        \** Total shared base Count *\
        sharedBaseCount?: number,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      aggregatedMetaInfo: (n = {}) => this.request({
        path: "/api/v1/aggregated-meta-info",
        method: "GET",
        format: "json",
        ...n
      }),
      /**
       * @description Get All K/V pairs in NocoCache
       *
       * @tags Utils
       * @name CacheGet
       * @summary Get Cache
       * @request GET:/api/v1/db/meta/cache
       */
      cacheGet: (n = {}) => this.request({
        path: "/api/v1/db/meta/cache",
        method: "GET",
        ...n
      }),
      /**
       * @description Delete All K/V pairs in NocoCache
       *
       * @tags Utils
       * @name CacheDelete
       * @summary Delete Cache
       * @request DELETE:/api/v1/db/meta/cache
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      cacheDelete: (n = {}) => this.request({
        path: "/api/v1/db/meta/cache",
        method: "DELETE",
        format: "json",
        ...n
      }),
      /**
       * @description Get dynamic command palette suggestions based on scope
       *
       * @tags Utils
       * @name CommandPalette
       * @summary Get command palette suggestions
       * @request POST:/api/v1/command_palette
       * @response `200` `any` OK
       */
      commandPalette: (n, r = {}) => this.request({
        path: "/api/v1/command_palette",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      })
    });
    ln(this, "dbTableWebhook", {
      /**
       * @description List all hook records in the given Table
       *
       * @tags DB Table Webhook
       * @name List
       * @summary List Table Hooks
       * @request GET:/api/v1/db/meta/tables/{tableId}/hooks
       * @response `200` `HookListType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      list: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}/hooks`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Create a hook in the given table
       *
       * @tags DB Table Webhook
       * @name Create
       * @summary Create Table Hook
       * @request POST:/api/v1/db/meta/tables/{tableId}/hooks
       * @response `200` `HookType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      create: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}/hooks`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Test the hook in the given Table
       *
       * @tags DB Table Webhook
       * @name Test
       * @summary Test Hook
       * @request POST:/api/v1/db/meta/tables/{tableId}/hooks/test
       * @response `200` `{
        \** @example The hook has been tested successfully *\
        msg?: string,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      test: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}/hooks/test`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Get the sample hook payload
       *
       * @tags DB Table Webhook
       * @name SamplePayloadGet
       * @summary Get Sample Hook Payload
       * @request GET:/api/v1/db/meta/tables/{tableId}/hooks/samplePayload/{operation}/{version}
       * @response `200` `{
        \** Sample Payload Data *\
        data?: object,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      samplePayloadGet: (n, r, a, o = {}) => this.request({
        path: `/api/v1/db/meta/tables/${n}/hooks/samplePayload/${r}/${a}`,
        method: "GET",
        format: "json",
        ...o
      }),
      /**
       * @description Update the exsiting hook by its ID
       *
       * @tags DB Table Webhook
       * @name Update
       * @summary Update Hook
       * @request PATCH:/api/v1/db/meta/hooks/{hookId}
       * @response `200` `HookType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      update: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/hooks/${n}`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Delete the exsiting hook by its ID
       *
       * @tags DB Table Webhook
       * @name Delete
       * @summary Delete Hook
       * @request DELETE:/api/v1/db/meta/hooks/{hookId}
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      delete: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/hooks/${n}`,
        method: "DELETE",
        format: "json",
        ...r
      })
    });
    ln(this, "plugin", {
      /**
       * @description List all plugins
       *
       * @tags Plugin
       * @name List
       * @summary List Plugins
       * @request GET:/api/v1/db/meta/plugins
       * @response `200` `{
        list?: (PluginType)[],
        \** Model for Paginated *\
        pageInfo?: PaginatedType,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      list: (n = {}) => this.request({
        path: "/api/v1/db/meta/plugins",
        method: "GET",
        format: "json",
        ...n
      }),
      /**
       * @description List all webhook plugins
       *
       * @tags Plugin
       * @name WebhookList
       * @summary Webhook List Plugins
       * @request GET:/api/v1/db/meta/plugins/webhook
       * @response `200` `{
        list?: (PluginType)[],
        \** Model for Paginated *\
        pageInfo?: PaginatedType,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      webhookList: (n = {}) => this.request({
        path: "/api/v1/db/meta/plugins/webhook",
        method: "GET",
        format: "json",
        ...n
      }),
      /**
       * @description Check plugin is active or not
       *
       * @tags Plugin
       * @name Status
       * @summary Get Plugin Status
       * @request GET:/api/v1/db/meta/plugins/{pluginTitle}/status
       * @response `200` `boolean` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      status: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/plugins/${n}/status`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Test if the plugin is working with the given configurations
       *
       * @tags Plugin
       * @name Test
       * @summary Test Plugin
       * @request POST:/api/v1/db/meta/plugins/test
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      test: (n, r = {}) => this.request({
        path: "/api/v1/db/meta/plugins/test",
        method: "POST",
        body: n,
        type: "application/json",
        format: "json",
        ...r
      }),
      /**
       * @description Update the plugin data by ID
       *
       * @tags Plugin
       * @name Update
       * @summary Update Plugin
       * @request PATCH:/api/v1/db/meta/plugins/{pluginId}
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      update: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/plugins/${n}`,
        method: "PATCH",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Get the plugin data by ID
       *
       * @tags Plugin
       * @name Read
       * @summary Get Plugin
       * @request GET:/api/v1/db/meta/plugins/{pluginId}
       * @response `200` `PluginType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      read: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/plugins/${n}`,
        method: "GET",
        format: "json",
        ...r
      })
    });
    ln(this, "apiToken", {
      /**
       * @description List API Tokens in the given base
       *
       * @tags API Token
       * @name List
       * @summary List API Tokens in Base
       * @request GET:/api/v1/db/meta/projects/{baseId}/api-tokens
       * @response `200` `ApiTokenListType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      list: (n, r = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/api-tokens`,
        method: "GET",
        format: "json",
        ...r
      }),
      /**
       * @description Create API Token in a base
       *
       * @tags API Token
       * @name Create
       * @summary Create API Token
       * @request POST:/api/v1/db/meta/projects/{baseId}/api-tokens
       * @response `200` `ApiTokenType` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      create: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/api-tokens`,
        method: "POST",
        body: r,
        type: "application/json",
        format: "json",
        ...a
      }),
      /**
       * @description Delete the given API Token in base
       *
       * @tags API Token
       * @name Delete
       * @summary Delete API Token
       * @request DELETE:/api/v1/db/meta/projects/{baseId}/api-tokens/{token}
       * @response `200` `number` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      delete: (n, r, a = {}) => this.request({
        path: `/api/v1/db/meta/projects/${n}/api-tokens/${r}`,
        method: "DELETE",
        format: "json",
        ...a
      })
    });
    ln(this, "storage", {
      /**
       * @description Upload attachment
       *
       * @tags Storage
       * @name Upload
       * @summary Attachment Upload
       * @request POST:/api/v1/db/storage/upload
       */
      upload: (n, r, a = {}) => this.request({
        path: "/api/v1/db/storage/upload",
        method: "POST",
        query: n,
        body: r,
        type: "multipart/form-data",
        ...a
      }),
      /**
       * @description Upload attachment by URL. Used in Airtable Migration.
       *
       * @tags Storage
       * @name UploadByUrl
       * @summary Attachment Upload by URL
       * @request POST:/api/v1/db/storage/upload-by-url
       */
      uploadByUrl: (n, r, a = {}) => this.request({
        path: "/api/v1/db/storage/upload-by-url",
        method: "POST",
        query: n,
        body: r,
        type: "application/json",
        ...a
      })
    });
    ln(this, "notification", {
      /**
       * @description List notifications
       *
       * @tags Notification
       * @name List
       * @summary Notification list
       * @request GET:/api/v1/notifications
       * @response `200` `NotificationListType` OK
       */
      list: (n, r = {}) => this.request({
        path: "/api/v1/notifications",
        method: "GET",
        query: n,
        format: "json",
        ...r
      }),
      /**
       * @description Notificattion update
       *
       * @tags Notification
       * @name Update
       * @summary Notification update
       * @request PATCH:/api/v1/notifications/{notificationId}
       * @response `200` `void` OK
       */
      update: (n, r, a = {}) => this.request({
        path: `/api/v1/notifications/${n}`,
        method: "PATCH",
        body: r,
        type: "application/json",
        ...a
      }),
      /**
       * @description Delete notification
       *
       * @tags Notification
       * @name Delete
       * @summary Delete notification
       * @request DELETE:/api/v1/notifications/{notificationId}
       * @response `200` `void` OK
       */
      delete: (n, r = {}) => this.request({
        path: `/api/v1/notifications/${n}`,
        method: "DELETE",
        ...r
      }),
      /**
       * @description Mark all notifications as read
       *
       * @tags Notification
       * @name MarkAllAsRead
       * @summary Mark all notifications as read
       * @request POST:/api/v1/notifications/mark-all-read
       * @response `200` `void` OK
       */
      markAllAsRead: (n = {}) => this.request({
        path: "/api/v1/notifications/mark-all-read",
        method: "POST",
        ...n
      })
    });
    ln(this, "dbDataTableRow", {
      /**
       * @description List all table rows in a given table
       *
       * @tags DB Data Table Row
       * @name List
       * @summary List Table Rows
       * @request GET:/api/v2/tables/{tableId}/records
       * @response `200` `{
        \** List of data objects *\
        list: (object)[],
        \** Paginated Info *\
        pageInfo: PaginatedType,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      list: (n, r, a = {}) => this.request({
        path: `/api/v2/tables/${n}/records`,
        method: "GET",
        query: r,
        format: "json",
        ...a
      }),
      /**
       * @description Create a new row in a given table and base.
       *
       * @tags DB Data Table Row
       * @name Create
       * @summary Create Table Rows
       * @request POST:/api/v2/tables/{tableId}/records
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      create: (n, r, a, o = {}) => this.request({
        path: `/api/v2/tables/${n}/records`,
        method: "POST",
        query: a,
        body: r,
        type: "application/json",
        format: "json",
        ...o
      }),
      /**
       * @description Create a new row in a given table and base.
       *
       * @tags DB Data Table Row
       * @name Update
       * @summary Update Table Rows
       * @request PUT:/api/v2/tables/{tableId}/records
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      update: (n, r, a, o = {}) => this.request({
        path: `/api/v2/tables/${n}/records`,
        method: "PUT",
        query: a,
        body: r,
        type: "application/json",
        format: "json",
        ...o
      }),
      delete: (n, r, a, o = {}) => this.request({
        path: `/api/v2/tables/${n}/records`,
        method: "DELETE",
        query: a,
        body: r,
        type: "application/json",
        format: "json",
        ...o
      }),
      /**
       * @description Get table row in a given table
       *
       * @tags DB Data Table Row
       * @name Read
       * @summary Read Table Row
       * @request GET:/api/v2/tables/{tableId}/records/{rowId}
       * @response `200` `object` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      read: (n, r, a, o = {}) => this.request({
        path: `/api/v2/tables/${n}/records/${r}`,
        method: "GET",
        query: a,
        format: "json",
        ...o
      }),
      /**
       * @description Count of rows in a given table
       *
       * @tags DB Data Table Row
       * @name Count
       * @summary Table Rows Count
       * @request GET:/api/v2/tables/{tableId}/records/count
       * @response `200` `{
        count?: number,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      count: (n, r, a = {}) => this.request({
        path: `/api/v2/tables/${n}/records/count`,
        method: "GET",
        query: r,
        format: "json",
        ...a
      }),
      /**
       * @description Linked rows in a given Links/LinkToAnotherRecord column
       *
       * @tags DB Data Table Row
       * @name NestedList
       * @summary Get Nested Relations Rows
       * @request GET:/api/v2/tables/{tableId}/links/{columnId}/records/{rowId}
       * @response `200` `{
        \** List of data objects *\
        list: (object)[],
        \** Paginated Info *\
        pageInfo: PaginatedType,
      
      }` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      nestedList: (n, r, a, o, i = {}) => this.request({
        path: `/api/v2/tables/${n}/links/${r}/records/${a}`,
        method: "GET",
        query: o,
        format: "json",
        ...i
      }),
      /**
       * @description Create a link with the row.
       *
       * @tags DB Data Table Row
       * @name NestedLink
       * @summary Create Nested Relations Rows
       * @request POST:/api/v2/tables/{tableId}/links/{columnId}/records/{rowId}
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      nestedLink: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v2/tables/${n}/links/${r}/records/${a}`,
        method: "POST",
        query: i,
        body: o,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Create a new row in a given table and base.
       *
       * @tags DB Data Table Row
       * @name NestedUnlink
       * @summary Delete Nested Relations Rows
       * @request DELETE:/api/v2/tables/{tableId}/links/{columnId}/records/{rowId}
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      nestedUnlink: (n, r, a, o, i, s = {}) => this.request({
        path: `/api/v2/tables/${n}/links/${r}/records/${a}`,
        method: "DELETE",
        query: i,
        body: o,
        type: "application/json",
        format: "json",
        ...s
      }),
      /**
       * @description Copy links from the one cell and paste them into another cell or delete all records from cell
       *
       * @tags DB Data Table Row
       * @name NestedListCopyPasteOrDeleteAll
       * @summary Copy paste or deleteAll nested link
       * @request POST:/api/v2/tables/{tableId}/links/{columnId}/records
       * @response `200` `any` OK
       * @response `400` `{
        \** @example BadRequest [Error]: <ERROR MESSAGE> *\
        msg: string,
      
      }`
       */
      nestedListCopyPasteOrDeleteAll: (n, r, a, o, i = {}) => this.request({
        path: `/api/v2/tables/${n}/links/${r}/records`,
        method: "POST",
        query: o,
        body: a,
        type: "application/json",
        format: "json",
        ...i
      })
    });
    ln(this, "jobs", {
      /**
       * @description Listen for job events
       *
       * @tags Jobs
       * @name Listen
       * @summary Jobs Listen
       * @request POST:/jobs/listen
       */
      listen: (n, r = {}) => this.request({
        path: "/jobs/listen",
        method: "POST",
        body: n,
        type: "application/json",
        ...r
      }),
      /**
       * @description Get job status
       *
       * @tags Jobs
       * @name Status
       * @summary Jobs Status
       * @request POST:/jobs/status
       */
      status: (n, r = {}) => this.request({
        path: "/jobs/status",
        method: "POST",
        body: n,
        type: "application/json",
        ...r
      })
    });
  }
}
var we = /* @__PURE__ */ ((e) => (e.ID = "ID", e.SingleLineText = "SingleLineText", e.LongText = "LongText", e.Attachment = "Attachment", e.Checkbox = "Checkbox", e.MultiSelect = "MultiSelect", e.SingleSelect = "SingleSelect", e.Date = "Date", e.Year = "Year", e.Time = "Time", e.PhoneNumber = "PhoneNumber", e.Email = "Email", e.URL = "URL", e.Number = "Number", e.Decimal = "Decimal", e.DateTime = "DateTime", e.JSON = "JSON", e))(we || {});
const L3 = {
  ID: "ID",
  SingleLineText: "Single line text",
  LongText: "Long text",
  RichText: "Rich text",
  Attachment: "Attachment",
  Checkbox: "Checkbox",
  MultiSelect: "Multi select",
  SingleSelect: "Single select",
  Date: "Date",
  Year: "Year",
  Time: "Time",
  PhoneNumber: "Phone number",
  Email: "Email",
  URL: "URL",
  Number: "Number",
  Decimal: "Decimal",
  DateTime: "Date time",
  JSON: "JSON",
  CreatedTime: "Created time",
  LastModifiedTime: "Last modified time"
}, Ci = [
  "Number",
  "Decimal",
  "Year"
  /* Year */
];
function L8(e) {
  return Ci.includes(typeof e == "object" ? e == null ? void 0 : e.uidt : e);
}
function Gr(e) {
  return !!(e && ((e.column_name === "created_at" || e.column_name === "updated_at") && e.uidt === we.DateTime || e.pk && (e.ai || e.cdf) || // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  e.pk && e.meta && e.meta.ag || e.system));
}
const B8 = ["YYYY-MM", "YYYY MM"], hm = ["HH:mm", "HH:mm:ss", "HH:mm:ss.SSS"], Bf = [
  "YYYY-MM-DD",
  "YYYY/MM/DD",
  "DD-MM-YYYY",
  "MM-DD-YYYY",
  "DD/MM/YYYY",
  "MM/DD/YYYY",
  "DD MM YYYY",
  "MM DD YYYY",
  "YYYY MM DD"
], F_ = (e) => B8.includes(e), B3 = [
  "int",
  "integer",
  "bigint",
  "bigserial",
  "char",
  "int2",
  "int4",
  "int8",
  "int4range",
  "int8range",
  "serial",
  "serial2",
  "serial8",
  "character",
  "bit",
  "bool",
  "boolean",
  "date",
  "double precision",
  "event_trigger",
  "fdw_handler",
  "float4",
  "float8",
  "uuid",
  "smallint",
  "smallserial",
  "character varying",
  "text",
  "real",
  "time",
  "time without time zone",
  "timestamp",
  "timestamp without time zone",
  "timestamptz",
  "timestamp with time zone",
  "timetz",
  "time with time zone",
  "daterange",
  "json",
  "jsonb",
  "gtsvector",
  "index_am_handler",
  "anyenum",
  "anynonarray",
  "anyrange",
  "box",
  "bpchar",
  "bytea",
  "cid",
  "cidr",
  "circle",
  "cstring",
  "inet",
  "internal",
  "interval",
  "language_handler",
  "line",
  "lsec",
  "macaddr",
  "money",
  "name",
  "numeric",
  "numrange",
  "oid",
  "opaque",
  "path",
  "pg_ddl_command",
  "pg_lsn",
  "pg_node_tree",
  "point",
  "polygon",
  "record",
  "refcursor",
  "regclass",
  "regconfig",
  "regdictionary",
  "regnamespace",
  "regoper",
  "regoperator",
  "regproc",
  "regpreocedure",
  "regrole",
  "regtype",
  "reltime",
  "smgr",
  "tid",
  "tinterval",
  "trigger",
  "tsm_handler",
  "tsquery",
  "tsrange",
  "tstzrange",
  "tsvector",
  "txid_snapshot",
  "unknown",
  "void",
  "xid",
  "xml"
];
class YV {
  static getNewTableColumns() {
    return [
      {
        column_name: "id",
        title: "Id",
        dt: "int4",
        dtx: "integer",
        ct: "int(11)",
        nrqd: !1,
        rqd: !0,
        ck: !1,
        pk: !0,
        un: !1,
        ai: !0,
        cdf: null,
        clen: null,
        np: 11,
        ns: 0,
        dtxp: "11",
        dtxs: "",
        altered: 1,
        uidt: "ID",
        uip: "",
        uicn: "",
        system: !0
      },
      {
        column_name: "created_at",
        title: "CreatedAt",
        dt: "timestamp",
        dtx: "specificType",
        ct: "timestamp",
        nrqd: !0,
        rqd: !1,
        ck: !1,
        pk: !1,
        un: !1,
        ai: !1,
        clen: 45,
        np: null,
        ns: null,
        dtxp: "",
        dtxs: "",
        altered: 1,
        uidt: "CreatedTime",
        uip: "",
        uicn: "",
        system: !0
      },
      {
        column_name: "updated_at",
        title: "UpdatedAt",
        dt: "timestamp",
        dtx: "specificType",
        ct: "timestamp",
        nrqd: !0,
        rqd: !1,
        ck: !1,
        pk: !1,
        un: !1,
        ai: !1,
        clen: 45,
        np: null,
        ns: null,
        dtxp: "",
        dtxs: "",
        altered: 1,
        uidt: "LastModifiedTime",
        uip: "",
        uicn: "",
        system: !0
      }
      // {
      //   column_name: 'created_by',
      //   title: 'nc_created_by',
      //   dt: 'varchar',
      //   dtx: 'specificType',
      //   ct: 'varchar(45)',
      //   nrqd: true,
      //   rqd: false,
      //   ck: false,
      //   pk: false,
      //   un: false,
      //   ai: false,
      //   clen: 45,
      //   np: null,
      //   ns: null,
      //   dtxp: '45',
      //   dtxs: '',
      //   altered: 1,
      //   uidt: 'CreatedBy',
      //   uip: '',
      //   uicn: '',
      //   system: true,
      // },
      // {
      //   column_name: 'updated_by',
      //   title: 'nc_updated_by',
      //   dt: 'varchar',
      //   dtx: 'specificType',
      //   ct: 'varchar(45)',
      //   nrqd: true,
      //   rqd: false,
      //   ck: false,
      //   pk: false,
      //   un: false,
      //   ai: false,
      //   clen: 45,
      //   np: null,
      //   ns: null,
      //   dtxp: '45',
      //   dtxs: '',
      //   altered: 1,
      //   uidt: 'LastModifiedBy',
      //   uip: '',
      //   uicn: '',
      //   system: true,
      // },
    ];
  }
  static getNewColumn(t) {
    return {
      column_name: "title" + t,
      dt: "character varying",
      dtx: "specificType",
      ct: "varchar(45)",
      nrqd: !0,
      rqd: !1,
      ck: !1,
      pk: !1,
      un: !1,
      ai: !1,
      cdf: null,
      clen: 45,
      np: null,
      ns: null,
      dtxp: "45",
      dtxs: "",
      altered: 1,
      uidt: "SingleLineText",
      uip: "",
      uicn: ""
    };
  }
  // static getDefaultLengthForDatatype(type) {
  //   switch (type) {
  //     case "int":
  //       return 11;
  //       break;
  //     case "tinyint":
  //       return 1;
  //       break;
  //     case "smallint":
  //       return 5;
  //       break;
  //
  //     case "mediumint":
  //       return 9;
  //       break;
  //     case "bigint":
  //       return 20;
  //       break;
  //     case "bit":
  //       return 64;
  //       break;
  //     case "boolean":
  //       return '';
  //       break;
  //     case "float":
  //       return 12;
  //       break;
  //     case "decimal":
  //       return 10;
  //       break;
  //     case "double":
  //       return 22;
  //       break;
  //     case "serial":
  //       return 20;
  //       break;
  //     case "date":
  //       return '';
  //       break;
  //     case "datetime":
  //     case "timestamp":
  //       return 6;
  //       break;
  //     case "time":
  //       return '';
  //       break;
  //     case "year":
  //       return '';
  //       break;
  //     case "char":
  //       return 255;
  //       break;
  //     case "varchar":
  //       return 45;
  //       break;
  //     case "nchar":
  //       return 255;
  //       break;
  //     case "text":
  //       return '';
  //       break;
  //     case "tinytext":
  //       return '';
  //       break;
  //     case "mediumtext":
  //       return '';
  //       break;
  //     case "longtext":
  //       return ''
  //       break;
  //     case "binary":
  //       return 255;
  //       break;
  //     case "varbinary":
  //       return 65500;
  //       break;
  //     case "blob":
  //       return '';
  //       break;
  //     case "tinyblob":
  //       return '';
  //       break;
  //     case "mediumblob":
  //       return '';
  //       break;
  //     case "longblob":
  //       return '';
  //       break;
  //     case "enum":
  //       return '\'a\',\'b\'';
  //       break;
  //     case "set":
  //       return '\'a\',\'b\'';
  //       break;
  //     case "geometry":
  //       return '';
  //     case "point":
  //       return '';
  //     case "linestring":
  //       return '';
  //     case "polygon":
  //       return '';
  //     case "multipoint":
  //       return '';
  //     case "multilinestring":
  //       return '';
  //     case "multipolygon":
  //       return '';
  //     case "json":
  //       return ''
  //       break;
  //
  //   }
  //
  // }
  static getDefaultLengthForDatatype(t) {
    switch (t) {
      case "int":
        return "";
      case "tinyint":
        return "";
      case "smallint":
        return "";
      case "mediumint":
        return "";
      case "bigint":
        return "";
      case "bit":
        return "";
      case "boolean":
        return "";
      case "float":
        return "";
      case "decimal":
        return "";
      case "double":
        return "";
      case "serial":
        return "";
      case "date":
        return "";
      case "datetime":
      case "timestamp":
        return "";
      case "time":
        return "";
      case "year":
        return "";
      case "char":
        return "";
      case "varchar":
        return "";
      case "nchar":
        return "";
      case "text":
        return "";
      case "tinytext":
        return "";
      case "mediumtext":
        return "";
      case "longtext":
        return "";
      case "binary":
        return "";
      case "varbinary":
        return "";
      case "blob":
        return "";
      case "tinyblob":
        return "";
      case "mediumblob":
        return "";
      case "longblob":
        return "";
      case "enum":
        return "";
      case "set":
        return "";
      case "geometry":
        return "";
      case "point":
        return "";
      case "linestring":
        return "";
      case "polygon":
        return "";
      case "multipoint":
        return "";
      case "multilinestring":
        return "";
      case "multipolygon":
        return "";
      case "json":
        return "";
    }
  }
  static getDefaultLengthIsDisabled(t) {
    switch (t) {
      case "anyenum":
      case "anynonarray":
      case "anyrange":
      case "bigint":
      case "bigserial":
      case "bit":
      case "bool":
      case "box":
      case "bpchar":
      case "bytea":
      case "char":
      case "character":
      case "cid":
      case "cidr":
      case "circle":
      case "cstring":
      case "date":
      case "daterange":
      case "double precision":
      case "event_trigger":
      case "fdw_handler":
      case "float4":
      case "float8":
      case "gtsvector":
      case "index_am_handler":
      case "inet":
      case "int":
      case "int2":
      case "int4":
      case "int8":
      case "int4range":
      case "int8range":
      case "integer":
      case "internal":
      case "interval":
      case "jsonb":
      case "language_handler":
      case "line":
      case "lsec":
      case "macaddr":
      case "money":
      case "name":
      case "numeric":
      case "numrange":
      case "oid":
      case "opaque":
      case "path":
      case "pg_ddl_command":
      case "pg_lsn":
      case "pg_node_tree":
      case "real":
      case "record":
      case "refcursor":
      case "regclass":
      case "regconfig":
      case "regdictionary":
      case "regnamespace":
      case "regoper":
      case "regoperator":
      case "regproc":
      case "regpreocedure":
      case "regrole":
      case "regtype":
      case "reltime":
      case "serial":
      case "serial2":
      case "serial8":
      case "smallint":
      case "smallserial":
      case "smgr":
      case "text":
      case "tid":
      case "time":
      case "time without time zone":
      case "timestamp":
      case "timestamp without time zone":
      case "timestamptz":
      case "timestamp with time zone":
      case "timetz":
      case "time with time zone":
      case "tinterval":
      case "trigger":
      case "tsm_handler":
      case "tsquery":
      case "tsrange":
      case "tstzrange":
      case "tsvector":
      case "txid_snapshot":
      case "unknown":
      case "void":
      case "xid":
      case "xml":
      case "character varying":
      case "tinyint":
      case "mediumint":
      case "float":
      case "decimal":
      case "double":
      case "boolean":
      case "datetime":
      case "uuid":
      case "year":
      case "varchar":
      case "nchar":
      case "tinytext":
      case "mediumtext":
      case "longtext":
      case "binary":
      case "varbinary":
      case "blob":
      case "tinyblob":
      case "mediumblob":
      case "longblob":
      case "enum":
      case "set":
      case "geometry":
      case "point":
      case "linestring":
      case "polygon":
      case "multipoint":
      case "multilinestring":
      case "multipolygon":
      case "json":
        return !0;
    }
  }
  static getDefaultValueForDatatype(t) {
    switch (t) {
      case "anyenum":
        return "eg: ";
      case "anynonarray":
        return "eg: ";
      case "anyrange":
        return "eg: ";
      case "bigint":
        return "eg: ";
      case "bigserial":
        return "eg: ";
      case "bit":
        return "eg: ";
      case "bool":
        return "eg: ";
      case "box":
        return "eg: ";
      case "bpchar":
        return "eg: ";
      case "bytea":
        return "eg: ";
      case "char":
        return "eg: ";
      case "character":
        return "eg: 'sample'";
      case "cid":
        return "eg: ";
      case "cidr":
        return "eg: ";
      case "circle":
        return "eg: ";
      case "cstring":
        return "eg: ";
      case "date":
        return "eg: '2020-09-09'";
      case "daterange":
        return "eg: ";
      case "double precision":
        return "eg: 1.2";
      case "event_trigger":
        return "eg: ";
      case "fdw_handler":
        return "eg: ";
      case "float4":
        return "eg: 1.2";
      case "float8":
        return "eg: 1.2";
      case "gtsvector":
        return "eg: ";
      case "index_am_handler":
        return "eg: ";
      case "inet":
        return "eg: ";
      case "int":
        return "eg: ";
      case "int2":
        return "eg: ";
      case "int4":
        return "eg: ";
      case "int8":
        return "eg: ";
      case "int4range":
        return "eg: ";
      case "int8range":
        return "eg: ";
      case "integer":
        return "eg: ";
      case "internal":
        return "eg: ";
      case "interval":
        return "eg: ";
      case "json":
        return "eg: ";
      case "jsonb":
        return "eg: ";
      case "language_handler":
        return "eg: ";
      case "line":
        return "eg: ";
      case "lsec":
        return "eg: ";
      case "macaddr":
        return "eg: ";
      case "money":
        return "eg: ";
      case "name":
        return "eg: ";
      case "numeric":
        return "eg: ";
      case "numrange":
        return "eg: ";
      case "oid":
        return "eg: ";
      case "opaque":
        return "eg: ";
      case "path":
        return "eg: ";
      case "pg_ddl_command":
        return "eg: ";
      case "pg_lsn":
        return "eg: ";
      case "pg_node_tree":
        return "eg: ";
      case "point":
        return "eg: ";
      case "polygon":
        return "eg: ";
      case "real":
        return "eg: 1.2";
      case "record":
        return "eg: ";
      case "refcursor":
        return "eg: ";
      case "regclass":
        return "eg: ";
      case "regconfig":
        return "eg: ";
      case "regdictionary":
        return "eg: ";
      case "regnamespace":
        return "eg: ";
      case "regoper":
        return "eg: ";
      case "regoperator":
        return "eg: ";
      case "regproc":
        return "eg: ";
      case "regpreocedure":
        return "eg: ";
      case "regrole":
        return "eg: ";
      case "regtype":
        return "eg: ";
      case "reltime":
        return "eg: ";
      case "serial":
        return "eg: ";
      case "serial2":
        return "eg: ";
      case "serial8":
        return "eg: ";
      case "smallint":
        return "eg: ";
      case "smallserial":
        return "eg: ";
      case "smgr":
        return "eg: ";
      case "text":
        return "eg: 'sample text'";
      case "tid":
        return "eg: ";
      case "time":
        return `eg: now()

'04:05:06.789'`;
      case "time without time zone":
        return `eg: now()

'04:05:06.789'`;
      case "timestamp":
        return `eg: now()

'2016-06-22 19:10:25-07'`;
      case "timestamp without time zone":
        return `eg: now()

'2016-06-22 19:10:25-07'`;
      case "timestamptz":
        return `eg: timezone('America/New_York','2016-06-01 00:00')

now()

'2016-06-22 19:10:25-07'`;
      case "timestamp with time zone":
        return `eg: now()

'2016-06-22 19:10:25-07'`;
      case "timetz":
        return "eg: now()";
      case "time with time zone":
        return "eg: now()";
      case "tinterval":
        return "eg: ";
      case "trigger":
        return "eg: ";
      case "tsm_handler":
        return "eg: ";
      case "tsquery":
        return "eg: ";
      case "tsrange":
        return "eg: ";
      case "tstzrange":
        return "eg: ";
      case "tsvector":
        return "eg: ";
      case "txid_snapshot":
        return "eg: ";
      case "unknown":
        return "eg: ";
      case "void":
        return "eg: ";
      case "xid":
        return "eg: ";
      case "xml":
        return "eg: ";
      case "character varying":
        return "eg: 'sample text'";
      case "tinyint":
        return "eg: ";
      case "mediumint":
        return "eg: ";
      case "float":
        return "eg: ";
      case "decimal":
        return "eg: ";
      case "double":
        return "eg: 1.2";
      case "boolean":
        return `eg: true

false`;
      case "datetime":
        return "eg: ";
      case "uuid":
        return "eg: ";
      case "year":
        return "eg: ";
      case "varchar":
        return "eg: ";
      case "nchar":
        return "eg: ";
      case "tinytext":
        return "eg: ";
      case "mediumtext":
        return "eg: ";
      case "longtext":
        return "eg: ";
      case "binary":
        return "eg: ";
      case "varbinary":
        return "eg: ";
      case "blob":
        return "eg: ";
      case "tinyblob":
        return "eg: ";
      case "mediumblob":
        return "eg: ";
      case "longblob":
        return "eg: ";
      case "enum":
        return "eg: ";
      case "set":
        return "eg: ";
      case "geometry":
        return "eg: ";
      case "linestring":
        return "eg: ";
      case "multipoint":
        return "eg: ";
      case "multilinestring":
        return "eg: ";
      case "multipolygon":
        return "eg: ";
    }
  }
  static getDefaultScaleForDatatype(t) {
    switch (t) {
      case "int":
        return " ";
      case "tinyint":
        return " ";
      case "smallint":
        return " ";
      case "mediumint":
        return " ";
      case "bigint":
        return " ";
      case "bit":
        return " ";
      case "boolean":
        return " ";
      case "float":
        return "2";
      case "decimal":
        return "2";
      case "double":
        return "2";
      case "serial":
        return " ";
      case "date":
      case "datetime":
      case "timestamp":
        return " ";
      case "time":
        return " ";
      case "year":
        return " ";
      case "char":
        return " ";
      case "varchar":
        return " ";
      case "nchar":
        return " ";
      case "text":
        return " ";
      case "tinytext":
        return " ";
      case "mediumtext":
        return " ";
      case "longtext":
        return " ";
      case "binary":
        return " ";
      case "varbinary":
        return " ";
      case "blob":
        return " ";
      case "tinyblob":
        return " ";
      case "mediumblob":
        return " ";
      case "longblob":
        return " ";
      case "enum":
        return " ";
      case "set":
        return " ";
      case "geometry":
        return " ";
      case "point":
        return " ";
      case "linestring":
        return " ";
      case "polygon":
        return " ";
      case "multipoint":
        return " ";
      case "multilinestring":
        return " ";
      case "multipolygon":
        return " ";
      case "json":
        return " ";
    }
  }
  static colPropAIDisabled(t, n) {
    if (t.dt === "int4" || t.dt === "integer" || t.dt === "bigint" || t.dt === "smallint") {
      for (let r = 0; r < n.length; ++r)
        if (n[r].cn !== t.cn && n[r].ai)
          return !0;
      return !1;
    } else
      return !0;
  }
  static colPropUNDisabled(t) {
    return !0;
  }
  static onCheckboxChangeAI(t) {
    console.log(t), (t.dt === "int" || t.dt === "bigint" || t.dt === "smallint" || t.dt === "tinyint") && (t.altered = t.altered || 2);
  }
  static onCheckboxChangeAU(t) {
    console.log(t), t.altered = t.altered || 2, t.au && (t.cdf = "now()");
  }
  static showScale() {
    return !1;
  }
  static removeUnsigned(t) {
    for (let n = 0; n < t.length; ++n)
      t[n].altered === 1 && !(t[n].dt === "int" || t[n].dt === "bigint" || t[n].dt === "tinyint" || t[n].dt === "smallint" || t[n].dt === "mediumint") && (t[n].un = !1, console.log(">> resetting unsigned value", t[n].cn)), console.log(t[n].cn);
  }
  static columnEditable(t) {
    return t.tn !== "_evolutions" || t.tn !== "nc_evolutions";
  }
  /*
  
    static extractFunctionName(query) {
      const reg =
        /^\s*CREATE\s+(?:OR\s+REPLACE\s*)?\s*FUNCTION\s+(?:[\w\d_]+\.)?([\w_\d]+)/i;
      const match = query.match(reg);
      return match && match[1];
    }
  
    static extractProcedureName(query) {
      const reg =
        /^\s*CREATE\s+(?:OR\s+REPLACE\s*)?\s*PROCEDURE\s+(?:[\w\d_]+\.)?([\w_\d]+)/i;
      const match = query.match(reg);
      return match && match[1];
    }
  
    static handleRawOutput(result, headers) {
      if (['DELETE', 'INSERT', 'UPDATE'].includes(result.command.toUpperCase())) {
        headers.push({ text: 'Row count', value: 'rowCount', sortable: false });
        result = [
          {
            rowCount: result.rowCount,
          },
        ];
      } else {
        result = result.rows;
        if (Array.isArray(result) && result[0]) {
          const keys = Object.keys(result[0]);
          // set headers before settings result
          for (let i = 0; i < keys.length; i++) {
            const text = keys[i];
            headers.push({ text, value: text, sortable: false });
          }
        }
      }
      return result;
    }
  
    static splitQueries(query) {
      /!***
       * we are splitting based on semicolon
       * there are mechanism to escape semicolon within single/double quotes(string)
       *!/
      return query.match(/\b("[^"]*;[^"]*"|'[^']*;[^']*'|[^;])*;/g);
    }
  
    /!**
     * if sql statement is SELECT - it limits to a number
     * @param args
     * @returns {string|*}
     *!/
    sanitiseQuery(args) {
      let q = args.query.trim().split(';');
  
      if (q[0].startsWith('Select')) {
        q = q[0] + ` LIMIT 0,${args.limit ? args.limit : 100};`;
      } else if (q[0].startsWith('select')) {
        q = q[0] + ` LIMIT 0,${args.limit ? args.limit : 100};`;
      } else if (q[0].startsWith('SELECT')) {
        q = q[0] + ` LIMIT 0,${args.limit ? args.limit : 100};`;
      } else {
        return args.query;
      }
  
      return q;
    }
  
    static getColumnsFromJson(json, tn) {
      const columns = [];
  
      try {
        if (typeof json === 'object' && !Array.isArray(json)) {
          const keys = Object.keys(json);
          for (let i = 0; i < keys.length; ++i) {
            const column = {
              dp: null,
              tn,
              column_name: keys[i],
              cno: keys[i],
              np: 10,
              ns: 0,
              clen: null,
              cop: 1,
              pk: false,
              nrqd: false,
              rqd: false,
              un: false,
              ct: 'int(11) unsigned',
              ai: false,
              unique: false,
              cdf: null,
              cc: '',
              csn: null,
              dtx: 'specificType',
              dtxp: null,
              dtxs: 0,
              altered: 1,
            };
  
            switch (typeof json[keys[i]]) {
              case 'number':
                if (Number.isInteger(json[keys[i]])) {
                  if (PgUi.isValidTimestamp(keys[i], json[keys[i]])) {
                    Object.assign(column, {
                      dt: 'timestamp',
                    });
                  } else {
                    Object.assign(column, {
                      dt: 'int',
                      np: 10,
                      ns: 0,
                    });
                  }
                } else {
                  Object.assign(column, {
                    dt: 'float4',
                    np: null,
                    ns: null,
                    dtxp: null,
                    dtxs: null,
                  });
                }
                break;
              case 'string':
                if (PgUi.isValidDate(json[keys[i]])) {
                  Object.assign(column, {
                    dt: 'date',
                  });
                } else if (json[keys[i]].length <= 255) {
                  Object.assign(column, {
                    dt: 'character varying',
                    np: null,
                    ns: 0,
                    dtxp: null,
                  });
                } else {
                  Object.assign(column, {
                    dt: 'text',
                  });
                }
                break;
              case 'boolean':
                Object.assign(column, {
                  dt: 'boolean',
                  np: 3,
                  ns: 0,
                });
                break;
              case 'object':
                Object.assign(column, {
                  dt: 'json',
                  np: 3,
                  ns: 0,
                });
                break;
              default:
                break;
            }
            columns.push(column);
          }
        }
      } catch (e) {
        console.log('Error in getColumnsFromJson', e);
      }
  
      return columns;
    }
  
    static isValidTimestamp(key, value) {
      if (typeof value !== 'number') {
        return false;
      }
      return new Date(value).getTime() > 0 && /(?:_|(?=A))[aA]t$/.test(key);
    }
  
    static isValidDate(value) {
      return new Date(value).getTime() > 0;
    }
  */
  static colPropAuDisabled(t) {
    if (t.altered !== 1)
      return !0;
    switch (t.dt) {
      case "time":
      case "time without time zone":
      case "timestamp":
      case "timestamp without time zone":
      case "timestamptz":
      case "timestamp with time zone":
      case "timetz":
      case "time with time zone":
        return !1;
      default:
        return !0;
    }
  }
  static getAbstractType(t) {
    var n;
    switch ((n = t.dt) == null ? void 0 : n.toLowerCase()) {
      case "anyenum":
        return "enum";
      case "anynonarray":
      case "anyrange":
        return "string";
      case "bit":
        return "integer";
      case "bool":
        return "boolean";
      case "box":
      case "bpchar":
      case "bytea":
      case "char":
      case "character":
        return "string";
      case "cid":
      case "cidr":
      case "circle":
      case "cstring":
        return "string";
      case "date":
        return "date";
      case "daterange":
        return "string";
      case "double precision":
        return "string";
      case "event_trigger":
      case "fdw_handler":
        return "string";
      case "float4":
      case "float8":
        return "float";
      case "gtsvector":
      case "index_am_handler":
      case "inet":
        return "string";
      case "int":
      case "int2":
      case "int4":
      case "int8":
      case "integer":
      case "bigint":
      case "bigserial":
        return "integer";
      case "int4range":
      case "int8range":
      case "internal":
      case "interval":
        return "string";
      case "language_handler":
      case "line":
      case "lsec":
      case "macaddr":
      case "money":
      case "name":
      case "numeric":
      case "numrange":
      case "oid":
      case "opaque":
      case "path":
      case "pg_ddl_command":
      case "pg_lsn":
      case "pg_node_tree":
      case "point":
      case "polygon":
        return "string";
      case "real":
        return "float";
      case "record":
      case "refcursor":
      case "regclass":
      case "regconfig":
      case "regdictionary":
      case "regnamespace":
      case "regoper":
      case "regoperator":
      case "regproc":
      case "regpreocedure":
      case "regrole":
      case "regtype":
      case "reltime":
        return "string";
      case "serial":
      case "serial2":
      case "serial8":
      case "smallint":
      case "smallserial":
        return "integer";
      case "smgr":
        return "string";
      case "text":
        return "text";
      case "tid":
        return "string";
      case "time":
      case "time without time zone":
        return "time";
      case "timestamp":
      case "timestamp without time zone":
      case "timestamptz":
      case "timestamp with time zone":
        return "datetime";
      case "timetz":
      case "time with time zone":
        return "time";
      case "tinterval":
      case "trigger":
      case "tsm_handler":
      case "tsquery":
      case "tsrange":
      case "tstzrange":
      case "tsvector":
      case "txid_snapshot":
      case "unknown":
      case "void":
      case "xid":
      case "character varying":
      case "xml":
        return "string";
      case "tinyint":
      case "mediumint":
        return "integer";
      case "float":
      case "decimal":
      case "double":
        return "float";
      case "boolean":
        return "boolean";
      case "datetime":
        return "datetime";
      case "uuid":
      case "year":
      case "varchar":
      case "nchar":
        return "string";
      case "tinytext":
      case "mediumtext":
      case "longtext":
        return "text";
      case "binary":
      case "varbinary":
        return "string";
      case "blob":
      case "tinyblob":
      case "mediumblob":
      case "longblob":
        return "blob";
      case "enum":
        return "enum";
      case "set":
        return "set";
      case "geometry":
      case "linestring":
      case "multipoint":
      case "multilinestring":
      case "multipolygon":
        return "string";
      case "json":
      case "jsonb":
        return "json";
    }
  }
  static getUIType(t) {
    switch (this.getAbstractType(t)) {
      case "integer":
        return "Number";
      case "boolean":
        return "Checkbox";
      case "float":
        return "Decimal";
      case "date":
        return "Date";
      case "datetime":
        return "CreatedTime";
      case "time":
        return "Time";
      case "year":
        return "Year";
      case "string":
        return "SingleLineText";
      case "text":
        return "LongText";
      case "blob":
        return "Attachment";
      case "enum":
        return "SingleSelect";
      case "set":
        return "MultiSelect";
      case "json":
        return "LongText";
    }
  }
  static getDataTypeForUiType(t, n) {
    const r = {};
    switch (t.uidt) {
      case "ID":
        {
          const a = n === "AI", o = n === "AG";
          r.dt = o ? "character varying" : "int4", r.pk = !0, r.un = a, r.ai = a, r.rqd = !0, r.meta = o ? { ag: "nc" } : void 0;
        }
        break;
      case "ForeignKey":
        r.dt = "character varying";
        break;
      case "SingleLineText":
        r.dt = "character varying";
        break;
      case "LongText":
        r.dt = "text";
        break;
      case "Attachment":
        r.dt = "text";
        break;
      case "GeoData":
        r.dt = "text";
        break;
      case "Checkbox":
        r.dt = "bool", r.cdf = "false";
        break;
      case "MultiSelect":
        r.dt = "text";
        break;
      case "SingleSelect":
        r.dt = "text";
        break;
      case "Collaborator":
        r.dt = "character varying";
        break;
      case "Date":
        r.dt = "date";
        break;
      case "Year":
        r.dt = "int";
        break;
      case "Time":
        r.dt = "time";
        break;
      case "PhoneNumber":
        r.dt = "character varying", r.validate = {
          func: ["isMobilePhone"],
          args: [""],
          msg: ["Validation failed : isMobilePhone"]
        };
        break;
      case "Email":
        r.dt = "character varying", r.validate = {
          func: ["isEmail"],
          args: [""],
          msg: ["Validation failed : isEmail"]
        };
        break;
      case "URL":
        r.dt = "character varying", r.validate = {
          func: ["isURL"],
          args: [""],
          msg: ["Validation failed : isURL"]
        };
        break;
      case "Number":
        r.dt = "bigint";
        break;
      case "Decimal":
        r.dt = "decimal";
        break;
      case "Currency":
        r.dt = "decimal", r.validate = {
          func: ["isCurrency"],
          args: [""],
          msg: ["Validation failed : isCurrency"]
        };
        break;
      case "Percent":
        r.dt = "double precision";
        break;
      case "Duration":
        r.dt = "decimal";
        break;
      case "Rating":
        r.dt = "smallint", r.cdf = "0";
        break;
      case "Formula":
        r.dt = "character varying";
        break;
      case "Rollup":
        r.dt = "character varying";
        break;
      case "Count":
        r.dt = "int8";
        break;
      case "Lookup":
        r.dt = "character varying";
        break;
      case "DateTime":
        r.dt = "timestamp";
        break;
      case "CreatedTime":
        r.dt = "timestamp";
        break;
      case "LastModifiedTime":
        r.dt = "timestamp";
        break;
      case "AutoNumber":
        r.dt = "int";
        break;
      case "Barcode":
        r.dt = "character varying";
        break;
      case "Button":
        r.dt = "character varying";
        break;
      case "JSON":
        r.dt = "json";
        break;
      default:
        r.dt = "character varying";
        break;
    }
    return r;
  }
  static getDataTypeListForUiType(t, n) {
    switch (t.uidt) {
      case "ID":
        return n === "AG" ? ["char", "character", "character varying"] : n === "AI" ? [
          "int",
          "integer",
          "bigint",
          "bigserial",
          "int2",
          "int4",
          "int8",
          "serial",
          "serial2",
          "serial8",
          "smallint",
          "smallserial"
        ] : B3;
      case "SingleLineText":
      case "LongText":
        return ["char", "character", "character varying", "text"];
      case "Attachment":
        return ["json", "char", "character", "character varying", "text"];
      case "JSON":
        return ["json", "jsonb", "text"];
      case "Checkbox":
        return [
          "bit",
          "bool",
          "int2",
          "int4",
          "int8",
          "boolean",
          "smallint",
          "int",
          "integer",
          "bigint",
          "bigserial",
          "char",
          "int4range",
          "int8range",
          "serial",
          "serial2",
          "serial8"
        ];
      case "MultiSelect":
        return ["text"];
      case "SingleSelect":
        return ["text"];
      case "Year":
        return ["int"];
      case "Time":
        return [
          "time",
          "time without time zone",
          "timestamp",
          "timestamp without time zone",
          "timestamptz",
          "timestamp with time zone",
          "timetz",
          "time with time zone"
        ];
      case "PhoneNumber":
      case "Email":
        return ["character varying"];
      case "URL":
        return ["character varying", "text"];
      case "Number":
        return [
          "int",
          "integer",
          "bigint",
          "bigserial",
          "int2",
          "int4",
          "int8",
          "serial",
          "serial2",
          "serial8",
          "double precision",
          "float4",
          "float8",
          "smallint",
          "smallserial",
          "numeric"
        ];
      case "Decimal":
        return ["double precision", "float4", "float8", "numeric"];
      case "Date":
        return [
          "date",
          "timestamp",
          "timestamp without time zone",
          "timestamptz",
          "timestamp with time zone"
        ];
      case "DateTime":
        return [
          "timestamp",
          "timestamp without time zone",
          "timestamptz",
          "timestamp with time zone"
        ];
      default:
        return B3;
    }
  }
  static getUnsupportedFnList() {
    return [];
  }
}
const qV = (e) => {
  const t = e || fM().jobs.listen;
  return async function n(r, a, o = 0) {
    try {
      const s = (await t({ data: { id: r }, _mid: o })).data;
      if (Array.isArray(s)) {
        let l = 0;
        for (const u of s) {
          if (u.status === "close")
            return a(u.data);
          u.status === "update" && a(u.data), l = u._mid;
        }
        await n(r, a, l);
      } else {
        if (s.status === "close")
          return a(s);
        s.status === "update" ? (a(s.data), await n(r, a, s._mid)) : s.status === "refresh" && await n(r, a, o);
      }
    } catch {
      setTimeout(() => {
        n(r, a, o);
      }, 1e3);
    }
  };
};
function Jl(e) {
  return fd() ? (vg(e), !0) : !1;
}
function Qs() {
  const e = /* @__PURE__ */ new Set(), t = (a) => {
    e.delete(a);
  };
  return {
    on: (a) => {
      e.add(a);
      const o = () => t(a);
      return Jl(o), {
        off: o
      };
    },
    off: t,
    trigger: (...a) => Promise.all(Array.from(e).map((o) => o(...a)))
  };
}
const _f = /* @__PURE__ */ new WeakMap(), XV = (e, t) => {
  var n;
  const r = (n = jn()) == null ? void 0 : n.proxy;
  if (r == null)
    throw new Error("provideLocal must be called in setup");
  _f.has(r) || _f.set(r, /* @__PURE__ */ Object.create(null));
  const a = _f.get(r);
  a[e] = t, kt(e, t);
}, ZV = (...e) => {
  var t;
  const n = e[0], r = (t = jn()) == null ? void 0 : t.proxy;
  if (r == null)
    throw new Error("injectLocal must be called in setup");
  return _f.has(r) && n in _f.get(r) ? _f.get(r)[n] : Ke(...e);
};
function QV(e, t) {
  const n = Symbol(e.name || "InjectionState"), r = void 0;
  return [(...i) => {
    const s = e(...i);
    return XV(n, s), s;
  }, () => ZV(n, r)];
}
function JV(e) {
  let t = 0, n, r;
  const a = () => {
    t -= 1, r && t <= 0 && (r.stop(), n = void 0, r = void 0);
  };
  return (...o) => (t += 1, n || (r = hg(!0), n = r.run(() => e(...o))), Jl(a), n);
}
function eU(e, t, { enumerable: n = !1, unwrap: r = !0 } = {}) {
  for (const [a, o] of Object.entries(t))
    a !== "value" && (Ft(o) && r ? Object.defineProperty(e, a, {
      get() {
        return o.value;
      },
      set(i) {
        o.value = i;
      },
      enumerable: n
    }) : Object.defineProperty(e, a, { value: o, enumerable: n }));
  return e;
}
function Io(e) {
  return typeof e == "function" ? e() : U(e);
}
const Fg = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const tU = (e) => typeof e < "u", nU = (e) => e != null, rU = Object.prototype.toString, aU = (e) => rU.call(e) === "[object Object]", Yu = () => {
}, oU = /* @__PURE__ */ iU();
function iU() {
  var e, t;
  return Fg && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function H8(e, t) {
  function n(...r) {
    return new Promise((a, o) => {
      Promise.resolve(e(() => t.apply(this, r), { fn: t, thisArg: this, args: r })).then(a).catch(o);
    });
  }
  return n;
}
const sU = (e) => e();
function j8(e, t = {}) {
  let n, r, a = Yu;
  const o = (s) => {
    clearTimeout(s), a(), a = Yu;
  };
  return (s) => {
    const l = Io(e), u = Io(t.maxWait);
    return n && o(n), l <= 0 || u !== void 0 && u <= 0 ? (r && (o(r), r = null), Promise.resolve(s())) : new Promise((c, f) => {
      a = t.rejectOnCancel ? f : c, u && !r && (r = setTimeout(() => {
        n && o(n), r = null, c(s());
      }, u)), n = setTimeout(() => {
        r && o(r), r = null, c(s());
      }, l);
    });
  };
}
function H3(e, t = !1, n = "Timeout") {
  return new Promise((r, a) => {
    setTimeout(t ? () => a(n) : r, e);
  });
}
function lU(e) {
  let t;
  function n() {
    return t || (t = e()), t;
  }
  return n.reset = async () => {
    const r = t;
    t = void 0, r && await r;
  }, n;
}
function uU(e) {
  return jn();
}
function cU(...e) {
  if (e.length !== 1)
    return Tt(...e);
  const t = e[0];
  return typeof t == "function" ? ql(xg(() => ({ get: t, set: Yu }))) : ne(t);
}
function V8(e, t = 200, n = {}) {
  return H8(
    j8(t, n),
    e
  );
}
function fU(e, t = {}) {
  let n = e, r, a;
  const o = xg((d, p) => (r = d, a = p, {
    get() {
      return i();
    },
    set(v) {
      s(v);
    }
  }));
  function i(d = !0) {
    return d && r(), n;
  }
  function s(d, p = !0) {
    var v, h;
    if (d === n)
      return;
    const m = n;
    ((v = t.onBeforeChange) == null ? void 0 : v.call(t, d, m)) !== !1 && (n = d, (h = t.onChanged) == null || h.call(t, d, m), p && a());
  }
  return eU(
    o,
    {
      get: i,
      set: s,
      untrackedGet: () => i(!1),
      silentSet: (d) => s(d, !1),
      peek: () => i(!1),
      lay: (d) => s(d, !1)
    },
    { enumerable: !0 }
  );
}
const dU = fU;
function pU(e, t, n = {}) {
  const {
    eventFilter: r = sU,
    ...a
  } = n;
  return He(
    e,
    H8(
      r,
      t
    ),
    a
  );
}
function hU(e, t = !0, n) {
  uU() ? Lt(e, n) : t ? e() : nn(e);
}
function $b(e, t = !1) {
  function n(f, { flush: d = "sync", deep: p = !1, timeout: v, throwOnTimeout: h } = {}) {
    let m = null;
    const x = [new Promise((g) => {
      m = He(
        e,
        (S) => {
          f(S) !== t && (m == null || m(), g(S));
        },
        {
          flush: d,
          deep: p,
          immediate: !0
        }
      );
    })];
    return v != null && x.push(
      H3(v, h).then(() => Io(e)).finally(() => m == null ? void 0 : m())
    ), Promise.race(x);
  }
  function r(f, d) {
    if (!Ft(f))
      return n((S) => S === f, d);
    const { flush: p = "sync", deep: v = !1, timeout: h, throwOnTimeout: m } = d ?? {};
    let y = null;
    const g = [new Promise((S) => {
      y = He(
        [e, f],
        ([w, _]) => {
          t !== (w === _) && (y == null || y(), S(w));
        },
        {
          flush: p,
          deep: v,
          immediate: !0
        }
      );
    })];
    return h != null && g.push(
      H3(h, m).then(() => Io(e)).finally(() => (y == null || y(), Io(e)))
    ), Promise.race(g);
  }
  function a(f) {
    return n((d) => !!d, f);
  }
  function o(f) {
    return r(null, f);
  }
  function i(f) {
    return r(void 0, f);
  }
  function s(f) {
    return n(Number.isNaN, f);
  }
  function l(f, d) {
    return n((p) => {
      const v = Array.from(p);
      return v.includes(f) || v.includes(Io(f));
    }, d);
  }
  function u(f) {
    return c(1, f);
  }
  function c(f = 1, d) {
    let p = -1;
    return n(() => (p += 1, p >= f), d);
  }
  return Array.isArray(Io(e)) ? {
    toMatch: n,
    toContains: l,
    changed: u,
    changedTimes: c,
    get not() {
      return $b(e, !t);
    }
  } : {
    toMatch: n,
    toBe: r,
    toBeTruthy: a,
    toBeNull: o,
    toBeNaN: s,
    toBeUndefined: i,
    changed: u,
    changedTimes: c,
    get not() {
      return $b(e, !t);
    }
  };
}
function j3(e) {
  return $b(e);
}
function vU(e = 0, t = {}) {
  let n = U(e);
  const r = ne(e), {
    max: a = Number.POSITIVE_INFINITY,
    min: o = Number.NEGATIVE_INFINITY
  } = t, i = (f = 1) => r.value = Math.max(Math.min(a, r.value + f), o), s = (f = 1) => r.value = Math.min(Math.max(o, r.value - f), a), l = () => r.value, u = (f) => r.value = Math.max(o, Math.min(a, f));
  return { count: r, inc: i, dec: s, get: l, set: u, reset: (f = n) => (n = f, u(f)) };
}
function mU(e, t, n = {}) {
  const {
    immediate: r = !0
  } = n, a = ne(!1);
  let o = null;
  function i() {
    o && (clearTimeout(o), o = null);
  }
  function s() {
    a.value = !1, i();
  }
  function l(...u) {
    i(), a.value = !0, o = setTimeout(() => {
      a.value = !1, o = null, e(...u);
    }, Io(t));
  }
  return r && (a.value = !0, Fg && l()), Jl(s), {
    isPending: ql(a),
    start: l,
    stop: s
  };
}
function gU(e, t, n = {}) {
  const {
    debounce: r = 0,
    maxWait: a = void 0,
    ...o
  } = n;
  return pU(
    e,
    t,
    {
      ...o,
      eventFilter: j8(r, { maxWait: a })
    }
  );
}
function yU(e, t, n) {
  const r = He(e, (...a) => (nn(() => r()), t(...a)), n);
  return r;
}
function ns(e) {
  var t;
  const n = Io(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const md = Fg ? window : void 0, U8 = Fg ? window.navigator : void 0;
function or(...e) {
  let t, n, r, a;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, r, a] = e, t = md) : [t, n, r, a] = e, !t)
    return Yu;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const o = [], i = () => {
    o.forEach((c) => c()), o.length = 0;
  }, s = (c, f, d, p) => (c.addEventListener(f, d, p), () => c.removeEventListener(f, d, p)), l = He(
    () => [ns(t), Io(a)],
    ([c, f]) => {
      if (i(), !c)
        return;
      const d = aU(f) ? { ...f } : f;
      o.push(
        ...n.flatMap((p) => r.map((v) => s(c, p, v, d)))
      );
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    l(), i();
  };
  return Jl(u), u;
}
let V3 = !1;
function Np(e, t, n = {}) {
  const { window: r = md, ignore: a = [], capture: o = !0, detectIframe: i = !1 } = n;
  if (!r)
    return Yu;
  oU && !V3 && (V3 = !0, Array.from(r.document.body.children).forEach((d) => d.addEventListener("click", Yu)), r.document.documentElement.addEventListener("click", Yu));
  let s = !0;
  const l = (d) => a.some((p) => {
    if (typeof p == "string")
      return Array.from(r.document.querySelectorAll(p)).some((v) => v === d.target || d.composedPath().includes(v));
    {
      const v = ns(p);
      return v && (d.target === v || d.composedPath().includes(v));
    }
  }), c = [
    or(r, "click", (d) => {
      const p = ns(e);
      if (!(!p || p === d.target || d.composedPath().includes(p))) {
        if (d.detail === 0 && (s = !l(d)), !s) {
          s = !0;
          return;
        }
        t(d);
      }
    }, { passive: !0, capture: o }),
    or(r, "pointerdown", (d) => {
      const p = ns(e);
      s = !l(d) && !!(p && !d.composedPath().includes(p));
    }, { passive: !0 }),
    i && or(r, "blur", (d) => {
      setTimeout(() => {
        var p;
        const v = ns(e);
        ((p = r.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(v != null && v.contains(r.document.activeElement)) && t(d);
      }, 0);
    })
  ].filter(Boolean);
  return () => c.forEach((d) => d());
}
function xU(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function Hf(...e) {
  let t, n, r = {};
  e.length === 3 ? (t = e[0], n = e[1], r = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], r = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
  const {
    target: a = md,
    eventName: o = "keydown",
    passive: i = !1,
    dedupe: s = !1
  } = r, l = xU(t);
  return or(a, o, (c) => {
    c.repeat && Io(s) || l(c) && n(c);
  }, i);
}
function bU() {
  const e = ne(!1), t = jn();
  return t && Lt(() => {
    e.value = !0;
  }, t), e;
}
function Lg(e) {
  const t = bU();
  return V(() => (t.value, !!e()));
}
function wU(e, t, n = {}) {
  const { window: r = md, ...a } = n;
  let o;
  const i = Lg(() => r && "MutationObserver" in r), s = () => {
    o && (o.disconnect(), o = void 0);
  }, l = V(() => {
    const d = Io(e), p = (Array.isArray(d) ? d : [d]).map(ns).filter(nU);
    return new Set(p);
  }), u = He(
    () => l.value,
    (d) => {
      s(), i.value && d.size && (o = new MutationObserver(t), d.forEach((p) => o.observe(p, a)));
    },
    { immediate: !0, flush: "post" }
  ), c = () => o == null ? void 0 : o.takeRecords(), f = () => {
    s(), u();
  };
  return Jl(f), {
    isSupported: i,
    stop: f,
    takeRecords: c
  };
}
function U3(e, t = {}) {
  const {
    controls: n = !1,
    navigator: r = U8
  } = t, a = Lg(() => r && "permissions" in r);
  let o;
  const i = typeof e == "string" ? { name: e } : e, s = ne(), l = () => {
    o && (s.value = o.state);
  }, u = lU(async () => {
    if (a.value) {
      if (!o)
        try {
          o = await r.permissions.query(i), or(o, "change", l), l();
        } catch {
          s.value = "prompt";
        }
      return o;
    }
  });
  return u(), n ? {
    state: s,
    isSupported: a,
    query: u
  } : s;
}
function SU(e = {}) {
  const {
    navigator: t = U8,
    read: n = !1,
    source: r,
    copiedDuring: a = 1500,
    legacy: o = !1
  } = e, i = Lg(() => t && "clipboard" in t), s = U3("clipboard-read"), l = U3("clipboard-write"), u = V(() => i.value || o), c = ne(""), f = ne(!1), d = mU(() => f.value = !1, a);
  function p() {
    i.value && y(s.value) ? t.clipboard.readText().then((x) => {
      c.value = x;
    }) : c.value = m();
  }
  u.value && n && or(["copy", "cut"], p);
  async function v(x = Io(r)) {
    u.value && x != null && (i.value && y(l.value) ? await t.clipboard.writeText(x) : h(x), c.value = x, f.value = !0, d.start());
  }
  function h(x) {
    const g = document.createElement("textarea");
    g.value = x ?? "", g.style.position = "absolute", g.style.opacity = "0", document.body.appendChild(g), g.select(), document.execCommand("copy"), g.remove();
  }
  function m() {
    var x, g, S;
    return (S = (g = (x = document == null ? void 0 : document.getSelection) == null ? void 0 : x.call(document)) == null ? void 0 : g.toString()) != null ? S : "";
  }
  function y(x) {
    return x === "granted" || x === "prompt";
  }
  return {
    isSupported: u,
    text: c,
    copied: f,
    copy: v
  };
}
function _U(e) {
  return JSON.parse(JSON.stringify(e));
}
function CU(e, t, n = {}) {
  const { window: r = md, ...a } = n;
  let o;
  const i = Lg(() => r && "ResizeObserver" in r), s = () => {
    o && (o.disconnect(), o = void 0);
  }, l = V(() => Array.isArray(e) ? e.map((f) => ns(f)) : [ns(e)]), u = He(
    l,
    (f) => {
      if (s(), i.value && r) {
        o = new ResizeObserver(t);
        for (const d of f)
          d && o.observe(d, a);
      }
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    s(), u();
  };
  return Jl(c), {
    isSupported: i,
    stop: c
  };
}
function EU(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: r = !0,
    windowScroll: a = !0,
    immediate: o = !0
  } = t, i = ne(0), s = ne(0), l = ne(0), u = ne(0), c = ne(0), f = ne(0), d = ne(0), p = ne(0);
  function v() {
    const h = ns(e);
    if (!h) {
      n && (i.value = 0, s.value = 0, l.value = 0, u.value = 0, c.value = 0, f.value = 0, d.value = 0, p.value = 0);
      return;
    }
    const m = h.getBoundingClientRect();
    i.value = m.height, s.value = m.bottom, l.value = m.left, u.value = m.right, c.value = m.top, f.value = m.width, d.value = m.x, p.value = m.y;
  }
  return CU(e, v), He(() => ns(e), (h) => !h && v()), wU(e, v, {
    attributeFilter: ["style", "class"]
  }), a && or("scroll", v, { capture: !0, passive: !0 }), r && or("resize", v, { passive: !0 }), hU(() => {
    o && v();
  }), {
    height: i,
    bottom: s,
    left: l,
    right: u,
    top: c,
    width: f,
    x: d,
    y: p,
    update: v
  };
}
function TU(e, t = {}) {
  const {
    delayEnter: n = 0,
    delayLeave: r = 0,
    window: a = md
  } = t, o = ne(!1);
  let i;
  const s = (l) => {
    const u = l ? n : r;
    i && (clearTimeout(i), i = void 0), u ? i = setTimeout(() => o.value = l, u) : o.value = l;
  };
  return a && (or(e, "mouseenter", () => s(!0), { passive: !0 }), or(e, "mouseleave", () => s(!1), { passive: !0 })), o;
}
const Fd = /* @__PURE__ */ new Map();
function $U(e) {
  const t = fd();
  function n(s) {
    var l;
    const u = Fd.get(e) || /* @__PURE__ */ new Set();
    u.add(s), Fd.set(e, u);
    const c = () => a(s);
    return (l = t == null ? void 0 : t.cleanups) == null || l.push(c), c;
  }
  function r(s) {
    function l(...u) {
      a(l), s(...u);
    }
    return n(l);
  }
  function a(s) {
    const l = Fd.get(e);
    l && (l.delete(s), l.size || o());
  }
  function o() {
    Fd.delete(e);
  }
  function i(s, l) {
    var u;
    (u = Fd.get(e)) == null || u.forEach((c) => c(s, l));
  }
  return { on: n, once: r, off: a, emit: i, reset: o };
}
function OU(e, t) {
  const n = Be(t);
  return He(
    cU(e),
    (r, a) => {
      n.value = a;
    },
    { flush: "sync" }
  ), ql(n);
}
function Ra(e, t, n, r = {}) {
  var a, o, i;
  const {
    clone: s = !1,
    passive: l = !1,
    eventName: u,
    deep: c = !1,
    defaultValue: f,
    shouldEmit: d
  } = r, p = jn(), v = n || (p == null ? void 0 : p.emit) || ((a = p == null ? void 0 : p.$emit) == null ? void 0 : a.bind(p)) || ((i = (o = p == null ? void 0 : p.proxy) == null ? void 0 : o.$emit) == null ? void 0 : i.bind(p == null ? void 0 : p.proxy));
  let h = u;
  t || (t = "modelValue"), h = h || `update:${t.toString()}`;
  const m = (g) => s ? typeof s == "function" ? s(g) : _U(g) : g, y = () => tU(e[t]) ? m(e[t]) : f, x = (g) => {
    d ? d(g) && v(h, g) : v(h, g);
  };
  if (l) {
    const g = y(), S = ne(g);
    let w = !1;
    return He(
      () => e[t],
      (_) => {
        w || (w = !0, S.value = m(_), nn(() => w = !1));
      }
    ), He(
      S,
      (_) => {
        !w && (_ !== e[t] || c) && x(_);
      },
      { deep: c }
    ), S;
  } else
    return V({
      get() {
        return y();
      },
      set(g) {
        x(g);
      }
    });
}
const AU = Symbol("is-group-by-injection"), vi = Symbol("readonly-injection"), z8 = Symbol("is-locked-injection"), _c = Symbol("is-public"), vo = Symbol("reload-view-data-injection"), IU = Symbol("scroll-parent-injection"), bs = Symbol("column-injection"), Bg = Symbol("reload-row-data-injection"), Hg = Symbol("cell-click-injection"), W8 = Symbol("current-cell-injection"), gd = Symbol("edit-mode-injection"), Cc = Symbol("active-cell"), jo = Symbol("edit-column-injection"), G8 = Symbol("all-filters-injection"), K8 = Symbol("toolbar-injection"), L_ = Symbol("events-injection"), Y8 = Symbol("poller-injection"), jg = Symbol(
  "show-system-fields-injection"
), q8 = Symbol("force-reload-data-injection"), mo = kp("tablesStore", () => {
  const { api: e } = Na(), t = ne(/* @__PURE__ */ new Map()), n = ne(), r = async (s, l = !1) => {
    var f;
    if (!l && t.value.get(s) || t.value.get(s) && !l)
      return;
    const c = await e.dbTable.list(s);
    (f = c.list) == null || f.forEach((d) => {
      let p = d.meta;
      if (typeof p == "string")
        try {
          p = JSON.parse(p);
        } catch (v) {
          console.error(v);
        }
      p || (p = {}), d.meta = p;
    }), t.value.set(s, c.list || []);
  }, a = (s, l) => {
    n.value = l;
    const u = t.value.get(s);
    if (u) {
      if (u.some((c) => c.id === l.id))
        return;
      u.push(l);
      return;
    }
    t.value.set(s, [l]);
  }, o = Ke(L_);
  return {
    baseTables: t,
    tableActivated: n,
    activeTable: a,
    loadProjectTables: r,
    updateTable: async () => {
      var s;
      (s = o.onTableMetaUpdated) == null || s.call(o);
    }
  };
}), ws = kp("baseStore", () => {
  const { isLoading: e } = Na(), t = ne(/* @__PURE__ */ new Map()), n = ne(), r = (y) => {
    n.value = y, t.value.set(y.id, y);
  }, a = V(() => {
    var y;
    return (y = n.value) == null ? void 0 : y.id;
  }), o = mo(), i = V(() => o.baseTables.get(a.value) || []), s = Qs(), l = V(() => {
    var y;
    return ((y = n.value) == null ? void 0 : y.sources) || [];
  }), u = ne({}), c = V(() => {
    const y = {
      showNullAndEmptyInFilter: !1
    };
    try {
      return (typeof n.value.meta == "string" ? JSON.parse(n.value.meta) : n.value.meta) ?? y;
    } catch {
      return y;
    }
  }), f = V(() => {
    const y = {};
    for (const x of l.value)
      x.id && (y[x.id] = YV);
    return y;
  });
  function d(y) {
    var x;
    return ((x = l.value.find((g) => g.id === y)) == null ? void 0 : x.type) || h8.MYSQL;
  }
  function p(y) {
    const x = l.value.find((g) => g.id === y);
    return (x == null ? void 0 : x.is_meta) || (x == null ? void 0 : x.is_local) || !1;
  }
  async function v() {
    n.value.id && await o.loadProjectTables(n.value.id, !0);
  }
  async function h() {
    if (!a.value) {
      console.warn("Base id not found");
      return;
    }
    return await v(), s.trigger(n.value);
  }
  return {
    base: n,
    setBase: r,
    sources: l,
    tables: i,
    loadProject: h,
    loadTables: v,
    sqlUis: f,
    baseMeta: c,
    isLoading: e,
    lastOpenedViewMap: u,
    isXcdbBase: p,
    baseUrl: ({ id: y }) => `/nc/${y}`,
    getBaseType: d
  };
});
function Vg(e, t = "InjectionState") {
  const n = Symbol(t);
  let r;
  const a = (...i) => {
    const s = e(...i);
    return kt(n, s), r = s, Jl(() => {
      r = void 0;
    }), s;
  }, o = () => {
    let i = Ke(n, void 0);
    return typeof i > "u" && (i = r), i;
  };
  return Jl(() => {
    r = void 0;
  }), [a, o];
}
const X8 = kp("fieldQueryStore", () => {
  const e = ne({
    field: "",
    query: ""
  }), t = ne({});
  return { search: e, loadFieldQuery: (r) => {
    r && (r in t.value || (t.value[r] = { field: "", query: "" }), e.value = t.value[r]);
  } };
}), [PU, DU] = Vg(
  (e, t, n, r) => {
    const { activeSorts: a } = Fn(pd()), o = ws(), i = $U(Symbol("SmartsheetStore")), s = V(() => {
      var m, y;
      return (y = (m = t.value) == null ? void 0 : m.columns) == null ? void 0 : y.some((x) => x.pk);
    }), { sqlUis: l } = Fn(o), u = V(() => {
      var y;
      const m = (y = t.value) == null ? void 0 : y.source_id;
      return m ? l.value[m] : Object.values(l.value)[0];
    }), c = X8(), { search: f } = Fn(c), d = V(() => {
      var x, g, S, w, _, b;
      let m;
      const y = ((g = (x = t.value) == null ? void 0 : x.columns) == null ? void 0 : g.find(({ id: E }) => E === f.value.field)) || ((w = (S = t.value) == null ? void 0 : S.columns) == null ? void 0 : w.find((E) => E.pv));
      if (!(!y || !((_ = f.value.query) != null && _.trim())))
        return ["text", "string"].includes((b = u.value) == null ? void 0 : b.getAbstractType(y)) && y.dt !== "bigint" ? m = `(${y.title},like,%${f.value.query.trim()}%)` : m = `(${y.title},eq,${f.value.query.trim()})`, m;
    }), p = ne(U(n) ?? []), v = ne([]), h = ne(U(r) ?? []);
    return He(
      p,
      () => {
        a.value = p.value;
      },
      {
        immediate: !0
      }
    ), He(
      h,
      () => {
        v.value = h.value;
      },
      { immediate: !0 }
    ), {
      // view,
      meta: t,
      // isLocked,
      xWhere: d,
      isPkAvail: s,
      sorts: p,
      nestedFilters: h,
      eventBus: i,
      sqlUi: u
    };
  },
  "smartsheet-store"
);
function Ss() {
  const e = DU();
  if (!e)
    throw new Error("Please call `useProvideSmartsheetStore` on the appropriate parent component");
  return e;
}
const [B_, kU] = Vg(
  (e, t) => {
    const n = ne(t), r = ne({}), a = V(() => U(t).rowMeta.new ?? !1);
    return {
      row: t,
      state: r,
      isNew: a,
      currentRow: n
    };
  },
  "smartsheet-row-store"
);
function MU() {
  const e = kU();
  if (e == null)
    throw new Error("Please call `useSmartsheetRowStore` on the appropriate parent component");
  return e;
}
var ra = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ki(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Z8(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var a = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var RU = NU;
function Cf(e) {
  return e instanceof Buffer ? Buffer.from(e) : new e.constructor(e.buffer.slice(), e.byteOffset, e.length);
}
function NU(e) {
  if (e = e || {}, e.circles) return FU(e);
  const t = /* @__PURE__ */ new Map();
  if (t.set(Date, (i) => new Date(i)), t.set(Map, (i, s) => new Map(r(Array.from(i), s))), t.set(Set, (i, s) => new Set(r(Array.from(i), s))), e.constructorHandlers)
    for (const i of e.constructorHandlers)
      t.set(i[0], i[1]);
  let n = null;
  return e.proto ? o : a;
  function r(i, s) {
    const l = Object.keys(i), u = new Array(l.length);
    for (let c = 0; c < l.length; c++) {
      const f = l[c], d = i[f];
      typeof d != "object" || d === null ? u[f] = d : d.constructor !== Object && (n = t.get(d.constructor)) ? u[f] = n(d, s) : ArrayBuffer.isView(d) ? u[f] = Cf(d) : u[f] = s(d);
    }
    return u;
  }
  function a(i) {
    if (typeof i != "object" || i === null) return i;
    if (Array.isArray(i)) return r(i, a);
    if (i.constructor !== Object && (n = t.get(i.constructor)))
      return n(i, a);
    const s = {};
    for (const l in i) {
      if (Object.hasOwnProperty.call(i, l) === !1) continue;
      const u = i[l];
      typeof u != "object" || u === null ? s[l] = u : u.constructor !== Object && (n = t.get(u.constructor)) ? s[l] = n(u, a) : ArrayBuffer.isView(u) ? s[l] = Cf(u) : s[l] = a(u);
    }
    return s;
  }
  function o(i) {
    if (typeof i != "object" || i === null) return i;
    if (Array.isArray(i)) return r(i, o);
    if (i.constructor !== Object && (n = t.get(i.constructor)))
      return n(i, o);
    const s = {};
    for (const l in i) {
      const u = i[l];
      typeof u != "object" || u === null ? s[l] = u : u.constructor !== Object && (n = t.get(u.constructor)) ? s[l] = n(u, o) : ArrayBuffer.isView(u) ? s[l] = Cf(u) : s[l] = o(u);
    }
    return s;
  }
}
function FU(e) {
  const t = [], n = [], r = /* @__PURE__ */ new Map();
  if (r.set(Date, (l) => new Date(l)), r.set(Map, (l, u) => new Map(o(Array.from(l), u))), r.set(Set, (l, u) => new Set(o(Array.from(l), u))), e.constructorHandlers)
    for (const l of e.constructorHandlers)
      r.set(l[0], l[1]);
  let a = null;
  return e.proto ? s : i;
  function o(l, u) {
    const c = Object.keys(l), f = new Array(c.length);
    for (let d = 0; d < c.length; d++) {
      const p = c[d], v = l[p];
      if (typeof v != "object" || v === null)
        f[p] = v;
      else if (v.constructor !== Object && (a = r.get(v.constructor)))
        f[p] = a(v, u);
      else if (ArrayBuffer.isView(v))
        f[p] = Cf(v);
      else {
        const h = t.indexOf(v);
        h !== -1 ? f[p] = n[h] : f[p] = u(v);
      }
    }
    return f;
  }
  function i(l) {
    if (typeof l != "object" || l === null) return l;
    if (Array.isArray(l)) return o(l, i);
    if (l.constructor !== Object && (a = r.get(l.constructor)))
      return a(l, i);
    const u = {};
    t.push(l), n.push(u);
    for (const c in l) {
      if (Object.hasOwnProperty.call(l, c) === !1) continue;
      const f = l[c];
      if (typeof f != "object" || f === null)
        u[c] = f;
      else if (f.constructor !== Object && (a = r.get(f.constructor)))
        u[c] = a(f, i);
      else if (ArrayBuffer.isView(f))
        u[c] = Cf(f);
      else {
        const d = t.indexOf(f);
        d !== -1 ? u[c] = n[d] : u[c] = i(f);
      }
    }
    return t.pop(), n.pop(), u;
  }
  function s(l) {
    if (typeof l != "object" || l === null) return l;
    if (Array.isArray(l)) return o(l, s);
    if (l.constructor !== Object && (a = r.get(l.constructor)))
      return a(l, s);
    const u = {};
    t.push(l), n.push(u);
    for (const c in l) {
      const f = l[c];
      if (typeof f != "object" || f === null)
        u[c] = f;
      else if (f.constructor !== Object && (a = r.get(f.constructor)))
        u[c] = a(f, s);
      else if (ArrayBuffer.isView(f))
        u[c] = Cf(f);
      else {
        const d = t.indexOf(f);
        d !== -1 ? u[c] = n[d] : u[c] = s(f);
      }
    }
    return t.pop(), n.pop(), u;
  }
}
const Q8 = /* @__PURE__ */ Ki(RU);
function ep(e) {
  "@babel/helpers - typeof";
  return ep = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ep(e);
}
function LU(e, t) {
  if (ep(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (ep(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function BU(e) {
  var t = LU(e, "string");
  return ep(t) == "symbol" ? t : t + "";
}
function HU(e, t, n) {
  return (t = BU(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function z3(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ve(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? z3(Object(n), !0).forEach(function(r) {
      HU(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : z3(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function D() {
  return D = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, D.apply(null, arguments);
}
const jU = (e) => typeof e == "function", VU = Array.isArray, UU = (e) => typeof e == "string", zU = (e) => e !== null && typeof e == "object", WU = /^on[^a-z]/, GU = (e) => WU.test(e), H_ = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, KU = /-(\w)/g, J8 = H_((e) => e.replace(KU, (t, n) => n ? n.toUpperCase() : "")), YU = /\B([A-Z])/g, qU = H_((e) => e.replace(YU, "-$1").toLowerCase()), XU = H_((e) => e.charAt(0).toUpperCase() + e.slice(1)), ZU = Object.prototype.hasOwnProperty, W3 = (e, t) => ZU.call(e, t);
function QU(e, t, n, r) {
  const a = e[n];
  if (a != null) {
    const o = W3(a, "default");
    if (o && r === void 0) {
      const i = a.default;
      r = a.type !== Function && jU(i) ? i() : i;
    }
    a.type === Boolean && (!W3(t, n) && !o ? r = !1 : r === "" && (r = !0));
  }
  return r;
}
function df(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
  return typeof e == "function" ? e(t) : e ?? n;
}
function JU(e) {
  let t;
  const n = new Promise((a) => {
    t = e(() => {
      a(!0);
    });
  }), r = () => {
    t == null || t();
  };
  return r.then = (a, o) => n.then(a, o), r.promise = n, r;
}
function Ge() {
  const e = [];
  for (let t = 0; t < arguments.length; t++) {
    const n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    if (n) {
      if (UU(n))
        e.push(n);
      else if (VU(n))
        for (let r = 0; r < n.length; r++) {
          const a = Ge(n[r]);
          a && e.push(a);
        }
      else if (zU(n))
        for (const r in n)
          n[r] && e.push(r);
    }
  }
  return e.join(" ");
}
var eI = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, n) {
    var r = -1;
    return t.some(function(a, o) {
      return a[0] === n ? (r = o, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(n) {
        var r = e(this.__entries__, n), a = this.__entries__[r];
        return a && a[1];
      }, t.prototype.set = function(n, r) {
        var a = e(this.__entries__, n);
        ~a ? this.__entries__[a][1] = r : this.__entries__.push([n, r]);
      }, t.prototype.delete = function(n) {
        var r = this.__entries__, a = e(r, n);
        ~a && r.splice(a, 1);
      }, t.prototype.has = function(n) {
        return !!~e(this.__entries__, n);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var a = 0, o = this.__entries__; a < o.length; a++) {
          var i = o[a];
          n.call(r, i[1], i[0]);
        }
      }, t;
    }()
  );
}(), Ob = typeof window < "u" && typeof document < "u" && window.document === document, vm = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), ez = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(vm) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), tz = 2;
function nz(e, t) {
  var n = !1, r = !1, a = 0;
  function o() {
    n && (n = !1, e()), r && s();
  }
  function i() {
    ez(o);
  }
  function s() {
    var l = Date.now();
    if (n) {
      if (l - a < tz)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(i, t);
    a = l;
  }
  return s;
}
var rz = 20, az = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], oz = typeof MutationObserver < "u", iz = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = nz(this.refresh.bind(this), rz);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var n = this.observers_, r = n.indexOf(t);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return t.forEach(function(n) {
        return n.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !Ob || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), oz ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !Ob || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var n = t.propertyName, r = n === void 0 ? "" : n, a = az.some(function(o) {
        return !!~r.indexOf(o);
      });
      a && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), tI = function(e, t) {
  for (var n = 0, r = Object.keys(t); n < r.length; n++) {
    var a = r[n];
    Object.defineProperty(e, a, {
      value: t[a],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, jf = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || vm;
}, nI = Ug(0, 0, 0, 0);
function mm(e) {
  return parseFloat(e) || 0;
}
function G3(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.reduce(function(r, a) {
    var o = e["border-" + a + "-width"];
    return r + mm(o);
  }, 0);
}
function sz(e) {
  for (var t = ["top", "right", "bottom", "left"], n = {}, r = 0, a = t; r < a.length; r++) {
    var o = a[r], i = e["padding-" + o];
    n[o] = mm(i);
  }
  return n;
}
function lz(e) {
  var t = e.getBBox();
  return Ug(0, 0, t.width, t.height);
}
function uz(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!t && !n)
    return nI;
  var r = jf(e).getComputedStyle(e), a = sz(r), o = a.left + a.right, i = a.top + a.bottom, s = mm(r.width), l = mm(r.height);
  if (r.boxSizing === "border-box" && (Math.round(s + o) !== t && (s -= G3(r, "left", "right") + o), Math.round(l + i) !== n && (l -= G3(r, "top", "bottom") + i)), !fz(e)) {
    var u = Math.round(s + o) - t, c = Math.round(l + i) - n;
    Math.abs(u) !== 1 && (s -= u), Math.abs(c) !== 1 && (l -= c);
  }
  return Ug(a.left, a.top, s, l);
}
var cz = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof jf(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof jf(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function fz(e) {
  return e === jf(e).document.documentElement;
}
function dz(e) {
  return Ob ? cz(e) ? lz(e) : uz(e) : nI;
}
function pz(e) {
  var t = e.x, n = e.y, r = e.width, a = e.height, o = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, i = Object.create(o.prototype);
  return tI(i, {
    x: t,
    y: n,
    width: r,
    height: a,
    top: n,
    right: t + r,
    bottom: a + n,
    left: t
  }), i;
}
function Ug(e, t, n, r) {
  return { x: e, y: t, width: n, height: r };
}
var hz = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Ug(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = dz(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), vz = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      var r = pz(n);
      tI(this, { target: t, contentRect: r });
    }
    return e;
  }()
), mz = (
  /** @class */
  function() {
    function e(t, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new eI(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = n, this.callbackCtx_ = r;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof jf(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) || (n.set(t, new hz(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof jf(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) && (n.delete(t), n.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && t.activeObservations_.push(n);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new vz(r.target, r.broadcastRect());
        });
        this.callback_.call(t, n, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), rI = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new eI(), aI = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = iz.getInstance(), r = new mz(t, n, this);
      rI.set(this, r);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  aI.prototype[e] = function() {
    var t;
    return (t = rI.get(this))[e].apply(t, arguments);
  };
});
var oI = function() {
  return typeof vm.ResizeObserver < "u" ? vm.ResizeObserver : aI;
}();
const Ab = (e) => e != null && e !== "", ha = (e, t) => {
  const n = D({}, e);
  return Object.keys(t).forEach((r) => {
    const a = n[r];
    if (a)
      a.type || a.default ? a.default = t[r] : a.def ? a.def(t[r]) : n[r] = {
        type: a,
        default: t[r]
      };
    else
      throw new Error(`not have ${r} prop`);
  }), n;
}, iI = (e) => {
  const t = Object.keys(e), n = {}, r = {}, a = {};
  for (let o = 0, i = t.length; o < i; o++) {
    const s = t[o];
    GU(s) ? (n[s[2].toLowerCase() + s.slice(3)] = e[s], r[s] = e[s]) : a[s] = e[s];
  }
  return {
    onEvents: r,
    events: n,
    extraAttrs: a
  };
}, gz = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const n = {}, r = /;(?![^(]*\))/g, a = /:(.+)/;
  return typeof e == "object" ? e : (e.split(r).forEach(function(o) {
    if (o) {
      const i = o.split(a);
      if (i.length > 1) {
        const s = t ? J8(i[0].trim()) : i[0].trim();
        n[s] = i[1].trim();
      }
    }
  }), n);
}, rf = (e, t) => e[t] !== void 0, sI = Symbol("skipFlatten"), ua = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  const n = Array.isArray(e) ? e : [e], r = [];
  return n.forEach((a) => {
    Array.isArray(a) ? r.push(...ua(a, t)) : a && a.type === dt ? a.key === sI ? r.push(a) : r.push(...ua(a.children, t)) : a && ka(a) ? t && !uI(a) ? r.push(a) : t || r.push(a) : Ab(a) && r.push(a);
  }), r;
}, yz = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (ka(e))
    return e.type === dt ? t === "default" ? ua(e.children) : [] : e.children && e.children[t] ? ua(e.children[t](n)) : [];
  {
    const r = e.$slots[t] && e.$slots[t](n);
    return ua(r);
  }
}, js = (e) => {
  var t;
  let n = ((t = e == null ? void 0 : e.vnode) === null || t === void 0 ? void 0 : t.el) || e && (e.$el || e);
  for (; n && !n.tagName; )
    n = n.nextSibling;
  return n;
}, xz = (e) => {
  const t = {};
  if (e.$ && e.$.vnode) {
    const n = e.$.vnode.props || {};
    Object.keys(e.$props).forEach((r) => {
      const a = e.$props[r], o = qU(r);
      (a !== void 0 || o in n) && (t[r] = a);
    });
  } else if (ka(e) && typeof e.type == "object") {
    const n = e.props || {}, r = {};
    Object.keys(n).forEach((o) => {
      r[J8(o)] = n[o];
    });
    const a = e.type.props || {};
    Object.keys(a).forEach((o) => {
      const i = QU(a, r, o, r[o]);
      (i !== void 0 || o in r) && (t[o] = i);
    });
  }
  return t;
}, lI = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, a;
  if (e.$) {
    const o = e[t];
    if (o !== void 0)
      return typeof o == "function" && r ? o(n) : o;
    a = e.$slots[t], a = r && a ? a(n) : a;
  } else if (ka(e)) {
    const o = e.props && e.props[t];
    if (o !== void 0 && e.props !== null)
      return typeof o == "function" && r ? o(n) : o;
    e.type === dt ? a = e.children : e.children && e.children[t] && (a = e.children[t], a = r && a ? a(n) : a);
  }
  return Array.isArray(a) && (a = ua(a), a = a.length === 1 ? a[0] : a, a = a.length === 0 ? void 0 : a), a;
};
function K3() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, n = {};
  return e.$ ? n = D(D({}, n), e.$attrs) : n = D(D({}, n), e.props), iI(n)[t ? "onEvents" : "events"];
}
function bz(e, t) {
  let r = ((ka(e) ? e.props : e.$attrs) || {}).style || {};
  return typeof r == "string" && (r = gz(r, t)), r;
}
function wz(e) {
  return e.length === 1 && e[0].type === dt;
}
function uI(e) {
  return e && (e.type === tr || e.type === dt && e.children.length === 0 || e.type === Bi && e.children.trim() === "");
}
function _s() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  const t = [];
  return e.forEach((n) => {
    Array.isArray(n) ? t.push(...n) : (n == null ? void 0 : n.type) === dt ? t.push(..._s(n.children)) : t.push(n);
  }), t.filter((n) => !uI(n));
}
function co(e) {
  return Array.isArray(e) && e.length === 1 && (e = e[0]), e && e.__v_isVNode && typeof e.type != "symbol";
}
function zg(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "default";
  var r, a;
  return (r = t[n]) !== null && r !== void 0 ? r : (a = e[n]) === null || a === void 0 ? void 0 : a.call(e);
}
const Wg = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ResizeObserver",
  props: {
    disabled: Boolean,
    onResize: Function
  },
  emits: ["resize"],
  setup(e, t) {
    let {
      slots: n
    } = t;
    const r = Wn({
      width: 0,
      height: 0,
      offsetHeight: 0,
      offsetWidth: 0
    });
    let a = null, o = null;
    const i = () => {
      o && (o.disconnect(), o = null);
    }, s = (c) => {
      const {
        onResize: f
      } = e, d = c[0].target, {
        width: p,
        height: v
      } = d.getBoundingClientRect(), {
        offsetWidth: h,
        offsetHeight: m
      } = d, y = Math.floor(p), x = Math.floor(v);
      if (r.width !== y || r.height !== x || r.offsetWidth !== h || r.offsetHeight !== m) {
        const g = {
          width: y,
          height: x,
          offsetWidth: h,
          offsetHeight: m
        };
        D(r, g), f && Promise.resolve().then(() => {
          f(D(D({}, g), {
            offsetWidth: h,
            offsetHeight: m
          }), d);
        });
      }
    }, l = jn(), u = () => {
      const {
        disabled: c
      } = e;
      if (c) {
        i();
        return;
      }
      const f = js(l);
      f !== a && (i(), a = f), !o && f && (o = new oI(s), o.observe(f));
    };
    return Lt(() => {
      u();
    }), Qa(() => {
      u();
    }), Bo(() => {
      i();
    }), He(() => e.disabled, () => {
      u();
    }, {
      flush: "post"
    }), () => {
      var c;
      return (c = n.default) === null || c === void 0 ? void 0 : c.call(n)[0];
    };
  }
});
let cI = (e) => setTimeout(e, 16), fI = (e) => clearTimeout(e);
typeof window < "u" && "requestAnimationFrame" in window && (cI = (e) => window.requestAnimationFrame(e), fI = (e) => window.cancelAnimationFrame(e));
let Y3 = 0;
const j_ = /* @__PURE__ */ new Map();
function dI(e) {
  j_.delete(e);
}
function dn(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  Y3 += 1;
  const n = Y3;
  function r(a) {
    if (a === 0)
      dI(n), e();
    else {
      const o = cI(() => {
        r(a - 1);
      });
      j_.set(n, o);
    }
  }
  return r(t), n;
}
dn.cancel = (e) => {
  const t = j_.get(e);
  return dI(t), fI(t);
};
const eu = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t;
}, yd = (e) => {
  const t = e;
  return t.install = function(n) {
    n.component(t.displayName || t.name, e);
  }, e;
};
function Vf() {
  return {
    type: [Function, Array]
  };
}
function hn(e) {
  return {
    type: Object,
    default: e
  };
}
function qt(e) {
  return {
    type: Boolean,
    default: e
  };
}
function Nt(e) {
  return {
    type: Function,
    default: e
  };
}
function Oi(e, t) {
  const n = {
    validator: () => !0,
    default: e
  };
  return n;
}
function io(e) {
  return {
    type: Array,
    default: e
  };
}
function Ur(e) {
  return {
    type: String,
    default: e
  };
}
function ca(e, t) {
  return e ? {
    type: e,
    default: t
  } : Oi(t);
}
let za = !1;
try {
  const e = Object.defineProperty({}, "passive", {
    get() {
      za = !0;
    }
  });
  window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e);
} catch {
}
function pf(e, t, n, r) {
  if (e && e.addEventListener) {
    let a = r;
    a === void 0 && za && (t === "touchstart" || t === "touchmove" || t === "wheel") && (a = {
      passive: !1
    }), e.addEventListener(t, n, a);
  }
  return {
    remove: () => {
      e && e.removeEventListener && e.removeEventListener(t, n);
    }
  };
}
const V_ = "anticon", pI = Symbol("GlobalFormContextKey"), Sz = (e) => {
  kt(pI, e);
}, _z = () => Ke(pI, {
  validateMessages: V(() => {
  })
}), Cz = () => ({
  iconPrefixCls: String,
  getTargetContainer: {
    type: Function
  },
  getPopupContainer: {
    type: Function
  },
  prefixCls: String,
  getPrefixCls: {
    type: Function
  },
  renderEmpty: {
    type: Function
  },
  transformCellText: {
    type: Function
  },
  csp: hn(),
  input: hn(),
  autoInsertSpaceInButton: {
    type: Boolean,
    default: void 0
  },
  locale: hn(),
  pageHeader: hn(),
  componentSize: {
    type: String
  },
  componentDisabled: {
    type: Boolean,
    default: void 0
  },
  direction: {
    type: String,
    default: "ltr"
  },
  space: hn(),
  virtual: {
    type: Boolean,
    default: void 0
  },
  dropdownMatchSelectWidth: {
    type: [Number, Boolean],
    default: !0
  },
  form: hn(),
  pagination: hn(),
  theme: hn(),
  select: hn(),
  wave: hn()
}), U_ = Symbol("configProvider"), hI = {
  getPrefixCls: (e, t) => t || (e ? `ant-${e}` : "ant"),
  iconPrefixCls: V(() => V_),
  getPopupContainer: V(() => () => document.body),
  direction: V(() => "ltr")
}, z_ = () => Ke(U_, hI), Ez = (e) => kt(U_, e), vI = Symbol("DisabledContextKey"), Ec = () => Ke(vI, ne(void 0)), mI = (e) => {
  const t = Ec();
  return kt(vI, V(() => {
    var n;
    return (n = e.value) !== null && n !== void 0 ? n : t.value;
  })), e;
}, gI = {
  // Options.jsx
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "",
  // Pagination.jsx
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages"
}, Tz = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "Ok",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
}, yI = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, gm = {
  lang: D({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, Tz),
  timePickerLocale: D({}, yI)
}, go = "${label} is not a valid ${type}", tu = {
  locale: "en",
  Pagination: gI,
  DatePicker: gm,
  TimePicker: yI,
  Calendar: gm,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  PageHeader: {
    back: "Back"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: go,
        method: go,
        array: go,
        object: go,
        number: go,
        date: go,
        boolean: go,
        integer: go,
        float: go,
        regexp: go,
        email: go,
        url: go,
        hex: go
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  }
}, xI = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "LocaleReceiver",
  props: {
    componentName: String,
    defaultLocale: {
      type: [Object, Function]
    },
    children: {
      type: Function
    }
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const r = Ke("localeData", {}), a = V(() => {
      const {
        componentName: i = "global",
        defaultLocale: s
      } = e, l = s || tu[i || "global"], {
        antLocale: u
      } = r, c = i && u ? u[i] : {};
      return D(D({}, typeof l == "function" ? l() : l), c || {});
    }), o = V(() => {
      const {
        antLocale: i
      } = r, s = i && i.locale;
      return i && i.exist && !s ? tu.locale : s;
    });
    return () => {
      const i = e.children || n.default, {
        antLocale: s
      } = r;
      return i == null ? void 0 : i(a.value, o.value, s);
    };
  }
});
function Tc(e, t, n) {
  const r = Ke("localeData", {});
  return [V(() => {
    const {
      antLocale: o
    } = r, i = U(t) || tu[e || "global"], s = e && o ? o[e] : {};
    return D(D(D({}, typeof i == "function" ? i() : i), s || {}), U(n) || {});
  })];
}
function W_(e) {
  for (var t = 0, n, r = 0, a = e.length; a >= 4; ++r, a -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
const q3 = "%";
class $z {
  constructor(t) {
    this.cache = /* @__PURE__ */ new Map(), this.instanceId = t;
  }
  get(t) {
    return this.cache.get(Array.isArray(t) ? t.join(q3) : t) || null;
  }
  update(t, n) {
    const r = Array.isArray(t) ? t.join(q3) : t, a = this.cache.get(r), o = n(a);
    o === null ? this.cache.delete(r) : this.cache.set(r, o);
  }
}
const bI = "data-token-hash", qu = "data-css-hash", Oz = "data-cache-path", hf = "__cssinjs_instance__";
function tp() {
  const e = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    const t = document.body.querySelectorAll(`style[${qu}]`) || [], {
      firstChild: n
    } = document.head;
    Array.from(t).forEach((a) => {
      a[hf] = a[hf] || e, a[hf] === e && document.head.insertBefore(a, n);
    });
    const r = {};
    Array.from(document.querySelectorAll(`style[${qu}]`)).forEach((a) => {
      var o;
      const i = a.getAttribute(qu);
      r[i] ? a[hf] === e && ((o = a.parentNode) === null || o === void 0 || o.removeChild(a)) : r[i] = !0;
    });
  }
  return new $z(e);
}
const wI = Symbol("StyleContextKey"), Az = () => {
  var e, t, n;
  const r = jn();
  let a;
  if (r && r.appContext) {
    const o = (n = (t = (e = r.appContext) === null || e === void 0 ? void 0 : e.config) === null || t === void 0 ? void 0 : t.globalProperties) === null || n === void 0 ? void 0 : n.__ANTDV_CSSINJS_CACHE__;
    o ? a = o : (a = tp(), r.appContext.config.globalProperties && (r.appContext.config.globalProperties.__ANTDV_CSSINJS_CACHE__ = a));
  } else
    a = tp();
  return a;
}, SI = {
  cache: tp(),
  defaultCache: !0,
  hashPriority: "low"
}, Gg = () => {
  const e = Az();
  return Ke(wI, Be(D(D({}, SI), {
    cache: e
  })));
}, Iz = (e) => {
  const t = Gg(), n = Be(D(D({}, SI), {
    cache: tp()
  }));
  return He([() => U(e), t], () => {
    const r = D({}, t.value), a = U(e);
    Object.keys(a).forEach((i) => {
      const s = a[i];
      a[i] !== void 0 && (r[i] = s);
    });
    const {
      cache: o
    } = a;
    r.cache = r.cache || tp(), r.defaultCache = !o && t.value.defaultCache, n.value = r;
  }, {
    immediate: !0
  }), kt(wI, n), n;
}, Pz = () => ({
  autoClear: qt(),
  /** @private Test only. Not work in production. */
  mock: Ur(),
  /**
   * Only set when you need ssr to extract style on you own.
   * If not provided, it will auto create <style /> on the end of Provider in server side.
   */
  cache: hn(),
  /** Tell children that this context is default generated context */
  defaultCache: qt(),
  /** Use `:where` selector to reduce hashId css selector priority */
  hashPriority: Ur(),
  /** Tell cssinjs where to inject style in */
  container: ca(),
  /** Component wil render inline  `<style />` for fallback in SSR. Not recommend. */
  ssrInline: qt(),
  /** Transform css before inject in document. Please note that `transformers` do not support dynamic update */
  transformers: io(),
  /**
   * Linters to lint css before inject in document.
   * Styles will be linted after transforming.
   * Please note that `linters` do not support dynamic update.
   */
  linters: io()
});
yd(/* @__PURE__ */ Me({
  name: "AStyleProvider",
  inheritAttrs: !1,
  props: Pz(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return Iz(e), () => {
      var r;
      return (r = n.default) === null || r === void 0 ? void 0 : r.call(n);
    };
  }
}));
function Dz() {
  return !1;
}
let Ib = !1;
function kz() {
  return Ib;
}
const Mz = process.env.NODE_ENV === "production" ? Dz : kz;
if (process.env.NODE_ENV !== "production" && typeof module < "u" && module && module.hot && typeof window < "u") {
  const e = window;
  if (typeof e.webpackHotUpdate == "function") {
    const t = e.webpackHotUpdate;
    e.webpackHotUpdate = function() {
      return Ib = !0, setTimeout(() => {
        Ib = !1;
      }, 0), t(...arguments);
    };
  }
}
function _I(e, t, n, r) {
  const a = Gg(), o = Be(""), i = Be();
  _n(() => {
    o.value = [e, ...t.value].join("%");
  });
  const s = Mz(), l = (u) => {
    a.value.cache.update(u, (c) => {
      const [f = 0, d] = c || [];
      return f - 1 === 0 ? (r == null || r(d, !1), null) : [f - 1, d];
    });
  };
  return He(o, (u, c) => {
    c && l(c), a.value.cache.update(u, (f) => {
      const [d = 0, p] = f || [];
      let v = p;
      process.env.NODE_ENV !== "production" && p && s && (r == null || r(v, s), v = null);
      const h = v || n();
      return [d + 1, h];
    }), i.value = a.value.cache.get(o.value)[1];
  }, {
    immediate: !0
  }), Sn(() => {
    l(o.value);
  }), i;
}
function li() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Pl(e, t) {
  return e && e.contains ? e.contains(t) : !1;
}
const X3 = "data-vc-order", Rz = "vc-util-key", Pb = /* @__PURE__ */ new Map();
function CI() {
  let {
    mark: e
  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return e ? e.startsWith("data-") ? e : `data-${e}` : Rz;
}
function Kg(e) {
  return e.attachTo ? e.attachTo : document.querySelector("head") || document.body;
}
function Nz(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function EI(e) {
  return Array.from((Pb.get(e) || e).children).filter((t) => t.tagName === "STYLE");
}
function TI(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!li())
    return null;
  const {
    csp: n,
    prepend: r
  } = t, a = document.createElement("style");
  a.setAttribute(X3, Nz(r)), n != null && n.nonce && (a.nonce = n == null ? void 0 : n.nonce), a.innerHTML = e;
  const o = Kg(t), {
    firstChild: i
  } = o;
  if (r) {
    if (r === "queue") {
      const s = EI(o).filter((l) => ["prepend", "prependQueue"].includes(l.getAttribute(X3)));
      if (s.length)
        return o.insertBefore(a, s[s.length - 1].nextSibling), a;
    }
    o.insertBefore(a, i);
  } else
    o.appendChild(a);
  return a;
}
function $I(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const n = Kg(t);
  return EI(n).find((r) => r.getAttribute(CI(t)) === e);
}
function ym(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const n = $I(e, t);
  n && Kg(t).removeChild(n);
}
function Fz(e, t) {
  const n = Pb.get(e);
  if (!n || !Pl(document, n)) {
    const r = TI("", t), {
      parentNode: a
    } = r;
    Pb.set(e, a), e.removeChild(r);
  }
}
function np(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var r, a, o;
  const i = Kg(n);
  Fz(i, n);
  const s = $I(t, n);
  if (s)
    return !((r = n.csp) === null || r === void 0) && r.nonce && s.nonce !== ((a = n.csp) === null || a === void 0 ? void 0 : a.nonce) && (s.nonce = (o = n.csp) === null || o === void 0 ? void 0 : o.nonce), s.innerHTML !== e && (s.innerHTML = e), s;
  const l = TI(e, n);
  return l.setAttribute(CI(n), t), l;
}
function Lz(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
class Uf {
  constructor() {
    this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  size() {
    return this.keys.length;
  }
  internalGet(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = {
      map: this.cache
    };
    return t.forEach((a) => {
      var o;
      r ? r = (o = r == null ? void 0 : r.map) === null || o === void 0 ? void 0 : o.get(a) : r = void 0;
    }), r != null && r.value && n && (r.value[1] = this.cacheCallTimes++), r == null ? void 0 : r.value;
  }
  get(t) {
    var n;
    return (n = this.internalGet(t, !0)) === null || n === void 0 ? void 0 : n[0];
  }
  has(t) {
    return !!this.internalGet(t);
  }
  set(t, n) {
    if (!this.has(t)) {
      if (this.size() + 1 > Uf.MAX_CACHE_SIZE + Uf.MAX_CACHE_OFFSET) {
        const [a] = this.keys.reduce((o, i) => {
          const [, s] = o;
          return this.internalGet(i)[1] < s ? [i, this.internalGet(i)[1]] : o;
        }, [this.keys[0], this.cacheCallTimes]);
        this.delete(a);
      }
      this.keys.push(t);
    }
    let r = this.cache;
    t.forEach((a, o) => {
      if (o === t.length - 1)
        r.set(a, {
          value: [n, this.cacheCallTimes++]
        });
      else {
        const i = r.get(a);
        i ? i.map || (i.map = /* @__PURE__ */ new Map()) : r.set(a, {
          map: /* @__PURE__ */ new Map()
        }), r = r.get(a).map;
      }
    });
  }
  deleteByPath(t, n) {
    var r;
    const a = t.get(n[0]);
    if (n.length === 1)
      return a.map ? t.set(n[0], {
        map: a.map
      }) : t.delete(n[0]), (r = a.value) === null || r === void 0 ? void 0 : r[0];
    const o = this.deleteByPath(a.map, n.slice(1));
    return (!a.map || a.map.size === 0) && !a.value && t.delete(n[0]), o;
  }
  delete(t) {
    if (this.has(t))
      return this.keys = this.keys.filter((n) => !Lz(n, t)), this.deleteByPath(this.cache, t);
  }
}
Uf.MAX_CACHE_SIZE = 20;
Uf.MAX_CACHE_OFFSET = 5;
let Db = {};
function Sa(e, t) {
  process.env.NODE_ENV !== "production" && !e && console !== void 0 && console.error(`Warning: ${t}`);
}
function Bz(e, t) {
  process.env.NODE_ENV !== "production" && !e && console !== void 0 && console.warn(`Note: ${t}`);
}
function Hz() {
  Db = {};
}
function OI(e, t, n) {
  !t && !Db[n] && (e(!1, n), Db[n] = !0);
}
function $o(e, t) {
  OI(Sa, e, t);
}
function kb(e, t) {
  OI(Bz, e, t);
}
function jz() {
}
let Pa = jz;
process.env.NODE_ENV !== "production" && (Pa = (e, t, n) => {
  $o(e, `[ant-design-vue: ${t}] ${n}`), process.env.NODE_ENV === "test" && Hz();
});
let Z3 = 0;
class AI {
  constructor(t) {
    this.derivatives = Array.isArray(t) ? t : [t], this.id = Z3, t.length === 0 && Pa(t.length > 0, "[Ant Design Vue CSS-in-JS] Theme should have at least one derivative function."), Z3 += 1;
  }
  getDerivativeToken(t) {
    return this.derivatives.reduce((n, r) => r(t, n), void 0);
  }
}
const py = new Uf();
function II(e) {
  const t = Array.isArray(e) ? e : [e];
  return py.has(t) || py.set(t, new AI(t)), py.get(t);
}
const Q3 = /* @__PURE__ */ new WeakMap();
function xm(e) {
  let t = Q3.get(e) || "";
  return t || (Object.keys(e).forEach((n) => {
    const r = e[n];
    t += n, r instanceof AI ? t += r.id : r && typeof r == "object" ? t += xm(r) : t += r;
  }), Q3.set(e, t)), t;
}
function Vz(e, t) {
  return W_(`${t}_${xm(e)}`);
}
const x0 = `random-${Date.now()}-${Math.random()}`.replace(/\./g, ""), PI = "_bAmBoO_";
function Uz(e, t, n) {
  var r, a;
  if (li()) {
    np(e, x0);
    const o = document.createElement("div");
    o.style.position = "fixed", o.style.left = "0", o.style.top = "0", t == null || t(o), document.body.appendChild(o), process.env.NODE_ENV !== "production" && (o.innerHTML = "Test", o.style.zIndex = "9999999");
    const i = n ? n(o) : (r = getComputedStyle(o).content) === null || r === void 0 ? void 0 : r.includes(PI);
    return (a = o.parentNode) === null || a === void 0 || a.removeChild(o), ym(x0), i;
  }
  return !1;
}
let hy;
function zz() {
  return hy === void 0 && (hy = Uz(`@layer ${x0} { .${x0} { content: "${PI}"!important; } }`, (e) => {
    e.className = x0;
  })), hy;
}
const J3 = {}, Wz = process.env.NODE_ENV === "production", Gz = process.env.NODE_ENV === "prerender", Kz = !Wz && !Gz ? "css-dev-only-do-not-override" : "css", Pu = /* @__PURE__ */ new Map();
function Yz(e) {
  Pu.set(e, (Pu.get(e) || 0) + 1);
}
function qz(e, t) {
  typeof document < "u" && document.querySelectorAll(`style[${bI}="${e}"]`).forEach((r) => {
    var a;
    r[hf] === t && ((a = r.parentNode) === null || a === void 0 || a.removeChild(r));
  });
}
const Xz = 0;
function Zz(e, t) {
  Pu.set(e, (Pu.get(e) || 0) - 1);
  const n = Array.from(Pu.keys()), r = n.filter((a) => (Pu.get(a) || 0) <= 0);
  n.length - r.length > Xz && r.forEach((a) => {
    qz(a, t), Pu.delete(a);
  });
}
const Qz = (e, t, n, r) => {
  const a = n.getDerivativeToken(e);
  let o = D(D({}, a), t);
  return r && (o = r(o)), o;
};
function Jz(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ne({});
  const r = Gg(), a = V(() => D({}, ...t.value)), o = V(() => xm(a.value)), i = V(() => xm(n.value.override || J3));
  return _I("token", V(() => [n.value.salt || "", e.value.id, o.value, i.value]), () => {
    const {
      salt: l = "",
      override: u = J3,
      formatToken: c,
      getComputedToken: f
    } = n.value, d = f ? f(a.value, u, e.value) : Qz(a.value, u, e.value, c), p = Vz(d, l);
    d._tokenKey = p, Yz(p);
    const v = `${Kz}-${W_(p)}`;
    return d._hashId = v, [d, v];
  }, (l) => {
    var u;
    Zz(l[0]._tokenKey, (u = r.value) === null || u === void 0 ? void 0 : u.cache.instanceId);
  });
}
var eW = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, DI = "comm", kI = "rule", MI = "decl", tW = "@import", nW = "@keyframes", rW = "@layer", RI = Math.abs, G_ = String.fromCharCode;
function NI(e) {
  return e.trim();
}
function Av(e, t, n) {
  return e.replace(t, n);
}
function aW(e, t, n) {
  return e.indexOf(t, n);
}
function rp(e, t) {
  return e.charCodeAt(t) | 0;
}
function ap(e, t, n) {
  return e.slice(t, n);
}
function Fs(e) {
  return e.length;
}
function oW(e) {
  return e.length;
}
function Oh(e, t) {
  return t.push(e), e;
}
var Yg = 1, zf = 1, FI = 0, ui = 0, kr = 0, xd = "";
function K_(e, t, n, r, a, o, i, s) {
  return { value: e, root: t, parent: n, type: r, props: a, children: o, line: Yg, column: zf, length: i, return: "", siblings: s };
}
function iW() {
  return kr;
}
function sW() {
  return kr = ui > 0 ? rp(xd, --ui) : 0, zf--, kr === 10 && (zf = 1, Yg--), kr;
}
function ji() {
  return kr = ui < FI ? rp(xd, ui++) : 0, zf++, kr === 10 && (zf = 1, Yg++), kr;
}
function Xu() {
  return rp(xd, ui);
}
function Iv() {
  return ui;
}
function qg(e, t) {
  return ap(xd, e, t);
}
function Mb(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function lW(e) {
  return Yg = zf = 1, FI = Fs(xd = e), ui = 0, [];
}
function uW(e) {
  return xd = "", e;
}
function vy(e) {
  return NI(qg(ui - 1, Rb(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function cW(e) {
  for (; (kr = Xu()) && kr < 33; )
    ji();
  return Mb(e) > 2 || Mb(kr) > 3 ? "" : " ";
}
function fW(e, t) {
  for (; --t && ji() && !(kr < 48 || kr > 102 || kr > 57 && kr < 65 || kr > 70 && kr < 97); )
    ;
  return qg(e, Iv() + (t < 6 && Xu() == 32 && ji() == 32));
}
function Rb(e) {
  for (; ji(); )
    switch (kr) {
      case e:
        return ui;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Rb(kr);
        break;
      case 40:
        e === 41 && Rb(e);
        break;
      case 92:
        ji();
        break;
    }
  return ui;
}
function dW(e, t) {
  for (; ji() && e + kr !== 57; )
    if (e + kr === 84 && Xu() === 47)
      break;
  return "/*" + qg(t, ui - 1) + "*" + G_(e === 47 ? e : ji());
}
function pW(e) {
  for (; !Mb(Xu()); )
    ji();
  return qg(e, ui);
}
function hW(e) {
  return uW(Pv("", null, null, null, [""], e = lW(e), 0, [0], e));
}
function Pv(e, t, n, r, a, o, i, s, l) {
  for (var u = 0, c = 0, f = i, d = 0, p = 0, v = 0, h = 1, m = 1, y = 1, x = 0, g = "", S = a, w = o, _ = r, b = g; m; )
    switch (v = x, x = ji()) {
      case 40:
        if (v != 108 && rp(b, f - 1) == 58) {
          aW(b += Av(vy(x), "&", "&\f"), "&\f", RI(u ? s[u - 1] : 0)) != -1 && (y = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        b += vy(x);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        b += cW(v);
        break;
      case 92:
        b += fW(Iv() - 1, 7);
        continue;
      case 47:
        switch (Xu()) {
          case 42:
          case 47:
            Oh(vW(dW(ji(), Iv()), t, n, l), l);
            break;
          default:
            b += "/";
        }
        break;
      case 123 * h:
        s[u++] = Fs(b) * y;
      case 125 * h:
      case 59:
      case 0:
        switch (x) {
          case 0:
          case 125:
            m = 0;
          case 59 + c:
            y == -1 && (b = Av(b, /\f/g, "")), p > 0 && Fs(b) - f && Oh(p > 32 ? tT(b + ";", r, n, f - 1, l) : tT(Av(b, " ", "") + ";", r, n, f - 2, l), l);
            break;
          case 59:
            b += ";";
          default:
            if (Oh(_ = eT(b, t, n, u, c, a, s, g, S = [], w = [], f, o), o), x === 123)
              if (c === 0)
                Pv(b, t, _, _, S, o, f, s, w);
              else
                switch (d === 99 && rp(b, 3) === 110 ? 100 : d) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Pv(e, _, _, r && Oh(eT(e, _, _, 0, 0, a, s, g, a, S = [], f, w), w), a, w, f, s, r ? S : w);
                    break;
                  default:
                    Pv(b, _, _, _, [""], w, 0, s, w);
                }
        }
        u = c = p = 0, h = y = 1, g = b = "", f = i;
        break;
      case 58:
        f = 1 + Fs(b), p = v;
      default:
        if (h < 1) {
          if (x == 123)
            --h;
          else if (x == 125 && h++ == 0 && sW() == 125)
            continue;
        }
        switch (b += G_(x), x * h) {
          case 38:
            y = c > 0 ? 1 : (b += "\f", -1);
            break;
          case 44:
            s[u++] = (Fs(b) - 1) * y, y = 1;
            break;
          case 64:
            Xu() === 45 && (b += vy(ji())), d = Xu(), c = f = Fs(g = b += pW(Iv())), x++;
            break;
          case 45:
            v === 45 && Fs(b) == 2 && (h = 0);
        }
    }
  return o;
}
function eT(e, t, n, r, a, o, i, s, l, u, c, f) {
  for (var d = a - 1, p = a === 0 ? o : [""], v = oW(p), h = 0, m = 0, y = 0; h < r; ++h)
    for (var x = 0, g = ap(e, d + 1, d = RI(m = i[h])), S = e; x < v; ++x)
      (S = NI(m > 0 ? p[x] + " " + g : Av(g, /&\f/g, p[x]))) && (l[y++] = S);
  return K_(e, t, n, a === 0 ? kI : s, l, u, c, f);
}
function vW(e, t, n, r) {
  return K_(e, t, n, DI, G_(iW()), ap(e, 2, -2), 0, r);
}
function tT(e, t, n, r, a) {
  return K_(e, t, n, MI, ap(e, 0, r), ap(e, r + 1, -1), r, a);
}
function Nb(e, t) {
  for (var n = "", r = 0; r < e.length; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function mW(e, t, n, r) {
  switch (e.type) {
    case rW:
      if (e.children.length) break;
    case tW:
    case MI:
      return e.return = e.return || e.value;
    case DI:
      return "";
    case nW:
      return e.return = e.value + "{" + Nb(e.children, r) + "}";
    case kI:
      if (!Fs(e.value = e.props.join(","))) return "";
  }
  return Fs(n = Nb(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function LI(e, t) {
  const {
    path: n,
    parentSelectors: r
  } = t;
  $o(!1, `[Ant Design Vue CSS-in-JS] ${n ? `Error in '${n}': ` : ""}${e}${r.length ? ` Selector info: ${r.join(" -> ")}` : ""}`);
}
const gW = (e, t, n) => {
  if (e === "content") {
    const r = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
    (typeof t != "string" || ["normal", "none", "initial", "inherit", "unset"].indexOf(t) === -1 && !r.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== '"' && t.charAt(0) !== "'")) && LI(`You seem to be using a value for 'content' without quotes, try replacing it with \`content: '"${t}"'\`.`, n);
  }
}, yW = (e, t, n) => {
  e === "animation" && n.hashId && t !== "none" && LI(`You seem to be using hashed animation '${t}', in which case 'animationName' with Keyframe as value is recommended.`, n);
}, nT = "data-ant-cssinjs-cache-path", xW = "_FILE_STYLE__";
let Zu, BI = !0;
function bW() {
  var e;
  if (!Zu && (Zu = {}, li())) {
    const t = document.createElement("div");
    t.className = nT, t.style.position = "fixed", t.style.visibility = "hidden", t.style.top = "-9999px", document.body.appendChild(t);
    let n = getComputedStyle(t).content || "";
    n = n.replace(/^"/, "").replace(/"$/, ""), n.split(";").forEach((a) => {
      const [o, i] = a.split(":");
      Zu[o] = i;
    });
    const r = document.querySelector(`style[${nT}]`);
    r && (BI = !1, (e = r.parentNode) === null || e === void 0 || e.removeChild(r)), document.body.removeChild(t);
  }
}
function wW(e) {
  return bW(), !!Zu[e];
}
function SW(e) {
  const t = Zu[e];
  let n = null;
  if (t && li())
    if (BI)
      n = xW;
    else {
      const r = document.querySelector(`style[${qu}="${Zu[e]}"]`);
      r ? n = r.innerHTML : delete Zu[e];
    }
  return [n, t];
}
const rT = li(), HI = "_skip_check_", jI = "_multi_value_";
function aT(e) {
  return Nb(hW(e), mW).replace(/\{%%%\:[^;];}/g, ";");
}
function _W(e) {
  return typeof e == "object" && e && (HI in e || jI in e);
}
function CW(e, t, n) {
  if (!t)
    return e;
  const r = `.${t}`, a = n === "low" ? `:where(${r})` : r;
  return e.split(",").map((i) => {
    var s;
    const l = i.trim().split(/\s+/);
    let u = l[0] || "";
    const c = ((s = u.match(/^\w+/)) === null || s === void 0 ? void 0 : s[0]) || "";
    return u = `${c}${a}${u.slice(c.length)}`, [u, ...l.slice(1)].join(" ");
  }).join(",");
}
const Fb = /* @__PURE__ */ new Set();
process.env.NODE_ENV;
const Lb = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    root: n,
    injectHash: r,
    parentSelectors: a
  } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  };
  const {
    hashId: o,
    layer: i,
    path: s,
    hashPriority: l,
    transformers: u = [],
    linters: c = []
  } = t;
  let f = "", d = {};
  function p(m) {
    const y = m.getName(o);
    if (!d[y]) {
      const [x] = Lb(m.style, t, {
        root: !1,
        parentSelectors: a
      });
      d[y] = `@keyframes ${m.getName(o)}${x}`;
    }
  }
  function v(m) {
    let y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return m.forEach((x) => {
      Array.isArray(x) ? v(x, y) : x && y.push(x);
    }), y;
  }
  if (v(Array.isArray(e) ? e : [e]).forEach((m) => {
    const y = typeof m == "string" && !n ? {} : m;
    if (typeof y == "string")
      f += `${y}
`;
    else if (y._keyframe)
      p(y);
    else {
      const x = u.reduce((g, S) => {
        var w;
        return ((w = S == null ? void 0 : S.visit) === null || w === void 0 ? void 0 : w.call(S, g)) || g;
      }, y);
      Object.keys(x).forEach((g) => {
        var S;
        const w = x[g];
        if (typeof w == "object" && w && (g !== "animationName" || !w._keyframe) && !_W(w)) {
          let _ = !1, b = g.trim(), E = !1;
          (n || r) && o ? b.startsWith("@") ? _ = !0 : b = CW(g, o, l) : n && !o && (b === "&" || b === "") && (b = "", E = !0);
          const [C, T] = Lb(w, t, {
            root: E,
            injectHash: _,
            parentSelectors: [...a, b]
          });
          d = D(D({}, d), T), f += `${b}${C}`;
        } else {
          let _ = function(E, C) {
            process.env.NODE_ENV !== "production" && (typeof w != "object" || !(w != null && w[HI])) && [gW, yW, ...c].forEach((I) => I(E, C, {
              path: s,
              hashId: o,
              parentSelectors: a
            }));
            const T = E.replace(/[A-Z]/g, (I) => `-${I.toLowerCase()}`);
            let O = C;
            !eW[E] && typeof O == "number" && O !== 0 && (O = `${O}px`), E === "animationName" && (C != null && C._keyframe) && (p(C), O = C.getName(o)), f += `${T}:${O};`;
          };
          const b = (S = w == null ? void 0 : w.value) !== null && S !== void 0 ? S : w;
          typeof w == "object" && (w != null && w[jI]) && Array.isArray(b) ? b.forEach((E) => {
            _(g, E);
          }) : _(g, b);
        }
      });
    }
  }), !n)
    f = `{${f}}`;
  else if (i && zz()) {
    const m = i.split(",");
    f = `@layer ${m[m.length - 1].trim()} {${f}}`, m.length > 1 && (f = `@layer ${i}{%%%:%}${f}`);
  }
  return [f, d];
};
function EW(e, t) {
  return W_(`${e.join("%")}${t}`);
}
function Bb(e, t) {
  const n = Gg(), r = V(() => e.value.token._tokenKey), a = V(() => [r.value, ...e.value.path]);
  let o = rT;
  return process.env.NODE_ENV !== "production" && n.value.mock !== void 0 && (o = n.value.mock === "client"), _I(
    "style",
    a,
    // Create cache if needed
    () => {
      const {
        path: i,
        hashId: s,
        layer: l,
        nonce: u,
        clientOnly: c,
        order: f = 0
      } = e.value, d = a.value.join("|");
      if (wW(d)) {
        const [b, E] = SW(d);
        if (b)
          return [b, r.value, E, {}, c, f];
      }
      const p = t(), {
        hashPriority: v,
        container: h,
        transformers: m,
        linters: y,
        cache: x
      } = n.value, [g, S] = Lb(p, {
        hashId: s,
        hashPriority: v,
        layer: l,
        path: i.join("-"),
        transformers: m,
        linters: y
      }), w = aT(g), _ = EW(a.value, w);
      if (o) {
        const b = {
          mark: qu,
          prepend: "queue",
          attachTo: h,
          priority: f
        }, E = typeof u == "function" ? u() : u;
        E && (b.csp = {
          nonce: E
        });
        const C = np(w, _, b);
        C[hf] = x.instanceId, C.setAttribute(bI, r.value), process.env.NODE_ENV !== "production" && C.setAttribute(Oz, a.value.join("|")), Object.keys(S).forEach((T) => {
          Fb.has(T) || (Fb.add(T), np(aT(S[T]), `_effect-${T}`, {
            mark: qu,
            prepend: "queue",
            attachTo: h
          }));
        });
      }
      return [w, r.value, _, S, c, f];
    },
    // Remove cache if no need
    (i, s) => {
      let [, , l] = i;
      (s || n.value.autoClear) && rT && ym(l, {
        mark: qu
      });
    }
  ), (i) => i;
}
class rn {
  constructor(t, n) {
    this._keyframe = !0, this.name = t, this.style = n;
  }
  getName() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return t ? `${t}-${this.name}` : this.name;
  }
}
const TW = "4.1.2", bm = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"];
function fa(e, t) {
  $W(e) && (e = "100%");
  var n = OW(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function Ah(e) {
  return Math.min(1, Math.max(0, e));
}
function $W(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function OW(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function VI(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Ih(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function Ru(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function AW(e, t, n) {
  return {
    r: fa(e, 255) * 255,
    g: fa(t, 255) * 255,
    b: fa(n, 255) * 255
  };
}
function oT(e, t, n) {
  e = fa(e, 255), t = fa(t, 255), n = fa(n, 255);
  var r = Math.max(e, t, n), a = Math.min(e, t, n), o = 0, i = 0, s = (r + a) / 2;
  if (r === a)
    i = 0, o = 0;
  else {
    var l = r - a;
    switch (i = s > 0.5 ? l / (2 - r - a) : l / (r + a), r) {
      case e:
        o = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        o = (n - e) / l + 2;
        break;
      case n:
        o = (e - t) / l + 4;
        break;
    }
    o /= 6;
  }
  return { h: o, s: i, l: s };
}
function my(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function IW(e, t, n) {
  var r, a, o;
  if (e = fa(e, 360), t = fa(t, 100), n = fa(n, 100), t === 0)
    a = n, o = n, r = n;
  else {
    var i = n < 0.5 ? n * (1 + t) : n + t - n * t, s = 2 * n - i;
    r = my(s, i, e + 1 / 3), a = my(s, i, e), o = my(s, i, e - 1 / 3);
  }
  return { r: r * 255, g: a * 255, b: o * 255 };
}
function Hb(e, t, n) {
  e = fa(e, 255), t = fa(t, 255), n = fa(n, 255);
  var r = Math.max(e, t, n), a = Math.min(e, t, n), o = 0, i = r, s = r - a, l = r === 0 ? 0 : s / r;
  if (r === a)
    o = 0;
  else {
    switch (r) {
      case e:
        o = (t - n) / s + (t < n ? 6 : 0);
        break;
      case t:
        o = (n - e) / s + 2;
        break;
      case n:
        o = (e - t) / s + 4;
        break;
    }
    o /= 6;
  }
  return { h: o, s: l, v: i };
}
function PW(e, t, n) {
  e = fa(e, 360) * 6, t = fa(t, 100), n = fa(n, 100);
  var r = Math.floor(e), a = e - r, o = n * (1 - t), i = n * (1 - a * t), s = n * (1 - (1 - a) * t), l = r % 6, u = [n, i, o, o, s, n][l], c = [s, n, n, i, o, o][l], f = [o, o, s, n, n, i][l];
  return { r: u * 255, g: c * 255, b: f * 255 };
}
function jb(e, t, n, r) {
  var a = [
    Ru(Math.round(e).toString(16)),
    Ru(Math.round(t).toString(16)),
    Ru(Math.round(n).toString(16))
  ];
  return r && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
}
function DW(e, t, n, r, a) {
  var o = [
    Ru(Math.round(e).toString(16)),
    Ru(Math.round(t).toString(16)),
    Ru(Math.round(n).toString(16)),
    Ru(kW(r))
  ];
  return a && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) && o[3].startsWith(o[3].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0) : o.join("");
}
function kW(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function iT(e) {
  return wo(e) / 255;
}
function wo(e) {
  return parseInt(e, 16);
}
function MW(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var Vb = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function af(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, r = null, a = null, o = null, i = !1, s = !1;
  return typeof e == "string" && (e = FW(e)), typeof e == "object" && (Os(e.r) && Os(e.g) && Os(e.b) ? (t = AW(e.r, e.g, e.b), i = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Os(e.h) && Os(e.s) && Os(e.v) ? (r = Ih(e.s), a = Ih(e.v), t = PW(e.h, r, a), i = !0, s = "hsv") : Os(e.h) && Os(e.s) && Os(e.l) && (r = Ih(e.s), o = Ih(e.l), t = IW(e.h, r, o), i = !0, s = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = VI(n), {
    ok: i,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var RW = "[-\\+]?\\d+%?", NW = "[-\\+]?\\d*\\.\\d+%?", Rl = "(?:".concat(NW, ")|(?:").concat(RW, ")"), gy = "[\\s|\\(]+(".concat(Rl, ")[,|\\s]+(").concat(Rl, ")[,|\\s]+(").concat(Rl, ")\\s*\\)?"), yy = "[\\s|\\(]+(".concat(Rl, ")[,|\\s]+(").concat(Rl, ")[,|\\s]+(").concat(Rl, ")[,|\\s]+(").concat(Rl, ")\\s*\\)?"), Ei = {
  CSS_UNIT: new RegExp(Rl),
  rgb: new RegExp("rgb" + gy),
  rgba: new RegExp("rgba" + yy),
  hsl: new RegExp("hsl" + gy),
  hsla: new RegExp("hsla" + yy),
  hsv: new RegExp("hsv" + gy),
  hsva: new RegExp("hsva" + yy),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function FW(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (Vb[e])
    e = Vb[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = Ei.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = Ei.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = Ei.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = Ei.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = Ei.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = Ei.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = Ei.hex8.exec(e), n ? {
    r: wo(n[1]),
    g: wo(n[2]),
    b: wo(n[3]),
    a: iT(n[4]),
    format: t ? "name" : "hex8"
  } : (n = Ei.hex6.exec(e), n ? {
    r: wo(n[1]),
    g: wo(n[2]),
    b: wo(n[3]),
    format: t ? "name" : "hex"
  } : (n = Ei.hex4.exec(e), n ? {
    r: wo(n[1] + n[1]),
    g: wo(n[2] + n[2]),
    b: wo(n[3] + n[3]),
    a: iT(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = Ei.hex3.exec(e), n ? {
    r: wo(n[1] + n[1]),
    g: wo(n[2] + n[2]),
    b: wo(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function Os(e) {
  return !!Ei.CSS_UNIT.exec(String(e));
}
var ir = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = ""), n === void 0 && (n = {});
      var r;
      if (t instanceof e)
        return t;
      typeof t == "number" && (t = MW(t)), this.originalInput = t;
      var a = af(t);
      this.originalInput = t, this.r = a.r, this.g = a.g, this.b = a.b, this.a = a.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (r = n.format) !== null && r !== void 0 ? r : a.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = a.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var t = this.toRgb();
      return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var t = this.toRgb(), n, r, a, o = t.r / 255, i = t.g / 255, s = t.b / 255;
      return o <= 0.03928 ? n = o / 12.92 : n = Math.pow((o + 0.055) / 1.055, 2.4), i <= 0.03928 ? r = i / 12.92 : r = Math.pow((i + 0.055) / 1.055, 2.4), s <= 0.03928 ? a = s / 12.92 : a = Math.pow((s + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * r + 0.0722 * a;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(t) {
      return this.a = VI(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var t = this.toHsl().s;
      return t === 0;
    }, e.prototype.toHsv = function() {
      var t = Hb(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var t = Hb(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), a = Math.round(t.v * 100);
      return this.a === 1 ? "hsv(".concat(n, ", ").concat(r, "%, ").concat(a, "%)") : "hsva(".concat(n, ", ").concat(r, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var t = oT(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var t = oT(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), a = Math.round(t.l * 100);
      return this.a === 1 ? "hsl(".concat(n, ", ").concat(r, "%, ").concat(a, "%)") : "hsla(".concat(n, ", ").concat(r, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
      return t === void 0 && (t = !1), jb(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
      return t === void 0 && (t = !1), DW(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
      return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var t = Math.round(this.r), n = Math.round(this.g), r = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(t, ", ").concat(n, ", ").concat(r, ")") : "rgba(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var t = function(n) {
        return "".concat(Math.round(fa(n, 255) * 100), "%");
      };
      return {
        r: t(this.r),
        g: t(this.g),
        b: t(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var t = function(n) {
        return Math.round(fa(n, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var t = "#" + jb(this.r, this.g, this.b, !1), n = 0, r = Object.entries(Vb); n < r.length; n++) {
        var a = r[n], o = a[0], i = a[1];
        if (t === i)
          return o;
      }
      return !1;
    }, e.prototype.toString = function(t) {
      var n = !!t;
      t = t ?? this.format;
      var r = !1, a = this.a < 1 && this.a >= 0, o = !n && a && (t.startsWith("hex") || t === "name");
      return o ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l += t / 100, n.l = Ah(n.l), new e(n);
    }, e.prototype.brighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toRgb();
      return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new e(n);
    }, e.prototype.darken = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l -= t / 100, n.l = Ah(n.l), new e(n);
    }, e.prototype.tint = function(t) {
      return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
      return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s -= t / 100, n.s = Ah(n.s), new e(n);
    }, e.prototype.saturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s += t / 100, n.s = Ah(n.s), new e(n);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(t) {
      var n = this.toHsl(), r = (n.h + t) % 360;
      return n.h = r < 0 ? 360 + r : r, new e(n);
    }, e.prototype.mix = function(t, n) {
      n === void 0 && (n = 50);
      var r = this.toRgb(), a = new e(t).toRgb(), o = n / 100, i = {
        r: (a.r - r.r) * o + r.r,
        g: (a.g - r.g) * o + r.g,
        b: (a.b - r.b) * o + r.b,
        a: (a.a - r.a) * o + r.a
      };
      return new e(i);
    }, e.prototype.analogous = function(t, n) {
      t === void 0 && (t = 6), n === void 0 && (n = 30);
      var r = this.toHsl(), a = 360 / n, o = [this];
      for (r.h = (r.h - (a * t >> 1) + 720) % 360; --t; )
        r.h = (r.h + a) % 360, o.push(new e(r));
      return o;
    }, e.prototype.complement = function() {
      var t = this.toHsl();
      return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
      t === void 0 && (t = 6);
      for (var n = this.toHsv(), r = n.h, a = n.s, o = n.v, i = [], s = 1 / t; t--; )
        i.push(new e({ h: r, s: a, v: o })), o = (o + s) % 1;
      return i;
    }, e.prototype.splitcomplement = function() {
      var t = this.toHsl(), n = t.h;
      return [
        this,
        new e({ h: (n + 72) % 360, s: t.s, l: t.l }),
        new e({ h: (n + 216) % 360, s: t.s, l: t.l })
      ];
    }, e.prototype.onBackground = function(t) {
      var n = this.toRgb(), r = new e(t).toRgb(), a = n.a + r.a * (1 - n.a);
      return new e({
        r: (n.r * n.a + r.r * r.a * (1 - n.a)) / a,
        g: (n.g * n.a + r.g * r.a * (1 - n.a)) / a,
        b: (n.b * n.a + r.b * r.a * (1 - n.a)) / a,
        a
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(t) {
      for (var n = this.toHsl(), r = n.h, a = [this], o = 360 / t, i = 1; i < t; i++)
        a.push(new e({ h: (r + i * o) % 360, s: n.s, l: n.l }));
      return a;
    }, e.prototype.equals = function(t) {
      return this.toRgbString() === new e(t).toRgbString();
    }, e;
  }()
), Ph = 2, sT = 0.16, LW = 0.05, BW = 0.05, HW = 0.15, UI = 5, zI = 4, jW = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function lT(e) {
  var t = e.r, n = e.g, r = e.b, a = Hb(t, n, r);
  return {
    h: a.h * 360,
    s: a.s,
    v: a.v
  };
}
function Dh(e) {
  var t = e.r, n = e.g, r = e.b;
  return "#".concat(jb(t, n, r, !1));
}
function VW(e, t, n) {
  var r = n / 100, a = {
    r: (t.r - e.r) * r + e.r,
    g: (t.g - e.g) * r + e.g,
    b: (t.b - e.b) * r + e.b
  };
  return a;
}
function uT(e, t, n) {
  var r;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? r = n ? Math.round(e.h) - Ph * t : Math.round(e.h) + Ph * t : r = n ? Math.round(e.h) + Ph * t : Math.round(e.h) - Ph * t, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function cT(e, t, n) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var r;
  return n ? r = e.s - sT * t : t === zI ? r = e.s + sT : r = e.s + LW * t, r > 1 && (r = 1), n && t === UI && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Number(r.toFixed(2));
}
function fT(e, t, n) {
  var r;
  return n ? r = e.v + BW * t : r = e.v - HW * t, r > 1 && (r = 1), Number(r.toFixed(2));
}
function fc(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [], r = af(e), a = UI; a > 0; a -= 1) {
    var o = lT(r), i = Dh(af({
      h: uT(o, a, !0),
      s: cT(o, a, !0),
      v: fT(o, a, !0)
    }));
    n.push(i);
  }
  n.push(Dh(r));
  for (var s = 1; s <= zI; s += 1) {
    var l = lT(r), u = Dh(af({
      h: uT(l, s),
      s: cT(l, s),
      v: fT(l, s)
    }));
    n.push(u);
  }
  return t.theme === "dark" ? jW.map(function(c) {
    var f = c.index, d = c.opacity, p = Dh(VW(af(t.backgroundColor || "#141414"), af(n[f]), d * 100));
    return p;
  }) : n;
}
var xy = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1890FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, Dv = {}, by = {};
Object.keys(xy).forEach(function(e) {
  Dv[e] = fc(xy[e]), Dv[e].primary = Dv[e][5], by[e] = fc(xy[e], {
    theme: "dark",
    backgroundColor: "#141414"
  }), by[e].primary = by[e][5];
});
var UW = Dv.blue;
const zW = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
};
function WW(e) {
  const {
    sizeUnit: t,
    sizeStep: n
  } = e;
  return {
    sizeXXL: t * (n + 8),
    sizeXL: t * (n + 4),
    sizeLG: t * (n + 2),
    sizeMD: t * (n + 1),
    sizeMS: t * n,
    size: t * n,
    sizeSM: t * (n - 1),
    sizeXS: t * (n - 2),
    sizeXXS: t * (n - 3)
    // 4
  };
}
const WI = {
  blue: "#1677ff",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  pink: "#eb2f96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, Xg = D(D({}, WI), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1
});
function GW(e, t) {
  let {
    generateColorPalettes: n,
    generateNeutralColorPalettes: r
  } = t;
  const {
    colorSuccess: a,
    colorWarning: o,
    colorError: i,
    colorInfo: s,
    colorPrimary: l,
    colorBgBase: u,
    colorTextBase: c
  } = e, f = n(l), d = n(a), p = n(o), v = n(i), h = n(s), m = r(u, c);
  return D(D({}, m), {
    colorPrimaryBg: f[1],
    colorPrimaryBgHover: f[2],
    colorPrimaryBorder: f[3],
    colorPrimaryBorderHover: f[4],
    colorPrimaryHover: f[5],
    colorPrimary: f[6],
    colorPrimaryActive: f[7],
    colorPrimaryTextHover: f[8],
    colorPrimaryText: f[9],
    colorPrimaryTextActive: f[10],
    colorSuccessBg: d[1],
    colorSuccessBgHover: d[2],
    colorSuccessBorder: d[3],
    colorSuccessBorderHover: d[4],
    colorSuccessHover: d[4],
    colorSuccess: d[6],
    colorSuccessActive: d[7],
    colorSuccessTextHover: d[8],
    colorSuccessText: d[9],
    colorSuccessTextActive: d[10],
    colorErrorBg: v[1],
    colorErrorBgHover: v[2],
    colorErrorBorder: v[3],
    colorErrorBorderHover: v[4],
    colorErrorHover: v[5],
    colorError: v[6],
    colorErrorActive: v[7],
    colorErrorTextHover: v[8],
    colorErrorText: v[9],
    colorErrorTextActive: v[10],
    colorWarningBg: p[1],
    colorWarningBgHover: p[2],
    colorWarningBorder: p[3],
    colorWarningBorderHover: p[4],
    colorWarningHover: p[4],
    colorWarning: p[6],
    colorWarningActive: p[7],
    colorWarningTextHover: p[8],
    colorWarningText: p[9],
    colorWarningTextActive: p[10],
    colorInfoBg: h[1],
    colorInfoBgHover: h[2],
    colorInfoBorder: h[3],
    colorInfoBorderHover: h[4],
    colorInfoHover: h[4],
    colorInfo: h[6],
    colorInfoActive: h[7],
    colorInfoTextHover: h[8],
    colorInfoText: h[9],
    colorInfoTextActive: h[10],
    colorBgMask: new ir("#000").setAlpha(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const KW = (e) => {
  let t = e, n = e, r = e, a = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? n = 4 : e < 8 && e >= 7 ? n = 5 : e < 14 && e >= 8 ? n = 6 : e < 16 && e >= 14 ? n = 7 : e >= 16 && (n = 8), e < 6 && e >= 2 ? r = 1 : e >= 6 && (r = 2), e > 4 && e < 8 ? a = 4 : e >= 8 && (a = 6), {
    borderRadius: e > 16 ? 16 : e,
    borderRadiusXS: r,
    borderRadiusSM: n,
    borderRadiusLG: t,
    borderRadiusOuter: a
  };
};
function YW(e) {
  const {
    motionUnit: t,
    motionBase: n,
    borderRadius: r,
    lineWidth: a
  } = e;
  return D({
    // motion
    motionDurationFast: `${(n + t).toFixed(1)}s`,
    motionDurationMid: `${(n + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(n + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: a + 1
  }, KW(r));
}
const As = (e, t) => new ir(e).setAlpha(t).toRgbString(), Ld = (e, t) => new ir(e).darken(t).toHexString(), qW = (e) => {
  const t = fc(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, XW = (e, t) => {
  const n = e || "#fff", r = t || "#000";
  return {
    colorBgBase: n,
    colorTextBase: r,
    colorText: As(r, 0.88),
    colorTextSecondary: As(r, 0.65),
    colorTextTertiary: As(r, 0.45),
    colorTextQuaternary: As(r, 0.25),
    colorFill: As(r, 0.15),
    colorFillSecondary: As(r, 0.06),
    colorFillTertiary: As(r, 0.04),
    colorFillQuaternary: As(r, 0.02),
    colorBgLayout: Ld(n, 4),
    colorBgContainer: Ld(n, 0),
    colorBgElevated: Ld(n, 0),
    colorBgSpotlight: As(r, 0.85),
    colorBorder: Ld(n, 15),
    colorBorderSecondary: Ld(n, 6)
  };
};
function ZW(e) {
  const t = new Array(10).fill(null).map((n, r) => {
    const a = r - 1, o = e * Math.pow(2.71828, a / 5), i = r > 1 ? Math.floor(o) : Math.ceil(o);
    return Math.floor(i / 2) * 2;
  });
  return t[1] = e, t.map((n) => {
    const r = n + 8;
    return {
      size: n,
      lineHeight: r / n
    };
  });
}
const QW = (e) => {
  const t = ZW(e), n = t.map((a) => a.size), r = t.map((a) => a.lineHeight);
  return {
    fontSizeSM: n[0],
    fontSize: n[1],
    fontSizeLG: n[2],
    fontSizeXL: n[3],
    fontSizeHeading1: n[6],
    fontSizeHeading2: n[5],
    fontSizeHeading3: n[4],
    fontSizeHeading4: n[3],
    fontSizeHeading5: n[2],
    lineHeight: r[1],
    lineHeightLG: r[2],
    lineHeightSM: r[0],
    lineHeightHeading1: r[6],
    lineHeightHeading2: r[5],
    lineHeightHeading3: r[4],
    lineHeightHeading4: r[3],
    lineHeightHeading5: r[2]
  };
};
function JW(e) {
  const t = Object.keys(WI).map((n) => {
    const r = fc(e[n]);
    return new Array(10).fill(1).reduce((a, o, i) => (a[`${n}-${i + 1}`] = r[i], a), {});
  }).reduce((n, r) => (n = D(D({}, n), r), n), {});
  return D(D(D(D(D(D(D({}, e), t), GW(e, {
    generateColorPalettes: qW,
    generateNeutralColorPalettes: XW
  })), QW(e.fontSize)), WW(e)), zW(e)), YW(e));
}
function wy(e) {
  return e >= 0 && e <= 255;
}
function kh(e, t) {
  const {
    r: n,
    g: r,
    b: a,
    a: o
  } = new ir(e).toRgb();
  if (o < 1)
    return e;
  const {
    r: i,
    g: s,
    b: l
  } = new ir(t).toRgb();
  for (let u = 0.01; u <= 1; u += 0.01) {
    const c = Math.round((n - i * (1 - u)) / u), f = Math.round((r - s * (1 - u)) / u), d = Math.round((a - l * (1 - u)) / u);
    if (wy(c) && wy(f) && wy(d))
      return new ir({
        r: c,
        g: f,
        b: d,
        a: Math.round(u * 100) / 100
      }).toRgbString();
  }
  return new ir({
    r: n,
    g: r,
    b: a,
    a: 1
  }).toRgbString();
}
var eG = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function tG(e) {
  const {
    override: t
  } = e, n = eG(e, ["override"]), r = D({}, t);
  Object.keys(Xg).forEach((p) => {
    delete r[p];
  });
  const a = D(D({}, n), r), o = 480, i = 576, s = 768, l = 992, u = 1200, c = 1600, f = 2e3;
  return D(D(D({}, a), {
    colorLink: a.colorInfoText,
    colorLinkHover: a.colorInfoHover,
    colorLinkActive: a.colorInfoActive,
    // ============== Background ============== //
    colorFillContent: a.colorFillSecondary,
    colorFillContentHover: a.colorFill,
    colorFillAlter: a.colorFillQuaternary,
    colorBgContainerDisabled: a.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: a.colorBgContainer,
    colorSplit: kh(a.colorBorderSecondary, a.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: a.colorTextQuaternary,
    colorTextDisabled: a.colorTextQuaternary,
    colorTextHeading: a.colorText,
    colorTextLabel: a.colorTextSecondary,
    colorTextDescription: a.colorTextTertiary,
    colorTextLightSolid: a.colorWhite,
    colorHighlight: a.colorError,
    colorBgTextHover: a.colorFillSecondary,
    colorBgTextActive: a.colorFill,
    colorIcon: a.colorTextTertiary,
    colorIconHover: a.colorText,
    colorErrorOutline: kh(a.colorErrorBg, a.colorBgContainer),
    colorWarningOutline: kh(a.colorWarningBg, a.colorBgContainer),
    // Font
    fontSizeIcon: a.fontSizeSM,
    // Control
    lineWidth: a.lineWidth,
    controlOutlineWidth: a.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: a.controlHeight / 2,
    controlItemBgHover: a.colorFillTertiary,
    controlItemBgActive: a.colorPrimaryBg,
    controlItemBgActiveHover: a.colorPrimaryBgHover,
    controlItemBgActiveDisabled: a.colorFill,
    controlTmpOutline: a.colorFillQuaternary,
    controlOutline: kh(a.colorPrimaryBg, a.colorBgContainer),
    lineType: a.lineType,
    borderRadius: a.borderRadius,
    borderRadiusXS: a.borderRadiusXS,
    borderRadiusSM: a.borderRadiusSM,
    borderRadiusLG: a.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: a.sizeXXS,
    paddingXS: a.sizeXS,
    paddingSM: a.sizeSM,
    padding: a.size,
    paddingMD: a.sizeMD,
    paddingLG: a.sizeLG,
    paddingXL: a.sizeXL,
    paddingContentHorizontalLG: a.sizeLG,
    paddingContentVerticalLG: a.sizeMS,
    paddingContentHorizontal: a.sizeMS,
    paddingContentVertical: a.sizeSM,
    paddingContentHorizontalSM: a.size,
    paddingContentVerticalSM: a.sizeXS,
    marginXXS: a.sizeXXS,
    marginXS: a.sizeXS,
    marginSM: a.sizeSM,
    margin: a.size,
    marginMD: a.sizeMD,
    marginLG: a.sizeLG,
    marginXL: a.sizeXL,
    marginXXL: a.sizeXXL,
    boxShadow: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: o,
    screenXSMin: o,
    screenXSMax: i - 1,
    screenSM: i,
    screenSMMin: i,
    screenSMMax: s - 1,
    screenMD: s,
    screenMDMin: s,
    screenMDMax: l - 1,
    screenLG: l,
    screenLGMin: l,
    screenLGMax: u - 1,
    screenXL: u,
    screenXLMin: u,
    screenXLMax: c - 1,
    screenXXL: c,
    screenXXLMin: c,
    screenXXLMax: f - 1,
    screenXXXL: f,
    screenXXXLMin: f,
    // FIXME: component box-shadow, should be removed
    boxShadowPopoverArrow: "3px 3px 7px rgba(0, 0, 0, 0.1)",
    boxShadowCard: `
      0 1px 2px -2px ${new ir("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new ir("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new ir("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), r);
}
const Y_ = (e, t, n, r, a) => {
  const o = e / 2, i = 0, s = o, l = n * 1 / Math.sqrt(2), u = o - n * (1 - 1 / Math.sqrt(2)), c = o - t * (1 / Math.sqrt(2)), f = n * (Math.sqrt(2) - 1) + t * (1 / Math.sqrt(2)), d = 2 * o - c, p = f, v = 2 * o - l, h = u, m = 2 * o - i, y = s, x = o * Math.sqrt(2) + n * (Math.sqrt(2) - 2), g = n * (Math.sqrt(2) - 1);
  return {
    pointerEvents: "none",
    width: e,
    height: e,
    overflow: "hidden",
    "&::after": {
      content: '""',
      position: "absolute",
      width: x,
      height: x,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${t}px 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: a,
      zIndex: 0,
      background: "transparent"
    },
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: e,
      height: e / 2,
      background: r,
      clipPath: {
        _multi_value_: !0,
        value: [`polygon(${g}px 100%, 50% ${g}px, ${2 * o - g}px 100%, ${g}px 100%)`, `path('M ${i} ${s} A ${n} ${n} 0 0 0 ${l} ${u} L ${c} ${f} A ${t} ${t} 0 0 1 ${d} ${p} L ${v} ${h} A ${n} ${n} 0 0 0 ${m} ${y} Z')`]
      },
      content: '""'
    }
  };
};
function GI(e, t) {
  return bm.reduce((n, r) => {
    const a = e[`${r}-1`], o = e[`${r}-3`], i = e[`${r}-6`], s = e[`${r}-7`];
    return D(D({}, n), t(r, {
      lightColor: a,
      lightBorderColor: o,
      darkColor: i,
      textColor: s
    }));
  }, {});
}
const op = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, gr = (e) => ({
  boxSizing: "border-box",
  margin: 0,
  padding: 0,
  color: e.colorText,
  fontSize: e.fontSize,
  // font-variant: @font-variant-base;
  lineHeight: e.lineHeight,
  listStyle: "none",
  // font-feature-settings: @font-feature-settings-base;
  fontFamily: e.fontFamily
}), Zg = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), wm = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), nG = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active,\n  &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), rG = (e, t) => {
  const {
    fontFamily: n,
    fontSize: r
  } = e, a = `[class^="${t}"], [class*=" ${t}"]`;
  return {
    [a]: {
      fontFamily: n,
      fontSize: r,
      boxSizing: "border-box",
      "&::before, &::after": {
        boxSizing: "border-box"
      },
      [a]: {
        boxSizing: "border-box",
        "&::before, &::after": {
          boxSizing: "border-box"
        }
      }
    }
  };
}, ip = (e) => ({
  outline: `${e.lineWidthBold}px solid ${e.colorPrimaryBorder}`,
  outlineOffset: 1,
  transition: "outline-offset 0s, outline 0s"
}), sp = (e) => ({
  "&:focus-visible": D({}, ip(e))
});
function xr(e, t, n) {
  return (r) => {
    const a = V(() => r == null ? void 0 : r.value), [o, i, s] = bd(), {
      getPrefixCls: l,
      iconPrefixCls: u
    } = z_(), c = V(() => l()), f = V(() => ({
      theme: o.value,
      token: i.value,
      hashId: s.value,
      path: ["Shared", c.value]
    }));
    Bb(f, () => [{
      // Link
      "&": nG(i.value)
    }]);
    const d = V(() => ({
      theme: o.value,
      token: i.value,
      hashId: s.value,
      path: [e, a.value, u.value]
    }));
    return [Bb(d, () => {
      const {
        token: p,
        flush: v
      } = oG(i.value), h = typeof n == "function" ? n(p) : n, m = D(D({}, h), i.value[e]), y = `.${a.value}`, x = xn(p, {
        componentCls: y,
        prefixCls: a.value,
        iconCls: `.${u.value}`,
        antCls: `.${c.value}`
      }, m), g = t(x, {
        hashId: s.value,
        prefixCls: a.value,
        rootPrefixCls: c.value,
        iconPrefixCls: u.value,
        overrideComponentToken: i.value[e]
      });
      return v(e, m), [rG(i.value, a.value), g];
    }), s];
  };
}
const KI = process.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC < "u";
let Ub = !0;
function xn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  if (!KI)
    return D({}, ...t);
  Ub = !1;
  const r = {};
  return t.forEach((a) => {
    Object.keys(a).forEach((i) => {
      Object.defineProperty(r, i, {
        configurable: !0,
        enumerable: !0,
        get: () => a[i]
      });
    });
  }), Ub = !0, r;
}
function aG() {
}
function oG(e) {
  let t, n = e, r = aG;
  return KI && (t = /* @__PURE__ */ new Set(), n = new Proxy(e, {
    get(a, o) {
      return Ub && t.add(o), a[o];
    }
  }), r = (a, o) => {
    Array.from(t);
  }), {
    token: n,
    keys: t,
    flush: r
  };
}
const iG = II(JW), YI = {
  token: Xg,
  hashed: !0
}, qI = Symbol("DesignTokenContext"), zb = Be(), sG = (e) => {
  kt(qI, e), He(e, () => {
    zb.value = U(e), y9(zb);
  }, {
    immediate: !0,
    deep: !0
  });
}, lG = /* @__PURE__ */ Me({
  props: {
    value: hn()
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    return sG(V(() => e.value)), () => {
      var r;
      return (r = n.default) === null || r === void 0 ? void 0 : r.call(n);
    };
  }
});
function bd() {
  const e = Ke(qI, V(() => zb.value || YI)), t = V(() => `${TW}-${e.value.hashed || ""}`), n = V(() => e.value.theme || iG), r = Jz(n, V(() => [Xg, e.value.token]), V(() => ({
    salt: t.value,
    override: D({
      override: e.value.token
    }, e.value.components),
    formatToken: tG
  })));
  return [n, V(() => r.value[0]), V(() => e.value.hashed ? r.value[1] : "")];
}
const XI = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  setup() {
    const [, e] = bd(), t = V(() => new ir(e.value.colorBgBase).toHsl().l < 0.5 ? {
      opacity: 0.65
    } : {});
    return () => A("svg", {
      style: t.value,
      width: "184",
      height: "152",
      viewBox: "0 0 184 152",
      xmlns: "http://www.w3.org/2000/svg"
    }, [A("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [A("g", {
      transform: "translate(24 31.67)"
    }, [A("ellipse", {
      "fill-opacity": ".8",
      fill: "#F5F5F7",
      cx: "67.797",
      cy: "106.89",
      rx: "67.797",
      ry: "12.668"
    }, null), A("path", {
      d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
      fill: "#AEB8C2"
    }, null), A("path", {
      d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
      fill: "url(#linearGradient-1)",
      transform: "translate(13.56)"
    }, null), A("path", {
      d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
      fill: "#F5F5F7"
    }, null), A("path", {
      d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
      fill: "#DCE0E6"
    }, null)]), A("path", {
      d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
      fill: "#DCE0E6"
    }, null), A("g", {
      transform: "translate(149.65 15.383)",
      fill: "#FFF"
    }, [A("ellipse", {
      cx: "20.654",
      cy: "3.167",
      rx: "2.849",
      ry: "2.815"
    }, null), A("path", {
      d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }, null)])])]);
  }
});
XI.PRESENTED_IMAGE_DEFAULT = !0;
const ZI = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  setup() {
    const [, e] = bd(), t = V(() => {
      const {
        colorFill: n,
        colorFillTertiary: r,
        colorFillQuaternary: a,
        colorBgContainer: o
      } = e.value;
      return {
        borderColor: new ir(n).onBackground(o).toHexString(),
        shadowColor: new ir(r).onBackground(o).toHexString(),
        contentColor: new ir(a).onBackground(o).toHexString()
      };
    });
    return () => A("svg", {
      width: "64",
      height: "41",
      viewBox: "0 0 64 41",
      xmlns: "http://www.w3.org/2000/svg"
    }, [A("g", {
      transform: "translate(0 1)",
      fill: "none",
      "fill-rule": "evenodd"
    }, [A("ellipse", {
      fill: t.value.shadowColor,
      cx: "32",
      cy: "33",
      rx: "32",
      ry: "7"
    }, null), A("g", {
      "fill-rule": "nonzero",
      stroke: t.value.borderColor
    }, [A("path", {
      d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }, null), A("path", {
      d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
      fill: t.value.contentColor
    }, null)])])]);
  }
});
ZI.PRESENTED_IMAGE_SIMPLE = !0;
const uG = (e) => {
  const {
    componentCls: t,
    margin: n,
    marginXS: r,
    marginXL: a,
    fontSize: o,
    lineHeight: i
  } = e;
  return {
    [t]: {
      marginInline: r,
      fontSize: o,
      lineHeight: i,
      textAlign: "center",
      // 原来 &-image 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${t}-image`]: {
        height: e.emptyImgHeight,
        marginBottom: r,
        opacity: e.opacityImage,
        img: {
          height: "100%"
        },
        svg: {
          height: "100%",
          margin: "auto"
        }
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${t}-footer`]: {
        marginTop: n
      },
      "&-normal": {
        marginBlock: a,
        color: e.colorTextDisabled,
        [`${t}-image`]: {
          height: e.emptyImgHeightMD
        }
      },
      "&-small": {
        marginBlock: r,
        color: e.colorTextDisabled,
        [`${t}-image`]: {
          height: e.emptyImgHeightSM
        }
      }
    }
  };
}, cG = xr("Empty", (e) => {
  const {
    componentCls: t,
    controlHeightLG: n
  } = e, r = xn(e, {
    emptyImgCls: `${t}-img`,
    emptyImgHeight: n * 2.5,
    emptyImgHeightMD: n,
    emptyImgHeightSM: n * 0.875
  });
  return [uG(r)];
});
var fG = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const QI = A(XI, null, null), JI = A(ZI, null, null), dG = () => ({
  prefixCls: String,
  imageStyle: hn(),
  image: Oi(),
  description: Oi()
}), q_ = /* @__PURE__ */ Me({
  name: "AEmpty",
  compatConfig: {
    MODE: 3
  },
  inheritAttrs: !1,
  props: dG(),
  setup(e, t) {
    let {
      slots: n = {},
      attrs: r
    } = t;
    const {
      direction: a,
      prefixCls: o
    } = mn("empty", e), [i, s] = cG(o);
    return () => {
      var l, u;
      const c = o.value, f = D(D({}, e), r), {
        image: d = ((l = n.image) === null || l === void 0 ? void 0 : l.call(n)) || QI,
        description: p = ((u = n.description) === null || u === void 0 ? void 0 : u.call(n)) || void 0,
        imageStyle: v,
        class: h = ""
      } = f, m = fG(f, ["image", "description", "imageStyle", "class"]);
      return i(A(xI, {
        componentName: "Empty",
        children: (y) => {
          const x = typeof p < "u" ? p : y.description, g = typeof x == "string" ? x : "empty";
          let S = null;
          return typeof d == "string" ? S = A("img", {
            alt: g,
            src: d
          }, null) : S = d, A("div", ve({
            class: Ge(c, h, s.value, {
              [`${c}-normal`]: d === JI,
              [`${c}-rtl`]: a.value === "rtl"
            })
          }, m), [A("div", {
            class: `${c}-image`,
            style: v
          }, [S]), x && A("p", {
            class: `${c}-description`
          }, [x]), n.default && A("div", {
            class: `${c}-footer`
          }, [_s(n.default())])]);
        }
      }, null));
    };
  }
});
q_.PRESENTED_IMAGE_DEFAULT = QI;
q_.PRESENTED_IMAGE_SIMPLE = JI;
const Bd = yd(q_), X_ = (e) => {
  const {
    prefixCls: t
  } = mn("empty", e);
  return ((r) => {
    switch (r) {
      case "Table":
      case "List":
        return A(Bd, {
          image: Bd.PRESENTED_IMAGE_SIMPLE
        }, null);
      case "Select":
      case "TreeSelect":
      case "Cascader":
      case "Transfer":
      case "Mentions":
        return A(Bd, {
          image: Bd.PRESENTED_IMAGE_SIMPLE,
          class: `${t.value}-small`
        }, null);
      default:
        return A(Bd, null, null);
    }
  })(e.componentName);
};
function pG(e) {
  return A(X_, {
    componentName: e
  }, null);
}
const eP = Symbol("SizeContextKey"), tP = () => Ke(eP, ne(void 0)), nP = (e) => {
  const t = tP();
  return kt(eP, V(() => e.value || t.value)), e;
}, mn = (e, t) => {
  const n = tP(), r = Ec(), a = Ke(U_, D(D({}, hI), {
    renderEmpty: (b) => Z0(X_, {
      componentName: b
    })
  })), o = V(() => a.getPrefixCls(e, t.prefixCls)), i = V(() => {
    var b, E;
    return (b = t.direction) !== null && b !== void 0 ? b : (E = a.direction) === null || E === void 0 ? void 0 : E.value;
  }), s = V(() => {
    var b;
    return (b = t.iconPrefixCls) !== null && b !== void 0 ? b : a.iconPrefixCls.value;
  }), l = V(() => a.getPrefixCls()), u = V(() => {
    var b;
    return (b = a.autoInsertSpaceInButton) === null || b === void 0 ? void 0 : b.value;
  }), c = a.renderEmpty, f = a.space, d = a.pageHeader, p = a.form, v = V(() => {
    var b, E;
    return (b = t.getTargetContainer) !== null && b !== void 0 ? b : (E = a.getTargetContainer) === null || E === void 0 ? void 0 : E.value;
  }), h = V(() => {
    var b, E, C;
    return (E = (b = t.getContainer) !== null && b !== void 0 ? b : t.getPopupContainer) !== null && E !== void 0 ? E : (C = a.getPopupContainer) === null || C === void 0 ? void 0 : C.value;
  }), m = V(() => {
    var b, E;
    return (b = t.dropdownMatchSelectWidth) !== null && b !== void 0 ? b : (E = a.dropdownMatchSelectWidth) === null || E === void 0 ? void 0 : E.value;
  }), y = V(() => {
    var b;
    return (t.virtual === void 0 ? ((b = a.virtual) === null || b === void 0 ? void 0 : b.value) !== !1 : t.virtual !== !1) && m.value !== !1;
  }), x = V(() => t.size || n.value), g = V(() => {
    var b, E, C;
    return (b = t.autocomplete) !== null && b !== void 0 ? b : (C = (E = a.input) === null || E === void 0 ? void 0 : E.value) === null || C === void 0 ? void 0 : C.autocomplete;
  }), S = V(() => {
    var b;
    return (b = t.disabled) !== null && b !== void 0 ? b : r.value;
  }), w = V(() => {
    var b;
    return (b = t.csp) !== null && b !== void 0 ? b : a.csp;
  }), _ = V(() => {
    var b, E;
    return (b = t.wave) !== null && b !== void 0 ? b : (E = a.wave) === null || E === void 0 ? void 0 : E.value;
  });
  return {
    configProvider: a,
    prefixCls: o,
    direction: i,
    size: x,
    getTargetContainer: v,
    getPopupContainer: h,
    space: f,
    pageHeader: d,
    form: p,
    autoInsertSpaceInButton: u,
    renderEmpty: c,
    virtual: y,
    dropdownMatchSelectWidth: m,
    rootPrefixCls: l,
    getPrefixCls: a.getPrefixCls,
    autocomplete: g,
    csp: w,
    iconPrefixCls: s,
    disabled: S,
    select: a.select,
    wave: _
  };
};
function Lr(e, t) {
  const n = D({}, e);
  for (let r = 0; r < t.length; r += 1) {
    const a = t[r];
    delete n[a];
  }
  return n;
}
function dT(e) {
  return typeof e == "object" && e != null && e.nodeType === 1;
}
function pT(e, t) {
  return (!t || e !== "hidden") && e !== "visible" && e !== "clip";
}
function Sy(e, t) {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    var n = getComputedStyle(e, null);
    return pT(n.overflowY, t) || pT(n.overflowX, t) || function(r) {
      var a = function(o) {
        if (!o.ownerDocument || !o.ownerDocument.defaultView) return null;
        try {
          return o.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      }(r);
      return !!a && (a.clientHeight < r.scrollHeight || a.clientWidth < r.scrollWidth);
    }(e);
  }
  return !1;
}
function Mh(e, t, n, r, a, o, i, s) {
  return o < e && i > t || o > e && i < t ? 0 : o <= e && s <= n || i >= t && s >= n ? o - e - r : i > t && s < n || o < e && s > n ? i - t + a : 0;
}
var hT = function(e, t) {
  var n = window, r = t.scrollMode, a = t.block, o = t.inline, i = t.boundary, s = t.skipOverflowHiddenElements, l = typeof i == "function" ? i : function(j) {
    return j !== i;
  };
  if (!dT(e)) throw new TypeError("Invalid target");
  for (var u, c, f = document.scrollingElement || document.documentElement, d = [], p = e; dT(p) && l(p); ) {
    if ((p = (c = (u = p).parentElement) == null ? u.getRootNode().host || null : c) === f) {
      d.push(p);
      break;
    }
    p != null && p === document.body && Sy(p) && !Sy(document.documentElement) || p != null && Sy(p, s) && d.push(p);
  }
  for (var v = n.visualViewport ? n.visualViewport.width : innerWidth, h = n.visualViewport ? n.visualViewport.height : innerHeight, m = window.scrollX || pageXOffset, y = window.scrollY || pageYOffset, x = e.getBoundingClientRect(), g = x.height, S = x.width, w = x.top, _ = x.right, b = x.bottom, E = x.left, C = a === "start" || a === "nearest" ? w : a === "end" ? b : w + g / 2, T = o === "center" ? E + S / 2 : o === "end" ? _ : E, O = [], I = 0; I < d.length; I++) {
    var k = d[I], B = k.getBoundingClientRect(), P = B.height, N = B.width, M = B.top, H = B.right, R = B.bottom, z = B.left;
    if (r === "if-needed" && w >= 0 && E >= 0 && b <= h && _ <= v && w >= M && b <= R && E >= z && _ <= H) return O;
    var W = getComputedStyle(k), F = parseInt(W.borderLeftWidth, 10), Y = parseInt(W.borderTopWidth, 10), X = parseInt(W.borderRightWidth, 10), q = parseInt(W.borderBottomWidth, 10), Q = 0, ue = 0, le = "offsetWidth" in k ? k.offsetWidth - k.clientWidth - F - X : 0, te = "offsetHeight" in k ? k.offsetHeight - k.clientHeight - Y - q : 0, G = "offsetWidth" in k ? k.offsetWidth === 0 ? 0 : N / k.offsetWidth : 0, oe = "offsetHeight" in k ? k.offsetHeight === 0 ? 0 : P / k.offsetHeight : 0;
    if (f === k) Q = a === "start" ? C : a === "end" ? C - h : a === "nearest" ? Mh(y, y + h, h, Y, q, y + C, y + C + g, g) : C - h / 2, ue = o === "start" ? T : o === "center" ? T - v / 2 : o === "end" ? T - v : Mh(m, m + v, v, F, X, m + T, m + T + S, S), Q = Math.max(0, Q + y), ue = Math.max(0, ue + m);
    else {
      Q = a === "start" ? C - M - Y : a === "end" ? C - R + q + te : a === "nearest" ? Mh(M, R, P, Y, q + te, C, C + g, g) : C - (M + P / 2) + te / 2, ue = o === "start" ? T - z - F : o === "center" ? T - (z + N / 2) + le / 2 : o === "end" ? T - H + X + le : Mh(z, H, N, F, X + le, T, T + S, S);
      var L = k.scrollLeft, re = k.scrollTop;
      C += re - (Q = Math.max(0, Math.min(re + Q / oe, k.scrollHeight - P / oe + te))), T += L - (ue = Math.max(0, Math.min(L + ue / G, k.scrollWidth - N / G + le)));
    }
    O.push({ el: k, top: Q, left: ue });
  }
  return O;
};
function rP(e) {
  return e === Object(e) && Object.keys(e).length !== 0;
}
function hG(e, t) {
  t === void 0 && (t = "auto");
  var n = "scrollBehavior" in document.body.style;
  e.forEach(function(r) {
    var a = r.el, o = r.top, i = r.left;
    a.scroll && n ? a.scroll({
      top: o,
      left: i,
      behavior: t
    }) : (a.scrollTop = o, a.scrollLeft = i);
  });
}
function vG(e) {
  return e === !1 ? {
    block: "end",
    inline: "nearest"
  } : rP(e) ? e : {
    block: "start",
    inline: "nearest"
  };
}
function mG(e, t) {
  var n = e.isConnected || e.ownerDocument.documentElement.contains(e);
  if (rP(t) && typeof t.behavior == "function")
    return t.behavior(n ? hT(e, t) : []);
  if (n) {
    var r = vG(t);
    return hG(hT(e, r), r.behavior);
  }
}
function gG(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function aP(e, t, n) {
  return n && gG(e, n), e;
}
function kv() {
  return (kv = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function oP(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function iP(e, t) {
  if (e == null) return {};
  var n, r, a = {}, o = Object.keys(e);
  for (r = 0; r < o.length; r++) t.indexOf(n = o[r]) >= 0 || (a[n] = e[n]);
  return a;
}
function vT(e) {
  return ((t = e) != null && typeof t == "object" && Array.isArray(t) === !1) == 1 && Object.prototype.toString.call(e) === "[object Object]";
  var t;
}
var sP = Object.prototype, lP = sP.toString, yG = sP.hasOwnProperty, uP = /^\s*function (\w+)/;
function mT(e) {
  var t, n = (t = e == null ? void 0 : e.type) !== null && t !== void 0 ? t : e;
  if (n) {
    var r = n.toString().match(uP);
    return r ? r[1] : "";
  }
  return "";
}
var dc = function(e) {
  var t, n;
  return vT(e) !== !1 && typeof (t = e.constructor) == "function" && vT(n = t.prototype) !== !1 && n.hasOwnProperty("isPrototypeOf") !== !1;
}, cP = function(e) {
  return e;
}, Ea = cP;
if (process.env.NODE_ENV !== "production") {
  var xG = typeof console < "u";
  Ea = xG ? function(e) {
    console.warn("[VueTypes warn]: " + e);
  } : cP;
}
var lp = function(e, t) {
  return yG.call(e, t);
}, bG = Number.isInteger || function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}, Wf = Array.isArray || function(e) {
  return lP.call(e) === "[object Array]";
}, Gf = function(e) {
  return lP.call(e) === "[object Function]";
}, Sm = function(e) {
  return dc(e) && lp(e, "_vueTypes_name");
}, fP = function(e) {
  return dc(e) && (lp(e, "type") || ["_vueTypes_name", "validator", "default", "required"].some(function(t) {
    return lp(e, t);
  }));
};
function Z_(e, t) {
  return Object.defineProperty(e.bind(t), "__original", { value: e });
}
function $c(e, t, n) {
  var r;
  n === void 0 && (n = !1);
  var a = !0, o = "";
  r = dc(e) ? e : { type: e };
  var i = Sm(r) ? r._vueTypes_name + " - " : "";
  if (fP(r) && r.type !== null) {
    if (r.type === void 0 || r.type === !0 || !r.required && t === void 0) return a;
    Wf(r.type) ? (a = r.type.some(function(f) {
      return $c(f, t, !0) === !0;
    }), o = r.type.map(function(f) {
      return mT(f);
    }).join(" or ")) : a = (o = mT(r)) === "Array" ? Wf(t) : o === "Object" ? dc(t) : o === "String" || o === "Number" || o === "Boolean" || o === "Function" ? function(f) {
      if (f == null) return "";
      var d = f.constructor.toString().match(uP);
      return d ? d[1] : "";
    }(t) === o : t instanceof r.type;
  }
  if (!a) {
    var s = i + 'value "' + t + '" should be of type "' + o + '"';
    return n === !1 ? (Ea(s), !1) : s;
  }
  if (lp(r, "validator") && Gf(r.validator)) {
    var l = Ea, u = [];
    if (Ea = function(f) {
      u.push(f);
    }, a = r.validator(t), Ea = l, !a) {
      var c = (u.length > 1 ? "* " : "") + u.join(`
* `);
      return u.length = 0, n === !1 ? (Ea(c), a) : c;
    }
  }
  return a;
}
function No(e, t) {
  var n = Object.defineProperties(t, { _vueTypes_name: { value: e, writable: !0 }, isRequired: { get: function() {
    return this.required = !0, this;
  } }, def: { value: function(a) {
    return a !== void 0 || this.default ? Gf(a) || $c(this, a, !0) === !0 ? (this.default = Wf(a) ? function() {
      return [].concat(a);
    } : dc(a) ? function() {
      return Object.assign({}, a);
    } : a, this) : (Ea(this._vueTypes_name + ' - invalid default value: "' + a + '"'), this) : this;
  } } }), r = n.validator;
  return Gf(r) && (n.validator = Z_(r, n)), n;
}
function gs(e, t) {
  var n = No(e, t);
  return Object.defineProperty(n, "validate", { value: function(r) {
    return Gf(this.validator) && Ea(this._vueTypes_name + ` - calling .validate() will overwrite the current custom validator function. Validator info:
` + JSON.stringify(this)), this.validator = Z_(r, this), this;
  } });
}
function gT(e, t, n) {
  var r, a, o = (r = t, a = {}, Object.getOwnPropertyNames(r).forEach(function(f) {
    a[f] = Object.getOwnPropertyDescriptor(r, f);
  }), Object.defineProperties({}, a));
  if (o._vueTypes_name = e, !dc(n)) return o;
  var i, s, l = n.validator, u = iP(n, ["validator"]);
  if (Gf(l)) {
    var c = o.validator;
    c && (c = (s = (i = c).__original) !== null && s !== void 0 ? s : i), o.validator = Z_(c ? function(f) {
      return c.call(this, f) && l.call(this, f);
    } : l, o);
  }
  return Object.assign(o, u);
}
function Qg(e) {
  return e.replace(/^(?!\s*$)/gm, "  ");
}
var wG = function() {
  return gs("any", {});
}, SG = function() {
  return gs("function", { type: Function });
}, _G = function() {
  return gs("boolean", { type: Boolean });
}, CG = function() {
  return gs("string", { type: String });
}, EG = function() {
  return gs("number", { type: Number });
}, TG = function() {
  return gs("array", { type: Array });
}, $G = function() {
  return gs("object", { type: Object });
}, OG = function() {
  return No("integer", { type: Number, validator: function(e) {
    return bG(e);
  } });
}, AG = function() {
  return No("symbol", { validator: function(e) {
    return typeof e == "symbol";
  } });
};
function IG(e, t) {
  if (t === void 0 && (t = "custom validation failed"), typeof e != "function") throw new TypeError("[VueTypes error]: You must provide a function as argument");
  return No(e.name || "<<anonymous function>>", { validator: function(n) {
    var r = e(n);
    return r || Ea(this._vueTypes_name + " - " + t), r;
  } });
}
function PG(e) {
  if (!Wf(e)) throw new TypeError("[VueTypes error]: You must provide an array as argument.");
  var t = 'oneOf - value should be one of "' + e.join('", "') + '".', n = e.reduce(function(r, a) {
    if (a != null) {
      var o = a.constructor;
      r.indexOf(o) === -1 && r.push(o);
    }
    return r;
  }, []);
  return No("oneOf", { type: n.length > 0 ? n : void 0, validator: function(r) {
    var a = e.indexOf(r) !== -1;
    return a || Ea(t), a;
  } });
}
function DG(e) {
  if (!Wf(e)) throw new TypeError("[VueTypes error]: You must provide an array as argument");
  for (var t = !1, n = [], r = 0; r < e.length; r += 1) {
    var a = e[r];
    if (fP(a)) {
      if (Sm(a) && a._vueTypes_name === "oneOf") {
        n = n.concat(a.type);
        continue;
      }
      if (Gf(a.validator) && (t = !0), a.type !== !0 && a.type) {
        n = n.concat(a.type);
        continue;
      }
    }
    n.push(a);
  }
  return n = n.filter(function(o, i) {
    return n.indexOf(o) === i;
  }), No("oneOfType", t ? { type: n, validator: function(o) {
    var i = [], s = e.some(function(l) {
      var u = $c(Sm(l) && l._vueTypes_name === "oneOf" ? l.type || null : l, o, !0);
      return typeof u == "string" && i.push(u), u === !0;
    });
    return s || Ea("oneOfType - provided value does not match any of the " + i.length + ` passed-in validators:
` + Qg(i.join(`
`))), s;
  } } : { type: n });
}
function kG(e) {
  return No("arrayOf", { type: Array, validator: function(t) {
    var n, r = t.every(function(a) {
      return (n = $c(e, a, !0)) === !0;
    });
    return r || Ea(`arrayOf - value validation error:
` + Qg(n)), r;
  } });
}
function MG(e) {
  return No("instanceOf", { type: e });
}
function RG(e) {
  return No("objectOf", { type: Object, validator: function(t) {
    var n, r = Object.keys(t).every(function(a) {
      return (n = $c(e, t[a], !0)) === !0;
    });
    return r || Ea(`objectOf - value validation error:
` + Qg(n)), r;
  } });
}
function NG(e) {
  var t = Object.keys(e), n = t.filter(function(a) {
    var o;
    return !!(!((o = e[a]) === null || o === void 0) && o.required);
  }), r = No("shape", { type: Object, validator: function(a) {
    var o = this;
    if (!dc(a)) return !1;
    var i = Object.keys(a);
    if (n.length > 0 && n.some(function(l) {
      return i.indexOf(l) === -1;
    })) {
      var s = n.filter(function(l) {
        return i.indexOf(l) === -1;
      });
      return Ea(s.length === 1 ? 'shape - required property "' + s[0] + '" is not defined.' : 'shape - required properties "' + s.join('", "') + '" are not defined.'), !1;
    }
    return i.every(function(l) {
      if (t.indexOf(l) === -1) return o._vueTypes_isLoose === !0 || (Ea('shape - shape definition does not include a "' + l + '" property. Allowed keys: "' + t.join('", "') + '".'), !1);
      var u = $c(e[l], a[l], !0);
      return typeof u == "string" && Ea('shape - "' + l + `" property validation error:
 ` + Qg(u)), u === !0;
    });
  } });
  return Object.defineProperty(r, "_vueTypes_isLoose", { writable: !0, value: !1 }), Object.defineProperty(r, "loose", { get: function() {
    return this._vueTypes_isLoose = !0, this;
  } }), r;
}
var Xi = function() {
  function e() {
  }
  return e.extend = function(t) {
    var n = this;
    if (Wf(t)) return t.forEach(function(f) {
      return n.extend(f);
    }), this;
    var r = t.name, a = t.validate, o = a !== void 0 && a, i = t.getter, s = i !== void 0 && i, l = iP(t, ["name", "validate", "getter"]);
    if (lp(this, r)) throw new TypeError('[VueTypes error]: Type "' + r + '" already defined');
    var u, c = l.type;
    return Sm(c) ? (delete l.type, Object.defineProperty(this, r, s ? { get: function() {
      return gT(r, c, l);
    } } : { value: function() {
      var f, d = gT(r, c, l);
      return d.validator && (d.validator = (f = d.validator).bind.apply(f, [d].concat([].slice.call(arguments)))), d;
    } })) : (u = s ? { get: function() {
      var f = Object.assign({}, l);
      return o ? gs(r, f) : No(r, f);
    }, enumerable: !0 } : { value: function() {
      var f, d, p = Object.assign({}, l);
      return f = o ? gs(r, p) : No(r, p), p.validator && (f.validator = (d = p.validator).bind.apply(d, [f].concat([].slice.call(arguments)))), f;
    }, enumerable: !0 }, Object.defineProperty(this, r, u));
  }, aP(e, null, [{ key: "any", get: function() {
    return wG();
  } }, { key: "func", get: function() {
    return SG().def(this.defaults.func);
  } }, { key: "bool", get: function() {
    return _G().def(this.defaults.bool);
  } }, { key: "string", get: function() {
    return CG().def(this.defaults.string);
  } }, { key: "number", get: function() {
    return EG().def(this.defaults.number);
  } }, { key: "array", get: function() {
    return TG().def(this.defaults.array);
  } }, { key: "object", get: function() {
    return $G().def(this.defaults.object);
  } }, { key: "integer", get: function() {
    return OG().def(this.defaults.integer);
  } }, { key: "symbol", get: function() {
    return AG();
  } }]), e;
}();
function dP(e) {
  var t;
  return e === void 0 && (e = { func: function() {
  }, bool: !0, string: "", number: 0, array: function() {
    return [];
  }, object: function() {
    return {};
  }, integer: 0 }), (t = function(n) {
    function r() {
      return n.apply(this, arguments) || this;
    }
    return oP(r, n), aP(r, null, [{ key: "sensibleDefaults", get: function() {
      return kv({}, this.defaults);
    }, set: function(a) {
      this.defaults = a !== !1 ? kv({}, a !== !0 ? a : e) : {};
    } }]), r;
  }(Xi)).defaults = kv({}, e), t;
}
Xi.defaults = {}, Xi.custom = IG, Xi.oneOf = PG, Xi.instanceOf = MG, Xi.oneOfType = DG, Xi.arrayOf = kG, Xi.objectOf = RG, Xi.shape = NG, Xi.utils = { validate: function(e, t) {
  return $c(t, e, !0) === !0;
}, toType: function(e, t, n) {
  return n === void 0 && (n = !1), n ? gs(e, t) : No(e, t);
} };
(function(e) {
  function t() {
    return e.apply(this, arguments) || this;
  }
  return oP(t, e), t;
})(dP());
const Oe = dP({
  func: void 0,
  bool: void 0,
  string: void 0,
  number: void 0,
  array: void 0,
  object: void 0,
  integer: void 0
});
Oe.extend([{
  name: "looseBool",
  getter: !0,
  type: Boolean,
  default: void 0
}, {
  name: "style",
  getter: !0,
  type: [String, Object],
  default: void 0
}, {
  name: "VueNode",
  getter: !0,
  type: null
}]);
const Aa = (e, t, n) => {
  $o(e, `[ant-design-vue: ${t}] ${n}`);
};
function yT(e, t) {
  const {
    key: n
  } = e;
  let r;
  return "value" in e && ({
    value: r
  } = e), n ?? (r !== void 0 ? r : `rc-index-key-${t}`);
}
function pP(e, t) {
  const {
    label: n,
    value: r,
    options: a
  } = e || {};
  return {
    label: n || (t ? "children" : "label"),
    value: r || "value",
    options: a || "options"
  };
}
function FG(e) {
  let {
    fieldNames: t,
    childrenAsData: n
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const r = [], {
    label: a,
    value: o,
    options: i
  } = pP(t, !1);
  function s(l, u) {
    l.forEach((c) => {
      const f = c[a];
      if (u || !(i in c)) {
        const d = c[o];
        r.push({
          key: yT(c, r.length),
          groupOption: u,
          data: c,
          label: f,
          value: d
        });
      } else {
        let d = f;
        d === void 0 && n && (d = c.label), r.push({
          key: yT(c, r.length),
          group: !0,
          data: c,
          label: d
        }), s(c[i], !0);
      }
    });
  }
  return s(e, !1), r;
}
function Wb(e) {
  const t = D({}, e);
  return "props" in t || Object.defineProperty(t, "props", {
    get() {
      return Sa(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), t;
    }
  }), t;
}
function LG(e, t) {
  if (!t || !t.length)
    return null;
  let n = !1;
  function r(o, i) {
    let [s, ...l] = i;
    if (!s)
      return [o];
    const u = o.split(s);
    return n = n || u.length > 1, u.reduce((c, f) => [...c, ...r(f, l)], []).filter((c) => c);
  }
  const a = r(e, t);
  return n ? a : null;
}
function BG() {
  return "";
}
function HG(e) {
  return e ? e.ownerDocument : window.document;
}
function hP() {
}
const jG = () => ({
  action: Oe.oneOfType([Oe.string, Oe.arrayOf(Oe.string)]).def([]),
  showAction: Oe.any.def([]),
  hideAction: Oe.any.def([]),
  getPopupClassNameFromAlign: Oe.any.def(BG),
  onPopupVisibleChange: Function,
  afterPopupVisibleChange: Oe.func.def(hP),
  popup: Oe.any,
  popupStyle: {
    type: Object,
    default: void 0
  },
  prefixCls: Oe.string.def("rc-trigger-popup"),
  popupClassName: Oe.string.def(""),
  popupPlacement: String,
  builtinPlacements: Oe.object,
  popupTransitionName: String,
  popupAnimation: Oe.any,
  mouseEnterDelay: Oe.number.def(0),
  mouseLeaveDelay: Oe.number.def(0.1),
  zIndex: Number,
  focusDelay: Oe.number.def(0),
  blurDelay: Oe.number.def(0.15),
  getPopupContainer: Function,
  getDocument: Oe.func.def(HG),
  forceRender: {
    type: Boolean,
    default: void 0
  },
  destroyPopupOnHide: {
    type: Boolean,
    default: !1
  },
  mask: {
    type: Boolean,
    default: !1
  },
  maskClosable: {
    type: Boolean,
    default: !0
  },
  // onPopupAlign: PropTypes.func.def(noop),
  popupAlign: Oe.object.def(() => ({})),
  popupVisible: {
    type: Boolean,
    default: void 0
  },
  defaultPopupVisible: {
    type: Boolean,
    default: !1
  },
  maskTransitionName: String,
  maskAnimation: String,
  stretch: String,
  alignPoint: {
    type: Boolean,
    default: void 0
  },
  autoDestroy: {
    type: Boolean,
    default: !1
  },
  mobile: Object,
  getTriggerDOMNode: Function
}), Q_ = {
  visible: Boolean,
  prefixCls: String,
  zIndex: Number,
  destroyPopupOnHide: Boolean,
  forceRender: Boolean,
  // Legacy Motion
  animation: [String, Object],
  transitionName: String,
  // Measure
  stretch: {
    type: String
  },
  // Align
  align: {
    type: Object
  },
  point: {
    type: Object
  },
  getRootDomNode: {
    type: Function
  },
  getClassNameFromAlign: {
    type: Function
  },
  onAlign: {
    type: Function
  },
  onMouseenter: {
    type: Function
  },
  onMouseleave: {
    type: Function
  },
  onMousedown: {
    type: Function
  },
  onTouchstart: {
    type: Function
  }
}, VG = D(D({}, Q_), {
  mobile: {
    type: Object
  }
}), UG = D(D({}, Q_), {
  mask: Boolean,
  mobile: {
    type: Object
  },
  maskAnimation: String,
  maskTransitionName: String
});
function J_(e) {
  let {
    prefixCls: t,
    animation: n,
    transitionName: r
  } = e;
  return n ? {
    name: `${t}-${n}`
  } : r ? {
    name: r
  } : {};
}
function vP(e) {
  const {
    prefixCls: t,
    visible: n,
    zIndex: r,
    mask: a,
    maskAnimation: o,
    maskTransitionName: i
  } = e;
  if (!a)
    return null;
  let s = {};
  return (i || o) && (s = J_({
    prefixCls: t,
    transitionName: i,
    animation: o
  })), A(Ho, ve({
    appear: !0
  }, s), {
    default: () => [Yn(A("div", {
      style: {
        zIndex: r
      },
      class: `${t}-mask`
    }, null), [[B9("if"), n]])]
  });
}
vP.displayName = "Mask";
const zG = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "MobilePopupInner",
  inheritAttrs: !1,
  props: VG,
  emits: ["mouseenter", "mouseleave", "mousedown", "touchstart", "align"],
  setup(e, t) {
    let {
      expose: n,
      slots: r
    } = t;
    const a = ne();
    return n({
      forceAlign: () => {
      },
      getElement: () => a.value
    }), () => {
      var o;
      const {
        zIndex: i,
        visible: s,
        prefixCls: l,
        mobile: {
          popupClassName: u,
          popupStyle: c,
          popupMotion: f = {},
          popupRender: d
        } = {}
      } = e, p = D({
        zIndex: i
      }, c);
      let v = ua((o = r.default) === null || o === void 0 ? void 0 : o.call(r));
      v.length > 1 && (v = A("div", {
        class: `${l}-content`
      }, [v])), d && (v = d(v));
      const h = Ge(l, u);
      return A(Ho, ve({
        ref: a
      }, f), {
        default: () => [s ? A("div", {
          class: h,
          style: p
        }, [v]) : null]
      });
    };
  }
});
var WG = function(e, t, n, r) {
  function a(o) {
    return o instanceof n ? o : new n(function(i) {
      i(o);
    });
  }
  return new (n || (n = Promise))(function(o, i) {
    function s(c) {
      try {
        u(r.next(c));
      } catch (f) {
        i(f);
      }
    }
    function l(c) {
      try {
        u(r.throw(c));
      } catch (f) {
        i(f);
      }
    }
    function u(c) {
      c.done ? o(c.value) : a(c.value).then(s, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
};
const xT = ["measure", "align", null, "motion"], GG = (e, t) => {
  const n = Be(null), r = Be(), a = Be(!1);
  function o(l) {
    a.value || (n.value = l);
  }
  function i() {
    dn.cancel(r.value);
  }
  function s(l) {
    i(), r.value = dn(() => {
      let u = n.value;
      switch (n.value) {
        case "align":
          u = "motion";
          break;
        case "motion":
          u = "stable";
          break;
      }
      o(u), l == null || l();
    });
  }
  return He(e, () => {
    o("measure");
  }, {
    immediate: !0,
    flush: "post"
  }), Lt(() => {
    He(n, () => {
      switch (n.value) {
        case "measure":
          t();
          break;
      }
      n.value && (r.value = dn(() => WG(void 0, void 0, void 0, function* () {
        const l = xT.indexOf(n.value), u = xT[l + 1];
        u && l !== -1 && o(u);
      })));
    }, {
      immediate: !0,
      flush: "post"
    });
  }), Sn(() => {
    a.value = !0, i();
  }), [n, s];
}, KG = (e) => {
  const t = Be({
    width: 0,
    height: 0
  });
  function n(a) {
    t.value = {
      width: a.offsetWidth,
      height: a.offsetHeight
    };
  }
  return [V(() => {
    const a = {};
    if (e.value) {
      const {
        width: o,
        height: i
      } = t.value;
      e.value.indexOf("height") !== -1 && i ? a.height = `${i}px` : e.value.indexOf("minHeight") !== -1 && i && (a.minHeight = `${i}px`), e.value.indexOf("width") !== -1 && o ? a.width = `${o}px` : e.value.indexOf("minWidth") !== -1 && o && (a.minWidth = `${o}px`);
    }
    return a;
  }), n];
};
function bT(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function wT(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bT(Object(n), !0).forEach(function(r) {
      YG(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bT(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Gb(e) {
  "@babel/helpers - typeof";
  return Gb = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gb(e);
}
function YG(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var Hd, qG = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  // IE did it wrong again ...
  ms: "-ms-",
  O: "-o-"
};
function _m() {
  if (Hd !== void 0)
    return Hd;
  Hd = "";
  var e = document.createElement("p").style, t = "Transform";
  for (var n in qG)
    n + t in e && (Hd = n);
  return Hd;
}
function mP() {
  return _m() ? "".concat(_m(), "TransitionProperty") : "transitionProperty";
}
function Jg() {
  return _m() ? "".concat(_m(), "Transform") : "transform";
}
function ST(e, t) {
  var n = mP();
  n && (e.style[n] = t, n !== "transitionProperty" && (e.style.transitionProperty = t));
}
function _y(e, t) {
  var n = Jg();
  n && (e.style[n] = t, n !== "transform" && (e.style.transform = t));
}
function XG(e) {
  return e.style.transitionProperty || e.style[mP()];
}
function ZG(e) {
  var t = window.getComputedStyle(e, null), n = t.getPropertyValue("transform") || t.getPropertyValue(Jg());
  if (n && n !== "none") {
    var r = n.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(r[12] || r[4], 0),
      y: parseFloat(r[13] || r[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var QG = /matrix\((.*)\)/, JG = /matrix3d\((.*)\)/;
function eK(e, t) {
  var n = window.getComputedStyle(e, null), r = n.getPropertyValue("transform") || n.getPropertyValue(Jg());
  if (r && r !== "none") {
    var a, o = r.match(QG);
    if (o)
      o = o[1], a = o.split(",").map(function(s) {
        return parseFloat(s, 10);
      }), a[4] = t.x, a[5] = t.y, _y(e, "matrix(".concat(a.join(","), ")"));
    else {
      var i = r.match(JG)[1];
      a = i.split(",").map(function(s) {
        return parseFloat(s, 10);
      }), a[12] = t.x, a[13] = t.y, _y(e, "matrix3d(".concat(a.join(","), ")"));
    }
  } else
    _y(e, "translateX(".concat(t.x, "px) translateY(").concat(t.y, "px) translateZ(0)"));
}
var tK = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source, Fp;
function _T(e) {
  var t = e.style.display;
  e.style.display = "none", e.offsetHeight, e.style.display = t;
}
function Ef(e, t, n) {
  var r = n;
  if (Gb(t) === "object") {
    for (var a in t)
      t.hasOwnProperty(a) && Ef(e, a, t[a]);
    return;
  }
  if (typeof r < "u") {
    typeof r == "number" && (r = "".concat(r, "px")), e.style[t] = r;
    return;
  }
  return Fp(e, t);
}
function nK(e) {
  var t, n, r, a = e.ownerDocument, o = a.body, i = a && a.documentElement;
  return t = e.getBoundingClientRect(), n = Math.floor(t.left), r = Math.floor(t.top), n -= i.clientLeft || o.clientLeft || 0, r -= i.clientTop || o.clientTop || 0, {
    left: n,
    top: r
  };
}
function gP(e, t) {
  var n = e["page".concat(t ? "Y" : "X", "Offset")], r = "scroll".concat(t ? "Top" : "Left");
  if (typeof n != "number") {
    var a = e.document;
    n = a.documentElement[r], typeof n != "number" && (n = a.body[r]);
  }
  return n;
}
function yP(e) {
  return gP(e);
}
function xP(e) {
  return gP(e, !0);
}
function up(e) {
  var t = nK(e), n = e.ownerDocument, r = n.defaultView || n.parentWindow;
  return t.left += yP(r), t.top += xP(r), t;
}
function eC(e) {
  return e != null && e == e.window;
}
function bP(e) {
  return eC(e) ? e.document : e.nodeType === 9 ? e : e.ownerDocument;
}
function rK(e, t, n) {
  var r = n, a = "", o = bP(e);
  return r = r || o.defaultView.getComputedStyle(e, null), r && (a = r.getPropertyValue(t) || r[t]), a;
}
var aK = new RegExp("^(".concat(tK, ")(?!px)[a-z%]+$"), "i"), oK = /^(top|right|bottom|left)$/, Cy = "currentStyle", Ey = "runtimeStyle", bu = "left", iK = "px";
function sK(e, t) {
  var n = e[Cy] && e[Cy][t];
  if (aK.test(n) && !oK.test(t)) {
    var r = e.style, a = r[bu], o = e[Ey][bu];
    e[Ey][bu] = e[Cy][bu], r[bu] = t === "fontSize" ? "1em" : n || 0, n = r.pixelLeft + iK, r[bu] = a, e[Ey][bu] = o;
  }
  return n === "" ? "auto" : n;
}
typeof window < "u" && (Fp = window.getComputedStyle ? rK : sK);
function Rh(e, t) {
  return e === "left" ? t.useCssRight ? "right" : e : t.useCssBottom ? "bottom" : e;
}
function CT(e) {
  if (e === "left")
    return "right";
  if (e === "right")
    return "left";
  if (e === "top")
    return "bottom";
  if (e === "bottom")
    return "top";
}
function ET(e, t, n) {
  Ef(e, "position") === "static" && (e.style.position = "relative");
  var r = -999, a = -999, o = Rh("left", n), i = Rh("top", n), s = CT(o), l = CT(i);
  o !== "left" && (r = 999), i !== "top" && (a = 999);
  var u = "", c = up(e);
  ("left" in t || "top" in t) && (u = XG(e) || "", ST(e, "none")), "left" in t && (e.style[s] = "", e.style[o] = "".concat(r, "px")), "top" in t && (e.style[l] = "", e.style[i] = "".concat(a, "px")), _T(e);
  var f = up(e), d = {};
  for (var p in t)
    if (t.hasOwnProperty(p)) {
      var v = Rh(p, n), h = p === "left" ? r : a, m = c[p] - f[p];
      v === p ? d[v] = h + m : d[v] = h - m;
    }
  Ef(e, d), _T(e), ("left" in t || "top" in t) && ST(e, u);
  var y = {};
  for (var x in t)
    if (t.hasOwnProperty(x)) {
      var g = Rh(x, n), S = t[x] - c[x];
      x === g ? y[g] = d[g] + S : y[g] = d[g] - S;
    }
  Ef(e, y);
}
function lK(e, t) {
  var n = up(e), r = ZG(e), a = {
    x: r.x,
    y: r.y
  };
  "left" in t && (a.x = r.x + t.left - n.left), "top" in t && (a.y = r.y + t.top - n.top), eK(e, a);
}
function uK(e, t, n) {
  if (n.ignoreShake) {
    var r = up(e), a = r.left.toFixed(0), o = r.top.toFixed(0), i = t.left.toFixed(0), s = t.top.toFixed(0);
    if (a === i && o === s)
      return;
  }
  n.useCssRight || n.useCssBottom ? ET(e, t, n) : n.useCssTransform && Jg() in document.body.style ? lK(e, t) : ET(e, t, n);
}
function tC(e, t) {
  for (var n = 0; n < e.length; n++)
    t(e[n]);
}
function wP(e) {
  return Fp(e, "boxSizing") === "border-box";
}
var cK = ["margin", "border", "padding"], Kb = -1, fK = 2, Yb = 1, dK = 0;
function pK(e, t, n) {
  var r = {}, a = e.style, o;
  for (o in t)
    t.hasOwnProperty(o) && (r[o] = a[o], a[o] = t[o]);
  n.call(e);
  for (o in t)
    t.hasOwnProperty(o) && (a[o] = r[o]);
}
function Jd(e, t, n) {
  var r = 0, a, o, i;
  for (o = 0; o < t.length; o++)
    if (a = t[o], a)
      for (i = 0; i < n.length; i++) {
        var s = void 0;
        a === "border" ? s = "".concat(a).concat(n[i], "Width") : s = a + n[i], r += parseFloat(Fp(e, s)) || 0;
      }
  return r;
}
var rs = {
  getParent: function(t) {
    var n = t;
    do
      n.nodeType === 11 && n.host ? n = n.host : n = n.parentNode;
    while (n && n.nodeType !== 1 && n.nodeType !== 9);
    return n;
  }
};
tC(["Width", "Height"], function(e) {
  rs["doc".concat(e)] = function(t) {
    var n = t.document;
    return Math.max(
      // firefox chrome documentElement.scrollHeight< body.scrollHeight
      // ie standard mode : documentElement.scrollHeight> body.scrollHeight
      n.documentElement["scroll".concat(e)],
      // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      n.body["scroll".concat(e)],
      rs["viewport".concat(e)](n)
    );
  }, rs["viewport".concat(e)] = function(t) {
    var n = "client".concat(e), r = t.document, a = r.body, o = r.documentElement, i = o[n];
    return r.compatMode === "CSS1Compat" && i || a && a[n] || i;
  };
});
function TT(e, t, n) {
  var r = n;
  if (eC(e))
    return t === "width" ? rs.viewportWidth(e) : rs.viewportHeight(e);
  if (e.nodeType === 9)
    return t === "width" ? rs.docWidth(e) : rs.docHeight(e);
  var a = t === "width" ? ["Left", "Right"] : ["Top", "Bottom"], o = Math.floor(t === "width" ? e.getBoundingClientRect().width : e.getBoundingClientRect().height), i = wP(e), s = 0;
  (o == null || o <= 0) && (o = void 0, s = Fp(e, t), (s == null || Number(s) < 0) && (s = e.style[t] || 0), s = Math.floor(parseFloat(s)) || 0), r === void 0 && (r = i ? Yb : Kb);
  var l = o !== void 0 || i, u = o || s;
  return r === Kb ? l ? u - Jd(e, ["border", "padding"], a) : s : l ? r === Yb ? u : u + (r === fK ? -Jd(e, ["border"], a) : Jd(e, ["margin"], a)) : s + Jd(e, cK.slice(r), a);
}
var hK = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function $T() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, a = t[0];
  return a.offsetWidth !== 0 ? r = TT.apply(void 0, t) : pK(a, hK, function() {
    r = TT.apply(void 0, t);
  }), r;
}
tC(["width", "height"], function(e) {
  var t = e.charAt(0).toUpperCase() + e.slice(1);
  rs["outer".concat(t)] = function(r, a) {
    return r && $T(r, e, a ? dK : Yb);
  };
  var n = e === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  rs[e] = function(r, a) {
    var o = a;
    if (o !== void 0) {
      if (r) {
        var i = wP(r);
        return i && (o += Jd(r, ["padding", "border"], n)), Ef(r, e, o);
      }
      return;
    }
    return r && $T(r, e, Kb);
  };
});
function SP(e, t) {
  for (var n in t)
    t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
}
var Yt = {
  getWindow: function(t) {
    if (t && t.document && t.setTimeout)
      return t;
    var n = t.ownerDocument || t;
    return n.defaultView || n.parentWindow;
  },
  getDocument: bP,
  offset: function(t, n, r) {
    if (typeof n < "u")
      uK(t, n, r || {});
    else
      return up(t);
  },
  isWindow: eC,
  each: tC,
  css: Ef,
  clone: function(t) {
    var n, r = {};
    for (n in t)
      t.hasOwnProperty(n) && (r[n] = t[n]);
    var a = t.overflow;
    if (a)
      for (n in t)
        t.hasOwnProperty(n) && (r.overflow[n] = t.overflow[n]);
    return r;
  },
  mix: SP,
  getWindowScrollLeft: function(t) {
    return yP(t);
  },
  getWindowScrollTop: function(t) {
    return xP(t);
  },
  merge: function() {
    for (var t = {}, n = 0; n < arguments.length; n++)
      Yt.mix(t, n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
SP(Yt, rs);
var Ty = Yt.getParent;
function qb(e) {
  if (Yt.isWindow(e) || e.nodeType === 9)
    return null;
  var t = Yt.getDocument(e), n = t.body, r, a = Yt.css(e, "position"), o = a === "fixed" || a === "absolute";
  if (!o)
    return e.nodeName.toLowerCase() === "html" ? null : Ty(e);
  for (r = Ty(e); r && r !== n && r.nodeType !== 9; r = Ty(r))
    if (a = Yt.css(r, "position"), a !== "static")
      return r;
  return null;
}
var OT = Yt.getParent;
function vK(e) {
  if (Yt.isWindow(e) || e.nodeType === 9)
    return !1;
  var t = Yt.getDocument(e), n = t.body, r = null;
  for (
    r = OT(e);
    // 修复元素位于 document.documentElement 下导致崩溃问题
    r && r !== n && r !== t;
    r = OT(r)
  ) {
    var a = Yt.css(r, "position");
    if (a === "fixed")
      return !0;
  }
  return !1;
}
function nC(e, t) {
  for (var n = {
    left: 0,
    right: 1 / 0,
    top: 0,
    bottom: 1 / 0
  }, r = qb(e), a = Yt.getDocument(e), o = a.defaultView || a.parentWindow, i = a.body, s = a.documentElement; r; ) {
    if ((navigator.userAgent.indexOf("MSIE") === -1 || r.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    r !== i && r !== s && Yt.css(r, "overflow") !== "visible") {
      var l = Yt.offset(r);
      l.left += r.clientLeft, l.top += r.clientTop, n.top = Math.max(n.top, l.top), n.right = Math.min(
        n.right,
        // consider area without scrollBar
        l.left + r.clientWidth
      ), n.bottom = Math.min(n.bottom, l.top + r.clientHeight), n.left = Math.max(n.left, l.left);
    } else if (r === i || r === s)
      break;
    r = qb(r);
  }
  var u = null;
  if (!Yt.isWindow(e) && e.nodeType !== 9) {
    u = e.style.position;
    var c = Yt.css(e, "position");
    c === "absolute" && (e.style.position = "fixed");
  }
  var f = Yt.getWindowScrollLeft(o), d = Yt.getWindowScrollTop(o), p = Yt.viewportWidth(o), v = Yt.viewportHeight(o), h = s.scrollWidth, m = s.scrollHeight, y = window.getComputedStyle(i);
  if (y.overflowX === "hidden" && (h = o.innerWidth), y.overflowY === "hidden" && (m = o.innerHeight), e.style && (e.style.position = u), t || vK(e))
    n.left = Math.max(n.left, f), n.top = Math.max(n.top, d), n.right = Math.min(n.right, f + p), n.bottom = Math.min(n.bottom, d + v);
  else {
    var x = Math.max(h, f + p);
    n.right = Math.min(n.right, x);
    var g = Math.max(m, d + v);
    n.bottom = Math.min(n.bottom, g);
  }
  return n.top >= 0 && n.left >= 0 && n.bottom > n.top && n.right > n.left ? n : null;
}
function mK(e, t, n, r) {
  var a = Yt.clone(e), o = {
    width: t.width,
    height: t.height
  };
  return r.adjustX && a.left < n.left && (a.left = n.left), r.resizeWidth && a.left >= n.left && a.left + o.width > n.right && (o.width -= a.left + o.width - n.right), r.adjustX && a.left + o.width > n.right && (a.left = Math.max(n.right - o.width, n.left)), r.adjustY && a.top < n.top && (a.top = n.top), r.resizeHeight && a.top >= n.top && a.top + o.height > n.bottom && (o.height -= a.top + o.height - n.bottom), r.adjustY && a.top + o.height > n.bottom && (a.top = Math.max(n.bottom - o.height, n.top)), Yt.mix(a, o);
}
function rC(e) {
  var t, n, r;
  if (!Yt.isWindow(e) && e.nodeType !== 9)
    t = Yt.offset(e), n = Yt.outerWidth(e), r = Yt.outerHeight(e);
  else {
    var a = Yt.getWindow(e);
    t = {
      left: Yt.getWindowScrollLeft(a),
      top: Yt.getWindowScrollTop(a)
    }, n = Yt.viewportWidth(a), r = Yt.viewportHeight(a);
  }
  return t.width = n, t.height = r, t;
}
function AT(e, t) {
  var n = t.charAt(0), r = t.charAt(1), a = e.width, o = e.height, i = e.left, s = e.top;
  return n === "c" ? s += o / 2 : n === "b" && (s += o), r === "c" ? i += a / 2 : r === "r" && (i += a), {
    left: i,
    top: s
  };
}
function Nh(e, t, n, r, a) {
  var o = AT(t, n[1]), i = AT(e, n[0]), s = [i.left - o.left, i.top - o.top];
  return {
    left: Math.round(e.left - s[0] + r[0] - a[0]),
    top: Math.round(e.top - s[1] + r[1] - a[1])
  };
}
function IT(e, t, n) {
  return e.left < n.left || e.left + t.width > n.right;
}
function PT(e, t, n) {
  return e.top < n.top || e.top + t.height > n.bottom;
}
function gK(e, t, n) {
  return e.left > n.right || e.left + t.width < n.left;
}
function yK(e, t, n) {
  return e.top > n.bottom || e.top + t.height < n.top;
}
function Fh(e, t, n) {
  var r = [];
  return Yt.each(e, function(a) {
    r.push(a.replace(t, function(o) {
      return n[o];
    }));
  }), r;
}
function Lh(e, t) {
  return e[t] = -e[t], e;
}
function DT(e, t) {
  var n;
  return /%$/.test(e) ? n = parseInt(e.substring(0, e.length - 1), 10) / 100 * t : n = parseInt(e, 10), n || 0;
}
function kT(e, t) {
  e[0] = DT(e[0], t.width), e[1] = DT(e[1], t.height);
}
function _P(e, t, n, r) {
  var a = n.points, o = n.offset || [0, 0], i = n.targetOffset || [0, 0], s = n.overflow, l = n.source || e;
  o = [].concat(o), i = [].concat(i), s = s || {};
  var u = {}, c = 0, f = !!(s && s.alwaysByViewport), d = nC(l, f), p = rC(l);
  kT(o, p), kT(i, t);
  var v = Nh(p, t, a, o, i), h = Yt.merge(p, v);
  if (d && (s.adjustX || s.adjustY) && r) {
    if (s.adjustX && IT(v, p, d)) {
      var m = Fh(a, /[lr]/gi, {
        l: "r",
        r: "l"
      }), y = Lh(o, 0), x = Lh(i, 0), g = Nh(p, t, m, y, x);
      gK(g, p, d) || (c = 1, a = m, o = y, i = x);
    }
    if (s.adjustY && PT(v, p, d)) {
      var S = Fh(a, /[tb]/gi, {
        t: "b",
        b: "t"
      }), w = Lh(o, 1), _ = Lh(i, 1), b = Nh(p, t, S, w, _);
      yK(b, p, d) || (c = 1, a = S, o = w, i = _);
    }
    c && (v = Nh(p, t, a, o, i), Yt.mix(h, v));
    var E = IT(v, p, d), C = PT(v, p, d);
    if (E || C) {
      var T = a;
      E && (T = Fh(a, /[lr]/gi, {
        l: "r",
        r: "l"
      })), C && (T = Fh(a, /[tb]/gi, {
        t: "b",
        b: "t"
      })), a = T, o = n.offset || [0, 0], i = n.targetOffset || [0, 0];
    }
    u.adjustX = s.adjustX && E, u.adjustY = s.adjustY && C, (u.adjustX || u.adjustY) && (h = mK(v, p, d, u));
  }
  return h.width !== p.width && Yt.css(l, "width", Yt.width(l) + h.width - p.width), h.height !== p.height && Yt.css(l, "height", Yt.height(l) + h.height - p.height), Yt.offset(l, {
    left: h.left,
    top: h.top
  }, {
    useCssRight: n.useCssRight,
    useCssBottom: n.useCssBottom,
    useCssTransform: n.useCssTransform,
    ignoreShake: n.ignoreShake
  }), {
    points: a,
    offset: o,
    targetOffset: i,
    overflow: u
  };
}
function xK(e, t) {
  var n = nC(e, t), r = rC(e);
  return !n || r.left + r.width <= n.left || r.top + r.height <= n.top || r.left >= n.right || r.top >= n.bottom;
}
function aC(e, t, n) {
  var r = n.target || t, a = rC(r), o = !xK(r, n.overflow && n.overflow.alwaysByViewport);
  return _P(e, a, n, o);
}
aC.__getOffsetParent = qb;
aC.__getVisibleRectForElement = nC;
function bK(e, t, n) {
  var r, a, o = Yt.getDocument(e), i = o.defaultView || o.parentWindow, s = Yt.getWindowScrollLeft(i), l = Yt.getWindowScrollTop(i), u = Yt.viewportWidth(i), c = Yt.viewportHeight(i);
  "pageX" in t ? r = t.pageX : r = s + t.clientX, "pageY" in t ? a = t.pageY : a = l + t.clientY;
  var f = {
    left: r,
    top: a,
    width: 0,
    height: 0
  }, d = r >= 0 && r <= s + u && a >= 0 && a <= l + c, p = [n.points[0], "cc"];
  return _P(e, f, wT(wT({}, n), {}, {
    points: p
  }), d);
}
function sr(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, a = e;
  if (Array.isArray(e) && (a = _s(e)[0]), !a)
    return null;
  const o = Yr(a, t, r);
  return o.props = n ? D(D({}, o.props), t) : o.props, Pa(typeof o.props.class != "object", "class must be string"), o;
}
function wK(e, t, n) {
  ms(Yr(e, D({}, t)), n);
}
const oC = (e) => {
  if (!e)
    return !1;
  if (e.offsetParent)
    return !0;
  if (e.getBBox) {
    const t = e.getBBox();
    if (t.width || t.height)
      return !0;
  }
  if (e.getBoundingClientRect) {
    const t = e.getBoundingClientRect();
    if (t.width || t.height)
      return !0;
  }
  return !1;
};
function SK(e, t) {
  return e === t ? !0 : !e || !t ? !1 : "pageX" in t && "pageY" in t ? e.pageX === t.pageX && e.pageY === t.pageY : "clientX" in t && "clientY" in t ? e.clientX === t.clientX && e.clientY === t.clientY : !1;
}
function _K(e, t) {
  e !== document.activeElement && Pl(t, e) && typeof e.focus == "function" && e.focus();
}
function MT(e, t) {
  let n = null, r = null;
  function a(i) {
    let [{
      target: s
    }] = i;
    if (!document.documentElement.contains(s)) return;
    const {
      width: l,
      height: u
    } = s.getBoundingClientRect(), c = Math.floor(l), f = Math.floor(u);
    (n !== c || r !== f) && Promise.resolve().then(() => {
      t({
        width: c,
        height: f
      });
    }), n = c, r = f;
  }
  const o = new oI(a);
  return e && o.observe(e), () => {
    o.disconnect();
  };
}
const CK = (e, t) => {
  let n = !1, r = null;
  function a() {
    clearTimeout(r);
  }
  function o(i) {
    if (!n || i === !0) {
      if (e() === !1)
        return;
      n = !0, a(), r = setTimeout(() => {
        n = !1;
      }, t.value);
    } else
      a(), r = setTimeout(() => {
        n = !1, o();
      }, t.value);
  }
  return [o, () => {
    n = !1, a();
  }];
};
function EK() {
  this.__data__ = [], this.size = 0;
}
function iC(e, t) {
  return e === t || e !== e && t !== t;
}
function e1(e, t) {
  for (var n = e.length; n--; )
    if (iC(e[n][0], t))
      return n;
  return -1;
}
var TK = Array.prototype, $K = TK.splice;
function OK(e) {
  var t = this.__data__, n = e1(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : $K.call(t, n, 1), --this.size, !0;
}
function AK(e) {
  var t = this.__data__, n = e1(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function IK(e) {
  return e1(this.__data__, e) > -1;
}
function PK(e, t) {
  var n = this.__data__, r = e1(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function ol(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
ol.prototype.clear = EK;
ol.prototype.delete = OK;
ol.prototype.get = AK;
ol.prototype.has = IK;
ol.prototype.set = PK;
function DK() {
  this.__data__ = new ol(), this.size = 0;
}
function kK(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function MK(e) {
  return this.__data__.get(e);
}
function RK(e) {
  return this.__data__.has(e);
}
var CP = typeof global == "object" && global && global.Object === Object && global, NK = typeof self == "object" && self && self.Object === Object && self, Yi = CP || NK || Function("return this")(), ci = Yi.Symbol, EP = Object.prototype, FK = EP.hasOwnProperty, LK = EP.toString, jd = ci ? ci.toStringTag : void 0;
function BK(e) {
  var t = FK.call(e, jd), n = e[jd];
  try {
    e[jd] = void 0;
    var r = !0;
  } catch {
  }
  var a = LK.call(e);
  return r && (t ? e[jd] = n : delete e[jd]), a;
}
var HK = Object.prototype, jK = HK.toString;
function VK(e) {
  return jK.call(e);
}
var UK = "[object Null]", zK = "[object Undefined]", RT = ci ? ci.toStringTag : void 0;
function Oc(e) {
  return e == null ? e === void 0 ? zK : UK : RT && RT in Object(e) ? BK(e) : VK(e);
}
function Js(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var WK = "[object AsyncFunction]", GK = "[object Function]", KK = "[object GeneratorFunction]", YK = "[object Proxy]";
function TP(e) {
  if (!Js(e))
    return !1;
  var t = Oc(e);
  return t == GK || t == KK || t == WK || t == YK;
}
var $y = Yi["__core-js_shared__"], NT = function() {
  var e = /[^.]+$/.exec($y && $y.keys && $y.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function qK(e) {
  return !!NT && NT in e;
}
var XK = Function.prototype, ZK = XK.toString;
function Ac(e) {
  if (e != null) {
    try {
      return ZK.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var QK = /[\\^$.*+?()[\]{}|]/g, JK = /^\[object .+?Constructor\]$/, eY = Function.prototype, tY = Object.prototype, nY = eY.toString, rY = tY.hasOwnProperty, aY = RegExp(
  "^" + nY.call(rY).replace(QK, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function oY(e) {
  if (!Js(e) || qK(e))
    return !1;
  var t = TP(e) ? aY : JK;
  return t.test(Ac(e));
}
function iY(e, t) {
  return e == null ? void 0 : e[t];
}
function Ic(e, t) {
  var n = iY(e, t);
  return oY(n) ? n : void 0;
}
var cp = Ic(Yi, "Map"), fp = Ic(Object, "create");
function sY() {
  this.__data__ = fp ? fp(null) : {}, this.size = 0;
}
function lY(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var uY = "__lodash_hash_undefined__", cY = Object.prototype, fY = cY.hasOwnProperty;
function dY(e) {
  var t = this.__data__;
  if (fp) {
    var n = t[e];
    return n === uY ? void 0 : n;
  }
  return fY.call(t, e) ? t[e] : void 0;
}
var pY = Object.prototype, hY = pY.hasOwnProperty;
function vY(e) {
  var t = this.__data__;
  return fp ? t[e] !== void 0 : hY.call(t, e);
}
var mY = "__lodash_hash_undefined__";
function gY(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = fp && t === void 0 ? mY : t, this;
}
function pc(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
pc.prototype.clear = sY;
pc.prototype.delete = lY;
pc.prototype.get = dY;
pc.prototype.has = vY;
pc.prototype.set = gY;
function yY() {
  this.size = 0, this.__data__ = {
    hash: new pc(),
    map: new (cp || ol)(),
    string: new pc()
  };
}
function xY(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function t1(e, t) {
  var n = e.__data__;
  return xY(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function bY(e) {
  var t = t1(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function wY(e) {
  return t1(this, e).get(e);
}
function SY(e) {
  return t1(this, e).has(e);
}
function _Y(e, t) {
  var n = t1(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function il(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
il.prototype.clear = yY;
il.prototype.delete = bY;
il.prototype.get = wY;
il.prototype.has = SY;
il.prototype.set = _Y;
var CY = 200;
function EY(e, t) {
  var n = this.__data__;
  if (n instanceof ol) {
    var r = n.__data__;
    if (!cp || r.length < CY - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new il(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function us(e) {
  var t = this.__data__ = new ol(e);
  this.size = t.size;
}
us.prototype.clear = DK;
us.prototype.delete = kK;
us.prototype.get = MK;
us.prototype.has = RK;
us.prototype.set = EY;
var TY = "__lodash_hash_undefined__";
function $Y(e) {
  return this.__data__.set(e, TY), this;
}
function OY(e) {
  return this.__data__.has(e);
}
function Kf(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new il(); ++t < n; )
    this.add(e[t]);
}
Kf.prototype.add = Kf.prototype.push = $Y;
Kf.prototype.has = OY;
function AY(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function Cm(e, t) {
  return e.has(t);
}
var IY = 1, PY = 2;
function $P(e, t, n, r, a, o) {
  var i = n & IY, s = e.length, l = t.length;
  if (s != l && !(i && l > s))
    return !1;
  var u = o.get(e), c = o.get(t);
  if (u && c)
    return u == t && c == e;
  var f = -1, d = !0, p = n & PY ? new Kf() : void 0;
  for (o.set(e, t), o.set(t, e); ++f < s; ) {
    var v = e[f], h = t[f];
    if (r)
      var m = i ? r(h, v, f, t, e, o) : r(v, h, f, e, t, o);
    if (m !== void 0) {
      if (m)
        continue;
      d = !1;
      break;
    }
    if (p) {
      if (!AY(t, function(y, x) {
        if (!Cm(p, x) && (v === y || a(v, y, n, r, o)))
          return p.push(x);
      })) {
        d = !1;
        break;
      }
    } else if (!(v === h || a(v, h, n, r, o))) {
      d = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), d;
}
var Em = Yi.Uint8Array;
function DY(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, a) {
    n[++t] = [a, r];
  }), n;
}
function sC(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var kY = 1, MY = 2, RY = "[object Boolean]", NY = "[object Date]", FY = "[object Error]", LY = "[object Map]", BY = "[object Number]", HY = "[object RegExp]", jY = "[object Set]", VY = "[object String]", UY = "[object Symbol]", zY = "[object ArrayBuffer]", WY = "[object DataView]", FT = ci ? ci.prototype : void 0, Oy = FT ? FT.valueOf : void 0;
function GY(e, t, n, r, a, o, i) {
  switch (n) {
    case WY:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case zY:
      return !(e.byteLength != t.byteLength || !o(new Em(e), new Em(t)));
    case RY:
    case NY:
    case BY:
      return iC(+e, +t);
    case FY:
      return e.name == t.name && e.message == t.message;
    case HY:
    case VY:
      return e == t + "";
    case LY:
      var s = DY;
    case jY:
      var l = r & kY;
      if (s || (s = sC), e.size != t.size && !l)
        return !1;
      var u = i.get(e);
      if (u)
        return u == t;
      r |= MY, i.set(e, t);
      var c = $P(s(e), s(t), r, a, o, i);
      return i.delete(e), c;
    case UY:
      if (Oy)
        return Oy.call(e) == Oy.call(t);
  }
  return !1;
}
function lC(e, t) {
  for (var n = -1, r = t.length, a = e.length; ++n < r; )
    e[a + n] = t[n];
  return e;
}
var fi = Array.isArray;
function OP(e, t, n) {
  var r = t(e);
  return fi(e) ? r : lC(r, n(e));
}
function KY(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = 0, o = []; ++n < r; ) {
    var i = e[n];
    t(i, n, e) && (o[a++] = i);
  }
  return o;
}
function AP() {
  return [];
}
var YY = Object.prototype, qY = YY.propertyIsEnumerable, LT = Object.getOwnPropertySymbols, uC = LT ? function(e) {
  return e == null ? [] : (e = Object(e), KY(LT(e), function(t) {
    return qY.call(e, t);
  }));
} : AP;
function XY(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
function ys(e) {
  return e != null && typeof e == "object";
}
var ZY = "[object Arguments]";
function BT(e) {
  return ys(e) && Oc(e) == ZY;
}
var IP = Object.prototype, QY = IP.hasOwnProperty, JY = IP.propertyIsEnumerable, n1 = BT(/* @__PURE__ */ function() {
  return arguments;
}()) ? BT : function(e) {
  return ys(e) && QY.call(e, "callee") && !JY.call(e, "callee");
};
function eq() {
  return !1;
}
var PP = typeof exports == "object" && exports && !exports.nodeType && exports, HT = PP && typeof module == "object" && module && !module.nodeType && module, tq = HT && HT.exports === PP, jT = tq ? Yi.Buffer : void 0, nq = jT ? jT.isBuffer : void 0, dp = nq || eq, rq = 9007199254740991, aq = /^(?:0|[1-9]\d*)$/;
function DP(e, t) {
  var n = typeof e;
  return t = t ?? rq, !!t && (n == "number" || n != "symbol" && aq.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var oq = 9007199254740991;
function cC(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= oq;
}
var iq = "[object Arguments]", sq = "[object Array]", lq = "[object Boolean]", uq = "[object Date]", cq = "[object Error]", fq = "[object Function]", dq = "[object Map]", pq = "[object Number]", hq = "[object Object]", vq = "[object RegExp]", mq = "[object Set]", gq = "[object String]", yq = "[object WeakMap]", xq = "[object ArrayBuffer]", bq = "[object DataView]", wq = "[object Float32Array]", Sq = "[object Float64Array]", _q = "[object Int8Array]", Cq = "[object Int16Array]", Eq = "[object Int32Array]", Tq = "[object Uint8Array]", $q = "[object Uint8ClampedArray]", Oq = "[object Uint16Array]", Aq = "[object Uint32Array]", Gn = {};
Gn[wq] = Gn[Sq] = Gn[_q] = Gn[Cq] = Gn[Eq] = Gn[Tq] = Gn[$q] = Gn[Oq] = Gn[Aq] = !0;
Gn[iq] = Gn[sq] = Gn[xq] = Gn[lq] = Gn[bq] = Gn[uq] = Gn[cq] = Gn[fq] = Gn[dq] = Gn[pq] = Gn[hq] = Gn[vq] = Gn[mq] = Gn[gq] = Gn[yq] = !1;
function Iq(e) {
  return ys(e) && cC(e.length) && !!Gn[Oc(e)];
}
function r1(e) {
  return function(t) {
    return e(t);
  };
}
var kP = typeof exports == "object" && exports && !exports.nodeType && exports, b0 = kP && typeof module == "object" && module && !module.nodeType && module, Pq = b0 && b0.exports === kP, Ay = Pq && CP.process, Yf = function() {
  try {
    var e = b0 && b0.require && b0.require("util").types;
    return e || Ay && Ay.binding && Ay.binding("util");
  } catch {
  }
}(), VT = Yf && Yf.isTypedArray, fC = VT ? r1(VT) : Iq, Dq = Object.prototype, kq = Dq.hasOwnProperty;
function MP(e, t) {
  var n = fi(e), r = !n && n1(e), a = !n && !r && dp(e), o = !n && !r && !a && fC(e), i = n || r || a || o, s = i ? XY(e.length, String) : [], l = s.length;
  for (var u in e)
    (t || kq.call(e, u)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    DP(u, l))) && s.push(u);
  return s;
}
var Mq = Object.prototype;
function a1(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Mq;
  return e === n;
}
function RP(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Rq = RP(Object.keys, Object), Nq = Object.prototype, Fq = Nq.hasOwnProperty;
function NP(e) {
  if (!a1(e))
    return Rq(e);
  var t = [];
  for (var n in Object(e))
    Fq.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function Lp(e) {
  return e != null && cC(e.length) && !TP(e);
}
function Bp(e) {
  return Lp(e) ? MP(e) : NP(e);
}
function Xb(e) {
  return OP(e, Bp, uC);
}
var Lq = 1, Bq = Object.prototype, Hq = Bq.hasOwnProperty;
function jq(e, t, n, r, a, o) {
  var i = n & Lq, s = Xb(e), l = s.length, u = Xb(t), c = u.length;
  if (l != c && !i)
    return !1;
  for (var f = l; f--; ) {
    var d = s[f];
    if (!(i ? d in t : Hq.call(t, d)))
      return !1;
  }
  var p = o.get(e), v = o.get(t);
  if (p && v)
    return p == t && v == e;
  var h = !0;
  o.set(e, t), o.set(t, e);
  for (var m = i; ++f < l; ) {
    d = s[f];
    var y = e[d], x = t[d];
    if (r)
      var g = i ? r(x, y, d, t, e, o) : r(y, x, d, e, t, o);
    if (!(g === void 0 ? y === x || a(y, x, n, r, o) : g)) {
      h = !1;
      break;
    }
    m || (m = d == "constructor");
  }
  if (h && !m) {
    var S = e.constructor, w = t.constructor;
    S != w && "constructor" in e && "constructor" in t && !(typeof S == "function" && S instanceof S && typeof w == "function" && w instanceof w) && (h = !1);
  }
  return o.delete(e), o.delete(t), h;
}
var Zb = Ic(Yi, "DataView"), Qb = Ic(Yi, "Promise"), Tf = Ic(Yi, "Set"), Jb = Ic(Yi, "WeakMap"), UT = "[object Map]", Vq = "[object Object]", zT = "[object Promise]", WT = "[object Set]", GT = "[object WeakMap]", KT = "[object DataView]", Uq = Ac(Zb), zq = Ac(cp), Wq = Ac(Qb), Gq = Ac(Tf), Kq = Ac(Jb), ni = Oc;
(Zb && ni(new Zb(new ArrayBuffer(1))) != KT || cp && ni(new cp()) != UT || Qb && ni(Qb.resolve()) != zT || Tf && ni(new Tf()) != WT || Jb && ni(new Jb()) != GT) && (ni = function(e) {
  var t = Oc(e), n = t == Vq ? e.constructor : void 0, r = n ? Ac(n) : "";
  if (r)
    switch (r) {
      case Uq:
        return KT;
      case zq:
        return UT;
      case Wq:
        return zT;
      case Gq:
        return WT;
      case Kq:
        return GT;
    }
  return t;
});
var Yq = 1, YT = "[object Arguments]", qT = "[object Array]", Bh = "[object Object]", qq = Object.prototype, XT = qq.hasOwnProperty;
function Xq(e, t, n, r, a, o) {
  var i = fi(e), s = fi(t), l = i ? qT : ni(e), u = s ? qT : ni(t);
  l = l == YT ? Bh : l, u = u == YT ? Bh : u;
  var c = l == Bh, f = u == Bh, d = l == u;
  if (d && dp(e)) {
    if (!dp(t))
      return !1;
    i = !0, c = !1;
  }
  if (d && !c)
    return o || (o = new us()), i || fC(e) ? $P(e, t, n, r, a, o) : GY(e, t, l, n, r, a, o);
  if (!(n & Yq)) {
    var p = c && XT.call(e, "__wrapped__"), v = f && XT.call(t, "__wrapped__");
    if (p || v) {
      var h = p ? e.value() : e, m = v ? t.value() : t;
      return o || (o = new us()), a(h, m, n, r, o);
    }
  }
  return d ? (o || (o = new us()), jq(e, t, n, r, a, o)) : !1;
}
function o1(e, t, n, r, a) {
  return e === t ? !0 : e == null || t == null || !ys(e) && !ys(t) ? e !== e && t !== t : Xq(e, t, n, r, o1, a);
}
function dC(e, t) {
  return o1(e, t);
}
const Zq = {
  align: Object,
  target: [Object, Function],
  onAlign: Function,
  monitorBufferTime: Number,
  monitorWindowResize: Boolean,
  disabled: Boolean
};
function ZT(e) {
  return typeof e != "function" ? null : e();
}
function QT(e) {
  return typeof e != "object" || !e ? null : e;
}
const Qq = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "Align",
  props: Zq,
  emits: ["align"],
  setup(e, t) {
    let {
      expose: n,
      slots: r
    } = t;
    const a = ne({}), o = ne(), [i, s] = CK(() => {
      const {
        disabled: d,
        target: p,
        align: v,
        onAlign: h
      } = e;
      if (!d && p && o.value) {
        const m = o.value;
        let y;
        const x = ZT(p), g = QT(p);
        a.value.element = x, a.value.point = g, a.value.align = v;
        const {
          activeElement: S
        } = document;
        return x && oC(x) ? y = aC(m, x, v) : g && (y = bK(m, g, v)), _K(S, m), h && y && h(m, y), !0;
      }
      return !1;
    }, V(() => e.monitorBufferTime)), l = ne({
      cancel: () => {
      }
    }), u = ne({
      cancel: () => {
      }
    }), c = () => {
      const d = e.target, p = ZT(d), v = QT(d);
      o.value !== u.value.element && (u.value.cancel(), u.value.element = o.value, u.value.cancel = MT(o.value, i)), (a.value.element !== p || !SK(a.value.point, v) || !dC(a.value.align, e.align)) && (i(), l.value.element !== p && (l.value.cancel(), l.value.element = p, l.value.cancel = MT(p, i)));
    };
    Lt(() => {
      nn(() => {
        c();
      });
    }), Qa(() => {
      nn(() => {
        c();
      });
    }), He(() => e.disabled, (d) => {
      d ? s() : i();
    }, {
      immediate: !0,
      flush: "post"
    });
    const f = ne(null);
    return He(() => e.monitorWindowResize, (d) => {
      d ? f.value || (f.value = pf(window, "resize", i)) : f.value && (f.value.remove(), f.value = null);
    }, {
      flush: "post"
    }), Bo(() => {
      l.value.cancel(), u.value.cancel(), f.value && f.value.remove(), s();
    }), n({
      forceAlign: () => i(!0)
    }), () => {
      const d = r == null ? void 0 : r.default();
      return d ? sr(d[0], {
        ref: o
      }, !0, !0) : null;
    };
  }
});
eu("bottomLeft", "bottomRight", "topLeft", "topRight");
const Jq = (e) => e !== void 0 && (e === "topLeft" || e === "topRight") ? "slide-down" : "slide-up", Hp = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return D(e ? {
    name: e,
    appear: !0,
    // type: 'animation',
    // appearFromClass: `${transitionName}-appear ${transitionName}-appear-prepare`,
    // appearActiveClass: `antdv-base-transtion`,
    // appearToClass: `${transitionName}-appear ${transitionName}-appear-active`,
    enterFromClass: `${e}-enter ${e}-enter-prepare ${e}-enter-start`,
    enterActiveClass: `${e}-enter ${e}-enter-prepare`,
    enterToClass: `${e}-enter ${e}-enter-active`,
    leaveFromClass: ` ${e}-leave`,
    leaveActiveClass: `${e}-leave ${e}-leave-active`,
    leaveToClass: `${e}-leave ${e}-leave-active`
  } : {
    css: !1
  }, t);
}, pC = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return D(e ? {
    name: e,
    appear: !0,
    // appearFromClass: `${transitionName}-appear ${transitionName}-appear-prepare`,
    appearActiveClass: `${e}`,
    appearToClass: `${e}-appear ${e}-appear-active`,
    enterFromClass: `${e}-appear ${e}-enter ${e}-appear-prepare ${e}-enter-prepare`,
    enterActiveClass: `${e}`,
    enterToClass: `${e}-enter ${e}-appear ${e}-appear-active ${e}-enter-active`,
    leaveActiveClass: `${e} ${e}-leave`,
    leaveToClass: `${e}-leave-active`
  } : {
    css: !1
  }, t);
}, qf = (e, t, n) => n !== void 0 ? n : `${e}-${t}`, eX = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "PopupInner",
  inheritAttrs: !1,
  props: Q_,
  emits: ["mouseenter", "mouseleave", "mousedown", "touchstart", "align"],
  setup(e, t) {
    let {
      expose: n,
      attrs: r,
      slots: a
    } = t;
    const o = Be(), i = Be(), s = Be(), [l, u] = KG(Tt(e, "stretch")), c = () => {
      e.stretch && u(e.getRootDomNode());
    }, f = Be(!1);
    let d;
    He(() => e.visible, (_) => {
      clearTimeout(d), _ ? d = setTimeout(() => {
        f.value = e.visible;
      }) : f.value = !1;
    }, {
      immediate: !0
    });
    const [p, v] = GG(f, c), h = Be(), m = () => e.point ? e.point : e.getRootDomNode, y = () => {
      var _;
      (_ = o.value) === null || _ === void 0 || _.forceAlign();
    }, x = (_, b) => {
      var E;
      const C = e.getClassNameFromAlign(b), T = s.value;
      s.value !== C && (s.value = C), p.value === "align" && (T !== C ? Promise.resolve().then(() => {
        y();
      }) : v(() => {
        var O;
        (O = h.value) === null || O === void 0 || O.call(h);
      }), (E = e.onAlign) === null || E === void 0 || E.call(e, _, b));
    }, g = V(() => {
      const _ = typeof e.animation == "object" ? e.animation : J_(e);
      return ["onAfterEnter", "onAfterLeave"].forEach((b) => {
        const E = _[b];
        _[b] = (C) => {
          v(), p.value = "stable", E == null || E(C);
        };
      }), _;
    }), S = () => new Promise((_) => {
      h.value = _;
    });
    He([g, p], () => {
      !g.value && p.value === "motion" && v();
    }, {
      immediate: !0
    }), n({
      forceAlign: y,
      getElement: () => i.value.$el || i.value
    });
    const w = V(() => {
      var _;
      return !(!((_ = e.align) === null || _ === void 0) && _.points && (p.value === "align" || p.value === "stable"));
    });
    return () => {
      var _;
      const {
        zIndex: b,
        align: E,
        prefixCls: C,
        destroyPopupOnHide: T,
        onMouseenter: O,
        onMouseleave: I,
        onTouchstart: k = () => {
        },
        onMousedown: B
      } = e, P = p.value, N = [D(D({}, l.value), {
        zIndex: b,
        opacity: P === "motion" || P === "stable" || !f.value ? null : 0,
        // pointerEvents: statusValue === 'stable' ? null : 'none',
        pointerEvents: !f.value && P !== "stable" ? "none" : null
      }), r.style];
      let M = ua((_ = a.default) === null || _ === void 0 ? void 0 : _.call(a, {
        visible: e.visible
      }));
      M.length > 1 && (M = A("div", {
        class: `${C}-content`
      }, [M]));
      const H = Ge(C, r.class, s.value), z = f.value || !e.visible ? Hp(g.value.name, g.value) : {};
      return A(Ho, ve(ve({
        ref: i
      }, z), {}, {
        onBeforeEnter: S
      }), {
        default: () => !T || e.visible ? Yn(A(Qq, {
          target: m(),
          key: "popup",
          ref: o,
          monitorWindowResize: !0,
          disabled: w.value,
          align: E,
          onAlign: x
        }, {
          default: () => A("div", {
            class: H,
            onMouseenter: O,
            onMouseleave: I,
            onMousedown: ft(B, ["capture"]),
            [za ? "onTouchstartPassive" : "onTouchstart"]: ft(k, ["capture"]),
            style: N
          }, [M])
        }), [[ko, f.value]]) : null
      });
    };
  }
}), tX = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "Popup",
  inheritAttrs: !1,
  props: UG,
  setup(e, t) {
    let {
      attrs: n,
      slots: r,
      expose: a
    } = t;
    const o = Be(!1), i = Be(!1), s = Be(), l = Be();
    return He([() => e.visible, () => e.mobile], () => {
      o.value = e.visible, e.visible && e.mobile && (i.value = !0);
    }, {
      immediate: !0,
      flush: "post"
    }), a({
      forceAlign: () => {
        var u;
        (u = s.value) === null || u === void 0 || u.forceAlign();
      },
      getElement: () => {
        var u;
        return (u = s.value) === null || u === void 0 ? void 0 : u.getElement();
      }
    }), () => {
      const u = D(D(D({}, e), n), {
        visible: o.value
      }), c = i.value ? A(zG, ve(ve({}, u), {}, {
        mobile: e.mobile,
        ref: s
      }), {
        default: r.default
      }) : A(eX, ve(ve({}, u), {}, {
        ref: s
      }), {
        default: r.default
      });
      return A("div", {
        ref: l
      }, [A(vP, u, null), c]);
    };
  }
});
function nX(e, t, n) {
  return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function JT(e, t, n) {
  const r = e[t] || {};
  return D(D({}, r), n);
}
function rX(e, t, n, r) {
  const {
    points: a
  } = n, o = Object.keys(e);
  for (let i = 0; i < o.length; i += 1) {
    const s = o[i];
    if (nX(e[s].points, a, r))
      return `${t}-placement-${s}`;
  }
  return "";
}
const FP = {
  methods: {
    setState() {
      let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0, n = typeof e == "function" ? e(this.$data, this.$props) : e;
      if (this.getDerivedStateFromProps) {
        const r = this.getDerivedStateFromProps(xz(this), D(D({}, this.$data), n));
        if (r === null)
          return;
        n = D(D({}, n), r || {});
      }
      D(this.$data, n), this._.isMounted && this.$forceUpdate(), nn(() => {
        t && t();
      });
    },
    __emit() {
      const e = [].slice.call(arguments, 0);
      let t = e[0];
      t = `on${t[0].toUpperCase()}${t.substring(1)}`;
      const n = this.$props[t] || this.$attrs[t];
      if (e.length && n)
        if (Array.isArray(n))
          for (let r = 0, a = n.length; r < a; r++)
            n[r](...e.slice(1));
        else
          n(...e.slice(1));
    }
  }
}, LP = Symbol("PortalContextKey"), hC = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    inTriggerContext: !0
  };
  kt(LP, {
    inTriggerContext: t.inTriggerContext,
    shouldRender: V(() => {
      const {
        sPopupVisible: n,
        popupRef: r,
        forceRender: a,
        autoDestroy: o
      } = e || {};
      let i = !1;
      return (n || r || a) && (i = !0), !n && o && (i = !1), i;
    })
  });
}, aX = () => {
  hC({}, {
    inTriggerContext: !1
  });
  const e = Ke(LP, {
    shouldRender: V(() => !1),
    inTriggerContext: !1
  });
  return {
    shouldRender: V(() => e.shouldRender.value || e.inTriggerContext === !1)
  };
}, BP = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "Portal",
  inheritAttrs: !1,
  props: {
    getContainer: Oe.func.isRequired,
    didUpdate: Function
  },
  setup(e, t) {
    let {
      slots: n
    } = t, r = !0, a;
    const {
      shouldRender: o
    } = aX();
    function i() {
      o.value && (a = e.getContainer());
    }
    g_(() => {
      r = !1, i();
    }), Lt(() => {
      a || i();
    });
    const s = He(o, () => {
      o.value && !a && (a = e.getContainer()), a && s();
    });
    return Qa(() => {
      nn(() => {
        var l;
        o.value && ((l = e.didUpdate) === null || l === void 0 || l.call(e, e));
      });
    }), () => {
      var l;
      return o.value ? r ? (l = n.default) === null || l === void 0 ? void 0 : l.call(n) : a ? A(Eg, {
        to: a
      }, n) : null : null;
    };
  }
});
let Iy;
function oX(e) {
  if (typeof document > "u")
    return 0;
  if (Iy === void 0) {
    const t = document.createElement("div");
    t.style.width = "100%", t.style.height = "200px";
    const n = document.createElement("div"), r = n.style;
    r.position = "absolute", r.top = "0", r.left = "0", r.pointerEvents = "none", r.visibility = "hidden", r.width = "200px", r.height = "150px", r.overflow = "hidden", n.appendChild(t), document.body.appendChild(n);
    const a = t.offsetWidth;
    n.style.overflow = "scroll";
    let o = t.offsetWidth;
    a === o && (o = n.clientWidth), document.body.removeChild(n), Iy = a - o;
  }
  return Iy;
}
const iX = `vc-util-locker-${Date.now()}`;
let e$ = 0;
function sX() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
function lX(e) {
  const t = V(() => !!e && !!e.value);
  e$ += 1;
  const n = `${iX}_${e$}`;
  _n((r) => {
    if (li()) {
      if (t.value) {
        const a = oX(), o = sX();
        np(`
html body {
  overflow-y: hidden;
  ${o ? `width: calc(100% - ${a}px);` : ""}
}`, n);
      } else
        ym(n);
      r(() => {
        ym(n);
      });
    }
  }, {
    flush: "post"
  });
}
let wu = 0;
const Mv = li(), t$ = (e) => {
  if (!Mv)
    return null;
  if (e) {
    if (typeof e == "string")
      return document.querySelectorAll(e)[0];
    if (typeof e == "function")
      return e();
    if (typeof e == "object" && e instanceof window.HTMLElement)
      return e;
  }
  return document.body;
}, HP = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "PortalWrapper",
  inheritAttrs: !1,
  props: {
    wrapperClassName: String,
    forceRender: {
      type: Boolean,
      default: void 0
    },
    getContainer: Oe.any,
    visible: {
      type: Boolean,
      default: void 0
    },
    autoLock: qt(),
    didUpdate: Function
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const r = Be(), a = Be(), o = Be(), i = Be(1), s = li() && document.createElement("div"), l = () => {
      var p, v;
      r.value === s && ((v = (p = r.value) === null || p === void 0 ? void 0 : p.parentNode) === null || v === void 0 || v.removeChild(r.value)), r.value = null;
    };
    let u = null;
    const c = function() {
      return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1) || r.value && !r.value.parentNode ? (u = t$(e.getContainer), u ? (u.appendChild(r.value), !0) : !1) : !0;
    }, f = () => Mv ? (r.value || (r.value = s, c(!0)), d(), r.value) : null, d = () => {
      const {
        wrapperClassName: p
      } = e;
      r.value && p && p !== r.value.className && (r.value.className = p);
    };
    return Qa(() => {
      d(), c();
    }), lX(V(() => e.autoLock && e.visible && li() && (r.value === document.body || r.value === s))), Lt(() => {
      let p = !1;
      He([() => e.visible, () => e.getContainer], (v, h) => {
        let [m, y] = v, [x, g] = h;
        Mv && (u = t$(e.getContainer), u === document.body && (m && !x ? wu += 1 : p && (wu -= 1))), p && (typeof y == "function" && typeof g == "function" ? y.toString() !== g.toString() : y !== g) && l(), p = !0;
      }, {
        immediate: !0,
        flush: "post"
      }), nn(() => {
        c() || (o.value = dn(() => {
          i.value += 1;
        }));
      });
    }), Sn(() => {
      const {
        visible: p
      } = e;
      Mv && u === document.body && (wu = p && wu ? wu - 1 : wu), l(), dn.cancel(o.value);
    }), () => {
      const {
        forceRender: p,
        visible: v
      } = e;
      let h = null;
      const m = {
        getOpenCount: () => wu,
        getContainer: f
      };
      return i.value && (p || v || a.value) && (h = A(BP, {
        getContainer: f,
        ref: a,
        didUpdate: e.didUpdate
      }, {
        default: () => {
          var y;
          return (y = n.default) === null || y === void 0 ? void 0 : y.call(n, m);
        }
      })), h;
    };
  }
}), uX = ["onClick", "onMousedown", "onTouchstart", "onMouseenter", "onMouseleave", "onFocus", "onBlur", "onContextmenu"], jp = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "Trigger",
  mixins: [FP],
  inheritAttrs: !1,
  props: jG(),
  setup(e) {
    const t = V(() => {
      const {
        popupPlacement: a,
        popupAlign: o,
        builtinPlacements: i
      } = e;
      return a && i ? JT(i, a, o) : o;
    }), n = Be(null), r = (a) => {
      n.value = a;
    };
    return {
      vcTriggerContext: Ke("vcTriggerContext", {}),
      popupRef: n,
      setPopupRef: r,
      triggerRef: Be(null),
      align: t,
      focusTime: null,
      clickOutsideHandler: null,
      contextmenuOutsideHandler1: null,
      contextmenuOutsideHandler2: null,
      touchOutsideHandler: null,
      attachId: null,
      delayTimer: null,
      hasPopupMouseDown: !1,
      preClickTime: null,
      preTouchTime: null,
      mouseDownTimeout: null,
      childOriginEvents: {}
    };
  },
  data() {
    const e = this.$props;
    let t;
    return this.popupVisible !== void 0 ? t = !!e.popupVisible : t = !!e.defaultPopupVisible, uX.forEach((n) => {
      this[`fire${n}`] = (r) => {
        this.fireEvents(n, r);
      };
    }), {
      prevPopupVisible: t,
      sPopupVisible: t,
      point: null
    };
  },
  watch: {
    popupVisible(e) {
      e !== void 0 && (this.prevPopupVisible = this.sPopupVisible, this.sPopupVisible = e);
    }
  },
  created() {
    kt("vcTriggerContext", {
      onPopupMouseDown: this.onPopupMouseDown,
      onPopupMouseenter: this.onPopupMouseenter,
      onPopupMouseleave: this.onPopupMouseleave
    }), hC(this);
  },
  deactivated() {
    this.setPopupVisible(!1);
  },
  mounted() {
    this.$nextTick(() => {
      this.updatedCal();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.updatedCal();
    });
  },
  beforeUnmount() {
    this.clearDelayTimer(), this.clearOutsideHandler(), clearTimeout(this.mouseDownTimeout), dn.cancel(this.attachId);
  },
  methods: {
    updatedCal() {
      const e = this.$props;
      if (this.$data.sPopupVisible) {
        let n;
        !this.clickOutsideHandler && (this.isClickToHide() || this.isContextmenuToShow()) && (n = e.getDocument(this.getRootDomNode()), this.clickOutsideHandler = pf(n, "mousedown", this.onDocumentClick)), this.touchOutsideHandler || (n = n || e.getDocument(this.getRootDomNode()), this.touchOutsideHandler = pf(n, "touchstart", this.onDocumentClick, za ? {
          passive: !1
        } : !1)), !this.contextmenuOutsideHandler1 && this.isContextmenuToShow() && (n = n || e.getDocument(this.getRootDomNode()), this.contextmenuOutsideHandler1 = pf(n, "scroll", this.onContextmenuClose)), !this.contextmenuOutsideHandler2 && this.isContextmenuToShow() && (this.contextmenuOutsideHandler2 = pf(window, "blur", this.onContextmenuClose));
      } else
        this.clearOutsideHandler();
    },
    onMouseenter(e) {
      const {
        mouseEnterDelay: t
      } = this.$props;
      this.fireEvents("onMouseenter", e), this.delaySetPopupVisible(!0, t, t ? null : e);
    },
    onMouseMove(e) {
      this.fireEvents("onMousemove", e), this.setPoint(e);
    },
    onMouseleave(e) {
      this.fireEvents("onMouseleave", e), this.delaySetPopupVisible(!1, this.$props.mouseLeaveDelay);
    },
    onPopupMouseenter() {
      const {
        vcTriggerContext: e = {}
      } = this;
      e.onPopupMouseenter && e.onPopupMouseenter(), this.clearDelayTimer();
    },
    onPopupMouseleave(e) {
      var t;
      if (e && e.relatedTarget && !e.relatedTarget.setTimeout && Pl((t = this.popupRef) === null || t === void 0 ? void 0 : t.getElement(), e.relatedTarget))
        return;
      this.isMouseLeaveToHide() && this.delaySetPopupVisible(!1, this.$props.mouseLeaveDelay);
      const {
        vcTriggerContext: n = {}
      } = this;
      n.onPopupMouseleave && n.onPopupMouseleave(e);
    },
    onFocus(e) {
      this.fireEvents("onFocus", e), this.clearDelayTimer(), this.isFocusToShow() && (this.focusTime = Date.now(), this.delaySetPopupVisible(!0, this.$props.focusDelay));
    },
    onMousedown(e) {
      this.fireEvents("onMousedown", e), this.preClickTime = Date.now();
    },
    onTouchstart(e) {
      this.fireEvents("onTouchstart", e), this.preTouchTime = Date.now();
    },
    onBlur(e) {
      Pl(e.target, e.relatedTarget || document.activeElement) || (this.fireEvents("onBlur", e), this.clearDelayTimer(), this.isBlurToHide() && this.delaySetPopupVisible(!1, this.$props.blurDelay));
    },
    onContextmenu(e) {
      e.preventDefault(), this.fireEvents("onContextmenu", e), this.setPopupVisible(!0, e);
    },
    onContextmenuClose() {
      this.isContextmenuToShow() && this.close();
    },
    onClick(e) {
      if (this.fireEvents("onClick", e), this.focusTime) {
        let n;
        if (this.preClickTime && this.preTouchTime ? n = Math.min(this.preClickTime, this.preTouchTime) : this.preClickTime ? n = this.preClickTime : this.preTouchTime && (n = this.preTouchTime), Math.abs(n - this.focusTime) < 20)
          return;
        this.focusTime = 0;
      }
      this.preClickTime = 0, this.preTouchTime = 0, this.isClickToShow() && (this.isClickToHide() || this.isBlurToHide()) && e && e.preventDefault && e.preventDefault(), e && e.domEvent && e.domEvent.preventDefault();
      const t = !this.$data.sPopupVisible;
      (this.isClickToHide() && !t || t && this.isClickToShow()) && this.setPopupVisible(!this.$data.sPopupVisible, e);
    },
    onPopupMouseDown() {
      const {
        vcTriggerContext: e = {}
      } = this;
      this.hasPopupMouseDown = !0, clearTimeout(this.mouseDownTimeout), this.mouseDownTimeout = setTimeout(() => {
        this.hasPopupMouseDown = !1;
      }, 0), e.onPopupMouseDown && e.onPopupMouseDown(...arguments);
    },
    onDocumentClick(e) {
      if (this.$props.mask && !this.$props.maskClosable)
        return;
      const t = e.target, n = this.getRootDomNode(), r = this.getPopupDomNode();
      // mousedown on the target should also close popup when action is contextMenu.
      // https://github.com/ant-design/ant-design/issues/29853
      (!Pl(n, t) || this.isContextMenuOnly()) && !Pl(r, t) && !this.hasPopupMouseDown && this.delaySetPopupVisible(!1, 0.1);
    },
    getPopupDomNode() {
      var e;
      return ((e = this.popupRef) === null || e === void 0 ? void 0 : e.getElement()) || null;
    },
    getRootDomNode() {
      var e, t, n, r;
      const {
        getTriggerDOMNode: a
      } = this.$props;
      if (a) {
        const o = ((t = (e = this.triggerRef) === null || e === void 0 ? void 0 : e.$el) === null || t === void 0 ? void 0 : t.nodeName) === "#comment" ? null : js(this.triggerRef);
        return js(a(o));
      }
      try {
        const o = ((r = (n = this.triggerRef) === null || n === void 0 ? void 0 : n.$el) === null || r === void 0 ? void 0 : r.nodeName) === "#comment" ? null : js(this.triggerRef);
        if (o)
          return o;
      } catch {
      }
      return js(this);
    },
    handleGetPopupClassFromAlign(e) {
      const t = [], n = this.$props, {
        popupPlacement: r,
        builtinPlacements: a,
        prefixCls: o,
        alignPoint: i,
        getPopupClassNameFromAlign: s
      } = n;
      return r && a && t.push(rX(a, o, e, i)), s && t.push(s(e)), t.join(" ");
    },
    getPopupAlign() {
      const e = this.$props, {
        popupPlacement: t,
        popupAlign: n,
        builtinPlacements: r
      } = e;
      return t && r ? JT(r, t, n) : n;
    },
    getComponent() {
      const e = {};
      this.isMouseEnterToShow() && (e.onMouseenter = this.onPopupMouseenter), this.isMouseLeaveToHide() && (e.onMouseleave = this.onPopupMouseleave), e.onMousedown = this.onPopupMouseDown, e[za ? "onTouchstartPassive" : "onTouchstart"] = this.onPopupMouseDown;
      const {
        handleGetPopupClassFromAlign: t,
        getRootDomNode: n,
        $attrs: r
      } = this, {
        prefixCls: a,
        destroyPopupOnHide: o,
        popupClassName: i,
        popupAnimation: s,
        popupTransitionName: l,
        popupStyle: u,
        mask: c,
        maskAnimation: f,
        maskTransitionName: d,
        zIndex: p,
        stretch: v,
        alignPoint: h,
        mobile: m,
        forceRender: y
      } = this.$props, {
        sPopupVisible: x,
        point: g
      } = this.$data, S = D(D({
        prefixCls: a,
        destroyPopupOnHide: o,
        visible: x,
        point: h ? g : null,
        align: this.align,
        animation: s,
        getClassNameFromAlign: t,
        stretch: v,
        getRootDomNode: n,
        mask: c,
        zIndex: p,
        transitionName: l,
        maskAnimation: f,
        maskTransitionName: d,
        class: i,
        style: u,
        onAlign: r.onPopupAlign || hP
      }, e), {
        ref: this.setPopupRef,
        mobile: m,
        forceRender: y
      });
      return A(tX, S, {
        default: this.$slots.popup || (() => lI(this, "popup"))
      });
    },
    attachParent(e) {
      dn.cancel(this.attachId);
      const {
        getPopupContainer: t,
        getDocument: n
      } = this.$props, r = this.getRootDomNode();
      let a;
      t ? (r || t.length === 0) && (a = t(r)) : a = n(this.getRootDomNode()).body, a ? a.appendChild(e) : this.attachId = dn(() => {
        this.attachParent(e);
      });
    },
    getContainer() {
      const {
        $props: e
      } = this, {
        getDocument: t
      } = e, n = t(this.getRootDomNode()).createElement("div");
      return n.style.position = "absolute", n.style.top = "0", n.style.left = "0", n.style.width = "100%", this.attachParent(n), n;
    },
    setPopupVisible(e, t) {
      const {
        alignPoint: n,
        sPopupVisible: r,
        onPopupVisibleChange: a
      } = this;
      this.clearDelayTimer(), r !== e && (rf(this, "popupVisible") || this.setState({
        sPopupVisible: e,
        prevPopupVisible: r
      }), a && a(e)), n && t && e && this.setPoint(t);
    },
    setPoint(e) {
      const {
        alignPoint: t
      } = this.$props;
      !t || !e || this.setState({
        point: {
          pageX: e.pageX,
          pageY: e.pageY
        }
      });
    },
    handlePortalUpdate() {
      this.prevPopupVisible !== this.sPopupVisible && this.afterPopupVisibleChange(this.sPopupVisible);
    },
    delaySetPopupVisible(e, t, n) {
      const r = t * 1e3;
      if (this.clearDelayTimer(), r) {
        const a = n ? {
          pageX: n.pageX,
          pageY: n.pageY
        } : null;
        this.delayTimer = setTimeout(() => {
          this.setPopupVisible(e, a), this.clearDelayTimer();
        }, r);
      } else
        this.setPopupVisible(e, n);
    },
    clearDelayTimer() {
      this.delayTimer && (clearTimeout(this.delayTimer), this.delayTimer = null);
    },
    clearOutsideHandler() {
      this.clickOutsideHandler && (this.clickOutsideHandler.remove(), this.clickOutsideHandler = null), this.contextmenuOutsideHandler1 && (this.contextmenuOutsideHandler1.remove(), this.contextmenuOutsideHandler1 = null), this.contextmenuOutsideHandler2 && (this.contextmenuOutsideHandler2.remove(), this.contextmenuOutsideHandler2 = null), this.touchOutsideHandler && (this.touchOutsideHandler.remove(), this.touchOutsideHandler = null);
    },
    createTwoChains(e) {
      let t = () => {
      };
      const n = K3(this);
      return this.childOriginEvents[e] && n[e] ? this[`fire${e}`] : (t = this.childOriginEvents[e] || n[e] || t, t);
    },
    isClickToShow() {
      const {
        action: e,
        showAction: t
      } = this.$props;
      return e.indexOf("click") !== -1 || t.indexOf("click") !== -1;
    },
    isContextMenuOnly() {
      const {
        action: e
      } = this.$props;
      return e === "contextmenu" || e.length === 1 && e[0] === "contextmenu";
    },
    isContextmenuToShow() {
      const {
        action: e,
        showAction: t
      } = this.$props;
      return e.indexOf("contextmenu") !== -1 || t.indexOf("contextmenu") !== -1;
    },
    isClickToHide() {
      const {
        action: e,
        hideAction: t
      } = this.$props;
      return e.indexOf("click") !== -1 || t.indexOf("click") !== -1;
    },
    isMouseEnterToShow() {
      const {
        action: e,
        showAction: t
      } = this.$props;
      return e.indexOf("hover") !== -1 || t.indexOf("mouseenter") !== -1;
    },
    isMouseLeaveToHide() {
      const {
        action: e,
        hideAction: t
      } = this.$props;
      return e.indexOf("hover") !== -1 || t.indexOf("mouseleave") !== -1;
    },
    isFocusToShow() {
      const {
        action: e,
        showAction: t
      } = this.$props;
      return e.indexOf("focus") !== -1 || t.indexOf("focus") !== -1;
    },
    isBlurToHide() {
      const {
        action: e,
        hideAction: t
      } = this.$props;
      return e.indexOf("focus") !== -1 || t.indexOf("blur") !== -1;
    },
    forcePopupAlign() {
      var e;
      this.$data.sPopupVisible && ((e = this.popupRef) === null || e === void 0 || e.forceAlign());
    },
    fireEvents(e, t) {
      this.childOriginEvents[e] && this.childOriginEvents[e](t);
      const n = this.$props[e] || this.$attrs[e];
      n && n(t);
    },
    close() {
      this.setPopupVisible(!1);
    }
  },
  render() {
    const {
      $attrs: e
    } = this, t = _s(yz(this)), {
      alignPoint: n,
      getPopupContainer: r
    } = this.$props, a = t[0];
    this.childOriginEvents = K3(a);
    const o = {
      key: "trigger"
    };
    this.isContextmenuToShow() ? o.onContextmenu = this.onContextmenu : o.onContextmenu = this.createTwoChains("onContextmenu"), this.isClickToHide() || this.isClickToShow() ? (o.onClick = this.onClick, o.onMousedown = this.onMousedown, o[za ? "onTouchstartPassive" : "onTouchstart"] = this.onTouchstart) : (o.onClick = this.createTwoChains("onClick"), o.onMousedown = this.createTwoChains("onMousedown"), o[za ? "onTouchstartPassive" : "onTouchstart"] = this.createTwoChains("onTouchstart")), this.isMouseEnterToShow() ? (o.onMouseenter = this.onMouseenter, n && (o.onMousemove = this.onMouseMove)) : o.onMouseenter = this.createTwoChains("onMouseenter"), this.isMouseLeaveToHide() ? o.onMouseleave = this.onMouseleave : o.onMouseleave = this.createTwoChains("onMouseleave"), this.isFocusToShow() || this.isBlurToHide() ? (o.onFocus = this.onFocus, o.onBlur = this.onBlur) : (o.onFocus = this.createTwoChains("onFocus"), o.onBlur = (u) => {
      u && (!u.relatedTarget || !Pl(u.target, u.relatedTarget)) && this.createTwoChains("onBlur")(u);
    });
    const i = Ge(a && a.props && a.props.class, e.class);
    i && (o.class = i);
    const s = sr(a, D(D({}, o), {
      ref: "triggerRef"
    }), !0, !0), l = A(HP, {
      key: "portal",
      getContainer: r && (() => r(this.getRootDomNode())),
      didUpdate: this.handlePortalUpdate,
      visible: this.$data.sPopupVisible
    }, {
      default: this.getComponent
    });
    return A(dt, null, [s, l]);
  }
});
var cX = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const fX = (e) => {
  const t = e === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: t,
        adjustY: 1
      }
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: t,
        adjustY: 1
      }
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: t,
        adjustY: 1
      }
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: t,
        adjustY: 1
      }
    }
  };
}, dX = /* @__PURE__ */ Me({
  name: "SelectTrigger",
  inheritAttrs: !1,
  props: {
    dropdownAlign: Object,
    visible: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    dropdownClassName: String,
    dropdownStyle: Oe.object,
    placement: String,
    empty: {
      type: Boolean,
      default: void 0
    },
    prefixCls: String,
    popupClassName: String,
    animation: String,
    transitionName: String,
    getPopupContainer: Function,
    dropdownRender: Function,
    containerWidth: Number,
    dropdownMatchSelectWidth: Oe.oneOfType([Number, Boolean]).def(!0),
    popupElement: Oe.any,
    direction: String,
    getTriggerDOMNode: Function,
    onPopupVisibleChange: Function,
    onPopupMouseEnter: Function,
    onPopupFocusin: Function,
    onPopupFocusout: Function
  },
  setup(e, t) {
    let {
      slots: n,
      attrs: r,
      expose: a
    } = t;
    const o = V(() => {
      const {
        dropdownMatchSelectWidth: s
      } = e;
      return fX(s);
    }), i = ne();
    return a({
      getPopupElement: () => i.value
    }), () => {
      const s = D(D({}, e), r), {
        empty: l = !1
      } = s, u = cX(s, ["empty"]), {
        visible: c,
        dropdownAlign: f,
        prefixCls: d,
        popupElement: p,
        dropdownClassName: v,
        dropdownStyle: h,
        direction: m = "ltr",
        placement: y,
        dropdownMatchSelectWidth: x,
        containerWidth: g,
        dropdownRender: S,
        animation: w,
        transitionName: _,
        getPopupContainer: b,
        getTriggerDOMNode: E,
        onPopupVisibleChange: C,
        onPopupMouseEnter: T,
        onPopupFocusin: O,
        onPopupFocusout: I
      } = u, k = `${d}-dropdown`;
      let B = p;
      S && (B = S({
        menuNode: p,
        props: e
      }));
      const P = w ? `${k}-${w}` : _, N = D({
        minWidth: `${g}px`
      }, h);
      return typeof x == "number" ? N.width = `${x}px` : x && (N.width = `${g}px`), A(jp, ve(ve({}, e), {}, {
        showAction: C ? ["click"] : [],
        hideAction: C ? ["click"] : [],
        popupPlacement: y || (m === "rtl" ? "bottomRight" : "bottomLeft"),
        builtinPlacements: o.value,
        prefixCls: k,
        popupTransitionName: P,
        popupAlign: f,
        popupVisible: c,
        getPopupContainer: b,
        popupClassName: Ge(v, {
          [`${k}-empty`]: l
        }),
        popupStyle: N,
        getTriggerDOMNode: E,
        onPopupVisibleChange: C
      }), {
        default: n.default,
        popup: () => A("div", {
          ref: i,
          onMouseenter: T,
          onFocusin: O,
          onFocusout: I
        }, [B])
      });
    };
  }
}), Ye = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  /**
   * END
   */
  END: 35,
  /**
   * HOME
   */
  HOME: 36,
  /**
   * LEFT
   */
  LEFT: 37,
  /**
   * UP
   */
  UP: 38,
  /**
   * RIGHT
   */
  RIGHT: 39,
  /**
   * DOWN
   */
  DOWN: 40,
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  /**
   * DELETE
   */
  DELETE: 46,
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  /**
   * DASH
   */
  DASH: 189,
  /**
   * EQUALS
   */
  EQUALS: 187,
  /**
   * COMMA
   */
  COMMA: 188,
  /**
   * PERIOD
   */
  PERIOD: 190,
  /**
   * SLASH
   */
  SLASH: 191,
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    const {
      keyCode: n
    } = t;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= Ye.F1 && n <= Ye.F12)
      return !1;
    switch (n) {
      case Ye.ALT:
      case Ye.CAPS_LOCK:
      case Ye.CONTEXT_MENU:
      case Ye.CTRL:
      case Ye.DOWN:
      case Ye.END:
      case Ye.ESC:
      case Ye.HOME:
      case Ye.INSERT:
      case Ye.LEFT:
      case Ye.MAC_FF_META:
      case Ye.META:
      case Ye.NUMLOCK:
      case Ye.NUM_CENTER:
      case Ye.PAGE_DOWN:
      case Ye.PAGE_UP:
      case Ye.PAUSE:
      case Ye.PRINT_SCREEN:
      case Ye.RIGHT:
      case Ye.SHIFT:
      case Ye.UP:
      case Ye.WIN_KEY:
      case Ye.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= Ye.ZERO && t <= Ye.NINE || t >= Ye.NUM_ZERO && t <= Ye.NUM_MULTIPLY || t >= Ye.A && t <= Ye.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case Ye.SPACE:
      case Ye.QUESTION_MARK:
      case Ye.NUM_PLUS:
      case Ye.NUM_MINUS:
      case Ye.NUM_PERIOD:
      case Ye.NUM_DIVISION:
      case Ye.SEMICOLON:
      case Ye.DASH:
      case Ye.EQUALS:
      case Ye.COMMA:
      case Ye.PERIOD:
      case Ye.SLASH:
      case Ye.APOSTROPHE:
      case Ye.SINGLE_QUOTE:
      case Ye.OPEN_SQUARE_BRACKET:
      case Ye.BACKSLASH:
      case Ye.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, hc = (e, t) => {
  let {
    slots: n
  } = t;
  var r;
  const {
    class: a,
    customizeIcon: o,
    customizeIconProps: i,
    onMousedown: s,
    onClick: l
  } = e;
  let u;
  return typeof o == "function" ? u = o(i) : u = o, A("span", {
    class: a,
    onMousedown: (c) => {
      c.preventDefault(), s && s(c);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: l,
    "aria-hidden": !0
  }, [u !== void 0 ? u : A("span", {
    class: a.split(/\s+/).map((c) => `${c}-icon`)
  }, [(r = n.default) === null || r === void 0 ? void 0 : r.call(n)])]);
};
hc.inheritAttrs = !1;
hc.displayName = "TransBtn";
hc.props = {
  class: String,
  customizeIcon: Oe.any,
  customizeIconProps: Oe.any,
  onMousedown: Function,
  onClick: Function
};
function pX(e) {
  e.target.composing = !0;
}
function n$(e) {
  e.target.composing && (e.target.composing = !1, hX(e.target, "input"));
}
function hX(e, t) {
  const n = document.createEvent("HTMLEvents");
  n.initEvent(t, !0, !0), e.dispatchEvent(n);
}
function Py(e, t, n, r) {
  e.addEventListener(t, n, r);
}
const Vp = {
  created(e, t) {
    (!t.modifiers || !t.modifiers.lazy) && (Py(e, "compositionstart", pX), Py(e, "compositionend", n$), Py(e, "change", n$));
  }
}, vX = {
  inputRef: Oe.any,
  prefixCls: String,
  id: String,
  inputElement: Oe.VueNode,
  disabled: {
    type: Boolean,
    default: void 0
  },
  autofocus: {
    type: Boolean,
    default: void 0
  },
  autocomplete: String,
  editable: {
    type: Boolean,
    default: void 0
  },
  activeDescendantId: String,
  value: String,
  open: {
    type: Boolean,
    default: void 0
  },
  tabindex: Oe.oneOfType([Oe.number, Oe.string]),
  /** Pass accessibility props to input */
  attrs: Oe.object,
  onKeydown: {
    type: Function
  },
  onMousedown: {
    type: Function
  },
  onChange: {
    type: Function
  },
  onPaste: {
    type: Function
  },
  onCompositionstart: {
    type: Function
  },
  onCompositionend: {
    type: Function
  },
  onFocus: {
    type: Function
  },
  onBlur: {
    type: Function
  }
}, jP = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "SelectInput",
  inheritAttrs: !1,
  props: vX,
  setup(e) {
    let t = null;
    const n = Ke("VCSelectContainerEvent");
    return () => {
      var r;
      const {
        prefixCls: a,
        id: o,
        inputElement: i,
        disabled: s,
        tabindex: l,
        autofocus: u,
        autocomplete: c,
        editable: f,
        activeDescendantId: d,
        value: p,
        onKeydown: v,
        onMousedown: h,
        onChange: m,
        onPaste: y,
        onCompositionstart: x,
        onCompositionend: g,
        onFocus: S,
        onBlur: w,
        open: _,
        inputRef: b,
        attrs: E
      } = e;
      let C = i || Yn(A("input", null, null), [[Vp]]);
      const T = C.props || {}, {
        onKeydown: O,
        onInput: I,
        onFocus: k,
        onBlur: B,
        onMousedown: P,
        onCompositionstart: N,
        onCompositionend: M,
        style: H
      } = T;
      return C = sr(C, D(D(D(D(D({
        type: "search"
      }, T), {
        id: o,
        ref: b,
        disabled: s,
        tabindex: l,
        autocomplete: c || "off",
        autofocus: u,
        class: Ge(`${a}-selection-search-input`, (r = C == null ? void 0 : C.props) === null || r === void 0 ? void 0 : r.class),
        role: "combobox",
        "aria-expanded": _,
        "aria-haspopup": "listbox",
        "aria-owns": `${o}_list`,
        "aria-autocomplete": "list",
        "aria-controls": `${o}_list`,
        "aria-activedescendant": d
      }), E), {
        value: f ? p : "",
        readonly: !f,
        unselectable: f ? null : "on",
        style: D(D({}, H), {
          opacity: f ? null : 0
        }),
        onKeydown: (R) => {
          v(R), O && O(R);
        },
        onMousedown: (R) => {
          h(R), P && P(R);
        },
        onInput: (R) => {
          m(R), I && I(R);
        },
        onCompositionstart(R) {
          x(R), N && N(R);
        },
        onCompositionend(R) {
          g(R), M && M(R);
        },
        onPaste: y,
        onFocus: function() {
          clearTimeout(t), k && k(arguments.length <= 0 ? void 0 : arguments[0]), S && S(arguments.length <= 0 ? void 0 : arguments[0]), n == null || n.focus(arguments.length <= 0 ? void 0 : arguments[0]);
        },
        onBlur: function() {
          for (var R = arguments.length, z = new Array(R), W = 0; W < R; W++)
            z[W] = arguments[W];
          t = setTimeout(() => {
            B && B(z[0]), w && w(z[0]), n == null || n.blur(z[0]);
          }, 100);
        }
      }), C.type === "textarea" ? {} : {
        type: "search"
      }), !0, !0), C;
    };
  }
}), mX = `accept acceptcharset accesskey action allowfullscreen allowtransparency
alt async autocomplete autofocus autoplay capture cellpadding cellspacing challenge
charset checked classid classname colspan cols content contenteditable contextmenu
controls coords crossorigin data datetime default defer dir disabled download draggable
enctype form formaction formenctype formmethod formnovalidate formtarget frameborder
headers height hidden high href hreflang htmlfor for httpequiv icon id inputmode integrity
is keyparams keytype kind label lang list loop low manifest marginheight marginwidth max maxlength media
mediagroup method min minlength multiple muted name novalidate nonce open
optimum pattern placeholder poster preload radiogroup readonly rel required
reversed role rowspan rows sandbox scope scoped scrolling seamless selected
shape size sizes span spellcheck src srcdoc srclang srcset start step style
summary tabindex target title type usemap value width wmode wrap`, gX = `onCopy onCut onPaste onCompositionend onCompositionstart onCompositionupdate onKeydown
    onKeypress onKeyup onFocus onBlur onChange onInput onSubmit onClick onContextmenu onDoubleclick onDblclick
    onDrag onDragend onDragenter onDragexit onDragleave onDragover onDragstart onDrop onMousedown
    onMouseenter onMouseleave onMousemove onMouseout onMouseover onMouseup onSelect onTouchcancel
    onTouchend onTouchmove onTouchstart onTouchstartPassive onTouchmovePassive onScroll onWheel onAbort onCanplay onCanplaythrough
    onDurationchange onEmptied onEncrypted onEnded onError onLoadeddata onLoadedmetadata
    onLoadstart onPause onPlay onPlaying onProgress onRatechange onSeeked onSeeking onStalled onSuspend onTimeupdate onVolumechange onWaiting onLoad onError`, r$ = `${mX} ${gX}`.split(/[\s\n]+/), yX = "aria-", xX = "data-";
function a$(e, t) {
  return e.indexOf(t) === 0;
}
function i1(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n;
  t === !1 ? n = {
    aria: !0,
    data: !0,
    attr: !0
  } : t === !0 ? n = {
    aria: !0
  } : n = D({}, t);
  const r = {};
  return Object.keys(e).forEach((a) => {
    // Aria
    (n.aria && (a === "role" || a$(a, yX)) || // Data
    n.data && a$(a, xX) || // Attr
    n.attr && (r$.includes(a) || r$.includes(a.toLowerCase()))) && (r[a] = e[a]);
  }), r;
}
const VP = Symbol("OverflowContextProviderKey"), e2 = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "OverflowContextProvider",
  inheritAttrs: !1,
  props: {
    value: {
      type: Object
    }
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    return kt(VP, V(() => e.value)), () => {
      var r;
      return (r = n.default) === null || r === void 0 ? void 0 : r.call(n);
    };
  }
}), bX = () => Ke(VP, V(() => null));
var wX = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const Wc = void 0, Rv = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "Item",
  props: {
    prefixCls: String,
    item: Oe.any,
    renderItem: Function,
    responsive: Boolean,
    itemKey: {
      type: [String, Number]
    },
    registerSize: Function,
    display: Boolean,
    order: Number,
    component: Oe.any,
    invalidate: Boolean
  },
  setup(e, t) {
    let {
      slots: n,
      expose: r
    } = t;
    const a = V(() => e.responsive && !e.display), o = ne();
    r({
      itemNodeRef: o
    });
    function i(s) {
      e.registerSize(e.itemKey, s);
    }
    return Bo(() => {
      i(null);
    }), () => {
      var s;
      const {
        prefixCls: l,
        invalidate: u,
        item: c,
        renderItem: f,
        responsive: d,
        registerSize: p,
        itemKey: v,
        display: h,
        order: m,
        component: y = "div"
      } = e, x = wX(e, ["prefixCls", "invalidate", "item", "renderItem", "responsive", "registerSize", "itemKey", "display", "order", "component"]), g = (s = n.default) === null || s === void 0 ? void 0 : s.call(n), S = f && c !== Wc ? f(c) : g;
      let w;
      u || (w = {
        opacity: a.value ? 0 : 1,
        height: a.value ? 0 : Wc,
        overflowY: a.value ? "hidden" : Wc,
        order: d ? m : Wc,
        pointerEvents: a.value ? "none" : Wc,
        position: a.value ? "absolute" : Wc
      });
      const _ = {};
      return a.value && (_["aria-hidden"] = !0), A(Wg, {
        disabled: !d,
        onResize: (b) => {
          let {
            offsetWidth: E
          } = b;
          i(E);
        }
      }, {
        default: () => A(y, ve(ve(ve({
          class: Ge(!u && l),
          style: w
        }, _), x), {}, {
          ref: o
        }), {
          default: () => [S]
        })
      });
    };
  }
});
var Dy = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const SX = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "RawItem",
  inheritAttrs: !1,
  props: {
    component: Oe.any,
    title: Oe.any,
    id: String,
    onMouseenter: {
      type: Function
    },
    onMouseleave: {
      type: Function
    },
    onClick: {
      type: Function
    },
    onKeydown: {
      type: Function
    },
    onFocus: {
      type: Function
    },
    role: String,
    tabindex: Number
  },
  setup(e, t) {
    let {
      slots: n,
      attrs: r
    } = t;
    const a = bX();
    return () => {
      var o;
      if (!a.value) {
        const {
          component: f = "div"
        } = e, d = Dy(e, ["component"]);
        return A(f, ve(ve({}, d), r), {
          default: () => [(o = n.default) === null || o === void 0 ? void 0 : o.call(n)]
        });
      }
      const i = a.value, {
        className: s
      } = i, l = Dy(i, ["className"]), {
        class: u
      } = r, c = Dy(r, ["class"]);
      return A(e2, {
        value: null
      }, {
        default: () => [A(Rv, ve(ve(ve({
          class: Ge(s, u)
        }, l), c), e), n)]
      });
    };
  }
});
var _X = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const UP = "responsive", zP = "invalidate";
function CX(e) {
  return `+ ${e.length} ...`;
}
const EX = () => ({
  id: String,
  prefixCls: String,
  data: Array,
  itemKey: [String, Number, Function],
  /** Used for `responsive`. It will limit render node to avoid perf issue */
  itemWidth: {
    type: Number,
    default: 10
  },
  renderItem: Function,
  /** @private Do not use in your production. Render raw node that need wrap Item by developer self */
  renderRawItem: Function,
  maxCount: [Number, String],
  renderRest: Function,
  /** @private Do not use in your production. Render raw node that need wrap Item by developer self */
  renderRawRest: Function,
  suffix: Oe.any,
  component: String,
  itemComponent: Oe.any,
  /** @private This API may be refactor since not well design */
  onVisibleChange: Function,
  /** When set to `full`, ssr will render full items by default and remove at client side */
  ssr: String,
  onMousedown: Function
}), Gs = /* @__PURE__ */ Me({
  name: "Overflow",
  inheritAttrs: !1,
  props: EX(),
  emits: ["visibleChange"],
  setup(e, t) {
    let {
      attrs: n,
      emit: r,
      slots: a
    } = t;
    const o = V(() => e.ssr === "full"), i = Be(null), s = V(() => i.value || 0), l = Be(/* @__PURE__ */ new Map()), u = Be(0), c = Be(0), f = Be(0), d = Be(null), p = Be(null), v = V(() => p.value === null && o.value ? Number.MAX_SAFE_INTEGER : p.value || 0), h = Be(!1), m = V(() => `${e.prefixCls}-item`), y = V(() => Math.max(u.value, c.value)), x = V(() => !!(e.data.length && e.maxCount === UP)), g = V(() => e.maxCount === zP), S = V(() => x.value || typeof e.maxCount == "number" && e.data.length > e.maxCount), w = V(() => {
      let P = e.data;
      return x.value ? i.value === null && o.value ? P = e.data : P = e.data.slice(0, Math.min(e.data.length, s.value / e.itemWidth)) : typeof e.maxCount == "number" && (P = e.data.slice(0, e.maxCount)), P;
    }), _ = V(() => x.value ? e.data.slice(v.value + 1) : e.data.slice(w.value.length)), b = (P, N) => {
      var M;
      return typeof e.itemKey == "function" ? e.itemKey(P) : (M = e.itemKey && (P == null ? void 0 : P[e.itemKey])) !== null && M !== void 0 ? M : N;
    }, E = V(() => e.renderItem || ((P) => P)), C = (P, N) => {
      p.value = P, N || (h.value = P < e.data.length - 1, r("visibleChange", P));
    }, T = (P, N) => {
      i.value = N.clientWidth;
    }, O = (P, N) => {
      const M = new Map(l.value);
      N === null ? M.delete(P) : M.set(P, N), l.value = M;
    }, I = (P, N) => {
      u.value = c.value, c.value = N;
    }, k = (P, N) => {
      f.value = N;
    }, B = (P) => l.value.get(b(w.value[P], P));
    return He([s, l, c, f, () => e.itemKey, w], () => {
      if (s.value && y.value && w.value) {
        let P = f.value;
        const N = w.value.length, M = N - 1;
        if (!N) {
          C(0), d.value = null;
          return;
        }
        for (let H = 0; H < N; H += 1) {
          const R = B(H);
          if (R === void 0) {
            C(H - 1, !0);
            break;
          }
          if (P += R, // Only one means `totalWidth` is the final width
          M === 0 && P <= s.value || // Last two width will be the final width
          H === M - 1 && P + B(M) <= s.value) {
            C(M), d.value = null;
            break;
          } else if (P + y.value > s.value) {
            C(H - 1), d.value = P - R - f.value + c.value;
            break;
          }
        }
        e.suffix && B(0) + f.value > s.value && (d.value = null);
      }
    }), () => {
      const P = h.value && !!_.value.length, {
        itemComponent: N,
        renderRawItem: M,
        renderRawRest: H,
        renderRest: R,
        prefixCls: z = "rc-overflow",
        suffix: W,
        component: F = "div",
        id: Y,
        onMousedown: X
      } = e, {
        class: q,
        style: Q
      } = n, ue = _X(n, ["class", "style"]);
      let le = {};
      d.value !== null && x.value && (le = {
        position: "absolute",
        left: `${d.value}px`,
        top: 0
      });
      const te = {
        prefixCls: m.value,
        responsive: x.value,
        component: N,
        invalidate: g.value
      }, G = M ? (j, J) => {
        const ae = b(j, J);
        return A(e2, {
          key: ae,
          value: D(D({}, te), {
            order: J,
            item: j,
            itemKey: ae,
            registerSize: O,
            display: J <= v.value
          })
        }, {
          default: () => [M(j, J)]
        });
      } : (j, J) => {
        const ae = b(j, J);
        return A(Rv, ve(ve({}, te), {}, {
          order: J,
          key: ae,
          item: j,
          renderItem: E.value,
          itemKey: ae,
          registerSize: O,
          display: J <= v.value
        }), null);
      };
      let oe = () => null;
      const L = {
        order: P ? v.value : Number.MAX_SAFE_INTEGER,
        className: `${m.value} ${m.value}-rest`,
        registerSize: I,
        display: P
      };
      if (H)
        H && (oe = () => A(e2, {
          value: D(D({}, te), L)
        }, {
          default: () => [H(_.value)]
        }));
      else {
        const j = R || CX;
        oe = () => A(Rv, ve(ve({}, te), L), {
          default: () => typeof j == "function" ? j(_.value) : j
        });
      }
      const re = () => {
        var j;
        return A(F, ve({
          id: Y,
          class: Ge(!g.value && z, q),
          style: Q,
          onMousedown: X
        }, ue), {
          default: () => [w.value.map(G), S.value ? oe() : null, W && A(Rv, ve(ve({}, te), {}, {
            order: v.value,
            class: `${m.value}-suffix`,
            registerSize: k,
            display: !0,
            style: le
          }), {
            default: () => W
          }), (j = a.default) === null || j === void 0 ? void 0 : j.call(a)]
        });
      };
      return A(Wg, {
        disabled: !x.value,
        onResize: T
      }, {
        default: re
      });
    };
  }
});
Gs.Item = SX;
Gs.RESPONSIVE = UP;
Gs.INVALIDATE = zP;
const TX = Symbol("TreeSelectLegacyContextPropsKey");
function vC() {
  return Ke(TX, {});
}
const $X = {
  id: String,
  prefixCls: String,
  values: Oe.array,
  open: {
    type: Boolean,
    default: void 0
  },
  searchValue: String,
  inputRef: Oe.any,
  placeholder: Oe.any,
  disabled: {
    type: Boolean,
    default: void 0
  },
  mode: String,
  showSearch: {
    type: Boolean,
    default: void 0
  },
  autofocus: {
    type: Boolean,
    default: void 0
  },
  autocomplete: String,
  activeDescendantId: String,
  tabindex: Oe.oneOfType([Oe.number, Oe.string]),
  removeIcon: Oe.any,
  choiceTransitionName: String,
  maxTagCount: Oe.oneOfType([Oe.number, Oe.string]),
  maxTagTextLength: Number,
  maxTagPlaceholder: Oe.any.def(() => (e) => `+ ${e.length} ...`),
  tagRender: Function,
  onToggleOpen: {
    type: Function
  },
  onRemove: Function,
  onInputChange: Function,
  onInputPaste: Function,
  onInputKeyDown: Function,
  onInputMouseDown: Function,
  onInputCompositionStart: Function,
  onInputCompositionEnd: Function
}, o$ = (e) => {
  e.preventDefault(), e.stopPropagation();
}, OX = /* @__PURE__ */ Me({
  name: "MultipleSelectSelector",
  inheritAttrs: !1,
  props: $X,
  setup(e) {
    const t = Be(), n = Be(0), r = Be(!1), a = vC(), o = V(() => `${e.prefixCls}-selection`), i = V(() => e.open || e.mode === "tags" ? e.searchValue : ""), s = V(() => e.mode === "tags" || e.showSearch && (e.open || r.value));
    Lt(() => {
      He(i, () => {
        n.value = t.value.scrollWidth;
      }, {
        flush: "post",
        immediate: !0
      });
    });
    function l(d, p, v, h, m) {
      return A("span", {
        class: Ge(`${o.value}-item`, {
          [`${o.value}-item-disabled`]: v
        }),
        title: typeof d == "string" || typeof d == "number" ? d.toString() : void 0
      }, [A("span", {
        class: `${o.value}-item-content`
      }, [p]), h && A(hc, {
        class: `${o.value}-item-remove`,
        onMousedown: o$,
        onClick: m,
        customizeIcon: e.removeIcon
      }, {
        default: () => [Jt("×")]
      })]);
    }
    function u(d, p, v, h, m, y) {
      var x;
      const g = (w) => {
        o$(w), e.onToggleOpen(!open);
      };
      let S = y;
      return a.keyEntities && (S = ((x = a.keyEntities[d]) === null || x === void 0 ? void 0 : x.node) || {}), A("span", {
        key: d,
        onMousedown: g
      }, [e.tagRender({
        label: p,
        value: d,
        disabled: v,
        closable: h,
        onClose: m,
        option: S
      })]);
    }
    function c(d) {
      const {
        disabled: p,
        label: v,
        value: h,
        option: m
      } = d, y = !e.disabled && !p;
      let x = v;
      if (typeof e.maxTagTextLength == "number" && (typeof v == "string" || typeof v == "number")) {
        const S = String(x);
        S.length > e.maxTagTextLength && (x = `${S.slice(0, e.maxTagTextLength)}...`);
      }
      const g = (S) => {
        var w;
        S && S.stopPropagation(), (w = e.onRemove) === null || w === void 0 || w.call(e, d);
      };
      return typeof e.tagRender == "function" ? u(h, x, p, y, g, m) : l(v, x, p, y, g);
    }
    function f(d) {
      const {
        maxTagPlaceholder: p = (h) => `+ ${h.length} ...`
      } = e, v = typeof p == "function" ? p(d) : p;
      return l(v, v, !1);
    }
    return () => {
      const {
        id: d,
        prefixCls: p,
        values: v,
        open: h,
        inputRef: m,
        placeholder: y,
        disabled: x,
        autofocus: g,
        autocomplete: S,
        activeDescendantId: w,
        tabindex: _,
        onInputChange: b,
        onInputPaste: E,
        onInputKeyDown: C,
        onInputMouseDown: T,
        onInputCompositionStart: O,
        onInputCompositionEnd: I
      } = e, k = A("div", {
        class: `${o.value}-search`,
        style: {
          width: n.value + "px"
        },
        key: "input"
      }, [A(jP, {
        inputRef: m,
        open: h,
        prefixCls: p,
        id: d,
        inputElement: null,
        disabled: x,
        autofocus: g,
        autocomplete: S,
        editable: s.value,
        activeDescendantId: w,
        value: i.value,
        onKeydown: C,
        onMousedown: T,
        onChange: b,
        onPaste: E,
        onCompositionstart: O,
        onCompositionend: I,
        tabindex: _,
        attrs: i1(e, !0),
        onFocus: () => r.value = !0,
        onBlur: () => r.value = !1
      }, null), A("span", {
        ref: t,
        class: `${o.value}-search-mirror`,
        "aria-hidden": !0
      }, [i.value, Jt(" ")])]), B = A(Gs, {
        prefixCls: `${o.value}-overflow`,
        data: v,
        renderItem: c,
        renderRest: f,
        suffix: k,
        itemKey: "key",
        maxCount: e.maxTagCount,
        key: "overflow"
      }, null);
      return A(dt, null, [B, !v.length && !i.value && A("span", {
        class: `${o.value}-placeholder`
      }, [y])]);
    };
  }
}), AX = {
  inputElement: Oe.any,
  id: String,
  prefixCls: String,
  values: Oe.array,
  open: {
    type: Boolean,
    default: void 0
  },
  searchValue: String,
  inputRef: Oe.any,
  placeholder: Oe.any,
  disabled: {
    type: Boolean,
    default: void 0
  },
  mode: String,
  showSearch: {
    type: Boolean,
    default: void 0
  },
  autofocus: {
    type: Boolean,
    default: void 0
  },
  autocomplete: String,
  activeDescendantId: String,
  tabindex: Oe.oneOfType([Oe.number, Oe.string]),
  activeValue: String,
  backfill: {
    type: Boolean,
    default: void 0
  },
  optionLabelRender: Function,
  onInputChange: Function,
  onInputPaste: Function,
  onInputKeyDown: Function,
  onInputMouseDown: Function,
  onInputCompositionStart: Function,
  onInputCompositionEnd: Function
}, mC = /* @__PURE__ */ Me({
  name: "SingleSelector",
  setup(e) {
    const t = Be(!1), n = V(() => e.mode === "combobox"), r = V(() => n.value || e.showSearch), a = V(() => {
      let u = e.searchValue || "";
      return n.value && e.activeValue && !t.value && (u = e.activeValue), u;
    }), o = vC();
    He([n, () => e.activeValue], () => {
      n.value && (t.value = !1);
    }, {
      immediate: !0
    });
    const i = V(() => e.mode !== "combobox" && !e.open && !e.showSearch ? !1 : !!a.value), s = V(() => {
      const u = e.values[0];
      return u && (typeof u.label == "string" || typeof u.label == "number") ? u.label.toString() : void 0;
    }), l = () => {
      if (e.values[0])
        return null;
      const u = i.value ? {
        visibility: "hidden"
      } : void 0;
      return A("span", {
        class: `${e.prefixCls}-selection-placeholder`,
        style: u
      }, [e.placeholder]);
    };
    return () => {
      var u, c, f, d;
      const {
        inputElement: p,
        prefixCls: v,
        id: h,
        values: m,
        inputRef: y,
        disabled: x,
        autofocus: g,
        autocomplete: S,
        activeDescendantId: w,
        open: _,
        tabindex: b,
        optionLabelRender: E,
        onInputKeyDown: C,
        onInputMouseDown: T,
        onInputChange: O,
        onInputPaste: I,
        onInputCompositionStart: k,
        onInputCompositionEnd: B
      } = e, P = m[0];
      let N = null;
      if (P && o.customSlots) {
        const M = (u = P.key) !== null && u !== void 0 ? u : P.value, H = ((c = o.keyEntities[M]) === null || c === void 0 ? void 0 : c.node) || {};
        N = o.customSlots[(f = H.slots) === null || f === void 0 ? void 0 : f.title] || o.customSlots.title || P.label, typeof N == "function" && (N = N(H));
      } else
        N = E && P ? E(P.option) : P == null ? void 0 : P.label;
      return A(dt, null, [A("span", {
        class: `${v}-selection-search`
      }, [A(jP, {
        inputRef: y,
        prefixCls: v,
        id: h,
        open: _,
        inputElement: p,
        disabled: x,
        autofocus: g,
        autocomplete: S,
        editable: r.value,
        activeDescendantId: w,
        value: a.value,
        onKeydown: C,
        onMousedown: T,
        onChange: (M) => {
          t.value = !0, O(M);
        },
        onPaste: I,
        onCompositionstart: k,
        onCompositionend: B,
        tabindex: b,
        attrs: i1(e, !0)
      }, null)]), !n.value && P && !i.value && A("span", {
        class: `${v}-selection-item`,
        title: s.value
      }, [A(dt, {
        key: (d = P.key) !== null && d !== void 0 ? d : P.value
      }, [N])]), l()]);
    };
  }
});
mC.props = AX;
mC.inheritAttrs = !1;
function IX(e) {
  return ![
    // System function button
    Ye.ESC,
    Ye.SHIFT,
    Ye.BACKSPACE,
    Ye.TAB,
    Ye.WIN_KEY,
    Ye.ALT,
    Ye.META,
    Ye.WIN_KEY_RIGHT,
    Ye.CTRL,
    Ye.SEMICOLON,
    Ye.EQUALS,
    Ye.CAPS_LOCK,
    Ye.CONTEXT_MENU,
    // F1-F12
    Ye.F1,
    Ye.F2,
    Ye.F3,
    Ye.F4,
    Ye.F5,
    Ye.F6,
    Ye.F7,
    Ye.F8,
    Ye.F9,
    Ye.F10,
    Ye.F11,
    Ye.F12
  ].includes(e);
}
function WP() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, t = null, n;
  Sn(() => {
    clearTimeout(n);
  });
  function r(a) {
    (a || t === null) && (t = a), clearTimeout(n), n = setTimeout(() => {
      t = null;
    }, e);
  }
  return [() => t, r];
}
function pp() {
  const e = (t) => {
    e.current = t;
  };
  return e;
}
const PX = /* @__PURE__ */ Me({
  name: "Selector",
  inheritAttrs: !1,
  props: {
    id: String,
    prefixCls: String,
    showSearch: {
      type: Boolean,
      default: void 0
    },
    open: {
      type: Boolean,
      default: void 0
    },
    /** Display in the Selector value, it's not same as `value` prop */
    values: Oe.array,
    multiple: {
      type: Boolean,
      default: void 0
    },
    mode: String,
    searchValue: String,
    activeValue: String,
    inputElement: Oe.any,
    autofocus: {
      type: Boolean,
      default: void 0
    },
    activeDescendantId: String,
    tabindex: Oe.oneOfType([Oe.number, Oe.string]),
    disabled: {
      type: Boolean,
      default: void 0
    },
    placeholder: Oe.any,
    removeIcon: Oe.any,
    // Tags
    maxTagCount: Oe.oneOfType([Oe.number, Oe.string]),
    maxTagTextLength: Number,
    maxTagPlaceholder: Oe.any,
    tagRender: Function,
    optionLabelRender: Function,
    /** Check if `tokenSeparators` contains `\n` or `\r\n` */
    tokenWithEnter: {
      type: Boolean,
      default: void 0
    },
    // Motion
    choiceTransitionName: String,
    onToggleOpen: {
      type: Function
    },
    /** `onSearch` returns go next step boolean to check if need do toggle open */
    onSearch: Function,
    onSearchSubmit: Function,
    onRemove: Function,
    onInputKeyDown: {
      type: Function
    },
    /**
     * @private get real dom for trigger align.
     * This may be removed after React provides replacement of `findDOMNode`
     */
    domRef: Function
  },
  setup(e, t) {
    let {
      expose: n
    } = t;
    const r = pp();
    let a = !1;
    const [o, i] = WP(0), s = (y) => {
      const {
        which: x
      } = y;
      (x === Ye.UP || x === Ye.DOWN) && y.preventDefault(), e.onInputKeyDown && e.onInputKeyDown(y), x === Ye.ENTER && e.mode === "tags" && !a && !e.open && e.onSearchSubmit(y.target.value), IX(x) && e.onToggleOpen(!0);
    }, l = () => {
      i(!0);
    };
    let u = null;
    const c = (y) => {
      e.onSearch(y, !0, a) !== !1 && e.onToggleOpen(!0);
    }, f = () => {
      a = !0;
    }, d = (y) => {
      a = !1, e.mode !== "combobox" && c(y.target.value);
    }, p = (y) => {
      let {
        target: {
          value: x
        }
      } = y;
      if (e.tokenWithEnter && u && /[\r\n]/.test(u)) {
        const g = u.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
        x = x.replace(g, u);
      }
      u = null, c(x);
    }, v = (y) => {
      const {
        clipboardData: x
      } = y;
      u = x.getData("text");
    }, h = (y) => {
      let {
        target: x
      } = y;
      x !== r.current && (document.body.style.msTouchAction !== void 0 ? setTimeout(() => {
        r.current.focus();
      }) : r.current.focus());
    }, m = (y) => {
      const x = o();
      y.target !== r.current && !x && y.preventDefault(), (e.mode !== "combobox" && (!e.showSearch || !x) || !e.open) && (e.open && e.onSearch("", !0, !1), e.onToggleOpen());
    };
    return n({
      focus: () => {
        r.current.focus();
      },
      blur: () => {
        r.current.blur();
      }
    }), () => {
      const {
        prefixCls: y,
        domRef: x,
        mode: g
      } = e, S = {
        inputRef: r,
        onInputKeyDown: s,
        onInputMouseDown: l,
        onInputChange: p,
        onInputPaste: v,
        onInputCompositionStart: f,
        onInputCompositionEnd: d
      }, w = g === "multiple" || g === "tags" ? A(OX, ve(ve({}, e), S), null) : A(mC, ve(ve({}, e), S), null);
      return A("div", {
        ref: x,
        class: `${y}-selector`,
        onClick: h,
        onMousedown: m
      }, [w]);
    };
  }
});
function DX(e, t, n) {
  function r(a) {
    var o, i, s;
    let l = a.target;
    l.shadowRoot && a.composed && (l = a.composedPath()[0] || l);
    const u = [(o = e[0]) === null || o === void 0 ? void 0 : o.value, (s = (i = e[1]) === null || i === void 0 ? void 0 : i.value) === null || s === void 0 ? void 0 : s.getPopupElement()];
    t.value && u.every((c) => c && !c.contains(l) && c !== l) && n(!1);
  }
  Lt(() => {
    window.addEventListener("mousedown", r);
  }), Sn(() => {
    window.removeEventListener("mousedown", r);
  });
}
function kX() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
  const t = Be(!1);
  let n;
  const r = () => {
    clearTimeout(n);
  };
  return Lt(() => {
    r();
  }), [t, (o, i) => {
    r(), n = setTimeout(() => {
      t.value = o, i && i();
    }, e);
  }, r];
}
const GP = Symbol("BaseSelectContextKey");
function MX(e) {
  return kt(GP, e);
}
function RX() {
  return Ke(GP, {});
}
const NX = () => {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  const e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
};
function KP(e) {
  if (!Ft(e)) return Wn(e);
  const t = new Proxy({}, {
    get(n, r, a) {
      return Reflect.get(e.value, r, a);
    },
    set(n, r, a) {
      return e.value[r] = a, !0;
    },
    deleteProperty(n, r) {
      return Reflect.deleteProperty(e.value, r);
    },
    has(n, r) {
      return Reflect.has(e.value, r);
    },
    ownKeys() {
      return Object.keys(e.value);
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    }
  });
  return Wn(t);
}
var FX = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const LX = ["value", "onChange", "removeIcon", "placeholder", "autofocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabindex", "OptionList", "notFoundContent"], BX = () => ({
  prefixCls: String,
  id: String,
  omitDomProps: Array,
  // >>> Value
  displayValues: Array,
  onDisplayValuesChange: Function,
  // >>> Active
  /** Current dropdown list active item string value */
  activeValue: String,
  /** Link search input with target element */
  activeDescendantId: String,
  onActiveValueChange: Function,
  // >>> Search
  searchValue: String,
  /** Trigger onSearch, return false to prevent trigger open event */
  onSearch: Function,
  /** Trigger when search text match the `tokenSeparators`. Will provide split content */
  onSearchSplit: Function,
  maxLength: Number,
  OptionList: Oe.any,
  /** Tell if provided `options` is empty */
  emptyOptions: Boolean
}), YP = () => ({
  showSearch: {
    type: Boolean,
    default: void 0
  },
  tagRender: {
    type: Function
  },
  optionLabelRender: {
    type: Function
  },
  direction: {
    type: String
  },
  // MISC
  tabindex: Number,
  autofocus: Boolean,
  notFoundContent: Oe.any,
  placeholder: Oe.any,
  onClear: Function,
  choiceTransitionName: String,
  // >>> Mode
  mode: String,
  // >>> Status
  disabled: {
    type: Boolean,
    default: void 0
  },
  loading: {
    type: Boolean,
    default: void 0
  },
  // >>> Open
  open: {
    type: Boolean,
    default: void 0
  },
  defaultOpen: {
    type: Boolean,
    default: void 0
  },
  onDropdownVisibleChange: {
    type: Function
  },
  // >>> Customize Input
  /** @private Internal usage. Do not use in your production. */
  getInputElement: {
    type: Function
  },
  /** @private Internal usage. Do not use in your production. */
  getRawInputElement: {
    type: Function
  },
  // >>> Selector
  maxTagTextLength: Number,
  maxTagCount: {
    type: [String, Number]
  },
  maxTagPlaceholder: Oe.any,
  // >>> Search
  tokenSeparators: {
    type: Array
  },
  // >>> Icons
  allowClear: {
    type: Boolean,
    default: void 0
  },
  showArrow: {
    type: Boolean,
    default: void 0
  },
  inputIcon: Oe.any,
  /** Clear all icon */
  clearIcon: Oe.any,
  /** Selector remove icon */
  removeIcon: Oe.any,
  // >>> Dropdown
  animation: String,
  transitionName: String,
  dropdownStyle: {
    type: Object
  },
  dropdownClassName: String,
  dropdownMatchSelectWidth: {
    type: [Boolean, Number],
    default: void 0
  },
  dropdownRender: {
    type: Function
  },
  dropdownAlign: Object,
  placement: {
    type: String
  },
  getPopupContainer: {
    type: Function
  },
  // >>> Focus
  showAction: {
    type: Array
  },
  onBlur: {
    type: Function
  },
  onFocus: {
    type: Function
  },
  // >>> Rest Events
  onKeyup: Function,
  onKeydown: Function,
  onMousedown: Function,
  onPopupScroll: Function,
  onInputKeyDown: Function,
  onMouseenter: Function,
  onMouseleave: Function,
  onClick: Function
}), HX = () => D(D({}, BX()), YP());
function gC(e) {
  return e === "tags" || e === "multiple";
}
const jX = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "BaseSelect",
  inheritAttrs: !1,
  props: ha(HX(), {
    showAction: [],
    notFoundContent: "Not Found"
  }),
  setup(e, t) {
    let {
      attrs: n,
      expose: r,
      slots: a
    } = t;
    const o = V(() => gC(e.mode)), i = V(() => e.showSearch !== void 0 ? e.showSearch : o.value || e.mode === "combobox"), s = Be(!1);
    Lt(() => {
      s.value = NX();
    });
    const l = vC(), u = Be(null), c = pp(), f = Be(null), d = Be(null), p = Be(null), v = ne(!1), [h, m, y] = kX();
    r({
      focus: () => {
        var G;
        (G = d.value) === null || G === void 0 || G.focus();
      },
      blur: () => {
        var G;
        (G = d.value) === null || G === void 0 || G.blur();
      },
      scrollTo: (G) => {
        var oe;
        return (oe = p.value) === null || oe === void 0 ? void 0 : oe.scrollTo(G);
      }
    });
    const S = V(() => {
      var G;
      if (e.mode !== "combobox")
        return e.searchValue;
      const oe = (G = e.displayValues[0]) === null || G === void 0 ? void 0 : G.value;
      return typeof oe == "string" || typeof oe == "number" ? String(oe) : "";
    }), w = e.open !== void 0 ? e.open : e.defaultOpen, _ = Be(w), b = Be(w), E = (G) => {
      _.value = e.open !== void 0 ? e.open : G, b.value = _.value;
    };
    He(() => e.open, () => {
      E(e.open);
    });
    const C = V(() => !e.notFoundContent && e.emptyOptions);
    _n(() => {
      b.value = _.value, (e.disabled || C.value && b.value && e.mode === "combobox") && (b.value = !1);
    });
    const T = V(() => C.value ? !1 : b.value), O = (G) => {
      const oe = G !== void 0 ? G : !b.value;
      b.value !== oe && !e.disabled && (E(oe), e.onDropdownVisibleChange && e.onDropdownVisibleChange(oe));
    }, I = V(() => (e.tokenSeparators || []).some((G) => [`
`, `\r
`].includes(G))), k = (G, oe, L) => {
      var re, j;
      let J = !0, ae = G;
      (re = e.onActiveValueChange) === null || re === void 0 || re.call(e, null);
      const he = L ? null : LG(G, e.tokenSeparators);
      return e.mode !== "combobox" && he && (ae = "", (j = e.onSearchSplit) === null || j === void 0 || j.call(e, he), O(!1), J = !1), e.onSearch && S.value !== ae && e.onSearch(ae, {
        source: oe ? "typing" : "effect"
      }), J;
    }, B = (G) => {
      var oe;
      !G || !G.trim() || (oe = e.onSearch) === null || oe === void 0 || oe.call(e, G, {
        source: "submit"
      });
    };
    He(b, () => {
      !b.value && !o.value && e.mode !== "combobox" && k("", !1, !1);
    }, {
      immediate: !0,
      flush: "post"
    }), He(() => e.disabled, () => {
      _.value && e.disabled && E(!1), e.disabled && !v.value && m(!1);
    }, {
      immediate: !0
    });
    const [P, N] = WP(), M = function(G) {
      var oe;
      const L = P(), {
        which: re
      } = G;
      if (re === Ye.ENTER && (e.mode !== "combobox" && G.preventDefault(), b.value || O(!0)), N(!!S.value), re === Ye.BACKSPACE && !L && o.value && !S.value && e.displayValues.length) {
        const he = [...e.displayValues];
        let K = null;
        for (let Z = he.length - 1; Z >= 0; Z -= 1) {
          const se = he[Z];
          if (!se.disabled) {
            he.splice(Z, 1), K = se;
            break;
          }
        }
        K && e.onDisplayValuesChange(he, {
          type: "remove",
          values: [K]
        });
      }
      for (var j = arguments.length, J = new Array(j > 1 ? j - 1 : 0), ae = 1; ae < j; ae++)
        J[ae - 1] = arguments[ae];
      b.value && p.value && p.value.onKeydown(G, ...J), (oe = e.onKeydown) === null || oe === void 0 || oe.call(e, G, ...J);
    }, H = function(G) {
      for (var oe = arguments.length, L = new Array(oe > 1 ? oe - 1 : 0), re = 1; re < oe; re++)
        L[re - 1] = arguments[re];
      b.value && p.value && p.value.onKeyup(G, ...L), e.onKeyup && e.onKeyup(G, ...L);
    }, R = (G) => {
      const oe = e.displayValues.filter((L) => L !== G);
      e.onDisplayValuesChange(oe, {
        type: "remove",
        values: [G]
      });
    }, z = Be(!1), W = function() {
      m(!0), e.disabled || (e.onFocus && !z.value && e.onFocus(...arguments), e.showAction && e.showAction.includes("focus") && O(!0)), z.value = !0;
    }, F = ne(!1), Y = function() {
      if (F.value || (v.value = !0, m(!1, () => {
        z.value = !1, v.value = !1, O(!1);
      }), e.disabled))
        return;
      const G = S.value;
      G && (e.mode === "tags" ? e.onSearch(G, {
        source: "submit"
      }) : e.mode === "multiple" && e.onSearch("", {
        source: "blur"
      })), e.onBlur && e.onBlur(...arguments);
    }, X = () => {
      F.value = !0;
    }, q = () => {
      F.value = !1;
    };
    kt("VCSelectContainerEvent", {
      focus: W,
      blur: Y
    });
    const Q = [];
    Lt(() => {
      Q.forEach((G) => clearTimeout(G)), Q.splice(0, Q.length);
    }), Sn(() => {
      Q.forEach((G) => clearTimeout(G)), Q.splice(0, Q.length);
    });
    const ue = function(G) {
      var oe, L;
      const {
        target: re
      } = G, j = (oe = f.value) === null || oe === void 0 ? void 0 : oe.getPopupElement();
      if (j && j.contains(re)) {
        const K = setTimeout(() => {
          var Z;
          const se = Q.indexOf(K);
          se !== -1 && Q.splice(se, 1), y(), !s.value && !j.contains(document.activeElement) && ((Z = d.value) === null || Z === void 0 || Z.focus());
        });
        Q.push(K);
      }
      for (var J = arguments.length, ae = new Array(J > 1 ? J - 1 : 0), he = 1; he < J; he++)
        ae[he - 1] = arguments[he];
      (L = e.onMousedown) === null || L === void 0 || L.call(e, G, ...ae);
    }, le = Be(null), te = () => {
    };
    return Lt(() => {
      He(T, () => {
        var G;
        if (T.value) {
          const oe = Math.ceil((G = u.value) === null || G === void 0 ? void 0 : G.offsetWidth);
          le.value !== oe && !Number.isNaN(oe) && (le.value = oe);
        }
      }, {
        immediate: !0,
        flush: "post"
      });
    }), DX([u, f], T, O), MX(KP(D(D({}, ac(e)), {
      open: b,
      triggerOpen: T,
      showSearch: i,
      multiple: o,
      toggleOpen: O
    }))), () => {
      const G = D(D({}, e), n), {
        prefixCls: oe,
        id: L,
        open: re,
        defaultOpen: j,
        mode: J,
        // Search related
        showSearch: ae,
        searchValue: he,
        onSearch: K,
        // Icons
        allowClear: Z,
        clearIcon: se,
        showArrow: me,
        inputIcon: xe,
        // Others
        disabled: be,
        loading: Te,
        getInputElement: Ie,
        getPopupContainer: Ve,
        placement: tt,
        // Dropdown
        animation: it,
        transitionName: Se,
        dropdownStyle: ge,
        dropdownClassName: pe,
        dropdownMatchSelectWidth: De,
        dropdownRender: Ue,
        dropdownAlign: Xe,
        showAction: ut,
        direction: xt,
        // Tags
        tokenSeparators: Mt,
        tagRender: yt,
        optionLabelRender: gt,
        // Events
        onPopupScroll: ct,
        onDropdownVisibleChange: Ht,
        onFocus: Ut,
        onBlur: In,
        onKeyup: wr,
        onKeydown: eo,
        onMousedown: ur,
        onClear: rr,
        omitDomProps: gi,
        getRawInputElement: yi,
        displayValues: $r,
        onDisplayValuesChange: An,
        emptyOptions: va,
        activeDescendantId: Ze,
        activeValue: Et,
        OptionList: _t
      } = G, ee = FX(G, ["prefixCls", "id", "open", "defaultOpen", "mode", "showSearch", "searchValue", "onSearch", "allowClear", "clearIcon", "showArrow", "inputIcon", "disabled", "loading", "getInputElement", "getPopupContainer", "placement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "showAction", "direction", "tokenSeparators", "tagRender", "optionLabelRender", "onPopupScroll", "onDropdownVisibleChange", "onFocus", "onBlur", "onKeyup", "onKeydown", "onMousedown", "onClear", "omitDomProps", "getRawInputElement", "displayValues", "onDisplayValuesChange", "emptyOptions", "activeDescendantId", "activeValue", "OptionList"]), fe = J === "combobox" && Ie && Ie() || null, ie = typeof yi == "function" && yi(), ce = D({}, ee);
      let de;
      ie && (de = (ht) => {
        O(ht);
      }), LX.forEach((ht) => {
        delete ce[ht];
      }), gi == null || gi.forEach((ht) => {
        delete ce[ht];
      });
      const ye = me !== void 0 ? me : Te || !o.value && J !== "combobox";
      let Pe;
      ye && (Pe = A(hc, {
        class: Ge(`${oe}-arrow`, {
          [`${oe}-arrow-loading`]: Te
        }),
        customizeIcon: xe,
        customizeIconProps: {
          loading: Te,
          searchValue: S.value,
          open: b.value,
          focused: h.value,
          showSearch: i.value
        }
      }, null));
      let je;
      const Ae = () => {
        rr == null || rr(), An([], {
          type: "clear",
          values: $r
        }), k("", !1, !1);
      };
      !be && Z && ($r.length || S.value) && (je = A(hc, {
        class: `${oe}-clear`,
        onMousedown: Ae,
        customizeIcon: se
      }, {
        default: () => [Jt("×")]
      }));
      const Re = A(_t, {
        ref: p
      }, D(D({}, l.customSlots), {
        option: a.option
      })), Ne = Ge(oe, n.class, {
        [`${oe}-focused`]: h.value,
        [`${oe}-multiple`]: o.value,
        [`${oe}-single`]: !o.value,
        [`${oe}-allow-clear`]: Z,
        [`${oe}-show-arrow`]: ye,
        [`${oe}-disabled`]: be,
        [`${oe}-loading`]: Te,
        [`${oe}-open`]: b.value,
        [`${oe}-customize-input`]: fe,
        [`${oe}-show-search`]: i.value
      }), Qe = A(dX, {
        ref: f,
        disabled: be,
        prefixCls: oe,
        visible: T.value,
        popupElement: Re,
        containerWidth: le.value,
        animation: it,
        transitionName: Se,
        dropdownStyle: ge,
        dropdownClassName: pe,
        direction: xt,
        dropdownMatchSelectWidth: De,
        dropdownRender: Ue,
        dropdownAlign: Xe,
        placement: tt,
        getPopupContainer: Ve,
        empty: va,
        getTriggerDOMNode: () => c.current,
        onPopupVisibleChange: de,
        onPopupMouseEnter: te,
        onPopupFocusin: X,
        onPopupFocusout: q
      }, {
        default: () => ie ? co(ie) && sr(ie, {
          ref: c
        }, !1, !0) : A(PX, ve(ve({}, e), {}, {
          domRef: c,
          prefixCls: oe,
          inputElement: fe,
          ref: d,
          id: L,
          showSearch: i.value,
          mode: J,
          activeDescendantId: Ze,
          tagRender: yt,
          optionLabelRender: gt,
          values: $r,
          open: b.value,
          onToggleOpen: O,
          activeValue: Et,
          searchValue: S.value,
          onSearch: k,
          onSearchSubmit: B,
          onRemove: R,
          tokenWithEnter: I.value
        }), null)
      });
      let $e;
      return ie ? $e = Qe : $e = A("div", ve(ve({}, ce), {}, {
        class: Ne,
        ref: u,
        onMousedown: ue,
        onKeydown: M,
        onKeyup: H
      }), [h.value && !b.value && A("span", {
        style: {
          width: 0,
          height: 0,
          position: "absolute",
          overflow: "hidden",
          opacity: 0
        },
        "aria-live": "polite"
      }, [`${$r.map((ht) => {
        let {
          label: ot,
          value: Je
        } = ht;
        return ["number", "string"].includes(typeof ot) ? ot : Je;
      }).join(", ")}`]), Qe, Pe, je]), $e;
    };
  }
}), s1 = (e, t) => {
  let {
    height: n,
    offset: r,
    prefixCls: a,
    onInnerResize: o
  } = e, {
    slots: i
  } = t;
  var s;
  let l = {}, u = {
    display: "flex",
    flexDirection: "column"
  };
  return r !== void 0 && (l = {
    height: `${n}px`,
    position: "relative",
    overflow: "hidden"
  }, u = D(D({}, u), {
    transform: `translateY(${r}px)`,
    position: "absolute",
    left: 0,
    right: 0,
    top: 0
  })), A("div", {
    style: l
  }, [A(Wg, {
    onResize: (c) => {
      let {
        offsetHeight: f
      } = c;
      f && o && o();
    }
  }, {
    default: () => [A("div", {
      style: u,
      class: Ge({
        [`${a}-holder-inner`]: a
      })
    }, [(s = i.default) === null || s === void 0 ? void 0 : s.call(i)])]
  })]);
};
s1.displayName = "Filter";
s1.inheritAttrs = !1;
s1.props = {
  prefixCls: String,
  /** Virtual filler height. Should be `count * itemMinHeight` */
  height: Number,
  /** Set offset of visible items. Should be the top of start item position */
  offset: Number,
  onInnerResize: Function
};
const qP = (e, t) => {
  let {
    setRef: n
  } = e, {
    slots: r
  } = t;
  var a;
  const o = ua((a = r.default) === null || a === void 0 ? void 0 : a.call(r));
  return o && o.length ? Yr(o[0], {
    ref: n
  }) : o;
};
qP.props = {
  setRef: {
    type: Function,
    default: () => {
    }
  }
};
const VX = 20;
function i$(e) {
  return "touches" in e ? e.touches[0].pageY : e.pageY;
}
const UX = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ScrollBar",
  inheritAttrs: !1,
  props: {
    prefixCls: String,
    scrollTop: Number,
    scrollHeight: Number,
    height: Number,
    count: Number,
    onScroll: {
      type: Function
    },
    onStartMove: {
      type: Function
    },
    onStopMove: {
      type: Function
    }
  },
  setup() {
    return {
      moveRaf: null,
      scrollbarRef: pp(),
      thumbRef: pp(),
      visibleTimeout: null,
      state: Wn({
        dragging: !1,
        pageY: null,
        startTop: null,
        visible: !1
      })
    };
  },
  watch: {
    scrollTop: {
      handler() {
        this.delayHidden();
      },
      flush: "post"
    }
  },
  mounted() {
    var e, t;
    (e = this.scrollbarRef.current) === null || e === void 0 || e.addEventListener("touchstart", this.onScrollbarTouchStart, za ? {
      passive: !1
    } : !1), (t = this.thumbRef.current) === null || t === void 0 || t.addEventListener("touchstart", this.onMouseDown, za ? {
      passive: !1
    } : !1);
  },
  beforeUnmount() {
    this.removeEvents(), clearTimeout(this.visibleTimeout);
  },
  methods: {
    delayHidden() {
      clearTimeout(this.visibleTimeout), this.state.visible = !0, this.visibleTimeout = setTimeout(() => {
        this.state.visible = !1;
      }, 2e3);
    },
    onScrollbarTouchStart(e) {
      e.preventDefault();
    },
    onContainerMouseDown(e) {
      e.stopPropagation(), e.preventDefault();
    },
    // ======================= Clean =======================
    patchEvents() {
      window.addEventListener("mousemove", this.onMouseMove), window.addEventListener("mouseup", this.onMouseUp), this.thumbRef.current.addEventListener("touchmove", this.onMouseMove, za ? {
        passive: !1
      } : !1), this.thumbRef.current.addEventListener("touchend", this.onMouseUp);
    },
    removeEvents() {
      window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("mouseup", this.onMouseUp), this.scrollbarRef.current.removeEventListener("touchstart", this.onScrollbarTouchStart, za ? {
        passive: !1
      } : !1), this.thumbRef.current && (this.thumbRef.current.removeEventListener("touchstart", this.onMouseDown, za ? {
        passive: !1
      } : !1), this.thumbRef.current.removeEventListener("touchmove", this.onMouseMove, za ? {
        passive: !1
      } : !1), this.thumbRef.current.removeEventListener("touchend", this.onMouseUp)), dn.cancel(this.moveRaf);
    },
    // ======================= Thumb =======================
    onMouseDown(e) {
      const {
        onStartMove: t
      } = this.$props;
      D(this.state, {
        dragging: !0,
        pageY: i$(e),
        startTop: this.getTop()
      }), t(), this.patchEvents(), e.stopPropagation(), e.preventDefault();
    },
    onMouseMove(e) {
      const {
        dragging: t,
        pageY: n,
        startTop: r
      } = this.state, {
        onScroll: a
      } = this.$props;
      if (dn.cancel(this.moveRaf), t) {
        const o = i$(e) - n, i = r + o, s = this.getEnableScrollRange(), l = this.getEnableHeightRange(), u = l ? i / l : 0, c = Math.ceil(u * s);
        this.moveRaf = dn(() => {
          a(c);
        });
      }
    },
    onMouseUp() {
      const {
        onStopMove: e
      } = this.$props;
      this.state.dragging = !1, e(), this.removeEvents();
    },
    // ===================== Calculate =====================
    getSpinHeight() {
      const {
        height: e,
        scrollHeight: t
      } = this.$props;
      let n = e / t * 100;
      return n = Math.max(n, VX), n = Math.min(n, e / 2), Math.floor(n);
    },
    getEnableScrollRange() {
      const {
        scrollHeight: e,
        height: t
      } = this.$props;
      return e - t || 0;
    },
    getEnableHeightRange() {
      const {
        height: e
      } = this.$props, t = this.getSpinHeight();
      return e - t || 0;
    },
    getTop() {
      const {
        scrollTop: e
      } = this.$props, t = this.getEnableScrollRange(), n = this.getEnableHeightRange();
      return e === 0 || t === 0 ? 0 : e / t * n;
    },
    // Not show scrollbar when height is large than scrollHeight
    showScroll() {
      const {
        height: e,
        scrollHeight: t
      } = this.$props;
      return t > e;
    }
  },
  render() {
    const {
      dragging: e,
      visible: t
    } = this.state, {
      prefixCls: n
    } = this.$props, r = this.getSpinHeight() + "px", a = this.getTop() + "px", o = this.showScroll(), i = o && t;
    return A("div", {
      ref: this.scrollbarRef,
      class: Ge(`${n}-scrollbar`, {
        [`${n}-scrollbar-show`]: o
      }),
      style: {
        width: "8px",
        top: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: i ? void 0 : "none"
      },
      onMousedown: this.onContainerMouseDown,
      onMousemove: this.delayHidden
    }, [A("div", {
      ref: this.thumbRef,
      class: Ge(`${n}-scrollbar-thumb`, {
        [`${n}-scrollbar-thumb-moving`]: e
      }),
      style: {
        width: "100%",
        height: r,
        top: a,
        left: 0,
        position: "absolute",
        background: "rgba(0, 0, 0, 0.5)",
        borderRadius: "99px",
        cursor: "pointer",
        userSelect: "none"
      },
      onMousedown: this.onMouseDown
    }, null)]);
  }
});
function zX(e, t, n, r) {
  const a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), i = ne(Symbol("update"));
  He(e, () => {
    i.value = Symbol("update");
  });
  let s;
  function l() {
    dn.cancel(s);
  }
  function u() {
    l(), s = dn(() => {
      a.forEach((f, d) => {
        if (f && f.offsetParent) {
          const {
            offsetHeight: p
          } = f;
          o.get(d) !== p && (i.value = Symbol("update"), o.set(d, f.offsetHeight));
        }
      });
    });
  }
  function c(f, d) {
    const p = t(f);
    a.get(p), d ? (a.set(p, d.$el || d), u()) : a.delete(p);
  }
  return Bo(() => {
    l();
  }), [c, u, o, i];
}
function WX(e, t, n, r, a, o, i, s) {
  let l;
  return (u) => {
    if (u == null) {
      s();
      return;
    }
    dn.cancel(l);
    const c = t.value, f = r.itemHeight;
    if (typeof u == "number")
      i(u);
    else if (u && typeof u == "object") {
      let d;
      const {
        align: p
      } = u;
      "index" in u ? {
        index: d
      } = u : d = c.findIndex((m) => a(m) === u.key);
      const {
        offset: v = 0
      } = u, h = (m, y) => {
        if (m < 0 || !e.value) return;
        const x = e.value.clientHeight;
        let g = !1, S = y;
        if (x) {
          const w = y || p;
          let _ = 0, b = 0, E = 0;
          const C = Math.min(c.length, d);
          for (let I = 0; I <= C; I += 1) {
            const k = a(c[I]);
            b = _;
            const B = n.get(k);
            E = b + (B === void 0 ? f : B), _ = E, I === d && B === void 0 && (g = !0);
          }
          const T = e.value.scrollTop;
          let O = null;
          switch (w) {
            case "top":
              O = b - v;
              break;
            case "bottom":
              O = E - x + v;
              break;
            default: {
              const I = T + x;
              b < T ? S = "top" : E > I && (S = "bottom");
            }
          }
          O !== null && O !== T && i(O);
        }
        l = dn(() => {
          g && o(), h(m - 1, S);
        }, 2);
      };
      h(5);
    }
  };
}
const GX = typeof navigator == "object" && /Firefox/i.test(navigator.userAgent), XP = (e, t) => {
  let n = !1, r = null;
  function a() {
    clearTimeout(r), n = !0, r = setTimeout(() => {
      n = !1;
    }, 50);
  }
  return function(o) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    const s = (
      // Pass origin wheel when on the top
      o < 0 && e.value || // Pass origin wheel when on the bottom
      o > 0 && t.value
    );
    return i && s ? (clearTimeout(r), n = !1) : (!s || n) && a(), !n && s;
  };
};
function KX(e, t, n, r) {
  let a = 0, o = null, i = null, s = !1;
  const l = XP(t, n);
  function u(f) {
    if (!e.value) return;
    dn.cancel(o);
    const {
      deltaY: d
    } = f;
    a += d, i = d, !l(d) && (GX || f.preventDefault(), o = dn(() => {
      r(a * (s ? 10 : 1)), a = 0;
    }));
  }
  function c(f) {
    e.value && (s = f.detail === i);
  }
  return [u, c];
}
const YX = 14 / 15;
function qX(e, t, n) {
  let r = !1, a = 0, o = null, i = null;
  const s = () => {
    o && (o.removeEventListener("touchmove", l), o.removeEventListener("touchend", u));
  }, l = (d) => {
    if (r) {
      const p = Math.ceil(d.touches[0].pageY);
      let v = a - p;
      a = p, n(v) && d.preventDefault(), clearInterval(i), i = setInterval(() => {
        v *= YX, (!n(v, !0) || Math.abs(v) <= 0.1) && clearInterval(i);
      }, 16);
    }
  }, u = () => {
    r = !1, s();
  }, c = (d) => {
    s(), d.touches.length === 1 && !r && (r = !0, a = Math.ceil(d.touches[0].pageY), o = d.target, o.addEventListener("touchmove", l, {
      passive: !1
    }), o.addEventListener("touchend", u));
  }, f = () => {
  };
  Lt(() => {
    document.addEventListener("touchmove", f, {
      passive: !1
    }), He(e, (d) => {
      t.value.removeEventListener("touchstart", c), s(), clearInterval(i), d && t.value.addEventListener("touchstart", c, {
        passive: !1
      });
    }, {
      immediate: !0
    });
  }), Sn(() => {
    document.removeEventListener("touchmove", f);
  });
}
var XX = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const ZX = [], QX = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function JX(e, t, n, r, a, o) {
  let {
    getKey: i
  } = o;
  return e.slice(t, n + 1).map((s, l) => {
    const u = t + l, c = a(s, u, {
      // style: status === 'MEASURE_START' ? { visibility: 'hidden' } : {},
    }), f = i(s);
    return A(qP, {
      key: f,
      setRef: (d) => r(s, d)
    }, {
      default: () => [c]
    });
  });
}
const eZ = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "List",
  inheritAttrs: !1,
  props: {
    prefixCls: String,
    data: Oe.array,
    height: Number,
    itemHeight: Number,
    /** If not match virtual scroll condition, Set List still use height of container. */
    fullHeight: {
      type: Boolean,
      default: void 0
    },
    itemKey: {
      type: [String, Number, Function],
      required: !0
    },
    component: {
      type: [String, Object]
    },
    /** Set `false` will always use real scroll instead of virtual one */
    virtual: {
      type: Boolean,
      default: void 0
    },
    children: Function,
    onScroll: Function,
    onMousedown: Function,
    onMouseenter: Function,
    onVisibleChange: Function
  },
  setup(e, t) {
    let {
      expose: n
    } = t;
    const r = V(() => {
      const {
        height: R,
        itemHeight: z,
        virtual: W
      } = e;
      return !!(W !== !1 && R && z);
    }), a = V(() => {
      const {
        height: R,
        itemHeight: z,
        data: W
      } = e;
      return r.value && W && z * W.length > R;
    }), o = Wn({
      scrollTop: 0,
      scrollMoving: !1
    }), i = V(() => e.data || ZX), s = Be([]);
    He(i, () => {
      s.value = At(i.value).slice();
    }, {
      immediate: !0
    });
    const l = Be((R) => {
    });
    He(() => e.itemKey, (R) => {
      typeof R == "function" ? l.value = R : l.value = (z) => z == null ? void 0 : z[R];
    }, {
      immediate: !0
    });
    const u = Be(), c = Be(), f = Be(), d = (R) => l.value(R), p = {
      getKey: d
    };
    function v(R) {
      let z;
      typeof R == "function" ? z = R(o.scrollTop) : z = R;
      const W = _(z);
      u.value && (u.value.scrollTop = W), o.scrollTop = W;
    }
    const [h, m, y, x] = zX(s, d), g = Wn({
      scrollHeight: void 0,
      start: 0,
      end: 0,
      offset: void 0
    }), S = Be(0);
    Lt(() => {
      nn(() => {
        var R;
        S.value = ((R = c.value) === null || R === void 0 ? void 0 : R.offsetHeight) || 0;
      });
    }), Qa(() => {
      nn(() => {
        var R;
        S.value = ((R = c.value) === null || R === void 0 ? void 0 : R.offsetHeight) || 0;
      });
    }), He([r, s], () => {
      r.value || D(g, {
        scrollHeight: void 0,
        start: 0,
        end: s.value.length - 1,
        offset: void 0
      });
    }, {
      immediate: !0
    }), He([r, s, S, a], () => {
      r.value && !a.value && D(g, {
        scrollHeight: S.value,
        start: 0,
        end: s.value.length - 1,
        offset: void 0
      }), u.value && (o.scrollTop = u.value.scrollTop);
    }, {
      immediate: !0
    }), He([a, r, () => o.scrollTop, s, x, () => e.height, S], () => {
      if (!r.value || !a.value)
        return;
      let R = 0, z, W, F;
      const Y = s.value.length, X = s.value, q = o.scrollTop, {
        itemHeight: Q,
        height: ue
      } = e, le = q + ue;
      for (let te = 0; te < Y; te += 1) {
        const G = X[te], oe = d(G);
        let L = y.get(oe);
        L === void 0 && (L = Q);
        const re = R + L;
        z === void 0 && re >= q && (z = te, W = R), F === void 0 && re > le && (F = te), R = re;
      }
      z === void 0 && (z = 0, W = 0, F = Math.ceil(ue / Q)), F === void 0 && (F = Y - 1), F = Math.min(F + 1, Y), D(g, {
        scrollHeight: R,
        start: z,
        end: F,
        offset: W
      });
    }, {
      immediate: !0
    });
    const w = V(() => g.scrollHeight - e.height);
    function _(R) {
      let z = R;
      return Number.isNaN(w.value) || (z = Math.min(z, w.value)), z = Math.max(z, 0), z;
    }
    const b = V(() => o.scrollTop <= 0), E = V(() => o.scrollTop >= w.value), C = XP(b, E);
    function T(R) {
      v(R);
    }
    function O(R) {
      var z;
      const {
        scrollTop: W
      } = R.currentTarget;
      W !== o.scrollTop && v(W), (z = e.onScroll) === null || z === void 0 || z.call(e, R);
    }
    const [I, k] = KX(r, b, E, (R) => {
      v((z) => z + R);
    });
    qX(r, u, (R, z) => C(R, z) ? !1 : (I({
      preventDefault() {
      },
      deltaY: R
    }), !0));
    function B(R) {
      r.value && R.preventDefault();
    }
    const P = () => {
      u.value && (u.value.removeEventListener("wheel", I, za ? {
        passive: !1
      } : !1), u.value.removeEventListener("DOMMouseScroll", k), u.value.removeEventListener("MozMousePixelScroll", B));
    };
    _n(() => {
      nn(() => {
        u.value && (P(), u.value.addEventListener("wheel", I, za ? {
          passive: !1
        } : !1), u.value.addEventListener("DOMMouseScroll", k), u.value.addEventListener("MozMousePixelScroll", B));
      });
    }), Sn(() => {
      P();
    });
    const N = WX(u, s, y, e, d, m, v, () => {
      var R;
      (R = f.value) === null || R === void 0 || R.delayHidden();
    });
    n({
      scrollTo: N
    });
    const M = V(() => {
      let R = null;
      return e.height && (R = D({
        [e.fullHeight ? "height" : "maxHeight"]: e.height + "px"
      }, QX), r.value && (R.overflowY = "hidden", o.scrollMoving && (R.pointerEvents = "none"))), R;
    });
    return He([() => g.start, () => g.end, s], () => {
      if (e.onVisibleChange) {
        const R = s.value.slice(g.start, g.end + 1);
        e.onVisibleChange(R, s.value);
      }
    }, {
      flush: "post"
    }), {
      state: o,
      mergedData: s,
      componentStyle: M,
      onFallbackScroll: O,
      onScrollBar: T,
      componentRef: u,
      useVirtual: r,
      calRes: g,
      collectHeight: m,
      setInstance: h,
      sharedConfig: p,
      scrollBarRef: f,
      fillerInnerRef: c,
      delayHideScrollBar: () => {
        var R;
        (R = f.value) === null || R === void 0 || R.delayHidden();
      }
    };
  },
  render() {
    const e = D(D({}, this.$props), this.$attrs), {
      prefixCls: t = "rc-virtual-list",
      height: n,
      itemHeight: r,
      // eslint-disable-next-line no-unused-vars
      fullHeight: a,
      data: o,
      itemKey: i,
      virtual: s,
      component: l = "div",
      onScroll: u,
      children: c = this.$slots.default,
      style: f,
      class: d
    } = e, p = XX(e, ["prefixCls", "height", "itemHeight", "fullHeight", "data", "itemKey", "virtual", "component", "onScroll", "children", "style", "class"]), v = Ge(t, d), {
      scrollTop: h
    } = this.state, {
      scrollHeight: m,
      offset: y,
      start: x,
      end: g
    } = this.calRes, {
      componentStyle: S,
      onFallbackScroll: w,
      onScrollBar: _,
      useVirtual: b,
      collectHeight: E,
      sharedConfig: C,
      setInstance: T,
      mergedData: O,
      delayHideScrollBar: I
    } = this;
    return A("div", ve({
      style: D(D({}, f), {
        position: "relative"
      }),
      class: v
    }, p), [A(l, {
      class: `${t}-holder`,
      style: S,
      ref: "componentRef",
      onScroll: w,
      onMouseenter: I
    }, {
      default: () => [A(s1, {
        prefixCls: t,
        height: m,
        offset: y,
        onInnerResize: E,
        ref: "fillerInnerRef"
      }, {
        default: () => JX(O, x, g, T, c, C)
      })]
    }), b && A(UX, {
      ref: "scrollBarRef",
      prefixCls: t,
      scrollTop: h,
      height: n,
      scrollHeight: m,
      count: O.length,
      onScroll: _,
      onStartMove: () => {
        this.state.scrollMoving = !0;
      },
      onStopMove: () => {
        this.state.scrollMoving = !1;
      }
    }, null)]);
  }
});
function ZP(e, t, n) {
  const r = ne(e());
  return He(t, (a, o) => {
    n ? n(a, o) && (r.value = e()) : r.value = e();
  }), r;
}
function tZ() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
const QP = Symbol("SelectContextKey");
function nZ(e) {
  return kt(QP, e);
}
function rZ() {
  return Ke(QP, {});
}
var aZ = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function s$(e) {
  return typeof e == "string" || typeof e == "number";
}
const oZ = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "OptionList",
  inheritAttrs: !1,
  setup(e, t) {
    let {
      expose: n,
      slots: r
    } = t;
    const a = RX(), o = rZ(), i = V(() => `${a.prefixCls}-item`), s = ZP(() => o.flattenOptions, [() => a.open, () => o.flattenOptions], (w) => w[0]), l = pp(), u = (w) => {
      w.preventDefault();
    }, c = (w) => {
      l.current && l.current.scrollTo(typeof w == "number" ? {
        index: w
      } : w);
    }, f = function(w) {
      let _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
      const b = s.value.length;
      for (let E = 0; E < b; E += 1) {
        const C = (w + E * _ + b) % b, {
          group: T,
          data: O
        } = s.value[C];
        if (!T && !O.disabled)
          return C;
      }
      return -1;
    }, d = Wn({
      activeIndex: f(0)
    }), p = function(w) {
      let _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      d.activeIndex = w;
      const b = {
        source: _ ? "keyboard" : "mouse"
      }, E = s.value[w];
      if (!E) {
        o.onActiveValue(null, -1, b);
        return;
      }
      o.onActiveValue(E.value, w, b);
    };
    He([() => s.value.length, () => a.searchValue], () => {
      p(o.defaultActiveFirstOption !== !1 ? f(0) : -1);
    }, {
      immediate: !0
    });
    const v = (w) => o.rawValues.has(w) && a.mode !== "combobox";
    He([() => a.open, () => a.searchValue], () => {
      if (!a.multiple && a.open && o.rawValues.size === 1) {
        const w = Array.from(o.rawValues)[0], _ = At(s.value).findIndex((b) => {
          let {
            data: E
          } = b;
          return E[o.fieldNames.value] === w;
        });
        _ !== -1 && (p(_), nn(() => {
          c(_);
        }));
      }
      a.open && nn(() => {
        var w;
        (w = l.current) === null || w === void 0 || w.scrollTo(void 0);
      });
    }, {
      immediate: !0,
      flush: "post"
    });
    const h = (w) => {
      w !== void 0 && o.onSelect(w, {
        selected: !o.rawValues.has(w)
      }), a.multiple || a.toggleOpen(!1);
    }, m = (w) => typeof w.label == "function" ? w.label() : w.label;
    function y(w) {
      const _ = s.value[w];
      if (!_) return null;
      const b = _.data || {}, {
        value: E
      } = b, {
        group: C
      } = _, T = i1(b, !0), O = m(_);
      return _ ? A("div", ve(ve({
        "aria-label": typeof O == "string" && !C ? O : null
      }, T), {}, {
        key: w,
        role: C ? "presentation" : "option",
        id: `${a.id}_list_${w}`,
        "aria-selected": v(E)
      }), [E]) : null;
    }
    return n({
      onKeydown: (w) => {
        const {
          which: _,
          ctrlKey: b
        } = w;
        switch (_) {
          case Ye.N:
          case Ye.P:
          case Ye.UP:
          case Ye.DOWN: {
            let E = 0;
            if (_ === Ye.UP ? E = -1 : _ === Ye.DOWN ? E = 1 : tZ() && b && (_ === Ye.N ? E = 1 : _ === Ye.P && (E = -1)), E !== 0) {
              const C = f(d.activeIndex + E, E);
              c(C), p(C, !0);
            }
            break;
          }
          case Ye.ENTER: {
            const E = s.value[d.activeIndex];
            E && !E.data.disabled ? h(E.value) : h(void 0), a.open && w.preventDefault();
            break;
          }
          case Ye.ESC:
            a.toggleOpen(!1), a.open && w.stopPropagation();
        }
      },
      onKeyup: () => {
      },
      scrollTo: (w) => {
        c(w);
      }
    }), () => {
      const {
        id: w,
        notFoundContent: _,
        onPopupScroll: b
      } = a, {
        menuItemSelectedIcon: E,
        fieldNames: C,
        virtual: T,
        listHeight: O,
        listItemHeight: I
      } = o, k = r.option, {
        activeIndex: B
      } = d, P = Object.keys(C).map((N) => C[N]);
      return s.value.length === 0 ? A("div", {
        role: "listbox",
        id: `${w}_list`,
        class: `${i.value}-empty`,
        onMousedown: u
      }, [_]) : A(dt, null, [A("div", {
        role: "listbox",
        id: `${w}_list`,
        style: {
          height: 0,
          width: 0,
          overflow: "hidden"
        }
      }, [y(B - 1), y(B), y(B + 1)]), A(eZ, {
        itemKey: "key",
        ref: l,
        data: s.value,
        height: O,
        itemHeight: I,
        fullHeight: !1,
        onMousedown: u,
        onScroll: b,
        virtual: T
      }, {
        default: (N, M) => {
          var H;
          const {
            group: R,
            groupOption: z,
            data: W,
            value: F
          } = N, {
            key: Y
          } = W, X = typeof N.label == "function" ? N.label() : N.label;
          if (R) {
            const se = (H = W.title) !== null && H !== void 0 ? H : s$(X) && X;
            return A("div", {
              class: Ge(i.value, `${i.value}-group`),
              title: se
            }, [k ? k(W) : X !== void 0 ? X : Y]);
          }
          const {
            disabled: q,
            title: Q,
            children: ue,
            style: le,
            class: te,
            className: G
          } = W, oe = aZ(W, ["disabled", "title", "children", "style", "class", "className"]), L = Lr(oe, P), re = v(F), j = `${i.value}-option`, J = Ge(i.value, j, te, G, {
            [`${j}-grouped`]: z,
            [`${j}-active`]: B === M && !q,
            [`${j}-disabled`]: q,
            [`${j}-selected`]: re
          }), ae = m(N), he = !E || typeof E == "function" || re, K = typeof ae == "number" ? ae : ae || F;
          let Z = s$(K) ? K.toString() : void 0;
          return Q !== void 0 && (Z = Q), A("div", ve(ve({}, L), {}, {
            "aria-selected": re,
            class: J,
            title: Z,
            onMousemove: (se) => {
              oe.onMousemove && oe.onMousemove(se), !(B === M || q) && p(M);
            },
            onClick: (se) => {
              q || h(F), oe.onClick && oe.onClick(se);
            },
            style: le
          }), [A("div", {
            class: `${j}-content`
          }, [k ? k(W) : K]), co(E) || re, he && A(hc, {
            class: `${i.value}-option-state`,
            customizeIcon: E,
            customizeIconProps: {
              isSelected: re
            }
          }, {
            default: () => [re ? "✓" : null]
          })]);
        }
      })]);
    };
  }
});
var iZ = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function sZ(e) {
  const t = e, {
    key: n,
    children: r
  } = t, a = t.props, {
    value: o,
    disabled: i
  } = a, s = iZ(a, ["value", "disabled"]), l = r == null ? void 0 : r.default;
  return D({
    key: n,
    value: o !== void 0 ? o : n,
    children: l,
    disabled: i || i === ""
  }, s);
}
function yC(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return ua(e).map((r, a) => {
    var o;
    if (!co(r) || !r.type)
      return null;
    const {
      type: {
        isSelectOptGroup: i
      },
      key: s,
      children: l,
      props: u
    } = r;
    if (t || !i)
      return sZ(r);
    const c = l && l.default ? l.default() : void 0, f = (u == null ? void 0 : u.label) || ((o = l.label) === null || o === void 0 ? void 0 : o.call(l)) || s;
    return D(D({
      key: `__RC_SELECT_GRP__${s === null ? a : String(s)}__`
    }, u), {
      label: f,
      options: yC(c || [])
    });
  }).filter((r) => r);
}
function lZ(e, t, n) {
  const r = Be(), a = Be(), o = Be(), i = Be([]);
  return He([e, t], () => {
    e.value ? i.value = At(e.value).slice() : i.value = yC(t.value);
  }, {
    immediate: !0,
    deep: !0
  }), _n(() => {
    const s = i.value, l = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), c = n.value;
    function f(d) {
      let p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      for (let v = 0; v < d.length; v += 1) {
        const h = d[v];
        !h[c.options] || p ? (l.set(h[c.value], h), u.set(h[c.label], h)) : f(h[c.options], !0);
      }
    }
    f(s), r.value = s, a.value = l, o.value = u;
  }), {
    options: r,
    valueOptions: a,
    labelOptions: o
  };
}
let l$ = 0;
const uZ = process.env.NODE_ENV !== "test" && li();
function cZ() {
  let e;
  return uZ ? (e = l$, l$ += 1) : e = "TEST_OR_SSR", e;
}
function fZ() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ne("");
  const t = `rc_select_${cZ()}`;
  return e.value || t;
}
function xC(e) {
  return Array.isArray(e) ? e : e !== void 0 ? [e] : [];
}
const dZ = typeof window < "u" && window.document && window.document.documentElement;
process.env.NODE_ENV;
function pZ(e) {
  const {
    mode: t,
    options: n,
    children: r,
    backfill: a,
    allowClear: o,
    placeholder: i,
    getInputElement: s,
    showSearch: l,
    onSearch: u,
    defaultOpen: c,
    autofocus: f,
    labelInValue: d,
    value: p,
    inputValue: v,
    optionLabelProp: h
  } = e, m = gC(t), y = l !== void 0 ? l : m || t === "combobox", x = n || yC(r);
  if ($o(t !== "tags" || x.every((g) => !g.disabled), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), $o(t !== "combobox" || !h, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), $o(t === "combobox" || !a, "`backfill` only works with `combobox` mode."), $o(t === "combobox" || !s, "`getInputElement` only work with `combobox` mode."), kb(t !== "combobox" || !s || !o || !i, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), u && !y && t !== "combobox" && t !== "tags" && $o(!1, "`onSearch` should work with `showSearch` instead of use alone."), kb(!c || f, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autofocus` if needed."), p != null) {
    const g = xC(p);
    $o(!d || g.every((S) => typeof S == "object" && ("key" in S || "value" in S)), "`value` should in shape of `{ value: string | number, label?: any }` when you set `labelInValue` to `true`"), $o(!m || Array.isArray(p), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (r) {
    let g = null;
    r.some((S) => {
      var w;
      if (!co(S) || !S.type)
        return !1;
      const {
        type: _
      } = S;
      return _.isSelectOption ? !1 : _.isSelectOptGroup ? !(((w = S.children) === null || w === void 0 ? void 0 : w.default()) || []).every((C) => !co(C) || !S.type || C.type.isSelectOption ? !0 : (g = C.type, !1)) : (g = _, !0);
    }), g && $o(!1, `\`children\` should be \`Select.Option\` or \`Select.OptGroup\` instead of \`${g.displayName || g.name || g}\`.`), $o(v === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function ky(e, t) {
  return xC(e).join("").toUpperCase().includes(t);
}
const hZ = (e, t, n, r, a) => V(() => {
  const o = n.value, i = a == null ? void 0 : a.value, s = r == null ? void 0 : r.value;
  if (!o || s === !1)
    return e.value;
  const {
    options: l,
    label: u,
    value: c
  } = t.value, f = [], d = typeof s == "function", p = o.toUpperCase(), v = d ? s : (m, y) => i ? ky(y[i], p) : y[l] ? ky(y[u !== "children" ? u : "label"], p) : ky(y[c], p), h = d ? (m) => Wb(m) : (m) => m;
  return e.value.forEach((m) => {
    if (m[l]) {
      if (v(o, h(m)))
        f.push(m);
      else {
        const x = m[l].filter((g) => v(o, h(g)));
        x.length && f.push(D(D({}, m), {
          [l]: x
        }));
      }
      return;
    }
    v(o, h(m)) && f.push(m);
  }), f;
}), vZ = (e, t) => {
  const n = Be({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  });
  return [V(() => {
    const {
      values: o,
      options: i
    } = n.value, s = e.value.map((c) => {
      var f;
      return c.label === void 0 ? D(D({}, c), {
        label: (f = o.get(c.value)) === null || f === void 0 ? void 0 : f.label
      }) : c;
    }), l = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map();
    return s.forEach((c) => {
      l.set(c.value, c), u.set(c.value, t.value.get(c.value) || i.get(c.value));
    }), n.value.values = l, n.value.options = u, s;
  }), (o) => t.value.get(o) || n.value.options.get(o)];
};
function ri(e, t) {
  const {
    defaultValue: n,
    value: r = ne()
  } = t || {};
  let a = typeof e == "function" ? e() : e;
  r.value !== void 0 && (a = U(r)), n !== void 0 && (a = typeof n == "function" ? n() : n);
  const o = ne(a), i = ne(a);
  _n(() => {
    let l = r.value !== void 0 ? r.value : o.value;
    t.postState && (l = t.postState(l)), i.value = l;
  });
  function s(l) {
    const u = i.value;
    o.value = l, At(i.value) !== l && t.onChange && t.onChange(l, u);
  }
  return He(r, () => {
    o.value = r.value;
  }), [i, s];
}
function Ai(e) {
  const t = typeof e == "function" ? e() : e, n = ne(t);
  function r(a) {
    n.value = a;
  }
  return [n, r];
}
const mZ = ["inputValue"];
function JP() {
  return D(D({}, YP()), {
    prefixCls: String,
    id: String,
    backfill: {
      type: Boolean,
      default: void 0
    },
    // >>> Field Names
    fieldNames: Object,
    // >>> Search
    /** @deprecated Use `searchValue` instead */
    inputValue: String,
    searchValue: String,
    onSearch: Function,
    autoClearSearchValue: {
      type: Boolean,
      default: void 0
    },
    // >>> Select
    onSelect: Function,
    onDeselect: Function,
    // >>> Options
    /**
     * In Select, `false` means do nothing.
     * In TreeSelect, `false` will highlight match item.
     * It's by design.
     */
    filterOption: {
      type: [Boolean, Function],
      default: void 0
    },
    filterSort: Function,
    optionFilterProp: String,
    optionLabelProp: String,
    options: Array,
    defaultActiveFirstOption: {
      type: Boolean,
      default: void 0
    },
    virtual: {
      type: Boolean,
      default: void 0
    },
    listHeight: Number,
    listItemHeight: Number,
    // >>> Icon
    menuItemSelectedIcon: Oe.any,
    mode: String,
    labelInValue: {
      type: Boolean,
      default: void 0
    },
    value: Oe.any,
    defaultValue: Oe.any,
    onChange: Function,
    children: Array
  });
}
function gZ(e) {
  return !e || typeof e != "object";
}
const yZ = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "VcSelect",
  inheritAttrs: !1,
  props: ha(JP(), {
    prefixCls: "vc-select",
    autoClearSearchValue: !0,
    listHeight: 200,
    listItemHeight: 20,
    dropdownMatchSelectWidth: !0
  }),
  setup(e, t) {
    let {
      expose: n,
      attrs: r,
      slots: a
    } = t;
    const o = fZ(Tt(e, "id")), i = V(() => gC(e.mode)), s = V(() => !!(!e.options && e.children)), l = V(() => e.filterOption === void 0 && e.mode === "combobox" ? !1 : e.filterOption), u = V(() => pP(e.fieldNames, s.value)), [c, f] = ri("", {
      value: V(() => e.searchValue !== void 0 ? e.searchValue : e.inputValue),
      postState: (te) => te || ""
    }), d = lZ(Tt(e, "options"), Tt(e, "children"), u), {
      valueOptions: p,
      labelOptions: v,
      options: h
    } = d, m = (te) => xC(te).map((oe) => {
      var L, re;
      let j, J, ae, he;
      gZ(oe) ? j = oe : (ae = oe.key, J = oe.label, j = (L = oe.value) !== null && L !== void 0 ? L : ae);
      const K = p.value.get(j);
      return K && (J === void 0 && (J = K == null ? void 0 : K[e.optionLabelProp || u.value.label]), ae === void 0 && (ae = (re = K == null ? void 0 : K.key) !== null && re !== void 0 ? re : j), he = K == null ? void 0 : K.disabled), {
        label: J,
        value: j,
        key: ae,
        disabled: he,
        option: K
      };
    }), [y, x] = ri(e.defaultValue, {
      value: Tt(e, "value")
    }), g = V(() => {
      var te;
      const G = m(y.value);
      return e.mode === "combobox" && !(!((te = G[0]) === null || te === void 0) && te.value) ? [] : G;
    }), [S, w] = vZ(g, p), _ = V(() => {
      if (!e.mode && S.value.length === 1) {
        const te = S.value[0];
        if (te.value === null && (te.label === null || te.label === void 0))
          return [];
      }
      return S.value.map((te) => {
        var G;
        return D(D({}, te), {
          label: (G = typeof te.label == "function" ? te.label() : te.label) !== null && G !== void 0 ? G : te.value
        });
      });
    }), b = V(() => new Set(S.value.map((te) => te.value)));
    _n(() => {
      var te;
      if (e.mode === "combobox") {
        const G = (te = S.value[0]) === null || te === void 0 ? void 0 : te.value;
        G != null && f(String(G));
      }
    }, {
      flush: "post"
    });
    const E = (te, G) => {
      const oe = G ?? te;
      return {
        [u.value.value]: te,
        [u.value.label]: oe
      };
    }, C = Be();
    _n(() => {
      if (e.mode !== "tags") {
        C.value = h.value;
        return;
      }
      const te = h.value.slice(), G = (oe) => p.value.has(oe);
      [...S.value].sort((oe, L) => oe.value < L.value ? -1 : 1).forEach((oe) => {
        const L = oe.value;
        G(L) || te.push(E(L, oe.label));
      }), C.value = te;
    });
    const T = hZ(C, u, c, l, Tt(e, "optionFilterProp")), O = V(() => e.mode !== "tags" || !c.value || T.value.some((te) => te[e.optionFilterProp || "value"] === c.value) ? T.value : [E(c.value), ...T.value]), I = V(() => e.filterSort ? [...O.value].sort((te, G) => e.filterSort(te, G)) : O.value), k = V(() => FG(I.value, {
      fieldNames: u.value,
      childrenAsData: s.value
    })), B = (te) => {
      const G = m(te);
      if (x(G), e.onChange && // Trigger event only when value changed
      (G.length !== S.value.length || G.some((oe, L) => {
        var re;
        return ((re = S.value[L]) === null || re === void 0 ? void 0 : re.value) !== (oe == null ? void 0 : oe.value);
      }))) {
        const oe = e.labelInValue ? G.map((re) => D(D({}, re), {
          originLabel: re.label,
          label: typeof re.label == "function" ? re.label() : re.label
        })) : G.map((re) => re.value), L = G.map((re) => Wb(w(re.value)));
        e.onChange(
          // Value
          i.value ? oe : oe[0],
          // Option
          i.value ? L : L[0]
        );
      }
    }, [P, N] = Ai(null), [M, H] = Ai(0), R = V(() => e.defaultActiveFirstOption !== void 0 ? e.defaultActiveFirstOption : e.mode !== "combobox"), z = function(te, G) {
      let {
        source: oe = "keyboard"
      } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      H(G), e.backfill && e.mode === "combobox" && te !== null && oe === "keyboard" && N(String(te));
    }, W = (te, G) => {
      const oe = () => {
        var L;
        const re = w(te), j = re == null ? void 0 : re[u.value.label];
        return [e.labelInValue ? {
          label: typeof j == "function" ? j() : j,
          originLabel: j,
          value: te,
          key: (L = re == null ? void 0 : re.key) !== null && L !== void 0 ? L : te
        } : te, Wb(re)];
      };
      if (G && e.onSelect) {
        const [L, re] = oe();
        e.onSelect(L, re);
      } else if (!G && e.onDeselect) {
        const [L, re] = oe();
        e.onDeselect(L, re);
      }
    }, F = (te, G) => {
      let oe;
      const L = i.value ? G.selected : !0;
      L ? oe = i.value ? [...S.value, te] : [te] : oe = S.value.filter((re) => re.value !== te), B(oe), W(te, L), e.mode === "combobox" ? N("") : (!i.value || e.autoClearSearchValue) && (f(""), N(""));
    }, Y = (te, G) => {
      B(te), (G.type === "remove" || G.type === "clear") && G.values.forEach((oe) => {
        W(oe.value, !1);
      });
    }, X = (te, G) => {
      var oe;
      if (f(te), N(null), G.source === "submit") {
        const L = (te || "").trim();
        if (L) {
          const re = Array.from(/* @__PURE__ */ new Set([...b.value, L]));
          B(re), W(L, !0), f("");
        }
        return;
      }
      G.source !== "blur" && (e.mode === "combobox" && B(te), (oe = e.onSearch) === null || oe === void 0 || oe.call(e, te));
    }, q = (te) => {
      let G = te;
      e.mode !== "tags" && (G = te.map((L) => {
        const re = v.value.get(L);
        return re == null ? void 0 : re.value;
      }).filter((L) => L !== void 0));
      const oe = Array.from(/* @__PURE__ */ new Set([...b.value, ...G]));
      B(oe), oe.forEach((L) => {
        W(L, !0);
      });
    }, Q = V(() => e.virtual !== !1 && e.dropdownMatchSelectWidth !== !1);
    nZ(KP(D(D({}, d), {
      flattenOptions: k,
      onActiveValue: z,
      defaultActiveFirstOption: R,
      onSelect: F,
      menuItemSelectedIcon: Tt(e, "menuItemSelectedIcon"),
      rawValues: b,
      fieldNames: u,
      virtual: Q,
      listHeight: Tt(e, "listHeight"),
      listItemHeight: Tt(e, "listItemHeight"),
      childrenAsData: s
    }))), process.env.NODE_ENV !== "production" && _n(() => {
      pZ(e);
    }, {
      flush: "post"
    });
    const ue = ne();
    n({
      focus() {
        var te;
        (te = ue.value) === null || te === void 0 || te.focus();
      },
      blur() {
        var te;
        (te = ue.value) === null || te === void 0 || te.blur();
      },
      scrollTo(te) {
        var G;
        (G = ue.value) === null || G === void 0 || G.scrollTo(te);
      }
    });
    const le = V(() => Lr(e, [
      "id",
      "mode",
      "prefixCls",
      "backfill",
      "fieldNames",
      // Search
      "inputValue",
      "searchValue",
      "onSearch",
      "autoClearSearchValue",
      // Select
      "onSelect",
      "onDeselect",
      "dropdownMatchSelectWidth",
      // Options
      "filterOption",
      "filterSort",
      "optionFilterProp",
      "optionLabelProp",
      "options",
      "children",
      "defaultActiveFirstOption",
      "menuItemSelectedIcon",
      "virtual",
      "listHeight",
      "listItemHeight",
      // Value
      "value",
      "defaultValue",
      "labelInValue",
      "onChange"
    ]));
    return () => A(jX, ve(ve(ve({}, le.value), r), {}, {
      id: o,
      prefixCls: e.prefixCls,
      ref: ue,
      omitDomProps: mZ,
      mode: e.mode,
      displayValues: _.value,
      onDisplayValuesChange: Y,
      searchValue: c.value,
      onSearch: X,
      onSearchSplit: q,
      dropdownMatchSelectWidth: e.dropdownMatchSelectWidth,
      OptionList: oZ,
      emptyOptions: !k.value.length,
      activeValue: P.value,
      activeDescendantId: `${o}_list_${M.value}`
    }), a);
  }
}), bC = () => null;
bC.isSelectOption = !0;
bC.displayName = "ASelectOption";
const wC = () => null;
wC.isSelectOptGroup = !0;
wC.displayName = "ASelectOptGroup";
var xZ = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" }, bZ = Symbol("iconContext"), eD = function() {
  return Ke(bZ, {
    prefixCls: ne("anticon"),
    rootClassName: ne(""),
    csp: ne()
  });
};
function SC() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function wZ(e, t) {
  return e && e.contains ? e.contains(t) : !1;
}
var u$ = "data-vc-order", SZ = "vc-icon-key", t2 = /* @__PURE__ */ new Map();
function tD() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : SZ;
}
function _C(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function _Z(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function nD(e) {
  return Array.from((t2.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function rD(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!SC())
    return null;
  var n = t.csp, r = t.prepend, a = document.createElement("style");
  a.setAttribute(u$, _Z(r)), n && n.nonce && (a.nonce = n.nonce), a.innerHTML = e;
  var o = _C(t), i = o.firstChild;
  if (r) {
    if (r === "queue") {
      var s = nD(o).filter(function(l) {
        return ["prepend", "prependQueue"].includes(l.getAttribute(u$));
      });
      if (s.length)
        return o.insertBefore(a, s[s.length - 1].nextSibling), a;
    }
    o.insertBefore(a, i);
  } else
    o.appendChild(a);
  return a;
}
function CZ(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = _C(t);
  return nD(n).find(function(r) {
    return r.getAttribute(tD(t)) === e;
  });
}
function EZ(e, t) {
  var n = t2.get(e);
  if (!n || !wZ(document, n)) {
    var r = rD("", t), a = r.parentNode;
    t2.set(e, a), e.removeChild(r);
  }
}
function TZ(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = _C(n);
  EZ(r, n);
  var a = CZ(t, n);
  if (a)
    return n.csp && n.csp.nonce && a.nonce !== n.csp.nonce && (a.nonce = n.csp.nonce), a.innerHTML !== e && (a.innerHTML = e), a;
  var o = rD(e, n);
  return o.setAttribute(tD(n), t), o;
}
function c$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      $Z(e, a, n[a]);
    });
  }
  return e;
}
function $Z(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function OZ(e, t) {
  process.env.NODE_ENV !== "production" && !e && console !== void 0 && console.error("Warning: ".concat(t));
}
function AZ(e, t) {
  OZ(e, "[@ant-design/icons-vue] ".concat(t));
}
function f$(e) {
  return typeof e == "object" && typeof e.name == "string" && typeof e.theme == "string" && (typeof e.icon == "object" || typeof e.icon == "function");
}
function n2(e, t, n) {
  return n ? Z0(e.tag, c$({
    key: t
  }, n, e.attrs), (e.children || []).map(function(r, a) {
    return n2(r, "".concat(t, "-").concat(e.tag, "-").concat(a));
  })) : Z0(e.tag, c$({
    key: t
  }, e.attrs), (e.children || []).map(function(r, a) {
    return n2(r, "".concat(t, "-").concat(e.tag, "-").concat(a));
  }));
}
function aD(e) {
  return fc(e)[0];
}
function oD(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var IZ = `
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
function iD(e) {
  return e && e.getRootNode && e.getRootNode();
}
function PZ(e) {
  return SC() ? iD(e) instanceof ShadowRoot : !1;
}
function DZ(e) {
  return PZ(e) ? iD(e) : null;
}
var kZ = function() {
  var t = eD(), n = t.prefixCls, r = t.csp, a = jn(), o = IZ;
  n && (o = o.replace(/anticon/g, n.value)), nn(function() {
    if (SC()) {
      var i = a.vnode.el, s = DZ(i);
      TZ(o, "@ant-design-vue-icons", {
        prepend: !0,
        csp: r.value,
        attachTo: s
      });
    }
  });
}, MZ = ["icon", "primaryColor", "secondaryColor"];
function RZ(e, t) {
  if (e == null) return {};
  var n = NZ(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      r = o[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function NZ(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Nv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      FZ(e, a, n[a]);
    });
  }
  return e;
}
function FZ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var w0 = Wn({
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
});
function LZ(e) {
  var t = e.primaryColor, n = e.secondaryColor;
  w0.primaryColor = t, w0.secondaryColor = n || aD(t), w0.calculated = !!n;
}
function BZ() {
  return Nv({}, w0);
}
var uu = function(t, n) {
  var r = Nv({}, t, n.attrs), a = r.icon, o = r.primaryColor, i = r.secondaryColor, s = RZ(r, MZ), l = w0;
  if (o && (l = {
    primaryColor: o,
    secondaryColor: i || aD(o)
  }), AZ(f$(a), "icon should be icon definiton, but got ".concat(a)), !f$(a))
    return null;
  var u = a;
  return u && typeof u.icon == "function" && (u = Nv({}, u, {
    icon: u.icon(l.primaryColor, l.secondaryColor)
  })), n2(u.icon, "svg-".concat(u.name), Nv({}, s, {
    "data-icon": u.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }));
};
uu.props = {
  icon: Object,
  primaryColor: String,
  secondaryColor: String,
  focusable: String
};
uu.inheritAttrs = !1;
uu.displayName = "IconBase";
uu.getTwoToneColors = BZ;
uu.setTwoToneColors = LZ;
function HZ(e, t) {
  return zZ(e) || UZ(e, t) || VZ(e, t) || jZ();
}
function jZ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function VZ(e, t) {
  if (e) {
    if (typeof e == "string") return d$(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return d$(e, t);
  }
}
function d$(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function UZ(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, o = !1, i, s;
    try {
      for (n = n.call(e); !(a = (i = n.next()).done) && (r.push(i.value), !(t && r.length === t)); a = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return r;
  }
}
function zZ(e) {
  if (Array.isArray(e)) return e;
}
function sD(e) {
  var t = oD(e), n = HZ(t, 2), r = n[0], a = n[1];
  return uu.setTwoToneColors({
    primaryColor: r,
    secondaryColor: a
  });
}
function WZ() {
  var e = uu.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var GZ = /* @__PURE__ */ Me({
  name: "InsertStyles",
  setup: function() {
    return kZ(), function() {
      return null;
    };
  }
}), KZ = ["class", "icon", "spin", "rotate", "tabindex", "twoToneColor", "onClick"];
function YZ(e, t) {
  return QZ(e) || ZZ(e, t) || XZ(e, t) || qZ();
}
function qZ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function XZ(e, t) {
  if (e) {
    if (typeof e == "string") return p$(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return p$(e, t);
  }
}
function p$(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function ZZ(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, o = !1, i, s;
    try {
      for (n = n.call(e); !(a = (i = n.next()).done) && (r.push(i.value), !(t && r.length === t)); a = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return r;
  }
}
function QZ(e) {
  if (Array.isArray(e)) return e;
}
function h$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      e0(e, a, n[a]);
    });
  }
  return e;
}
function e0(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function JZ(e, t) {
  if (e == null) return {};
  var n = eQ(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      r = o[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function eQ(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
sD(UW.primary);
var Bn = function(t, n) {
  var r, a = h$({}, t, n.attrs), o = a.class, i = a.icon, s = a.spin, l = a.rotate, u = a.tabindex, c = a.twoToneColor, f = a.onClick, d = JZ(a, KZ), p = eD(), v = p.prefixCls, h = p.rootClassName, m = (r = {}, e0(r, h.value, !!h.value), e0(r, v.value, !0), e0(r, "".concat(v.value, "-").concat(i.name), !!i.name), e0(r, "".concat(v.value, "-spin"), !!s || i.name === "loading"), r), y = u;
  y === void 0 && f && (y = -1);
  var x = l ? {
    msTransform: "rotate(".concat(l, "deg)"),
    transform: "rotate(".concat(l, "deg)")
  } : void 0, g = oD(c), S = YZ(g, 2), w = S[0], _ = S[1];
  return A("span", h$({
    role: "img",
    "aria-label": i.name
  }, d, {
    onClick: f,
    class: [m, o],
    tabindex: y
  }), [A(uu, {
    icon: i,
    primaryColor: w,
    secondaryColor: _,
    style: x
  }, null), A(GZ, null, null)]);
};
Bn.props = {
  spin: Boolean,
  rotate: Number,
  icon: Object,
  twoToneColor: [String, Array]
};
Bn.displayName = "AntdIcon";
Bn.inheritAttrs = !1;
Bn.getTwoToneColor = WZ;
Bn.setTwoToneColor = sD;
function v$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      tQ(e, a, n[a]);
    });
  }
  return e;
}
function tQ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var CC = function(t, n) {
  var r = v$({}, t, n.attrs);
  return A(Bn, v$({}, r, {
    icon: xZ
  }), null);
};
CC.displayName = "DownOutlined";
CC.inheritAttrs = !1;
var nQ = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" };
function m$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      rQ(e, a, n[a]);
    });
  }
  return e;
}
function rQ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var el = function(t, n) {
  var r = m$({}, t, n.attrs);
  return A(Bn, m$({}, r, {
    icon: nQ
  }), null);
};
el.displayName = "LoadingOutlined";
el.inheritAttrs = !1;
var aQ = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" };
function g$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      oQ(e, a, n[a]);
    });
  }
  return e;
}
function oQ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var EC = function(t, n) {
  var r = g$({}, t, n.attrs);
  return A(Bn, g$({}, r, {
    icon: aQ
  }), null);
};
EC.displayName = "CheckOutlined";
EC.inheritAttrs = !1;
var iQ = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
function y$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      sQ(e, a, n[a]);
    });
  }
  return e;
}
function sQ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var cu = function(t, n) {
  var r = y$({}, t, n.attrs);
  return A(Bn, y$({}, r, {
    icon: iQ
  }), null);
};
cu.displayName = "CloseOutlined";
cu.inheritAttrs = !1;
var lQ = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" };
function x$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      uQ(e, a, n[a]);
    });
  }
  return e;
}
function uQ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Vo = function(t, n) {
  var r = x$({}, t, n.attrs);
  return A(Bn, x$({}, r, {
    icon: lQ
  }), null);
};
Vo.displayName = "CloseCircleFilled";
Vo.inheritAttrs = !1;
var cQ = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, name: "search", theme: "outlined" };
function b$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      fQ(e, a, n[a]);
    });
  }
  return e;
}
function fQ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var l1 = function(t, n) {
  var r = b$({}, t, n.attrs);
  return A(Bn, b$({}, r, {
    icon: cQ
  }), null);
};
l1.displayName = "SearchOutlined";
l1.inheritAttrs = !1;
function dQ(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    loading: n,
    multiple: r,
    prefixCls: a,
    hasFeedback: o,
    feedbackIcon: i,
    showArrow: s
  } = e, l = e.suffixIcon || t.suffixIcon && t.suffixIcon(), u = e.clearIcon || t.clearIcon && t.clearIcon(), c = e.menuItemSelectedIcon || t.menuItemSelectedIcon && t.menuItemSelectedIcon(), f = e.removeIcon || t.removeIcon && t.removeIcon(), d = u ?? A(Vo, null, null), p = (y) => A(dt, null, [s !== !1 && y, o && i]);
  let v = null;
  if (l !== void 0)
    v = p(l);
  else if (n)
    v = p(A(el, {
      spin: !0
    }, null));
  else {
    const y = `${a}-suffix`;
    v = (x) => {
      let {
        open: g,
        showSearch: S
      } = x;
      return p(g && S ? A(l1, {
        class: y
      }, null) : A(CC, {
        class: y
      }, null));
    };
  }
  let h = null;
  c !== void 0 ? h = c : r ? h = A(EC, null, null) : h = null;
  let m = null;
  return f !== void 0 ? m = f : m = A(cu, null, null), {
    clearIcon: d,
    suffixIcon: v,
    itemIcon: h,
    removeIcon: m
  };
}
function TC(e) {
  const t = Symbol("contextKey");
  return {
    useProvide: (a, o) => {
      const i = Wn({});
      return kt(t, i), _n(() => {
        D(i, a, o || {});
      }), i;
    },
    useInject: () => Ke(t, e) || {}
  };
}
const Tm = Symbol("ContextProps"), $m = Symbol("InternalContextProps"), pQ = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : V(() => !0);
  const n = ne(/* @__PURE__ */ new Map()), r = (i, s) => {
    n.value.set(i, s), n.value = new Map(n.value);
  }, a = (i) => {
    n.value.delete(i), n.value = new Map(n.value);
  }, o = jn();
  He([t, n], () => {
    if (process.env.NODE_ENV !== "production" && t.value && n.value.size > 1) {
      Aa(!1, "Form.Item", `FormItem can only collect one field item, you haved set ${[...n.value.values()].map((s) => `\`${s.name}\``).join(", ")} ${n.value.size} field items.
        You can set not need to be collected fields into \`a-form-item-rest\``);
      let i = o;
      for (; i.parent; )
        console.warn("at", i.type), i = i.parent;
    }
  }), kt(Tm, e), kt($m, {
    addFormItemField: r,
    removeFormItemField: a
  });
}, r2 = {
  id: V(() => {
  }),
  onFieldBlur: () => {
  },
  onFieldChange: () => {
  },
  clearValidate: () => {
  }
}, a2 = {
  addFormItemField: () => {
  },
  removeFormItemField: () => {
  }
}, fu = () => {
  const e = Ke($m, a2), t = Symbol("FormItemFieldKey"), n = jn();
  return e.addFormItemField(t, n.type), Sn(() => {
    e.removeFormItemField(t);
  }), kt($m, a2), kt(Tm, r2), Ke(Tm, r2);
}, o2 = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AFormItemRest",
  setup(e, t) {
    let {
      slots: n
    } = t;
    return kt($m, a2), kt(Tm, r2), () => {
      var r;
      return (r = n.default) === null || r === void 0 ? void 0 : r.call(n);
    };
  }
}), Wi = TC({}), w$ = /* @__PURE__ */ Me({
  name: "NoFormStatus",
  setup(e, t) {
    let {
      slots: n
    } = t;
    return Wi.useProvide({}), () => {
      var r;
      return (r = n.default) === null || r === void 0 ? void 0 : r.call(n);
    };
  }
});
function zl(e, t, n) {
  return Ge({
    [`${e}-status-success`]: t === "success",
    [`${e}-status-warning`]: t === "warning",
    [`${e}-status-error`]: t === "error",
    [`${e}-status-validating`]: t === "validating",
    [`${e}-has-feedback`]: n
  });
}
const wd = (e, t) => t || e, hQ = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      "&-block": {
        display: "flex",
        width: "100%"
      },
      "&-vertical": {
        flexDirection: "column"
      }
    }
  };
}, vQ = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      "&-rtl": {
        direction: "rtl"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-align": {
        flexDirection: "column",
        "&-center": {
          alignItems: "center"
        },
        "&-start": {
          alignItems: "flex-start"
        },
        "&-end": {
          alignItems: "flex-end"
        },
        "&-baseline": {
          alignItems: "baseline"
        }
      },
      [`${t}-space-item`]: {
        "&:empty": {
          display: "none"
        }
      }
    }
  };
}, mQ = xr("Space", (e) => [vQ(e), hQ(e)]);
var gQ = "[object Symbol]";
function u1(e) {
  return typeof e == "symbol" || ys(e) && Oc(e) == gQ;
}
function c1(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = Array(r); ++n < r; )
    a[n] = t(e[n], n, e);
  return a;
}
var yQ = 1 / 0, S$ = ci ? ci.prototype : void 0, _$ = S$ ? S$.toString : void 0;
function lD(e) {
  if (typeof e == "string")
    return e;
  if (fi(e))
    return c1(e, lD) + "";
  if (u1(e))
    return _$ ? _$.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -yQ ? "-0" : t;
}
var xQ = /\s/;
function bQ(e) {
  for (var t = e.length; t-- && xQ.test(e.charAt(t)); )
    ;
  return t;
}
var wQ = /^\s+/;
function SQ(e) {
  return e && e.slice(0, bQ(e) + 1).replace(wQ, "");
}
var C$ = NaN, _Q = /^[-+]0x[0-9a-f]+$/i, CQ = /^0b[01]+$/i, EQ = /^0o[0-7]+$/i, TQ = parseInt;
function i2(e) {
  if (typeof e == "number")
    return e;
  if (u1(e))
    return C$;
  if (Js(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Js(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = SQ(e);
  var n = CQ.test(e);
  return n || EQ.test(e) ? TQ(e.slice(2), n ? 2 : 8) : _Q.test(e) ? C$ : +e;
}
var E$ = 1 / 0, $Q = 17976931348623157e292;
function OQ(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = i2(e), e === E$ || e === -E$) {
    var t = e < 0 ? -1 : 1;
    return t * $Q;
  }
  return e === e ? e : 0;
}
function AQ(e) {
  var t = OQ(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
function $C(e) {
  return e;
}
var T$ = Object.create, IQ = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Js(t))
      return {};
    if (T$)
      return T$(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function PQ(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
function DQ() {
}
function kQ(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var MQ = 800, RQ = 16, NQ = Date.now;
function FQ(e) {
  var t = 0, n = 0;
  return function() {
    var r = NQ(), a = RQ - (r - n);
    if (n = r, a > 0) {
      if (++t >= MQ)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function LQ(e) {
  return function() {
    return e;
  };
}
var Om = function() {
  try {
    var e = Ic(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), BQ = Om ? function(e, t) {
  return Om(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: LQ(t),
    writable: !0
  });
} : $C, uD = FQ(BQ);
function HQ(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
function cD(e, t, n, r) {
  for (var a = e.length, o = n + -1; ++o < a; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
function jQ(e) {
  return e !== e;
}
function VQ(e, t, n) {
  for (var r = n - 1, a = e.length; ++r < a; )
    if (e[r] === t)
      return r;
  return -1;
}
function UQ(e, t, n) {
  return t === t ? VQ(e, t, n) : cD(e, jQ, n);
}
function fD(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && UQ(e, t, 0) > -1;
}
function dD(e, t, n) {
  t == "__proto__" && Om ? Om(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var zQ = Object.prototype, WQ = zQ.hasOwnProperty;
function pD(e, t, n) {
  var r = e[t];
  (!(WQ.call(e, t) && iC(r, n)) || n === void 0 && !(t in e)) && dD(e, t, n);
}
function Up(e, t, n, r) {
  var a = !n;
  n || (n = {});
  for (var o = -1, i = t.length; ++o < i; ) {
    var s = t[o], l = void 0;
    l === void 0 && (l = e[s]), a ? dD(n, s, l) : pD(n, s, l);
  }
  return n;
}
var $$ = Math.max;
function hD(e, t, n) {
  return t = $$(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, a = -1, o = $$(r.length - t, 0), i = Array(o); ++a < o; )
      i[a] = r[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = r[a];
    return s[t] = n(i), PQ(e, this, s);
  };
}
function GQ(e, t) {
  return uD(hD(e, t, $C), e + "");
}
function KQ(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var YQ = Object.prototype, qQ = YQ.hasOwnProperty;
function XQ(e) {
  if (!Js(e))
    return KQ(e);
  var t = a1(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !qQ.call(e, r)) || n.push(r);
  return n;
}
function OC(e) {
  return Lp(e) ? MP(e, !0) : XQ(e);
}
var ZQ = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, QQ = /^\w*$/;
function AC(e, t) {
  if (fi(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || u1(e) ? !0 : QQ.test(e) || !ZQ.test(e) || t != null && e in Object(t);
}
var JQ = "Expected a function";
function IC(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(JQ);
  var n = function() {
    var r = arguments, a = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(a))
      return o.get(a);
    var i = e.apply(this, r);
    return n.cache = o.set(a, i) || o, i;
  };
  return n.cache = new (IC.Cache || il)(), n;
}
IC.Cache = il;
var eJ = 500;
function tJ(e) {
  var t = IC(e, function(r) {
    return n.size === eJ && n.clear(), r;
  }), n = t.cache;
  return t;
}
var nJ = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, rJ = /\\(\\)?/g, aJ = tJ(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(nJ, function(n, r, a, o) {
    t.push(a ? o.replace(rJ, "$1") : r || n);
  }), t;
});
function oJ(e) {
  return e == null ? "" : lD(e);
}
function f1(e, t) {
  return fi(e) ? e : AC(e, t) ? [e] : aJ(oJ(e));
}
var iJ = 1 / 0;
function zp(e) {
  if (typeof e == "string" || u1(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -iJ ? "-0" : t;
}
function PC(e, t) {
  t = f1(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[zp(t[n++])];
  return n && n == r ? e : void 0;
}
function sJ(e, t, n) {
  var r = e == null ? void 0 : PC(e, t);
  return r === void 0 ? n : r;
}
var O$ = ci ? ci.isConcatSpreadable : void 0;
function lJ(e) {
  return fi(e) || n1(e) || !!(O$ && e && e[O$]);
}
function uJ(e, t, n, r, a) {
  var o = -1, i = e.length;
  for (n || (n = lJ), a || (a = []); ++o < i; ) {
    var s = e[o];
    n(s) ? lC(a, s) : a[a.length] = s;
  }
  return a;
}
function cJ(e) {
  var t = e == null ? 0 : e.length;
  return t ? uJ(e) : [];
}
function fJ(e) {
  return uD(hD(e, void 0, cJ), e + "");
}
var DC = RP(Object.getPrototypeOf, Object), dJ = "[object Object]", pJ = Function.prototype, hJ = Object.prototype, vD = pJ.toString, vJ = hJ.hasOwnProperty, mJ = vD.call(Object);
function mD(e) {
  if (!ys(e) || Oc(e) != dJ)
    return !1;
  var t = DC(e);
  if (t === null)
    return !0;
  var n = vJ.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && vD.call(n) == mJ;
}
function gJ(e, t, n) {
  var r = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), n = n > a ? a : n, n < 0 && (n += a), a = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var o = Array(a); ++r < a; )
    o[r] = e[r + t];
  return o;
}
function yJ(e, t) {
  return e && Up(t, Bp(t), e);
}
function xJ(e, t) {
  return e && Up(t, OC(t), e);
}
var gD = typeof exports == "object" && exports && !exports.nodeType && exports, A$ = gD && typeof module == "object" && module && !module.nodeType && module, bJ = A$ && A$.exports === gD, I$ = bJ ? Yi.Buffer : void 0, P$ = I$ ? I$.allocUnsafe : void 0;
function wJ(e, t) {
  if (t)
    return e.slice();
  var n = e.length, r = P$ ? P$(n) : new e.constructor(n);
  return e.copy(r), r;
}
function SJ(e, t) {
  return Up(e, uC(e), t);
}
var _J = Object.getOwnPropertySymbols, yD = _J ? function(e) {
  for (var t = []; e; )
    lC(t, uC(e)), e = DC(e);
  return t;
} : AP;
function CJ(e, t) {
  return Up(e, yD(e), t);
}
function xD(e) {
  return OP(e, OC, yD);
}
var EJ = Object.prototype, TJ = EJ.hasOwnProperty;
function $J(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && TJ.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
function kC(e) {
  var t = new e.constructor(e.byteLength);
  return new Em(t).set(new Em(e)), t;
}
function OJ(e, t) {
  var n = t ? kC(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var AJ = /\w*$/;
function IJ(e) {
  var t = new e.constructor(e.source, AJ.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var D$ = ci ? ci.prototype : void 0, k$ = D$ ? D$.valueOf : void 0;
function PJ(e) {
  return k$ ? Object(k$.call(e)) : {};
}
function DJ(e, t) {
  var n = t ? kC(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var kJ = "[object Boolean]", MJ = "[object Date]", RJ = "[object Map]", NJ = "[object Number]", FJ = "[object RegExp]", LJ = "[object Set]", BJ = "[object String]", HJ = "[object Symbol]", jJ = "[object ArrayBuffer]", VJ = "[object DataView]", UJ = "[object Float32Array]", zJ = "[object Float64Array]", WJ = "[object Int8Array]", GJ = "[object Int16Array]", KJ = "[object Int32Array]", YJ = "[object Uint8Array]", qJ = "[object Uint8ClampedArray]", XJ = "[object Uint16Array]", ZJ = "[object Uint32Array]";
function QJ(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case jJ:
      return kC(e);
    case kJ:
    case MJ:
      return new r(+e);
    case VJ:
      return OJ(e, n);
    case UJ:
    case zJ:
    case WJ:
    case GJ:
    case KJ:
    case YJ:
    case qJ:
    case XJ:
    case ZJ:
      return DJ(e, n);
    case RJ:
      return new r();
    case NJ:
    case BJ:
      return new r(e);
    case FJ:
      return IJ(e);
    case LJ:
      return new r();
    case HJ:
      return PJ(e);
  }
}
function JJ(e) {
  return typeof e.constructor == "function" && !a1(e) ? IQ(DC(e)) : {};
}
var eee = "[object Map]";
function tee(e) {
  return ys(e) && ni(e) == eee;
}
var M$ = Yf && Yf.isMap, nee = M$ ? r1(M$) : tee, ree = "[object Set]";
function aee(e) {
  return ys(e) && ni(e) == ree;
}
var R$ = Yf && Yf.isSet, oee = R$ ? r1(R$) : aee, iee = 1, see = 2, lee = 4, bD = "[object Arguments]", uee = "[object Array]", cee = "[object Boolean]", fee = "[object Date]", dee = "[object Error]", wD = "[object Function]", pee = "[object GeneratorFunction]", hee = "[object Map]", vee = "[object Number]", SD = "[object Object]", mee = "[object RegExp]", gee = "[object Set]", yee = "[object String]", xee = "[object Symbol]", bee = "[object WeakMap]", wee = "[object ArrayBuffer]", See = "[object DataView]", _ee = "[object Float32Array]", Cee = "[object Float64Array]", Eee = "[object Int8Array]", Tee = "[object Int16Array]", $ee = "[object Int32Array]", Oee = "[object Uint8Array]", Aee = "[object Uint8ClampedArray]", Iee = "[object Uint16Array]", Pee = "[object Uint32Array]", zn = {};
zn[bD] = zn[uee] = zn[wee] = zn[See] = zn[cee] = zn[fee] = zn[_ee] = zn[Cee] = zn[Eee] = zn[Tee] = zn[$ee] = zn[hee] = zn[vee] = zn[SD] = zn[mee] = zn[gee] = zn[yee] = zn[xee] = zn[Oee] = zn[Aee] = zn[Iee] = zn[Pee] = !0;
zn[dee] = zn[wD] = zn[bee] = !1;
function S0(e, t, n, r, a, o) {
  var i, s = t & iee, l = t & see, u = t & lee;
  if (n && (i = a ? n(e, r, a, o) : n(e)), i !== void 0)
    return i;
  if (!Js(e))
    return e;
  var c = fi(e);
  if (c) {
    if (i = $J(e), !s)
      return kQ(e, i);
  } else {
    var f = ni(e), d = f == wD || f == pee;
    if (dp(e))
      return wJ(e, s);
    if (f == SD || f == bD || d && !a) {
      if (i = l || d ? {} : JJ(e), !s)
        return l ? CJ(e, xJ(i, e)) : SJ(e, yJ(i, e));
    } else {
      if (!zn[f])
        return a ? e : {};
      i = QJ(e, f, s);
    }
  }
  o || (o = new us());
  var p = o.get(e);
  if (p)
    return p;
  o.set(e, i), oee(e) ? e.forEach(function(m) {
    i.add(S0(m, t, n, m, e, o));
  }) : nee(e) && e.forEach(function(m, y) {
    i.set(y, S0(m, t, n, y, e, o));
  });
  var v = u ? l ? xD : Xb : l ? OC : Bp, h = c ? void 0 : v(e);
  return HQ(h || e, function(m, y) {
    h && (y = m, m = e[y]), pD(i, y, S0(m, t, n, y, e, o));
  }), i;
}
var Dee = 1, kee = 4;
function Fv(e) {
  return S0(e, Dee | kee);
}
var Mee = 1, Ree = 2;
function Nee(e, t, n, r) {
  var a = n.length, o = a;
  if (e == null)
    return !o;
  for (e = Object(e); a--; ) {
    var i = n[a];
    if (i[2] ? i[1] !== e[i[0]] : !(i[0] in e))
      return !1;
  }
  for (; ++a < o; ) {
    i = n[a];
    var s = i[0], l = e[s], u = i[1];
    if (i[2]) {
      if (l === void 0 && !(s in e))
        return !1;
    } else {
      var c = new us(), f;
      if (!(f === void 0 ? o1(u, l, Mee | Ree, r, c) : f))
        return !1;
    }
  }
  return !0;
}
function _D(e) {
  return e === e && !Js(e);
}
function Fee(e) {
  for (var t = Bp(e), n = t.length; n--; ) {
    var r = t[n], a = e[r];
    t[n] = [r, a, _D(a)];
  }
  return t;
}
function CD(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function Lee(e) {
  var t = Fee(e);
  return t.length == 1 && t[0][2] ? CD(t[0][0], t[0][1]) : function(n) {
    return n === e || Nee(n, e, t);
  };
}
function Bee(e, t) {
  return e != null && t in Object(e);
}
function Hee(e, t, n) {
  t = f1(t, e);
  for (var r = -1, a = t.length, o = !1; ++r < a; ) {
    var i = zp(t[r]);
    if (!(o = e != null && n(e, i)))
      break;
    e = e[i];
  }
  return o || ++r != a ? o : (a = e == null ? 0 : e.length, !!a && cC(a) && DP(i, a) && (fi(e) || n1(e)));
}
function jee(e, t) {
  return e != null && Hee(e, t, Bee);
}
var Vee = 1, Uee = 2;
function zee(e, t) {
  return AC(e) && _D(t) ? CD(zp(e), t) : function(n) {
    var r = sJ(n, e);
    return r === void 0 && r === t ? jee(n, e) : o1(t, r, Vee | Uee);
  };
}
function Wee(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function Gee(e) {
  return function(t) {
    return PC(t, e);
  };
}
function Kee(e) {
  return AC(e) ? Wee(zp(e)) : Gee(e);
}
function ED(e) {
  return typeof e == "function" ? e : e == null ? $C : typeof e == "object" ? fi(e) ? zee(e[0], e[1]) : Lee(e) : Kee(e);
}
var My = function() {
  return Yi.Date.now();
}, Yee = "Expected a function", qee = Math.max, Xee = Math.min;
function Zee(e, t, n) {
  var r, a, o, i, s, l, u = 0, c = !1, f = !1, d = !0;
  if (typeof e != "function")
    throw new TypeError(Yee);
  t = i2(t) || 0, Js(n) && (c = !!n.leading, f = "maxWait" in n, o = f ? qee(i2(n.maxWait) || 0, t) : o, d = "trailing" in n ? !!n.trailing : d);
  function p(_) {
    var b = r, E = a;
    return r = a = void 0, u = _, i = e.apply(E, b), i;
  }
  function v(_) {
    return u = _, s = setTimeout(y, t), c ? p(_) : i;
  }
  function h(_) {
    var b = _ - l, E = _ - u, C = t - b;
    return f ? Xee(C, o - E) : C;
  }
  function m(_) {
    var b = _ - l, E = _ - u;
    return l === void 0 || b >= t || b < 0 || f && E >= o;
  }
  function y() {
    var _ = My();
    if (m(_))
      return x(_);
    s = setTimeout(y, h(_));
  }
  function x(_) {
    return s = void 0, d && r ? p(_) : (r = a = void 0, i);
  }
  function g() {
    s !== void 0 && clearTimeout(s), u = 0, r = l = a = s = void 0;
  }
  function S() {
    return s === void 0 ? i : x(My());
  }
  function w() {
    var _ = My(), b = m(_);
    if (r = arguments, a = this, l = _, b) {
      if (s === void 0)
        return v(l);
      if (f)
        return clearTimeout(s), s = setTimeout(y, t), p(l);
    }
    return s === void 0 && (s = setTimeout(y, t)), i;
  }
  return w.cancel = g, w.flush = S, w;
}
function Qee(e) {
  return ys(e) && Lp(e);
}
function Jee(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function ete(e) {
  return function(t, n, r) {
    var a = Object(t);
    if (!Lp(t)) {
      var o = ED(n);
      t = Bp(t), n = function(s) {
        return o(a[s], s, a);
      };
    }
    var i = e(t, n, r);
    return i > -1 ? a[o ? t[i] : i] : void 0;
  };
}
var tte = Math.max;
function nte(e, t, n) {
  var r = e == null ? 0 : e.length;
  if (!r)
    return -1;
  var a = n == null ? 0 : AQ(n);
  return a < 0 && (a = tte(r + a, 0)), cD(e, ED(t), a);
}
var rte = ete(nte), ate = Math.min;
function ote(e, t, n) {
  for (var r = fD, a = e[0].length, o = e.length, i = o, s = Array(o), l = 1 / 0, u = []; i--; ) {
    var c = e[i];
    i && t && (c = c1(c, r1(t))), l = ate(c.length, l), s[i] = a >= 120 && c.length >= 120 ? new Kf(i && c) : void 0;
  }
  c = e[0];
  var f = -1, d = s[0];
  e:
    for (; ++f < a && u.length < l; ) {
      var p = c[f], v = p;
      if (p = p !== 0 ? p : 0, !(d ? Cm(d, v) : r(u, v))) {
        for (i = o; --i; ) {
          var h = s[i];
          if (!(h ? Cm(h, v) : r(e[i], v)))
            continue e;
        }
        d && d.push(v), u.push(p);
      }
    }
  return u;
}
function ite(e) {
  return Qee(e) ? e : [];
}
var ste = GQ(function(e) {
  var t = c1(e, ite);
  return t.length && t[0] === e[0] ? ote(t) : [];
});
function lte(e, t) {
  return t.length < 2 ? e : PC(e, gJ(t, 0, -1));
}
var ute = "[object Map]", cte = "[object Set]", fte = Object.prototype, dte = fte.hasOwnProperty;
function TD(e) {
  if (e == null)
    return !0;
  if (Lp(e) && (fi(e) || typeof e == "string" || typeof e.splice == "function" || dp(e) || fC(e) || n1(e)))
    return !e.length;
  var t = ni(e);
  if (t == ute || t == cte)
    return !e.size;
  if (a1(e))
    return !NP(e).length;
  for (var n in e)
    if (dte.call(e, n))
      return !1;
  return !0;
}
function pte(e, t) {
  return t = f1(t, e), e = lte(e, t), e == null || delete e[zp(Jee(t))];
}
function hte(e) {
  return mD(e) ? void 0 : e;
}
var vte = 1, mte = 2, gte = 4, yte = fJ(function(e, t) {
  var n = {};
  if (e == null)
    return n;
  var r = !1;
  t = c1(t, function(o) {
    return o = f1(o, e), r || (r = o.length > 1), o;
  }), Up(e, xD(e), n), r && (n = S0(n, vte | mte | gte, hte));
  for (var a = t.length; a--; )
    pte(n, t[a]);
  return n;
}), xte = 1 / 0, bte = Tf && 1 / sC(new Tf([, -0]))[1] == xte ? function(e) {
  return new Tf(e);
} : DQ, wte = 200;
function Ste(e, t, n) {
  var r = -1, a = fD, o = e.length, i = !0, s = [], l = s;
  if (o >= wte) {
    var u = bte(e);
    if (u)
      return sC(u);
    i = !1, a = Cm, l = new Kf();
  } else
    l = s;
  e:
    for (; ++r < o; ) {
      var c = e[r], f = c;
      if (c = c !== 0 ? c : 0, i && f === f) {
        for (var d = l.length; d--; )
          if (l[d] === f)
            continue e;
        s.push(c);
      } else a(l, f, n) || (l !== s && l.push(f), s.push(c));
    }
  return s;
}
function Ry(e) {
  return e && e.length ? Ste(e) : [];
}
const _te = () => ({
  compactSize: String,
  compactDirection: Oe.oneOf(eu("horizontal", "vertical")).def("horizontal"),
  isFirstItem: qt(),
  isLastItem: qt()
}), d1 = TC(null), Wp = (e, t) => {
  const n = d1.useInject(), r = V(() => {
    if (!n || TD(n)) return "";
    const {
      compactDirection: a,
      isFirstItem: o,
      isLastItem: i
    } = n, s = a === "vertical" ? "-vertical-" : "-";
    return Ge({
      [`${e.value}-compact${s}item`]: !0,
      [`${e.value}-compact${s}first-item`]: o,
      [`${e.value}-compact${s}last-item`]: i,
      [`${e.value}-compact${s}item-rtl`]: t.value === "rtl"
    });
  });
  return {
    compactSize: V(() => n == null ? void 0 : n.compactSize),
    compactDirection: V(() => n == null ? void 0 : n.compactDirection),
    compactItemClassnames: r
  };
}, N$ = /* @__PURE__ */ Me({
  name: "NoCompactStyle",
  setup(e, t) {
    let {
      slots: n
    } = t;
    return d1.useProvide(null), () => {
      var r;
      return (r = n.default) === null || r === void 0 ? void 0 : r.call(n);
    };
  }
}), Cte = () => ({
  prefixCls: String,
  size: {
    type: String
  },
  direction: Oe.oneOf(eu("horizontal", "vertical")).def("horizontal"),
  align: Oe.oneOf(eu("start", "end", "center", "baseline")),
  block: {
    type: Boolean,
    default: void 0
  }
}), Ete = /* @__PURE__ */ Me({
  name: "CompactItem",
  props: _te(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return d1.useProvide(e), () => {
      var r;
      return (r = n.default) === null || r === void 0 ? void 0 : r.call(n);
    };
  }
});
Cte();
const Tte = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), $te = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), p1 = function(e, t, n, r) {
  const o = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${o}${e}-enter,
      ${o}${e}-appear
    `]: D(D({}, Tte(r)), {
      animationPlayState: "paused"
    }),
    [`${o}${e}-leave`]: D(D({}, $te(r)), {
      animationPlayState: "paused"
    }),
    [`
      ${o}${e}-enter${e}-enter-active,
      ${o}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${o}${e}-leave${e}-leave-active`]: {
      animationName: n,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, Ote = new rn("antFadeIn", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), Ate = new rn("antFadeOut", {
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
}), Ite = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const {
    antCls: n
  } = e, r = `${n}-fade`, a = t ? "&" : "";
  return [p1(r, Ote, Ate, e.motionDurationMid, t), {
    [`
        ${a}${r}-enter,
        ${a}${r}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: "linear"
    },
    [`${a}${r}-leave`]: {
      animationTimingFunction: "linear"
    }
  }];
}, Pte = new rn("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), Dte = new rn("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), kte = new rn("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), Mte = new rn("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), Rte = new rn("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), Nte = new rn("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), Fte = new rn("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), Lte = new rn("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), Bte = {
  "move-up": {
    inKeyframes: Fte,
    outKeyframes: Lte
  },
  "move-down": {
    inKeyframes: Pte,
    outKeyframes: Dte
  },
  "move-left": {
    inKeyframes: kte,
    outKeyframes: Mte
  },
  "move-right": {
    inKeyframes: Rte,
    outKeyframes: Nte
  }
}, Xf = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: a,
    outKeyframes: o
  } = Bte[t];
  return [p1(r, a, o, e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, h1 = new rn("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), v1 = new rn("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), m1 = new rn("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), g1 = new rn("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), Hte = new rn("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), jte = new rn("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), Vte = new rn("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), Ute = new rn("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), zte = {
  "slide-up": {
    inKeyframes: h1,
    outKeyframes: v1
  },
  "slide-down": {
    inKeyframes: m1,
    outKeyframes: g1
  },
  "slide-left": {
    inKeyframes: Hte,
    outKeyframes: jte
  },
  "slide-right": {
    inKeyframes: Vte,
    outKeyframes: Ute
  }
}, nu = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: a,
    outKeyframes: o
  } = zte[t];
  return [p1(r, a, o, e.motionDurationMid), {
    [`
      ${r}-enter,
      ${r}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutQuint
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInQuint
    }
  }];
}, MC = new rn("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), Wte = new rn("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), F$ = new rn("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), L$ = new rn("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), Gte = new rn("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), Kte = new rn("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), Yte = new rn("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), qte = new rn("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), Xte = new rn("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), Zte = new rn("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), Qte = new rn("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), Jte = new rn("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), ene = {
  zoom: {
    inKeyframes: MC,
    outKeyframes: Wte
  },
  "zoom-big": {
    inKeyframes: F$,
    outKeyframes: L$
  },
  "zoom-big-fast": {
    inKeyframes: F$,
    outKeyframes: L$
  },
  "zoom-left": {
    inKeyframes: Yte,
    outKeyframes: qte
  },
  "zoom-right": {
    inKeyframes: Xte,
    outKeyframes: Zte
  },
  "zoom-up": {
    inKeyframes: Gte,
    outKeyframes: Kte
  },
  "zoom-down": {
    inKeyframes: Qte,
    outKeyframes: Jte
  }
}, y1 = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: a,
    outKeyframes: o
  } = ene[t];
  return [p1(r, a, o, t === "zoom-big-fast" ? e.motionDurationFast : e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, $D = (e) => ({
  [e.componentCls]: {
    // For common/openAnimation
    [`${e.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
      }
    },
    [`${e.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
    }
  }
}), B$ = (e) => {
  const {
    controlPaddingHorizontal: t
  } = e;
  return {
    position: "relative",
    display: "block",
    minHeight: e.controlHeight,
    padding: `${(e.controlHeight - e.fontSize * e.lineHeight) / 2}px ${t}px`,
    color: e.colorText,
    fontWeight: "normal",
    fontSize: e.fontSize,
    lineHeight: e.lineHeight,
    boxSizing: "border-box"
  };
}, tne = (e) => {
  const {
    antCls: t,
    componentCls: n
  } = e, r = `${n}-item`;
  return [
    {
      [`${n}-dropdown`]: D(D({}, gr(e)), {
        position: "absolute",
        top: -9999,
        zIndex: e.zIndexPopup,
        boxSizing: "border-box",
        padding: e.paddingXXS,
        overflow: "hidden",
        fontSize: e.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: e.colorBgElevated,
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        [`
            &${t}-slide-up-enter${t}-slide-up-enter-active${n}-dropdown-placement-bottomLeft,
            &${t}-slide-up-appear${t}-slide-up-appear-active${n}-dropdown-placement-bottomLeft
          `]: {
          animationName: h1
        },
        [`
            &${t}-slide-up-enter${t}-slide-up-enter-active${n}-dropdown-placement-topLeft,
            &${t}-slide-up-appear${t}-slide-up-appear-active${n}-dropdown-placement-topLeft
          `]: {
          animationName: m1
        },
        [`&${t}-slide-up-leave${t}-slide-up-leave-active${n}-dropdown-placement-bottomLeft`]: {
          animationName: v1
        },
        [`&${t}-slide-up-leave${t}-slide-up-leave-active${n}-dropdown-placement-topLeft`]: {
          animationName: g1
        },
        "&-hidden": {
          display: "none"
        },
        "&-empty": {
          color: e.colorTextDisabled
        },
        // ========================= Options =========================
        [`${r}-empty`]: D(D({}, B$(e)), {
          color: e.colorTextDisabled
        }),
        [`${r}`]: D(D({}, B$(e)), {
          cursor: "pointer",
          transition: `background ${e.motionDurationSlow} ease`,
          borderRadius: e.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: e.colorTextDescription,
            fontSize: e.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": D({
              flex: "auto"
            }, op),
            "&-state": {
              flex: "none"
            },
            [`&-active:not(${r}-option-disabled)`]: {
              backgroundColor: e.controlItemBgHover
            },
            [`&-selected:not(${r}-option-disabled)`]: {
              color: e.colorText,
              fontWeight: e.fontWeightStrong,
              backgroundColor: e.controlItemBgActive,
              [`${r}-option-state`]: {
                color: e.colorPrimary
              }
            },
            "&-disabled": {
              [`&${r}-option-selected`]: {
                backgroundColor: e.colorBgContainerDisabled
              },
              color: e.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: e.controlPaddingHorizontal * 2
            }
          }
        }),
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    nu(e, "slide-up"),
    nu(e, "slide-down"),
    Xf(e, "move-up"),
    Xf(e, "move-down")
  ];
}, Gc = 2;
function OD(e) {
  let {
    controlHeightSM: t,
    controlHeight: n,
    lineWidth: r
  } = e;
  const a = (n - t) / 2 - r, o = Math.ceil(a / 2);
  return [a, o];
}
function Ny(e, t) {
  const {
    componentCls: n,
    iconCls: r
  } = e, a = `${n}-selection-overflow`, o = e.controlHeightSM, [i] = OD(e), s = t ? `${n}-${t}` : "";
  return {
    [`${n}-multiple${s}`]: {
      fontSize: e.fontSize,
      /**
       * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
       * may update to redesign with its align logic.
       */
      // =========================== Overflow ===========================
      [a]: {
        position: "relative",
        display: "flex",
        flex: "auto",
        flexWrap: "wrap",
        maxWidth: "100%",
        "&-item": {
          flex: "none",
          alignSelf: "center",
          maxWidth: "100%",
          display: "inline-flex"
        }
      },
      // ========================= Selector =========================
      [`${n}-selector`]: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        // Multiple is little different that horizontal is follow the vertical
        padding: `${i - Gc}px ${Gc * 2}px`,
        borderRadius: e.borderRadius,
        [`${n}-show-search&`]: {
          cursor: "text"
        },
        [`${n}-disabled&`]: {
          background: e.colorBgContainerDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${Gc}px 0`,
          lineHeight: `${o}px`,
          content: '"\\a0"'
        }
      },
      [`
        &${n}-show-arrow ${n}-selector,
        &${n}-allow-clear ${n}-selector
      `]: {
        paddingInlineEnd: e.fontSizeIcon + e.controlPaddingHorizontal
      },
      // ======================== Selections ========================
      [`${n}-selection-item`]: {
        position: "relative",
        display: "flex",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        height: o,
        marginTop: Gc,
        marginBottom: Gc,
        lineHeight: `${o - e.lineWidth * 2}px`,
        background: e.colorFillSecondary,
        border: `${e.lineWidth}px solid ${e.colorSplit}`,
        borderRadius: e.borderRadiusSM,
        cursor: "default",
        transition: `font-size ${e.motionDurationSlow}, line-height ${e.motionDurationSlow}, height ${e.motionDurationSlow}`,
        userSelect: "none",
        marginInlineEnd: Gc * 2,
        paddingInlineStart: e.paddingXS,
        paddingInlineEnd: e.paddingXS / 2,
        [`${n}-disabled&`]: {
          color: e.colorTextDisabled,
          borderColor: e.colorBorder,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: e.paddingXS / 2,
          overflow: "hidden",
          whiteSpace: "pre",
          textOverflow: "ellipsis"
        },
        "&-remove": D(D({}, Zg()), {
          display: "inline-block",
          color: e.colorIcon,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${r}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: e.colorIconHover
          }
        })
      },
      // ========================== Input ==========================
      [`${a}-item + ${a}-item`]: {
        [`${n}-selection-search`]: {
          marginInlineStart: 0
        }
      },
      [`${n}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: e.inputPaddingHorizontalBase - i,
        "\n          &-input,\n          &-mirror\n        ": {
          height: o,
          fontFamily: e.fontFamily,
          lineHeight: `${o}px`,
          transition: `all ${e.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${n}-selection-placeholder `]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: e.inputPaddingHorizontalBase,
        insetInlineEnd: e.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${e.motionDurationSlow}`
      }
    }
  };
}
function nne(e) {
  const {
    componentCls: t
  } = e, n = xn(e, {
    controlHeight: e.controlHeightSM,
    controlHeightSM: e.controlHeightXS,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS
  }), [, r] = OD(e);
  return [
    Ny(e),
    // ======================== Small ========================
    // Shared
    Ny(n, "sm"),
    // Padding
    {
      [`${t}-multiple${t}-sm`]: {
        [`${t}-selection-placeholder`]: {
          insetInlineStart: e.controlPaddingHorizontalSM - e.lineWidth,
          insetInlineEnd: "auto"
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${t}-selection-search`]: {
          marginInlineStart: r
        }
      }
    },
    // ======================== Large ========================
    // Shared
    Ny(xn(e, {
      fontSize: e.fontSizeLG,
      controlHeight: e.controlHeightLG,
      controlHeightSM: e.controlHeight,
      borderRadius: e.borderRadiusLG,
      borderRadiusSM: e.borderRadius
    }), "lg")
  ];
}
function Fy(e, t) {
  const {
    componentCls: n,
    inputPaddingHorizontalBase: r,
    borderRadius: a
  } = e, o = e.controlHeight - e.lineWidth * 2, i = Math.ceil(e.fontSize * 1.25), s = t ? `${n}-${t}` : "";
  return {
    [`${n}-single${s}`]: {
      fontSize: e.fontSize,
      // ========================= Selector =========================
      [`${n}-selector`]: D(D({}, gr(e)), {
        display: "flex",
        borderRadius: a,
        [`${n}-selection-search`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: r,
          insetInlineEnd: r,
          bottom: 0,
          "&-input": {
            width: "100%"
          }
        },
        [`
          ${n}-selection-item,
          ${n}-selection-placeholder
        `]: {
          padding: 0,
          lineHeight: `${o}px`,
          transition: `all ${e.motionDurationSlow}`,
          // Firefox inline-block position calculation is not same as Chrome & Safari. Patch this:
          "@supports (-moz-appearance: meterbar)": {
            lineHeight: `${o}px`
          }
        },
        [`${n}-selection-item`]: {
          position: "relative",
          userSelect: "none"
        },
        [`${n}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${n}-selection-item:after`,
          /* For undefined value baseline align */
          `${n}-selection-placeholder:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${n}-show-arrow ${n}-selection-item,
        &${n}-show-arrow ${n}-selection-placeholder
      `]: {
        paddingInlineEnd: i
      },
      // Opacity selection if open
      [`&${n}-open ${n}-selection-item`]: {
        color: e.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${n}-customize-input)`]: {
        [`${n}-selector`]: {
          width: "100%",
          height: e.controlHeight,
          padding: `0 ${r}px`,
          [`${n}-selection-search-input`]: {
            height: o
          },
          "&:after": {
            lineHeight: `${o}px`
          }
        }
      },
      [`&${n}-customize-input`]: {
        [`${n}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${n}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${n}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${r}px`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function rne(e) {
  const {
    componentCls: t
  } = e, n = e.controlPaddingHorizontalSM - e.lineWidth;
  return [
    Fy(e),
    // ======================== Small ========================
    // Shared
    Fy(xn(e, {
      controlHeight: e.controlHeightSM,
      borderRadius: e.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${t}-single${t}-sm`]: {
        [`&:not(${t}-customize-input)`]: {
          [`${t}-selection-search`]: {
            insetInlineStart: n,
            insetInlineEnd: n
          },
          [`${t}-selector`]: {
            padding: `0 ${n}px`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${t}-show-arrow ${t}-selection-search`]: {
            insetInlineEnd: n + e.fontSize * 1.5
          },
          [`
            &${t}-show-arrow ${t}-selection-item,
            &${t}-show-arrow ${t}-selection-placeholder
          `]: {
            paddingInlineEnd: e.fontSize * 1.5
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    Fy(xn(e, {
      controlHeight: e.controlHeightLG,
      fontSize: e.fontSizeLG,
      borderRadius: e.borderRadiusLG
    }), "lg")
  ];
}
function ane(e, t, n) {
  const {
    focusElCls: r,
    focus: a,
    borderElCls: o
  } = n, i = o ? "> *" : "", s = ["hover", a ? "focus" : null, "active"].filter(Boolean).map((l) => `&:${l} ${i}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: -e.lineWidth
    },
    "&-item": D(D({
      [s]: {
        zIndex: 2
      }
    }, r ? {
      [`&${r}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${i}`]: {
        zIndex: 0
      }
    })
  };
}
function one(e, t, n) {
  const {
    borderElCls: r
  } = n, a = r ? `> ${r}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${a}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${a}, &${e}-sm ${a}, &${e}-lg ${a}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${a}, &${e}-sm ${a}, &${e}-lg ${a}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function x1(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: n
  } = e, r = `${n}-compact`;
  return {
    [r]: D(D({}, ane(e, r, t)), one(n, r, t))
  };
}
const ine = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    position: "relative",
    backgroundColor: e.colorBgContainer,
    border: `${e.lineWidth}px ${e.lineType} ${e.colorBorder}`,
    transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${t}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit"
      }
    },
    [`${t}-disabled&`]: {
      color: e.colorTextDisabled,
      background: e.colorBgContainerDisabled,
      cursor: "not-allowed",
      [`${t}-multiple&`]: {
        background: e.colorBgContainerDisabled
      },
      input: {
        cursor: "not-allowed"
      }
    }
  };
}, Ly = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  const {
    componentCls: r,
    borderHoverColor: a,
    outlineColor: o,
    antCls: i
  } = t, s = n ? {
    [`${r}-selector`]: {
      borderColor: a
    }
  } : {};
  return {
    [e]: {
      [`&:not(${r}-disabled):not(${r}-customize-input):not(${i}-pagination-size-changer)`]: D(D({}, s), {
        [`${r}-focused& ${r}-selector`]: {
          borderColor: a,
          boxShadow: `0 0 0 ${t.controlOutlineWidth}px ${o}`,
          borderInlineEndWidth: `${t.controlLineWidth}px !important`,
          outline: 0
        },
        [`&:hover ${r}-selector`]: {
          borderColor: a,
          borderInlineEndWidth: `${t.controlLineWidth}px !important`
        }
      })
    }
  };
}, sne = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      "&::-webkit-search-cancel-button": {
        display: "none",
        "-webkit-appearance": "none"
      }
    }
  };
}, lne = (e) => {
  const {
    componentCls: t,
    inputPaddingHorizontalBase: n,
    iconCls: r
  } = e;
  return {
    [t]: D(D({}, gr(e)), {
      position: "relative",
      display: "inline-block",
      cursor: "pointer",
      [`&:not(${t}-customize-input) ${t}-selector`]: D(D({}, ine(e)), sne(e)),
      // [`&:not(&-disabled):hover ${selectCls}-selector`]: {
      //   ...genHoverStyle(token),
      // },
      // ======================== Selection ========================
      [`${t}-selection-item`]: D({
        flex: 1,
        fontWeight: "normal"
      }, op),
      // ======================= Placeholder =======================
      [`${t}-selection-placeholder`]: D(D({}, op), {
        flex: 1,
        color: e.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${t}-arrow`]: D(D({}, Zg()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: n,
        height: e.fontSizeIcon,
        marginTop: -e.fontSizeIcon / 2,
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        [r]: {
          verticalAlign: "top",
          transition: `transform ${e.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${t}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${t}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Clear ==========================
      [`${t}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: n,
        zIndex: 1,
        display: "inline-block",
        width: e.fontSizeIcon,
        height: e.fontSizeIcon,
        marginTop: -e.fontSizeIcon / 2,
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        background: e.colorBgContainer,
        cursor: "pointer",
        opacity: 0,
        transition: `color ${e.motionDurationMid} ease, opacity ${e.motionDurationSlow} ease`,
        textRendering: "auto",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: e.colorTextTertiary
        }
      },
      "&:hover": {
        [`${t}-clear`]: {
          opacity: 1
        }
      }
    }),
    // ========================= Feedback ==========================
    [`${t}-has-feedback`]: {
      [`${t}-clear`]: {
        insetInlineEnd: n + e.fontSize + e.paddingXXS
      }
    }
  };
}, une = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    {
      [t]: {
        // ==================== BorderLess ====================
        [`&-borderless ${t}-selector`]: {
          backgroundColor: "transparent !important",
          borderColor: "transparent !important",
          boxShadow: "none !important"
        },
        // ==================== In Form ====================
        [`&${t}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    lne(e),
    // Single
    rne(e),
    // Multiple
    nne(e),
    // Dropdown
    tne(e),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${t}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==                     Status                      ==
    // =====================================================
    Ly(t, xn(e, {
      borderHoverColor: e.colorPrimaryHover,
      outlineColor: e.controlOutline
    })),
    Ly(`${t}-status-error`, xn(e, {
      borderHoverColor: e.colorErrorHover,
      outlineColor: e.colorErrorOutline
    }), !0),
    Ly(`${t}-status-warning`, xn(e, {
      borderHoverColor: e.colorWarningHover,
      outlineColor: e.colorWarningOutline
    }), !0),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    x1(e, {
      borderElCls: `${t}-selector`,
      focusElCls: `${t}-focused`
    })
  ];
}, cne = xr("Select", (e, t) => {
  let {
    rootPrefixCls: n
  } = t;
  const r = xn(e, {
    rootPrefixCls: n,
    inputPaddingHorizontalBase: e.paddingSM - 1
  });
  return [une(r)];
}, (e) => ({
  zIndexPopup: e.zIndexPopupBase + 50
})), RC = () => D(D({}, Lr(JP(), ["inputIcon", "mode", "getInputElement", "getRawInputElement", "backfill"])), {
  value: ca([Array, Object, String, Number]),
  defaultValue: ca([Array, Object, String, Number]),
  notFoundContent: Oe.any,
  suffixIcon: Oe.any,
  itemIcon: Oe.any,
  size: Ur(),
  mode: Ur(),
  bordered: qt(!0),
  transitionName: String,
  choiceTransitionName: Ur(""),
  popupClassName: String,
  /** @deprecated Please use `popupClassName` instead */
  dropdownClassName: String,
  placement: Ur(),
  status: Ur(),
  "onUpdate:value": Nt()
}), H$ = "SECRET_COMBOBOX_MODE_DO_NOT_USE", es = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ASelect",
  Option: bC,
  OptGroup: wC,
  inheritAttrs: !1,
  props: ha(RC(), {
    listHeight: 256,
    listItemHeight: 24
  }),
  SECRET_COMBOBOX_MODE_DO_NOT_USE: H$,
  slots: Object,
  setup(e, t) {
    let {
      attrs: n,
      emit: r,
      slots: a,
      expose: o
    } = t;
    const i = ne(), s = fu(), l = Wi.useInject(), u = V(() => wd(l.status, e.status)), c = () => {
      var F;
      (F = i.value) === null || F === void 0 || F.focus();
    }, f = () => {
      var F;
      (F = i.value) === null || F === void 0 || F.blur();
    }, d = (F) => {
      var Y;
      (Y = i.value) === null || Y === void 0 || Y.scrollTo(F);
    }, p = V(() => {
      const {
        mode: F
      } = e;
      if (F !== "combobox")
        return F === H$ ? "combobox" : F;
    });
    process.env.NODE_ENV !== "production" && Aa(!e.dropdownClassName, "Select", "`dropdownClassName` is deprecated. Please use `popupClassName` instead.");
    const {
      prefixCls: v,
      direction: h,
      configProvider: m,
      renderEmpty: y,
      size: x,
      getPrefixCls: g,
      getPopupContainer: S,
      disabled: w,
      select: _
    } = mn("select", e), {
      compactSize: b,
      compactItemClassnames: E
    } = Wp(v, h), C = V(() => b.value || x.value), T = Ec(), O = V(() => {
      var F;
      return (F = w.value) !== null && F !== void 0 ? F : T.value;
    }), [I, k] = cne(v), B = V(() => g()), P = V(() => e.placement !== void 0 ? e.placement : h.value === "rtl" ? "bottomRight" : "bottomLeft"), N = V(() => qf(B.value, Jq(P.value), e.transitionName)), M = V(() => Ge({
      [`${v.value}-lg`]: C.value === "large",
      [`${v.value}-sm`]: C.value === "small",
      [`${v.value}-rtl`]: h.value === "rtl",
      [`${v.value}-borderless`]: !e.bordered,
      [`${v.value}-in-form-item`]: l.isFormItemInput
    }, zl(v.value, u.value, l.hasFeedback), E.value, k.value)), H = function() {
      for (var F = arguments.length, Y = new Array(F), X = 0; X < F; X++)
        Y[X] = arguments[X];
      r("update:value", Y[0]), r("change", ...Y), s.onFieldChange();
    }, R = (F) => {
      r("blur", F), s.onFieldBlur();
    };
    o({
      blur: f,
      focus: c,
      scrollTo: d
    });
    const z = V(() => p.value === "multiple" || p.value === "tags"), W = V(() => e.showArrow !== void 0 ? e.showArrow : e.loading || !(z.value || p.value === "combobox"));
    return () => {
      var F, Y, X, q;
      const {
        notFoundContent: Q,
        listHeight: ue = 256,
        listItemHeight: le = 24,
        popupClassName: te,
        dropdownClassName: G,
        virtual: oe,
        dropdownMatchSelectWidth: L,
        id: re = s.id.value,
        placeholder: j = (F = a.placeholder) === null || F === void 0 ? void 0 : F.call(a),
        showArrow: J
      } = e, {
        hasFeedback: ae,
        feedbackIcon: he
      } = l;
      let K;
      Q !== void 0 ? K = Q : a.notFoundContent ? K = a.notFoundContent() : p.value === "combobox" ? K = null : K = (y == null ? void 0 : y("Select")) || A(X_, {
        componentName: "Select"
      }, null);
      const {
        suffixIcon: Z,
        itemIcon: se,
        removeIcon: me,
        clearIcon: xe
      } = dQ(D(D({}, e), {
        multiple: z.value,
        prefixCls: v.value,
        hasFeedback: ae,
        feedbackIcon: he,
        showArrow: W.value
      }), a), be = Lr(e, ["prefixCls", "suffixIcon", "itemIcon", "removeIcon", "clearIcon", "size", "bordered", "status"]), Te = Ge(te || G, {
        [`${v.value}-dropdown-${h.value}`]: h.value === "rtl"
      }, k.value);
      return I(A(yZ, ve(ve(ve({
        ref: i,
        virtual: oe,
        dropdownMatchSelectWidth: L
      }, be), n), {}, {
        showSearch: (Y = e.showSearch) !== null && Y !== void 0 ? Y : (X = _ == null ? void 0 : _.value) === null || X === void 0 ? void 0 : X.showSearch,
        placeholder: j,
        listHeight: ue,
        listItemHeight: le,
        mode: p.value,
        prefixCls: v.value,
        direction: h.value,
        inputIcon: Z,
        menuItemSelectedIcon: se,
        removeIcon: me,
        clearIcon: xe,
        notFoundContent: K,
        class: [M.value, n.class],
        getPopupContainer: S == null ? void 0 : S.value,
        dropdownClassName: Te,
        onChange: H,
        onBlur: R,
        id: re,
        dropdownRender: be.dropdownRender || a.dropdownRender,
        transitionName: N.value,
        children: (q = a.default) === null || q === void 0 ? void 0 : q.call(a),
        tagRender: e.tagRender || a.tagRender,
        optionLabelRender: a.optionLabel,
        maxTagPlaceholder: e.maxTagPlaceholder || a.maxTagPlaceholder,
        showArrow: ae || J,
        disabled: O.value
      }), {
        option: a.option
      }));
    };
  }
});
es.install = function(e) {
  return e.component(es.name, es), e.component(es.Option.displayName, es.Option), e.component(es.OptGroup.displayName, es.OptGroup), e;
};
const ia = es.Option;
es.OptGroup;
const fo = es;
var fne = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, name: "check-circle", theme: "outlined" };
function j$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      dne(e, a, n[a]);
    });
  }
  return e;
}
function dne(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var NC = function(t, n) {
  var r = j$({}, t, n.attrs);
  return A(Bn, j$({}, r, {
    icon: fne
  }), null);
};
NC.displayName = "CheckCircleOutlined";
NC.inheritAttrs = !1;
var pne = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] }, name: "exclamation-circle", theme: "outlined" };
function V$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      hne(e, a, n[a]);
    });
  }
  return e;
}
function hne(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var FC = function(t, n) {
  var r = V$({}, t, n.attrs);
  return A(Bn, V$({}, r, {
    icon: pne
  }), null);
};
FC.displayName = "ExclamationCircleOutlined";
FC.inheritAttrs = !1;
var vne = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, name: "info-circle", theme: "outlined" };
function U$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      mne(e, a, n[a]);
    });
  }
  return e;
}
function mne(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var LC = function(t, n) {
  var r = U$({}, t, n.attrs);
  return A(Bn, U$({}, r, {
    icon: vne
  }), null);
};
LC.displayName = "InfoCircleOutlined";
LC.inheritAttrs = !1;
var gne = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z" } }] }, name: "close-circle", theme: "outlined" };
function z$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      yne(e, a, n[a]);
    });
  }
  return e;
}
function yne(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var BC = function(t, n) {
  var r = z$({}, t, n.attrs);
  return A(Bn, z$({}, r, {
    icon: gne
  }), null);
};
BC.displayName = "CloseCircleOutlined";
BC.inheritAttrs = !1;
var xne = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
function W$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      bne(e, a, n[a]);
    });
  }
  return e;
}
function bne(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var du = function(t, n) {
  var r = W$({}, t, n.attrs);
  return A(Bn, W$({}, r, {
    icon: xne
  }), null);
};
du.displayName = "CheckCircleFilled";
du.inheritAttrs = !1;
var wne = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" };
function G$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      Sne(e, a, n[a]);
    });
  }
  return e;
}
function Sne(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var pu = function(t, n) {
  var r = G$({}, t, n.attrs);
  return A(Bn, G$({}, r, {
    icon: wne
  }), null);
};
pu.displayName = "ExclamationCircleFilled";
pu.inheritAttrs = !1;
var _ne = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" };
function K$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      Cne(e, a, n[a]);
    });
  }
  return e;
}
function Cne(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Pc = function(t, n) {
  var r = K$({}, t, n.attrs);
  return A(Bn, K$({}, r, {
    icon: _ne
  }), null);
};
Pc.displayName = "InfoCircleFilled";
Pc.inheritAttrs = !1;
const Hh = ["xxxl", "xxl", "xl", "lg", "md", "sm", "xs"], Ene = (e) => ({
  xs: `(max-width: ${e.screenXSMax}px)`,
  sm: `(min-width: ${e.screenSM}px)`,
  md: `(min-width: ${e.screenMD}px)`,
  lg: `(min-width: ${e.screenLG}px)`,
  xl: `(min-width: ${e.screenXL}px)`,
  xxl: `(min-width: ${e.screenXXL}px)`,
  xxxl: `{min-width: ${e.screenXXXL}px}`
});
function AD() {
  const [, e] = bd();
  return V(() => {
    const t = Ene(e.value), n = /* @__PURE__ */ new Map();
    let r = -1, a = {};
    return {
      matchHandlers: {},
      dispatch(o) {
        return a = o, n.forEach((i) => i(a)), n.size >= 1;
      },
      subscribe(o) {
        return n.size || this.register(), r += 1, n.set(r, o), o(a), r;
      },
      unsubscribe(o) {
        n.delete(o), n.size || this.unregister();
      },
      unregister() {
        Object.keys(t).forEach((o) => {
          const i = t[o], s = this.matchHandlers[i];
          s == null || s.mql.removeListener(s == null ? void 0 : s.listener);
        }), n.clear();
      },
      register() {
        Object.keys(t).forEach((o) => {
          const i = t[o], s = (u) => {
            let {
              matches: c
            } = u;
            this.dispatch(D(D({}, a), {
              [o]: c
            }));
          }, l = window.matchMedia(i);
          l.addListener(s), this.matchHandlers[i] = {
            mql: l,
            listener: s
          }, s(l);
        });
      },
      responsiveMap: t
    };
  });
}
function Tne() {
  const e = Be({});
  let t = null;
  const n = AD();
  return Lt(() => {
    t = n.value.subscribe((r) => {
      e.value = r;
    });
  }), Bo(() => {
    n.value.unsubscribe(t);
  }), e;
}
const zo = {
  adjustX: 1,
  adjustY: 1
}, Wo = [0, 0], ID = {
  left: {
    points: ["cr", "cl"],
    overflow: zo,
    offset: [-4, 0],
    targetOffset: Wo
  },
  right: {
    points: ["cl", "cr"],
    overflow: zo,
    offset: [4, 0],
    targetOffset: Wo
  },
  top: {
    points: ["bc", "tc"],
    overflow: zo,
    offset: [0, -4],
    targetOffset: Wo
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: zo,
    offset: [0, 4],
    targetOffset: Wo
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: zo,
    offset: [0, -4],
    targetOffset: Wo
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: zo,
    offset: [-4, 0],
    targetOffset: Wo
  },
  topRight: {
    points: ["br", "tr"],
    overflow: zo,
    offset: [0, -4],
    targetOffset: Wo
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: zo,
    offset: [4, 0],
    targetOffset: Wo
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: zo,
    offset: [0, 4],
    targetOffset: Wo
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: zo,
    offset: [4, 0],
    targetOffset: Wo
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: zo,
    offset: [0, 4],
    targetOffset: Wo
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: zo,
    offset: [-4, 0],
    targetOffset: Wo
  }
}, $ne = {
  prefixCls: String,
  id: String,
  overlayInnerStyle: Oe.any
}, One = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "TooltipContent",
  props: $ne,
  setup(e, t) {
    let {
      slots: n
    } = t;
    return () => {
      var r;
      return A("div", {
        class: `${e.prefixCls}-inner`,
        id: e.id,
        role: "tooltip",
        style: e.overlayInnerStyle
      }, [(r = n.overlay) === null || r === void 0 ? void 0 : r.call(n)]);
    };
  }
});
var Ane = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function Y$() {
}
const Ine = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "Tooltip",
  inheritAttrs: !1,
  props: {
    trigger: Oe.any.def(["hover"]),
    defaultVisible: {
      type: Boolean,
      default: void 0
    },
    visible: {
      type: Boolean,
      default: void 0
    },
    placement: Oe.string.def("right"),
    transitionName: String,
    animation: Oe.any,
    afterVisibleChange: Oe.func.def(() => {
    }),
    overlayStyle: {
      type: Object,
      default: void 0
    },
    overlayClassName: String,
    prefixCls: Oe.string.def("rc-tooltip"),
    mouseEnterDelay: Oe.number.def(0.1),
    mouseLeaveDelay: Oe.number.def(0.1),
    getPopupContainer: Function,
    destroyTooltipOnHide: {
      type: Boolean,
      default: !1
    },
    align: Oe.object.def(() => ({})),
    arrowContent: Oe.any.def(null),
    tipId: String,
    builtinPlacements: Oe.object,
    overlayInnerStyle: {
      type: Object,
      default: void 0
    },
    popupVisible: {
      type: Boolean,
      default: void 0
    },
    onVisibleChange: Function,
    onPopupAlign: Function
  },
  setup(e, t) {
    let {
      slots: n,
      attrs: r,
      expose: a
    } = t;
    const o = Be(), i = () => {
      const {
        prefixCls: c,
        tipId: f,
        overlayInnerStyle: d
      } = e;
      return [A("div", {
        class: `${c}-arrow`,
        key: "arrow"
      }, [zg(n, e, "arrowContent")]), A(One, {
        key: "content",
        prefixCls: c,
        id: f,
        overlayInnerStyle: d
      }, {
        overlay: n.overlay
      })];
    };
    a({
      getPopupDomNode: () => o.value.getPopupDomNode(),
      triggerDOM: o,
      forcePopupAlign: () => {
        var c;
        return (c = o.value) === null || c === void 0 ? void 0 : c.forcePopupAlign();
      }
    });
    const l = Be(!1), u = Be(!1);
    return _n(() => {
      const {
        destroyTooltipOnHide: c
      } = e;
      if (typeof c == "boolean")
        l.value = c;
      else if (c && typeof c == "object") {
        const {
          keepParent: f
        } = c;
        l.value = f === !0, u.value = f === !1;
      }
    }), () => {
      const {
        overlayClassName: c,
        trigger: f,
        mouseEnterDelay: d,
        mouseLeaveDelay: p,
        overlayStyle: v,
        prefixCls: h,
        afterVisibleChange: m,
        transitionName: y,
        animation: x,
        placement: g,
        align: S,
        destroyTooltipOnHide: w,
        defaultVisible: _
      } = e, b = Ane(e, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "afterVisibleChange", "transitionName", "animation", "placement", "align", "destroyTooltipOnHide", "defaultVisible"]), E = D({}, b);
      e.visible !== void 0 && (E.popupVisible = e.visible);
      const C = D(D(D({
        popupClassName: c,
        prefixCls: h,
        action: f,
        builtinPlacements: ID,
        popupPlacement: g,
        popupAlign: S,
        afterPopupVisibleChange: m,
        popupTransitionName: y,
        popupAnimation: x,
        defaultPopupVisible: _,
        destroyPopupOnHide: l.value,
        autoDestroy: u.value,
        mouseLeaveDelay: p,
        popupStyle: v,
        mouseEnterDelay: d
      }, E), r), {
        onPopupVisibleChange: e.onVisibleChange || Y$,
        onPopupAlign: e.onPopupAlign || Y$,
        ref: o,
        popup: i()
      });
      return A(jp, C, {
        default: n.default
      });
    };
  }
}), Pne = () => ({
  trigger: [String, Array],
  open: {
    type: Boolean,
    default: void 0
  },
  /** @deprecated Please use `open` instead. */
  visible: {
    type: Boolean,
    default: void 0
  },
  placement: String,
  color: String,
  transitionName: String,
  overlayStyle: hn(),
  overlayInnerStyle: hn(),
  overlayClassName: String,
  openClassName: String,
  prefixCls: String,
  mouseEnterDelay: Number,
  mouseLeaveDelay: Number,
  getPopupContainer: Function,
  arrowPointAtCenter: {
    type: Boolean,
    default: void 0
  },
  autoAdjustOverflow: {
    type: [Boolean, Object],
    default: void 0
  },
  destroyTooltipOnHide: {
    type: Boolean,
    default: void 0
  },
  align: hn(),
  builtinPlacements: hn(),
  children: Array,
  /** @deprecated Please use `onOpenChange` instead. */
  onVisibleChange: Function,
  /** @deprecated Please use `onUpdate:open` instead. */
  "onUpdate:visible": Function,
  onOpenChange: Function,
  "onUpdate:open": Function
}), Dne = {
  adjustX: 1,
  adjustY: 1
}, q$ = {
  adjustX: 0,
  adjustY: 0
}, kne = [0, 0];
function X$(e) {
  return typeof e == "boolean" ? e ? Dne : q$ : D(D({}, q$), e);
}
function PD(e) {
  const {
    arrowWidth: t = 4,
    horizontalArrowShift: n = 16,
    verticalArrowShift: r = 8,
    autoAdjustOverflow: a,
    arrowPointAtCenter: o
  } = e, i = {
    left: {
      points: ["cr", "cl"],
      offset: [-4, 0]
    },
    right: {
      points: ["cl", "cr"],
      offset: [4, 0]
    },
    top: {
      points: ["bc", "tc"],
      offset: [0, -4]
    },
    bottom: {
      points: ["tc", "bc"],
      offset: [0, 4]
    },
    topLeft: {
      points: ["bl", "tc"],
      offset: [-(n + t), -4]
    },
    leftTop: {
      points: ["tr", "cl"],
      offset: [-4, -(r + t)]
    },
    topRight: {
      points: ["br", "tc"],
      offset: [n + t, -4]
    },
    rightTop: {
      points: ["tl", "cr"],
      offset: [4, -(r + t)]
    },
    bottomRight: {
      points: ["tr", "bc"],
      offset: [n + t, 4]
    },
    rightBottom: {
      points: ["bl", "cr"],
      offset: [4, r + t]
    },
    bottomLeft: {
      points: ["tl", "bc"],
      offset: [-(n + t), 4]
    },
    leftBottom: {
      points: ["br", "cl"],
      offset: [-4, r + t]
    }
  };
  return Object.keys(i).forEach((s) => {
    i[s] = o ? D(D({}, i[s]), {
      overflow: X$(a),
      targetOffset: kne
    }) : D(D({}, ID[s]), {
      overflow: X$(a)
    }), i[s].ignoreShake = !0;
  }), i;
}
function s2() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  for (let t = 0, n = e.length; t < n; t++)
    if (e[t] !== void 0)
      return e[t];
}
const Mne = bm.map((e) => `${e}-inverse`), Rne = ["success", "processing", "error", "default", "warning"];
function DD(e) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? [...Mne, ...bm].includes(e) : bm.includes(e);
}
function Nne(e) {
  return Rne.includes(e);
}
function Fne(e, t) {
  const n = DD(t), r = Ge({
    [`${e}-${t}`]: t && n
  }), a = {}, o = {};
  return t && !n && (a.background = t, o["--antd-arrow-background-color"] = t), {
    className: r,
    overlayStyle: a,
    arrowStyle: o
  };
}
function jh(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return e.map((n) => `${t}${n}`).join(",");
}
const kD = 8;
function MD(e) {
  const t = kD, {
    sizePopupArrow: n,
    contentRadius: r,
    borderRadiusOuter: a,
    limitVerticalRadius: o
  } = e, i = n / 2 - Math.ceil(a * (Math.sqrt(2) - 1)), s = (r > 12 ? r + 2 : 12) - i, l = o ? t - i : s;
  return {
    dropdownArrowOffset: s,
    dropdownArrowOffsetVertical: l
  };
}
function Lne(e, t) {
  const {
    componentCls: n,
    sizePopupArrow: r,
    marginXXS: a,
    borderRadiusXS: o,
    borderRadiusOuter: i,
    boxShadowPopoverArrow: s
  } = e, {
    colorBg: l,
    showArrowCls: u,
    contentRadius: c = e.borderRadiusLG,
    limitVerticalRadius: f
  } = t, {
    dropdownArrowOffsetVertical: d,
    dropdownArrowOffset: p
  } = MD({
    sizePopupArrow: r,
    contentRadius: c,
    borderRadiusOuter: i,
    limitVerticalRadius: f
  }), v = r / 2 + a;
  return {
    [n]: {
      // ============================ Basic ============================
      [`${n}-arrow`]: [D(D({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, Y_(r, o, i, l, s)), {
        "&:before": {
          background: l
        }
      })],
      // ========================== Placement ==========================
      // Here handle the arrow position and rotate stuff
      // >>>>> Top
      [[`&-placement-top ${n}-arrow`, `&-placement-topLeft ${n}-arrow`, `&-placement-topRight ${n}-arrow`].join(",")]: {
        bottom: 0,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top ${n}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      [`&-placement-topLeft ${n}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: p
        }
      },
      [`&-placement-topRight ${n}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: p
        }
      },
      // >>>>> Bottom
      [[`&-placement-bottom ${n}-arrow`, `&-placement-bottomLeft ${n}-arrow`, `&-placement-bottomRight ${n}-arrow`].join(",")]: {
        top: 0,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom ${n}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      [`&-placement-bottomLeft ${n}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: p
        }
      },
      [`&-placement-bottomRight ${n}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: p
        }
      },
      // >>>>> Left
      [[`&-placement-left ${n}-arrow`, `&-placement-leftTop ${n}-arrow`, `&-placement-leftBottom ${n}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: 0
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left ${n}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop ${n}-arrow`]: {
        top: d
      },
      [`&-placement-leftBottom ${n}-arrow`]: {
        bottom: d
      },
      // >>>>> Right
      [[`&-placement-right ${n}-arrow`, `&-placement-rightTop ${n}-arrow`, `&-placement-rightBottom ${n}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: 0
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right ${n}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop ${n}-arrow`]: {
        top: d
      },
      [`&-placement-rightBottom ${n}-arrow`]: {
        bottom: d
      },
      // =========================== Offset ============================
      // Offset the popover to account for the dropdown arrow
      // >>>>> Top
      [jh(["&-placement-topLeft", "&-placement-top", "&-placement-topRight"], u)]: {
        paddingBottom: v
      },
      // >>>>> Bottom
      [jh(["&-placement-bottomLeft", "&-placement-bottom", "&-placement-bottomRight"], u)]: {
        paddingTop: v
      },
      // >>>>> Left
      [jh(["&-placement-leftTop", "&-placement-left", "&-placement-leftBottom"], u)]: {
        paddingRight: {
          _skip_check_: !0,
          value: v
        }
      },
      // >>>>> Right
      [jh(["&-placement-rightTop", "&-placement-right", "&-placement-rightBottom"], u)]: {
        paddingLeft: {
          _skip_check_: !0,
          value: v
        }
      }
    }
  };
}
const Bne = (e) => {
  const {
    componentCls: t,
    // ant-tooltip
    tooltipMaxWidth: n,
    tooltipColor: r,
    tooltipBg: a,
    tooltipBorderRadius: o,
    zIndexPopup: i,
    controlHeight: s,
    boxShadowSecondary: l,
    paddingSM: u,
    paddingXS: c,
    tooltipRadiusOuter: f
  } = e;
  return [
    {
      [t]: D(D(D(D({}, gr(e)), {
        position: "absolute",
        zIndex: i,
        display: "block",
        "&": [{
          width: "max-content"
        }, {
          width: "intrinsic"
        }],
        maxWidth: n,
        visibility: "visible",
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": a,
        // Wrapper for the tooltip content
        [`${t}-inner`]: {
          minWidth: s,
          minHeight: s,
          padding: `${u / 2}px ${c}px`,
          color: r,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: a,
          borderRadius: o,
          boxShadow: l
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${t}-inner`]: {
            borderRadius: Math.min(o, kD)
          }
        },
        [`${t}-content`]: {
          position: "relative"
        }
      }), GI(e, (d, p) => {
        let {
          darkColor: v
        } = p;
        return {
          [`&${t}-${d}`]: {
            [`${t}-inner`]: {
              backgroundColor: v
            },
            [`${t}-arrow`]: {
              "--antd-arrow-background-color": v
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    Lne(xn(e, {
      borderRadiusOuter: f
    }), {
      colorBg: "var(--antd-arrow-background-color)",
      showArrowCls: "",
      contentRadius: o,
      limitVerticalRadius: !0
    }),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none"
      }
    }
  ];
}, Hne = (e, t) => xr("Tooltip", (r) => {
  if ((t == null ? void 0 : t.value) === !1)
    return [];
  const {
    borderRadius: a,
    colorTextLightSolid: o,
    colorBgDefault: i,
    borderRadiusOuter: s
  } = r, l = xn(r, {
    // default variables
    tooltipMaxWidth: 250,
    tooltipColor: o,
    tooltipBorderRadius: a,
    tooltipBg: i,
    tooltipRadiusOuter: s > 4 ? 4 : s
  });
  return [Bne(l), y1(r, "zoom-big-fast")];
}, (r) => {
  let {
    zIndexPopupBase: a,
    colorBgSpotlight: o
  } = r;
  return {
    zIndexPopup: a + 70,
    colorBgDefault: o
  };
})(e), jne = (e, t) => {
  const n = {}, r = D({}, e);
  return t.forEach((a) => {
    e && a in e && (n[a] = e[a], delete r[a]);
  }), {
    picked: n,
    omitted: r
  };
}, Vne = () => D(D({}, Pne()), {
  title: Oe.any
}), Une = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ATooltip",
  inheritAttrs: !1,
  props: ha(Vne(), {
    trigger: "hover",
    align: {},
    placement: "top",
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    arrowPointAtCenter: !1,
    autoAdjustOverflow: !0
  }),
  slots: Object,
  // emits: ['update:visible', 'visibleChange'],
  setup(e, t) {
    let {
      slots: n,
      emit: r,
      attrs: a,
      expose: o
    } = t;
    process.env.NODE_ENV !== "production" && [["visible", "open"], ["onVisibleChange", "onOpenChange"]].forEach((T) => {
      let [O, I] = T;
      Pa(e[O] === void 0, "Tooltip", `\`${O}\` is deprecated, please use \`${I}\` instead.`);
    });
    const {
      prefixCls: i,
      getPopupContainer: s,
      direction: l,
      rootPrefixCls: u
    } = mn("tooltip", e), c = V(() => {
      var T;
      return (T = e.open) !== null && T !== void 0 ? T : e.visible;
    }), f = ne(s2([e.open, e.visible])), d = ne();
    let p;
    He(c, (T) => {
      dn.cancel(p), p = dn(() => {
        f.value = !!T;
      });
    });
    const v = () => {
      var T;
      const O = (T = e.title) !== null && T !== void 0 ? T : n.title;
      return !O && O !== 0;
    }, h = (T) => {
      const O = v();
      c.value === void 0 && (f.value = O ? !1 : T), O || (r("update:visible", T), r("visibleChange", T), r("update:open", T), r("openChange", T));
    };
    o({
      getPopupDomNode: () => d.value.getPopupDomNode(),
      open: f,
      forcePopupAlign: () => {
        var T;
        return (T = d.value) === null || T === void 0 ? void 0 : T.forcePopupAlign();
      }
    });
    const y = V(() => {
      const {
        builtinPlacements: T,
        arrowPointAtCenter: O,
        autoAdjustOverflow: I
      } = e;
      return T || PD({
        arrowPointAtCenter: O,
        autoAdjustOverflow: I
      });
    }), x = (T) => T || T === "", g = (T) => {
      const O = T.type;
      if (typeof O == "object" && T.props && ((O.__ANT_BUTTON === !0 || O === "button") && x(T.props.disabled) || O.__ANT_SWITCH === !0 && (x(T.props.disabled) || x(T.props.loading)) || O.__ANT_RADIO === !0 && x(T.props.disabled))) {
        const {
          picked: I,
          omitted: k
        } = jne(bz(T), ["position", "left", "right", "top", "bottom", "float", "display", "zIndex"]), B = D(D({
          display: "inline-block"
        }, I), {
          cursor: "not-allowed",
          lineHeight: 1,
          width: T.props && T.props.block ? "100%" : void 0
        }), P = D(D({}, k), {
          pointerEvents: "none"
        }), N = sr(T, {
          style: P
        }, !0);
        return A("span", {
          style: B,
          class: `${i.value}-disabled-compatible-wrapper`
        }, [N]);
      }
      return T;
    }, S = () => {
      var T, O;
      return (T = e.title) !== null && T !== void 0 ? T : (O = n.title) === null || O === void 0 ? void 0 : O.call(n);
    }, w = (T, O) => {
      const I = y.value, k = Object.keys(I).find((B) => {
        var P, N;
        return I[B].points[0] === ((P = O.points) === null || P === void 0 ? void 0 : P[0]) && I[B].points[1] === ((N = O.points) === null || N === void 0 ? void 0 : N[1]);
      });
      if (k) {
        const B = T.getBoundingClientRect(), P = {
          top: "50%",
          left: "50%"
        };
        k.indexOf("top") >= 0 || k.indexOf("Bottom") >= 0 ? P.top = `${B.height - O.offset[1]}px` : (k.indexOf("Top") >= 0 || k.indexOf("bottom") >= 0) && (P.top = `${-O.offset[1]}px`), k.indexOf("left") >= 0 || k.indexOf("Right") >= 0 ? P.left = `${B.width - O.offset[0]}px` : (k.indexOf("right") >= 0 || k.indexOf("Left") >= 0) && (P.left = `${-O.offset[0]}px`), T.style.transformOrigin = `${P.left} ${P.top}`;
      }
    }, _ = V(() => Fne(i.value, e.color)), b = V(() => a["data-popover-inject"]), [E, C] = Hne(i, V(() => !b.value));
    return () => {
      var T, O;
      const {
        openClassName: I,
        overlayClassName: k,
        overlayStyle: B,
        overlayInnerStyle: P
      } = e;
      let N = (O = _s((T = n.default) === null || T === void 0 ? void 0 : T.call(n))) !== null && O !== void 0 ? O : null;
      N = N.length === 1 ? N[0] : N;
      let M = f.value;
      if (c.value === void 0 && v() && (M = !1), !N)
        return null;
      const H = g(co(N) && !wz(N) ? N : A("span", null, [N])), R = Ge({
        [I || `${i.value}-open`]: !0,
        [H.props && H.props.class]: H.props && H.props.class
      }), z = Ge(k, {
        [`${i.value}-rtl`]: l.value === "rtl"
      }, _.value.className, C.value), W = D(D({}, _.value.overlayStyle), P), F = _.value.arrowStyle, Y = D(D(D({}, a), e), {
        prefixCls: i.value,
        getPopupContainer: s == null ? void 0 : s.value,
        builtinPlacements: y.value,
        visible: M,
        ref: d,
        overlayClassName: z,
        overlayStyle: D(D({}, F), B),
        overlayInnerStyle: W,
        onVisibleChange: h,
        onPopupAlign: w,
        transitionName: qf(u.value, "zoom-big-fast", e.transitionName)
      });
      return E(A(Ine, Y, {
        default: () => [f.value ? sr(H, {
          class: R
        }) : H],
        arrowContent: () => A("span", {
          class: `${i.value}-arrow-content`
        }, null),
        overlay: S
      }));
    };
  }
}), b1 = yd(Une), Kc = {
  adjustX: 1,
  adjustY: 1
}, Yc = [0, 0], zne = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Kc,
    offset: [0, -4],
    targetOffset: Yc
  },
  topCenter: {
    points: ["bc", "tc"],
    overflow: Kc,
    offset: [0, -4],
    targetOffset: Yc
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Kc,
    offset: [0, -4],
    targetOffset: Yc
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Kc,
    offset: [0, 4],
    targetOffset: Yc
  },
  bottomCenter: {
    points: ["tc", "bc"],
    overflow: Kc,
    offset: [0, 4],
    targetOffset: Yc
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Kc,
    offset: [0, 4],
    targetOffset: Yc
  }
};
var Wne = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const Gne = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  props: {
    minOverlayWidthMatchTrigger: {
      type: Boolean,
      default: void 0
    },
    arrow: {
      type: Boolean,
      default: !1
    },
    prefixCls: Oe.string.def("rc-dropdown"),
    transitionName: String,
    overlayClassName: Oe.string.def(""),
    openClassName: String,
    animation: Oe.any,
    align: Oe.object,
    overlayStyle: {
      type: Object,
      default: void 0
    },
    placement: Oe.string.def("bottomLeft"),
    overlay: Oe.any,
    trigger: Oe.oneOfType([Oe.string, Oe.arrayOf(Oe.string)]).def("hover"),
    alignPoint: {
      type: Boolean,
      default: void 0
    },
    showAction: Oe.array,
    hideAction: Oe.array,
    getPopupContainer: Function,
    visible: {
      type: Boolean,
      default: void 0
    },
    defaultVisible: {
      type: Boolean,
      default: !1
    },
    mouseEnterDelay: Oe.number.def(0.15),
    mouseLeaveDelay: Oe.number.def(0.1)
  },
  emits: ["visibleChange", "overlayClick"],
  setup(e, t) {
    let {
      slots: n,
      emit: r,
      expose: a
    } = t;
    const o = ne(!!e.visible);
    He(() => e.visible, (p) => {
      p !== void 0 && (o.value = p);
    });
    const i = ne();
    a({
      triggerRef: i
    });
    const s = (p) => {
      e.visible === void 0 && (o.value = !1), r("overlayClick", p);
    }, l = (p) => {
      e.visible === void 0 && (o.value = p), r("visibleChange", p);
    }, u = () => {
      var p;
      const v = (p = n.overlay) === null || p === void 0 ? void 0 : p.call(n), h = {
        prefixCls: `${e.prefixCls}-menu`,
        onClick: s
      };
      return A(dt, {
        key: sI
      }, [e.arrow && A("div", {
        class: `${e.prefixCls}-arrow`
      }, null), sr(v, h, !1)]);
    }, c = V(() => {
      const {
        minOverlayWidthMatchTrigger: p = !e.alignPoint
      } = e;
      return p;
    }), f = () => {
      var p;
      const v = (p = n.default) === null || p === void 0 ? void 0 : p.call(n);
      return o.value && v ? sr(v[0], {
        class: e.openClassName || `${e.prefixCls}-open`
      }, !1) : v;
    }, d = V(() => !e.hideAction && e.trigger.indexOf("contextmenu") !== -1 ? ["click"] : e.hideAction);
    return () => {
      const {
        prefixCls: p,
        arrow: v,
        showAction: h,
        overlayStyle: m,
        trigger: y,
        placement: x,
        align: g,
        getPopupContainer: S,
        transitionName: w,
        animation: _,
        overlayClassName: b
      } = e, E = Wne(e, ["prefixCls", "arrow", "showAction", "overlayStyle", "trigger", "placement", "align", "getPopupContainer", "transitionName", "animation", "overlayClassName"]);
      return A(jp, ve(ve({}, E), {}, {
        prefixCls: p,
        ref: i,
        popupClassName: Ge(b, {
          [`${p}-show-arrow`]: v
        }),
        popupStyle: m,
        builtinPlacements: zne,
        action: y,
        showAction: h,
        hideAction: d.value || [],
        popupPlacement: x,
        popupAlign: g,
        popupTransitionName: w,
        popupAnimation: _,
        popupVisible: o.value,
        stretch: c.value ? "minWidth" : "",
        onPopupVisibleChange: l,
        getPopupContainer: S
      }), {
        popup: u,
        default: f
      });
    };
  }
}), Kne = (e) => {
  const {
    componentCls: t,
    colorPrimary: n
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${n})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        }
      }
    }
  };
}, Yne = xr("Wave", (e) => [Kne(e)]);
function qne(e) {
  const t = (e || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
  return t && t[1] && t[2] && t[3] ? !(t[1] === t[2] && t[2] === t[3]) : !0;
}
function By(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && qne(e) && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent";
}
function Xne(e) {
  const {
    borderTopColor: t,
    borderColor: n,
    backgroundColor: r
  } = getComputedStyle(e);
  return By(t) ? t : By(n) ? n : By(r) ? r : null;
}
function Hy(e) {
  return Number.isNaN(e) ? 0 : e;
}
const Zne = /* @__PURE__ */ Me({
  props: {
    target: hn(),
    className: String
  },
  setup(e) {
    const t = Be(null), [n, r] = Ai(null), [a, o] = Ai([]), [i, s] = Ai(0), [l, u] = Ai(0), [c, f] = Ai(0), [d, p] = Ai(0), [v, h] = Ai(!1);
    function m() {
      const {
        target: b
      } = e, E = getComputedStyle(b);
      r(Xne(b));
      const C = E.position === "static", {
        borderLeftWidth: T,
        borderTopWidth: O
      } = E;
      s(C ? b.offsetLeft : Hy(-parseFloat(T))), u(C ? b.offsetTop : Hy(-parseFloat(O))), f(b.offsetWidth), p(b.offsetHeight);
      const {
        borderTopLeftRadius: I,
        borderTopRightRadius: k,
        borderBottomLeftRadius: B,
        borderBottomRightRadius: P
      } = E;
      o([I, k, P, B].map((N) => Hy(parseFloat(N))));
    }
    let y, x, g;
    const S = () => {
      clearTimeout(g), dn.cancel(x), y == null || y.disconnect();
    }, w = () => {
      var b;
      const E = (b = t.value) === null || b === void 0 ? void 0 : b.parentElement;
      E && (ms(null, E), E.parentElement && E.parentElement.removeChild(E));
    };
    Lt(() => {
      S(), g = setTimeout(() => {
        w();
      }, 5e3);
      const {
        target: b
      } = e;
      b && (x = dn(() => {
        m(), h(!0);
      }), typeof ResizeObserver < "u" && (y = new ResizeObserver(m), y.observe(b)));
    }), Sn(() => {
      S();
    });
    const _ = (b) => {
      b.propertyName === "opacity" && w();
    };
    return () => {
      if (!v.value)
        return null;
      const b = {
        left: `${i.value}px`,
        top: `${l.value}px`,
        width: `${c.value}px`,
        height: `${d.value}px`,
        borderRadius: a.value.map((E) => `${E}px`).join(" ")
      };
      return n && (b["--wave-color"] = n.value), A(Ho, {
        appear: !0,
        name: "wave-motion",
        appearFromClass: "wave-motion-appear",
        appearActiveClass: "wave-motion-appear",
        appearToClass: "wave-motion-appear wave-motion-appear-active"
      }, {
        default: () => [A("div", {
          ref: t,
          class: e.className,
          style: b,
          onTransitionend: _
        }, null)]
      });
    };
  }
});
function Qne(e, t) {
  const n = document.createElement("div");
  n.style.position = "absolute", n.style.left = "0px", n.style.top = "0px", e == null || e.insertBefore(n, e == null ? void 0 : e.firstChild), ms(A(Zne, {
    target: e,
    className: t
  }, null), n);
}
function Jne(e, t, n) {
  function r() {
    var a;
    const o = js(e);
    !((a = n == null ? void 0 : n.value) === null || a === void 0) && a.disabled || !o || Qne(o, t.value);
  }
  return r;
}
const RD = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "Wave",
  props: {
    disabled: Boolean
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const r = jn(), {
      prefixCls: a,
      wave: o
    } = mn("wave", e), [, i] = Yne(a), s = Jne(r, V(() => Ge(a.value, i.value)), o);
    let l;
    const u = () => {
      js(r).removeEventListener("click", l, !0);
    };
    return Lt(() => {
      He(() => e.disabled, () => {
        u(), nn(() => {
          const c = js(r);
          c == null || c.removeEventListener("click", l, !0), !(!c || c.nodeType !== 1 || e.disabled) && (l = (f) => {
            f.target.tagName === "INPUT" || !oC(f.target) || // No need wave
            !c.getAttribute || c.getAttribute("disabled") || c.disabled || c.className.includes("disabled") || c.className.includes("-leave") || s();
          }, c.addEventListener("click", l, !0));
        });
      }, {
        immediate: !0,
        flush: "post"
      });
    }), Sn(() => {
      u();
    }), () => {
      var c;
      return (c = n.default) === null || c === void 0 ? void 0 : c.call(n)[0];
    };
  }
});
function ND(e) {
  return e === "danger" ? {
    danger: !0
  } : {
    type: e
  };
}
const FD = () => ({
  prefixCls: String,
  type: String,
  htmlType: {
    type: String,
    default: "button"
  },
  shape: {
    type: String
  },
  size: {
    type: String
  },
  loading: {
    type: [Boolean, Object],
    default: () => !1
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  ghost: {
    type: Boolean,
    default: void 0
  },
  block: {
    type: Boolean,
    default: void 0
  },
  danger: {
    type: Boolean,
    default: void 0
  },
  icon: Oe.any,
  href: String,
  target: String,
  title: String,
  onClick: Vf(),
  onMousedown: Vf()
}), Z$ = (e) => {
  e && (e.style.width = "0px", e.style.opacity = "0", e.style.transform = "scale(0)");
}, Q$ = (e) => {
  nn(() => {
    e && (e.style.width = `${e.scrollWidth}px`, e.style.opacity = "1", e.style.transform = "scale(1)");
  });
}, J$ = (e) => {
  e && e.style && (e.style.width = null, e.style.opacity = null, e.style.transform = null);
}, ere = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "LoadingIcon",
  props: {
    prefixCls: String,
    loading: [Boolean, Object],
    existIcon: Boolean
  },
  setup(e) {
    return () => {
      const {
        existIcon: t,
        prefixCls: n,
        loading: r
      } = e;
      if (t)
        return A("span", {
          class: `${n}-loading-icon`
        }, [A(el, null, null)]);
      const a = !!r;
      return A(Ho, {
        name: `${n}-loading-icon-motion`,
        onBeforeEnter: Z$,
        onEnter: Q$,
        onAfterEnter: J$,
        onBeforeLeave: Q$,
        onLeave: (o) => {
          setTimeout(() => {
            Z$(o);
          });
        },
        onAfterLeave: J$
      }, {
        default: () => [a ? A("span", {
          class: `${n}-loading-icon`
        }, [A(el, null, null)]) : null]
      });
    };
  }
}), e5 = (e, t) => ({
  // Border
  [`> span, > ${e}`]: {
    "&:not(:last-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: t
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: t
        }
      }
    }
  }
}), tre = (e) => {
  const {
    componentCls: t,
    fontSize: n,
    lineWidth: r,
    colorPrimaryHover: a,
    colorErrorHover: o
  } = e;
  return {
    [`${t}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${t}`]: {
          "&:not(:last-child)": {
            [`&, & > ${t}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: -r,
            [`&, & > ${t}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [t]: {
          position: "relative",
          zIndex: 1,
          "&:hover,\n          &:focus,\n          &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${t}-icon-only`]: {
          fontSize: n
        }
      },
      // Border Color
      e5(`${t}-primary`, a),
      e5(`${t}-danger`, o)
    ]
  };
};
function nre(e, t) {
  return {
    // border collapse
    [`&-item:not(${t}-last-item)`]: {
      marginBottom: -e.lineWidth
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function rre(e, t) {
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${t}-first-item:not(${t}-last-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${t}-last-item:not(${t}-first-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function are(e) {
  const t = `${e.componentCls}-compact-vertical`;
  return {
    [t]: D(D({}, nre(e, t)), rre(e.componentCls, t))
  };
}
const ore = (e) => {
  const {
    componentCls: t,
    iconCls: n
  } = e;
  return {
    [t]: {
      outline: "none",
      position: "relative",
      display: "inline-block",
      fontWeight: 400,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      backgroundColor: "transparent",
      border: `${e.lineWidth}px ${e.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      lineHeight: e.lineHeight,
      color: e.colorText,
      "> span": {
        display: "inline-block"
      },
      // Leave a space between icon and text.
      [`> ${n} + span, > span + ${n}`]: {
        marginInlineStart: e.marginXS
      },
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": D({}, sp(e)),
      // make `btn-icon-only` not too narrow
      [`&-icon-only${t}-compact-item`]: {
        flex: "none"
      },
      // Special styles for Primary Button
      [`&-compact-item${t}-primary`]: {
        [`&:not([disabled]) + ${t}-compact-item${t}-primary:not([disabled])`]: {
          position: "relative",
          "&:before": {
            position: "absolute",
            top: -e.lineWidth,
            insetInlineStart: -e.lineWidth,
            display: "inline-block",
            width: e.lineWidth,
            height: `calc(100% + ${e.lineWidth * 2}px)`,
            backgroundColor: e.colorPrimaryHover,
            content: '""'
          }
        }
      },
      // Special styles for Primary Button
      "&-compact-vertical-item": {
        [`&${t}-primary`]: {
          [`&:not([disabled]) + ${t}-compact-vertical-item${t}-primary:not([disabled])`]: {
            position: "relative",
            "&:before": {
              position: "absolute",
              top: -e.lineWidth,
              insetInlineStart: -e.lineWidth,
              display: "inline-block",
              width: `calc(100% + ${e.lineWidth * 2}px)`,
              height: e.lineWidth,
              backgroundColor: e.colorPrimaryHover,
              content: '""'
            }
          }
        }
      }
    }
  };
}, tl = (e, t) => ({
  "&:not(:disabled)": {
    "&:hover": e,
    "&:active": t
  }
}), ire = (e) => ({
  minWidth: e.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), sre = (e) => ({
  borderRadius: e.controlHeight,
  paddingInlineStart: e.controlHeight / 2,
  paddingInlineEnd: e.controlHeight / 2
}), l2 = (e) => ({
  cursor: "not-allowed",
  borderColor: e.colorBorder,
  color: e.colorTextDisabled,
  backgroundColor: e.colorBgContainerDisabled,
  boxShadow: "none"
}), Am = (e, t, n, r, a, o, i) => ({
  [`&${e}-background-ghost`]: D(D({
    color: t || void 0,
    backgroundColor: "transparent",
    borderColor: n || void 0,
    boxShadow: "none"
  }, tl(D({
    backgroundColor: "transparent"
  }, o), D({
    backgroundColor: "transparent"
  }, i))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: r || void 0,
      borderColor: a || void 0
    }
  })
}), HC = (e) => ({
  "&:disabled": D({}, l2(e))
}), LD = (e) => D({}, HC(e)), Im = (e) => ({
  "&:disabled": {
    cursor: "not-allowed",
    color: e.colorTextDisabled
  }
}), BD = (e) => D(D(D(D(D({}, LD(e)), {
  backgroundColor: e.colorBgContainer,
  borderColor: e.colorBorder,
  boxShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlTmpOutline}`
}), tl({
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), Am(e.componentCls, e.colorBgContainer, e.colorBgContainer, e.colorTextDisabled, e.colorBorder)), {
  [`&${e.componentCls}-dangerous`]: D(D(D({
    color: e.colorError,
    borderColor: e.colorError
  }, tl({
    color: e.colorErrorHover,
    borderColor: e.colorErrorBorderHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), Am(e.componentCls, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder)), HC(e))
}), lre = (e) => D(D(D(D(D({}, LD(e)), {
  color: e.colorTextLightSolid,
  backgroundColor: e.colorPrimary,
  boxShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlOutline}`
}), tl({
  color: e.colorTextLightSolid,
  backgroundColor: e.colorPrimaryHover
}, {
  color: e.colorTextLightSolid,
  backgroundColor: e.colorPrimaryActive
})), Am(e.componentCls, e.colorPrimary, e.colorPrimary, e.colorTextDisabled, e.colorBorder, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), {
  [`&${e.componentCls}-dangerous`]: D(D(D({
    backgroundColor: e.colorError,
    boxShadow: `0 ${e.controlOutlineWidth}px 0 ${e.colorErrorOutline}`
  }, tl({
    backgroundColor: e.colorErrorHover
  }, {
    backgroundColor: e.colorErrorActive
  })), Am(e.componentCls, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder, {
    color: e.colorErrorHover,
    borderColor: e.colorErrorHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), HC(e))
}), ure = (e) => D(D({}, BD(e)), {
  borderStyle: "dashed"
}), cre = (e) => D(D(D({
  color: e.colorLink
}, tl({
  color: e.colorLinkHover
}, {
  color: e.colorLinkActive
})), Im(e)), {
  [`&${e.componentCls}-dangerous`]: D(D({
    color: e.colorError
  }, tl({
    color: e.colorErrorHover
  }, {
    color: e.colorErrorActive
  })), Im(e))
}), fre = (e) => D(D(D({}, tl({
  color: e.colorText,
  backgroundColor: e.colorBgTextHover
}, {
  color: e.colorText,
  backgroundColor: e.colorBgTextActive
})), Im(e)), {
  [`&${e.componentCls}-dangerous`]: D(D({
    color: e.colorError
  }, Im(e)), tl({
    color: e.colorErrorHover,
    backgroundColor: e.colorErrorBg
  }, {
    color: e.colorErrorHover,
    backgroundColor: e.colorErrorBg
  }))
}), dre = (e) => D(D({}, l2(e)), {
  [`&${e.componentCls}:hover`]: D({}, l2(e))
}), pre = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-default`]: BD(e),
    [`${t}-primary`]: lre(e),
    [`${t}-dashed`]: ure(e),
    [`${t}-link`]: cre(e),
    [`${t}-text`]: fre(e),
    [`${t}-disabled`]: dre(e)
  };
}, jC = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls: n,
    iconCls: r,
    controlHeight: a,
    fontSize: o,
    lineHeight: i,
    lineWidth: s,
    borderRadius: l,
    buttonPaddingHorizontal: u
  } = e, c = Math.max(0, (a - o * i) / 2 - s), f = u - s, d = `${n}-icon-only`;
  return [
    // Size
    {
      [`${n}${t}`]: {
        fontSize: o,
        height: a,
        padding: `${c}px ${f}px`,
        borderRadius: l,
        [`&${d}`]: {
          width: a,
          paddingInlineStart: 0,
          paddingInlineEnd: 0,
          [`&${n}-round`]: {
            width: "auto"
          },
          "> span": {
            transform: "scale(1.143)"
            // 14px -> 16px
          }
        },
        // Loading
        [`&${n}-loading`]: {
          opacity: e.opacityLoading,
          cursor: "default"
        },
        [`${n}-loading-icon`]: {
          transition: `width ${e.motionDurationSlow} ${e.motionEaseInOut}, opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`
        },
        [`&:not(${d}) ${n}-loading-icon > ${r}`]: {
          marginInlineEnd: e.marginXS
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${n}${n}-circle${t}`]: ire(e)
    },
    {
      [`${n}${n}-round${t}`]: sre(e)
    }
  ];
}, hre = (e) => jC(e), vre = (e) => {
  const t = xn(e, {
    controlHeight: e.controlHeightSM,
    padding: e.paddingXS,
    buttonPaddingHorizontal: 8,
    borderRadius: e.borderRadiusSM
  });
  return jC(t, `${e.componentCls}-sm`);
}, mre = (e) => {
  const t = xn(e, {
    controlHeight: e.controlHeightLG,
    fontSize: e.fontSizeLG,
    borderRadius: e.borderRadiusLG
  });
  return jC(t, `${e.componentCls}-lg`);
}, gre = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`&${t}-block`]: {
        width: "100%"
      }
    }
  };
}, yre = xr("Button", (e) => {
  const {
    controlTmpOutline: t,
    paddingContentHorizontal: n
  } = e, r = xn(e, {
    colorOutlineDefault: t,
    buttonPaddingHorizontal: n
  });
  return [
    // Shared
    ore(r),
    // Size
    vre(r),
    hre(r),
    mre(r),
    // Block
    gre(r),
    // Group (type, ghost, danger, disabled, loading)
    pre(r),
    // Button Group
    tre(r),
    // Space Compact
    x1(e, {
      focus: !1
    }),
    are(e)
  ];
}), xre = () => ({
  prefixCls: String,
  size: {
    type: String
  }
}), HD = TC(), u2 = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AButtonGroup",
  props: xre(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      prefixCls: r,
      direction: a
    } = mn("btn-group", e), [, , o] = bd();
    HD.useProvide(Wn({
      size: V(() => e.size)
    }));
    const i = V(() => {
      const {
        size: s
      } = e;
      let l = "";
      switch (s) {
        case "large":
          l = "lg";
          break;
        case "small":
          l = "sm";
          break;
        case "middle":
        case void 0:
          break;
        default:
          Aa(!s, "Button.Group", "Invalid prop `size`.");
      }
      return {
        [`${r.value}`]: !0,
        [`${r.value}-${l}`]: l,
        [`${r.value}-rtl`]: a.value === "rtl",
        [o.value]: !0
      };
    });
    return () => {
      var s;
      return A("div", {
        class: i.value
      }, [ua((s = n.default) === null || s === void 0 ? void 0 : s.call(n))]);
    };
  }
}), t5 = /^[\u4e00-\u9fa5]{2}$/, n5 = t5.test.bind(t5);
function Vh(e) {
  return e === "text" || e === "link";
}
const fn = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AButton",
  inheritAttrs: !1,
  __ANT_BUTTON: !0,
  props: ha(FD(), {
    type: "default"
  }),
  slots: Object,
  // emits: ['click', 'mousedown'],
  setup(e, t) {
    let {
      slots: n,
      attrs: r,
      emit: a,
      expose: o
    } = t;
    const {
      prefixCls: i,
      autoInsertSpaceInButton: s,
      direction: l,
      size: u
    } = mn("btn", e), [c, f] = yre(i), d = HD.useInject(), p = Ec(), v = V(() => {
      var P;
      return (P = e.disabled) !== null && P !== void 0 ? P : p.value;
    }), h = Be(null), m = Be(void 0);
    let y = !1;
    const x = Be(!1), g = Be(!1), S = V(() => s.value !== !1), {
      compactSize: w,
      compactItemClassnames: _
    } = Wp(i, l), b = V(() => typeof e.loading == "object" && e.loading.delay ? e.loading.delay || !0 : !!e.loading);
    He(b, (P) => {
      clearTimeout(m.value), typeof b.value == "number" ? m.value = setTimeout(() => {
        x.value = P;
      }, b.value) : x.value = P;
    }, {
      immediate: !0
    });
    const E = V(() => {
      const {
        type: P,
        shape: N = "default",
        ghost: M,
        block: H,
        danger: R
      } = e, z = i.value, W = {
        large: "lg",
        small: "sm",
        middle: void 0
      }, F = w.value || (d == null ? void 0 : d.size) || u.value, Y = F && W[F] || "";
      return [_.value, {
        [f.value]: !0,
        [`${z}`]: !0,
        [`${z}-${N}`]: N !== "default" && N,
        [`${z}-${P}`]: P,
        [`${z}-${Y}`]: Y,
        [`${z}-loading`]: x.value,
        [`${z}-background-ghost`]: M && !Vh(P),
        [`${z}-two-chinese-chars`]: g.value && S.value,
        [`${z}-block`]: H,
        [`${z}-dangerous`]: !!R,
        [`${z}-rtl`]: l.value === "rtl"
      }];
    }), C = () => {
      const P = h.value;
      if (!P || s.value === !1)
        return;
      const N = P.textContent;
      y && n5(N) ? g.value || (g.value = !0) : g.value && (g.value = !1);
    }, T = (P) => {
      if (x.value || v.value) {
        P.preventDefault();
        return;
      }
      a("click", P);
    }, O = (P) => {
      a("mousedown", P);
    }, I = (P, N) => {
      const M = N ? " " : "";
      if (P.type === Bi) {
        let H = P.children.trim();
        return n5(H) && (H = H.split("").join(M)), A("span", null, [H]);
      }
      return P;
    };
    return _n(() => {
      Aa(!(e.ghost && Vh(e.type)), "Button", "`link` or `text` button can't be a `ghost` button.");
    }), Lt(C), Qa(C), Sn(() => {
      m.value && clearTimeout(m.value);
    }), o({
      focus: () => {
        var P;
        (P = h.value) === null || P === void 0 || P.focus();
      },
      blur: () => {
        var P;
        (P = h.value) === null || P === void 0 || P.blur();
      }
    }), () => {
      var P, N;
      const {
        icon: M = (P = n.icon) === null || P === void 0 ? void 0 : P.call(n)
      } = e, H = ua((N = n.default) === null || N === void 0 ? void 0 : N.call(n));
      y = H.length === 1 && !M && !Vh(e.type);
      const {
        type: R,
        htmlType: z,
        href: W,
        title: F,
        target: Y
      } = e, X = x.value ? "loading" : M, q = D(D({}, r), {
        title: F,
        disabled: v.value,
        class: [E.value, r.class, {
          [`${i.value}-icon-only`]: H.length === 0 && !!X
        }],
        onClick: T,
        onMousedown: O
      });
      v.value || delete q.disabled;
      const Q = M && !x.value ? M : A(ere, {
        existIcon: !!M,
        prefixCls: i.value,
        loading: !!x.value
      }, null), ue = H.map((te) => I(te, y && S.value));
      if (W !== void 0)
        return c(A("a", ve(ve({}, q), {}, {
          href: W,
          target: Y,
          ref: h
        }), [Q, ue]));
      let le = A("button", ve(ve({}, q), {}, {
        ref: h,
        type: z
      }), [Q, ue]);
      if (!Vh(R)) {
        const te = /* @__PURE__ */ function() {
          return le;
        }();
        le = A(RD, {
          ref: "wave",
          disabled: !!x.value
        }, {
          default: () => [te]
        });
      }
      return c(le);
    };
  }
});
fn.Group = u2;
fn.install = function(e) {
  return e.component(fn.name, fn), e.component(u2.name, u2), e;
};
const jD = () => ({
  arrow: ca([Boolean, Object]),
  trigger: {
    type: [Array, String]
  },
  menu: hn(),
  overlay: Oe.any,
  /** @deprecated Please use `open` instead */
  visible: qt(),
  open: qt(),
  disabled: qt(),
  danger: qt(),
  autofocus: qt(),
  align: hn(),
  getPopupContainer: Function,
  prefixCls: String,
  transitionName: String,
  placement: String,
  overlayClassName: String,
  overlayStyle: hn(),
  forceRender: qt(),
  mouseEnterDelay: Number,
  mouseLeaveDelay: Number,
  openClassName: String,
  minOverlayWidthMatchTrigger: qt(),
  destroyPopupOnHide: qt(),
  /** @deprecated Please use `onOpenChange` instead */
  onVisibleChange: {
    type: Function
  },
  /** @deprecated Please use `onUpdate:open` instead */
  "onUpdate:visible": {
    type: Function
  },
  onOpenChange: {
    type: Function
  },
  "onUpdate:open": {
    type: Function
  }
}), jy = FD(), bre = () => D(D({}, jD()), {
  type: jy.type,
  size: String,
  htmlType: jy.htmlType,
  href: String,
  disabled: qt(),
  prefixCls: String,
  icon: Oe.any,
  title: String,
  loading: jy.loading,
  onClick: Vf()
});
var wre = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" };
function r5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      Sre(e, a, n[a]);
    });
  }
  return e;
}
function Sre(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var w1 = function(t, n) {
  var r = r5({}, t, n.attrs);
  return A(Bn, r5({}, r, {
    icon: wre
  }), null);
};
w1.displayName = "EllipsisOutlined";
w1.inheritAttrs = !1;
const _re = (e) => {
  const {
    componentCls: t,
    antCls: n,
    paddingXS: r,
    opacityLoading: a
  } = e;
  return {
    [`${t}-button`]: {
      whiteSpace: "nowrap",
      [`&${n}-btn-group > ${n}-btn`]: {
        [`&-loading, &-loading + ${n}-btn`]: {
          cursor: "default",
          pointerEvents: "none",
          opacity: a
        },
        [`&:last-child:not(:first-child):not(${n}-btn-icon-only)`]: {
          paddingInline: r
        }
      }
    }
  };
}, Cre = (e) => {
  const {
    componentCls: t,
    menuCls: n,
    colorError: r,
    colorTextLightSolid: a
  } = e, o = `${n}-item`;
  return {
    [`${t}, ${t}-menu-submenu`]: {
      [`${n} ${o}`]: {
        [`&${o}-danger:not(${o}-disabled)`]: {
          color: r,
          "&:hover": {
            color: a,
            backgroundColor: r
          }
        }
      }
    }
  };
}, Ere = (e) => {
  const {
    componentCls: t,
    menuCls: n,
    zIndexPopup: r,
    dropdownArrowDistance: a,
    dropdownArrowOffset: o,
    sizePopupArrow: i,
    antCls: s,
    iconCls: l,
    motionDurationMid: u,
    dropdownPaddingVertical: c,
    fontSize: f,
    dropdownEdgeChildPadding: d,
    colorTextDisabled: p,
    fontSizeIcon: v,
    controlPaddingHorizontal: h,
    colorBgElevated: m,
    boxShadowPopoverArrow: y
  } = e;
  return [
    {
      [t]: D(D({}, gr(e)), {
        position: "absolute",
        top: -9999,
        left: {
          _skip_check_: !0,
          value: -9999
        },
        zIndex: r,
        display: "block",
        // A placeholder out of dropdown visible range to avoid close when user moving
        "&::before": {
          position: "absolute",
          insetBlock: -a + i / 2,
          // insetInlineStart: -7, // FIXME: Seems not work for hidden element
          zIndex: -9999,
          opacity: 1e-4,
          content: '""'
        },
        [`${t}-wrap`]: {
          position: "relative",
          [`${s}-btn > ${l}-down`]: {
            fontSize: v
          },
          [`${l}-down::before`]: {
            transition: `transform ${u}`
          }
        },
        [`${t}-wrap-open`]: {
          [`${l}-down::before`]: {
            transform: "rotate(180deg)"
          }
        },
        "\n        &-hidden,\n        &-menu-hidden,\n        &-menu-submenu-hidden\n      ": {
          display: "none"
        },
        // =============================================================
        // ==                          Arrow                          ==
        // =============================================================
        // Offset the popover to account for the dropdown arrow
        [`
        &-show-arrow${t}-placement-topLeft,
        &-show-arrow${t}-placement-top,
        &-show-arrow${t}-placement-topRight
      `]: {
          paddingBottom: a
        },
        [`
        &-show-arrow${t}-placement-bottomLeft,
        &-show-arrow${t}-placement-bottom,
        &-show-arrow${t}-placement-bottomRight
      `]: {
          paddingTop: a
        },
        // Note: .popover-arrow is outer, .popover-arrow:after is inner
        [`${t}-arrow`]: D({
          position: "absolute",
          zIndex: 1,
          display: "block"
        }, Y_(i, e.borderRadiusXS, e.borderRadiusOuter, m, y)),
        [`
        &-placement-top > ${t}-arrow,
        &-placement-topLeft > ${t}-arrow,
        &-placement-topRight > ${t}-arrow
      `]: {
          bottom: a,
          transform: "translateY(100%) rotate(180deg)"
        },
        [`&-placement-top > ${t}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: "50%"
          },
          transform: "translateX(-50%) translateY(100%) rotate(180deg)"
        },
        [`&-placement-topLeft > ${t}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: o
          }
        },
        [`&-placement-topRight > ${t}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: o
          }
        },
        [`
          &-placement-bottom > ${t}-arrow,
          &-placement-bottomLeft > ${t}-arrow,
          &-placement-bottomRight > ${t}-arrow
        `]: {
          top: a,
          transform: "translateY(-100%)"
        },
        [`&-placement-bottom > ${t}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: "50%"
          },
          transform: "translateY(-100%) translateX(-50%)"
        },
        [`&-placement-bottomLeft > ${t}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: o
          }
        },
        [`&-placement-bottomRight > ${t}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: o
          }
        },
        // =============================================================
        // ==                         Motion                          ==
        // =============================================================
        // When position is not enough for dropdown, the placement will revert.
        // We will handle this with revert motion name.
        [`&${s}-slide-down-enter${s}-slide-down-enter-active${t}-placement-bottomLeft,
          &${s}-slide-down-appear${s}-slide-down-appear-active${t}-placement-bottomLeft,
          &${s}-slide-down-enter${s}-slide-down-enter-active${t}-placement-bottom,
          &${s}-slide-down-appear${s}-slide-down-appear-active${t}-placement-bottom,
          &${s}-slide-down-enter${s}-slide-down-enter-active${t}-placement-bottomRight,
          &${s}-slide-down-appear${s}-slide-down-appear-active${t}-placement-bottomRight`]: {
          animationName: h1
        },
        [`&${s}-slide-up-enter${s}-slide-up-enter-active${t}-placement-topLeft,
          &${s}-slide-up-appear${s}-slide-up-appear-active${t}-placement-topLeft,
          &${s}-slide-up-enter${s}-slide-up-enter-active${t}-placement-top,
          &${s}-slide-up-appear${s}-slide-up-appear-active${t}-placement-top,
          &${s}-slide-up-enter${s}-slide-up-enter-active${t}-placement-topRight,
          &${s}-slide-up-appear${s}-slide-up-appear-active${t}-placement-topRight`]: {
          animationName: m1
        },
        [`&${s}-slide-down-leave${s}-slide-down-leave-active${t}-placement-bottomLeft,
          &${s}-slide-down-leave${s}-slide-down-leave-active${t}-placement-bottom,
          &${s}-slide-down-leave${s}-slide-down-leave-active${t}-placement-bottomRight`]: {
          animationName: v1
        },
        [`&${s}-slide-up-leave${s}-slide-up-leave-active${t}-placement-topLeft,
          &${s}-slide-up-leave${s}-slide-up-leave-active${t}-placement-top,
          &${s}-slide-up-leave${s}-slide-up-leave-active${t}-placement-topRight`]: {
          animationName: g1
        }
      })
    },
    {
      // =============================================================
      // ==                          Menu                           ==
      // =============================================================
      [`${t} ${n}`]: {
        position: "relative",
        margin: 0
      },
      [`${n}-submenu-popup`]: {
        position: "absolute",
        zIndex: r,
        background: "transparent",
        boxShadow: "none",
        transformOrigin: "0 0",
        "ul,li": {
          listStyle: "none"
        },
        ul: {
          marginInline: "0.3em"
        }
      },
      [`${t}, ${t}-menu-submenu`]: {
        [n]: D(D({
          padding: d,
          listStyleType: "none",
          backgroundColor: m,
          backgroundClip: "padding-box",
          borderRadius: e.borderRadiusLG,
          outline: "none",
          boxShadow: e.boxShadowSecondary
        }, sp(e)), {
          [`${n}-item-group-title`]: {
            padding: `${c}px ${h}px`,
            color: e.colorTextDescription,
            transition: `all ${u}`
          },
          // ======================= Item Content =======================
          [`${n}-item`]: {
            position: "relative",
            display: "flex",
            alignItems: "center",
            borderRadius: e.borderRadiusSM
          },
          [`${n}-item-icon`]: {
            minWidth: f,
            marginInlineEnd: e.marginXS,
            fontSize: e.fontSizeSM
          },
          [`${n}-title-content`]: {
            flex: "auto",
            "> a": {
              color: "inherit",
              transition: `all ${u}`,
              "&:hover": {
                color: "inherit"
              },
              "&::after": {
                position: "absolute",
                inset: 0,
                content: '""'
              }
            }
          },
          // =========================== Item ===========================
          [`${n}-item, ${n}-submenu-title`]: D(D({
            clear: "both",
            margin: 0,
            padding: `${c}px ${h}px`,
            color: e.colorText,
            fontWeight: "normal",
            fontSize: f,
            lineHeight: e.lineHeight,
            cursor: "pointer",
            transition: `all ${u}`,
            "&:hover, &-active": {
              backgroundColor: e.controlItemBgHover
            }
          }, sp(e)), {
            "&-selected": {
              color: e.colorPrimary,
              backgroundColor: e.controlItemBgActive,
              "&:hover, &-active": {
                backgroundColor: e.controlItemBgActiveHover
              }
            },
            "&-disabled": {
              color: p,
              cursor: "not-allowed",
              "&:hover": {
                color: p,
                backgroundColor: m,
                cursor: "not-allowed"
              },
              a: {
                pointerEvents: "none"
              }
            },
            "&-divider": {
              height: 1,
              margin: `${e.marginXXS}px 0`,
              overflow: "hidden",
              lineHeight: 0,
              backgroundColor: e.colorSplit
            },
            [`${t}-menu-submenu-expand-icon`]: {
              position: "absolute",
              insetInlineEnd: e.paddingXS,
              [`${t}-menu-submenu-arrow-icon`]: {
                marginInlineEnd: "0 !important",
                color: e.colorTextDescription,
                fontSize: v,
                fontStyle: "normal"
              }
            }
          }),
          [`${n}-item-group-list`]: {
            margin: `0 ${e.marginXS}px`,
            padding: 0,
            listStyle: "none"
          },
          [`${n}-submenu-title`]: {
            paddingInlineEnd: h + e.fontSizeSM
          },
          [`${n}-submenu-vertical`]: {
            position: "relative"
          },
          [`${n}-submenu${n}-submenu-disabled ${t}-menu-submenu-title`]: {
            [`&, ${t}-menu-submenu-arrow-icon`]: {
              color: p,
              backgroundColor: m,
              cursor: "not-allowed"
            }
          },
          // https://github.com/ant-design/ant-design/issues/19264
          [`${n}-submenu-selected ${t}-menu-submenu-title`]: {
            color: e.colorPrimary
          }
        })
      }
    },
    // Follow code may reuse in other components
    [nu(e, "slide-up"), nu(e, "slide-down"), Xf(e, "move-up"), Xf(e, "move-down"), y1(e, "zoom-big")]
  ];
}, VD = xr("Dropdown", (e, t) => {
  let {
    rootPrefixCls: n
  } = t;
  const {
    marginXXS: r,
    sizePopupArrow: a,
    controlHeight: o,
    fontSize: i,
    lineHeight: s,
    paddingXXS: l,
    componentCls: u,
    borderRadiusOuter: c,
    borderRadiusLG: f
  } = e, d = (o - i * s) / 2, {
    dropdownArrowOffset: p
  } = MD({
    sizePopupArrow: a,
    contentRadius: f,
    borderRadiusOuter: c
  }), v = xn(e, {
    menuCls: `${u}-menu`,
    rootPrefixCls: n,
    dropdownArrowDistance: a / 2 + r,
    dropdownArrowOffset: p,
    dropdownPaddingVertical: d,
    dropdownEdgeChildPadding: l
  });
  return [Ere(v), _re(v), Cre(v)];
}, (e) => ({
  zIndexPopup: e.zIndexPopupBase + 50
}));
var Tre = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const $re = fn.Group, Pm = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ADropdownButton",
  inheritAttrs: !1,
  __ANT_BUTTON: !0,
  props: ha(bre(), {
    trigger: "hover",
    placement: "bottomRight",
    type: "default"
  }),
  // emits: ['click', 'visibleChange', 'update:visible'],s
  slots: Object,
  setup(e, t) {
    let {
      slots: n,
      attrs: r,
      emit: a
    } = t;
    const o = (d) => {
      a("update:visible", d), a("visibleChange", d), a("update:open", d), a("openChange", d);
    }, {
      prefixCls: i,
      direction: s,
      getPopupContainer: l
    } = mn("dropdown", e), u = V(() => `${i.value}-button`), [c, f] = VD(i);
    return () => {
      var d, p;
      const v = D(D({}, e), r), {
        type: h = "default",
        disabled: m,
        danger: y,
        loading: x,
        htmlType: g,
        class: S = "",
        overlay: w = (d = n.overlay) === null || d === void 0 ? void 0 : d.call(n),
        trigger: _,
        align: b,
        open: E,
        visible: C,
        onVisibleChange: T,
        placement: O = s.value === "rtl" ? "bottomLeft" : "bottomRight",
        href: I,
        title: k,
        icon: B = ((p = n.icon) === null || p === void 0 ? void 0 : p.call(n)) || A(w1, null, null),
        mouseEnterDelay: P,
        mouseLeaveDelay: N,
        overlayClassName: M,
        overlayStyle: H,
        destroyPopupOnHide: R,
        onClick: z,
        "onUpdate:open": W
      } = v, F = Tre(v, ["type", "disabled", "danger", "loading", "htmlType", "class", "overlay", "trigger", "align", "open", "visible", "onVisibleChange", "placement", "href", "title", "icon", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyPopupOnHide", "onClick", "onUpdate:open"]), Y = {
        align: b,
        disabled: m,
        trigger: m ? [] : _,
        placement: O,
        getPopupContainer: l == null ? void 0 : l.value,
        onOpenChange: o,
        mouseEnterDelay: P,
        mouseLeaveDelay: N,
        open: E ?? C,
        overlayClassName: M,
        overlayStyle: H,
        destroyPopupOnHide: R
      }, X = A(fn, {
        danger: y,
        type: h,
        disabled: m,
        loading: x,
        onClick: z,
        htmlType: g,
        href: I,
        title: k
      }, {
        default: n.default
      }), q = A(fn, {
        danger: y,
        type: h,
        icon: B
      }, null);
      return c(A($re, ve(ve({}, F), {}, {
        class: Ge(u.value, S, f.value)
      }), {
        default: () => [n.leftButton ? n.leftButton({
          button: X
        }) : X, A(cs, Y, {
          default: () => [n.rightButton ? n.rightButton({
            button: q
          }) : q],
          overlay: () => w
        })]
      }));
    };
  }
});
var Ore = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" };
function a5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      Are(e, a, n[a]);
    });
  }
  return e;
}
function Are(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Zf = function(t, n) {
  var r = a5({}, t, n.attrs);
  return A(Bn, a5({}, r, {
    icon: Ore
  }), null);
};
Zf.displayName = "RightOutlined";
Zf.inheritAttrs = !1;
const UD = Symbol("OverrideContextKey"), zD = () => Ke(UD, void 0), Ire = (e) => {
  var t, n, r;
  const {
    prefixCls: a,
    mode: o,
    selectable: i,
    validator: s,
    onClick: l,
    expandIcon: u
  } = zD() || {};
  kt(UD, {
    prefixCls: V(() => {
      var c, f;
      return (f = (c = e.prefixCls) === null || c === void 0 ? void 0 : c.value) !== null && f !== void 0 ? f : a == null ? void 0 : a.value;
    }),
    mode: V(() => {
      var c, f;
      return (f = (c = e.mode) === null || c === void 0 ? void 0 : c.value) !== null && f !== void 0 ? f : o == null ? void 0 : o.value;
    }),
    selectable: V(() => {
      var c, f;
      return (f = (c = e.selectable) === null || c === void 0 ? void 0 : c.value) !== null && f !== void 0 ? f : i == null ? void 0 : i.value;
    }),
    validator: (t = e.validator) !== null && t !== void 0 ? t : s,
    onClick: (n = e.onClick) !== null && n !== void 0 ? n : l,
    expandIcon: (r = e.expandIcon) !== null && r !== void 0 ? r : u == null ? void 0 : u.value
  });
}, cs = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ADropdown",
  inheritAttrs: !1,
  props: ha(jD(), {
    mouseEnterDelay: 0.15,
    mouseLeaveDelay: 0.1,
    placement: "bottomLeft",
    trigger: "hover"
  }),
  // emits: ['visibleChange', 'update:visible'],
  slots: Object,
  setup(e, t) {
    let {
      slots: n,
      attrs: r,
      emit: a
    } = t;
    const {
      prefixCls: o,
      rootPrefixCls: i,
      direction: s,
      getPopupContainer: l
    } = mn("dropdown", e), [u, c] = VD(o);
    process.env.NODE_ENV !== "production" && [["visible", "open"], ["onVisibleChange", "onOpenChange"], ["onUpdate:visible", "onUpdate:open"]].forEach((m) => {
      let [y, x] = m;
      Pa(e[y] === void 0, "Dropdown", `\`${y}\` is deprecated which will be removed in next major version, please use \`${x}\` instead.`);
    });
    const f = V(() => {
      const {
        placement: m = "",
        transitionName: y
      } = e;
      return y !== void 0 ? y : m.includes("top") ? `${i.value}-slide-down` : `${i.value}-slide-up`;
    });
    Ire({
      prefixCls: V(() => `${o.value}-menu`),
      expandIcon: V(() => A("span", {
        class: `${o.value}-menu-submenu-arrow`
      }, [A(Zf, {
        class: `${o.value}-menu-submenu-arrow-icon`
      }, null)])),
      mode: V(() => "vertical"),
      selectable: V(() => !1),
      onClick: () => {
      },
      validator: (m) => {
        let {
          mode: y
        } = m;
        Pa(!y || y === "vertical", "Dropdown", `mode="${y}" is not supported for Dropdown's Menu.`);
      }
    });
    const d = () => {
      var m, y, x;
      const g = e.overlay || ((m = n.overlay) === null || m === void 0 ? void 0 : m.call(n)), S = Array.isArray(g) ? g[0] : g;
      if (!S) return null;
      const w = S.props || {};
      Aa(!w.mode || w.mode === "vertical", "Dropdown", `mode="${w.mode}" is not supported for Dropdown's Menu.`);
      const {
        selectable: _ = !1,
        expandIcon: b = (x = (y = S.children) === null || y === void 0 ? void 0 : y.expandIcon) === null || x === void 0 ? void 0 : x.call(y)
      } = w, E = typeof b < "u" && co(b) ? b : A("span", {
        class: `${o.value}-menu-submenu-arrow`
      }, [A(Zf, {
        class: `${o.value}-menu-submenu-arrow-icon`
      }, null)]);
      return co(S) ? sr(S, {
        mode: "vertical",
        selectable: _,
        expandIcon: () => E
      }) : S;
    }, p = V(() => {
      const m = e.placement;
      if (!m)
        return s.value === "rtl" ? "bottomRight" : "bottomLeft";
      if (m.includes("Center")) {
        const y = m.slice(0, m.indexOf("Center"));
        return Aa(!m.includes("Center"), "Dropdown", `You are using '${m}' placement in Dropdown, which is deprecated. Try to use '${y}' instead.`), y;
      }
      return m;
    }), v = V(() => typeof e.visible == "boolean" ? e.visible : e.open), h = (m) => {
      a("update:visible", m), a("visibleChange", m), a("update:open", m), a("openChange", m);
    };
    return () => {
      var m, y;
      const {
        arrow: x,
        trigger: g,
        disabled: S,
        overlayClassName: w
      } = e, _ = (m = n.default) === null || m === void 0 ? void 0 : m.call(n)[0], b = sr(_, D({
        class: Ge((y = _ == null ? void 0 : _.props) === null || y === void 0 ? void 0 : y.class, {
          [`${o.value}-rtl`]: s.value === "rtl"
        }, `${o.value}-trigger`)
      }, S ? {
        disabled: S
      } : {})), E = Ge(w, c.value, {
        [`${o.value}-rtl`]: s.value === "rtl"
      }), C = S ? [] : g;
      let T;
      C && C.includes("contextmenu") && (T = !0);
      const O = PD({
        arrowPointAtCenter: typeof x == "object" && x.pointAtCenter,
        autoAdjustOverflow: !0
      }), I = Lr(D(D(D({}, e), r), {
        visible: v.value,
        builtinPlacements: O,
        overlayClassName: E,
        arrow: !!x,
        alignPoint: T,
        prefixCls: o.value,
        getPopupContainer: l == null ? void 0 : l.value,
        transitionName: f.value,
        trigger: C,
        onVisibleChange: h,
        placement: p.value
      }), ["overlay", "onUpdate:visible"]);
      return u(A(Gne, I, {
        default: () => [b],
        overlay: d
      }));
    };
  }
});
cs.Button = Pm;
function Pre(e, t, n, r) {
  let a;
  if (a !== void 0)
    return !!a;
  if (e === t)
    return !0;
  if (typeof e != "object" || !e || typeof t != "object" || !t)
    return !1;
  const o = Object.keys(e), i = Object.keys(t);
  if (o.length !== i.length)
    return !1;
  const s = Object.prototype.hasOwnProperty.bind(t);
  for (let l = 0; l < o.length; l++) {
    const u = o[l];
    if (!s(u))
      return !1;
    const c = e[u], f = t[u];
    if (a = void 0, a === !1 || a === void 0 && c !== f)
      return !1;
  }
  return !0;
}
function of(e, t) {
  return Pre(At(e), At(t));
}
const WD = Symbol("menuContextKey"), GD = (e) => {
  kt(WD, e);
}, sl = () => Ke(WD), KD = Symbol("ForceRenderKey"), Dre = (e) => {
  kt(KD, e);
}, YD = () => Ke(KD, !1), qD = Symbol("menuFirstLevelContextKey"), XD = (e) => {
  kt(qD, e);
}, kre = () => Ke(qD, !0), Dm = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "MenuContextProvider",
  inheritAttrs: !1,
  props: {
    mode: {
      type: String,
      default: void 0
    },
    overflowDisabled: {
      type: Boolean,
      default: void 0
    }
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const r = sl(), a = D({}, r);
    return e.mode !== void 0 && (a.mode = Tt(e, "mode")), e.overflowDisabled !== void 0 && (a.overflowDisabled = Tt(e, "overflowDisabled")), GD(a), () => {
      var o;
      return (o = n.default) === null || o === void 0 ? void 0 : o.call(n);
    };
  }
}), Mre = GD, Rre = Symbol("siderCollapsed"), Uh = "$$__vc-menu-more__key", ZD = Symbol("KeyPathContext"), VC = () => Ke(ZD, {
  parentEventKeys: V(() => []),
  parentKeys: V(() => []),
  parentInfo: {}
}), Nre = (e, t, n) => {
  const {
    parentEventKeys: r,
    parentKeys: a
  } = VC(), o = V(() => [...r.value, e]), i = V(() => [...a.value, t]);
  return kt(ZD, {
    parentEventKeys: o,
    parentKeys: i,
    parentInfo: n
  }), i;
}, QD = Symbol("measure"), o5 = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    return kt(QD, !0), () => {
      var r;
      return (r = n.default) === null || r === void 0 ? void 0 : r.call(n);
    };
  }
}), UC = () => Ke(QD, !1), Fre = Nre;
function JD(e) {
  const {
    mode: t,
    rtl: n,
    inlineIndent: r
  } = sl();
  return V(() => t.value !== "inline" ? null : n.value ? {
    paddingRight: `${e.value * r.value}px`
  } : {
    paddingLeft: `${e.value * r.value}px`
  });
}
let Lre = 0;
const Bre = () => ({
  id: String,
  role: String,
  disabled: Boolean,
  danger: Boolean,
  title: {
    type: [String, Boolean],
    default: void 0
  },
  icon: Oe.any,
  onMouseenter: Function,
  onMouseleave: Function,
  onClick: Function,
  onKeydown: Function,
  onFocus: Function,
  // Internal user prop
  originItemValue: hn()
}), Qf = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AMenuItem",
  inheritAttrs: !1,
  props: Bre(),
  slots: Object,
  setup(e, t) {
    let {
      slots: n,
      emit: r,
      attrs: a
    } = t;
    const o = jn(), i = UC(), s = typeof o.vnode.key == "symbol" ? String(o.vnode.key) : o.vnode.key;
    Aa(typeof o.vnode.key != "symbol", "MenuItem", `MenuItem \`:key="${String(s)}"\` not support Symbol type`);
    const l = `menu_item_${++Lre}_$$_${s}`, {
      parentEventKeys: u,
      parentKeys: c
    } = VC(), {
      prefixCls: f,
      activeKeys: d,
      disabled: p,
      changeActiveKeys: v,
      rtl: h,
      inlineCollapsed: m,
      siderCollapsed: y,
      onItemClick: x,
      selectedKeys: g,
      registerMenuInfo: S,
      unRegisterMenuInfo: w
    } = sl(), _ = kre(), b = Be(!1), E = V(() => [...c.value, s]);
    S(l, {
      eventKey: l,
      key: s,
      parentEventKeys: u,
      parentKeys: c,
      isLeaf: !0
    }), Sn(() => {
      w(l);
    }), He(d, () => {
      b.value = !!d.value.find((W) => W === s);
    }, {
      immediate: !0
    });
    const T = V(() => p.value || e.disabled), O = V(() => g.value.includes(s)), I = V(() => {
      const W = `${f.value}-item`;
      return {
        [`${W}`]: !0,
        [`${W}-danger`]: e.danger,
        [`${W}-active`]: b.value,
        [`${W}-selected`]: O.value,
        [`${W}-disabled`]: T.value
      };
    }), k = (W) => ({
      key: s,
      eventKey: l,
      keyPath: E.value,
      eventKeyPath: [...u.value, l],
      domEvent: W,
      item: D(D({}, e), a)
    }), B = (W) => {
      if (T.value)
        return;
      const F = k(W);
      r("click", W), x(F);
    }, P = (W) => {
      T.value || (v(E.value), r("mouseenter", W));
    }, N = (W) => {
      T.value || (v([]), r("mouseleave", W));
    }, M = (W) => {
      if (r("keydown", W), W.which === Ye.ENTER) {
        const F = k(W);
        r("click", W), x(F);
      }
    }, H = (W) => {
      v(E.value), r("focus", W);
    }, R = (W, F) => {
      const Y = A("span", {
        class: `${f.value}-title-content`
      }, [F]);
      return (!W || co(F) && F.type === "span") && F && m.value && _ && typeof F == "string" ? A("div", {
        class: `${f.value}-inline-collapsed-noicon`
      }, [F.charAt(0)]) : Y;
    }, z = JD(V(() => E.value.length));
    return () => {
      var W, F, Y, X, q;
      if (i) return null;
      const Q = (W = e.title) !== null && W !== void 0 ? W : (F = n.title) === null || F === void 0 ? void 0 : F.call(n), ue = ua((Y = n.default) === null || Y === void 0 ? void 0 : Y.call(n)), le = ue.length;
      let te = Q;
      typeof Q > "u" ? te = _ && le ? ue : "" : Q === !1 && (te = "");
      const G = {
        title: te
      };
      !y.value && !m.value && (G.title = null, G.open = !1);
      const oe = {};
      e.role === "option" && (oe["aria-selected"] = O.value);
      const L = (X = e.icon) !== null && X !== void 0 ? X : (q = n.icon) === null || q === void 0 ? void 0 : q.call(n, e);
      return A(b1, ve(ve({}, G), {}, {
        placement: h.value ? "left" : "right",
        overlayClassName: `${f.value}-inline-collapsed-tooltip`
      }), {
        default: () => [A(Gs.Item, ve(ve(ve({
          component: "li"
        }, a), {}, {
          id: e.id,
          style: D(D({}, a.style || {}), z.value),
          class: [I.value, {
            [`${a.class}`]: !!a.class,
            [`${f.value}-item-only-child`]: (L ? le + 1 : le) === 1
          }],
          role: e.role || "menuitem",
          tabindex: e.disabled ? null : -1,
          "data-menu-id": s,
          "aria-disabled": e.disabled
        }, oe), {}, {
          onMouseenter: P,
          onMouseleave: N,
          onClick: B,
          onKeydown: M,
          onFocus: H,
          title: typeof Q == "string" ? Q : void 0
        }), {
          default: () => [sr(typeof L == "function" ? L(e.originItemValue) : L, {
            class: `${f.value}-item-icon`
          }, !1), R(L, ue)]
        })]
      });
    };
  }
}), Nl = {
  adjustX: 1,
  adjustY: 1
}, Hre = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Nl,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Nl,
    offset: [0, 7]
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: Nl,
    offset: [-4, 0]
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: Nl,
    offset: [4, 0]
  }
}, jre = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Nl,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Nl,
    offset: [0, 7]
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: Nl,
    offset: [-4, 0]
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: Nl,
    offset: [4, 0]
  }
}, Vre = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
}, i5 = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "PopupTrigger",
  inheritAttrs: !1,
  props: {
    prefixCls: String,
    mode: String,
    visible: Boolean,
    // popup: React.ReactNode;
    popupClassName: String,
    popupOffset: Array,
    disabled: Boolean,
    onVisibleChange: Function
  },
  slots: Object,
  emits: ["visibleChange"],
  setup(e, t) {
    let {
      slots: n,
      emit: r
    } = t;
    const a = Be(!1), {
      getPopupContainer: o,
      rtl: i,
      subMenuOpenDelay: s,
      subMenuCloseDelay: l,
      builtinPlacements: u,
      triggerSubMenuAction: c,
      forceSubMenuRender: f,
      motion: d,
      defaultMotions: p,
      rootClassName: v
    } = sl(), h = YD(), m = V(() => i.value ? D(D({}, jre), u.value) : D(D({}, Hre), u.value)), y = V(() => Vre[e.mode]), x = Be();
    He(() => e.visible, (w) => {
      dn.cancel(x.value), x.value = dn(() => {
        a.value = w;
      });
    }, {
      immediate: !0
    }), Sn(() => {
      dn.cancel(x.value);
    });
    const g = (w) => {
      r("visibleChange", w);
    }, S = V(() => {
      var w, _;
      const b = d.value || ((w = p.value) === null || w === void 0 ? void 0 : w[e.mode]) || ((_ = p.value) === null || _ === void 0 ? void 0 : _.other), E = typeof b == "function" ? b() : b;
      return E ? Hp(E.name, {
        css: !0
      }) : void 0;
    });
    return () => {
      const {
        prefixCls: w,
        popupClassName: _,
        mode: b,
        popupOffset: E,
        disabled: C
      } = e;
      return A(jp, {
        prefixCls: w,
        popupClassName: Ge(`${w}-popup`, {
          [`${w}-rtl`]: i.value
        }, _, v.value),
        stretch: b === "horizontal" ? "minWidth" : null,
        getPopupContainer: o.value,
        builtinPlacements: m.value,
        popupPlacement: y.value,
        popupVisible: a.value,
        popupAlign: E && {
          offset: E
        },
        action: C ? [] : [c.value],
        mouseEnterDelay: s.value,
        mouseLeaveDelay: l.value,
        onPopupVisibleChange: g,
        forceRender: h || f.value,
        popupAnimation: S.value
      }, {
        popup: n.popup,
        default: n.default
      });
    };
  }
}), zC = (e, t) => {
  let {
    slots: n,
    attrs: r
  } = t;
  var a;
  const {
    prefixCls: o,
    mode: i
  } = sl();
  return A("ul", ve(ve({}, r), {}, {
    class: Ge(o.value, `${o.value}-sub`, `${o.value}-${i.value === "inline" ? "inline" : "vertical"}`),
    "data-menu-list": !0
  }), [(a = n.default) === null || a === void 0 ? void 0 : a.call(n)]);
};
zC.displayName = "SubMenuList";
const Ure = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "InlineSubMenuList",
  inheritAttrs: !1,
  props: {
    id: String,
    open: Boolean,
    keyPath: Array
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const r = V(() => "inline"), {
      motion: a,
      mode: o,
      defaultMotions: i
    } = sl(), s = V(() => o.value === r.value), l = ne(!s.value), u = V(() => s.value ? e.open : !1);
    He(o, () => {
      s.value && (l.value = !1);
    }, {
      flush: "post"
    });
    const c = V(() => {
      var f, d;
      const p = a.value || ((f = i.value) === null || f === void 0 ? void 0 : f[r.value]) || ((d = i.value) === null || d === void 0 ? void 0 : d.other), v = typeof p == "function" ? p() : p;
      return D(D({}, v), {
        appear: e.keyPath.length <= 1
      });
    });
    return () => {
      var f;
      return l.value ? null : A(Dm, {
        mode: r.value
      }, {
        default: () => [A(Ho, c.value, {
          default: () => [Yn(A(zC, {
            id: e.id
          }, {
            default: () => [(f = n.default) === null || f === void 0 ? void 0 : f.call(n)]
          }), [[ko, u.value]])]
        })]
      });
    };
  }
});
let s5 = 0;
const zre = () => ({
  icon: Oe.any,
  title: Oe.any,
  disabled: Boolean,
  level: Number,
  popupClassName: String,
  popupOffset: Array,
  internalPopupClose: Boolean,
  eventKey: String,
  expandIcon: Function,
  theme: String,
  onMouseenter: Function,
  onMouseleave: Function,
  onTitleClick: Function,
  // Internal user prop
  originItemValue: hn()
}), Jf = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ASubMenu",
  inheritAttrs: !1,
  props: zre(),
  slots: Object,
  setup(e, t) {
    let {
      slots: n,
      attrs: r,
      emit: a
    } = t;
    var o, i;
    XD(!1);
    const s = UC(), l = jn(), u = typeof l.vnode.key == "symbol" ? String(l.vnode.key) : l.vnode.key;
    Aa(typeof l.vnode.key != "symbol", "SubMenu", `SubMenu \`:key="${String(u)}"\` not support Symbol type`);
    const c = Ab(u) ? u : `sub_menu_${++s5}_$$_not_set_key`, f = (o = e.eventKey) !== null && o !== void 0 ? o : Ab(u) ? `sub_menu_${++s5}_$$_${u}` : c, {
      parentEventKeys: d,
      parentInfo: p,
      parentKeys: v
    } = VC(), h = V(() => [...v.value, c]), m = Be([]), y = {
      eventKey: f,
      key: c,
      parentEventKeys: d,
      childrenEventKeys: m,
      parentKeys: v
    };
    (i = p.childrenEventKeys) === null || i === void 0 || i.value.push(f), Sn(() => {
      var Z;
      p.childrenEventKeys && (p.childrenEventKeys.value = (Z = p.childrenEventKeys) === null || Z === void 0 ? void 0 : Z.value.filter((se) => se != f));
    }), Fre(f, c, y);
    const {
      prefixCls: x,
      activeKeys: g,
      disabled: S,
      changeActiveKeys: w,
      mode: _,
      inlineCollapsed: b,
      openKeys: E,
      overflowDisabled: C,
      onOpenChange: T,
      registerMenuInfo: O,
      unRegisterMenuInfo: I,
      selectedSubMenuKeys: k,
      expandIcon: B,
      theme: P
    } = sl(), N = u != null, M = !s && (YD() || !N);
    Dre(M), (s && N || !s && !N || M) && (O(f, y), Sn(() => {
      I(f);
    }));
    const H = V(() => `${x.value}-submenu`), R = V(() => S.value || e.disabled), z = Be(), W = Be(), F = V(() => E.value.includes(c)), Y = V(() => !C.value && F.value), X = V(() => k.value.includes(c)), q = Be(!1);
    He(g, () => {
      q.value = !!g.value.find((Z) => Z === c);
    }, {
      immediate: !0
    });
    const Q = (Z) => {
      R.value || (a("titleClick", Z, c), _.value === "inline" && T(c, !F.value));
    }, ue = (Z) => {
      R.value || (w(h.value), a("mouseenter", Z));
    }, le = (Z) => {
      R.value || (w([]), a("mouseleave", Z));
    }, te = JD(V(() => h.value.length)), G = (Z) => {
      _.value !== "inline" && T(c, Z);
    }, oe = () => {
      w(h.value);
    }, L = f && `${f}-popup`, re = V(() => Ge(x.value, `${x.value}-${e.theme || P.value}`, e.popupClassName)), j = (Z, se) => {
      if (!se)
        return b.value && !v.value.length && Z && typeof Z == "string" ? A("div", {
          class: `${x.value}-inline-collapsed-noicon`
        }, [Z.charAt(0)]) : A("span", {
          class: `${x.value}-title-content`
        }, [Z]);
      const me = co(Z) && Z.type === "span";
      return A(dt, null, [sr(typeof se == "function" ? se(e.originItemValue) : se, {
        class: `${x.value}-item-icon`
      }, !1), me ? Z : A("span", {
        class: `${x.value}-title-content`
      }, [Z])]);
    }, J = V(() => _.value !== "inline" && h.value.length > 1 ? "vertical" : _.value), ae = V(() => _.value === "horizontal" ? "vertical" : _.value), he = V(() => J.value === "horizontal" ? "vertical" : J.value), K = () => {
      var Z, se;
      const me = H.value, xe = (Z = e.icon) !== null && Z !== void 0 ? Z : (se = n.icon) === null || se === void 0 ? void 0 : se.call(n, e), be = e.expandIcon || n.expandIcon || B.value, Te = j(zg(n, e, "title"), xe);
      return A("div", {
        style: te.value,
        class: `${me}-title`,
        tabindex: R.value ? null : -1,
        ref: z,
        title: typeof Te == "string" ? Te : null,
        "data-menu-id": c,
        "aria-expanded": Y.value,
        "aria-haspopup": !0,
        "aria-controls": L,
        "aria-disabled": R.value,
        onClick: Q,
        onFocus: oe
      }, [Te, _.value !== "horizontal" && be ? be(D(D({}, e), {
        isOpen: Y.value
      })) : A("i", {
        class: `${me}-arrow`
      }, null)]);
    };
    return () => {
      var Z;
      if (s)
        return N ? (Z = n.default) === null || Z === void 0 ? void 0 : Z.call(n) : null;
      const se = H.value;
      let me = () => null;
      if (!C.value && _.value !== "inline") {
        const xe = _.value === "horizontal" ? [0, 8] : [10, 0];
        me = () => A(i5, {
          mode: J.value,
          prefixCls: se,
          visible: !e.internalPopupClose && Y.value,
          popupClassName: re.value,
          popupOffset: e.popupOffset || xe,
          disabled: R.value,
          onVisibleChange: G
        }, {
          default: () => [K()],
          popup: () => A(Dm, {
            mode: he.value
          }, {
            default: () => [A(zC, {
              id: L,
              ref: W
            }, {
              default: n.default
            })]
          })
        });
      } else
        me = () => A(i5, null, {
          default: K
        });
      return A(Dm, {
        mode: ae.value
      }, {
        default: () => [A(Gs.Item, ve(ve({
          component: "li"
        }, r), {}, {
          role: "none",
          class: Ge(se, `${se}-${_.value}`, r.class, {
            [`${se}-open`]: Y.value,
            [`${se}-active`]: q.value,
            [`${se}-selected`]: X.value,
            [`${se}-disabled`]: R.value
          }),
          onMouseenter: ue,
          onMouseleave: le,
          "data-submenu-id": c
        }), {
          default: () => A(dt, null, [me(), !C.value && A(Ure, {
            id: L,
            open: Y.value,
            keyPath: h.value
          }, {
            default: n.default
          })])
        })]
      });
    };
  }
});
function ek(e, t) {
  return e.classList ? e.classList.contains(t) : ` ${e.className} `.indexOf(` ${t} `) > -1;
}
function l5(e, t) {
  e.classList ? e.classList.add(t) : ek(e, t) || (e.className = `${e.className} ${t}`);
}
function u5(e, t) {
  if (e.classList)
    e.classList.remove(t);
  else if (ek(e, t)) {
    const n = e.className;
    e.className = ` ${n} `.replace(` ${t} `, " ");
  }
}
const tk = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ant-motion-collapse", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return {
    name: e,
    appear: t,
    css: !0,
    onBeforeEnter: (n) => {
      n.style.height = "0px", n.style.opacity = "0", l5(n, e);
    },
    onEnter: (n) => {
      nn(() => {
        n.style.height = `${n.scrollHeight}px`, n.style.opacity = "1";
      });
    },
    onAfterEnter: (n) => {
      n && (u5(n, e), n.style.height = null, n.style.opacity = null);
    },
    onBeforeLeave: (n) => {
      l5(n, e), n.style.height = `${n.offsetHeight}px`, n.style.opacity = null;
    },
    onLeave: (n) => {
      setTimeout(() => {
        n.style.height = "0px", n.style.opacity = "0";
      });
    },
    onAfterLeave: (n) => {
      n && (u5(n, e), n.style && (n.style.height = null, n.style.opacity = null));
    }
  };
}, Wre = () => ({
  title: Oe.any,
  // Internal user prop
  originItemValue: hn()
}), km = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AMenuItemGroup",
  inheritAttrs: !1,
  props: Wre(),
  slots: Object,
  setup(e, t) {
    let {
      slots: n,
      attrs: r
    } = t;
    const {
      prefixCls: a
    } = sl(), o = V(() => `${a.value}-item-group`), i = UC();
    return () => {
      var s, l;
      return i ? (s = n.default) === null || s === void 0 ? void 0 : s.call(n) : A("li", ve(ve({}, r), {}, {
        onClick: (u) => u.stopPropagation(),
        class: o.value
      }), [A("div", {
        title: typeof e.title == "string" ? e.title : void 0,
        class: `${o.value}-title`
      }, [zg(n, e, "title")]), A("ul", {
        class: `${o.value}-list`
      }, [(l = n.default) === null || l === void 0 ? void 0 : l.call(n)])]);
    };
  }
}), Gre = () => ({
  prefixCls: String,
  dashed: Boolean
}), Mm = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AMenuDivider",
  props: Gre(),
  setup(e) {
    const {
      prefixCls: t
    } = sl(), n = V(() => ({
      [`${t.value}-item-divider`]: !0,
      [`${t.value}-item-divider-dashed`]: !!e.dashed
    }));
    return () => A("li", {
      class: n.value
    }, null);
  }
});
var Kre = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function c2(e, t, n) {
  return (e || []).map((r, a) => {
    if (r && typeof r == "object") {
      const o = r, {
        label: i,
        children: s,
        key: l,
        type: u
      } = o, c = Kre(o, ["label", "children", "key", "type"]), f = l ?? `tmp-${a}`, d = n ? n.parentKeys.slice() : [], p = [], v = {
        eventKey: f,
        key: f,
        parentEventKeys: ne(d),
        parentKeys: ne(d),
        childrenEventKeys: ne(p),
        isLeaf: !1
      };
      if (s || u === "group") {
        if (u === "group") {
          const m = c2(s, t, n);
          return A(km, ve(ve({
            key: f
          }, c), {}, {
            title: i,
            originItemValue: r
          }), {
            default: () => [m]
          });
        }
        t.set(f, v), n && n.childrenEventKeys.push(f);
        const h = c2(s, t, {
          childrenEventKeys: p,
          parentKeys: [].concat(d, f)
        });
        return A(Jf, ve(ve({
          key: f
        }, c), {}, {
          title: i,
          originItemValue: r
        }), {
          default: () => [h]
        });
      }
      return u === "divider" ? A(Mm, ve({
        key: f
      }, c), null) : (v.isLeaf = !0, t.set(f, v), A(Qf, ve(ve({
        key: f
      }, c), {}, {
        originItemValue: r
      }), {
        default: () => [i]
      }));
    }
    return null;
  }).filter((r) => r);
}
function Yre(e) {
  const t = Be([]), n = Be(!1), r = Be(/* @__PURE__ */ new Map());
  return He(() => e.items, () => {
    const a = /* @__PURE__ */ new Map();
    n.value = !1, e.items ? (n.value = !0, t.value = c2(e.items, a)) : t.value = void 0, r.value = a;
  }, {
    immediate: !0,
    deep: !0
  }), {
    itemsNodes: t,
    store: r,
    hasItmes: n
  };
}
const qre = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    menuHorizontalHeight: r,
    colorSplit: a,
    lineWidth: o,
    lineType: i,
    menuItemPaddingInline: s
  } = e;
  return {
    [`${t}-horizontal`]: {
      lineHeight: `${r}px`,
      border: 0,
      borderBottom: `${o}px ${i} ${a}`,
      boxShadow: "none",
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        content: '"\\20"'
      },
      // ======================= Item =======================
      [`${t}-item, ${t}-submenu`]: {
        position: "relative",
        display: "inline-block",
        verticalAlign: "bottom",
        paddingInline: s
      },
      [`> ${t}-item:hover,
        > ${t}-item-active,
        > ${t}-submenu ${t}-submenu-title:hover`]: {
        backgroundColor: "transparent"
      },
      [`${t}-item, ${t}-submenu-title`]: {
        transition: [`border-color ${n}`, `background ${n}`].join(",")
      },
      // ===================== Sub Menu =====================
      [`${t}-submenu-arrow`]: {
        display: "none"
      }
    }
  };
}, Xre = (e) => {
  let {
    componentCls: t,
    menuArrowOffset: n
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl"
    },
    [`${t}-submenu-rtl`]: {
      transformOrigin: "100% 0"
    },
    // Vertical Arrow
    [`${t}-rtl${t}-vertical,
    ${t}-submenu-rtl ${t}-vertical`]: {
      [`${t}-submenu-arrow`]: {
        "&::before": {
          transform: `rotate(-45deg) translateY(-${n})`
        },
        "&::after": {
          transform: `rotate(45deg) translateY(${n})`
        }
      }
    }
  };
}, c5 = (e) => D({}, ip(e)), f5 = (e, t) => {
  const {
    componentCls: n,
    colorItemText: r,
    colorItemTextSelected: a,
    colorGroupTitle: o,
    colorItemBg: i,
    colorSubItemBg: s,
    colorItemBgSelected: l,
    colorActiveBarHeight: u,
    colorActiveBarWidth: c,
    colorActiveBarBorderSize: f,
    motionDurationSlow: d,
    motionEaseInOut: p,
    motionEaseOut: v,
    menuItemPaddingInline: h,
    motionDurationMid: m,
    colorItemTextHover: y,
    lineType: x,
    colorSplit: g,
    // Disabled
    colorItemTextDisabled: S,
    // Danger
    colorDangerItemText: w,
    colorDangerItemTextHover: _,
    colorDangerItemTextSelected: b,
    colorDangerItemBgActive: E,
    colorDangerItemBgSelected: C,
    colorItemBgHover: T,
    menuSubMenuBg: O,
    // Horizontal
    colorItemTextSelectedHorizontal: I,
    colorItemBgSelectedHorizontal: k
  } = e;
  return {
    [`${n}-${t}`]: {
      color: r,
      background: i,
      [`&${n}-root:focus-visible`]: D({}, c5(e)),
      // ======================== Item ========================
      [`${n}-item-group-title`]: {
        color: o
      },
      [`${n}-submenu-selected`]: {
        [`> ${n}-submenu-title`]: {
          color: a
        }
      },
      // Disabled
      [`${n}-item-disabled, ${n}-submenu-disabled`]: {
        color: `${S} !important`
      },
      // Hover
      [`${n}-item:hover, ${n}-submenu-title:hover`]: {
        [`&:not(${n}-item-selected):not(${n}-submenu-selected)`]: {
          color: y
        }
      },
      [`&:not(${n}-horizontal)`]: {
        [`${n}-item:not(${n}-item-selected)`]: {
          "&:hover": {
            backgroundColor: T
          },
          "&:active": {
            backgroundColor: l
          }
        },
        [`${n}-submenu-title`]: {
          "&:hover": {
            backgroundColor: T
          },
          "&:active": {
            backgroundColor: l
          }
        }
      },
      // Danger - only Item has
      [`${n}-item-danger`]: {
        color: w,
        [`&${n}-item:hover`]: {
          [`&:not(${n}-item-selected):not(${n}-submenu-selected)`]: {
            color: _
          }
        },
        [`&${n}-item:active`]: {
          background: E
        }
      },
      [`${n}-item a`]: {
        "&, &:hover": {
          color: "inherit"
        }
      },
      [`${n}-item-selected`]: {
        color: a,
        // Danger
        [`&${n}-item-danger`]: {
          color: b
        },
        "a, a:hover": {
          color: "inherit"
        }
      },
      [`& ${n}-item-selected`]: {
        backgroundColor: l,
        // Danger
        [`&${n}-item-danger`]: {
          backgroundColor: C
        }
      },
      [`${n}-item, ${n}-submenu-title`]: {
        [`&:not(${n}-item-disabled):focus-visible`]: D({}, c5(e))
      },
      [`&${n}-submenu > ${n}`]: {
        backgroundColor: O
      },
      [`&${n}-popup > ${n}`]: {
        backgroundColor: i
      },
      // ====================== Horizontal ======================
      [`&${n}-horizontal`]: D(D({}, t === "dark" ? {
        borderBottom: 0
      } : {}), {
        [`> ${n}-item, > ${n}-submenu`]: {
          top: f,
          marginTop: -f,
          marginBottom: 0,
          borderRadius: 0,
          "&::after": {
            position: "absolute",
            insetInline: h,
            bottom: 0,
            borderBottom: `${u}px solid transparent`,
            transition: `border-color ${d} ${p}`,
            content: '""'
          },
          "&:hover, &-active, &-open": {
            "&::after": {
              borderBottomWidth: u,
              borderBottomColor: I
            }
          },
          "&-selected": {
            color: I,
            backgroundColor: k,
            "&::after": {
              borderBottomWidth: u,
              borderBottomColor: I
            }
          }
        }
      }),
      // ================== Inline & Vertical ===================
      //
      [`&${n}-root`]: {
        [`&${n}-inline, &${n}-vertical`]: {
          borderInlineEnd: `${f}px ${x} ${g}`
        }
      },
      // ======================== Inline ========================
      [`&${n}-inline`]: {
        // Sub
        [`${n}-sub${n}-inline`]: {
          background: s
        },
        // Item
        [`${n}-item, ${n}-submenu-title`]: f && c ? {
          width: `calc(100% + ${f}px)`
        } : {},
        [`${n}-item`]: {
          position: "relative",
          "&::after": {
            position: "absolute",
            insetBlock: 0,
            insetInlineEnd: 0,
            borderInlineEnd: `${c}px solid ${a}`,
            transform: "scaleY(0.0001)",
            opacity: 0,
            transition: [`transform ${m} ${v}`, `opacity ${m} ${v}`].join(","),
            content: '""'
          },
          // Danger
          [`&${n}-item-danger`]: {
            "&::after": {
              borderInlineEndColor: b
            }
          }
        },
        [`${n}-selected, ${n}-item-selected`]: {
          "&::after": {
            transform: "scaleY(1)",
            opacity: 1,
            transition: [`transform ${m} ${p}`, `opacity ${m} ${p}`].join(",")
          }
        }
      }
    }
  };
}, d5 = (e) => {
  const {
    componentCls: t,
    menuItemHeight: n,
    itemMarginInline: r,
    padding: a,
    menuArrowSize: o,
    marginXS: i,
    marginXXS: s
  } = e, l = a + o + i;
  return {
    [`${t}-item`]: {
      position: "relative"
    },
    [`${t}-item, ${t}-submenu-title`]: {
      height: n,
      lineHeight: `${n}px`,
      paddingInline: a,
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginInline: r,
      marginBlock: s,
      width: `calc(100% - ${r * 2}px)`
    },
    // disable margin collapsed
    [`${t}-submenu`]: {
      paddingBottom: 0.02
    },
    [`> ${t}-item,
            > ${t}-submenu > ${t}-submenu-title`]: {
      height: n,
      lineHeight: `${n}px`
    },
    [`${t}-item-group-list ${t}-submenu-title,
            ${t}-submenu-title`]: {
      paddingInlineEnd: l
    }
  };
}, Zre = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    menuItemHeight: r,
    colorTextLightSolid: a,
    dropdownWidth: o,
    controlHeightLG: i,
    motionDurationMid: s,
    motionEaseOut: l,
    paddingXL: u,
    fontSizeSM: c,
    fontSizeLG: f,
    motionDurationSlow: d,
    paddingXS: p,
    boxShadowSecondary: v
  } = e, h = {
    height: r,
    lineHeight: `${r}px`,
    listStylePosition: "inside",
    listStyleType: "disc"
  };
  return [
    {
      [t]: {
        "&-inline, &-vertical": D({
          [`&${t}-root`]: {
            boxShadow: "none"
          }
        }, d5(e))
      },
      [`${t}-submenu-popup`]: {
        [`${t}-vertical`]: D(D({}, d5(e)), {
          boxShadow: v
        })
      }
    },
    // Vertical only
    {
      [`${t}-submenu-popup ${t}-vertical${t}-sub`]: {
        minWidth: o,
        maxHeight: `calc(100vh - ${i * 2.5}px)`,
        padding: "0",
        overflow: "hidden",
        borderInlineEnd: 0,
        // https://github.com/ant-design/ant-design/issues/22244
        // https://github.com/ant-design/ant-design/issues/26812
        "&:not([class*='-active'])": {
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    },
    // Inline Only
    {
      [`${t}-inline`]: {
        width: "100%",
        // Motion enhance for first level
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu-title`]: {
            display: "flex",
            alignItems: "center",
            transition: [`border-color ${d}`, `background ${d}`, `padding ${s} ${l}`].join(","),
            [`> ${t}-title-content`]: {
              flex: "auto",
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            "> *": {
              flex: "none"
            }
          }
        },
        // >>>>> Sub
        [`${t}-sub${t}-inline`]: {
          padding: 0,
          border: 0,
          borderRadius: 0,
          boxShadow: "none",
          [`& > ${t}-submenu > ${t}-submenu-title`]: h,
          [`& ${t}-item-group-title`]: {
            paddingInlineStart: u
          }
        },
        // >>>>> Item
        [`${t}-item`]: h
      }
    },
    // Inline Collapse Only
    {
      [`${t}-inline-collapsed`]: {
        width: r * 2,
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu ${t}-submenu-title`]: {
            [`> ${t}-inline-collapsed-noicon`]: {
              fontSize: f,
              textAlign: "center"
            }
          }
        },
        [`> ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-submenu > ${t}-submenu-title,
          > ${t}-submenu > ${t}-submenu-title`]: {
          insetInlineStart: 0,
          paddingInline: `calc(50% - ${c}px)`,
          textOverflow: "clip",
          [`
            ${t}-submenu-arrow,
            ${t}-submenu-expand-icon
          `]: {
            opacity: 0
          },
          [`${t}-item-icon, ${n}`]: {
            margin: 0,
            fontSize: f,
            lineHeight: `${r}px`,
            "+ span": {
              display: "inline-block",
              opacity: 0
            }
          }
        },
        [`${t}-item-icon, ${n}`]: {
          display: "inline-block"
        },
        "&-tooltip": {
          pointerEvents: "none",
          [`${t}-item-icon, ${n}`]: {
            display: "none"
          },
          "a, a:hover": {
            color: a
          }
        },
        [`${t}-item-group-title`]: D(D({}, op), {
          paddingInline: p
        })
      }
    }
  ];
}, p5 = (e) => {
  const {
    componentCls: t,
    fontSize: n,
    motionDurationSlow: r,
    motionDurationMid: a,
    motionEaseInOut: o,
    motionEaseOut: i,
    iconCls: s,
    controlHeightSM: l
  } = e;
  return {
    // >>>>> Item
    [`${t}-item, ${t}-submenu-title`]: {
      position: "relative",
      display: "block",
      margin: 0,
      whiteSpace: "nowrap",
      cursor: "pointer",
      transition: [`border-color ${r}`, `background ${r}`, `padding ${r} ${o}`].join(","),
      [`${t}-item-icon, ${s}`]: {
        minWidth: n,
        fontSize: n,
        transition: [`font-size ${a} ${i}`, `margin ${r} ${o}`, `color ${r}`].join(","),
        "+ span": {
          marginInlineStart: l - n,
          opacity: 1,
          transition: [`opacity ${r} ${o}`, `margin ${r}`, `color ${r}`].join(",")
        }
      },
      [`${t}-item-icon`]: D({}, Zg()),
      [`&${t}-item-only-child`]: {
        [`> ${s}, > ${t}-item-icon`]: {
          marginInlineEnd: 0
        }
      }
    },
    // Disabled state sets text to gray and nukes hover/tab effects
    [`${t}-item-disabled, ${t}-submenu-disabled`]: {
      background: "none !important",
      cursor: "not-allowed",
      "&::after": {
        borderColor: "transparent !important"
      },
      a: {
        color: "inherit !important"
      },
      [`> ${t}-submenu-title`]: {
        color: "inherit !important",
        cursor: "not-allowed"
      }
    }
  };
}, h5 = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    motionEaseInOut: r,
    borderRadius: a,
    menuArrowSize: o,
    menuArrowOffset: i
  } = e;
  return {
    [`${t}-submenu`]: {
      "&-expand-icon, &-arrow": {
        position: "absolute",
        top: "50%",
        insetInlineEnd: e.margin,
        width: o,
        color: "currentcolor",
        transform: "translateY(-50%)",
        transition: `transform ${n} ${r}, opacity ${n}`
      },
      "&-arrow": {
        // →
        "&::before, &::after": {
          position: "absolute",
          width: o * 0.6,
          height: o * 0.15,
          backgroundColor: "currentcolor",
          borderRadius: a,
          transition: [`background ${n} ${r}`, `transform ${n} ${r}`, `top ${n} ${r}`, `color ${n} ${r}`].join(","),
          content: '""'
        },
        "&::before": {
          transform: `rotate(45deg) translateY(-${i})`
        },
        "&::after": {
          transform: `rotate(-45deg) translateY(${i})`
        }
      }
    }
  };
}, Qre = (e) => {
  const {
    antCls: t,
    componentCls: n,
    fontSize: r,
    motionDurationSlow: a,
    motionDurationMid: o,
    motionEaseInOut: i,
    lineHeight: s,
    paddingXS: l,
    padding: u,
    colorSplit: c,
    lineWidth: f,
    zIndexPopup: d,
    borderRadiusLG: p,
    radiusSubMenuItem: v,
    menuArrowSize: h,
    menuArrowOffset: m,
    lineType: y,
    menuPanelMaskInset: x
  } = e;
  return [
    // Misc
    {
      "": {
        [`${n}`]: D(D({}, wm()), {
          // Hidden
          "&-hidden": {
            display: "none"
          }
        })
      },
      [`${n}-submenu-hidden`]: {
        display: "none"
      }
    },
    {
      [n]: D(D(D(D(D(D(D({}, gr(e)), wm()), {
        marginBottom: 0,
        paddingInlineStart: 0,
        // Override default ul/ol
        fontSize: r,
        lineHeight: 0,
        listStyle: "none",
        outline: "none",
        transition: `width ${a} cubic-bezier(0.2, 0, 0, 1) 0s`,
        "ul, ol": {
          margin: 0,
          padding: 0,
          listStyle: "none"
        },
        // Overflow ellipsis
        "&-overflow": {
          display: "flex",
          [`${n}-item`]: {
            flex: "none"
          }
        },
        [`${n}-item, ${n}-submenu, ${n}-submenu-title`]: {
          borderRadius: e.radiusItem
        },
        [`${n}-item-group-title`]: {
          padding: `${l}px ${u}px`,
          fontSize: r,
          lineHeight: s,
          transition: `all ${a}`
        },
        [`&-horizontal ${n}-submenu`]: {
          transition: [`border-color ${a} ${i}`, `background ${a} ${i}`].join(",")
        },
        [`${n}-submenu, ${n}-submenu-inline`]: {
          transition: [`border-color ${a} ${i}`, `background ${a} ${i}`, `padding ${o} ${i}`].join(",")
        },
        [`${n}-submenu ${n}-sub`]: {
          cursor: "initial",
          transition: [`background ${a} ${i}`, `padding ${a} ${i}`].join(",")
        },
        [`${n}-title-content`]: {
          transition: `color ${a}`
        },
        [`${n}-item a`]: {
          "&::before": {
            position: "absolute",
            inset: 0,
            backgroundColor: "transparent",
            content: '""'
          }
        },
        // Removed a Badge related style seems it's safe
        // https://github.com/ant-design/ant-design/issues/19809
        // >>>>> Divider
        [`${n}-item-divider`]: {
          overflow: "hidden",
          lineHeight: 0,
          borderColor: c,
          borderStyle: y,
          borderWidth: 0,
          borderTopWidth: f,
          marginBlock: f,
          padding: 0,
          "&-dashed": {
            borderStyle: "dashed"
          }
        }
      }), p5(e)), {
        [`${n}-item-group`]: {
          [`${n}-item-group-list`]: {
            margin: 0,
            padding: 0,
            [`${n}-item, ${n}-submenu-title`]: {
              paddingInline: `${r * 2}px ${u}px`
            }
          }
        },
        // ======================= Sub Menu =======================
        "&-submenu": {
          "&-popup": {
            position: "absolute",
            zIndex: d,
            background: "transparent",
            borderRadius: p,
            boxShadow: "none",
            transformOrigin: "0 0",
            // https://github.com/ant-design/ant-design/issues/13955
            "&::before": {
              position: "absolute",
              inset: `${x}px 0 0`,
              zIndex: -1,
              width: "100%",
              height: "100%",
              opacity: 0,
              content: '""'
            }
          },
          // https://github.com/ant-design/ant-design/issues/13955
          "&-placement-rightTop::before": {
            top: 0,
            insetInlineStart: x
          },
          [`> ${n}`]: D(D(D({
            borderRadius: p
          }, p5(e)), h5(e)), {
            [`${n}-item, ${n}-submenu > ${n}-submenu-title`]: {
              borderRadius: v
            },
            [`${n}-submenu-title::after`]: {
              transition: `transform ${a} ${i}`
            }
          })
        }
      }), h5(e)), {
        [`&-inline-collapsed ${n}-submenu-arrow,
        &-inline ${n}-submenu-arrow`]: {
          // ↓
          "&::before": {
            transform: `rotate(-45deg) translateX(${m})`
          },
          "&::after": {
            transform: `rotate(45deg) translateX(-${m})`
          }
        },
        [`${n}-submenu-open${n}-submenu-inline > ${n}-submenu-title > ${n}-submenu-arrow`]: {
          // ↑
          transform: `translateY(-${h * 0.2}px)`,
          "&::after": {
            transform: `rotate(-45deg) translateX(-${m})`
          },
          "&::before": {
            transform: `rotate(45deg) translateX(${m})`
          }
        }
      })
    },
    // Integration with header element so menu items have the same height
    {
      [`${t}-layout-header`]: {
        [n]: {
          lineHeight: "inherit"
        }
      }
    }
  ];
}, Jre = (e, t) => xr("Menu", (r, a) => {
  let {
    overrideComponentToken: o
  } = a;
  if ((t == null ? void 0 : t.value) === !1)
    return [];
  const {
    colorBgElevated: i,
    colorPrimary: s,
    colorError: l,
    colorErrorHover: u,
    colorTextLightSolid: c
  } = r, {
    controlHeightLG: f,
    fontSize: d
  } = r, p = d / 7 * 5, v = xn(r, {
    menuItemHeight: f,
    menuItemPaddingInline: r.margin,
    menuArrowSize: p,
    menuHorizontalHeight: f * 1.15,
    menuArrowOffset: `${p * 0.25}px`,
    menuPanelMaskInset: -7,
    menuSubMenuBg: i
  }), h = new ir(c).setAlpha(0.65).toRgbString(), m = xn(v, {
    colorItemText: h,
    colorItemTextHover: c,
    colorGroupTitle: h,
    colorItemTextSelected: c,
    colorItemBg: "#001529",
    colorSubItemBg: "#000c17",
    colorItemBgActive: "transparent",
    colorItemBgSelected: s,
    colorActiveBarWidth: 0,
    colorActiveBarHeight: 0,
    colorActiveBarBorderSize: 0,
    // Disabled
    colorItemTextDisabled: new ir(c).setAlpha(0.25).toRgbString(),
    // Danger
    colorDangerItemText: l,
    colorDangerItemTextHover: u,
    colorDangerItemTextSelected: c,
    colorDangerItemBgActive: l,
    colorDangerItemBgSelected: l,
    menuSubMenuBg: "#001529",
    // Horizontal
    colorItemTextSelectedHorizontal: c,
    colorItemBgSelectedHorizontal: s
  }, D({}, o));
  return [
    // Basic
    Qre(v),
    // Horizontal
    qre(v),
    // Vertical
    Zre(v),
    // Theme
    f5(v, "light"),
    f5(m, "dark"),
    // RTL
    Xre(v),
    // Motion
    $D(v),
    nu(v, "slide-up"),
    nu(v, "slide-down"),
    y1(v, "zoom-big")
  ];
}, (r) => {
  const {
    colorPrimary: a,
    colorError: o,
    colorTextDisabled: i,
    colorErrorBg: s,
    colorText: l,
    colorTextDescription: u,
    colorBgContainer: c,
    colorFillAlter: f,
    colorFillContent: d,
    lineWidth: p,
    lineWidthBold: v,
    controlItemBgActive: h,
    colorBgTextHover: m
  } = r;
  return {
    dropdownWidth: 160,
    zIndexPopup: r.zIndexPopupBase + 50,
    radiusItem: r.borderRadiusLG,
    radiusSubMenuItem: r.borderRadiusSM,
    colorItemText: l,
    colorItemTextHover: l,
    colorItemTextHoverHorizontal: a,
    colorGroupTitle: u,
    colorItemTextSelected: a,
    colorItemTextSelectedHorizontal: a,
    colorItemBg: c,
    colorItemBgHover: m,
    colorItemBgActive: d,
    colorSubItemBg: f,
    colorItemBgSelected: h,
    colorItemBgSelectedHorizontal: "transparent",
    colorActiveBarWidth: 0,
    colorActiveBarHeight: v,
    colorActiveBarBorderSize: p,
    // Disabled
    colorItemTextDisabled: i,
    // Danger
    colorDangerItemText: o,
    colorDangerItemTextHover: o,
    colorDangerItemTextSelected: o,
    colorDangerItemBgActive: s,
    colorDangerItemBgSelected: s,
    itemMarginInline: r.marginXXS
  };
})(e), eae = () => ({
  id: String,
  prefixCls: String,
  // donot use items, now only support inner use
  items: Array,
  disabled: Boolean,
  inlineCollapsed: Boolean,
  disabledOverflow: Boolean,
  forceSubMenuRender: Boolean,
  openKeys: Array,
  selectedKeys: Array,
  activeKey: String,
  selectable: {
    type: Boolean,
    default: !0
  },
  multiple: {
    type: Boolean,
    default: !1
  },
  tabindex: {
    type: [Number, String]
  },
  motion: Object,
  role: String,
  theme: {
    type: String,
    default: "light"
  },
  mode: {
    type: String,
    default: "vertical"
  },
  inlineIndent: {
    type: Number,
    default: 24
  },
  subMenuOpenDelay: {
    type: Number,
    default: 0
  },
  subMenuCloseDelay: {
    type: Number,
    default: 0.1
  },
  builtinPlacements: {
    type: Object
  },
  triggerSubMenuAction: {
    type: String,
    default: "hover"
  },
  getPopupContainer: Function,
  expandIcon: Function,
  onOpenChange: Function,
  onSelect: Function,
  onDeselect: Function,
  onClick: [Function, Array],
  onFocus: Function,
  onBlur: Function,
  onMousedown: Function,
  "onUpdate:openKeys": Function,
  "onUpdate:selectedKeys": Function,
  "onUpdate:activeKey": Function
}), v5 = [], Wl = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AMenu",
  inheritAttrs: !1,
  props: eae(),
  slots: Object,
  setup(e, t) {
    let {
      slots: n,
      emit: r,
      attrs: a
    } = t;
    const {
      direction: o,
      getPrefixCls: i
    } = mn("menu", e), s = zD(), l = V(() => {
      var Q;
      return i("menu", e.prefixCls || ((Q = s == null ? void 0 : s.prefixCls) === null || Q === void 0 ? void 0 : Q.value));
    }), [u, c] = Jre(l, V(() => !s)), f = Be(/* @__PURE__ */ new Map()), d = Ke(Rre, ne(void 0)), p = V(() => d.value !== void 0 ? d.value : e.inlineCollapsed), {
      itemsNodes: v
    } = Yre(e), h = Be(!1);
    Lt(() => {
      h.value = !0;
    }), _n(() => {
      Aa(!(e.inlineCollapsed === !0 && e.mode !== "inline"), "Menu", "`inlineCollapsed` should only be used when `mode` is inline."), Aa(!(d.value !== void 0 && e.inlineCollapsed === !0), "Menu", "`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.");
    });
    const m = ne([]), y = ne([]), x = ne({});
    He(f, () => {
      const Q = {};
      for (const ue of f.value.values())
        Q[ue.key] = ue;
      x.value = Q;
    }, {
      flush: "post"
    }), _n(() => {
      if (e.activeKey !== void 0) {
        let Q = [];
        const ue = e.activeKey ? x.value[e.activeKey] : void 0;
        ue && e.activeKey !== void 0 ? Q = Ry([].concat(U(ue.parentKeys), e.activeKey)) : Q = [], of(m.value, Q) || (m.value = Q);
      }
    }), He(() => e.selectedKeys, (Q) => {
      Q && (y.value = Q.slice());
    }, {
      immediate: !0,
      deep: !0
    });
    const g = ne([]);
    He([x, y], () => {
      let Q = [];
      y.value.forEach((ue) => {
        const le = x.value[ue];
        le && (Q = Q.concat(U(le.parentKeys)));
      }), Q = Ry(Q), of(g.value, Q) || (g.value = Q);
    }, {
      immediate: !0
    });
    const S = (Q) => {
      if (e.selectable) {
        const {
          key: ue
        } = Q, le = y.value.includes(ue);
        let te;
        e.multiple ? le ? te = y.value.filter((oe) => oe !== ue) : te = [...y.value, ue] : te = [ue];
        const G = D(D({}, Q), {
          selectedKeys: te
        });
        of(te, y.value) || (e.selectedKeys === void 0 && (y.value = te), r("update:selectedKeys", te), le && e.multiple ? r("deselect", G) : r("select", G));
      }
      T.value !== "inline" && !e.multiple && w.value.length && k(v5);
    }, w = ne([]);
    He(() => e.openKeys, function() {
      let Q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : w.value;
      of(w.value, Q) || (w.value = Q.slice());
    }, {
      immediate: !0,
      deep: !0
    });
    let _;
    const b = (Q) => {
      clearTimeout(_), _ = setTimeout(() => {
        e.activeKey === void 0 && (m.value = Q), r("update:activeKey", Q[Q.length - 1]);
      });
    }, E = V(() => !!e.disabled), C = V(() => o.value === "rtl"), T = ne("vertical"), O = Be(!1);
    _n(() => {
      var Q;
      (e.mode === "inline" || e.mode === "vertical") && p.value ? (T.value = "vertical", O.value = p.value) : (T.value = e.mode, O.value = !1), !((Q = s == null ? void 0 : s.mode) === null || Q === void 0) && Q.value && (T.value = s.mode.value);
    });
    const I = V(() => T.value === "inline"), k = (Q) => {
      w.value = Q, r("update:openKeys", Q), r("openChange", Q);
    }, B = ne(w.value), P = Be(!1);
    He(w, () => {
      I.value && (B.value = w.value);
    }, {
      immediate: !0
    }), He(I, () => {
      if (!P.value) {
        P.value = !0;
        return;
      }
      I.value ? w.value = B.value : k(v5);
    }, {
      immediate: !0
    });
    const N = V(() => ({
      [`${l.value}`]: !0,
      [`${l.value}-root`]: !0,
      [`${l.value}-${T.value}`]: !0,
      [`${l.value}-inline-collapsed`]: O.value,
      [`${l.value}-rtl`]: C.value,
      [`${l.value}-${e.theme}`]: !0
    })), M = V(() => i()), H = V(() => ({
      horizontal: {
        name: `${M.value}-slide-up`
      },
      inline: tk(`${M.value}-motion-collapse`),
      other: {
        name: `${M.value}-zoom-big`
      }
    }));
    XD(!0);
    const R = function() {
      let Q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      const ue = [], le = f.value;
      return Q.forEach((te) => {
        const {
          key: G,
          childrenEventKeys: oe
        } = le.get(te);
        ue.push(G, ...R(U(oe)));
      }), ue;
    }, z = (Q) => {
      var ue;
      r("click", Q), S(Q), (ue = s == null ? void 0 : s.onClick) === null || ue === void 0 || ue.call(s);
    }, W = (Q, ue) => {
      var le;
      const te = ((le = x.value[Q]) === null || le === void 0 ? void 0 : le.childrenEventKeys) || [];
      let G = w.value.filter((oe) => oe !== Q);
      if (ue)
        G.push(Q);
      else if (T.value !== "inline") {
        const oe = R(U(te));
        G = Ry(G.filter((L) => !oe.includes(L)));
      }
      of(w, G) || k(G);
    }, F = (Q, ue) => {
      f.value.set(Q, ue), f.value = new Map(f.value);
    }, Y = (Q) => {
      f.value.delete(Q), f.value = new Map(f.value);
    }, X = ne(0), q = V(() => {
      var Q;
      return e.expandIcon || n.expandIcon || !((Q = s == null ? void 0 : s.expandIcon) === null || Q === void 0) && Q.value ? (ue) => {
        let le = e.expandIcon || n.expandIcon;
        return le = typeof le == "function" ? le(ue) : le, sr(le, {
          class: `${l.value}-submenu-expand-icon`
        }, !1);
      } : null;
    });
    return Mre({
      prefixCls: l,
      activeKeys: m,
      openKeys: w,
      selectedKeys: y,
      changeActiveKeys: b,
      disabled: E,
      rtl: C,
      mode: T,
      inlineIndent: V(() => e.inlineIndent),
      subMenuCloseDelay: V(() => e.subMenuCloseDelay),
      subMenuOpenDelay: V(() => e.subMenuOpenDelay),
      builtinPlacements: V(() => e.builtinPlacements),
      triggerSubMenuAction: V(() => e.triggerSubMenuAction),
      getPopupContainer: V(() => e.getPopupContainer),
      inlineCollapsed: O,
      theme: V(() => e.theme),
      siderCollapsed: d,
      defaultMotions: V(() => h.value ? H.value : null),
      motion: V(() => h.value ? e.motion : null),
      overflowDisabled: Be(void 0),
      onOpenChange: W,
      onItemClick: z,
      registerMenuInfo: F,
      unRegisterMenuInfo: Y,
      selectedSubMenuKeys: g,
      expandIcon: q,
      forceSubMenuRender: V(() => e.forceSubMenuRender),
      rootClassName: c
    }), () => {
      var Q, ue;
      const le = v.value || ua((Q = n.default) === null || Q === void 0 ? void 0 : Q.call(n)), te = X.value >= le.length - 1 || T.value !== "horizontal" || e.disabledOverflow, G = T.value !== "horizontal" || e.disabledOverflow ? le : (
        // Need wrap for overflow dropdown that do not response for open
        le.map((L, re) => (
          // Always wrap provider to avoid sub node re-mount
          A(Dm, {
            key: L.key,
            overflowDisabled: re > X.value
          }, {
            default: () => L
          })
        ))
      ), oe = ((ue = n.overflowedIndicator) === null || ue === void 0 ? void 0 : ue.call(n)) || A(w1, null, null);
      return u(A(Gs, ve(ve({}, a), {}, {
        onMousedown: e.onMousedown,
        prefixCls: `${l.value}-overflow`,
        component: "ul",
        itemComponent: Qf,
        class: [N.value, a.class, c.value],
        role: "menu",
        id: e.id,
        data: G,
        renderRawItem: (L) => L,
        renderRawRest: (L) => {
          const re = L.length, j = re ? le.slice(-re) : null;
          return A(dt, null, [A(Jf, {
            eventKey: Uh,
            key: Uh,
            title: oe,
            disabled: te,
            internalPopupClose: re === 0
          }, {
            default: () => j
          }), A(o5, null, {
            default: () => [A(Jf, {
              eventKey: Uh,
              key: Uh,
              title: oe,
              disabled: te,
              internalPopupClose: re === 0
            }, {
              default: () => j
            })]
          })]);
        },
        maxCount: T.value !== "horizontal" || e.disabledOverflow ? Gs.INVALIDATE : Gs.RESPONSIVE,
        ssr: "full",
        "data-menu-list": !0,
        onVisibleChange: (L) => {
          X.value = L;
        }
      }), {
        default: () => [A(Eg, {
          to: "body"
        }, {
          default: () => [A("div", {
            style: {
              display: "none"
            },
            "aria-hidden": !0
          }, [A(o5, null, {
            default: () => [G]
          })])]
        })]
      }));
    };
  }
});
Wl.install = function(e) {
  return e.component(Wl.name, Wl), e.component(Qf.name, Qf), e.component(Jf.name, Jf), e.component(Mm.name, Mm), e.component(km.name, km), e;
};
Wl.Item = Qf;
Wl.Divider = Mm;
Wl.SubMenu = Jf;
Wl.ItemGroup = km;
var nk = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ra, function() {
    var n = 1e3, r = 6e4, a = 36e5, o = "millisecond", i = "second", s = "minute", l = "hour", u = "day", c = "week", f = "month", d = "quarter", p = "year", v = "date", h = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, x = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(B) {
      var P = ["th", "st", "nd", "rd"], N = B % 100;
      return "[" + B + (P[(N - 20) % 10] || P[N] || P[0]) + "]";
    } }, g = function(B, P, N) {
      var M = String(B);
      return !M || M.length >= P ? B : "" + Array(P + 1 - M.length).join(N) + B;
    }, S = { s: g, z: function(B) {
      var P = -B.utcOffset(), N = Math.abs(P), M = Math.floor(N / 60), H = N % 60;
      return (P <= 0 ? "+" : "-") + g(M, 2, "0") + ":" + g(H, 2, "0");
    }, m: function B(P, N) {
      if (P.date() < N.date()) return -B(N, P);
      var M = 12 * (N.year() - P.year()) + (N.month() - P.month()), H = P.clone().add(M, f), R = N - H < 0, z = P.clone().add(M + (R ? -1 : 1), f);
      return +(-(M + (N - H) / (R ? H - z : z - H)) || 0);
    }, a: function(B) {
      return B < 0 ? Math.ceil(B) || 0 : Math.floor(B);
    }, p: function(B) {
      return { M: f, y: p, w: c, d: u, D: v, h: l, m: s, s: i, ms: o, Q: d }[B] || String(B || "").toLowerCase().replace(/s$/, "");
    }, u: function(B) {
      return B === void 0;
    } }, w = "en", _ = {};
    _[w] = x;
    var b = "$isDayjsObject", E = function(B) {
      return B instanceof I || !(!B || !B[b]);
    }, C = function B(P, N, M) {
      var H;
      if (!P) return w;
      if (typeof P == "string") {
        var R = P.toLowerCase();
        _[R] && (H = R), N && (_[R] = N, H = R);
        var z = P.split("-");
        if (!H && z.length > 1) return B(z[0]);
      } else {
        var W = P.name;
        _[W] = P, H = W;
      }
      return !M && H && (w = H), H || !M && w;
    }, T = function(B, P) {
      if (E(B)) return B.clone();
      var N = typeof P == "object" ? P : {};
      return N.date = B, N.args = arguments, new I(N);
    }, O = S;
    O.l = C, O.i = E, O.w = function(B, P) {
      return T(B, { locale: P.$L, utc: P.$u, x: P.$x, $offset: P.$offset });
    };
    var I = function() {
      function B(N) {
        this.$L = C(N.locale, null, !0), this.parse(N), this.$x = this.$x || N.x || {}, this[b] = !0;
      }
      var P = B.prototype;
      return P.parse = function(N) {
        this.$d = function(M) {
          var H = M.date, R = M.utc;
          if (H === null) return /* @__PURE__ */ new Date(NaN);
          if (O.u(H)) return /* @__PURE__ */ new Date();
          if (H instanceof Date) return new Date(H);
          if (typeof H == "string" && !/Z$/i.test(H)) {
            var z = H.match(m);
            if (z) {
              var W = z[2] - 1 || 0, F = (z[7] || "0").substring(0, 3);
              return R ? new Date(Date.UTC(z[1], W, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, F)) : new Date(z[1], W, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, F);
            }
          }
          return new Date(H);
        }(N), this.init();
      }, P.init = function() {
        var N = this.$d;
        this.$y = N.getFullYear(), this.$M = N.getMonth(), this.$D = N.getDate(), this.$W = N.getDay(), this.$H = N.getHours(), this.$m = N.getMinutes(), this.$s = N.getSeconds(), this.$ms = N.getMilliseconds();
      }, P.$utils = function() {
        return O;
      }, P.isValid = function() {
        return this.$d.toString() !== h;
      }, P.isSame = function(N, M) {
        var H = T(N);
        return this.startOf(M) <= H && H <= this.endOf(M);
      }, P.isAfter = function(N, M) {
        return T(N) < this.startOf(M);
      }, P.isBefore = function(N, M) {
        return this.endOf(M) < T(N);
      }, P.$g = function(N, M, H) {
        return O.u(N) ? this[M] : this.set(H, N);
      }, P.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, P.valueOf = function() {
        return this.$d.getTime();
      }, P.startOf = function(N, M) {
        var H = this, R = !!O.u(M) || M, z = O.p(N), W = function(te, G) {
          var oe = O.w(H.$u ? Date.UTC(H.$y, G, te) : new Date(H.$y, G, te), H);
          return R ? oe : oe.endOf(u);
        }, F = function(te, G) {
          return O.w(H.toDate()[te].apply(H.toDate("s"), (R ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(G)), H);
        }, Y = this.$W, X = this.$M, q = this.$D, Q = "set" + (this.$u ? "UTC" : "");
        switch (z) {
          case p:
            return R ? W(1, 0) : W(31, 11);
          case f:
            return R ? W(1, X) : W(0, X + 1);
          case c:
            var ue = this.$locale().weekStart || 0, le = (Y < ue ? Y + 7 : Y) - ue;
            return W(R ? q - le : q + (6 - le), X);
          case u:
          case v:
            return F(Q + "Hours", 0);
          case l:
            return F(Q + "Minutes", 1);
          case s:
            return F(Q + "Seconds", 2);
          case i:
            return F(Q + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, P.endOf = function(N) {
        return this.startOf(N, !1);
      }, P.$set = function(N, M) {
        var H, R = O.p(N), z = "set" + (this.$u ? "UTC" : ""), W = (H = {}, H[u] = z + "Date", H[v] = z + "Date", H[f] = z + "Month", H[p] = z + "FullYear", H[l] = z + "Hours", H[s] = z + "Minutes", H[i] = z + "Seconds", H[o] = z + "Milliseconds", H)[R], F = R === u ? this.$D + (M - this.$W) : M;
        if (R === f || R === p) {
          var Y = this.clone().set(v, 1);
          Y.$d[W](F), Y.init(), this.$d = Y.set(v, Math.min(this.$D, Y.daysInMonth())).$d;
        } else W && this.$d[W](F);
        return this.init(), this;
      }, P.set = function(N, M) {
        return this.clone().$set(N, M);
      }, P.get = function(N) {
        return this[O.p(N)]();
      }, P.add = function(N, M) {
        var H, R = this;
        N = Number(N);
        var z = O.p(M), W = function(X) {
          var q = T(R);
          return O.w(q.date(q.date() + Math.round(X * N)), R);
        };
        if (z === f) return this.set(f, this.$M + N);
        if (z === p) return this.set(p, this.$y + N);
        if (z === u) return W(1);
        if (z === c) return W(7);
        var F = (H = {}, H[s] = r, H[l] = a, H[i] = n, H)[z] || 1, Y = this.$d.getTime() + N * F;
        return O.w(Y, this);
      }, P.subtract = function(N, M) {
        return this.add(-1 * N, M);
      }, P.format = function(N) {
        var M = this, H = this.$locale();
        if (!this.isValid()) return H.invalidDate || h;
        var R = N || "YYYY-MM-DDTHH:mm:ssZ", z = O.z(this), W = this.$H, F = this.$m, Y = this.$M, X = H.weekdays, q = H.months, Q = H.meridiem, ue = function(G, oe, L, re) {
          return G && (G[oe] || G(M, R)) || L[oe].slice(0, re);
        }, le = function(G) {
          return O.s(W % 12 || 12, G, "0");
        }, te = Q || function(G, oe, L) {
          var re = G < 12 ? "AM" : "PM";
          return L ? re.toLowerCase() : re;
        };
        return R.replace(y, function(G, oe) {
          return oe || function(L) {
            switch (L) {
              case "YY":
                return String(M.$y).slice(-2);
              case "YYYY":
                return O.s(M.$y, 4, "0");
              case "M":
                return Y + 1;
              case "MM":
                return O.s(Y + 1, 2, "0");
              case "MMM":
                return ue(H.monthsShort, Y, q, 3);
              case "MMMM":
                return ue(q, Y);
              case "D":
                return M.$D;
              case "DD":
                return O.s(M.$D, 2, "0");
              case "d":
                return String(M.$W);
              case "dd":
                return ue(H.weekdaysMin, M.$W, X, 2);
              case "ddd":
                return ue(H.weekdaysShort, M.$W, X, 3);
              case "dddd":
                return X[M.$W];
              case "H":
                return String(W);
              case "HH":
                return O.s(W, 2, "0");
              case "h":
                return le(1);
              case "hh":
                return le(2);
              case "a":
                return te(W, F, !0);
              case "A":
                return te(W, F, !1);
              case "m":
                return String(F);
              case "mm":
                return O.s(F, 2, "0");
              case "s":
                return String(M.$s);
              case "ss":
                return O.s(M.$s, 2, "0");
              case "SSS":
                return O.s(M.$ms, 3, "0");
              case "Z":
                return z;
            }
            return null;
          }(G) || z.replace(":", "");
        });
      }, P.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, P.diff = function(N, M, H) {
        var R, z = this, W = O.p(M), F = T(N), Y = (F.utcOffset() - this.utcOffset()) * r, X = this - F, q = function() {
          return O.m(z, F);
        };
        switch (W) {
          case p:
            R = q() / 12;
            break;
          case f:
            R = q();
            break;
          case d:
            R = q() / 3;
            break;
          case c:
            R = (X - Y) / 6048e5;
            break;
          case u:
            R = (X - Y) / 864e5;
            break;
          case l:
            R = X / a;
            break;
          case s:
            R = X / r;
            break;
          case i:
            R = X / n;
            break;
          default:
            R = X;
        }
        return H ? R : O.a(R);
      }, P.daysInMonth = function() {
        return this.endOf(f).$D;
      }, P.$locale = function() {
        return _[this.$L];
      }, P.locale = function(N, M) {
        if (!N) return this.$L;
        var H = this.clone(), R = C(N, M, !0);
        return R && (H.$L = R), H;
      }, P.clone = function() {
        return O.w(this.$d, this);
      }, P.toDate = function() {
        return new Date(this.valueOf());
      }, P.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, P.toISOString = function() {
        return this.$d.toISOString();
      }, P.toString = function() {
        return this.$d.toUTCString();
      }, B;
    }(), k = I.prototype;
    return T.prototype = k, [["$ms", o], ["$s", i], ["$m", s], ["$H", l], ["$W", u], ["$M", f], ["$y", p], ["$D", v]].forEach(function(B) {
      k[B[1]] = function(P) {
        return this.$g(P, B[0], B[1]);
      };
    }), T.extend = function(B, P) {
      return B.$i || (B(P, I, T), B.$i = !0), T;
    }, T.locale = C, T.isDayjs = E, T.unix = function(B) {
      return T(1e3 * B);
    }, T.en = _[w], T.Ls = _, T.p = {}, T;
  });
})(nk);
var rk = nk.exports;
const It = /* @__PURE__ */ Ki(rk);
var ak = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ra, function() {
    return function(n, r) {
      r.prototype.weekday = function(a) {
        var o = this.$locale().weekStart || 0, i = this.$W, s = (i < o ? i + 7 : i) - o;
        return this.$utils().u(a) ? s : this.subtract(s, "day").add(a, "day");
      };
    };
  });
})(ak);
var tae = ak.exports;
const nae = /* @__PURE__ */ Ki(tae);
var ok = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ra, function() {
    return function(n, r, a) {
      var o = r.prototype, i = function(f) {
        return f && (f.indexOf ? f : f.s);
      }, s = function(f, d, p, v, h) {
        var m = f.name ? f : f.$locale(), y = i(m[d]), x = i(m[p]), g = y || x.map(function(w) {
          return w.slice(0, v);
        });
        if (!h) return g;
        var S = m.weekStart;
        return g.map(function(w, _) {
          return g[(_ + (S || 0)) % 7];
        });
      }, l = function() {
        return a.Ls[a.locale()];
      }, u = function(f, d) {
        return f.formats[d] || function(p) {
          return p.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(v, h, m) {
            return h || m.slice(1);
          });
        }(f.formats[d.toUpperCase()]);
      }, c = function() {
        var f = this;
        return { months: function(d) {
          return d ? d.format("MMMM") : s(f, "months");
        }, monthsShort: function(d) {
          return d ? d.format("MMM") : s(f, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return f.$locale().weekStart || 0;
        }, weekdays: function(d) {
          return d ? d.format("dddd") : s(f, "weekdays");
        }, weekdaysMin: function(d) {
          return d ? d.format("dd") : s(f, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(d) {
          return d ? d.format("ddd") : s(f, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(d) {
          return u(f.$locale(), d);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      o.localeData = function() {
        return c.bind(this)();
      }, a.localeData = function() {
        var f = l();
        return { firstDayOfWeek: function() {
          return f.weekStart || 0;
        }, weekdays: function() {
          return a.weekdays();
        }, weekdaysShort: function() {
          return a.weekdaysShort();
        }, weekdaysMin: function() {
          return a.weekdaysMin();
        }, months: function() {
          return a.months();
        }, monthsShort: function() {
          return a.monthsShort();
        }, longDateFormat: function(d) {
          return u(f, d);
        }, meridiem: f.meridiem, ordinal: f.ordinal };
      }, a.months = function() {
        return s(l(), "months");
      }, a.monthsShort = function() {
        return s(l(), "monthsShort", "months", 3);
      }, a.weekdays = function(f) {
        return s(l(), "weekdays", null, null, f);
      }, a.weekdaysShort = function(f) {
        return s(l(), "weekdaysShort", "weekdays", 3, f);
      }, a.weekdaysMin = function(f) {
        return s(l(), "weekdaysMin", "weekdays", 2, f);
      };
    };
  });
})(ok);
var rae = ok.exports;
const aae = /* @__PURE__ */ Ki(rae);
var ik = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ra, function() {
    var n = "week", r = "year";
    return function(a, o, i) {
      var s = o.prototype;
      s.week = function(l) {
        if (l === void 0 && (l = null), l !== null) return this.add(7 * (l - this.week()), "day");
        var u = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var c = i(this).startOf(r).add(1, r).date(u), f = i(this).endOf(n);
          if (c.isBefore(f)) return 1;
        }
        var d = i(this).startOf(r).date(u).startOf(n).subtract(1, "millisecond"), p = this.diff(d, n, !0);
        return p < 0 ? i(this).startOf("week").week() : Math.ceil(p);
      }, s.weeks = function(l) {
        return l === void 0 && (l = null), this.week(l);
      };
    };
  });
})(ik);
var oae = ik.exports;
const iae = /* @__PURE__ */ Ki(oae);
var sk = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ra, function() {
    return function(n, r) {
      r.prototype.weekYear = function() {
        var a = this.month(), o = this.week(), i = this.year();
        return o === 1 && a === 11 ? i + 1 : a === 0 && o >= 52 ? i - 1 : i;
      };
    };
  });
})(sk);
var sae = sk.exports;
const lae = /* @__PURE__ */ Ki(sae);
var lk = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ra, function() {
    var n = "month", r = "quarter";
    return function(a, o) {
      var i = o.prototype;
      i.quarter = function(u) {
        return this.$utils().u(u) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (u - 1));
      };
      var s = i.add;
      i.add = function(u, c) {
        return u = Number(u), this.$utils().p(c) === r ? this.add(3 * u, n) : s.bind(this)(u, c);
      };
      var l = i.startOf;
      i.startOf = function(u, c) {
        var f = this.$utils(), d = !!f.u(c) || c;
        if (f.p(u) === r) {
          var p = this.quarter() - 1;
          return d ? this.month(3 * p).startOf(n).startOf("day") : this.month(3 * p + 2).endOf(n).endOf("day");
        }
        return l.bind(this)(u, c);
      };
    };
  });
})(lk);
var uae = lk.exports;
const cae = /* @__PURE__ */ Ki(uae);
var uk = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ra, function() {
    return function(n, r) {
      var a = r.prototype, o = a.format;
      a.format = function(i) {
        var s = this, l = this.$locale();
        if (!this.isValid()) return o.bind(this)(i);
        var u = this.$utils(), c = (i || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(f) {
          switch (f) {
            case "Q":
              return Math.ceil((s.$M + 1) / 3);
            case "Do":
              return l.ordinal(s.$D);
            case "gggg":
              return s.weekYear();
            case "GGGG":
              return s.isoWeekYear();
            case "wo":
              return l.ordinal(s.week(), "W");
            case "w":
            case "ww":
              return u.s(s.week(), f === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return u.s(s.isoWeek(), f === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return u.s(String(s.$H === 0 ? 24 : s.$H), f === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(s.$d.getTime() / 1e3);
            case "x":
              return s.$d.getTime();
            case "z":
              return "[" + s.offsetName() + "]";
            case "zzz":
              return "[" + s.offsetName("long") + "]";
            default:
              return f;
          }
        });
        return o.bind(this)(c);
      };
    };
  });
})(uk);
var fae = uk.exports;
const dae = /* @__PURE__ */ Ki(fae);
var ck = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ra, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, a = /\d\d/, o = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, s = {}, l = function(h) {
      return (h = +h) + (h > 68 ? 1900 : 2e3);
    }, u = function(h) {
      return function(m) {
        this[h] = +m;
      };
    }, c = [/[+-]\d\d:?(\d\d)?|Z/, function(h) {
      (this.zone || (this.zone = {})).offset = function(m) {
        if (!m || m === "Z") return 0;
        var y = m.match(/([+-]|\d\d)/g), x = 60 * y[1] + (+y[2] || 0);
        return x === 0 ? 0 : y[0] === "+" ? -x : x;
      }(h);
    }], f = function(h) {
      var m = s[h];
      return m && (m.indexOf ? m : m.s.concat(m.f));
    }, d = function(h, m) {
      var y, x = s.meridiem;
      if (x) {
        for (var g = 1; g <= 24; g += 1) if (h.indexOf(x(g, 0, m)) > -1) {
          y = g > 12;
          break;
        }
      } else y = h === (m ? "pm" : "PM");
      return y;
    }, p = { A: [i, function(h) {
      this.afternoon = d(h, !1);
    }], a: [i, function(h) {
      this.afternoon = d(h, !0);
    }], S: [/\d/, function(h) {
      this.milliseconds = 100 * +h;
    }], SS: [a, function(h) {
      this.milliseconds = 10 * +h;
    }], SSS: [/\d{3}/, function(h) {
      this.milliseconds = +h;
    }], s: [o, u("seconds")], ss: [o, u("seconds")], m: [o, u("minutes")], mm: [o, u("minutes")], H: [o, u("hours")], h: [o, u("hours")], HH: [o, u("hours")], hh: [o, u("hours")], D: [o, u("day")], DD: [a, u("day")], Do: [i, function(h) {
      var m = s.ordinal, y = h.match(/\d+/);
      if (this.day = y[0], m) for (var x = 1; x <= 31; x += 1) m(x).replace(/\[|\]/g, "") === h && (this.day = x);
    }], M: [o, u("month")], MM: [a, u("month")], MMM: [i, function(h) {
      var m = f("months"), y = (f("monthsShort") || m.map(function(x) {
        return x.slice(0, 3);
      })).indexOf(h) + 1;
      if (y < 1) throw new Error();
      this.month = y % 12 || y;
    }], MMMM: [i, function(h) {
      var m = f("months").indexOf(h) + 1;
      if (m < 1) throw new Error();
      this.month = m % 12 || m;
    }], Y: [/[+-]?\d+/, u("year")], YY: [a, function(h) {
      this.year = l(h);
    }], YYYY: [/\d{4}/, u("year")], Z: c, ZZ: c };
    function v(h) {
      var m, y;
      m = h, y = s && s.formats;
      for (var x = (h = m.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(C, T, O) {
        var I = O && O.toUpperCase();
        return T || y[O] || n[O] || y[I].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(k, B, P) {
          return B || P.slice(1);
        });
      })).match(r), g = x.length, S = 0; S < g; S += 1) {
        var w = x[S], _ = p[w], b = _ && _[0], E = _ && _[1];
        x[S] = E ? { regex: b, parser: E } : w.replace(/^\[|\]$/g, "");
      }
      return function(C) {
        for (var T = {}, O = 0, I = 0; O < g; O += 1) {
          var k = x[O];
          if (typeof k == "string") I += k.length;
          else {
            var B = k.regex, P = k.parser, N = C.slice(I), M = B.exec(N)[0];
            P.call(T, M), C = C.replace(M, "");
          }
        }
        return function(H) {
          var R = H.afternoon;
          if (R !== void 0) {
            var z = H.hours;
            R ? z < 12 && (H.hours += 12) : z === 12 && (H.hours = 0), delete H.afternoon;
          }
        }(T), T;
      };
    }
    return function(h, m, y) {
      y.p.customParseFormat = !0, h && h.parseTwoDigitYear && (l = h.parseTwoDigitYear);
      var x = m.prototype, g = x.parse;
      x.parse = function(S) {
        var w = S.date, _ = S.utc, b = S.args;
        this.$u = _;
        var E = b[1];
        if (typeof E == "string") {
          var C = b[2] === !0, T = b[3] === !0, O = C || T, I = b[2];
          T && (I = b[2]), s = this.$locale(), !C && I && (s = y.Ls[I]), this.$d = function(N, M, H) {
            try {
              if (["x", "X"].indexOf(M) > -1) return new Date((M === "X" ? 1e3 : 1) * N);
              var R = v(M)(N), z = R.year, W = R.month, F = R.day, Y = R.hours, X = R.minutes, q = R.seconds, Q = R.milliseconds, ue = R.zone, le = /* @__PURE__ */ new Date(), te = F || (z || W ? 1 : le.getDate()), G = z || le.getFullYear(), oe = 0;
              z && !W || (oe = W > 0 ? W - 1 : le.getMonth());
              var L = Y || 0, re = X || 0, j = q || 0, J = Q || 0;
              return ue ? new Date(Date.UTC(G, oe, te, L, re, j, J + 60 * ue.offset * 1e3)) : H ? new Date(Date.UTC(G, oe, te, L, re, j, J)) : new Date(G, oe, te, L, re, j, J);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(w, E, _), this.init(), I && I !== !0 && (this.$L = this.locale(I).$L), O && w != this.format(E) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
        } else if (E instanceof Array) for (var k = E.length, B = 1; B <= k; B += 1) {
          b[1] = E[B - 1];
          var P = y.apply(this, b);
          if (P.isValid()) {
            this.$d = P.$d, this.$L = P.$L, this.init();
            break;
          }
          B === k && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else g.call(this, S);
      };
    };
  });
})(ck);
var pae = ck.exports;
const hae = /* @__PURE__ */ Ki(pae);
It.extend(hae);
It.extend(dae);
It.extend(nae);
It.extend(aae);
It.extend(iae);
It.extend(lae);
It.extend(cae);
It.extend((e, t) => {
  const n = t.prototype, r = n.format;
  n.format = function(o) {
    const i = (o || "").replace("Wo", "wo");
    return r.bind(this)(i);
  };
});
const vae = {
  // ar_EG:
  // az_AZ:
  // bg_BG:
  bn_BD: "bn-bd",
  by_BY: "be",
  // ca_ES:
  // cs_CZ:
  // da_DK:
  // de_DE:
  // el_GR:
  en_GB: "en-gb",
  en_US: "en",
  // es_ES:
  // et_EE:
  // fa_IR:
  // fi_FI:
  fr_BE: "fr",
  fr_CA: "fr-ca",
  // fr_FR:
  // ga_IE:
  // gl_ES:
  // he_IL:
  // hi_IN:
  // hr_HR:
  // hu_HU:
  hy_AM: "hy-am",
  // id_ID:
  // is_IS:
  // it_IT:
  // ja_JP:
  // ka_GE:
  // kk_KZ:
  // km_KH:
  kmr_IQ: "ku",
  // kn_IN:
  // ko_KR:
  // ku_IQ: // previous ku in antd
  // lt_LT:
  // lv_LV:
  // mk_MK:
  // ml_IN:
  // mn_MN:
  // ms_MY:
  // nb_NO:
  // ne_NP:
  nl_BE: "nl-be",
  // nl_NL:
  // pl_PL:
  pt_BR: "pt-br",
  // pt_PT:
  // ro_RO:
  // ru_RU:
  // sk_SK:
  // sl_SI:
  // sr_RS:
  // sv_SE:
  // ta_IN:
  // th_TH:
  // tr_TR:
  // uk_UA:
  // ur_PK:
  // vi_VN:
  zh_CN: "zh-cn",
  zh_HK: "zh-hk",
  zh_TW: "zh-tw"
}, Su = (e) => vae[e] || e.split("_")[0], m5 = () => {
  kb(!1, "Not match any format. Please help to fire a issue about this.");
}, mae = /\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|k{1,2}|S/g;
function g5(e, t, n) {
  const r = [...new Set(e.split(n))];
  let a = 0;
  for (let o = 0; o < r.length; o++) {
    const i = r[o];
    if (a += i.length, a > t)
      return i;
    a += n.length;
  }
}
const y5 = (e, t) => {
  if (!e) return null;
  if (It.isDayjs(e))
    return e;
  const n = t.matchAll(mae);
  let r = It(e, t);
  if (n === null)
    return r;
  for (const a of n) {
    const o = a[0], i = a.index;
    if (o === "Q") {
      const s = e.slice(i - 1, i), l = g5(e, i, s).match(/\d+/)[0];
      r = r.quarter(parseInt(l));
    }
    if (o.toLowerCase() === "wo") {
      const s = e.slice(i - 1, i), l = g5(e, i, s).match(/\d+/)[0];
      r = r.week(parseInt(l));
    }
    o.toLowerCase() === "ww" && (r = r.week(parseInt(e.slice(i, i + o.length)))), o.toLowerCase() === "w" && (r = r.week(parseInt(e.slice(i, i + o.length + 1))));
  }
  return r;
}, gae = {
  // get
  getNow: () => It(),
  getFixedDate: (e) => It(e, ["YYYY-M-DD", "YYYY-MM-DD"]),
  getEndDate: (e) => e.endOf("month"),
  getWeekDay: (e) => {
    const t = e.locale("en");
    return t.weekday() + t.localeData().firstDayOfWeek();
  },
  getYear: (e) => e.year(),
  getMonth: (e) => e.month(),
  getDate: (e) => e.date(),
  getHour: (e) => e.hour(),
  getMinute: (e) => e.minute(),
  getSecond: (e) => e.second(),
  // set
  addYear: (e, t) => e.add(t, "year"),
  addMonth: (e, t) => e.add(t, "month"),
  addDate: (e, t) => e.add(t, "day"),
  setYear: (e, t) => e.year(t),
  setMonth: (e, t) => e.month(t),
  setDate: (e, t) => e.date(t),
  setHour: (e, t) => e.hour(t),
  setMinute: (e, t) => e.minute(t),
  setSecond: (e, t) => e.second(t),
  // Compare
  isAfter: (e, t) => e.isAfter(t),
  isValidate: (e) => e.isValid(),
  locale: {
    getWeekFirstDay: (e) => It().locale(Su(e)).localeData().firstDayOfWeek(),
    getWeekFirstDate: (e, t) => t.locale(Su(e)).weekday(0),
    getWeek: (e, t) => t.locale(Su(e)).week(),
    getShortWeekDays: (e) => It().locale(Su(e)).localeData().weekdaysMin(),
    getShortMonths: (e) => It().locale(Su(e)).localeData().monthsShort(),
    format: (e, t, n) => t.locale(Su(e)).format(n),
    parse: (e, t, n) => {
      const r = Su(e);
      for (let a = 0; a < n.length; a += 1) {
        const o = n[a], i = t;
        if (o.includes("wo") || o.includes("Wo")) {
          const l = i.split("-")[0], u = i.split("-")[1], c = It(l, "YYYY").startOf("year").locale(r);
          for (let f = 0; f <= 52; f += 1) {
            const d = c.add(f, "week");
            if (d.format("Wo") === u)
              return d;
          }
          return m5(), null;
        }
        const s = It(i, o, !0).locale(r);
        if (s.isValid())
          return s;
      }
      return t || m5(), null;
    }
  },
  toDate: (e, t) => Array.isArray(e) ? e.map((n) => y5(n, t)) : y5(e, t),
  toString: (e, t) => Array.isArray(e) ? e.map((n) => It.isDayjs(n) ? n.format(t) : n) : It.isDayjs(e) ? e.format(t) : e
};
function br(e) {
  const t = w_();
  return D(D({}, e), t);
}
const fk = Symbol("PanelContextProps"), WC = (e) => {
  kt(fk, e);
}, Cs = () => Ke(fk, {}), zh = {
  visibility: "hidden"
};
function hu(e, t) {
  let {
    slots: n
  } = t;
  var r;
  const a = br(e), {
    prefixCls: o,
    prevIcon: i = "‹",
    nextIcon: s = "›",
    superPrevIcon: l = "«",
    superNextIcon: u = "»",
    onSuperPrev: c,
    onSuperNext: f,
    onPrev: d,
    onNext: p
  } = a, {
    hideNextBtn: v,
    hidePrevBtn: h
  } = Cs();
  return A("div", {
    class: o
  }, [c && A("button", {
    type: "button",
    onClick: c,
    tabindex: -1,
    class: `${o}-super-prev-btn`,
    style: h.value ? zh : {}
  }, [l]), d && A("button", {
    type: "button",
    onClick: d,
    tabindex: -1,
    class: `${o}-prev-btn`,
    style: h.value ? zh : {}
  }, [i]), A("div", {
    class: `${o}-view`
  }, [(r = n.default) === null || r === void 0 ? void 0 : r.call(n)]), p && A("button", {
    type: "button",
    onClick: p,
    tabindex: -1,
    class: `${o}-next-btn`,
    style: v.value ? zh : {}
  }, [s]), f && A("button", {
    type: "button",
    onClick: f,
    tabindex: -1,
    class: `${o}-super-next-btn`,
    style: v.value ? zh : {}
  }, [u])]);
}
hu.displayName = "Header";
hu.inheritAttrs = !1;
function GC(e) {
  const t = br(e), {
    prefixCls: n,
    generateConfig: r,
    viewDate: a,
    onPrevDecades: o,
    onNextDecades: i
  } = t, {
    hideHeader: s
  } = Cs();
  if (s)
    return null;
  const l = `${n}-header`, u = r.getYear(a), c = Math.floor(u / Vs) * Vs, f = c + Vs - 1;
  return A(hu, ve(ve({}, t), {}, {
    prefixCls: l,
    onSuperPrev: o,
    onSuperNext: i
  }), {
    default: () => [c, Jt("-"), f]
  });
}
GC.displayName = "DecadeHeader";
GC.inheritAttrs = !1;
function dk(e, t, n, r, a) {
  let o = e.setHour(t, n);
  return o = e.setMinute(o, r), o = e.setSecond(o, a), o;
}
function Lv(e, t, n) {
  if (!n)
    return t;
  let r = t;
  return r = e.setHour(r, e.getHour(n)), r = e.setMinute(r, e.getMinute(n)), r = e.setSecond(r, e.getSecond(n)), r;
}
function yae(e, t, n, r, a, o) {
  const i = Math.floor(e / r) * r;
  if (i < e)
    return [i, 60 - a, 60 - o];
  const s = Math.floor(t / a) * a;
  if (s < t)
    return [i, s, 60 - o];
  const l = Math.floor(n / o) * o;
  return [i, s, l];
}
function xae(e, t) {
  const n = e.getYear(t), r = e.getMonth(t) + 1, a = e.getEndDate(e.getFixedDate(`${n}-${r}-01`)), o = e.getDate(a), i = r < 10 ? `0${r}` : `${r}`;
  return `${n}-${i}-${o}`;
}
function Dc(e) {
  const {
    prefixCls: t,
    disabledDate: n,
    onSelect: r,
    picker: a,
    rowNum: o,
    colNum: i,
    prefixColumn: s,
    rowClassName: l,
    baseDate: u,
    getCellClassName: c,
    getCellText: f,
    getCellNode: d,
    getCellDate: p,
    generateConfig: v,
    titleCell: h,
    headerCells: m
  } = br(e), {
    onDateMouseenter: y,
    onDateMouseleave: x,
    mode: g
  } = Cs(), S = `${t}-cell`, w = [];
  for (let _ = 0; _ < o; _ += 1) {
    const b = [];
    let E;
    for (let C = 0; C < i; C += 1) {
      const T = _ * i + C, O = p(u, T), I = h2({
        cellDate: O,
        mode: g.value,
        disabledDate: n,
        generateConfig: v
      });
      C === 0 && (E = O, s && b.push(s(E)));
      const k = h && h(O);
      b.push(A("td", {
        key: C,
        title: k,
        class: Ge(S, D({
          [`${S}-disabled`]: I,
          [`${S}-start`]: f(O) === 1 || a === "year" && Number(k) % 10 === 0,
          [`${S}-end`]: k === xae(v, O) || a === "year" && Number(k) % 10 === 9
        }, c(O))),
        onClick: (B) => {
          B.stopPropagation(), I || r(O);
        },
        onMouseenter: () => {
          !I && y && y(O);
        },
        onMouseleave: () => {
          !I && x && x(O);
        }
      }, [d ? d(O) : A("div", {
        class: `${S}-inner`
      }, [f(O)])]));
    }
    w.push(A("tr", {
      key: _,
      class: l && l(E)
    }, [b]));
  }
  return A("div", {
    class: `${t}-body`
  }, [A("table", {
    class: `${t}-content`
  }, [m && A("thead", null, [A("tr", null, [m])]), A("tbody", null, [w])])]);
}
Dc.displayName = "PanelBody";
Dc.inheritAttrs = !1;
const f2 = 3, x5 = 4;
function KC(e) {
  const t = br(e), n = ki - 1, {
    prefixCls: r,
    viewDate: a,
    generateConfig: o
  } = t, i = `${r}-cell`, s = o.getYear(a), l = Math.floor(s / ki) * ki, u = Math.floor(s / Vs) * Vs, c = u + Vs - 1, f = o.setYear(a, u - Math.ceil((f2 * x5 * ki - Vs) / 2)), d = (p) => {
    const v = o.getYear(p), h = v + n;
    return {
      [`${i}-in-view`]: u <= v && h <= c,
      [`${i}-selected`]: v === l
    };
  };
  return A(Dc, ve(ve({}, t), {}, {
    rowNum: x5,
    colNum: f2,
    baseDate: f,
    getCellText: (p) => {
      const v = o.getYear(p);
      return `${v}-${v + n}`;
    },
    getCellClassName: d,
    getCellDate: (p, v) => o.addYear(p, v * ki)
  }), null);
}
KC.displayName = "DecadeBody";
KC.inheritAttrs = !1;
const Wh = /* @__PURE__ */ new Map();
function bae(e, t) {
  let n;
  function r() {
    oC(e) ? t() : n = dn(() => {
      r();
    });
  }
  return r(), () => {
    dn.cancel(n);
  };
}
function d2(e, t, n) {
  if (Wh.get(e) && dn.cancel(Wh.get(e)), n <= 0) {
    Wh.set(e, dn(() => {
      e.scrollTop = t;
    }));
    return;
  }
  const a = (t - e.scrollTop) / n * 10;
  Wh.set(e, dn(() => {
    e.scrollTop += a, e.scrollTop !== t && d2(e, t, n - 10);
  }));
}
function Sd(e, t) {
  let {
    onLeftRight: n,
    onCtrlLeftRight: r,
    onUpDown: a,
    onPageUpDown: o,
    onEnter: i
  } = t;
  const {
    which: s,
    ctrlKey: l,
    metaKey: u
  } = e;
  switch (s) {
    case Ye.LEFT:
      if (l || u) {
        if (r)
          return r(-1), !0;
      } else if (n)
        return n(-1), !0;
      break;
    case Ye.RIGHT:
      if (l || u) {
        if (r)
          return r(1), !0;
      } else if (n)
        return n(1), !0;
      break;
    case Ye.UP:
      if (a)
        return a(-1), !0;
      break;
    case Ye.DOWN:
      if (a)
        return a(1), !0;
      break;
    case Ye.PAGE_UP:
      if (o)
        return o(-1), !0;
      break;
    case Ye.PAGE_DOWN:
      if (o)
        return o(1), !0;
      break;
    case Ye.ENTER:
      if (i)
        return i(), !0;
      break;
  }
  return !1;
}
function pk(e, t, n, r) {
  let a = e;
  if (!a)
    switch (t) {
      case "time":
        a = r ? "hh:mm:ss a" : "HH:mm:ss";
        break;
      case "week":
        a = "gggg-wo";
        break;
      case "month":
        a = "YYYY-MM";
        break;
      case "quarter":
        a = "YYYY-[Q]Q";
        break;
      case "year":
        a = "YYYY";
        break;
      default:
        a = n ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
    }
  return a;
}
function hk(e, t, n) {
  const r = e === "time" ? 8 : 10, a = typeof t == "function" ? t(n.getNow()).length : t.length;
  return Math.max(r, a) + 2;
}
let Vd = null;
const Gh = /* @__PURE__ */ new Set();
function wae(e) {
  return !Vd && typeof window < "u" && window.addEventListener && (Vd = (t) => {
    [...Gh].forEach((n) => {
      n(t);
    });
  }, window.addEventListener("mousedown", Vd)), Gh.add(e), () => {
    Gh.delete(e), Gh.size === 0 && (window.removeEventListener("mousedown", Vd), Vd = null);
  };
}
function Sae(e) {
  var t;
  const n = e.target;
  return e.composed && n.shadowRoot && ((t = e.composedPath) === null || t === void 0 ? void 0 : t.call(e)[0]) || n;
}
const _ae = (e) => e === "month" || e === "date" ? "year" : e, Cae = (e) => e === "date" ? "month" : e, Eae = (e) => e === "month" || e === "date" ? "quarter" : e, Tae = (e) => e === "date" ? "week" : e, $ae = {
  year: _ae,
  month: Cae,
  quarter: Eae,
  week: Tae,
  time: null,
  date: null
};
function vk(e, t) {
  return process.env.NODE_ENV === "test" ? !1 : e.some((n) => n && n.contains(t));
}
const ki = 10, Vs = ki * 10;
function YC(e) {
  const t = br(e), {
    prefixCls: n,
    onViewDateChange: r,
    generateConfig: a,
    viewDate: o,
    operationRef: i,
    onSelect: s,
    onPanelChange: l
  } = t, u = `${n}-decade-panel`;
  i.value = {
    onKeydown: (d) => Sd(d, {
      onLeftRight: (p) => {
        s(a.addYear(o, p * ki), "key");
      },
      onCtrlLeftRight: (p) => {
        s(a.addYear(o, p * Vs), "key");
      },
      onUpDown: (p) => {
        s(a.addYear(o, p * ki * f2), "key");
      },
      onEnter: () => {
        l("year", o);
      }
    })
  };
  const c = (d) => {
    const p = a.addYear(o, d * Vs);
    r(p), l(null, p);
  }, f = (d) => {
    s(d, "mouse"), l("year", d);
  };
  return A("div", {
    class: u
  }, [A(GC, ve(ve({}, t), {}, {
    prefixCls: n,
    onPrevDecades: () => {
      c(-1);
    },
    onNextDecades: () => {
      c(1);
    }
  }), null), A(KC, ve(ve({}, t), {}, {
    prefixCls: n,
    onSelect: f
  }), null)]);
}
YC.displayName = "DecadePanel";
YC.inheritAttrs = !1;
const Bv = 7;
function kc(e, t) {
  if (!e && !t)
    return !0;
  if (!e || !t)
    return !1;
}
function Oae(e, t, n) {
  const r = kc(t, n);
  if (typeof r == "boolean")
    return r;
  const a = Math.floor(e.getYear(t) / 10), o = Math.floor(e.getYear(n) / 10);
  return a === o;
}
function S1(e, t, n) {
  const r = kc(t, n);
  return typeof r == "boolean" ? r : e.getYear(t) === e.getYear(n);
}
function p2(e, t) {
  return Math.floor(e.getMonth(t) / 3) + 1;
}
function mk(e, t, n) {
  const r = kc(t, n);
  return typeof r == "boolean" ? r : S1(e, t, n) && p2(e, t) === p2(e, n);
}
function qC(e, t, n) {
  const r = kc(t, n);
  return typeof r == "boolean" ? r : S1(e, t, n) && e.getMonth(t) === e.getMonth(n);
}
function Us(e, t, n) {
  const r = kc(t, n);
  return typeof r == "boolean" ? r : e.getYear(t) === e.getYear(n) && e.getMonth(t) === e.getMonth(n) && e.getDate(t) === e.getDate(n);
}
function Aae(e, t, n) {
  const r = kc(t, n);
  return typeof r == "boolean" ? r : e.getHour(t) === e.getHour(n) && e.getMinute(t) === e.getMinute(n) && e.getSecond(t) === e.getSecond(n);
}
function gk(e, t, n, r) {
  const a = kc(n, r);
  return typeof a == "boolean" ? a : e.locale.getWeek(t, n) === e.locale.getWeek(t, r);
}
function $f(e, t, n) {
  return Us(e, t, n) && Aae(e, t, n);
}
function Kh(e, t, n, r) {
  return !t || !n || !r ? !1 : !Us(e, t, r) && !Us(e, n, r) && e.isAfter(r, t) && e.isAfter(n, r);
}
function Iae(e, t, n) {
  const r = t.locale.getWeekFirstDay(e), a = t.setDate(n, 1), o = t.getWeekDay(a);
  let i = t.addDate(a, r - o);
  return t.getMonth(i) === t.getMonth(n) && t.getDate(i) > 1 && (i = t.addDate(i, -7)), i;
}
function _0(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  switch (t) {
    case "year":
      return n.addYear(e, r * 10);
    case "quarter":
    case "month":
      return n.addYear(e, r);
    default:
      return n.addMonth(e, r);
  }
}
function sa(e, t) {
  let {
    generateConfig: n,
    locale: r,
    format: a
  } = t;
  return typeof a == "function" ? a(e) : n.locale.format(r.locale, e, a);
}
function yk(e, t) {
  let {
    generateConfig: n,
    locale: r,
    formatList: a
  } = t;
  return !e || typeof a[0] == "function" ? null : n.locale.parse(r.locale, e, a);
}
function h2(e) {
  let {
    cellDate: t,
    mode: n,
    disabledDate: r,
    generateConfig: a
  } = e;
  if (!r) return !1;
  const o = (i, s, l) => {
    let u = s;
    for (; u <= l; ) {
      let c;
      switch (i) {
        case "date": {
          if (c = a.setDate(t, u), !r(c))
            return !1;
          break;
        }
        case "month": {
          if (c = a.setMonth(t, u), !h2({
            cellDate: c,
            mode: "month",
            generateConfig: a,
            disabledDate: r
          }))
            return !1;
          break;
        }
        case "year": {
          if (c = a.setYear(t, u), !h2({
            cellDate: c,
            mode: "year",
            generateConfig: a,
            disabledDate: r
          }))
            return !1;
          break;
        }
      }
      u += 1;
    }
    return !0;
  };
  switch (n) {
    case "date":
    case "week":
      return r(t);
    case "month": {
      const s = a.getDate(a.getEndDate(t));
      return o("date", 1, s);
    }
    case "quarter": {
      const i = Math.floor(a.getMonth(t) / 3) * 3, s = i + 2;
      return o("month", i, s);
    }
    case "year":
      return o("month", 0, 11);
    case "decade": {
      const i = a.getYear(t), s = Math.floor(i / ki) * ki, l = s + ki - 1;
      return o("year", s, l);
    }
  }
}
function XC(e) {
  const t = br(e), {
    hideHeader: n
  } = Cs();
  if (n.value)
    return null;
  const {
    prefixCls: r,
    generateConfig: a,
    locale: o,
    value: i,
    format: s
  } = t, l = `${r}-header`;
  return A(hu, {
    prefixCls: l
  }, {
    default: () => [i ? sa(i, {
      locale: o,
      format: s,
      generateConfig: a
    }) : " "]
  });
}
XC.displayName = "TimeHeader";
XC.inheritAttrs = !1;
const Yh = /* @__PURE__ */ Me({
  name: "TimeUnitColumn",
  props: ["prefixCls", "units", "onSelect", "value", "active", "hideDisabledOptions"],
  setup(e) {
    const {
      open: t
    } = Cs(), n = Be(null), r = ne(/* @__PURE__ */ new Map()), a = ne();
    return He(() => e.value, () => {
      const o = r.value.get(e.value);
      o && t.value !== !1 && d2(n.value, o.offsetTop, 120);
    }), Sn(() => {
      var o;
      (o = a.value) === null || o === void 0 || o.call(a);
    }), He(t, () => {
      var o;
      (o = a.value) === null || o === void 0 || o.call(a), nn(() => {
        if (t.value) {
          const i = r.value.get(e.value);
          i && (a.value = bae(i, () => {
            d2(n.value, i.offsetTop, 0);
          }));
        }
      });
    }, {
      immediate: !0,
      flush: "post"
    }), () => {
      const {
        prefixCls: o,
        units: i,
        onSelect: s,
        value: l,
        active: u,
        hideDisabledOptions: c
      } = e, f = `${o}-cell`;
      return A("ul", {
        class: Ge(`${o}-column`, {
          [`${o}-column-active`]: u
        }),
        ref: n,
        style: {
          position: "relative"
        }
      }, [i.map((d) => c && d.disabled ? null : A("li", {
        key: d.value,
        ref: (p) => {
          r.value.set(d.value, p);
        },
        class: Ge(f, {
          [`${f}-disabled`]: d.disabled,
          [`${f}-selected`]: l === d.value
        }),
        onClick: () => {
          d.disabled || s(d.value);
        }
      }, [A("div", {
        class: `${f}-inner`
      }, [d.label])]))]);
    };
  }
});
function xk(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0", r = String(e);
  for (; r.length < t; )
    r = `${n}${e}`;
  return r;
}
const Pae = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t;
};
function bk(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function wk(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    (n.startsWith("data-") || n.startsWith("aria-") || n === "role" || n === "name") && !n.startsWith("data-__") && (t[n] = e[n]);
  }), t;
}
function an(e, t) {
  return e ? e[t] : null;
}
function Jo(e, t, n) {
  const r = [an(e, 0), an(e, 1)];
  return r[n] = typeof t == "function" ? t(r[n]) : t, !r[0] && !r[1] ? null : r;
}
function Vy(e, t, n, r) {
  const a = [];
  for (let o = e; o <= t; o += n)
    a.push({
      label: xk(o, 2),
      value: o,
      disabled: (r || []).includes(o)
    });
  return a;
}
const Dae = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "TimeBody",
  inheritAttrs: !1,
  props: ["generateConfig", "prefixCls", "operationRef", "activeColumnIndex", "value", "showHour", "showMinute", "showSecond", "use12Hours", "hourStep", "minuteStep", "secondStep", "disabledHours", "disabledMinutes", "disabledSeconds", "disabledTime", "hideDisabledOptions", "onSelect"],
  setup(e) {
    const t = V(() => e.value ? e.generateConfig.getHour(e.value) : -1), n = V(() => e.use12Hours ? t.value >= 12 : !1), r = V(() => e.use12Hours ? t.value % 12 : t.value), a = V(() => e.value ? e.generateConfig.getMinute(e.value) : -1), o = V(() => e.value ? e.generateConfig.getSecond(e.value) : -1), i = ne(e.generateConfig.getNow()), s = ne(), l = ne(), u = ne();
    Cg(() => {
      i.value = e.generateConfig.getNow();
    }), _n(() => {
      if (e.disabledTime) {
        const m = e.disabledTime(i);
        [s.value, l.value, u.value] = [m.disabledHours, m.disabledMinutes, m.disabledSeconds];
      } else
        [s.value, l.value, u.value] = [e.disabledHours, e.disabledMinutes, e.disabledSeconds];
    });
    const c = (m, y, x, g) => {
      let S = e.value || e.generateConfig.getNow();
      const w = Math.max(0, y), _ = Math.max(0, x), b = Math.max(0, g);
      return S = dk(e.generateConfig, S, !e.use12Hours || !m ? w : w + 12, _, b), S;
    }, f = V(() => {
      var m;
      return Vy(0, 23, (m = e.hourStep) !== null && m !== void 0 ? m : 1, s.value && s.value());
    }), d = V(() => {
      if (!e.use12Hours)
        return [!1, !1];
      const m = [!0, !0];
      return f.value.forEach((y) => {
        let {
          disabled: x,
          value: g
        } = y;
        x || (g >= 12 ? m[1] = !1 : m[0] = !1);
      }), m;
    }), p = V(() => e.use12Hours ? f.value.filter(n.value ? (m) => m.value >= 12 : (m) => m.value < 12).map((m) => {
      const y = m.value % 12, x = y === 0 ? "12" : xk(y, 2);
      return D(D({}, m), {
        label: x,
        value: y
      });
    }) : f.value), v = V(() => {
      var m;
      return Vy(0, 59, (m = e.minuteStep) !== null && m !== void 0 ? m : 1, l.value && l.value(t.value));
    }), h = V(() => {
      var m;
      return Vy(0, 59, (m = e.secondStep) !== null && m !== void 0 ? m : 1, u.value && u.value(t.value, a.value));
    });
    return () => {
      const {
        prefixCls: m,
        operationRef: y,
        activeColumnIndex: x,
        showHour: g,
        showMinute: S,
        showSecond: w,
        use12Hours: _,
        hideDisabledOptions: b,
        onSelect: E
      } = e, C = [], T = `${m}-content`, O = `${m}-time-panel`;
      y.value = {
        onUpDown: (B) => {
          const P = C[x];
          if (P) {
            const N = P.units.findIndex((H) => H.value === P.value), M = P.units.length;
            for (let H = 1; H < M; H += 1) {
              const R = P.units[(N + B * H + M) % M];
              if (R.disabled !== !0) {
                P.onSelect(R.value);
                break;
              }
            }
          }
        }
      };
      function I(B, P, N, M, H) {
        B !== !1 && C.push({
          node: sr(P, {
            prefixCls: O,
            value: N,
            active: x === C.length,
            onSelect: H,
            units: M,
            hideDisabledOptions: b
          }),
          onSelect: H,
          value: N,
          units: M
        });
      }
      I(g, A(Yh, {
        key: "hour"
      }, null), r.value, p.value, (B) => {
        E(c(n.value, B, a.value, o.value), "mouse");
      }), I(S, A(Yh, {
        key: "minute"
      }, null), a.value, v.value, (B) => {
        E(c(n.value, r.value, B, o.value), "mouse");
      }), I(w, A(Yh, {
        key: "second"
      }, null), o.value, h.value, (B) => {
        E(c(n.value, r.value, a.value, B), "mouse");
      });
      let k = -1;
      return typeof n.value == "boolean" && (k = n.value ? 1 : 0), I(_ === !0, A(Yh, {
        key: "12hours"
      }, null), k, [{
        label: "AM",
        value: 0,
        disabled: d.value[0]
      }, {
        label: "PM",
        value: 1,
        disabled: d.value[1]
      }], (B) => {
        E(c(!!B, r.value, a.value, o.value), "mouse");
      }), A("div", {
        class: T
      }, [C.map((B) => {
        let {
          node: P
        } = B;
        return P;
      })]);
    };
  }
}), kae = (e) => e.filter((t) => t !== !1).length;
function _1(e) {
  const t = br(e), {
    generateConfig: n,
    format: r = "HH:mm:ss",
    prefixCls: a,
    active: o,
    operationRef: i,
    showHour: s,
    showMinute: l,
    showSecond: u,
    use12Hours: c = !1,
    onSelect: f,
    value: d
  } = t, p = `${a}-time-panel`, v = ne(), h = ne(-1), m = kae([s, l, u, c]);
  return i.value = {
    onKeydown: (y) => Sd(y, {
      onLeftRight: (x) => {
        h.value = (h.value + x + m) % m;
      },
      onUpDown: (x) => {
        h.value === -1 ? h.value = 0 : v.value && v.value.onUpDown(x);
      },
      onEnter: () => {
        f(d || n.getNow(), "key"), h.value = -1;
      }
    }),
    onBlur: () => {
      h.value = -1;
    }
  }, A("div", {
    class: Ge(p, {
      [`${p}-active`]: o
    })
  }, [A(XC, ve(ve({}, t), {}, {
    format: r,
    prefixCls: a
  }), null), A(Dae, ve(ve({}, t), {}, {
    prefixCls: a,
    activeColumnIndex: h.value,
    operationRef: v
  }), null)]);
}
_1.displayName = "TimePanel";
_1.inheritAttrs = !1;
function C1(e) {
  let {
    cellPrefixCls: t,
    generateConfig: n,
    rangedValue: r,
    hoverRangedValue: a,
    isInView: o,
    isSameCell: i,
    offsetCell: s,
    today: l,
    value: u
  } = e;
  function c(f) {
    const d = s(f, -1), p = s(f, 1), v = an(r, 0), h = an(r, 1), m = an(a, 0), y = an(a, 1), x = Kh(n, m, y, f);
    function g(C) {
      return i(v, C);
    }
    function S(C) {
      return i(h, C);
    }
    const w = i(m, f), _ = i(y, f), b = (x || _) && (!o(d) || S(d)), E = (x || w) && (!o(p) || g(p));
    return {
      // In view
      [`${t}-in-view`]: o(f),
      // Range
      [`${t}-in-range`]: Kh(n, v, h, f),
      [`${t}-range-start`]: g(f),
      [`${t}-range-end`]: S(f),
      [`${t}-range-start-single`]: g(f) && !h,
      [`${t}-range-end-single`]: S(f) && !v,
      [`${t}-range-start-near-hover`]: g(f) && (i(d, m) || Kh(n, m, y, d)),
      [`${t}-range-end-near-hover`]: S(f) && (i(p, y) || Kh(n, m, y, p)),
      // Range Hover
      [`${t}-range-hover`]: x,
      [`${t}-range-hover-start`]: w,
      [`${t}-range-hover-end`]: _,
      // Range Edge
      [`${t}-range-hover-edge-start`]: b,
      [`${t}-range-hover-edge-end`]: E,
      [`${t}-range-hover-edge-start-near-range`]: b && i(d, h),
      [`${t}-range-hover-edge-end-near-range`]: E && i(p, v),
      // Others
      [`${t}-today`]: i(l, f),
      [`${t}-selected`]: i(u, f)
    };
  }
  return c;
}
const Sk = Symbol("RangeContextProps"), Mae = (e) => {
  kt(Sk, e);
}, Gp = () => Ke(Sk, {
  rangedValue: ne(),
  hoverRangedValue: ne(),
  inRange: ne(),
  panelPosition: ne()
}), Rae = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "PanelContextProvider",
  inheritAttrs: !1,
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const r = {
      rangedValue: ne(e.value.rangedValue),
      hoverRangedValue: ne(e.value.hoverRangedValue),
      inRange: ne(e.value.inRange),
      panelPosition: ne(e.value.panelPosition)
    };
    return Mae(r), He(() => e.value, () => {
      Object.keys(e.value).forEach((a) => {
        r[a] && (r[a].value = e.value[a]);
      });
    }), () => {
      var a;
      return (a = n.default) === null || a === void 0 ? void 0 : a.call(n);
    };
  }
});
function E1(e) {
  const t = br(e), {
    prefixCls: n,
    generateConfig: r,
    prefixColumn: a,
    locale: o,
    rowCount: i,
    viewDate: s,
    value: l,
    dateRender: u
  } = t, {
    rangedValue: c,
    hoverRangedValue: f
  } = Gp(), d = Iae(o.locale, r, s), p = `${n}-cell`, v = r.locale.getWeekFirstDay(o.locale), h = r.getNow(), m = [], y = o.shortWeekDays || (r.locale.getShortWeekDays ? r.locale.getShortWeekDays(o.locale) : []);
  a && m.push(A("th", {
    key: "empty",
    "aria-label": "empty cell"
  }, null));
  for (let S = 0; S < Bv; S += 1)
    m.push(A("th", {
      key: S
    }, [y[(S + v) % Bv]]));
  const x = C1({
    cellPrefixCls: p,
    today: h,
    value: l,
    generateConfig: r,
    rangedValue: a ? null : c.value,
    hoverRangedValue: a ? null : f.value,
    isSameCell: (S, w) => Us(r, S, w),
    isInView: (S) => qC(r, S, s),
    offsetCell: (S, w) => r.addDate(S, w)
  }), g = u ? (S) => u({
    current: S,
    today: h
  }) : void 0;
  return A(Dc, ve(ve({}, t), {}, {
    rowNum: i,
    colNum: Bv,
    baseDate: d,
    getCellNode: g,
    getCellText: r.getDate,
    getCellClassName: x,
    getCellDate: r.addDate,
    titleCell: (S) => sa(S, {
      locale: o,
      format: "YYYY-MM-DD",
      generateConfig: r
    }),
    headerCells: m
  }), null);
}
E1.displayName = "DateBody";
E1.inheritAttrs = !1;
E1.props = [
  "prefixCls",
  "generateConfig",
  "value?",
  "viewDate",
  "locale",
  "rowCount",
  "onSelect",
  "dateRender?",
  "disabledDate?",
  // Used for week panel
  "prefixColumn?",
  "rowClassName?"
];
function ZC(e) {
  const t = br(e), {
    prefixCls: n,
    generateConfig: r,
    locale: a,
    viewDate: o,
    onNextMonth: i,
    onPrevMonth: s,
    onNextYear: l,
    onPrevYear: u,
    onYearClick: c,
    onMonthClick: f
  } = t, {
    hideHeader: d
  } = Cs();
  if (d.value)
    return null;
  const p = `${n}-header`, v = a.shortMonths || (r.locale.getShortMonths ? r.locale.getShortMonths(a.locale) : []), h = r.getMonth(o), m = A("button", {
    type: "button",
    key: "year",
    onClick: c,
    tabindex: -1,
    class: `${n}-year-btn`
  }, [sa(o, {
    locale: a,
    format: a.yearFormat,
    generateConfig: r
  })]), y = A("button", {
    type: "button",
    key: "month",
    onClick: f,
    tabindex: -1,
    class: `${n}-month-btn`
  }, [a.monthFormat ? sa(o, {
    locale: a,
    format: a.monthFormat,
    generateConfig: r
  }) : v[h]]), x = a.monthBeforeYear ? [y, m] : [m, y];
  return A(hu, ve(ve({}, t), {}, {
    prefixCls: p,
    onSuperPrev: u,
    onPrev: s,
    onNext: i,
    onSuperNext: l
  }), {
    default: () => [x]
  });
}
ZC.displayName = "DateHeader";
ZC.inheritAttrs = !1;
const Nae = 6;
function Kp(e) {
  const t = br(e), {
    prefixCls: n,
    panelName: r = "date",
    keyboardConfig: a,
    active: o,
    operationRef: i,
    generateConfig: s,
    value: l,
    viewDate: u,
    onViewDateChange: c,
    onPanelChange: f,
    onSelect: d
  } = t, p = `${n}-${r}-panel`;
  i.value = {
    onKeydown: (m) => Sd(m, D({
      onLeftRight: (y) => {
        d(s.addDate(l || u, y), "key");
      },
      onCtrlLeftRight: (y) => {
        d(s.addYear(l || u, y), "key");
      },
      onUpDown: (y) => {
        d(s.addDate(l || u, y * Bv), "key");
      },
      onPageUpDown: (y) => {
        d(s.addMonth(l || u, y), "key");
      }
    }, a))
  };
  const v = (m) => {
    const y = s.addYear(u, m);
    c(y), f(null, y);
  }, h = (m) => {
    const y = s.addMonth(u, m);
    c(y), f(null, y);
  };
  return A("div", {
    class: Ge(p, {
      [`${p}-active`]: o
    })
  }, [A(ZC, ve(ve({}, t), {}, {
    prefixCls: n,
    value: l,
    viewDate: u,
    onPrevYear: () => {
      v(-1);
    },
    onNextYear: () => {
      v(1);
    },
    onPrevMonth: () => {
      h(-1);
    },
    onNextMonth: () => {
      h(1);
    },
    onMonthClick: () => {
      f("month", u);
    },
    onYearClick: () => {
      f("year", u);
    }
  }), null), A(E1, ve(ve({}, t), {}, {
    onSelect: (m) => d(m, "mouse"),
    prefixCls: n,
    value: l,
    viewDate: u,
    rowCount: Nae
  }), null)]);
}
Kp.displayName = "DatePanel";
Kp.inheritAttrs = !1;
const b5 = Pae("date", "time");
function QC(e) {
  const t = br(e), {
    prefixCls: n,
    operationRef: r,
    generateConfig: a,
    value: o,
    defaultValue: i,
    disabledTime: s,
    showTime: l,
    onSelect: u
  } = t, c = `${n}-datetime-panel`, f = ne(null), d = ne({}), p = ne({}), v = typeof l == "object" ? D({}, l) : {};
  function h(g) {
    const S = b5.indexOf(f.value) + g;
    return b5[S] || null;
  }
  const m = (g) => {
    p.value.onBlur && p.value.onBlur(g), f.value = null;
  };
  r.value = {
    onKeydown: (g) => {
      if (g.which === Ye.TAB) {
        const S = h(g.shiftKey ? -1 : 1);
        return f.value = S, S && g.preventDefault(), !0;
      }
      if (f.value) {
        const S = f.value === "date" ? d : p;
        return S.value && S.value.onKeydown && S.value.onKeydown(g), !0;
      }
      return [Ye.LEFT, Ye.RIGHT, Ye.UP, Ye.DOWN].includes(g.which) ? (f.value = "date", !0) : !1;
    },
    onBlur: m,
    onClose: m
  };
  const y = (g, S) => {
    let w = g;
    S === "date" && !o && v.defaultValue ? (w = a.setHour(w, a.getHour(v.defaultValue)), w = a.setMinute(w, a.getMinute(v.defaultValue)), w = a.setSecond(w, a.getSecond(v.defaultValue))) : S === "time" && !o && i && (w = a.setYear(w, a.getYear(i)), w = a.setMonth(w, a.getMonth(i)), w = a.setDate(w, a.getDate(i))), u && u(w, "mouse");
  }, x = s ? s(o || null) : {};
  return A("div", {
    class: Ge(c, {
      [`${c}-active`]: f.value
    })
  }, [A(Kp, ve(ve({}, t), {}, {
    operationRef: d,
    active: f.value === "date",
    onSelect: (g) => {
      y(Lv(a, g, !o && typeof l == "object" ? l.defaultValue : null), "date");
    }
  }), null), A(_1, ve(ve(ve(ve({}, t), {}, {
    format: void 0
  }, v), x), {}, {
    disabledTime: null,
    defaultValue: void 0,
    operationRef: p,
    active: f.value === "time",
    onSelect: (g) => {
      y(g, "time");
    }
  }), null)]);
}
QC.displayName = "DatetimePanel";
QC.inheritAttrs = !1;
function JC(e) {
  const t = br(e), {
    prefixCls: n,
    generateConfig: r,
    locale: a,
    value: o
  } = t, i = `${n}-cell`, s = (c) => A("td", {
    key: "week",
    class: Ge(i, `${i}-week`)
  }, [r.locale.getWeek(a.locale, c)]), l = `${n}-week-panel-row`, u = (c) => Ge(l, {
    [`${l}-selected`]: gk(r, a.locale, o, c)
  });
  return A(Kp, ve(ve({}, t), {}, {
    panelName: "week",
    prefixColumn: s,
    rowClassName: u,
    keyboardConfig: {
      onLeftRight: null
    }
  }), null);
}
JC.displayName = "WeekPanel";
JC.inheritAttrs = !1;
function e4(e) {
  const t = br(e), {
    prefixCls: n,
    generateConfig: r,
    locale: a,
    viewDate: o,
    onNextYear: i,
    onPrevYear: s,
    onYearClick: l
  } = t, {
    hideHeader: u
  } = Cs();
  if (u.value)
    return null;
  const c = `${n}-header`;
  return A(hu, ve(ve({}, t), {}, {
    prefixCls: c,
    onSuperPrev: s,
    onSuperNext: i
  }), {
    default: () => [A("button", {
      type: "button",
      onClick: l,
      class: `${n}-year-btn`
    }, [sa(o, {
      locale: a,
      format: a.yearFormat,
      generateConfig: r
    })])]
  });
}
e4.displayName = "MonthHeader";
e4.inheritAttrs = !1;
const _k = 3, Fae = 4;
function t4(e) {
  const t = br(e), {
    prefixCls: n,
    locale: r,
    value: a,
    viewDate: o,
    generateConfig: i,
    monthCellRender: s
  } = t, {
    rangedValue: l,
    hoverRangedValue: u
  } = Gp(), c = `${n}-cell`, f = C1({
    cellPrefixCls: c,
    value: a,
    generateConfig: i,
    rangedValue: l.value,
    hoverRangedValue: u.value,
    isSameCell: (h, m) => qC(i, h, m),
    isInView: () => !0,
    offsetCell: (h, m) => i.addMonth(h, m)
  }), d = r.shortMonths || (i.locale.getShortMonths ? i.locale.getShortMonths(r.locale) : []), p = i.setMonth(o, 0), v = s ? (h) => s({
    current: h,
    locale: r
  }) : void 0;
  return A(Dc, ve(ve({}, t), {}, {
    rowNum: Fae,
    colNum: _k,
    baseDate: p,
    getCellNode: v,
    getCellText: (h) => r.monthFormat ? sa(h, {
      locale: r,
      format: r.monthFormat,
      generateConfig: i
    }) : d[i.getMonth(h)],
    getCellClassName: f,
    getCellDate: i.addMonth,
    titleCell: (h) => sa(h, {
      locale: r,
      format: "YYYY-MM",
      generateConfig: i
    })
  }), null);
}
t4.displayName = "MonthBody";
t4.inheritAttrs = !1;
function n4(e) {
  const t = br(e), {
    prefixCls: n,
    operationRef: r,
    onViewDateChange: a,
    generateConfig: o,
    value: i,
    viewDate: s,
    onPanelChange: l,
    onSelect: u
  } = t, c = `${n}-month-panel`;
  r.value = {
    onKeydown: (d) => Sd(d, {
      onLeftRight: (p) => {
        u(o.addMonth(i || s, p), "key");
      },
      onCtrlLeftRight: (p) => {
        u(o.addYear(i || s, p), "key");
      },
      onUpDown: (p) => {
        u(o.addMonth(i || s, p * _k), "key");
      },
      onEnter: () => {
        l("date", i || s);
      }
    })
  };
  const f = (d) => {
    const p = o.addYear(s, d);
    a(p), l(null, p);
  };
  return A("div", {
    class: c
  }, [A(e4, ve(ve({}, t), {}, {
    prefixCls: n,
    onPrevYear: () => {
      f(-1);
    },
    onNextYear: () => {
      f(1);
    },
    onYearClick: () => {
      l("year", s);
    }
  }), null), A(t4, ve(ve({}, t), {}, {
    prefixCls: n,
    onSelect: (d) => {
      u(d, "mouse"), l("date", d);
    }
  }), null)]);
}
n4.displayName = "MonthPanel";
n4.inheritAttrs = !1;
function r4(e) {
  const t = br(e), {
    prefixCls: n,
    generateConfig: r,
    locale: a,
    viewDate: o,
    onNextYear: i,
    onPrevYear: s,
    onYearClick: l
  } = t, {
    hideHeader: u
  } = Cs();
  if (u.value)
    return null;
  const c = `${n}-header`;
  return A(hu, ve(ve({}, t), {}, {
    prefixCls: c,
    onSuperPrev: s,
    onSuperNext: i
  }), {
    default: () => [A("button", {
      type: "button",
      onClick: l,
      class: `${n}-year-btn`
    }, [sa(o, {
      locale: a,
      format: a.yearFormat,
      generateConfig: r
    })])]
  });
}
r4.displayName = "QuarterHeader";
r4.inheritAttrs = !1;
const Lae = 4, Bae = 1;
function a4(e) {
  const t = br(e), {
    prefixCls: n,
    locale: r,
    value: a,
    viewDate: o,
    generateConfig: i
  } = t, {
    rangedValue: s,
    hoverRangedValue: l
  } = Gp(), u = `${n}-cell`, c = C1({
    cellPrefixCls: u,
    value: a,
    generateConfig: i,
    rangedValue: s.value,
    hoverRangedValue: l.value,
    isSameCell: (d, p) => mk(i, d, p),
    isInView: () => !0,
    offsetCell: (d, p) => i.addMonth(d, p * 3)
  }), f = i.setDate(i.setMonth(o, 0), 1);
  return A(Dc, ve(ve({}, t), {}, {
    rowNum: Bae,
    colNum: Lae,
    baseDate: f,
    getCellText: (d) => sa(d, {
      locale: r,
      format: r.quarterFormat || "[Q]Q",
      generateConfig: i
    }),
    getCellClassName: c,
    getCellDate: (d, p) => i.addMonth(d, p * 3),
    titleCell: (d) => sa(d, {
      locale: r,
      format: "YYYY-[Q]Q",
      generateConfig: i
    })
  }), null);
}
a4.displayName = "QuarterBody";
a4.inheritAttrs = !1;
function o4(e) {
  const t = br(e), {
    prefixCls: n,
    operationRef: r,
    onViewDateChange: a,
    generateConfig: o,
    value: i,
    viewDate: s,
    onPanelChange: l,
    onSelect: u
  } = t, c = `${n}-quarter-panel`;
  r.value = {
    onKeydown: (d) => Sd(d, {
      onLeftRight: (p) => {
        u(o.addMonth(i || s, p * 3), "key");
      },
      onCtrlLeftRight: (p) => {
        u(o.addYear(i || s, p), "key");
      },
      onUpDown: (p) => {
        u(o.addYear(i || s, p), "key");
      }
    })
  };
  const f = (d) => {
    const p = o.addYear(s, d);
    a(p), l(null, p);
  };
  return A("div", {
    class: c
  }, [A(r4, ve(ve({}, t), {}, {
    prefixCls: n,
    onPrevYear: () => {
      f(-1);
    },
    onNextYear: () => {
      f(1);
    },
    onYearClick: () => {
      l("year", s);
    }
  }), null), A(a4, ve(ve({}, t), {}, {
    prefixCls: n,
    onSelect: (d) => {
      u(d, "mouse");
    }
  }), null)]);
}
o4.displayName = "QuarterPanel";
o4.inheritAttrs = !1;
function i4(e) {
  const t = br(e), {
    prefixCls: n,
    generateConfig: r,
    viewDate: a,
    onPrevDecade: o,
    onNextDecade: i,
    onDecadeClick: s
  } = t, {
    hideHeader: l
  } = Cs();
  if (l.value)
    return null;
  const u = `${n}-header`, c = r.getYear(a), f = Math.floor(c / Fl) * Fl, d = f + Fl - 1;
  return A(hu, ve(ve({}, t), {}, {
    prefixCls: u,
    onSuperPrev: o,
    onSuperNext: i
  }), {
    default: () => [A("button", {
      type: "button",
      onClick: s,
      class: `${n}-decade-btn`
    }, [f, Jt("-"), d])]
  });
}
i4.displayName = "YearHeader";
i4.inheritAttrs = !1;
const v2 = 3, w5 = 4;
function s4(e) {
  const t = br(e), {
    prefixCls: n,
    value: r,
    viewDate: a,
    locale: o,
    generateConfig: i
  } = t, {
    rangedValue: s,
    hoverRangedValue: l
  } = Gp(), u = `${n}-cell`, c = i.getYear(a), f = Math.floor(c / Fl) * Fl, d = f + Fl - 1, p = i.setYear(a, f - Math.ceil((v2 * w5 - Fl) / 2)), v = (m) => {
    const y = i.getYear(m);
    return f <= y && y <= d;
  }, h = C1({
    cellPrefixCls: u,
    value: r,
    generateConfig: i,
    rangedValue: s.value,
    hoverRangedValue: l.value,
    isSameCell: (m, y) => S1(i, m, y),
    isInView: v,
    offsetCell: (m, y) => i.addYear(m, y)
  });
  return A(Dc, ve(ve({}, t), {}, {
    rowNum: w5,
    colNum: v2,
    baseDate: p,
    getCellText: i.getYear,
    getCellClassName: h,
    getCellDate: i.addYear,
    titleCell: (m) => sa(m, {
      locale: o,
      format: "YYYY",
      generateConfig: i
    })
  }), null);
}
s4.displayName = "YearBody";
s4.inheritAttrs = !1;
const Fl = 10;
function l4(e) {
  const t = br(e), {
    prefixCls: n,
    operationRef: r,
    onViewDateChange: a,
    generateConfig: o,
    value: i,
    viewDate: s,
    sourceMode: l,
    onSelect: u,
    onPanelChange: c
  } = t, f = `${n}-year-panel`;
  r.value = {
    onKeydown: (p) => Sd(p, {
      onLeftRight: (v) => {
        u(o.addYear(i || s, v), "key");
      },
      onCtrlLeftRight: (v) => {
        u(o.addYear(i || s, v * Fl), "key");
      },
      onUpDown: (v) => {
        u(o.addYear(i || s, v * v2), "key");
      },
      onEnter: () => {
        c(l === "date" ? "date" : "month", i || s);
      }
    })
  };
  const d = (p) => {
    const v = o.addYear(s, p * 10);
    a(v), c(null, v);
  };
  return A("div", {
    class: f
  }, [A(i4, ve(ve({}, t), {}, {
    prefixCls: n,
    onPrevDecade: () => {
      d(-1);
    },
    onNextDecade: () => {
      d(1);
    },
    onDecadeClick: () => {
      c("decade", s);
    }
  }), null), A(s4, ve(ve({}, t), {}, {
    prefixCls: n,
    onSelect: (p) => {
      c(l === "date" ? "date" : "month", p), u(p, "mouse");
    }
  }), null)]);
}
l4.displayName = "YearPanel";
l4.inheritAttrs = !1;
function Ck(e, t, n) {
  return n ? A("div", {
    class: `${e}-footer-extra`
  }, [n(t)]) : null;
}
function Ek(e) {
  let {
    prefixCls: t,
    components: n = {},
    needConfirmButton: r,
    onNow: a,
    onOk: o,
    okDisabled: i,
    showNow: s,
    locale: l
  } = e, u, c;
  if (r) {
    const f = n.button || "button";
    a && s !== !1 && (u = A("li", {
      class: `${t}-now`
    }, [A("a", {
      class: `${t}-now-btn`,
      onClick: a
    }, [l.now])])), c = r && A("li", {
      class: `${t}-ok`
    }, [A(f, {
      disabled: i,
      onClick: (d) => {
        d.stopPropagation(), o && o();
      }
    }, {
      default: () => [l.ok]
    })]);
  }
  return !u && !c ? null : A("ul", {
    class: `${t}-ranges`
  }, [u, c]);
}
function Hae() {
  return /* @__PURE__ */ Me({
    name: "PickerPanel",
    inheritAttrs: !1,
    props: {
      prefixCls: String,
      locale: Object,
      generateConfig: Object,
      value: Object,
      defaultValue: Object,
      pickerValue: Object,
      defaultPickerValue: Object,
      disabledDate: Function,
      mode: String,
      picker: {
        type: String,
        default: "date"
      },
      tabindex: {
        type: [Number, String],
        default: 0
      },
      showNow: {
        type: Boolean,
        default: void 0
      },
      showTime: [Boolean, Object],
      showToday: Boolean,
      renderExtraFooter: Function,
      dateRender: Function,
      hideHeader: {
        type: Boolean,
        default: void 0
      },
      onSelect: Function,
      onChange: Function,
      onPanelChange: Function,
      onMousedown: Function,
      onPickerValueChange: Function,
      onOk: Function,
      components: Object,
      direction: String,
      hourStep: {
        type: Number,
        default: 1
      },
      minuteStep: {
        type: Number,
        default: 1
      },
      secondStep: {
        type: Number,
        default: 1
      }
    },
    setup(e, t) {
      let {
        attrs: n
      } = t;
      const r = V(() => e.picker === "date" && !!e.showTime || e.picker === "time"), a = V(() => 24 % e.hourStep === 0), o = V(() => 60 % e.minuteStep === 0), i = V(() => 60 % e.secondStep === 0);
      process.env.NODE_ENV !== "production" && _n(() => {
        const {
          generateConfig: M,
          value: H,
          hourStep: R = 1,
          minuteStep: z = 1,
          secondStep: W = 1
        } = e;
        Sa(!H || M.isValidate(H), "Invalidate date pass to `value`."), Sa(!H || M.isValidate(H), "Invalidate date pass to `defaultValue`."), Sa(a.value, `\`hourStep\` ${R} is invalid. It should be a factor of 24.`), Sa(o.value, `\`minuteStep\` ${z} is invalid. It should be a factor of 60.`), Sa(i.value, `\`secondStep\` ${W} is invalid. It should be a factor of 60.`);
      });
      const s = Cs(), {
        operationRef: l,
        onSelect: u,
        hideRanges: c,
        defaultOpenValue: f
      } = s, {
        inRange: d,
        panelPosition: p,
        rangedValue: v,
        hoverRangedValue: h
      } = Gp(), m = ne({}), [y, x] = ri(null, {
        value: Tt(e, "value"),
        defaultValue: e.defaultValue,
        postState: (M) => !M && (f != null && f.value) && e.picker === "time" ? f.value : M
      }), [g, S] = ri(null, {
        value: Tt(e, "pickerValue"),
        defaultValue: e.defaultPickerValue || y.value,
        postState: (M) => {
          const {
            generateConfig: H,
            showTime: R,
            defaultValue: z
          } = e, W = H.getNow();
          return M ? !y.value && e.showTime ? typeof R == "object" ? Lv(H, Array.isArray(M) ? M[0] : M, R.defaultValue || W) : z ? Lv(H, Array.isArray(M) ? M[0] : M, z) : Lv(H, Array.isArray(M) ? M[0] : M, W) : M : W;
        }
      }), w = (M) => {
        S(M), e.onPickerValueChange && e.onPickerValueChange(M);
      }, _ = (M) => {
        const H = $ae[e.picker];
        return H ? H(M) : M;
      }, [b, E] = ri(() => e.picker === "time" ? "time" : _("date"), {
        value: Tt(e, "mode")
      });
      He(() => e.picker, () => {
        E(e.picker);
      });
      const C = ne(b.value), T = (M) => {
        C.value = M;
      }, O = (M, H) => {
        const {
          onPanelChange: R,
          generateConfig: z
        } = e, W = _(M || b.value);
        T(b.value), E(W), R && (b.value !== W || $f(z, g.value, g.value)) && R(H, W);
      }, I = function(M, H) {
        let R = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
        const {
          picker: z,
          generateConfig: W,
          onSelect: F,
          onChange: Y,
          disabledDate: X
        } = e;
        (b.value === z || R) && (x(M), F && F(M), u && u(M, H), Y && !$f(W, M, y.value) && !(X != null && X(M)) && Y(M));
      }, k = (M) => m.value && m.value.onKeydown ? ([Ye.LEFT, Ye.RIGHT, Ye.UP, Ye.DOWN, Ye.PAGE_UP, Ye.PAGE_DOWN, Ye.ENTER].includes(M.which) && M.preventDefault(), m.value.onKeydown(M)) : (Sa(!1, "Panel not correct handle keyDown event. Please help to fire issue about this."), !1), B = (M) => {
        m.value && m.value.onBlur && m.value.onBlur(M);
      }, P = () => {
        const {
          generateConfig: M,
          hourStep: H,
          minuteStep: R,
          secondStep: z
        } = e, W = M.getNow(), F = yae(M.getHour(W), M.getMinute(W), M.getSecond(W), a.value ? H : 1, o.value ? R : 1, i.value ? z : 1), Y = dk(
          M,
          W,
          F[0],
          // hour
          F[1],
          // minute
          F[2]
        );
        I(Y, "submit");
      }, N = V(() => {
        const {
          prefixCls: M,
          direction: H
        } = e;
        return Ge(`${M}-panel`, {
          [`${M}-panel-has-range`]: v && v.value && v.value[0] && v.value[1],
          [`${M}-panel-has-range-hover`]: h && h.value && h.value[0] && h.value[1],
          [`${M}-panel-rtl`]: H === "rtl"
        });
      });
      return WC(D(D({}, s), {
        mode: b,
        hideHeader: V(() => {
          var M;
          return e.hideHeader !== void 0 ? e.hideHeader : (M = s.hideHeader) === null || M === void 0 ? void 0 : M.value;
        }),
        hidePrevBtn: V(() => d.value && p.value === "right"),
        hideNextBtn: V(() => d.value && p.value === "left")
      })), He(() => e.value, () => {
        e.value && S(e.value);
      }), () => {
        const {
          prefixCls: M = "ant-picker",
          locale: H,
          generateConfig: R,
          disabledDate: z,
          picker: W = "date",
          tabindex: F = 0,
          showNow: Y,
          showTime: X,
          showToday: q,
          renderExtraFooter: Q,
          onMousedown: ue,
          onOk: le,
          components: te
        } = e;
        l && p.value !== "right" && (l.value = {
          onKeydown: k,
          onClose: () => {
            m.value && m.value.onClose && m.value.onClose();
          }
        });
        let G;
        const oe = D(D(D({}, n), e), {
          operationRef: m,
          prefixCls: M,
          viewDate: g.value,
          value: y.value,
          onViewDateChange: w,
          sourceMode: C.value,
          onPanelChange: O,
          disabledDate: z
        });
        switch (delete oe.onChange, delete oe.onSelect, b.value) {
          case "decade":
            G = A(YC, ve(ve({}, oe), {}, {
              onSelect: (J, ae) => {
                w(J), I(J, ae);
              }
            }), null);
            break;
          case "year":
            G = A(l4, ve(ve({}, oe), {}, {
              onSelect: (J, ae) => {
                w(J), I(J, ae);
              }
            }), null);
            break;
          case "month":
            G = A(n4, ve(ve({}, oe), {}, {
              onSelect: (J, ae) => {
                w(J), I(J, ae);
              }
            }), null);
            break;
          case "quarter":
            G = A(o4, ve(ve({}, oe), {}, {
              onSelect: (J, ae) => {
                w(J), I(J, ae);
              }
            }), null);
            break;
          case "week":
            G = A(JC, ve(ve({}, oe), {}, {
              onSelect: (J, ae) => {
                w(J), I(J, ae);
              }
            }), null);
            break;
          case "time":
            delete oe.showTime, G = A(_1, ve(ve(ve({}, oe), typeof X == "object" ? X : null), {}, {
              onSelect: (J, ae) => {
                w(J), I(J, ae);
              }
            }), null);
            break;
          default:
            X ? G = A(QC, ve(ve({}, oe), {}, {
              onSelect: (J, ae) => {
                w(J), I(J, ae);
              }
            }), null) : G = A(Kp, ve(ve({}, oe), {}, {
              onSelect: (J, ae) => {
                w(J), I(J, ae);
              }
            }), null);
        }
        let L, re;
        c != null && c.value || (L = Ck(M, b.value, Q), re = Ek({
          prefixCls: M,
          components: te,
          needConfirmButton: r.value,
          okDisabled: !y.value || z && z(y.value),
          locale: H,
          showNow: Y,
          onNow: r.value && P,
          onOk: () => {
            y.value && (I(y.value, "submit", !0), le && le(y.value));
          }
        }));
        let j;
        if (q && b.value === "date" && W === "date" && !X) {
          const J = R.getNow(), ae = `${M}-today-btn`, he = z && z(J);
          j = A("a", {
            class: Ge(ae, he && `${ae}-disabled`),
            "aria-disabled": he,
            onClick: () => {
              he || I(J, "mouse", !0);
            }
          }, [H.today]);
        }
        return A("div", {
          tabindex: F,
          class: Ge(N.value, n.class),
          style: n.style,
          onKeydown: k,
          onBlur: B,
          onMousedown: ue
        }, [G, L || re || j ? A("div", {
          class: `${M}-footer`
        }, [L, re, j]) : null]);
      };
    }
  });
}
const jae = Hae(), Tk = (e) => A(jae, e), Vae = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
function $k(e, t) {
  let {
    slots: n
  } = t;
  const {
    prefixCls: r,
    popupStyle: a,
    visible: o,
    dropdownClassName: i,
    dropdownAlign: s,
    transitionName: l,
    getPopupContainer: u,
    range: c,
    popupPlacement: f,
    direction: d
  } = br(e), p = `${r}-dropdown`;
  return A(jp, {
    showAction: [],
    hideAction: [],
    popupPlacement: f !== void 0 ? f : d === "rtl" ? "bottomRight" : "bottomLeft",
    builtinPlacements: Vae,
    prefixCls: p,
    popupTransitionName: l,
    popupAlign: s,
    popupVisible: o,
    popupClassName: Ge(i, {
      [`${p}-range`]: c,
      [`${p}-rtl`]: d === "rtl"
    }),
    popupStyle: a,
    getPopupContainer: u
  }, {
    default: n.default,
    popup: n.popupElement
  });
}
const Ok = /* @__PURE__ */ Me({
  name: "PresetPanel",
  props: {
    prefixCls: String,
    presets: {
      type: Array,
      default: () => []
    },
    onClick: Function,
    onHover: Function
  },
  setup(e) {
    return () => e.presets.length ? A("div", {
      class: `${e.prefixCls}-presets`
    }, [A("ul", null, [e.presets.map((t, n) => {
      let {
        label: r,
        value: a
      } = t;
      return A("li", {
        key: n,
        onClick: () => {
          e.onClick(a);
        },
        onMouseenter: () => {
          var o;
          (o = e.onHover) === null || o === void 0 || o.call(e, a);
        },
        onMouseleave: () => {
          var o;
          (o = e.onHover) === null || o === void 0 || o.call(e, null);
        }
      }, [r]);
    })])]) : null;
  }
});
function m2(e) {
  let {
    open: t,
    value: n,
    isClickOutside: r,
    triggerOpen: a,
    forwardKeydown: o,
    onKeydown: i,
    blurToCancel: s,
    onSubmit: l,
    onCancel: u,
    onFocus: c,
    onBlur: f
  } = e;
  const d = Be(!1), p = Be(!1), v = Be(!1), h = Be(!1), m = Be(!1), y = V(() => ({
    onMousedown: () => {
      d.value = !0, a(!0);
    },
    onKeydown: (g) => {
      if (i(g, () => {
        m.value = !0;
      }), !m.value) {
        switch (g.which) {
          case Ye.ENTER: {
            t.value ? l() !== !1 && (d.value = !0) : a(!0), g.preventDefault();
            return;
          }
          case Ye.TAB: {
            d.value && t.value && !g.shiftKey ? (d.value = !1, g.preventDefault()) : !d.value && t.value && !o(g) && g.shiftKey && (d.value = !0, g.preventDefault());
            return;
          }
          case Ye.ESC: {
            d.value = !0, u();
            return;
          }
        }
        !t.value && ![Ye.SHIFT].includes(g.which) ? a(!0) : d.value || o(g);
      }
    },
    onFocus: (g) => {
      d.value = !0, p.value = !0, c && c(g);
    },
    onBlur: (g) => {
      if (v.value || !r(document.activeElement)) {
        v.value = !1;
        return;
      }
      s.value ? setTimeout(() => {
        let {
          activeElement: S
        } = document;
        for (; S && S.shadowRoot; )
          S = S.shadowRoot.activeElement;
        r(S) && u();
      }, 0) : t.value && (a(!1), h.value && l()), p.value = !1, f && f(g);
    }
  }));
  He(t, () => {
    h.value = !1;
  }), He(n, () => {
    h.value = !0;
  });
  const x = Be();
  return Lt(() => {
    x.value = wae((g) => {
      const S = Sae(g);
      if (t.value) {
        const w = r(S);
        w ? (!p.value || w) && a(!1) : (v.value = !0, dn(() => {
          v.value = !1;
        }));
      }
    });
  }), Sn(() => {
    x.value && x.value();
  }), [y, {
    focused: p,
    typing: d
  }];
}
function g2(e) {
  let {
    valueTexts: t,
    onTextChange: n
  } = e;
  const r = ne("");
  function a(i) {
    r.value = i, n(i);
  }
  function o() {
    r.value = t.value[0];
  }
  return He(() => [...t.value], function(i) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    i.join("||") !== s.join("||") && t.value.every((l) => l !== r.value) && o();
  }, {
    immediate: !0
  }), [r, a, o];
}
function Rm(e, t) {
  let {
    formatList: n,
    generateConfig: r,
    locale: a
  } = t;
  const o = ZP(() => {
    if (!e.value)
      return [[""], ""];
    let l = "";
    const u = [];
    for (let c = 0; c < n.value.length; c += 1) {
      const f = n.value[c], d = sa(e.value, {
        generateConfig: r.value,
        locale: a.value,
        format: f
      });
      u.push(d), c === 0 && (l = d);
    }
    return [u, l];
  }, [e, n], (l, u) => u[0] !== l[0] || !of(u[1], l[1])), i = V(() => o.value[0]), s = V(() => o.value[1]);
  return [i, s];
}
function y2(e, t) {
  let {
    formatList: n,
    generateConfig: r,
    locale: a
  } = t;
  const o = ne(null);
  let i;
  function s(f) {
    let d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (dn.cancel(i), d) {
      o.value = f;
      return;
    }
    i = dn(() => {
      o.value = f;
    });
  }
  const [, l] = Rm(o, {
    formatList: n,
    generateConfig: r,
    locale: a
  });
  function u(f) {
    s(f);
  }
  function c() {
    let f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    s(null, f);
  }
  return He(e, () => {
    c(!0);
  }), Sn(() => {
    dn.cancel(i);
  }), [l, u, c];
}
function Ak(e, t) {
  return V(() => e != null && e.value ? e.value : t != null && t.value ? ($o(!1, "`ranges` is deprecated. Please use `presets` instead."), Object.keys(t.value).map((r) => {
    const a = t.value[r], o = typeof a == "function" ? a() : a;
    return {
      label: r,
      value: o
    };
  })) : []);
}
function Ik(e) {
  const {
    picker: t,
    disabledHours: n,
    disabledMinutes: r,
    disabledSeconds: a
  } = e;
  t === "time" && (n || r || a) && Sa(!1, "'disabledHours', 'disabledMinutes', 'disabledSeconds' will be removed in the next major version, please use 'disabledTime' instead.");
}
function Uae() {
  return /* @__PURE__ */ Me({
    name: "Picker",
    inheritAttrs: !1,
    props: ["prefixCls", "id", "tabindex", "dropdownClassName", "dropdownAlign", "popupStyle", "transitionName", "generateConfig", "locale", "inputReadOnly", "allowClear", "autofocus", "showTime", "showNow", "showHour", "showMinute", "showSecond", "picker", "format", "use12Hours", "value", "defaultValue", "open", "defaultOpen", "defaultOpenValue", "suffixIcon", "presets", "clearIcon", "disabled", "disabledDate", "placeholder", "getPopupContainer", "panelRender", "inputRender", "onChange", "onOpenChange", "onPanelChange", "onFocus", "onBlur", "onMousedown", "onMouseup", "onMouseenter", "onMouseleave", "onContextmenu", "onClick", "onKeydown", "onSelect", "direction", "autocomplete", "showToday", "renderExtraFooter", "dateRender", "minuteStep", "hourStep", "secondStep", "hideDisabledOptions"],
    setup(e, t) {
      let {
        attrs: n,
        expose: r
      } = t;
      const a = ne(null), o = V(() => e.presets), i = Ak(o), s = V(() => {
        var z;
        return (z = e.picker) !== null && z !== void 0 ? z : "date";
      }), l = V(() => s.value === "date" && !!e.showTime || s.value === "time");
      process.env.NODE_ENV !== "production" && Ik(e);
      const u = V(() => bk(pk(e.format, s.value, e.showTime, e.use12Hours))), c = ne(null), f = ne(null), d = ne(null), [p, v] = ri(null, {
        value: Tt(e, "value"),
        defaultValue: e.defaultValue
      }), h = ne(p.value), m = (z) => {
        h.value = z;
      }, y = ne(null), [x, g] = ri(!1, {
        value: Tt(e, "open"),
        defaultValue: e.defaultOpen,
        postState: (z) => e.disabled ? !1 : z,
        onChange: (z) => {
          e.onOpenChange && e.onOpenChange(z), !z && y.value && y.value.onClose && y.value.onClose();
        }
      }), [S, w] = Rm(h, {
        formatList: u,
        generateConfig: Tt(e, "generateConfig"),
        locale: Tt(e, "locale")
      }), [_, b, E] = g2({
        valueTexts: S,
        onTextChange: (z) => {
          const W = yk(z, {
            locale: e.locale,
            formatList: u.value,
            generateConfig: e.generateConfig
          });
          W && (!e.disabledDate || !e.disabledDate(W)) && m(W);
        }
      }), C = (z) => {
        const {
          onChange: W,
          generateConfig: F,
          locale: Y
        } = e;
        m(z), v(z), W && !$f(F, p.value, z) && W(z, z ? sa(z, {
          generateConfig: F,
          locale: Y,
          format: u.value[0]
        }) : "");
      }, T = (z) => {
        e.disabled && z || g(z);
      }, O = (z) => x.value && y.value && y.value.onKeydown ? y.value.onKeydown(z) : (Sa(!1, "Picker not correct forward Keydown operation. Please help to fire issue about this."), !1), I = function() {
        e.onMouseup && e.onMouseup(...arguments), a.value && (a.value.focus(), T(!0));
      }, [k, {
        focused: B,
        typing: P
      }] = m2({
        blurToCancel: l,
        open: x,
        value: _,
        triggerOpen: T,
        forwardKeydown: O,
        isClickOutside: (z) => !vk([c.value, f.value, d.value], z),
        onSubmit: () => (
          // When user typing disabledDate with keyboard and enter, this value will be empty
          !h.value || // Normal disabled check
          e.disabledDate && e.disabledDate(h.value) ? !1 : (C(h.value), T(!1), E(), !0)
        ),
        onCancel: () => {
          T(!1), m(p.value), E();
        },
        onKeydown: (z, W) => {
          var F;
          (F = e.onKeydown) === null || F === void 0 || F.call(e, z, W);
        },
        onFocus: (z) => {
          var W;
          (W = e.onFocus) === null || W === void 0 || W.call(e, z);
        },
        onBlur: (z) => {
          var W;
          (W = e.onBlur) === null || W === void 0 || W.call(e, z);
        }
      });
      He([x, S], () => {
        x.value || (m(p.value), !S.value.length || S.value[0] === "" ? b("") : w.value !== _.value && E());
      }), He(s, () => {
        x.value || E();
      }), He(p, () => {
        m(p.value);
      });
      const [N, M, H] = y2(_, {
        formatList: u,
        generateConfig: Tt(e, "generateConfig"),
        locale: Tt(e, "locale")
      }), R = (z, W) => {
        (W === "submit" || W !== "key" && !l.value) && (C(z), T(!1));
      };
      return WC({
        operationRef: y,
        hideHeader: V(() => s.value === "time"),
        onSelect: R,
        open: x,
        defaultOpenValue: Tt(e, "defaultOpenValue"),
        onDateMouseenter: M,
        onDateMouseleave: H
      }), r({
        focus: () => {
          a.value && a.value.focus();
        },
        blur: () => {
          a.value && a.value.blur();
        }
      }), () => {
        const {
          prefixCls: z = "rc-picker",
          id: W,
          tabindex: F,
          dropdownClassName: Y,
          dropdownAlign: X,
          popupStyle: q,
          transitionName: Q,
          generateConfig: ue,
          locale: le,
          inputReadOnly: te,
          allowClear: G,
          autofocus: oe,
          picker: L = "date",
          defaultOpenValue: re,
          suffixIcon: j,
          clearIcon: J,
          disabled: ae,
          placeholder: he,
          getPopupContainer: K,
          panelRender: Z,
          onMousedown: se,
          onMouseenter: me,
          onMouseleave: xe,
          onContextmenu: be,
          onClick: Te,
          onSelect: Ie,
          direction: Ve,
          autocomplete: tt = "off"
        } = e, it = D(D(D({}, e), n), {
          class: Ge({
            [`${z}-panel-focused`]: !P.value
          }),
          style: void 0,
          pickerValue: void 0,
          onPickerValueChange: void 0,
          onChange: null
        });
        let Se = A("div", {
          class: `${z}-panel-layout`
        }, [A(Ok, {
          prefixCls: z,
          presets: i.value,
          onClick: (xt) => {
            C(xt), T(!1);
          }
        }, null), A(Tk, ve(ve({}, it), {}, {
          generateConfig: ue,
          value: h.value,
          locale: le,
          tabindex: -1,
          onSelect: (xt) => {
            Ie == null || Ie(xt), m(xt);
          },
          direction: Ve,
          onPanelChange: (xt, Mt) => {
            const {
              onPanelChange: yt
            } = e;
            H(!0), yt == null || yt(xt, Mt);
          }
        }), null)]);
        Z && (Se = Z(Se));
        const ge = A("div", {
          class: `${z}-panel-container`,
          ref: c,
          onMousedown: (xt) => {
            xt.preventDefault();
          }
        }, [Se]);
        let pe;
        j && (pe = A("span", {
          class: `${z}-suffix`
        }, [j]));
        let De;
        G && p.value && !ae && (De = A("span", {
          onMousedown: (xt) => {
            xt.preventDefault(), xt.stopPropagation();
          },
          onMouseup: (xt) => {
            xt.preventDefault(), xt.stopPropagation(), C(null), T(!1);
          },
          class: `${z}-clear`,
          role: "button"
        }, [J || A("span", {
          class: `${z}-clear-btn`
        }, null)]));
        const Ue = D(D(D(D({
          id: W,
          tabindex: F,
          disabled: ae,
          readonly: te || typeof u.value[0] == "function" || !P.value,
          value: N.value || _.value,
          onInput: (xt) => {
            b(xt.target.value);
          },
          autofocus: oe,
          placeholder: he,
          ref: a,
          title: _.value
        }, k.value), {
          size: hk(L, u.value[0], ue)
        }), wk(e)), {
          autocomplete: tt
        }), Xe = e.inputRender ? e.inputRender(Ue) : A("input", Ue, null);
        process.env.NODE_ENV !== "production" && Sa(!re, "`defaultOpenValue` may confuse user for the current value status. Please use `defaultValue` instead.");
        const ut = Ve === "rtl" ? "bottomRight" : "bottomLeft";
        return A("div", {
          ref: d,
          class: Ge(z, n.class, {
            [`${z}-disabled`]: ae,
            [`${z}-focused`]: B.value,
            [`${z}-rtl`]: Ve === "rtl"
          }),
          style: n.style,
          onMousedown: se,
          onMouseup: I,
          onMouseenter: me,
          onMouseleave: xe,
          onContextmenu: be,
          onClick: Te
        }, [A("div", {
          class: Ge(`${z}-input`, {
            [`${z}-input-placeholder`]: !!N.value
          }),
          ref: f
        }, [Xe, pe, De]), A($k, {
          visible: x.value,
          popupStyle: q,
          prefixCls: z,
          dropdownClassName: Y,
          dropdownAlign: X,
          getPopupContainer: K,
          transitionName: Q,
          popupPlacement: ut,
          direction: Ve
        }, {
          default: () => [A("div", {
            style: {
              pointerEvents: "none",
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0
            }
          }, null)],
          popupElement: () => ge
        })]);
      };
    }
  });
}
const zae = Uae();
function Wae(e, t) {
  let {
    picker: n,
    locale: r,
    selectedValue: a,
    disabledDate: o,
    disabled: i,
    generateConfig: s
  } = e;
  const l = V(() => an(a.value, 0)), u = V(() => an(a.value, 1));
  function c(h) {
    return s.value.locale.getWeekFirstDate(r.value.locale, h);
  }
  function f(h) {
    const m = s.value.getYear(h), y = s.value.getMonth(h);
    return m * 100 + y;
  }
  function d(h) {
    const m = s.value.getYear(h), y = p2(s.value, h);
    return m * 10 + y;
  }
  return [(h) => {
    var m;
    if (o && (!((m = o == null ? void 0 : o.value) === null || m === void 0) && m.call(o, h)))
      return !0;
    if (i[1] && u)
      return !Us(s.value, h, u.value) && s.value.isAfter(h, u.value);
    if (t.value[1] && u.value)
      switch (n.value) {
        case "quarter":
          return d(h) > d(u.value);
        case "month":
          return f(h) > f(u.value);
        case "week":
          return c(h) > c(u.value);
        default:
          return !Us(s.value, h, u.value) && s.value.isAfter(h, u.value);
      }
    return !1;
  }, (h) => {
    var m;
    if (!((m = o.value) === null || m === void 0) && m.call(o, h))
      return !0;
    if (i[0] && l)
      return !Us(s.value, h, u.value) && s.value.isAfter(l.value, h);
    if (t.value[0] && l.value)
      switch (n.value) {
        case "quarter":
          return d(h) < d(l.value);
        case "month":
          return f(h) < f(l.value);
        case "week":
          return c(h) < c(l.value);
        default:
          return !Us(s.value, h, l.value) && s.value.isAfter(l.value, h);
      }
    return !1;
  }];
}
function Gae(e, t, n, r) {
  const a = _0(e, n, r, 1);
  function o(i) {
    return i(e, t) ? "same" : i(a, t) ? "closing" : "far";
  }
  switch (n) {
    case "year":
      return o((i, s) => Oae(r, i, s));
    case "quarter":
    case "month":
      return o((i, s) => S1(r, i, s));
    default:
      return o((i, s) => qC(r, i, s));
  }
}
function Kae(e, t, n, r) {
  const a = an(e, 0), o = an(e, 1);
  if (t === 0)
    return a;
  if (a && o)
    switch (Gae(a, o, n, r)) {
      case "same":
        return a;
      case "closing":
        return a;
      default:
        return _0(o, n, r, -1);
    }
  return a;
}
function Yae(e) {
  let {
    values: t,
    picker: n,
    defaultDates: r,
    generateConfig: a
  } = e;
  const o = ne([an(r, 0), an(r, 1)]), i = ne(null), s = V(() => an(t.value, 0)), l = V(() => an(t.value, 1)), u = (p) => o.value[p] ? o.value[p] : an(i.value, p) || Kae(t.value, p, n.value, a.value) || s.value || l.value || a.value.getNow(), c = ne(null), f = ne(null);
  _n(() => {
    c.value = u(0), f.value = u(1);
  });
  function d(p, v) {
    if (p) {
      let h = Jo(i.value, p, v);
      o.value = Jo(o.value, null, v) || [null, null];
      const m = (v + 1) % 2;
      an(t.value, m) || (h = Jo(h, p, m)), i.value = h;
    } else (s.value || l.value) && (i.value = null);
  }
  return [c, f, d];
}
function qae(e) {
  return fd() ? (vg(e), !0) : !1;
}
function Xae(e) {
  return typeof e == "function" ? e() : U(e);
}
function Pk(e) {
  var t;
  const n = Xae(e);
  return (t = n == null ? void 0 : n.$el) !== null && t !== void 0 ? t : n;
}
function Zae(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  jn() ? Lt(e) : t ? e() : nn(e);
}
function Qae(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const n = Be(), r = () => n.value = !!e();
  return r(), Zae(r, t), n;
}
var Uy;
const Dk = typeof window < "u";
Dk && (!((Uy = window == null ? void 0 : window.navigator) === null || Uy === void 0) && Uy.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
const Jae = Dk ? window : void 0;
var eoe = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function toe(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    window: r = Jae
  } = n, a = eoe(n, ["window"]);
  let o;
  const i = Qae(() => r && "ResizeObserver" in r), s = () => {
    o && (o.disconnect(), o = void 0);
  }, l = He(() => Pk(e), (c) => {
    s(), i.value && r && c && (o = new ResizeObserver(t), o.observe(c, a));
  }, {
    immediate: !0,
    flush: "post"
  }), u = () => {
    s(), l();
  };
  return qae(u), {
    isSupported: i,
    stop: u
  };
}
function Ud(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    width: 0,
    height: 0
  }, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    box: r = "content-box"
  } = n, a = Be(t.width), o = Be(t.height);
  return toe(e, (i) => {
    let [s] = i;
    const l = r === "border-box" ? s.borderBoxSize : r === "content-box" ? s.contentBoxSize : s.devicePixelContentBoxSize;
    l ? (a.value = l.reduce((u, c) => {
      let {
        inlineSize: f
      } = c;
      return u + f;
    }, 0), o.value = l.reduce((u, c) => {
      let {
        blockSize: f
      } = c;
      return u + f;
    }, 0)) : (a.value = s.contentRect.width, o.value = s.contentRect.height);
  }, n), He(() => Pk(e), (i) => {
    a.value = i ? t.width : 0, o.value = i ? t.height : 0;
  }), {
    width: a,
    height: o
  };
}
function S5(e, t) {
  return e && e[0] && e[1] && t.isAfter(e[0], e[1]) ? [e[1], e[0]] : e;
}
function _5(e, t, n, r) {
  return !!(e || r && r[t] || n[(t + 1) % 2]);
}
function noe() {
  return /* @__PURE__ */ Me({
    name: "RangerPicker",
    inheritAttrs: !1,
    props: ["prefixCls", "id", "popupStyle", "dropdownClassName", "transitionName", "dropdownAlign", "getPopupContainer", "generateConfig", "locale", "placeholder", "autofocus", "disabled", "format", "picker", "showTime", "showNow", "showHour", "showMinute", "showSecond", "use12Hours", "separator", "value", "defaultValue", "defaultPickerValue", "open", "defaultOpen", "disabledDate", "disabledTime", "dateRender", "panelRender", "ranges", "allowEmpty", "allowClear", "suffixIcon", "clearIcon", "pickerRef", "inputReadOnly", "mode", "renderExtraFooter", "onChange", "onOpenChange", "onPanelChange", "onCalendarChange", "onFocus", "onBlur", "onMousedown", "onMouseup", "onMouseenter", "onMouseleave", "onClick", "onOk", "onKeydown", "components", "order", "direction", "activePickerIndex", "autocomplete", "minuteStep", "hourStep", "secondStep", "hideDisabledOptions", "disabledMinutes", "presets", "prevIcon", "nextIcon", "superPrevIcon", "superNextIcon"],
    setup(e, t) {
      let {
        attrs: n,
        expose: r
      } = t;
      const a = V(() => e.picker === "date" && !!e.showTime || e.picker === "time"), o = V(() => e.presets), i = V(() => e.ranges), s = Ak(o, i), l = ne({}), u = ne(null), c = ne(null), f = ne(null), d = ne(null), p = ne(null), v = ne(null), h = ne(null), m = ne(null);
      process.env.NODE_ENV !== "production" && Ik(e);
      const y = V(() => bk(pk(e.format, e.picker, e.showTime, e.use12Hours))), [x, g] = ri(0, {
        value: Tt(e, "activePickerIndex")
      }), S = ne(null), w = V(() => {
        const {
          disabled: Ze
        } = e;
        return Array.isArray(Ze) ? Ze : [Ze || !1, Ze || !1];
      }), [_, b] = ri(null, {
        value: Tt(e, "value"),
        defaultValue: e.defaultValue,
        postState: (Ze) => e.picker === "time" && !e.order ? Ze : S5(Ze, e.generateConfig)
      }), [E, C, T] = Yae({
        values: _,
        picker: Tt(e, "picker"),
        defaultDates: e.defaultPickerValue,
        generateConfig: Tt(e, "generateConfig")
      }), [O, I] = ri(_.value, {
        postState: (Ze) => {
          let Et = Ze;
          if (w.value[0] && w.value[1])
            return Et;
          for (let _t = 0; _t < 2; _t += 1)
            w.value[_t] && !an(Et, _t) && !an(e.allowEmpty, _t) && (Et = Jo(Et, e.generateConfig.getNow(), _t));
          return Et;
        }
      }), [k, B] = ri([e.picker, e.picker], {
        value: Tt(e, "mode")
      });
      He(() => e.picker, () => {
        B([e.picker, e.picker]);
      });
      const P = (Ze, Et) => {
        var _t;
        B(Ze), (_t = e.onPanelChange) === null || _t === void 0 || _t.call(e, Et, Ze);
      }, [N, M] = Wae({
        picker: Tt(e, "picker"),
        selectedValue: O,
        locale: Tt(e, "locale"),
        disabled: w,
        disabledDate: Tt(e, "disabledDate"),
        generateConfig: Tt(e, "generateConfig")
      }, l), [H, R] = ri(!1, {
        value: Tt(e, "open"),
        defaultValue: e.defaultOpen,
        postState: (Ze) => w.value[x.value] ? !1 : Ze,
        onChange: (Ze) => {
          var Et;
          (Et = e.onOpenChange) === null || Et === void 0 || Et.call(e, Ze), !Ze && S.value && S.value.onClose && S.value.onClose();
        }
      }), z = V(() => H.value && x.value === 0), W = V(() => H.value && x.value === 1), F = ne(0), Y = ne(0), X = ne(0), {
        width: q
      } = Ud(u);
      He([H, q], () => {
        !H.value && u.value && (X.value = q.value);
      });
      const {
        width: Q
      } = Ud(c), {
        width: ue
      } = Ud(m), {
        width: le
      } = Ud(f), {
        width: te
      } = Ud(p);
      He([x, H, Q, ue, le, te, () => e.direction], () => {
        Y.value = 0, x.value ? f.value && p.value && (Y.value = le.value + te.value, Q.value && ue.value && Y.value > Q.value - ue.value - (e.direction === "rtl" || m.value.offsetLeft > Y.value ? 0 : m.value.offsetLeft) && (F.value = Y.value)) : x.value === 0 && (F.value = 0);
      }, {
        immediate: !0
      });
      const G = ne();
      function oe(Ze, Et) {
        if (Ze)
          clearTimeout(G.value), l.value[Et] = !0, g(Et), R(Ze), H.value || T(null, Et);
        else if (x.value === Et) {
          R(Ze);
          const _t = l.value;
          G.value = setTimeout(() => {
            _t === l.value && (l.value = {});
          });
        }
      }
      function L(Ze) {
        oe(!0, Ze), setTimeout(() => {
          const Et = [v, h][Ze];
          Et.value && Et.value.focus();
        }, 0);
      }
      function re(Ze, Et) {
        let _t = Ze, ee = an(_t, 0), fe = an(_t, 1);
        const {
          generateConfig: ie,
          locale: ce,
          picker: de,
          order: ye,
          onCalendarChange: Pe,
          allowEmpty: je,
          onChange: Ae,
          showTime: Re
        } = e;
        ee && fe && ie.isAfter(ee, fe) && (// WeekPicker only compare week
        de === "week" && !gk(ie, ce.locale, ee, fe) || // QuotaPicker only compare week
        de === "quarter" && !mk(ie, ee, fe) || // Other non-TimePicker compare date
        de !== "week" && de !== "quarter" && de !== "time" && !(Re ? $f(ie, ee, fe) : Us(ie, ee, fe)) ? (Et === 0 ? (_t = [ee, null], fe = null) : (ee = null, _t = [null, fe]), l.value = {
          [Et]: !0
        }) : (de !== "time" || ye !== !1) && (_t = S5(_t, ie))), I(_t);
        const Ne = _t && _t[0] ? sa(_t[0], {
          generateConfig: ie,
          locale: ce,
          format: y.value[0]
        }) : "", Qe = _t && _t[1] ? sa(_t[1], {
          generateConfig: ie,
          locale: ce,
          format: y.value[0]
        }) : "";
        Pe && Pe(_t, [Ne, Qe], {
          range: Et === 0 ? "start" : "end"
        });
        const $e = _5(ee, 0, w.value, je), ht = _5(fe, 1, w.value, je);
        (_t === null || $e && ht) && (b(_t), Ae && (!$f(ie, an(_.value, 0), ee) || !$f(ie, an(_.value, 1), fe)) && Ae(_t, [Ne, Qe]));
        let Je = null;
        Et === 0 && !w.value[1] ? Je = 1 : Et === 1 && !w.value[0] && (Je = 0), Je !== null && Je !== x.value && (!l.value[Je] || !an(_t, Je)) && an(_t, Et) ? L(Je) : oe(!1, Et);
      }
      const j = (Ze) => H && S.value && S.value.onKeydown ? S.value.onKeydown(Ze) : (Sa(!1, "Picker not correct forward Keydown operation. Please help to fire issue about this."), !1), J = {
        formatList: y,
        generateConfig: Tt(e, "generateConfig"),
        locale: Tt(e, "locale")
      }, [ae, he] = Rm(V(() => an(O.value, 0)), J), [K, Z] = Rm(V(() => an(O.value, 1)), J), se = (Ze, Et) => {
        const _t = yk(Ze, {
          locale: e.locale,
          formatList: y.value,
          generateConfig: e.generateConfig
        });
        _t && !(Et === 0 ? N : M)(_t) && (I(Jo(O.value, _t, Et)), T(_t, Et));
      }, [me, xe, be] = g2({
        valueTexts: ae,
        onTextChange: (Ze) => se(Ze, 0)
      }), [Te, Ie, Ve] = g2({
        valueTexts: K,
        onTextChange: (Ze) => se(Ze, 1)
      }), [tt, it] = Ai(null), [Se, ge] = Ai(null), [pe, De, Ue] = y2(me, J), [Xe, ut, xt] = y2(Te, J), Mt = (Ze) => {
        ge(Jo(O.value, Ze, x.value)), x.value === 0 ? De(Ze) : ut(Ze);
      }, yt = () => {
        ge(Jo(O.value, null, x.value)), x.value === 0 ? Ue() : xt();
      }, gt = (Ze, Et) => ({
        forwardKeydown: j,
        onBlur: (_t) => {
          var ee;
          (ee = e.onBlur) === null || ee === void 0 || ee.call(e, _t);
        },
        isClickOutside: (_t) => !vk([c.value, f.value, d.value, u.value], _t),
        onFocus: (_t) => {
          var ee;
          g(Ze), (ee = e.onFocus) === null || ee === void 0 || ee.call(e, _t);
        },
        triggerOpen: (_t) => {
          oe(_t, Ze);
        },
        onSubmit: () => {
          if (
            // When user typing disabledDate with keyboard and enter, this value will be empty
            !O.value || // Normal disabled check
            e.disabledDate && e.disabledDate(O.value[Ze])
          )
            return !1;
          re(O.value, Ze), Et();
        },
        onCancel: () => {
          oe(!1, Ze), I(_.value), Et();
        }
      }), [ct, {
        focused: Ht,
        typing: Ut
      }] = m2(D(D({}, gt(0, be)), {
        blurToCancel: a,
        open: z,
        value: me,
        onKeydown: (Ze, Et) => {
          var _t;
          (_t = e.onKeydown) === null || _t === void 0 || _t.call(e, Ze, Et);
        }
      })), [In, {
        focused: wr,
        typing: eo
      }] = m2(D(D({}, gt(1, Ve)), {
        blurToCancel: a,
        open: W,
        value: Te,
        onKeydown: (Ze, Et) => {
          var _t;
          (_t = e.onKeydown) === null || _t === void 0 || _t.call(e, Ze, Et);
        }
      })), ur = (Ze) => {
        var Et;
        (Et = e.onClick) === null || Et === void 0 || Et.call(e, Ze), !H.value && !v.value.contains(Ze.target) && !h.value.contains(Ze.target) && (w.value[0] ? w.value[1] || L(1) : L(0));
      }, rr = (Ze) => {
        var Et;
        (Et = e.onMousedown) === null || Et === void 0 || Et.call(e, Ze), H.value && (Ht.value || wr.value) && !v.value.contains(Ze.target) && !h.value.contains(Ze.target) && Ze.preventDefault();
      }, gi = V(() => {
        var Ze;
        return !((Ze = _.value) === null || Ze === void 0) && Ze[0] ? sa(_.value[0], {
          locale: e.locale,
          format: "YYYYMMDDHHmmss",
          generateConfig: e.generateConfig
        }) : "";
      }), yi = V(() => {
        var Ze;
        return !((Ze = _.value) === null || Ze === void 0) && Ze[1] ? sa(_.value[1], {
          locale: e.locale,
          format: "YYYYMMDDHHmmss",
          generateConfig: e.generateConfig
        }) : "";
      });
      He([H, ae, K], () => {
        H.value || (I(_.value), !ae.value.length || ae.value[0] === "" ? xe("") : he.value !== me.value && be(), !K.value.length || K.value[0] === "" ? Ie("") : Z.value !== Te.value && Ve());
      }), He([gi, yi], () => {
        I(_.value);
      }), process.env.NODE_ENV !== "production" && _n(() => {
        const {
          value: Ze,
          disabled: Et
        } = e;
        Ze && Array.isArray(Et) && (an(Et, 0) && !an(Ze, 0) || an(Et, 1) && !an(Ze, 1)) && Sa(!1, "`disabled` should not set with empty `value`. You should set `allowEmpty` or `value` instead.");
      }), r({
        focus: () => {
          v.value && v.value.focus();
        },
        blur: () => {
          v.value && v.value.blur(), h.value && h.value.blur();
        }
      });
      const $r = V(() => H.value && Se.value && Se.value[0] && Se.value[1] && e.generateConfig.isAfter(Se.value[1], Se.value[0]) ? Se.value : null);
      function An() {
        let Ze = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          generateConfig: _t,
          showTime: ee,
          dateRender: fe,
          direction: ie,
          disabledTime: ce,
          prefixCls: de,
          locale: ye
        } = e;
        let Pe = ee;
        if (ee && typeof ee == "object" && ee.defaultValue) {
          const Ae = ee.defaultValue;
          Pe = D(D({}, ee), {
            defaultValue: an(Ae, x.value) || void 0
          });
        }
        let je = null;
        return fe && (je = (Ae) => {
          let {
            current: Re,
            today: Ne
          } = Ae;
          return fe({
            current: Re,
            today: Ne,
            info: {
              range: x.value ? "end" : "start"
            }
          });
        }), A(Rae, {
          value: {
            inRange: !0,
            panelPosition: Ze,
            rangedValue: tt.value || O.value,
            hoverRangedValue: $r.value
          }
        }, {
          default: () => [A(Tk, ve(ve(ve({}, e), Et), {}, {
            dateRender: je,
            showTime: Pe,
            mode: k.value[x.value],
            generateConfig: _t,
            style: void 0,
            direction: ie,
            disabledDate: x.value === 0 ? N : M,
            disabledTime: (Ae) => ce ? ce(Ae, x.value === 0 ? "start" : "end") : !1,
            class: Ge({
              [`${de}-panel-focused`]: x.value === 0 ? !Ut.value : !eo.value
            }),
            value: an(O.value, x.value),
            locale: ye,
            tabIndex: -1,
            onPanelChange: (Ae, Re) => {
              x.value === 0 && Ue(!0), x.value === 1 && xt(!0), P(Jo(k.value, Re, x.value), Jo(O.value, Ae, x.value));
              let Ne = Ae;
              Ze === "right" && k.value[x.value] === Re && (Ne = _0(Ne, Re, _t, -1)), T(Ne, x.value);
            },
            onOk: null,
            onSelect: void 0,
            onChange: void 0,
            defaultValue: x.value === 0 ? an(O.value, 1) : an(O.value, 0)
          }), null)]
        });
      }
      const va = (Ze, Et) => {
        const _t = Jo(O.value, Ze, x.value);
        Et === "submit" || Et !== "key" && !a.value ? (re(_t, x.value), x.value === 0 ? Ue() : xt()) : I(_t);
      };
      return WC({
        operationRef: S,
        hideHeader: V(() => e.picker === "time"),
        onDateMouseenter: Mt,
        onDateMouseleave: yt,
        hideRanges: V(() => !0),
        onSelect: va,
        open: H
      }), () => {
        const {
          prefixCls: Ze = "rc-picker",
          id: Et,
          popupStyle: _t,
          dropdownClassName: ee,
          transitionName: fe,
          dropdownAlign: ie,
          getPopupContainer: ce,
          generateConfig: de,
          locale: ye,
          placeholder: Pe,
          autofocus: je,
          picker: Ae = "date",
          showTime: Re,
          separator: Ne = "~",
          disabledDate: Qe,
          panelRender: $e,
          allowClear: ht,
          suffixIcon: ot,
          clearIcon: Je,
          inputReadOnly: _e,
          renderExtraFooter: Ee,
          onMouseenter: Le,
          onMouseleave: lt,
          onMouseup: Rt,
          onOk: nt,
          components: Ot,
          direction: sn,
          autocomplete: Tn = "off"
        } = e, Xt = sn === "rtl" ? {
          right: `${Y.value}px`
        } : {
          left: `${Y.value}px`
        };
        function bn() {
          let qr;
          const ml = Ck(Ze, k.value[x.value], Ee), xE = Ek({
            prefixCls: Ze,
            components: Ot,
            needConfirmButton: a.value,
            okDisabled: !an(O.value, x.value) || Qe && Qe(O.value[x.value]),
            locale: ye,
            onOk: () => {
              an(O.value, x.value) && (re(O.value, x.value), nt && nt(O.value));
            }
          });
          if (Ae !== "time" && !Re) {
            const gl = x.value === 0 ? E.value : C.value, eF = _0(gl, Ae, de), q1 = k.value[x.value] === Ae, bE = An(q1 ? "left" : !1, {
              pickerValue: gl,
              onPickerValueChange: (X1) => {
                T(X1, x.value);
              }
            }), wE = An("right", {
              pickerValue: eF,
              onPickerValueChange: (X1) => {
                T(_0(X1, Ae, de, -1), x.value);
              }
            });
            sn === "rtl" ? qr = A(dt, null, [wE, q1 && bE]) : qr = A(dt, null, [bE, q1 && wE]);
          } else
            qr = An();
          let Y1 = A("div", {
            class: `${Ze}-panel-layout`
          }, [A(Ok, {
            prefixCls: Ze,
            presets: s.value,
            onClick: (gl) => {
              re(gl, null), oe(!1, x.value);
            },
            onHover: (gl) => {
              it(gl);
            }
          }, null), A("div", null, [A("div", {
            class: `${Ze}-panels`
          }, [qr]), (ml || xE) && A("div", {
            class: `${Ze}-footer`
          }, [ml, xE])])]);
          return $e && (Y1 = $e(Y1)), A("div", {
            class: `${Ze}-panel-container`,
            style: {
              marginLeft: `${F.value}px`
            },
            ref: c,
            onMousedown: (gl) => {
              gl.preventDefault();
            }
          }, [Y1]);
        }
        const Or = A("div", {
          class: Ge(`${Ze}-range-wrapper`, `${Ze}-${Ae}-range-wrapper`),
          style: {
            minWidth: `${X.value}px`
          }
        }, [A("div", {
          ref: m,
          class: `${Ze}-range-arrow`,
          style: Xt
        }, null), bn()]);
        let xi;
        ot && (xi = A("span", {
          class: `${Ze}-suffix`
        }, [ot]));
        let pl;
        ht && (an(_.value, 0) && !w.value[0] || an(_.value, 1) && !w.value[1]) && (pl = A("span", {
          onMousedown: (qr) => {
            qr.preventDefault(), qr.stopPropagation();
          },
          onMouseup: (qr) => {
            qr.preventDefault(), qr.stopPropagation();
            let ml = _.value;
            w.value[0] || (ml = Jo(ml, null, 0)), w.value[1] || (ml = Jo(ml, null, 1)), re(ml, null), oe(!1, x.value);
          },
          class: `${Ze}-clear`
        }, [Je || A("span", {
          class: `${Ze}-clear-btn`
        }, null)]));
        const hl = {
          size: hk(Ae, y.value[0], de)
        };
        let bi = 0, vl = 0;
        f.value && d.value && p.value && (x.value === 0 ? vl = f.value.offsetWidth : (bi = Y.value, vl = d.value.offsetWidth));
        const ma = sn === "rtl" ? {
          right: `${bi}px`
        } : {
          left: `${bi}px`
        };
        return A("div", ve({
          ref: u,
          class: Ge(Ze, `${Ze}-range`, n.class, {
            [`${Ze}-disabled`]: w.value[0] && w.value[1],
            [`${Ze}-focused`]: x.value === 0 ? Ht.value : wr.value,
            [`${Ze}-rtl`]: sn === "rtl"
          }),
          style: n.style,
          onClick: ur,
          onMouseenter: Le,
          onMouseleave: lt,
          onMousedown: rr,
          onMouseup: Rt
        }, wk(e)), [A("div", {
          class: Ge(`${Ze}-input`, {
            [`${Ze}-input-active`]: x.value === 0,
            [`${Ze}-input-placeholder`]: !!pe.value
          }),
          ref: f
        }, [A("input", ve(ve(ve({
          id: Et,
          disabled: w.value[0],
          readonly: _e || typeof y.value[0] == "function" || !Ut.value,
          value: pe.value || me.value,
          onInput: (qr) => {
            xe(qr.target.value);
          },
          autofocus: je,
          placeholder: an(Pe, 0) || "",
          ref: v
        }, ct.value), hl), {}, {
          autocomplete: Tn
        }), null)]), A("div", {
          class: `${Ze}-range-separator`,
          ref: p
        }, [Ne]), A("div", {
          class: Ge(`${Ze}-input`, {
            [`${Ze}-input-active`]: x.value === 1,
            [`${Ze}-input-placeholder`]: !!Xe.value
          }),
          ref: d
        }, [A("input", ve(ve(ve({
          disabled: w.value[1],
          readonly: _e || typeof y.value[0] == "function" || !eo.value,
          value: Xe.value || Te.value,
          onInput: (qr) => {
            Ie(qr.target.value);
          },
          placeholder: an(Pe, 1) || "",
          ref: h
        }, In.value), hl), {}, {
          autocomplete: Tn
        }), null)]), A("div", {
          class: `${Ze}-active-bar`,
          style: D(D({}, ma), {
            width: `${vl}px`,
            position: "absolute"
          })
        }, null), xi, pl, A($k, {
          visible: H.value,
          popupStyle: _t,
          prefixCls: Ze,
          dropdownClassName: ee,
          dropdownAlign: ie,
          getPopupContainer: ce,
          transitionName: fe,
          range: !0,
          direction: sn
        }, {
          default: () => [A("div", {
            style: {
              pointerEvents: "none",
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0
            }
          }, null)],
          popupElement: () => Or
        })]);
      };
    }
  });
}
const roe = noe();
var aoe = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const ooe = {
  prefixCls: String,
  name: String,
  id: String,
  type: String,
  defaultChecked: {
    type: [Boolean, Number],
    default: void 0
  },
  checked: {
    type: [Boolean, Number],
    default: void 0
  },
  disabled: Boolean,
  tabindex: {
    type: [Number, String]
  },
  readonly: Boolean,
  autofocus: Boolean,
  value: Oe.any,
  required: Boolean
}, ioe = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "Checkbox",
  inheritAttrs: !1,
  props: ha(ooe, {
    prefixCls: "rc-checkbox",
    type: "checkbox",
    defaultChecked: !1
  }),
  emits: ["click", "change"],
  setup(e, t) {
    let {
      attrs: n,
      emit: r,
      expose: a
    } = t;
    const o = ne(e.checked === void 0 ? e.defaultChecked : e.checked), i = ne();
    He(() => e.checked, () => {
      o.value = e.checked;
    }), a({
      focus() {
        var c;
        (c = i.value) === null || c === void 0 || c.focus();
      },
      blur() {
        var c;
        (c = i.value) === null || c === void 0 || c.blur();
      }
    });
    const s = ne(), l = (c) => {
      if (e.disabled)
        return;
      e.checked === void 0 && (o.value = c.target.checked), c.shiftKey = s.value;
      const f = {
        target: D(D({}, e), {
          checked: c.target.checked
        }),
        stopPropagation() {
          c.stopPropagation();
        },
        preventDefault() {
          c.preventDefault();
        },
        nativeEvent: c
      };
      e.checked !== void 0 && (i.value.checked = !!e.checked), r("change", f), s.value = !1;
    }, u = (c) => {
      r("click", c), s.value = c.shiftKey;
    };
    return () => {
      const {
        prefixCls: c,
        name: f,
        id: d,
        type: p,
        disabled: v,
        readonly: h,
        tabindex: m,
        autofocus: y,
        value: x,
        required: g
      } = e, S = aoe(e, ["prefixCls", "name", "id", "type", "disabled", "readonly", "tabindex", "autofocus", "value", "required"]), {
        class: w,
        onFocus: _,
        onBlur: b,
        onKeydown: E,
        onKeypress: C,
        onKeyup: T
      } = n, O = D(D({}, S), n), I = Object.keys(O).reduce((P, N) => ((N.startsWith("data-") || N.startsWith("aria-") || N === "role") && (P[N] = O[N]), P), {}), k = Ge(c, w, {
        [`${c}-checked`]: o.value,
        [`${c}-disabled`]: v
      }), B = D(D({
        name: f,
        id: d,
        type: p,
        readonly: h,
        disabled: v,
        tabindex: m,
        class: `${c}-input`,
        checked: !!o.value,
        autofocus: y,
        value: x
      }, I), {
        onChange: l,
        onClick: u,
        onFocus: _,
        onBlur: b,
        onKeydown: E,
        onKeypress: C,
        onKeyup: T,
        required: g
      });
      return A("span", {
        class: k
      }, [A("input", ve({
        ref: i
      }, B), null), A("span", {
        class: `${c}-inner`
      }, null)]);
    };
  }
}), soe = (e) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color: e,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
}), T1 = (e) => ({
  borderColor: e.inputBorderHoverColor,
  borderInlineEndWidth: e.lineWidth
}), ed = (e) => ({
  borderColor: e.inputBorderHoverColor,
  boxShadow: `0 0 0 ${e.controlOutlineWidth}px ${e.controlOutline}`,
  borderInlineEndWidth: e.lineWidth,
  outline: 0
}), loe = (e) => ({
  color: e.colorTextDisabled,
  backgroundColor: e.colorBgContainerDisabled,
  borderColor: e.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "&:hover": D({}, T1(xn(e, {
    inputBorderHoverColor: e.colorBorder
  })))
}), kk = (e) => {
  const {
    inputPaddingVerticalLG: t,
    fontSizeLG: n,
    lineHeightLG: r,
    borderRadiusLG: a,
    inputPaddingHorizontalLG: o
  } = e;
  return {
    padding: `${t}px ${o}px`,
    fontSize: n,
    lineHeight: r,
    borderRadius: a
  };
}, u4 = (e) => ({
  padding: `${e.inputPaddingVerticalSM}px ${e.controlPaddingHorizontalSM - 1}px`,
  borderRadius: e.borderRadiusSM
}), Mk = (e, t) => {
  const {
    componentCls: n,
    colorError: r,
    colorWarning: a,
    colorErrorOutline: o,
    colorWarningOutline: i,
    colorErrorBorderHover: s,
    colorWarningBorderHover: l
  } = e;
  return {
    [`&-status-error:not(${t}-disabled):not(${t}-borderless)${t}`]: {
      borderColor: r,
      "&:hover": {
        borderColor: s
      },
      "&:focus, &-focused": D({}, ed(xn(e, {
        inputBorderActiveColor: r,
        inputBorderHoverColor: r,
        controlOutline: o
      }))),
      [`${n}-prefix`]: {
        color: r
      }
    },
    [`&-status-warning:not(${t}-disabled):not(${t}-borderless)${t}`]: {
      borderColor: a,
      "&:hover": {
        borderColor: l
      },
      "&:focus, &-focused": D({}, ed(xn(e, {
        inputBorderActiveColor: a,
        inputBorderHoverColor: a,
        controlOutline: i
      }))),
      [`${n}-prefix`]: {
        color: a
      }
    }
  };
}, $1 = (e) => D(D({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${e.inputPaddingVertical}px ${e.inputPaddingHorizontal}px`,
  color: e.colorText,
  fontSize: e.fontSize,
  lineHeight: e.lineHeight,
  backgroundColor: e.colorBgContainer,
  backgroundImage: "none",
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: e.colorBorder,
  borderRadius: e.borderRadius,
  transition: `all ${e.motionDurationMid}`
}, soe(e.colorTextPlaceholder)), {
  "&:hover": D({}, T1(e)),
  "&:focus, &-focused": D({}, ed(e)),
  "&-disabled, &[disabled]": D({}, loe(e)),
  "&-borderless": {
    "&, &:hover, &:focus, &-focused, &-disabled, &[disabled]": {
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none"
    }
  },
  // Reset height for `textarea`s
  "textarea&": {
    maxWidth: "100%",
    height: "auto",
    minHeight: e.controlHeight,
    lineHeight: e.lineHeight,
    verticalAlign: "bottom",
    transition: `all ${e.motionDurationSlow}, height 0s`,
    resize: "vertical"
  },
  // Size
  "&-lg": D({}, kk(e)),
  "&-sm": D({}, u4(e)),
  // RTL
  "&-rtl": {
    direction: "rtl"
  },
  "&-textarea-rtl": {
    direction: "rtl"
  }
}), uoe = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    "&[class*='col-']": {
      paddingInlineEnd: e.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${t}, &-lg > ${t}-group-addon`]: D({}, kk(e)),
    [`&-sm ${t}, &-sm > ${t}-group-addon`]: D({}, u4(e)),
    [`> ${t}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${t}-group`]: {
      "&-addon, &-wrap": {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${e.inputPaddingHorizontal}px`,
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.fontSize,
        textAlign: "center",
        backgroundColor: e.colorFillAlter,
        border: `${e.lineWidth}px ${e.lineType} ${e.colorBorder}`,
        borderRadius: e.borderRadius,
        transition: `all ${e.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${n}-select`]: {
          margin: `-${e.inputPaddingVertical + 1}px -${e.inputPaddingHorizontal}px`,
          [`&${n}-select-single:not(${n}-select-customize-input)`]: {
            [`${n}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${e.lineWidth}px ${e.lineType} transparent`,
              boxShadow: "none"
            }
          },
          "&-open, &-focused": {
            [`${n}-select-selector`]: {
              color: e.colorPrimary
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${n}-cascader-picker`]: {
          margin: `-9px -${e.inputPaddingHorizontal}px`,
          backgroundColor: "transparent",
          [`${n}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    },
    [`${t}`]: {
      float: "inline-start",
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${t}:first-child, ${t}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${n}-select ${n}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}-affix-wrapper`]: {
      [`&:not(:first-child) ${t}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${t}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}:last-child, ${t}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${n}-select ${n}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${t}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${t}-search &`]: {
          borderStartStartRadius: e.borderRadius,
          borderEndStartRadius: e.borderRadius
        }
      },
      [`&:not(:first-child), ${t}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${t}-group-compact`]: D(D({
      display: "block"
    }, wm()), {
      [`${t}-group-addon, ${t}-group-wrap, > ${t}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: e.lineWidth,
          "&:hover": {
            zIndex: 1
          },
          "&:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-block",
        float: "none",
        verticalAlign: "top",
        borderRadius: 0
      },
      [`& > ${t}-affix-wrapper`]: {
        display: "inline-flex"
      },
      [`& > ${n}-picker-range`]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: -e.lineWidth,
        borderInlineEndWidth: e.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [`${t}`]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${n}-select > ${n}-select-selector,
      & > ${n}-select-auto-complete ${t},
      & > ${n}-cascader-picker ${t},
      & > ${t}-group-wrapper ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderRadius: 0,
        "&:hover": {
          zIndex: 1
        },
        "&:focus": {
          zIndex: 1
        }
      },
      [`& > ${n}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${n}-select > ${n}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${n}-select:first-child > ${n}-select-selector,
      & > ${n}-select-auto-complete:first-child ${t},
      & > ${n}-cascader-picker:first-child ${t}`]: {
        borderStartStartRadius: e.borderRadius,
        borderEndStartRadius: e.borderRadius
      },
      [`& > *:last-child,
      & > ${n}-select:last-child > ${n}-select-selector,
      & > ${n}-cascader-picker:last-child ${t},
      & > ${n}-cascader-picker-focused:last-child ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderStartEndRadius: e.borderRadius,
        borderEndEndRadius: e.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${n}-select-auto-complete ${t}`]: {
        verticalAlign: "top"
      },
      [`${t}-group-wrapper + ${t}-group-wrapper`]: {
        marginInlineStart: -e.lineWidth,
        [`${t}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${t}-group-wrapper:not(:last-child)`]: {
        [`&${t}-search > ${t}-group`]: {
          [`& > ${t}-group-addon > ${t}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${t}`]: {
            borderStartStartRadius: e.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: e.borderRadius
          }
        }
      }
    }),
    [`&&-sm ${n}-btn`]: {
      fontSize: e.fontSizeSM,
      height: e.controlHeightSM,
      lineHeight: "normal"
    },
    [`&&-lg ${n}-btn`]: {
      fontSize: e.fontSizeLG,
      height: e.controlHeightLG,
      lineHeight: "normal"
    },
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&&-lg ${n}-select-single ${n}-select-selector`]: {
      height: `${e.controlHeightLG}px`,
      [`${n}-select-selection-item, ${n}-select-selection-placeholder`]: {
        // -2 is for the border size & override default
        lineHeight: `${e.controlHeightLG - 2}px`
      },
      [`${n}-select-selection-search-input`]: {
        height: `${e.controlHeightLG}px`
      }
    },
    [`&&-sm ${n}-select-single ${n}-select-selector`]: {
      height: `${e.controlHeightSM}px`,
      [`${n}-select-selection-item, ${n}-select-selection-placeholder`]: {
        // -2 is for the border size & override default
        lineHeight: `${e.controlHeightSM - 2}px`
      },
      [`${n}-select-selection-search-input`]: {
        height: `${e.controlHeightSM}px`
      }
    }
  };
}, coe = (e) => {
  const {
    componentCls: t,
    controlHeightSM: n,
    lineWidth: r
  } = e, o = (n - r * 2 - 16) / 2;
  return {
    [t]: D(D(D(D({}, gr(e)), $1(e)), Mk(e, t)), {
      '&[type="color"]': {
        height: e.controlHeight,
        [`&${t}-lg`]: {
          height: e.controlHeightLG
        },
        [`&${t}-sm`]: {
          height: n,
          paddingTop: o,
          paddingBottom: o
        }
      }
    })
  };
}, foe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // ========================= Input =========================
    [`${t}-clear-icon`]: {
      margin: 0,
      color: e.colorTextQuaternary,
      fontSize: e.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${e.motionDurationSlow}`,
      "&:hover": {
        color: e.colorTextTertiary
      },
      "&:active": {
        color: e.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${e.inputAffixPadding}px`
      }
    },
    // ======================= TextArea ========================
    "&-textarea-with-clear-btn": {
      padding: "0 !important",
      border: "0 !important",
      [`${t}-clear-icon`]: {
        position: "absolute",
        insetBlockStart: e.paddingXS,
        insetInlineEnd: e.paddingXS,
        zIndex: 1
      }
    }
  };
}, doe = (e) => {
  const {
    componentCls: t,
    inputAffixPadding: n,
    colorTextDescription: r,
    motionDurationSlow: a,
    colorIcon: o,
    colorIconHover: i,
    iconCls: s
  } = e;
  return {
    [`${t}-affix-wrapper`]: D(D(D(D(D({}, $1(e)), {
      display: "inline-flex",
      [`&:not(${t}-affix-wrapper-disabled):hover`]: D(D({}, T1(e)), {
        zIndex: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      }),
      "&-focused, &:focus": {
        zIndex: 1
      },
      "&-disabled": {
        [`${t}[disabled]`]: {
          background: "transparent"
        }
      },
      [`> input${t}`]: {
        padding: 0,
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${t}`]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: e.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: r
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: e.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: n
        },
        "&-suffix": {
          marginInlineStart: n
        }
      }
    }), foe(e)), {
      // password
      [`${s}${t}-password-icon`]: {
        color: o,
        cursor: "pointer",
        transition: `all ${a}`,
        "&:hover": {
          color: i
        }
      }
    }), Mk(e, `${t}-affix-wrapper`))
  };
}, poe = (e) => {
  const {
    componentCls: t,
    colorError: n,
    colorSuccess: r,
    borderRadiusLG: a,
    borderRadiusSM: o
  } = e;
  return {
    [`${t}-group`]: D(D(D({}, gr(e)), uoe(e)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": {
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${t}-group-addon`]: {
            borderRadius: a
          }
        },
        "&-sm": {
          [`${t}-group-addon`]: {
            borderRadius: o
          }
        },
        // Status
        "&-status-error": {
          [`${t}-group-addon`]: {
            color: n,
            borderColor: n
          }
        },
        "&-status-warning": {
          [`${t}-group-addon:last-child`]: {
            color: r,
            borderColor: r
          }
        }
      }
    })
  };
}, hoe = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e, r = `${t}-search`;
  return {
    [r]: {
      [`${t}`]: {
        "&:hover, &:focus": {
          borderColor: e.colorPrimaryHover,
          [`+ ${t}-group-addon ${r}-button:not(${n}-btn-primary)`]: {
            borderInlineStartColor: e.colorPrimaryHover
          }
        }
      },
      [`${t}-affix-wrapper`]: {
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#components-auto-complete-demo-certain-category
      [`${t}-lg`]: {
        lineHeight: e.lineHeightLG - 2e-4
      },
      [`> ${t}-group`]: {
        [`> ${t}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${r}-button`]: {
            paddingTop: 0,
            paddingBottom: 0,
            borderStartStartRadius: 0,
            borderStartEndRadius: e.borderRadius,
            borderEndEndRadius: e.borderRadius,
            borderEndStartRadius: 0
          },
          [`${r}-button:not(${n}-btn-primary)`]: {
            color: e.colorTextDescription,
            "&:hover": {
              color: e.colorPrimaryHover
            },
            "&:active": {
              color: e.colorPrimaryActive
            },
            [`&${n}-btn-loading::before`]: {
              insetInlineStart: 0,
              insetInlineEnd: 0,
              insetBlockStart: 0,
              insetBlockEnd: 0
            }
          }
        }
      },
      [`${r}-button`]: {
        height: e.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`&-large ${r}-button`]: {
        height: e.controlHeightLG
      },
      [`&-small ${r}-button`]: {
        height: e.controlHeightSM
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${t}-compact-item`]: {
        [`&:not(${t}-compact-last-item)`]: {
          [`${t}-group-addon`]: {
            [`${t}-search-button`]: {
              marginInlineEnd: -e.lineWidth,
              borderRadius: 0
            }
          }
        },
        [`&:not(${t}-compact-first-item)`]: {
          [`${t},${t}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${t}-group-addon ${t}-search-button,
        > ${t},
        ${t}-affix-wrapper`]: {
          "&:hover,&:focus,&:active": {
            zIndex: 2
          }
        },
        [`> ${t}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
};
function c4(e) {
  return xn(e, {
    inputAffixPadding: e.paddingXXS,
    inputPaddingVertical: Math.max(Math.round((e.controlHeight - e.fontSize * e.lineHeight) / 2 * 10) / 10 - e.lineWidth, 3),
    inputPaddingVerticalLG: Math.ceil((e.controlHeightLG - e.fontSizeLG * e.lineHeightLG) / 2 * 10) / 10 - e.lineWidth,
    inputPaddingVerticalSM: Math.max(Math.round((e.controlHeightSM - e.fontSize * e.lineHeight) / 2 * 10) / 10 - e.lineWidth, 0),
    inputPaddingHorizontal: e.paddingSM - e.lineWidth,
    inputPaddingHorizontalSM: e.paddingXS - e.lineWidth,
    inputPaddingHorizontalLG: e.controlPaddingHorizontal - e.lineWidth,
    inputBorderHoverColor: e.colorPrimaryHover,
    inputBorderActiveColor: e.colorPrimaryHover
  });
}
const voe = (e) => {
  const {
    componentCls: t,
    inputPaddingHorizontal: n,
    paddingLG: r
  } = e, a = `${t}-textarea`;
  return {
    [a]: {
      position: "relative",
      [`${a}-suffix`]: {
        position: "absolute",
        top: 0,
        insetInlineEnd: n,
        bottom: 0,
        zIndex: 1,
        display: "inline-flex",
        alignItems: "center",
        margin: "auto"
      },
      "&-status-error,\n        &-status-warning,\n        &-status-success,\n        &-status-validating": {
        [`&${a}-has-feedback`]: {
          [`${t}`]: {
            paddingInlineEnd: r
          }
        }
      },
      "&-show-count": {
        // https://github.com/ant-design/ant-design/issues/33049
        [`> ${t}`]: {
          height: "100%"
        },
        "&::after": {
          color: e.colorTextDescription,
          whiteSpace: "nowrap",
          content: "attr(data-count)",
          pointerEvents: "none",
          float: "right"
        }
      },
      "&-rtl": {
        "&::after": {
          float: "left"
        }
      }
    }
  };
}, f4 = xr("Input", (e) => {
  const t = c4(e);
  return [
    coe(t),
    voe(t),
    doe(t),
    poe(t),
    hoe(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    x1(t)
  ];
}), zy = (e, t, n, r) => {
  const {
    lineHeight: a
  } = e, o = Math.floor(n * a) + 2, i = Math.max((t - o) / 2, 0), s = Math.max(t - o - i, 0);
  return {
    padding: `${i}px ${r}px ${s}px`
  };
}, moe = (e) => {
  const {
    componentCls: t,
    pickerCellCls: n,
    pickerCellInnerCls: r,
    pickerPanelCellHeight: a,
    motionDurationSlow: o,
    borderRadiusSM: i,
    motionDurationMid: s,
    controlItemBgHover: l,
    lineWidth: u,
    lineType: c,
    colorPrimary: f,
    controlItemBgActive: d,
    colorTextLightSolid: p,
    controlHeightSM: v,
    pickerDateHoverRangeBorderColor: h,
    pickerCellBorderGap: m,
    pickerBasicCellHoverWithRangeColor: y,
    pickerPanelCellWidth: x,
    colorTextDisabled: g,
    colorBgContainerDisabled: S
  } = e;
  return {
    "&::before": {
      position: "absolute",
      top: "50%",
      insetInlineStart: 0,
      insetInlineEnd: 0,
      zIndex: 1,
      height: a,
      transform: "translateY(-50%)",
      transition: `all ${o}`,
      content: '""'
    },
    // >>> Default
    [r]: {
      position: "relative",
      zIndex: 2,
      display: "inline-block",
      minWidth: a,
      height: a,
      lineHeight: `${a}px`,
      borderRadius: i,
      transition: `background ${s}, border ${s}`
    },
    // >>> Hover
    [`&:hover:not(${n}-in-view),
    &:hover:not(${n}-selected):not(${n}-range-start):not(${n}-range-end):not(${n}-range-hover-start):not(${n}-range-hover-end)`]: {
      [r]: {
        background: l
      }
    },
    // >>> Today
    [`&-in-view${n}-today ${r}`]: {
      "&::before": {
        position: "absolute",
        top: 0,
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        zIndex: 1,
        border: `${u}px ${c} ${f}`,
        borderRadius: i,
        content: '""'
      }
    },
    // >>> In Range
    [`&-in-view${n}-in-range`]: {
      position: "relative",
      "&::before": {
        background: d
      }
    },
    // >>> Selected
    [`&-in-view${n}-selected ${r},
      &-in-view${n}-range-start ${r},
      &-in-view${n}-range-end ${r}`]: {
      color: p,
      background: f
    },
    [`&-in-view${n}-range-start:not(${n}-range-start-single),
      &-in-view${n}-range-end:not(${n}-range-end-single)`]: {
      "&::before": {
        background: d
      }
    },
    [`&-in-view${n}-range-start::before`]: {
      insetInlineStart: "50%"
    },
    [`&-in-view${n}-range-end::before`]: {
      insetInlineEnd: "50%"
    },
    // >>> Range Hover
    [`&-in-view${n}-range-hover-start:not(${n}-in-range):not(${n}-range-start):not(${n}-range-end),
      &-in-view${n}-range-hover-end:not(${n}-in-range):not(${n}-range-start):not(${n}-range-end),
      &-in-view${n}-range-hover-start${n}-range-start-single,
      &-in-view${n}-range-hover-start${n}-range-start${n}-range-end${n}-range-end-near-hover,
      &-in-view${n}-range-hover-end${n}-range-start${n}-range-end${n}-range-start-near-hover,
      &-in-view${n}-range-hover-end${n}-range-end-single,
      &-in-view${n}-range-hover:not(${n}-in-range)`]: {
      "&::after": {
        position: "absolute",
        top: "50%",
        zIndex: 0,
        height: v,
        borderTop: `${u}px dashed ${h}`,
        borderBottom: `${u}px dashed ${h}`,
        transform: "translateY(-50%)",
        transition: `all ${o}`,
        content: '""'
      }
    },
    // Add space for stash
    "&-range-hover-start::after,\n      &-range-hover-end::after,\n      &-range-hover::after": {
      insetInlineEnd: 0,
      insetInlineStart: m
    },
    // Hover with in range
    [`&-in-view${n}-in-range${n}-range-hover::before,
      &-in-view${n}-range-start${n}-range-hover::before,
      &-in-view${n}-range-end${n}-range-hover::before,
      &-in-view${n}-range-start:not(${n}-range-start-single)${n}-range-hover-start::before,
      &-in-view${n}-range-end:not(${n}-range-end-single)${n}-range-hover-end::before,
      ${t}-panel
      > :not(${t}-date-panel)
      &-in-view${n}-in-range${n}-range-hover-start::before,
      ${t}-panel
      > :not(${t}-date-panel)
      &-in-view${n}-in-range${n}-range-hover-end::before`]: {
      background: y
    },
    // range start border-radius
    [`&-in-view${n}-range-start:not(${n}-range-start-single):not(${n}-range-end) ${r}`]: {
      borderStartStartRadius: i,
      borderEndStartRadius: i,
      borderStartEndRadius: 0,
      borderEndEndRadius: 0
    },
    // range end border-radius
    [`&-in-view${n}-range-end:not(${n}-range-end-single):not(${n}-range-start) ${r}`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      borderStartEndRadius: i,
      borderEndEndRadius: i
    },
    [`&-range-hover${n}-range-end::after`]: {
      insetInlineStart: "50%"
    },
    // Edge start
    [`tr > &-in-view${n}-range-hover:first-child::after,
      tr > &-in-view${n}-range-hover-end:first-child::after,
      &-in-view${n}-start${n}-range-hover-edge-start${n}-range-hover-edge-start-near-range::after,
      &-in-view${n}-range-hover-edge-start:not(${n}-range-hover-edge-start-near-range)::after,
      &-in-view${n}-range-hover-start::after`]: {
      insetInlineStart: (x - a) / 2,
      borderInlineStart: `${u}px dashed ${h}`,
      borderStartStartRadius: u,
      borderEndStartRadius: u
    },
    // Edge end
    [`tr > &-in-view${n}-range-hover:last-child::after,
      tr > &-in-view${n}-range-hover-start:last-child::after,
      &-in-view${n}-end${n}-range-hover-edge-end${n}-range-hover-edge-end-near-range::after,
      &-in-view${n}-range-hover-edge-end:not(${n}-range-hover-edge-end-near-range)::after,
      &-in-view${n}-range-hover-end::after`]: {
      insetInlineEnd: (x - a) / 2,
      borderInlineEnd: `${u}px dashed ${h}`,
      borderStartEndRadius: u,
      borderEndEndRadius: u
    },
    // >>> Disabled
    "&-disabled": {
      color: g,
      pointerEvents: "none",
      [r]: {
        background: "transparent"
      },
      "&::before": {
        background: S
      }
    },
    [`&-disabled${n}-today ${r}::before`]: {
      borderColor: g
    }
  };
}, goe = (e) => {
  const {
    componentCls: t,
    pickerCellInnerCls: n,
    pickerYearMonthCellWidth: r,
    pickerControlIconSize: a,
    pickerPanelCellWidth: o,
    paddingSM: i,
    paddingXS: s,
    paddingXXS: l,
    colorBgContainer: u,
    lineWidth: c,
    lineType: f,
    borderRadiusLG: d,
    colorPrimary: p,
    colorTextHeading: v,
    colorSplit: h,
    pickerControlIconBorderWidth: m,
    colorIcon: y,
    pickerTextHeight: x,
    motionDurationMid: g,
    colorIconHover: S,
    fontWeightStrong: w,
    pickerPanelCellHeight: _,
    pickerCellPaddingVertical: b,
    colorTextDisabled: E,
    colorText: C,
    fontSize: T,
    pickerBasicCellHoverWithRangeColor: O,
    motionDurationSlow: I,
    pickerPanelWithoutTimeCellHeight: k,
    pickerQuarterPanelContentHeight: B,
    colorLink: P,
    colorLinkActive: N,
    colorLinkHover: M,
    pickerDateHoverRangeBorderColor: H,
    borderRadiusSM: R,
    colorTextLightSolid: z,
    borderRadius: W,
    controlItemBgHover: F,
    pickerTimePanelColumnHeight: Y,
    pickerTimePanelColumnWidth: X,
    pickerTimePanelCellHeight: q,
    controlItemBgActive: Q,
    marginXXS: ue
  } = e, le = o * 7 + i * 2 + 4, te = (le - s * 2) / 3 - r - i;
  return {
    [t]: {
      "&-panel": {
        display: "inline-flex",
        flexDirection: "column",
        textAlign: "center",
        background: u,
        border: `${c}px ${f} ${h}`,
        borderRadius: d,
        outline: "none",
        "&-focused": {
          borderColor: p
        },
        "&-rtl": {
          direction: "rtl",
          [`${t}-prev-icon,
              ${t}-super-prev-icon`]: {
            transform: "rotate(45deg)"
          },
          [`${t}-next-icon,
              ${t}-super-next-icon`]: {
            transform: "rotate(-135deg)"
          }
        }
      },
      // ========================================================
      // =                     Shared Panel                     =
      // ========================================================
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel,\n        &-week-panel,\n        &-date-panel,\n        &-time-panel": {
        display: "flex",
        flexDirection: "column",
        width: le
      },
      // ======================= Header =======================
      "&-header": {
        display: "flex",
        padding: `0 ${s}px`,
        color: v,
        borderBottom: `${c}px ${f} ${h}`,
        "> *": {
          flex: "none"
        },
        button: {
          padding: 0,
          color: y,
          lineHeight: `${x}px`,
          background: "transparent",
          border: 0,
          cursor: "pointer",
          transition: `color ${g}`
        },
        "> button": {
          minWidth: "1.6em",
          fontSize: T,
          "&:hover": {
            color: S
          }
        },
        "&-view": {
          flex: "auto",
          fontWeight: w,
          lineHeight: `${x}px`,
          button: {
            color: "inherit",
            fontWeight: "inherit",
            verticalAlign: "top",
            "&:not(:first-child)": {
              marginInlineStart: s
            },
            "&:hover": {
              color: p
            }
          }
        }
      },
      // Arrow button
      "&-prev-icon,\n        &-next-icon,\n        &-super-prev-icon,\n        &-super-next-icon": {
        position: "relative",
        display: "inline-block",
        width: a,
        height: a,
        "&::before": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          display: "inline-block",
          width: a,
          height: a,
          border: "0 solid currentcolor",
          borderBlockStartWidth: m,
          borderBlockEndWidth: 0,
          borderInlineStartWidth: m,
          borderInlineEndWidth: 0,
          content: '""'
        }
      },
      "&-super-prev-icon,\n        &-super-next-icon": {
        "&::after": {
          position: "absolute",
          top: Math.ceil(a / 2),
          insetInlineStart: Math.ceil(a / 2),
          display: "inline-block",
          width: a,
          height: a,
          border: "0 solid currentcolor",
          borderBlockStartWidth: m,
          borderBlockEndWidth: 0,
          borderInlineStartWidth: m,
          borderInlineEndWidth: 0,
          content: '""'
        }
      },
      "&-prev-icon,\n        &-super-prev-icon": {
        transform: "rotate(-45deg)"
      },
      "&-next-icon,\n        &-super-next-icon": {
        transform: "rotate(135deg)"
      },
      // ======================== Body ========================
      "&-content": {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
        "th, td": {
          position: "relative",
          minWidth: _,
          fontWeight: "normal"
        },
        th: {
          height: _ + b * 2,
          color: C,
          verticalAlign: "middle"
        }
      },
      "&-cell": D({
        padding: `${b}px 0`,
        color: E,
        cursor: "pointer",
        // In view
        "&-in-view": {
          color: C
        }
      }, moe(e)),
      // DatePanel only
      [`&-date-panel ${t}-cell-in-view${t}-cell-in-range${t}-cell-range-hover-start ${n},
        &-date-panel ${t}-cell-in-view${t}-cell-in-range${t}-cell-range-hover-end ${n}`]: {
        "&::after": {
          position: "absolute",
          top: 0,
          bottom: 0,
          zIndex: -1,
          background: O,
          transition: `all ${I}`,
          content: '""'
        }
      },
      [`&-date-panel
        ${t}-cell-in-view${t}-cell-in-range${t}-cell-range-hover-start
        ${n}::after`]: {
        insetInlineEnd: -(o - _) / 2,
        insetInlineStart: 0
      },
      [`&-date-panel ${t}-cell-in-view${t}-cell-in-range${t}-cell-range-hover-end ${n}::after`]: {
        insetInlineEnd: 0,
        insetInlineStart: -(o - _) / 2
      },
      // Hover with range start & end
      [`&-range-hover${t}-range-start::after`]: {
        insetInlineEnd: "50%"
      },
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${t}-content`]: {
          height: k * 4
        },
        [n]: {
          padding: `0 ${s}px`
        }
      },
      "&-quarter-panel": {
        [`${t}-content`]: {
          height: B
        }
      },
      // ======================== Footer ========================
      [`&-panel ${t}-footer`]: {
        borderTop: `${c}px ${f} ${h}`
      },
      "&-footer": {
        width: "min-content",
        minWidth: "100%",
        lineHeight: `${x - 2 * c}px`,
        textAlign: "center",
        "&-extra": {
          padding: `0 ${i}`,
          lineHeight: `${x - 2 * c}px`,
          textAlign: "start",
          "&:not(:last-child)": {
            borderBottom: `${c}px ${f} ${h}`
          }
        }
      },
      "&-now": {
        textAlign: "start"
      },
      "&-today-btn": {
        color: P,
        "&:hover": {
          color: M
        },
        "&:active": {
          color: N
        },
        [`&${t}-today-btn-disabled`]: {
          color: E,
          cursor: "not-allowed"
        }
      },
      // ========================================================
      // =                       Special                        =
      // ========================================================
      // ===================== Decade Panel =====================
      "&-decade-panel": {
        [n]: {
          padding: `0 ${s / 2}px`
        },
        [`${t}-cell::before`]: {
          display: "none"
        }
      },
      // ============= Year & Quarter & Month Panel =============
      "&-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${t}-body`]: {
          padding: `0 ${s}px`
        },
        [n]: {
          width: r
        },
        [`${t}-cell-range-hover-start::after`]: {
          insetInlineStart: te,
          borderInlineStart: `${c}px dashed ${H}`,
          borderStartStartRadius: R,
          borderBottomStartRadius: R,
          borderStartEndRadius: 0,
          borderBottomEndRadius: 0,
          [`${t}-panel-rtl &`]: {
            insetInlineEnd: te,
            borderInlineEnd: `${c}px dashed ${H}`,
            borderStartStartRadius: 0,
            borderBottomStartRadius: 0,
            borderStartEndRadius: R,
            borderBottomEndRadius: R
          }
        },
        [`${t}-cell-range-hover-end::after`]: {
          insetInlineEnd: te,
          borderInlineEnd: `${c}px dashed ${H}`,
          borderStartStartRadius: 0,
          borderEndStartRadius: 0,
          borderStartEndRadius: W,
          borderEndEndRadius: W,
          [`${t}-panel-rtl &`]: {
            insetInlineStart: te,
            borderInlineStart: `${c}px dashed ${H}`,
            borderStartStartRadius: W,
            borderEndStartRadius: W,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        }
      },
      // ====================== Week Panel ======================
      "&-week-panel": {
        [`${t}-body`]: {
          padding: `${s}px ${i}px`
        },
        // Clear cell style
        [`${t}-cell`]: {
          [`&:hover ${n},
            &-selected ${n},
            ${n}`]: {
            background: "transparent !important"
          }
        },
        "&-row": {
          td: {
            transition: `background ${g}`,
            "&:first-child": {
              borderStartStartRadius: R,
              borderEndStartRadius: R
            },
            "&:last-child": {
              borderStartEndRadius: R,
              borderEndEndRadius: R
            }
          },
          "&:hover td": {
            background: F
          },
          "&-selected td,\n            &-selected:hover td": {
            background: p,
            [`&${t}-cell-week`]: {
              color: new ir(z).setAlpha(0.5).toHexString()
            },
            [`&${t}-cell-today ${n}::before`]: {
              borderColor: z
            },
            [n]: {
              color: z
            }
          }
        }
      },
      // ====================== Date Panel ======================
      "&-date-panel": {
        [`${t}-body`]: {
          padding: `${s}px ${i}px`
        },
        [`${t}-content`]: {
          width: o * 7,
          th: {
            width: o
          }
        }
      },
      // ==================== Datetime Panel ====================
      "&-datetime-panel": {
        display: "flex",
        [`${t}-time-panel`]: {
          borderInlineStart: `${c}px ${f} ${h}`
        },
        [`${t}-date-panel,
          ${t}-time-panel`]: {
          transition: `opacity ${I}`
        },
        // Keyboard
        "&-active": {
          [`${t}-date-panel,
            ${t}-time-panel`]: {
            opacity: 0.3,
            "&-active": {
              opacity: 1
            }
          }
        }
      },
      // ====================== Time Panel ======================
      "&-time-panel": {
        width: "auto",
        minWidth: "auto",
        direction: "ltr",
        [`${t}-content`]: {
          display: "flex",
          flex: "auto",
          height: Y
        },
        "&-column": {
          flex: "1 0 auto",
          width: X,
          margin: `${l}px 0`,
          padding: 0,
          overflowY: "hidden",
          textAlign: "start",
          listStyle: "none",
          transition: `background ${g}`,
          overflowX: "hidden",
          "&::after": {
            display: "block",
            height: Y - q,
            content: '""'
          },
          "&:not(:first-child)": {
            borderInlineStart: `${c}px ${f} ${h}`
          },
          "&-active": {
            background: new ir(Q).setAlpha(0.2).toHexString()
          },
          "&:hover": {
            overflowY: "auto"
          },
          "> li": {
            margin: 0,
            padding: 0,
            [`&${t}-time-panel-cell`]: {
              marginInline: ue,
              [`${t}-time-panel-cell-inner`]: {
                display: "block",
                width: X - 2 * ue,
                height: q,
                margin: 0,
                paddingBlock: 0,
                paddingInlineEnd: 0,
                paddingInlineStart: (X - q) / 2,
                color: C,
                lineHeight: `${q}px`,
                borderRadius: R,
                cursor: "pointer",
                transition: `background ${g}`,
                "&:hover": {
                  background: F
                }
              },
              "&-selected": {
                [`${t}-time-panel-cell-inner`]: {
                  background: Q
                }
              },
              "&-disabled": {
                [`${t}-time-panel-cell-inner`]: {
                  color: E,
                  background: "transparent",
                  cursor: "not-allowed"
                }
              }
            }
          }
        }
      },
      // https://github.com/ant-design/ant-design/issues/39227
      [`&-datetime-panel ${t}-time-panel-column:after`]: {
        height: Y - q + l * 2
      }
    }
  };
}, yoe = (e) => {
  const {
    componentCls: t,
    colorBgContainer: n,
    colorError: r,
    colorErrorOutline: a,
    colorWarning: o,
    colorWarningOutline: i
  } = e;
  return {
    [t]: {
      [`&-status-error${t}`]: {
        "&, &:not([disabled]):hover": {
          backgroundColor: n,
          borderColor: r
        },
        "&-focused, &:focus": D({}, ed(xn(e, {
          inputBorderActiveColor: r,
          inputBorderHoverColor: r,
          controlOutline: a
        }))),
        [`${t}-active-bar`]: {
          background: r
        }
      },
      [`&-status-warning${t}`]: {
        "&, &:not([disabled]):hover": {
          backgroundColor: n,
          borderColor: o
        },
        "&-focused, &:focus": D({}, ed(xn(e, {
          inputBorderActiveColor: o,
          inputBorderHoverColor: o,
          controlOutline: i
        }))),
        [`${t}-active-bar`]: {
          background: o
        }
      }
    }
  };
}, xoe = (e) => {
  const {
    componentCls: t,
    antCls: n,
    boxShadowPopoverArrow: r,
    controlHeight: a,
    fontSize: o,
    inputPaddingHorizontal: i,
    colorBgContainer: s,
    lineWidth: l,
    lineType: u,
    colorBorder: c,
    borderRadius: f,
    motionDurationMid: d,
    colorBgContainerDisabled: p,
    colorTextDisabled: v,
    colorTextPlaceholder: h,
    controlHeightLG: m,
    fontSizeLG: y,
    controlHeightSM: x,
    inputPaddingHorizontalSM: g,
    paddingXS: S,
    marginXS: w,
    colorTextDescription: _,
    lineWidthBold: b,
    lineHeight: E,
    colorPrimary: C,
    motionDurationSlow: T,
    zIndexPopup: O,
    paddingXXS: I,
    paddingSM: k,
    pickerTextHeight: B,
    controlItemBgActive: P,
    colorPrimaryBorder: N,
    sizePopupArrow: M,
    borderRadiusXS: H,
    borderRadiusOuter: R,
    colorBgElevated: z,
    borderRadiusLG: W,
    boxShadowSecondary: F,
    borderRadiusSM: Y,
    colorSplit: X,
    controlItemBgHover: q,
    presetsWidth: Q,
    presetsMaxWidth: ue
  } = e;
  return [
    {
      [t]: D(D(D({}, gr(e)), zy(e, a, o, i)), {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        background: s,
        lineHeight: 1,
        border: `${l}px ${u} ${c}`,
        borderRadius: f,
        transition: `border ${d}, box-shadow ${d}`,
        "&:hover, &-focused": D({}, T1(e)),
        "&-focused": D({}, ed(e)),
        [`&${t}-disabled`]: {
          background: p,
          borderColor: c,
          cursor: "not-allowed",
          [`${t}-suffix`]: {
            color: v
          }
        },
        [`&${t}-borderless`]: {
          backgroundColor: "transparent !important",
          borderColor: "transparent !important",
          boxShadow: "none !important"
        },
        // ======================== Input =========================
        [`${t}-input`]: {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          width: "100%",
          "> input": D(D({}, $1(e)), {
            flex: "auto",
            // Fix Firefox flex not correct:
            // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
            minWidth: 1,
            height: "auto",
            padding: 0,
            background: "transparent",
            border: 0,
            "&:focus": {
              boxShadow: "none"
            },
            "&[disabled]": {
              background: "transparent"
            }
          }),
          "&:hover": {
            [`${t}-clear`]: {
              opacity: 1
            }
          },
          "&-placeholder": {
            "> input": {
              color: h
            }
          }
        },
        // Size
        "&-large": D(D({}, zy(e, m, y, i)), {
          [`${t}-input > input`]: {
            fontSize: y
          }
        }),
        "&-small": D({}, zy(e, x, o, g)),
        [`${t}-suffix`]: {
          display: "flex",
          flex: "none",
          alignSelf: "center",
          marginInlineStart: S / 2,
          color: v,
          lineHeight: 1,
          pointerEvents: "none",
          "> *": {
            verticalAlign: "top",
            "&:not(:last-child)": {
              marginInlineEnd: w
            }
          }
        },
        [`${t}-clear`]: {
          position: "absolute",
          top: "50%",
          insetInlineEnd: 0,
          color: v,
          lineHeight: 1,
          background: s,
          transform: "translateY(-50%)",
          cursor: "pointer",
          opacity: 0,
          transition: `opacity ${d}, color ${d}`,
          "> *": {
            verticalAlign: "top"
          },
          "&:hover": {
            color: _
          }
        },
        [`${t}-separator`]: {
          position: "relative",
          display: "inline-block",
          width: "1em",
          height: y,
          color: v,
          fontSize: y,
          verticalAlign: "top",
          cursor: "default",
          [`${t}-focused &`]: {
            color: _
          },
          [`${t}-range-separator &`]: {
            [`${t}-disabled &`]: {
              cursor: "not-allowed"
            }
          }
        },
        // ======================== Range =========================
        "&-range": {
          position: "relative",
          display: "inline-flex",
          // Clear
          [`${t}-clear`]: {
            insetInlineEnd: i
          },
          "&:hover": {
            [`${t}-clear`]: {
              opacity: 1
            }
          },
          // Active bar
          [`${t}-active-bar`]: {
            bottom: -l,
            height: b,
            marginInlineStart: i,
            background: C,
            opacity: 0,
            transition: `all ${T} ease-out`,
            pointerEvents: "none"
          },
          [`&${t}-focused`]: {
            [`${t}-active-bar`]: {
              opacity: 1
            }
          },
          [`${t}-range-separator`]: {
            alignItems: "center",
            padding: `0 ${S}px`,
            lineHeight: 1
          },
          [`&${t}-small`]: {
            [`${t}-clear`]: {
              insetInlineEnd: g
            },
            [`${t}-active-bar`]: {
              marginInlineStart: g
            }
          }
        },
        // ======================= Dropdown =======================
        "&-dropdown": D(D(D({}, gr(e)), goe(e)), {
          position: "absolute",
          // Fix incorrect position of picker popup
          // https://github.com/ant-design/ant-design/issues/35590
          top: -9999,
          left: {
            _skip_check_: !0,
            value: -9999
          },
          zIndex: O,
          [`&${t}-dropdown-hidden`]: {
            display: "none"
          },
          [`&${t}-dropdown-placement-bottomLeft`]: {
            [`${t}-range-arrow`]: {
              top: 0,
              display: "block",
              transform: "translateY(-100%)"
            }
          },
          [`&${t}-dropdown-placement-topLeft`]: {
            [`${t}-range-arrow`]: {
              bottom: 0,
              display: "block",
              transform: "translateY(100%) rotate(180deg)"
            }
          },
          [`&${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-topLeft,
          &${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-topRight,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-topLeft,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-topRight`]: {
            animationName: m1
          },
          [`&${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-bottomLeft,
          &${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-bottomRight,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-bottomLeft,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-bottomRight`]: {
            animationName: h1
          },
          [`&${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-topLeft,
          &${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-topRight`]: {
            animationName: g1
          },
          [`&${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-bottomLeft,
          &${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-bottomRight`]: {
            animationName: v1
          },
          // Time picker with additional style
          [`${t}-panel > ${t}-time-panel`]: {
            paddingTop: I
          },
          // ======================== Ranges ========================
          [`${t}-ranges`]: {
            marginBottom: 0,
            padding: `${I}px ${k}px`,
            overflow: "hidden",
            lineHeight: `${B - 2 * l - S / 2}px`,
            textAlign: "start",
            listStyle: "none",
            display: "flex",
            justifyContent: "space-between",
            "> li": {
              display: "inline-block"
            },
            // https://github.com/ant-design/ant-design/issues/23687
            [`${t}-preset > ${n}-tag-blue`]: {
              color: C,
              background: P,
              borderColor: N,
              cursor: "pointer"
            },
            [`${t}-ok`]: {
              marginInlineStart: "auto"
            }
          },
          [`${t}-range-wrapper`]: {
            display: "flex",
            position: "relative"
          },
          [`${t}-range-arrow`]: D({
            position: "absolute",
            zIndex: 1,
            display: "none",
            marginInlineStart: i * 1.5,
            transition: `left ${T} ease-out`
          }, Y_(M, H, R, z, r)),
          [`${t}-panel-container`]: {
            overflow: "hidden",
            verticalAlign: "top",
            background: z,
            borderRadius: W,
            boxShadow: F,
            transition: `margin ${T}`,
            // ======================== Layout ========================
            [`${t}-panel-layout`]: {
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "stretch"
            },
            // ======================== Preset ========================
            [`${t}-presets`]: {
              display: "flex",
              flexDirection: "column",
              minWidth: Q,
              maxWidth: ue,
              ul: {
                height: 0,
                flex: "auto",
                listStyle: "none",
                overflow: "auto",
                margin: 0,
                padding: S,
                borderInlineEnd: `${l}px ${u} ${X}`,
                li: D(D({}, op), {
                  borderRadius: Y,
                  paddingInline: S,
                  paddingBlock: (x - Math.round(o * E)) / 2,
                  cursor: "pointer",
                  transition: `all ${T}`,
                  "+ li": {
                    marginTop: w
                  },
                  "&:hover": {
                    background: q
                  }
                })
              }
            },
            // ======================== Panels ========================
            [`${t}-panels`]: {
              display: "inline-flex",
              flexWrap: "nowrap",
              direction: "ltr",
              [`${t}-panel`]: {
                borderWidth: `0 0 ${l}px`
              },
              "&:last-child": {
                [`${t}-panel`]: {
                  borderWidth: 0
                }
              }
            },
            [`${t}-panel`]: {
              verticalAlign: "top",
              background: "transparent",
              borderRadius: 0,
              borderWidth: 0,
              [`${t}-content,
            table`]: {
                textAlign: "center"
              },
              "&-focused": {
                borderColor: c
              }
            }
          }
        }),
        "&-dropdown-range": {
          padding: `${M * 2 / 3}px 0`,
          "&-hidden": {
            display: "none"
          }
        },
        "&-rtl": {
          direction: "rtl",
          [`${t}-separator`]: {
            transform: "rotate(180deg)"
          },
          [`${t}-footer`]: {
            "&-extra": {
              direction: "rtl"
            }
          }
        }
      })
    },
    // Follow code may reuse in other components
    nu(e, "slide-up"),
    nu(e, "slide-down"),
    Xf(e, "move-up"),
    Xf(e, "move-down")
  ];
}, boe = (e) => {
  const {
    componentCls: n,
    controlHeightLG: r,
    controlHeightSM: a,
    colorPrimary: o,
    paddingXXS: i
  } = e;
  return {
    pickerCellCls: `${n}-cell`,
    pickerCellInnerCls: `${n}-cell-inner`,
    pickerTextHeight: r,
    pickerPanelCellWidth: a * 1.5,
    pickerPanelCellHeight: a,
    pickerDateHoverRangeBorderColor: new ir(o).lighten(20).toHexString(),
    pickerBasicCellHoverWithRangeColor: new ir(o).lighten(35).toHexString(),
    pickerPanelWithoutTimeCellHeight: r * 1.65,
    pickerYearMonthCellWidth: r * 1.5,
    pickerTimePanelColumnHeight: 28 * 8,
    pickerTimePanelColumnWidth: r * 1.4,
    pickerTimePanelCellHeight: 28,
    pickerQuarterPanelContentHeight: r * 1.4,
    pickerCellPaddingVertical: i,
    pickerCellBorderGap: 2,
    pickerControlIconSize: 7,
    pickerControlIconBorderWidth: 1.5
  };
}, Rk = xr("DatePicker", (e) => {
  const t = xn(c4(e), boe(e));
  return [
    xoe(t),
    yoe(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    x1(e, {
      focusElCls: `${e.componentCls}-focused`
    })
  ];
}, (e) => ({
  presetsWidth: 120,
  presetsMaxWidth: 200,
  zIndexPopup: e.zIndexPopupBase + 50
})), woe = () => ({
  prefixCls: String,
  width: {
    type: [Number, String]
  }
}), d4 = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "SkeletonTitle",
  props: woe(),
  setup(e) {
    return () => {
      const {
        prefixCls: t,
        width: n
      } = e, r = typeof n == "number" ? `${n}px` : n;
      return A("h3", {
        class: t,
        style: {
          width: r
        }
      }, null);
    };
  }
}), Soe = () => ({
  prefixCls: String,
  width: {
    type: [Number, String, Array]
  },
  rows: Number
}), _oe = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "SkeletonParagraph",
  props: Soe(),
  setup(e) {
    const t = (n) => {
      const {
        width: r,
        rows: a = 2
      } = e;
      if (Array.isArray(r))
        return r[n];
      if (a - 1 === n)
        return r;
    };
    return () => {
      const {
        prefixCls: n,
        rows: r
      } = e, a = [...Array(r)].map((o, i) => {
        const s = t(i);
        return A("li", {
          key: i,
          style: {
            width: typeof s == "number" ? `${s}px` : s
          }
        }, null);
      });
      return A("ul", {
        class: n
      }, [a]);
    };
  }
}), O1 = () => ({
  prefixCls: String,
  size: [String, Number],
  shape: String,
  active: {
    type: Boolean,
    default: void 0
  }
}), Nk = (e) => {
  const {
    prefixCls: t,
    size: n,
    shape: r
  } = e, a = Ge({
    [`${t}-lg`]: n === "large",
    [`${t}-sm`]: n === "small"
  }), o = Ge({
    [`${t}-circle`]: r === "circle",
    [`${t}-square`]: r === "square",
    [`${t}-round`]: r === "round"
  }), i = typeof n == "number" ? {
    width: `${n}px`,
    height: `${n}px`,
    lineHeight: `${n}px`
  } : {};
  return A("span", {
    class: Ge(t, a, o),
    style: i
  }, null);
};
Nk.displayName = "SkeletonElement";
const A1 = Nk, Coe = new rn("ant-skeleton-loading", {
  "0%": {
    transform: "translateX(-37.5%)"
  },
  "100%": {
    transform: "translateX(37.5%)"
  }
}), I1 = (e) => ({
  height: e,
  lineHeight: `${e}px`
}), Of = (e) => D({
  width: e
}, I1(e)), Eoe = (e) => ({
  position: "relative",
  // fix https://github.com/ant-design/ant-design/issues/36444
  // https://monshin.github.io/202109/css/safari-border-radius-overflow-hidden/
  /* stylelint-disable-next-line property-no-vendor-prefix,value-no-vendor-prefix */
  zIndex: 0,
  overflow: "hidden",
  background: "transparent",
  "&::after": {
    position: "absolute",
    top: 0,
    insetInlineEnd: "-150%",
    bottom: 0,
    insetInlineStart: "-150%",
    background: e.skeletonLoadingBackground,
    animationName: Coe,
    animationDuration: e.skeletonLoadingMotionDuration,
    animationTimingFunction: "ease",
    animationIterationCount: "infinite",
    content: '""'
  }
}), Wy = (e) => D({
  width: e * 5,
  minWidth: e * 5
}, I1(e)), Toe = (e) => {
  const {
    skeletonAvatarCls: t,
    color: n,
    controlHeight: r,
    controlHeightLG: a,
    controlHeightSM: o
  } = e;
  return {
    [`${t}`]: D({
      display: "inline-block",
      verticalAlign: "top",
      background: n
    }, Of(r)),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    },
    [`${t}${t}-lg`]: D({}, Of(a)),
    [`${t}${t}-sm`]: D({}, Of(o))
  };
}, $oe = (e) => {
  const {
    controlHeight: t,
    borderRadiusSM: n,
    skeletonInputCls: r,
    controlHeightLG: a,
    controlHeightSM: o,
    color: i
  } = e;
  return {
    [`${r}`]: D({
      display: "inline-block",
      verticalAlign: "top",
      background: i,
      borderRadius: n
    }, Wy(t)),
    [`${r}-lg`]: D({}, Wy(a)),
    [`${r}-sm`]: D({}, Wy(o))
  };
}, C5 = (e) => D({
  width: e
}, I1(e)), Ooe = (e) => {
  const {
    skeletonImageCls: t,
    imageSizeBase: n,
    color: r,
    borderRadiusSM: a
  } = e;
  return {
    [`${t}`]: D(D({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "top",
      background: r,
      borderRadius: a
    }, C5(n * 2)), {
      [`${t}-path`]: {
        fill: "#bfbfbf"
      },
      [`${t}-svg`]: D(D({}, C5(n)), {
        maxWidth: n * 4,
        maxHeight: n * 4
      }),
      [`${t}-svg${t}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    }
  };
}, Gy = (e, t, n) => {
  const {
    skeletonButtonCls: r
  } = e;
  return {
    [`${n}${r}-circle`]: {
      width: t,
      minWidth: t,
      borderRadius: "50%"
    },
    [`${n}${r}-round`]: {
      borderRadius: t
    }
  };
}, Ky = (e) => D({
  width: e * 2,
  minWidth: e * 2
}, I1(e)), Aoe = (e) => {
  const {
    borderRadiusSM: t,
    skeletonButtonCls: n,
    controlHeight: r,
    controlHeightLG: a,
    controlHeightSM: o,
    color: i
  } = e;
  return D(D(D(D(D({
    [`${n}`]: D({
      display: "inline-block",
      verticalAlign: "top",
      background: i,
      borderRadius: t,
      width: r * 2,
      minWidth: r * 2
    }, Ky(r))
  }, Gy(e, r, n)), {
    [`${n}-lg`]: D({}, Ky(a))
  }), Gy(e, a, `${n}-lg`)), {
    [`${n}-sm`]: D({}, Ky(o))
  }), Gy(e, o, `${n}-sm`));
}, Ioe = (e) => {
  const {
    componentCls: t,
    skeletonAvatarCls: n,
    skeletonTitleCls: r,
    skeletonParagraphCls: a,
    skeletonButtonCls: o,
    skeletonInputCls: i,
    skeletonImageCls: s,
    controlHeight: l,
    controlHeightLG: u,
    controlHeightSM: c,
    color: f,
    padding: d,
    marginSM: p,
    borderRadius: v,
    skeletonTitleHeight: h,
    skeletonBlockRadius: m,
    skeletonParagraphLineHeight: y,
    controlHeightXS: x,
    skeletonParagraphMarginTop: g
  } = e;
  return {
    [`${t}`]: {
      display: "table",
      width: "100%",
      [`${t}-header`]: {
        display: "table-cell",
        paddingInlineEnd: d,
        verticalAlign: "top",
        // Avatar
        [`${n}`]: D({
          display: "inline-block",
          verticalAlign: "top",
          background: f
        }, Of(l)),
        [`${n}-circle`]: {
          borderRadius: "50%"
        },
        [`${n}-lg`]: D({}, Of(u)),
        [`${n}-sm`]: D({}, Of(c))
      },
      [`${t}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [`${r}`]: {
          width: "100%",
          height: h,
          background: f,
          borderRadius: m,
          [`+ ${a}`]: {
            marginBlockStart: c
          }
        },
        // paragraph
        [`${a}`]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: y,
            listStyle: "none",
            background: f,
            borderRadius: m,
            "+ li": {
              marginBlockStart: x
            }
          }
        },
        [`${a}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${t}-content`]: {
        [`${r}, ${a} > li`]: {
          borderRadius: v
        }
      }
    },
    [`${t}-with-avatar ${t}-content`]: {
      // Title
      [`${r}`]: {
        marginBlockStart: p,
        [`+ ${a}`]: {
          marginBlockStart: g
        }
      }
    },
    // Skeleton element
    [`${t}${t}-element`]: D(D(D(D({
      display: "inline-block",
      width: "auto"
    }, Aoe(e)), Toe(e)), $oe(e)), Ooe(e)),
    // Skeleton Block Button, Input
    [`${t}${t}-block`]: {
      width: "100%",
      [`${o}`]: {
        width: "100%"
      },
      [`${i}`]: {
        width: "100%"
      }
    },
    // With active animation
    [`${t}${t}-active`]: {
      [`
        ${r},
        ${a} > li,
        ${n},
        ${o},
        ${i},
        ${s}
      `]: D({}, Eoe(e))
    }
  };
}, Yp = xr("Skeleton", (e) => {
  const {
    componentCls: t
  } = e, n = xn(e, {
    skeletonAvatarCls: `${t}-avatar`,
    skeletonTitleCls: `${t}-title`,
    skeletonParagraphCls: `${t}-paragraph`,
    skeletonButtonCls: `${t}-button`,
    skeletonInputCls: `${t}-input`,
    skeletonImageCls: `${t}-image`,
    imageSizeBase: e.controlHeight * 1.5,
    skeletonTitleHeight: e.controlHeight / 2,
    skeletonBlockRadius: e.borderRadiusSM,
    skeletonParagraphLineHeight: e.controlHeight / 2,
    skeletonParagraphMarginTop: e.marginLG + e.marginXXS,
    borderRadius: 100,
    skeletonLoadingBackground: `linear-gradient(90deg, ${e.color} 25%, ${e.colorGradientEnd} 37%, ${e.color} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return [Ioe(n)];
}, (e) => {
  const {
    colorFillContent: t,
    colorFill: n
  } = e;
  return {
    color: t,
    colorGradientEnd: n
  };
}), Poe = () => ({
  active: {
    type: Boolean,
    default: void 0
  },
  loading: {
    type: Boolean,
    default: void 0
  },
  prefixCls: String,
  avatar: {
    type: [Boolean, Object],
    default: void 0
  },
  title: {
    type: [Boolean, Object],
    default: void 0
  },
  paragraph: {
    type: [Boolean, Object],
    default: void 0
  },
  round: {
    type: Boolean,
    default: void 0
  }
});
function Yy(e) {
  return e && typeof e == "object" ? e : {};
}
function Doe(e, t) {
  return e && !t ? {
    size: "large",
    shape: "square"
  } : {
    size: "large",
    shape: "circle"
  };
}
function koe(e, t) {
  return !e && t ? {
    width: "38%"
  } : e && t ? {
    width: "50%"
  } : {};
}
function Moe(e, t) {
  const n = {};
  return (!e || !t) && (n.width = "61%"), !e && t ? n.rows = 3 : n.rows = 2, n;
}
const oo = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ASkeleton",
  props: ha(Poe(), {
    avatar: !1,
    title: !0,
    paragraph: !0
  }),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      prefixCls: r,
      direction: a
    } = mn("skeleton", e), [o, i] = Yp(r);
    return () => {
      var s;
      const {
        loading: l,
        avatar: u,
        title: c,
        paragraph: f,
        active: d,
        round: p
      } = e, v = r.value;
      if (l || e.loading === void 0) {
        const h = !!u || u === "", m = !!c || c === "", y = !!f || f === "";
        let x;
        if (h) {
          const w = D(D({
            prefixCls: `${v}-avatar`
          }, Doe(m, y)), Yy(u));
          x = A("div", {
            class: `${v}-header`
          }, [A(A1, w, null)]);
        }
        let g;
        if (m || y) {
          let w;
          if (m) {
            const b = D(D({
              prefixCls: `${v}-title`
            }, koe(h, y)), Yy(c));
            w = A(d4, b, null);
          }
          let _;
          if (y) {
            const b = D(D({
              prefixCls: `${v}-paragraph`
            }, Moe(h, m)), Yy(f));
            _ = A(_oe, b, null);
          }
          g = A("div", {
            class: `${v}-content`
          }, [w, _]);
        }
        const S = Ge(v, {
          [`${v}-with-avatar`]: h,
          [`${v}-active`]: d,
          [`${v}-rtl`]: a.value === "rtl",
          [`${v}-round`]: p,
          [i.value]: !0
        });
        return o(A("div", {
          class: S
        }, [x, g]));
      }
      return (s = n.default) === null || s === void 0 ? void 0 : s.call(n);
    };
  }
}), Roe = () => D(D({}, O1()), {
  size: String,
  block: Boolean
}), Fk = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ASkeletonButton",
  props: ha(Roe(), {
    size: "default"
  }),
  setup(e) {
    const {
      prefixCls: t
    } = mn("skeleton", e), [n, r] = Yp(t), a = V(() => Ge(t.value, `${t.value}-element`, {
      [`${t.value}-active`]: e.active,
      [`${t.value}-block`]: e.block
    }, r.value));
    return () => n(A("div", {
      class: a.value
    }, [A(A1, ve(ve({}, e), {}, {
      prefixCls: `${t.value}-button`
    }), null)]));
  }
}), p4 = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ASkeletonInput",
  props: D(D({}, Lr(O1(), ["shape"])), {
    size: String,
    block: Boolean
  }),
  setup(e) {
    const {
      prefixCls: t
    } = mn("skeleton", e), [n, r] = Yp(t), a = V(() => Ge(t.value, `${t.value}-element`, {
      [`${t.value}-active`]: e.active,
      [`${t.value}-block`]: e.block
    }, r.value));
    return () => n(A("div", {
      class: a.value
    }, [A(A1, ve(ve({}, e), {}, {
      prefixCls: `${t.value}-input`
    }), null)]));
  }
}), Noe = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z", Lk = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ASkeletonImage",
  props: Lr(O1(), ["size", "shape", "active"]),
  setup(e) {
    const {
      prefixCls: t
    } = mn("skeleton", e), [n, r] = Yp(t), a = V(() => Ge(t.value, `${t.value}-element`, r.value));
    return () => n(A("div", {
      class: a.value
    }, [A("div", {
      class: `${t.value}-image`
    }, [A("svg", {
      viewBox: "0 0 1098 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: `${t.value}-image-svg`
    }, [A("path", {
      d: Noe,
      class: `${t.value}-image-path`
    }, null)])])]));
  }
}), Foe = () => D(D({}, O1()), {
  shape: String
}), Bk = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ASkeletonAvatar",
  props: ha(Foe(), {
    size: "default",
    shape: "circle"
  }),
  setup(e) {
    const {
      prefixCls: t
    } = mn("skeleton", e), [n, r] = Yp(t), a = V(() => Ge(t.value, `${t.value}-element`, {
      [`${t.value}-active`]: e.active
    }, r.value));
    return () => n(A("div", {
      class: a.value
    }, [A(A1, ve(ve({}, e), {}, {
      prefixCls: `${t.value}-avatar`
    }), null)]));
  }
});
oo.Button = Fk;
oo.Avatar = Bk;
oo.Input = p4;
oo.Image = Lk;
oo.Title = d4;
oo.install = function(e) {
  return e.component(oo.name, oo), e.component(oo.Button.name, Fk), e.component(oo.Avatar.name, Bk), e.component(oo.Input.name, p4), e.component(oo.Image.name, Lk), e.component(oo.Title.name, d4), e;
};
var Loe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" };
function E5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      Boe(e, a, n[a]);
    });
  }
  return e;
}
function Boe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Nm = function(t, n) {
  var r = E5({}, t, n.attrs);
  return A(Bn, E5({}, r, {
    icon: Loe
  }), null);
};
Nm.displayName = "LeftOutlined";
Nm.inheritAttrs = !1;
const Hk = () => li() && window.document.documentElement;
let qh;
const Hoe = () => {
  if (!Hk())
    return !1;
  if (qh !== void 0)
    return qh;
  const e = document.createElement("div");
  return e.style.display = "flex", e.style.flexDirection = "column", e.style.rowGap = "1px", e.appendChild(document.createElement("div")), e.appendChild(document.createElement("div")), document.body.appendChild(e), qh = e.scrollHeight === 1, document.body.removeChild(e), qh;
}, joe = () => {
  const e = Be(!1);
  return Lt(() => {
    e.value = Hoe();
  }), e;
}, jk = Symbol("rowContextKey"), Voe = (e) => {
  kt(jk, e);
}, Uoe = () => Ke(jk, {
  gutter: V(() => {
  }),
  wrap: V(() => {
  }),
  supportFlexGap: V(() => {
  })
}), zoe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      display: "flex",
      flexFlow: "row wrap",
      minWidth: 0,
      "&::before, &::after": {
        display: "flex"
      },
      "&-no-wrap": {
        flexWrap: "nowrap"
      },
      // The origin of the X-axis
      "&-start": {
        justifyContent: "flex-start"
      },
      // The center of the X-axis
      "&-center": {
        justifyContent: "center"
      },
      // The opposite of the X-axis
      "&-end": {
        justifyContent: "flex-end"
      },
      "&-space-between": {
        justifyContent: "space-between"
      },
      "&-space-around ": {
        justifyContent: "space-around"
      },
      // Align at the top
      "&-top": {
        alignItems: "flex-start"
      },
      // Align at the center
      "&-middle": {
        alignItems: "center"
      },
      "&-bottom": {
        alignItems: "flex-end"
      }
    }
  };
}, Woe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      position: "relative",
      maxWidth: "100%",
      // Prevent columns from collapsing when empty
      minHeight: 1
    }
  };
}, Goe = (e, t) => {
  const {
    componentCls: n,
    gridColumns: r
  } = e, a = {};
  for (let o = r; o >= 0; o--)
    o === 0 ? (a[`${n}${t}-${o}`] = {
      display: "none"
    }, a[`${n}-push-${o}`] = {
      insetInlineStart: "auto"
    }, a[`${n}-pull-${o}`] = {
      insetInlineEnd: "auto"
    }, a[`${n}${t}-push-${o}`] = {
      insetInlineStart: "auto"
    }, a[`${n}${t}-pull-${o}`] = {
      insetInlineEnd: "auto"
    }, a[`${n}${t}-offset-${o}`] = {
      marginInlineEnd: 0
    }, a[`${n}${t}-order-${o}`] = {
      order: 0
    }) : (a[`${n}${t}-${o}`] = {
      display: "block",
      flex: `0 0 ${o / r * 100}%`,
      maxWidth: `${o / r * 100}%`
    }, a[`${n}${t}-push-${o}`] = {
      insetInlineStart: `${o / r * 100}%`
    }, a[`${n}${t}-pull-${o}`] = {
      insetInlineEnd: `${o / r * 100}%`
    }, a[`${n}${t}-offset-${o}`] = {
      marginInlineStart: `${o / r * 100}%`
    }, a[`${n}${t}-order-${o}`] = {
      order: o
    });
  return a;
}, x2 = (e, t) => Goe(e, t), Koe = (e, t, n) => ({
  [`@media (min-width: ${t}px)`]: D({}, x2(e, n))
}), Yoe = xr("Grid", (e) => [zoe(e)]), qoe = xr("Grid", (e) => {
  const t = xn(e, {
    gridColumns: 24
    // Row is divided into 24 parts in Grid
  }), n = {
    "-sm": t.screenSMMin,
    "-md": t.screenMDMin,
    "-lg": t.screenLGMin,
    "-xl": t.screenXLMin,
    "-xxl": t.screenXXLMin
  };
  return [Woe(t), x2(t, ""), x2(t, "-xs"), Object.keys(n).map((r) => Koe(t, n[r], r)).reduce((r, a) => D(D({}, r), a), {})];
}), Xoe = () => ({
  align: ca([String, Object]),
  justify: ca([String, Object]),
  prefixCls: String,
  gutter: ca([Number, Array, Object], 0),
  wrap: {
    type: Boolean,
    default: void 0
  }
}), Zoe = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ARow",
  inheritAttrs: !1,
  props: Xoe(),
  setup(e, t) {
    let {
      slots: n,
      attrs: r
    } = t;
    const {
      prefixCls: a,
      direction: o
    } = mn("row", e), [i, s] = Yoe(a);
    let l;
    const u = AD(), c = ne({
      xs: !0,
      sm: !0,
      md: !0,
      lg: !0,
      xl: !0,
      xxl: !0
    }), f = ne({
      xs: !1,
      sm: !1,
      md: !1,
      lg: !1,
      xl: !1,
      xxl: !1
    }), d = (g) => V(() => {
      if (typeof e[g] == "string")
        return e[g];
      if (typeof e[g] != "object")
        return "";
      for (let S = 0; S < Hh.length; S++) {
        const w = Hh[S];
        if (!f.value[w]) continue;
        const _ = e[g][w];
        if (_ !== void 0)
          return _;
      }
      return "";
    }), p = d("align"), v = d("justify"), h = joe();
    Lt(() => {
      l = u.value.subscribe((g) => {
        f.value = g;
        const S = e.gutter || 0;
        (!Array.isArray(S) && typeof S == "object" || Array.isArray(S) && (typeof S[0] == "object" || typeof S[1] == "object")) && (c.value = g);
      });
    }), Sn(() => {
      u.value.unsubscribe(l);
    });
    const m = V(() => {
      const g = [void 0, void 0], {
        gutter: S = 0
      } = e;
      return (Array.isArray(S) ? S : [S, void 0]).forEach((_, b) => {
        if (typeof _ == "object")
          for (let E = 0; E < Hh.length; E++) {
            const C = Hh[E];
            if (c.value[C] && _[C] !== void 0) {
              g[b] = _[C];
              break;
            }
          }
        else
          g[b] = _;
      }), g;
    });
    Voe({
      gutter: m,
      supportFlexGap: h,
      wrap: V(() => e.wrap)
    });
    const y = V(() => Ge(a.value, {
      [`${a.value}-no-wrap`]: e.wrap === !1,
      [`${a.value}-${v.value}`]: v.value,
      [`${a.value}-${p.value}`]: p.value,
      [`${a.value}-rtl`]: o.value === "rtl"
    }, r.class, s.value)), x = V(() => {
      const g = m.value, S = {}, w = g[0] != null && g[0] > 0 ? `${g[0] / -2}px` : void 0, _ = g[1] != null && g[1] > 0 ? `${g[1] / -2}px` : void 0;
      return w && (S.marginLeft = w, S.marginRight = w), h.value ? S.rowGap = `${g[1]}px` : _ && (S.marginTop = _, S.marginBottom = _), S;
    });
    return () => {
      var g;
      return i(A("div", ve(ve({}, r), {}, {
        class: y.value,
        style: D(D({}, x.value), r.style)
      }), [(g = n.default) === null || g === void 0 ? void 0 : g.call(n)]));
    };
  }
});
function Nu() {
  return Nu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nu.apply(this, arguments);
}
function Qoe(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, hp(e, t);
}
function b2(e) {
  return b2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, b2(e);
}
function hp(e, t) {
  return hp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, hp(e, t);
}
function Joe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Hv(e, t, n) {
  return Joe() ? Hv = Reflect.construct.bind() : Hv = function(a, o, i) {
    var s = [null];
    s.push.apply(s, o);
    var l = Function.bind.apply(a, s), u = new l();
    return i && hp(u, i.prototype), u;
  }, Hv.apply(null, arguments);
}
function eie(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function w2(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return w2 = function(r) {
    if (r === null || !eie(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r)) return t.get(r);
      t.set(r, a);
    }
    function a() {
      return Hv(r, arguments, b2(this).constructor);
    }
    return a.prototype = Object.create(r.prototype, {
      constructor: {
        value: a,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), hp(a, r);
  }, w2(e);
}
var tie = /%[sdj%]/g, Vk = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (Vk = function(t, n) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && n.every(function(r) {
    return typeof r == "string";
  }) && console.warn(t, n);
});
function S2(e) {
  if (!e || !e.length) return null;
  var t = {};
  return e.forEach(function(n) {
    var r = n.field;
    t[r] = t[r] || [], t[r].push(n);
  }), t;
}
function Mo(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var a = 0, o = n.length;
  if (typeof e == "function")
    return e.apply(null, n);
  if (typeof e == "string") {
    var i = e.replace(tie, function(s) {
      if (s === "%%")
        return "%";
      if (a >= o)
        return s;
      switch (s) {
        case "%s":
          return String(n[a++]);
        case "%d":
          return Number(n[a++]);
        case "%j":
          try {
            return JSON.stringify(n[a++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return s;
      }
    });
    return i;
  }
  return e;
}
function nie(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function Br(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || nie(t) && typeof e == "string" && !e);
}
function rie(e, t, n) {
  var r = [], a = 0, o = e.length;
  function i(s) {
    r.push.apply(r, s || []), a++, a === o && n(r);
  }
  e.forEach(function(s) {
    t(s, i);
  });
}
function T5(e, t, n) {
  var r = 0, a = e.length;
  function o(i) {
    if (i && i.length) {
      n(i);
      return;
    }
    var s = r;
    r = r + 1, s < a ? t(e[s], o) : n([]);
  }
  o([]);
}
function aie(e) {
  var t = [];
  return Object.keys(e).forEach(function(n) {
    t.push.apply(t, e[n] || []);
  }), t;
}
var $5 = /* @__PURE__ */ function(e) {
  Qoe(t, e);
  function t(n, r) {
    var a;
    return a = e.call(this, "Async Validation Error") || this, a.errors = n, a.fields = r, a;
  }
  return t;
}(/* @__PURE__ */ w2(Error));
function oie(e, t, n, r, a) {
  if (t.first) {
    var o = new Promise(function(d, p) {
      var v = function(y) {
        return r(y), y.length ? p(new $5(y, S2(y))) : d(a);
      }, h = aie(e);
      T5(h, n, v);
    });
    return o.catch(function(d) {
      return d;
    }), o;
  }
  var i = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], s = Object.keys(e), l = s.length, u = 0, c = [], f = new Promise(function(d, p) {
    var v = function(m) {
      if (c.push.apply(c, m), u++, u === l)
        return r(c), c.length ? p(new $5(c, S2(c))) : d(a);
    };
    s.length || (r(c), d(a)), s.forEach(function(h) {
      var m = e[h];
      i.indexOf(h) !== -1 ? T5(m, n, v) : rie(m, n, v);
    });
  });
  return f.catch(function(d) {
    return d;
  }), f;
}
function iie(e) {
  return !!(e && e.message !== void 0);
}
function sie(e, t) {
  for (var n = e, r = 0; r < t.length; r++) {
    if (n == null)
      return n;
    n = n[t[r]];
  }
  return n;
}
function O5(e, t) {
  return function(n) {
    var r;
    return e.fullFields ? r = sie(t, e.fullFields) : r = t[n.field || e.fullField], iie(n) ? (n.field = n.field || e.fullField, n.fieldValue = r, n) : {
      message: typeof n == "function" ? n() : n,
      fieldValue: r,
      field: n.field || e.fullField
    };
  };
}
function A5(e, t) {
  if (t) {
    for (var n in t)
      if (t.hasOwnProperty(n)) {
        var r = t[n];
        typeof r == "object" && typeof e[n] == "object" ? e[n] = Nu({}, e[n], r) : e[n] = r;
      }
  }
  return e;
}
var Uk = function(t, n, r, a, o, i) {
  t.required && (!r.hasOwnProperty(t.field) || Br(n, i || t.type)) && a.push(Mo(o.messages.required, t.fullField));
}, lie = function(t, n, r, a, o) {
  (/^\s+$/.test(n) || n === "") && a.push(Mo(o.messages.whitespace, t.fullField));
}, Xh, uie = function() {
  if (Xh)
    return Xh;
  var e = "[a-fA-F\\d:]", t = function(S) {
    return S && S.includeBoundaries ? "(?:(?<=\\s|^)(?=" + e + ")|(?<=" + e + ")(?=\\s|$))" : "";
  }, n = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", r = "[a-fA-F\\d]{1,4}", a = (`
(?:
(?:` + r + ":){7}(?:" + r + `|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:` + r + ":){6}(?:" + n + "|:" + r + `|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:` + r + ":){5}(?::" + n + "|(?::" + r + `){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:` + r + ":){4}(?:(?::" + r + "){0,1}:" + n + "|(?::" + r + `){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:` + r + ":){3}(?:(?::" + r + "){0,2}:" + n + "|(?::" + r + `){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:` + r + ":){2}(?:(?::" + r + "){0,3}:" + n + "|(?::" + r + `){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:` + r + ":){1}(?:(?::" + r + "){0,4}:" + n + "|(?::" + r + `){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::` + r + "){0,5}:" + n + "|(?::" + r + `){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`).replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), o = new RegExp("(?:^" + n + "$)|(?:^" + a + "$)"), i = new RegExp("^" + n + "$"), s = new RegExp("^" + a + "$"), l = function(S) {
    return S && S.exact ? o : new RegExp("(?:" + t(S) + n + t(S) + ")|(?:" + t(S) + a + t(S) + ")", "g");
  };
  l.v4 = function(g) {
    return g && g.exact ? i : new RegExp("" + t(g) + n + t(g), "g");
  }, l.v6 = function(g) {
    return g && g.exact ? s : new RegExp("" + t(g) + a + t(g), "g");
  };
  var u = "(?:(?:[a-z]+:)?//)", c = "(?:\\S+(?::\\S*)?@)?", f = l.v4().source, d = l.v6().source, p = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", v = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", h = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", m = "(?::\\d{2,5})?", y = '(?:[/?#][^\\s"]*)?', x = "(?:" + u + "|www\\.)" + c + "(?:localhost|" + f + "|" + d + "|" + p + v + h + ")" + m + y;
  return Xh = new RegExp("(?:^" + x + "$)", "i"), Xh;
}, I5 = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, t0 = {
  integer: function(t) {
    return t0.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return t0.number(t) && !t0.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return typeof t == "object" && !t0.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(I5.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(uie());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(I5.hex);
  }
}, cie = function(t, n, r, a, o) {
  if (t.required && n === void 0) {
    Uk(t, n, r, a, o);
    return;
  }
  var i = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], s = t.type;
  i.indexOf(s) > -1 ? t0[s](n) || a.push(Mo(o.messages.types[s], t.fullField, t.type)) : s && typeof n !== t.type && a.push(Mo(o.messages.types[s], t.fullField, t.type));
}, fie = function(t, n, r, a, o) {
  var i = typeof t.len == "number", s = typeof t.min == "number", l = typeof t.max == "number", u = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, c = n, f = null, d = typeof n == "number", p = typeof n == "string", v = Array.isArray(n);
  if (d ? f = "number" : p ? f = "string" : v && (f = "array"), !f)
    return !1;
  v && (c = n.length), p && (c = n.replace(u, "_").length), i ? c !== t.len && a.push(Mo(o.messages[f].len, t.fullField, t.len)) : s && !l && c < t.min ? a.push(Mo(o.messages[f].min, t.fullField, t.min)) : l && !s && c > t.max ? a.push(Mo(o.messages[f].max, t.fullField, t.max)) : s && l && (c < t.min || c > t.max) && a.push(Mo(o.messages[f].range, t.fullField, t.min, t.max));
}, qc = "enum", die = function(t, n, r, a, o) {
  t[qc] = Array.isArray(t[qc]) ? t[qc] : [], t[qc].indexOf(n) === -1 && a.push(Mo(o.messages[qc], t.fullField, t[qc].join(", ")));
}, pie = function(t, n, r, a, o) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(n) || a.push(Mo(o.messages.pattern.mismatch, t.fullField, n, t.pattern));
    else if (typeof t.pattern == "string") {
      var i = new RegExp(t.pattern);
      i.test(n) || a.push(Mo(o.messages.pattern.mismatch, t.fullField, n, t.pattern));
    }
  }
}, yn = {
  required: Uk,
  whitespace: lie,
  type: cie,
  range: fie,
  enum: die,
  pattern: pie
}, hie = function(t, n, r, a, o) {
  var i = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Br(n, "string") && !t.required)
      return r();
    yn.required(t, n, a, i, o, "string"), Br(n, "string") || (yn.type(t, n, a, i, o), yn.range(t, n, a, i, o), yn.pattern(t, n, a, i, o), t.whitespace === !0 && yn.whitespace(t, n, a, i, o));
  }
  r(i);
}, vie = function(t, n, r, a, o) {
  var i = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Br(n) && !t.required)
      return r();
    yn.required(t, n, a, i, o), n !== void 0 && yn.type(t, n, a, i, o);
  }
  r(i);
}, mie = function(t, n, r, a, o) {
  var i = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (n === "" && (n = void 0), Br(n) && !t.required)
      return r();
    yn.required(t, n, a, i, o), n !== void 0 && (yn.type(t, n, a, i, o), yn.range(t, n, a, i, o));
  }
  r(i);
}, gie = function(t, n, r, a, o) {
  var i = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Br(n) && !t.required)
      return r();
    yn.required(t, n, a, i, o), n !== void 0 && yn.type(t, n, a, i, o);
  }
  r(i);
}, yie = function(t, n, r, a, o) {
  var i = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Br(n) && !t.required)
      return r();
    yn.required(t, n, a, i, o), Br(n) || yn.type(t, n, a, i, o);
  }
  r(i);
}, xie = function(t, n, r, a, o) {
  var i = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Br(n) && !t.required)
      return r();
    yn.required(t, n, a, i, o), n !== void 0 && (yn.type(t, n, a, i, o), yn.range(t, n, a, i, o));
  }
  r(i);
}, bie = function(t, n, r, a, o) {
  var i = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Br(n) && !t.required)
      return r();
    yn.required(t, n, a, i, o), n !== void 0 && (yn.type(t, n, a, i, o), yn.range(t, n, a, i, o));
  }
  r(i);
}, wie = function(t, n, r, a, o) {
  var i = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (n == null && !t.required)
      return r();
    yn.required(t, n, a, i, o, "array"), n != null && (yn.type(t, n, a, i, o), yn.range(t, n, a, i, o));
  }
  r(i);
}, Sie = function(t, n, r, a, o) {
  var i = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Br(n) && !t.required)
      return r();
    yn.required(t, n, a, i, o), n !== void 0 && yn.type(t, n, a, i, o);
  }
  r(i);
}, _ie = "enum", Cie = function(t, n, r, a, o) {
  var i = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Br(n) && !t.required)
      return r();
    yn.required(t, n, a, i, o), n !== void 0 && yn[_ie](t, n, a, i, o);
  }
  r(i);
}, Eie = function(t, n, r, a, o) {
  var i = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Br(n, "string") && !t.required)
      return r();
    yn.required(t, n, a, i, o), Br(n, "string") || yn.pattern(t, n, a, i, o);
  }
  r(i);
}, Tie = function(t, n, r, a, o) {
  var i = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Br(n, "date") && !t.required)
      return r();
    if (yn.required(t, n, a, i, o), !Br(n, "date")) {
      var l;
      n instanceof Date ? l = n : l = new Date(n), yn.type(t, l, a, i, o), l && yn.range(t, l.getTime(), a, i, o);
    }
  }
  r(i);
}, $ie = function(t, n, r, a, o) {
  var i = [], s = Array.isArray(n) ? "array" : typeof n;
  yn.required(t, n, a, i, o, s), r(i);
}, qy = function(t, n, r, a, o) {
  var i = t.type, s = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if (Br(n, i) && !t.required)
      return r();
    yn.required(t, n, a, s, o, i), Br(n, i) || yn.type(t, n, a, s, o);
  }
  r(s);
}, Oie = function(t, n, r, a, o) {
  var i = [], s = t.required || !t.required && a.hasOwnProperty(t.field);
  if (s) {
    if (Br(n) && !t.required)
      return r();
    yn.required(t, n, a, i, o);
  }
  r(i);
}, C0 = {
  string: hie,
  method: vie,
  number: mie,
  boolean: gie,
  regexp: yie,
  integer: xie,
  float: bie,
  array: wie,
  object: Sie,
  enum: Cie,
  pattern: Eie,
  date: Tie,
  url: qy,
  hex: qy,
  email: qy,
  required: $ie,
  any: Oie
};
function _2() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var C2 = _2(), qp = /* @__PURE__ */ function() {
  function e(n) {
    this.rules = null, this._messages = C2, this.define(n);
  }
  var t = e.prototype;
  return t.define = function(r) {
    var a = this;
    if (!r)
      throw new Error("Cannot configure a schema with no rules");
    if (typeof r != "object" || Array.isArray(r))
      throw new Error("Rules must be an object");
    this.rules = {}, Object.keys(r).forEach(function(o) {
      var i = r[o];
      a.rules[o] = Array.isArray(i) ? i : [i];
    });
  }, t.messages = function(r) {
    return r && (this._messages = A5(_2(), r)), this._messages;
  }, t.validate = function(r, a, o) {
    var i = this;
    a === void 0 && (a = {}), o === void 0 && (o = function() {
    });
    var s = r, l = a, u = o;
    if (typeof l == "function" && (u = l, l = {}), !this.rules || Object.keys(this.rules).length === 0)
      return u && u(null, s), Promise.resolve(s);
    function c(h) {
      var m = [], y = {};
      function x(S) {
        if (Array.isArray(S)) {
          var w;
          m = (w = m).concat.apply(w, S);
        } else
          m.push(S);
      }
      for (var g = 0; g < h.length; g++)
        x(h[g]);
      m.length ? (y = S2(m), u(m, y)) : u(null, s);
    }
    if (l.messages) {
      var f = this.messages();
      f === C2 && (f = _2()), A5(f, l.messages), l.messages = f;
    } else
      l.messages = this.messages();
    var d = {}, p = l.keys || Object.keys(this.rules);
    p.forEach(function(h) {
      var m = i.rules[h], y = s[h];
      m.forEach(function(x) {
        var g = x;
        typeof g.transform == "function" && (s === r && (s = Nu({}, s)), y = s[h] = g.transform(y)), typeof g == "function" ? g = {
          validator: g
        } : g = Nu({}, g), g.validator = i.getValidationMethod(g), g.validator && (g.field = h, g.fullField = g.fullField || h, g.type = i.getType(g), d[h] = d[h] || [], d[h].push({
          rule: g,
          value: y,
          source: s,
          field: h
        }));
      });
    });
    var v = {};
    return oie(d, l, function(h, m) {
      var y = h.rule, x = (y.type === "object" || y.type === "array") && (typeof y.fields == "object" || typeof y.defaultField == "object");
      x = x && (y.required || !y.required && h.value), y.field = h.field;
      function g(_, b) {
        return Nu({}, b, {
          fullField: y.fullField + "." + _,
          fullFields: y.fullFields ? [].concat(y.fullFields, [_]) : [_]
        });
      }
      function S(_) {
        _ === void 0 && (_ = []);
        var b = Array.isArray(_) ? _ : [_];
        !l.suppressWarning && b.length && e.warning("async-validator:", b), b.length && y.message !== void 0 && (b = [].concat(y.message));
        var E = b.map(O5(y, s));
        if (l.first && E.length)
          return v[y.field] = 1, m(E);
        if (!x)
          m(E);
        else {
          if (y.required && !h.value)
            return y.message !== void 0 ? E = [].concat(y.message).map(O5(y, s)) : l.error && (E = [l.error(y, Mo(l.messages.required, y.field))]), m(E);
          var C = {};
          y.defaultField && Object.keys(h.value).map(function(I) {
            C[I] = y.defaultField;
          }), C = Nu({}, C, h.rule.fields);
          var T = {};
          Object.keys(C).forEach(function(I) {
            var k = C[I], B = Array.isArray(k) ? k : [k];
            T[I] = B.map(g.bind(null, I));
          });
          var O = new e(T);
          O.messages(l.messages), h.rule.options && (h.rule.options.messages = l.messages, h.rule.options.error = l.error), O.validate(h.value, h.rule.options || l, function(I) {
            var k = [];
            E && E.length && k.push.apply(k, E), I && I.length && k.push.apply(k, I), m(k.length ? k : null);
          });
        }
      }
      var w;
      if (y.asyncValidator)
        w = y.asyncValidator(y, h.value, S, h.source, l);
      else if (y.validator) {
        try {
          w = y.validator(y, h.value, S, h.source, l);
        } catch (_) {
          console.error == null || console.error(_), l.suppressValidatorError || setTimeout(function() {
            throw _;
          }, 0), S(_.message);
        }
        w === !0 ? S() : w === !1 ? S(typeof y.message == "function" ? y.message(y.fullField || y.field) : y.message || (y.fullField || y.field) + " fails") : w instanceof Array ? S(w) : w instanceof Error && S(w.message);
      }
      w && w.then && w.then(function() {
        return S();
      }, function(_) {
        return S(_);
      });
    }, function(h) {
      c(h);
    }, s);
  }, t.getType = function(r) {
    if (r.type === void 0 && r.pattern instanceof RegExp && (r.type = "pattern"), typeof r.validator != "function" && r.type && !C0.hasOwnProperty(r.type))
      throw new Error(Mo("Unknown rule type %s", r.type));
    return r.type || "string";
  }, t.getValidationMethod = function(r) {
    if (typeof r.validator == "function")
      return r.validator;
    var a = Object.keys(r), o = a.indexOf("message");
    return o !== -1 && a.splice(o, 1), a.length === 1 && a[0] === "required" ? C0.required : C0[this.getType(r)] || void 0;
  }, e;
}();
qp.register = function(t, n) {
  if (typeof n != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  C0[t] = n;
};
qp.warning = Vk;
qp.messages = C2;
qp.validators = C0;
function Gl(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function zk(e, t) {
  let n = e;
  for (let r = 0; r < t.length; r += 1) {
    if (n == null)
      return;
    n = n[t[r]];
  }
  return n;
}
function Wk(e, t, n, r) {
  if (!t.length)
    return n;
  const [a, ...o] = t;
  let i;
  return !e && typeof a == "number" ? i = [] : Array.isArray(e) ? i = [...e] : i = D({}, e), r && n === void 0 && o.length === 1 ? delete i[a][o[0]] : i[a] = Wk(i[a], o, n, r), i;
}
function Aie(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && r && n === void 0 && !zk(e, t.slice(0, -1)) ? e : Wk(e, t, n, r);
}
function E2(e) {
  return Gl(e);
}
function Iie(e, t) {
  return zk(e, t);
}
function Pie(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return Aie(e, t, n, r);
}
function Die(e, t) {
  return e && e.some((n) => Mie(n, t));
}
function P5(e) {
  return typeof e == "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function Gk(e, t) {
  const n = Array.isArray(e) ? [...e] : D({}, e);
  return t && Object.keys(t).forEach((r) => {
    const a = n[r], o = t[r], i = P5(a) && P5(o);
    n[r] = i ? Gk(a, o || {}) : o;
  }), n;
}
function kie(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return n.reduce((a, o) => Gk(a, o), e);
}
function D5(e, t) {
  let n = {};
  return t.forEach((r) => {
    const a = Iie(e, r);
    n = Pie(n, r, a);
  }), n;
}
function Mie(e, t) {
  return !e || !t || e.length !== t.length ? !1 : e.every((n, r) => t[r] === n);
}
const yo = "'${name}' is not a valid ${type}", P1 = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: yo,
    method: yo,
    array: yo,
    object: yo,
    number: yo,
    date: yo,
    boolean: yo,
    integer: yo,
    float: yo,
    regexp: yo,
    email: yo,
    url: yo,
    hex: yo
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
};
var D1 = function(e, t, n, r) {
  function a(o) {
    return o instanceof n ? o : new n(function(i) {
      i(o);
    });
  }
  return new (n || (n = Promise))(function(o, i) {
    function s(c) {
      try {
        u(r.next(c));
      } catch (f) {
        i(f);
      }
    }
    function l(c) {
      try {
        u(r.throw(c));
      } catch (f) {
        i(f);
      }
    }
    function u(c) {
      c.done ? o(c.value) : a(c.value).then(s, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
};
const Rie = qp;
function Nie(e, t) {
  return e.replace(/\$\{\w+\}/g, (n) => {
    const r = n.slice(2, -1);
    return t[r];
  });
}
function T2(e, t, n, r, a) {
  return D1(this, void 0, void 0, function* () {
    const o = D({}, n);
    delete o.ruleIndex, delete o.trigger;
    let i = null;
    o && o.type === "array" && o.defaultField && (i = o.defaultField, delete o.defaultField);
    const s = new Rie({
      [e]: [o]
    }), l = kie({}, P1, r.validateMessages);
    s.messages(l);
    let u = [];
    try {
      yield Promise.resolve(s.validate({
        [e]: t
      }, D({}, r)));
    } catch (d) {
      d.errors ? u = d.errors.map((p, v) => {
        let {
          message: h
        } = p;
        return (
          // Wrap VueNode with `key`
          co(h) ? Yr(h, {
            key: `error_${v}`
          }) : h
        );
      }) : (console.error(d), u = [l.default()]);
    }
    if (!u.length && i)
      return (yield Promise.all(t.map((p, v) => T2(`${e}.${v}`, p, i, r, a)))).reduce((p, v) => [...p, ...v], []);
    const c = D(D(D({}, n), {
      name: e,
      enum: (n.enum || []).join(", ")
    }), a);
    return u.map((d) => typeof d == "string" ? Nie(d, c) : d);
  });
}
function Kk(e, t, n, r, a, o) {
  const i = e.join("."), s = n.map((u, c) => {
    const f = u.validator, d = D(D({}, u), {
      ruleIndex: c
    });
    return f && (d.validator = (p, v, h) => {
      let m = !1;
      const x = f(p, v, function() {
        for (var g = arguments.length, S = new Array(g), w = 0; w < g; w++)
          S[w] = arguments[w];
        Promise.resolve().then(() => {
          Sa(!m, "Your validator function has already return a promise. `callback` will be ignored."), m || h(...S);
        });
      });
      m = x && typeof x.then == "function" && typeof x.catch == "function", Sa(m, "`callback` is deprecated. Please return a promise instead."), m && x.then(() => {
        h();
      }).catch((g) => {
        h(g || " ");
      });
    }), d;
  }).sort((u, c) => {
    let {
      warningOnly: f,
      ruleIndex: d
    } = u, {
      warningOnly: p,
      ruleIndex: v
    } = c;
    return !!f == !!p ? d - v : f ? 1 : -1;
  });
  let l;
  if (a === !0)
    l = new Promise((u, c) => D1(this, void 0, void 0, function* () {
      for (let f = 0; f < s.length; f += 1) {
        const d = s[f], p = yield T2(i, t, d, r, o);
        if (p.length) {
          c([{
            errors: p,
            rule: d
          }]);
          return;
        }
      }
      u([]);
    }));
  else {
    const u = s.map((c) => T2(i, t, c, r, o).then((f) => ({
      errors: f,
      rule: c
    })));
    l = (a ? Lie(u) : Fie(u)).then((c) => Promise.reject(c));
  }
  return l.catch((u) => u), l;
}
function Fie(e) {
  return D1(this, void 0, void 0, function* () {
    return Promise.all(e).then((t) => [].concat(...t));
  });
}
function Lie(e) {
  return D1(this, void 0, void 0, function* () {
    let t = 0;
    return new Promise((n) => {
      e.forEach((r) => {
        r.then((a) => {
          a.errors.length && n([a]), t += 1, t === e.length && n([]);
        });
      });
    });
  });
}
const Yk = Symbol("formContextKey"), qk = (e) => {
  kt(Yk, e);
}, h4 = () => Ke(Yk, {
  name: V(() => {
  }),
  labelAlign: V(() => "right"),
  vertical: V(() => !1),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  addField: (e, t) => {
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeField: (e) => {
  },
  model: V(() => {
  }),
  rules: V(() => {
  }),
  colon: V(() => {
  }),
  labelWrap: V(() => {
  }),
  labelCol: V(() => {
  }),
  requiredMark: V(() => !1),
  validateTrigger: V(() => {
  }),
  onValidate: () => {
  },
  validateMessages: V(() => P1)
}), Xk = Symbol("formItemPrefixContextKey"), Bie = (e) => {
  kt(Xk, e);
}, Hie = () => Ke(Xk, {
  prefixCls: V(() => "")
});
function jie(e) {
  return typeof e == "number" ? `${e} ${e} auto` : /^\d+(\.\d+)?(px|em|rem|%)$/.test(e) ? `0 0 ${e}` : e;
}
const Vie = () => ({
  span: [String, Number],
  order: [String, Number],
  offset: [String, Number],
  push: [String, Number],
  pull: [String, Number],
  xs: {
    type: [String, Number, Object],
    default: void 0
  },
  sm: {
    type: [String, Number, Object],
    default: void 0
  },
  md: {
    type: [String, Number, Object],
    default: void 0
  },
  lg: {
    type: [String, Number, Object],
    default: void 0
  },
  xl: {
    type: [String, Number, Object],
    default: void 0
  },
  xxl: {
    type: [String, Number, Object],
    default: void 0
  },
  prefixCls: String,
  flex: [String, Number]
}), Uie = ["xs", "sm", "md", "lg", "xl", "xxl"], Zk = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ACol",
  inheritAttrs: !1,
  props: Vie(),
  setup(e, t) {
    let {
      slots: n,
      attrs: r
    } = t;
    const {
      gutter: a,
      supportFlexGap: o,
      wrap: i
    } = Uoe(), {
      prefixCls: s,
      direction: l
    } = mn("col", e), [u, c] = qoe(s), f = V(() => {
      const {
        span: p,
        order: v,
        offset: h,
        push: m,
        pull: y
      } = e, x = s.value;
      let g = {};
      return Uie.forEach((S) => {
        let w = {};
        const _ = e[S];
        typeof _ == "number" ? w.span = _ : typeof _ == "object" && (w = _ || {}), g = D(D({}, g), {
          [`${x}-${S}-${w.span}`]: w.span !== void 0,
          [`${x}-${S}-order-${w.order}`]: w.order || w.order === 0,
          [`${x}-${S}-offset-${w.offset}`]: w.offset || w.offset === 0,
          [`${x}-${S}-push-${w.push}`]: w.push || w.push === 0,
          [`${x}-${S}-pull-${w.pull}`]: w.pull || w.pull === 0,
          [`${x}-rtl`]: l.value === "rtl"
        });
      }), Ge(x, {
        [`${x}-${p}`]: p !== void 0,
        [`${x}-order-${v}`]: v,
        [`${x}-offset-${h}`]: h,
        [`${x}-push-${m}`]: m,
        [`${x}-pull-${y}`]: y
      }, g, r.class, c.value);
    }), d = V(() => {
      const {
        flex: p
      } = e, v = a.value, h = {};
      if (v && v[0] > 0) {
        const m = `${v[0] / 2}px`;
        h.paddingLeft = m, h.paddingRight = m;
      }
      if (v && v[1] > 0 && !o.value) {
        const m = `${v[1] / 2}px`;
        h.paddingTop = m, h.paddingBottom = m;
      }
      return p && (h.flex = jie(p), i.value === !1 && !h.minWidth && (h.minWidth = 0)), h;
    });
    return () => {
      var p;
      return u(A("div", ve(ve({}, r), {}, {
        class: f.value,
        style: [d.value, r.style]
      }), [(p = n.default) === null || p === void 0 ? void 0 : p.call(n)]));
    };
  }
});
var zie = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, name: "question-circle", theme: "outlined" };
function k5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      Wie(e, a, n[a]);
    });
  }
  return e;
}
function Wie(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var v4 = function(t, n) {
  var r = k5({}, t, n.attrs);
  return A(Bn, k5({}, r, {
    icon: zie
  }), null);
};
v4.displayName = "QuestionCircleOutlined";
v4.inheritAttrs = !1;
const m4 = (e, t) => {
  let {
    slots: n,
    emit: r,
    attrs: a
  } = t;
  var o, i, s, l, u;
  const {
    prefixCls: c,
    htmlFor: f,
    labelCol: d,
    labelAlign: p,
    colon: v,
    required: h,
    requiredMark: m
  } = D(D({}, e), a), [y] = Tc("Form"), x = (o = e.label) !== null && o !== void 0 ? o : (i = n.label) === null || i === void 0 ? void 0 : i.call(n);
  if (!x) return null;
  const {
    vertical: g,
    labelAlign: S,
    labelCol: w,
    labelWrap: _,
    colon: b
  } = h4(), E = d || (w == null ? void 0 : w.value) || {}, C = p || (S == null ? void 0 : S.value), T = `${c}-item-label`, O = Ge(T, C === "left" && `${T}-left`, E.class, {
    [`${T}-wrap`]: !!_.value
  });
  let I = x;
  const k = v === !0 || (b == null ? void 0 : b.value) !== !1 && v !== !1;
  if (k && !g.value && typeof x == "string" && x.trim() !== "" && (I = x.replace(/[:|：]\s*$/, "")), e.tooltip || n.tooltip) {
    const N = A("span", {
      class: `${c}-item-tooltip`
    }, [A(b1, {
      title: e.tooltip
    }, {
      default: () => [A(v4, null, null)]
    })]);
    I = A(dt, null, [I, n.tooltip ? (s = n.tooltip) === null || s === void 0 ? void 0 : s.call(n, {
      class: `${c}-item-tooltip`
    }) : N]);
  }
  m === "optional" && !h && (I = A(dt, null, [I, A("span", {
    class: `${c}-item-optional`
  }, [((l = y.value) === null || l === void 0 ? void 0 : l.optional) || ((u = tu.Form) === null || u === void 0 ? void 0 : u.optional)])]));
  const P = Ge({
    [`${c}-item-required`]: h,
    [`${c}-item-required-mark-optional`]: m === "optional",
    [`${c}-item-no-colon`]: !k
  });
  return A(Zk, ve(ve({}, E), {}, {
    class: O
  }), {
    default: () => [A("label", {
      for: f,
      class: P,
      title: typeof x == "string" ? x : "",
      onClick: (N) => r("click", N)
    }, [I])]
  });
};
m4.displayName = "FormItemLabel";
m4.inheritAttrs = !1;
const Gie = (e) => {
  const {
    componentCls: t
  } = e, n = `${t}-show-help`, r = `${t}-show-help-item`;
  return {
    [n]: {
      // Explain holder
      transition: `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`,
      "&-appear, &-enter": {
        opacity: 0,
        "&-active": {
          opacity: 1
        }
      },
      "&-leave": {
        opacity: 1,
        "&-active": {
          opacity: 0
        }
      },
      // Explain
      [r]: {
        overflow: "hidden",
        transition: `height ${e.motionDurationSlow} ${e.motionEaseInOut},
                     opacity ${e.motionDurationSlow} ${e.motionEaseInOut},
                     transform ${e.motionDurationSlow} ${e.motionEaseInOut} !important`,
        [`&${r}-appear, &${r}-enter`]: {
          transform: "translateY(-5px)",
          opacity: 0,
          "&-active": {
            transform: "translateY(0)",
            opacity: 1
          }
        },
        [`&${r}-leave-active`]: {
          transform: "translateY(-5px)"
        }
      }
    }
  };
}, Kie = (e) => ({
  legend: {
    display: "block",
    width: "100%",
    marginBottom: e.marginLG,
    padding: 0,
    color: e.colorTextDescription,
    fontSize: e.fontSizeLG,
    lineHeight: "inherit",
    border: 0,
    borderBottom: `${e.lineWidth}px ${e.lineType} ${e.colorBorder}`
  },
  label: {
    fontSize: e.fontSize
  },
  'input[type="search"]': {
    boxSizing: "border-box"
  },
  // Position radios and checkboxes better
  'input[type="radio"], input[type="checkbox"]': {
    lineHeight: "normal"
  },
  'input[type="file"]': {
    display: "block"
  },
  // Make range inputs behave like textual form controls
  'input[type="range"]': {
    display: "block",
    width: "100%"
  },
  // Make multiple select elements height not fixed
  "select[multiple], select[size]": {
    height: "auto"
  },
  // Focus for file, radio, and checkbox
  "input[type='file']:focus,\n  input[type='radio']:focus,\n  input[type='checkbox']:focus": {
    outline: 0,
    boxShadow: `0 0 0 ${e.controlOutlineWidth}px ${e.controlOutline}`
  },
  // Adjust output element
  output: {
    display: "block",
    paddingTop: 15,
    color: e.colorText,
    fontSize: e.fontSize,
    lineHeight: e.lineHeight
  }
}), M5 = (e, t) => {
  const {
    formItemCls: n
  } = e;
  return {
    [n]: {
      [`${n}-label > label`]: {
        height: t
      },
      [`${n}-control-input`]: {
        minHeight: t
      }
    }
  };
}, Yie = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [e.componentCls]: D(D(D({}, gr(e)), Kie(e)), {
      [`${t}-text`]: {
        display: "inline-block",
        paddingInlineEnd: e.paddingSM
      },
      // ================================================================
      // =                             Size                             =
      // ================================================================
      "&-small": D({}, M5(e, e.controlHeightSM)),
      "&-large": D({}, M5(e, e.controlHeightLG))
    })
  };
}, qie = (e) => {
  const {
    formItemCls: t,
    iconCls: n,
    componentCls: r,
    rootPrefixCls: a
  } = e;
  return {
    [t]: D(D({}, gr(e)), {
      marginBottom: e.marginLG,
      verticalAlign: "top",
      "&-with-help": {
        transition: "none"
      },
      [`&-hidden,
        &-hidden.${a}-row`]: {
        // https://github.com/ant-design/ant-design/issues/26141
        display: "none"
      },
      "&-has-warning": {
        [`${t}-split`]: {
          color: e.colorError
        }
      },
      "&-has-error": {
        [`${t}-split`]: {
          color: e.colorWarning
        }
      },
      // ==============================================================
      // =                            Label                           =
      // ==============================================================
      [`${t}-label`]: {
        display: "inline-block",
        flexGrow: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textAlign: "end",
        verticalAlign: "middle",
        "&-left": {
          textAlign: "start"
        },
        "&-wrap": {
          overflow: "unset",
          lineHeight: `${e.lineHeight} - 0.25em`,
          whiteSpace: "unset"
        },
        "> label": {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
          height: e.controlHeight,
          color: e.colorTextHeading,
          fontSize: e.fontSize,
          [`> ${n}`]: {
            fontSize: e.fontSize,
            verticalAlign: "top"
          },
          // Required mark
          [`&${t}-required:not(${t}-required-mark-optional)::before`]: {
            display: "inline-block",
            marginInlineEnd: e.marginXXS,
            color: e.colorError,
            fontSize: e.fontSize,
            fontFamily: "SimSun, sans-serif",
            lineHeight: 1,
            content: '"*"',
            [`${r}-hide-required-mark &`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${t}-optional`]: {
            display: "inline-block",
            marginInlineStart: e.marginXXS,
            color: e.colorTextDescription,
            [`${r}-hide-required-mark &`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${t}-tooltip`]: {
            color: e.colorTextDescription,
            cursor: "help",
            writingMode: "horizontal-tb",
            marginInlineStart: e.marginXXS
          },
          "&::after": {
            content: '":"',
            position: "relative",
            marginBlock: 0,
            marginInlineStart: e.marginXXS / 2,
            marginInlineEnd: e.marginXS
          },
          [`&${t}-no-colon::after`]: {
            content: '" "'
          }
        }
      },
      // ==============================================================
      // =                            Input                           =
      // ==============================================================
      [`${t}-control`]: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        [`&:first-child:not([class^="'${a}-col-'"]):not([class*="' ${a}-col-'"])`]: {
          width: "100%"
        },
        "&-input": {
          position: "relative",
          display: "flex",
          alignItems: "center",
          minHeight: e.controlHeight,
          "&-content": {
            flex: "auto",
            maxWidth: "100%"
          }
        }
      },
      // ==============================================================
      // =                           Explain                          =
      // ==============================================================
      [t]: {
        "&-explain, &-extra": {
          clear: "both",
          color: e.colorTextDescription,
          fontSize: e.fontSize,
          lineHeight: e.lineHeight
        },
        "&-explain-connected": {
          width: "100%"
        },
        "&-extra": {
          minHeight: e.controlHeightSM,
          transition: `color ${e.motionDurationMid} ${e.motionEaseOut}`
          // sync input color transition
        },
        "&-explain": {
          "&-error": {
            color: e.colorError
          },
          "&-warning": {
            color: e.colorWarning
          }
        }
      },
      [`&-with-help ${t}-explain`]: {
        height: "auto",
        opacity: 1
      },
      // ==============================================================
      // =                        Feedback Icon                       =
      // ==============================================================
      [`${t}-feedback-icon`]: {
        fontSize: e.fontSize,
        textAlign: "center",
        visibility: "visible",
        animationName: MC,
        animationDuration: e.motionDurationMid,
        animationTimingFunction: e.motionEaseOutBack,
        pointerEvents: "none",
        "&-success": {
          color: e.colorSuccess
        },
        "&-error": {
          color: e.colorError
        },
        "&-warning": {
          color: e.colorWarning
        },
        "&-validating": {
          color: e.colorPrimary
        }
      }
    })
  };
}, Xie = (e) => {
  const {
    componentCls: t,
    formItemCls: n,
    rootPrefixCls: r
  } = e;
  return {
    [`${t}-horizontal`]: {
      [`${n}-label`]: {
        flexGrow: 0
      },
      [`${n}-control`]: {
        flex: "1 1 0",
        // https://github.com/ant-design/ant-design/issues/32777
        // https://github.com/ant-design/ant-design/issues/33773
        minWidth: 0
      },
      // https://github.com/ant-design/ant-design/issues/32980
      [`${n}-label.${r}-col-24 + ${n}-control`]: {
        minWidth: "unset"
      }
    }
  };
}, Zie = (e) => {
  const {
    componentCls: t,
    formItemCls: n
  } = e;
  return {
    [`${t}-inline`]: {
      display: "flex",
      flexWrap: "wrap",
      [n]: {
        flex: "none",
        flexWrap: "nowrap",
        marginInlineEnd: e.margin,
        marginBottom: 0,
        "&-with-help": {
          marginBottom: e.marginLG
        },
        [`> ${n}-label,
        > ${n}-control`]: {
          display: "inline-block",
          verticalAlign: "top"
        },
        [`> ${n}-label`]: {
          flex: "none"
        },
        [`${t}-text`]: {
          display: "inline-block"
        },
        [`${n}-has-feedback`]: {
          display: "inline-block"
        }
      }
    }
  };
}, sf = (e) => ({
  margin: 0,
  padding: `0 0 ${e.paddingXS}px`,
  whiteSpace: "initial",
  textAlign: "start",
  "> label": {
    margin: 0,
    "&::after": {
      display: "none"
    }
  }
}), Qie = (e) => {
  const {
    componentCls: t,
    formItemCls: n
  } = e;
  return {
    [`${n} ${n}-label`]: sf(e),
    [t]: {
      [n]: {
        flexWrap: "wrap",
        [`${n}-label,
          ${n}-control`]: {
          flex: "0 0 100%",
          maxWidth: "100%"
        }
      }
    }
  };
}, Jie = (e) => {
  const {
    componentCls: t,
    formItemCls: n,
    rootPrefixCls: r
  } = e;
  return {
    [`${t}-vertical`]: {
      [n]: {
        "&-row": {
          flexDirection: "column"
        },
        "&-label > label": {
          height: "auto"
        },
        [`${t}-item-control`]: {
          width: "100%"
        }
      }
    },
    [`${t}-vertical ${n}-label,
      .${r}-col-24${n}-label,
      .${r}-col-xl-24${n}-label`]: sf(e),
    [`@media (max-width: ${e.screenXSMax}px)`]: [Qie(e), {
      [t]: {
        [`.${r}-col-xs-24${n}-label`]: sf(e)
      }
    }],
    [`@media (max-width: ${e.screenSMMax}px)`]: {
      [t]: {
        [`.${r}-col-sm-24${n}-label`]: sf(e)
      }
    },
    [`@media (max-width: ${e.screenMDMax}px)`]: {
      [t]: {
        [`.${r}-col-md-24${n}-label`]: sf(e)
      }
    },
    [`@media (max-width: ${e.screenLGMax}px)`]: {
      [t]: {
        [`.${r}-col-lg-24${n}-label`]: sf(e)
      }
    }
  };
}, g4 = xr("Form", (e, t) => {
  let {
    rootPrefixCls: n
  } = t;
  const r = xn(e, {
    formItemCls: `${e.componentCls}-item`,
    rootPrefixCls: n
  });
  return [Yie(r), qie(r), Gie(r), Xie(r), Zie(r), Jie(r), $D(r), MC];
}), ese = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ErrorList",
  inheritAttrs: !1,
  props: ["errors", "help", "onErrorVisibleChanged", "helpStatus", "warnings"],
  setup(e, t) {
    let {
      attrs: n
    } = t;
    const {
      prefixCls: r,
      status: a
    } = Hie(), o = V(() => `${r.value}-item-explain`), i = V(() => !!(e.errors && e.errors.length)), s = ne(a.value), [, l] = g4(r);
    return He([i, a], () => {
      i.value && (s.value = a.value);
    }), () => {
      var u, c;
      const f = tk(`${r.value}-show-help-item`), d = pC(`${r.value}-show-help-item`, f);
      return d.role = "alert", d.class = [l.value, o.value, n.class, `${r.value}-show-help`], A(Ho, ve(ve({}, Hp(`${r.value}-show-help`)), {}, {
        onAfterEnter: () => e.onErrorVisibleChanged(!0),
        onAfterLeave: () => e.onErrorVisibleChanged(!1)
      }), {
        default: () => [Yn(A(Ig, ve(ve({}, d), {}, {
          tag: "div"
        }), {
          default: () => [(c = e.errors) === null || c === void 0 ? void 0 : c.map((p, v) => A("div", {
            key: v,
            class: s.value ? `${o.value}-${s.value}` : ""
          }, [p]))]
        }), [[ko, !!(!((u = e.errors) === null || u === void 0) && u.length)]])]
      });
    };
  }
}), tse = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  slots: Object,
  inheritAttrs: !1,
  props: ["prefixCls", "errors", "hasFeedback", "onDomErrorVisibleChange", "wrapperCol", "help", "extra", "status", "marginBottom", "onErrorVisibleChanged"],
  setup(e, t) {
    let {
      slots: n
    } = t;
    const r = h4(), {
      wrapperCol: a
    } = r, o = D({}, r);
    return delete o.labelCol, delete o.wrapperCol, qk(o), Bie({
      prefixCls: V(() => e.prefixCls),
      status: V(() => e.status)
    }), () => {
      var i, s, l;
      const {
        prefixCls: u,
        wrapperCol: c,
        marginBottom: f,
        onErrorVisibleChanged: d,
        help: p = (i = n.help) === null || i === void 0 ? void 0 : i.call(n),
        errors: v = _s((s = n.errors) === null || s === void 0 ? void 0 : s.call(n)),
        // hasFeedback,
        // status,
        extra: h = (l = n.extra) === null || l === void 0 ? void 0 : l.call(n)
      } = e, m = `${u}-item`, y = c || (a == null ? void 0 : a.value) || {}, x = Ge(`${m}-control`, y.class);
      return A(Zk, ve(ve({}, y), {}, {
        class: x
      }), {
        default: () => {
          var g;
          return A(dt, null, [A("div", {
            class: `${m}-control-input`
          }, [A("div", {
            class: `${m}-control-input-content`
          }, [(g = n.default) === null || g === void 0 ? void 0 : g.call(n)])]), f !== null || v.length ? A("div", {
            style: {
              display: "flex",
              flexWrap: "nowrap"
            }
          }, [A(ese, {
            errors: v,
            help: p,
            class: `${m}-explain-connected`,
            onErrorVisibleChanged: d
          }, null), !!f && A("div", {
            style: {
              width: 0,
              height: `${f}px`
            }
          }, null)]) : null, h ? A("div", {
            class: `${m}-extra`
          }, [h]) : null]);
        }
      });
    };
  }
});
function nse(e) {
  const t = Be(e.value.slice());
  let n = null;
  return _n(() => {
    clearTimeout(n), n = setTimeout(() => {
      t.value = e.value;
    }, e.value.length ? 0 : 10);
  }), t;
}
eu("success", "warning", "error", "validating", "");
const rse = {
  success: du,
  warning: pu,
  error: Vo,
  validating: el
};
function Xy(e, t, n) {
  let r = e;
  const a = t;
  let o = 0;
  try {
    for (let i = a.length; o < i - 1 && !(!r && !n); ++o) {
      const s = a[o];
      if (s in r)
        r = r[s];
      else {
        if (n)
          throw Error("please transfer a valid name path to form item!");
        break;
      }
    }
    if (n && !r)
      throw Error("please transfer a valid name path to form item!");
  } catch {
    console.error("please transfer a valid name path to form item!");
  }
  return {
    o: r,
    k: a[o],
    v: r ? r[a[o]] : void 0
  };
}
const ase = () => ({
  htmlFor: String,
  prefixCls: String,
  label: Oe.any,
  help: Oe.any,
  extra: Oe.any,
  labelCol: {
    type: Object
  },
  wrapperCol: {
    type: Object
  },
  hasFeedback: {
    type: Boolean,
    default: !1
  },
  colon: {
    type: Boolean,
    default: void 0
  },
  labelAlign: String,
  prop: {
    type: [String, Number, Array]
  },
  name: {
    type: [String, Number, Array]
  },
  rules: [Array, Object],
  autoLink: {
    type: Boolean,
    default: !0
  },
  required: {
    type: Boolean,
    default: void 0
  },
  validateFirst: {
    type: Boolean,
    default: void 0
  },
  validateStatus: Oe.oneOf(eu("", "success", "warning", "error", "validating")),
  validateTrigger: {
    type: [String, Array]
  },
  messageVariables: {
    type: Object
  },
  hidden: Boolean,
  noStyle: Boolean,
  tooltip: String
});
let ose = 0;
const ise = "form_item", Jr = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AFormItem",
  inheritAttrs: !1,
  __ANT_NEW_FORM_ITEM: !0,
  props: ase(),
  slots: Object,
  setup(e, t) {
    let {
      slots: n,
      attrs: r,
      expose: a
    } = t;
    Sa(e.prop === void 0, "`prop` is deprecated. Please use `name` instead.");
    const o = `form-item-${++ose}`, {
      prefixCls: i
    } = mn("form", e), [s, l] = g4(i), u = Be(), c = h4(), f = V(() => e.name || e.prop), d = Be([]), p = Be(!1), v = Be(), h = V(() => {
      const q = f.value;
      return E2(q);
    }), m = V(() => {
      if (h.value.length) {
        const q = c.name.value, Q = h.value.join("_");
        return q ? `${q}_${Q}` : `${ise}_${Q}`;
      } else
        return;
    }), y = () => {
      const q = c.model.value;
      if (!(!q || !f.value))
        return Xy(q, h.value, !0).v;
    }, x = V(() => y()), g = Be(Fv(x.value)), S = V(() => {
      let q = e.validateTrigger !== void 0 ? e.validateTrigger : c.validateTrigger.value;
      return q = q === void 0 ? "change" : q, Gl(q);
    }), w = V(() => {
      let q = c.rules.value;
      const Q = e.rules, ue = e.required !== void 0 ? {
        required: !!e.required,
        trigger: S.value
      } : [], le = Xy(q, h.value);
      q = q ? le.o[le.k] || le.v : [];
      const te = [].concat(Q || q || []);
      return rte(te, (G) => G.required) ? te : te.concat(ue);
    }), _ = V(() => {
      const q = w.value;
      let Q = !1;
      return q && q.length && q.every((ue) => ue.required ? (Q = !0, !1) : !0), Q || e.required;
    }), b = Be();
    _n(() => {
      b.value = e.validateStatus;
    });
    const E = V(() => {
      let q = {};
      return typeof e.label == "string" ? q.label = e.label : e.name && (q.label = String(e.name)), e.messageVariables && (q = D(D({}, q), e.messageVariables)), q;
    }), C = (q) => {
      if (h.value.length === 0)
        return;
      const {
        validateFirst: Q = !1
      } = e, {
        triggerName: ue
      } = q || {};
      let le = w.value;
      if (ue && (le = le.filter((G) => {
        const {
          trigger: oe
        } = G;
        return !oe && !S.value.length ? !0 : Gl(oe || S.value).includes(ue);
      })), !le.length)
        return Promise.resolve();
      const te = Kk(h.value, x.value, le, D({
        validateMessages: c.validateMessages.value
      }, q), Q, E.value);
      return b.value = "validating", d.value = [], te.catch((G) => G).then(function() {
        let G = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        if (b.value === "validating") {
          const oe = G.filter((L) => L && L.errors.length);
          b.value = oe.length ? "error" : "success", d.value = oe.map((L) => L.errors), c.onValidate(f.value, !d.value.length, d.value.length ? At(d.value[0]) : null);
        }
      }), te;
    }, T = () => {
      C({
        triggerName: "blur"
      });
    }, O = () => {
      if (p.value) {
        p.value = !1;
        return;
      }
      C({
        triggerName: "change"
      });
    }, I = () => {
      b.value = e.validateStatus, p.value = !1, d.value = [];
    }, k = () => {
      var q;
      b.value = e.validateStatus, p.value = !0, d.value = [];
      const Q = c.model.value || {}, ue = x.value, le = Xy(Q, h.value, !0);
      Array.isArray(ue) ? le.o[le.k] = [].concat((q = g.value) !== null && q !== void 0 ? q : []) : le.o[le.k] = g.value, nn(() => {
        p.value = !1;
      });
    }, B = V(() => e.htmlFor === void 0 ? m.value : e.htmlFor), P = () => {
      const q = B.value;
      if (!q || !v.value)
        return;
      const Q = v.value.$el.querySelector(`[id="${q}"]`);
      Q && Q.focus && Q.focus();
    };
    a({
      onFieldBlur: T,
      onFieldChange: O,
      clearValidate: I,
      resetField: k
    }), pQ({
      id: m,
      onFieldBlur: () => {
        e.autoLink && T();
      },
      onFieldChange: () => {
        e.autoLink && O();
      },
      clearValidate: I
    }, V(() => !!(e.autoLink && c.model.value && f.value)));
    let N = !1;
    He(f, (q) => {
      q ? N || (N = !0, c.addField(o, {
        fieldValue: x,
        fieldId: m,
        fieldName: f,
        resetField: k,
        clearValidate: I,
        namePath: h,
        validateRules: C,
        rules: w
      })) : (N = !1, c.removeField(o));
    }, {
      immediate: !0
    }), Sn(() => {
      c.removeField(o);
    });
    const M = nse(d), H = V(() => e.validateStatus !== void 0 ? e.validateStatus : M.value.length ? "error" : b.value), R = V(() => ({
      [`${i.value}-item`]: !0,
      [l.value]: !0,
      // Status
      [`${i.value}-item-has-feedback`]: H.value && e.hasFeedback,
      [`${i.value}-item-has-success`]: H.value === "success",
      [`${i.value}-item-has-warning`]: H.value === "warning",
      [`${i.value}-item-has-error`]: H.value === "error",
      [`${i.value}-item-is-validating`]: H.value === "validating",
      [`${i.value}-item-hidden`]: e.hidden
    })), z = Wn({});
    Wi.useProvide(z), _n(() => {
      let q;
      if (e.hasFeedback) {
        const Q = H.value && rse[H.value];
        q = Q ? A("span", {
          class: Ge(`${i.value}-item-feedback-icon`, `${i.value}-item-feedback-icon-${H.value}`)
        }, [A(Q, null, null)]) : null;
      }
      D(z, {
        status: H.value,
        hasFeedback: e.hasFeedback,
        feedbackIcon: q,
        isFormItemInput: !0
      });
    });
    const W = Be(null), F = Be(!1), Y = () => {
      if (u.value) {
        const q = getComputedStyle(u.value);
        W.value = parseInt(q.marginBottom, 10);
      }
    };
    Lt(() => {
      He(F, () => {
        F.value && Y();
      }, {
        flush: "post",
        immediate: !0
      });
    });
    const X = (q) => {
      q || (W.value = null);
    };
    return () => {
      var q, Q;
      if (e.noStyle) return (q = n.default) === null || q === void 0 ? void 0 : q.call(n);
      const ue = (Q = e.help) !== null && Q !== void 0 ? Q : n.help ? _s(n.help()) : null, le = !!(ue != null && Array.isArray(ue) && ue.length || M.value.length);
      return F.value = le, s(A("div", {
        class: [R.value, le ? `${i.value}-item-with-help` : "", r.class],
        ref: u
      }, [A(Zoe, ve(ve({}, r), {}, {
        class: `${i.value}-row`,
        key: "row"
      }), {
        default: () => {
          var te, G;
          return A(dt, null, [A(m4, ve(ve({}, e), {}, {
            htmlFor: B.value,
            required: _.value,
            requiredMark: c.requiredMark.value,
            prefixCls: i.value,
            onClick: P,
            label: e.label
          }), {
            label: n.label,
            tooltip: n.tooltip
          }), A(tse, ve(ve({}, e), {}, {
            errors: ue != null ? Gl(ue) : M.value,
            marginBottom: W.value,
            prefixCls: i.value,
            status: H.value,
            ref: v,
            help: ue,
            extra: (te = e.extra) !== null && te !== void 0 ? te : (G = n.extra) === null || G === void 0 ? void 0 : G.call(n),
            onErrorVisibleChanged: X
          }), {
            default: n.default
          })]);
        }
      }), !!W.value && A("div", {
        class: `${i.value}-margin-offset`,
        style: {
          marginBottom: `-${W.value}px`
        }
      }, null)]));
    };
  }
});
function Qk(e) {
  let t = !1, n = e.length;
  const r = [];
  return e.length ? new Promise((a, o) => {
    e.forEach((i, s) => {
      i.catch((l) => (t = !0, l)).then((l) => {
        n -= 1, r[s] = l, !(n > 0) && (t && o(r), a(r));
      });
    });
  }) : Promise.resolve([]);
}
function R5(e) {
  let t = !1;
  return e && e.length && e.every((n) => n.required ? (t = !0, !1) : !0), t;
}
function N5(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function Zy(e, t, n) {
  let r = e;
  t = t.replace(/\[(\w+)\]/g, ".$1"), t = t.replace(/^\./, "");
  const a = t.split(".");
  let o = 0;
  for (let i = a.length; o < i - 1 && !(!r && !n); ++o) {
    const s = a[o];
    if (s in r)
      r = r[s];
    else {
      if (n)
        throw new Error("please transfer a valid name path to validate!");
      break;
    }
  }
  return {
    o: r,
    k: a[o],
    v: r ? r[a[o]] : null,
    isValid: r && a[o] in r
  };
}
function sse(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ne({}), n = arguments.length > 2 ? arguments[2] : void 0;
  const r = Fv(U(e)), a = Wn({}), o = Be([]), i = (g) => {
    D(U(e), D(D({}, Fv(r)), g)), nn(() => {
      Object.keys(a).forEach((S) => {
        a[S] = {
          autoLink: !1,
          required: R5(U(t)[S])
        };
      });
    });
  }, s = function() {
    let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], S = arguments.length > 1 ? arguments[1] : void 0;
    return S.length ? g.filter((w) => {
      const _ = N5(w.trigger || "change");
      return ste(_, S).length;
    }) : g;
  };
  let l = null;
  const u = function(g) {
    let S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = arguments.length > 2 ? arguments[2] : void 0;
    const _ = [], b = {};
    for (let T = 0; T < g.length; T++) {
      const O = g[T], I = Zy(U(e), O, w);
      if (!I.isValid) continue;
      b[O] = I.v;
      const k = s(U(t)[O], N5(S && S.trigger));
      k.length && _.push(c(O, I.v, k, S || {}).then(() => ({
        name: O,
        errors: [],
        warnings: []
      })).catch((B) => {
        const P = [], N = [];
        return B.forEach((M) => {
          let {
            rule: {
              warningOnly: H
            },
            errors: R
          } = M;
          H ? N.push(...R) : P.push(...R);
        }), P.length ? Promise.reject({
          name: O,
          errors: P,
          warnings: N
        }) : {
          name: O,
          errors: P,
          warnings: N
        };
      }));
    }
    const E = Qk(_);
    l = E;
    const C = E.then(() => l === E ? Promise.resolve(b) : Promise.reject([])).catch((T) => {
      const O = T.filter((I) => I && I.errors.length);
      return Promise.reject({
        values: b,
        errorFields: O,
        outOfDate: l !== E
      });
    });
    return C.catch((T) => T), C;
  }, c = function(g, S, w) {
    let _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const b = Kk([g], S, w, D({
      validateMessages: P1
    }, _), !!_.validateFirst);
    return a[g] ? (a[g].validateStatus = "validating", b.catch((E) => E).then(function() {
      let E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      var C;
      if (a[g].validateStatus === "validating") {
        const T = E.filter((O) => O && O.errors.length);
        a[g].validateStatus = T.length ? "error" : "success", a[g].help = T.length ? T.map((O) => O.errors) : null, (C = n == null ? void 0 : n.onValidate) === null || C === void 0 || C.call(n, g, !T.length, T.length ? At(a[g].help[0]) : null);
      }
    }), b) : b.catch((E) => E);
  }, f = (g, S) => {
    let w = [], _ = !0;
    g ? Array.isArray(g) ? w = g : w = [g] : (_ = !1, w = o.value);
    const b = u(w, S || {}, _);
    return b.catch((E) => E), b;
  }, d = (g) => {
    let S = [];
    g ? Array.isArray(g) ? S = g : S = [g] : S = o.value, S.forEach((w) => {
      a[w] && D(a[w], {
        validateStatus: "",
        help: null
      });
    });
  }, p = (g) => {
    const S = {
      autoLink: !1
    }, w = [], _ = Array.isArray(g) ? g : [g];
    for (let b = 0; b < _.length; b++) {
      const E = _[b];
      (E == null ? void 0 : E.validateStatus) === "error" && (S.validateStatus = "error", E.help && w.push(E.help)), S.required = S.required || (E == null ? void 0 : E.required);
    }
    return S.help = w, S;
  };
  let v = r, h = !0;
  const m = (g) => {
    const S = [];
    o.value.forEach((w) => {
      const _ = Zy(g, w, !1), b = Zy(v, w, !1);
      (h && (n == null ? void 0 : n.immediate) && _.isValid || !dC(_.v, b.v)) && S.push(w);
    }), f(S, {
      trigger: "change"
    }), h = !1, v = Fv(At(g));
  }, y = n == null ? void 0 : n.debounce;
  let x = !0;
  return He(t, () => {
    o.value = t ? Object.keys(U(t)) : [], !x && n && n.validateOnRuleChange && f(), x = !1;
  }, {
    deep: !0,
    immediate: !0
  }), He(o, () => {
    const g = {};
    o.value.forEach((S) => {
      g[S] = D({}, a[S], {
        autoLink: !1,
        required: R5(U(t)[S])
      }), delete a[S];
    });
    for (const S in a)
      Object.prototype.hasOwnProperty.call(a, S) && delete a[S];
    D(a, g);
  }, {
    immediate: !0
  }), He(e, y && y.wait ? Zee(m, y.wait, yte(y, ["wait"])) : m, {
    immediate: n && !!n.immediate,
    deep: !0
  }), {
    modelRef: e,
    rulesRef: t,
    initialModel: r,
    validateInfos: a,
    resetFields: i,
    validate: f,
    validateField: c,
    mergeValidateInfo: p,
    clearValidate: d
  };
}
const lse = () => ({
  layout: Oe.oneOf(eu("horizontal", "inline", "vertical")),
  labelCol: hn(),
  wrapperCol: hn(),
  colon: qt(),
  labelAlign: Ur(),
  labelWrap: qt(),
  prefixCls: String,
  requiredMark: ca([String, Boolean]),
  /** @deprecated Will warning in future branch. Pls use `requiredMark` instead. */
  hideRequiredMark: qt(),
  model: Oe.object,
  rules: hn(),
  validateMessages: hn(),
  validateOnRuleChange: qt(),
  // 提交失败自动滚动到第一个错误字段
  scrollToFirstError: Oi(),
  onSubmit: Nt(),
  name: String,
  validateTrigger: ca([String, Array]),
  size: Ur(),
  disabled: qt(),
  onValuesChange: Nt(),
  onFieldsChange: Nt(),
  onFinish: Nt(),
  onFinishFailed: Nt(),
  onValidate: Nt()
});
function use(e, t) {
  return dC(Gl(e), Gl(t));
}
const Bs = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AForm",
  inheritAttrs: !1,
  props: ha(lse(), {
    layout: "horizontal",
    hideRequiredMark: !1,
    colon: !0
  }),
  Item: Jr,
  useForm: sse,
  // emits: ['finishFailed', 'submit', 'finish', 'validate'],
  setup(e, t) {
    let {
      emit: n,
      slots: r,
      expose: a,
      attrs: o
    } = t;
    const {
      prefixCls: i,
      direction: s,
      form: l,
      size: u,
      disabled: c
    } = mn("form", e), f = V(() => e.requiredMark === "" || e.requiredMark), d = V(() => {
      var M;
      return f.value !== void 0 ? f.value : l && ((M = l.value) === null || M === void 0 ? void 0 : M.requiredMark) !== void 0 ? l.value.requiredMark : !e.hideRequiredMark;
    });
    nP(u), mI(c);
    const p = V(() => {
      var M, H;
      return (M = e.colon) !== null && M !== void 0 ? M : (H = l.value) === null || H === void 0 ? void 0 : H.colon;
    }), {
      validateMessages: v
    } = _z(), h = V(() => D(D(D({}, P1), v.value), e.validateMessages)), [m, y] = g4(i), x = V(() => Ge(i.value, {
      [`${i.value}-${e.layout}`]: !0,
      [`${i.value}-hide-required-mark`]: d.value === !1,
      [`${i.value}-rtl`]: s.value === "rtl",
      [`${i.value}-${u.value}`]: u.value
    }, y.value)), g = ne(), S = {}, w = (M, H) => {
      S[M] = H;
    }, _ = (M) => {
      delete S[M];
    }, b = (M) => {
      const H = !!M, R = H ? Gl(M).map(E2) : [];
      return H ? Object.values(S).filter((z) => R.findIndex((W) => use(W, z.fieldName.value)) > -1) : Object.values(S);
    }, E = (M) => {
      if (!e.model) {
        Pa(!1, "Form", "model is required for resetFields to work.");
        return;
      }
      b(M).forEach((H) => {
        H.resetField();
      });
    }, C = (M) => {
      b(M).forEach((H) => {
        H.clearValidate();
      });
    }, T = (M) => {
      const {
        scrollToFirstError: H
      } = e;
      if (n("finishFailed", M), H && M.errorFields.length) {
        let R = {};
        typeof H == "object" && (R = H), I(M.errorFields[0].name, R);
      }
    }, O = function() {
      return P(...arguments);
    }, I = function(M) {
      let H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const R = b(M ? [M] : void 0);
      if (R.length) {
        const z = R[0].fieldId.value, W = z ? document.getElementById(z) : null;
        W && mG(W, D({
          scrollMode: "if-needed",
          block: "nearest"
        }, H));
      }
    }, k = function() {
      let M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      if (M === !0) {
        const H = [];
        return Object.values(S).forEach((R) => {
          let {
            namePath: z
          } = R;
          H.push(z.value);
        }), D5(e.model, H);
      } else
        return D5(e.model, M);
    }, B = (M, H) => {
      if (Pa(!(M instanceof Function), "Form", "validateFields/validateField/validate not support callback, please use promise instead"), !e.model)
        return Pa(!1, "Form", "model is required for validateFields to work."), Promise.reject("Form `model` is required for validateFields to work.");
      const R = !!M, z = R ? Gl(M).map(E2) : [], W = [];
      Object.values(S).forEach((X) => {
        var q;
        if (R || z.push(X.namePath.value), !(!((q = X.rules) === null || q === void 0) && q.value.length))
          return;
        const Q = X.namePath.value;
        if (!R || Die(z, Q)) {
          const ue = X.validateRules(D({
            validateMessages: h.value
          }, H));
          W.push(ue.then(() => ({
            name: Q,
            errors: [],
            warnings: []
          })).catch((le) => {
            const te = [], G = [];
            return le.forEach((oe) => {
              let {
                rule: {
                  warningOnly: L
                },
                errors: re
              } = oe;
              L ? G.push(...re) : te.push(...re);
            }), te.length ? Promise.reject({
              name: Q,
              errors: te,
              warnings: G
            }) : {
              name: Q,
              errors: te,
              warnings: G
            };
          }));
        }
      });
      const F = Qk(W);
      g.value = F;
      const Y = F.then(() => g.value === F ? Promise.resolve(k(z)) : Promise.reject([])).catch((X) => {
        const q = X.filter((Q) => Q && Q.errors.length);
        return Promise.reject({
          values: k(z),
          errorFields: q,
          outOfDate: g.value !== F
        });
      });
      return Y.catch((X) => X), Y;
    }, P = function() {
      return B(...arguments);
    }, N = (M) => {
      M.preventDefault(), M.stopPropagation(), n("submit", M), e.model && B().then((R) => {
        n("finish", R);
      }).catch((R) => {
        T(R);
      });
    };
    return a({
      resetFields: E,
      clearValidate: C,
      validateFields: B,
      getFieldsValue: k,
      validate: O,
      scrollToField: I
    }), qk({
      model: V(() => e.model),
      name: V(() => e.name),
      labelAlign: V(() => e.labelAlign),
      labelCol: V(() => e.labelCol),
      labelWrap: V(() => e.labelWrap),
      wrapperCol: V(() => e.wrapperCol),
      vertical: V(() => e.layout === "vertical"),
      colon: p,
      requiredMark: d,
      validateTrigger: V(() => e.validateTrigger),
      rules: V(() => e.rules),
      addField: w,
      removeField: _,
      onValidate: (M, H, R) => {
        n("validate", M, H, R);
      },
      validateMessages: h
    }), He(() => e.rules, () => {
      e.validateOnRuleChange && B();
    }), () => {
      var M;
      return m(A("form", ve(ve({}, o), {}, {
        onSubmit: N,
        class: [x.value, o.class]
      }), [(M = r.default) === null || M === void 0 ? void 0 : M.call(r)]));
    };
  }
});
Bs.useInjectFormItemContext = fu;
Bs.ItemRest = o2;
Bs.install = function(e) {
  return e.component(Bs.name, Bs), e.component(Bs.Item.name, Bs.Item), e.component(o2.name, o2), e;
};
const cse = new rn("antCheckboxEffect", {
  "0%": {
    transform: "scale(1)",
    opacity: 0.5
  },
  "100%": {
    transform: "scale(1.6)",
    opacity: 0
  }
}), fse = (e) => {
  const {
    checkboxCls: t
  } = e, n = `${t}-wrapper`;
  return [
    // ===================== Basic =====================
    {
      // Group
      [`${t}-group`]: D(D({}, gr(e)), {
        display: "inline-flex",
        flexWrap: "wrap",
        columnGap: e.marginXS,
        // Group > Grid
        [`> ${e.antCls}-row`]: {
          flex: 1
        }
      }),
      // Wrapper
      [n]: D(D({}, gr(e)), {
        display: "inline-flex",
        alignItems: "baseline",
        cursor: "pointer",
        // Fix checkbox & radio in flex align #30260
        "&:after": {
          display: "inline-block",
          width: 0,
          overflow: "hidden",
          content: "'\\a0'"
        },
        // Checkbox near checkbox
        [`& + ${n}`]: {
          marginInlineStart: 0
        },
        [`&${n}-in-form-item`]: {
          'input[type="checkbox"]': {
            width: 14,
            height: 14
            // FIXME: magic
          }
        }
      }),
      // Wrapper > Checkbox
      [t]: D(D({}, gr(e)), {
        position: "relative",
        whiteSpace: "nowrap",
        lineHeight: 1,
        cursor: "pointer",
        // To make alignment right when `controlHeight` is changed
        // Ref: https://github.com/ant-design/ant-design/issues/41564
        alignSelf: "center",
        // Wrapper > Checkbox > input
        [`${t}-input`]: {
          position: "absolute",
          // Since baseline align will get additional space offset,
          // we need to move input to top to make it align with text.
          // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
          inset: 0,
          zIndex: 1,
          cursor: "pointer",
          opacity: 0,
          margin: 0,
          [`&:focus-visible + ${t}-inner`]: D({}, ip(e))
        },
        // Wrapper > Checkbox > inner
        [`${t}-inner`]: {
          boxSizing: "border-box",
          position: "relative",
          top: 0,
          insetInlineStart: 0,
          display: "block",
          width: e.checkboxSize,
          height: e.checkboxSize,
          direction: "ltr",
          backgroundColor: e.colorBgContainer,
          border: `${e.lineWidth}px ${e.lineType} ${e.colorBorder}`,
          borderRadius: e.borderRadiusSM,
          borderCollapse: "separate",
          transition: `all ${e.motionDurationSlow}`,
          "&:after": {
            boxSizing: "border-box",
            position: "absolute",
            top: "50%",
            insetInlineStart: "21.5%",
            display: "table",
            width: e.checkboxSize / 14 * 5,
            height: e.checkboxSize / 14 * 8,
            border: `${e.lineWidthBold}px solid ${e.colorWhite}`,
            borderTop: 0,
            borderInlineStart: 0,
            transform: "rotate(45deg) scale(0) translate(-50%,-50%)",
            opacity: 0,
            content: '""',
            transition: `all ${e.motionDurationFast} ${e.motionEaseInBack}, opacity ${e.motionDurationFast}`
          }
        },
        // Wrapper > Checkbox + Text
        "& + span": {
          paddingInlineStart: e.paddingXS,
          paddingInlineEnd: e.paddingXS
        }
      })
    },
    // ================= Indeterminate =================
    {
      [t]: {
        "&-indeterminate": {
          // Wrapper > Checkbox > inner
          [`${t}-inner`]: {
            "&:after": {
              top: "50%",
              insetInlineStart: "50%",
              width: e.fontSizeLG / 2,
              height: e.fontSizeLG / 2,
              backgroundColor: e.colorPrimary,
              border: 0,
              transform: "translate(-50%, -50%) scale(1)",
              opacity: 1,
              content: '""'
            }
          }
        }
      }
    },
    // ===================== Hover =====================
    {
      // Wrapper
      [`${n}:hover ${t}:after`]: {
        visibility: "visible"
      },
      // Wrapper & Wrapper > Checkbox
      [`
        ${n}:not(${n}-disabled),
        ${t}:not(${t}-disabled)
      `]: {
        [`&:hover ${t}-inner`]: {
          borderColor: e.colorPrimary
        }
      },
      [`${n}:not(${n}-disabled)`]: {
        [`&:hover ${t}-checked:not(${t}-disabled) ${t}-inner`]: {
          backgroundColor: e.colorPrimaryHover,
          borderColor: "transparent"
        },
        [`&:hover ${t}-checked:not(${t}-disabled):after`]: {
          borderColor: e.colorPrimaryHover
        }
      }
    },
    // ==================== Checked ====================
    {
      // Wrapper > Checkbox
      [`${t}-checked`]: {
        [`${t}-inner`]: {
          backgroundColor: e.colorPrimary,
          borderColor: e.colorPrimary,
          "&:after": {
            opacity: 1,
            transform: "rotate(45deg) scale(1) translate(-50%,-50%)",
            transition: `all ${e.motionDurationMid} ${e.motionEaseOutBack} ${e.motionDurationFast}`
          }
        },
        // Checked Effect
        "&:after": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          width: "100%",
          height: "100%",
          borderRadius: e.borderRadiusSM,
          visibility: "hidden",
          border: `${e.lineWidthBold}px solid ${e.colorPrimary}`,
          animationName: cse,
          animationDuration: e.motionDurationSlow,
          animationTimingFunction: "ease-in-out",
          animationFillMode: "backwards",
          content: '""',
          transition: `all ${e.motionDurationSlow}`
        }
      },
      [`
        ${n}-checked:not(${n}-disabled),
        ${t}-checked:not(${t}-disabled)
      `]: {
        [`&:hover ${t}-inner`]: {
          backgroundColor: e.colorPrimaryHover,
          borderColor: "transparent"
        },
        [`&:hover ${t}:after`]: {
          borderColor: e.colorPrimaryHover
        }
      }
    },
    // ==================== Disable ====================
    {
      // Wrapper
      [`${n}-disabled`]: {
        cursor: "not-allowed"
      },
      // Wrapper > Checkbox
      [`${t}-disabled`]: {
        // Wrapper > Checkbox > input
        [`&, ${t}-input`]: {
          cursor: "not-allowed",
          // Disabled for native input to enable Tooltip event handler
          // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
          pointerEvents: "none"
        },
        // Wrapper > Checkbox > inner
        [`${t}-inner`]: {
          background: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          "&:after": {
            borderColor: e.colorTextDisabled
          }
        },
        "&:after": {
          display: "none"
        },
        "& + span": {
          color: e.colorTextDisabled
        },
        [`&${t}-indeterminate ${t}-inner::after`]: {
          background: e.colorTextDisabled
        }
      }
    }
  ];
};
function dse(e, t) {
  const n = xn(t, {
    checkboxCls: `.${e}`,
    checkboxSize: t.controlInteractiveSize
  });
  return [fse(n)];
}
const Jk = xr("Checkbox", (e, t) => {
  let {
    prefixCls: n
  } = t;
  return [dse(n, e)];
}), pse = () => ({
  name: String,
  prefixCls: String,
  options: io([]),
  disabled: Boolean,
  id: String
}), hse = () => D(D({}, pse()), {
  defaultValue: io(),
  value: io(),
  onChange: Nt(),
  "onUpdate:value": Nt()
}), vse = () => ({
  prefixCls: String,
  defaultChecked: qt(),
  checked: qt(),
  disabled: qt(),
  isGroup: qt(),
  value: Oe.any,
  name: String,
  id: String,
  indeterminate: qt(),
  type: Ur("checkbox"),
  autofocus: qt(),
  onChange: Nt(),
  "onUpdate:checked": Nt(),
  onClick: Nt(),
  skipGroup: qt(!1)
}), mse = () => D(D({}, vse()), {
  indeterminate: qt(!1)
}), e7 = Symbol("CheckboxGroupContext");
var F5 = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const aa = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ACheckbox",
  inheritAttrs: !1,
  __ANT_CHECKBOX: !0,
  props: mse(),
  // emits: ['change', 'update:checked'],
  setup(e, t) {
    let {
      emit: n,
      attrs: r,
      slots: a,
      expose: o
    } = t;
    const i = fu(), s = Wi.useInject(), {
      prefixCls: l,
      direction: u,
      disabled: c
    } = mn("checkbox", e), f = Ec(), [d, p] = Jk(l), v = Ke(e7, void 0), h = Symbol("checkboxUniId"), m = V(() => (v == null ? void 0 : v.disabled.value) || c.value);
    _n(() => {
      !e.skipGroup && v && v.registerValue(h, e.value);
    }), Sn(() => {
      v && v.cancelValue(h);
    }), Lt(() => {
      Pa(!!(e.checked !== void 0 || v || e.value === void 0), "Checkbox", "`value` is not validate prop, do you mean `checked`?");
    });
    const y = (w) => {
      const _ = w.target.checked;
      n("update:checked", _), n("change", w), i.onFieldChange();
    }, x = ne();
    return o({
      focus: () => {
        var w;
        (w = x.value) === null || w === void 0 || w.focus();
      },
      blur: () => {
        var w;
        (w = x.value) === null || w === void 0 || w.blur();
      }
    }), () => {
      var w;
      const _ = ua((w = a.default) === null || w === void 0 ? void 0 : w.call(a)), {
        indeterminate: b,
        skipGroup: E,
        id: C = i.id.value
      } = e, T = F5(e, ["indeterminate", "skipGroup", "id"]), {
        onMouseenter: O,
        onMouseleave: I,
        onInput: k,
        class: B,
        style: P
      } = r, N = F5(r, ["onMouseenter", "onMouseleave", "onInput", "class", "style"]), M = D(D(D(D({}, T), {
        id: C,
        prefixCls: l.value
      }), N), {
        disabled: m.value
      });
      v && !E ? (M.onChange = function() {
        for (var W = arguments.length, F = new Array(W), Y = 0; Y < W; Y++)
          F[Y] = arguments[Y];
        n("change", ...F), v.toggleOption({
          label: _,
          value: e.value
        });
      }, M.name = v.name.value, M.checked = v.mergedValue.value.includes(e.value), M.disabled = m.value || f.value, M.indeterminate = b) : M.onChange = y;
      const H = Ge({
        [`${l.value}-wrapper`]: !0,
        [`${l.value}-rtl`]: u.value === "rtl",
        [`${l.value}-wrapper-checked`]: M.checked,
        [`${l.value}-wrapper-disabled`]: M.disabled,
        [`${l.value}-wrapper-in-form-item`]: s.isFormItemInput
      }, B, p.value), R = Ge({
        [`${l.value}-indeterminate`]: b
      }, p.value);
      return d(A("label", {
        class: H,
        style: P,
        onMouseenter: O,
        onMouseleave: I
      }, [A(ioe, ve(ve({
        "aria-checked": b ? "mixed" : void 0
      }, M), {}, {
        class: R,
        ref: x
      }), null), _.length ? A("span", null, [_]) : null]));
    };
  }
}), $2 = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ACheckboxGroup",
  inheritAttrs: !1,
  props: hse(),
  // emits: ['change', 'update:value'],
  setup(e, t) {
    let {
      slots: n,
      attrs: r,
      emit: a,
      expose: o
    } = t;
    const i = fu(), {
      prefixCls: s,
      direction: l
    } = mn("checkbox", e), u = V(() => `${s.value}-group`), [c, f] = Jk(u), d = ne((e.value === void 0 ? e.defaultValue : e.value) || []);
    He(() => e.value, () => {
      d.value = e.value || [];
    });
    const p = V(() => e.options.map((S) => typeof S == "string" || typeof S == "number" ? {
      label: S,
      value: S
    } : S)), v = ne(Symbol()), h = ne(/* @__PURE__ */ new Map()), m = (S) => {
      h.value.delete(S), v.value = Symbol();
    }, y = (S, w) => {
      h.value.set(S, w), v.value = Symbol();
    }, x = ne(/* @__PURE__ */ new Map());
    return He(v, () => {
      const S = /* @__PURE__ */ new Map();
      for (const w of h.value.values())
        S.set(w, !0);
      x.value = S;
    }), kt(e7, {
      cancelValue: m,
      registerValue: y,
      toggleOption: (S) => {
        const w = d.value.indexOf(S.value), _ = [...d.value];
        w === -1 ? _.push(S.value) : _.splice(w, 1), e.value === void 0 && (d.value = _);
        const b = _.filter((E) => x.value.has(E)).sort((E, C) => {
          const T = p.value.findIndex((I) => I.value === E), O = p.value.findIndex((I) => I.value === C);
          return T - O;
        });
        a("update:value", b), a("change", b), i.onFieldChange();
      },
      mergedValue: d,
      name: V(() => e.name),
      disabled: V(() => e.disabled)
    }), o({
      mergedValue: d
    }), () => {
      var S;
      const {
        id: w = i.id.value
      } = e;
      let _ = null;
      return p.value && p.value.length > 0 && (_ = p.value.map((b) => {
        var E;
        return A(aa, {
          prefixCls: s.value,
          key: b.value.toString(),
          disabled: "disabled" in b ? b.disabled : e.disabled,
          indeterminate: b.indeterminate,
          value: b.value,
          checked: d.value.indexOf(b.value) !== -1,
          onChange: b.onChange,
          class: `${u.value}-item`
        }, {
          default: () => [n.label !== void 0 ? (E = n.label) === null || E === void 0 ? void 0 : E.call(n, b) : b.label]
        });
      })), c(A("div", ve(ve({}, r), {}, {
        class: [u.value, {
          [`${u.value}-rtl`]: l.value === "rtl"
        }, r.class, f.value],
        id: w
      }), [_ || ((S = n.default) === null || S === void 0 ? void 0 : S.call(n))]));
    };
  }
});
aa.Group = $2;
aa.install = function(e) {
  return e.component(aa.name, aa), e.component($2.name, $2), e;
};
let jv = D({}, tu.Modal);
function gse(e) {
  e ? jv = D(D({}, jv), e) : jv = D({}, tu.Modal);
}
function yse() {
  return jv;
}
const O2 = "internalMark", Vv = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ALocaleProvider",
  props: {
    locale: {
      type: Object
    },
    ANT_MARK__: String
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    Pa(e.ANT_MARK__ === O2, "LocaleProvider", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead");
    const r = Wn({
      antLocale: D(D({}, e.locale), {
        exist: !0
      }),
      ANT_MARK__: O2
    });
    return kt("localeData", r), He(() => e.locale, (a) => {
      gse(a && a.Modal), r.antLocale = D(D({}, a), {
        exist: !0
      });
    }, {
      immediate: !0
    }), () => {
      var a;
      return (a = n.default) === null || a === void 0 ? void 0 : a.call(n);
    };
  }
});
Vv.install = function(e) {
  return e.component(Vv.name, Vv), e;
};
const xse = yd(Vv), t7 = /* @__PURE__ */ Me({
  name: "Notice",
  inheritAttrs: !1,
  props: ["prefixCls", "duration", "updateMark", "noticeKey", "closeIcon", "closable", "props", "onClick", "onClose", "holder", "visible"],
  setup(e, t) {
    let {
      attrs: n,
      slots: r
    } = t, a, o = !1;
    const i = V(() => e.duration === void 0 ? 4.5 : e.duration), s = () => {
      i.value && !o && (a = setTimeout(() => {
        u();
      }, i.value * 1e3));
    }, l = () => {
      a && (clearTimeout(a), a = null);
    }, u = (f) => {
      f && f.stopPropagation(), l();
      const {
        onClose: d,
        noticeKey: p
      } = e;
      d && d(p);
    }, c = () => {
      l(), s();
    };
    return Lt(() => {
      s();
    }), Bo(() => {
      o = !0, l();
    }), He([i, () => e.updateMark, () => e.visible], (f, d) => {
      let [p, v, h] = f, [m, y, x] = d;
      (p !== m || v !== y || h !== x && x) && c();
    }, {
      flush: "post"
    }), () => {
      var f, d;
      const {
        prefixCls: p,
        closable: v,
        closeIcon: h = (f = r.closeIcon) === null || f === void 0 ? void 0 : f.call(r),
        onClick: m,
        holder: y
      } = e, {
        class: x,
        style: g
      } = n, S = `${p}-notice`, w = Object.keys(n).reduce((b, E) => ((E.startsWith("data-") || E.startsWith("aria-") || E === "role") && (b[E] = n[E]), b), {}), _ = A("div", ve({
        class: Ge(S, x, {
          [`${S}-closable`]: v
        }),
        style: g,
        onMouseenter: l,
        onMouseleave: s,
        onClick: m
      }, w), [A("div", {
        class: `${S}-content`
      }, [(d = r.default) === null || d === void 0 ? void 0 : d.call(r)]), v ? A("a", {
        tabindex: 0,
        onClick: u,
        class: `${S}-close`
      }, [h || A("span", {
        class: `${S}-close-x`
      }, null)]) : null]);
      return y ? A(Eg, {
        to: y
      }, {
        default: () => _
      }) : _;
    };
  }
});
var bse = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
let L5 = 0;
const wse = Date.now();
function B5() {
  const e = L5;
  return L5 += 1, `rcNotification_${wse}_${e}`;
}
const Fm = /* @__PURE__ */ Me({
  name: "Notification",
  inheritAttrs: !1,
  props: ["prefixCls", "transitionName", "animation", "maxCount", "closeIcon", "hashId"],
  setup(e, t) {
    let {
      attrs: n,
      expose: r,
      slots: a
    } = t;
    const o = /* @__PURE__ */ new Map(), i = ne([]), s = V(() => {
      const {
        prefixCls: c,
        animation: f = "fade"
      } = e;
      let d = e.transitionName;
      return !d && f && (d = `${c}-${f}`), pC(d);
    }), l = (c, f) => {
      const d = c.key || B5(), p = D(D({}, c), {
        key: d
      }), {
        maxCount: v
      } = e, h = i.value.map((y) => y.notice.key).indexOf(d), m = i.value.concat();
      h !== -1 ? m.splice(h, 1, {
        notice: p,
        holderCallback: f
      }) : (v && i.value.length >= v && (p.key = m[0].notice.key, p.updateMark = B5(), p.userPassKey = d, m.shift()), m.push({
        notice: p,
        holderCallback: f
      })), i.value = m;
    }, u = (c) => {
      i.value = i.value.filter((f) => {
        let {
          notice: {
            key: d,
            userPassKey: p
          }
        } = f;
        return (p || d) !== c;
      });
    };
    return r({
      add: l,
      remove: u,
      notices: i
    }), () => {
      var c;
      const {
        prefixCls: f,
        closeIcon: d = (c = a.closeIcon) === null || c === void 0 ? void 0 : c.call(a, {
          prefixCls: f
        })
      } = e, p = i.value.map((h, m) => {
        let {
          notice: y,
          holderCallback: x
        } = h;
        const g = m === i.value.length - 1 ? y.updateMark : void 0, {
          key: S,
          userPassKey: w
        } = y, {
          content: _
        } = y, b = D(D(D({
          prefixCls: f,
          closeIcon: typeof d == "function" ? d({
            prefixCls: f
          }) : d
        }, y), y.props), {
          key: S,
          noticeKey: w || S,
          updateMark: g,
          onClose: (E) => {
            var C;
            u(E), (C = y.onClose) === null || C === void 0 || C.call(y);
          },
          onClick: y.onClick
        });
        return x ? A("div", {
          key: S,
          class: `${f}-hook-holder`,
          ref: (E) => {
            typeof S > "u" || (E ? (o.set(S, E), x(E, b)) : o.delete(S));
          }
        }, null) : A(t7, ve(ve({}, b), {}, {
          class: Ge(b.class, e.hashId)
        }), {
          default: () => [typeof _ == "function" ? _({
            prefixCls: f
          }) : _]
        });
      }), v = {
        [f]: 1,
        [n.class]: !!n.class,
        [e.hashId]: !0
      };
      return A("div", {
        class: v,
        style: n.style || {
          top: "65px",
          left: "50%"
        }
      }, [A(Ig, ve({
        tag: "div"
      }, s.value), {
        default: () => [p]
      })]);
    };
  }
});
Fm.newInstance = function(t, n) {
  const r = t || {}, {
    name: a = "notification",
    getContainer: o,
    appContext: i,
    prefixCls: s,
    rootPrefixCls: l,
    transitionName: u,
    hasTransitionName: c,
    useStyle: f
  } = r, d = bse(r, ["name", "getContainer", "appContext", "prefixCls", "rootPrefixCls", "transitionName", "hasTransitionName", "useStyle"]), p = document.createElement("div");
  o ? o().appendChild(p) : document.body.appendChild(p);
  const h = A(/* @__PURE__ */ Me({
    compatConfig: {
      MODE: 3
    },
    name: "NotificationWrapper",
    setup(m, y) {
      let {
        attrs: x
      } = y;
      const g = Be(), S = V(() => Qr.getPrefixCls(a, s)), [, w] = f(S);
      return Lt(() => {
        n({
          notice(_) {
            var b;
            (b = g.value) === null || b === void 0 || b.add(_);
          },
          removeNotice(_) {
            var b;
            (b = g.value) === null || b === void 0 || b.remove(_);
          },
          destroy() {
            ms(null, p), p.parentNode && p.parentNode.removeChild(p);
          },
          component: g
        });
      }), () => {
        const _ = Qr, b = _.getRootPrefixCls(l, S.value), E = c ? u : `${S.value}-${u}`;
        return A(Qu, ve(ve({}, _), {}, {
          prefixCls: b
        }), {
          default: () => [A(Fm, ve(ve({
            ref: g
          }, x), {}, {
            prefixCls: S.value,
            transitionName: E,
            hashId: w.value
          }), null)]
        });
      };
    }
  }), d);
  h.appContext = i || h.appContext, ms(h, p);
};
let H5 = 0;
const Sse = Date.now();
function j5() {
  const e = H5;
  return H5 += 1, `rcNotification_${Sse}_${e}`;
}
const _se = /* @__PURE__ */ Me({
  name: "HookNotification",
  inheritAttrs: !1,
  props: ["prefixCls", "transitionName", "animation", "maxCount", "closeIcon", "hashId", "remove", "notices", "getStyles", "getClassName", "onAllRemoved", "getContainer"],
  setup(e, t) {
    let {
      attrs: n,
      slots: r
    } = t;
    const a = /* @__PURE__ */ new Map(), o = V(() => e.notices), i = V(() => {
      let c = e.transitionName;
      if (!c && e.animation)
        switch (typeof e.animation) {
          case "string":
            c = e.animation;
            break;
          case "function":
            c = e.animation().name;
            break;
          case "object":
            c = e.animation.name;
            break;
          default:
            c = `${e.prefixCls}-fade`;
            break;
        }
      return pC(c);
    }), s = (c) => e.remove(c), l = ne({});
    He(o, () => {
      const c = {};
      Object.keys(l.value).forEach((f) => {
        c[f] = [];
      }), e.notices.forEach((f) => {
        const {
          placement: d = "topRight"
        } = f.notice;
        d && (c[d] = c[d] || [], c[d].push(f));
      }), l.value = c;
    });
    const u = V(() => Object.keys(l.value));
    return () => {
      var c;
      const {
        prefixCls: f,
        closeIcon: d = (c = r.closeIcon) === null || c === void 0 ? void 0 : c.call(r, {
          prefixCls: f
        })
      } = e, p = u.value.map((v) => {
        var h, m;
        const y = l.value[v], x = (h = e.getClassName) === null || h === void 0 ? void 0 : h.call(e, v), g = (m = e.getStyles) === null || m === void 0 ? void 0 : m.call(e, v), S = y.map((b, E) => {
          let {
            notice: C,
            holderCallback: T
          } = b;
          const O = E === o.value.length - 1 ? C.updateMark : void 0, {
            key: I,
            userPassKey: k
          } = C, {
            content: B
          } = C, P = D(D(D({
            prefixCls: f,
            closeIcon: typeof d == "function" ? d({
              prefixCls: f
            }) : d
          }, C), C.props), {
            key: I,
            noticeKey: k || I,
            updateMark: O,
            onClose: (N) => {
              var M;
              s(N), (M = C.onClose) === null || M === void 0 || M.call(C);
            },
            onClick: C.onClick
          });
          return T ? A("div", {
            key: I,
            class: `${f}-hook-holder`,
            ref: (N) => {
              typeof I > "u" || (N ? (a.set(I, N), T(N, P)) : a.delete(I));
            }
          }, null) : A(t7, ve(ve({}, P), {}, {
            class: Ge(P.class, e.hashId)
          }), {
            default: () => [typeof B == "function" ? B({
              prefixCls: f
            }) : B]
          });
        }), w = {
          [f]: 1,
          [`${f}-${v}`]: 1,
          [n.class]: !!n.class,
          [e.hashId]: !0,
          [x]: !!x
        };
        function _() {
          var b;
          y.length > 0 || (Reflect.deleteProperty(l.value, v), (b = e.onAllRemoved) === null || b === void 0 || b.call(e));
        }
        return A("div", {
          key: v,
          class: w,
          style: n.style || g || {
            top: "65px",
            left: "50%"
          }
        }, [A(Ig, ve(ve({
          tag: "div"
        }, i.value), {}, {
          onAfterLeave: _
        }), {
          default: () => [S]
        })]);
      });
      return A(BP, {
        getContainer: e.getContainer
      }, {
        default: () => [p]
      });
    };
  }
}), Cse = _se;
var Ese = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const Tse = () => document.body;
let V5 = 0;
function $se() {
  const e = {};
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return n.forEach((a) => {
    a && Object.keys(a).forEach((o) => {
      const i = a[o];
      i !== void 0 && (e[o] = i);
    });
  }), e;
}
function n7() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    getContainer: t = Tse,
    motion: n,
    prefixCls: r,
    maxCount: a,
    getClassName: o,
    getStyles: i,
    onAllRemoved: s
  } = e, l = Ese(e, ["getContainer", "motion", "prefixCls", "maxCount", "getClassName", "getStyles", "onAllRemoved"]), u = Be([]), c = Be(), f = (y, x) => {
    const g = y.key || j5(), S = D(D({}, y), {
      key: g
    }), w = u.value.map((b) => b.notice.key).indexOf(g), _ = u.value.concat();
    w !== -1 ? _.splice(w, 1, {
      notice: S,
      holderCallback: x
    }) : (a && u.value.length >= a && (S.key = _[0].notice.key, S.updateMark = j5(), S.userPassKey = g, _.shift()), _.push({
      notice: S,
      holderCallback: x
    })), u.value = _;
  }, d = (y) => {
    u.value = u.value.filter((x) => {
      let {
        notice: {
          key: g,
          userPassKey: S
        }
      } = x;
      return (S || g) !== y;
    });
  }, p = () => {
    u.value = [];
  }, v = () => A(Cse, {
    ref: c,
    prefixCls: r,
    maxCount: a,
    notices: u.value,
    remove: d,
    getClassName: o,
    getStyles: i,
    animation: n,
    hashId: e.hashId,
    onAllRemoved: s,
    getContainer: t
  }, null), h = Be([]), m = {
    open: (y) => {
      const x = $se(l, y);
      (x.key === null || x.key === void 0) && (x.key = `vc-notification-${V5}`, V5 += 1), h.value = [...h.value, {
        type: "open",
        config: x
      }];
    },
    close: (y) => {
      h.value = [...h.value, {
        type: "close",
        key: y
      }];
    },
    destroy: () => {
      h.value = [...h.value, {
        type: "destroy"
      }];
    }
  };
  return He(h, () => {
    h.value.length && (h.value.forEach((y) => {
      switch (y.type) {
        case "open":
          f(y.config);
          break;
        case "close":
          d(y.key);
          break;
        case "destroy":
          p();
          break;
      }
    }), h.value = []);
  }), [m, v];
}
const Ose = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    boxShadowSecondary: r,
    colorBgElevated: a,
    colorSuccess: o,
    colorError: i,
    colorWarning: s,
    colorInfo: l,
    fontSizeLG: u,
    motionEaseInOutCirc: c,
    motionDurationSlow: f,
    marginXS: d,
    paddingXS: p,
    borderRadiusLG: v,
    zIndexPopup: h,
    // Custom token
    messageNoticeContentPadding: m
  } = e, y = new rn("MessageMoveIn", {
    "0%": {
      padding: 0,
      transform: "translateY(-100%)",
      opacity: 0
    },
    "100%": {
      padding: p,
      transform: "translateY(0)",
      opacity: 1
    }
  }), x = new rn("MessageMoveOut", {
    "0%": {
      maxHeight: e.height,
      padding: p,
      opacity: 1
    },
    "100%": {
      maxHeight: 0,
      padding: 0,
      opacity: 0
    }
  });
  return [
    // ============================ Holder ============================
    {
      [t]: D(D({}, gr(e)), {
        position: "fixed",
        top: d,
        left: "50%",
        transform: "translateX(-50%)",
        width: "100%",
        pointerEvents: "none",
        zIndex: h,
        [`${t}-move-up`]: {
          animationFillMode: "forwards"
        },
        [`
        ${t}-move-up-appear,
        ${t}-move-up-enter
      `]: {
          animationName: y,
          animationDuration: f,
          animationPlayState: "paused",
          animationTimingFunction: c
        },
        [`
        ${t}-move-up-appear${t}-move-up-appear-active,
        ${t}-move-up-enter${t}-move-up-enter-active
      `]: {
          animationPlayState: "running"
        },
        [`${t}-move-up-leave`]: {
          animationName: x,
          animationDuration: f,
          animationPlayState: "paused",
          animationTimingFunction: c
        },
        [`${t}-move-up-leave${t}-move-up-leave-active`]: {
          animationPlayState: "running"
        },
        "&-rtl": {
          direction: "rtl",
          span: {
            direction: "rtl"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [`${t}-notice`]: {
        padding: p,
        textAlign: "center",
        [n]: {
          verticalAlign: "text-bottom",
          marginInlineEnd: d,
          fontSize: u
        },
        [`${t}-notice-content`]: {
          display: "inline-block",
          padding: m,
          background: a,
          borderRadius: v,
          boxShadow: r,
          pointerEvents: "all"
        },
        [`${t}-success ${n}`]: {
          color: o
        },
        [`${t}-error ${n}`]: {
          color: i
        },
        [`${t}-warning ${n}`]: {
          color: s
        },
        [`
        ${t}-info ${n},
        ${t}-loading ${n}`]: {
          color: l
        }
      }
    },
    // ============================= Pure =============================
    {
      [`${t}-notice-pure-panel`]: {
        padding: 0,
        textAlign: "start"
      }
    }
  ];
}, r7 = xr("Message", (e) => {
  const t = xn(e, {
    messageNoticeContentPadding: `${(e.controlHeightLG - e.fontSize * e.lineHeight) / 2}px ${e.paddingSM}px`
  });
  return [Ose(t)];
}, (e) => ({
  height: 150,
  zIndexPopup: e.zIndexPopupBase + 10
})), Ase = {
  info: A(Pc, null, null),
  success: A(du, null, null),
  error: A(Vo, null, null),
  warning: A(pu, null, null),
  loading: A(el, null, null)
}, Ise = /* @__PURE__ */ Me({
  name: "PureContent",
  inheritAttrs: !1,
  props: ["prefixCls", "type", "icon"],
  setup(e, t) {
    let {
      slots: n
    } = t;
    return () => {
      var r;
      return A("div", {
        class: Ge(`${e.prefixCls}-custom-content`, `${e.prefixCls}-${e.type}`)
      }, [e.icon || Ase[e.type], A("span", null, [(r = n.default) === null || r === void 0 ? void 0 : r.call(n)])]);
    };
  }
});
var Pse = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const Dse = 8, kse = 3, Mse = /* @__PURE__ */ Me({
  name: "Holder",
  inheritAttrs: !1,
  props: ["top", "prefixCls", "getContainer", "maxCount", "duration", "rtl", "transitionName", "onAllRemoved"],
  setup(e, t) {
    let {
      expose: n
    } = t;
    var r, a;
    const {
      getPrefixCls: o,
      getPopupContainer: i
    } = mn("message", e), s = V(() => o("message", e.prefixCls)), [, l] = r7(s), u = () => {
      var h;
      const m = (h = e.top) !== null && h !== void 0 ? h : Dse;
      return {
        left: "50%",
        transform: "translateX(-50%)",
        top: typeof m == "number" ? `${m}px` : m
      };
    }, c = () => Ge(l.value, e.rtl ? `${s.value}-rtl` : ""), f = () => {
      var h;
      return J_({
        prefixCls: s.value,
        animation: (h = e.animation) !== null && h !== void 0 ? h : "move-up",
        transitionName: e.transitionName
      });
    }, d = A("span", {
      class: `${s.value}-close-x`
    }, [A(cu, {
      class: `${s.value}-close-icon`
    }, null)]), [p, v] = n7({
      //@ts-ignore
      getStyles: u,
      prefixCls: s.value,
      getClassName: c,
      motion: f,
      closable: !1,
      closeIcon: d,
      duration: (r = e.duration) !== null && r !== void 0 ? r : kse,
      getContainer: (a = e.staticGetContainer) !== null && a !== void 0 ? a : i.value,
      maxCount: e.maxCount,
      onAllRemoved: e.onAllRemoved
    });
    return n(D(D({}, p), {
      prefixCls: s,
      hashId: l
    })), v;
  }
});
let U5 = 0;
function Rse(e) {
  const t = Be(null), n = Symbol("messageHolderKey"), r = (l) => {
    var u;
    (u = t.value) === null || u === void 0 || u.close(l);
  }, a = (l) => {
    if (!t.value) {
      const w = () => {
      };
      return w.then = () => {
      }, w;
    }
    const {
      open: u,
      prefixCls: c,
      hashId: f
    } = t.value, d = `${c}-notice`, {
      content: p,
      icon: v,
      type: h,
      key: m,
      class: y,
      onClose: x
    } = l, g = Pse(l, ["content", "icon", "type", "key", "class", "onClose"]);
    let S = m;
    return S == null && (U5 += 1, S = `antd-message-${U5}`), JU((w) => (u(D(D({}, g), {
      key: S,
      content: () => A(Ise, {
        prefixCls: c,
        type: h,
        icon: typeof v == "function" ? v() : v
      }, {
        default: () => [typeof p == "function" ? p() : p]
      }),
      placement: "top",
      // @ts-ignore
      class: Ge(h && `${d}-${h}`, f, y),
      onClose: () => {
        x == null || x(), w();
      }
    })), () => {
      r(S);
    }));
  }, i = {
    open: a,
    destroy: (l) => {
      var u;
      l !== void 0 ? r(l) : (u = t.value) === null || u === void 0 || u.destroy();
    }
  };
  return ["info", "success", "warning", "error", "loading"].forEach((l) => {
    const u = (c, f, d) => {
      let p;
      c && typeof c == "object" && "content" in c ? p = c : p = {
        content: c
      };
      let v, h;
      typeof f == "function" ? h = f : (v = f, h = d);
      const m = D(D({
        onClose: h,
        duration: v
      }, p), {
        type: l
      });
      return a(m);
    };
    i[l] = u;
  }), [i, () => A(Mse, ve(ve({
    key: n
  }, e), {}, {
    ref: t
  }), null)];
}
function Nse(e) {
  return Rse(e);
}
let a7 = 3, o7, Wa, Fse = 1, i7 = "", s7 = "move-up", l7 = !1, u7 = () => document.body, c7, f7 = !1;
function Lse() {
  return Fse++;
}
function Bse(e) {
  e.top !== void 0 && (o7 = e.top, Wa = null), e.duration !== void 0 && (a7 = e.duration), e.prefixCls !== void 0 && (i7 = e.prefixCls), e.getContainer !== void 0 && (u7 = e.getContainer, Wa = null), e.transitionName !== void 0 && (s7 = e.transitionName, Wa = null, l7 = !0), e.maxCount !== void 0 && (c7 = e.maxCount, Wa = null), e.rtl !== void 0 && (f7 = e.rtl);
}
function Hse(e, t) {
  if (Wa) {
    t(Wa);
    return;
  }
  Fm.newInstance({
    appContext: e.appContext,
    prefixCls: e.prefixCls || i7,
    rootPrefixCls: e.rootPrefixCls,
    transitionName: s7,
    hasTransitionName: l7,
    style: {
      top: o7
    },
    getContainer: u7 || e.getPopupContainer,
    maxCount: c7,
    name: "message",
    useStyle: r7
  }, (n) => {
    if (Wa) {
      t(Wa);
      return;
    }
    Wa = n, t(n);
  });
}
const d7 = {
  info: Pc,
  success: du,
  error: Vo,
  warning: pu,
  loading: el
}, jse = Object.keys(d7);
function Vse(e) {
  const t = e.duration !== void 0 ? e.duration : a7, n = e.key || Lse(), r = new Promise((o) => {
    const i = () => (typeof e.onClose == "function" && e.onClose(), o(!0));
    Hse(e, (s) => {
      s.notice({
        key: n,
        duration: t,
        style: e.style || {},
        class: e.class,
        content: (l) => {
          let {
            prefixCls: u
          } = l;
          const c = d7[e.type], f = c ? A(c, null, null) : "", d = Ge(`${u}-custom-content`, {
            [`${u}-${e.type}`]: e.type,
            [`${u}-rtl`]: f7 === !0
          });
          return A("div", {
            class: d
          }, [typeof e.icon == "function" ? e.icon() : e.icon || f, A("span", null, [typeof e.content == "function" ? e.content() : e.content])]);
        },
        onClose: i,
        onClick: e.onClick
      });
    });
  }), a = () => {
    Wa && Wa.removeNotice(n);
  };
  return a.then = (o, i) => r.then(o, i), a.promise = r, a;
}
function Use(e) {
  return Object.prototype.toString.call(e) === "[object Object]" && !!e.content;
}
const wt = {
  open: Vse,
  config: Bse,
  destroy(e) {
    if (Wa)
      if (e) {
        const {
          removeNotice: t
        } = Wa;
        t(e);
      } else {
        const {
          destroy: t
        } = Wa;
        t(), Wa = null;
      }
  }
};
function zse(e, t) {
  e[t] = (n, r, a) => Use(n) ? e.open(D(D({}, n), {
    type: t
  })) : (typeof r == "function" && (a = r, r = void 0), e.open({
    content: n,
    duration: r,
    type: t,
    onClose: a
  }));
}
jse.forEach((e) => zse(wt, e));
wt.warn = wt.warning;
wt.useMessage = Nse;
const Wse = (e) => {
  const {
    componentCls: t,
    width: n,
    notificationMarginEdge: r
  } = e, a = new rn("antNotificationTopFadeIn", {
    "0%": {
      marginTop: "-100%",
      opacity: 0
    },
    "100%": {
      marginTop: 0,
      opacity: 1
    }
  }), o = new rn("antNotificationBottomFadeIn", {
    "0%": {
      marginBottom: "-100%",
      opacity: 0
    },
    "100%": {
      marginBottom: 0,
      opacity: 1
    }
  }), i = new rn("antNotificationLeftFadeIn", {
    "0%": {
      right: {
        _skip_check_: !0,
        value: n
      },
      opacity: 0
    },
    "100%": {
      right: {
        _skip_check_: !0,
        value: 0
      },
      opacity: 1
    }
  });
  return {
    [`&${t}-top, &${t}-bottom`]: {
      marginInline: 0
    },
    [`&${t}-top`]: {
      [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
        animationName: a
      }
    },
    [`&${t}-bottom`]: {
      [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
        animationName: o
      }
    },
    [`&${t}-topLeft, &${t}-bottomLeft`]: {
      marginInlineEnd: 0,
      marginInlineStart: r,
      [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
        animationName: i
      }
    }
  };
}, Gse = (e) => {
  const {
    iconCls: t,
    componentCls: n,
    // .ant-notification
    boxShadowSecondary: r,
    fontSizeLG: a,
    notificationMarginBottom: o,
    borderRadiusLG: i,
    colorSuccess: s,
    colorInfo: l,
    colorWarning: u,
    colorError: c,
    colorTextHeading: f,
    notificationBg: d,
    notificationPadding: p,
    notificationMarginEdge: v,
    motionDurationMid: h,
    motionEaseInOut: m,
    fontSize: y,
    lineHeight: x,
    width: g,
    notificationIconSize: S
  } = e, w = `${n}-notice`, _ = new rn("antNotificationFadeIn", {
    "0%": {
      left: {
        _skip_check_: !0,
        value: g
      },
      opacity: 0
    },
    "100%": {
      left: {
        _skip_check_: !0,
        value: 0
      },
      opacity: 1
    }
  }), b = new rn("antNotificationFadeOut", {
    "0%": {
      maxHeight: e.animationMaxHeight,
      marginBottom: o,
      opacity: 1
    },
    "100%": {
      maxHeight: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
      opacity: 0
    }
  });
  return [
    // ============================ Holder ============================
    {
      [n]: D(D(D(D({}, gr(e)), {
        position: "fixed",
        zIndex: e.zIndexPopup,
        marginInlineEnd: v,
        [`${n}-hook-holder`]: {
          position: "relative"
        },
        [`&${n}-top, &${n}-bottom`]: {
          [`${n}-notice`]: {
            marginInline: "auto auto"
          }
        },
        [`&${n}-topLeft, &${n}-bottomLeft`]: {
          [`${n}-notice`]: {
            marginInlineEnd: "auto",
            marginInlineStart: 0
          }
        },
        //  animation
        [`${n}-fade-enter, ${n}-fade-appear`]: {
          animationDuration: e.motionDurationMid,
          animationTimingFunction: m,
          animationFillMode: "both",
          opacity: 0,
          animationPlayState: "paused"
        },
        [`${n}-fade-leave`]: {
          animationTimingFunction: m,
          animationFillMode: "both",
          animationDuration: h,
          animationPlayState: "paused"
        },
        [`${n}-fade-enter${n}-fade-enter-active, ${n}-fade-appear${n}-fade-appear-active`]: {
          animationName: _,
          animationPlayState: "running"
        },
        [`${n}-fade-leave${n}-fade-leave-active`]: {
          animationName: b,
          animationPlayState: "running"
        }
      }), Wse(e)), {
        // RTL
        "&-rtl": {
          direction: "rtl",
          [`${n}-notice-btn`]: {
            float: "left"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [w]: {
        position: "relative",
        width: g,
        maxWidth: `calc(100vw - ${v * 2}px)`,
        marginBottom: o,
        marginInlineStart: "auto",
        padding: p,
        overflow: "hidden",
        lineHeight: x,
        wordWrap: "break-word",
        background: d,
        borderRadius: i,
        boxShadow: r,
        [`${n}-close-icon`]: {
          fontSize: y,
          cursor: "pointer"
        },
        [`${w}-message`]: {
          marginBottom: e.marginXS,
          color: f,
          fontSize: a,
          lineHeight: e.lineHeightLG
        },
        [`${w}-description`]: {
          fontSize: y
        },
        [`&${w}-closable ${w}-message`]: {
          paddingInlineEnd: e.paddingLG
        },
        [`${w}-with-icon ${w}-message`]: {
          marginBottom: e.marginXS,
          marginInlineStart: e.marginSM + S,
          fontSize: a
        },
        [`${w}-with-icon ${w}-description`]: {
          marginInlineStart: e.marginSM + S,
          fontSize: y
        },
        // Icon & color style in different selector level
        // https://github.com/ant-design/ant-design/issues/16503
        // https://github.com/ant-design/ant-design/issues/15512
        [`${w}-icon`]: {
          position: "absolute",
          fontSize: S,
          lineHeight: 0,
          // icon-font
          [`&-success${t}`]: {
            color: s
          },
          [`&-info${t}`]: {
            color: l
          },
          [`&-warning${t}`]: {
            color: u
          },
          [`&-error${t}`]: {
            color: c
          }
        },
        [`${w}-close`]: {
          position: "absolute",
          top: e.notificationPaddingVertical,
          insetInlineEnd: e.notificationPaddingHorizontal,
          color: e.colorIcon,
          outline: "none",
          width: e.notificationCloseButtonSize,
          height: e.notificationCloseButtonSize,
          borderRadius: e.borderRadiusSM,
          transition: `background-color ${e.motionDurationMid}, color ${e.motionDurationMid}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&:hover": {
            color: e.colorIconHover,
            backgroundColor: e.wireframe ? "transparent" : e.colorFillContent
          }
        },
        [`${w}-btn`]: {
          float: "right",
          marginTop: e.marginSM
        }
      }
    },
    // ============================= Pure =============================
    {
      [`${w}-pure-panel`]: {
        margin: 0
      }
    }
  ];
}, p7 = xr("Notification", (e) => {
  const t = e.paddingMD, n = e.paddingLG, r = xn(e, {
    // default.less variables
    notificationBg: e.colorBgElevated,
    notificationPaddingVertical: t,
    notificationPaddingHorizontal: n,
    // index.less variables
    notificationPadding: `${e.paddingMD}px ${e.paddingContentHorizontalLG}px`,
    notificationMarginBottom: e.margin,
    notificationMarginEdge: e.marginLG,
    animationMaxHeight: 150,
    notificationIconSize: e.fontSizeLG * e.lineHeightLG,
    notificationCloseButtonSize: e.controlHeightLG * 0.55
  });
  return [Gse(r)];
}, (e) => ({
  zIndexPopup: e.zIndexPopupBase + 50,
  width: 384
}));
function Kse(e, t) {
  return t || A("span", {
    class: `${e}-close-x`
  }, [A(cu, {
    class: `${e}-close-icon`
  }, null)]);
}
A(Pc, null, null), A(du, null, null), A(Vo, null, null), A(pu, null, null), A(el, null, null);
const Yse = {
  success: du,
  info: Pc,
  error: Vo,
  warning: pu
};
function qse(e) {
  let {
    prefixCls: t,
    icon: n,
    type: r,
    message: a,
    description: o,
    btn: i
  } = e, s = null;
  if (n)
    s = A("span", {
      class: `${t}-icon`
    }, [df(n)]);
  else if (r) {
    const l = Yse[r];
    s = A(l, {
      class: `${t}-icon ${t}-icon-${r}`
    }, null);
  }
  return A("div", {
    class: Ge({
      [`${t}-with-icon`]: s
    }),
    role: "alert"
  }, [s, A("div", {
    class: `${t}-message`
  }, [a]), A("div", {
    class: `${t}-description`
  }, [o]), i && A("div", {
    class: `${t}-btn`
  }, [i])]);
}
function h7(e, t, n) {
  let r;
  switch (t = typeof t == "number" ? `${t}px` : t, n = typeof n == "number" ? `${n}px` : n, e) {
    case "top":
      r = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: t,
        bottom: "auto"
      };
      break;
    case "topLeft":
      r = {
        left: 0,
        top: t,
        bottom: "auto"
      };
      break;
    case "topRight":
      r = {
        right: 0,
        top: t,
        bottom: "auto"
      };
      break;
    case "bottom":
      r = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: "auto",
        bottom: n
      };
      break;
    case "bottomLeft":
      r = {
        left: 0,
        top: "auto",
        bottom: n
      };
      break;
    default:
      r = {
        right: 0,
        top: "auto",
        bottom: n
      };
      break;
  }
  return r;
}
function Xse(e) {
  return {
    name: `${e}-fade`
  };
}
var Zse = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const z5 = 24, Qse = 4.5, Jse = /* @__PURE__ */ Me({
  name: "Holder",
  inheritAttrs: !1,
  props: ["prefixCls", "class", "type", "icon", "content", "onAllRemoved"],
  setup(e, t) {
    let {
      expose: n
    } = t;
    const {
      getPrefixCls: r,
      getPopupContainer: a
    } = mn("notification", e), o = V(() => e.prefixCls || r("notification")), i = (d) => {
      var p, v;
      return h7(d, (p = e.top) !== null && p !== void 0 ? p : z5, (v = e.bottom) !== null && v !== void 0 ? v : z5);
    }, [, s] = p7(o), l = () => Ge(s.value, {
      [`${o.value}-rtl`]: e.rtl
    }), u = () => Xse(o.value), [c, f] = n7({
      prefixCls: o.value,
      getStyles: i,
      getClassName: l,
      motion: u,
      closable: !0,
      closeIcon: Kse(o.value),
      duration: Qse,
      getContainer: () => {
        var d, p;
        return ((d = e.getPopupContainer) === null || d === void 0 ? void 0 : d.call(e)) || ((p = a.value) === null || p === void 0 ? void 0 : p.call(a)) || document.body;
      },
      maxCount: e.maxCount,
      hashId: s.value,
      onAllRemoved: e.onAllRemoved
    });
    return n(D(D({}, c), {
      prefixCls: o.value,
      hashId: s
    })), f;
  }
});
function ele(e) {
  const t = Be(null), n = Symbol("notificationHolderKey"), r = (s) => {
    if (!t.value)
      return;
    const {
      open: l,
      prefixCls: u,
      hashId: c
    } = t.value, f = `${u}-notice`, {
      message: d,
      description: p,
      icon: v,
      type: h,
      btn: m,
      class: y
    } = s, x = Zse(s, ["message", "description", "icon", "type", "btn", "class"]);
    return l(D(D({
      placement: "topRight"
    }, x), {
      content: () => A(qse, {
        prefixCls: f,
        icon: typeof v == "function" ? v() : v,
        type: h,
        message: typeof d == "function" ? d() : d,
        description: typeof p == "function" ? p() : p,
        btn: typeof m == "function" ? m() : m
      }, null),
      // @ts-ignore
      class: Ge(h && `${f}-${h}`, c, y)
    }));
  }, o = {
    open: r,
    destroy: (s) => {
      var l, u;
      s !== void 0 ? (l = t.value) === null || l === void 0 || l.close(s) : (u = t.value) === null || u === void 0 || u.destroy();
    }
  };
  return ["success", "info", "warning", "error"].forEach((s) => {
    o[s] = (l) => r(D(D({}, l), {
      type: s
    }));
  }), [o, () => A(Jse, ve(ve({
    key: n
  }, e), {}, {
    ref: t
  }), null)];
}
function tle(e) {
  return ele(e);
}
const Du = {};
let v7 = 4.5, m7 = "24px", g7 = "24px", A2 = "", y7 = "topRight", x7 = () => document.body, b7 = null, I2 = !1, w7;
function nle(e) {
  const {
    duration: t,
    placement: n,
    bottom: r,
    top: a,
    getContainer: o,
    closeIcon: i,
    prefixCls: s
  } = e;
  s !== void 0 && (A2 = s), t !== void 0 && (v7 = t), n !== void 0 && (y7 = n), r !== void 0 && (g7 = typeof r == "number" ? `${r}px` : r), a !== void 0 && (m7 = typeof a == "number" ? `${a}px` : a), o !== void 0 && (x7 = o), i !== void 0 && (b7 = i), e.rtl !== void 0 && (I2 = e.rtl), e.maxCount !== void 0 && (w7 = e.maxCount);
}
function rle(e, t) {
  let {
    prefixCls: n,
    placement: r = y7,
    getContainer: a = x7,
    top: o,
    bottom: i,
    closeIcon: s = b7,
    appContext: l
  } = e;
  const {
    getPrefixCls: u
  } = vle(), c = u("notification", n || A2), f = `${c}-${r}-${I2}`, d = Du[f];
  if (d) {
    Promise.resolve(d).then((v) => {
      t(v);
    });
    return;
  }
  const p = Ge(`${c}-${r}`, {
    [`${c}-rtl`]: I2 === !0
  });
  Fm.newInstance({
    name: "notification",
    prefixCls: n || A2,
    useStyle: p7,
    class: p,
    style: h7(r, o ?? m7, i ?? g7),
    appContext: l,
    getContainer: a,
    closeIcon: (v) => {
      let {
        prefixCls: h
      } = v;
      return A("span", {
        class: `${h}-close-x`
      }, [df(s, {}, A(cu, {
        class: `${h}-close-icon`
      }, null))]);
    },
    maxCount: w7,
    hasTransitionName: !0
  }, (v) => {
    Du[f] = v, t(v);
  });
}
const ale = {
  success: NC,
  info: LC,
  error: BC,
  warning: FC
};
function ole(e) {
  const {
    icon: t,
    type: n,
    description: r,
    message: a,
    btn: o
  } = e, i = e.duration === void 0 ? v7 : e.duration;
  rle(e, (s) => {
    s.notice({
      content: (l) => {
        let {
          prefixCls: u
        } = l;
        const c = `${u}-notice`;
        let f = null;
        if (t)
          f = () => A("span", {
            class: `${c}-icon`
          }, [df(t)]);
        else if (n) {
          const d = ale[n];
          f = () => A(d, {
            class: `${c}-icon ${c}-icon-${n}`
          }, null);
        }
        return A("div", {
          class: f ? `${c}-with-icon` : ""
        }, [f && f(), A("div", {
          class: `${c}-message`
        }, [!r && f ? A("span", {
          class: `${c}-message-single-line-auto-margin`
        }, null) : null, df(a)]), A("div", {
          class: `${c}-description`
        }, [df(r)]), o ? A("span", {
          class: `${c}-btn`
        }, [df(o)]) : null]);
      },
      duration: i,
      closable: !0,
      onClose: e.onClose,
      onClick: e.onClick,
      key: e.key,
      style: e.style || {},
      class: e.class
    });
  });
}
const td = {
  open: ole,
  close(e) {
    Object.keys(Du).forEach((t) => Promise.resolve(Du[t]).then((n) => {
      n.removeNotice(e);
    }));
  },
  config: nle,
  destroy() {
    Object.keys(Du).forEach((e) => {
      Promise.resolve(Du[e]).then((t) => {
        t.destroy();
      }), delete Du[e];
    });
  }
}, ile = ["success", "info", "warning", "error"];
ile.forEach((e) => {
  td[e] = (t) => td.open(D(D({}, t), {
    type: e
  }));
});
td.warn = td.warning;
td.useNotification = tle;
const sle = `-ant-${Date.now()}-${Math.random()}`;
function lle(e, t) {
  const n = {}, r = (i, s) => {
    let l = i.clone();
    return l = (s == null ? void 0 : s(l)) || l, l.toRgbString();
  }, a = (i, s) => {
    const l = new ir(i), u = fc(l.toRgbString());
    n[`${s}-color`] = r(l), n[`${s}-color-disabled`] = u[1], n[`${s}-color-hover`] = u[4], n[`${s}-color-active`] = u[6], n[`${s}-color-outline`] = l.clone().setAlpha(0.2).toRgbString(), n[`${s}-color-deprecated-bg`] = u[0], n[`${s}-color-deprecated-border`] = u[2];
  };
  if (t.primaryColor) {
    a(t.primaryColor, "primary");
    const i = new ir(t.primaryColor), s = fc(i.toRgbString());
    s.forEach((u, c) => {
      n[`primary-${c + 1}`] = u;
    }), n["primary-color-deprecated-l-35"] = r(i, (u) => u.lighten(35)), n["primary-color-deprecated-l-20"] = r(i, (u) => u.lighten(20)), n["primary-color-deprecated-t-20"] = r(i, (u) => u.tint(20)), n["primary-color-deprecated-t-50"] = r(i, (u) => u.tint(50)), n["primary-color-deprecated-f-12"] = r(i, (u) => u.setAlpha(u.getAlpha() * 0.12));
    const l = new ir(s[0]);
    n["primary-color-active-deprecated-f-30"] = r(l, (u) => u.setAlpha(u.getAlpha() * 0.3)), n["primary-color-active-deprecated-d-02"] = r(l, (u) => u.darken(2));
  }
  return t.successColor && a(t.successColor, "success"), t.warningColor && a(t.warningColor, "warning"), t.errorColor && a(t.errorColor, "error"), t.infoColor && a(t.infoColor, "info"), `
  :root {
    ${Object.keys(n).map((i) => `--${e}-${i}: ${n[i]};`).join(`
`)}
  }
  `.trim();
}
function ule(e, t) {
  const n = lle(e, t);
  li() ? np(n, `${sle}-dynamic-theme`) : Pa(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const cle = (e) => {
  const [t, n] = bd();
  return Bb(V(() => ({
    theme: t.value,
    token: n.value,
    hashId: "",
    path: ["ant-design-icons", e.value]
  })), () => [{
    [`.${e.value}`]: D(D({}, Zg()), {
      [`.${e.value} .${e.value}-icon`]: {
        display: "block"
      }
    })
  }]);
};
function fle(e, t) {
  const n = V(() => (e == null ? void 0 : e.value) || {}), r = V(() => n.value.inherit === !1 || !(t != null && t.value) ? YI : t.value);
  return V(() => {
    if (!(e != null && e.value))
      return t == null ? void 0 : t.value;
    const o = D({}, r.value.components);
    return Object.keys(e.value.components || {}).forEach((i) => {
      o[i] = D(D({}, o[i]), e.value.components[i]);
    }), D(D(D({}, r.value), n.value), {
      token: D(D({}, r.value.token), n.value.token),
      components: o
    });
  });
}
var dle = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const ple = "ant";
function Af() {
  return Qr.prefixCls || ple;
}
function S7() {
  return Qr.iconPrefixCls || V_;
}
const y4 = Wn({}), Qr = Wn({});
_n(() => {
  D(Qr, y4), Qr.prefixCls = Af(), Qr.iconPrefixCls = S7(), Qr.getPrefixCls = (e, t) => t || (e ? `${Qr.prefixCls}-${e}` : Qr.prefixCls), Qr.getRootPrefixCls = () => Qr.prefixCls ? Qr.prefixCls : Af();
});
let Qy;
const hle = (e) => {
  Qy && Qy(), Qy = _n(() => {
    D(y4, Wn(e)), D(Qr, Wn(e));
  }), e.theme && ule(Af(), e.theme);
}, vle = () => ({
  getPrefixCls: (e, t) => t || (e ? `${Af()}-${e}` : Af()),
  getIconPrefixCls: S7,
  getRootPrefixCls: () => Qr.prefixCls ? Qr.prefixCls : Af()
}), Qu = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AConfigProvider",
  inheritAttrs: !1,
  props: Cz(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const r = z_(), a = (P, N) => {
      const {
        prefixCls: M = "ant"
      } = e;
      if (N) return N;
      const H = M || r.getPrefixCls("");
      return P ? `${H}-${P}` : H;
    }, o = V(() => e.iconPrefixCls || r.iconPrefixCls.value || V_), i = V(() => o.value !== r.iconPrefixCls.value), s = V(() => {
      var P;
      return e.csp || ((P = r.csp) === null || P === void 0 ? void 0 : P.value);
    }), l = cle(o), u = fle(V(() => e.theme), V(() => {
      var P;
      return (P = r.theme) === null || P === void 0 ? void 0 : P.value;
    })), c = (P) => (e.renderEmpty || n.renderEmpty || r.renderEmpty || pG)(P), f = V(() => {
      var P, N;
      return (P = e.autoInsertSpaceInButton) !== null && P !== void 0 ? P : (N = r.autoInsertSpaceInButton) === null || N === void 0 ? void 0 : N.value;
    }), d = V(() => {
      var P;
      return e.locale || ((P = r.locale) === null || P === void 0 ? void 0 : P.value);
    });
    He(d, () => {
      y4.locale = d.value;
    }, {
      immediate: !0
    });
    const p = V(() => {
      var P;
      return e.direction || ((P = r.direction) === null || P === void 0 ? void 0 : P.value);
    }), v = V(() => {
      var P, N;
      return (P = e.space) !== null && P !== void 0 ? P : (N = r.space) === null || N === void 0 ? void 0 : N.value;
    }), h = V(() => {
      var P, N;
      return (P = e.virtual) !== null && P !== void 0 ? P : (N = r.virtual) === null || N === void 0 ? void 0 : N.value;
    }), m = V(() => {
      var P, N;
      return (P = e.dropdownMatchSelectWidth) !== null && P !== void 0 ? P : (N = r.dropdownMatchSelectWidth) === null || N === void 0 ? void 0 : N.value;
    }), y = V(() => {
      var P;
      return e.getTargetContainer !== void 0 ? e.getTargetContainer : (P = r.getTargetContainer) === null || P === void 0 ? void 0 : P.value;
    }), x = V(() => {
      var P;
      return e.getPopupContainer !== void 0 ? e.getPopupContainer : (P = r.getPopupContainer) === null || P === void 0 ? void 0 : P.value;
    }), g = V(() => {
      var P;
      return e.pageHeader !== void 0 ? e.pageHeader : (P = r.pageHeader) === null || P === void 0 ? void 0 : P.value;
    }), S = V(() => {
      var P;
      return e.input !== void 0 ? e.input : (P = r.input) === null || P === void 0 ? void 0 : P.value;
    }), w = V(() => {
      var P;
      return e.pagination !== void 0 ? e.pagination : (P = r.pagination) === null || P === void 0 ? void 0 : P.value;
    }), _ = V(() => {
      var P;
      return e.form !== void 0 ? e.form : (P = r.form) === null || P === void 0 ? void 0 : P.value;
    }), b = V(() => {
      var P;
      return e.select !== void 0 ? e.select : (P = r.select) === null || P === void 0 ? void 0 : P.value;
    }), E = V(() => e.componentSize), C = V(() => e.componentDisabled), T = V(() => {
      var P, N;
      return (P = e.wave) !== null && P !== void 0 ? P : (N = r.wave) === null || N === void 0 ? void 0 : N.value;
    }), O = {
      csp: s,
      autoInsertSpaceInButton: f,
      locale: d,
      direction: p,
      space: v,
      virtual: h,
      dropdownMatchSelectWidth: m,
      getPrefixCls: a,
      iconPrefixCls: o,
      theme: V(() => {
        var P, N;
        return (P = u.value) !== null && P !== void 0 ? P : (N = r.theme) === null || N === void 0 ? void 0 : N.value;
      }),
      renderEmpty: c,
      getTargetContainer: y,
      getPopupContainer: x,
      pageHeader: g,
      input: S,
      pagination: w,
      form: _,
      select: b,
      componentSize: E,
      componentDisabled: C,
      transformCellText: V(() => e.transformCellText),
      wave: T
    }, I = V(() => {
      const P = u.value || {}, {
        algorithm: N,
        token: M
      } = P, H = dle(P, ["algorithm", "token"]), R = N && (!Array.isArray(N) || N.length > 0) ? II(N) : void 0;
      return D(D({}, H), {
        theme: R,
        token: D(D({}, Xg), M)
      });
    }), k = V(() => {
      var P, N;
      let M = {};
      return d.value && (M = ((P = d.value.Form) === null || P === void 0 ? void 0 : P.defaultValidateMessages) || ((N = tu.Form) === null || N === void 0 ? void 0 : N.defaultValidateMessages) || {}), e.form && e.form.validateMessages && (M = D(D({}, M), e.form.validateMessages)), M;
    });
    Ez(O), Sz({
      validateMessages: k
    }), nP(E), mI(C);
    const B = (P) => {
      var N, M;
      let H = i.value ? l((N = n.default) === null || N === void 0 ? void 0 : N.call(n)) : (M = n.default) === null || M === void 0 ? void 0 : M.call(n);
      if (e.theme) {
        const R = /* @__PURE__ */ function() {
          return H;
        }();
        H = A(lG, {
          value: I.value
        }, {
          default: () => [R]
        });
      }
      return A(xse, {
        locale: d.value || P,
        ANT_MARK__: O2
      }, {
        default: () => [H]
      });
    };
    return _n(() => {
      p.value && (wt.config({
        rtl: p.value === "rtl"
      }), td.config({
        rtl: p.value === "rtl"
      }));
    }), () => A(xI, {
      children: (P, N, M) => B(M)
    }, null);
  }
});
Qu.config = hle;
Qu.install = function(e) {
  e.component(Qu.name, Qu);
};
const mle = (e, t) => {
  let {
    attrs: n,
    slots: r
  } = t;
  return A(fn, ve(ve({
    size: "small",
    type: "primary"
  }, e), n), r);
}, Zh = (e, t, n) => {
  const r = XU(n);
  return {
    [`${e.componentCls}-${t}`]: {
      color: e[`color${n}`],
      background: e[`color${r}Bg`],
      borderColor: e[`color${r}Border`],
      [`&${e.componentCls}-borderless`]: {
        borderColor: "transparent"
      }
    }
  };
}, gle = (e) => GI(e, (t, n) => {
  let {
    textColor: r,
    lightBorderColor: a,
    lightColor: o,
    darkColor: i
  } = n;
  return {
    [`${e.componentCls}-${t}`]: {
      color: r,
      background: o,
      borderColor: a,
      // Inverse color
      "&-inverse": {
        color: e.colorTextLightSolid,
        background: i,
        borderColor: i
      },
      [`&${e.componentCls}-borderless`]: {
        borderColor: "transparent"
      }
    }
  };
}), yle = (e) => {
  const {
    paddingXXS: t,
    lineWidth: n,
    tagPaddingHorizontal: r,
    componentCls: a
  } = e, o = r - n, i = t - n;
  return {
    // Result
    [a]: D(D({}, gr(e)), {
      display: "inline-block",
      height: "auto",
      marginInlineEnd: e.marginXS,
      paddingInline: o,
      fontSize: e.tagFontSize,
      lineHeight: `${e.tagLineHeight}px`,
      whiteSpace: "nowrap",
      background: e.tagDefaultBg,
      border: `${e.lineWidth}px ${e.lineType} ${e.colorBorder}`,
      borderRadius: e.borderRadiusSM,
      opacity: 1,
      transition: `all ${e.motionDurationMid}`,
      textAlign: "start",
      // RTL
      [`&${a}-rtl`]: {
        direction: "rtl"
      },
      "&, a, a:hover": {
        color: e.tagDefaultColor
      },
      [`${a}-close-icon`]: {
        marginInlineStart: i,
        color: e.colorTextDescription,
        fontSize: e.tagIconSize,
        cursor: "pointer",
        transition: `all ${e.motionDurationMid}`,
        "&:hover": {
          color: e.colorTextHeading
        }
      },
      [`&${a}-has-color`]: {
        borderColor: "transparent",
        [`&, a, a:hover, ${e.iconCls}-close, ${e.iconCls}-close:hover`]: {
          color: e.colorTextLightSolid
        }
      },
      "&-checkable": {
        backgroundColor: "transparent",
        borderColor: "transparent",
        cursor: "pointer",
        [`&:not(${a}-checkable-checked):hover`]: {
          color: e.colorPrimary,
          backgroundColor: e.colorFillSecondary
        },
        "&:active, &-checked": {
          color: e.colorTextLightSolid
        },
        "&-checked": {
          backgroundColor: e.colorPrimary,
          "&:hover": {
            backgroundColor: e.colorPrimaryHover
          }
        },
        "&:active": {
          backgroundColor: e.colorPrimaryActive
        }
      },
      "&-hidden": {
        display: "none"
      },
      // To ensure that a space will be placed between character and `Icon`.
      [`> ${e.iconCls} + span, > span + ${e.iconCls}`]: {
        marginInlineStart: o
      }
    }),
    [`${a}-borderless`]: {
      borderColor: "transparent",
      background: e.tagBorderlessBg
    }
  };
}, _7 = xr("Tag", (e) => {
  const {
    fontSize: t,
    lineHeight: n,
    lineWidth: r,
    fontSizeIcon: a
  } = e, o = Math.round(t * n), i = e.fontSizeSM, s = o - r * 2, l = e.colorFillAlter, u = e.colorText, c = xn(e, {
    tagFontSize: i,
    tagLineHeight: s,
    tagDefaultBg: l,
    tagDefaultColor: u,
    tagIconSize: a - 2 * r,
    tagPaddingHorizontal: 8,
    tagBorderlessBg: e.colorFillTertiary
  });
  return [yle(c), gle(c), Zh(c, "success", "Success"), Zh(c, "processing", "Info"), Zh(c, "error", "Error"), Zh(c, "warning", "Warning")];
}), xle = () => ({
  prefixCls: String,
  checked: {
    type: Boolean,
    default: void 0
  },
  onChange: {
    type: Function
  },
  onClick: {
    type: Function
  },
  "onUpdate:checked": Function
}), P2 = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ACheckableTag",
  inheritAttrs: !1,
  props: xle(),
  // emits: ['update:checked', 'change', 'click'],
  setup(e, t) {
    let {
      slots: n,
      emit: r,
      attrs: a
    } = t;
    const {
      prefixCls: o
    } = mn("tag", e), [i, s] = _7(o), l = (c) => {
      const {
        checked: f
      } = e;
      r("update:checked", !f), r("change", !f), r("click", c);
    }, u = V(() => Ge(o.value, s.value, {
      [`${o.value}-checkable`]: !0,
      [`${o.value}-checkable-checked`]: e.checked
    }));
    return () => {
      var c;
      return i(A("span", ve(ve({}, a), {}, {
        class: [u.value, a.class],
        onClick: l
      }), [(c = n.default) === null || c === void 0 ? void 0 : c.call(n)]));
    };
  }
}), ble = () => ({
  prefixCls: String,
  color: {
    type: String
  },
  closable: {
    type: Boolean,
    default: !1
  },
  closeIcon: Oe.any,
  /** @deprecated `visible` will be removed in next major version. */
  visible: {
    type: Boolean,
    default: void 0
  },
  onClose: {
    type: Function
  },
  onClick: Vf(),
  "onUpdate:visible": Function,
  icon: Oe.any,
  bordered: {
    type: Boolean,
    default: !0
  }
}), fs = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ATag",
  inheritAttrs: !1,
  props: ble(),
  // emits: ['update:visible', 'close'],
  slots: Object,
  setup(e, t) {
    let {
      slots: n,
      emit: r,
      attrs: a
    } = t;
    const {
      prefixCls: o,
      direction: i
    } = mn("tag", e), [s, l] = _7(o), u = Be(!0);
    process.env.NODE_ENV !== "production" && Pa(e.visible === void 0, "Tag", '`visible` is deprecated, please use `<Tag v-show="visible" />` instead.'), _n(() => {
      e.visible !== void 0 && (u.value = e.visible);
    });
    const c = (v) => {
      v.stopPropagation(), r("update:visible", !1), r("close", v), !v.defaultPrevented && e.visible === void 0 && (u.value = !1);
    }, f = V(() => DD(e.color) || Nne(e.color)), d = V(() => Ge(o.value, l.value, {
      [`${o.value}-${e.color}`]: f.value,
      [`${o.value}-has-color`]: e.color && !f.value,
      [`${o.value}-hidden`]: !u.value,
      [`${o.value}-rtl`]: i.value === "rtl",
      [`${o.value}-borderless`]: !e.bordered
    })), p = (v) => {
      r("click", v);
    };
    return () => {
      var v, h, m;
      const {
        icon: y = (v = n.icon) === null || v === void 0 ? void 0 : v.call(n),
        color: x,
        closeIcon: g = (h = n.closeIcon) === null || h === void 0 ? void 0 : h.call(n),
        closable: S = !1
      } = e, w = () => S ? g ? A("span", {
        class: `${o.value}-close-icon`,
        onClick: c
      }, [g]) : A(cu, {
        class: `${o.value}-close-icon`,
        onClick: c
      }, null) : null, _ = {
        backgroundColor: x && !f.value ? x : void 0
      }, b = y || null, E = (m = n.default) === null || m === void 0 ? void 0 : m.call(n), C = b ? A(dt, null, [b, A("span", null, [E])]) : E, T = e.onClick !== void 0, O = A("span", ve(ve({}, a), {}, {
        onClick: p,
        class: [d.value, a.class],
        style: [_, a.style]
      }), [C, w()]);
      return s(T ? A(RD, null, {
        default: () => [O]
      }) : O);
    };
  }
});
fs.CheckableTag = P2;
fs.install = function(e) {
  return e.component(fs.name, fs), e.component(P2.name, P2), e;
};
function wle(e, t) {
  let {
    slots: n,
    attrs: r
  } = t;
  return A(fs, ve(ve({
    color: "blue"
  }, e), r), n);
}
var Sle = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, name: "calendar", theme: "outlined" };
function W5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      _le(e, a, n[a]);
    });
  }
  return e;
}
function _le(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var k1 = function(t, n) {
  var r = W5({}, t, n.attrs);
  return A(Bn, W5({}, r, {
    icon: Sle
  }), null);
};
k1.displayName = "CalendarOutlined";
k1.inheritAttrs = !1;
var Cle = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, name: "clock-circle", theme: "outlined" };
function G5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      Ele(e, a, n[a]);
    });
  }
  return e;
}
function Ele(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var M1 = function(t, n) {
  var r = G5({}, t, n.attrs);
  return A(Bn, G5({}, r, {
    icon: Cle
  }), null);
};
M1.displayName = "ClockCircleOutlined";
M1.inheritAttrs = !1;
function Tle(e, t, n) {
  return n !== void 0 ? n : t === "year" && e.lang.yearPlaceholder ? e.lang.yearPlaceholder : t === "quarter" && e.lang.quarterPlaceholder ? e.lang.quarterPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.monthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.weekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.placeholder : e.lang.placeholder;
}
function $le(e, t, n) {
  return n !== void 0 ? n : t === "year" && e.lang.yearPlaceholder ? e.lang.rangeYearPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.rangeMonthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.rangeWeekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.rangePlaceholder : e.lang.rangePlaceholder;
}
function C7(e, t) {
  const n = {
    adjustX: 1,
    adjustY: 1
  };
  switch (t) {
    case "bottomLeft":
      return {
        points: ["tl", "bl"],
        offset: [0, 4],
        overflow: n
      };
    case "bottomRight":
      return {
        points: ["tr", "br"],
        offset: [0, 4],
        overflow: n
      };
    case "topLeft":
      return {
        points: ["bl", "tl"],
        offset: [0, -4],
        overflow: n
      };
    case "topRight":
      return {
        points: ["br", "tr"],
        offset: [0, -4],
        overflow: n
      };
    default:
      return {
        points: e === "rtl" ? ["tr", "br"] : ["tl", "bl"],
        offset: [0, 4],
        overflow: n
      };
  }
}
function E7() {
  return {
    id: String,
    /**
     * @deprecated `dropdownClassName` is deprecated which will be removed in next major
     *   version.Please use `popupClassName` instead.
     */
    dropdownClassName: String,
    popupClassName: String,
    popupStyle: hn(),
    transitionName: String,
    placeholder: String,
    allowClear: qt(),
    autofocus: qt(),
    disabled: qt(),
    tabindex: Number,
    open: qt(),
    defaultOpen: qt(),
    /** Make input readOnly to avoid popup keyboard in mobile */
    inputReadOnly: qt(),
    format: ca([String, Function, Array]),
    // Value
    // format:  string | CustomFormat<DateType> | (string | CustomFormat<DateType>)[];
    // Render
    // suffixIcon?: VueNode;
    // clearIcon?: VueNode;
    // prevIcon?: VueNode;
    // nextIcon?: VueNode;
    // superPrevIcon?: VueNode;
    // superNextIcon?: VueNode;
    getPopupContainer: Nt(),
    panelRender: Nt(),
    // // Events
    onChange: Nt(),
    "onUpdate:value": Nt(),
    onOk: Nt(),
    onOpenChange: Nt(),
    "onUpdate:open": Nt(),
    onFocus: Nt(),
    onBlur: Nt(),
    onMousedown: Nt(),
    onMouseup: Nt(),
    onMouseenter: Nt(),
    onMouseleave: Nt(),
    onClick: Nt(),
    onContextmenu: Nt(),
    onKeydown: Nt(),
    // WAI-ARIA
    role: String,
    name: String,
    autocomplete: String,
    direction: Ur(),
    showToday: qt(),
    showTime: ca([Boolean, Object]),
    locale: hn(),
    size: Ur(),
    bordered: qt(),
    dateRender: Nt(),
    disabledDate: Nt(),
    mode: Ur(),
    picker: Ur(),
    valueFormat: String,
    placement: Ur(),
    status: Ur(),
    /** @deprecated Please use `disabledTime` instead. */
    disabledHours: Nt(),
    /** @deprecated Please use `disabledTime` instead. */
    disabledMinutes: Nt(),
    /** @deprecated Please use `disabledTime` instead. */
    disabledSeconds: Nt()
  };
}
function Ole() {
  return {
    defaultPickerValue: ca([Object, String]),
    defaultValue: ca([Object, String]),
    value: ca([Object, String]),
    presets: io(),
    disabledTime: Nt(),
    renderExtraFooter: Nt(),
    showNow: qt(),
    monthCellRender: Nt(),
    // deprecated  Please use `monthCellRender"` instead.',
    monthCellContentRender: Nt()
  };
}
function Ale() {
  return {
    allowEmpty: io(),
    dateRender: Nt(),
    defaultPickerValue: io(),
    defaultValue: io(),
    value: io(),
    presets: io(),
    disabledTime: Nt(),
    disabled: ca([Boolean, Array]),
    renderExtraFooter: Nt(),
    separator: {
      type: String
    },
    showTime: ca([Boolean, Object]),
    ranges: hn(),
    placeholder: io(),
    mode: io(),
    onChange: Nt(),
    "onUpdate:value": Nt(),
    onCalendarChange: Nt(),
    onPanelChange: Nt(),
    onOk: Nt()
  };
}
var Ile = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function Ple(e, t) {
  function n(u, c) {
    const f = D(D(D({}, E7()), Ole()), t);
    return /* @__PURE__ */ Me({
      compatConfig: {
        MODE: 3
      },
      name: c,
      inheritAttrs: !1,
      props: f,
      slots: Object,
      setup(d, p) {
        let {
          slots: v,
          expose: h,
          attrs: m,
          emit: y
        } = p;
        const x = d, g = fu(), S = Wi.useInject();
        process.env.NODE_ENV !== "production" && (Aa(u !== "quarter", c || "DatePicker", `DatePicker.${c} is legacy usage. Please use DatePicker[picker='${u}'] directly.`), Aa(!x.dropdownClassName, c || "DatePicker", "`dropdownClassName` is deprecated. Please use `popupClassName` instead."), Aa(!(x.monthCellContentRender || v.monthCellContentRender), c || "DatePicker", '`monthCellContentRender` is deprecated. Please use `monthCellRender"` instead.'), Aa(!m.getCalendarContainer, c || "DatePicker", '`getCalendarContainer` is deprecated. Please use `getPopupContainer"` instead.'));
        const {
          prefixCls: w,
          direction: _,
          getPopupContainer: b,
          size: E,
          rootPrefixCls: C,
          disabled: T
        } = mn("picker", x), {
          compactSize: O,
          compactItemClassnames: I
        } = Wp(w, _), k = V(() => O.value || E.value), [B, P] = Rk(w), N = ne();
        h({
          focus: () => {
            var le;
            (le = N.value) === null || le === void 0 || le.focus();
          },
          blur: () => {
            var le;
            (le = N.value) === null || le === void 0 || le.blur();
          }
        });
        const M = (le) => x.valueFormat ? e.toString(le, x.valueFormat) : le, H = (le, te) => {
          const G = M(le);
          y("update:value", G), y("change", G, te), g.onFieldChange();
        }, R = (le) => {
          y("update:open", le), y("openChange", le);
        }, z = (le) => {
          y("focus", le);
        }, W = (le) => {
          y("blur", le), g.onFieldBlur();
        }, F = (le, te) => {
          const G = M(le);
          y("panelChange", G, te);
        }, Y = (le) => {
          const te = M(le);
          y("ok", te);
        }, [X] = Tc("DatePicker", gm), q = V(() => x.value ? x.valueFormat ? e.toDate(x.value, x.valueFormat) : x.value : x.value === "" ? void 0 : x.value), Q = V(() => x.defaultValue ? x.valueFormat ? e.toDate(x.defaultValue, x.valueFormat) : x.defaultValue : x.defaultValue === "" ? void 0 : x.defaultValue), ue = V(() => x.defaultPickerValue ? x.valueFormat ? e.toDate(x.defaultPickerValue, x.valueFormat) : x.defaultPickerValue : x.defaultPickerValue === "" ? void 0 : x.defaultPickerValue);
        return () => {
          var le, te, G, oe, L, re;
          const j = D(D({}, X.value), x.locale), J = D(D({}, x), m), {
            bordered: ae = !0,
            placeholder: he,
            suffixIcon: K = (le = v.suffixIcon) === null || le === void 0 ? void 0 : le.call(v),
            showToday: Z = !0,
            transitionName: se,
            allowClear: me = !0,
            dateRender: xe = v.dateRender,
            renderExtraFooter: be = v.renderExtraFooter,
            monthCellRender: Te = v.monthCellRender || x.monthCellContentRender || v.monthCellContentRender,
            clearIcon: Ie = (te = v.clearIcon) === null || te === void 0 ? void 0 : te.call(v),
            id: Ve = g.id.value
          } = J, tt = Ile(J, ["bordered", "placeholder", "suffixIcon", "showToday", "transitionName", "allowClear", "dateRender", "renderExtraFooter", "monthCellRender", "clearIcon", "id"]), it = J.showTime === "" ? !0 : J.showTime, {
            format: Se
          } = J;
          let ge = {};
          u && (ge.picker = u);
          const pe = u || J.picker || "date";
          ge = D(D(D({}, ge), it ? Lm(D({
            format: Se,
            picker: pe
          }, typeof it == "object" ? it : {})) : {}), pe === "time" ? Lm(D(D({
            format: Se
          }, tt), {
            picker: pe
          })) : {});
          const De = w.value, Ue = A(dt, null, [K || A(u === "time" ? M1 : k1, null, null), S.hasFeedback && S.feedbackIcon]);
          return B(A(zae, ve(ve(ve({
            monthCellRender: Te,
            dateRender: xe,
            renderExtraFooter: be,
            ref: N,
            placeholder: Tle(j, pe, he),
            suffixIcon: Ue,
            dropdownAlign: C7(_.value, x.placement),
            clearIcon: Ie || A(Vo, null, null),
            allowClear: me,
            transitionName: se || `${C.value}-slide-up`
          }, tt), ge), {}, {
            id: Ve,
            picker: pe,
            value: q.value,
            defaultValue: Q.value,
            defaultPickerValue: ue.value,
            showToday: Z,
            locale: j.lang,
            class: Ge({
              [`${De}-${k.value}`]: k.value,
              [`${De}-borderless`]: !ae
            }, zl(De, wd(S.status, x.status), S.hasFeedback), m.class, P.value, I.value),
            disabled: T.value,
            prefixCls: De,
            getPopupContainer: m.getCalendarContainer || b.value,
            generateConfig: e,
            prevIcon: ((G = v.prevIcon) === null || G === void 0 ? void 0 : G.call(v)) || A("span", {
              class: `${De}-prev-icon`
            }, null),
            nextIcon: ((oe = v.nextIcon) === null || oe === void 0 ? void 0 : oe.call(v)) || A("span", {
              class: `${De}-next-icon`
            }, null),
            superPrevIcon: ((L = v.superPrevIcon) === null || L === void 0 ? void 0 : L.call(v)) || A("span", {
              class: `${De}-super-prev-icon`
            }, null),
            superNextIcon: ((re = v.superNextIcon) === null || re === void 0 ? void 0 : re.call(v)) || A("span", {
              class: `${De}-super-next-icon`
            }, null),
            components: T7,
            direction: _.value,
            dropdownClassName: Ge(P.value, x.popupClassName, x.dropdownClassName),
            onChange: H,
            onOpenChange: R,
            onFocus: z,
            onBlur: W,
            onPanelChange: F,
            onOk: Y
          }), null));
        };
      }
    });
  }
  const r = n(void 0, "ADatePicker"), a = n("week", "AWeekPicker"), o = n("month", "AMonthPicker"), i = n("year", "AYearPicker"), s = n("time", "TimePicker"), l = n("quarter", "AQuarterPicker");
  return {
    DatePicker: r,
    WeekPicker: a,
    MonthPicker: o,
    YearPicker: i,
    TimePicker: s,
    QuarterPicker: l
  };
}
var Dle = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, name: "swap-right", theme: "outlined" };
function K5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      kle(e, a, n[a]);
    });
  }
  return e;
}
function kle(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var x4 = function(t, n) {
  var r = K5({}, t, n.attrs);
  return A(Bn, K5({}, r, {
    icon: Dle
  }), null);
};
x4.displayName = "SwapRightOutlined";
x4.inheritAttrs = !1;
var Mle = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function Rle(e, t) {
  return /* @__PURE__ */ Me({
    compatConfig: {
      MODE: 3
    },
    name: "ARangePicker",
    inheritAttrs: !1,
    props: D(D(D({}, E7()), Ale()), t),
    slots: Object,
    setup(r, a) {
      let {
        expose: o,
        slots: i,
        attrs: s,
        emit: l
      } = a;
      const u = r, c = fu(), f = Wi.useInject();
      process.env.NODE_ENV !== "production" && (Aa(!u.dropdownClassName, "RangePicker", "`dropdownClassName` is deprecated. Please use `popupClassName` instead."), Aa(!s.getCalendarContainer, "DatePicker", '`getCalendarContainer` is deprecated. Please use `getPopupContainer"` instead.'));
      const {
        prefixCls: d,
        direction: p,
        getPopupContainer: v,
        size: h,
        rootPrefixCls: m,
        disabled: y
      } = mn("picker", u), {
        compactSize: x,
        compactItemClassnames: g
      } = Wp(d, p), S = V(() => x.value || h.value), [w, _] = Rk(d), b = ne();
      o({
        focus: () => {
          var z;
          (z = b.value) === null || z === void 0 || z.focus();
        },
        blur: () => {
          var z;
          (z = b.value) === null || z === void 0 || z.blur();
        }
      });
      const E = (z) => u.valueFormat ? e.toString(z, u.valueFormat) : z, C = (z, W) => {
        const F = E(z);
        l("update:value", F), l("change", F, W), c.onFieldChange();
      }, T = (z) => {
        l("update:open", z), l("openChange", z);
      }, O = (z) => {
        l("focus", z);
      }, I = (z) => {
        l("blur", z), c.onFieldBlur();
      }, k = (z, W) => {
        const F = E(z);
        l("panelChange", F, W);
      }, B = (z) => {
        const W = E(z);
        l("ok", W);
      }, P = (z, W, F) => {
        const Y = E(z);
        l("calendarChange", Y, W, F);
      }, [N] = Tc("DatePicker", gm), M = V(() => u.value && u.valueFormat ? e.toDate(u.value, u.valueFormat) : u.value), H = V(() => u.defaultValue && u.valueFormat ? e.toDate(u.defaultValue, u.valueFormat) : u.defaultValue), R = V(() => u.defaultPickerValue && u.valueFormat ? e.toDate(u.defaultPickerValue, u.valueFormat) : u.defaultPickerValue);
      return () => {
        var z, W, F, Y, X, q, Q;
        const ue = D(D({}, N.value), u.locale), le = D(D({}, u), s), {
          prefixCls: te,
          bordered: G = !0,
          placeholder: oe,
          suffixIcon: L = (z = i.suffixIcon) === null || z === void 0 ? void 0 : z.call(i),
          picker: re = "date",
          transitionName: j,
          allowClear: J = !0,
          dateRender: ae = i.dateRender,
          renderExtraFooter: he = i.renderExtraFooter,
          separator: K = (W = i.separator) === null || W === void 0 ? void 0 : W.call(i),
          clearIcon: Z = (F = i.clearIcon) === null || F === void 0 ? void 0 : F.call(i),
          id: se = c.id.value
        } = le, me = Mle(le, ["prefixCls", "bordered", "placeholder", "suffixIcon", "picker", "transitionName", "allowClear", "dateRender", "renderExtraFooter", "separator", "clearIcon", "id"]);
        delete me["onUpdate:value"], delete me["onUpdate:open"];
        const {
          format: xe,
          showTime: be
        } = le;
        let Te = {};
        Te = D(D(D({}, Te), be ? Lm(D({
          format: xe,
          picker: re
        }, be)) : {}), re === "time" ? Lm(D(D({
          format: xe
        }, Lr(me, ["disabledTime"])), {
          picker: re
        })) : {});
        const Ie = d.value, Ve = A(dt, null, [L || A(re === "time" ? M1 : k1, null, null), f.hasFeedback && f.feedbackIcon]);
        return w(A(roe, ve(ve(ve({
          dateRender: ae,
          renderExtraFooter: he,
          separator: K || A("span", {
            "aria-label": "to",
            class: `${Ie}-separator`
          }, [A(x4, null, null)]),
          ref: b,
          dropdownAlign: C7(p.value, u.placement),
          placeholder: $le(ue, re, oe),
          suffixIcon: Ve,
          clearIcon: Z || A(Vo, null, null),
          allowClear: J,
          transitionName: j || `${m.value}-slide-up`
        }, me), Te), {}, {
          disabled: y.value,
          id: se,
          value: M.value,
          defaultValue: H.value,
          defaultPickerValue: R.value,
          picker: re,
          class: Ge({
            [`${Ie}-${S.value}`]: S.value,
            [`${Ie}-borderless`]: !G
          }, zl(Ie, wd(f.status, u.status), f.hasFeedback), s.class, _.value, g.value),
          locale: ue.lang,
          prefixCls: Ie,
          getPopupContainer: s.getCalendarContainer || v.value,
          generateConfig: e,
          prevIcon: ((Y = i.prevIcon) === null || Y === void 0 ? void 0 : Y.call(i)) || A("span", {
            class: `${Ie}-prev-icon`
          }, null),
          nextIcon: ((X = i.nextIcon) === null || X === void 0 ? void 0 : X.call(i)) || A("span", {
            class: `${Ie}-next-icon`
          }, null),
          superPrevIcon: ((q = i.superPrevIcon) === null || q === void 0 ? void 0 : q.call(i)) || A("span", {
            class: `${Ie}-super-prev-icon`
          }, null),
          superNextIcon: ((Q = i.superNextIcon) === null || Q === void 0 ? void 0 : Q.call(i)) || A("span", {
            class: `${Ie}-super-next-icon`
          }, null),
          components: T7,
          direction: p.value,
          dropdownClassName: Ge(_.value, u.popupClassName, u.dropdownClassName),
          onChange: C,
          onOpenChange: T,
          onFocus: O,
          onBlur: I,
          onPanelChange: k,
          onOk: B,
          onCalendarChange: P
        }), null));
      };
    }
  });
}
const T7 = {
  button: mle,
  rangeItem: wle
};
function Nle(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function Lm(e) {
  const {
    format: t,
    picker: n,
    showHour: r,
    showMinute: a,
    showSecond: o,
    use12Hours: i
  } = e, s = Nle(t)[0], l = D({}, e);
  return s && typeof s == "string" && (!s.includes("s") && o === void 0 && (l.showSecond = !1), !s.includes("m") && a === void 0 && (l.showMinute = !1), !s.includes("H") && !s.includes("h") && r === void 0 && (l.showHour = !1), (s.includes("a") || s.includes("A")) && i === void 0 && (l.use12Hours = !0)), n === "time" ? l : (typeof s == "function" && delete l.format, {
    showTime: l
  });
}
function Fle(e, t) {
  const {
    DatePicker: n,
    WeekPicker: r,
    MonthPicker: a,
    YearPicker: o,
    TimePicker: i,
    QuarterPicker: s
  } = Ple(e, t), l = Rle(e, t);
  return {
    DatePicker: n,
    WeekPicker: r,
    MonthPicker: a,
    YearPicker: o,
    TimePicker: i,
    QuarterPicker: s,
    RangePicker: l
  };
}
const {
  DatePicker: Jy,
  WeekPicker: ex,
  MonthPicker: tx,
  YearPicker: Lle,
  TimePicker: Ble,
  QuarterPicker: nx,
  RangePicker: rx
} = Fle(gae), $7 = D(Jy, {
  WeekPicker: ex,
  MonthPicker: tx,
  YearPicker: Lle,
  RangePicker: rx,
  TimePicker: Ble,
  QuarterPicker: nx,
  install: (e) => (e.component(Jy.name, Jy), e.component(rx.name, rx), e.component(tx.name, tx), e.component(ex.name, ex), e.component(nx.name, nx), e)
}), Hle = (e) => {
  const {
    componentCls: t,
    sizePaddingEdgeHorizontal: n,
    colorSplit: r,
    lineWidth: a
  } = e;
  return {
    [t]: D(D({}, gr(e)), {
      borderBlockStart: `${a}px solid ${r}`,
      // vertical
      "&-vertical": {
        position: "relative",
        top: "-0.06em",
        display: "inline-block",
        height: "0.9em",
        margin: `0 ${e.dividerVerticalGutterMargin}px`,
        verticalAlign: "middle",
        borderTop: 0,
        borderInlineStart: `${a}px solid ${r}`
      },
      "&-horizontal": {
        display: "flex",
        clear: "both",
        width: "100%",
        minWidth: "100%",
        margin: `${e.dividerHorizontalGutterMargin}px 0`
      },
      [`&-horizontal${t}-with-text`]: {
        display: "flex",
        alignItems: "center",
        margin: `${e.dividerHorizontalWithTextGutterMargin}px 0`,
        color: e.colorTextHeading,
        fontWeight: 500,
        fontSize: e.fontSizeLG,
        whiteSpace: "nowrap",
        textAlign: "center",
        borderBlockStart: `0 ${r}`,
        "&::before, &::after": {
          position: "relative",
          width: "50%",
          borderBlockStart: `${a}px solid transparent`,
          // Chrome not accept `inherit` in `border-top`
          borderBlockStartColor: "inherit",
          borderBlockEnd: 0,
          transform: "translateY(50%)",
          content: "''"
        }
      },
      [`&-horizontal${t}-with-text-left`]: {
        "&::before": {
          width: "5%"
        },
        "&::after": {
          width: "95%"
        }
      },
      [`&-horizontal${t}-with-text-right`]: {
        "&::before": {
          width: "95%"
        },
        "&::after": {
          width: "5%"
        }
      },
      [`${t}-inner-text`]: {
        display: "inline-block",
        padding: "0 1em"
      },
      "&-dashed": {
        background: "none",
        borderColor: r,
        borderStyle: "dashed",
        borderWidth: `${a}px 0 0`
      },
      [`&-horizontal${t}-with-text${t}-dashed`]: {
        "&::before, &::after": {
          borderStyle: "dashed none none"
        }
      },
      [`&-vertical${t}-dashed`]: {
        borderInlineStartWidth: a,
        borderInlineEnd: 0,
        borderBlockStart: 0,
        borderBlockEnd: 0
      },
      [`&-plain${t}-with-text`]: {
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.fontSize
      },
      [`&-horizontal${t}-with-text-left${t}-no-default-orientation-margin-left`]: {
        "&::before": {
          width: 0
        },
        "&::after": {
          width: "100%"
        },
        [`${t}-inner-text`]: {
          paddingInlineStart: n
        }
      },
      [`&-horizontal${t}-with-text-right${t}-no-default-orientation-margin-right`]: {
        "&::before": {
          width: "100%"
        },
        "&::after": {
          width: 0
        },
        [`${t}-inner-text`]: {
          paddingInlineEnd: n
        }
      }
    })
  };
}, jle = xr("Divider", (e) => {
  const t = xn(e, {
    dividerVerticalGutterMargin: e.marginXS,
    dividerHorizontalWithTextGutterMargin: e.margin,
    dividerHorizontalGutterMargin: e.marginLG
  });
  return [Hle(t)];
}, {
  sizePaddingEdgeHorizontal: 0
}), Vle = () => ({
  prefixCls: String,
  type: {
    type: String,
    default: "horizontal"
  },
  dashed: {
    type: Boolean,
    default: !1
  },
  orientation: {
    type: String,
    default: "center"
  },
  plain: {
    type: Boolean,
    default: !1
  },
  orientationMargin: [String, Number]
}), Ule = /* @__PURE__ */ Me({
  name: "ADivider",
  inheritAttrs: !1,
  compatConfig: {
    MODE: 3
  },
  props: Vle(),
  setup(e, t) {
    let {
      slots: n,
      attrs: r
    } = t;
    const {
      prefixCls: a,
      direction: o
    } = mn("divider", e), [i, s] = jle(a), l = V(() => e.orientation === "left" && e.orientationMargin != null), u = V(() => e.orientation === "right" && e.orientationMargin != null), c = V(() => {
      const {
        type: p,
        dashed: v,
        plain: h
      } = e, m = a.value;
      return {
        [m]: !0,
        [s.value]: !!s.value,
        [`${m}-${p}`]: !0,
        [`${m}-dashed`]: !!v,
        [`${m}-plain`]: !!h,
        [`${m}-rtl`]: o.value === "rtl",
        [`${m}-no-default-orientation-margin-left`]: l.value,
        [`${m}-no-default-orientation-margin-right`]: u.value
      };
    }), f = V(() => {
      const p = typeof e.orientationMargin == "number" ? `${e.orientationMargin}px` : e.orientationMargin;
      return D(D({}, l.value && {
        marginLeft: p
      }), u.value && {
        marginRight: p
      });
    }), d = V(() => e.orientation.length > 0 ? "-" + e.orientation : e.orientation);
    return () => {
      var p;
      const v = ua((p = n.default) === null || p === void 0 ? void 0 : p.call(n));
      return i(A("div", ve(ve({}, r), {}, {
        class: [c.value, v.length ? `${a.value}-with-text ${a.value}-with-text${d.value}` : "", r.class],
        role: "separator"
      }), [v.length ? A("span", {
        class: `${a.value}-inner-text`,
        style: f.value
      }, [v]) : null]));
    };
  }
}), E0 = yd(Ule);
cs.Button = Pm;
cs.install = function(e) {
  return e.component(cs.name, cs), e.component(Pm.name, Pm), e;
};
const T0 = (e) => e != null && (Array.isArray(e) ? _s(e).length : !0);
function b4(e) {
  return T0(e.prefix) || T0(e.suffix) || T0(e.allowClear);
}
function Uv(e) {
  return T0(e.addonBefore) || T0(e.addonAfter);
}
function D2(e) {
  return typeof e > "u" || e === null ? "" : String(e);
}
function $0(e, t, n, r) {
  if (!n)
    return;
  const a = t;
  if (t.type === "click") {
    Object.defineProperty(a, "target", {
      writable: !0
    }), Object.defineProperty(a, "currentTarget", {
      writable: !0
    });
    const o = e.cloneNode(!0);
    a.target = o, a.currentTarget = o, o.value = "", n(a);
    return;
  }
  if (r !== void 0) {
    Object.defineProperty(a, "target", {
      writable: !0
    }), Object.defineProperty(a, "currentTarget", {
      writable: !0
    }), a.target = e, a.currentTarget = e, e.value = r, n(a);
    return;
  }
  n(a);
}
function O7(e, t) {
  if (!e) return;
  e.focus(t);
  const {
    cursor: n
  } = t || {};
  if (n) {
    const r = e.value.length;
    switch (n) {
      case "start":
        e.setSelectionRange(0, 0);
        break;
      case "end":
        e.setSelectionRange(r, r);
        break;
      default:
        e.setSelectionRange(0, r);
    }
  }
}
const zle = () => ({
  addonBefore: Oe.any,
  addonAfter: Oe.any,
  prefix: Oe.any,
  suffix: Oe.any,
  clearIcon: Oe.any,
  affixWrapperClassName: String,
  groupClassName: String,
  wrapperClassName: String,
  inputClassName: String,
  allowClear: {
    type: Boolean,
    default: void 0
  }
}), A7 = () => D(D({}, zle()), {
  value: {
    type: [String, Number, Symbol],
    default: void 0
  },
  defaultValue: {
    type: [String, Number, Symbol],
    default: void 0
  },
  inputElement: Oe.any,
  prefixCls: String,
  disabled: {
    type: Boolean,
    default: void 0
  },
  focused: {
    type: Boolean,
    default: void 0
  },
  triggerFocus: Function,
  readonly: {
    type: Boolean,
    default: void 0
  },
  handleReset: Function,
  hidden: {
    type: Boolean,
    default: void 0
  }
}), I7 = () => D(D({}, A7()), {
  id: String,
  placeholder: {
    type: [String, Number]
  },
  autocomplete: String,
  type: Ur("text"),
  name: String,
  size: {
    type: String
  },
  autofocus: {
    type: Boolean,
    default: void 0
  },
  lazy: {
    type: Boolean,
    default: !0
  },
  maxlength: Number,
  loading: {
    type: Boolean,
    default: void 0
  },
  bordered: {
    type: Boolean,
    default: void 0
  },
  showCount: {
    type: [Boolean, Object]
  },
  htmlSize: Number,
  onPressEnter: Function,
  onKeydown: Function,
  onKeyup: Function,
  onFocus: Function,
  onBlur: Function,
  onChange: Function,
  onInput: Function,
  "onUpdate:value": Function,
  onCompositionstart: Function,
  onCompositionend: Function,
  valueModifiers: Object,
  hidden: {
    type: Boolean,
    default: void 0
  },
  status: String
}), Wle = /* @__PURE__ */ Me({
  name: "BaseInput",
  inheritAttrs: !1,
  props: A7(),
  setup(e, t) {
    let {
      slots: n,
      attrs: r
    } = t;
    const a = ne(), o = (s) => {
      var l;
      if (!((l = a.value) === null || l === void 0) && l.contains(s.target)) {
        const {
          triggerFocus: u
        } = e;
        u == null || u();
      }
    }, i = () => {
      var s;
      const {
        allowClear: l,
        value: u,
        disabled: c,
        readonly: f,
        handleReset: d,
        suffix: p = n.suffix,
        prefixCls: v
      } = e;
      if (!l)
        return null;
      const h = !c && !f && u, m = `${v}-clear-icon`, y = ((s = n.clearIcon) === null || s === void 0 ? void 0 : s.call(n)) || "*";
      return A("span", {
        onClick: d,
        onMousedown: (x) => x.preventDefault(),
        class: Ge({
          [`${m}-hidden`]: !h,
          [`${m}-has-suffix`]: !!p
        }, m),
        role: "button",
        tabindex: -1
      }, [y]);
    };
    return () => {
      var s, l;
      const {
        focused: u,
        value: c,
        disabled: f,
        allowClear: d,
        readonly: p,
        hidden: v,
        prefixCls: h,
        prefix: m = (s = n.prefix) === null || s === void 0 ? void 0 : s.call(n),
        suffix: y = (l = n.suffix) === null || l === void 0 ? void 0 : l.call(n),
        addonAfter: x = n.addonAfter,
        addonBefore: g = n.addonBefore,
        inputElement: S,
        affixWrapperClassName: w,
        wrapperClassName: _,
        groupClassName: b
      } = e;
      let E = sr(S, {
        value: c,
        hidden: v
      });
      if (b4({
        prefix: m,
        suffix: y,
        allowClear: d
      })) {
        const C = `${h}-affix-wrapper`, T = Ge(C, {
          [`${C}-disabled`]: f,
          [`${C}-focused`]: u,
          [`${C}-readonly`]: p,
          [`${C}-input-with-clear-btn`]: y && d && c
        }, !Uv({
          addonAfter: x,
          addonBefore: g
        }) && r.class, w), O = (y || d) && A("span", {
          class: `${h}-suffix`
        }, [i(), y]);
        E = A("span", {
          class: T,
          style: r.style,
          hidden: !Uv({
            addonAfter: x,
            addonBefore: g
          }) && v,
          onMousedown: o,
          ref: a
        }, [m && A("span", {
          class: `${h}-prefix`
        }, [m]), sr(S, {
          style: null,
          value: c,
          hidden: null
        }), O]);
      }
      if (Uv({
        addonAfter: x,
        addonBefore: g
      })) {
        const C = `${h}-group`, T = `${C}-addon`, O = Ge(`${h}-wrapper`, C, _), I = Ge(`${h}-group-wrapper`, r.class, b);
        return A("span", {
          class: I,
          style: r.style,
          hidden: v
        }, [A("span", {
          class: O
        }, [g && A("span", {
          class: T
        }, [g]), sr(E, {
          style: null,
          hidden: null
        }), x && A("span", {
          class: T
        }, [x])])]);
      }
      return E;
    };
  }
});
var Gle = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const Kle = /* @__PURE__ */ Me({
  name: "VCInput",
  inheritAttrs: !1,
  props: I7(),
  setup(e, t) {
    let {
      slots: n,
      attrs: r,
      expose: a,
      emit: o
    } = t;
    const i = Be(e.value === void 0 ? e.defaultValue : e.value), s = Be(!1), l = Be(), u = Be();
    He(() => e.value, () => {
      i.value = e.value;
    }), He(() => e.disabled, () => {
      e.disabled && (s.value = !1);
    });
    const c = (b) => {
      l.value && O7(l.value, b);
    };
    a({
      focus: c,
      blur: () => {
        var b;
        (b = l.value) === null || b === void 0 || b.blur();
      },
      input: l,
      stateValue: i,
      setSelectionRange: (b, E, C) => {
        var T;
        (T = l.value) === null || T === void 0 || T.setSelectionRange(b, E, C);
      },
      select: () => {
        var b;
        (b = l.value) === null || b === void 0 || b.select();
      }
    });
    const v = (b) => {
      o("change", b);
    }, h = (b, E) => {
      i.value !== b && (e.value === void 0 ? i.value = b : nn(() => {
        var C;
        l.value.value !== i.value && ((C = u.value) === null || C === void 0 || C.$forceUpdate());
      }), nn(() => {
        E && E();
      }));
    }, m = (b) => {
      const {
        value: E,
        composing: C
      } = b.target;
      if ((b.isComposing || C) && e.lazy || i.value === E) return;
      const T = b.target.value;
      $0(l.value, b, v), h(T);
    }, y = (b) => {
      b.keyCode === 13 && o("pressEnter", b), o("keydown", b);
    }, x = (b) => {
      s.value = !0, o("focus", b);
    }, g = (b) => {
      s.value = !1, o("blur", b);
    }, S = (b) => {
      $0(l.value, b, v), h("", () => {
        c();
      });
    }, w = () => {
      var b, E;
      const {
        addonBefore: C = n.addonBefore,
        addonAfter: T = n.addonAfter,
        disabled: O,
        valueModifiers: I = {},
        htmlSize: k,
        autocomplete: B,
        prefixCls: P,
        inputClassName: N,
        prefix: M = (b = n.prefix) === null || b === void 0 ? void 0 : b.call(n),
        suffix: H = (E = n.suffix) === null || E === void 0 ? void 0 : E.call(n),
        allowClear: R,
        type: z = "text"
      } = e, W = Lr(e, [
        "prefixCls",
        "onPressEnter",
        "addonBefore",
        "addonAfter",
        "prefix",
        "suffix",
        "allowClear",
        // Input elements must be either controlled or uncontrolled,
        // specify either the value prop, or the defaultValue prop, but not both.
        "defaultValue",
        "size",
        "bordered",
        "htmlSize",
        "lazy",
        "showCount",
        "valueModifiers",
        "showCount",
        "affixWrapperClassName",
        "groupClassName",
        "inputClassName",
        "wrapperClassName"
      ]), F = D(D(D({}, W), r), {
        autocomplete: B,
        onChange: m,
        onInput: m,
        onFocus: x,
        onBlur: g,
        onKeydown: y,
        class: Ge(P, {
          [`${P}-disabled`]: O
        }, N, !Uv({
          addonAfter: T,
          addonBefore: C
        }) && !b4({
          prefix: M,
          suffix: H,
          allowClear: R
        }) && r.class),
        ref: l,
        key: "ant-input",
        size: k,
        type: z
      });
      I.lazy && delete F.onInput, F.autofocus || delete F.autofocus;
      const Y = A("input", Lr(F, ["size"]), null);
      return Yn(Y, [[Vp]]);
    }, _ = () => {
      var b;
      const {
        maxlength: E,
        suffix: C = (b = n.suffix) === null || b === void 0 ? void 0 : b.call(n),
        showCount: T,
        prefixCls: O
      } = e, I = Number(E) > 0;
      if (C || T) {
        const k = [...D2(i.value)].length, B = typeof T == "object" ? T.formatter({
          count: k,
          maxlength: E
        }) : `${k}${I ? ` / ${E}` : ""}`;
        return A(dt, null, [!!T && A("span", {
          class: Ge(`${O}-show-count-suffix`, {
            [`${O}-show-count-has-suffix`]: !!C
          })
        }, [B]), C]);
      }
      return null;
    };
    return Lt(() => {
      process.env.NODE_ENV === "test" && e.autofocus && c();
    }), () => {
      const {
        prefixCls: b,
        disabled: E
      } = e, C = Gle(e, ["prefixCls", "disabled"]);
      return A(Wle, ve(ve(ve({}, C), r), {}, {
        ref: u,
        prefixCls: b,
        inputElement: w(),
        handleReset: S,
        value: D2(i.value),
        focused: s.value,
        triggerFocus: c,
        suffix: _(),
        disabled: E
      }), n);
    };
  }
}), R1 = () => Lr(I7(), ["wrapperClassName", "groupClassName", "inputClassName", "affixWrapperClassName"]), P7 = () => D(D({}, Lr(R1(), ["prefix", "addonBefore", "addonAfter", "suffix"])), {
  rows: Number,
  autosize: {
    type: [Boolean, Object],
    default: void 0
  },
  autoSize: {
    type: [Boolean, Object],
    default: void 0
  },
  onResize: {
    type: Function
  },
  onCompositionstart: Vf(),
  onCompositionend: Vf(),
  valueModifiers: Object
});
var Yle = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const dr = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AInput",
  inheritAttrs: !1,
  props: R1(),
  setup(e, t) {
    let {
      slots: n,
      attrs: r,
      expose: a,
      emit: o
    } = t;
    const i = ne(), s = fu(), l = Wi.useInject(), u = V(() => wd(l.status, e.status)), {
      direction: c,
      prefixCls: f,
      size: d,
      autocomplete: p
    } = mn("input", e), {
      compactSize: v,
      compactItemClassnames: h
    } = Wp(f, c), m = V(() => v.value || d.value), [y, x] = f4(f), g = Ec();
    a({
      focus: (k) => {
        var B;
        (B = i.value) === null || B === void 0 || B.focus(k);
      },
      blur: () => {
        var k;
        (k = i.value) === null || k === void 0 || k.blur();
      },
      input: i,
      setSelectionRange: (k, B, P) => {
        var N;
        (N = i.value) === null || N === void 0 || N.setSelectionRange(k, B, P);
      },
      select: () => {
        var k;
        (k = i.value) === null || k === void 0 || k.select();
      }
    });
    const E = ne([]), C = () => {
      E.value.push(setTimeout(() => {
        var k, B, P, N;
        !((k = i.value) === null || k === void 0) && k.input && ((B = i.value) === null || B === void 0 ? void 0 : B.input.getAttribute("type")) === "password" && (!((P = i.value) === null || P === void 0) && P.input.hasAttribute("value")) && ((N = i.value) === null || N === void 0 || N.input.removeAttribute("value"));
      }));
    };
    Lt(() => {
      C();
    }), Cg(() => {
      E.value.forEach((k) => clearTimeout(k));
    }), Sn(() => {
      E.value.forEach((k) => clearTimeout(k));
    });
    const T = (k) => {
      C(), o("blur", k), s.onFieldBlur();
    }, O = (k) => {
      C(), o("focus", k);
    }, I = (k) => {
      o("update:value", k.target.value), o("change", k), o("input", k), s.onFieldChange();
    };
    return () => {
      var k, B, P, N, M, H;
      const {
        hasFeedback: R,
        feedbackIcon: z
      } = l, {
        allowClear: W,
        bordered: F = !0,
        prefix: Y = (k = n.prefix) === null || k === void 0 ? void 0 : k.call(n),
        suffix: X = (B = n.suffix) === null || B === void 0 ? void 0 : B.call(n),
        addonAfter: q = (P = n.addonAfter) === null || P === void 0 ? void 0 : P.call(n),
        addonBefore: Q = (N = n.addonBefore) === null || N === void 0 ? void 0 : N.call(n),
        id: ue = (M = s.id) === null || M === void 0 ? void 0 : M.value
      } = e, le = Yle(e, ["allowClear", "bordered", "prefix", "suffix", "addonAfter", "addonBefore", "id"]), te = (R || X) && A(dt, null, [X, R && z]), G = f.value, oe = b4({
        prefix: Y,
        suffix: X
      }) || !!R, L = n.clearIcon || (() => A(Vo, null, null));
      return y(A(Kle, ve(ve(ve({}, r), Lr(le, ["onUpdate:value", "onChange", "onInput"])), {}, {
        onChange: I,
        id: ue,
        disabled: (H = e.disabled) !== null && H !== void 0 ? H : g.value,
        ref: i,
        prefixCls: G,
        autocomplete: p.value,
        onBlur: T,
        onFocus: O,
        prefix: Y,
        suffix: te,
        allowClear: W,
        addonAfter: q && A(N$, null, {
          default: () => [A(w$, null, {
            default: () => [q]
          })]
        }),
        addonBefore: Q && A(N$, null, {
          default: () => [A(w$, null, {
            default: () => [Q]
          })]
        }),
        class: [r.class, h.value],
        inputClassName: Ge({
          [`${G}-sm`]: m.value === "small",
          [`${G}-lg`]: m.value === "large",
          [`${G}-rtl`]: c.value === "rtl",
          [`${G}-borderless`]: !F
        }, !oe && zl(G, u.value), x.value),
        affixWrapperClassName: Ge({
          [`${G}-affix-wrapper-sm`]: m.value === "small",
          [`${G}-affix-wrapper-lg`]: m.value === "large",
          [`${G}-affix-wrapper-rtl`]: c.value === "rtl",
          [`${G}-affix-wrapper-borderless`]: !F
        }, zl(`${G}-affix-wrapper`, u.value, R), x.value),
        wrapperClassName: Ge({
          [`${G}-group-rtl`]: c.value === "rtl"
        }, x.value),
        groupClassName: Ge({
          [`${G}-group-wrapper-sm`]: m.value === "small",
          [`${G}-group-wrapper-lg`]: m.value === "large",
          [`${G}-group-wrapper-rtl`]: c.value === "rtl"
        }, zl(`${G}-group-wrapper`, u.value, R), x.value)
      }), D(D({}, n), {
        clearIcon: L
      })));
    };
  }
}), qle = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AInputGroup",
  inheritAttrs: !1,
  props: {
    prefixCls: String,
    size: {
      type: String
    },
    compact: {
      type: Boolean,
      default: void 0
    }
  },
  setup(e, t) {
    let {
      slots: n,
      attrs: r
    } = t;
    const {
      prefixCls: a,
      direction: o,
      getPrefixCls: i
    } = mn("input-group", e), s = Wi.useInject();
    Wi.useProvide(s, {
      isFormItemInput: !1
    });
    const l = V(() => i("input")), [u, c] = f4(l), f = V(() => {
      const d = a.value;
      return {
        [`${d}`]: !0,
        [c.value]: !0,
        [`${d}-lg`]: e.size === "large",
        [`${d}-sm`]: e.size === "small",
        [`${d}-compact`]: e.compact,
        [`${d}-rtl`]: o.value === "rtl"
      };
    });
    return () => {
      var d;
      return u(A("span", ve(ve({}, r), {}, {
        class: Ge(f.value, r.class)
      }), [(d = n.default) === null || d === void 0 ? void 0 : d.call(n)]));
    };
  }
});
var Xle = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const Zle = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AInputSearch",
  inheritAttrs: !1,
  props: D(D({}, R1()), {
    inputPrefixCls: String,
    // 不能设置默认值 https://github.com/vueComponent/ant-design-vue/issues/1916
    enterButton: Oe.any,
    onSearch: {
      type: Function
    }
  }),
  setup(e, t) {
    let {
      slots: n,
      attrs: r,
      expose: a,
      emit: o
    } = t;
    const i = Be(), s = Be(!1);
    a({
      focus: () => {
        var w;
        (w = i.value) === null || w === void 0 || w.focus();
      },
      blur: () => {
        var w;
        (w = i.value) === null || w === void 0 || w.blur();
      }
    });
    const c = (w) => {
      o("update:value", w.target.value), w && w.target && w.type === "click" && o("search", w.target.value, w), o("change", w);
    }, f = (w) => {
      var _;
      document.activeElement === ((_ = i.value) === null || _ === void 0 ? void 0 : _.input) && w.preventDefault();
    }, d = (w) => {
      var _, b;
      o("search", (b = (_ = i.value) === null || _ === void 0 ? void 0 : _.input) === null || b === void 0 ? void 0 : b.stateValue, w);
    }, p = (w) => {
      s.value || e.loading || d(w);
    }, v = (w) => {
      s.value = !0, o("compositionstart", w);
    }, h = (w) => {
      s.value = !1, o("compositionend", w);
    }, {
      prefixCls: m,
      getPrefixCls: y,
      direction: x,
      size: g
    } = mn("input-search", e), S = V(() => y("input", e.inputPrefixCls));
    return () => {
      var w, _, b, E;
      const {
        disabled: C,
        loading: T,
        addonAfter: O = (w = n.addonAfter) === null || w === void 0 ? void 0 : w.call(n),
        suffix: I = (_ = n.suffix) === null || _ === void 0 ? void 0 : _.call(n)
      } = e, k = Xle(e, ["disabled", "loading", "addonAfter", "suffix"]);
      let {
        enterButton: B = (E = (b = n.enterButton) === null || b === void 0 ? void 0 : b.call(n)) !== null && E !== void 0 ? E : !1
      } = e;
      B = B || B === "";
      const P = typeof B == "boolean" ? A(l1, null, null) : null, N = `${m.value}-button`, M = Array.isArray(B) ? B[0] : B;
      let H;
      const R = M.type && mD(M.type) && M.type.__ANT_BUTTON;
      if (R || M.tagName === "button")
        H = sr(M, D({
          onMousedown: f,
          onClick: d,
          key: "enterButton"
        }, R ? {
          class: N,
          size: g.value
        } : {}), !1);
      else {
        const W = P && !B;
        H = A(fn, {
          class: N,
          type: B ? "primary" : void 0,
          size: g.value,
          disabled: C,
          key: "enterButton",
          onMousedown: f,
          onClick: d,
          loading: T,
          icon: W ? P : null
        }, {
          default: () => [W ? null : P || B]
        });
      }
      O && (H = [H, O]);
      const z = Ge(m.value, {
        [`${m.value}-rtl`]: x.value === "rtl",
        [`${m.value}-${g.value}`]: !!g.value,
        [`${m.value}-with-button`]: !!B
      }, r.class);
      return A(dr, ve(ve(ve({
        ref: i
      }, Lr(k, ["onUpdate:value", "onSearch", "enterButton"])), r), {}, {
        onPressEnter: p,
        onCompositionstart: v,
        onCompositionend: h,
        size: g.value,
        prefixCls: S.value,
        addonAfter: H,
        suffix: I,
        onChange: c,
        class: z,
        disabled: C
      }), n);
    };
  }
}), Y5 = (e) => e != null && (Array.isArray(e) ? _s(e).length : !0);
function Qle(e) {
  return Y5(e.addonBefore) || Y5(e.addonAfter);
}
const Jle = ["text", "input"], eue = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ClearableLabeledInput",
  inheritAttrs: !1,
  props: {
    prefixCls: String,
    inputType: Oe.oneOf(eu("text", "input")),
    value: Oi(),
    defaultValue: Oi(),
    allowClear: {
      type: Boolean,
      default: void 0
    },
    element: Oi(),
    handleReset: Function,
    disabled: {
      type: Boolean,
      default: void 0
    },
    direction: {
      type: String
    },
    size: {
      type: String
    },
    suffix: Oi(),
    prefix: Oi(),
    addonBefore: Oi(),
    addonAfter: Oi(),
    readonly: {
      type: Boolean,
      default: void 0
    },
    focused: {
      type: Boolean,
      default: void 0
    },
    bordered: {
      type: Boolean,
      default: !0
    },
    triggerFocus: {
      type: Function
    },
    hidden: Boolean,
    status: String,
    hashId: String
  },
  setup(e, t) {
    let {
      slots: n,
      attrs: r
    } = t;
    const a = Wi.useInject(), o = (s) => {
      const {
        value: l,
        disabled: u,
        readonly: c,
        handleReset: f,
        suffix: d = n.suffix
      } = e, p = !u && !c && l, v = `${s}-clear-icon`;
      return A(Vo, {
        onClick: f,
        onMousedown: (h) => h.preventDefault(),
        class: Ge({
          [`${v}-hidden`]: !p,
          [`${v}-has-suffix`]: !!d
        }, v),
        role: "button"
      }, null);
    }, i = (s, l) => {
      const {
        value: u,
        allowClear: c,
        direction: f,
        bordered: d,
        hidden: p,
        status: v,
        addonAfter: h = n.addonAfter,
        addonBefore: m = n.addonBefore,
        hashId: y
      } = e, {
        status: x,
        hasFeedback: g
      } = a;
      if (!c)
        return sr(l, {
          value: u,
          disabled: e.disabled
        });
      const S = Ge(`${s}-affix-wrapper`, `${s}-affix-wrapper-textarea-with-clear-btn`, zl(`${s}-affix-wrapper`, wd(x, v), g), {
        [`${s}-affix-wrapper-rtl`]: f === "rtl",
        [`${s}-affix-wrapper-borderless`]: !d,
        // className will go to addon wrapper
        [`${r.class}`]: !Qle({
          addonAfter: h,
          addonBefore: m
        }) && r.class
      }, y);
      return A("span", {
        class: S,
        style: r.style,
        hidden: p
      }, [sr(l, {
        style: null,
        value: u,
        disabled: e.disabled
      }), o(s)]);
    };
    return () => {
      var s;
      const {
        prefixCls: l,
        inputType: u,
        element: c = (s = n.element) === null || s === void 0 ? void 0 : s.call(n)
      } = e;
      return u === Jle[0] ? i(l, c) : null;
    };
  }
}), tue = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, nue = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"], ax = {};
let Go;
function rue(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const n = e.getAttribute("id") || e.getAttribute("data-reactid") || e.getAttribute("name");
  if (t && ax[n])
    return ax[n];
  const r = window.getComputedStyle(e), a = r.getPropertyValue("box-sizing") || r.getPropertyValue("-moz-box-sizing") || r.getPropertyValue("-webkit-box-sizing"), o = parseFloat(r.getPropertyValue("padding-bottom")) + parseFloat(r.getPropertyValue("padding-top")), i = parseFloat(r.getPropertyValue("border-bottom-width")) + parseFloat(r.getPropertyValue("border-top-width")), l = {
    sizingStyle: nue.map((u) => `${u}:${r.getPropertyValue(u)}`).join(";"),
    paddingSize: o,
    borderSize: i,
    boxSizing: a
  };
  return t && n && (ax[n] = l), l;
}
function aue(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  Go || (Go = document.createElement("textarea"), Go.setAttribute("tab-index", "-1"), Go.setAttribute("aria-hidden", "true"), document.body.appendChild(Go)), e.getAttribute("wrap") ? Go.setAttribute("wrap", e.getAttribute("wrap")) : Go.removeAttribute("wrap");
  const {
    paddingSize: a,
    borderSize: o,
    boxSizing: i,
    sizingStyle: s
  } = rue(e, t);
  Go.setAttribute("style", `${s};${tue}`), Go.value = e.value || e.placeholder || "";
  let l, u, c, f = Go.scrollHeight;
  if (i === "border-box" ? f += o : i === "content-box" && (f -= a), n !== null || r !== null) {
    Go.value = " ";
    const p = Go.scrollHeight - a;
    n !== null && (l = p * n, i === "border-box" && (l = l + a + o), f = Math.max(l, f)), r !== null && (u = p * r, i === "border-box" && (u = u + a + o), c = f > u ? "" : "hidden", f = Math.min(u, f));
  }
  const d = {
    height: `${f}px`,
    overflowY: c,
    resize: "none"
  };
  return l && (d.minHeight = `${l}px`), u && (d.maxHeight = `${u}px`), d;
}
const ox = 0, ix = 1, sx = 2, oue = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ResizableTextArea",
  inheritAttrs: !1,
  props: P7(),
  setup(e, t) {
    let {
      attrs: n,
      emit: r,
      expose: a
    } = t, o, i;
    const s = ne(), l = ne({}), u = ne(sx);
    Sn(() => {
      dn.cancel(o), dn.cancel(i);
    });
    const c = () => {
      try {
        if (document.activeElement === s.value) {
          const _ = s.value.selectionStart, b = s.value.selectionEnd, E = s.value.scrollTop;
          s.value.setSelectionRange(_, b), s.value.scrollTop = E;
        }
      } catch {
      }
    }, f = ne(), d = ne();
    _n(() => {
      const _ = e.autoSize || e.autosize;
      _ ? (f.value = _.minRows, d.value = _.maxRows) : (f.value = void 0, d.value = void 0);
    });
    const p = V(() => !!(e.autoSize || e.autosize)), v = () => {
      u.value = ox;
    };
    He([() => e.value, f, d, p], () => {
      p.value && v();
    }, {
      immediate: !0,
      flush: "post"
    });
    const h = ne();
    He([u, s], () => {
      if (s.value)
        if (u.value === ox)
          u.value = ix;
        else if (u.value === ix) {
          const _ = aue(s.value, !1, f.value, d.value);
          u.value = sx, h.value = _;
        } else
          c();
    }, {
      immediate: !0,
      flush: "post"
    });
    const m = jn(), y = ne(), x = () => {
      dn.cancel(y.value);
    }, g = (_) => {
      u.value === sx && (r("resize", _), p.value && (x(), y.value = dn(() => {
        v();
      })));
    };
    Sn(() => {
      x();
    }), a({
      resizeTextarea: () => {
        v();
      },
      textArea: s,
      instance: m
    }), Pa(e.autosize === void 0, "Input.TextArea", "autosize is deprecated, please use autoSize instead.");
    const w = () => {
      const {
        prefixCls: _,
        disabled: b
      } = e, E = Lr(e, ["prefixCls", "onPressEnter", "autoSize", "autosize", "defaultValue", "allowClear", "type", "lazy", "maxlength", "valueModifiers"]), C = Ge(_, n.class, {
        [`${_}-disabled`]: b
      }), T = p.value ? h.value : null, O = [n.style, l.value, T], I = D(D(D({}, E), n), {
        style: O,
        class: C
      });
      return (u.value === ox || u.value === ix) && O.push({
        overflowX: "hidden",
        overflowY: "hidden"
      }), I.autofocus || delete I.autofocus, I.rows === 0 && delete I.rows, A(Wg, {
        onResize: g,
        disabled: !p.value
      }, {
        default: () => [Yn(A("textarea", ve(ve({}, I), {}, {
          ref: s
        }), null), [[Vp]])]
      });
    };
    return () => w();
  }
});
function D7(e, t) {
  return [...e || ""].slice(0, t).join("");
}
function q5(e, t, n, r) {
  let a = n;
  return e ? a = D7(n, r) : [...t || ""].length < n.length && [...n || ""].length > r && (a = t), a;
}
const k7 = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ATextarea",
  inheritAttrs: !1,
  props: P7(),
  setup(e, t) {
    let {
      attrs: n,
      expose: r,
      emit: a
    } = t;
    const o = fu(), i = Wi.useInject(), s = V(() => wd(i.status, e.status)), l = Be(e.value === void 0 ? e.defaultValue : e.value), u = Be(), c = Be(""), {
      prefixCls: f,
      size: d,
      direction: p
    } = mn("input", e), [v, h] = f4(f), m = Ec(), y = V(() => e.showCount === "" || e.showCount || !1), x = V(() => Number(e.maxlength) > 0), g = Be(!1), S = Be(), w = Be(0), _ = (H) => {
      g.value = !0, S.value = c.value, w.value = H.currentTarget.selectionStart, a("compositionstart", H);
    }, b = (H) => {
      var R;
      g.value = !1;
      let z = H.currentTarget.value;
      if (x.value) {
        const W = w.value >= e.maxlength + 1 || w.value === ((R = S.value) === null || R === void 0 ? void 0 : R.length);
        z = q5(W, S.value, z, e.maxlength);
      }
      z !== c.value && (O(z), $0(H.currentTarget, H, B, z)), a("compositionend", H);
    }, E = jn();
    He(() => e.value, () => {
      var H;
      "value" in E.vnode.props, l.value = (H = e.value) !== null && H !== void 0 ? H : "";
    });
    const C = (H) => {
      var R;
      O7((R = u.value) === null || R === void 0 ? void 0 : R.textArea, H);
    }, T = () => {
      var H, R;
      (R = (H = u.value) === null || H === void 0 ? void 0 : H.textArea) === null || R === void 0 || R.blur();
    }, O = (H, R) => {
      l.value !== H && (e.value === void 0 ? l.value = H : nn(() => {
        var z, W, F;
        u.value.textArea.value !== c.value && ((F = (z = u.value) === null || z === void 0 ? void 0 : (W = z.instance).update) === null || F === void 0 || F.call(W));
      }), nn(() => {
        R && R();
      }));
    }, I = (H) => {
      H.keyCode === 13 && a("pressEnter", H), a("keydown", H);
    }, k = (H) => {
      const {
        onBlur: R
      } = e;
      R == null || R(H), o.onFieldBlur();
    }, B = (H) => {
      a("update:value", H.target.value), a("change", H), a("input", H), o.onFieldChange();
    }, P = (H) => {
      $0(u.value.textArea, H, B), O("", () => {
        C();
      });
    }, N = (H) => {
      const {
        composing: R
      } = H.target;
      let z = H.target.value;
      if (g.value = !!(H.isComposing || R), !(g.value && e.lazy || l.value === z)) {
        if (x.value) {
          const W = H.target, F = W.selectionStart >= e.maxlength + 1 || W.selectionStart === z.length || !W.selectionStart;
          z = q5(F, c.value, z, e.maxlength);
        }
        $0(H.currentTarget, H, B, z), O(z);
      }
    }, M = () => {
      var H, R;
      const {
        class: z
      } = n, {
        bordered: W = !0
      } = e, F = D(D(D({}, Lr(e, ["allowClear"])), n), {
        class: [{
          [`${f.value}-borderless`]: !W,
          [`${z}`]: z && !y.value,
          [`${f.value}-sm`]: d.value === "small",
          [`${f.value}-lg`]: d.value === "large"
        }, zl(f.value, s.value), h.value],
        disabled: m.value,
        showCount: null,
        prefixCls: f.value,
        onInput: N,
        onChange: N,
        onBlur: k,
        onKeydown: I,
        onCompositionstart: _,
        onCompositionend: b
      });
      return !((H = e.valueModifiers) === null || H === void 0) && H.lazy && delete F.onInput, A(oue, ve(ve({}, F), {}, {
        id: (R = F == null ? void 0 : F.id) !== null && R !== void 0 ? R : o.id.value,
        ref: u,
        maxlength: e.maxlength
      }), null);
    };
    return r({
      focus: C,
      blur: T,
      resizableTextArea: u
    }), _n(() => {
      let H = D2(l.value);
      !g.value && x.value && (e.value === null || e.value === void 0) && (H = D7(H, e.maxlength)), c.value = H;
    }), () => {
      var H;
      const {
        maxlength: R,
        bordered: z = !0,
        hidden: W
      } = e, {
        style: F,
        class: Y
      } = n, X = D(D(D({}, e), n), {
        prefixCls: f.value,
        inputType: "text",
        handleReset: P,
        direction: p.value,
        bordered: z,
        style: y.value ? void 0 : F,
        hashId: h.value,
        disabled: (H = e.disabled) !== null && H !== void 0 ? H : m.value
      });
      let q = A(eue, ve(ve({}, X), {}, {
        value: c.value,
        status: e.status
      }), {
        element: M
      });
      if (y.value || i.hasFeedback) {
        const Q = [...c.value].length;
        let ue = "";
        typeof y.value == "object" ? ue = y.value.formatter({
          value: c.value,
          count: Q,
          maxlength: R
        }) : ue = `${Q}${x.value ? ` / ${R}` : ""}`, q = A("div", {
          hidden: W,
          class: Ge(`${f.value}-textarea`, {
            [`${f.value}-textarea-rtl`]: p.value === "rtl",
            [`${f.value}-textarea-show-count`]: y.value,
            [`${f.value}-textarea-in-form-item`]: i.isFormItemInput
          }, `${f.value}-textarea-show-count`, Y, h.value),
          style: F,
          "data-count": typeof ue != "object" ? ue : void 0
        }, [q, i.hasFeedback && A("span", {
          class: `${f.value}-textarea-suffix`
        }, [i.feedbackIcon])]);
      }
      return v(q);
    };
  }
});
var iue = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" };
function X5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      sue(e, a, n[a]);
    });
  }
  return e;
}
function sue(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var w4 = function(t, n) {
  var r = X5({}, t, n.attrs);
  return A(Bn, X5({}, r, {
    icon: iue
  }), null);
};
w4.displayName = "EyeOutlined";
w4.inheritAttrs = !1;
var lue = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { tag: "path", attrs: { d: "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, name: "eye-invisible", theme: "outlined" };
function Z5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      uue(e, a, n[a]);
    });
  }
  return e;
}
function uue(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var S4 = function(t, n) {
  var r = Z5({}, t, n.attrs);
  return A(Bn, Z5({}, r, {
    icon: lue
  }), null);
};
S4.displayName = "EyeInvisibleOutlined";
S4.inheritAttrs = !1;
var cue = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const fue = {
  click: "onClick",
  hover: "onMouseover"
}, due = (e) => A(e ? w4 : S4, null, null), pue = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AInputPassword",
  inheritAttrs: !1,
  props: D(D({}, R1()), {
    prefixCls: String,
    inputPrefixCls: String,
    action: {
      type: String,
      default: "click"
    },
    visibilityToggle: {
      type: Boolean,
      default: !0
    },
    visible: {
      type: Boolean,
      default: void 0
    },
    "onUpdate:visible": Function,
    iconRender: Function
  }),
  setup(e, t) {
    let {
      slots: n,
      attrs: r,
      expose: a,
      emit: o
    } = t;
    const i = Be(!1), s = () => {
      const {
        disabled: m
      } = e;
      m || (i.value = !i.value, o("update:visible", i.value));
    };
    _n(() => {
      e.visible !== void 0 && (i.value = !!e.visible);
    });
    const l = Be();
    a({
      focus: () => {
        var m;
        (m = l.value) === null || m === void 0 || m.focus();
      },
      blur: () => {
        var m;
        (m = l.value) === null || m === void 0 || m.blur();
      }
    });
    const f = (m) => {
      const {
        action: y,
        iconRender: x = n.iconRender || due
      } = e, g = fue[y] || "", S = x(i.value), w = {
        [g]: s,
        class: `${m}-icon`,
        key: "passwordIcon",
        onMousedown: (_) => {
          _.preventDefault();
        },
        onMouseup: (_) => {
          _.preventDefault();
        }
      };
      return sr(co(S) ? S : A("span", null, [S]), w);
    }, {
      prefixCls: d,
      getPrefixCls: p
    } = mn("input-password", e), v = V(() => p("input", e.inputPrefixCls)), h = () => {
      const {
        size: m,
        visibilityToggle: y
      } = e, x = cue(e, ["size", "visibilityToggle"]), g = y && f(d.value), S = Ge(d.value, r.class, {
        [`${d.value}-${m}`]: !!m
      }), w = D(D(D({}, Lr(x, ["suffix", "iconRender", "action"])), r), {
        type: i.value ? "text" : "password",
        class: S,
        prefixCls: v.value,
        suffix: g
      });
      return m && (w.size = m), A(dr, ve({
        ref: l
      }, w), n);
    };
    return () => h();
  }
});
dr.Group = qle;
dr.Search = Zle;
dr.TextArea = k7;
dr.Password = pue;
dr.install = function(e) {
  return e.component(dr.name, dr), e.component(dr.Group.name, dr.Group), e.component(dr.Search.name, dr.Search), e.component(dr.TextArea.name, dr.TextArea), e.component(dr.Password.name, dr.Password), e;
};
function _4() {
  return {
    keyboard: {
      type: Boolean,
      default: void 0
    },
    mask: {
      type: Boolean,
      default: void 0
    },
    afterClose: Function,
    closable: {
      type: Boolean,
      default: void 0
    },
    maskClosable: {
      type: Boolean,
      default: void 0
    },
    visible: {
      type: Boolean,
      default: void 0
    },
    destroyOnClose: {
      type: Boolean,
      default: void 0
    },
    mousePosition: Oe.shape({
      x: Number,
      y: Number
    }).loose,
    title: Oe.any,
    footer: Oe.any,
    transitionName: String,
    maskTransitionName: String,
    animation: Oe.any,
    maskAnimation: Oe.any,
    wrapStyle: {
      type: Object,
      default: void 0
    },
    bodyStyle: {
      type: Object,
      default: void 0
    },
    maskStyle: {
      type: Object,
      default: void 0
    },
    prefixCls: String,
    wrapClassName: String,
    rootClassName: String,
    width: [String, Number],
    height: [String, Number],
    zIndex: Number,
    bodyProps: Oe.any,
    maskProps: Oe.any,
    wrapProps: Oe.any,
    getContainer: Oe.any,
    dialogStyle: {
      type: Object,
      default: void 0
    },
    dialogClass: String,
    closeIcon: Oe.any,
    forceRender: {
      type: Boolean,
      default: void 0
    },
    getOpenCount: Function,
    // https://github.com/ant-design/ant-design/issues/19771
    // https://github.com/react-component/dialog/issues/95
    focusTriggerAfterClose: {
      type: Boolean,
      default: void 0
    },
    onClose: Function,
    modalRender: Function
  };
}
function Q5(e, t, n) {
  let r = t;
  return !r && n && (r = `${e}-${n}`), r;
}
let J5 = -1;
function hue() {
  return J5 += 1, J5;
}
function e6(e, t) {
  let n = e[`page${t ? "Y" : "X"}Offset`];
  const r = `scroll${t ? "Top" : "Left"}`;
  if (typeof n != "number") {
    const a = e.document;
    n = a.documentElement[r], typeof n != "number" && (n = a.body[r]);
  }
  return n;
}
function vue(e) {
  const t = e.getBoundingClientRect(), n = {
    left: t.left,
    top: t.top
  }, r = e.ownerDocument, a = r.defaultView || r.parentWindow;
  return n.left += e6(a), n.top += e6(a, !0), n;
}
const t6 = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
}, mue = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "DialogContent",
  inheritAttrs: !1,
  props: D(D({}, _4()), {
    motionName: String,
    ariaId: String,
    onVisibleChanged: Function,
    onMousedown: Function,
    onMouseup: Function
  }),
  setup(e, t) {
    let {
      expose: n,
      slots: r,
      attrs: a
    } = t;
    const o = ne(), i = ne(), s = ne();
    n({
      focus: () => {
        var d;
        (d = o.value) === null || d === void 0 || d.focus();
      },
      changeActive: (d) => {
        const {
          activeElement: p
        } = document;
        d && p === i.value ? o.value.focus() : !d && p === o.value && i.value.focus();
      }
    });
    const l = ne(), u = V(() => {
      const {
        width: d,
        height: p
      } = e, v = {};
      return d !== void 0 && (v.width = typeof d == "number" ? `${d}px` : d), p !== void 0 && (v.height = typeof p == "number" ? `${p}px` : p), l.value && (v.transformOrigin = l.value), v;
    }), c = () => {
      nn(() => {
        if (s.value) {
          const d = vue(s.value);
          l.value = e.mousePosition ? `${e.mousePosition.x - d.left}px ${e.mousePosition.y - d.top}px` : "";
        }
      });
    }, f = (d) => {
      e.onVisibleChanged(d);
    };
    return () => {
      var d, p, v, h;
      const {
        prefixCls: m,
        footer: y = (d = r.footer) === null || d === void 0 ? void 0 : d.call(r),
        title: x = (p = r.title) === null || p === void 0 ? void 0 : p.call(r),
        ariaId: g,
        closable: S,
        closeIcon: w = (v = r.closeIcon) === null || v === void 0 ? void 0 : v.call(r),
        onClose: _,
        bodyStyle: b,
        bodyProps: E,
        onMousedown: C,
        onMouseup: T,
        visible: O,
        modalRender: I = r.modalRender,
        destroyOnClose: k,
        motionName: B
      } = e;
      let P;
      y && (P = A("div", {
        class: `${m}-footer`
      }, [y]));
      let N;
      x && (N = A("div", {
        class: `${m}-header`
      }, [A("div", {
        class: `${m}-title`,
        id: g
      }, [x])]));
      let M;
      S && (M = A("button", {
        type: "button",
        onClick: _,
        "aria-label": "Close",
        class: `${m}-close`
      }, [w || A("span", {
        class: `${m}-close-x`
      }, null)]));
      const H = A("div", {
        class: `${m}-content`
      }, [M, N, A("div", ve({
        class: `${m}-body`,
        style: b
      }, E), [(h = r.default) === null || h === void 0 ? void 0 : h.call(r)]), P]), R = Hp(B);
      return A(Ho, ve(ve({}, R), {}, {
        onBeforeEnter: c,
        onAfterEnter: () => f(!0),
        onAfterLeave: () => f(!1)
      }), {
        default: () => [O || !k ? Yn(A("div", ve(ve({}, a), {}, {
          ref: s,
          key: "dialog-element",
          role: "document",
          style: [u.value, a.style],
          class: [m, a.class],
          onMousedown: C,
          onMouseup: T
        }), [A("div", {
          tabindex: 0,
          ref: o,
          style: t6,
          "aria-hidden": "true"
        }, null), I ? I({
          originVNode: H
        }) : H, A("div", {
          tabindex: 0,
          ref: i,
          style: t6,
          "aria-hidden": "true"
        }, null)]), [[ko, O]]) : null]
      });
    };
  }
}), gue = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "DialogMask",
  props: {
    prefixCls: String,
    visible: Boolean,
    motionName: String,
    maskProps: Object
  },
  setup(e, t) {
    return () => {
      const {
        prefixCls: n,
        visible: r,
        maskProps: a,
        motionName: o
      } = e, i = Hp(o);
      return A(Ho, i, {
        default: () => [Yn(A("div", ve({
          class: `${n}-mask`
        }, a), null), [[ko, r]])]
      });
    };
  }
}), n6 = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "VcDialog",
  inheritAttrs: !1,
  props: ha(D(D({}, _4()), {
    getOpenCount: Function,
    scrollLocker: Object
  }), {
    mask: !0,
    visible: !1,
    keyboard: !0,
    closable: !0,
    maskClosable: !0,
    destroyOnClose: !1,
    prefixCls: "rc-dialog",
    getOpenCount: () => null,
    focusTriggerAfterClose: !0
  }),
  setup(e, t) {
    let {
      attrs: n,
      slots: r
    } = t;
    const a = Be(), o = Be(), i = Be(), s = Be(e.visible), l = Be(`vcDialogTitle${hue()}`), u = (y) => {
      var x, g;
      if (y)
        Pl(o.value, document.activeElement) || (a.value = document.activeElement, (x = i.value) === null || x === void 0 || x.focus());
      else {
        const S = s.value;
        if (s.value = !1, e.mask && a.value && e.focusTriggerAfterClose) {
          try {
            a.value.focus({
              preventScroll: !0
            });
          } catch {
          }
          a.value = null;
        }
        S && ((g = e.afterClose) === null || g === void 0 || g.call(e));
      }
    }, c = (y) => {
      var x;
      (x = e.onClose) === null || x === void 0 || x.call(e, y);
    }, f = Be(!1), d = Be(), p = () => {
      clearTimeout(d.value), f.value = !0;
    }, v = () => {
      d.value = setTimeout(() => {
        f.value = !1;
      });
    }, h = (y) => {
      if (!e.maskClosable) return null;
      f.value ? f.value = !1 : o.value === y.target && c(y);
    }, m = (y) => {
      if (e.keyboard && y.keyCode === Ye.ESC) {
        y.stopPropagation(), c(y);
        return;
      }
      e.visible && y.keyCode === Ye.TAB && i.value.changeActive(!y.shiftKey);
    };
    return He(() => e.visible, () => {
      e.visible && (s.value = !0);
    }, {
      flush: "post"
    }), Sn(() => {
      var y;
      clearTimeout(d.value), (y = e.scrollLocker) === null || y === void 0 || y.unLock();
    }), _n(() => {
      var y, x;
      (y = e.scrollLocker) === null || y === void 0 || y.unLock(), s.value && ((x = e.scrollLocker) === null || x === void 0 || x.lock());
    }), () => {
      const {
        prefixCls: y,
        mask: x,
        visible: g,
        maskTransitionName: S,
        maskAnimation: w,
        zIndex: _,
        wrapClassName: b,
        rootClassName: E,
        wrapStyle: C,
        closable: T,
        maskProps: O,
        maskStyle: I,
        transitionName: k,
        animation: B,
        wrapProps: P,
        title: N = r.title
      } = e, {
        style: M,
        class: H
      } = n;
      return A("div", ve({
        class: [`${y}-root`, E]
      }, i1(e, {
        data: !0
      })), [A(gue, {
        prefixCls: y,
        visible: x && g,
        motionName: Q5(y, S, w),
        style: D({
          zIndex: _
        }, I),
        maskProps: O
      }, null), A("div", ve({
        tabIndex: -1,
        onKeydown: m,
        class: Ge(`${y}-wrap`, b),
        ref: o,
        onClick: h,
        role: "dialog",
        "aria-labelledby": N ? l.value : null,
        style: D(D({
          zIndex: _
        }, C), {
          display: s.value ? null : "none"
        })
      }, P), [A(mue, ve(ve({}, Lr(e, ["scrollLocker"])), {}, {
        style: M,
        class: H,
        onMousedown: p,
        onMouseup: v,
        ref: i,
        closable: T,
        ariaId: l.value,
        prefixCls: y,
        visible: g,
        onClose: c,
        onVisibleChanged: u,
        motionName: Q5(y, k, B)
      }), r)])]);
    };
  }
}), yue = _4(), xue = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "DialogWrap",
  inheritAttrs: !1,
  props: ha(yue, {
    visible: !1
  }),
  setup(e, t) {
    let {
      attrs: n,
      slots: r
    } = t;
    const a = ne(e.visible);
    return hC({}, {
      inTriggerContext: !1
    }), He(() => e.visible, () => {
      e.visible && (a.value = !0);
    }, {
      flush: "post"
    }), () => {
      const {
        visible: o,
        getContainer: i,
        forceRender: s,
        destroyOnClose: l = !1,
        afterClose: u
      } = e;
      let c = D(D(D({}, e), n), {
        ref: "_component",
        key: "dialog"
      });
      return i === !1 ? A(n6, ve(ve({}, c), {}, {
        getOpenCount: () => 2
      }), r) : !s && l && !a.value ? null : A(HP, {
        autoLock: !0,
        visible: o,
        forceRender: s,
        getContainer: i
      }, {
        default: (f) => (c = D(D(D({}, c), f), {
          afterClose: () => {
            u == null || u(), a.value = !1;
          }
        }), A(n6, c, r))
      });
    };
  }
});
function r6(e) {
  return {
    position: e,
    top: 0,
    insetInlineEnd: 0,
    bottom: 0,
    insetInlineStart: 0
  };
}
const bue = (e) => {
  const {
    componentCls: t
  } = e;
  return [{
    [`${t}-root`]: {
      [`${t}${e.antCls}-zoom-enter, ${t}${e.antCls}-zoom-appear`]: {
        // reset scale avoid mousePosition bug
        transform: "none",
        opacity: 0,
        animationDuration: e.motionDurationSlow,
        // https://github.com/ant-design/ant-design/issues/11777
        userSelect: "none"
      },
      [`${t}${e.antCls}-zoom-leave ${t}-content`]: {
        pointerEvents: "none"
      },
      [`${t}-mask`]: D(D({}, r6("fixed")), {
        zIndex: e.zIndexPopupBase,
        height: "100%",
        backgroundColor: e.colorBgMask,
        [`${t}-hidden`]: {
          display: "none"
        }
      }),
      [`${t}-wrap`]: D(D({}, r6("fixed")), {
        overflow: "auto",
        outline: 0,
        WebkitOverflowScrolling: "touch"
      })
    }
  }, {
    [`${t}-root`]: Ite(e)
  }];
}, wue = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    // ======================== Root =========================
    {
      [`${t}-root`]: {
        [`${t}-wrap`]: {
          zIndex: e.zIndexPopupBase,
          position: "fixed",
          inset: 0,
          overflow: "auto",
          outline: 0,
          WebkitOverflowScrolling: "touch"
        },
        [`${t}-wrap-rtl`]: {
          direction: "rtl"
        },
        [`${t}-centered`]: {
          textAlign: "center",
          "&::before": {
            display: "inline-block",
            width: 0,
            height: "100%",
            verticalAlign: "middle",
            content: '""'
          },
          [t]: {
            top: 0,
            display: "inline-block",
            paddingBottom: 0,
            textAlign: "start",
            verticalAlign: "middle"
          }
        },
        [`@media (max-width: ${e.screenSMMax})`]: {
          [t]: {
            maxWidth: "calc(100vw - 16px)",
            margin: `${e.marginXS} auto`
          },
          [`${t}-centered`]: {
            [t]: {
              flex: 1
            }
          }
        }
      }
    },
    // ======================== Modal ========================
    {
      [t]: D(D({}, gr(e)), {
        pointerEvents: "none",
        position: "relative",
        top: 100,
        width: "auto",
        maxWidth: `calc(100vw - ${e.margin * 2}px)`,
        margin: "0 auto",
        paddingBottom: e.paddingLG,
        [`${t}-title`]: {
          margin: 0,
          color: e.modalHeadingColor,
          fontWeight: e.fontWeightStrong,
          fontSize: e.modalHeaderTitleFontSize,
          lineHeight: e.modalHeaderTitleLineHeight,
          wordWrap: "break-word"
        },
        [`${t}-content`]: {
          position: "relative",
          backgroundColor: e.modalContentBg,
          backgroundClip: "padding-box",
          border: 0,
          borderRadius: e.borderRadiusLG,
          boxShadow: e.boxShadowSecondary,
          pointerEvents: "auto",
          padding: `${e.paddingMD}px ${e.paddingContentHorizontalLG}px`
        },
        [`${t}-close`]: D({
          position: "absolute",
          top: (e.modalHeaderCloseSize - e.modalCloseBtnSize) / 2,
          insetInlineEnd: (e.modalHeaderCloseSize - e.modalCloseBtnSize) / 2,
          zIndex: e.zIndexPopupBase + 10,
          padding: 0,
          color: e.modalCloseColor,
          fontWeight: e.fontWeightStrong,
          lineHeight: 1,
          textDecoration: "none",
          background: "transparent",
          borderRadius: e.borderRadiusSM,
          width: e.modalConfirmIconSize,
          height: e.modalConfirmIconSize,
          border: 0,
          outline: 0,
          cursor: "pointer",
          transition: `color ${e.motionDurationMid}, background-color ${e.motionDurationMid}`,
          "&-x": {
            display: "block",
            fontSize: e.fontSizeLG,
            fontStyle: "normal",
            lineHeight: `${e.modalCloseBtnSize}px`,
            textAlign: "center",
            textTransform: "none",
            textRendering: "auto"
          },
          "&:hover": {
            color: e.modalIconHoverColor,
            backgroundColor: e.wireframe ? "transparent" : e.colorFillContent,
            textDecoration: "none"
          },
          "&:active": {
            backgroundColor: e.wireframe ? "transparent" : e.colorFillContentHover
          }
        }, sp(e)),
        [`${t}-header`]: {
          color: e.colorText,
          background: e.modalHeaderBg,
          borderRadius: `${e.borderRadiusLG}px ${e.borderRadiusLG}px 0 0`,
          marginBottom: e.marginXS
        },
        [`${t}-body`]: {
          fontSize: e.fontSize,
          lineHeight: e.lineHeight,
          wordWrap: "break-word"
        },
        [`${t}-footer`]: {
          textAlign: "end",
          background: e.modalFooterBg,
          marginTop: e.marginSM,
          [`${e.antCls}-btn + ${e.antCls}-btn:not(${e.antCls}-dropdown-trigger)`]: {
            marginBottom: 0,
            marginInlineStart: e.marginXS
          }
        },
        [`${t}-open`]: {
          overflow: "hidden"
        }
      })
    },
    // ======================== Pure =========================
    {
      [`${t}-pure-panel`]: {
        top: "auto",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        [`${t}-content,
          ${t}-body,
          ${t}-confirm-body-wrapper`]: {
          display: "flex",
          flexDirection: "column",
          flex: "auto"
        },
        [`${t}-confirm-body`]: {
          marginBottom: "auto"
        }
      }
    }
  ];
}, Sue = (e) => {
  const {
    componentCls: t
  } = e, n = `${t}-confirm`;
  return {
    [n]: {
      "&-rtl": {
        direction: "rtl"
      },
      [`${e.antCls}-modal-header`]: {
        display: "none"
      },
      [`${n}-body-wrapper`]: D({}, wm()),
      [`${n}-body`]: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        [`${n}-title`]: {
          flex: "0 0 100%",
          display: "block",
          // create BFC to avoid
          // https://user-images.githubusercontent.com/507615/37702510-ba844e06-2d2d-11e8-9b67-8e19be57f445.png
          overflow: "hidden",
          color: e.colorTextHeading,
          fontWeight: e.fontWeightStrong,
          fontSize: e.modalHeaderTitleFontSize,
          lineHeight: e.modalHeaderTitleLineHeight,
          [`+ ${n}-content`]: {
            marginBlockStart: e.marginXS,
            flexBasis: "100%",
            maxWidth: `calc(100% - ${e.modalConfirmIconSize + e.marginSM}px)`
          }
        },
        [`${n}-content`]: {
          color: e.colorText,
          fontSize: e.fontSize
        },
        [`> ${e.iconCls}`]: {
          flex: "none",
          marginInlineEnd: e.marginSM,
          fontSize: e.modalConfirmIconSize,
          [`+ ${n}-title`]: {
            flex: 1
          },
          // `content` after `icon` should set marginLeft
          [`+ ${n}-title + ${n}-content`]: {
            marginInlineStart: e.modalConfirmIconSize + e.marginSM
          }
        }
      },
      [`${n}-btns`]: {
        textAlign: "end",
        marginTop: e.marginSM,
        [`${e.antCls}-btn + ${e.antCls}-btn`]: {
          marginBottom: 0,
          marginInlineStart: e.marginXS
        }
      }
    },
    [`${n}-error ${n}-body > ${e.iconCls}`]: {
      color: e.colorError
    },
    [`${n}-warning ${n}-body > ${e.iconCls},
        ${n}-confirm ${n}-body > ${e.iconCls}`]: {
      color: e.colorWarning
    },
    [`${n}-info ${n}-body > ${e.iconCls}`]: {
      color: e.colorInfo
    },
    [`${n}-success ${n}-body > ${e.iconCls}`]: {
      color: e.colorSuccess
    },
    // https://github.com/ant-design/ant-design/issues/37329
    [`${t}-zoom-leave ${t}-btns`]: {
      pointerEvents: "none"
    }
  };
}, _ue = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-root`]: {
      [`${t}-wrap-rtl`]: {
        direction: "rtl",
        [`${t}-confirm-body`]: {
          direction: "rtl"
        }
      }
    }
  };
}, Cue = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e, r = `${t}-confirm`;
  return {
    [t]: {
      [`${t}-content`]: {
        padding: 0
      },
      [`${t}-header`]: {
        padding: e.modalHeaderPadding,
        borderBottom: `${e.modalHeaderBorderWidth}px ${e.modalHeaderBorderStyle} ${e.modalHeaderBorderColorSplit}`,
        marginBottom: 0
      },
      [`${t}-body`]: {
        padding: e.modalBodyPadding
      },
      [`${t}-footer`]: {
        padding: `${e.modalFooterPaddingVertical}px ${e.modalFooterPaddingHorizontal}px`,
        borderTop: `${e.modalFooterBorderWidth}px ${e.modalFooterBorderStyle} ${e.modalFooterBorderColorSplit}`,
        borderRadius: `0 0 ${e.borderRadiusLG}px ${e.borderRadiusLG}px`,
        marginTop: 0
      }
    },
    [r]: {
      [`${n}-modal-body`]: {
        padding: `${e.padding * 2}px ${e.padding * 2}px ${e.paddingLG}px`
      },
      [`${r}-body`]: {
        [`> ${e.iconCls}`]: {
          marginInlineEnd: e.margin,
          // `content` after `icon` should set marginLeft
          [`+ ${r}-title + ${r}-content`]: {
            marginInlineStart: e.modalConfirmIconSize + e.margin
          }
        }
      },
      [`${r}-btns`]: {
        marginTop: e.marginLG
      }
    }
  };
}, Eue = xr("Modal", (e) => {
  const t = e.padding, n = e.fontSizeHeading5, r = e.lineHeightHeading5, a = xn(e, {
    modalBodyPadding: e.paddingLG,
    modalHeaderBg: e.colorBgElevated,
    modalHeaderPadding: `${t}px ${e.paddingLG}px`,
    modalHeaderBorderWidth: e.lineWidth,
    modalHeaderBorderStyle: e.lineType,
    modalHeaderTitleLineHeight: r,
    modalHeaderTitleFontSize: n,
    modalHeaderBorderColorSplit: e.colorSplit,
    modalHeaderCloseSize: r * n + t * 2,
    modalContentBg: e.colorBgElevated,
    modalHeadingColor: e.colorTextHeading,
    modalCloseColor: e.colorTextDescription,
    modalFooterBg: "transparent",
    modalFooterBorderColorSplit: e.colorSplit,
    modalFooterBorderStyle: e.lineType,
    modalFooterPaddingVertical: e.paddingXS,
    modalFooterPaddingHorizontal: e.padding,
    modalFooterBorderWidth: e.lineWidth,
    modalConfirmTitleFontSize: e.fontSizeLG,
    modalIconHoverColor: e.colorIconHover,
    modalConfirmIconSize: e.fontSize * e.lineHeight,
    modalCloseBtnSize: e.controlHeightLG * 0.55
  });
  return [wue(a), Sue(a), _ue(a), bue(a), e.wireframe && Cue(a), y1(a, "zoom")];
});
function Tue(e, t, n) {
  var r = n || {}, a = r.noTrailing, o = a === void 0 ? !1 : a, i = r.noLeading, s = i === void 0 ? !1 : i, l = r.debounceMode, u = l === void 0 ? void 0 : l, c, f = !1, d = 0;
  function p() {
    c && clearTimeout(c);
  }
  function v(m) {
    var y = m || {}, x = y.upcomingOnly, g = x === void 0 ? !1 : x;
    p(), f = !g;
  }
  function h() {
    for (var m = arguments.length, y = new Array(m), x = 0; x < m; x++)
      y[x] = arguments[x];
    var g = this, S = Date.now() - d;
    if (f)
      return;
    function w() {
      d = Date.now(), t.apply(g, y);
    }
    function _() {
      c = void 0;
    }
    !s && u && !c && w(), p(), u === void 0 && S > e ? s ? (d = Date.now(), o || (c = setTimeout(u ? _ : w, e))) : w() : o !== !0 && (c = setTimeout(u ? _ : w, u === void 0 ? e - S : e));
  }
  return h.cancel = v, h;
}
function $ue(e, t, n) {
  var r = {}, a = r.atBegin, o = a === void 0 ? !1 : a;
  return Tue(e, t, {
    debounceMode: o !== !1
  });
}
const Oue = new rn("antSpinMove", {
  to: {
    opacity: 1
  }
}), Aue = new rn("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), Iue = (e) => ({
  [`${e.componentCls}`]: D(D({}, gr(e)), {
    position: "absolute",
    display: "none",
    color: e.colorPrimary,
    textAlign: "center",
    verticalAlign: "middle",
    opacity: 0,
    transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`,
    "&-spinning": {
      position: "static",
      display: "inline-block",
      opacity: 1
    },
    "&-nested-loading": {
      position: "relative",
      [`> div > ${e.componentCls}`]: {
        position: "absolute",
        top: 0,
        insetInlineStart: 0,
        zIndex: 4,
        display: "block",
        width: "100%",
        height: "100%",
        maxHeight: e.contentHeight,
        [`${e.componentCls}-dot`]: {
          position: "absolute",
          top: "50%",
          insetInlineStart: "50%",
          margin: -e.spinDotSize / 2
        },
        [`${e.componentCls}-text`]: {
          position: "absolute",
          top: "50%",
          width: "100%",
          paddingTop: (e.spinDotSize - e.fontSize) / 2 + 2,
          textShadow: `0 1px 2px ${e.colorBgContainer}`
          // FIXME: shadow
        },
        [`&${e.componentCls}-show-text ${e.componentCls}-dot`]: {
          marginTop: -(e.spinDotSize / 2) - 10
        },
        "&-sm": {
          [`${e.componentCls}-dot`]: {
            margin: -e.spinDotSizeSM / 2
          },
          [`${e.componentCls}-text`]: {
            paddingTop: (e.spinDotSizeSM - e.fontSize) / 2 + 2
          },
          [`&${e.componentCls}-show-text ${e.componentCls}-dot`]: {
            marginTop: -(e.spinDotSizeSM / 2) - 10
          }
        },
        "&-lg": {
          [`${e.componentCls}-dot`]: {
            margin: -(e.spinDotSizeLG / 2)
          },
          [`${e.componentCls}-text`]: {
            paddingTop: (e.spinDotSizeLG - e.fontSize) / 2 + 2
          },
          [`&${e.componentCls}-show-text ${e.componentCls}-dot`]: {
            marginTop: -(e.spinDotSizeLG / 2) - 10
          }
        }
      },
      [`${e.componentCls}-container`]: {
        position: "relative",
        transition: `opacity ${e.motionDurationSlow}`,
        "&::after": {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          zIndex: 10,
          width: "100%",
          height: "100%",
          background: e.colorBgContainer,
          opacity: 0,
          transition: `all ${e.motionDurationSlow}`,
          content: '""',
          pointerEvents: "none"
        }
      },
      [`${e.componentCls}-blur`]: {
        clear: "both",
        opacity: 0.5,
        userSelect: "none",
        pointerEvents: "none",
        "&::after": {
          opacity: 0.4,
          pointerEvents: "auto"
        }
      }
    },
    // tip
    // ------------------------------
    "&-tip": {
      color: e.spinDotDefault
    },
    // dots
    // ------------------------------
    [`${e.componentCls}-dot`]: {
      position: "relative",
      display: "inline-block",
      fontSize: e.spinDotSize,
      width: "1em",
      height: "1em",
      "&-item": {
        position: "absolute",
        display: "block",
        width: (e.spinDotSize - e.marginXXS / 2) / 2,
        height: (e.spinDotSize - e.marginXXS / 2) / 2,
        backgroundColor: e.colorPrimary,
        borderRadius: "100%",
        transform: "scale(0.75)",
        transformOrigin: "50% 50%",
        opacity: 0.3,
        animationName: Oue,
        animationDuration: "1s",
        animationIterationCount: "infinite",
        animationTimingFunction: "linear",
        animationDirection: "alternate",
        "&:nth-child(1)": {
          top: 0,
          insetInlineStart: 0
        },
        "&:nth-child(2)": {
          top: 0,
          insetInlineEnd: 0,
          animationDelay: "0.4s"
        },
        "&:nth-child(3)": {
          insetInlineEnd: 0,
          bottom: 0,
          animationDelay: "0.8s"
        },
        "&:nth-child(4)": {
          bottom: 0,
          insetInlineStart: 0,
          animationDelay: "1.2s"
        }
      },
      "&-spin": {
        transform: "rotate(45deg)",
        animationName: Aue,
        animationDuration: "1.2s",
        animationIterationCount: "infinite",
        animationTimingFunction: "linear"
      }
    },
    // Sizes
    // ------------------------------
    // small
    [`&-sm ${e.componentCls}-dot`]: {
      fontSize: e.spinDotSizeSM,
      i: {
        width: (e.spinDotSizeSM - e.marginXXS / 2) / 2,
        height: (e.spinDotSizeSM - e.marginXXS / 2) / 2
      }
    },
    // large
    [`&-lg ${e.componentCls}-dot`]: {
      fontSize: e.spinDotSizeLG,
      i: {
        width: (e.spinDotSizeLG - e.marginXXS) / 2,
        height: (e.spinDotSizeLG - e.marginXXS) / 2
      }
    },
    [`&${e.componentCls}-show-text ${e.componentCls}-text`]: {
      display: "block"
    }
  })
}), Pue = xr("Spin", (e) => {
  const t = xn(e, {
    spinDotDefault: e.colorTextDescription,
    spinDotSize: e.controlHeightLG / 2,
    spinDotSizeSM: e.controlHeightLG * 0.35,
    spinDotSizeLG: e.controlHeight
  });
  return [Iue(t)];
}, {
  contentHeight: 400
});
var Due = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const kue = () => ({
  prefixCls: String,
  spinning: {
    type: Boolean,
    default: void 0
  },
  size: String,
  wrapperClassName: String,
  tip: Oe.any,
  delay: Number,
  indicator: Oe.any
});
let zv = null;
function Mue(e, t) {
  return !!e && !!t && !isNaN(Number(t));
}
function Rue(e) {
  const t = e.indicator;
  zv = typeof t == "function" ? t : () => A(t, null, null);
}
const O0 = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ASpin",
  inheritAttrs: !1,
  props: ha(kue(), {
    size: "default",
    spinning: !0,
    wrapperClassName: ""
  }),
  setup(e, t) {
    let {
      attrs: n,
      slots: r
    } = t;
    const {
      prefixCls: a,
      size: o,
      direction: i
    } = mn("spin", e), [s, l] = Pue(a), u = Be(e.spinning && !Mue(e.spinning, e.delay));
    let c;
    return He([() => e.spinning, () => e.delay], () => {
      c == null || c.cancel(), c = $ue(e.delay, () => {
        u.value = e.spinning;
      }), c == null || c();
    }, {
      immediate: !0,
      flush: "post"
    }), Sn(() => {
      c == null || c.cancel();
    }), () => {
      var f, d;
      const {
        class: p
      } = n, v = Due(n, ["class"]), {
        tip: h = (f = r.tip) === null || f === void 0 ? void 0 : f.call(r)
      } = e, m = (d = r.default) === null || d === void 0 ? void 0 : d.call(r), y = {
        [l.value]: !0,
        [a.value]: !0,
        [`${a.value}-sm`]: o.value === "small",
        [`${a.value}-lg`]: o.value === "large",
        [`${a.value}-spinning`]: u.value,
        [`${a.value}-show-text`]: !!h,
        [`${a.value}-rtl`]: i.value === "rtl",
        [p]: !!p
      };
      function x(S) {
        const w = `${S}-dot`;
        let _ = zg(r, e, "indicator");
        return _ === null ? null : (Array.isArray(_) && (_ = _.length === 1 ? _[0] : _), ka(_) ? Yr(_, {
          class: w
        }) : zv && ka(zv()) ? Yr(zv(), {
          class: w
        }) : A("span", {
          class: `${w} ${S}-dot-spin`
        }, [A("i", {
          class: `${S}-dot-item`
        }, null), A("i", {
          class: `${S}-dot-item`
        }, null), A("i", {
          class: `${S}-dot-item`
        }, null), A("i", {
          class: `${S}-dot-item`
        }, null)]));
      }
      const g = A("div", ve(ve({}, v), {}, {
        class: y,
        "aria-live": "polite",
        "aria-busy": u.value
      }), [x(a.value), h ? A("div", {
        class: `${a.value}-text`
      }, [h]) : null]);
      if (m && _s(m).length) {
        const S = {
          [`${a.value}-container`]: !0,
          [`${a.value}-blur`]: u.value
        };
        return s(A("div", {
          class: [`${a.value}-nested-loading`, e.wrapperClassName, l.value]
        }, [u.value && A("div", {
          key: "loading"
        }, [g]), A("div", {
          class: S,
          key: "container"
        }, [m])]));
      }
      return s(g);
    };
  }
});
O0.setDefaultIndicator = Rue;
O0.install = function(e) {
  return e.component(O0.name, O0), e;
};
var Nue = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, name: "double-left", theme: "outlined" };
function a6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      Fue(e, a, n[a]);
    });
  }
  return e;
}
function Fue(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Bm = function(t, n) {
  var r = a6({}, t, n.attrs);
  return A(Bn, a6({}, r, {
    icon: Nue
  }), null);
};
Bm.displayName = "DoubleLeftOutlined";
Bm.inheritAttrs = !1;
var Lue = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, name: "double-right", theme: "outlined" };
function o6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? Object(arguments[t]) : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      Bue(e, a, n[a]);
    });
  }
  return e;
}
function Bue(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Hm = function(t, n) {
  var r = o6({}, t, n.attrs);
  return A(Bn, o6({}, r, {
    icon: Lue
  }), null);
};
Hm.displayName = "DoubleRightOutlined";
Hm.inheritAttrs = !1;
const Hue = /* @__PURE__ */ Me({
  name: "MiniSelect",
  compatConfig: {
    MODE: 3
  },
  inheritAttrs: !1,
  props: RC(),
  Option: fo.Option,
  setup(e, t) {
    let {
      attrs: n,
      slots: r
    } = t;
    return () => {
      const a = D(D(D({}, e), {
        size: "small"
      }), n);
      return A(fo, a, r);
    };
  }
}), jue = /* @__PURE__ */ Me({
  name: "MiddleSelect",
  inheritAttrs: !1,
  props: RC(),
  Option: fo.Option,
  setup(e, t) {
    let {
      attrs: n,
      slots: r
    } = t;
    return () => {
      const a = D(D(D({}, e), {
        size: "middle"
      }), n);
      return A(fo, a, r);
    };
  }
}), _u = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "Pager",
  inheritAttrs: !1,
  props: {
    rootPrefixCls: String,
    page: Number,
    active: {
      type: Boolean,
      default: void 0
    },
    last: {
      type: Boolean,
      default: void 0
    },
    locale: Oe.object,
    showTitle: {
      type: Boolean,
      default: void 0
    },
    itemRender: {
      type: Function,
      default: () => {
      }
    },
    onClick: {
      type: Function
    },
    onKeypress: {
      type: Function
    }
  },
  eimt: ["click", "keypress"],
  setup(e, t) {
    let {
      emit: n,
      attrs: r
    } = t;
    const a = () => {
      n("click", e.page);
    }, o = (i) => {
      n("keypress", i, a, e.page);
    };
    return () => {
      const {
        showTitle: i,
        page: s,
        itemRender: l
      } = e, {
        class: u,
        style: c
      } = r, f = `${e.rootPrefixCls}-item`, d = Ge(f, `${f}-${e.page}`, {
        [`${f}-active`]: e.active,
        [`${f}-disabled`]: !e.page
      }, u);
      return A("li", {
        onClick: a,
        onKeypress: o,
        title: i ? String(s) : null,
        tabindex: "0",
        class: d,
        style: c
      }, [l({
        page: s,
        type: "page",
        originalElement: A("a", {
          rel: "nofollow"
        }, [s])
      })]);
    };
  }
}), Ou = {
  ZERO: 48,
  NINE: 57,
  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,
  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,
  ARROW_UP: 38,
  ARROW_DOWN: 40
}, Vue = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  props: {
    disabled: {
      type: Boolean,
      default: void 0
    },
    changeSize: Function,
    quickGo: Function,
    selectComponentClass: Oe.any,
    current: Number,
    pageSizeOptions: Oe.array.def(["10", "20", "50", "100"]),
    pageSize: Number,
    buildOptionText: Function,
    locale: Oe.object,
    rootPrefixCls: String,
    selectPrefixCls: String,
    goButton: Oe.any
  },
  setup(e) {
    const t = ne(""), n = V(() => !t.value || isNaN(t.value) ? void 0 : Number(t.value)), r = (l) => `${l.value} ${e.locale.items_per_page}`, a = (l) => {
      const {
        value: u,
        composing: c
      } = l.target;
      l.isComposing || c || t.value === u || (t.value = u);
    }, o = (l) => {
      const {
        goButton: u,
        quickGo: c,
        rootPrefixCls: f
      } = e;
      if (!(u || t.value === ""))
        if (l.relatedTarget && (l.relatedTarget.className.indexOf(`${f}-item-link`) >= 0 || l.relatedTarget.className.indexOf(`${f}-item`) >= 0)) {
          t.value = "";
          return;
        } else
          c(n.value), t.value = "";
    }, i = (l) => {
      t.value !== "" && (l.keyCode === Ou.ENTER || l.type === "click") && (e.quickGo(n.value), t.value = "");
    }, s = V(() => {
      const {
        pageSize: l,
        pageSizeOptions: u
      } = e;
      return u.some((c) => c.toString() === l.toString()) ? u : u.concat([l.toString()]).sort((c, f) => {
        const d = isNaN(Number(c)) ? 0 : Number(c), p = isNaN(Number(f)) ? 0 : Number(f);
        return d - p;
      });
    });
    return () => {
      const {
        rootPrefixCls: l,
        locale: u,
        changeSize: c,
        quickGo: f,
        goButton: d,
        selectComponentClass: p,
        selectPrefixCls: v,
        pageSize: h,
        disabled: m
      } = e, y = `${l}-options`;
      let x = null, g = null, S = null;
      if (!c && !f)
        return null;
      if (c && p) {
        const w = e.buildOptionText || r, _ = s.value.map((b, E) => A(p.Option, {
          key: E,
          value: b
        }, {
          default: () => [w({
            value: b
          })]
        }));
        x = A(p, {
          disabled: m,
          prefixCls: v,
          showSearch: !1,
          class: `${y}-size-changer`,
          optionLabelProp: "children",
          value: (h || s.value[0]).toString(),
          onChange: (b) => c(Number(b)),
          getPopupContainer: (b) => b.parentNode
        }, {
          default: () => [_]
        });
      }
      return f && (d && (S = typeof d == "boolean" ? A("button", {
        type: "button",
        onClick: i,
        onKeyup: i,
        disabled: m,
        class: `${y}-quick-jumper-button`
      }, [u.jump_to_confirm]) : A("span", {
        onClick: i,
        onKeyup: i
      }, [d])), g = A("div", {
        class: `${y}-quick-jumper`
      }, [u.jump_to, Yn(A("input", {
        disabled: m,
        type: "text",
        value: t.value,
        onInput: a,
        onChange: a,
        onKeyup: i,
        onBlur: o
      }, null), [[Vp]]), u.page, S])), A("li", {
        class: `${y}`
      }, [x, g]);
    };
  }
}), M7 = {
  // Options.jsx
  items_per_page: "条/页",
  jump_to: "跳至",
  jump_to_confirm: "确定",
  page: "页",
  // Pagination.jsx
  prev_page: "上一页",
  next_page: "下一页",
  prev_5: "向前 5 页",
  next_5: "向后 5 页",
  prev_3: "向前 3 页",
  next_3: "向后 3 页"
};
var Uue = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
function zue(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
function Wue(e) {
  let {
    originalElement: t
  } = e;
  return t;
}
function Is(e, t, n) {
  const r = typeof e > "u" ? t.statePageSize : e;
  return Math.floor((n.total - 1) / r) + 1;
}
const Gue = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "Pagination",
  mixins: [FP],
  inheritAttrs: !1,
  props: {
    disabled: {
      type: Boolean,
      default: void 0
    },
    prefixCls: Oe.string.def("rc-pagination"),
    selectPrefixCls: Oe.string.def("rc-select"),
    current: Number,
    defaultCurrent: Oe.number.def(1),
    total: Oe.number.def(0),
    pageSize: Number,
    defaultPageSize: Oe.number.def(10),
    hideOnSinglePage: {
      type: Boolean,
      default: !1
    },
    showSizeChanger: {
      type: Boolean,
      default: void 0
    },
    showLessItems: {
      type: Boolean,
      default: !1
    },
    // showSizeChange: PropTypes.func.def(noop),
    selectComponentClass: Oe.any,
    showPrevNextJumpers: {
      type: Boolean,
      default: !0
    },
    showQuickJumper: Oe.oneOfType([Oe.looseBool, Oe.object]).def(!1),
    showTitle: {
      type: Boolean,
      default: !0
    },
    pageSizeOptions: Oe.arrayOf(Oe.oneOfType([Oe.number, Oe.string])),
    buildOptionText: Function,
    showTotal: Function,
    simple: {
      type: Boolean,
      default: void 0
    },
    locale: Oe.object.def(M7),
    itemRender: Oe.func.def(Wue),
    prevIcon: Oe.any,
    nextIcon: Oe.any,
    jumpPrevIcon: Oe.any,
    jumpNextIcon: Oe.any,
    totalBoundaryShowSizeChanger: Oe.number.def(50)
  },
  data() {
    const e = this.$props;
    let t = s2([this.current, this.defaultCurrent]);
    const n = s2([this.pageSize, this.defaultPageSize]);
    return t = Math.min(t, Is(n, void 0, e)), {
      stateCurrent: t,
      stateCurrentInputValue: t,
      statePageSize: n
    };
  },
  watch: {
    current(e) {
      this.setState({
        stateCurrent: e,
        stateCurrentInputValue: e
      });
    },
    pageSize(e) {
      const t = {};
      let n = this.stateCurrent;
      const r = Is(e, this.$data, this.$props);
      n = n > r ? r : n, rf(this, "current") || (t.stateCurrent = n, t.stateCurrentInputValue = n), t.statePageSize = e, this.setState(t);
    },
    stateCurrent(e, t) {
      this.$nextTick(() => {
        if (this.$refs.paginationNode) {
          const n = this.$refs.paginationNode.querySelector(`.${this.prefixCls}-item-${t}`);
          n && document.activeElement === n && n.blur();
        }
      });
    },
    total() {
      const e = {}, t = Is(this.pageSize, this.$data, this.$props);
      if (rf(this, "current")) {
        const n = Math.min(this.current, t);
        e.stateCurrent = n, e.stateCurrentInputValue = n;
      } else {
        let n = this.stateCurrent;
        n === 0 && t > 0 ? n = 1 : n = Math.min(this.stateCurrent, t), e.stateCurrent = n;
      }
      this.setState(e);
    }
  },
  methods: {
    getJumpPrevPage() {
      return Math.max(1, this.stateCurrent - (this.showLessItems ? 3 : 5));
    },
    getJumpNextPage() {
      return Math.min(Is(void 0, this.$data, this.$props), this.stateCurrent + (this.showLessItems ? 3 : 5));
    },
    getItemIcon(e, t) {
      const {
        prefixCls: n
      } = this.$props;
      return lI(this, e, this.$props) || A("button", {
        type: "button",
        "aria-label": t,
        class: `${n}-item-link`
      }, null);
    },
    getValidValue(e) {
      const t = e.target.value, n = Is(void 0, this.$data, this.$props), {
        stateCurrentInputValue: r
      } = this.$data;
      let a;
      return t === "" ? a = t : isNaN(Number(t)) ? a = r : t >= n ? a = n : a = Number(t), a;
    },
    isValid(e) {
      return zue(e) && e !== this.stateCurrent;
    },
    shouldDisplayQuickJumper() {
      const {
        showQuickJumper: e,
        pageSize: t,
        total: n
      } = this.$props;
      return n <= t ? !1 : e;
    },
    // calculatePage (p) {
    //   let pageSize = p
    //   if (typeof pageSize === 'undefined') {
    //     pageSize = this.statePageSize
    //   }
    //   return Math.floor((this.total - 1) / pageSize) + 1
    // },
    handleKeyDown(e) {
      (e.keyCode === Ou.ARROW_UP || e.keyCode === Ou.ARROW_DOWN) && e.preventDefault();
    },
    handleKeyUp(e) {
      if (e.isComposing || e.target.composing) return;
      const t = this.getValidValue(e), n = this.stateCurrentInputValue;
      t !== n && this.setState({
        stateCurrentInputValue: t
      }), e.keyCode === Ou.ENTER ? this.handleChange(t) : e.keyCode === Ou.ARROW_UP ? this.handleChange(t - 1) : e.keyCode === Ou.ARROW_DOWN && this.handleChange(t + 1);
    },
    changePageSize(e) {
      let t = this.stateCurrent;
      const n = t, r = Is(e, this.$data, this.$props);
      t = t > r ? r : t, r === 0 && (t = this.stateCurrent), typeof e == "number" && (rf(this, "pageSize") || this.setState({
        statePageSize: e
      }), rf(this, "current") || this.setState({
        stateCurrent: t,
        stateCurrentInputValue: t
      })), this.__emit("update:pageSize", e), t !== n && this.__emit("update:current", t), this.__emit("showSizeChange", t, e), this.__emit("change", t, e);
    },
    handleChange(e) {
      const {
        disabled: t
      } = this.$props;
      let n = e;
      if (this.isValid(n) && !t) {
        const r = Is(void 0, this.$data, this.$props);
        return n > r ? n = r : n < 1 && (n = 1), rf(this, "current") || this.setState({
          stateCurrent: n,
          stateCurrentInputValue: n
        }), this.__emit("update:current", n), this.__emit("change", n, this.statePageSize), n;
      }
      return this.stateCurrent;
    },
    prev() {
      this.hasPrev() && this.handleChange(this.stateCurrent - 1);
    },
    next() {
      this.hasNext() && this.handleChange(this.stateCurrent + 1);
    },
    jumpPrev() {
      this.handleChange(this.getJumpPrevPage());
    },
    jumpNext() {
      this.handleChange(this.getJumpNextPage());
    },
    hasPrev() {
      return this.stateCurrent > 1;
    },
    hasNext() {
      return this.stateCurrent < Is(void 0, this.$data, this.$props);
    },
    getShowSizeChanger() {
      const {
        showSizeChanger: e,
        total: t,
        totalBoundaryShowSizeChanger: n
      } = this.$props;
      return typeof e < "u" ? e : t > n;
    },
    runIfEnter(e, t) {
      if (e.key === "Enter" || e.charCode === 13) {
        for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
          r[a - 2] = arguments[a];
        t(...r);
      }
    },
    runIfEnterPrev(e) {
      this.runIfEnter(e, this.prev);
    },
    runIfEnterNext(e) {
      this.runIfEnter(e, this.next);
    },
    runIfEnterJumpPrev(e) {
      this.runIfEnter(e, this.jumpPrev);
    },
    runIfEnterJumpNext(e) {
      this.runIfEnter(e, this.jumpNext);
    },
    handleGoTO(e) {
      (e.keyCode === Ou.ENTER || e.type === "click") && this.handleChange(this.stateCurrentInputValue);
    },
    renderPrev(e) {
      const {
        itemRender: t
      } = this.$props, n = t({
        page: e,
        type: "prev",
        originalElement: this.getItemIcon("prevIcon", "prev page")
      }), r = !this.hasPrev();
      return co(n) ? sr(n, r ? {
        disabled: r
      } : {}) : n;
    },
    renderNext(e) {
      const {
        itemRender: t
      } = this.$props, n = t({
        page: e,
        type: "next",
        originalElement: this.getItemIcon("nextIcon", "next page")
      }), r = !this.hasNext();
      return co(n) ? sr(n, r ? {
        disabled: r
      } : {}) : n;
    }
  },
  render() {
    const {
      prefixCls: e,
      disabled: t,
      hideOnSinglePage: n,
      total: r,
      locale: a,
      showQuickJumper: o,
      showLessItems: i,
      showTitle: s,
      showTotal: l,
      simple: u,
      itemRender: c,
      showPrevNextJumpers: f,
      jumpPrevIcon: d,
      jumpNextIcon: p,
      selectComponentClass: v,
      selectPrefixCls: h,
      pageSizeOptions: m
    } = this.$props, {
      stateCurrent: y,
      statePageSize: x
    } = this, g = iI(this.$attrs).extraAttrs, {
      class: S
    } = g, w = Uue(g, ["class"]);
    if (n === !0 && this.total <= x)
      return null;
    const _ = Is(void 0, this.$data, this.$props), b = [];
    let E = null, C = null, T = null, O = null, I = null;
    const k = o && o.goButton, B = i ? 1 : 2, P = y - 1 > 0 ? y - 1 : 0, N = y + 1 < _ ? y + 1 : _, M = this.hasPrev(), H = this.hasNext();
    if (u)
      return k && (typeof k == "boolean" ? I = A("button", {
        type: "button",
        onClick: this.handleGoTO,
        onKeyup: this.handleGoTO
      }, [a.jump_to_confirm]) : I = A("span", {
        onClick: this.handleGoTO,
        onKeyup: this.handleGoTO
      }, [k]), I = A("li", {
        title: s ? `${a.jump_to}${y}/${_}` : null,
        class: `${e}-simple-pager`
      }, [I])), A("ul", ve({
        class: Ge(`${e} ${e}-simple`, {
          [`${e}-disabled`]: t
        }, S)
      }, w), [A("li", {
        title: s ? a.prev_page : null,
        onClick: this.prev,
        tabindex: M ? 0 : null,
        onKeypress: this.runIfEnterPrev,
        class: Ge(`${e}-prev`, {
          [`${e}-disabled`]: !M
        }),
        "aria-disabled": !M
      }, [this.renderPrev(P)]), A("li", {
        title: s ? `${y}/${_}` : null,
        class: `${e}-simple-pager`
      }, [Yn(A("input", {
        type: "text",
        value: this.stateCurrentInputValue,
        disabled: t,
        onKeydown: this.handleKeyDown,
        onKeyup: this.handleKeyUp,
        onInput: this.handleKeyUp,
        onChange: this.handleKeyUp,
        size: "3"
      }, null), [[Vp]]), A("span", {
        class: `${e}-slash`
      }, [Jt("／")]), _]), A("li", {
        title: s ? a.next_page : null,
        onClick: this.next,
        tabindex: H ? 0 : null,
        onKeypress: this.runIfEnterNext,
        class: Ge(`${e}-next`, {
          [`${e}-disabled`]: !H
        }),
        "aria-disabled": !H
      }, [this.renderNext(N)]), I]);
    if (_ <= 3 + B * 2) {
      const Y = {
        locale: a,
        rootPrefixCls: e,
        showTitle: s,
        itemRender: c,
        onClick: this.handleChange,
        onKeypress: this.runIfEnter
      };
      _ || b.push(A(_u, ve(ve({}, Y), {}, {
        key: "noPager",
        page: 1,
        class: `${e}-item-disabled`
      }), null));
      for (let X = 1; X <= _; X += 1) {
        const q = y === X;
        b.push(A(_u, ve(ve({}, Y), {}, {
          key: X,
          page: X,
          active: q
        }), null));
      }
    } else {
      const Y = i ? a.prev_3 : a.prev_5, X = i ? a.next_3 : a.next_5;
      f && (E = A("li", {
        title: this.showTitle ? Y : null,
        key: "prev",
        onClick: this.jumpPrev,
        tabindex: "0",
        onKeypress: this.runIfEnterJumpPrev,
        class: Ge(`${e}-jump-prev`, {
          [`${e}-jump-prev-custom-icon`]: !!d
        })
      }, [c({
        page: this.getJumpPrevPage(),
        type: "jump-prev",
        originalElement: this.getItemIcon("jumpPrevIcon", "prev page")
      })]), C = A("li", {
        title: this.showTitle ? X : null,
        key: "next",
        tabindex: "0",
        onClick: this.jumpNext,
        onKeypress: this.runIfEnterJumpNext,
        class: Ge(`${e}-jump-next`, {
          [`${e}-jump-next-custom-icon`]: !!p
        })
      }, [c({
        page: this.getJumpNextPage(),
        type: "jump-next",
        originalElement: this.getItemIcon("jumpNextIcon", "next page")
      })])), O = A(_u, {
        locale: a,
        last: !0,
        rootPrefixCls: e,
        onClick: this.handleChange,
        onKeypress: this.runIfEnter,
        key: _,
        page: _,
        active: !1,
        showTitle: s,
        itemRender: c
      }, null), T = A(_u, {
        locale: a,
        rootPrefixCls: e,
        onClick: this.handleChange,
        onKeypress: this.runIfEnter,
        key: 1,
        page: 1,
        active: !1,
        showTitle: s,
        itemRender: c
      }, null);
      let q = Math.max(1, y - B), Q = Math.min(y + B, _);
      y - 1 <= B && (Q = 1 + B * 2), _ - y <= B && (q = _ - B * 2);
      for (let ue = q; ue <= Q; ue += 1) {
        const le = y === ue;
        b.push(A(_u, {
          locale: a,
          rootPrefixCls: e,
          onClick: this.handleChange,
          onKeypress: this.runIfEnter,
          key: ue,
          page: ue,
          active: le,
          showTitle: s,
          itemRender: c
        }, null));
      }
      y - 1 >= B * 2 && y !== 3 && (b[0] = A(_u, {
        locale: a,
        rootPrefixCls: e,
        onClick: this.handleChange,
        onKeypress: this.runIfEnter,
        key: q,
        page: q,
        class: `${e}-item-after-jump-prev`,
        active: !1,
        showTitle: this.showTitle,
        itemRender: c
      }, null), b.unshift(E)), _ - y >= B * 2 && y !== _ - 2 && (b[b.length - 1] = A(_u, {
        locale: a,
        rootPrefixCls: e,
        onClick: this.handleChange,
        onKeypress: this.runIfEnter,
        key: Q,
        page: Q,
        class: `${e}-item-before-jump-next`,
        active: !1,
        showTitle: this.showTitle,
        itemRender: c
      }, null), b.push(C)), q !== 1 && b.unshift(T), Q !== _ && b.push(O);
    }
    let R = null;
    l && (R = A("li", {
      class: `${e}-total-text`
    }, [l(r, [r === 0 ? 0 : (y - 1) * x + 1, y * x > r ? r : y * x])]));
    const z = !M || !_, W = !H || !_, F = this.buildOptionText || this.$slots.buildOptionText;
    return A("ul", ve(ve({
      unselectable: "on",
      ref: "paginationNode"
    }, w), {}, {
      class: Ge({
        [`${e}`]: !0,
        [`${e}-disabled`]: t
      }, S)
    }), [R, A("li", {
      title: s ? a.prev_page : null,
      onClick: this.prev,
      tabindex: z ? null : 0,
      onKeypress: this.runIfEnterPrev,
      class: Ge(`${e}-prev`, {
        [`${e}-disabled`]: z
      }),
      "aria-disabled": z
    }, [this.renderPrev(P)]), b, A("li", {
      title: s ? a.next_page : null,
      onClick: this.next,
      tabindex: W ? null : 0,
      onKeypress: this.runIfEnterNext,
      class: Ge(`${e}-next`, {
        [`${e}-disabled`]: W
      }),
      "aria-disabled": W
    }, [this.renderNext(N)]), A(Vue, {
      disabled: t,
      locale: a,
      rootPrefixCls: e,
      selectComponentClass: v,
      selectPrefixCls: h,
      changeSize: this.getShowSizeChanger() ? this.changePageSize : null,
      current: y,
      pageSize: x,
      pageSizeOptions: m,
      buildOptionText: F || null,
      quickGo: this.shouldDisplayQuickJumper() ? this.handleChange : null,
      goButton: k
    }, null)]);
  }
}), Kue = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-disabled`]: {
      "&, &:hover": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      },
      "&:focus-visible": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      }
    },
    [`&${t}-disabled`]: {
      cursor: "not-allowed",
      [`&${t}-mini`]: {
        [`
          &:hover ${t}-item:not(${t}-item-active),
          &:active ${t}-item:not(${t}-item-active),
          &:hover ${t}-item-link,
          &:active ${t}-item-link
        `]: {
          backgroundColor: "transparent"
        }
      },
      [`${t}-item`]: {
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        a: {
          color: e.colorTextDisabled,
          backgroundColor: "transparent",
          border: "none",
          cursor: "not-allowed"
        },
        "&-active": {
          borderColor: e.colorBorder,
          backgroundColor: e.paginationItemDisabledBgActive,
          "&:hover, &:active": {
            backgroundColor: e.paginationItemDisabledBgActive
          },
          a: {
            color: e.paginationItemDisabledColorActive
          }
        }
      },
      [`${t}-item-link`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        [`${t}-simple&`]: {
          backgroundColor: "transparent",
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      },
      [`${t}-simple-pager`]: {
        color: e.colorTextDisabled
      },
      [`${t}-jump-prev, ${t}-jump-next`]: {
        [`${t}-item-link-icon`]: {
          opacity: 0
        },
        [`${t}-item-ellipsis`]: {
          opacity: 1
        }
      }
    },
    [`&${t}-simple`]: {
      [`${t}-prev, ${t}-next`]: {
        [`&${t}-disabled ${t}-item-link`]: {
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      }
    }
  };
}, Yue = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`&${t}-mini ${t}-total-text, &${t}-mini ${t}-simple-pager`]: {
      height: e.paginationItemSizeSM,
      lineHeight: `${e.paginationItemSizeSM}px`
    },
    [`&${t}-mini ${t}-item`]: {
      minWidth: e.paginationItemSizeSM,
      height: e.paginationItemSizeSM,
      margin: 0,
      lineHeight: `${e.paginationItemSizeSM - 2}px`
    },
    [`&${t}-mini ${t}-item:not(${t}-item-active)`]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&:hover": {
        backgroundColor: e.colorBgTextHover
      },
      "&:active": {
        backgroundColor: e.colorBgTextActive
      }
    },
    [`&${t}-mini ${t}-prev, &${t}-mini ${t}-next`]: {
      minWidth: e.paginationItemSizeSM,
      height: e.paginationItemSizeSM,
      margin: 0,
      lineHeight: `${e.paginationItemSizeSM}px`,
      [`&:hover ${t}-item-link`]: {
        backgroundColor: e.colorBgTextHover
      },
      [`&:active ${t}-item-link`]: {
        backgroundColor: e.colorBgTextActive
      },
      [`&${t}-disabled:hover ${t}-item-link`]: {
        backgroundColor: "transparent"
      }
    },
    [`
    &${t}-mini ${t}-prev ${t}-item-link,
    &${t}-mini ${t}-next ${t}-item-link
    `]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&::after": {
        height: e.paginationItemSizeSM,
        lineHeight: `${e.paginationItemSizeSM}px`
      }
    },
    [`&${t}-mini ${t}-jump-prev, &${t}-mini ${t}-jump-next`]: {
      height: e.paginationItemSizeSM,
      marginInlineEnd: 0,
      lineHeight: `${e.paginationItemSizeSM}px`
    },
    [`&${t}-mini ${t}-options`]: {
      marginInlineStart: e.paginationMiniOptionsMarginInlineStart,
      "&-size-changer": {
        top: e.paginationMiniOptionsSizeChangerTop
      },
      "&-quick-jumper": {
        height: e.paginationItemSizeSM,
        lineHeight: `${e.paginationItemSizeSM}px`,
        input: D(D({}, u4(e)), {
          width: e.paginationMiniQuickJumperInputWidth,
          height: e.controlHeightSM
        })
      }
    }
  };
}, que = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`
    &${t}-simple ${t}-prev,
    &${t}-simple ${t}-next
    `]: {
      height: e.paginationItemSizeSM,
      lineHeight: `${e.paginationItemSizeSM}px`,
      verticalAlign: "top",
      [`${t}-item-link`]: {
        height: e.paginationItemSizeSM,
        backgroundColor: "transparent",
        border: 0,
        "&:hover": {
          backgroundColor: e.colorBgTextHover
        },
        "&:active": {
          backgroundColor: e.colorBgTextActive
        },
        "&::after": {
          height: e.paginationItemSizeSM,
          lineHeight: `${e.paginationItemSizeSM}px`
        }
      }
    },
    [`&${t}-simple ${t}-simple-pager`]: {
      display: "inline-block",
      height: e.paginationItemSizeSM,
      marginInlineEnd: e.marginXS,
      input: {
        boxSizing: "border-box",
        height: "100%",
        marginInlineEnd: e.marginXS,
        padding: `0 ${e.paginationItemPaddingInline}px`,
        textAlign: "center",
        backgroundColor: e.paginationItemInputBg,
        border: `${e.lineWidth}px ${e.lineType} ${e.colorBorder}`,
        borderRadius: e.borderRadius,
        outline: "none",
        transition: `border-color ${e.motionDurationMid}`,
        color: "inherit",
        "&:hover": {
          borderColor: e.colorPrimary
        },
        "&:focus": {
          borderColor: e.colorPrimaryHover,
          boxShadow: `${e.inputOutlineOffset}px 0 ${e.controlOutlineWidth}px ${e.controlOutline}`
        },
        "&[disabled]": {
          color: e.colorTextDisabled,
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          cursor: "not-allowed"
        }
      }
    }
  };
}, Xue = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-jump-prev, ${t}-jump-next`]: {
      outline: 0,
      [`${t}-item-container`]: {
        position: "relative",
        [`${t}-item-link-icon`]: {
          color: e.colorPrimary,
          fontSize: e.fontSizeSM,
          opacity: 0,
          transition: `all ${e.motionDurationMid}`,
          "&-svg": {
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            margin: "auto"
          }
        },
        [`${t}-item-ellipsis`]: {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          display: "block",
          margin: "auto",
          color: e.colorTextDisabled,
          fontFamily: "Arial, Helvetica, sans-serif",
          letterSpacing: e.paginationEllipsisLetterSpacing,
          textAlign: "center",
          textIndent: e.paginationEllipsisTextIndent,
          opacity: 1,
          transition: `all ${e.motionDurationMid}`
        }
      },
      "&:hover": {
        [`${t}-item-link-icon`]: {
          opacity: 1
        },
        [`${t}-item-ellipsis`]: {
          opacity: 0
        }
      },
      "&:focus-visible": D({
        [`${t}-item-link-icon`]: {
          opacity: 1
        },
        [`${t}-item-ellipsis`]: {
          opacity: 0
        }
      }, ip(e))
    },
    [`
    ${t}-prev,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      marginInlineEnd: e.marginXS
    },
    [`
    ${t}-prev,
    ${t}-next,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      display: "inline-block",
      minWidth: e.paginationItemSize,
      height: e.paginationItemSize,
      color: e.colorText,
      fontFamily: e.paginationFontFamily,
      lineHeight: `${e.paginationItemSize}px`,
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      borderRadius: e.borderRadius,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid}`
    },
    [`${t}-prev, ${t}-next`]: {
      fontFamily: "Arial, Helvetica, sans-serif",
      outline: 0,
      button: {
        color: e.colorText,
        cursor: "pointer",
        userSelect: "none"
      },
      [`${t}-item-link`]: {
        display: "block",
        width: "100%",
        height: "100%",
        padding: 0,
        fontSize: e.fontSizeSM,
        textAlign: "center",
        backgroundColor: "transparent",
        border: `${e.lineWidth}px ${e.lineType} transparent`,
        borderRadius: e.borderRadius,
        outline: "none",
        transition: `all ${e.motionDurationMid}`
      },
      [`&:focus-visible ${t}-item-link`]: D({}, ip(e)),
      [`&:hover ${t}-item-link`]: {
        backgroundColor: e.colorBgTextHover
      },
      [`&:active ${t}-item-link`]: {
        backgroundColor: e.colorBgTextActive
      },
      [`&${t}-disabled:hover`]: {
        [`${t}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`${t}-slash`]: {
      marginInlineEnd: e.paginationSlashMarginInlineEnd,
      marginInlineStart: e.paginationSlashMarginInlineStart
    },
    [`${t}-options`]: {
      display: "inline-block",
      marginInlineStart: e.margin,
      verticalAlign: "middle",
      "&-size-changer.-select": {
        display: "inline-block",
        width: "auto"
      },
      "&-quick-jumper": {
        display: "inline-block",
        height: e.controlHeight,
        marginInlineStart: e.marginXS,
        lineHeight: `${e.controlHeight}px`,
        verticalAlign: "top",
        input: D(D({}, $1(e)), {
          width: e.controlHeightLG * 1.25,
          height: e.controlHeight,
          boxSizing: "border-box",
          margin: 0,
          marginInlineStart: e.marginXS,
          marginInlineEnd: e.marginXS
        })
      }
    }
  };
}, Zue = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-item`]: D(D({
      display: "inline-block",
      minWidth: e.paginationItemSize,
      height: e.paginationItemSize,
      marginInlineEnd: e.marginXS,
      fontFamily: e.paginationFontFamily,
      lineHeight: `${e.paginationItemSize - 2}px`,
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      backgroundColor: "transparent",
      border: `${e.lineWidth}px ${e.lineType} transparent`,
      borderRadius: e.borderRadius,
      outline: 0,
      cursor: "pointer",
      userSelect: "none",
      a: {
        display: "block",
        padding: `0 ${e.paginationItemPaddingInline}px`,
        color: e.colorText,
        transition: "none",
        "&:hover": {
          textDecoration: "none"
        }
      },
      [`&:not(${t}-item-active)`]: {
        "&:hover": {
          transition: `all ${e.motionDurationMid}`,
          backgroundColor: e.colorBgTextHover
        },
        "&:active": {
          backgroundColor: e.colorBgTextActive
        }
      }
    }, sp(e)), {
      "&-active": {
        fontWeight: e.paginationFontWeightActive,
        backgroundColor: e.paginationItemBgActive,
        borderColor: e.colorPrimary,
        a: {
          color: e.colorPrimary
        },
        "&:hover": {
          borderColor: e.colorPrimaryHover
        },
        "&:hover a": {
          color: e.colorPrimaryHover
        }
      }
    })
  };
}, Que = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: D(D(D(D(D(D(D(D({}, gr(e)), {
      "ul, ol": {
        margin: 0,
        padding: 0,
        listStyle: "none"
      },
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        content: '""'
      },
      [`${t}-total-text`]: {
        display: "inline-block",
        height: e.paginationItemSize,
        marginInlineEnd: e.marginXS,
        lineHeight: `${e.paginationItemSize - 2}px`,
        verticalAlign: "middle"
      }
    }), Zue(e)), Xue(e)), que(e)), Yue(e)), Kue(e)), {
      // media query style
      [`@media only screen and (max-width: ${e.screenLG}px)`]: {
        [`${t}-item`]: {
          "&-after-jump-prev, &-before-jump-next": {
            display: "none"
          }
        }
      },
      [`@media only screen and (max-width: ${e.screenSM}px)`]: {
        [`${t}-options`]: {
          display: "none"
        }
      }
    }),
    // rtl style
    [`&${e.componentCls}-rtl`]: {
      direction: "rtl"
    }
  };
}, Jue = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}${t}-disabled`]: {
      "&, &:hover": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      "&:focus-visible": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      [`${t}-item, ${t}-item-link`]: {
        backgroundColor: e.colorBgContainerDisabled,
        borderColor: e.colorBorder,
        [`&:hover:not(${t}-item-active)`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          a: {
            color: e.colorTextDisabled
          }
        },
        [`&${t}-item-active`]: {
          backgroundColor: e.paginationItemDisabledBgActive
        }
      },
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          color: e.colorTextDisabled
        },
        [`${t}-item-link`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder
        }
      }
    },
    [t]: {
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          borderColor: e.colorPrimaryHover,
          backgroundColor: e.paginationItemBg
        },
        [`${t}-item-link`]: {
          backgroundColor: e.paginationItemLinkBg,
          borderColor: e.colorBorder
        },
        [`&:hover ${t}-item-link`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.paginationItemBg,
          color: e.colorPrimary
        },
        [`&${t}-disabled`]: {
          [`${t}-item-link`]: {
            borderColor: e.colorBorder,
            color: e.colorTextDisabled
          }
        }
      },
      [`${t}-item`]: {
        backgroundColor: e.paginationItemBg,
        border: `${e.lineWidth}px ${e.lineType} ${e.colorBorder}`,
        [`&:hover:not(${t}-item-active)`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.paginationItemBg,
          a: {
            color: e.colorPrimary
          }
        },
        "&-active": {
          borderColor: e.colorPrimary
        }
      }
    }
  };
}, ece = xr("Pagination", (e) => {
  const t = xn(e, {
    paginationItemSize: e.controlHeight,
    paginationFontFamily: e.fontFamily,
    paginationItemBg: e.colorBgContainer,
    paginationItemBgActive: e.colorBgContainer,
    paginationFontWeightActive: e.fontWeightStrong,
    paginationItemSizeSM: e.controlHeightSM,
    paginationItemInputBg: e.colorBgContainer,
    paginationMiniOptionsSizeChangerTop: 0,
    paginationItemDisabledBgActive: e.controlItemBgActiveDisabled,
    paginationItemDisabledColorActive: e.colorTextDisabled,
    paginationItemLinkBg: e.colorBgContainer,
    inputOutlineOffset: "0 0",
    paginationMiniOptionsMarginInlineStart: e.marginXXS / 2,
    paginationMiniQuickJumperInputWidth: e.controlHeightLG * 1.1,
    paginationItemPaddingInline: e.marginXXS * 1.5,
    paginationEllipsisLetterSpacing: e.marginXXS / 2,
    paginationSlashMarginInlineStart: e.marginXXS,
    paginationSlashMarginInlineEnd: e.marginSM,
    paginationEllipsisTextIndent: "0.13em"
    // magic for ui experience
  }, c4(e));
  return [Que(t), e.wireframe && Jue(t)];
});
var tce = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const nce = () => ({
  total: Number,
  defaultCurrent: Number,
  disabled: qt(),
  current: Number,
  defaultPageSize: Number,
  pageSize: Number,
  hideOnSinglePage: qt(),
  showSizeChanger: qt(),
  pageSizeOptions: io(),
  buildOptionText: Nt(),
  showQuickJumper: ca([Boolean, Object]),
  showTotal: Nt(),
  size: Ur(),
  simple: qt(),
  locale: Object,
  prefixCls: String,
  selectPrefixCls: String,
  totalBoundaryShowSizeChanger: Number,
  selectComponentClass: String,
  itemRender: Nt(),
  role: String,
  responsive: Boolean,
  showLessItems: qt(),
  onChange: Nt(),
  onShowSizeChange: Nt(),
  "onUpdate:current": Nt(),
  "onUpdate:pageSize": Nt()
}), rce = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "APagination",
  inheritAttrs: !1,
  props: nce(),
  // emits: ['change', 'showSizeChange', 'update:current', 'update:pageSize'],
  setup(e, t) {
    let {
      slots: n,
      attrs: r
    } = t;
    const {
      prefixCls: a,
      configProvider: o,
      direction: i,
      size: s
    } = mn("pagination", e), [l, u] = ece(a), c = V(() => o.getPrefixCls("select", e.selectPrefixCls)), f = Tne(), [d] = Tc("Pagination", gI, Tt(e, "locale")), p = (v) => {
      const h = A("span", {
        class: `${v}-item-ellipsis`
      }, [Jt("•••")]), m = A("button", {
        class: `${v}-item-link`,
        type: "button",
        tabindex: -1
      }, [i.value === "rtl" ? A(Zf, null, null) : A(Nm, null, null)]), y = A("button", {
        class: `${v}-item-link`,
        type: "button",
        tabindex: -1
      }, [i.value === "rtl" ? A(Nm, null, null) : A(Zf, null, null)]), x = A("a", {
        rel: "nofollow",
        class: `${v}-item-link`
      }, [A("div", {
        class: `${v}-item-container`
      }, [i.value === "rtl" ? A(Hm, {
        class: `${v}-item-link-icon`
      }, null) : A(Bm, {
        class: `${v}-item-link-icon`
      }, null), h])]), g = A("a", {
        rel: "nofollow",
        class: `${v}-item-link`
      }, [A("div", {
        class: `${v}-item-container`
      }, [i.value === "rtl" ? A(Bm, {
        class: `${v}-item-link-icon`
      }, null) : A(Hm, {
        class: `${v}-item-link-icon`
      }, null), h])]);
      return {
        prevIcon: m,
        nextIcon: y,
        jumpPrevIcon: x,
        jumpNextIcon: g
      };
    };
    return () => {
      var v;
      const {
        itemRender: h = n.itemRender,
        buildOptionText: m = n.buildOptionText,
        selectComponentClass: y,
        responsive: x
      } = e, g = tce(e, ["itemRender", "buildOptionText", "selectComponentClass", "responsive"]), S = s.value === "small" || !!(!((v = f.value) === null || v === void 0) && v.xs && !s.value && x), w = D(D(D(D(D({}, g), p(a.value)), {
        prefixCls: a.value,
        selectPrefixCls: c.value,
        selectComponentClass: y || (S ? Hue : jue),
        locale: d.value,
        buildOptionText: m
      }), r), {
        class: Ge({
          [`${a.value}-mini`]: S,
          [`${a.value}-rtl`]: i.value === "rtl"
        }, r.class, u.value),
        itemRender: h
      });
      return l(A(Gue, w, null));
    };
  }
}), ace = yd(rce);
var oce = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
    t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
let k2;
const ice = (e) => {
  k2 = {
    x: e.pageX,
    y: e.pageY
  }, setTimeout(() => k2 = null, 100);
};
Hk() && pf(document.documentElement, "click", ice, !0);
const sce = () => ({
  prefixCls: String,
  /** @deprecated Please use `open` instead. */
  visible: {
    type: Boolean,
    default: void 0
  },
  open: {
    type: Boolean,
    default: void 0
  },
  confirmLoading: {
    type: Boolean,
    default: void 0
  },
  title: Oe.any,
  closable: {
    type: Boolean,
    default: void 0
  },
  closeIcon: Oe.any,
  onOk: Function,
  onCancel: Function,
  "onUpdate:visible": Function,
  "onUpdate:open": Function,
  onChange: Function,
  afterClose: Function,
  centered: {
    type: Boolean,
    default: void 0
  },
  width: [String, Number],
  footer: Oe.any,
  okText: Oe.any,
  okType: String,
  cancelText: Oe.any,
  icon: Oe.any,
  maskClosable: {
    type: Boolean,
    default: void 0
  },
  forceRender: {
    type: Boolean,
    default: void 0
  },
  okButtonProps: hn(),
  cancelButtonProps: hn(),
  destroyOnClose: {
    type: Boolean,
    default: void 0
  },
  wrapClassName: String,
  maskTransitionName: String,
  transitionName: String,
  getContainer: {
    type: [String, Function, Boolean, Object],
    default: void 0
  },
  zIndex: Number,
  bodyStyle: hn(),
  maskStyle: hn(),
  mask: {
    type: Boolean,
    default: void 0
  },
  keyboard: {
    type: Boolean,
    default: void 0
  },
  wrapProps: Object,
  focusTriggerAfterClose: {
    type: Boolean,
    default: void 0
  },
  modalRender: Function,
  mousePosition: hn()
}), Ka = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "AModal",
  inheritAttrs: !1,
  props: ha(sce(), {
    width: 520,
    confirmLoading: !1,
    okType: "primary"
  }),
  setup(e, t) {
    let {
      emit: n,
      slots: r,
      attrs: a
    } = t;
    const [o] = Tc("Modal"), {
      prefixCls: i,
      rootPrefixCls: s,
      direction: l,
      getPopupContainer: u
    } = mn("modal", e), [c, f] = Eue(i);
    Pa(e.visible === void 0, "Modal", "`visible` will be removed in next major version, please use `open` instead.");
    const d = (h) => {
      n("update:visible", !1), n("update:open", !1), n("cancel", h), n("change", !1);
    }, p = (h) => {
      n("ok", h);
    }, v = () => {
      var h, m;
      const {
        okText: y = (h = r.okText) === null || h === void 0 ? void 0 : h.call(r),
        okType: x,
        cancelText: g = (m = r.cancelText) === null || m === void 0 ? void 0 : m.call(r),
        confirmLoading: S
      } = e;
      return A(dt, null, [A(fn, ve({
        onClick: d
      }, e.cancelButtonProps), {
        default: () => [g || o.value.cancelText]
      }), A(fn, ve(ve({}, ND(x)), {}, {
        loading: S,
        onClick: p
      }, e.okButtonProps), {
        default: () => [y || o.value.okText]
      })]);
    };
    return () => {
      var h, m;
      const {
        prefixCls: y,
        visible: x,
        open: g,
        wrapClassName: S,
        centered: w,
        getContainer: _,
        closeIcon: b = (h = r.closeIcon) === null || h === void 0 ? void 0 : h.call(r),
        focusTriggerAfterClose: E = !0
      } = e, C = oce(e, ["prefixCls", "visible", "open", "wrapClassName", "centered", "getContainer", "closeIcon", "focusTriggerAfterClose"]), T = Ge(S, {
        [`${i.value}-centered`]: !!w,
        [`${i.value}-wrap-rtl`]: l.value === "rtl"
      });
      return c(A(xue, ve(ve(ve({}, C), a), {}, {
        rootClassName: f.value,
        class: Ge(f.value, a.class),
        getContainer: _ || (u == null ? void 0 : u.value),
        prefixCls: i.value,
        wrapClassName: T,
        visible: g ?? x,
        onClose: d,
        focusTriggerAfterClose: E,
        transitionName: qf(s.value, "zoom", e.transitionName),
        maskTransitionName: qf(s.value, "fade", e.maskTransitionName),
        mousePosition: (m = C.mousePosition) !== null && m !== void 0 ? m : k2
      }), D(D({}, r), {
        footer: r.footer || v,
        closeIcon: () => A("span", {
          class: `${i.value}-close-x`
        }, [b || A(cu, {
          class: `${i.value}-close-icon`
        }, null)])
      })));
    };
  }
}), lce = () => {
  const e = Be(!1);
  return Sn(() => {
    e.value = !0;
  }), e;
}, uce = {
  type: {
    type: String
  },
  actionFn: Function,
  close: Function,
  autofocus: Boolean,
  prefixCls: String,
  buttonProps: hn(),
  emitEvent: Boolean,
  quitOnNullishReturnValue: Boolean
};
function i6(e) {
  return !!(e && e.then);
}
const s6 = /* @__PURE__ */ Me({
  compatConfig: {
    MODE: 3
  },
  name: "ActionButton",
  props: uce,
  setup(e, t) {
    let {
      slots: n
    } = t;
    const r = Be(!1), a = Be(), o = Be(!1);
    let i;
    const s = lce();
    Lt(() => {
      e.autofocus && (i = setTimeout(() => {
        var f, d;
        return (d = (f = js(a.value)) === null || f === void 0 ? void 0 : f.focus) === null || d === void 0 ? void 0 : d.call(f);
      }));
    }), Sn(() => {
      clearTimeout(i);
    });
    const l = function() {
      for (var f, d = arguments.length, p = new Array(d), v = 0; v < d; v++)
        p[v] = arguments[v];
      (f = e.close) === null || f === void 0 || f.call(e, ...p);
    }, u = (f) => {
      i6(f) && (o.value = !0, f.then(function() {
        s.value || (o.value = !1), l(...arguments), r.value = !1;
      }, (d) => (s.value || (o.value = !1), r.value = !1, Promise.reject(d))));
    }, c = (f) => {
      const {
        actionFn: d
      } = e;
      if (r.value)
        return;
      if (r.value = !0, !d) {
        l();
        return;
      }
      let p;
      if (e.emitEvent) {
        if (p = d(f), e.quitOnNullishReturnValue && !i6(p)) {
          r.value = !1, l(f);
          return;
        }
      } else if (d.length)
        p = d(e.close), r.value = !1;
      else if (p = d(), !p) {
        l();
        return;
      }
      u(p);
    };
    return () => {
      const {
        type: f,
        prefixCls: d,
        buttonProps: p
      } = e;
      return A(fn, ve(ve(ve({}, ND(f)), {}, {
        onClick: c,
        loading: o.value,
        prefixCls: d
      }, p), {}, {
        ref: a
      }), n);
    };
  }
});
function Xc(e) {
  return typeof e == "function" ? e() : e;
}
const R7 = /* @__PURE__ */ Me({
  name: "ConfirmDialog",
  inheritAttrs: !1,
  props: ["icon", "onCancel", "onOk", "close", "closable", "zIndex", "afterClose", "visible", "open", "keyboard", "centered", "getContainer", "maskStyle", "okButtonProps", "cancelButtonProps", "okType", "prefixCls", "okCancel", "width", "mask", "maskClosable", "okText", "cancelText", "autoFocusButton", "transitionName", "maskTransitionName", "type", "title", "content", "direction", "rootPrefixCls", "bodyStyle", "closeIcon", "modalRender", "focusTriggerAfterClose", "wrapClassName", "confirmPrefixCls", "footer"],
  setup(e, t) {
    let {
      attrs: n
    } = t;
    const [r] = Tc("Modal");
    return process.env.NODE_ENV !== "production" && Pa(e.visible === void 0, "Modal", "`visible` is deprecated, please use `open` instead."), () => {
      const {
        icon: a,
        onCancel: o,
        onOk: i,
        close: s,
        okText: l,
        closable: u = !1,
        zIndex: c,
        afterClose: f,
        keyboard: d,
        centered: p,
        getContainer: v,
        maskStyle: h,
        okButtonProps: m,
        cancelButtonProps: y,
        okCancel: x,
        width: g = 416,
        mask: S = !0,
        maskClosable: w = !1,
        type: _,
        open: b,
        title: E,
        content: C,
        direction: T,
        closeIcon: O,
        modalRender: I,
        focusTriggerAfterClose: k,
        rootPrefixCls: B,
        bodyStyle: P,
        wrapClassName: N,
        footer: M
      } = e;
      let H = a;
      if (!a && a !== null)
        switch (_) {
          case "info":
            H = A(Pc, null, null);
            break;
          case "success":
            H = A(du, null, null);
            break;
          case "error":
            H = A(Vo, null, null);
            break;
          default:
            H = A(pu, null, null);
        }
      const R = e.okType || "primary", z = e.prefixCls || "ant-modal", W = `${z}-confirm`, F = n.style || {}, Y = x ?? _ === "confirm", X = e.autoFocusButton === null ? !1 : e.autoFocusButton || "ok", q = `${z}-confirm`, Q = Ge(q, `${q}-${e.type}`, {
        [`${q}-rtl`]: T === "rtl"
      }, n.class), ue = r.value, le = Y && A(s6, {
        actionFn: o,
        close: s,
        autofocus: X === "cancel",
        buttonProps: y,
        prefixCls: `${B}-btn`
      }, {
        default: () => [Xc(e.cancelText) || ue.cancelText]
      });
      return A(Ka, {
        prefixCls: z,
        class: Q,
        wrapClassName: Ge({
          [`${q}-centered`]: !!p
        }, N),
        onCancel: (te) => s == null ? void 0 : s({
          triggerCancel: !0
        }, te),
        open: b,
        title: "",
        footer: "",
        transitionName: qf(B, "zoom", e.transitionName),
        maskTransitionName: qf(B, "fade", e.maskTransitionName),
        mask: S,
        maskClosable: w,
        maskStyle: h,
        style: F,
        bodyStyle: P,
        width: g,
        zIndex: c,
        afterClose: f,
        keyboard: d,
        centered: p,
        getContainer: v,
        closable: u,
        closeIcon: O,
        modalRender: I,
        focusTriggerAfterClose: k
      }, {
        default: () => [A("div", {
          class: `${W}-body-wrapper`
        }, [A("div", {
          class: `${W}-body`
        }, [Xc(H), E === void 0 ? null : A("span", {
          class: `${W}-title`
        }, [Xc(E)]), A("div", {
          class: `${W}-content`
        }, [Xc(C)])]), M !== void 0 ? Xc(M) : A("div", {
          class: `${W}-btns`
        }, [le, A(s6, {
          type: R,
          actionFn: i,
          close: s,
          autofocus: X === "ok",
          buttonProps: m,
          prefixCls: `${B}-btn`
        }, {
          default: () => [Xc(l) || (Y ? ue.okText : ue.justOkText)]
        })])])]
      });
    };
  }
}), Fu = [], Xp = (e) => {
  const t = document.createDocumentFragment();
  let n = D(D({}, Lr(e, ["parentContext", "appContext"])), {
    close: o,
    open: !0
  }), r = null;
  function a() {
    r && (ms(null, t), r = null);
    for (var u = arguments.length, c = new Array(u), f = 0; f < u; f++)
      c[f] = arguments[f];
    const d = c.some((p) => p && p.triggerCancel);
    e.onCancel && d && e.onCancel(() => {
    }, ...c.slice(1));
    for (let p = 0; p < Fu.length; p++)
      if (Fu[p] === o) {
        Fu.splice(p, 1);
        break;
      }
  }
  function o() {
    for (var u = arguments.length, c = new Array(u), f = 0; f < u; f++)
      c[f] = arguments[f];
    n = D(D({}, n), {
      open: !1,
      afterClose: () => {
        typeof e.afterClose == "function" && e.afterClose(), a.apply(this, c);
      }
    }), n.visible && delete n.visible, i(n);
  }
  function i(u) {
    typeof u == "function" ? n = u(n) : n = D(D({}, n), u), r && wK(r, n, t);
  }
  const s = (u) => {
    const c = Qr, f = c.prefixCls, d = u.prefixCls || `${f}-modal`, p = c.iconPrefixCls, v = yse();
    return A(Qu, ve(ve({}, c), {}, {
      prefixCls: f
    }), {
      default: () => [A(R7, ve(ve({}, u), {}, {
        rootPrefixCls: f,
        prefixCls: d,
        iconPrefixCls: p,
        locale: v,
        cancelText: u.cancelText || v.cancelText
      }), null)]
    });
  };
  function l(u) {
    const c = A(s, D({}, u));
    return c.appContext = e.parentContext || e.appContext || c.appContext, ms(c, t), c;
  }
  return r = l(n), Fu.push(o), {
    destroy: o,
    update: i
  };
};
function N7(e) {
  return D(D({}, e), {
    type: "warning"
  });
}
function F7(e) {
  return D(D({}, e), {
    type: "info"
  });
}
function L7(e) {
  return D(D({}, e), {
    type: "success"
  });
}
function B7(e) {
  return D(D({}, e), {
    type: "error"
  });
}
function H7(e) {
  return D(D({}, e), {
    type: "confirm"
  });
}
const cce = () => ({
  config: Object,
  afterClose: Function,
  destroyAction: Function,
  open: Boolean
}), fce = /* @__PURE__ */ Me({
  name: "HookModal",
  inheritAttrs: !1,
  props: ha(cce(), {
    config: {
      width: 520,
      okType: "primary"
    }
  }),
  setup(e, t) {
    let {
      expose: n
    } = t;
    var r;
    const a = V(() => e.open), o = V(() => e.config), {
      direction: i,
      getPrefixCls: s
    } = z_(), l = s("modal"), u = s(), c = () => {
      var v, h;
      e == null || e.afterClose(), (h = (v = o.value).afterClose) === null || h === void 0 || h.call(v);
    }, f = function() {
      e.destroyAction(...arguments);
    };
    n({
      destroy: f
    });
    const d = (r = o.value.okCancel) !== null && r !== void 0 ? r : o.value.type === "confirm", [p] = Tc("Modal", tu.Modal);
    return () => A(R7, ve(ve({
      prefixCls: l,
      rootPrefixCls: u
    }, o.value), {}, {
      close: f,
      open: a.value,
      afterClose: c,
      okText: o.value.okText || (d ? p == null ? void 0 : p.value.okText : p == null ? void 0 : p.value.justOkText),
      direction: o.value.direction || i.value,
      cancelText: o.value.cancelText || (p == null ? void 0 : p.value.cancelText)
    }), null);
  }
});
let l6 = 0;
const dce = /* @__PURE__ */ Me({
  name: "ElementsHolder",
  inheritAttrs: !1,
  setup(e, t) {
    let {
      expose: n
    } = t;
    const r = Be([]);
    return n({
      addModal: (o) => (r.value.push(o), r.value = r.value.slice(), () => {
        r.value = r.value.filter((i) => i !== o);
      })
    }), () => r.value.map((o) => o());
  }
});
function pce() {
  const e = Be(null), t = Be([]);
  He(t, () => {
    t.value.length && ([...t.value].forEach((i) => {
      i();
    }), t.value = []);
  }, {
    immediate: !0
  });
  const n = (o) => function(s) {
    var l;
    l6 += 1;
    const u = Be(!0), c = Be(null), f = Be(U(s)), d = Be({});
    He(() => s, (g) => {
      m(D(D({}, Ft(g) ? g.value : g), d.value));
    });
    const p = function() {
      u.value = !1;
      for (var g = arguments.length, S = new Array(g), w = 0; w < g; w++)
        S[w] = arguments[w];
      const _ = S.some((b) => b && b.triggerCancel);
      f.value.onCancel && _ && f.value.onCancel(() => {
      }, ...S.slice(1));
    };
    let v;
    const h = () => A(fce, {
      key: `modal-${l6}`,
      config: o(f.value),
      ref: c,
      open: u.value,
      destroyAction: p,
      afterClose: () => {
        v == null || v();
      }
    }, null);
    v = (l = e.value) === null || l === void 0 ? void 0 : l.addModal(h), v && Fu.push(v);
    const m = (g) => {
      f.value = D(D({}, f.value), g);
    };
    return {
      destroy: () => {
        c.value ? p() : t.value = [...t.value, p];
      },
      update: (g) => {
        d.value = g, c.value ? m(g) : t.value = [...t.value, () => m(g)];
      }
    };
  }, r = V(() => ({
    info: n(F7),
    success: n(L7),
    error: n(B7),
    warning: n(N7),
    confirm: n(H7)
  })), a = Symbol("modalHolderKey");
  return [r.value, () => A(dce, {
    key: a,
    ref: e
  }, null)];
}
function j7(e) {
  return Xp(N7(e));
}
Ka.useModal = pce;
Ka.info = function(t) {
  return Xp(F7(t));
};
Ka.success = function(t) {
  return Xp(L7(t));
};
Ka.error = function(t) {
  return Xp(B7(t));
};
Ka.warning = j7;
Ka.warn = j7;
Ka.confirm = function(t) {
  return Xp(H7(t));
};
Ka.destroyAll = function() {
  for (; Fu.length; ) {
    const t = Fu.pop();
    t && t();
  }
};
Ka.install = function(e) {
  return e.component(Ka.name, Ka), e;
};
const hce = kp("metaStore", () => {
  const e = {
    id: "mkoq0wps7erg5sp",
    source_id: "bi5j4j1az28tcjb",
    base_id: "p1xsf1p7utb2t32",
    table_name: "nc_zj0l___Features",
    title: "Features",
    type: "table",
    meta: { hasNonDefaultViews: !0 },
    schema: null,
    enabled: 1,
    mm: 0,
    tags: null,
    pinned: null,
    deleted: null,
    order: 1,
    created_at: "2024-02-22 09:48:36+00:00",
    updated_at: "2024-03-01 08:40:06+00:00",
    description: null,
    columns: [
      {
        id: "ckomlvzuylcllre",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "Id",
        column_name: "id",
        uidt: "ID",
        dt: "integer",
        np: null,
        ns: "0",
        clen: null,
        cop: null,
        pk: 1,
        pv: null,
        rqd: 1,
        un: 0,
        ct: "int(11)",
        ai: 1,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "integer",
        dtxp: "",
        dtxs: "",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: null,
        order: 1,
        created_at: "2024-02-22 09:48:36+00:00",
        updated_at: "2024-02-22 09:48:36+00:00",
        meta: null,
        description: null
      },
      {
        id: "carbaqf99k78fce",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "Title",
        column_name: "title",
        uidt: "SingleLineText",
        dt: "varchar",
        np: null,
        ns: null,
        clen: "45",
        cop: null,
        pk: 0,
        pv: 1,
        rqd: 0,
        un: 0,
        ct: "varchar",
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: "",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: null,
        order: 2,
        created_at: "2024-02-22 09:48:36+00:00",
        updated_at: "2024-02-22 09:48:36+00:00",
        meta: null,
        description: null
      },
      {
        id: "csyu4cz6dq1olye",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "CreatedAt",
        column_name: "created_at",
        uidt: "CreatedTime",
        dt: "datetime",
        np: null,
        ns: null,
        clen: "45",
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: "datetime",
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: "",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 1,
        order: 3,
        created_at: "2024-02-22 09:48:36+00:00",
        updated_at: "2024-02-22 09:48:36+00:00",
        meta: null,
        description: null
      },
      {
        id: "c3gaa3jjc5qk35i",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "UpdatedAt",
        column_name: "updated_at",
        uidt: "LastModifiedTime",
        dt: "datetime",
        np: null,
        ns: null,
        clen: "45",
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: "datetime",
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: "",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 1,
        order: 4,
        created_at: "2024-02-22 09:48:36+00:00",
        updated_at: "2024-02-22 09:48:36+00:00",
        meta: null,
        description: null
      },
      {
        id: "cyl598avan47hi8",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "nc_created_by",
        column_name: "created_by",
        uidt: "CreatedBy",
        dt: "varchar",
        np: null,
        ns: null,
        clen: "45",
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: "varchar",
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: "",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 1,
        order: 5,
        created_at: "2024-02-22 09:48:36+00:00",
        updated_at: "2024-02-22 09:48:36+00:00",
        meta: null,
        description: null
      },
      {
        id: "cbzkqc7mq0vkz42",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "nc_updated_by",
        column_name: "updated_by",
        uidt: "LastModifiedBy",
        dt: "varchar",
        np: null,
        ns: null,
        clen: "45",
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: "varchar",
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: "",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 1,
        order: 6,
        created_at: "2024-02-22 09:48:36+00:00",
        updated_at: "2024-02-22 09:48:36+00:00",
        meta: null,
        description: null
      },
      {
        id: "co2sfxglg4pi3je",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "多选",
        column_name: "field_2",
        uidt: "MultiSelect",
        dt: "text",
        np: null,
        ns: null,
        clen: "45",
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: "varchar",
        ai: 0,
        unique: null,
        cdf: "1",
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "'1','2','12312312312w12ws12s121s'",
        dtxs: " ",
        au: null,
        validate: "",
        virtual: null,
        deleted: null,
        system: 0,
        order: 7,
        created_at: "2024-02-22 09:48:48+00:00",
        updated_at: "2024-03-06 03:43:11+00:00",
        meta: {},
        description: null,
        colOptions: {
          options: [
            {
              id: "skav9o9j1toed12",
              fk_column_id: "co2sfxglg4pi3je",
              title: "1",
              color: "#cfdffe",
              order: 1
            },
            {
              id: "s5u0xrdblhy6h84",
              fk_column_id: "co2sfxglg4pi3je",
              title: "2",
              color: "#d0f1fd",
              order: 2
            },
            {
              id: "s84g1blrda56sdo",
              fk_column_id: "co2sfxglg4pi3je",
              title: "12312312312w12ws12s121s",
              color: "#c2f5e8",
              order: 3
            }
          ]
        }
      },
      {
        id: "cpgy8imia8zt1kj",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "title8",
        column_name: "title8",
        uidt: "Checkbox",
        dt: "boolean",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: "0",
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: null,
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 0,
        order: 8,
        created_at: "2024-03-05 08:04:18+00:00",
        updated_at: "2024-03-05 08:04:18+00:00",
        meta: {
          icon: { checked: "mdi-check-bold", unchecked: "mdi-crop-square" },
          color: "#777",
          iconIdx: 0
        },
        description: null
      },
      {
        id: "clsz9dez9ck9gly",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "单选",
        column_name: "field_3",
        uidt: "SingleSelect",
        dt: "text",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "'1','2','123'",
        dtxs: "",
        au: null,
        validate: "",
        virtual: null,
        deleted: null,
        system: 0,
        order: 10,
        created_at: "2024-03-05 09:08:23+00:00",
        updated_at: "2024-03-06 03:43:24+00:00",
        meta: {},
        description: null,
        colOptions: {
          options: [
            {
              id: "smn2zg8rz1moqtd",
              fk_column_id: "clsz9dez9ck9gly",
              title: "1",
              color: "#cfdffe",
              order: 1
            },
            {
              id: "sq56os349h77kkb",
              fk_column_id: "clsz9dez9ck9gly",
              title: "2",
              color: "#d0f1fd",
              order: 2
            },
            {
              id: "s80hbju3ar9j8k7",
              fk_column_id: "clsz9dez9ck9gly",
              title: "123",
              color: "#ffdaf6",
              order: 3
            }
          ]
        }
      },
      {
        id: "cn84686gwxadsph",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "日期",
        column_name: "field_1",
        uidt: "Date",
        dt: "date",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: null,
        au: null,
        validate: "",
        virtual: null,
        deleted: null,
        system: 0,
        order: 11,
        created_at: "2024-03-06 03:06:30+00:00",
        updated_at: "2024-03-06 03:07:16+00:00",
        meta: { date_format: "YYYY-MM-DD" },
        description: null
      },
      {
        id: "con69reobx1bxd7",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "日期时间",
        column_name: "field",
        uidt: "DateTime",
        dt: "datetime",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: null,
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 0,
        order: 12,
        created_at: "2024-03-06 03:07:08+00:00",
        updated_at: "2024-03-06 03:07:08+00:00",
        meta: { date_format: "YYYY-MM-DD", time_format: "HH:mm" },
        description: null
      },
      {
        id: "c5el3qqyx7in434",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "url",
        column_name: "url",
        uidt: "URL",
        dt: "varchar",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: null,
        au: null,
        validate: '{"func":["isURL"],"args":[""],"msg":["Validation failed : isURL"]}',
        virtual: null,
        deleted: null,
        system: 0,
        order: 13,
        created_at: "2024-03-06 03:43:37+00:00",
        updated_at: "2024-03-06 03:43:37+00:00",
        meta: {},
        description: null
      },
      {
        id: "cwd8omv2ma64a7a",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "decimal",
        column_name: "decimal",
        uidt: "Decimal",
        dt: "decimal",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: null,
        au: null,
        validate: "",
        virtual: null,
        deleted: null,
        system: 0,
        order: 14,
        created_at: "2024-03-06 07:39:43+00:00",
        updated_at: "2024-03-06 07:43:41+00:00",
        meta: { precision: 1 },
        description: null
      },
      {
        id: "c7fw069w9uv5v38",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "number",
        column_name: "number",
        uidt: "Number",
        dt: "integer",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: " ",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 0,
        order: 15,
        created_at: "2024-03-06 08:05:03+00:00",
        updated_at: "2024-03-06 08:05:03+00:00",
        meta: {},
        description: null
      },
      {
        id: "cfzu9cai9zrf8kf",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "json",
        column_name: "json",
        uidt: "JSON",
        dt: "text",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: " ",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 0,
        order: 16,
        created_at: "2024-03-06 08:36:39+00:00",
        updated_at: "2024-03-06 08:36:39+00:00",
        meta: {},
        description: null
      }
    ],
    views: [
      {
        ptn: "nc_zj0l___Features",
        _ptn: "Features",
        ptype: "table",
        tn: "Features",
        _tn: "Features",
        table_meta: { hasNonDefaultViews: !0 },
        id: "vwn2u4gvtgud7vf1",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "Features",
        type: 3,
        is_default: 1,
        show_system_fields: 0,
        lock_type: "collaborative",
        uuid: null,
        password: null,
        show: 1,
        order: 1,
        created_at: "2024-02-22 09:48:36+00:00",
        updated_at: "2024-03-05 08:44:26+00:00",
        meta: {},
        description: null,
        view: {
          fk_view_id: "vwn2u4gvtgud7vf1",
          source_id: "bi5j4j1az28tcjb",
          base_id: "p1xsf1p7utb2t32",
          uuid: null,
          created_at: "2024-02-22 09:48:36+00:00",
          updated_at: "2024-02-22 09:48:36+00:00",
          meta: null,
          row_height: null
        },
        disabled: {
          owner: !1,
          creator: !1,
          viewer: !1,
          editor: !1,
          commenter: !1,
          guest: !1
        }
      },
      {
        ptn: "nc_zj0l___Features",
        _ptn: "Features",
        ptype: "table",
        tn: "Grid",
        _tn: "Grid",
        table_meta: { hasNonDefaultViews: !0 },
        id: "vw1r7c7nu83v5hbt",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "Grid",
        type: 3,
        is_default: null,
        show_system_fields: null,
        lock_type: "collaborative",
        uuid: null,
        password: null,
        show: 1,
        order: 2,
        created_at: "2024-03-01 03:23:51+00:00",
        updated_at: "2024-03-01 03:23:51+00:00",
        meta: {},
        description: null,
        view: {
          fk_view_id: "vw1r7c7nu83v5hbt",
          source_id: "bi5j4j1az28tcjb",
          base_id: "p1xsf1p7utb2t32",
          uuid: null,
          created_at: "2024-03-01 03:23:51+00:00",
          updated_at: "2024-03-01 03:23:51+00:00",
          meta: null,
          row_height: null
        },
        disabled: {
          owner: !1,
          creator: !1,
          viewer: !1,
          editor: !1,
          commenter: !1,
          guest: !1
        }
      },
      {
        ptn: "nc_zj0l___Features",
        _ptn: "Features",
        ptype: "table",
        tn: "Form",
        _tn: "Form",
        table_meta: { hasNonDefaultViews: !0 },
        id: "vwdm55bp72sj6b55",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "Form",
        type: 1,
        is_default: null,
        show_system_fields: null,
        lock_type: "collaborative",
        uuid: null,
        password: null,
        show: 1,
        order: 3,
        created_at: "2024-03-01 08:40:06+00:00",
        updated_at: "2024-03-01 08:40:06+00:00",
        meta: {},
        description: null,
        view: {
          source_id: "bi5j4j1az28tcjb",
          base_id: "p1xsf1p7utb2t32",
          fk_view_id: "vwdm55bp72sj6b55",
          heading: "Form",
          subheading: null,
          success_msg: null,
          redirect_url: null,
          redirect_after_secs: null,
          email: null,
          submit_another_form: null,
          show_blank_form: null,
          uuid: null,
          banner_image_url: null,
          logo_url: null,
          created_at: "2024-03-01 08:40:06+00:00",
          updated_at: "2024-03-01 08:40:06+00:00",
          meta: {}
        },
        disabled: {
          owner: !1,
          creator: !1,
          viewer: !1,
          editor: !1,
          commenter: !1,
          guest: !1
        }
      }
    ],
    columnsById: {
      ckomlvzuylcllre: {
        id: "ckomlvzuylcllre",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "Id",
        column_name: "id",
        uidt: "ID",
        dt: "integer",
        np: null,
        ns: "0",
        clen: null,
        cop: null,
        pk: 1,
        pv: null,
        rqd: 1,
        un: 0,
        ct: "int(11)",
        ai: 1,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "integer",
        dtxp: "",
        dtxs: "",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: null,
        order: 1,
        created_at: "2024-02-22 09:48:36+00:00",
        updated_at: "2024-02-22 09:48:36+00:00",
        meta: null,
        description: null
      },
      carbaqf99k78fce: {
        id: "carbaqf99k78fce",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "Title",
        column_name: "title",
        uidt: "SingleLineText",
        dt: "varchar",
        np: null,
        ns: null,
        clen: "45",
        cop: null,
        pk: 0,
        pv: 1,
        rqd: 0,
        un: 0,
        ct: "varchar",
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: "",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: null,
        order: 2,
        created_at: "2024-02-22 09:48:36+00:00",
        updated_at: "2024-02-22 09:48:36+00:00",
        meta: null,
        description: null
      },
      csyu4cz6dq1olye: {
        id: "csyu4cz6dq1olye",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "CreatedAt",
        column_name: "created_at",
        uidt: "CreatedTime",
        dt: "datetime",
        np: null,
        ns: null,
        clen: "45",
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: "datetime",
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: "",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 1,
        order: 3,
        created_at: "2024-02-22 09:48:36+00:00",
        updated_at: "2024-02-22 09:48:36+00:00",
        meta: null,
        description: null
      },
      c3gaa3jjc5qk35i: {
        id: "c3gaa3jjc5qk35i",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "UpdatedAt",
        column_name: "updated_at",
        uidt: "LastModifiedTime",
        dt: "datetime",
        np: null,
        ns: null,
        clen: "45",
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: "datetime",
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: "",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 1,
        order: 4,
        created_at: "2024-02-22 09:48:36+00:00",
        updated_at: "2024-02-22 09:48:36+00:00",
        meta: null,
        description: null
      },
      cyl598avan47hi8: {
        id: "cyl598avan47hi8",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "nc_created_by",
        column_name: "created_by",
        uidt: "CreatedBy",
        dt: "varchar",
        np: null,
        ns: null,
        clen: "45",
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: "varchar",
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: "",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 1,
        order: 5,
        created_at: "2024-02-22 09:48:36+00:00",
        updated_at: "2024-02-22 09:48:36+00:00",
        meta: null,
        description: null
      },
      cbzkqc7mq0vkz42: {
        id: "cbzkqc7mq0vkz42",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "nc_updated_by",
        column_name: "updated_by",
        uidt: "LastModifiedBy",
        dt: "varchar",
        np: null,
        ns: null,
        clen: "45",
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: "varchar",
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: "",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 1,
        order: 6,
        created_at: "2024-02-22 09:48:36+00:00",
        updated_at: "2024-02-22 09:48:36+00:00",
        meta: null,
        description: null
      },
      co2sfxglg4pi3je: {
        id: "co2sfxglg4pi3je",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "多选",
        column_name: "field_2",
        uidt: "MultiSelect",
        dt: "text",
        np: null,
        ns: null,
        clen: "45",
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: "varchar",
        ai: 0,
        unique: null,
        cdf: "1",
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "'1','2','12312312312w12ws12s121s'",
        dtxs: " ",
        au: null,
        validate: "",
        virtual: null,
        deleted: null,
        system: 0,
        order: 7,
        created_at: "2024-02-22 09:48:48+00:00",
        updated_at: "2024-03-06 03:43:11+00:00",
        meta: {},
        description: null,
        colOptions: {
          options: [
            {
              id: "skav9o9j1toed12",
              fk_column_id: "co2sfxglg4pi3je",
              title: "1",
              color: "#cfdffe",
              order: 1
            },
            {
              id: "s5u0xrdblhy6h84",
              fk_column_id: "co2sfxglg4pi3je",
              title: "2",
              color: "#d0f1fd",
              order: 2
            },
            {
              id: "s84g1blrda56sdo",
              fk_column_id: "co2sfxglg4pi3je",
              title: "12312312312w12ws12s121s",
              color: "#c2f5e8",
              order: 3
            }
          ]
        }
      },
      cpgy8imia8zt1kj: {
        id: "cpgy8imia8zt1kj",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "title8",
        column_name: "title8",
        uidt: "Checkbox",
        dt: "boolean",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: "0",
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: null,
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 0,
        order: 8,
        created_at: "2024-03-05 08:04:18+00:00",
        updated_at: "2024-03-05 08:04:18+00:00",
        meta: {
          icon: { checked: "mdi-check-bold", unchecked: "mdi-crop-square" },
          color: "#777",
          iconIdx: 0
        },
        description: null
      },
      clsz9dez9ck9gly: {
        id: "clsz9dez9ck9gly",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "单选",
        column_name: "field_3",
        uidt: "SingleSelect",
        dt: "text",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "'1','2','123'",
        dtxs: "",
        au: null,
        validate: "",
        virtual: null,
        deleted: null,
        system: 0,
        order: 10,
        created_at: "2024-03-05 09:08:23+00:00",
        updated_at: "2024-03-06 03:43:24+00:00",
        meta: {},
        description: null,
        colOptions: {
          options: [
            {
              id: "smn2zg8rz1moqtd",
              fk_column_id: "clsz9dez9ck9gly",
              title: "1",
              color: "#cfdffe",
              order: 1
            },
            {
              id: "sq56os349h77kkb",
              fk_column_id: "clsz9dez9ck9gly",
              title: "2",
              color: "#d0f1fd",
              order: 2
            },
            {
              id: "s80hbju3ar9j8k7",
              fk_column_id: "clsz9dez9ck9gly",
              title: "123",
              color: "#ffdaf6",
              order: 3
            }
          ]
        }
      },
      cn84686gwxadsph: {
        id: "cn84686gwxadsph",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "日期",
        column_name: "field_1",
        uidt: "Date",
        dt: "date",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: null,
        au: null,
        validate: "",
        virtual: null,
        deleted: null,
        system: 0,
        order: 11,
        created_at: "2024-03-06 03:06:30+00:00",
        updated_at: "2024-03-06 03:07:16+00:00",
        meta: { date_format: "YYYY-MM-DD" },
        description: null
      },
      con69reobx1bxd7: {
        id: "con69reobx1bxd7",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "日期时间",
        column_name: "field",
        uidt: "DateTime",
        dt: "datetime",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: null,
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 0,
        order: 12,
        created_at: "2024-03-06 03:07:08+00:00",
        updated_at: "2024-03-06 03:07:08+00:00",
        meta: { date_format: "YYYY-MM-DD", time_format: "HH:mm" },
        description: null
      },
      c5el3qqyx7in434: {
        id: "c5el3qqyx7in434",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "url",
        column_name: "url",
        uidt: "URL",
        dt: "varchar",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: null,
        au: null,
        validate: '{"func":["isURL"],"args":[""],"msg":["Validation failed : isURL"]}',
        virtual: null,
        deleted: null,
        system: 0,
        order: 13,
        created_at: "2024-03-06 03:43:37+00:00",
        updated_at: "2024-03-06 03:43:37+00:00",
        meta: {},
        description: null
      },
      cwd8omv2ma64a7a: {
        id: "cwd8omv2ma64a7a",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "decimal",
        column_name: "decimal",
        uidt: "Decimal",
        dt: "decimal",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: null,
        au: null,
        validate: "",
        virtual: null,
        deleted: null,
        system: 0,
        order: 14,
        created_at: "2024-03-06 07:39:43+00:00",
        updated_at: "2024-03-06 07:43:41+00:00",
        meta: { precision: 1 },
        description: null
      },
      c7fw069w9uv5v38: {
        id: "c7fw069w9uv5v38",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "number",
        column_name: "number",
        uidt: "Number",
        dt: "integer",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: " ",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 0,
        order: 15,
        created_at: "2024-03-06 08:05:03+00:00",
        updated_at: "2024-03-06 08:05:03+00:00",
        meta: {},
        description: null
      },
      cfzu9cai9zrf8kf: {
        id: "cfzu9cai9zrf8kf",
        source_id: "bi5j4j1az28tcjb",
        base_id: "p1xsf1p7utb2t32",
        fk_model_id: "mkoq0wps7erg5sp",
        title: "json",
        column_name: "json",
        uidt: "JSON",
        dt: "text",
        np: null,
        ns: null,
        clen: null,
        cop: null,
        pk: 0,
        pv: null,
        rqd: 0,
        un: 0,
        ct: null,
        ai: 0,
        unique: null,
        cdf: null,
        cc: null,
        csn: null,
        dtx: "specificType",
        dtxp: "",
        dtxs: " ",
        au: null,
        validate: null,
        virtual: null,
        deleted: null,
        system: 0,
        order: 16,
        created_at: "2024-03-06 08:36:39+00:00",
        updated_at: "2024-03-06 08:36:39+00:00",
        meta: {},
        description: null
      }
    }
  }, t = ne(e), n = ne({
    mkoq0wps7erg5sp: e
  });
  return { meta: t, loadMeta: async (a) => {
    const o = n.value[a];
    if (o)
      return o;
  } };
});
function vce(e) {
  const t = e.instance;
  return t.interceptors.request.use((n) => (n.headers.Authorization = localStorage.getItem("API_TOKEN"), n.headers["Workspace-Id"] = localStorage.getItem("WORKSPACE_ID"), n)), t.interceptors.response.use(
    (n) => n,
    // Handle Error
    (n) => {
      if (!n.response || n.response.status !== 401)
        return Promise.reject(n);
    }
  ), e;
}
const nd = () => /Mac/i.test(navigator.platform), ku = () => document.querySelector(".expanded-cell-input"), jm = () => document.querySelector(".ant-modal.active, .ant-drawer-open"), mce = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="alivfkbf5__design-iconfont" width="16" height="16"><defs><clipPath id="alivfkbf5__mgu8cha0j__uzvdssypda"><rect width="24" height="24" rx="0"></rect></clipPath></defs><g clip-path="url(#alivfkbf5__mgu8cha0j__uzvdssypda)"><path d="M20,2L4,2C3.447715,2,3,2.447715,3,3L3,6C3,6.55228,3.447715,7,4,7C4.55228,7,5,6.55228,5,6L5,4.5C5,4.22386,5.22386,4,5.5,4L10.5,4C10.77614,4,11,4.22386,11,4.5L11,19.5C11,19.7761,10.77614,20,10.5,20L9,20C8.44772,20,8,20.4477,8,21C8,21.5523,8.44772,22,9,22L15,22C15.5523,22,16,21.5523,16,21C16,20.4477,15.5523,20,15,20L13.5,20C13.2239,20,13,19.7761,13,19.5L13,4.5C13,4.22386,13.2239,4,13.5,4L18.5,4C18.7761,4,19,4.22386,19,4.5L19,6C19,6.55228,19.4477,7,20,7C20.5523,7,21,6.55228,21,6L21,3C21,2.447715,20.5523,2,20,2" fill="currentColor" fill-rule="evenodd"></path></g></svg>', gce = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="vthi01l0d__design-iconfont" width="16" height="16"><defs><clipPath id="vthi01l0d__mh3y0q5oi__m4ekjnygea"><rect width="24" height="24" rx="0"></rect></clipPath></defs><g clip-path="url(#vthi01l0d__mh3y0q5oi__m4ekjnygea)"><path d="M3.509322,10.7267C3.265368,11.33658,3.714526,12,4.37139,12C4.75105,12,5.09246,11.76886,5.23346,11.41635L5.8,10L10.2,10L10.766539999999999,11.41635C10.907540000000001,11.76886,11.24895,12,11.62861,12C12.28547,12,12.73463,11.33658,12.49068,10.7267L9.251439999999999,2.628609C9.09958,2.248951,8.73187,2,8.32297,2L7.67703,2C7.26813,2,6.90042,2.248951,6.7485599999999994,2.628609L3.509322,10.7267ZM9.4,8L8.46424,5.6606000000000005C8.296610000000001,5.2415199999999995,7.70339,5.2415199999999995,7.53576,5.6606000000000005L6.6,8L9.4,8ZM13,6C13,5.44772,13.4477,5,14,5L20,5C20.5523,5,21,5.44772,21,6C21,6.55228,20.5523,7,20,7L14,7C13.4477,7,13,6.55228,13,6ZM16,10C15.4477,10,15,10.44772,15,11C15,11.55228,15.4477,12,16,12L20,12C20.5523,12,21,11.55228,21,11C21,10.44772,20.5523,10,20,10L16,10ZM4,15C3.447715,15,3,15.4477,3,16C3,16.552300000000002,3.447715,17,4,17L20,17C20.5523,17,21,16.552300000000002,21,16C21,15.4477,20.5523,15,20,15L4,15ZM3,21C3,20.4477,3.447715,20,4,20L20,20C20.5523,20,21,20.4477,21,21C21,21.5523,20.5523,22,20,22L4,22C3.447715,22,3,21.5523,3,21Z" fill="currentColor" fill-rule="evenodd"></path></g></svg>', yce = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="l8s7vclst__design-iconfont" width="16" height="16"><defs><clipPath id="l8s7vclst__aa8num0f2__u9umgurc7a"><rect width="24" height="24" rx="0"></rect></clipPath></defs><g clip-path="url(#l8s7vclst__aa8num0f2__u9umgurc7a)"><path d="M7.1644,21C6.55487,21,6.09122,20.4527,6.19143,19.8514L6.83333,16L4,16C3.447715,16,3,15.5523,3,15C3,14.4477,3.447715,14,4,14L7.16667,14L7.83333,10L4,10C3.447715,10,3,9.55228,3,9C3,8.44772,3.447715,8,4,8L8.16667,8L8.86263,3.824232C8.9419,3.348604,9.35341,3,9.8356,3C10.445129999999999,3,10.90878,3.5473179999999997,10.80857,4.14856L10.16667,8L15.1667,8L15.8626,3.824232C15.9419,3.348604,16.3534,3,16.8356,3C17.4451,3,17.9088,3.5473179999999997,17.8086,4.14856L17.1667,8L20,8C20.5523,8,21,8.44772,21,9C21,9.55228,20.5523,10,20,10L16.8333,10L16.1667,14L20,14C20.5523,14,21,14.4477,21,15C21,15.5523,20.5523,16,20,16L15.8333,16L15.1374,20.1758C15.0581,20.6514,14.6466,21,14.1644,21C13.5549,21,13.0912,20.4527,13.1914,19.8514L13.8333,16L8.83333,16L8.13737,20.1758C8.0581,20.6514,7.64659,21,7.1644,21ZM9.16667,14L14.1667,14L14.8333,10L9.83333,10L9.16667,14Z" fill="currentColor" fill-rule="evenodd"></path></g></svg>', xce = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="nm6v3lxn7__design-iconfont" width="16" height="16"><defs><clipPath id="nm6v3lxn7__4az97ksye__3qrh5mleoa"><rect width="24" height="24" rx="0"></rect></clipPath></defs><g clip-path="url(#nm6v3lxn7__4az97ksye__3qrh5mleoa)"><path d="M6,7L6,17C6,18.6569,7.34315,20,9,20L10,20C11.65685,20,13,18.6569,13,17L13,7C13,5.34315,11.65685,4,10,4L9,4C7.34315,4,6,5.34315,6,7ZM15,7L15,17C15,18.6569,16.3431,20,18,20L19,20C20.6569,20,22,18.6569,22,17L22,7C22,5.34315,20.6569,4,19,4L18,4C16.3431,4,15,5.34315,15,7ZM8.29289,17.7071Q8,17.4142,8,17L8,7Q8,6.585789999999999,8.29289,6.29289Q8.58579,6,9,6L10,6Q10.41421,6,10.70711,6.29289Q11,6.585789999999999,11,7L11,17Q11,17.4142,10.70711,17.7071Q10.41421,18,10,18L9,18Q8.58579,18,8.29289,17.7071ZM17.2929,17.7071Q17,17.4142,17,17L17,7Q17,6.585789999999999,17.2929,6.29289Q17.5858,6,18,6L19,6Q19.4142,6,19.7071,6.29289Q20,6.585789999999999,20,7L20,17Q20,17.4142,19.7071,17.7071Q19.4142,18,19,18L18,18Q17.5858,18,17.2929,17.7071ZM2,18L2,19C2,19.552300000000002,2.447715,20,3,20L4,20C4.55229,20,5,19.552300000000002,5,19L5,18C5,17.447699999999998,4.55229,17,4,17L3,17C2.447715,17,2,17.447699999999998,2,18Z" fill="currentColor" fill-rule="evenodd"></path></g></svg>', bce = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="6pju37lh1__design-iconfont" width="16" height="16"><defs><clipPath id="6pju37lh1__kx0fuvzcv__8pt67udfpa"><rect width="24" height="24" rx="0"></rect></clipPath></defs><g clip-path="url(#6pju37lh1__kx0fuvzcv__8pt67udfpa)"><path d="M7,6L7,7C7,7.55228,7.44772,8,8,8C8.55228,8,9,7.55228,9,7L9,6L15,6L15,7C15,7.55228,15.4477,8,16,8C16.552300000000002,8,17,7.55228,17,7L17,6L18,6Q18.4142,6,18.7071,6.29289Q19,6.585789999999999,19,7L19,10L5,10L5,7Q5,6.585789999999999,5.29289,6.29289Q5.585789999999999,6,6,6L7,6ZM5,12L5,18Q5,18.4142,5.29289,18.7071Q5.585789999999999,19,6,19L18,19Q18.4142,19,18.7071,18.7071Q19,18.4142,19,18L19,12L5,12ZM17,4L18,4C19.6569,4,21,5.34315,21,7L21,18C21,19.6569,19.6569,21,18,21L6,21C4.34315,21,3,19.6569,3,18L3,7C3,5.34315,4.34315,4,6,4L7,4C7,3.447715,7.44772,3,8,3C8.55228,3,9,3.447715,9,4L15,4C15,3.447715,15.4477,3,16,3C16.552300000000002,3,17,3.447715,17,4Z" fill="currentColor" fill-rule="evenodd"></path></g></svg>', wce = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="ha71f2fon__design-iconfont" width="16" height="16"><defs><clipPath id="ha71f2fon__rvmokalaw__cqk0qroi5a"><rect width="24" height="24" rx="0"></rect></clipPath></defs><g clip-path="url(#ha71f2fon__rvmokalaw__cqk0qroi5a)"><path d="M12,3C7.02944,3,3,7.02944,3,12C3,16.970599999999997,7.02944,21,12,21C16.970599999999997,21,21,16.970599999999997,21,12C21,7.02944,16.970599999999997,3,12,3ZM7.05025,16.9497Q5,14.8995,5,12Q5,9.1005,7.05025,7.05025Q9.1005,5,12,5Q14.8995,5,16.9497,7.05025Q19,9.10051,19,12Q19,14.8995,16.9497,16.9497Q14.8995,19,12,19Q9.10051,19,7.05025,16.9497ZM12,9C10.34315,9,9,10.34315,9,12C9,13.6569,10.34315,15,12,15C13.6569,15,15,13.6569,15,12C15,10.34315,13.6569,9,12,9Z" fill="currentColor" fill-rule="evenodd"></path></g></svg>', Sce = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="267kx6vb6__design-iconfont" width="16" height="16"><defs><clipPath id="267kx6vb6__mgnkfovy4__vh7s2phzoa"><rect width="24" height="24" rx="0"></rect></clipPath></defs><g clip-path="url(#267kx6vb6__mgnkfovy4__vh7s2phzoa)"><path d="M3,13L3,11C3,10.44772,3.447715,10,4,10L6,10C6.55228,10,7,10.44772,7,11L7,13C7,13.5523,6.55228,14,6,14L4,14C3.447715,14,3,13.5523,3,13ZM3,20L3,18C3,17.447699999999998,3.447715,17,4,17L6,17C6.55228,17,7,17.447699999999998,7,18L7,20C7,20.5523,6.55228,21,6,21L4,21C3.447715,21,3,20.5523,3,20ZM3,6L3,4C3,3.447715,3.447715,3,4,3L6,3C6.55228,3,7,3.447715,7,4L7,6C7,6.55229,6.55228,7,6,7L4,7C3.447715,7,3,6.55229,3,6ZM9,19C9,18.447699999999998,9.44772,18,10,18L20,18C20.5523,18,21,18.447699999999998,21,19C21,19.5523,20.5523,20,20,20L10,20C9.44772,20,9,19.5523,9,19ZM9,12C9,11.44772,9.44772,11,10,11L20,11C20.5523,11,21,11.44772,21,12C21,12.55228,20.5523,13,20,13L10,13C9.44772,13,9,12.55228,9,12ZM9,5C9,4.44771,9.44772,4,10,4L20,4C20.5523,4,21,4.44771,21,5C21,5.55229,20.5523,6,20,6L10,6C9.44772,6,9,5.55229,9,5Z" fill="currentColor"></path></g></svg>', _ce = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="zu3rtpde4__design-iconfont" width="16" height="16"><defs><clipPath id="zu3rtpde4__ff9zf3g9v__jogfb0o4qa"><rect width="24" height="24" rx="0"></rect></clipPath></defs><g clip-path="url(#zu3rtpde4__ff9zf3g9v__jogfb0o4qa)"><path d="M2.999924659729004,6L2.999924659729004,18C2.999924659729004,19.6569,4.3430746597290035,21,5.999924659729004,21L17.999924659729004,21C19.656824659729004,21,20.999924659729004,19.6569,20.999924659729004,18L20.999924659729004,6C20.999924659729004,4.34315,19.656824659729004,3,17.999924659729004,3L5.999924659729004,3C4.3430746597290035,3,2.999924659729004,4.34315,2.999924659729004,6ZM5.292814659729004,18.7071Q4.999924659729004,18.4142,4.999924659729004,18L4.999924659729004,6Q4.999924659729004,5.585789999999999,5.292814659729004,5.29289Q5.585714659729003,5,5.999924659729004,5L17.999924659729004,5Q18.414124659729005,5,18.707024659729004,5.29289Q18.999924659729004,5.585789999999999,18.999924659729004,6L18.999924659729004,18Q18.999924659729004,18.4142,18.707024659729004,18.7071Q18.414124659729005,19,17.999924659729004,19L5.999924659729004,19Q5.585714659729003,19,5.292814659729004,18.7071ZM11.707104659729003,14.7072L16.000024659729004,10.414290000000001C16.390524659729003,10.02376,16.390524659729003,9.3906,16.000024659729004,9.00008C15.609524659729004,8.609549999999999,14.976324659729004,8.609549999999999,14.585824659729004,9.00008L11.353554659729005,12.23231C11.158294659729004,12.42757,10.841704659729004,12.42757,10.646444659729003,12.23231L9.414214659729005,11.00008C9.023684659729003,10.609549999999999,8.390524659729003,10.609549999999999,8.000004659729004,11.00008C7.6094746597290035,11.3906,7.6094746597290035,12.02376,8.000004659729004,12.41429L10.292894659729004,14.7072C10.683414659729003,15.0977,11.316584659729005,15.0977,11.707104659729003,14.7072Z" fill="currentColor" fill-rule="evenodd"></path></g></svg>', Cce = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="47psoyv16__design-iconfont" width="16" height="16"><defs><clipPath id="47psoyv16__3dcgyss1z__nxdln3boia"><rect width="24" height="24" rx="0"></rect></clipPath></defs><g clip-path="url(#47psoyv16__3dcgyss1z__nxdln3boia)"><path d="M17.656045696640014,10.58541034729004L15.534045696640014,12.70742034729004C15.143545696640015,13.09794034729004,15.143545696640015,13.731090347290039,15.534045696640014,14.12159034729004C15.924545696640015,14.512190347290039,16.557745696640012,14.512190347290039,16.948245696640015,14.12159034729004L19.070245696640015,11.999620347290039C21.022845696640015,10.047000347290039,21.022845696640015,6.881180347290039,19.070245696640015,4.9285603472900394C17.117645696640015,2.975935347290039,13.951845696640016,2.975935347290039,11.999175696640014,4.9285603472900394L9.877165696640015,7.050570347290039C9.486645696640014,7.441090347290039,9.486645696640014,8.07425034729004,9.877165696640015,8.464780347290038C10.267695696640015,8.85530034729004,10.900855696640015,8.85530034729004,11.291385696640015,8.464780347290038L13.413395696640015,6.342770347290039Q14.292045696640015,5.464090347290039,15.534745696640014,5.464090347290039Q16.777345696640015,5.464090347290039,17.656045696640014,6.342770347290039Q18.534745696640016,7.221450347290039,18.534745696640016,8.464090347290039Q18.534745696640016,9.706730347290039,17.656045696640014,10.58541034729004ZM9.171945696640016,13.413990347290039C8.781425696640014,13.80449034729004,8.781425696640014,14.437690347290038,9.171945696640016,14.82819034729004C9.562475696640014,15.218690347290039,10.195635696640014,15.218690347290039,10.586165696640014,14.82819034729004L14.828845696640014,10.58556034729004C15.219345696640014,10.195040347290039,15.219345696640014,9.56187034729004,14.828845696640014,9.171350347290039C14.438245696640015,8.780820347290039,13.805145696640015,8.780820347290039,13.414585696640014,9.171350347290039L9.171945696640016,13.413990347290039ZM4.928115696640015,11.999620347290039L7.048745696640015,9.878990347290038C7.439265696640015,9.48847034729004,8.072435696640014,9.48847034729004,8.462955696640016,9.878990347290038C8.853475696640015,10.26952034729004,8.853475696640015,10.902680347290039,8.462955696640016,11.293210347290039L6.342325696640015,13.413840347290039Q5.463645696640015,14.29249034729004,5.463645696640015,15.535190347290039Q5.463645696640015,16.77779034729004,6.342325696640015,17.65649034729004Q7.221005696640015,18.53519034729004,8.463645696640015,18.53519034729004Q9.706285696640014,18.53519034729004,10.584965696640015,17.65649034729004L12.705595696640014,15.535890347290039C13.096115696640014,15.14529034729004,13.729245696640014,15.14529034729004,14.119845696640015,15.535890347290039C14.510345696640014,15.92639034729004,14.510345696640014,16.559490347290037,14.119845696640015,16.95009034729004L11.999175696640014,19.07069034729004C10.046555696640015,21.02329034729004,6.880735696640015,21.02329034729004,4.928115696640015,19.07069034729004C2.9754906966400148,17.11809034729004,2.9754906966400148,13.95229034729004,4.928115696640015,11.999620347290039Z" fill="currentColor" fill-rule="evenodd"></path></g></svg>', Ece = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="v2wfe989h__design-iconfont" width="16" height="16"><defs><clipPath id="v2wfe989h__tdc3wb10d__r0y14n3qza"><rect width="24" height="24" rx="0"></rect></clipPath></defs><g clip-path="url(#v2wfe989h__tdc3wb10d__r0y14n3qza)"><path d="M2,17L2,7C2,5.34315,3.34315,4,5,4L19,4C20.6569,4,22,5.34315,22,7L22,10C22,10.55228,21.5523,11,21,11C20.4477,11,20,10.55228,20,10L20,7Q20,6.585789999999999,19.7071,6.29289Q19.4142,6,19,6L5,6Q4.585789999999999,6,4.29289,6.29289Q4,6.585789999999999,4,7L4,17Q4,17.4142,4.29289,17.7071Q4.58578,18,5,18L12,18C12.5523,18,13,18.447699999999998,13,19C13,19.552300000000002,12.5523,20,12,20L5,20C3.34315,20,2,18.6569,2,17ZM7,9L7,15C7,15.5523,7.44772,16,8,16C8.55228,16,9,15.5523,9,15L9,9C9,8.44772,8.55228,8,8,8C7.44772,8,7,8.44772,7,9ZM17,11L17,12C16.2621,12,15.55,12.27198,15,12.76393L15,11Q15,10.58579,14.7071,10.29289Q14.4142,10,14,10L13,10L13,14L14,14Q14.0913,14,14.1766,13.98577C14.0598,14.3111,14,14.6543,14,15L14,16L12,16C11.44772,16,11,15.5523,11,15L11,9C11,8.44772,11.44772,8,12,8L14,8C15.6569,8,17,9.34315,17,11ZM16,16L16,15C16,13.89543,16.895400000000002,13,18,13L19,13C20.1046,13,21,13.89543,21,15L21,16C21.5523,16,22,16.447699999999998,22,17L22,19C22,19.552300000000002,21.5523,20,21,20L16,20C15.4477,20,15,19.552300000000002,15,19L15,17C15,16.447699999999998,15.4477,16,16,16ZM20,15L20,16L17,16L17,15Q17,14.5858,17.2929,14.2929Q17.5858,14,18,14L19,14Q19.4142,14,19.7071,14.2929Q20,14.5858,20,15Z" fill="currentColor" fill-rule="evenodd"></path></g></svg>', Tce = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="6wl5z6ob8__design-iconfont" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3 12a9 9 0 0 1 17.946-.993c.06.55-.394.993-.946.993-.552 0-.992-.448-1.064-.996Q18.64 8.74 16.95 7.05 14.9 5 12 5 9.1 5 7.05 7.05 5 9.1 5 12q0 2.9 2.05 4.95 1.69 1.689 3.954 1.986c.548.072.996.512.996 1.064s-.444 1.006-.993.946A9.001 9.001 0 0 1 3 12Zm15 2h-1a2 2 0 0 0-2 2v1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1v-1a2 2 0 0 0-2-2Zm-3.33-.689a3 3 0 0 0-1.359 1.358 1 1 0 0 1-.225-.169l-1.793-1.793A1 1 0 0 1 11 12V9a1 1 0 1 1 2 0v2.379a.5.5 0 0 0 .146.353l1.354 1.354a1 1 0 0 1 .17.225ZM19 17v-1q0-.414-.293-.707T18 15h-1q-.414 0-.707.293T16 16v1h3Z"/></svg>', $ce = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="ww9jgkze6__design-iconfont" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3 12a9 9 0 0 1 17.736-2.172h1.921l-2.828 2.829L17 9.828h1.676q-.491-1.543-1.726-2.778Q14.9 5 12 5 9.1 5 7.05 7.05 5 9.1 5 12q0 2.9 2.05 4.95 1.69 1.689 3.954 1.986c.548.072.996.512.996 1.064s-.444 1.006-.993.946A9.001 9.001 0 0 1 3 12Zm11.67 1.311a3 3 0 0 0-1.359 1.358 1 1 0 0 1-.225-.169l-1.793-1.793A1 1 0 0 1 11 12V9a1 1 0 1 1 2 0v2.379a.5.5 0 0 0 .146.353l1.354 1.354a1 1 0 0 1 .17.225ZM15 16v1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1v-1a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2Zm4 1v-1q0-.414-.293-.707T18 15h-1q-.414 0-.707.293T16 16v1h3Z"/></svg>', M2 = (e) => {
  let t;
  return typeof e == "object" ? t = e.uidt : t = e, [
    we.LongText,
    we.SingleLineText,
    we.Number,
    we.PhoneNumber,
    we.Email,
    we.Decimal,
    we.JSON,
    we.URL
  ].includes(t);
}, Oce = (e) => {
  var t;
  return e && e.rqd && !e.cdf && !e.ai && !((t = e.meta) != null && t.ag);
}, V7 = (e, t) => Oce(e) && (t[e.title] === void 0 || t[e.title] === null), Ace = [
  {
    label: "文本",
    name: we.SingleLineText,
    iconfont: "wenben"
  },
  {
    label: "长文本",
    name: we.LongText,
    iconfont: "zhangwenben"
  },
  {
    label: "整数",
    name: we.Number,
    iconfont: "zhengshu"
  },
  {
    label: "小数",
    name: we.Decimal,
    iconfont: "xiaoshu"
  },
  {
    label: "日期时间",
    name: we.DateTime,
    iconfont: "riji"
  },
  {
    label: "单选",
    name: we.SingleSelect,
    iconfont: "shanxuan"
  },
  {
    label: "多选",
    name: we.MultiSelect,
    iconfont: "duoxuan"
  },
  {
    label: "复选框",
    name: we.Checkbox,
    iconfont: "fuxuankuang"
  },
  // {
  //   label: '附件',
  //   name: UITypes.Attachment,
  //   // icon: iconMap.image
  // iconfont: 'bujian'
  // },
  {
    label: "链接",
    name: we.URL,
    iconfont: "lianxie"
  }
  // {
  //   label: 'JSON',
  //   name: UITypes.JSON,
  //   // icon: iconMap.json
  // iconfont: 'json-1'
  // }
  // {
  //   name: UITypes.Date,
  //   icon: iconMap.calendar,
  // },
], C4 = {
  [we.ID]: Ece,
  CreatedTime: Tce,
  LastModifiedTime: $ce,
  [we.SingleLineText]: mce,
  [we.LongText]: gce,
  [we.Number]: yce,
  [we.Decimal]: xce,
  [we.DateTime]: bce,
  [we.SingleSelect]: wce,
  [we.MultiSelect]: Sce,
  [we.Checkbox]: _ce,
  [we.URL]: Cce
}, u6 = (e) => !e && !Array.isArray(e) ? null : e.filter((t) => t.pk).map((t) => t.title).join("___"), Mi = (e, t) => !e || !t ? null : t.filter((n) => n.pk).map((n) => e == null ? void 0 : e[n.title]).join("___"), So = (e, t) => {
  const n = {}, r = t == null ? void 0 : t.filter((a) => a.pk);
  if (e && r && r.length)
    for (const a of r)
      a.title && (n[a.title] = e[a.title]);
  return n;
}, Ice = (e = []) => e.reduce(
  (n, r) => {
    if (!Gr(r) && (r != null && r.cdf)) {
      const a = r.cdf;
      n[r.title] = typeof a == "string" ? a.replace(/^'/, "").replace(/'$/, "") : a;
    }
    return n;
  },
  {}
);
async function R2({
  row: e,
  meta: t,
  throwError: n,
  undo: r = !1
}) {
  var i;
  const a = /* @__PURE__ */ new Set(), o = await ((i = t.columns) == null ? void 0 : i.reduce(async (s, l) => {
    const u = await s;
    return V7(l, e) && a.add(l.title), (!l.ai || r) && (e == null ? void 0 : e[l.title]) !== null && (u[l.title] = e == null ? void 0 : e[l.title]), u;
  }, Promise.resolve({})));
  if (n && a.size)
    throw new Error(`Missing required columns: ${[...a].join(", ")}`);
  return { missingRequiredColumns: a, insertObj: o };
}
const wl = (e, t) => {
  for (const [n, r] of Object.entries(t))
    if (Object.keys(e).every((a) => e[a] === r.row[a]))
      return parseInt(n);
  return -1;
};
function U7(e, t, n) {
  if (!n) return e;
  e != null && e.endsWith(n.split("/")[1]) || (e = `${e}.${n.split("/")[1]}`);
  let r = 1;
  for (; t.some((a) => (a == null ? void 0 : a.title) === e || (a == null ? void 0 : a.fileName) === e); )
    e = e.replace(/(.+?)(\.[^.]+)$/, `$1(${r++})$2`);
  return e;
}
function Ga(e) {
  if (!e) return {};
  try {
    return typeof e == "string" ? JSON.parse(e) : e;
  } catch {
    return {};
  }
}
async function Pn(e) {
  if (!e || !e.response) return e.message;
  let t, n = null;
  if (e.response.data instanceof Blob)
    try {
      const r = JSON.parse(await e.response.data.text());
      t = r.msg, n = r.errors;
    } catch {
      t = "Some internal error occurred";
    }
  else
    t = e.response.data.msg || e.response.data.message || "Some internal error occurred", n = e.response.data.errors;
  return Array.isArray(n) && n.length ? n.map((r) => (r.instancePath ? `${r.instancePath} - ` : "") + r.message).join(", ") : t || "Some error occurred";
}
const rd = {
  light: [
    "#cfdffe",
    "#d0f1fd",
    "#c2f5e8",
    "#ffdaf6",
    "#ffdce5",
    "#fee2d5",
    "#ffeab6",
    "#d1f7c4",
    "#ede2fe",
    "#eeeeee"
  ],
  dark: [
    "#2d7ff999",
    "#18bfff99",
    "#20d9d299",
    "#ff08c299",
    "#f82b6099",
    "#ff6f2c99",
    "#fcb40099",
    "#20c93399",
    "#8b46ff99",
    "#666"
  ]
};
var N2 = { exports: {} }, F2 = { exports: {} }, L2 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function n(a) {
    "@babel/helpers - typeof";
    return n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
      return typeof o;
    } : function(o) {
      return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, n(a);
  }
  function r(a) {
    var o = typeof a == "string" || a instanceof String;
    if (!o) {
      var i = n(a);
      throw a === null ? i = "null" : i === "object" && (i = a.constructor.name), new TypeError("Expected a string but received a ".concat(i));
    }
  }
  e.exports = t.default, e.exports.default = t.default;
})(L2, L2.exports);
var st = L2.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o) {
    return (0, n.default)(o), o = Date.parse(o), isNaN(o) ? null : new Date(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(F2, F2.exports);
var E4 = F2.exports, B2 = { exports: {} }, _d = {}, Zn = {};
Object.defineProperty(Zn, "__esModule", {
  value: !0
});
Zn.farsiLocales = Zn.englishLocales = Zn.dotDecimal = Zn.decimal = Zn.commaDecimal = Zn.bengaliLocales = Zn.arabicLocales = Zn.alphanumeric = Zn.alpha = void 0;
var po = Zn.alpha = {
  "en-US": /^[A-Z]+$/i,
  "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
  "bg-BG": /^[А-Я]+$/i,
  "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[A-ZÆØÅ]+$/i,
  "de-DE": /^[A-ZÄÖÜß]+$/i,
  "el-GR": /^[Α-ώ]+$/i,
  "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
  "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
  "fi-FI": /^[A-ZÅÄÖ]+$/i,
  "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
  "nb-NO": /^[A-ZÆØÅ]+$/i,
  "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[A-ZÆØÅ]+$/i,
  "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[А-ЯЁ]+$/i,
  "kk-KZ": /^[А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
  "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[A-ZÅÄÖ]+$/i,
  "th-TH": /^[ก-๐\s]+$/i,
  "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
  "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
  "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[א-ת]+$/,
  fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
  bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
  eo: /^[ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
  "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
  "si-LK": /^[\u0D80-\u0DFF]+$/
}, ho = Zn.alphanumeric = {
  "en-US": /^[0-9A-Z]+$/i,
  "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
  "bg-BG": /^[0-9А-Я]+$/i,
  "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[0-9A-ZÆØÅ]+$/i,
  "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
  "el-GR": /^[0-9Α-ω]+$/i,
  "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
  "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
  "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
  "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
  "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
  "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[0-9А-ЯЁ]+$/i,
  "kk-KZ": /^[0-9А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
  "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
  "th-TH": /^[ก-๙\s]+$/i,
  "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
  "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
  "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[0-9א-ת]+$/,
  fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
  bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
  eo: /^[0-9ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
  "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
  "si-LK": /^[0-9\u0D80-\u0DFF]+$/
}, qa = Zn.decimal = {
  "en-US": ".",
  ar: "٫"
}, c6 = Zn.englishLocales = ["AU", "GB", "HK", "IN", "NZ", "ZA", "ZM"];
for (var Qh, lx = 0; lx < c6.length; lx++)
  Qh = "en-".concat(c6[lx]), po[Qh] = po["en-US"], ho[Qh] = ho["en-US"], qa[Qh] = qa["en-US"];
var f6 = Zn.arabicLocales = ["AE", "BH", "DZ", "EG", "IQ", "JO", "KW", "LB", "LY", "MA", "QM", "QA", "SA", "SD", "SY", "TN", "YE"];
for (var Jh, ux = 0; ux < f6.length; ux++)
  Jh = "ar-".concat(f6[ux]), po[Jh] = po.ar, ho[Jh] = ho.ar, qa[Jh] = qa.ar;
var d6 = Zn.farsiLocales = ["IR", "AF"];
for (var cx, fx = 0; fx < d6.length; fx++)
  cx = "fa-".concat(d6[fx]), ho[cx] = ho.fa, qa[cx] = qa.ar;
var p6 = Zn.bengaliLocales = ["BD", "IN"];
for (var ev, dx = 0; dx < p6.length; dx++)
  ev = "bn-".concat(p6[dx]), po[ev] = po.bn, ho[ev] = ho.bn, qa[ev] = qa["en-US"];
var h6 = Zn.dotDecimal = ["ar-EG", "ar-LB", "ar-LY"], v6 = Zn.commaDecimal = ["bg-BG", "cs-CZ", "da-DK", "de-DE", "el-GR", "en-ZM", "eo", "es-ES", "fr-CA", "fr-FR", "id-ID", "it-IT", "ku-IQ", "hi-IN", "hu-HU", "nb-NO", "nn-NO", "nl-NL", "pl-PL", "pt-PT", "ru-RU", "kk-KZ", "si-LK", "sl-SI", "sr-RS@latin", "sr-RS", "sv-SE", "tr-TR", "uk-UA", "vi-VN"];
for (var px = 0; px < h6.length; px++)
  qa[h6[px]] = qa["en-US"];
for (var hx = 0; hx < v6.length; hx++)
  qa[v6[hx]] = ",";
po["fr-CA"] = po["fr-FR"];
ho["fr-CA"] = ho["fr-FR"];
po["pt-BR"] = po["pt-PT"];
ho["pt-BR"] = ho["pt-PT"];
qa["pt-BR"] = qa["pt-PT"];
po["pl-Pl"] = po["pl-PL"];
ho["pl-Pl"] = ho["pl-PL"];
qa["pl-Pl"] = qa["pl-PL"];
po["fa-AF"] = po.fa;
Object.defineProperty(_d, "__esModule", {
  value: !0
});
_d.default = kce;
_d.locales = void 0;
var Pce = Dce(st), z7 = Zn;
function Dce(e) {
  return e && e.__esModule ? e : { default: e };
}
function kce(e, t) {
  (0, Pce.default)(e), t = t || {};
  var n = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(t.locale ? z7.decimal[t.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
  if (e === "" || e === "." || e === "," || e === "-" || e === "+")
    return !1;
  var r = parseFloat(e.replace(",", "."));
  return n.test(e) && (!t.hasOwnProperty("min") || r >= t.min) && (!t.hasOwnProperty("max") || r <= t.max) && (!t.hasOwnProperty("lt") || r < t.lt) && (!t.hasOwnProperty("gt") || r > t.gt);
}
_d.locales = Object.keys(z7.decimal);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(_d);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o) {
    return (0, n.default)(o) ? parseFloat(o) : NaN;
  }
  e.exports = t.default, e.exports.default = t.default;
})(B2, B2.exports);
var W7 = B2.exports, H2 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o, i) {
    return (0, n.default)(o), parseInt(o, i || 10);
  }
  e.exports = t.default, e.exports.default = t.default;
})(H2, H2.exports);
var Mce = H2.exports, j2 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o, i) {
    return (0, n.default)(o), i ? o === "1" || /^true$/i.test(o) : o !== "0" && !/^false$/i.test(o) && o !== "";
  }
  e.exports = t.default, e.exports.default = t.default;
})(j2, j2.exports);
var Rce = j2.exports, V2 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o, i) {
    return (0, n.default)(o), o === i;
  }
  e.exports = t.default, e.exports.default = t.default;
})(V2, V2.exports);
var Nce = V2.exports, U2 = { exports: {} }, z2 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function n(a) {
    "@babel/helpers - typeof";
    return n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
      return typeof o;
    } : function(o) {
      return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, n(a);
  }
  function r(a) {
    return n(a) === "object" && a !== null ? typeof a.toString == "function" ? a = a.toString() : a = "[object Object]" : (a === null || typeof a > "u" || isNaN(a) && !a.length) && (a = ""), String(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(z2, z2.exports);
var G7 = z2.exports, W2 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 ? arguments[1] : void 0;
    for (var o in a)
      typeof r[o] > "u" && (r[o] = a[o]);
    return r;
  }
  e.exports = t.default, e.exports.default = t.default;
})(W2, W2.exports);
var Ja = W2.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var n = o(st), r = o(G7), a = o(Ja);
  function o(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var i = {
    ignoreCase: !1,
    minOccurrences: 1
  };
  function s(l, u, c) {
    return (0, n.default)(l), c = (0, a.default)(c, i), c.ignoreCase ? l.toLowerCase().split((0, r.default)(u).toLowerCase()).length > c.minOccurrences : l.split((0, r.default)(u)).length > c.minOccurrences;
  }
  e.exports = t.default, e.exports.default = t.default;
})(U2, U2.exports);
var Fce = U2.exports, G2 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o, i, s) {
    return (0, n.default)(o), Object.prototype.toString.call(i) !== "[object RegExp]" && (i = new RegExp(i, s)), !!o.match(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(G2, G2.exports);
var Lce = G2.exports, K2 = { exports: {} }, Y2 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i) {
    "@babel/helpers - typeof";
    return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
      return typeof s;
    } : function(s) {
      return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
    }, a(i);
  }
  function o(i, s) {
    (0, n.default)(i);
    var l, u;
    a(s) === "object" ? (l = s.min || 0, u = s.max) : (l = arguments[1], u = arguments[2]);
    var c = encodeURI(i).split(/%..|./).length - 1;
    return c >= l && (typeof u > "u" || c <= u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Y2, Y2.exports);
var K7 = Y2.exports, q2 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = a(st), r = a(Ja);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = {
    require_tld: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1,
    allow_numeric_tld: !1,
    allow_wildcard: !1,
    ignore_max_length: !1
  };
  function i(s, l) {
    (0, n.default)(s), l = (0, r.default)(l, o), l.allow_trailing_dot && s[s.length - 1] === "." && (s = s.substring(0, s.length - 1)), l.allow_wildcard === !0 && s.indexOf("*.") === 0 && (s = s.substring(2));
    var u = s.split("."), c = u[u.length - 1];
    return l.require_tld && (u.length < 2 || !l.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(c) || /\s/.test(c)) || !l.allow_numeric_tld && /^\d+$/.test(c) ? !1 : u.every(function(f) {
      return !(f.length > 63 && !l.ignore_max_length || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(f) || /[\uff01-\uff5e]/.test(f) || /^-|-$/.test(f) || !l.allow_underscores && /_/.test(f));
    });
  }
  e.exports = t.default, e.exports.default = t.default;
})(q2, q2.exports);
var T4 = q2.exports, X2 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var n = r(st);
  function r(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var a = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", o = "(".concat(a, "[.]){3}").concat(a), i = new RegExp("^".concat(o, "$")), s = "(?:[0-9a-fA-F]{1,4})", l = new RegExp("^(" + "(?:".concat(s, ":){7}(?:").concat(s, "|:)|") + "(?:".concat(s, ":){6}(?:").concat(o, "|:").concat(s, "|:)|") + "(?:".concat(s, ":){5}(?::").concat(o, "|(:").concat(s, "){1,2}|:)|") + "(?:".concat(s, ":){4}(?:(:").concat(s, "){0,1}:").concat(o, "|(:").concat(s, "){1,3}|:)|") + "(?:".concat(s, ":){3}(?:(:").concat(s, "){0,2}:").concat(o, "|(:").concat(s, "){1,4}|:)|") + "(?:".concat(s, ":){2}(?:(:").concat(s, "){0,3}:").concat(o, "|(:").concat(s, "){1,5}|:)|") + "(?:".concat(s, ":){1}(?:(:").concat(s, "){0,4}:").concat(o, "|(:").concat(s, "){1,6}|:)|") + "(?::((?::".concat(s, "){0,5}:").concat(o, "|(?::").concat(s, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
  function u(c) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return (0, n.default)(c), f = String(f), f ? f === "4" ? i.test(c) : f === "6" ? l.test(c) : !1 : u(c, 4) || u(c, 6);
  }
  e.exports = t.default, e.exports.default = t.default;
})(X2, X2.exports);
var N1 = X2.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = y;
  var n = s(st), r = s(K7), a = s(T4), o = s(N1), i = s(Ja);
  function s(x) {
    return x && x.__esModule ? x : { default: x };
  }
  var l = {
    allow_display_name: !1,
    allow_underscores: !1,
    require_display_name: !1,
    allow_utf8_local_part: !0,
    require_tld: !0,
    blacklisted_chars: "",
    ignore_max_length: !1,
    host_blacklist: [],
    host_whitelist: []
  }, u = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i, c = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, f = /^[a-z\d]+$/, d = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, p = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, v = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, h = 254;
  function m(x) {
    var g = x.replace(/^"(.+)"$/, "$1");
    if (!g.trim())
      return !1;
    var S = /[\.";<>]/.test(g);
    if (S) {
      if (g === x)
        return !1;
      var w = g.split('"').length === g.split('\\"').length;
      if (!w)
        return !1;
    }
    return !0;
  }
  function y(x, g) {
    if ((0, n.default)(x), g = (0, i.default)(g, l), g.require_display_name || g.allow_display_name) {
      var S = x.match(u);
      if (S) {
        var w = S[1];
        if (x = x.replace(w, "").replace(/(^<|>$)/g, ""), w.endsWith(" ") && (w = w.slice(0, -1)), !m(w))
          return !1;
      } else if (g.require_display_name)
        return !1;
    }
    if (!g.ignore_max_length && x.length > h)
      return !1;
    var _ = x.split("@"), b = _.pop(), E = b.toLowerCase();
    if (g.host_blacklist.includes(E) || g.host_whitelist.length > 0 && !g.host_whitelist.includes(E))
      return !1;
    var C = _.join("@");
    if (g.domain_specific_validation && (E === "gmail.com" || E === "googlemail.com")) {
      C = C.toLowerCase();
      var T = C.split("+")[0];
      if (!(0, r.default)(T.replace(/\./g, ""), {
        min: 6,
        max: 30
      }))
        return !1;
      for (var O = T.split("."), I = 0; I < O.length; I++)
        if (!f.test(O[I]))
          return !1;
    }
    if (g.ignore_max_length === !1 && (!(0, r.default)(C, {
      max: 64
    }) || !(0, r.default)(b, {
      max: 254
    })))
      return !1;
    if (!(0, a.default)(b, {
      require_tld: g.require_tld,
      ignore_max_length: g.ignore_max_length,
      allow_underscores: g.allow_underscores
    })) {
      if (!g.allow_ip_domain)
        return !1;
      if (!(0, o.default)(b)) {
        if (!b.startsWith("[") || !b.endsWith("]"))
          return !1;
        var k = b.slice(1, -1);
        if (k.length === 0 || !(0, o.default)(k))
          return !1;
      }
    }
    if (C[0] === '"')
      return C = C.slice(1, C.length - 1), g.allow_utf8_local_part ? v.test(C) : d.test(C);
    for (var B = g.allow_utf8_local_part ? p : c, P = C.split("."), N = 0; N < P.length; N++)
      if (!B.test(P[N]))
        return !1;
    return !(g.blacklisted_chars && C.search(new RegExp("[".concat(g.blacklisted_chars, "]+"), "g")) !== -1);
  }
  e.exports = t.default, e.exports.default = t.default;
})(K2, K2.exports);
var Y7 = K2.exports, Z2 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = y;
  var n = i(st), r = i(T4), a = i(N1), o = i(Ja);
  function i(x) {
    return x && x.__esModule ? x : { default: x };
  }
  function s(x, g) {
    return d(x) || f(x, g) || u(x, g) || l();
  }
  function l() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function u(x, g) {
    if (x) {
      if (typeof x == "string") return c(x, g);
      var S = Object.prototype.toString.call(x).slice(8, -1);
      if (S === "Object" && x.constructor && (S = x.constructor.name), S === "Map" || S === "Set") return Array.from(x);
      if (S === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S)) return c(x, g);
    }
  }
  function c(x, g) {
    (g == null || g > x.length) && (g = x.length);
    for (var S = 0, w = new Array(g); S < g; S++) w[S] = x[S];
    return w;
  }
  function f(x, g) {
    var S = x == null ? null : typeof Symbol < "u" && x[Symbol.iterator] || x["@@iterator"];
    if (S != null) {
      var w, _, b, E, C = [], T = !0, O = !1;
      try {
        if (b = (S = S.call(x)).next, g !== 0) for (; !(T = (w = b.call(S)).done) && (C.push(w.value), C.length !== g); T = !0) ;
      } catch (I) {
        O = !0, _ = I;
      } finally {
        try {
          if (!T && S.return != null && (E = S.return(), Object(E) !== E)) return;
        } finally {
          if (O) throw _;
        }
      }
      return C;
    }
  }
  function d(x) {
    if (Array.isArray(x)) return x;
  }
  var p = {
    protocols: ["http", "https", "ftp"],
    require_tld: !0,
    require_protocol: !1,
    require_host: !0,
    require_port: !1,
    require_valid_protocol: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1,
    allow_protocol_relative_urls: !1,
    allow_fragments: !0,
    allow_query_components: !0,
    validate_length: !0
  }, v = /^\[([^\]]+)\](?::([0-9]+))?$/;
  function h(x) {
    return Object.prototype.toString.call(x) === "[object RegExp]";
  }
  function m(x, g) {
    for (var S = 0; S < g.length; S++) {
      var w = g[S];
      if (x === w || h(w) && w.test(x))
        return !0;
    }
    return !1;
  }
  function y(x, g) {
    if ((0, n.default)(x), !x || /[\s<>]/.test(x) || x.indexOf("mailto:") === 0 || (g = (0, o.default)(g, p), g.validate_length && x.length >= 2083) || !g.allow_fragments && x.includes("#") || !g.allow_query_components && (x.includes("?") || x.includes("&")))
      return !1;
    var S, w, _, b, E, C, T, O;
    if (T = x.split("#"), x = T.shift(), T = x.split("?"), x = T.shift(), T = x.split("://"), T.length > 1) {
      if (S = T.shift().toLowerCase(), g.require_valid_protocol && g.protocols.indexOf(S) === -1)
        return !1;
    } else {
      if (g.require_protocol)
        return !1;
      if (x.slice(0, 2) === "//") {
        if (!g.allow_protocol_relative_urls)
          return !1;
        T[0] = x.slice(2);
      }
    }
    if (x = T.join("://"), x === "")
      return !1;
    if (T = x.split("/"), x = T.shift(), x === "" && !g.require_host)
      return !0;
    if (T = x.split("@"), T.length > 1) {
      if (g.disallow_auth || T[0] === "" || (w = T.shift(), w.indexOf(":") >= 0 && w.split(":").length > 2))
        return !1;
      var I = w.split(":"), k = s(I, 2), B = k[0], P = k[1];
      if (B === "" && P === "")
        return !1;
    }
    b = T.join("@"), C = null, O = null;
    var N = b.match(v);
    if (N ? (_ = "", O = N[1], C = N[2] || null) : (T = b.split(":"), _ = T.shift(), T.length && (C = T.join(":"))), C !== null && C.length > 0) {
      if (E = parseInt(C, 10), !/^[0-9]+$/.test(C) || E <= 0 || E > 65535)
        return !1;
    } else if (g.require_port)
      return !1;
    return g.host_whitelist ? m(_, g.host_whitelist) : _ === "" && !g.require_host ? !0 : !(!(0, a.default)(_) && !(0, r.default)(_, g) && (!O || !(0, a.default)(O, 6)) || (_ = _ || O, g.host_blacklist && m(_, g.host_blacklist)));
  }
  e.exports = t.default, e.exports.default = t.default;
})(Z2, Z2.exports);
var Bce = Z2.exports, Q2 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var n = r(st);
  function r(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var a = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/, o = /^([0-9a-fA-F]){12}$/, i = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/, s = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){6}([0-9a-fA-F]{2})$/, l = /^([0-9a-fA-F]){16}$/, u = /^([0-9a-fA-F]{4}\.){3}([0-9a-fA-F]{4})$/;
  function c(f, d) {
    return (0, n.default)(f), d != null && d.eui && (d.eui = String(d.eui)), d != null && d.no_colons || d != null && d.no_separators ? d.eui === "48" ? o.test(f) : d.eui === "64" ? l.test(f) : o.test(f) || l.test(f) : (d == null ? void 0 : d.eui) === "48" ? a.test(f) || i.test(f) : (d == null ? void 0 : d.eui) === "64" ? s.test(f) || u.test(f) : c(f, {
      eui: "48"
    }) || c(f, {
      eui: "64"
    });
  }
  e.exports = t.default, e.exports.default = t.default;
})(Q2, Q2.exports);
var Hce = Q2.exports, J2 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var n = a(st), r = a(N1);
  function a(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var o = /^\d{1,3}$/, i = 32, s = 128;
  function l(u) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (0, n.default)(u);
    var f = u.split("/");
    if (f.length !== 2 || !o.test(f[1]) || f[1].length > 1 && f[1].startsWith("0"))
      return !1;
    var d = (0, r.default)(f[0], c);
    if (!d)
      return !1;
    var p = null;
    switch (String(c)) {
      case "4":
        p = i;
        break;
      case "6":
        p = s;
        break;
      default:
        p = (0, r.default)(f[0], "6") ? s : i;
    }
    return f[1] <= p && f[1] >= 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(J2, J2.exports);
var jce = J2.exports, ew = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = v;
  var n = r(Ja);
  function r(h) {
    return h && h.__esModule ? h : { default: h };
  }
  function a(h, m) {
    return s(h) || i(h, m) || u(h, m) || o();
  }
  function o() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function i(h, m) {
    var y = h == null ? null : typeof Symbol < "u" && h[Symbol.iterator] || h["@@iterator"];
    if (y != null) {
      var x, g, S, w, _ = [], b = !0, E = !1;
      try {
        if (S = (y = y.call(h)).next, m !== 0) for (; !(b = (x = S.call(y)).done) && (_.push(x.value), _.length !== m); b = !0) ;
      } catch (C) {
        E = !0, g = C;
      } finally {
        try {
          if (!b && y.return != null && (w = y.return(), Object(w) !== w)) return;
        } finally {
          if (E) throw g;
        }
      }
      return _;
    }
  }
  function s(h) {
    if (Array.isArray(h)) return h;
  }
  function l(h, m) {
    var y = typeof Symbol < "u" && h[Symbol.iterator] || h["@@iterator"];
    if (!y) {
      if (Array.isArray(h) || (y = u(h)) || m) {
        y && (h = y);
        var x = 0, g = function() {
        };
        return { s: g, n: function() {
          return x >= h.length ? { done: !0 } : { done: !1, value: h[x++] };
        }, e: function(E) {
          throw E;
        }, f: g };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var S = !0, w = !1, _;
    return { s: function() {
      y = y.call(h);
    }, n: function() {
      var E = y.next();
      return S = E.done, E;
    }, e: function(E) {
      w = !0, _ = E;
    }, f: function() {
      try {
        !S && y.return != null && y.return();
      } finally {
        if (w) throw _;
      }
    } };
  }
  function u(h, m) {
    if (h) {
      if (typeof h == "string") return c(h, m);
      var y = Object.prototype.toString.call(h).slice(8, -1);
      if (y === "Object" && h.constructor && (y = h.constructor.name), y === "Map" || y === "Set") return Array.from(h);
      if (y === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(y)) return c(h, m);
    }
  }
  function c(h, m) {
    (m == null || m > h.length) && (m = h.length);
    for (var y = 0, x = new Array(m); y < m; y++) x[y] = h[y];
    return x;
  }
  var f = {
    format: "YYYY/MM/DD",
    delimiters: ["/", "-"],
    strictMode: !1
  };
  function d(h) {
    return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(h);
  }
  function p(h, m) {
    for (var y = [], x = Math.min(h.length, m.length), g = 0; g < x; g++)
      y.push([h[g], m[g]]);
    return y;
  }
  function v(h, m) {
    if (typeof m == "string" ? m = (0, n.default)({
      format: m
    }, f) : m = (0, n.default)(m, f), typeof h == "string" && d(m.format)) {
      var y = m.delimiters.find(function(P) {
        return m.format.indexOf(P) !== -1;
      }), x = m.strictMode ? y : m.delimiters.find(function(P) {
        return h.indexOf(P) !== -1;
      }), g = p(h.split(x), m.format.toLowerCase().split(y)), S = {}, w = l(g), _;
      try {
        for (w.s(); !(_ = w.n()).done; ) {
          var b = a(_.value, 2), E = b[0], C = b[1];
          if (E.length !== C.length)
            return !1;
          S[C.charAt(0)] = E;
        }
      } catch (P) {
        w.e(P);
      } finally {
        w.f();
      }
      var T = S.y;
      if (T.startsWith("-"))
        return !1;
      if (S.y.length === 2) {
        var O = parseInt(S.y, 10);
        if (isNaN(O))
          return !1;
        var I = (/* @__PURE__ */ new Date()).getFullYear() % 100;
        O < I ? T = "20".concat(S.y) : T = "19".concat(S.y);
      }
      var k = S.m;
      S.m.length === 1 && (k = "0".concat(S.m));
      var B = S.d;
      return S.d.length === 1 && (B = "0".concat(S.d)), new Date("".concat(T, "-").concat(k, "-").concat(B, "T00:00:00.000Z")).getUTCDate() === +S.d;
    }
    return m.strictMode ? !1 : Object.prototype.toString.call(h) === "[object Date]" && isFinite(h);
  }
  e.exports = t.default, e.exports.default = t.default;
})(ew, ew.exports);
var q7 = ew.exports, tw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = r(Ja);
  function r(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var a = {
    hourFormat: "hour24",
    mode: "default"
  }, o = {
    hour24: {
      default: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
      withSeconds: /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/
    },
    hour12: {
      default: /^(0?[1-9]|1[0-2]):([0-5][0-9]) (A|P)M$/,
      withSeconds: /^(0?[1-9]|1[0-2]):([0-5][0-9]):([0-5][0-9]) (A|P)M$/
    }
  };
  function i(s, l) {
    return l = (0, n.default)(l, a), typeof s != "string" ? !1 : o[l.hourFormat][l.mode].test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(tw, tw.exports);
var Vce = tw.exports, nw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var n = r(st);
  function r(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var a = {
    loose: !1
  }, o = ["true", "false", "1", "0"], i = [].concat(o, ["yes", "no"]);
  function s(l) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : a;
    return (0, n.default)(l), u.loose ? i.includes(l.toLowerCase()) : o.includes(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(nw, nw.exports);
var Uce = nw.exports, rw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = x;
  var n = r(st);
  function r(g) {
    return g && g.__esModule ? g : { default: g };
  }
  var a = "([A-Za-z]{3}(-[A-Za-z]{3}){0,2})", o = "(([a-zA-Z]{2,3}(-".concat(a, ")?)|([a-zA-Z]{5,8}))"), i = "([A-Za-z]{4})", s = "([A-Za-z]{2}|\\d{3})", l = "([A-Za-z0-9]{5,8}|(\\d[A-Z-a-z0-9]{3}))", u = "(\\d|[A-W]|[Y-Z]|[a-w]|[y-z])", c = "(".concat(u, "(-[A-Za-z0-9]{2,8})+)"), f = "(x(-[A-Za-z0-9]{1,8})+)", d = "((en-GB-oed)|(i-ami)|(i-bnn)|(i-default)|(i-enochian)|(i-hak)|(i-klingon)|(i-lux)|(i-mingo)|(i-navajo)|(i-pwn)|(i-tao)|(i-tay)|(i-tsu)|(sgn-BE-FR)|(sgn-BE-NL)|(sgn-CH-DE))", p = "((art-lojban)|(cel-gaulish)|(no-bok)|(no-nyn)|(zh-guoyu)|(zh-hakka)|(zh-min)|(zh-min-nan)|(zh-xiang))", v = "(".concat(d, "|").concat(p, ")"), h = "(-|_)", m = "".concat(o, "(").concat(h).concat(i, ")?(").concat(h).concat(s, ")?(").concat(h).concat(l, ")*(").concat(h).concat(c, ")*(").concat(h).concat(f, ")?"), y = new RegExp("(^".concat(f, "$)|(^").concat(v, "$)|(^").concat(m, "$)"));
  function x(g) {
    return (0, n.default)(g), y.test(g);
  }
  e.exports = t.default, e.exports.default = t.default;
})(rw, rw.exports);
var zce = rw.exports, aw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /^(?!(1[3-9])|(20)|(3[3-9])|(4[0-9])|(5[0-9])|(60)|(7[3-9])|(8[1-9])|(9[0-2])|(9[3-9]))[0-9]{9}$/;
  function o(i) {
    if ((0, n.default)(i), !a.test(i)) return !1;
    for (var s = 0, l = 0; l < i.length; l++)
      l % 3 === 0 ? s += i[l] * 3 : l % 3 === 1 ? s += i[l] * 7 : s += i[l] * 1;
    return s % 10 === 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(aw, aw.exports);
var Wce = aw.exports, Zp = {};
Object.defineProperty(Zp, "__esModule", {
  value: !0
});
Zp.default = Yce;
Zp.locales = void 0;
var Gce = Kce(st), ow = Zn;
function Kce(e) {
  return e && e.__esModule ? e : { default: e };
}
function Yce(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  (0, Gce.default)(e);
  var r = e, a = n.ignore;
  if (a)
    if (a instanceof RegExp)
      r = r.replace(a, "");
    else if (typeof a == "string")
      r = r.replace(new RegExp("[".concat(a.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
    else
      throw new Error("ignore should be instance of a String or RegExp");
  if (t in ow.alpha)
    return ow.alpha[t].test(r);
  throw new Error("Invalid locale '".concat(t, "'"));
}
Zp.locales = Object.keys(ow.alpha);
var Qp = {};
Object.defineProperty(Qp, "__esModule", {
  value: !0
});
Qp.default = Zce;
Qp.locales = void 0;
var qce = Xce(st), iw = Zn;
function Xce(e) {
  return e && e.__esModule ? e : { default: e };
}
function Zce(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  (0, qce.default)(e);
  var r = e, a = n.ignore;
  if (a)
    if (a instanceof RegExp)
      r = r.replace(a, "");
    else if (typeof a == "string")
      r = r.replace(new RegExp("[".concat(a.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
    else
      throw new Error("ignore should be instance of a String or RegExp");
  if (t in iw.alphanumeric)
    return iw.alphanumeric[t].test(r);
  throw new Error("Invalid locale '".concat(t, "'"));
}
Qp.locales = Object.keys(iw.alphanumeric);
var sw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = a(st), r = Zn;
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = /^[0-9]+$/;
  function i(s, l) {
    return (0, n.default)(s), l && l.no_symbols ? o.test(s) : new RegExp("^[+-]?([0-9]*[".concat((l || {}).locale ? r.decimal[l.locale] : ".", "])?[0-9]+$")).test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(sw, sw.exports);
var Qce = sw.exports, lw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = {
    AM: /^[A-Z]{2}\d{7}$/,
    // ARMENIA
    AR: /^[A-Z]{3}\d{6}$/,
    // ARGENTINA
    AT: /^[A-Z]\d{7}$/,
    // AUSTRIA
    AU: /^[A-Z]\d{7}$/,
    // AUSTRALIA
    AZ: /^[A-Z]{1}\d{8}$/,
    // AZERBAIJAN
    BE: /^[A-Z]{2}\d{6}$/,
    // BELGIUM
    BG: /^\d{9}$/,
    // BULGARIA
    BR: /^[A-Z]{2}\d{6}$/,
    // BRAZIL
    BY: /^[A-Z]{2}\d{7}$/,
    // BELARUS
    CA: /^[A-Z]{2}\d{6}$/,
    // CANADA
    CH: /^[A-Z]\d{7}$/,
    // SWITZERLAND
    CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
    // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
    CY: /^[A-Z](\d{6}|\d{8})$/,
    // CYPRUS
    CZ: /^\d{8}$/,
    // CZECH REPUBLIC
    DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
    // GERMANY
    DK: /^\d{9}$/,
    // DENMARK
    DZ: /^\d{9}$/,
    // ALGERIA
    EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
    // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
    ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
    // SPAIN
    FI: /^[A-Z]{2}\d{7}$/,
    // FINLAND
    FR: /^\d{2}[A-Z]{2}\d{5}$/,
    // FRANCE
    GB: /^\d{9}$/,
    // UNITED KINGDOM
    GR: /^[A-Z]{2}\d{7}$/,
    // GREECE
    HR: /^\d{9}$/,
    // CROATIA
    HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
    // HUNGARY
    IE: /^[A-Z0-9]{2}\d{7}$/,
    // IRELAND
    IN: /^[A-Z]{1}-?\d{7}$/,
    // INDIA
    ID: /^[A-C]\d{7}$/,
    // INDONESIA
    IR: /^[A-Z]\d{8}$/,
    // IRAN
    IS: /^(A)\d{7}$/,
    // ICELAND
    IT: /^[A-Z0-9]{2}\d{7}$/,
    // ITALY
    JM: /^[Aa]\d{7}$/,
    // JAMAICA
    JP: /^[A-Z]{2}\d{7}$/,
    // JAPAN
    KR: /^[MS]\d{8}$/,
    // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
    KZ: /^[a-zA-Z]\d{7}$/,
    // KAZAKHSTAN
    LI: /^[a-zA-Z]\d{5}$/,
    // LIECHTENSTEIN
    LT: /^[A-Z0-9]{8}$/,
    // LITHUANIA
    LU: /^[A-Z0-9]{8}$/,
    // LUXEMBURG
    LV: /^[A-Z0-9]{2}\d{7}$/,
    // LATVIA
    LY: /^[A-Z0-9]{8}$/,
    // LIBYA
    MT: /^\d{7}$/,
    // MALTA
    MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
    // MOZAMBIQUE
    MY: /^[AHK]\d{8}$/,
    // MALAYSIA
    MX: /^\d{10,11}$/,
    // MEXICO
    NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
    // NETHERLANDS
    NZ: /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])\d{6}$/,
    // NEW ZEALAND
    PH: /^([A-Z](\d{6}|\d{7}[A-Z]))|([A-Z]{2}(\d{6}|\d{7}))$/,
    // PHILIPPINES
    PK: /^[A-Z]{2}\d{7}$/,
    // PAKISTAN
    PL: /^[A-Z]{2}\d{7}$/,
    // POLAND
    PT: /^[A-Z]\d{6}$/,
    // PORTUGAL
    RO: /^\d{8,9}$/,
    // ROMANIA
    RU: /^\d{9}$/,
    // RUSSIAN FEDERATION
    SE: /^\d{8}$/,
    // SWEDEN
    SL: /^(P)[A-Z]\d{7}$/,
    // SLOVENIA
    SK: /^[0-9A-Z]\d{7}$/,
    // SLOVAKIA
    TH: /^[A-Z]{1,2}\d{6,7}$/,
    // THAILAND
    TR: /^[A-Z]\d{8}$/,
    // TURKEY
    UA: /^[A-Z]{2}\d{6}$/,
    // UKRAINE
    US: /^\d{9}$/,
    // UNITED STATES
    ZA: /^[TAMD]\d{8}$/
    // SOUTH AFRICA
  };
  function o(i, s) {
    (0, n.default)(i);
    var l = i.replace(/\s/g, "").toUpperCase();
    return s.toUpperCase() in a && a[s].test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(lw, lw.exports);
var Jce = lw.exports, uw = { exports: {} }, cw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = r(st);
  function r(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var a = /^(?:[-+]?(?:0|[1-9][0-9]*))$/, o = /^[-+]?[0-9]+$/;
  function i(s, l) {
    (0, n.default)(s), l = l || {};
    var u = l.allow_leading_zeroes === !1 ? a : o, c = !l.hasOwnProperty("min") || s >= l.min, f = !l.hasOwnProperty("max") || s <= l.max, d = !l.hasOwnProperty("lt") || s < l.lt, p = !l.hasOwnProperty("gt") || s > l.gt;
    return u.test(s) && c && f && d && p;
  }
  e.exports = t.default, e.exports.default = t.default;
})(cw, cw.exports);
var $4 = cw.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r($4);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o) {
    return (0, n.default)(o, {
      allow_leading_zeroes: !1,
      min: 0,
      max: 65535
    });
  }
  e.exports = t.default, e.exports.default = t.default;
})(uw, uw.exports);
var efe = uw.exports, fw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o) {
    return (0, n.default)(o), o === o.toLowerCase();
  }
  e.exports = t.default, e.exports.default = t.default;
})(fw, fw.exports);
var tfe = fw.exports, dw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o) {
    return (0, n.default)(o), o === o.toUpperCase();
  }
  e.exports = t.default, e.exports.default = t.default;
})(dw, dw.exports);
var nfe = dw.exports, pw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = r(st);
  function r(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var a = /^[0-9]{15}$/, o = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
  function i(s, l) {
    (0, n.default)(s), l = l || {};
    var u = a;
    if (l.allow_hyphens && (u = o), !u.test(s))
      return !1;
    s = s.replace(/-/g, "");
    for (var c = 0, f = 2, d = 14, p = 0; p < d; p++) {
      var v = s.substring(d - p - 1, d - p), h = parseInt(v, 10) * f;
      h >= 10 ? c += h % 10 + 1 : c += h, f === 1 ? f += 1 : f -= 1;
    }
    var m = (10 - c % 10) % 10;
    return m === parseInt(s.substring(14, 15), 10);
  }
  e.exports = t.default, e.exports.default = t.default;
})(pw, pw.exports);
var rfe = pw.exports, hw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /^[\x00-\x7F]+$/;
  function o(i) {
    return (0, n.default)(i), a.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(hw, hw.exports);
var afe = hw.exports, Cd = {};
Object.defineProperty(Cd, "__esModule", {
  value: !0
});
Cd.default = lfe;
Cd.fullWidth = void 0;
var ofe = ife(st);
function ife(e) {
  return e && e.__esModule ? e : { default: e };
}
var sfe = Cd.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
function lfe(e) {
  return (0, ofe.default)(e), sfe.test(e);
}
var Ed = {};
Object.defineProperty(Ed, "__esModule", {
  value: !0
});
Ed.default = dfe;
Ed.halfWidth = void 0;
var ufe = cfe(st);
function cfe(e) {
  return e && e.__esModule ? e : { default: e };
}
var ffe = Ed.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
function dfe(e) {
  return (0, ufe.default)(e), ffe.test(e);
}
var vw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = o(st), r = Cd, a = Ed;
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function i(s) {
    return (0, n.default)(s), r.fullWidth.test(s) && a.halfWidth.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(vw, vw.exports);
var pfe = vw.exports, mw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /[^\x00-\x7F]/;
  function o(i) {
    return (0, n.default)(i), a.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(mw, mw.exports);
var hfe = mw.exports, gw = { exports: {} }, yw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r, a) {
    var o = r.join("");
    return new RegExp(o, a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(yw, yw.exports);
var vfe = yw.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = a(st), r = a(vfe);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = (0, r.default)(["^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)", "(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))", "?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$"], "i");
  function i(s) {
    return (0, n.default)(s), o.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(gw, gw.exports);
var mfe = gw.exports, xw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
  function o(i) {
    return (0, n.default)(i), a.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(xw, xw.exports);
var gfe = xw.exports, bw = { exports: {} }, ww = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = function(a, o) {
    return a.some(function(i) {
      return o === i;
    });
  };
  t.default = n, e.exports = t.default, e.exports.default = t.default;
})(ww, ww.exports);
var yfe = ww.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var n = i(Ja), r = i(st), a = i(yfe), o = Zn;
  function i(f) {
    return f && f.__esModule ? f : { default: f };
  }
  function s(f) {
    var d = new RegExp("^[-+]?([0-9]+)?(\\".concat(o.decimal[f.locale], "[0-9]{").concat(f.decimal_digits, "})").concat(f.force_decimal ? "" : "?", "$"));
    return d;
  }
  var l = {
    force_decimal: !1,
    decimal_digits: "1,",
    locale: "en-US"
  }, u = ["", "-", "+"];
  function c(f, d) {
    if ((0, r.default)(f), d = (0, n.default)(d, l), d.locale in o.decimal)
      return !(0, a.default)(u, f.replace(/ /g, "")) && s(d).test(f);
    throw new Error("Invalid locale '".concat(d.locale, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(bw, bw.exports);
var xfe = bw.exports, Sw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /^(0x|0h)?[0-9A-F]+$/i;
  function o(i) {
    return (0, n.default)(i), a.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Sw, Sw.exports);
var X7 = Sw.exports, _w = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /^(0o)?[0-7]+$/i;
  function o(i) {
    return (0, n.default)(i), a.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(_w, _w.exports);
var bfe = _w.exports, Cw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = a(st), r = a(W7);
  function a(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i, s) {
    return (0, n.default)(i), (0, r.default)(i) % parseInt(s, 10) === 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Cw, Cw.exports);
var wfe = Cw.exports, Ew = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
  function o(i) {
    return (0, n.default)(i), a.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Ew, Ew.exports);
var Sfe = Ew.exports, Tw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var n = r(st);
  function r(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var a = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/, o = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, i = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)$/, s = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
  function l(u) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    return (0, n.default)(u), c ? a.test(u) || o.test(u) || i.test(u) || s.test(u) : a.test(u) || o.test(u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Tw, Tw.exports);
var _fe = Tw.exports, $w = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = r(st);
  function r(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var a = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i, o = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
  function i(s) {
    (0, n.default)(s);
    var l = s.replace(/\s+/g, " ").replace(/\s?(hsla?\(|\)|,)\s?/ig, "$1");
    return l.indexOf(",") !== -1 ? a.test(l) : o.test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})($w, $w.exports);
var Cfe = $w.exports, Ow = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
  function o(i) {
    return (0, n.default)(i), a.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Ow, Ow.exports);
var Efe = Ow.exports, Jp = {};
Object.defineProperty(Jp, "__esModule", {
  value: !0
});
Jp.default = Pfe;
Jp.locales = void 0;
var Tfe = $fe(st);
function $fe(e) {
  return e && e.__esModule ? e : { default: e };
}
var Vm = {
  AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
  AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
  AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
  AT: /^(AT[0-9]{2})\d{16}$/,
  AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  BA: /^(BA[0-9]{2})\d{16}$/,
  BE: /^(BE[0-9]{2})\d{12}$/,
  BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
  BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
  BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
  BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
  CR: /^(CR[0-9]{2})\d{18}$/,
  CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
  CZ: /^(CZ[0-9]{2})\d{20}$/,
  DE: /^(DE[0-9]{2})\d{18}$/,
  DK: /^(DK[0-9]{2})\d{14}$/,
  DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
  DZ: /^(DZ\d{24})$/,
  EE: /^(EE[0-9]{2})\d{16}$/,
  EG: /^(EG[0-9]{2})\d{25}$/,
  ES: /^(ES[0-9]{2})\d{20}$/,
  FI: /^(FI[0-9]{2})\d{14}$/,
  FO: /^(FO[0-9]{2})\d{14}$/,
  FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
  GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
  GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
  GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
  GL: /^(GL[0-9]{2})\d{14}$/,
  GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
  GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
  HR: /^(HR[0-9]{2})\d{17}$/,
  HU: /^(HU[0-9]{2})\d{24}$/,
  IE: /^(IE[0-9]{2})[A-Z0-9]{4}\d{14}$/,
  IL: /^(IL[0-9]{2})\d{19}$/,
  IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
  IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
  IS: /^(IS[0-9]{2})\d{22}$/,
  IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
  JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
  KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
  KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
  LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
  LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
  LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
  LT: /^(LT[0-9]{2})\d{16}$/,
  LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
  LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
  MA: /^(MA[0-9]{26})$/,
  MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
  MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
  ME: /^(ME[0-9]{2})\d{18}$/,
  MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
  MR: /^(MR[0-9]{2})\d{23}$/,
  MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
  MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
  MZ: /^(MZ[0-9]{2})\d{21}$/,
  NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
  NO: /^(NO[0-9]{2})\d{11}$/,
  PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
  PL: /^(PL[0-9]{2})\d{24}$/,
  PS: /^(PS[0-9]{2})[A-Z0-9]{4}\d{21}$/,
  PT: /^(PT[0-9]{2})\d{21}$/,
  QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
  RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
  RS: /^(RS[0-9]{2})\d{18}$/,
  SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
  SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
  SE: /^(SE[0-9]{2})\d{20}$/,
  SI: /^(SI[0-9]{2})\d{15}$/,
  SK: /^(SK[0-9]{2})\d{20}$/,
  SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
  SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  TL: /^(TL[0-9]{2})\d{19}$/,
  TN: /^(TN[0-9]{2})\d{20}$/,
  TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
  UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
  VA: /^(VA[0-9]{2})\d{18}$/,
  VG: /^(VG[0-9]{2})[A-Z0-9]{4}\d{16}$/,
  XK: /^(XK[0-9]{2})\d{16}$/
};
function Ofe(e) {
  var t = e.filter(function(n) {
    return !(n in Vm);
  });
  return !(t.length > 0);
}
function Afe(e, t) {
  var n = e.replace(/[\s\-]+/gi, "").toUpperCase(), r = n.slice(0, 2).toUpperCase(), a = r in Vm;
  if (t.whitelist) {
    if (!Ofe(t.whitelist))
      return !1;
    var o = t.whitelist.includes(r);
    if (!o)
      return !1;
  }
  if (t.blacklist) {
    var i = t.blacklist.includes(r);
    if (i)
      return !1;
  }
  return a && Vm[r].test(n);
}
function Ife(e) {
  var t = e.replace(/[^A-Z0-9]+/gi, "").toUpperCase(), n = t.slice(4) + t.slice(0, 4), r = n.replace(/[A-Z]/g, function(o) {
    return o.charCodeAt(0) - 55;
  }), a = r.match(/\d{1,7}/g).reduce(function(o, i) {
    return Number(o + i) % 97;
  }, "");
  return a === 1;
}
function Pfe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return (0, Tfe.default)(e), Afe(e, t) && Ife(e);
}
Jp.locales = Object.keys(Vm);
var Aw = { exports: {} }, Td = {};
Object.defineProperty(Td, "__esModule", {
  value: !0
});
Td.CountryCodes = void 0;
Td.default = Mfe;
var Dfe = kfe(st);
function kfe(e) {
  return e && e.__esModule ? e : { default: e };
}
var Z7 = /* @__PURE__ */ new Set(["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW"]);
function Mfe(e) {
  return (0, Dfe.default)(e), Z7.has(e.toUpperCase());
}
Td.CountryCodes = Z7;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = a(st), r = Td;
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
  function i(s) {
    (0, n.default)(s);
    var l = s.slice(4, 6).toUpperCase();
    return !r.CountryCodes.has(l) && l !== "XK" ? !1 : o.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Aw, Aw.exports);
var Rfe = Aw.exports, Iw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /^[a-f0-9]{32}$/;
  function o(i) {
    return (0, n.default)(i), a.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Iw, Iw.exports);
var Nfe = Iw.exports, Pw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = {
    md5: 32,
    md4: 32,
    sha1: 40,
    sha256: 64,
    sha384: 96,
    sha512: 128,
    ripemd128: 32,
    ripemd160: 40,
    tiger128: 32,
    tiger160: 40,
    tiger192: 48,
    crc32: 8,
    crc32b: 8
  };
  function o(i, s) {
    (0, n.default)(i);
    var l = new RegExp("^[a-fA-F0-9]{".concat(a[s], "}$"));
    return l.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Pw, Pw.exports);
var Ffe = Pw.exports, Dw = { exports: {} }, kw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var n = a(st), r = a(Ja);
  function a(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var o = /[^A-Z0-9+\/=]/i, i = /^[A-Z0-9_\-]*$/i, s = {
    urlSafe: !1
  };
  function l(u, c) {
    (0, n.default)(u), c = (0, r.default)(c, s);
    var f = u.length;
    if (c.urlSafe)
      return i.test(u);
    if (f % 4 !== 0 || o.test(u))
      return !1;
    var d = u.indexOf("=");
    return d === -1 || d === f - 1 || d === f - 2 && u[f - 1] === "=";
  }
  e.exports = t.default, e.exports.default = t.default;
})(kw, kw.exports);
var Q7 = kw.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = a(st), r = a(Q7);
  function a(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i) {
    (0, n.default)(i);
    var s = i.split("."), l = s.length;
    return l !== 3 ? !1 : s.reduce(function(u, c) {
      return u && (0, r.default)(c, {
        urlSafe: !0
      });
    }, !0);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Dw, Dw.exports);
var Lfe = Dw.exports, Mw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var n = a(st), r = a(Ja);
  function a(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function o(l) {
    "@babel/helpers - typeof";
    return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
      return typeof u;
    } : function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, o(l);
  }
  var i = {
    allow_primitives: !1
  };
  function s(l, u) {
    (0, n.default)(l);
    try {
      u = (0, r.default)(u, i);
      var c = [];
      u.allow_primitives && (c = [null, !1, !0]);
      var f = JSON.parse(l);
      return c.includes(f) || !!f && o(f) === "object";
    } catch {
    }
    return !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Mw, Mw.exports);
var Bfe = Mw.exports, Rw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = a(st), r = a(Ja);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = {
    ignore_whitespace: !1
  };
  function i(s, l) {
    return (0, n.default)(s), l = (0, r.default)(l, o), (l.ignore_whitespace ? s.trim().length : s.length) === 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Rw, Rw.exports);
var Hfe = Rw.exports, Nw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i) {
    "@babel/helpers - typeof";
    return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
      return typeof s;
    } : function(s) {
      return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
    }, a(i);
  }
  function o(i, s) {
    (0, n.default)(i);
    var l, u;
    a(s) === "object" ? (l = s.min || 0, u = s.max) : (l = arguments[1] || 0, u = arguments[2]);
    var c = i.match(/(\uFE0F|\uFE0E)/g) || [], f = i.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [], d = i.length - c.length - f.length;
    return d >= l && (typeof u > "u" || d <= u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Nw, Nw.exports);
var jfe = Nw.exports, Fw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = {
    1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    7: /^[0-9A-F]{8}-[0-9A-F]{4}-7[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
  };
  function o(i, s) {
    (0, n.default)(i);
    var l = a[[void 0, null].includes(s) ? "all" : s];
    return !!l && l.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Fw, Fw.exports);
var Vfe = Fw.exports, Lw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = a(st), r = a(X7);
  function a(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i) {
    return (0, n.default)(i), (0, r.default)(i) && i.length === 24;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Lw, Lw.exports);
var Ufe = Lw.exports, Bw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(E4);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o, i) {
    var s = (i == null ? void 0 : i.comparisonDate) || i || Date().toString(), l = (0, n.default)(s), u = (0, n.default)(o);
    return !!(u && l && u > l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Bw, Bw.exports);
var zfe = Bw.exports, Hw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = a(st), r = a(E4);
  function a(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : String(/* @__PURE__ */ new Date());
    (0, n.default)(i);
    var l = (0, r.default)(s), u = (0, r.default)(i);
    return !!(u && l && u < l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Hw, Hw.exports);
var Wfe = Hw.exports, jw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = a(st), r = a(G7);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function o(s) {
    "@babel/helpers - typeof";
    return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
      return typeof l;
    } : function(l) {
      return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
    }, o(s);
  }
  function i(s, l) {
    (0, n.default)(s);
    var u;
    if (Object.prototype.toString.call(l) === "[object Array]") {
      var c = [];
      for (u in l)
        ({}).hasOwnProperty.call(l, u) && (c[u] = (0, r.default)(l[u]));
      return c.indexOf(s) >= 0;
    } else {
      if (o(l) === "object")
        return l.hasOwnProperty(s);
      if (l && typeof l.indexOf == "function")
        return l.indexOf(s) >= 0;
    }
    return !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(jw, jw.exports);
var Gfe = jw.exports, Vw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o) {
    (0, n.default)(o);
    for (var i = o.replace(/[- ]+/g, ""), s = 0, l, u, c, f = i.length - 1; f >= 0; f--)
      l = i.substring(f, f + 1), u = parseInt(l, 10), c ? (u *= 2, u >= 10 ? s += u % 10 + 1 : s += u) : s += u, c = !c;
    return !!(s % 10 === 0 && i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Vw, Vw.exports);
var J7 = Vw.exports, Uw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var n = a(st), r = a(J7);
  function a(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var o = {
    amex: /^3[47][0-9]{13}$/,
    dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
    mastercard: /^5[1-5][0-9]{2}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
    // /^[25][1-7][0-9]{14}$/;
    unionpay: /^(6[27][0-9]{14}|^(81[0-9]{14,17}))$/,
    visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/
  }, i = function() {
    var l = [];
    for (var u in o)
      o.hasOwnProperty(u) && l.push(o[u]);
    return l;
  }();
  function s(l) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, n.default)(l);
    var c = u.provider, f = l.replace(/[- ]+/g, "");
    if (c && c.toLowerCase() in o) {
      if (!o[c.toLowerCase()].test(f))
        return !1;
    } else {
      if (c && !(c.toLowerCase() in o))
        throw new Error("".concat(c, " is not a valid credit card provider."));
      if (!i.some(function(d) {
        return d.test(f);
      }))
        return !1;
    }
    return (0, r.default)(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Uw, Uw.exports);
var Kfe = Uw.exports, zw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = a(st), r = a($4);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = {
    PL: function(l) {
      (0, n.default)(l);
      var u = {
        1: 1,
        2: 3,
        3: 7,
        4: 9,
        5: 1,
        6: 3,
        7: 7,
        8: 9,
        9: 1,
        10: 3,
        11: 0
      };
      if (l != null && l.length === 11 && (0, r.default)(l, {
        allow_leading_zeroes: !0
      })) {
        var c = l.split("").slice(0, -1), f = c.reduce(function(v, h, m) {
          return v + Number(h) * u[m + 1];
        }, 0), d = f % 10, p = Number(l.charAt(l.length - 1));
        if (d === 0 && p === 0 || p === 10 - d)
          return !0;
      }
      return !1;
    },
    ES: function(l) {
      (0, n.default)(l);
      var u = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/, c = {
        X: 0,
        Y: 1,
        Z: 2
      }, f = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"], d = l.trim().toUpperCase();
      if (!u.test(d))
        return !1;
      var p = d.slice(0, -1).replace(/[X,Y,Z]/g, function(v) {
        return c[v];
      });
      return d.endsWith(f[p % 23]);
    },
    FI: function(l) {
      if ((0, n.default)(l), l.length !== 11 || !l.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/))
        return !1;
      var u = "0123456789ABCDEFHJKLMNPRSTUVWXY", c = parseInt(l.slice(0, 6), 10) * 1e3 + parseInt(l.slice(7, 10), 10), f = c % 31, d = u[f];
      return d === l.slice(10, 11);
    },
    IN: function(l) {
      var u = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/, c = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], f = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], d = l.trim();
      if (!u.test(d))
        return !1;
      var p = 0, v = d.replace(/\s/g, "").split("").map(Number).reverse();
      return v.forEach(function(h, m) {
        p = c[p][f[m % 8][h]];
      }), p === 0;
    },
    IR: function(l) {
      if (!l.match(/^\d{10}$/) || (l = "0000".concat(l).slice(l.length - 6), parseInt(l.slice(3, 9), 10) === 0)) return !1;
      for (var u = parseInt(l.slice(9, 10), 10), c = 0, f = 0; f < 9; f++)
        c += parseInt(l.slice(f, f + 1), 10) * (10 - f);
      return c %= 11, c < 2 && u === c || c >= 2 && u === 11 - c;
    },
    IT: function(l) {
      return l.length !== 9 || l === "CA00000AA" ? !1 : l.search(/C[A-Z]\d{5}[A-Z]{2}/i) > -1;
    },
    NO: function(l) {
      var u = l.trim();
      if (isNaN(Number(u)) || u.length !== 11 || u === "00000000000") return !1;
      var c = u.split("").map(Number), f = (11 - (3 * c[0] + 7 * c[1] + 6 * c[2] + 1 * c[3] + 8 * c[4] + 9 * c[5] + 4 * c[6] + 5 * c[7] + 2 * c[8]) % 11) % 11, d = (11 - (5 * c[0] + 4 * c[1] + 3 * c[2] + 2 * c[3] + 7 * c[4] + 6 * c[5] + 5 * c[6] + 4 * c[7] + 3 * c[8] + 2 * f) % 11) % 11;
      return !(f !== c[9] || d !== c[10]);
    },
    TH: function(l) {
      if (!l.match(/^[1-8]\d{12}$/)) return !1;
      for (var u = 0, c = 0; c < 12; c++)
        u += parseInt(l[c], 10) * (13 - c);
      return l[12] === ((11 - u % 11) % 10).toString();
    },
    LK: function(l) {
      var u = /^[1-9]\d{8}[vx]$/i, c = /^[1-9]\d{11}$/i;
      return l.length === 10 && u.test(l) ? !0 : !!(l.length === 12 && c.test(l));
    },
    "he-IL": function(l) {
      var u = /^\d{9}$/, c = l.trim();
      if (!u.test(c))
        return !1;
      for (var f = c, d = 0, p, v = 0; v < f.length; v++)
        p = Number(f[v]) * (v % 2 + 1), d += p > 9 ? p - 9 : p;
      return d % 10 === 0;
    },
    "ar-LY": function(l) {
      var u = /^(1|2)\d{11}$/, c = l.trim();
      return !!u.test(c);
    },
    "ar-TN": function(l) {
      var u = /^\d{8}$/, c = l.trim();
      return !!u.test(c);
    },
    "zh-CN": function(l) {
      var u = [
        "11",
        // 北京
        "12",
        // 天津
        "13",
        // 河北
        "14",
        // 山西
        "15",
        // 内蒙古
        "21",
        // 辽宁
        "22",
        // 吉林
        "23",
        // 黑龙江
        "31",
        // 上海
        "32",
        // 江苏
        "33",
        // 浙江
        "34",
        // 安徽
        "35",
        // 福建
        "36",
        // 江西
        "37",
        // 山东
        "41",
        // 河南
        "42",
        // 湖北
        "43",
        // 湖南
        "44",
        // 广东
        "45",
        // 广西
        "46",
        // 海南
        "50",
        // 重庆
        "51",
        // 四川
        "52",
        // 贵州
        "53",
        // 云南
        "54",
        // 西藏
        "61",
        // 陕西
        "62",
        // 甘肃
        "63",
        // 青海
        "64",
        // 宁夏
        "65",
        // 新疆
        "71",
        // 台湾
        "81",
        // 香港
        "82",
        // 澳门
        "91"
        // 国外
      ], c = ["7", "9", "10", "5", "8", "4", "2", "1", "6", "3", "7", "9", "10", "5", "8", "4", "2"], f = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"], d = function(S) {
        return u.includes(S);
      }, p = function(S) {
        var w = parseInt(S.substring(0, 4), 10), _ = parseInt(S.substring(4, 6), 10), b = parseInt(S.substring(6), 10), E = new Date(w, _ - 1, b);
        return E > /* @__PURE__ */ new Date() ? !1 : E.getFullYear() === w && E.getMonth() === _ - 1 && E.getDate() === b;
      }, v = function(S) {
        for (var w = S.substring(0, 17), _ = 0, b = 0; b < 17; b++)
          _ += parseInt(w.charAt(b), 10) * parseInt(c[b], 10);
        var E = _ % 11;
        return f[E];
      }, h = function(S) {
        return v(S) === S.charAt(17).toUpperCase();
      }, m = function(S) {
        var w = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(S);
        if (!w) return !1;
        var _ = S.substring(0, 2);
        if (w = d(_), !w) return !1;
        var b = "19".concat(S.substring(6, 12));
        return w = p(b), !!w;
      }, y = function(S) {
        var w = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(S);
        if (!w) return !1;
        var _ = S.substring(0, 2);
        if (w = d(_), !w) return !1;
        var b = S.substring(6, 14);
        return w = p(b), w ? h(S) : !1;
      }, x = function(S) {
        var w = /^\d{15}|(\d{17}(\d|x|X))$/.test(S);
        return w ? S.length === 15 ? m(S) : y(S) : !1;
      };
      return x(l);
    },
    "zh-HK": function(l) {
      l = l.trim();
      var u = /^[A-Z]{1,2}[0-9]{6}((\([0-9A]\))|(\[[0-9A]\])|([0-9A]))$/, c = /^[0-9]$/;
      if (l = l.toUpperCase(), !u.test(l)) return !1;
      l = l.replace(/\[|\]|\(|\)/g, ""), l.length === 8 && (l = "3".concat(l));
      for (var f = 0, d = 0; d <= 7; d++) {
        var p = void 0;
        c.test(l[d]) ? p = l[d] : p = (l[d].charCodeAt(0) - 55) % 11, f += p * (9 - d);
      }
      f %= 11;
      var v;
      return f === 0 ? v = "0" : f === 1 ? v = "A" : v = String(11 - f), v === l[l.length - 1];
    },
    "zh-TW": function(l) {
      var u = {
        A: 10,
        B: 11,
        C: 12,
        D: 13,
        E: 14,
        F: 15,
        G: 16,
        H: 17,
        I: 34,
        J: 18,
        K: 19,
        L: 20,
        M: 21,
        N: 22,
        O: 35,
        P: 23,
        Q: 24,
        R: 25,
        S: 26,
        T: 27,
        U: 28,
        V: 29,
        W: 32,
        X: 30,
        Y: 31,
        Z: 33
      }, c = l.trim().toUpperCase();
      return /^[A-Z][0-9]{9}$/.test(c) ? Array.from(c).reduce(function(f, d, p) {
        if (p === 0) {
          var v = u[d];
          return v % 10 * 9 + Math.floor(v / 10);
        }
        return p === 9 ? (10 - f % 10 - Number(d)) % 10 === 0 : f + Number(d) * (9 - p);
      }, 0) : !1;
    }
  };
  function i(s, l) {
    if ((0, n.default)(s), l in o)
      return o[l](s);
    if (l === "any") {
      for (var u in o)
        if (o.hasOwnProperty(u)) {
          var c = o[u];
          if (c(s))
            return !0;
        }
      return !1;
    }
    throw new Error("Invalid locale '".concat(l, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(zw, zw.exports);
var Yfe = zw.exports, Ww = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var n = r(st);
  function r(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var a = 8, o = 14, i = /^(\d{8}|\d{13}|\d{14})$/;
  function s(c, f) {
    return c === a || c === o ? f % 2 === 0 ? 3 : 1 : f % 2 === 0 ? 1 : 3;
  }
  function l(c) {
    var f = c.slice(0, -1).split("").map(function(p, v) {
      return Number(p) * s(c.length, v);
    }).reduce(function(p, v) {
      return p + v;
    }, 0), d = 10 - f % 10;
    return d < 10 ? d : 0;
  }
  function u(c) {
    (0, n.default)(c);
    var f = Number(c.slice(-1));
    return i.test(c) && f === l(c);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Ww, Ww.exports);
var qfe = Ww.exports, Gw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
  function o(i) {
    if ((0, n.default)(i), !a.test(i))
      return !1;
    for (var s = !0, l = 0, u = i.length - 2; u >= 0; u--)
      if (i[u] >= "A" && i[u] <= "Z")
        for (var c = i[u].charCodeAt(0) - 55, f = c % 10, d = Math.trunc(c / 10), p = 0, v = [f, d]; p < v.length; p++) {
          var h = v[p];
          s ? h >= 5 ? l += 1 + (h - 5) * 2 : l += h * 2 : l += h, s = !s;
        }
      else {
        var m = i[u].charCodeAt(0) - 48;
        s ? m >= 5 ? l += 1 + (m - 5) * 2 : l += m * 2 : l += m, s = !s;
      }
    var y = Math.trunc((l + 9) / 10) * 10 - l;
    return +i[i.length - 1] === y;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Gw, Gw.exports);
var Xfe = Gw.exports, Kw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var n = r(st);
  function r(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var a = /^(?:[0-9]{9}X|[0-9]{10})$/, o = /^(?:[0-9]{13})$/, i = [1, 3];
  function s(l, u) {
    (0, n.default)(l);
    var c = String((u == null ? void 0 : u.version) || u);
    if (!(u != null && u.version || u))
      return s(l, {
        version: 10
      }) || s(l, {
        version: 13
      });
    var f = l.replace(/[\s-]+/g, ""), d = 0;
    if (c === "10") {
      if (!a.test(f))
        return !1;
      for (var p = 0; p < c - 1; p++)
        d += (p + 1) * f.charAt(p);
      if (f.charAt(9) === "X" ? d += 10 * 10 : d += 10 * f.charAt(9), d % 11 === 0)
        return !0;
    } else if (c === "13") {
      if (!o.test(f))
        return !1;
      for (var v = 0; v < 12; v++)
        d += i[v % 2] * f.charAt(v);
      if (f.charAt(12) - (10 - d % 10) % 10 === 0)
        return !0;
    }
    return !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Kw, Kw.exports);
var Zfe = Kw.exports, Yw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = "^\\d{4}-?\\d{3}[\\dX]$";
  function o(i) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, n.default)(i);
    var l = a;
    if (l = s.require_hyphen ? l.replace("?", "") : l, l = s.case_sensitive ? new RegExp(l) : new RegExp(l, "i"), !l.test(i))
      return !1;
    for (var u = i.replace("-", "").toUpperCase(), c = 0, f = 0; f < u.length; f++) {
      var d = u[f];
      c += (d === "X" ? 10 : +d) * (8 - f);
    }
    return c % 11 === 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Yw, Yw.exports);
var Qfe = Yw.exports, qw = { exports: {} }, Mc = {};
Object.defineProperty(Mc, "__esModule", {
  value: !0
});
Mc.iso7064Check = Jfe;
Mc.luhnCheck = ede;
Mc.reverseMultiplyAndSum = tde;
Mc.verhoeffCheck = nde;
function Jfe(e) {
  for (var t = 10, n = 0; n < e.length - 1; n++)
    t = (parseInt(e[n], 10) + t) % 10 === 0 ? 10 * 2 % 11 : (parseInt(e[n], 10) + t) % 10 * 2 % 11;
  return t = t === 1 ? 0 : 11 - t, t === parseInt(e[10], 10);
}
function ede(e) {
  for (var t = 0, n = !1, r = e.length - 1; r >= 0; r--) {
    if (n) {
      var a = parseInt(e[r], 10) * 2;
      a > 9 ? t += a.toString().split("").map(function(o) {
        return parseInt(o, 10);
      }).reduce(function(o, i) {
        return o + i;
      }, 0) : t += a;
    } else
      t += parseInt(e[r], 10);
    n = !n;
  }
  return t % 10 === 0;
}
function tde(e, t) {
  for (var n = 0, r = 0; r < e.length; r++)
    n += e[r] * (t - r);
  return n;
}
function nde(e) {
  for (var t = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], n = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], r = e.split("").reverse().join(""), a = 0, o = 0; o < r.length; o++)
    a = t[a][n[o % 8][parseInt(r[o], 10)]];
  return a === 0;
}
(function(e, t) {
  function n(K) {
    "@babel/helpers - typeof";
    return n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Z) {
      return typeof Z;
    } : function(Z) {
      return Z && typeof Symbol == "function" && Z.constructor === Symbol && Z !== Symbol.prototype ? "symbol" : typeof Z;
    }, n(K);
  }
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = he;
  var r = l(st), a = s(Mc), o = l(q7);
  function i(K) {
    if (typeof WeakMap != "function") return null;
    var Z = /* @__PURE__ */ new WeakMap(), se = /* @__PURE__ */ new WeakMap();
    return (i = function(xe) {
      return xe ? se : Z;
    })(K);
  }
  function s(K, Z) {
    if (K && K.__esModule) return K;
    if (K === null || n(K) != "object" && typeof K != "function") return { default: K };
    var se = i(Z);
    if (se && se.has(K)) return se.get(K);
    var me = { __proto__: null }, xe = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var be in K) if (be !== "default" && {}.hasOwnProperty.call(K, be)) {
      var Te = xe ? Object.getOwnPropertyDescriptor(K, be) : null;
      Te && (Te.get || Te.set) ? Object.defineProperty(me, be, Te) : me[be] = K[be];
    }
    return me.default = K, se && se.set(K, me), me;
  }
  function l(K) {
    return K && K.__esModule ? K : { default: K };
  }
  function u(K) {
    return p(K) || d(K) || f(K) || c();
  }
  function c() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function f(K, Z) {
    if (K) {
      if (typeof K == "string") return v(K, Z);
      var se = Object.prototype.toString.call(K).slice(8, -1);
      if (se === "Object" && K.constructor && (se = K.constructor.name), se === "Map" || se === "Set") return Array.from(K);
      if (se === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(se)) return v(K, Z);
    }
  }
  function d(K) {
    if (typeof Symbol < "u" && K[Symbol.iterator] != null || K["@@iterator"] != null) return Array.from(K);
  }
  function p(K) {
    if (Array.isArray(K)) return v(K);
  }
  function v(K, Z) {
    (Z == null || Z > K.length) && (Z = K.length);
    for (var se = 0, me = new Array(Z); se < Z; se++) me[se] = K[se];
    return me;
  }
  function h(K) {
    var Z = K.slice(0, 2), se = parseInt(K.slice(2, 4), 10);
    se > 40 ? (se -= 40, Z = "20".concat(Z)) : se > 20 ? (se -= 20, Z = "18".concat(Z)) : Z = "19".concat(Z), se < 10 && (se = "0".concat(se));
    var me = "".concat(Z, "/").concat(se, "/").concat(K.slice(4, 6));
    if (!(0, o.default)(me, "YYYY/MM/DD"))
      return !1;
    for (var xe = K.split("").map(function(Ve) {
      return parseInt(Ve, 10);
    }), be = [2, 4, 8, 5, 10, 9, 7, 3, 6], Te = 0, Ie = 0; Ie < be.length; Ie++)
      Te += xe[Ie] * be[Ie];
    return Te = Te % 11 === 10 ? 0 : Te % 11, Te === xe[9];
  }
  function m(K) {
    var Z = K.split(""), se = Z.filter(function(xe, be) {
      return be % 2;
    }).map(function(xe) {
      return Number(xe) * 2;
    }).join("").split(""), me = Z.filter(function(xe, be) {
      return !(be % 2);
    }).concat(se).map(function(xe) {
      return Number(xe);
    }).reduce(function(xe, be) {
      return xe + be;
    });
    return me % 10 === 0;
  }
  function y(K) {
    K = K.replace(/\W/, "");
    var Z = parseInt(K.slice(0, 2), 10);
    if (K.length === 10)
      Z < 54 ? Z = "20".concat(Z) : Z = "19".concat(Z);
    else {
      if (K.slice(6) === "000")
        return !1;
      if (Z < 54)
        Z = "19".concat(Z);
      else
        return !1;
    }
    Z.length === 3 && (Z = [Z.slice(0, 2), "0", Z.slice(2)].join(""));
    var se = parseInt(K.slice(2, 4), 10);
    if (se > 50 && (se -= 50), se > 20) {
      if (parseInt(Z, 10) < 2004)
        return !1;
      se -= 20;
    }
    se < 10 && (se = "0".concat(se));
    var me = "".concat(Z, "/").concat(se, "/").concat(K.slice(4, 6));
    if (!(0, o.default)(me, "YYYY/MM/DD"))
      return !1;
    if (K.length === 10 && parseInt(K, 10) % 11 !== 0) {
      var xe = parseInt(K.slice(0, 9), 10) % 11;
      if (parseInt(Z, 10) < 1986 && xe === 10) {
        if (parseInt(K.slice(9), 10) !== 0)
          return !1;
      } else
        return !1;
    }
    return !0;
  }
  function x(K) {
    return a.luhnCheck(K);
  }
  function g(K) {
    for (var Z = K.split("").map(function(Ve) {
      return parseInt(Ve, 10);
    }), se = [], me = 0; me < Z.length - 1; me++) {
      se.push("");
      for (var xe = 0; xe < Z.length - 1; xe++)
        Z[me] === Z[xe] && (se[me] += xe);
    }
    if (se = se.filter(function(Ve) {
      return Ve.length > 1;
    }), se.length !== 2 && se.length !== 3)
      return !1;
    if (se[0].length === 3) {
      for (var be = se[0].split("").map(function(Ve) {
        return parseInt(Ve, 10);
      }), Te = 0, Ie = 0; Ie < be.length - 1; Ie++)
        be[Ie] + 1 === be[Ie + 1] && (Te += 1);
      if (Te === 2)
        return !1;
    }
    return a.iso7064Check(K);
  }
  function S(K) {
    K = K.replace(/\W/, "");
    var Z = parseInt(K.slice(4, 6), 10), se = K.slice(6, 7);
    switch (se) {
      case "0":
      case "1":
      case "2":
      case "3":
        Z = "19".concat(Z);
        break;
      case "4":
      case "9":
        Z < 37 ? Z = "20".concat(Z) : Z = "19".concat(Z);
        break;
      default:
        if (Z < 37)
          Z = "20".concat(Z);
        else if (Z > 58)
          Z = "18".concat(Z);
        else
          return !1;
        break;
    }
    Z.length === 3 && (Z = [Z.slice(0, 2), "0", Z.slice(2)].join(""));
    var me = "".concat(Z, "/").concat(K.slice(2, 4), "/").concat(K.slice(0, 2));
    if (!(0, o.default)(me, "YYYY/MM/DD"))
      return !1;
    for (var xe = K.split("").map(function(Ve) {
      return parseInt(Ve, 10);
    }), be = 0, Te = 4, Ie = 0; Ie < 9; Ie++)
      be += xe[Ie] * Te, Te -= 1, Te === 1 && (Te = 7);
    return be %= 11, be === 1 ? !1 : be === 0 ? xe[9] === 0 : xe[9] === 11 - be;
  }
  function w(K) {
    for (var Z = K.slice(0, 8).split("").map(function(be) {
      return parseInt(be, 10);
    }), se = 0, me = 1; me < Z.length; me += 2)
      se += Z[me];
    for (var xe = 0; xe < Z.length; xe += 2)
      Z[xe] < 2 ? se += 1 - Z[xe] : (se += 2 * (Z[xe] - 2) + 5, Z[xe] > 4 && (se += 2));
    return String.fromCharCode(se % 26 + 65) === K.charAt(8);
  }
  function _(K) {
    for (var Z = K.split("").map(function(xe) {
      return parseInt(xe, 10);
    }), se = 0, me = 0; me < 8; me++)
      se += Z[me] * Math.pow(2, 8 - me);
    return se % 11 % 10 === Z[8];
  }
  function b(K) {
    var Z = a.reverseMultiplyAndSum(K.split("").slice(0, 7).map(function(se) {
      return parseInt(se, 10);
    }), 8);
    return K.length === 9 && K[8] !== "W" && (Z += (K[8].charCodeAt(0) - 64) * 9), Z %= 23, Z === 0 ? K[7].toUpperCase() === "W" : K[7].toUpperCase() === String.fromCharCode(64 + Z);
  }
  var E = {
    andover: ["10", "12"],
    atlanta: ["60", "67"],
    austin: ["50", "53"],
    brookhaven: ["01", "02", "03", "04", "05", "06", "11", "13", "14", "16", "21", "22", "23", "25", "34", "51", "52", "54", "55", "56", "57", "58", "59", "65"],
    cincinnati: ["30", "32", "35", "36", "37", "38", "61"],
    fresno: ["15", "24"],
    internet: ["20", "26", "27", "45", "46", "47"],
    kansas: ["40", "44"],
    memphis: ["94", "95"],
    ogden: ["80", "90"],
    philadelphia: ["33", "39", "41", "42", "43", "46", "48", "62", "63", "64", "66", "68", "71", "72", "73", "74", "75", "76", "77", "81", "82", "83", "84", "85", "86", "87", "88", "91", "92", "93", "98", "99"],
    sba: ["31"]
  };
  function C() {
    var K = [];
    for (var Z in E)
      E.hasOwnProperty(Z) && K.push.apply(K, u(E[Z]));
    return K;
  }
  function T(K) {
    return C().indexOf(K.slice(0, 2)) !== -1;
  }
  function O(K) {
    for (var Z = 0, se = K.split(""), me = parseInt(se.pop(), 10), xe = 0; xe < se.length; xe++)
      Z += se[9 - xe] * (2 + xe % 6);
    var be = 11 - Z % 11;
    return be === 11 ? be = 0 : be === 10 && (be = 9), me === be;
  }
  function I(K) {
    var Z = K.toUpperCase().split("");
    if (isNaN(parseInt(Z[0], 10)) && Z.length > 1) {
      var se = 0;
      switch (Z[0]) {
        case "Y":
          se = 1;
          break;
        case "Z":
          se = 2;
          break;
      }
      Z.splice(0, 1, se);
    } else
      for (; Z.length < 9; )
        Z.unshift(0);
    var me = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"];
    Z = Z.join("");
    var xe = parseInt(Z.slice(0, 8), 10) % 23;
    return Z[8] === me[xe];
  }
  function k(K) {
    var Z = K.slice(1, 3), se = K.slice(0, 1);
    switch (se) {
      case "1":
      case "2":
        Z = "18".concat(Z);
        break;
      case "3":
      case "4":
        Z = "19".concat(Z);
        break;
      default:
        Z = "20".concat(Z);
        break;
    }
    var me = "".concat(Z, "/").concat(K.slice(3, 5), "/").concat(K.slice(5, 7));
    if (!(0, o.default)(me, "YYYY/MM/DD"))
      return !1;
    for (var xe = K.split("").map(function(tt) {
      return parseInt(tt, 10);
    }), be = 0, Te = 1, Ie = 0; Ie < 10; Ie++)
      be += xe[Ie] * Te, Te += 1, Te === 10 && (Te = 1);
    if (be % 11 === 10) {
      be = 0, Te = 3;
      for (var Ve = 0; Ve < 10; Ve++)
        be += xe[Ve] * Te, Te += 1, Te === 10 && (Te = 1);
      if (be % 11 === 10)
        return xe[10] === 0;
    }
    return be % 11 === xe[10];
  }
  function B(K) {
    var Z = K.slice(4, 6), se = K.slice(6, 7);
    switch (se) {
      case "+":
        Z = "18".concat(Z);
        break;
      case "-":
        Z = "19".concat(Z);
        break;
      default:
        Z = "20".concat(Z);
        break;
    }
    var me = "".concat(Z, "/").concat(K.slice(2, 4), "/").concat(K.slice(0, 2));
    if (!(0, o.default)(me, "YYYY/MM/DD"))
      return !1;
    var xe = parseInt(K.slice(0, 6) + K.slice(7, 10), 10) % 31;
    if (xe < 10)
      return xe === parseInt(K.slice(10), 10);
    xe -= 10;
    var be = ["A", "B", "C", "D", "E", "F", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y"];
    return be[xe] === K.slice(10);
  }
  function P(K) {
    if (K.slice(2, 4) !== "00" || K.slice(4, 6) !== "00") {
      var Z = "".concat(K.slice(0, 2), "/").concat(K.slice(2, 4), "/").concat(K.slice(4, 6));
      if (!(0, o.default)(Z, "YY/MM/DD"))
        return !1;
    }
    var se = 97 - parseInt(K.slice(0, 9), 10) % 97, me = parseInt(K.slice(9, 11), 10);
    return !(se !== me && (se = 97 - parseInt("2".concat(K.slice(0, 9)), 10) % 97, se !== me));
  }
  function N(K) {
    K = K.replace(/\s/g, "");
    var Z = parseInt(K.slice(0, 10), 10) % 511, se = parseInt(K.slice(10, 13), 10);
    return Z === se;
  }
  function M(K) {
    var Z = "".concat(K.slice(0, 4), "/").concat(K.slice(4, 6), "/").concat(K.slice(6, 8));
    return !(0, o.default)(Z, "YYYY/MM/DD") || !a.luhnCheck(K.slice(0, 12)) ? !1 : a.verhoeffCheck("".concat(K.slice(0, 11)).concat(K[12]));
  }
  function H(K) {
    return a.iso7064Check(K);
  }
  function R(K) {
    for (var Z = K.split("").map(function(xe) {
      return parseInt(xe, 10);
    }), se = 8, me = 1; me < 9; me++)
      se += Z[me] * (me + 1);
    return se % 11 === Z[9];
  }
  function z(K) {
    for (var Z = !1, se = !1, me = 0; me < 3; me++)
      if (!Z && /[AEIOU]/.test(K[me]))
        Z = !0;
      else if (!se && Z && K[me] === "X")
        se = !0;
      else if (me > 0 && (Z && !se && !/[AEIOU]/.test(K[me]) || se && !/X/.test(K[me])))
        return !1;
    return !0;
  }
  function W(K) {
    var Z = K.toUpperCase().split("");
    if (!z(Z.slice(0, 3)) || !z(Z.slice(3, 6)))
      return !1;
    for (var se = [6, 7, 9, 10, 12, 13, 14], me = {
      L: "0",
      M: "1",
      N: "2",
      P: "3",
      Q: "4",
      R: "5",
      S: "6",
      T: "7",
      U: "8",
      V: "9"
    }, xe = 0, be = se; xe < be.length; xe++) {
      var Te = be[xe];
      Z[Te] in me && Z.splice(Te, 1, me[Z[Te]]);
    }
    var Ie = {
      A: "01",
      B: "02",
      C: "03",
      D: "04",
      E: "05",
      H: "06",
      L: "07",
      M: "08",
      P: "09",
      R: "10",
      S: "11",
      T: "12"
    }, Ve = Ie[Z[8]], tt = parseInt(Z[9] + Z[10], 10);
    tt > 40 && (tt -= 40), tt < 10 && (tt = "0".concat(tt));
    var it = "".concat(Z[6]).concat(Z[7], "/").concat(Ve, "/").concat(tt);
    if (!(0, o.default)(it, "YY/MM/DD"))
      return !1;
    for (var Se = 0, ge = 1; ge < Z.length - 1; ge += 2) {
      var pe = parseInt(Z[ge], 10);
      isNaN(pe) && (pe = Z[ge].charCodeAt(0) - 65), Se += pe;
    }
    for (var De = {
      // Maps of characters at odd places
      A: 1,
      B: 0,
      C: 5,
      D: 7,
      E: 9,
      F: 13,
      G: 15,
      H: 17,
      I: 19,
      J: 21,
      K: 2,
      L: 4,
      M: 18,
      N: 20,
      O: 11,
      P: 3,
      Q: 6,
      R: 8,
      S: 12,
      T: 14,
      U: 16,
      V: 10,
      W: 22,
      X: 25,
      Y: 24,
      Z: 23,
      0: 1,
      1: 0
    }, Ue = 0; Ue < Z.length - 1; Ue += 2) {
      var Xe = 0;
      if (Z[Ue] in De)
        Xe = De[Z[Ue]];
      else {
        var ut = parseInt(Z[Ue], 10);
        Xe = 2 * ut + 1, ut > 4 && (Xe += 2);
      }
      Se += Xe;
    }
    return String.fromCharCode(65 + Se % 26) === Z[15];
  }
  function F(K) {
    K = K.replace(/\W/, "");
    var Z = K.slice(0, 2);
    if (Z !== "32") {
      var se = K.slice(2, 4);
      if (se !== "00") {
        var me = K.slice(4, 6);
        switch (K[6]) {
          case "0":
            me = "18".concat(me);
            break;
          case "1":
            me = "19".concat(me);
            break;
          default:
            me = "20".concat(me);
            break;
        }
        var xe = "".concat(me, "/").concat(K.slice(2, 4), "/").concat(Z);
        if (!(0, o.default)(xe, "YYYY/MM/DD"))
          return !1;
      }
      for (var be = 1101, Te = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2], Ie = 0; Ie < K.length - 1; Ie++)
        be -= parseInt(K[Ie], 10) * Te[Ie];
      return parseInt(K[10], 10) === be % 11;
    }
    return !0;
  }
  function Y(K) {
    if (K.length !== 9) {
      for (var Z = K.toUpperCase().split(""); Z.length < 8; )
        Z.unshift(0);
      switch (K[7]) {
        case "A":
        case "P":
          if (parseInt(Z[6], 10) === 0)
            return !1;
          break;
        default: {
          var se = parseInt(Z.join("").slice(0, 5), 10);
          if (se > 32e3)
            return !1;
          var me = parseInt(Z.join("").slice(5, 7), 10);
          if (se === me)
            return !1;
        }
      }
    }
    return !0;
  }
  function X(K) {
    return a.reverseMultiplyAndSum(K.split("").slice(0, 8).map(function(Z) {
      return parseInt(Z, 10);
    }), 9) % 11 === parseInt(K[8], 10);
  }
  function q(K) {
    if (K.length === 10) {
      for (var Z = [6, 5, 7, 2, 3, 4, 5, 6, 7], se = 0, me = 0; me < Z.length; me++)
        se += parseInt(K[me], 10) * Z[me];
      return se %= 11, se === 10 ? !1 : se === parseInt(K[9], 10);
    }
    var xe = K.slice(0, 2), be = parseInt(K.slice(2, 4), 10);
    be > 80 ? (xe = "18".concat(xe), be -= 80) : be > 60 ? (xe = "22".concat(xe), be -= 60) : be > 40 ? (xe = "21".concat(xe), be -= 40) : be > 20 ? (xe = "20".concat(xe), be -= 20) : xe = "19".concat(xe), be < 10 && (be = "0".concat(be));
    var Te = "".concat(xe, "/").concat(be, "/").concat(K.slice(4, 6));
    if (!(0, o.default)(Te, "YYYY/MM/DD"))
      return !1;
    for (var Ie = 0, Ve = 1, tt = 0; tt < K.length - 1; tt++)
      Ie += parseInt(K[tt], 10) * Ve % 10, Ve += 2, Ve > 10 ? Ve = 1 : Ve === 5 && (Ve += 2);
    return Ie = 10 - Ie % 10, Ie === parseInt(K[10], 10);
  }
  function Q(K) {
    if (K.length === 11) {
      var Z, se;
      if (Z = 0, // Reject known invalid CPFs
      K === "11111111111" || K === "22222222222" || K === "33333333333" || K === "44444444444" || K === "55555555555" || K === "66666666666" || K === "77777777777" || K === "88888888888" || K === "99999999999" || K === "00000000000") return !1;
      for (var me = 1; me <= 9; me++) Z += parseInt(K.substring(me - 1, me), 10) * (11 - me);
      if (se = Z * 10 % 11, se === 10 && (se = 0), se !== parseInt(K.substring(9, 10), 10)) return !1;
      Z = 0;
      for (var xe = 1; xe <= 10; xe++) Z += parseInt(K.substring(xe - 1, xe), 10) * (12 - xe);
      return se = Z * 10 % 11, se === 10 && (se = 0), se === parseInt(K.substring(10, 11), 10);
    }
    if (
      // Reject know invalid CNPJs
      K === "00000000000000" || K === "11111111111111" || K === "22222222222222" || K === "33333333333333" || K === "44444444444444" || K === "55555555555555" || K === "66666666666666" || K === "77777777777777" || K === "88888888888888" || K === "99999999999999"
    )
      return !1;
    for (var be = K.length - 2, Te = K.substring(0, be), Ie = K.substring(be), Ve = 0, tt = be - 7, it = be; it >= 1; it--)
      Ve += Te.charAt(be - it) * tt, tt -= 1, tt < 2 && (tt = 9);
    var Se = Ve % 11 < 2 ? 0 : 11 - Ve % 11;
    if (Se !== parseInt(Ie.charAt(0), 10))
      return !1;
    be += 1, Te = K.substring(0, be), Ve = 0, tt = be - 7;
    for (var ge = be; ge >= 1; ge--)
      Ve += Te.charAt(be - ge) * tt, tt -= 1, tt < 2 && (tt = 9);
    return Se = Ve % 11 < 2 ? 0 : 11 - Ve % 11, Se === parseInt(Ie.charAt(1), 10);
  }
  function ue(K) {
    var Z = 11 - a.reverseMultiplyAndSum(K.split("").slice(0, 8).map(function(se) {
      return parseInt(se, 10);
    }), 9) % 11;
    return Z > 9 ? parseInt(K[8], 10) === 0 : Z === parseInt(K[8], 10);
  }
  function le(K) {
    if (K.slice(0, 4) !== "9000") {
      var Z = K.slice(1, 3);
      switch (K[0]) {
        case "1":
        case "2":
          Z = "19".concat(Z);
          break;
        case "3":
        case "4":
          Z = "18".concat(Z);
          break;
        case "5":
        case "6":
          Z = "20".concat(Z);
          break;
      }
      var se = "".concat(Z, "/").concat(K.slice(3, 5), "/").concat(K.slice(5, 7));
      if (se.length === 8) {
        if (!(0, o.default)(se, "YY/MM/DD"))
          return !1;
      } else if (!(0, o.default)(se, "YYYY/MM/DD"))
        return !1;
      for (var me = K.split("").map(function(Ie) {
        return parseInt(Ie, 10);
      }), xe = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9], be = 0, Te = 0; Te < xe.length; Te++)
        be += me[Te] * xe[Te];
      return be % 11 === 10 ? me[12] === 1 : me[12] === be % 11;
    }
    return !0;
  }
  function te(K) {
    if (K.length === 9) {
      if (K = K.replace(/\W/, ""), K.slice(6) === "000")
        return !1;
      var Z = parseInt(K.slice(0, 2), 10);
      if (Z > 53)
        return !1;
      Z < 10 ? Z = "190".concat(Z) : Z = "19".concat(Z);
      var se = parseInt(K.slice(2, 4), 10);
      se > 50 && (se -= 50), se < 10 && (se = "0".concat(se));
      var me = "".concat(Z, "/").concat(se, "/").concat(K.slice(4, 6));
      if (!(0, o.default)(me, "YYYY/MM/DD"))
        return !1;
    }
    return !0;
  }
  function G(K) {
    var Z = 11 - a.reverseMultiplyAndSum(K.split("").slice(0, 7).map(function(se) {
      return parseInt(se, 10);
    }), 8) % 11;
    return Z === 10 ? parseInt(K[7], 10) === 0 : Z === parseInt(K[7], 10);
  }
  function oe(K) {
    var Z = K.slice(0);
    K.length > 11 && (Z = Z.slice(2));
    var se = "", me = Z.slice(2, 4), xe = parseInt(Z.slice(4, 6), 10);
    if (K.length > 11)
      se = K.slice(0, 4);
    else if (se = K.slice(0, 2), K.length === 11 && xe < 60) {
      var be = (/* @__PURE__ */ new Date()).getFullYear().toString(), Te = parseInt(be.slice(0, 2), 10);
      if (be = parseInt(be, 10), K[6] === "-")
        parseInt("".concat(Te).concat(se), 10) > be ? se = "".concat(Te - 1).concat(se) : se = "".concat(Te).concat(se);
      else if (se = "".concat(Te - 1).concat(se), be - parseInt(se, 10) < 100)
        return !1;
    }
    xe > 60 && (xe -= 60), xe < 10 && (xe = "0".concat(xe));
    var Ie = "".concat(se, "/").concat(me, "/").concat(xe);
    if (Ie.length === 8) {
      if (!(0, o.default)(Ie, "YY/MM/DD"))
        return !1;
    } else if (!(0, o.default)(Ie, "YYYY/MM/DD"))
      return !1;
    return a.luhnCheck(K.replace(/\W/, ""));
  }
  function L(K) {
    for (var Z = K.split("").map(function(be) {
      return parseInt(be, 10);
    }), se = [-1, 5, 7, 9, 4, 6, 10, 5, 7], me = 0, xe = 0; xe < se.length; xe++)
      me += Z[xe] * se[xe];
    return me % 11 === 10 ? Z[9] === 0 : Z[9] === me % 11;
  }
  var re = {
    "bg-BG": /^\d{10}$/,
    "cs-CZ": /^\d{6}\/{0,1}\d{3,4}$/,
    "de-AT": /^\d{9}$/,
    "de-DE": /^[1-9]\d{10}$/,
    "dk-DK": /^\d{6}-{0,1}\d{4}$/,
    "el-CY": /^[09]\d{7}[A-Z]$/,
    "el-GR": /^([0-4]|[7-9])\d{8}$/,
    "en-CA": /^\d{9}$/,
    "en-GB": /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
    "en-IE": /^\d{7}[A-W][A-IW]{0,1}$/i,
    "en-US": /^\d{2}[- ]{0,1}\d{7}$/,
    "es-AR": /(20|23|24|27|30|33|34)[0-9]{8}[0-9]/,
    "es-ES": /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
    "et-EE": /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
    "fi-FI": /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
    "fr-BE": /^\d{11}$/,
    "fr-FR": /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
    // Conforms both to official spec and provided example
    "fr-LU": /^\d{13}$/,
    "hr-HR": /^\d{11}$/,
    "hu-HU": /^8\d{9}$/,
    "it-IT": /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
    "lv-LV": /^\d{6}-{0,1}\d{5}$/,
    // Conforms both to DG TAXUD spec and original research
    "mt-MT": /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
    "nl-NL": /^\d{9}$/,
    "pl-PL": /^\d{10,11}$/,
    "pt-BR": /(?:^\d{11}$)|(?:^\d{14}$)/,
    "pt-PT": /^\d{9}$/,
    "ro-RO": /^\d{13}$/,
    "sk-SK": /^\d{6}\/{0,1}\d{3,4}$/,
    "sl-SI": /^[1-9]\d{7}$/,
    "sv-SE": /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/,
    "uk-UA": /^\d{10}$/
  };
  re["lb-LU"] = re["fr-LU"], re["lt-LT"] = re["et-EE"], re["nl-BE"] = re["fr-BE"], re["fr-CA"] = re["en-CA"];
  var j = {
    "bg-BG": h,
    "cs-CZ": y,
    "de-AT": x,
    "de-DE": g,
    "dk-DK": S,
    "el-CY": w,
    "el-GR": _,
    "en-CA": m,
    "en-IE": b,
    "en-US": T,
    "es-AR": O,
    "es-ES": I,
    "et-EE": k,
    "fi-FI": B,
    "fr-BE": P,
    "fr-FR": N,
    "fr-LU": M,
    "hr-HR": H,
    "hu-HU": R,
    "it-IT": W,
    "lv-LV": F,
    "mt-MT": Y,
    "nl-NL": X,
    "pl-PL": q,
    "pt-BR": Q,
    "pt-PT": ue,
    "ro-RO": le,
    "sk-SK": te,
    "sl-SI": G,
    "sv-SE": oe,
    "uk-UA": L
  };
  j["lb-LU"] = j["fr-LU"], j["lt-LT"] = j["et-EE"], j["nl-BE"] = j["fr-BE"], j["fr-CA"] = j["en-CA"];
  var J = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g, ae = {
    "de-AT": J,
    "de-DE": /[\/\\]/g,
    "fr-BE": J
  };
  ae["nl-BE"] = ae["fr-BE"];
  function he(K) {
    var Z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
    (0, r.default)(K);
    var se = K.slice(0);
    if (Z in re)
      return Z in ae && (se = se.replace(ae[Z], "")), re[Z].test(se) ? Z in j ? j[Z](se) : !0 : !1;
    throw new Error("Invalid locale '".concat(Z, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(qw, qw.exports);
var rde = qw.exports, eh = {};
Object.defineProperty(eh, "__esModule", {
  value: !0
});
eh.default = ide;
eh.locales = void 0;
var ade = ode(st);
function ode(e) {
  return e && e.__esModule ? e : { default: e };
}
var er = {
  "am-AM": /^(\+?374|0)(33|4[134]|55|77|88|9[13-689])\d{6}$/,
  "ar-AE": /^((\+?971)|0)?5[024568]\d{7}$/,
  "ar-BH": /^(\+?973)?(3|6)\d{7}$/,
  "ar-DZ": /^(\+?213|0)(5|6|7)\d{8}$/,
  "ar-LB": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
  "ar-EG": /^((\+?20)|0)?1[0125]\d{8}$/,
  "ar-IQ": /^(\+?964|0)?7[0-9]\d{8}$/,
  "ar-JO": /^(\+?962|0)?7[789]\d{7}$/,
  "ar-KW": /^(\+?965)([569]\d{7}|41\d{6})$/,
  "ar-LY": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
  "ar-MA": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
  "ar-OM": /^((\+|00)968)?(9[1-9])\d{6}$/,
  "ar-PS": /^(\+?970|0)5[6|9](\d{7})$/,
  "ar-SA": /^(!?(\+?966)|0)?5\d{8}$/,
  "ar-SD": /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
  "ar-SY": /^(!?(\+?963)|0)?9\d{8}$/,
  "ar-TN": /^(\+?216)?[2459]\d{7}$/,
  "az-AZ": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
  "bs-BA": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
  "be-BY": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
  "bg-BG": /^(\+?359|0)?8[789]\d{7}$/,
  "bn-BD": /^(\+?880|0)1[13456789][0-9]{8}$/,
  "ca-AD": /^(\+376)?[346]\d{5}$/,
  "cs-CZ": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  "da-DK": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "de-DE": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
  "de-AT": /^(\+43|0)\d{1,4}\d{3,12}$/,
  "de-CH": /^(\+41|0)([1-9])\d{1,9}$/,
  "de-LU": /^(\+352)?((6\d1)\d{6})$/,
  "dv-MV": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
  "el-GR": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
  "el-CY": /^(\+?357?)?(9(9|6)\d{6})$/,
  "en-AI": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
  "en-AU": /^(\+?61|0)4\d{8}$/,
  "en-AG": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
  "en-BM": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
  "en-BS": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
  "en-GB": /^(\+?44|0)7\d{9}$/,
  "en-GG": /^(\+?44|0)1481\d{6}$/,
  "en-GH": /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
  "en-GY": /^(\+592|0)6\d{6}$/,
  "en-HK": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
  "en-MO": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
  "en-IE": /^(\+?353|0)8[356789]\d{7}$/,
  "en-IN": /^(\+?91|0)?[6789]\d{9}$/,
  "en-JM": /^(\+?876)?\d{7}$/,
  "en-KE": /^(\+?254|0)(7|1)\d{8}$/,
  "fr-CF": /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
  "en-SS": /^(\+?211|0)(9[1257])\d{7}$/,
  "en-KI": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
  "en-KN": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
  "en-LS": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
  "en-MT": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
  "en-MU": /^(\+?230|0)?\d{8}$/,
  "en-MW": /^(\+?265|0)(((77|88|31|99|98|21)\d{7})|(((111)|1)\d{6})|(32000\d{4}))$/,
  "en-NA": /^(\+?264|0)(6|8)\d{7}$/,
  "en-NG": /^(\+?234|0)?[789]\d{9}$/,
  "en-NZ": /^(\+?64|0)[28]\d{7,9}$/,
  "en-PG": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
  "en-PK": /^((00|\+)?92|0)3[0-6]\d{8}$/,
  "en-PH": /^(09|\+639)\d{9}$/,
  "en-RW": /^(\+?250|0)?[7]\d{8}$/,
  "en-SG": /^(\+65)?[3689]\d{7}$/,
  "en-SL": /^(\+?232|0)\d{8}$/,
  "en-TZ": /^(\+?255|0)?[67]\d{8}$/,
  "en-UG": /^(\+?256|0)?[7]\d{8}$/,
  "en-US": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
  "en-ZA": /^(\+?27|0)\d{9}$/,
  "en-ZM": /^(\+?26)?09[567]\d{7}$/,
  "en-ZW": /^(\+263)[0-9]{9}$/,
  "en-BW": /^(\+?267)?(7[1-8]{1})\d{6}$/,
  "es-AR": /^\+?549(11|[2368]\d)\d{8}$/,
  "es-BO": /^(\+?591)?(6|7)\d{7}$/,
  "es-CO": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
  "es-CL": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
  "es-CR": /^(\+506)?[2-8]\d{7}$/,
  "es-CU": /^(\+53|0053)?5\d{7}$/,
  "es-DO": /^(\+?1)?8[024]9\d{7}$/,
  "es-HN": /^(\+?504)?[9|8|3|2]\d{7}$/,
  "es-EC": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
  "es-ES": /^(\+?34)?[6|7]\d{8}$/,
  "es-PE": /^(\+?51)?9\d{8}$/,
  "es-MX": /^(\+?52)?(1|01)?\d{10,11}$/,
  "es-NI": /^(\+?505)\d{7,8}$/,
  "es-PA": /^(\+?507)\d{7,8}$/,
  "es-PY": /^(\+?595|0)9[9876]\d{7}$/,
  "es-SV": /^(\+?503)?[67]\d{7}$/,
  "es-UY": /^(\+598|0)9[1-9][\d]{6}$/,
  "es-VE": /^(\+?58)?(2|4)\d{9}$/,
  "et-EE": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
  "fa-IR": /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
  "fi-FI": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
  "fj-FJ": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
  "fo-FO": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "fr-BF": /^(\+226|0)[67]\d{7}$/,
  "fr-BJ": /^(\+229)\d{8}$/,
  "fr-CD": /^(\+?243|0)?(8|9)\d{8}$/,
  "fr-CM": /^(\+?237)6[0-9]{8}$/,
  "fr-FR": /^(\+?33|0)[67]\d{8}$/,
  "fr-GF": /^(\+?594|0|00594)[67]\d{8}$/,
  "fr-GP": /^(\+?590|0|00590)[67]\d{8}$/,
  "fr-MQ": /^(\+?596|0|00596)[67]\d{8}$/,
  "fr-PF": /^(\+?689)?8[789]\d{6}$/,
  "fr-RE": /^(\+?262|0|00262)[67]\d{8}$/,
  "fr-WF": /^(\+681)?\d{6}$/,
  "he-IL": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
  "hu-HU": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
  "id-ID": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
  "ir-IR": /^(\+98|0)?9\d{9}$/,
  "it-IT": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  "it-SM": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
  "ja-JP": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
  "ka-GE": /^(\+?995)?(79\d{7}|5\d{8})$/,
  "kk-KZ": /^(\+?7|8)?7\d{9}$/,
  "kl-GL": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "ko-KR": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
  "ky-KG": /^(\+?7\s?\+?7|0)\s?\d{2}\s?\d{3}\s?\d{4}$/,
  "lt-LT": /^(\+370|8)\d{8}$/,
  "lv-LV": /^(\+?371)2\d{7}$/,
  "mg-MG": /^((\+?261|0)(2|3)\d)?\d{7}$/,
  "mn-MN": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
  "my-MM": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
  "ms-MY": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
  "mz-MZ": /^(\+?258)?8[234567]\d{7}$/,
  "nb-NO": /^(\+?47)?[49]\d{7}$/,
  "ne-NP": /^(\+?977)?9[78]\d{8}$/,
  "nl-BE": /^(\+?32|0)4\d{8}$/,
  "nl-NL": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
  "nl-AW": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
  "nn-NO": /^(\+?47)?[49]\d{7}$/,
  "pl-PL": /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
  "pt-BR": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
  "pt-PT": /^(\+?351)?9[1236]\d{7}$/,
  "pt-AO": /^(\+244)\d{9}$/,
  "ro-MD": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
  "ro-RO": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
  "ru-RU": /^(\+?7|8)?9\d{9}$/,
  "si-LK": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
  "sl-SI": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
  "sk-SK": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  "so-SO": /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
  "sq-AL": /^(\+355|0)6[789]\d{6}$/,
  "sr-RS": /^(\+3816|06)[- \d]{5,9}$/,
  "sv-SE": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
  "tg-TJ": /^(\+?992)?[5][5]\d{7}$/,
  "th-TH": /^(\+66|66|0)\d{9}$/,
  "tr-TR": /^(\+?90|0)?5\d{9}$/,
  "tk-TM": /^(\+993|993|8)\d{8}$/,
  "uk-UA": /^(\+?38|8)?0\d{9}$/,
  "uz-UZ": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
  "vi-VN": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
  "zh-CN": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
  "zh-TW": /^(\+?886\-?|0)?9\d{8}$/,
  "dz-BT": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
  "ar-YE": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
  "ar-EH": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
  "fa-AF": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/
};
er["en-CA"] = er["en-US"];
er["fr-CA"] = er["en-CA"];
er["fr-BE"] = er["nl-BE"];
er["zh-HK"] = er["en-HK"];
er["zh-MO"] = er["en-MO"];
er["ga-IE"] = er["en-IE"];
er["fr-CH"] = er["de-CH"];
er["it-CH"] = er["fr-CH"];
function ide(e, t, n) {
  if ((0, ade.default)(e), n && n.strictMode && !e.startsWith("+"))
    return !1;
  if (Array.isArray(t))
    return t.some(function(o) {
      if (er.hasOwnProperty(o)) {
        var i = er[o];
        if (i.test(e))
          return !0;
      }
      return !1;
    });
  if (t in er)
    return er[t].test(e);
  if (!t || t === "any") {
    for (var r in er)
      if (er.hasOwnProperty(r)) {
        var a = er[r];
        if (a.test(e))
          return !0;
      }
    return !1;
  }
  throw new Error("Invalid locale '".concat(t, "'"));
}
eh.locales = Object.keys(er);
var Xw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /^(0x)[0-9a-f]{40}$/i;
  function o(i) {
    return (0, n.default)(i), a.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Xw, Xw.exports);
var sde = Xw.exports, Zw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var n = a(Ja), r = a(st);
  function a(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function o(l) {
    var u = "\\d{".concat(l.digits_after_decimal[0], "}");
    l.digits_after_decimal.forEach(function(x, g) {
      g !== 0 && (u = "".concat(u, "|\\d{").concat(x, "}"));
    });
    var c = "(".concat(l.symbol.replace(/\W/, function(x) {
      return "\\".concat(x);
    }), ")").concat(l.require_symbol ? "" : "?"), f = "-?", d = "[1-9]\\d*", p = "[1-9]\\d{0,2}(\\".concat(l.thousands_separator, "\\d{3})*"), v = ["0", d, p], h = "(".concat(v.join("|"), ")?"), m = "(\\".concat(l.decimal_separator, "(").concat(u, "))").concat(l.require_decimal ? "" : "?"), y = h + (l.allow_decimal || l.require_decimal ? m : "");
    return l.allow_negatives && !l.parens_for_negatives && (l.negative_sign_after_digits ? y += f : l.negative_sign_before_digits && (y = f + y)), l.allow_negative_sign_placeholder ? y = "( (?!\\-))?".concat(y) : l.allow_space_after_symbol ? y = " ?".concat(y) : l.allow_space_after_digits && (y += "( (?!$))?"), l.symbol_after_digits ? y += c : y = c + y, l.allow_negatives && (l.parens_for_negatives ? y = "(\\(".concat(y, "\\)|").concat(y, ")") : l.negative_sign_before_digits || l.negative_sign_after_digits || (y = f + y)), new RegExp("^(?!-? )(?=.*\\d)".concat(y, "$"));
  }
  var i = {
    symbol: "$",
    require_symbol: !1,
    allow_space_after_symbol: !1,
    symbol_after_digits: !1,
    allow_negatives: !0,
    parens_for_negatives: !1,
    negative_sign_before_digits: !1,
    negative_sign_after_digits: !1,
    allow_negative_sign_placeholder: !1,
    thousands_separator: ",",
    decimal_separator: ".",
    allow_decimal: !0,
    require_decimal: !1,
    digits_after_decimal: [2],
    allow_space_after_digits: !1
  };
  function s(l, u) {
    return (0, r.default)(l), u = (0, n.default)(u, i), o(u).test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Zw, Zw.exports);
var lde = Zw.exports, Qw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = r(st);
  function r(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var a = /^(bc1)[a-z0-9]{25,39}$/, o = /^(1|3)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
  function i(s) {
    return (0, n.default)(s), a.test(s) || o.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Qw, Qw.exports);
var ude = Qw.exports, th = {};
Object.defineProperty(th, "__esModule", {
  value: !0
});
th.isFreightContainerID = void 0;
th.isISO6346 = eM;
var cde = fde(st);
function fde(e) {
  return e && e.__esModule ? e : { default: e };
}
var dde = /^[A-Z]{3}(U[0-9]{7})|([J,Z][0-9]{6,7})$/, pde = /^[0-9]$/;
function eM(e) {
  if ((0, cde.default)(e), e = e.toUpperCase(), !dde.test(e)) return !1;
  if (e.length === 11) {
    for (var t = 0, n = 0; n < e.length - 1; n++)
      if (pde.test(e[n]))
        t += e[n] * Math.pow(2, n);
      else {
        var r = void 0, a = e.charCodeAt(n) - 55;
        a < 11 ? r = a : a >= 11 && a <= 20 ? r = 12 + a % 11 : a >= 21 && a <= 30 ? r = 23 + a % 21 : r = 34 + a % 31, t += r * Math.pow(2, n);
      }
    var o = t % 11;
    return Number(e[e.length - 1]) === o;
  }
  return !0;
}
th.isFreightContainerID = eM;
var Jw = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /* @__PURE__ */ new Set(["aa", "ab", "ae", "af", "ak", "am", "an", "ar", "as", "av", "ay", "az", "az", "ba", "be", "bg", "bh", "bi", "bm", "bn", "bo", "br", "bs", "ca", "ce", "ch", "co", "cr", "cs", "cu", "cv", "cy", "da", "de", "dv", "dz", "ee", "el", "en", "eo", "es", "et", "eu", "fa", "ff", "fi", "fj", "fo", "fr", "fy", "ga", "gd", "gl", "gn", "gu", "gv", "ha", "he", "hi", "ho", "hr", "ht", "hu", "hy", "hz", "ia", "id", "ie", "ig", "ii", "ik", "io", "is", "it", "iu", "ja", "jv", "ka", "kg", "ki", "kj", "kk", "kl", "km", "kn", "ko", "kr", "ks", "ku", "kv", "kw", "ky", "la", "lb", "lg", "li", "ln", "lo", "lt", "lu", "lv", "mg", "mh", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my", "na", "nb", "nd", "ne", "ng", "nl", "nn", "no", "nr", "nv", "ny", "oc", "oj", "om", "or", "os", "pa", "pi", "pl", "ps", "pt", "qu", "rm", "rn", "ro", "ru", "rw", "sa", "sc", "sd", "se", "sg", "si", "sk", "sl", "sm", "sn", "so", "sq", "sr", "ss", "st", "su", "sv", "sw", "ta", "te", "tg", "th", "ti", "tk", "tl", "tn", "to", "tr", "ts", "tt", "tw", "ty", "ug", "uk", "ur", "uz", "ve", "vi", "vo", "wa", "wo", "xh", "yi", "yo", "za", "zh", "zu"]);
  function o(i) {
    return (0, n.default)(i), a.has(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Jw, Jw.exports);
var hde = Jw.exports, eS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var n = r(st);
  function r(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var a = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, o = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, i = function(u) {
    var c = u.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
    if (c) {
      var f = Number(c[1]), d = Number(c[2]);
      return f % 4 === 0 && f % 100 !== 0 || f % 400 === 0 ? d <= 366 : d <= 365;
    }
    var p = u.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number), v = p[1], h = p[2], m = p[3], y = h && "0".concat(h).slice(-2), x = m && "0".concat(m).slice(-2), g = new Date("".concat(v, "-").concat(y || "01", "-").concat(x || "01"));
    return h && m ? g.getUTCFullYear() === v && g.getUTCMonth() + 1 === h && g.getUTCDate() === m : !0;
  };
  function s(l) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, n.default)(l);
    var c = u.strictSeparator ? o.test(l) : a.test(l);
    return c && u.strict ? i(l) : c;
  }
  e.exports = t.default, e.exports.default = t.default;
})(eS, eS.exports);
var vde = eS.exports, tS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = y;
  var n = r(st);
  function r(x) {
    return x && x.__esModule ? x : { default: x };
  }
  var a = /[0-9]{4}/, o = /(0[1-9]|1[0-2])/, i = /([12]\d|0[1-9]|3[01])/, s = /([01][0-9]|2[0-3])/, l = /[0-5][0-9]/, u = /([0-5][0-9]|60)/, c = /(\.[0-9]+)?/, f = new RegExp("[-+]".concat(s.source, ":").concat(l.source)), d = new RegExp("([zZ]|".concat(f.source, ")")), p = new RegExp("".concat(s.source, ":").concat(l.source, ":").concat(u.source).concat(c.source)), v = new RegExp("".concat(a.source, "-").concat(o.source, "-").concat(i.source)), h = new RegExp("".concat(p.source).concat(d.source)), m = new RegExp("^".concat(v.source, "[ tT]").concat(h.source, "$"));
  function y(x) {
    return (0, n.default)(x), m.test(x);
  }
  e.exports = t.default, e.exports.default = t.default;
})(tS, tS.exports);
var mde = tS.exports, nS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /* @__PURE__ */ new Set(["AFG", "ALA", "ALB", "DZA", "ASM", "AND", "AGO", "AIA", "ATA", "ATG", "ARG", "ARM", "ABW", "AUS", "AUT", "AZE", "BHS", "BHR", "BGD", "BRB", "BLR", "BEL", "BLZ", "BEN", "BMU", "BTN", "BOL", "BES", "BIH", "BWA", "BVT", "BRA", "IOT", "BRN", "BGR", "BFA", "BDI", "KHM", "CMR", "CAN", "CPV", "CYM", "CAF", "TCD", "CHL", "CHN", "CXR", "CCK", "COL", "COM", "COG", "COD", "COK", "CRI", "CIV", "HRV", "CUB", "CUW", "CYP", "CZE", "DNK", "DJI", "DMA", "DOM", "ECU", "EGY", "SLV", "GNQ", "ERI", "EST", "ETH", "FLK", "FRO", "FJI", "FIN", "FRA", "GUF", "PYF", "ATF", "GAB", "GMB", "GEO", "DEU", "GHA", "GIB", "GRC", "GRL", "GRD", "GLP", "GUM", "GTM", "GGY", "GIN", "GNB", "GUY", "HTI", "HMD", "VAT", "HND", "HKG", "HUN", "ISL", "IND", "IDN", "IRN", "IRQ", "IRL", "IMN", "ISR", "ITA", "JAM", "JPN", "JEY", "JOR", "KAZ", "KEN", "KIR", "PRK", "KOR", "KWT", "KGZ", "LAO", "LVA", "LBN", "LSO", "LBR", "LBY", "LIE", "LTU", "LUX", "MAC", "MKD", "MDG", "MWI", "MYS", "MDV", "MLI", "MLT", "MHL", "MTQ", "MRT", "MUS", "MYT", "MEX", "FSM", "MDA", "MCO", "MNG", "MNE", "MSR", "MAR", "MOZ", "MMR", "NAM", "NRU", "NPL", "NLD", "NCL", "NZL", "NIC", "NER", "NGA", "NIU", "NFK", "MNP", "NOR", "OMN", "PAK", "PLW", "PSE", "PAN", "PNG", "PRY", "PER", "PHL", "PCN", "POL", "PRT", "PRI", "QAT", "REU", "ROU", "RUS", "RWA", "BLM", "SHN", "KNA", "LCA", "MAF", "SPM", "VCT", "WSM", "SMR", "STP", "SAU", "SEN", "SRB", "SYC", "SLE", "SGP", "SXM", "SVK", "SVN", "SLB", "SOM", "ZAF", "SGS", "SSD", "ESP", "LKA", "SDN", "SUR", "SJM", "SWZ", "SWE", "CHE", "SYR", "TWN", "TJK", "TZA", "THA", "TLS", "TGO", "TKL", "TON", "TTO", "TUN", "TUR", "TKM", "TCA", "TUV", "UGA", "UKR", "ARE", "GBR", "USA", "UMI", "URY", "UZB", "VUT", "VEN", "VNM", "VGB", "VIR", "WLF", "ESH", "YEM", "ZMB", "ZWE"]);
  function o(i) {
    return (0, n.default)(i), a.has(i.toUpperCase());
  }
  e.exports = t.default, e.exports.default = t.default;
})(nS, nS.exports);
var gde = nS.exports, nh = {};
Object.defineProperty(nh, "__esModule", {
  value: !0
});
nh.CurrencyCodes = void 0;
nh.default = bde;
var yde = xde(st);
function xde(e) {
  return e && e.__esModule ? e : { default: e };
}
var tM = /* @__PURE__ */ new Set(["AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BOV", "BRL", "BSD", "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHE", "CHF", "CHW", "CLF", "CLP", "CNY", "COP", "COU", "CRC", "CUC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HRK", "HTG", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MXV", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLE", "SLL", "SOS", "SRD", "SSP", "STN", "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "USN", "UYI", "UYU", "UYW", "UZS", "VES", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XBA", "XBB", "XBC", "XBD", "XCD", "XDR", "XOF", "XPD", "XPF", "XPT", "XSU", "XTS", "XUA", "XXX", "YER", "ZAR", "ZMW", "ZWL"]);
function bde(e) {
  return (0, yde.default)(e), tM.has(e.toUpperCase());
}
nh.CurrencyCodes = tM;
var rS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var n = a(st), r = a(Ja);
  function a(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var o = /^[A-Z2-7]+=*$/, i = /^[A-HJKMNP-TV-Z0-9]+$/, s = {
    crockford: !1
  };
  function l(u, c) {
    if ((0, n.default)(u), c = (0, r.default)(c, s), c.crockford)
      return i.test(u);
    var f = u.length;
    return !!(f % 8 === 0 && o.test(u));
  }
  e.exports = t.default, e.exports.default = t.default;
})(rS, rS.exports);
var wde = rS.exports, aS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /^[A-HJ-NP-Za-km-z1-9]*$/;
  function o(i) {
    return (0, n.default)(i), !!a.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(aS, aS.exports);
var Sde = aS.exports, oS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var n = r(st);
  function r(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var a = /^[a-z]+\/[a-z0-9\-\+\._]+$/i, o = /^[a-z\-]+=[a-z0-9\-]+$/i, i = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
  function s(l) {
    (0, n.default)(l);
    var u = l.split(",");
    if (u.length < 2)
      return !1;
    var c = u.shift().trim().split(";"), f = c.shift();
    if (f.slice(0, 5) !== "data:")
      return !1;
    var d = f.slice(5);
    if (d !== "" && !a.test(d))
      return !1;
    for (var p = 0; p < c.length; p++)
      if (!(p === c.length - 1 && c[p].toLowerCase() === "base64") && !o.test(c[p]))
        return !1;
    for (var v = 0; v < u.length; v++)
      if (!i.test(u[v]))
        return !1;
    return !0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(oS, oS.exports);
var _de = oS.exports, iS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /(?:^magnet:\?|[^?&]&)xt(?:\.1)?=urn:(?:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?|btmh:1220[a-z0-9]{64})(?:$|&)/i;
  function o(i) {
    return (0, n.default)(i), i.indexOf("magnet:?") !== 0 ? !1 : a.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(iS, iS.exports);
var Cde = iS.exports, sS = { exports: {} }, lS = { exports: {} }, uS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o, i) {
    if ((0, n.default)(o), i) {
      var s = new RegExp("[".concat(i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+$"), "g");
      return o.replace(s, "");
    }
    for (var l = o.length - 1; /\s/.test(o.charAt(l)); )
      l -= 1;
    return o.slice(0, l + 1);
  }
  e.exports = t.default, e.exports.default = t.default;
})(uS, uS.exports);
var nM = uS.exports, cS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o, i) {
    (0, n.default)(o);
    var s = i ? new RegExp("^[".concat(i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+"), "g") : /^\s+/g;
    return o.replace(s, "");
  }
  e.exports = t.default, e.exports.default = t.default;
})(cS, cS.exports);
var rM = cS.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = a(nM), r = a(rM);
  function a(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i, s) {
    return (0, n.default)((0, r.default)(i, s), s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(lS, lS.exports);
var aM = lS.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = v;
  var n = o(aM), r = o(Y7), a = o(st);
  function o(h) {
    return h && h.__esModule ? h : { default: h };
  }
  function i(h, m) {
    return u(h) || l(h, m) || f(h, m) || s();
  }
  function s() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function l(h, m) {
    var y = h == null ? null : typeof Symbol < "u" && h[Symbol.iterator] || h["@@iterator"];
    if (y != null) {
      var x, g, S, w, _ = [], b = !0, E = !1;
      try {
        if (S = (y = y.call(h)).next, m !== 0) for (; !(b = (x = S.call(y)).done) && (_.push(x.value), _.length !== m); b = !0) ;
      } catch (C) {
        E = !0, g = C;
      } finally {
        try {
          if (!b && y.return != null && (w = y.return(), Object(w) !== w)) return;
        } finally {
          if (E) throw g;
        }
      }
      return _;
    }
  }
  function u(h) {
    if (Array.isArray(h)) return h;
  }
  function c(h, m) {
    var y = typeof Symbol < "u" && h[Symbol.iterator] || h["@@iterator"];
    if (!y) {
      if (Array.isArray(h) || (y = f(h)) || m) {
        y && (h = y);
        var x = 0, g = function() {
        };
        return { s: g, n: function() {
          return x >= h.length ? { done: !0 } : { done: !1, value: h[x++] };
        }, e: function(E) {
          throw E;
        }, f: g };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var S = !0, w = !1, _;
    return { s: function() {
      y = y.call(h);
    }, n: function() {
      var E = y.next();
      return S = E.done, E;
    }, e: function(E) {
      w = !0, _ = E;
    }, f: function() {
      try {
        !S && y.return != null && y.return();
      } finally {
        if (w) throw _;
      }
    } };
  }
  function f(h, m) {
    if (h) {
      if (typeof h == "string") return d(h, m);
      var y = Object.prototype.toString.call(h).slice(8, -1);
      if (y === "Object" && h.constructor && (y = h.constructor.name), y === "Map" || y === "Set") return Array.from(h);
      if (y === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(y)) return d(h, m);
    }
  }
  function d(h, m) {
    (m == null || m > h.length) && (m = h.length);
    for (var y = 0, x = new Array(m); y < m; y++) x[y] = h[y];
    return x;
  }
  function p(h) {
    var m = /* @__PURE__ */ new Set(["subject", "body", "cc", "bcc"]), y = {
      cc: "",
      bcc: ""
    }, x = !1, g = h.split("&");
    if (g.length > 4)
      return !1;
    var S = c(g), w;
    try {
      for (S.s(); !(w = S.n()).done; ) {
        var _ = w.value, b = _.split("="), E = i(b, 2), C = E[0], T = E[1];
        if (C && !m.has(C)) {
          x = !0;
          break;
        }
        T && (C === "cc" || C === "bcc") && (y[C] = T), C && m.delete(C);
      }
    } catch (O) {
      S.e(O);
    } finally {
      S.f();
    }
    return x ? !1 : y;
  }
  function v(h, m) {
    if ((0, a.default)(h), h.indexOf("mailto:") !== 0)
      return !1;
    var y = h.replace("mailto:", "").split("?"), x = i(y, 2), g = x[0], S = x[1], w = S === void 0 ? "" : S;
    if (!g && !w)
      return !0;
    var _ = p(w);
    return _ ? "".concat(g, ",").concat(_.cc, ",").concat(_.bcc).split(",").every(function(b) {
      return b = (0, n.default)(b, " "), b ? (0, r.default)(b, m) : !0;
    }) : !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(sS, sS.exports);
var Ede = sS.exports, fS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var n = r(st);
  function r(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var a = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+_]{1,100}$/i, o = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i, i = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i;
  function s(l) {
    return (0, n.default)(l), a.test(l) || o.test(l) || i.test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(fS, fS.exports);
var Tde = fS.exports, dS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var n = a(st), r = a(Ja);
  function a(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var o = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/, i = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/, s = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i, l = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i, u = {
    checkDMS: !1
  };
  function c(f, d) {
    if ((0, n.default)(f), d = (0, r.default)(d, u), !f.includes(",")) return !1;
    var p = f.split(",");
    return p[0].startsWith("(") && !p[1].endsWith(")") || p[1].endsWith(")") && !p[0].startsWith("(") ? !1 : d.checkDMS ? s.test(p[0]) && l.test(p[1]) : o.test(p[0]) && i.test(p[1]);
  }
  e.exports = t.default, e.exports.default = t.default;
})(dS, dS.exports);
var $de = dS.exports, rh = {};
Object.defineProperty(rh, "__esModule", {
  value: !0
});
rh.default = Ide;
rh.locales = void 0;
var Ode = Ade(st);
function Ade(e) {
  return e && e.__esModule ? e : { default: e };
}
var m6 = /^\d{3}$/, xo = /^\d{4}$/, La = /^\d{5}$/, vx = /^\d{6}$/, lf = {
  AD: /^AD\d{3}$/,
  AT: xo,
  AU: xo,
  AZ: /^AZ\d{4}$/,
  BA: /^([7-8]\d{4}$)/,
  BE: xo,
  BG: xo,
  BR: /^\d{5}-\d{3}$/,
  BY: /^2[1-4]\d{4}$/,
  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
  CH: xo,
  CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
  CZ: /^\d{3}\s?\d{2}$/,
  DE: La,
  DK: xo,
  DO: La,
  DZ: La,
  EE: La,
  ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
  FI: La,
  FR: /^\d{2}\s?\d{3}$/,
  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
  GR: /^\d{3}\s?\d{2}$/,
  HR: /^([1-5]\d{4}$)/,
  HT: /^HT\d{4}$/,
  HU: xo,
  ID: La,
  IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
  IL: /^(\d{5}|\d{7})$/,
  IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
  IR: /^(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}$/,
  IS: m6,
  IT: La,
  JP: /^\d{3}\-\d{4}$/,
  KE: La,
  KR: /^(\d{5}|\d{6})$/,
  LI: /^(948[5-9]|949[0-7])$/,
  LT: /^LT\-\d{5}$/,
  LU: xo,
  LV: /^LV\-\d{4}$/,
  LK: La,
  MG: m6,
  MX: La,
  MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
  MY: La,
  NL: /^[1-9]\d{3}\s?(?!sa|sd|ss)[a-z]{2}$/i,
  NO: xo,
  NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
  NZ: xo,
  PL: /^\d{2}\-\d{3}$/,
  PR: /^00[679]\d{2}([ -]\d{4})?$/,
  PT: /^\d{4}\-\d{3}?$/,
  RO: vx,
  RU: vx,
  SA: La,
  SE: /^[1-9]\d{2}\s?\d{2}$/,
  SG: vx,
  SI: xo,
  SK: /^\d{3}\s?\d{2}$/,
  TH: La,
  TN: xo,
  TW: /^\d{3}(\d{2})?$/,
  UA: La,
  US: /^\d{5}(-\d{4})?$/,
  ZA: xo,
  ZM: La
};
rh.locales = Object.keys(lf);
function Ide(e, t) {
  if ((0, Ode.default)(e), t in lf)
    return lf[t].test(e);
  if (t === "any") {
    for (var n in lf)
      if (lf.hasOwnProperty(n)) {
        var r = lf[n];
        if (r.test(e))
          return !0;
      }
    return !1;
  }
  throw new Error("Invalid locale '".concat(t, "'"));
}
var pS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o) {
    return (0, n.default)(o), o.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;").replace(/\\/g, "&#x5C;").replace(/`/g, "&#96;");
  }
  e.exports = t.default, e.exports.default = t.default;
})(pS, pS.exports);
var Pde = pS.exports, hS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o) {
    return (0, n.default)(o), o.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#x2F;/g, "/").replace(/&#x5C;/g, "\\").replace(/&#96;/g, "`").replace(/&amp;/g, "&");
  }
  e.exports = t.default, e.exports.default = t.default;
})(hS, hS.exports);
var Dde = hS.exports, vS = { exports: {} }, mS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o, i) {
    return (0, n.default)(o), o.replace(new RegExp("[".concat(i, "]+"), "g"), "");
  }
  e.exports = t.default, e.exports.default = t.default;
})(mS, mS.exports);
var oM = mS.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = a(st), r = a(oM);
  function a(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i, s) {
    (0, n.default)(i);
    var l = s ? "\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F" : "\\x00-\\x1F\\x7F";
    return (0, r.default)(i, l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(vS, vS.exports);
var kde = vS.exports, gS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o, i) {
    return (0, n.default)(o), o.replace(new RegExp("[^".concat(i, "]+"), "g"), "");
  }
  e.exports = t.default, e.exports.default = t.default;
})(gS, gS.exports);
var Mde = gS.exports, yS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(st);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o, i) {
    (0, n.default)(o);
    for (var s = o.length - 1; s >= 0; s--)
      if (i.indexOf(o[s]) === -1)
        return !1;
    return !0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(yS, yS.exports);
var Rde = yS.exports, xS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var n = r(Ja);
  function r(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var a = {
    // The following options apply to all email addresses
    // Lowercases the local part of the email address.
    // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
    // The domain is always lowercased, as per RFC 1035
    all_lowercase: !0,
    // The following conversions are specific to GMail
    // Lowercases the local part of the GMail address (known to be case-insensitive)
    gmail_lowercase: !0,
    // Removes dots from the local part of the email address, as that's ignored by GMail
    gmail_remove_dots: !0,
    // Removes the subaddress (e.g. "+foo") from the email address
    gmail_remove_subaddress: !0,
    // Conversts the googlemail.com domain to gmail.com
    gmail_convert_googlemaildotcom: !0,
    // The following conversions are specific to Outlook.com / Windows Live / Hotmail
    // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
    outlookdotcom_lowercase: !0,
    // Removes the subaddress (e.g. "+foo") from the email address
    outlookdotcom_remove_subaddress: !0,
    // The following conversions are specific to Yahoo
    // Lowercases the local part of the Yahoo address (known to be case-insensitive)
    yahoo_lowercase: !0,
    // Removes the subaddress (e.g. "-foo") from the email address
    yahoo_remove_subaddress: !0,
    // The following conversions are specific to Yandex
    // Lowercases the local part of the Yandex address (known to be case-insensitive)
    yandex_lowercase: !0,
    // The following conversions are specific to iCloud
    // Lowercases the local part of the iCloud address (known to be case-insensitive)
    icloud_lowercase: !0,
    // Removes the subaddress (e.g. "+foo") from the email address
    icloud_remove_subaddress: !0
  }, o = ["icloud.com", "me.com"], i = ["hotmail.at", "hotmail.be", "hotmail.ca", "hotmail.cl", "hotmail.co.il", "hotmail.co.nz", "hotmail.co.th", "hotmail.co.uk", "hotmail.com", "hotmail.com.ar", "hotmail.com.au", "hotmail.com.br", "hotmail.com.gr", "hotmail.com.mx", "hotmail.com.pe", "hotmail.com.tr", "hotmail.com.vn", "hotmail.cz", "hotmail.de", "hotmail.dk", "hotmail.es", "hotmail.fr", "hotmail.hu", "hotmail.id", "hotmail.ie", "hotmail.in", "hotmail.it", "hotmail.jp", "hotmail.kr", "hotmail.lv", "hotmail.my", "hotmail.ph", "hotmail.pt", "hotmail.sa", "hotmail.sg", "hotmail.sk", "live.be", "live.co.uk", "live.com", "live.com.ar", "live.com.mx", "live.de", "live.es", "live.eu", "live.fr", "live.it", "live.nl", "msn.com", "outlook.at", "outlook.be", "outlook.cl", "outlook.co.il", "outlook.co.nz", "outlook.co.th", "outlook.com", "outlook.com.ar", "outlook.com.au", "outlook.com.br", "outlook.com.gr", "outlook.com.pe", "outlook.com.tr", "outlook.com.vn", "outlook.cz", "outlook.de", "outlook.dk", "outlook.es", "outlook.fr", "outlook.hu", "outlook.id", "outlook.ie", "outlook.in", "outlook.it", "outlook.jp", "outlook.kr", "outlook.lv", "outlook.my", "outlook.ph", "outlook.pt", "outlook.sa", "outlook.sg", "outlook.sk", "passport.com"], s = ["rocketmail.com", "yahoo.ca", "yahoo.co.uk", "yahoo.com", "yahoo.de", "yahoo.fr", "yahoo.in", "yahoo.it", "ymail.com"], l = ["yandex.ru", "yandex.ua", "yandex.kz", "yandex.com", "yandex.by", "ya.ru"];
  function u(f) {
    return f.length > 1 ? f : "";
  }
  function c(f, d) {
    d = (0, n.default)(d, a);
    var p = f.split("@"), v = p.pop(), h = p.join("@"), m = [h, v];
    if (m[1] = m[1].toLowerCase(), m[1] === "gmail.com" || m[1] === "googlemail.com") {
      if (d.gmail_remove_subaddress && (m[0] = m[0].split("+")[0]), d.gmail_remove_dots && (m[0] = m[0].replace(/\.+/g, u)), !m[0].length)
        return !1;
      (d.all_lowercase || d.gmail_lowercase) && (m[0] = m[0].toLowerCase()), m[1] = d.gmail_convert_googlemaildotcom ? "gmail.com" : m[1];
    } else if (o.indexOf(m[1]) >= 0) {
      if (d.icloud_remove_subaddress && (m[0] = m[0].split("+")[0]), !m[0].length)
        return !1;
      (d.all_lowercase || d.icloud_lowercase) && (m[0] = m[0].toLowerCase());
    } else if (i.indexOf(m[1]) >= 0) {
      if (d.outlookdotcom_remove_subaddress && (m[0] = m[0].split("+")[0]), !m[0].length)
        return !1;
      (d.all_lowercase || d.outlookdotcom_lowercase) && (m[0] = m[0].toLowerCase());
    } else if (s.indexOf(m[1]) >= 0) {
      if (d.yahoo_remove_subaddress) {
        var y = m[0].split("-");
        m[0] = y.length > 1 ? y.slice(0, -1).join("-") : y[0];
      }
      if (!m[0].length)
        return !1;
      (d.all_lowercase || d.yahoo_lowercase) && (m[0] = m[0].toLowerCase());
    } else l.indexOf(m[1]) >= 0 ? ((d.all_lowercase || d.yandex_lowercase) && (m[0] = m[0].toLowerCase()), m[1] = "yandex.ru") : d.all_lowercase && (m[0] = m[0].toLowerCase());
    return m.join("@");
  }
  e.exports = t.default, e.exports.default = t.default;
})(xS, xS.exports);
var Nde = xS.exports, bS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
  function o(i) {
    return (0, n.default)(i), a.test(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(bS, bS.exports);
var Fde = bS.exports, wS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(st);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = {
    "cs-CZ": function(s) {
      return /^(([ABCDEFHIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(s);
    },
    "de-DE": function(s) {
      return /^((A|AA|AB|AC|AE|AH|AK|AM|AN|AÖ|AP|AS|AT|AU|AW|AZ|B|BA|BB|BC|BE|BF|BH|BI|BK|BL|BM|BN|BO|BÖ|BS|BT|BZ|C|CA|CB|CE|CO|CR|CW|D|DA|DD|DE|DH|DI|DL|DM|DN|DO|DU|DW|DZ|E|EA|EB|ED|EE|EF|EG|EH|EI|EL|EM|EN|ER|ES|EU|EW|F|FB|FD|FF|FG|FI|FL|FN|FO|FR|FS|FT|FÜ|FW|FZ|G|GA|GC|GD|GE|GF|GG|GI|GK|GL|GM|GN|GÖ|GP|GR|GS|GT|GÜ|GV|GW|GZ|H|HA|HB|HC|HD|HE|HF|HG|HH|HI|HK|HL|HM|HN|HO|HP|HR|HS|HU|HV|HX|HY|HZ|IK|IL|IN|IZ|J|JE|JL|K|KA|KB|KC|KE|KF|KG|KH|KI|KK|KL|KM|KN|KO|KR|KS|KT|KU|KW|KY|L|LA|LB|LC|LD|LF|LG|LH|LI|LL|LM|LN|LÖ|LP|LR|LU|M|MA|MB|MC|MD|ME|MG|MH|MI|MK|ML|MM|MN|MO|MQ|MR|MS|MÜ|MW|MY|MZ|N|NB|ND|NE|NF|NH|NI|NK|NM|NÖ|NP|NR|NT|NU|NW|NY|NZ|OA|OB|OC|OD|OE|OF|OG|OH|OK|OL|OP|OS|OZ|P|PA|PB|PE|PF|PI|PL|PM|PN|PR|PS|PW|PZ|R|RA|RC|RD|RE|RG|RH|RI|RL|RM|RN|RO|RP|RS|RT|RU|RV|RW|RZ|S|SB|SC|SE|SG|SI|SK|SL|SM|SN|SO|SP|SR|ST|SU|SW|SY|SZ|TE|TF|TG|TO|TP|TR|TS|TT|TÜ|ÜB|UE|UH|UL|UM|UN|V|VB|VG|VK|VR|VS|W|WA|WB|WE|WF|WI|WK|WL|WM|WN|WO|WR|WS|WT|WÜ|WW|WZ|Z|ZE|ZI|ZP|ZR|ZW|ZZ)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(ABG|ABI|AIB|AIC|ALF|ALZ|ANA|ANG|ANK|APD|ARN|ART|ASL|ASZ|AUR|AZE|BAD|BAR|BBG|BCH|BED|BER|BGD|BGL|BID|BIN|BIR|BIT|BIW|BKS|BLB|BLK|BNA|BOG|BOH|BOR|BOT|BRA|BRB|BRG|BRK|BRL|BRV|BSB|BSK|BTF|BÜD|BUL|BÜR|BÜS|BÜZ|CAS|CHA|CLP|CLZ|COC|COE|CUX|DAH|DAN|DAU|DBR|DEG|DEL|DGF|DIL|DIN|DIZ|DKB|DLG|DON|DUD|DÜW|EBE|EBN|EBS|ECK|EIC|EIL|EIN|EIS|EMD|EMS|ERB|ERH|ERK|ERZ|ESB|ESW|FDB|FDS|FEU|FFB|FKB|FLÖ|FOR|FRG|FRI|FRW|FTL|FÜS|GAN|GAP|GDB|GEL|GEO|GER|GHA|GHC|GLA|GMN|GNT|GOA|GOH|GRA|GRH|GRI|GRM|GRZ|GTH|GUB|GUN|GVM|HAB|HAL|HAM|HAS|HBN|HBS|HCH|HDH|HDL|HEB|HEF|HEI|HER|HET|HGN|HGW|HHM|HIG|HIP|HMÜ|HOG|HOH|HOL|HOM|HOR|HÖS|HOT|HRO|HSK|HST|HVL|HWI|IGB|ILL|JÜL|KEH|KEL|KEM|KIB|KLE|KLZ|KÖN|KÖT|KÖZ|KRU|KÜN|KUS|KYF|LAN|LAU|LBS|LBZ|LDK|LDS|LEO|LER|LEV|LIB|LIF|LIP|LÖB|LOS|LRO|LSZ|LÜN|LUP|LWL|MAB|MAI|MAK|MAL|MED|MEG|MEI|MEK|MEL|MER|MET|MGH|MGN|MHL|MIL|MKK|MOD|MOL|MON|MOS|MSE|MSH|MSP|MST|MTK|MTL|MÜB|MÜR|MYK|MZG|NAB|NAI|NAU|NDH|NEA|NEB|NEC|NEN|NES|NEW|NMB|NMS|NOH|NOL|NOM|NOR|NVP|NWM|OAL|OBB|OBG|OCH|OHA|ÖHR|OHV|OHZ|OPR|OSL|OVI|OVL|OVP|PAF|PAN|PAR|PCH|PEG|PIR|PLÖ|PRÜ|QFT|QLB|RDG|REG|REH|REI|RID|RIE|ROD|ROF|ROK|ROL|ROS|ROT|ROW|RSL|RÜD|RÜG|SAB|SAD|SAN|SAW|SBG|SBK|SCZ|SDH|SDL|SDT|SEB|SEE|SEF|SEL|SFB|SFT|SGH|SHA|SHG|SHK|SHL|SIG|SIM|SLE|SLF|SLK|SLN|SLS|SLÜ|SLZ|SMÜ|SOB|SOG|SOK|SÖM|SON|SPB|SPN|SRB|SRO|STA|STB|STD|STE|STL|SUL|SÜW|SWA|SZB|TBB|TDO|TET|TIR|TÖL|TUT|UEM|UER|UFF|USI|VAI|VEC|VER|VIB|VIE|VIT|VOH|WAF|WAK|WAN|WAR|WAT|WBS|WDA|WEL|WEN|WER|WES|WHV|WIL|WIS|WIT|WIZ|WLG|WMS|WND|WOB|WOH|WOL|WOR|WOS|WRN|WSF|WST|WSW|WTL|WTM|WUG|WÜM|WUN|WUR|WZL|ZEL|ZIG)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(s);
    },
    "de-LI": function(s) {
      return /^FL[- ]?\d{1,5}[UZ]?$/.test(s);
    },
    "en-IN": function(s) {
      return /^[A-Z]{2}[ -]?[0-9]{1,2}(?:[ -]?[A-Z])(?:[ -]?[A-Z]*)?[ -]?[0-9]{4}$/.test(s);
    },
    "es-AR": function(s) {
      return /^(([A-Z]{2} ?[0-9]{3} ?[A-Z]{2})|([A-Z]{3} ?[0-9]{3}))$/.test(s);
    },
    "fi-FI": function(s) {
      return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(s);
    },
    "hu-HU": function(s) {
      return /^((((?!AAA)(([A-NPRSTVZWXY]{1})([A-PR-Z]{1})([A-HJ-NPR-Z]))|(A[ABC]I)|A[ABC]O|A[A-W]Q|BPI|BPO|UCO|UDO|XAO)-(?!000)\d{3})|(M\d{6})|((CK|DT|CD|HC|H[ABEFIKLMNPRSTVX]|MA|OT|R[A-Z]) \d{2}-\d{2})|(CD \d{3}-\d{3})|(C-(C|X) \d{4})|(X-(A|B|C) \d{4})|(([EPVZ]-\d{5}))|(S A[A-Z]{2} \d{2})|(SP \d{2}-\d{2}))$/.test(s);
    },
    "pt-BR": function(s) {
      return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(s);
    },
    "pt-PT": function(s) {
      return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(s);
    },
    "sq-AL": function(s) {
      return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(s);
    },
    "sv-SE": function(s) {
      return /^[A-HJ-PR-UW-Z]{3} ?[\d]{2}[A-HJ-PR-UW-Z1-9]$|(^[A-ZÅÄÖ ]{2,7}$)/.test(s.trim());
    },
    "en-PK": function(s) {
      return /(^[A-Z]{2}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{3}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{4}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]((\s|-){0,1})[0-9]{4}((\s|-)[0-9]{2}){0,1}$)/.test(s.trim());
    }
  };
  function o(i, s) {
    if ((0, n.default)(i), s in a)
      return a[s](i);
    if (s === "any") {
      for (var l in a) {
        var u = a[l];
        if (u(i))
          return !0;
      }
      return !1;
    }
    throw new Error("Invalid locale '".concat(s, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(wS, wS.exports);
var Lde = wS.exports, SS = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = p;
  var n = a(Ja), r = a(st);
  function a(v) {
    return v && v.__esModule ? v : { default: v };
  }
  var o = /^[A-Z]$/, i = /^[a-z]$/, s = /^[0-9]$/, l = /^[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/\\ ]$/, u = {
    minLength: 8,
    minLowercase: 1,
    minUppercase: 1,
    minNumbers: 1,
    minSymbols: 1,
    returnScore: !1,
    pointsPerUnique: 1,
    pointsPerRepeat: 0.5,
    pointsForContainingLower: 10,
    pointsForContainingUpper: 10,
    pointsForContainingNumber: 10,
    pointsForContainingSymbol: 10
  };
  function c(v) {
    var h = {};
    return Array.from(v).forEach(function(m) {
      var y = h[m];
      y ? h[m] += 1 : h[m] = 1;
    }), h;
  }
  function f(v) {
    var h = c(v), m = {
      length: v.length,
      uniqueChars: Object.keys(h).length,
      uppercaseCount: 0,
      lowercaseCount: 0,
      numberCount: 0,
      symbolCount: 0
    };
    return Object.keys(h).forEach(function(y) {
      o.test(y) ? m.uppercaseCount += h[y] : i.test(y) ? m.lowercaseCount += h[y] : s.test(y) ? m.numberCount += h[y] : l.test(y) && (m.symbolCount += h[y]);
    }), m;
  }
  function d(v, h) {
    var m = 0;
    return m += v.uniqueChars * h.pointsPerUnique, m += (v.length - v.uniqueChars) * h.pointsPerRepeat, v.lowercaseCount > 0 && (m += h.pointsForContainingLower), v.uppercaseCount > 0 && (m += h.pointsForContainingUpper), v.numberCount > 0 && (m += h.pointsForContainingNumber), v.symbolCount > 0 && (m += h.pointsForContainingSymbol), m;
  }
  function p(v) {
    var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    (0, r.default)(v);
    var m = f(v);
    return h = (0, n.default)(h || {}, u), h.returnScore ? d(m, h) : m.length >= h.minLength && m.lowercaseCount >= h.minLowercase && m.uppercaseCount >= h.minUppercase && m.numberCount >= h.minNumbers && m.symbolCount >= h.minSymbols;
  }
  e.exports = t.default, e.exports.default = t.default;
})(SS, SS.exports);
var Bde = SS.exports, ah = {};
function _S(e) {
  "@babel/helpers - typeof";
  return _S = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _S(e);
}
Object.defineProperty(ah, "__esModule", {
  value: !0
});
ah.default = Gde;
ah.vatMatchers = void 0;
var g6 = Vde(st), Hde = jde(Mc);
function iM(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (iM = function(a) {
    return a ? n : t;
  })(e);
}
function jde(e, t) {
  if (e && e.__esModule) return e;
  if (e === null || _S(e) != "object" && typeof e != "function") return { default: e };
  var n = iM(t);
  if (n && n.has(e)) return n.get(e);
  var r = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e) if (o !== "default" && {}.hasOwnProperty.call(e, o)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, o) : null;
    i && (i.get || i.set) ? Object.defineProperty(r, o, i) : r[o] = e[o];
  }
  return r.default = e, n && n.set(e, r), r;
}
function Vde(e) {
  return e && e.__esModule ? e : { default: e };
}
var Ude = function(t) {
  var n = t.match(/^(AU)?(\d{11})$/);
  if (!n)
    return !1;
  var r = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
  t = t.replace(/^AU/, "");
  for (var a = (parseInt(t.slice(0, 1), 10) - 1).toString() + t.slice(1), o = 0, i = 0; i < 11; i++)
    o += r[i] * a.charAt(i);
  return o !== 0 && o % 89 === 0;
}, zde = function(t) {
  var n = function(a) {
    var o = a.pop(), i = [5, 4, 3, 2, 7, 6, 5, 4], s = (11 - a.reduce(function(l, u, c) {
      return l + u * i[c];
    }, 0) % 11) % 11;
    return o === s;
  };
  return /^(CHE[- ]?)?(\d{9}|(\d{3}\.\d{3}\.\d{3})|(\d{3} \d{3} \d{3})) ?(TVA|MWST|IVA)?$/.test(t) && n(t.match(/\d/g).map(function(r) {
    return +r;
  }));
}, Wde = function(t) {
  var n = t.match(/^(PT)?(\d{9})$/);
  if (!n)
    return !1;
  var r = n[2], a = 11 - Hde.reverseMultiplyAndSum(r.split("").slice(0, 8).map(function(o) {
    return parseInt(o, 10);
  }), 9) % 11;
  return a > 9 ? parseInt(r[8], 10) === 0 : a === parseInt(r[8], 10);
}, y6 = ah.vatMatchers = {
  /**
   * European Union VAT identification numbers
   */
  AT: function(t) {
    return /^(AT)?U\d{8}$/.test(t);
  },
  BE: function(t) {
    return /^(BE)?\d{10}$/.test(t);
  },
  BG: function(t) {
    return /^(BG)?\d{9,10}$/.test(t);
  },
  HR: function(t) {
    return /^(HR)?\d{11}$/.test(t);
  },
  CY: function(t) {
    return /^(CY)?\w{9}$/.test(t);
  },
  CZ: function(t) {
    return /^(CZ)?\d{8,10}$/.test(t);
  },
  DK: function(t) {
    return /^(DK)?\d{8}$/.test(t);
  },
  EE: function(t) {
    return /^(EE)?\d{9}$/.test(t);
  },
  FI: function(t) {
    return /^(FI)?\d{8}$/.test(t);
  },
  FR: function(t) {
    return /^(FR)?\w{2}\d{9}$/.test(t);
  },
  DE: function(t) {
    return /^(DE)?\d{9}$/.test(t);
  },
  EL: function(t) {
    return /^(EL)?\d{9}$/.test(t);
  },
  HU: function(t) {
    return /^(HU)?\d{8}$/.test(t);
  },
  IE: function(t) {
    return /^(IE)?\d{7}\w{1}(W)?$/.test(t);
  },
  IT: function(t) {
    return /^(IT)?\d{11}$/.test(t);
  },
  LV: function(t) {
    return /^(LV)?\d{11}$/.test(t);
  },
  LT: function(t) {
    return /^(LT)?\d{9,12}$/.test(t);
  },
  LU: function(t) {
    return /^(LU)?\d{8}$/.test(t);
  },
  MT: function(t) {
    return /^(MT)?\d{8}$/.test(t);
  },
  NL: function(t) {
    return /^(NL)?\d{9}B\d{2}$/.test(t);
  },
  PL: function(t) {
    return /^(PL)?(\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3}))$/.test(t);
  },
  PT: Wde,
  RO: function(t) {
    return /^(RO)?\d{2,10}$/.test(t);
  },
  SK: function(t) {
    return /^(SK)?\d{10}$/.test(t);
  },
  SI: function(t) {
    return /^(SI)?\d{8}$/.test(t);
  },
  ES: function(t) {
    return /^(ES)?\w\d{7}[A-Z]$/.test(t);
  },
  SE: function(t) {
    return /^(SE)?\d{12}$/.test(t);
  },
  /**
   * VAT numbers of non-EU countries
   */
  AL: function(t) {
    return /^(AL)?\w{9}[A-Z]$/.test(t);
  },
  MK: function(t) {
    return /^(MK)?\d{13}$/.test(t);
  },
  AU: Ude,
  BY: function(t) {
    return /^(УНП )?\d{9}$/.test(t);
  },
  CA: function(t) {
    return /^(CA)?\d{9}$/.test(t);
  },
  IS: function(t) {
    return /^(IS)?\d{5,6}$/.test(t);
  },
  IN: function(t) {
    return /^(IN)?\d{15}$/.test(t);
  },
  ID: function(t) {
    return /^(ID)?(\d{15}|(\d{2}.\d{3}.\d{3}.\d{1}-\d{3}.\d{3}))$/.test(t);
  },
  IL: function(t) {
    return /^(IL)?\d{9}$/.test(t);
  },
  KZ: function(t) {
    return /^(KZ)?\d{12}$/.test(t);
  },
  NZ: function(t) {
    return /^(NZ)?\d{9}$/.test(t);
  },
  NG: function(t) {
    return /^(NG)?(\d{12}|(\d{8}-\d{4}))$/.test(t);
  },
  NO: function(t) {
    return /^(NO)?\d{9}MVA$/.test(t);
  },
  PH: function(t) {
    return /^(PH)?(\d{12}|\d{3} \d{3} \d{3} \d{3})$/.test(t);
  },
  RU: function(t) {
    return /^(RU)?(\d{10}|\d{12})$/.test(t);
  },
  SM: function(t) {
    return /^(SM)?\d{5}$/.test(t);
  },
  SA: function(t) {
    return /^(SA)?\d{15}$/.test(t);
  },
  RS: function(t) {
    return /^(RS)?\d{9}$/.test(t);
  },
  CH: zde,
  TR: function(t) {
    return /^(TR)?\d{10}$/.test(t);
  },
  UA: function(t) {
    return /^(UA)?\d{12}$/.test(t);
  },
  GB: function(t) {
    return /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/.test(t);
  },
  UZ: function(t) {
    return /^(UZ)?\d{9}$/.test(t);
  },
  /**
   * VAT numbers of Latin American countries
   */
  AR: function(t) {
    return /^(AR)?\d{11}$/.test(t);
  },
  BO: function(t) {
    return /^(BO)?\d{7}$/.test(t);
  },
  BR: function(t) {
    return /^(BR)?((\d{2}.\d{3}.\d{3}\/\d{4}-\d{2})|(\d{3}.\d{3}.\d{3}-\d{2}))$/.test(t);
  },
  CL: function(t) {
    return /^(CL)?\d{8}-\d{1}$/.test(t);
  },
  CO: function(t) {
    return /^(CO)?\d{10}$/.test(t);
  },
  CR: function(t) {
    return /^(CR)?\d{9,12}$/.test(t);
  },
  EC: function(t) {
    return /^(EC)?\d{13}$/.test(t);
  },
  SV: function(t) {
    return /^(SV)?\d{4}-\d{6}-\d{3}-\d{1}$/.test(t);
  },
  GT: function(t) {
    return /^(GT)?\d{7}-\d{1}$/.test(t);
  },
  HN: function(t) {
    return /^(HN)?$/.test(t);
  },
  MX: function(t) {
    return /^(MX)?\w{3,4}\d{6}\w{3}$/.test(t);
  },
  NI: function(t) {
    return /^(NI)?\d{3}-\d{6}-\d{4}\w{1}$/.test(t);
  },
  PA: function(t) {
    return /^(PA)?$/.test(t);
  },
  PY: function(t) {
    return /^(PY)?\d{6,8}-\d{1}$/.test(t);
  },
  PE: function(t) {
    return /^(PE)?\d{11}$/.test(t);
  },
  DO: function(t) {
    return /^(DO)?(\d{11}|(\d{3}-\d{7}-\d{1})|[1,4,5]{1}\d{8}|([1,4,5]{1})-\d{2}-\d{5}-\d{1})$/.test(t);
  },
  UY: function(t) {
    return /^(UY)?\d{12}$/.test(t);
  },
  VE: function(t) {
    return /^(VE)?[J,G,V,E]{1}-(\d{9}|(\d{8}-\d{1}))$/.test(t);
  }
};
function Gde(e, t) {
  if ((0, g6.default)(e), (0, g6.default)(t), t in y6)
    return y6[t](e);
  throw new Error("Invalid country code: '".concat(t, "'"));
}
(function(e, t) {
  function n(Je) {
    "@babel/helpers - typeof";
    return n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_e) {
      return typeof _e;
    } : function(_e) {
      return _e && typeof Symbol == "function" && _e.constructor === Symbol && _e !== Symbol.prototype ? "symbol" : typeof _e;
    }, n(Je);
  }
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = $e(E4), a = $e(W7), o = $e(Mce), i = $e(Rce), s = $e(Nce), l = $e(Fce), u = $e(Lce), c = $e(Y7), f = $e(Bce), d = $e(Hce), p = $e(N1), v = $e(jce), h = $e(T4), m = $e(q7), y = $e(Vce), x = $e(Uce), g = $e(zce), S = $e(Wce), w = Qe(Zp), _ = Qe(Qp), b = $e(Qce), E = $e(Jce), C = $e(efe), T = $e(tfe), O = $e(nfe), I = $e(rfe), k = $e(afe), B = $e(Cd), P = $e(Ed), N = $e(pfe), M = $e(hfe), H = $e(mfe), R = $e(gfe), z = $e($4), W = Qe(_d), F = $e(xfe), Y = $e(X7), X = $e(bfe), q = $e(wfe), Q = $e(Sfe), ue = $e(_fe), le = $e(Cfe), te = $e(Efe), G = Qe(Jp), oe = $e(Rfe), L = $e(Nfe), re = $e(Ffe), j = $e(Lfe), J = $e(Bfe), ae = $e(Hfe), he = $e(jfe), K = $e(K7), Z = $e(Vfe), se = $e(Ufe), me = $e(zfe), xe = $e(Wfe), be = $e(Gfe), Te = $e(J7), Ie = $e(Kfe), Ve = $e(Yfe), tt = $e(qfe), it = $e(Xfe), Se = $e(Zfe), ge = $e(Qfe), pe = $e(rde), De = Qe(eh), Ue = $e(sde), Xe = $e(lde), ut = $e(ude), xt = th, Mt = $e(hde), yt = $e(vde), gt = $e(mde), ct = $e(Td), Ht = $e(gde), Ut = $e(nh), In = $e(wde), wr = $e(Sde), eo = $e(Q7), ur = $e(_de), rr = $e(Cde), gi = $e(Ede), yi = $e(Tde), $r = $e($de), An = Qe(rh), va = $e(rM), Ze = $e(nM), Et = $e(aM), _t = $e(Pde), ee = $e(Dde), fe = $e(kde), ie = $e(Mde), ce = $e(oM), de = $e(Rde), ye = $e(Nde), Pe = $e(Fde), je = $e(Lde), Ae = $e(Bde), Re = $e(ah);
  function Ne(Je) {
    if (typeof WeakMap != "function") return null;
    var _e = /* @__PURE__ */ new WeakMap(), Ee = /* @__PURE__ */ new WeakMap();
    return (Ne = function(lt) {
      return lt ? Ee : _e;
    })(Je);
  }
  function Qe(Je, _e) {
    if (Je && Je.__esModule) return Je;
    if (Je === null || n(Je) != "object" && typeof Je != "function") return { default: Je };
    var Ee = Ne(_e);
    if (Ee && Ee.has(Je)) return Ee.get(Je);
    var Le = { __proto__: null }, lt = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var Rt in Je) if (Rt !== "default" && {}.hasOwnProperty.call(Je, Rt)) {
      var nt = lt ? Object.getOwnPropertyDescriptor(Je, Rt) : null;
      nt && (nt.get || nt.set) ? Object.defineProperty(Le, Rt, nt) : Le[Rt] = Je[Rt];
    }
    return Le.default = Je, Ee && Ee.set(Je, Le), Le;
  }
  function $e(Je) {
    return Je && Je.__esModule ? Je : { default: Je };
  }
  var ht = "13.12.0", ot = {
    version: ht,
    toDate: r.default,
    toFloat: a.default,
    toInt: o.default,
    toBoolean: i.default,
    equals: s.default,
    contains: l.default,
    matches: u.default,
    isEmail: c.default,
    isURL: f.default,
    isMACAddress: d.default,
    isIP: p.default,
    isIPRange: v.default,
    isFQDN: h.default,
    isBoolean: x.default,
    isIBAN: G.default,
    isBIC: oe.default,
    isAbaRouting: S.default,
    isAlpha: w.default,
    isAlphaLocales: w.locales,
    isAlphanumeric: _.default,
    isAlphanumericLocales: _.locales,
    isNumeric: b.default,
    isPassportNumber: E.default,
    isPort: C.default,
    isLowercase: T.default,
    isUppercase: O.default,
    isAscii: k.default,
    isFullWidth: B.default,
    isHalfWidth: P.default,
    isVariableWidth: N.default,
    isMultibyte: M.default,
    isSemVer: H.default,
    isSurrogatePair: R.default,
    isInt: z.default,
    isIMEI: I.default,
    isFloat: W.default,
    isFloatLocales: W.locales,
    isDecimal: F.default,
    isHexadecimal: Y.default,
    isOctal: X.default,
    isDivisibleBy: q.default,
    isHexColor: Q.default,
    isRgbColor: ue.default,
    isHSL: le.default,
    isISRC: te.default,
    isMD5: L.default,
    isHash: re.default,
    isJWT: j.default,
    isJSON: J.default,
    isEmpty: ae.default,
    isLength: he.default,
    isLocale: g.default,
    isByteLength: K.default,
    isUUID: Z.default,
    isMongoId: se.default,
    isAfter: me.default,
    isBefore: xe.default,
    isIn: be.default,
    isLuhnNumber: Te.default,
    isCreditCard: Ie.default,
    isIdentityCard: Ve.default,
    isEAN: tt.default,
    isISIN: it.default,
    isISBN: Se.default,
    isISSN: ge.default,
    isMobilePhone: De.default,
    isMobilePhoneLocales: De.locales,
    isPostalCode: An.default,
    isPostalCodeLocales: An.locales,
    isEthereumAddress: Ue.default,
    isCurrency: Xe.default,
    isBtcAddress: ut.default,
    isISO6346: xt.isISO6346,
    isFreightContainerID: xt.isFreightContainerID,
    isISO6391: Mt.default,
    isISO8601: yt.default,
    isRFC3339: gt.default,
    isISO31661Alpha2: ct.default,
    isISO31661Alpha3: Ht.default,
    isISO4217: Ut.default,
    isBase32: In.default,
    isBase58: wr.default,
    isBase64: eo.default,
    isDataURI: ur.default,
    isMagnetURI: rr.default,
    isMailtoURI: gi.default,
    isMimeType: yi.default,
    isLatLong: $r.default,
    ltrim: va.default,
    rtrim: Ze.default,
    trim: Et.default,
    escape: _t.default,
    unescape: ee.default,
    stripLow: fe.default,
    whitelist: ie.default,
    blacklist: ce.default,
    isWhitelisted: de.default,
    normalizeEmail: ye.default,
    toString,
    isSlug: Pe.default,
    isStrongPassword: Ae.default,
    isTaxID: pe.default,
    isDate: m.default,
    isTime: y.default,
    isLicensePlate: je.default,
    isVAT: Re.default,
    ibanLocales: G.locales
  };
  t.default = ot, e.exports = t.default, e.exports.default = t.default;
})(N2, N2.exports);
var Kde = N2.exports;
const tv = (e, t) => Kde.isURL(`${e}`, t), Yde = (e) => L8(e) || e === we.Time ? "=" : [we.SingleSelect, we.Collaborator, we.Date, we.DateTime].includes(
  e
) ? "is" : "is equal", qde = (e) => L8(e) || e === we.Time ? "!=" : [we.SingleSelect, we.Collaborator, we.Date, we.DateTime].includes(
  e
) ? "is not" : "is not equal", Xde = (e) => e === we.Attachment ? "filenames contain" : "is like", Zde = (e) => e === we.Attachment ? "filenames doesn't contain" : "is not like", Qde = (e) => [we.Date, we.DateTime].includes(e) ? "is after" : ">", Jde = (e) => [we.Date, we.DateTime].includes(e) ? "is before" : "<", e0e = (e) => [we.Date, we.DateTime].includes(e) ? "is on or after" : ">=", t0e = (e) => [we.Date, we.DateTime].includes(e) ? "is on or before" : "<=", n0 = (e, t) => [
  {
    text: "is checked",
    value: "checked",
    ignoreVal: !0,
    includedTypes: [we.Checkbox]
  },
  {
    text: "is not checked",
    value: "notchecked",
    ignoreVal: !0,
    includedTypes: [we.Checkbox]
  },
  {
    text: Yde(e),
    value: "eq",
    ignoreVal: !1,
    excludedTypes: [we.Checkbox, we.MultiSelect, we.Attachment, we.User]
  },
  {
    text: qde(e),
    value: "neq",
    ignoreVal: !1,
    excludedTypes: [we.Checkbox, we.MultiSelect, we.Attachment, we.User]
  },
  {
    text: Xde(e),
    value: "like",
    ignoreVal: !1,
    excludedTypes: [
      we.Checkbox,
      we.SingleSelect,
      we.MultiSelect,
      we.User,
      we.Collaborator,
      we.Date,
      we.DateTime,
      we.Time,
      ...Ci
    ]
  },
  {
    text: Zde(e),
    value: "nlike",
    ignoreVal: !1,
    excludedTypes: [
      we.Checkbox,
      we.SingleSelect,
      we.MultiSelect,
      we.User,
      we.Collaborator,
      we.Date,
      we.DateTime,
      we.Time,
      ...Ci
    ]
  },
  {
    text: "is empty",
    value: "empty",
    ignoreVal: !0,
    excludedTypes: [
      we.Checkbox,
      we.SingleSelect,
      we.MultiSelect,
      we.User,
      we.Collaborator,
      we.Attachment,
      we.Date,
      we.DateTime,
      we.Time,
      ...Ci
    ]
  },
  {
    text: "is not empty",
    value: "notempty",
    ignoreVal: !0,
    excludedTypes: [
      we.Checkbox,
      we.SingleSelect,
      we.MultiSelect,
      we.User,
      we.Collaborator,
      we.Attachment,
      we.Date,
      we.DateTime,
      we.Time,
      ...Ci
    ]
  },
  {
    text: "is null",
    value: "null",
    ignoreVal: !0,
    excludedTypes: [
      ...Ci,
      we.Checkbox,
      we.SingleSelect,
      we.MultiSelect,
      we.User,
      we.Collaborator,
      we.Attachment,
      we.Date,
      we.DateTime,
      we.Time
    ]
  },
  {
    text: "is not null",
    value: "notnull",
    ignoreVal: !0,
    excludedTypes: [
      ...Ci,
      we.Checkbox,
      we.SingleSelect,
      we.MultiSelect,
      we.User,
      we.Collaborator,
      we.Attachment,
      we.Date,
      we.DateTime,
      we.Time
    ]
  },
  {
    text: "contains all of",
    value: "allof",
    ignoreVal: !1,
    includedTypes: [we.MultiSelect, we.User]
  },
  {
    text: "contains any of",
    value: "anyof",
    ignoreVal: !1,
    includedTypes: [we.MultiSelect, we.SingleSelect, we.User]
  },
  {
    text: "does not contain all of",
    value: "nallof",
    ignoreVal: !1,
    includedTypes: [we.MultiSelect, we.User]
  },
  {
    text: "does not contain any of",
    value: "nanyof",
    ignoreVal: !1,
    includedTypes: [we.MultiSelect, we.SingleSelect, we.User]
  },
  {
    text: Qde(e),
    value: "gt",
    ignoreVal: !1,
    includedTypes: [...Ci, we.Date, we.DateTime, we.Time]
  },
  {
    text: Jde(e),
    value: "lt",
    ignoreVal: !1,
    includedTypes: [...Ci, we.Date, we.DateTime, we.Time]
  },
  {
    text: e0e(e),
    value: "gte",
    ignoreVal: !1,
    includedTypes: [...Ci, we.Date, we.DateTime, we.Time]
  },
  {
    text: t0e(e),
    value: "lte",
    ignoreVal: !1,
    includedTypes: [...Ci, we.Date, we.DateTime, we.Time]
  },
  {
    text: "is within",
    value: "isWithin",
    ignoreVal: !0,
    includedTypes: [we.Date, we.DateTime]
  },
  {
    text: "is blank",
    value: "blank",
    ignoreVal: !0,
    excludedTypes: [we.Checkbox]
  },
  {
    text: "is not blank",
    value: "notblank",
    ignoreVal: !0,
    excludedTypes: [we.Checkbox]
  }
], nv = (e, t) => {
  const n = t && F_(t);
  return e === "isWithin" ? [
    {
      text: "the past week",
      value: "pastWeek",
      ignoreVal: !0,
      includedTypes: [we.Date, we.DateTime]
    },
    {
      text: "the past month",
      value: "pastMonth",
      ignoreVal: !0,
      includedTypes: [we.Date, we.DateTime]
    },
    {
      text: "the past year",
      value: "pastYear",
      ignoreVal: !0,
      includedTypes: [we.Date, we.DateTime]
    },
    {
      text: "the next week",
      value: "nextWeek",
      ignoreVal: !0,
      includedTypes: [we.Date, we.DateTime]
    },
    {
      text: "the next month",
      value: "nextMonth",
      ignoreVal: !0,
      includedTypes: [we.Date, we.DateTime]
    },
    {
      text: "the next year",
      value: "nextYear",
      ignoreVal: !0,
      includedTypes: [we.Date, we.DateTime]
    },
    {
      text: "the next number of days",
      value: "nextNumberOfDays",
      ignoreVal: !1,
      includedTypes: [we.Date, we.DateTime]
    },
    {
      text: "the past number of days",
      value: "pastNumberOfDays",
      ignoreVal: !1,
      includedTypes: [we.Date, we.DateTime]
    }
  ] : [
    {
      text: "today",
      value: "today",
      ignoreVal: !0,
      includedTypes: [...n ? [] : [we.Date, we.DateTime]]
    },
    {
      text: "tomorrow",
      value: "tomorrow",
      ignoreVal: !0,
      includedTypes: [...n ? [] : [we.Date, we.DateTime]]
    },
    {
      text: "yesterday",
      value: "yesterday",
      ignoreVal: !0,
      includedTypes: [...n ? [] : [we.Date, we.DateTime]]
    },
    {
      text: "one week ago",
      value: "oneWeekAgo",
      ignoreVal: !0,
      includedTypes: [...n ? [] : [we.Date, we.DateTime]]
    },
    {
      text: "one week from now",
      value: "oneWeekFromNow",
      ignoreVal: !0,
      includedTypes: [...n ? [] : [we.Date, we.DateTime]]
    },
    {
      text: "one month ago",
      value: "oneMonthAgo",
      ignoreVal: !0,
      includedTypes: [we.Date, we.DateTime]
    },
    {
      text: "one month from now",
      value: "oneMonthFromNow",
      ignoreVal: !0,
      includedTypes: [we.Date, we.DateTime]
    },
    {
      text: "number of days ago",
      value: "daysAgo",
      ignoreVal: !1,
      includedTypes: [...n ? [] : [we.Date, we.DateTime]]
    },
    {
      text: "number of days from now",
      value: "daysFromNow",
      ignoreVal: !1,
      includedTypes: [...n ? [] : [we.Date, we.DateTime]]
    },
    {
      text: n ? "exact month" : "exact date",
      value: "exactDate",
      ignoreVal: !1,
      includedTypes: [we.Date, we.DateTime]
    }
  ];
}, n0e = (e) => {
  switch (e) {
    case we.Year:
    case we.Number:
    case we.Decimal:
    case we.ID:
    case we.Time:
    case we.Date:
    case we.DateTime:
    case "CreatedTime":
    case "LastModifiedTime":
      return [
        { text: "1 → 9", value: "asc" },
        { text: "9 → 1", value: "desc" }
      ];
    case we.Checkbox:
      return [
        { text: "▢ → ✓", value: "asc" },
        { text: "✓ → ▢", value: "desc" }
      ];
    default:
      return [
        { text: "A → Z", value: "asc" },
        { text: "Z → A", value: "desc" }
      ];
  }
};
var r0e = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(rk);
  })(ra, function(n) {
    function r(i) {
      return i && typeof i == "object" && "default" in i ? i : { default: i };
    }
    var a = r(n), o = { name: "zh-cn", weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"), weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"), weekdaysMin: "日_一_二_三_四_五_六".split("_"), months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(i, s) {
      return s === "W" ? i + "周" : i + "日";
    }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日Ah点mm分", LLLL: "YYYY年M月D日ddddAh点mm分", l: "YYYY/M/D", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日dddd HH:mm" }, relativeTime: { future: "%s内", past: "%s前", s: "几秒", m: "1 分钟", mm: "%d 分钟", h: "1 小时", hh: "%d 小时", d: "1 天", dd: "%d 天", M: "1 个月", MM: "%d 个月", y: "1 年", yy: "%d 年" }, meridiem: function(i, s) {
      var l = 100 * i + s;
      return l < 600 ? "凌晨" : l < 900 ? "早上" : l < 1100 ? "上午" : l < 1300 ? "中午" : l < 1800 ? "下午" : "晚上";
    } };
    return a.default.locale(o, null, !0), o;
  });
})(r0e);
It.locale("zh-cn");
const sM = (e, t) => e.uidt === we.Checkbox || t === "boolean", a0e = (e) => e.uidt === we.LongText, o0e = (e, t) => e.uidt === we.SingleLineText || t === "string", Um = (e, t) => t === "integer", CS = (e, t) => t === "float" || t === we.Number, i0e = (e) => e.uidt === we.ID, s0e = (e) => e.uidt === "CreatedTime" || e.uidt === "LastModifiedTime", ES = (e, t) => t === "date" || e.uidt === we.Date, TS = (e, t) => t === "datetime" || e.uidt === we.DateTime, lM = (e) => e.uidt === we.SingleSelect, uM = (e) => e.uidt === we.MultiSelect, l0e = (e) => e.uidt === we.URL, cM = (e) => e.uidt === we.Attachment, $S = (e) => e.uidt === we.Decimal, u0e = (e) => [
  we.SingleLineText,
  we.LongText,
  we.PhoneNumber,
  we.URL,
  we.Number,
  we.Decimal
].includes(e.uidt), c0e = (e) => !!e.pv, x6 = (e) => !!e.pk, f0e = () => ({
  validator: (e, t) => new Promise((r, a) => {
    (t == null ? void 0 : t.length) > 255 && a(new Error("列名的长度超过了 255 字符的限制")), r(!0);
  })
}), d0e = !1;
function fM() {
  const e = window.DB_API_BASE_URL;
  return vce(new KV({ baseURL: e }));
}
function Na({
  axiosConfig: e
} = {}) {
  const { count: t, inc: n, dec: r } = vU(0), a = ne(!1), o = ne(null), i = ne(null), s = Qs(), l = Qs(), u = Ke("api");
  function c() {
    a.value = !0, n();
  }
  function f() {
    r(), d();
  }
  function d() {
    t.value === 0 && (a.value = !1);
  }
  function p() {
    o.value = null, i.value = null;
  }
  return u.instance.interceptors.request.use(
    (v) => (p(), c(), {
      ...v,
      ...U(e)
    }),
    async (v) => (s.trigger(v), o.value = await Pn(v), i.value = null, f(), Promise.reject(v))
  ), u.instance.interceptors.response.use(
    (v) => (l.trigger(v), i.value = v, f(), Promise.resolve(v)),
    async (v) => (s.trigger(v), o.value = await Pn(v), f(), Promise.reject(v))
  ), {
    api: u,
    isLoading: a,
    response: i,
    error: o,
    onError: s.on,
    onResponse: l.on
  };
}
const p0e = Q8(), h0e = Bs.useForm, OS = [we.URL], [v0e, m0e] = QV(
  (e, t) => {
    var b, E;
    const n = ws(), { sqlUis: r } = Fn(n), { api: a } = Na(), o = ne(
      (b = e.value) != null && b.source_id ? r.value[(E = e.value) == null ? void 0 : E.source_id] : Object.values(r.value)[0]
    ), { tableActivated: i } = Fn(mo());
    console.log("====== meta", e, i);
    const s = V(() => {
      var C, T;
      return (T = (C = i.value) == null ? void 0 : C.views) == null ? void 0 : T[0];
    }), l = V(() => {
      var C;
      return !!((C = t == null ? void 0 : t.value) != null && C.id);
    }), u = ne({}), c = (C) => {
      u.value = { ...u.value, ...C };
    }, f = ne({
      title: "title",
      uidt: we.SingleLineText,
      ...p0e(t.value || {})
    }), d = () => {
      var O, I, k, B;
      let C = (((I = (O = e.value) == null ? void 0 : O.columns) == null ? void 0 : I.length) || 0) + 1, T = `title${C}`;
      for (; (B = (k = e.value) == null ? void 0 : k.columns) != null && B.some((P) => {
        var N;
        return ((N = P.column_name) == null ? void 0 : N.toLowerCase()) === T.toLowerCase();
      }); )
        C++, T = `title${C}`;
      return C;
    }, p = () => {
      var T;
      c({});
      const C = (T = o.value) == null ? void 0 : T.getNewColumn(d());
      f.value = {
        ...C,
        meta: {},
        title: C == null ? void 0 : C.column_name
      };
    }, v = V(() => ({
      title: [
        {
          required: !0,
          message: "列名是必填项"
        },
        // validation for unique column name
        {
          validator: (C, T) => new Promise((O, I) => {
            var k, B, P, N;
            if (T !== "" && ((B = (k = e.value) == null ? void 0 : k.columns) != null && B.some(
              (M) => M.id !== f.value.id && // ignore current column
              // compare against column_name and title
              ((T || "").toLowerCase() === (M.column_name || "").toLowerCase() || (T || "").toLowerCase() === (M.title || "").toLowerCase()) && M.system
            )))
              return I(new Error("字段名称已被系统使用"));
            if (T !== "" && ((N = (P = e.value) == null ? void 0 : P.columns) != null && N.some(
              (M) => M.id !== f.value.id && // ignore current column
              // compare against column_name and title
              ((T || "").toLowerCase() === (M.column_name || "").toLowerCase() || (T || "").toLowerCase() === (M.title || "").toLowerCase())
            )))
              return I(new Error("字段名称重复"));
            O();
          })
        },
        f0e()
      ],
      uidt: [
        {
          required: !0,
          message: "需要 UI 数据类型"
        }
      ],
      ...(u == null ? void 0 : u.value) || {}
    })), { resetFields: h, validate: m, validateInfos: y } = h0e(f, v), x = OU(f.value.uidt, f.value.uidt), g = () => {
      var O, I, k;
      const C = o.value.getDataTypeForUiType(
        f.value,
        void 0
      );
      f.value = {
        ...!l.value && {
          // only take title, column_name and uidt when creating a column
          // to avoid the extra props from being taken (e.g. SingleLineText -> LTAR -> SingleLineText)
          // to mess up the column creation
          title: f.value.title,
          column_name: f.value.column_name,
          uidt: f.value.uidt,
          temp_id: f.value.temp_id
        },
        ...l.value && {
          // take the existing formState.value when editing a column
          // LTAR is not available in this case
          ...f.value
        },
        meta: {},
        rqd: !1,
        pk: !1,
        ai: !1,
        cdf: null,
        un: !1,
        dtx: "specificType",
        ...C
      }, f.value.dtxp = o.value.getDefaultLengthForDatatype(f.value.dt), f.value.dtxs = o.value.getDefaultScaleForDatatype(f.value.dt);
      const T = [we.MultiSelect, we.SingleSelect];
      t && T.includes(f.value.uidt) && T.includes((O = t.value) == null ? void 0 : O.uidt) && (f.value.dtxp = (I = t.value) == null ? void 0 : I.dtxp), OS.includes(f.value.uidt) && (f.value.meta = {
        validate: f.value.meta && f.value.meta.validate
      }), t.value && f.value.uidt === ((k = t.value) == null ? void 0 : k.uidt) && (f.value.dtxp = t.value.dtxp, f.value.dtxs = t.value.dtxs), f.value.altered = f.value.altered || 2;
    }, S = () => {
      var T;
      f.value.rqd = !1, f.value.uidt !== we.ID && (f.value.primaryKey = !1), f.value.ai = !1, f.value.cdf = null, f.value.un = !1, f.value.dtxp = o.value.getDefaultLengthForDatatype(f.value.dt), f.value.dtxs = o.value.getDefaultScaleForDatatype(f.value.dt), f.value.dtx = "specificType";
      const C = [we.MultiSelect, we.SingleSelect];
      t.value && C.includes(f.value.uidt) && C.includes(t.value.uidt) && (f.value.dtxp = t.value.dtxp), t.value && f.value.uidt === ((T = t.value) == null ? void 0 : T.uidt) && (f.value.dtxp = t.value.dtxp, f.value.dtxs = t.value.dtxs), f.value.altered = f.value.altered || 2;
    }, w = (C = 2, T = !1) => {
      f.value.altered = f.value.altered || C, T && (f.value.cdf = f.value.cdf || null);
    }, _ = async (C, T) => {
      var O, I, k, B, P, N, M, H, R, z;
      try {
        if (!await m()) return;
      } catch (W) {
        const F = (O = W.errorFields) == null ? void 0 : O.map((Y) => {
          var X;
          return (X = Y.errors) == null ? void 0 : X.join(", ");
        }).filter(Boolean).join(", ");
        F ? wt.error(F) : wt.error("表单验证失败");
        return;
      }
      if (["SingleLineText", "LongText", "Checkbox", "MultiSelect"].includes(
        x.value || ""
      ) && f.value.uidt === "SingleSelect")
        if (x.value === "Checkbox")
          f.value.colOptions = {
            options: [
              { title: "true", color: "#cfdffe" },
              { title: "false", color: "#d0f1fd" }
            ]
          };
        else {
          const W = (I = n.base) == null ? void 0 : I.id, F = (k = i.value) == null ? void 0 : k.id, Y = (B = s.value) == null ? void 0 : B.id;
          if (W && F && Y) {
            const X = await a.dbViewRow.list(W, F, Y, {
              offset: 0,
              limit: 100
            }), q = rd.light;
            let Q;
            x.value === "SingleLineText" || x.value === "LongText" ? Q = Array.from(
              new Set((P = X.data.list) == null ? void 0 : P.map((le) => le[f.value.title]).filter(Boolean))
            ) : Q = Array.from(
              new Set(
                (N = X.data.list) == null ? void 0 : N.map((le) => {
                  var te;
                  return (te = le[f.value.title]) == null ? void 0 : te.split(",", 1)[0];
                }).filter(Boolean)
              )
            );
            const ue = Q.map((le, te) => ({
              title: le,
              color: q[te % q.length]
            }));
            f.value.colOptions = { options: ue };
          }
        }
      try {
        if (f.value.table_name = (M = e.value) == null ? void 0 : M.table_name, t.value)
          OS.includes(f.value.uidt) || (f.value.validate = ""), await a.dbTableColumn.update((H = t.value) == null ? void 0 : H.id, f.value);
        else {
          f.value.uidt, we.ID;
          const W = (R = s.value) == null ? void 0 : R.id;
          if (!W)
            return !1;
          await a.dbTableColumn.create((z = e.value) == null ? void 0 : z.id, {
            view_id: W,
            ...f.value,
            ...T
          });
        }
        return await (C == null ? void 0 : C()), !0;
      } catch (W) {
        wt.error(await Pn(W));
      }
    };
    return He(
      () => {
        var C;
        return (C = f.value) == null ? void 0 : C.title;
      },
      (C) => f.value.column_name = C
    ), console.log("====== validateInfos", y), {
      formState: f,
      generateNewColumnMeta: p,
      addOrUpdate: _,
      onAlter: w,
      onDataTypeChange: S,
      onUidtOrIdTypeChange: g,
      setAdditionalValidations: c,
      resetFields: h,
      validate: m,
      validateInfos: y,
      isEdit: l,
      column: t,
      sqlUi: o
    };
  }
);
function O4() {
  const e = m0e();
  if (e == null)
    throw new Error("Please call `useProvideColumnCreateStore` on the appropriate parent component");
  return e;
}
const g0e = (e = !1) => {
  const t = async (o, i = 0) => {
    try {
      const s = document.createElement("textarea");
      s.innerHTML = o, document.body.appendChild(s), s.select();
      const l = document.execCommand("copy");
      if (document.body.removeChild(s), !l && i < 3)
        return new Promise(
          (u, c) => setTimeout(
            () => t(o, i + 1).then(u).catch(c),
            100
          )
        );
      if (!l)
        throw new Error("failed");
      return l;
    } catch {
      if (!e) throw new Error("未能复制到剪贴板");
      return Ka.info({
        title: "Copy failed, please manually copy it from here",
        content: o,
        class: "nc-copy-failed-modal",
        width: "550px"
      }), !1;
    }
  }, { copy: n, isSupported: r } = SU();
  return { copy: async (o) => {
    try {
      if (r.value)
        return await n(o), !0;
    } catch (i) {
      console.log("copy error:", i);
    }
    return t(o);
  } };
}, y0e = () => ({ paste: async () => {
  try {
    if (!navigator.clipboard) throw new Error("从剪贴板粘贴失败");
    const t = await navigator.clipboard.readText(), n = new Event("paste", {
      bubbles: !1,
      cancelable: !0
    });
    return Object.defineProperty(n, "clipboardData", { value: {
      getData: () => t || ""
    } }), document.dispatchEvent(n), !0;
  } catch {
    return wt.error("从剪贴板粘贴失败"), !1;
  }
} });
var dM = { exports: {} };
/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ra, function n() {
    var r = typeof self < "u" ? self : typeof window < "u" ? window : r !== void 0 ? r : {}, a = !r.document && !!r.postMessage, o = r.IS_PAPA_WORKER || !1, i = {}, s = 0, l = { parse: function(E, C) {
      var T = (C = C || {}).dynamicTyping || !1;
      if (b(T) && (C.dynamicTypingFunction = T, T = {}), C.dynamicTyping = T, C.transform = !!b(C.transform) && C.transform, C.worker && l.WORKERS_SUPPORTED) {
        var O = function() {
          if (!l.WORKERS_SUPPORTED) return !1;
          var k = (P = r.URL || r.webkitURL || null, N = n.toString(), l.BLOB_URL || (l.BLOB_URL = P.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", N, ")();"], { type: "text/javascript" })))), B = new r.Worker(k), P, N;
          return B.onmessage = x, B.id = s++, i[B.id] = B;
        }();
        return O.userStep = C.step, O.userChunk = C.chunk, O.userComplete = C.complete, O.userError = C.error, C.step = b(C.step), C.chunk = b(C.chunk), C.complete = b(C.complete), C.error = b(C.error), delete C.worker, void O.postMessage({ input: E, config: C, workerId: O.id });
      }
      var I = null;
      return l.NODE_STREAM_INPUT, typeof E == "string" ? (E = function(k) {
        return k.charCodeAt(0) === 65279 ? k.slice(1) : k;
      }(E), I = C.download ? new f(C) : new p(C)) : E.readable === !0 && b(E.read) && b(E.on) ? I = new v(C) : (r.File && E instanceof File || E instanceof Object) && (I = new d(C)), I.stream(E);
    }, unparse: function(E, C) {
      var T = !1, O = !0, I = ",", k = `\r
`, B = '"', P = B + B, N = !1, M = null, H = !1;
      (function() {
        if (typeof C == "object") {
          if (typeof C.delimiter != "string" || l.BAD_DELIMITERS.filter(function(F) {
            return C.delimiter.indexOf(F) !== -1;
          }).length || (I = C.delimiter), (typeof C.quotes == "boolean" || typeof C.quotes == "function" || Array.isArray(C.quotes)) && (T = C.quotes), typeof C.skipEmptyLines != "boolean" && typeof C.skipEmptyLines != "string" || (N = C.skipEmptyLines), typeof C.newline == "string" && (k = C.newline), typeof C.quoteChar == "string" && (B = C.quoteChar), typeof C.header == "boolean" && (O = C.header), Array.isArray(C.columns)) {
            if (C.columns.length === 0) throw new Error("Option columns is empty");
            M = C.columns;
          }
          C.escapeChar !== void 0 && (P = C.escapeChar + B), (typeof C.escapeFormulae == "boolean" || C.escapeFormulae instanceof RegExp) && (H = C.escapeFormulae instanceof RegExp ? C.escapeFormulae : /^[=+\-@\t\r].*$/);
        }
      })();
      var R = new RegExp(m(B), "g");
      if (typeof E == "string" && (E = JSON.parse(E)), Array.isArray(E)) {
        if (!E.length || Array.isArray(E[0])) return z(null, E, N);
        if (typeof E[0] == "object") return z(M || Object.keys(E[0]), E, N);
      } else if (typeof E == "object") return typeof E.data == "string" && (E.data = JSON.parse(E.data)), Array.isArray(E.data) && (E.fields || (E.fields = E.meta && E.meta.fields || M), E.fields || (E.fields = Array.isArray(E.data[0]) ? E.fields : typeof E.data[0] == "object" ? Object.keys(E.data[0]) : []), Array.isArray(E.data[0]) || typeof E.data[0] == "object" || (E.data = [E.data])), z(E.fields || [], E.data || [], N);
      throw new Error("Unable to serialize unrecognized input");
      function z(F, Y, X) {
        var q = "";
        typeof F == "string" && (F = JSON.parse(F)), typeof Y == "string" && (Y = JSON.parse(Y));
        var Q = Array.isArray(F) && 0 < F.length, ue = !Array.isArray(Y[0]);
        if (Q && O) {
          for (var le = 0; le < F.length; le++) 0 < le && (q += I), q += W(F[le], le);
          0 < Y.length && (q += k);
        }
        for (var te = 0; te < Y.length; te++) {
          var G = Q ? F.length : Y[te].length, oe = !1, L = Q ? Object.keys(Y[te]).length === 0 : Y[te].length === 0;
          if (X && !Q && (oe = X === "greedy" ? Y[te].join("").trim() === "" : Y[te].length === 1 && Y[te][0].length === 0), X === "greedy" && Q) {
            for (var re = [], j = 0; j < G; j++) {
              var J = ue ? F[j] : j;
              re.push(Y[te][J]);
            }
            oe = re.join("").trim() === "";
          }
          if (!oe) {
            for (var ae = 0; ae < G; ae++) {
              0 < ae && !L && (q += I);
              var he = Q && ue ? F[ae] : ae;
              q += W(Y[te][he], ae);
            }
            te < Y.length - 1 && (!X || 0 < G && !L) && (q += k);
          }
        }
        return q;
      }
      function W(F, Y) {
        if (F == null) return "";
        if (F.constructor === Date) return JSON.stringify(F).slice(1, 25);
        var X = !1;
        H && typeof F == "string" && H.test(F) && (F = "'" + F, X = !0);
        var q = F.toString().replace(R, P);
        return (X = X || T === !0 || typeof T == "function" && T(F, Y) || Array.isArray(T) && T[Y] || function(Q, ue) {
          for (var le = 0; le < ue.length; le++) if (-1 < Q.indexOf(ue[le])) return !0;
          return !1;
        }(q, l.BAD_DELIMITERS) || -1 < q.indexOf(I) || q.charAt(0) === " " || q.charAt(q.length - 1) === " ") ? B + q + B : q;
      }
    } };
    if (l.RECORD_SEP = "", l.UNIT_SEP = "", l.BYTE_ORDER_MARK = "\uFEFF", l.BAD_DELIMITERS = ["\r", `
`, '"', l.BYTE_ORDER_MARK], l.WORKERS_SUPPORTED = !a && !!r.Worker, l.NODE_STREAM_INPUT = 1, l.LocalChunkSize = 10485760, l.RemoteChunkSize = 5242880, l.DefaultDelimiter = ",", l.Parser = y, l.ParserHandle = h, l.NetworkStreamer = f, l.FileStreamer = d, l.StringStreamer = p, l.ReadableStreamStreamer = v, r.jQuery) {
      var u = r.jQuery;
      u.fn.parse = function(E) {
        var C = E.config || {}, T = [];
        return this.each(function(k) {
          if (!(u(this).prop("tagName").toUpperCase() === "INPUT" && u(this).attr("type").toLowerCase() === "file" && r.FileReader) || !this.files || this.files.length === 0) return !0;
          for (var B = 0; B < this.files.length; B++) T.push({ file: this.files[B], inputElem: this, instanceConfig: u.extend({}, C) });
        }), O(), this;
        function O() {
          if (T.length !== 0) {
            var k, B, P, N, M = T[0];
            if (b(E.before)) {
              var H = E.before(M.file, M.inputElem);
              if (typeof H == "object") {
                if (H.action === "abort") return k = "AbortError", B = M.file, P = M.inputElem, N = H.reason, void (b(E.error) && E.error({ name: k }, B, P, N));
                if (H.action === "skip") return void I();
                typeof H.config == "object" && (M.instanceConfig = u.extend(M.instanceConfig, H.config));
              } else if (H === "skip") return void I();
            }
            var R = M.instanceConfig.complete;
            M.instanceConfig.complete = function(z) {
              b(R) && R(z, M.file, M.inputElem), I();
            }, l.parse(M.file, M.instanceConfig);
          } else b(E.complete) && E.complete();
        }
        function I() {
          T.splice(0, 1), O();
        }
      };
    }
    function c(E) {
      this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, (function(C) {
        var T = w(C);
        T.chunkSize = parseInt(T.chunkSize), C.step || C.chunk || (T.chunkSize = null), this._handle = new h(T), (this._handle.streamer = this)._config = T;
      }).call(this, E), this.parseChunk = function(C, T) {
        if (this.isFirstChunk && b(this._config.beforeFirstChunk)) {
          var O = this._config.beforeFirstChunk(C);
          O !== void 0 && (C = O);
        }
        this.isFirstChunk = !1, this._halted = !1;
        var I = this._partialLine + C;
        this._partialLine = "";
        var k = this._handle.parse(I, this._baseIndex, !this._finished);
        if (!this._handle.paused() && !this._handle.aborted()) {
          var B = k.meta.cursor;
          this._finished || (this._partialLine = I.substring(B - this._baseIndex), this._baseIndex = B), k && k.data && (this._rowCount += k.data.length);
          var P = this._finished || this._config.preview && this._rowCount >= this._config.preview;
          if (o) r.postMessage({ results: k, workerId: l.WORKER_ID, finished: P });
          else if (b(this._config.chunk) && !T) {
            if (this._config.chunk(k, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
            k = void 0, this._completeResults = void 0;
          }
          return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(k.data), this._completeResults.errors = this._completeResults.errors.concat(k.errors), this._completeResults.meta = k.meta), this._completed || !P || !b(this._config.complete) || k && k.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), P || k && k.meta.paused || this._nextChunk(), k;
        }
        this._halted = !0;
      }, this._sendError = function(C) {
        b(this._config.error) ? this._config.error(C) : o && this._config.error && r.postMessage({ workerId: l.WORKER_ID, error: C, finished: !1 });
      };
    }
    function f(E) {
      var C;
      (E = E || {}).chunkSize || (E.chunkSize = l.RemoteChunkSize), c.call(this, E), this._nextChunk = a ? function() {
        this._readChunk(), this._chunkLoaded();
      } : function() {
        this._readChunk();
      }, this.stream = function(T) {
        this._input = T, this._nextChunk();
      }, this._readChunk = function() {
        if (this._finished) this._chunkLoaded();
        else {
          if (C = new XMLHttpRequest(), this._config.withCredentials && (C.withCredentials = this._config.withCredentials), a || (C.onload = _(this._chunkLoaded, this), C.onerror = _(this._chunkError, this)), C.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !a), this._config.downloadRequestHeaders) {
            var T = this._config.downloadRequestHeaders;
            for (var O in T) C.setRequestHeader(O, T[O]);
          }
          if (this._config.chunkSize) {
            var I = this._start + this._config.chunkSize - 1;
            C.setRequestHeader("Range", "bytes=" + this._start + "-" + I);
          }
          try {
            C.send(this._config.downloadRequestBody);
          } catch (k) {
            this._chunkError(k.message);
          }
          a && C.status === 0 && this._chunkError();
        }
      }, this._chunkLoaded = function() {
        C.readyState === 4 && (C.status < 200 || 400 <= C.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : C.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(T) {
          var O = T.getResponseHeader("Content-Range");
          return O === null ? -1 : parseInt(O.substring(O.lastIndexOf("/") + 1));
        }(C), this.parseChunk(C.responseText)));
      }, this._chunkError = function(T) {
        var O = C.statusText || T;
        this._sendError(new Error(O));
      };
    }
    function d(E) {
      var C, T;
      (E = E || {}).chunkSize || (E.chunkSize = l.LocalChunkSize), c.call(this, E);
      var O = typeof FileReader < "u";
      this.stream = function(I) {
        this._input = I, T = I.slice || I.webkitSlice || I.mozSlice, O ? ((C = new FileReader()).onload = _(this._chunkLoaded, this), C.onerror = _(this._chunkError, this)) : C = new FileReaderSync(), this._nextChunk();
      }, this._nextChunk = function() {
        this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
      }, this._readChunk = function() {
        var I = this._input;
        if (this._config.chunkSize) {
          var k = Math.min(this._start + this._config.chunkSize, this._input.size);
          I = T.call(I, this._start, k);
        }
        var B = C.readAsText(I, this._config.encoding);
        O || this._chunkLoaded({ target: { result: B } });
      }, this._chunkLoaded = function(I) {
        this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(I.target.result);
      }, this._chunkError = function() {
        this._sendError(C.error);
      };
    }
    function p(E) {
      var C;
      c.call(this, E = E || {}), this.stream = function(T) {
        return C = T, this._nextChunk();
      }, this._nextChunk = function() {
        if (!this._finished) {
          var T, O = this._config.chunkSize;
          return O ? (T = C.substring(0, O), C = C.substring(O)) : (T = C, C = ""), this._finished = !C, this.parseChunk(T);
        }
      };
    }
    function v(E) {
      c.call(this, E = E || {});
      var C = [], T = !0, O = !1;
      this.pause = function() {
        c.prototype.pause.apply(this, arguments), this._input.pause();
      }, this.resume = function() {
        c.prototype.resume.apply(this, arguments), this._input.resume();
      }, this.stream = function(I) {
        this._input = I, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
      }, this._checkIsFinished = function() {
        O && C.length === 1 && (this._finished = !0);
      }, this._nextChunk = function() {
        this._checkIsFinished(), C.length ? this.parseChunk(C.shift()) : T = !0;
      }, this._streamData = _(function(I) {
        try {
          C.push(typeof I == "string" ? I : I.toString(this._config.encoding)), T && (T = !1, this._checkIsFinished(), this.parseChunk(C.shift()));
        } catch (k) {
          this._streamError(k);
        }
      }, this), this._streamError = _(function(I) {
        this._streamCleanUp(), this._sendError(I);
      }, this), this._streamEnd = _(function() {
        this._streamCleanUp(), O = !0, this._streamData("");
      }, this), this._streamCleanUp = _(function() {
        this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
      }, this);
    }
    function h(E) {
      var C, T, O, I = Math.pow(2, 53), k = -I, B = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, P = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, N = this, M = 0, H = 0, R = !1, z = !1, W = [], F = { data: [], errors: [], meta: {} };
      if (b(E.step)) {
        var Y = E.step;
        E.step = function(te) {
          if (F = te, Q()) q();
          else {
            if (q(), F.data.length === 0) return;
            M += te.data.length, E.preview && M > E.preview ? T.abort() : (F.data = F.data[0], Y(F, N));
          }
        };
      }
      function X(te) {
        return E.skipEmptyLines === "greedy" ? te.join("").trim() === "" : te.length === 1 && te[0].length === 0;
      }
      function q() {
        return F && O && (le("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + l.DefaultDelimiter + "'"), O = !1), E.skipEmptyLines && (F.data = F.data.filter(function(te) {
          return !X(te);
        })), Q() && function() {
          if (!F) return;
          function te(oe, L) {
            b(E.transformHeader) && (oe = E.transformHeader(oe, L)), W.push(oe);
          }
          if (Array.isArray(F.data[0])) {
            for (var G = 0; Q() && G < F.data.length; G++) F.data[G].forEach(te);
            F.data.splice(0, 1);
          } else F.data.forEach(te);
        }(), function() {
          if (!F || !E.header && !E.dynamicTyping && !E.transform) return F;
          function te(oe, L) {
            var re, j = E.header ? {} : [];
            for (re = 0; re < oe.length; re++) {
              var J = re, ae = oe[re];
              E.header && (J = re >= W.length ? "__parsed_extra" : W[re]), E.transform && (ae = E.transform(ae, J)), ae = ue(J, ae), J === "__parsed_extra" ? (j[J] = j[J] || [], j[J].push(ae)) : j[J] = ae;
            }
            return E.header && (re > W.length ? le("FieldMismatch", "TooManyFields", "Too many fields: expected " + W.length + " fields but parsed " + re, H + L) : re < W.length && le("FieldMismatch", "TooFewFields", "Too few fields: expected " + W.length + " fields but parsed " + re, H + L)), j;
          }
          var G = 1;
          return !F.data.length || Array.isArray(F.data[0]) ? (F.data = F.data.map(te), G = F.data.length) : F.data = te(F.data, 0), E.header && F.meta && (F.meta.fields = W), H += G, F;
        }();
      }
      function Q() {
        return E.header && W.length === 0;
      }
      function ue(te, G) {
        return oe = te, E.dynamicTypingFunction && E.dynamicTyping[oe] === void 0 && (E.dynamicTyping[oe] = E.dynamicTypingFunction(oe)), (E.dynamicTyping[oe] || E.dynamicTyping) === !0 ? G === "true" || G === "TRUE" || G !== "false" && G !== "FALSE" && (function(L) {
          if (B.test(L)) {
            var re = parseFloat(L);
            if (k < re && re < I) return !0;
          }
          return !1;
        }(G) ? parseFloat(G) : P.test(G) ? new Date(G) : G === "" ? null : G) : G;
        var oe;
      }
      function le(te, G, oe, L) {
        var re = { type: te, code: G, message: oe };
        L !== void 0 && (re.row = L), F.errors.push(re);
      }
      this.parse = function(te, G, oe) {
        var L = E.quoteChar || '"';
        if (E.newline || (E.newline = function(J, ae) {
          J = J.substring(0, 1048576);
          var he = new RegExp(m(ae) + "([^]*?)" + m(ae), "gm"), K = (J = J.replace(he, "")).split("\r"), Z = J.split(`
`), se = 1 < Z.length && Z[0].length < K[0].length;
          if (K.length === 1 || se) return `
`;
          for (var me = 0, xe = 0; xe < K.length; xe++) K[xe][0] === `
` && me++;
          return me >= K.length / 2 ? `\r
` : "\r";
        }(te, L)), O = !1, E.delimiter) b(E.delimiter) && (E.delimiter = E.delimiter(te), F.meta.delimiter = E.delimiter);
        else {
          var re = function(J, ae, he, K, Z) {
            var se, me, xe, be;
            Z = Z || [",", "	", "|", ";", l.RECORD_SEP, l.UNIT_SEP];
            for (var Te = 0; Te < Z.length; Te++) {
              var Ie = Z[Te], Ve = 0, tt = 0, it = 0;
              xe = void 0;
              for (var Se = new y({ comments: K, delimiter: Ie, newline: ae, preview: 10 }).parse(J), ge = 0; ge < Se.data.length; ge++) if (he && X(Se.data[ge])) it++;
              else {
                var pe = Se.data[ge].length;
                tt += pe, xe !== void 0 ? 0 < pe && (Ve += Math.abs(pe - xe), xe = pe) : xe = pe;
              }
              0 < Se.data.length && (tt /= Se.data.length - it), (me === void 0 || Ve <= me) && (be === void 0 || be < tt) && 1.99 < tt && (me = Ve, se = Ie, be = tt);
            }
            return { successful: !!(E.delimiter = se), bestDelimiter: se };
          }(te, E.newline, E.skipEmptyLines, E.comments, E.delimitersToGuess);
          re.successful ? E.delimiter = re.bestDelimiter : (O = !0, E.delimiter = l.DefaultDelimiter), F.meta.delimiter = E.delimiter;
        }
        var j = w(E);
        return E.preview && E.header && j.preview++, C = te, T = new y(j), F = T.parse(C, G, oe), q(), R ? { meta: { paused: !0 } } : F || { meta: { paused: !1 } };
      }, this.paused = function() {
        return R;
      }, this.pause = function() {
        R = !0, T.abort(), C = b(E.chunk) ? "" : C.substring(T.getCharIndex());
      }, this.resume = function() {
        N.streamer._halted ? (R = !1, N.streamer.parseChunk(C, !0)) : setTimeout(N.resume, 3);
      }, this.aborted = function() {
        return z;
      }, this.abort = function() {
        z = !0, T.abort(), F.meta.aborted = !0, b(E.complete) && E.complete(F), C = "";
      };
    }
    function m(E) {
      return E.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function y(E) {
      var C, T = (E = E || {}).delimiter, O = E.newline, I = E.comments, k = E.step, B = E.preview, P = E.fastMode, N = C = E.quoteChar === void 0 || E.quoteChar === null ? '"' : E.quoteChar;
      if (E.escapeChar !== void 0 && (N = E.escapeChar), (typeof T != "string" || -1 < l.BAD_DELIMITERS.indexOf(T)) && (T = ","), I === T) throw new Error("Comment character same as delimiter");
      I === !0 ? I = "#" : (typeof I != "string" || -1 < l.BAD_DELIMITERS.indexOf(I)) && (I = !1), O !== `
` && O !== "\r" && O !== `\r
` && (O = `
`);
      var M = 0, H = !1;
      this.parse = function(R, z, W) {
        if (typeof R != "string") throw new Error("Input must be a string");
        var F = R.length, Y = T.length, X = O.length, q = I.length, Q = b(k), ue = [], le = [], te = [], G = M = 0;
        if (!R) return De();
        if (E.header && !z) {
          var oe = R.split(O)[0].split(T), L = [], re = {}, j = !1;
          for (var J in oe) {
            var ae = oe[J];
            b(E.transformHeader) && (ae = E.transformHeader(ae, J));
            var he = ae, K = re[ae] || 0;
            for (0 < K && (j = !0, he = ae + "_" + K), re[ae] = K + 1; L.includes(he); ) he = he + "_" + K;
            L.push(he);
          }
          if (j) {
            var Z = R.split(O);
            Z[0] = L.join(T), R = Z.join(O);
          }
        }
        if (P || P !== !1 && R.indexOf(C) === -1) {
          for (var se = R.split(O), me = 0; me < se.length; me++) {
            if (te = se[me], M += te.length, me !== se.length - 1) M += O.length;
            else if (W) return De();
            if (!I || te.substring(0, q) !== I) {
              if (Q) {
                if (ue = [], it(te.split(T)), Ue(), H) return De();
              } else it(te.split(T));
              if (B && B <= me) return ue = ue.slice(0, B), De(!0);
            }
          }
          return De();
        }
        for (var xe = R.indexOf(T, M), be = R.indexOf(O, M), Te = new RegExp(m(N) + m(C), "g"), Ie = R.indexOf(C, M); ; ) if (R[M] !== C) if (I && te.length === 0 && R.substring(M, M + q) === I) {
          if (be === -1) return De();
          M = be + X, be = R.indexOf(O, M), xe = R.indexOf(T, M);
        } else if (xe !== -1 && (xe < be || be === -1)) te.push(R.substring(M, xe)), M = xe + Y, xe = R.indexOf(T, M);
        else {
          if (be === -1) break;
          if (te.push(R.substring(M, be)), pe(be + X), Q && (Ue(), H)) return De();
          if (B && ue.length >= B) return De(!0);
        }
        else for (Ie = M, M++; ; ) {
          if ((Ie = R.indexOf(C, Ie + 1)) === -1) return W || le.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: ue.length, index: M }), ge();
          if (Ie === F - 1) return ge(R.substring(M, Ie).replace(Te, C));
          if (C !== N || R[Ie + 1] !== N) {
            if (C === N || Ie === 0 || R[Ie - 1] !== N) {
              xe !== -1 && xe < Ie + 1 && (xe = R.indexOf(T, Ie + 1)), be !== -1 && be < Ie + 1 && (be = R.indexOf(O, Ie + 1));
              var Ve = Se(be === -1 ? xe : Math.min(xe, be));
              if (R.substr(Ie + 1 + Ve, Y) === T) {
                te.push(R.substring(M, Ie).replace(Te, C)), R[M = Ie + 1 + Ve + Y] !== C && (Ie = R.indexOf(C, M)), xe = R.indexOf(T, M), be = R.indexOf(O, M);
                break;
              }
              var tt = Se(be);
              if (R.substring(Ie + 1 + tt, Ie + 1 + tt + X) === O) {
                if (te.push(R.substring(M, Ie).replace(Te, C)), pe(Ie + 1 + tt + X), xe = R.indexOf(T, M), Ie = R.indexOf(C, M), Q && (Ue(), H)) return De();
                if (B && ue.length >= B) return De(!0);
                break;
              }
              le.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: ue.length, index: M }), Ie++;
            }
          } else Ie++;
        }
        return ge();
        function it(Xe) {
          ue.push(Xe), G = M;
        }
        function Se(Xe) {
          var ut = 0;
          if (Xe !== -1) {
            var xt = R.substring(Ie + 1, Xe);
            xt && xt.trim() === "" && (ut = xt.length);
          }
          return ut;
        }
        function ge(Xe) {
          return W || (Xe === void 0 && (Xe = R.substring(M)), te.push(Xe), M = F, it(te), Q && Ue()), De();
        }
        function pe(Xe) {
          M = Xe, it(te), te = [], be = R.indexOf(O, M);
        }
        function De(Xe) {
          return { data: ue, errors: le, meta: { delimiter: T, linebreak: O, aborted: H, truncated: !!Xe, cursor: G + (z || 0) } };
        }
        function Ue() {
          k(De()), ue = [], le = [];
        }
      }, this.abort = function() {
        H = !0;
      }, this.getCharIndex = function() {
        return M;
      };
    }
    function x(E) {
      var C = E.data, T = i[C.workerId], O = !1;
      if (C.error) T.userError(C.error, C.file);
      else if (C.results && C.results.data) {
        var I = { abort: function() {
          O = !0, g(C.workerId, { data: [], errors: [], meta: { aborted: !0 } });
        }, pause: S, resume: S };
        if (b(T.userStep)) {
          for (var k = 0; k < C.results.data.length && (T.userStep({ data: C.results.data[k], errors: C.results.errors, meta: C.results.meta }, I), !O); k++) ;
          delete C.results;
        } else b(T.userChunk) && (T.userChunk(C.results, I, C.file), delete C.results);
      }
      C.finished && !O && g(C.workerId, C.results);
    }
    function g(E, C) {
      var T = i[E];
      b(T.userComplete) && T.userComplete(C), T.terminate(), delete i[E];
    }
    function S() {
      throw new Error("Not implemented.");
    }
    function w(E) {
      if (typeof E != "object" || E === null) return E;
      var C = Array.isArray(E) ? [] : {};
      for (var T in E) C[T] = w(E[T]);
      return C;
    }
    function _(E, C) {
      return function() {
        E.apply(C, arguments);
      };
    }
    function b(E) {
      return typeof E == "function";
    }
    return o && (r.onmessage = function(E) {
      var C = E.data;
      if (l.WORKER_ID === void 0 && C && (l.WORKER_ID = C.workerId), typeof C.input == "string") r.postMessage({ workerId: l.WORKER_ID, results: l.parse(C.input, C.config), finished: !0 });
      else if (r.File && C.input instanceof File || C.input instanceof Object) {
        var T = l.parse(C.input, C.config);
        T && r.postMessage({ workerId: l.WORKER_ID, results: T, finished: !0 });
      }
    }), (f.prototype = Object.create(c.prototype)).constructor = f, (d.prototype = Object.create(c.prototype)).constructor = d, (p.prototype = Object.create(p.prototype)).constructor = p, (v.prototype = Object.create(c.prototype)).constructor = v, l;
  });
})(dM);
var x0e = dM.exports;
class b6 {
  constructor(t = null, n = null) {
    ln(this, "_start");
    ln(this, "_end");
    this._start = t, this._end = n ?? this._start;
  }
  isEmpty() {
    return this._start == null || this._end == null;
  }
  isSingleCell() {
    var t, n, r, a;
    return !this.isEmpty() && ((t = this._start) == null ? void 0 : t.col) === ((n = this._end) == null ? void 0 : n.col) && ((r = this._start) == null ? void 0 : r.row) === ((a = this._end) == null ? void 0 : a.row);
  }
  isSingleRow() {
    var t, n;
    return !this.isEmpty() && ((t = this._start) == null ? void 0 : t.row) === ((n = this._end) == null ? void 0 : n.row);
  }
  isCellInRange(t) {
    return !this.isEmpty() && t.row >= this.start.row && t.row <= this.end.row && t.col >= this.start.col && t.col <= this.end.col;
  }
  isRowInRange(t) {
    return !this.isEmpty() && t >= this.start.row && t <= this.end.row;
  }
  isColInRange(t) {
    return !this.isEmpty() && t >= this.start.col && t <= this.end.col;
  }
  get start() {
    var t, n, r, a;
    return {
      row: Math.min(((t = this._start) == null ? void 0 : t.row) ?? NaN, ((n = this._end) == null ? void 0 : n.row) ?? NaN),
      col: Math.min(((r = this._start) == null ? void 0 : r.col) ?? NaN, ((a = this._end) == null ? void 0 : a.col) ?? NaN)
    };
  }
  get end() {
    var t, n, r, a;
    return {
      row: Math.max(((t = this._start) == null ? void 0 : t.row) ?? NaN, ((n = this._end) == null ? void 0 : n.row) ?? NaN),
      col: Math.max(((r = this._start) == null ? void 0 : r.col) ?? NaN, ((a = this._end) == null ? void 0 : a.col) ?? NaN)
    };
  }
  startRange(t) {
    this._start = t, this._end = t;
  }
  endRange(t) {
    this._end = t;
  }
  clear() {
    this._start = null, this._end = null;
  }
}
var pM = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ra, function() {
    var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, a = /([+-]|\d\d)/g;
    return function(o, i, s) {
      var l = i.prototype;
      s.utc = function(h) {
        var m = { date: h, utc: !0, args: arguments };
        return new i(m);
      }, l.utc = function(h) {
        var m = s(this.toDate(), { locale: this.$L, utc: !0 });
        return h ? m.add(this.utcOffset(), n) : m;
      }, l.local = function() {
        return s(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var u = l.parse;
      l.parse = function(h) {
        h.utc && (this.$u = !0), this.$utils().u(h.$offset) || (this.$offset = h.$offset), u.call(this, h);
      };
      var c = l.init;
      l.init = function() {
        if (this.$u) {
          var h = this.$d;
          this.$y = h.getUTCFullYear(), this.$M = h.getUTCMonth(), this.$D = h.getUTCDate(), this.$W = h.getUTCDay(), this.$H = h.getUTCHours(), this.$m = h.getUTCMinutes(), this.$s = h.getUTCSeconds(), this.$ms = h.getUTCMilliseconds();
        } else c.call(this);
      };
      var f = l.utcOffset;
      l.utcOffset = function(h, m) {
        var y = this.$utils().u;
        if (y(h)) return this.$u ? 0 : y(this.$offset) ? f.call(this) : this.$offset;
        if (typeof h == "string" && (h = function(w) {
          w === void 0 && (w = "");
          var _ = w.match(r);
          if (!_) return null;
          var b = ("" + _[0]).match(a) || ["-", 0, 0], E = b[0], C = 60 * +b[1] + +b[2];
          return C === 0 ? 0 : E === "+" ? C : -C;
        }(h), h === null)) return this;
        var x = Math.abs(h) <= 16 ? 60 * h : h, g = this;
        if (m) return g.$offset = x, g.$u = h === 0, g;
        if (h !== 0) {
          var S = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (g = this.local().add(x + S, n)).$offset = x, g.$x.$localOffset = S;
        } else g = this.utc();
        return g;
      };
      var d = l.format;
      l.format = function(h) {
        var m = h || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return d.call(this, m);
      }, l.valueOf = function() {
        var h = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * h;
      }, l.isUTC = function() {
        return !!this.$u;
      }, l.toISOString = function() {
        return this.toDate().toISOString();
      }, l.toString = function() {
        return this.toDate().toUTCString();
      };
      var p = l.toDate;
      l.toDate = function(h) {
        return h === "s" && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : p.call(this);
      };
      var v = l.diff;
      l.diff = function(h, m, y) {
        if (h && this.$u === h.$u) return v.call(this, h, m, y);
        var x = this.local(), g = s(h).local();
        return v.call(x, g, m, y);
      };
    };
  });
})(pM);
var b0e = pM.exports;
const w0e = /* @__PURE__ */ Ki(b0e);
It.extend(w0e);
function zd(e, t = !1, n = !1) {
  var u, c, f, d;
  const { to: r, value: a, column: o, files: i = [], oldValue: s } = e, l = t ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm:ssZ";
  if (a === "" && r !== we.Attachment) return null;
  switch (r) {
    case we.SingleLineText:
    case we.LongText:
      return a.match(/^".*"$/) ? a.slice(1, -1) : a;
    case we.Number: {
      const p = Number(a);
      if (isNaN(p)) {
        if (n)
          return null;
        throw new TypeError(`值 '${a}' 不是一个数字`);
      }
      return p;
    }
    case we.Checkbox:
      if (typeof a == "boolean") return a;
      if (typeof a == "string") {
        const p = a.trim().toLowerCase();
        if (p === "true" || p === "1") return !0;
        if (p === "false" || p === "0" || p === "") return !1;
      }
      return null;
    case we.Date: {
      const p = It(a, ((u = Ga(o == null ? void 0 : o.meta)) == null ? void 0 : u.date_format) ?? "YYYY-MM-DD");
      if (!p.isValid()) {
        if (n)
          return null;
        throw new Error("不是一个合法的日期值");
      }
      return p.format("YYYY-MM-DD");
    }
    case we.DateTime: {
      const p = It(
        a,
        `${((c = Ga(o == null ? void 0 : o.meta)) == null ? void 0 : c.date_format) ?? "YYYY-MM-DD"} ${((f = Ga(o == null ? void 0 : o.meta)) == null ? void 0 : f.time_format) ?? "HH:mm"}`
      );
      if (!p.isValid()) {
        if (n)
          return null;
        throw new Error("不是一个合法的日期时间值");
      }
      return p.utc().format("YYYY-MM-DD HH:mm:ssZ");
    }
    case we.Time: {
      let p = It(a);
      if (p.isValid() || (p = It(a, "HH:mm:ss")), p.isValid() || (p = It(`1999-01-01 ${a}`)), !p.isValid()) {
        if (n)
          return null;
        throw new Error("Not a valid time value");
      }
      return p.format(l);
    }
    case we.Year: {
      if (/^\d+$/.test(a))
        return +a;
      const p = It(a);
      if (p.isValid())
        return p.format("YYYY");
      if (n)
        return null;
      throw new Error("Not a valid year value");
    }
    case we.Attachment: {
      const p = Ga(s), v = p && Array.isArray(p) ? p : [];
      if (!a && !i.length)
        return v.length ? void 0 : null;
      let h = [];
      if (a) {
        try {
          h = Ga(a), h = Array.isArray(h) ? h : typeof h == "object" && Object.keys(h).length ? [h] : [];
        } catch {
          if (n)
            return null;
          throw new Error("Invalid attachment data");
        }
        if (h.some((y) => y && !(y.url || y.data || y.path)))
          return null;
      }
      const m = [];
      for (const y of a ? h : i)
        m.push(y);
      if (v.length && !m.length)
        return;
      if (a && m.length) {
        const y = [];
        for (const x of m)
          y.push({
            ...x,
            title: U7(
              x == null ? void 0 : x.title,
              [...v, ...y],
              x == null ? void 0 : x.mimetype
            )
          });
        return JSON.stringify([...v, ...y]);
      } else return i.length && m.length ? m : null;
    }
    case we.SingleSelect:
    case we.MultiSelect: {
      if (a === "") return null;
      const p = (((d = o.colOptions) == null ? void 0 : d.options) || []).map(
        (m) => m.title
      ), h = a.split(",").filter((m) => p.includes(m));
      return h.length === 0 ? null : h.join(",");
    }
    default:
      return a;
  }
}
const mx = 0;
function S0e(e, t, n, r, a, o, i, s, l, u, c, f, d, p) {
  const v = ne(e), { copy: h } = g0e(), { base: m } = Fn(ws()), { api: y } = Na(), x = ne(r), g = ne(!1), S = ne(!1), w = Wn(new b6()), _ = Wn(new b6()), b = Wn({ row: null, col: null }), E = V(() => {
    var L;
    return (L = U(t)) == null ? void 0 : L.length;
  }), C = V(
    () => !(b.row === null || b.col === null || isNaN(b.row) || isNaN(b.col))
  );
  function T(L, re) {
    b.row === L && b.col === re || (x.value = !1, b.row = L, b.col = re);
  }
  function O(L) {
    const re = I(L), j = k(L);
    return `${re} ${j}`;
  }
  function I(L) {
    var re;
    return ((re = Ga(L == null ? void 0 : L.meta)) == null ? void 0 : re.date_format) ?? Bf[0];
  }
  function k(L) {
    var re;
    return ((re = Ga(L == null ? void 0 : L.meta)) == null ? void 0 : re.time_format) ?? hm[0];
  }
  const B = (L, re) => {
    var J;
    let j = re.title && L.row[re.title] || "";
    if (re.uidt === we.Checkbox && (j = !!j), [we.User, we.CreatedBy, we.LastModifiedBy].includes(re.uidt) && j && (j = Array.isArray(j) ? j : [j].map((ae) => ae.email).join(", ")), typeof j == "object" ? j = JSON.stringify(j) : j = j.toString(), re.uidt === we.Formula && (j = j.replace(
      /\b(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}[+-]\d{2}:\d{2})\b/g,
      (ae) => It(ae).utc().local().format("YYYY-MM-DD HH:mm")
    )), [we.DateTime, we.CreatedTime, we.LastModifiedTime].includes(
      re.uidt
    )) {
      j = j.replace(/["']/g, "");
      let ae = It(j);
      if (ae.isValid() || (ae = It(j, "YYYY-MM-DD HH:mm:ssZ")), j = ae.format(O(re)), !ae.isValid())
        return "";
    }
    if (re.uidt === we.Date) {
      const ae = (J = Ga(re.meta)) == null ? void 0 : J.date_format;
      ae && F_(ae) ? j = It(j, ae).format(ae) : j = It(j, "YYYY-MM-DD").format(ae);
    }
    if (re.uidt === we.Time) {
      j = j.replace(/["']/g, "");
      let ae = It(j);
      if (ae.isValid() || (ae = It(j, "YYYY-MM-DD HH:mm:ssZ")), ae.isValid() || (ae = It(j, "HH:mm:ss")), !ae.isValid())
        return "";
      j = ae.format(k(re));
    }
    return re.uidt === we.LongText && (j = `"${j.replace(/"/g, '\\"')}"`), j;
  }, P = (L, re) => {
    let j = "<table>", J = "";
    const ae = [];
    return L.forEach((he, K) => {
      let Z = "<tr>";
      const se = [];
      re.forEach((me, xe) => {
        const be = B(he, me);
        Z += `<td>${be}</td>`, J = `${J}${be}${re.length - 1 !== xe ? "	" : ""}`, se.push(be);
      }), j += `${Z}</tr>`, L.length - 1 !== K && (J = `${J}
`), ae.push(se);
    }), j += "</table>", { html: j, text: J, json: ae };
  }, N = async (L, re) => {
    const { html: j, text: J } = P(L, re), ae = new Blob([j], { type: "text/html" }), he = new Blob([J], { type: "text/plain" });
    return navigator.clipboard.write([
      new ClipboardItem({ [ae.type]: ae, [he.type]: he })
    ]);
  };
  async function M(L) {
    try {
      if (w.start !== null && w.end !== null && !w.isSingleCell()) {
        const re = U(n).slice(w.start.row, w.end.row + 1), j = U(t).slice(w.start.col, w.end.col + 1);
        await N(re, j), wt.success("复制到剪贴板");
      } else {
        const re = (L == null ? void 0 : L.row) ?? b.row, j = (L == null ? void 0 : L.col) ?? b.col;
        if (re != null && j != null) {
          const J = U(n)[re], ae = U(t)[j], he = B(J, ae);
          await h(he), wt.success("复制到剪贴板");
        }
      }
    } catch {
      wt.error("未能复制到剪贴板");
    }
  }
  function H(L, re) {
    return b.col === re && b.row === L ? !0 : w.isCellInRange({ row: L, col: re });
  }
  function R(L, re) {
    return _._start === null || _._end === null || w.isCellInRange({ row: L, col: re }) ? !1 : _.isCellInRange({ row: L, col: re });
  }
  const z = (L, re, j = !1) => !L || !re ? (j && wt.info("Please select a cell to paste"), !1) : Gr(re) ? (j && wt.info("处于活动状态的单元格不能粘贴内容"), !1) : re.ai ? (j && wt.info("自动增量字段不可编辑"), !1) : re.pk && !L.rowMeta.new ? (j && wt.info("不支持编辑主键"), !1) : !0;
  function W(L, re, j) {
    if (S.value) {
      const J = U(n)[re];
      if (!w._start || !w._end || J.rowMeta.new) return;
      _.endRange({ row: re, col: w._end.col }), u == null || u(re, j);
      return;
    }
    g.value && (w.endRange({ row: re, col: j }), u == null || u(re, j), L.preventDefault());
  }
  function F(L, re, j) {
    if (!(((L == null ? void 0 : L.button) !== mx || (L == null ? void 0 : L.button) === mx && L.ctrlKey) && H(re, j))) {
      if (x.value || (g.value = !0), o.value = !1, L.preventDefault(), L.shiftKey) {
        (b.col === null || b.row === null) && w.startRange({ row: re, col: j }), w.endRange({ row: re, col: j });
        return;
      }
      w.startRange({ row: re, col: j }), (b.row !== re || b.col !== j) && (b.row = null, b.col = null);
    }
  }
  const Y = (L, re, j) => {
    (!L.shiftKey || b.col === null || b.row === null) && T(re, j), u == null || u(re, j);
  }, X = () => {
    if (S.value) {
      if (S.value = !1, _._start === null || _._end === null) return;
      if (w._start !== null && w._end !== null) {
        const L = { row: w._start.row, col: w._start.col }, re = U(n).slice(w.start.row, w.end.row + 1), j = U(t).slice(w.start.col, w.end.col + 1), J = P(re, j).json, ae = _._start.row <= _._end.row ? 1 : -1;
        let he = ae === 1 ? 0 : J.length - 1;
        const K = [], Z = [];
        for (let se = _._start.row; ae === 1 ? se <= _._end.row : se >= _._end.row; se += ae) {
          if (H(se, w.start.col))
            continue;
          const me = U(n)[se];
          let xe = 0;
          for (let be = _.start.col; be <= _.end.col; be++) {
            const Te = U(t)[be];
            if (!z(me, Te)) {
              xe++;
              continue;
            }
            Z.push(Te.title);
            const Ie = zd(
              {
                value: J[he][xe],
                to: Te.uidt,
                column: Te
              },
              !1,
              !0
            );
            Ie !== void 0 && (me.row[Te.title] = Ie, K.push(me)), xe++;
          }
          ae === 1 ? he = he < J.length - 1 ? he + 1 : 0 : he = he >= 1 ? he - 1 : J.length - 1;
        }
        d == null || d(K, Z).then(() => {
          _._start === null || _._end === null || (w.startRange(L), w.endRange(_._end), T(L.row, L.col), _.clear());
        });
      } else
        _.clear();
      return;
    }
    g.value && (g.value = !1, setTimeout(() => {
      w._start && (b.row !== w._start.row || b.col !== w._start.col) && T(w._start.row, w._start.col);
    }, 0));
  }, q = async (L) => {
    var j, J, ae, he, K, Z, se, me, xe, be, Te, Ie, Ve, tt, it, Se, ge, pe, De, Ue, Xe, ut, xt, Mt, yt, gt, ct, Ht, Ut, In, wr, eo;
    if (await (c == null ? void 0 : c(L)))
      return !0;
    if (ku() || !C.value || b.row === null || b.col === null)
      return;
    const re = nd() ? L.metaKey : L.ctrlKey;
    switch (L.key) {
      case "Tab":
        L.preventDefault(), w.clear(), L.shiftKey ? b.col > 0 ? (b.col--, x.value = !1) : b.row > 0 && (b.row--, b.col = U(E.value) - 1, x.value = !1) : b.col < U(E.value) - 1 ? (b.col++, x.value = !1) : b.row < U(n).length - 1 && (b.row++, b.col = 0, x.value = !1), u == null || u();
        break;
      case "Enter":
        L.preventDefault(), w.clear(), l(U(n)[b.row], U(t)[b.col]);
        break;
      case "Delete":
      case "Backspace":
        L.preventDefault(), w.isSingleCell() ? (w.clear(), await i(b)) : await s();
        break;
      case "ArrowRight":
        L.preventDefault(), L.shiftKey ? re ? (x.value = !1, w.endRange({
          row: ((j = w._end) == null ? void 0 : j.row) ?? b.row,
          col: U(E.value) - 1
        }), u == null || u((J = w._end) == null ? void 0 : J.row, (ae = w._end) == null ? void 0 : ae.col)) : (((he = w._end) == null ? void 0 : he.col) ?? b.col) < U(E.value) - 1 && (x.value = !1, w.endRange({
          row: ((K = w._end) == null ? void 0 : K.row) ?? b.row,
          col: (((Z = w._end) == null ? void 0 : Z.col) ?? b.col) + 1
        }), u == null || u((se = w._end) == null ? void 0 : se.row, (me = w._end) == null ? void 0 : me.col)) : (w.clear(), b.col < U(E.value) - 1 && (b.col++, w.startRange({ row: b.row, col: b.col }), u == null || u(), x.value = !1));
        break;
      case "ArrowLeft":
        L.preventDefault(), L.shiftKey ? re ? (x.value = !1, w.endRange({
          row: ((xe = w._end) == null ? void 0 : xe.row) ?? b.row,
          col: 0
        }), u == null || u((be = w._end) == null ? void 0 : be.row, (Te = w._end) == null ? void 0 : Te.col)) : (((Ie = w._end) == null ? void 0 : Ie.col) ?? b.col) > 0 && (x.value = !1, w.endRange({
          row: ((Ve = w._end) == null ? void 0 : Ve.row) ?? b.row,
          col: (((tt = w._end) == null ? void 0 : tt.col) ?? b.col) - 1
        }), u == null || u((it = w._end) == null ? void 0 : it.row, (Se = w._end) == null ? void 0 : Se.col)) : (w.clear(), b.col > 0 && (b.col--, w.startRange({ row: b.row, col: b.col }), u == null || u(), x.value = !1));
        break;
      case "ArrowUp":
        L.preventDefault(), L.shiftKey ? re ? (x.value = !1, w.endRange({
          row: 0,
          col: ((ge = w._end) == null ? void 0 : ge.col) ?? b.col
        }), u == null || u((pe = w._end) == null ? void 0 : pe.row, (De = w._end) == null ? void 0 : De.col)) : (((Ue = w._end) == null ? void 0 : Ue.row) ?? b.row) > 0 && (x.value = !1, w.endRange({
          row: (((Xe = w._end) == null ? void 0 : Xe.row) ?? b.row) - 1,
          col: ((ut = w._end) == null ? void 0 : ut.col) ?? b.col
        }), u == null || u((xt = w._end) == null ? void 0 : xt.row, (Mt = w._end) == null ? void 0 : Mt.col)) : (w.clear(), b.row > 0 && (b.row--, w.startRange({ row: b.row, col: b.col }), u == null || u(), x.value = !1));
        break;
      case "ArrowDown":
        L.preventDefault(), L.shiftKey ? re ? (x.value = !1, w.endRange({
          row: U(n).length - 1,
          col: ((yt = w._end) == null ? void 0 : yt.col) ?? b.col
        }), u == null || u((gt = w._end) == null ? void 0 : gt.row, (ct = w._end) == null ? void 0 : ct.col)) : (((Ht = w._end) == null ? void 0 : Ht.row) ?? b.row) < U(n).length - 1 && (x.value = !1, w.endRange({
          row: (((Ut = w._end) == null ? void 0 : Ut.row) ?? b.row) + 1,
          col: ((In = w._end) == null ? void 0 : In.col) ?? b.col
        }), u == null || u((wr = w._end) == null ? void 0 : wr.row, (eo = w._end) == null ? void 0 : eo.col)) : (w.clear(), b.row < U(n).length - 1 && (b.row++, w.startRange({ row: b.row, col: b.col }), u == null || u(), x.value = !1));
        break;
      default:
        {
          const ur = U(n)[b.row], rr = U(t)[b.col];
          if ((!U(x) || !M2(rr)) && !jm() && (nd() ? L.metaKey : L.ctrlKey))
            switch (L.keyCode) {
              case 67:
                await M();
                break;
              case 65:
                w.startRange({ row: 0, col: 0 }), w.endRange({
                  row: U(n).length - 1,
                  col: U(E.value) - 1
                });
                break;
            }
          if (L.key === "Escape" && (w.clear(), b.col = null, b.row = null), U(x) || L.ctrlKey || L.altKey || L.metaKey)
            return !0;
          if (L.key.length === 1) {
            if (!U(a) && !ur.rowMeta.new)
              return wt.info("不允许更新没有主键的表");
            M2(rr) && l(ur, rr) && rr.title && (rr.uidt === we.LongText ? ur.row[rr.title] === "<br />" ? ur.row[rr.title] = L.key : ur.row[rr.title] = ur.row[rr.title] ? ur.row[rr.title] + L.key : L.key : ur.row[rr.title] = "");
          }
        }
        break;
    }
  }, Q = () => w.clear(), ue = w.clear.bind(w), le = async (L) => {
    var j, J, ae, he, K, Z, se;
    if (jm() || ku() || !C.value || U(x) || b.row === null || b.row === void 0 || b.col === null || b.col === void 0)
      return;
    L.preventDefault();
    const re = ((j = L.clipboardData) == null ? void 0 : j.getData("text/plain")) || "";
    try {
      if (re != null && re.includes(`
`) || re != null && re.includes("	")) {
        const me = x0e.parse(re, { delimiter: "	", escapeChar: "\\" });
        if (me.errors.length > 0)
          throw new Error(me.errors[0].message);
        const xe = me.data, be = Math.max(
          xe.length,
          w.end.row - w.start.row + 1
        ), Te = be, Ie = xe[0].length, Ve = U(t).slice(b.col, b.col + Ie), tt = U(n).slice(b.row, b.row + be), it = [];
        let Se = 0, ge = !1;
        for (let pe = 0; pe < Te; pe++) {
          const De = tt[pe];
          if (!De || De.rowMeta.new) break;
          Se++;
          for (let Ue = 0; Ue < Ie; Ue++) {
            const Xe = Ve[Ue];
            if (!z(De, Xe)) {
              ge || (wt.info(
                "Group paste operation is not supported on Links/LinkToAnotherRecord column"
              ), ge = !0);
              continue;
            }
            it.push(Xe.title);
            const ut = zd(
              {
                // Repeat the clipboard data array if the matrix is smaller than the selection
                value: xe[pe % xe.length][Ue],
                to: Xe.uidt,
                column: Xe,
                oldValue: Xe.uidt === we.Attachment ? De.row[Xe.title] : void 0
              },
              !1,
              !0
            );
            ut !== void 0 && (De.row[Xe.title] = ut);
          }
        }
        try {
          await (d == null ? void 0 : d(tt, it));
        } catch {
          wt.error("格式不兼容，粘贴失败");
        }
        Se > 0 && (w.startRange({ row: b.row, col: b.col }), w.endRange({
          row: b.row + Se - 1,
          col: b.col + Ie - 1
        }));
      } else if (w.isSingleCell()) {
        const me = U(n)[b.row], xe = U(t)[b.col];
        if (!z(me, xe, !0))
          return;
        const be = zd(
          {
            value: re,
            to: xe.uidt,
            column: xe,
            files: xe.uidt === we.Attachment && ((ae = (J = L.clipboardData) == null ? void 0 : J.files) != null && ae.length) ? (he = L.clipboardData) == null ? void 0 : he.files : void 0,
            oldValue: me.row[xe.title]
          },
          !1
        );
        if (xe.uidt === we.Attachment && ((Z = (K = L.clipboardData) == null ? void 0 : K.files) != null && Z.length) && (be != null && be.length)) {
          const Te = await G(
            be,
            xe.id,
            me.row[xe.title]
          );
          me.row[xe.title] = Te ? JSON.stringify(Te) : null;
        } else be !== void 0 && (me.row[xe.title] = be);
        await (f == null ? void 0 : f(b));
      } else {
        const me = w.start, xe = w.end, be = Math.min(me.row, xe.row), Te = Math.max(me.row, xe.row), Ie = Math.min(me.col, xe.col), Ve = Math.max(me.col, xe.col), tt = U(t).slice(Ie, Ve + 1), it = U(n).slice(be, Te + 1), Se = [];
        let ge, pe = !1;
        const De = (se = L.clipboardData) == null ? void 0 : se.files;
        for (const Ue of it)
          if (!(!Ue || Ue.rowMeta.new))
            for (const Xe of tt) {
              if (!Xe.title || !z(Ue, Xe)) {
                pe || (wt.info(
                  "Group paste operation is not supported on Links/LinkToAnotherRecord column"
                ), pe = !0);
                continue;
              }
              if (De != null && De.length) {
                if (Xe.uidt !== we.Attachment)
                  continue;
                if (ge === void 0) {
                  const ut = zd(
                    {
                      value: "",
                      to: Xe.uidt,
                      column: Xe,
                      files: De,
                      oldValue: Ue.row[Xe.title]
                    },
                    !1,
                    !0
                  );
                  if (ut != null && ut.length) {
                    const xt = await G(
                      ut,
                      Xe.id,
                      Ue.row[Xe.title]
                    );
                    ge = xt ? JSON.stringify(xt) : null;
                  }
                }
              } else
                ge = zd(
                  {
                    value: re,
                    to: Xe.uidt,
                    column: Xe,
                    oldValue: Ue.row[Xe.title]
                  },
                  !1,
                  !0
                );
              Se.push(Xe.title), ge !== void 0 && (Ue.row[Xe.title] = ge);
            }
        if (!Se.length) return;
        await (d == null ? void 0 : d(it, Se));
      }
    } catch (me) {
      console.error(me), wt.error(await Pn(me));
    }
  };
  function te(L) {
    var re, j;
    (L == null ? void 0 : L.button) === mx && (S.value = !0, w._start && w._end && (_.startRange({ row: (re = w._start) == null ? void 0 : re.row, col: w._start.col }), _.endRange({ row: (j = w._end) == null ? void 0 : j.row, col: w._end.col })), L.preventDefault());
  }
  async function G(L, re, j) {
    var ae;
    const J = [];
    try {
      const he = await y.storage.upload(
        {
          path: ["noco", m.value.id, (ae = v.value) == null ? void 0 : ae.id, re].join("/")
        },
        {
          files: L
        }
      );
      for (const K of he)
        J.push({
          ...K,
          title: U7(
            K == null ? void 0 : K.title,
            [...oe(j), ...J],
            K == null ? void 0 : K.mimetype
          )
        });
      return J;
    } catch (he) {
      wt.error(he.message || "发生了一些内部错误");
    }
  }
  function oe(L) {
    const re = Ga(L);
    return re && Array.isArray(re) ? re : [];
  }
  return or(document, "keydown", q), or(document, "mouseup", X), or(document, "paste", le), or(p, "mousedown", te), {
    isCellActive: C,
    handleMouseDown: F,
    handleMouseOver: W,
    clearSelectedRange: ue,
    copyValue: M,
    isCellSelected: H,
    activeCell: b,
    handleCellClick: Y,
    resetSelectedRange: Q,
    selectedRange: w,
    makeActive: T,
    isCellInFillRange: R,
    isFillMode: S
  };
}
const $d = JV(() => {
  const e = Q8(), t = {
    baseId: "p1xsf1p7utb2t32",
    typeOrId: "nc",
    viewId: "moww1jelte277fr",
    viewTitle: ""
  }, n = V(() => {
    const v = [{ key: "root", param: "root" }];
    for (const [h, m] of Object.entries(t))
      Array.isArray(m) ? v.push({ key: h, param: m.join(",") }) : v.push({ key: h, param: m });
    return v;
  }), r = (v) => {
    const h = n.value.find((m) => m.key === "slugs");
    return h && (Array.isArray(h.param) ? h.param : h.param.split(",")).some((y) => ["webhook", "field", "api", "relation"].includes(y)) ? !1 : v.every((m) => n.value.some(
      // viewTitle is optional for default view
      (y) => Array.isArray(m.param) ? m.key === "viewTitle" && y.key === "viewTitle" && y.param === "" || m.key === y.key && m.param.includes(y.param) : m.key === "viewTitle" && y.key === "viewTitle" && y.param === "" || m.key === y.key && m.param === y.param
    ));
  }, a = ne([]), o = ne([]), i = (v, h = !1) => {
    h || (o.value = o.value.filter((m) => !r(m.scope || []))), a.value.push(v);
  }, s = (v) => {
    o.value.push(v);
  }, l = async () => {
    let v = -1;
    for (let m = a.value.length - 1; m >= 0; m--) {
      const y = a.value[m].scope || [{ key: "root", param: "root" }];
      if (r(y)) {
        v = m;
        break;
      }
    }
    if (v === -1) return;
    const h = a.value.splice(v, 1)[0];
    if (h)
      try {
        await h.undo.fn.apply(h, h.undo.args), s(h);
      } catch {
        wt.warn("Error while undoing action, it is skipped.");
      }
  }, u = async () => {
    let v = -1;
    for (let m = o.value.length - 1; m >= 0; m--) {
      const y = o.value[m].scope || [{ key: "root", param: "root" }];
      if (r(y)) {
        v = m;
        break;
      }
    }
    if (v === -1) return;
    const h = o.value.splice(v, 1)[0];
    if (h)
      try {
        await h.redo.fn.apply(h, h.redo.args), i(h, !0);
      } catch {
        wt.warn("Error while redoing action, it is skipped.");
      }
  }, c = () => [{ key: "root", param: "root" }], f = (v) => v.base ? [{ key: "baseId", param: v.base.id }] : v.model ? [{ key: "baseId", param: v.model.base_id }] : v.view ? [{ key: "baseId", param: v.view.base_id }] : [{ key: "baseId", param: v.base_id }], d = (v) => v.model ? [
    { key: "baseId", param: v.model.base_id },
    { key: "viewId", param: v.model.id }
  ] : v.view ? [
    { key: "baseId", param: v.view.base_id },
    { key: "viewId", param: v.view.fk_model_id }
  ] : [
    { key: "baseId", param: v.base_id },
    { key: "viewId", param: v.model_id }
  ], p = (v) => v.view ? [
    { key: "baseId", param: v.view.base_id },
    { key: "viewId", param: v.view.fk_model_id },
    { key: "viewTitle", param: [v.view.title, v.view.id] }
  ] : [
    { key: "baseId", param: v.base_id },
    { key: "viewId", param: v.model_id },
    { key: "viewTitle", param: [v.title, v.id] }
  ];
  return or(document, "keydown", async (v) => {
    const h = nd() ? v.metaKey : v.ctrlKey;
    if (!(v && (v.target instanceof HTMLInputElement || v.target instanceof HTMLTextAreaElement)) && h && !v.altKey)
      switch (v.keyCode) {
        case 90: {
          v.preventDefault(), v.shiftKey ? o.value.length && u() : a.value.length && l();
          break;
        }
      }
  }), {
    addUndo: i,
    undo: l,
    clone: e,
    defineRootScope: c,
    defineProjectScope: f,
    defineModelScope: d,
    defineViewScope: p
  };
});
function _0e(e) {
  const { meta: t, viewMeta: n, formattedData: r, paginationData: a, callbacks: o } = e, { addUndo: i, clone: s, defineViewScope: l } = $d(), { base: u } = Fn(ws()), { api: c } = Na(), { isPaginationLoading: f } = Fn(pd()), d = V({
    get() {
      return !!r.value.length && r.value.every((T) => T.rowMeta.selected);
    },
    set(T) {
      r.value.forEach((O) => O.rowMeta.selected = T);
    }
  });
  function p(T = r.value.length, O = t.value) {
    return r.value.splice(T, 0, {
      row: { ...Ice(O == null ? void 0 : O.columns) },
      oldRow: {},
      rowMeta: { new: !0 }
    }), r.value[T];
  }
  async function v(T, O = {}, {
    metaValue: I = t.value,
    viewMetaValue: k = n.value
  } = {}, B = !1) {
    var N, M;
    const P = T.row;
    T.rowMeta && (T.rowMeta.saving = !0);
    try {
      const { missingRequiredColumns: H, insertObj: R } = await R2({
        meta: I,
        row: P,
        undo: B
      });
      if (H.size) return;
      const W = (await c.dbViewRow.create(
        (N = u.value) == null ? void 0 : N.id,
        I == null ? void 0 : I.id,
        k == null ? void 0 : k.id,
        { ...R, ...O || {} }
      )).data;
      if (!B) {
        Object.assign(T, {
          row: { ...W, ...P },
          rowMeta: { ...T.rowMeta || {}, new: void 0 },
          oldRow: { ...W }
        });
        const F = Mi(W, I == null ? void 0 : I.columns), Y = So(W, I == null ? void 0 : I.columns), X = wl(Y, r.value);
        i({
          redo: {
            fn: async function(Q, ue, le) {
              var G, oe;
              Q.row = { ...Y, ...Q.row };
              const te = await v(Q, ue, void 0, !0);
              X !== -1 && le.pageSize === a.value.pageSize ? le.page === a.value.page ? r.value.splice(X, 0, {
                row: { ...Q, ...te },
                rowMeta: Q.rowMeta,
                oldRow: Q.oldRow
              }) : await ((G = o == null ? void 0 : o.changePage) == null ? void 0 : G.call(o, le.page)) : await ((oe = o == null ? void 0 : o.loadData) == null ? void 0 : oe.call(o));
            },
            args: [
              s(T),
              s(O),
              { page: a.value.page, pageSize: a.value.pageSize }
            ]
          },
          undo: {
            fn: async function(Q) {
              await S(Q), X !== -1 && r.value.splice(X, 1), a.value.totalRows = a.value.totalRows - 1;
            },
            args: [F]
          },
          scope: l({ view: n.value })
        });
      }
      return await ((M = o == null ? void 0 : o.syncCount) == null ? void 0 : M.call(o)), W;
    } catch (H) {
      wt.error(await Pn(H));
    } finally {
      T.rowMeta && (T.rowMeta.saving = !1);
    }
  }
  async function h(T, {
    metaValue: O = t.value,
    viewMetaValue: I = n.value
  } = {}, k = !1) {
    var B, P;
    f.value = !0;
    try {
      const N = ((B = await Promise.all(
        T.map(async (H) => {
          const { missingRequiredColumns: R, insertObj: z } = await R2({
            meta: O,
            ltarState: {},
            getMeta,
            row: H.row,
            undo: k
          });
          if (R.size === 0)
            return z;
        })
      )) == null ? void 0 : B.filter(Boolean)) ?? [], M = await c.dbDataTableRow.create(
        O == null ? void 0 : O.id,
        N,
        {
          viewId: I == null ? void 0 : I.id
        }
      );
      return await ((P = o == null ? void 0 : o.syncCount) == null ? void 0 : P.call(o)), M;
    } catch (N) {
      wt.error(await Pn(N));
    } finally {
      f.value = !1;
    }
  }
  async function m(T, O, {
    metaValue: I = t.value,
    viewMetaValue: k = n.value
  } = {}, B = !1) {
    T.rowMeta && (T.rowMeta.saving = !0);
    try {
      const P = Mi(T.row, I == null ? void 0 : I.columns), M = (await c.dbViewRow.update(
        "noco",
        u == null ? void 0 : u.value.id,
        I == null ? void 0 : I.id,
        k == null ? void 0 : k.id,
        P,
        {
          // if value is undefined treat it as null
          [O]: T.row[O] ?? null
        }
        // todo:
        // {
        //   query: { ignoreWebhook: !saved }
        // }
      )).data;
      return B || (i({
        redo: {
          fn: async function(R, z, W) {
            var Y, X, q;
            const F = await m(R, z, void 0, !0);
            if (W.page === a.value.page && W.pageSize === a.value.pageSize) {
              const Q = wl(
                So(R.row, (Y = t == null ? void 0 : t.value) == null ? void 0 : Y.columns),
                r.value
              );
              if (Q !== -1) {
                const ue = r.value[Q];
                Object.assign(ue.row, F), Object.assign(ue.oldRow, F);
              } else
                await ((X = o == null ? void 0 : o.loadData) == null ? void 0 : X.call(o));
            } else
              await ((q = o == null ? void 0 : o.changePage) == null ? void 0 : q.call(o, W.page));
          },
          args: [
            s(T),
            O,
            { page: a.value.page, pageSize: a.value.pageSize }
          ]
        },
        undo: {
          fn: async function(R, z, W) {
            var Y, X, q;
            const F = await m(
              { row: R.oldRow, oldRow: R.row, rowMeta: R.rowMeta },
              z,
              void 0,
              !0
            );
            if (W.page === a.value.page && W.pageSize === a.value.pageSize) {
              const Q = wl(
                So(R.row, (Y = t == null ? void 0 : t.value) == null ? void 0 : Y.columns),
                r.value
              );
              if (Q !== -1) {
                const ue = r.value[Q];
                Object.assign(ue.row, F), Object.assign(ue.oldRow, F);
              } else
                await ((X = o == null ? void 0 : o.loadData) == null ? void 0 : X.call(o));
            } else
              await ((q = o == null ? void 0 : o.changePage) == null ? void 0 : q.call(o, W.page));
          },
          args: [
            s(T),
            O,
            { page: a.value.page, pageSize: a.value.pageSize }
          ]
        },
        scope: l({ view: n.value })
      }), Object.assign(
        T.row,
        I.columns.reduce(
          (H, R) => (R.title in M && (R.uidt === we.Checkbox || R.uidt === "LastModifiedTime" || R.au || R.cdf && / on update /i.test(R.cdf)) && (H[R.title] = M[R.title]), H),
          {}
        )
      ), Object.assign(T.oldRow, M)), M;
    } catch (P) {
      wt.error(`行更新失败 ${await Pn(P)}`);
    } finally {
      T.rowMeta && (T.rowMeta.saving = !1);
    }
  }
  async function y(T, O, I, k = {}) {
    if (T.rowMeta && (T.rowMeta.changed = !1), await j3(() => {
      var B, P;
      return !((B = T.rowMeta) != null && B.new && ((P = T.rowMeta) != null && P.saving));
    }).toMatch((B) => B), T.rowMeta.new)
      return await v(T, I, k);
    O && await m(T, O, k);
  }
  async function x(T, O, {
    metaValue: I = t.value,
    viewMetaValue: k = n.value
  } = {}, B = !1) {
    const P = [];
    for (const M of T)
      M.rowMeta && (M.rowMeta.changed = !1), P.push(j3(() => {
        var H, R;
        return !((H = M.rowMeta) != null && H.new && ((R = M.rowMeta) != null && R.saving));
      }).toMatch((H) => H));
    await Promise.all(P);
    const N = [];
    for (const M of T) {
      M.rowMeta && (M.rowMeta.saving = !0);
      const H = So(M.row, I == null ? void 0 : I.columns), R = O.reduce(
        (z, W) => (z[W] = M.row[W], z),
        {}
      );
      N.push({ ...R, ...H });
    }
    await c.dbTableRow.bulkUpdate(
      "noco",
      I == null ? void 0 : I.base_id,
      I == null ? void 0 : I.id,
      N
    ), B || i({
      redo: {
        fn: async function(H, R, z) {
          var W, F, Y;
          if (await x(H, R, { metaValue: I, viewMetaValue: k }, !0), z.page === a.value.page && z.pageSize === a.value.pageSize)
            for (const X of H) {
              const q = wl(
                So(X.row, (W = t == null ? void 0 : t.value) == null ? void 0 : W.columns),
                r.value
              );
              if (q !== -1) {
                const Q = r.value[q];
                Object.assign(Q.row, X.row), Object.assign(Q.oldRow, X.row);
              } else {
                await ((F = o == null ? void 0 : o.loadData) == null ? void 0 : F.call(o));
                break;
              }
            }
          else
            await ((Y = o == null ? void 0 : o.changePage) == null ? void 0 : Y.call(o, z.page));
        },
        args: [
          s(T),
          s(O),
          { page: a.value.page, pageSize: a.value.pageSize }
        ]
      },
      undo: {
        fn: async function(H, R, z) {
          var W, F, Y;
          if (await x(H, R, { metaValue: I, viewMetaValue: k }, !0), z.page === a.value.page && z.pageSize === a.value.pageSize)
            for (const X of H) {
              const q = wl(
                So(X.row, (W = t == null ? void 0 : t.value) == null ? void 0 : W.columns),
                r.value
              );
              if (q !== -1) {
                const Q = r.value[q];
                Object.assign(Q.row, X.row), Object.assign(Q.oldRow, X.row);
              } else {
                await ((F = o == null ? void 0 : o.loadData) == null ? void 0 : F.call(o));
                break;
              }
            }
          else
            await ((Y = o == null ? void 0 : o.changePage) == null ? void 0 : Y.call(o, z.page));
        },
        args: [
          s(
            T.map((M) => ({ row: M.oldRow, oldRow: M.row, rowMeta: M.rowMeta }))
          ),
          O,
          { page: a.value.page, pageSize: a.value.pageSize }
        ]
      },
      scope: l({ view: k })
    });
    for (const M of T)
      M.rowMeta && (M.rowMeta.saving = !1);
  }
  async function g(T, {
    metaValue: O = t.value,
    viewMetaValue: I = n.value
  } = {}) {
    var k;
    I && (await c.dbTableRow.bulkUpdateAll(
      "noco",
      O == null ? void 0 : O.base_id,
      O == null ? void 0 : O.id,
      T,
      {
        viewId: I.id
      }
    ), await ((k = o == null ? void 0 : o.loadData) == null ? void 0 : k.call(o)));
  }
  async function S(T, {
    metaValue: O = t.value,
    viewMetaValue: I = n.value
  } = {}) {
    if (!T)
      throw new Error("Delete not allowed for table which doesn't have primary Key");
    return (await c.dbViewRow.delete(
      "noco",
      u.value.id,
      O == null ? void 0 : O.id,
      I == null ? void 0 : I.id,
      encodeURIComponent(T)
    )).success ? !0 : (wt.info("删除失败"), !1);
  }
  async function w(T, O) {
    var I, k, B;
    try {
      const P = r.value[T];
      if (!P.rowMeta.new) {
        const N = (k = (I = t == null ? void 0 : t.value) == null ? void 0 : I.columns) == null ? void 0 : k.filter((H) => H.pk).map((H) => P.row[H.title]).join("___");
        if (!await S(N))
          return;
        O || i({
          redo: {
            fn: async function(R) {
              var F;
              await S(R);
              const z = So(
                P.row,
                (F = t == null ? void 0 : t.value) == null ? void 0 : F.columns
              ), W = wl(z, r.value);
              W !== -1 && r.value.splice(W, 1), a.value.totalRows = a.value.totalRows - 1;
            },
            args: [N]
          },
          undo: {
            fn: async function(R, z, W) {
              var Y, X, q;
              const F = So(R.row, (Y = t.value) == null ? void 0 : Y.columns);
              R.row = { ...F, ...R.row }, await v(R, z, {}, !0), T !== -1 && W.pageSize === a.value.pageSize ? W.page === a.value.page ? r.value.splice(T, 0, R) : await ((X = o == null ? void 0 : o.changePage) == null ? void 0 : X.call(o, W.page)) : await ((q = o == null ? void 0 : o.loadData) == null ? void 0 : q.call(o));
            },
            args: [
              s(P),
              {},
              { page: a.value.page, pageSize: a.value.pageSize }
            ]
          },
          scope: l({ view: n.value })
        });
      }
      r.value.splice(T, 1), await ((B = o == null ? void 0 : o.syncCount) == null ? void 0 : B.call(o));
    } catch (P) {
      wt.error(`删除行失败: ${await Pn(P)}`);
    }
  }
  async function _() {
    var k, B, P;
    let T = r.value.length, O = [], I = "";
    for (; T--; ) {
      const { row: N, rowMeta: M } = r.value[T];
      if (M.selected && !M.new) {
        const H = u6((k = t == null ? void 0 : t.value) == null ? void 0 : k.columns), R = Mi(N, (B = t == null ? void 0 : t.value) == null ? void 0 : B.columns);
        H && R && (I || (I = H), O.push({
          [I]: R,
          row: s(r.value[T]),
          rowIndex: T
        }));
      }
    }
    if (O.length) {
      try {
        const N = await E(
          O.map((M) => ({
            [I]: M[I]
          }))
        );
        if (Array.isArray(N)) {
          const M = new Set(N.map((R) => R[I]));
          O = O.filter(
            (R) => M.has(R[I])
          );
          const H = new Set(O.map((R) => R.rowIndex));
          r.value = r.value.filter((R, z) => H.has(z));
        } else
          O = [];
      } catch (N) {
        return wt.error(`删除行失败: ${await Pn(N)}`);
      }
      O.length && (i({
        redo: {
          fn: async function(M, H) {
            var z, W;
            const R = await E(
              M.map((F) => ({
                [H]: F[H]
              }))
            );
            if (Array.isArray(R))
              for (const { row: F } of M) {
                const Y = So(
                  F.row,
                  (z = t == null ? void 0 : t.value) == null ? void 0 : z.columns
                ), X = wl(Y, r.value);
                X !== -1 && r.value.splice(X, 1), a.value.totalRows = a.value.totalRows - 1;
              }
            await ((W = o == null ? void 0 : o.syncPagination) == null ? void 0 : W.call(o));
          },
          args: [O, I]
        },
        undo: {
          fn: async function(M, H) {
            var W, F;
            const R = M.map((Y) => {
              var q;
              const X = So(Y.row, (q = t.value) == null ? void 0 : q.columns);
              return Y.row = { ...X, ...Y.row }, Y;
            }).reverse(), z = await h(
              R.map((Y) => Y.row),
              void 0,
              !0
            );
            if (Array.isArray(z))
              for (const { row: Y, rowIndex: X } of R)
                X !== -1 && H.pageSize === a.value.pageSize ? H.page === a.value.page ? r.value.splice(X, 0, Y) : await ((W = o == null ? void 0 : o.changePage) == null ? void 0 : W.call(o, H.page)) : await ((F = o == null ? void 0 : o.loadData) == null ? void 0 : F.call(o));
          },
          args: [
            O,
            { page: a.value.page, pageSize: a.value.pageSize }
          ]
        },
        scope: l({ view: n.value })
      }), await ((P = o == null ? void 0 : o.syncPagination) == null ? void 0 : P.call(o)));
    }
  }
  async function b(T) {
    var N, M, H, R;
    if (!T._start || !T._end) return;
    const O = Math.max(T._start.row, T._end.row), I = Math.min(T._start.row, T._end.row);
    let k = O + 1, B = [], P = "";
    for (; k--; ) {
      try {
        const { row: z, rowMeta: W } = r.value[k];
        if (!W.new) {
          const F = u6((N = t == null ? void 0 : t.value) == null ? void 0 : N.columns), Y = Mi(z, (M = t == null ? void 0 : t.value) == null ? void 0 : M.columns);
          F && Y && (P || (P = F), B.push({
            [P]: Y,
            row: s(r.value[k]),
            rowIndex: k
          }));
        }
      } catch (z) {
        return wt.error(`删除行失败: ${await Pn(z)}`);
      }
      if (k === I) break;
    }
    if (B.length) {
      try {
        const z = await E(
          B.map((W) => ({
            [P]: W[P]
          }))
        );
        if (Array.isArray(z)) {
          const W = new Set(z.map((Y) => Y[P]));
          B = B.filter(
            (Y) => W.has(Y[P])
          );
          const F = new Set(B.map((Y) => Y.rowIndex));
          r.value = r.value.filter((Y, X) => F.has(X));
        } else
          B = [];
      } catch (z) {
        return wt.error(`删除行失败: ${await Pn(z)}`);
      }
      B.length && (i({
        redo: {
          fn: async function(W, F) {
            var X, q;
            const Y = await E(
              W.map((Q) => ({
                [F]: Q[F]
              }))
            );
            if (Array.isArray(Y))
              for (const { row: Q } of W) {
                const ue = So(
                  Q.row,
                  (X = t == null ? void 0 : t.value) == null ? void 0 : X.columns
                ), le = wl(ue, r.value);
                le !== -1 && r.value.splice(le, 1), a.value.totalRows = a.value.totalRows - 1;
              }
            await ((q = o == null ? void 0 : o.syncPagination) == null ? void 0 : q.call(o));
          },
          args: [B, P]
        },
        undo: {
          fn: async function(W, F) {
            var q, Q;
            const Y = W.map((ue) => {
              var te;
              const le = So(ue.row, (te = t.value) == null ? void 0 : te.columns);
              return ue.row = { ...le, ...ue.row }, ue;
            }).reverse(), X = await h(
              Y.map((ue) => ue.row),
              void 0,
              !0
            );
            if (Array.isArray(X))
              for (const { row: ue, rowIndex: le } of Y)
                le !== -1 && F.pageSize === a.value.pageSize ? F.page === a.value.page ? r.value.splice(le, 0, ue) : await ((q = o == null ? void 0 : o.changePage) == null ? void 0 : q.call(o, F.page)) : await ((Q = o == null ? void 0 : o.loadData) == null ? void 0 : Q.call(o));
          },
          args: [
            B,
            { page: a.value.page, pageSize: a.value.pageSize }
          ]
        },
        scope: l({ view: n.value })
      }), await ((H = o == null ? void 0 : o.syncCount) == null ? void 0 : H.call(o)), await ((R = o == null ? void 0 : o.syncPagination) == null ? void 0 : R.call(o)));
    }
  }
  async function E(T, {
    metaValue: O = t.value,
    viewMetaValue: I = n.value
  } = {}) {
    var k;
    f.value = !0;
    try {
      const P = (await c.dbDataTableRow.delete(
        O == null ? void 0 : O.id,
        T.length === 1 ? T[0] : T,
        {
          viewId: I == null ? void 0 : I.id
        }
      )).data;
      return await ((k = o == null ? void 0 : o.syncCount) == null ? void 0 : k.call(o)), T.length === 1 && P ? [P] : P;
    } catch (B) {
      wt.error(await Pn(B));
    } finally {
      f.value = !1;
    }
  }
  return {
    insertRow: v,
    updateRowProperty: m,
    addEmptyRow: p,
    deleteRow: w,
    deleteRowById: S,
    deleteSelectedRows: _,
    deleteRangeOfRows: b,
    updateOrSaveRow: y,
    bulkUpdateRows: x,
    bulkUpdateView: g,
    selectedAllRecords: d,
    removeRowIfNew: (T) => {
      const O = r.value.indexOf(T);
      return O > -1 && T.rowMeta.new ? (r.value.splice(O, 1), !0) : !1;
    },
    bulkDeleteRows: E,
    bulkInsertRows: h
  };
}
const C0e = (e) => e.map((t) => ({
  row: { ...t },
  oldRow: { ...t },
  rowMeta: {}
}));
function E0e(e, t, n) {
  const r = V(() => {
    var P;
    return (P = e.value) == null ? void 0 : P.id;
  }), { api: a, isLoading: o, error: i } = Na(), s = 25, l = ne({ page: 1, pageSize: s });
  He(r, () => {
    l.value = { page: 1, pageSize: s };
  });
  const u = ne([]), { base: c } = Fn(ws()), { isPaginationLoading: f } = Fn(pd()), d = V({
    get: () => l.value,
    set: (P) => {
      l.value = P;
    }
  }), p = V(() => ({
    offset: ((d.value.page ?? 0) - 1) * (d.value.pageSize ?? s),
    limit: d.value.pageSize ?? s,
    where: (n == null ? void 0 : n.value) ?? ""
  }));
  async function v() {
    var N, M;
    const P = await a.dbViewRow.count(
      "noco",
      (N = c == null ? void 0 : c.value) == null ? void 0 : N.id,
      r.value,
      (M = t == null ? void 0 : t.value) == null ? void 0 : M.id
    );
    d.value.totalRows = P.data.count;
  }
  async function h(P = !1) {
    var W, F, Y;
    let N;
    P ? N = (await a.dbViewRow.count(
      "noco",
      (W = c == null ? void 0 : c.value) == null ? void 0 : W.id,
      r.value,
      (F = t == null ? void 0 : t.value) == null ? void 0 : F.id
    )).data.count ?? 0 : N = ((Y = d.value) == null ? void 0 : Y.totalRows) ?? 0;
    const M = d.value.pageSize ?? s, H = d.value.page ?? 1, R = Math.ceil(N / M), z = Math.max(1, Math.min(R, H));
    H > z ? x(z) : await y({
      offset: (z - 1) * M,
      where: n == null ? void 0 : n.value
    });
  }
  const m = ne();
  async function y(P = {}) {
    var W, F;
    const N = (W = c.value) == null ? void 0 : W.id, M = r.value, H = (F = t.value) == null ? void 0 : F.id;
    if (!N || !M || !H)
      return;
    m.value && m.value.cancel();
    const R = lr.CancelToken;
    m.value = R.source();
    try {
      f.value = !0;
      const Y = await a.dbViewRow.list(
        N,
        M,
        H,
        {
          ...p.value,
          ...P,
          where: n == null ? void 0 : n.value
        },
        { cancelToken: m.value.token }
      );
      u.value = C0e(Y.data.list), d.value = Y.data.pageInfo, f.value = !1;
    } catch (Y) {
      f.value = !1;
      const X = Y;
      return X.code === "ERR_CANCELED" ? void 0 : wt.error(await Pn(X));
    }
    const z = Math.max(
      1,
      Math.ceil(d.value.totalRows / d.value.pageSize)
    );
    z < d.value.page && await x(z);
  }
  async function x(P) {
    d.value.page = P, await y({
      offset: (P - 1) * (d.value.pageSize || s),
      where: n == null ? void 0 : n.value
    });
  }
  const {
    insertRow: g,
    updateRowProperty: S,
    addEmptyRow: w,
    deleteRow: _,
    deleteRowById: b,
    deleteSelectedRows: E,
    deleteRangeOfRows: C,
    updateOrSaveRow: T,
    bulkUpdateRows: O,
    bulkUpdateView: I,
    selectedAllRecords: k,
    removeRowIfNew: B
  } = _0e({
    meta: e,
    viewMeta: t,
    formattedData: u,
    paginationData: d,
    callbacks: {
      changePage: x,
      loadData: y,
      syncCount: v,
      syncPagination: h
    }
  });
  return {
    error: i,
    isLoading: o,
    loadData: y,
    paginationData: d,
    queryParams: p,
    formattedData: u,
    insertRow: g,
    updateRowProperty: S,
    changePage: x,
    addEmptyRow: w,
    deleteRow: _,
    deleteRowById: b,
    deleteSelectedRows: E,
    deleteRangeOfRows: C,
    updateOrSaveRow: T,
    bulkUpdateRows: O,
    bulkUpdateView: I,
    selectedAllRecords: k,
    syncCount: v,
    syncPagination: h,
    removeRowIfNew: B
  };
}
function A4(e, t) {
  const { sorts: n, eventBus: r } = Ss(), { api: a } = Na(), { addUndo: o, clone: i, defineViewScope: s } = $d(), l = Ke(vo), u = Ke(_c, ne(!1)), c = ne([]);
  yU(n, (y) => {
    c.value = i(y);
  });
  const f = async () => {
    if (u.value) {
      n.value = [];
      return;
    }
    try {
      if (!(e != null && e.value)) return;
      const y = await a.dbTableSort.list(e.value.id);
      n.value = y.data.list;
    } catch (y) {
      console.error(y), wt.error(await Pn(y));
    }
  }, d = (y, x) => Object.entries(x).filter(([g, S]) => y[g] !== S && g in y).reduce((g, [S, w]) => ({ ...g, [S]: w }), {}), p = async (y, x, g = !1) => {
    var S;
    if (!g) {
      const w = c.value[x];
      if (w) {
        const _ = i(d(y, w));
        Object.keys(_).length > 0 && o({
          undo: {
            fn: (b, E) => {
              const C = n.value[x];
              C && (C[b] = E, p(C, x, !0));
            },
            args: [Object.keys(_)[0], Object.values(_)[0]]
          },
          redo: {
            fn: (b, E) => {
              const C = n.value[x];
              C && (C[b] = E, p(C, x, !0));
            },
            args: [Object.keys(_)[0], y[Object.keys(_)[0]]]
          },
          scope: s({ view: e.value })
        });
      }
    }
    if (u.value) {
      n.value[x] = y, n.value = [...n.value], l == null || l.trigger();
      return;
    }
    try {
      if (y.id)
        await a.dbTableSort.update(y.id, y);
      else {
        const w = (S = e.value) == null ? void 0 : S.id;
        if (!w)
          return;
        const _ = await a.dbTableSort.create(w, y);
        n.value[x] = _.data;
      }
      t == null || t();
    } catch (w) {
      console.error(w), wt.error(await Pn(w));
    }
    c.value = i(n.value);
  }, v = async ({
    direction: y,
    column: x,
    callback: g
  }) => {
    var S;
    try {
      const w = n.value.findIndex((C) => C.fk_column_id === x.id), _ = w > -1 ? n.value[w] : void 0;
      _ && await a.dbTableSort.delete(_.id);
      const E = (await a.dbTableSort.create((S = e.value) == null ? void 0 : S.id, {
        fk_column_id: x.id,
        direction: y,
        push_to_top: !0
      })).data;
      n.value = [
        ...n.value.filter((C, T) => T !== w),
        E
      ], o({
        redo: {
          fn: async function() {
            var O;
            const T = await a.dbTableSort.create((O = e.value) == null ? void 0 : O.id, {
              fk_column_id: x.id,
              direction: y,
              push_to_top: !0
            });
            this.undo.args = [T.id], r.emit(Ws.SORT_RELOAD), l == null || l.trigger();
          },
          args: []
        },
        undo: {
          fn: async function(T) {
            await a.dbTableSort.delete(T), r.emit(Ws.SORT_RELOAD), l == null || l.trigger();
          },
          args: [E.id]
        },
        scope: s({ view: e.value })
      }), r.emit(Ws.SORT_RELOAD), g == null || g();
    } catch (w) {
      console.error(w), wt.error(await Pn(w));
    }
  };
  async function h(y, x, g = !1) {
    try {
      y.id && !u.value && await a.dbTableSort.delete(y.id), n.value.splice(x, 1), n.value = [...n.value], g || o({
        redo: {
          fn: async () => {
            await h(y, x, !0);
          },
          args: []
        },
        undo: {
          fn: () => {
            n.value.splice(x, 0, y), p(y, x, !0);
          },
          args: [i(y), x]
        },
        scope: s({ view: e.value })
      }), c.value = i(n.value), l == null || l.trigger();
    } catch (S) {
      console.error(S), wt.error(await Pn(S));
    }
  }
  const m = (y = !1, x) => {
    n.value = [
      ...n.value,
      {
        fk_column_id: x == null ? void 0 : x.id,
        direction: "asc"
      }
    ], y || o({
      undo: {
        fn: async () => {
          await h(n.value[n.value.length - 1], n.value.length - 1, !0);
        },
        args: []
      },
      redo: {
        fn: () => {
          m(!0);
        },
        args: []
      },
      scope: s({ view: e.value })
    }), c.value = i(n.value);
  };
  return { sorts: n, loadSorts: f, addSort: m, deleteSort: h, saveOrUpdate: p, insertSort: v };
}
const [T0e, $0e] = Vg(
  (e, t, n, r = !1) => {
    const a = ne(), o = ne(""), { api: i } = Na(), s = ne(!1);
    $d();
    const l = V(() => {
      var x;
      return (x = t.value) != null && x.columns ? t.value.columns.reduce(
        (g, S) => ({
          ...g,
          [S.id]: S
        }),
        {}
      ) : {};
    }), u = ne({}), c = async () => {
      var g, S, w;
      if (!t || !e) return;
      let x = 1;
      if ((g = e.value) != null && g.id) {
        const E = (await i.dbViewColumn.list(e.value.id)).data.list.reduce((T, O) => (O.show = !!O.show, {
          ...T,
          [O.fk_column_id]: O
        }), {});
        a.value = (w = (S = t.value) == null ? void 0 : S.columns) == null ? void 0 : w.map((T) => {
          var I;
          const O = E[T.id] || {};
          return {
            title: T.title,
            fk_column_id: T.id,
            ...O,
            show: O.show,
            order: O.order || x++,
            system: Gr((I = l == null ? void 0 : l.value) == null ? void 0 : I[O.fk_column_id]),
            isViewEssentialField: !1
          };
        }).sort((T, O) => T.order - O.order);
        const C = a.value ?? [];
        u.value = C.reduce(
          (T, O) => ({
            ...T,
            [O.fk_column_id]: O
          }),
          {}
        );
      }
    }, f = async (x) => {
      var g;
      (g = e == null ? void 0 : e.value) != null && g.id && (x ? await i.dbView.showAllColumn(e.value.id, {
        ignoreIds: x
      }) : await i.dbView.showAllColumn(e.value.id)), await c(), n == null || n();
    }, d = async (x) => {
      var g;
      (g = e == null ? void 0 : e.value) != null && g.id && (x ? await i.dbView.hideAllColumn(e.value.id, {
        ignoreIds: x
      }) : await i.dbView.hideAllColumn(e.value.id)), await c(), n == null || n();
    }, p = async (x, g, S = !1) => {
      var w, _;
      if (x.id && ((w = e == null ? void 0 : e.value) != null && w.id))
        await i.dbViewColumn.update(e.value.id, x.id, x);
      else if ((_ = e.value) != null && _.id) {
        const b = await i.dbViewColumn.create(e.value.id, x);
        return a.value && (a.value[g] = b), b;
      }
      S || (await c(), n == null || n());
    }, v = V({
      get() {
        var x;
        return ((x = e.value) == null ? void 0 : x.show_system_fields) || !1;
      },
      set(x) {
        var g;
        (g = e == null ? void 0 : e.value) != null && g.id && (r || i.dbView.update(e.value.id, {
          show_system_fields: x
        }).finally(() => {
          c(), n == null || n();
        }), e.value.show_system_fields = x);
      }
    }), h = V(() => {
      var x, g, S;
      return ((S = (g = (x = a == null ? void 0 : a.value) == null ? void 0 : x.filter((w) => {
        var _, b, E, C, T;
        return !v.value && l.value && ((_ = l == null ? void 0 : l.value) != null && _[w.fk_column_id]) && Gr((b = l.value) == null ? void 0 : b[w.fk_column_id]) && !((C = (E = l.value) == null ? void 0 : E[w.fk_column_id]) != null && C.pv) ? !1 : w.show && ((T = l == null ? void 0 : l.value) == null ? void 0 : T[w.fk_column_id]);
      })) == null ? void 0 : g.sort((w, _) => w.order - _.order)) == null ? void 0 : S.map((w) => {
        var _;
        return (_ = l == null ? void 0 : l.value) == null ? void 0 : _[w.fk_column_id];
      })) || [];
    }), m = ne("200px");
    return {
      fields: a,
      loadViewColumns: c,
      filterQuery: o,
      showAll: f,
      hideAll: d,
      saveOrUpdate: p,
      sortedAndFilteredFields: h,
      showSystemFields: v,
      metaColumnById: l,
      isViewColumnsLoading: s,
      updateGridViewColumn: async (x, g, S = !1) => {
        r.value || await i.dbView.gridColumnUpdate(x, {
          ...g
        });
      },
      gridViewCols: u,
      resizingColOldWith: m
    };
  },
  "useViewColumnsOrThrow"
);
function Od() {
  const e = $0e();
  if (e == null)
    throw new Error("Please call `useProvideViewColumns` on the appropriate parent component");
  return e;
}
function hM(e, t, n, r, a, o) {
  const i = ne(a), { nestedFilters: s } = Ss(), l = Ke(vo), u = Ke(_c, ne(!1)), c = V(() => u.value), f = ne([]), d = V({
    get: () => c.value ? i.value : f.value,
    set: (R) => {
      if (c.value) {
        i.value = R, o && (s.value = R), s.value = [...s.value], l == null || l.trigger({ ignoreTableMetaUpdate: !0 });
        return;
      }
      f.value = R;
    }
  }), p = V(() => d.value.filter((R) => R.status !== "delete")), { api: v } = Na(), h = async () => {
    var R, z;
    if ((R = e.value) != null && R.id && !c.value)
      try {
        let W;
        t ? W = await v.dbTableFilter.childrenRead(t) : W = await v.dbTableFilter.read(e.value.id), d.value = ((z = W == null ? void 0 : W.data) == null ? void 0 : z.list) || [];
      } catch (W) {
        console.log(W), wt.error(await Pn(W));
      }
  }, { addUndo: m, clone: y, defineViewScope: x } = $d(), g = ne([]), S = (R, z) => Object.entries(z).filter(([W, F]) => R[W] !== F && W in R).reduce((W, [F, Y]) => ({ ...W, [F]: Y }), {}), w = async (R, z, W = !1, F = !1) => {
    if (e.value) {
      if (!F) {
        const Y = g.value[z];
        if (Y) {
          const X = y(S(R, Y));
          Object.keys(X).length > 0 && m({
            undo: {
              fn: (q, Q) => {
                const ue = d.value[z];
                ue && (ue[q] = Q, w(ue, z, W, !0));
              },
              args: [Object.keys(X)[0], Object.values(X)[0]]
            },
            redo: {
              fn: (q, Q) => {
                const ue = d.value[z];
                ue && (ue[q] = Q, w(ue, z, W, !0));
              },
              args: [Object.keys(X)[0], R[Object.keys(X)[0]]]
            },
            scope: x({ view: e.value })
          });
        }
      }
      try {
        if (c.value)
          d.value[z] = { ...R }, d.value = [...d.value];
        else if (!(n != null && n.value) && !W)
          R.status = R.id ? "update" : "create";
        else if (R.id && R.status !== "create")
          await v.dbTableFilter.update(R.id, {
            ...R,
            fk_parent_id: t
          });
        else {
          const Y = await v.dbTableFilter.create(e.value.id, {
            ...R,
            fk_parent_id: t
          });
          d.value[z] = Y.data;
        }
      } catch (Y) {
        console.log(Y), wt.error(await Pn(Y));
      }
      g.value = y(d.value), r == null || r();
    }
  }, _ = async (R, z, W = !1) => {
    if (!W && !R.is_group && m({
      undo: {
        fn: async (F) => {
          F.status = "create", d.value.splice(z, 0, F), await w(F, z, !1, !0);
        },
        args: [y(R)]
      },
      redo: {
        fn: async (F) => {
          await _(d.value[F], F, !0);
        },
        args: [z]
      },
      scope: x({ view: e.value })
    }), c.value)
      d.value.splice(z, 1), d.value = [...d.value], r == null || r();
    else if (R.id)
      if (!(n != null && n.value))
        R.status = "delete";
      else
        try {
          await v.dbTableFilter.delete(R.id), r == null || r(), d.value.splice(z, 1);
        } catch (F) {
          console.log(F), wt.error(await Pn(F));
        }
    else
      d.value.splice(z, 1);
  }, { tableActivated: b } = Fn(mo()), { baseMeta: E } = Fn(ws()), C = V(() => {
    var R, z, W, F;
    return (z = (R = b.value) == null ? void 0 : R.columns) != null && z.length ? (F = (W = b.value) == null ? void 0 : W.columns) == null ? void 0 : F.reduce((Y, X) => (Y[X.id] = X.uidt, Y), {}) : {};
  }), T = (R, z) => {
    const W = ["empty", "notempty", "null", "notnull"].includes(z.value), F = C.value[R.fk_column_id];
    return z.includedTypes ? R.fk_column_id && z.includedTypes.includes(F) ? W ? E.value.showNullAndEmptyInFilter : !0 : !1 : z.excludedTypes ? R.fk_column_id && !z.excludedTypes.includes(F) ? W ? E.value.showNullAndEmptyInFilter : !0 : !1 : W ? E.value.showNullAndEmptyInFilter : !0;
  }, O = (R, z) => {
    const W = C.value[R.fk_column_id];
    if (z.includedTypes)
      return R.fk_column_id && z.includedTypes.includes(W);
    if (z.excludedTypes)
      return R.fk_column_id && !z.excludedTypes.includes(W);
  }, { metaColumnById: I } = Od(), k = V(
    () => {
      var R, z;
      return (z = (R = b.value) == null ? void 0 : R.columns) == null ? void 0 : z.filter((W) => {
        var F;
        return Gr((F = I == null ? void 0 : I.value) == null ? void 0 : F[W.id]) ? !0 : W.uidt === we.ID || W.system ? !1 : !(W.colOptions && W.system);
      });
    }
  ), B = () => {
    var R, z;
    return {
      comparison_op: (z = n0((R = k.value) == null ? void 0 : R[0].uidt).filter(
        (W) => {
          var F;
          return T({ fk_column_id: (F = k.value) == null ? void 0 : F[0].id }, W);
        }
      )) == null ? void 0 : z[0].value,
      value: "",
      status: "create",
      logical_op: "and"
    };
  }, P = async (R = !1) => {
    d.value.push(B()), R || m({
      undo: {
        fn: async function(W) {
          this.redo.args = [W, y(d.value[W])], await _(d.value[W], W, !0);
        },
        args: [d.value.length - 1]
      },
      redo: {
        fn: async (z, W) => {
          W.status = "create", d.value.splice(z, 0, W), await w(W, z, !1, !0);
        },
        args: []
      },
      scope: x({ view: e.value })
    }), g.value = y(d.value);
  }, N = async () => {
    const R = B(), z = {
      is_group: !0,
      status: "create",
      logical_op: "and"
    };
    c.value && (z.children = [R]), d.value.push(z);
    const W = d.value.length - 1;
    await w(d.value[W], W, !0), g.value = y(d.value);
  }, M = async () => {
    var R;
    try {
      for (const [z, W] of Object.entries(d.value))
        W.status === "delete" ? await v.dbTableFilter.delete(W.id) : W.status === "update" ? await v.dbTableFilter.update(W.id, {
          ...W,
          fk_parent_id: t
        }) : W.status === "create" && (d.value[+z] = await v.dbTableFilter.create((R = e == null ? void 0 : e.value) == null ? void 0 : R.id, {
          ...W,
          fk_parent_id: t
        }));
      r == null || r();
    } catch (z) {
      console.log(z), wt.error(await Pn(z));
    }
  }, H = V8(w, 500);
  return {
    sync: M,
    filters: d,
    nonDeletedFilters: p,
    loadFilters: h,
    saveOrUpdate: w,
    saveOrUpdateDebounced: H,
    deleteFilter: _,
    addFilter: P,
    addFilterGroup: N,
    isComparisonOpAllowed: T,
    isComparisonSubOpAllowed: O,
    types: C
  };
}
const [O0e, hTe] = Vg(
  (e, t) => {
    const { api: n } = Na();
    ne(0);
    const r = ne(/* @__PURE__ */ new Set()), { base: a } = Fn(ws()), { tableActivated: o } = Fn(mo()), i = V(() => {
      var x, g;
      return (g = (x = o.value) == null ? void 0 : x.views) == null ? void 0 : g[0];
    }), s = ne(
      t.value.rowMeta.new ? t.value : { row: {}, oldRow: {}, rowMeta: {} }
    );
    B_(e, s);
    const { addUndo: l, clone: u, defineViewScope: c } = $d(), f = Ke(Bg, Qs()), d = V(() => {
      var x, g, S, w;
      if ((x = s == null ? void 0 : s.value) != null && x.row) {
        const _ = (S = (g = e == null ? void 0 : e.value) == null ? void 0 : g.columns) == null ? void 0 : S.find((C) => C.pv);
        if (!_)
          return;
        const b = (w = s.value.row) == null ? void 0 : w[_.title], E = _.uidt;
        if (E === we.Date)
          return (/^\d+$/.test(b) ? It(+b) : It(b)).format("YYYY-MM-DD");
        if (E === we.DateTime)
          return (/^\d+$/.test(b) ? It(+b) : It(b)).format("YYYY-MM-DD HH:mm");
        if (E === we.Time) {
          let C = It(b);
          return C.isValid() || (C = It(b, "HH:mm:ss")), C.isValid() || (C = It(`1999-01-01 ${b}`)), C.isValid() ? C.format("HH:mm:ss") : b;
        }
        return b;
      }
      return "";
    }), p = V(
      () => Mi(s.value.row, e.value.columns)
    );
    return {
      // ...rowStore,
      row: s,
      deleteRowById: async (x) => {
        var w, _;
        const g = (w = a.value) == null ? void 0 : w.id, S = (_ = e.value) == null ? void 0 : _.id;
        if (!(!g || !S))
          try {
            const E = (await n.dbTableRow.delete(
              "noco",
              g,
              S,
              encodeURIComponent(
                x ?? Mi(s.value.row, e.value.columns) ?? ""
              )
            )).data;
            if (typeof E == "object" && E.message)
              return console.error(E.message), wt.error("删除失败"), !1;
          } catch (b) {
            wt.error(`删除失败: ${await Pn(b)}`);
          }
      },
      displayValue: d,
      save: async (x = !1) => {
        var S, w, _, b, E, C;
        let g;
        try {
          const T = ((S = s.value.rowMeta) == null ? void 0 : S.new) ?? !1, O = (w = a.value) == null ? void 0 : w.id, I = (_ = e.value) == null ? void 0 : _.id, k = (b = i.value) == null ? void 0 : b.id;
          if (!O || !I)
            return;
          if (T) {
            const { missingRequiredColumns: B, insertObj: P } = await R2({
              meta: e.value,
              row: s.value.row,
              throwError: !0
            });
            if (B.size)
              return;
            if (g = await n.dbTableRow.create("noco", O, I, {
              ...P
            }), Object.assign(s.value, {
              row: g,
              rowMeta: {},
              oldRow: { ...g }
            }), !x) {
              const N = Mi(g, (E = e.value) == null ? void 0 : E.columns), M = So(s.value.row, (C = e.value) == null ? void 0 : C.columns);
              l({
                redo: {
                  fn: async (H) => {
                    await n.dbTableRow.create("noco", O, I, {
                      ...M,
                      ...H
                    }), f == null || f.trigger();
                  },
                  args: [u(P)]
                },
                undo: {
                  fn: async (H) => {
                    if (!k)
                      return;
                    const R = await n.dbViewRow.delete(
                      "noco",
                      O,
                      I,
                      k,
                      encodeURIComponent(H)
                    );
                    if (R.message)
                      throw new Error(R.message);
                    f == null || f.trigger();
                  },
                  args: [N]
                },
                scope: c({ view: i.value })
              });
            }
          } else {
            const B = [...r.value].reduce(
              (P, N) => (P[N] = s.value.row[N] ?? null, P),
              {}
            );
            if (Object.keys(B).length) {
              const P = Mi(s.value.row, e.value.columns);
              if (!P)
                return wt.info("Update not allowed for table which doesn't have primary Key");
              if (await n.dbTableRow.update(
                "noco",
                O,
                I,
                encodeURIComponent(P),
                B
              ), !x) {
                const N = [...r.value].reduce(
                  (M, H) => (M[H] = s.value.oldRow[H], M),
                  {}
                );
                l({
                  redo: {
                    fn: async (M, H) => {
                      await n.dbTableRow.update(
                        "noco",
                        O,
                        I,
                        encodeURIComponent(M),
                        H
                      ), f == null || f.trigger();
                    },
                    args: [P, u(B)]
                  },
                  undo: {
                    fn: async (M, H) => {
                      await n.dbTableRow.update(
                        "noco",
                        O,
                        I,
                        encodeURIComponent(M),
                        H
                      ), f == null || f.trigger();
                    },
                    args: [P, u(N)]
                  },
                  scope: c({ view: i.value })
                });
              }
            } else {
              wt.info("没有要更新的列");
              return;
            }
          }
          r.value = /* @__PURE__ */ new Set();
        } catch (T) {
          console.error(T), wt.error(`行更新失败: ${await Pn(T)}`);
        }
        return g;
      },
      changedColumns: r,
      loadRow: async (x, g = !1) => {
        var E, C, T;
        const S = (E = a.value) == null ? void 0 : E.id, w = (C = e.value) == null ? void 0 : C.id;
        if (!S || !w)
          return;
        let b = (await n.dbTableRow.read(
          "noco",
          S,
          w,
          encodeURIComponent(
            x ?? Mi(s.value.row, e.value.columns) ?? ""
          ),
          { getHiddenColumn: !0 }
        )).data;
        g && (b = {
          ...s.value.row,
          ...(T = e.value.columns) == null ? void 0 : T.reduce(
            (O, I) => (Gr(I) && I.title in b && (O[I.title] = b[I.title]), O),
            {}
          )
        }), Object.assign(s.value, {
          row: b,
          oldRow: { ...b },
          rowMeta: {}
        });
      },
      primaryKey: p,
      // saveRowAndStay,
      clearColumns: () => {
        r.value = /* @__PURE__ */ new Set();
      }
    };
  },
  "expanded-form-store"
), A0e = {
  locale: "zh_CN",
  today: "今天",
  now: "此刻",
  backToToday: "返回今天",
  ok: "确定",
  timeSelect: "选择时间",
  dateSelect: "选择日期",
  weekSelect: "选择周",
  clear: "清除",
  month: "月",
  year: "年",
  previousMonth: "上个月 (翻页上键)",
  nextMonth: "下个月 (翻页下键)",
  monthSelect: "选择月份",
  yearSelect: "选择年份",
  decadeSelect: "选择年代",
  yearFormat: "YYYY年",
  dayFormat: "D日",
  dateFormat: "YYYY年M月D日",
  dateTimeFormat: "YYYY年M月D日 HH时mm分ss秒",
  previousYear: "上一年 (Control键加左方向键)",
  nextYear: "下一年 (Control键加右方向键)",
  previousDecade: "上一年代",
  nextDecade: "下一年代",
  previousCentury: "上一世纪",
  nextCentury: "下一世纪"
}, vM = {
  placeholder: "请选择时间",
  rangePlaceholder: ["开始时间", "结束时间"]
}, AS = {
  lang: D({
    placeholder: "请选择日期",
    yearPlaceholder: "请选择年份",
    quarterPlaceholder: "请选择季度",
    monthPlaceholder: "请选择月份",
    weekPlaceholder: "请选择周",
    rangePlaceholder: ["开始日期", "结束日期"],
    rangeYearPlaceholder: ["开始年份", "结束年份"],
    rangeMonthPlaceholder: ["开始月份", "结束月份"],
    rangeQuarterPlaceholder: ["开始季度", "结束季度"],
    rangeWeekPlaceholder: ["开始周", "结束周"]
  }, A0e),
  timePickerLocale: D({}, vM)
};
AS.lang.ok = "确定";
const bo = "${label}不是一个有效的${type}", I0e = {
  locale: "zh-cn",
  Pagination: M7,
  DatePicker: AS,
  TimePicker: vM,
  Calendar: AS,
  // locales for all components
  global: {
    placeholder: "请选择"
  },
  Table: {
    filterTitle: "筛选",
    filterConfirm: "确定",
    filterReset: "重置",
    filterEmptyText: "无筛选项",
    filterCheckall: "全选",
    filterSearchPlaceholder: "在筛选项中搜索",
    selectAll: "全选当页",
    selectInvert: "反选当页",
    selectNone: "清空所有",
    selectionAll: "全选所有",
    sortTitle: "排序",
    expand: "展开行",
    collapse: "关闭行",
    triggerDesc: "点击降序",
    triggerAsc: "点击升序",
    cancelSort: "取消排序"
  },
  Tour: {
    Next: "下一步",
    Previous: "上一步",
    Finish: "结束导览"
  },
  Modal: {
    okText: "确定",
    cancelText: "取消",
    justOkText: "知道了"
  },
  Popconfirm: {
    cancelText: "取消",
    okText: "确定"
  },
  Transfer: {
    searchPlaceholder: "请输入搜索内容",
    itemUnit: "项",
    itemsUnit: "项",
    remove: "删除",
    selectCurrent: "全选当页",
    removeCurrent: "删除当页",
    selectAll: "全选所有",
    removeAll: "删除全部",
    selectInvert: "反选当页"
  },
  Upload: {
    uploading: "文件上传中",
    removeFile: "删除文件",
    uploadError: "上传错误",
    previewFile: "预览文件",
    downloadFile: "下载文件"
  },
  Empty: {
    description: "暂无数据"
  },
  Icon: {
    icon: "图标"
  },
  Text: {
    edit: "编辑",
    copy: "复制",
    copied: "复制成功",
    expand: "展开"
  },
  PageHeader: {
    back: "返回"
  },
  Form: {
    optional: "（可选）",
    defaultValidateMessages: {
      default: "字段验证错误${label}",
      required: "请输入${label}",
      enum: "${label}必须是其中一个[${enum}]",
      whitespace: "${label}不能为空字符",
      date: {
        format: "${label}日期格式无效",
        parse: "${label}不能转换为日期",
        invalid: "${label}是一个无效日期"
      },
      types: {
        string: bo,
        method: bo,
        array: bo,
        object: bo,
        number: bo,
        date: bo,
        boolean: bo,
        integer: bo,
        float: bo,
        regexp: bo,
        email: bo,
        url: bo,
        hex: bo
      },
      string: {
        len: "${label}须为${len}个字符",
        min: "${label}最少${min}个字符",
        max: "${label}最多${max}个字符",
        range: "${label}须在${min}-${max}字符之间"
      },
      number: {
        len: "${label}必须等于${len}",
        min: "${label}最小值为${min}",
        max: "${label}最大值为${max}",
        range: "${label}须在${min}-${max}之间"
      },
      array: {
        len: "须为${len}个${label}",
        min: "最少${min}个${label}",
        max: "最多${max}个${label}",
        range: "${label}数量须在${min}-${max}之间"
      },
      pattern: {
        mismatch: "${label}与模式不匹配${pattern}"
      }
    }
  },
  Image: {
    preview: "预览"
  },
  QRCode: {
    expired: "二维码已过期",
    refresh: "点击刷新",
    scanned: "已扫描"
  }
}, P0e = { class: "count" }, D0e = /* @__PURE__ */ Me({
  __name: "Pagination",
  props: {
    paginationData: {},
    changePage: { type: Function },
    hideSidebars: { type: Boolean },
    fixedSize: {},
    extraStyle: {}
  },
  emits: ["update:paginationData"],
  setup(e, { emit: t }) {
    const n = e, a = Ra(n, "paginationData", t), { changePage: o } = n, i = Tt(n, "fixedSize"), s = Tt(n, "extraStyle"), { isViewDataLoading: l, isPaginationLoading: u } = Fn(pd()), c = V(() => {
      var p;
      return ((p = a.value) == null ? void 0 : p.totalRows) ?? 0;
    }), f = V(() => {
      var p;
      return ((p = a.value) == null ? void 0 : p.pageSize) ?? 25;
    }), d = V({
      get: () => {
        var p;
        return ((p = a == null ? void 0 : a.value) == null ? void 0 : p.page) ?? 1;
      },
      set: async (p) => {
        u.value = !0;
        try {
          await (o == null ? void 0 : o(p)), u.value = !1;
        } catch (v) {
          if (lr.isCancel(v))
            return;
          u.value = !1;
        }
      }
    });
    return (p, v) => (Ce(), rt("div", {
      class: "nc-grid-pagination-wrapper",
      style: _r(`${i.value ? `width: ${i.value}px;` : ""}${s.value}`)
    }, [
      ke("span", P0e, "共计 " + Wt(c.value) + " 条记录", 1),
      A(U(Qu), { locale: U(I0e) }, {
        default: Fe(() => [
          A(U(ace), {
            current: d.value,
            "onUpdate:current": v[0] || (v[0] = (h) => d.value = h),
            "page-size": f.value,
            "onUpdate:pageSize": v[1] || (v[1] = (h) => f.value = h),
            total: c.value,
            "show-size-changer": !1
          }, null, 8, ["current", "page-size", "total"])
        ]),
        _: 1
      }, 8, ["locale"])
    ], 4));
  }
}), Cn = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, a] of t)
    n[r] = a;
  return n;
}, k0e = /* @__PURE__ */ Cn(D0e, [["__scopeId", "data-v-e7ae99ee"]]), IS = /* @__PURE__ */ Me({
  __name: "NcTooltip",
  props: {
    modifierKey: {},
    tooltipStyle: {},
    disabled: { type: Boolean },
    placement: {},
    showOnTruncateOnly: { type: Boolean },
    hideOnClick: { type: Boolean },
    overlayClassName: {}
  },
  setup(e) {
    const t = e, n = V(() => t.modifierKey), r = V(() => t.tooltipStyle), a = V(() => t.disabled), o = V(() => t.showOnTruncateOnly), i = V(() => t.hideOnClick), s = V(() => t.placement ?? "top"), l = ne(), u = dU(!1, {
      onBeforeChange: (m) => {
        if (m && a.value) return !1;
      }
    }), c = TU(() => l.value), f = w_(), d = ne(!1), p = V(() => t.overlayClassName);
    Hf(
      (m) => m.key === n.value,
      (m) => {
        m.preventDefault(), c.value && (u.value = !0), d.value = !0;
      },
      { eventName: "keydown" }
    ), Hf(
      (m) => m.key === n.value,
      (m) => {
        m.preventDefault(), u.value = !1, d.value = !1;
      },
      { eventName: "keyup" }
    ), He(
      [c, () => n.value, () => a.value],
      ([m, y, x]) => {
        if (o != null && o.value) {
          const g = l == null ? void 0 : l.value;
          if (!(g && g.scrollWidth > g.clientWidth)) {
            u.value = !1;
            return;
          }
        }
        if (!m || x) {
          u.value = !1;
          return;
        }
        if (m && !y) {
          u.value = !0;
          return;
        }
        if (m && y && !d.value) {
          u.value = !1;
          return;
        }
        !u.value && m && y && d.value && (u.value = !0);
      }
    );
    const v = V(() => ({
      style: f.style,
      class: f.class
    })), h = () => {
      i.value && u.value && (u.value = !1);
    };
    return (m, y) => (Ce(), et(U(b1), {
      open: U(u),
      "onUpdate:open": y[0] || (y[0] = (x) => Ft(u) ? u.value = x : null),
      "overlay-class-name": `nc-tooltip ${U(u) ? "visible" : "hidden"} ${p.value}`,
      "overlay-style": r.value,
      "arrow-point-at-center": "",
      trigger: [],
      placement: s.value
    }, {
      title: Fe(() => [
        uo(m.$slots, "title")
      ]),
      default: Fe(() => [
        ke("div", sc({
          ref_key: "el",
          ref: l
        }, v.value, { onMousedown: h }), [
          uo(m.$slots, "default")
        ], 16)
      ]),
      _: 3
    }, 8, ["open", "overlay-class-name", "overlay-style", "placement"]));
  }
}), I4 = /* @__PURE__ */ Me({
  __name: "NcMenu",
  props: {
    selectable: { type: Boolean }
  },
  setup(e) {
    const t = e, n = V(() => t.selectable ?? !1);
    return (r, a) => (Ce(), et(U(Wl), {
      class: "nc-menu",
      selectable: n.value
    }, {
      default: Fe(() => [
        uo(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["selectable"]));
  }
}), M0e = { class: "nc-menu-item-inner" }, ea = /* @__PURE__ */ Me({
  __name: "NcMenuItem",
  setup(e) {
    return (t, n) => (Ce(), et(U(Qf), { class: "nc-menu-item" }, {
      default: Fe(() => [
        ke("div", M0e, [
          uo(t.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), zm = /* @__PURE__ */ Me({
  __name: "NcModal",
  props: {
    visible: { type: Boolean },
    width: {},
    size: { default: "medium" },
    destroyOnClose: { type: Boolean, default: !0 },
    maskClosable: { type: Boolean, default: !0 },
    closable: { type: Boolean, default: !1 },
    keyboard: { type: Boolean, default: !0 }
  },
  emits: ["update:visible"],
  setup(e, { emit: t }) {
    const n = e, r = t, { width: a, destroyOnClose: o } = n, { maskClosable: i, closable: s, keyboard: l } = ac(n), u = V(() => a || (n.size === "small" ? "28rem" : n.size === "medium" ? "40rem" : n.size === "large" ? "80rem" : "max(30vw, 600px)")), c = V(() => n.size === "large" ? "80vh" : "auto"), f = Ra(n, "visible", r);
    return (d, p) => (Ce(), et(U(Ka), {
      open: U(f),
      "onUpdate:open": p[0] || (p[0] = (v) => Ft(f) ? f.value = v : null),
      class: tn({ active: U(f) }),
      width: u.value,
      closable: U(s),
      keyboard: U(l),
      footer: null,
      "destroy-on-close": U(o),
      "mask-closable": U(i),
      onKeydown: p[1] || (p[1] = zt((v) => f.value = !1, ["esc"]))
    }, {
      default: Fe(() => [
        ke("div", {
          class: "nc-modal",
          style: _r({ "max-height": c.value })
        }, [
          uo(d.$slots, "default")
        ], 4)
      ]),
      _: 3
    }, 8, ["open", "class", "width", "closable", "keyboard", "destroy-on-close", "mask-closable"]));
  }
}), R0e = { class: "nc-delete-modal-content" }, N0e = { class: "title" }, F0e = { class: "desc" }, L0e = { class: "actions" }, B0e = /* @__PURE__ */ Me({
  __name: "NcDeleteModal",
  props: {
    visible: { type: Boolean },
    entityName: {},
    onDelete: { type: Function }
  },
  emits: ["update:visible"],
  setup(e, { emit: t }) {
    const n = e, a = Ra(n, "visible", t), o = ne(!1), i = async () => {
      o.value = !0;
      try {
        await n.onDelete(), a.value = !1;
      } catch (s) {
        console.error(s), wt.error(await Pn(s));
      } finally {
        o.value = !1;
      }
    };
    return Hf("Escape", () => {
      a.value && (a.value = !1);
    }), Hf("Enter", () => {
      o.value || a.value && i();
    }), (s, l) => (Ce(), et(zm, {
      visible: U(a),
      "onUpdate:visible": l[1] || (l[1] = (u) => Ft(a) ? a.value = u : null),
      size: "small",
      centered: ""
    }, {
      default: Fe(() => [
        ke("div", R0e, [
          ke("div", N0e, "删除 " + Wt(n.entityName), 1),
          ke("div", F0e, "您确定要删除【" + Wt(n.entityName.toLowerCase()) + "】吗？", 1),
          uo(s.$slots, "entity-preview", {}, void 0, !0),
          ke("div", L0e, [
            A(U(fn), {
              class: "action",
              onClick: l[0] || (l[0] = (u) => a.value = !1)
            }, {
              default: Fe(() => [
                Jt(" 取消 ")
              ]),
              _: 1
            }),
            A(U(fn), {
              key: "submit",
              class: "action delete",
              danger: "",
              "html-type": "submit",
              loading: o.value,
              onClick: i
            }, {
              default: Fe(() => [
                Jt(" 删除 ")
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ]),
      _: 3
    }, 8, ["visible"]));
  }
}), mM = /* @__PURE__ */ Cn(B0e, [["__scopeId", "data-v-eec6919a"]]), H0e = {
  key: 0,
  class: "nc-delete-column"
}, j0e = { class: "name" }, V0e = /* @__PURE__ */ Me({
  __name: "DeleteColumnModal",
  props: {
    visible: { type: Boolean },
    column: {}
  },
  emits: ["update:visible"],
  setup(e, { emit: t }) {
    const n = e, a = Ra(n, "visible", t), { api: o } = Na(), i = ne(!1), s = Ke(vo), l = async () => {
      i.value = !0;
      try {
        await o.dbTableColumn.delete(n.column.id), a.value = !1, s == null || s.trigger();
      } catch (u) {
        wt.error(await Pn(u));
      } finally {
        i.value = !1;
      }
    };
    return (u, c) => (Ce(), et(mM, {
      visible: U(a),
      "onUpdate:visible": c[0] || (c[0] = (f) => Ft(a) ? a.value = f : null),
      "entity-name": "列",
      "on-delete": l
    }, {
      "entity-preview": Fe(() => [
        u.column ? (Ce(), rt("div", H0e, [
          ke("div", j0e, Wt(u.column.title), 1)
        ])) : bt("", !0)
      ]),
      _: 1
    }, 8, ["visible"]));
  }
}), U0e = /* @__PURE__ */ Cn(V0e, [["__scopeId", "data-v-f2c4f1c4"]]), P4 = (e) => (Xa("data-v-59a35523"), e = e(), Za(), e), z0e = /* @__PURE__ */ P4(() => /* @__PURE__ */ ke("div", { class: "title" }, "复制 列", -1)), W0e = /* @__PURE__ */ P4(() => /* @__PURE__ */ ke("div", { class: "desc" }, "Are you sure you want to duplicate the field?", -1)), G0e = /* @__PURE__ */ P4(() => /* @__PURE__ */ ke("div", { class: "advance" }, "高级设置", -1)), K0e = { class: "checkbox" }, Y0e = { class: "actions" }, q0e = /* @__PURE__ */ Me({
  __name: "ColumnDuplicate",
  props: {
    modelValue: { type: Boolean },
    column: {},
    extra: {}
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const r = e, a = n, { api: o } = Na(), i = Ra(r, "modelValue", a), s = Ke(vo), l = ne({
      includeData: !0
    }), u = V(() => {
      const { includeData: v } = l.value;
      return {
        excludeData: !v
      };
    }), c = ne(!1), f = async () => {
      s == null || s.trigger();
    }, d = Ke(Y8), p = async () => {
      var v;
      try {
        c.value = !0;
        const m = (v = (await o.dbTable.duplicateColumn(r.column.base_id, r.column.id, {
          options: u.value,
          extra: r.extra
        })).data) == null ? void 0 : v.id;
        if (!m)
          return;
        d(m, async (y) => {
          y.status !== "close" && (y.status === xb.COMPLETED ? (f(), c.value = !1, i.value = !1) : y.status === xb.FAILED && (wt.error("There was an error duplicating the column."), f(), c.value = !1, i.value = !1));
        });
      } catch (h) {
        wt.error(await Pn(h)), c.value = !1, i.value = !1;
      }
    };
    return Hf("Enter", () => {
      i.value && p();
    }), t({
      duplicate: p
    }), (v, h) => (Ce(), et(zm, {
      visible: U(i),
      "onUpdate:visible": h[2] || (h[2] = (m) => Ft(i) ? i.value = m : null),
      class: tn([{ active: U(i) }, "nc-column-duplicate"]),
      closable: !c.value,
      "mask-closable": !c.value,
      keyboard: !c.value,
      centered: "",
      "wrap-class-name": "nc-modal-column-duplicate",
      footer: null,
      onKeydown: h[3] || (h[3] = zt((m) => i.value = !1, ["esc"]))
    }, {
      default: Fe(() => [
        ke("div", null, [
          z0e,
          W0e,
          G0e,
          A(U(E0), { class: "divider" }),
          ke("div", K0e, [
            A(U(aa), {
              checked: l.value.includeData,
              "onUpdate:checked": h[0] || (h[0] = (m) => l.value.includeData = m),
              disabled: c.value
            }, {
              default: Fe(() => [
                Jt("包括数据")
              ]),
              _: 1
            }, 8, ["checked", "disabled"])
          ])
        ]),
        ke("div", Y0e, [
          c.value ? bt("", !0) : (Ce(), et(U(fn), {
            class: "action",
            key: "back",
            onClick: h[1] || (h[1] = (m) => i.value = !1)
          }, {
            default: Fe(() => [
              Jt("取消")
            ]),
            _: 1
          })),
          A(U(fn), {
            class: "action confirm",
            key: "submit",
            type: "primary",
            loading: c.value,
            onClick: p
          }, {
            default: Fe(() => [
              Jt(" 确认 ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "class", "closable", "mask-closable", "keyboard"]));
  }
}), X0e = /* @__PURE__ */ Cn(q0e, [["__scopeId", "data-v-59a35523"]]), Wm = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4%206L8%2010L12%206'%20stroke='%236a7184'%20stroke-width='1.33333'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Rc = (e) => (Xa("data-v-ebae8729"), e = e(), Za(), e), Z0e = { class: "nc-header-menu-trigger" }, Q0e = ["src"], J0e = /* @__PURE__ */ Rc(() => /* @__PURE__ */ ke("span", null, "编辑", -1)), epe = /* @__PURE__ */ Rc(() => /* @__PURE__ */ ke("span", null, "升序", -1)), tpe = /* @__PURE__ */ Rc(() => /* @__PURE__ */ ke("span", null, "降序", -1)), npe = /* @__PURE__ */ Rc(() => /* @__PURE__ */ ke("span", null, "复制", -1)), rpe = /* @__PURE__ */ Rc(() => /* @__PURE__ */ ke("span", null, "在右侧插入列", -1)), ape = /* @__PURE__ */ Rc(() => /* @__PURE__ */ ke("span", null, "在左侧插入列", -1)), ope = /* @__PURE__ */ Rc(() => /* @__PURE__ */ ke("span", { class: "nc-column-delete" }, "删除", -1)), ipe = /* @__PURE__ */ Me({
  __name: "HeaderMenu",
  props: {
    column: {},
    isOpen: { type: Boolean }
  },
  emits: ["edit", "addColumn", "update:isOpen"],
  setup(e, { emit: t }) {
    const n = e, r = Tt(n, "column"), a = t, o = Ra(n, "isOpen", a), i = Ke(vo), { tableActivated: s } = Fn(mo()), l = V(() => {
      var w, _;
      return (_ = (w = s.value) == null ? void 0 : w.views) == null ? void 0 : _[0];
    }), { insertSort: u } = A4(l, () => i == null ? void 0 : i.trigger()), c = async (w) => {
      await u({
        column: r.value,
        direction: w,
        callback: () => {
          o.value = !1, i == null || i.trigger({
            ignoreTableMetaUpdate: !0
          });
        }
      });
    }, f = ne(!1), d = ne(), p = async () => {
      var T, O, I;
      if (!r.value)
        return;
      const w = (T = s.value) == null ? void 0 : T.columns, _ = (I = (O = s.value) == null ? void 0 : O.views) == null ? void 0 : I[0];
      if (!(w != null && w.length) || !_)
        return;
      const b = w.findIndex((k) => k.id === r.value.id);
      let E = b === w.length - 1 ? (w[b].order || 1) + 1 : ((w[b].order || 1) + (w[b + 1].order || 2)) / 2;
      const C = _.id;
      d.value = {
        pv: !1,
        view_id: C,
        column_order: {
          view_id: C,
          order: E
        }
      }, f.value = !0, o.value = !1;
    }, v = async (w = !1) => {
      var O, I, k;
      const _ = (O = s.value) == null ? void 0 : O.columns, b = (k = (I = s.value) == null ? void 0 : I.views) == null ? void 0 : k[0];
      if (!(_ != null && _.length) || !b)
        return;
      const E = _.findIndex((B) => B.id === r.value.id);
      if (E < 0)
        return;
      let C;
      w ? C = E === 0 ? (_[E].order || 1) / 2 : ((_[E].order || 1) + (_[E - 1].order || 0)) / 2 : C = E === _.length - 1 ? (_[E].order || 1) + 1 : ((_[E].order || 1) + (_[E + 1].order || 2)) / 2;
      const T = b.id;
      a("addColumn", {
        column_order: {
          view_id: T,
          order: C
        }
      });
    }, h = ne(!1), m = () => {
      o.value = !1, h.value = !0;
    }, y = () => {
      o.value = !1, a("edit");
    }, x = (w) => {
      o.value = !1, v(w === "before" ? !0 : void 0);
    }, g = V(() => r.value && !r.value.system), S = V(() => !r.value.system);
    return (w, _) => (Ce(), rt(dt, null, [
      A(U(cs), {
        open: U(o),
        "onUpdate:open": _[4] || (_[4] = (b) => Ft(o) ? o.value = b : null),
        trigger: ["click"],
        placement: "bottomRight",
        "overlay-class-name": "nc-dropdown-column-operations",
        onClick: _[5] || (_[5] = ft((b) => o.value = !U(o), ["stop"]))
      }, {
        overlay: Fe(() => [
          A(I4, { class: "nc-column-options" }, {
            default: Fe(() => [
              A(ea, { onClick: y }, {
                default: Fe(() => [
                  J0e
                ]),
                _: 1
              }),
              A(U(E0), { class: "divider" }),
              A(ea, {
                onClick: _[0] || (_[0] = (b) => c("asc"))
              }, {
                default: Fe(() => [
                  epe
                ]),
                _: 1
              }),
              A(ea, {
                onClick: _[1] || (_[1] = (b) => c("desc"))
              }, {
                default: Fe(() => [
                  tpe
                ]),
                _: 1
              }),
              r.value.pk ? bt("", !0) : (Ce(), et(U(E0), {
                key: 0,
                class: "divider"
              })),
              !r.value.pk && S.value ? (Ce(), et(ea, {
                key: 1,
                onClick: p
              }, {
                default: Fe(() => [
                  npe
                ]),
                _: 1
              })) : bt("", !0),
              A(ea, {
                onClick: _[2] || (_[2] = (b) => x("after"))
              }, {
                default: Fe(() => [
                  rpe
                ]),
                _: 1
              }),
              r.value.pv ? bt("", !0) : (Ce(), et(ea, {
                key: 2,
                onClick: _[3] || (_[3] = (b) => x("before"))
              }, {
                default: Fe(() => [
                  ape
                ]),
                _: 1
              })),
              r.value.pv ? bt("", !0) : (Ce(), et(U(E0), {
                key: 3,
                class: "divider"
              })),
              !r.value.pv && g.value ? (Ce(), et(ea, {
                key: 4,
                class: "nc-column-options-delete",
                onClick: m
              }, {
                default: Fe(() => [
                  ope
                ]),
                _: 1
              })) : bt("", !0)
            ]),
            _: 1
          })
        ]),
        default: Fe(() => [
          ke("div", Z0e, [
            ke("img", {
              class: "chevron-down",
              src: U(Wm)
            }, null, 8, Q0e)
          ])
        ]),
        _: 1
      }, 8, ["open"]),
      A(U0e, {
        visible: h.value,
        "onUpdate:visible": _[6] || (_[6] = (b) => h.value = b),
        column: r.value
      }, null, 8, ["visible", "column"]),
      r.value ? (Ce(), et(X0e, {
        key: 0,
        modelValue: f.value,
        "onUpdate:modelValue": _[7] || (_[7] = (b) => f.value = b),
        column: r.value,
        extra: d.value
      }, null, 8, ["modelValue", "column", "extra"])) : bt("", !0)
    ], 64));
  }
}), spe = /* @__PURE__ */ Cn(ipe, [["__scopeId", "data-v-ebae8729"]]), lpe = /* @__PURE__ */ Me({
  __name: "DateOptions",
  props: {
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    var o;
    const a = Ra(e, "value", t);
    return (o = a.value.meta) != null && o.date_format || (a.value.meta || (a.value.meta = {}), a.value.meta.date_format = Bf[0]), (i, s) => (Ce(), et(U(Jr), { label: "日期格式" }, {
      default: Fe(() => [
        A(U(fo), {
          value: U(a).meta.date_format,
          "onUpdate:value": s[0] || (s[0] = (l) => U(a).meta.date_format = l),
          "show-search": "",
          class: "nc-date-select",
          "popup-class-name": "nc-dropdown-date-format"
        }, {
          default: Fe(() => [
            (Ce(!0), rt(dt, null, Vn([...U(Bf), ...U(B8)], (l, u) => (Ce(), et(U(ia), {
              key: u,
              value: l
            }, {
              default: Fe(() => [
                Jt(Wt(l), 1)
              ]),
              _: 2
            }, 1032, ["value"]))), 128))
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }));
  }
}), upe = /* @__PURE__ */ Me({
  __name: "DecimalOptions",
  props: {
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = [1, 2, 3, 4, 5, 6, 7, 8], o = {
      1: "1.0",
      2: "1.00",
      3: "1.000",
      4: "1.0000",
      5: "1.00000",
      6: "1.000000",
      7: "1.0000000",
      8: "1.00000000"
    }, i = Ra(n, "value", r);
    Lt(() => {
      var l;
      (l = i.value.meta) != null && l.precision || (i.value.meta || (i.value.meta = {}), i.value.meta.precision = a[0]);
    });
    const s = (l) => {
      i.value.dtxs = Math.max(l, i.value.dtxs);
    };
    return (l, u) => (Ce(), et(U(Jr), { label: "精度" }, {
      default: Fe(() => {
        var c;
        return [
          (c = U(i).meta) != null && c.precision ? (Ce(), et(U(fo), {
            key: 0,
            value: U(i).meta.precision,
            "onUpdate:value": u[0] || (u[0] = (f) => U(i).meta.precision = f),
            "popup-class-name": "nc-dropdown-decimal-format",
            onChange: s
          }, {
            default: Fe(() => [
              (Ce(), rt(dt, null, Vn(a, (f, d) => A(U(ia), {
                key: d,
                value: f
              }, {
                default: Fe(() => [
                  Jt(Wt(o[f]), 1)
                ]),
                _: 2
              }, 1032, ["value"])), 64))
            ]),
            _: 1
          }, 8, ["value"])) : bt("", !0)
        ];
      }),
      _: 1
    }));
  }
}), cpe = /* @__PURE__ */ Me({
  __name: "DateTimeOptions",
  props: {
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    var o, i;
    const a = Ra(e, "value", t);
    return (o = a.value.meta) != null && o.date_format || (a.value.meta || (a.value.meta = {}), a.value.meta.date_format = Bf[0]), (i = a.value.meta) != null && i.time_format || (a.value.meta || (a.value.meta = {}), a.value.meta.time_format = hm[0]), (s, l) => (Ce(), rt(dt, null, [
      A(U(Jr), { label: "日期格式" }, {
        default: Fe(() => [
          A(U(fo), {
            value: U(a).meta.date_format,
            "onUpdate:value": l[0] || (l[0] = (u) => U(a).meta.date_format = u),
            class: "nc-date-select",
            "popup-class-name": "nc-dropdown-date-format"
          }, {
            default: Fe(() => [
              (Ce(!0), rt(dt, null, Vn(U(Bf), (u, c) => (Ce(), et(U(ia), {
                key: c,
                value: u
              }, {
                default: Fe(() => [
                  Jt(Wt(u), 1)
                ]),
                _: 2
              }, 1032, ["value"]))), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }),
      A(U(Jr), { label: "时间格式" }, {
        default: Fe(() => [
          A(U(fo), {
            value: U(a).meta.time_format,
            "onUpdate:value": l[1] || (l[1] = (u) => U(a).meta.time_format = u),
            class: "nc-time-select",
            "popup-class-name": "nc-dropdown-time-format"
          }, {
            default: Fe(() => [
              (Ce(!0), rt(dt, null, Vn(U(hm), (u, c) => (Ce(), et(U(ia), {
                key: c,
                value: u
              }, {
                default: Fe(() => [
                  Jt(Wt(u), 1)
                ]),
                _: 2
              }, 1032, ["value"]))), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      })
    ], 64));
  }
});
var gM = { exports: {} };
const fpe = /* @__PURE__ */ Z8(WH);
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function w6(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? w6(Object(n), !0).forEach(function(r) {
      dpe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : w6(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Wv(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Wv = function(t) {
    return typeof t;
  } : Wv = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wv(e);
}
function dpe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function di() {
  return di = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, di.apply(this, arguments);
}
function ppe(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function hpe(e, t) {
  if (e == null) return {};
  var n = ppe(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      r = o[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function vpe(e) {
  return mpe(e) || gpe(e) || ype(e) || xpe();
}
function mpe(e) {
  if (Array.isArray(e)) return PS(e);
}
function gpe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function ype(e, t) {
  if (e) {
    if (typeof e == "string") return PS(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PS(e, t);
  }
}
function PS(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function xpe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var bpe = "1.14.0";
function Ks(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var ll = Ks(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), oh = Ks(/Edge/i), S6 = Ks(/firefox/i), A0 = Ks(/safari/i) && !Ks(/chrome/i) && !Ks(/android/i), yM = Ks(/iP(ad|od|hone)/i), wpe = Ks(/chrome/i) && Ks(/android/i), xM = {
  capture: !1,
  passive: !1
};
function gn(e, t, n) {
  e.addEventListener(t, n, !ll && xM);
}
function un(e, t, n) {
  e.removeEventListener(t, n, !ll && xM);
}
function Gm(e, t) {
  if (t) {
    if (t[0] === ">" && (t = t.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(t);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(t);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(t);
      } catch {
        return !1;
      }
    return !1;
  }
}
function Spe(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function Ii(e, t, n, r) {
  if (e) {
    n = n || document;
    do {
      if (t != null && (t[0] === ">" ? e.parentNode === n && Gm(e, t) : Gm(e, t)) || r && e === n)
        return e;
      if (e === n) break;
    } while (e = Spe(e));
  }
  return null;
}
var _6 = /\s+/g;
function ar(e, t, n) {
  if (e && t)
    if (e.classList)
      e.classList[n ? "add" : "remove"](t);
    else {
      var r = (" " + e.className + " ").replace(_6, " ").replace(" " + t + " ", " ");
      e.className = (r + (n ? " " + t : "")).replace(_6, " ");
    }
}
function $t(e, t, n) {
  var r = e && e.style;
  if (r) {
    if (n === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), t === void 0 ? n : n[t];
    !(t in r) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), r[t] = n + (typeof n == "string" ? "" : "px");
  }
}
function Ju(e, t) {
  var n = "";
  if (typeof e == "string")
    n = e;
  else
    do {
      var r = $t(e, "transform");
      r && r !== "none" && (n = r + " " + n);
    } while (!t && (e = e.parentNode));
  var a = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return a && new a(n);
}
function bM(e, t, n) {
  if (e) {
    var r = e.getElementsByTagName(t), a = 0, o = r.length;
    if (n)
      for (; a < o; a++)
        n(r[a], a);
    return r;
  }
  return [];
}
function ds() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function Jn(e, t, n, r, a) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var o, i, s, l, u, c, f;
    if (e !== window && e.parentNode && e !== ds() ? (o = e.getBoundingClientRect(), i = o.top, s = o.left, l = o.bottom, u = o.right, c = o.height, f = o.width) : (i = 0, s = 0, l = window.innerHeight, u = window.innerWidth, c = window.innerHeight, f = window.innerWidth), (t || n) && e !== window && (a = a || e.parentNode, !ll))
      do
        if (a && a.getBoundingClientRect && ($t(a, "transform") !== "none" || n && $t(a, "position") !== "static")) {
          var d = a.getBoundingClientRect();
          i -= d.top + parseInt($t(a, "border-top-width")), s -= d.left + parseInt($t(a, "border-left-width")), l = i + o.height, u = s + o.width;
          break;
        }
      while (a = a.parentNode);
    if (r && e !== window) {
      var p = Ju(a || e), v = p && p.a, h = p && p.d;
      p && (i /= h, s /= v, f /= v, c /= h, l = i + c, u = s + f);
    }
    return {
      top: i,
      left: s,
      bottom: l,
      right: u,
      width: f,
      height: c
    };
  }
}
function C6(e, t, n) {
  for (var r = Ll(e, !0), a = Jn(e)[t]; r; ) {
    var o = Jn(r)[n], i = void 0;
    if (i = a >= o, !i) return r;
    if (r === ds()) break;
    r = Ll(r, !1);
  }
  return !1;
}
function ad(e, t, n, r) {
  for (var a = 0, o = 0, i = e.children; o < i.length; ) {
    if (i[o].style.display !== "none" && i[o] !== Bt.ghost && (r || i[o] !== Bt.dragged) && Ii(i[o], n.draggable, e, !1)) {
      if (a === t)
        return i[o];
      a++;
    }
    o++;
  }
  return null;
}
function D4(e, t) {
  for (var n = e.lastElementChild; n && (n === Bt.ghost || $t(n, "display") === "none" || t && !Gm(n, t)); )
    n = n.previousElementSibling;
  return n || null;
}
function pr(e, t) {
  var n = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling; )
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== Bt.clone && (!t || Gm(e, t)) && n++;
  return n;
}
function E6(e) {
  var t = 0, n = 0, r = ds();
  if (e)
    do {
      var a = Ju(e), o = a.a, i = a.d;
      t += e.scrollLeft * o, n += e.scrollTop * i;
    } while (e !== r && (e = e.parentNode));
  return [t, n];
}
function _pe(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n)) {
      for (var r in t)
        if (t.hasOwnProperty(r) && t[r] === e[n][r]) return Number(n);
    }
  return -1;
}
function Ll(e, t) {
  if (!e || !e.getBoundingClientRect) return ds();
  var n = e, r = !1;
  do
    if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
      var a = $t(n);
      if (n.clientWidth < n.scrollWidth && (a.overflowX == "auto" || a.overflowX == "scroll") || n.clientHeight < n.scrollHeight && (a.overflowY == "auto" || a.overflowY == "scroll")) {
        if (!n.getBoundingClientRect || n === document.body) return ds();
        if (r || t) return n;
        r = !0;
      }
    }
  while (n = n.parentNode);
  return ds();
}
function Cpe(e, t) {
  if (e && t)
    for (var n in t)
      t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
}
function gx(e, t) {
  return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var I0;
function wM(e, t) {
  return function() {
    if (!I0) {
      var n = arguments, r = this;
      n.length === 1 ? e.call(r, n[0]) : e.apply(r, n), I0 = setTimeout(function() {
        I0 = void 0;
      }, t);
    }
  };
}
function Epe() {
  clearTimeout(I0), I0 = void 0;
}
function SM(e, t, n) {
  e.scrollLeft += t, e.scrollTop += n;
}
function k4(e) {
  var t = window.Polymer, n = window.jQuery || window.Zepto;
  return t && t.dom ? t.dom(e).cloneNode(!0) : n ? n(e).clone(!0)[0] : e.cloneNode(!0);
}
function T6(e, t) {
  $t(e, "position", "absolute"), $t(e, "top", t.top), $t(e, "left", t.left), $t(e, "width", t.width), $t(e, "height", t.height);
}
function yx(e) {
  $t(e, "position", ""), $t(e, "top", ""), $t(e, "left", ""), $t(e, "width", ""), $t(e, "height", "");
}
var Ta = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function Tpe() {
  var e = [], t;
  return {
    captureAnimationState: function() {
      if (e = [], !!this.options.animation) {
        var r = [].slice.call(this.el.children);
        r.forEach(function(a) {
          if (!($t(a, "display") === "none" || a === Bt.ghost)) {
            e.push({
              target: a,
              rect: Jn(a)
            });
            var o = xs({}, e[e.length - 1].rect);
            if (a.thisAnimationDuration) {
              var i = Ju(a, !0);
              i && (o.top -= i.f, o.left -= i.e);
            }
            a.fromRect = o;
          }
        });
      }
    },
    addAnimationState: function(r) {
      e.push(r);
    },
    removeAnimationState: function(r) {
      e.splice(_pe(e, {
        target: r
      }), 1);
    },
    animateAll: function(r) {
      var a = this;
      if (!this.options.animation) {
        clearTimeout(t), typeof r == "function" && r();
        return;
      }
      var o = !1, i = 0;
      e.forEach(function(s) {
        var l = 0, u = s.target, c = u.fromRect, f = Jn(u), d = u.prevFromRect, p = u.prevToRect, v = s.rect, h = Ju(u, !0);
        h && (f.top -= h.f, f.left -= h.e), u.toRect = f, u.thisAnimationDuration && gx(d, f) && !gx(c, f) && // Make sure animatingRect is on line between toRect & fromRect
        (v.top - f.top) / (v.left - f.left) === (c.top - f.top) / (c.left - f.left) && (l = Ope(v, d, p, a.options)), gx(f, c) || (u.prevFromRect = c, u.prevToRect = f, l || (l = a.options.animation), a.animate(u, v, f, l)), l && (o = !0, i = Math.max(i, l), clearTimeout(u.animationResetTimer), u.animationResetTimer = setTimeout(function() {
          u.animationTime = 0, u.prevFromRect = null, u.fromRect = null, u.prevToRect = null, u.thisAnimationDuration = null;
        }, l), u.thisAnimationDuration = l);
      }), clearTimeout(t), o ? t = setTimeout(function() {
        typeof r == "function" && r();
      }, i) : typeof r == "function" && r(), e = [];
    },
    animate: function(r, a, o, i) {
      if (i) {
        $t(r, "transition", ""), $t(r, "transform", "");
        var s = Ju(this.el), l = s && s.a, u = s && s.d, c = (a.left - o.left) / (l || 1), f = (a.top - o.top) / (u || 1);
        r.animatingX = !!c, r.animatingY = !!f, $t(r, "transform", "translate3d(" + c + "px," + f + "px,0)"), this.forRepaintDummy = $pe(r), $t(r, "transition", "transform " + i + "ms" + (this.options.easing ? " " + this.options.easing : "")), $t(r, "transform", "translate3d(0,0,0)"), typeof r.animated == "number" && clearTimeout(r.animated), r.animated = setTimeout(function() {
          $t(r, "transition", ""), $t(r, "transform", ""), r.animated = !1, r.animatingX = !1, r.animatingY = !1;
        }, i);
      }
    }
  };
}
function $pe(e) {
  return e.offsetWidth;
}
function Ope(e, t, n, r) {
  return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - n.top, 2) + Math.pow(t.left - n.left, 2)) * r.animation;
}
var Zc = [], xx = {
  initializeByDefault: !0
}, ih = {
  mount: function(t) {
    for (var n in xx)
      xx.hasOwnProperty(n) && !(n in t) && (t[n] = xx[n]);
    Zc.forEach(function(r) {
      if (r.pluginName === t.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(t.pluginName, " more than once");
    }), Zc.push(t);
  },
  pluginEvent: function(t, n, r) {
    var a = this;
    this.eventCanceled = !1, r.cancel = function() {
      a.eventCanceled = !0;
    };
    var o = t + "Global";
    Zc.forEach(function(i) {
      n[i.pluginName] && (n[i.pluginName][o] && n[i.pluginName][o](xs({
        sortable: n
      }, r)), n.options[i.pluginName] && n[i.pluginName][t] && n[i.pluginName][t](xs({
        sortable: n
      }, r)));
    });
  },
  initializePlugins: function(t, n, r, a) {
    Zc.forEach(function(s) {
      var l = s.pluginName;
      if (!(!t.options[l] && !s.initializeByDefault)) {
        var u = new s(t, n, t.options);
        u.sortable = t, u.options = t.options, t[l] = u, di(r, u.defaults);
      }
    });
    for (var o in t.options)
      if (t.options.hasOwnProperty(o)) {
        var i = this.modifyOption(t, o, t.options[o]);
        typeof i < "u" && (t.options[o] = i);
      }
  },
  getEventProperties: function(t, n) {
    var r = {};
    return Zc.forEach(function(a) {
      typeof a.eventProperties == "function" && di(r, a.eventProperties.call(n[a.pluginName], t));
    }), r;
  },
  modifyOption: function(t, n, r) {
    var a;
    return Zc.forEach(function(o) {
      t[o.pluginName] && o.optionListeners && typeof o.optionListeners[n] == "function" && (a = o.optionListeners[n].call(t[o.pluginName], r));
    }), a;
  }
};
function r0(e) {
  var t = e.sortable, n = e.rootEl, r = e.name, a = e.targetEl, o = e.cloneEl, i = e.toEl, s = e.fromEl, l = e.oldIndex, u = e.newIndex, c = e.oldDraggableIndex, f = e.newDraggableIndex, d = e.originalEvent, p = e.putSortable, v = e.extraEventProperties;
  if (t = t || n && n[Ta], !!t) {
    var h, m = t.options, y = "on" + r.charAt(0).toUpperCase() + r.substr(1);
    window.CustomEvent && !ll && !oh ? h = new CustomEvent(r, {
      bubbles: !0,
      cancelable: !0
    }) : (h = document.createEvent("Event"), h.initEvent(r, !0, !0)), h.to = i || n, h.from = s || n, h.item = a || n, h.clone = o, h.oldIndex = l, h.newIndex = u, h.oldDraggableIndex = c, h.newDraggableIndex = f, h.originalEvent = d, h.pullMode = p ? p.lastPutMode : void 0;
    var x = xs(xs({}, v), ih.getEventProperties(r, t));
    for (var g in x)
      h[g] = x[g];
    n && n.dispatchEvent(h), m[y] && m[y].call(t, h);
  }
}
var Ape = ["evt"], to = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = r.evt, o = hpe(r, Ape);
  ih.pluginEvent.bind(Bt)(t, n, xs({
    dragEl: mt,
    parentEl: cr,
    ghostEl: Zt,
    rootEl: Xn,
    nextEl: Au,
    lastDownEl: Gv,
    cloneEl: fr,
    cloneHidden: Dl,
    dragStarted: a0,
    putSortable: Xr,
    activeSortable: Bt.active,
    originalEvent: a,
    oldIndex: vf,
    oldDraggableIndex: P0,
    newIndex: Eo,
    newDraggableIndex: $l,
    hideGhostForTarget: TM,
    unhideGhostForTarget: $M,
    cloneNowHidden: function() {
      Dl = !0;
    },
    cloneNowShown: function() {
      Dl = !1;
    },
    dispatchSortableEvent: function(s) {
      Ha({
        sortable: n,
        name: s,
        originalEvent: a
      });
    }
  }, o));
};
function Ha(e) {
  r0(xs({
    putSortable: Xr,
    cloneEl: fr,
    targetEl: mt,
    rootEl: Xn,
    oldIndex: vf,
    oldDraggableIndex: P0,
    newIndex: Eo,
    newDraggableIndex: $l
  }, e));
}
var mt, cr, Zt, Xn, Au, Gv, fr, Dl, vf, Eo, P0, $l, rv, Xr, uf = !1, Km = !1, Ym = [], Cu, wi, bx, wx, $6, O6, a0, Qc, D0, k0 = !1, av = !1, Kv, ga, Sx = [], DS = !1, qm = [], F1 = typeof document < "u", ov = yM, A6 = oh || ll ? "cssFloat" : "float", Ipe = F1 && !wpe && !yM && "draggable" in document.createElement("div"), _M = function() {
  if (F1) {
    if (ll)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
}(), CM = function(t, n) {
  var r = $t(t), a = parseInt(r.width) - parseInt(r.paddingLeft) - parseInt(r.paddingRight) - parseInt(r.borderLeftWidth) - parseInt(r.borderRightWidth), o = ad(t, 0, n), i = ad(t, 1, n), s = o && $t(o), l = i && $t(i), u = s && parseInt(s.marginLeft) + parseInt(s.marginRight) + Jn(o).width, c = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + Jn(i).width;
  if (r.display === "flex")
    return r.flexDirection === "column" || r.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (r.display === "grid")
    return r.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (o && s.float && s.float !== "none") {
    var f = s.float === "left" ? "left" : "right";
    return i && (l.clear === "both" || l.clear === f) ? "vertical" : "horizontal";
  }
  return o && (s.display === "block" || s.display === "flex" || s.display === "table" || s.display === "grid" || u >= a && r[A6] === "none" || i && r[A6] === "none" && u + c > a) ? "vertical" : "horizontal";
}, Ppe = function(t, n, r) {
  var a = r ? t.left : t.top, o = r ? t.right : t.bottom, i = r ? t.width : t.height, s = r ? n.left : n.top, l = r ? n.right : n.bottom, u = r ? n.width : n.height;
  return a === s || o === l || a + i / 2 === s + u / 2;
}, Dpe = function(t, n) {
  var r;
  return Ym.some(function(a) {
    var o = a[Ta].options.emptyInsertThreshold;
    if (!(!o || D4(a))) {
      var i = Jn(a), s = t >= i.left - o && t <= i.right + o, l = n >= i.top - o && n <= i.bottom + o;
      if (s && l)
        return r = a;
    }
  }), r;
}, EM = function(t) {
  function n(o, i) {
    return function(s, l, u, c) {
      var f = s.options.group.name && l.options.group.name && s.options.group.name === l.options.group.name;
      if (o == null && (i || f))
        return !0;
      if (o == null || o === !1)
        return !1;
      if (i && o === "clone")
        return o;
      if (typeof o == "function")
        return n(o(s, l, u, c), i)(s, l, u, c);
      var d = (i ? s : l).options.group.name;
      return o === !0 || typeof o == "string" && o === d || o.join && o.indexOf(d) > -1;
    };
  }
  var r = {}, a = t.group;
  (!a || Wv(a) != "object") && (a = {
    name: a
  }), r.name = a.name, r.checkPull = n(a.pull, !0), r.checkPut = n(a.put), r.revertClone = a.revertClone, t.group = r;
}, TM = function() {
  !_M && Zt && $t(Zt, "display", "none");
}, $M = function() {
  !_M && Zt && $t(Zt, "display", "");
};
F1 && document.addEventListener("click", function(e) {
  if (Km)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), Km = !1, !1;
}, !0);
var Eu = function(t) {
  if (mt) {
    t = t.touches ? t.touches[0] : t;
    var n = Dpe(t.clientX, t.clientY);
    if (n) {
      var r = {};
      for (var a in t)
        t.hasOwnProperty(a) && (r[a] = t[a]);
      r.target = r.rootEl = n, r.preventDefault = void 0, r.stopPropagation = void 0, n[Ta]._onDragOver(r);
    }
  }
}, kpe = function(t) {
  mt && mt.parentNode[Ta]._isOutsideThisEl(t.target);
};
function Bt(e, t) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = t = di({}, t), e[Ta] = this;
  var n = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return CM(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(i, s) {
      i.setData("Text", s.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Bt.supportPointer !== !1 && "PointerEvent" in window && !A0,
    emptyInsertThreshold: 5
  };
  ih.initializePlugins(this, e, n);
  for (var r in n)
    !(r in t) && (t[r] = n[r]);
  EM(t);
  for (var a in this)
    a.charAt(0) === "_" && typeof this[a] == "function" && (this[a] = this[a].bind(this));
  this.nativeDraggable = t.forceFallback ? !1 : Ipe, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? gn(e, "pointerdown", this._onTapStart) : (gn(e, "mousedown", this._onTapStart), gn(e, "touchstart", this._onTapStart)), this.nativeDraggable && (gn(e, "dragover", this), gn(e, "dragenter", this)), Ym.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), di(this, Tpe());
}
Bt.prototype = /** @lends Sortable.prototype */
{
  constructor: Bt,
  _isOutsideThisEl: function(t) {
    !this.el.contains(t) && t !== this.el && (Qc = null);
  },
  _getDirection: function(t, n) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, t, n, mt) : this.options.direction;
  },
  _onTapStart: function(t) {
    if (t.cancelable) {
      var n = this, r = this.el, a = this.options, o = a.preventOnFilter, i = t.type, s = t.touches && t.touches[0] || t.pointerType && t.pointerType === "touch" && t, l = (s || t).target, u = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || l, c = a.filter;
      if (jpe(r), !mt && !(/mousedown|pointerdown/.test(i) && t.button !== 0 || a.disabled) && !u.isContentEditable && !(!this.nativeDraggable && A0 && l && l.tagName.toUpperCase() === "SELECT") && (l = Ii(l, a.draggable, r, !1), !(l && l.animated) && Gv !== l)) {
        if (vf = pr(l), P0 = pr(l, a.draggable), typeof c == "function") {
          if (c.call(this, t, l, this)) {
            Ha({
              sortable: n,
              rootEl: u,
              name: "filter",
              targetEl: l,
              toEl: r,
              fromEl: r
            }), to("filter", n, {
              evt: t
            }), o && t.cancelable && t.preventDefault();
            return;
          }
        } else if (c && (c = c.split(",").some(function(f) {
          if (f = Ii(u, f.trim(), r, !1), f)
            return Ha({
              sortable: n,
              rootEl: f,
              name: "filter",
              targetEl: l,
              fromEl: r,
              toEl: r
            }), to("filter", n, {
              evt: t
            }), !0;
        }), c)) {
          o && t.cancelable && t.preventDefault();
          return;
        }
        a.handle && !Ii(u, a.handle, r, !1) || this._prepareDragStart(t, s, l);
      }
    }
  },
  _prepareDragStart: function(t, n, r) {
    var a = this, o = a.el, i = a.options, s = o.ownerDocument, l;
    if (r && !mt && r.parentNode === o) {
      var u = Jn(r);
      if (Xn = o, mt = r, cr = mt.parentNode, Au = mt.nextSibling, Gv = r, rv = i.group, Bt.dragged = mt, Cu = {
        target: mt,
        clientX: (n || t).clientX,
        clientY: (n || t).clientY
      }, $6 = Cu.clientX - u.left, O6 = Cu.clientY - u.top, this._lastX = (n || t).clientX, this._lastY = (n || t).clientY, mt.style["will-change"] = "all", l = function() {
        if (to("delayEnded", a, {
          evt: t
        }), Bt.eventCanceled) {
          a._onDrop();
          return;
        }
        a._disableDelayedDragEvents(), !S6 && a.nativeDraggable && (mt.draggable = !0), a._triggerDragStart(t, n), Ha({
          sortable: a,
          name: "choose",
          originalEvent: t
        }), ar(mt, i.chosenClass, !0);
      }, i.ignore.split(",").forEach(function(c) {
        bM(mt, c.trim(), _x);
      }), gn(s, "dragover", Eu), gn(s, "mousemove", Eu), gn(s, "touchmove", Eu), gn(s, "mouseup", a._onDrop), gn(s, "touchend", a._onDrop), gn(s, "touchcancel", a._onDrop), S6 && this.nativeDraggable && (this.options.touchStartThreshold = 4, mt.draggable = !0), to("delayStart", this, {
        evt: t
      }), i.delay && (!i.delayOnTouchOnly || n) && (!this.nativeDraggable || !(oh || ll))) {
        if (Bt.eventCanceled) {
          this._onDrop();
          return;
        }
        gn(s, "mouseup", a._disableDelayedDrag), gn(s, "touchend", a._disableDelayedDrag), gn(s, "touchcancel", a._disableDelayedDrag), gn(s, "mousemove", a._delayedDragTouchMoveHandler), gn(s, "touchmove", a._delayedDragTouchMoveHandler), i.supportPointer && gn(s, "pointermove", a._delayedDragTouchMoveHandler), a._dragStartTimer = setTimeout(l, i.delay);
      } else
        l();
    }
  },
  _delayedDragTouchMoveHandler: function(t) {
    var n = t.touches ? t.touches[0] : t;
    Math.max(Math.abs(n.clientX - this._lastX), Math.abs(n.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    mt && _x(mt), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var t = this.el.ownerDocument;
    un(t, "mouseup", this._disableDelayedDrag), un(t, "touchend", this._disableDelayedDrag), un(t, "touchcancel", this._disableDelayedDrag), un(t, "mousemove", this._delayedDragTouchMoveHandler), un(t, "touchmove", this._delayedDragTouchMoveHandler), un(t, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(t, n) {
    n = n || t.pointerType == "touch" && t, !this.nativeDraggable || n ? this.options.supportPointer ? gn(document, "pointermove", this._onTouchMove) : n ? gn(document, "touchmove", this._onTouchMove) : gn(document, "mousemove", this._onTouchMove) : (gn(mt, "dragend", this), gn(Xn, "dragstart", this._onDragStart));
    try {
      document.selection ? Yv(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(t, n) {
    if (uf = !1, Xn && mt) {
      to("dragStarted", this, {
        evt: n
      }), this.nativeDraggable && gn(document, "dragover", kpe);
      var r = this.options;
      !t && ar(mt, r.dragClass, !1), ar(mt, r.ghostClass, !0), Bt.active = this, t && this._appendGhost(), Ha({
        sortable: this,
        name: "start",
        originalEvent: n
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (wi) {
      this._lastX = wi.clientX, this._lastY = wi.clientY, TM();
      for (var t = document.elementFromPoint(wi.clientX, wi.clientY), n = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(wi.clientX, wi.clientY), t !== n); )
        n = t;
      if (mt.parentNode[Ta]._isOutsideThisEl(t), n)
        do {
          if (n[Ta]) {
            var r = void 0;
            if (r = n[Ta]._onDragOver({
              clientX: wi.clientX,
              clientY: wi.clientY,
              target: t,
              rootEl: n
            }), r && !this.options.dragoverBubble)
              break;
          }
          t = n;
        } while (n = n.parentNode);
      $M();
    }
  },
  _onTouchMove: function(t) {
    if (Cu) {
      var n = this.options, r = n.fallbackTolerance, a = n.fallbackOffset, o = t.touches ? t.touches[0] : t, i = Zt && Ju(Zt, !0), s = Zt && i && i.a, l = Zt && i && i.d, u = ov && ga && E6(ga), c = (o.clientX - Cu.clientX + a.x) / (s || 1) + (u ? u[0] - Sx[0] : 0) / (s || 1), f = (o.clientY - Cu.clientY + a.y) / (l || 1) + (u ? u[1] - Sx[1] : 0) / (l || 1);
      if (!Bt.active && !uf) {
        if (r && Math.max(Math.abs(o.clientX - this._lastX), Math.abs(o.clientY - this._lastY)) < r)
          return;
        this._onDragStart(t, !0);
      }
      if (Zt) {
        i ? (i.e += c - (bx || 0), i.f += f - (wx || 0)) : i = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: c,
          f
        };
        var d = "matrix(".concat(i.a, ",").concat(i.b, ",").concat(i.c, ",").concat(i.d, ",").concat(i.e, ",").concat(i.f, ")");
        $t(Zt, "webkitTransform", d), $t(Zt, "mozTransform", d), $t(Zt, "msTransform", d), $t(Zt, "transform", d), bx = c, wx = f, wi = o;
      }
      t.cancelable && t.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!Zt) {
      var t = this.options.fallbackOnBody ? document.body : Xn, n = Jn(mt, !0, ov, !0, t), r = this.options;
      if (ov) {
        for (ga = t; $t(ga, "position") === "static" && $t(ga, "transform") === "none" && ga !== document; )
          ga = ga.parentNode;
        ga !== document.body && ga !== document.documentElement ? (ga === document && (ga = ds()), n.top += ga.scrollTop, n.left += ga.scrollLeft) : ga = ds(), Sx = E6(ga);
      }
      Zt = mt.cloneNode(!0), ar(Zt, r.ghostClass, !1), ar(Zt, r.fallbackClass, !0), ar(Zt, r.dragClass, !0), $t(Zt, "transition", ""), $t(Zt, "transform", ""), $t(Zt, "box-sizing", "border-box"), $t(Zt, "margin", 0), $t(Zt, "top", n.top), $t(Zt, "left", n.left), $t(Zt, "width", n.width), $t(Zt, "height", n.height), $t(Zt, "opacity", "0.8"), $t(Zt, "position", ov ? "absolute" : "fixed"), $t(Zt, "zIndex", "100000"), $t(Zt, "pointerEvents", "none"), Bt.ghost = Zt, t.appendChild(Zt), $t(Zt, "transform-origin", $6 / parseInt(Zt.style.width) * 100 + "% " + O6 / parseInt(Zt.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(t, n) {
    var r = this, a = t.dataTransfer, o = r.options;
    if (to("dragStart", this, {
      evt: t
    }), Bt.eventCanceled) {
      this._onDrop();
      return;
    }
    to("setupClone", this), Bt.eventCanceled || (fr = k4(mt), fr.draggable = !1, fr.style["will-change"] = "", this._hideClone(), ar(fr, this.options.chosenClass, !1), Bt.clone = fr), r.cloneId = Yv(function() {
      to("clone", r), !Bt.eventCanceled && (r.options.removeCloneOnHide || Xn.insertBefore(fr, mt), r._hideClone(), Ha({
        sortable: r,
        name: "clone"
      }));
    }), !n && ar(mt, o.dragClass, !0), n ? (Km = !0, r._loopId = setInterval(r._emulateDragOver, 50)) : (un(document, "mouseup", r._onDrop), un(document, "touchend", r._onDrop), un(document, "touchcancel", r._onDrop), a && (a.effectAllowed = "move", o.setData && o.setData.call(r, a, mt)), gn(document, "drop", r), $t(mt, "transform", "translateZ(0)")), uf = !0, r._dragStartId = Yv(r._dragStarted.bind(r, n, t)), gn(document, "selectstart", r), a0 = !0, A0 && $t(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(t) {
    var n = this.el, r = t.target, a, o, i, s = this.options, l = s.group, u = Bt.active, c = rv === l, f = s.sort, d = Xr || u, p, v = this, h = !1;
    if (DS) return;
    function m(H, R) {
      to(H, v, xs({
        evt: t,
        isOwner: c,
        axis: p ? "vertical" : "horizontal",
        revert: i,
        dragRect: a,
        targetRect: o,
        canSort: f,
        fromSortable: d,
        target: r,
        completed: x,
        onMove: function(W, F) {
          return iv(Xn, n, mt, a, W, Jn(W), t, F);
        },
        changed: g
      }, R));
    }
    function y() {
      m("dragOverAnimationCapture"), v.captureAnimationState(), v !== d && d.captureAnimationState();
    }
    function x(H) {
      return m("dragOverCompleted", {
        insertion: H
      }), H && (c ? u._hideClone() : u._showClone(v), v !== d && (ar(mt, Xr ? Xr.options.ghostClass : u.options.ghostClass, !1), ar(mt, s.ghostClass, !0)), Xr !== v && v !== Bt.active ? Xr = v : v === Bt.active && Xr && (Xr = null), d === v && (v._ignoreWhileAnimating = r), v.animateAll(function() {
        m("dragOverAnimationComplete"), v._ignoreWhileAnimating = null;
      }), v !== d && (d.animateAll(), d._ignoreWhileAnimating = null)), (r === mt && !mt.animated || r === n && !r.animated) && (Qc = null), !s.dragoverBubble && !t.rootEl && r !== document && (mt.parentNode[Ta]._isOutsideThisEl(t.target), !H && Eu(t)), !s.dragoverBubble && t.stopPropagation && t.stopPropagation(), h = !0;
    }
    function g() {
      Eo = pr(mt), $l = pr(mt, s.draggable), Ha({
        sortable: v,
        name: "change",
        toEl: n,
        newIndex: Eo,
        newDraggableIndex: $l,
        originalEvent: t
      });
    }
    if (t.preventDefault !== void 0 && t.cancelable && t.preventDefault(), r = Ii(r, s.draggable, n, !0), m("dragOver"), Bt.eventCanceled) return h;
    if (mt.contains(t.target) || r.animated && r.animatingX && r.animatingY || v._ignoreWhileAnimating === r)
      return x(!1);
    if (Km = !1, u && !s.disabled && (c ? f || (i = cr !== Xn) : Xr === this || (this.lastPutMode = rv.checkPull(this, u, mt, t)) && l.checkPut(this, u, mt, t))) {
      if (p = this._getDirection(t, r) === "vertical", a = Jn(mt), m("dragOverValid"), Bt.eventCanceled) return h;
      if (i)
        return cr = Xn, y(), this._hideClone(), m("revert"), Bt.eventCanceled || (Au ? Xn.insertBefore(mt, Au) : Xn.appendChild(mt)), x(!0);
      var S = D4(n, s.draggable);
      if (!S || Fpe(t, p, this) && !S.animated) {
        if (S === mt)
          return x(!1);
        if (S && n === t.target && (r = S), r && (o = Jn(r)), iv(Xn, n, mt, a, r, o, t, !!r) !== !1)
          return y(), n.appendChild(mt), cr = n, g(), x(!0);
      } else if (S && Npe(t, p, this)) {
        var w = ad(n, 0, s, !0);
        if (w === mt)
          return x(!1);
        if (r = w, o = Jn(r), iv(Xn, n, mt, a, r, o, t, !1) !== !1)
          return y(), n.insertBefore(mt, w), cr = n, g(), x(!0);
      } else if (r.parentNode === n) {
        o = Jn(r);
        var _ = 0, b, E = mt.parentNode !== n, C = !Ppe(mt.animated && mt.toRect || a, r.animated && r.toRect || o, p), T = p ? "top" : "left", O = C6(r, "top", "top") || C6(mt, "top", "top"), I = O ? O.scrollTop : void 0;
        Qc !== r && (b = o[T], k0 = !1, av = !C && s.invertSwap || E), _ = Lpe(t, r, o, p, C ? 1 : s.swapThreshold, s.invertedSwapThreshold == null ? s.swapThreshold : s.invertedSwapThreshold, av, Qc === r);
        var k;
        if (_ !== 0) {
          var B = pr(mt);
          do
            B -= _, k = cr.children[B];
          while (k && ($t(k, "display") === "none" || k === Zt));
        }
        if (_ === 0 || k === r)
          return x(!1);
        Qc = r, D0 = _;
        var P = r.nextElementSibling, N = !1;
        N = _ === 1;
        var M = iv(Xn, n, mt, a, r, o, t, N);
        if (M !== !1)
          return (M === 1 || M === -1) && (N = M === 1), DS = !0, setTimeout(Rpe, 30), y(), N && !P ? n.appendChild(mt) : r.parentNode.insertBefore(mt, N ? P : r), O && SM(O, 0, I - O.scrollTop), cr = mt.parentNode, b !== void 0 && !av && (Kv = Math.abs(b - Jn(r)[T])), g(), x(!0);
      }
      if (n.contains(mt))
        return x(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    un(document, "mousemove", this._onTouchMove), un(document, "touchmove", this._onTouchMove), un(document, "pointermove", this._onTouchMove), un(document, "dragover", Eu), un(document, "mousemove", Eu), un(document, "touchmove", Eu);
  },
  _offUpEvents: function() {
    var t = this.el.ownerDocument;
    un(t, "mouseup", this._onDrop), un(t, "touchend", this._onDrop), un(t, "pointerup", this._onDrop), un(t, "touchcancel", this._onDrop), un(document, "selectstart", this);
  },
  _onDrop: function(t) {
    var n = this.el, r = this.options;
    if (Eo = pr(mt), $l = pr(mt, r.draggable), to("drop", this, {
      evt: t
    }), cr = mt && mt.parentNode, Eo = pr(mt), $l = pr(mt, r.draggable), Bt.eventCanceled) {
      this._nulling();
      return;
    }
    uf = !1, av = !1, k0 = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), kS(this.cloneId), kS(this._dragStartId), this.nativeDraggable && (un(document, "drop", this), un(n, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), A0 && $t(document.body, "user-select", ""), $t(mt, "transform", ""), t && (a0 && (t.cancelable && t.preventDefault(), !r.dropBubble && t.stopPropagation()), Zt && Zt.parentNode && Zt.parentNode.removeChild(Zt), (Xn === cr || Xr && Xr.lastPutMode !== "clone") && fr && fr.parentNode && fr.parentNode.removeChild(fr), mt && (this.nativeDraggable && un(mt, "dragend", this), _x(mt), mt.style["will-change"] = "", a0 && !uf && ar(mt, Xr ? Xr.options.ghostClass : this.options.ghostClass, !1), ar(mt, this.options.chosenClass, !1), Ha({
      sortable: this,
      name: "unchoose",
      toEl: cr,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: t
    }), Xn !== cr ? (Eo >= 0 && (Ha({
      rootEl: cr,
      name: "add",
      toEl: cr,
      fromEl: Xn,
      originalEvent: t
    }), Ha({
      sortable: this,
      name: "remove",
      toEl: cr,
      originalEvent: t
    }), Ha({
      rootEl: cr,
      name: "sort",
      toEl: cr,
      fromEl: Xn,
      originalEvent: t
    }), Ha({
      sortable: this,
      name: "sort",
      toEl: cr,
      originalEvent: t
    })), Xr && Xr.save()) : Eo !== vf && Eo >= 0 && (Ha({
      sortable: this,
      name: "update",
      toEl: cr,
      originalEvent: t
    }), Ha({
      sortable: this,
      name: "sort",
      toEl: cr,
      originalEvent: t
    })), Bt.active && ((Eo == null || Eo === -1) && (Eo = vf, $l = P0), Ha({
      sortable: this,
      name: "end",
      toEl: cr,
      originalEvent: t
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    to("nulling", this), Xn = mt = cr = Zt = Au = fr = Gv = Dl = Cu = wi = a0 = Eo = $l = vf = P0 = Qc = D0 = Xr = rv = Bt.dragged = Bt.ghost = Bt.clone = Bt.active = null, qm.forEach(function(t) {
      t.checked = !0;
    }), qm.length = bx = wx = 0;
  },
  handleEvent: function(t) {
    switch (t.type) {
      case "drop":
      case "dragend":
        this._onDrop(t);
        break;
      case "dragenter":
      case "dragover":
        mt && (this._onDragOver(t), Mpe(t));
        break;
      case "selectstart":
        t.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var t = [], n, r = this.el.children, a = 0, o = r.length, i = this.options; a < o; a++)
      n = r[a], Ii(n, i.draggable, this.el, !1) && t.push(n.getAttribute(i.dataIdAttr) || Hpe(n));
    return t;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(t, n) {
    var r = {}, a = this.el;
    this.toArray().forEach(function(o, i) {
      var s = a.children[i];
      Ii(s, this.options.draggable, a, !1) && (r[o] = s);
    }, this), n && this.captureAnimationState(), t.forEach(function(o) {
      r[o] && (a.removeChild(r[o]), a.appendChild(r[o]));
    }), n && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var t = this.options.store;
    t && t.set && t.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(t, n) {
    return Ii(t, n || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(t, n) {
    var r = this.options;
    if (n === void 0)
      return r[t];
    var a = ih.modifyOption(this, t, n);
    typeof a < "u" ? r[t] = a : r[t] = n, t === "group" && EM(r);
  },
  /**
   * Destroy
   */
  destroy: function() {
    to("destroy", this);
    var t = this.el;
    t[Ta] = null, un(t, "mousedown", this._onTapStart), un(t, "touchstart", this._onTapStart), un(t, "pointerdown", this._onTapStart), this.nativeDraggable && (un(t, "dragover", this), un(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function(n) {
      n.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), Ym.splice(Ym.indexOf(this.el), 1), this.el = t = null;
  },
  _hideClone: function() {
    if (!Dl) {
      if (to("hideClone", this), Bt.eventCanceled) return;
      $t(fr, "display", "none"), this.options.removeCloneOnHide && fr.parentNode && fr.parentNode.removeChild(fr), Dl = !0;
    }
  },
  _showClone: function(t) {
    if (t.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (Dl) {
      if (to("showClone", this), Bt.eventCanceled) return;
      mt.parentNode == Xn && !this.options.group.revertClone ? Xn.insertBefore(fr, mt) : Au ? Xn.insertBefore(fr, Au) : Xn.appendChild(fr), this.options.group.revertClone && this.animate(mt, fr), $t(fr, "display", ""), Dl = !1;
    }
  }
};
function Mpe(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function iv(e, t, n, r, a, o, i, s) {
  var l, u = e[Ta], c = u.options.onMove, f;
  return window.CustomEvent && !ll && !oh ? l = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (l = document.createEvent("Event"), l.initEvent("move", !0, !0)), l.to = t, l.from = e, l.dragged = n, l.draggedRect = r, l.related = a || t, l.relatedRect = o || Jn(t), l.willInsertAfter = s, l.originalEvent = i, e.dispatchEvent(l), c && (f = c.call(u, l, i)), f;
}
function _x(e) {
  e.draggable = !1;
}
function Rpe() {
  DS = !1;
}
function Npe(e, t, n) {
  var r = Jn(ad(n.el, 0, n.options, !0)), a = 10;
  return t ? e.clientX < r.left - a || e.clientY < r.top && e.clientX < r.right : e.clientY < r.top - a || e.clientY < r.bottom && e.clientX < r.left;
}
function Fpe(e, t, n) {
  var r = Jn(D4(n.el, n.options.draggable)), a = 10;
  return t ? e.clientX > r.right + a || e.clientX <= r.right && e.clientY > r.bottom && e.clientX >= r.left : e.clientX > r.right && e.clientY > r.top || e.clientX <= r.right && e.clientY > r.bottom + a;
}
function Lpe(e, t, n, r, a, o, i, s) {
  var l = r ? e.clientY : e.clientX, u = r ? n.height : n.width, c = r ? n.top : n.left, f = r ? n.bottom : n.right, d = !1;
  if (!i) {
    if (s && Kv < u * a) {
      if (!k0 && (D0 === 1 ? l > c + u * o / 2 : l < f - u * o / 2) && (k0 = !0), k0)
        d = !0;
      else if (D0 === 1 ? l < c + Kv : l > f - Kv)
        return -D0;
    } else if (l > c + u * (1 - a) / 2 && l < f - u * (1 - a) / 2)
      return Bpe(t);
  }
  return d = d || i, d && (l < c + u * o / 2 || l > f - u * o / 2) ? l > c + u / 2 ? 1 : -1 : 0;
}
function Bpe(e) {
  return pr(mt) < pr(e) ? 1 : -1;
}
function Hpe(e) {
  for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, r = 0; n--; )
    r += t.charCodeAt(n);
  return r.toString(36);
}
function jpe(e) {
  qm.length = 0;
  for (var t = e.getElementsByTagName("input"), n = t.length; n--; ) {
    var r = t[n];
    r.checked && qm.push(r);
  }
}
function Yv(e) {
  return setTimeout(e, 0);
}
function kS(e) {
  return clearTimeout(e);
}
F1 && gn(document, "touchmove", function(e) {
  (Bt.active || uf) && e.cancelable && e.preventDefault();
});
Bt.utils = {
  on: gn,
  off: un,
  css: $t,
  find: bM,
  is: function(t, n) {
    return !!Ii(t, n, t, !1);
  },
  extend: Cpe,
  throttle: wM,
  closest: Ii,
  toggleClass: ar,
  clone: k4,
  index: pr,
  nextTick: Yv,
  cancelNextTick: kS,
  detectDirection: CM,
  getChild: ad
};
Bt.get = function(e) {
  return e[Ta];
};
Bt.mount = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  t[0].constructor === Array && (t = t[0]), t.forEach(function(r) {
    if (!r.prototype || !r.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(r));
    r.utils && (Bt.utils = xs(xs({}, Bt.utils), r.utils)), ih.mount(r);
  });
};
Bt.create = function(e, t) {
  return new Bt(e, t);
};
Bt.version = bpe;
var Ir = [], o0, MS, RS = !1, Cx, Ex, Xm, i0;
function Vpe() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var t in this)
      t.charAt(0) === "_" && typeof this[t] == "function" && (this[t] = this[t].bind(this));
  }
  return e.prototype = {
    dragStarted: function(n) {
      var r = n.originalEvent;
      this.sortable.nativeDraggable ? gn(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? gn(document, "pointermove", this._handleFallbackAutoScroll) : r.touches ? gn(document, "touchmove", this._handleFallbackAutoScroll) : gn(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(n) {
      var r = n.originalEvent;
      !this.options.dragOverBubble && !r.rootEl && this._handleAutoScroll(r);
    },
    drop: function() {
      this.sortable.nativeDraggable ? un(document, "dragover", this._handleAutoScroll) : (un(document, "pointermove", this._handleFallbackAutoScroll), un(document, "touchmove", this._handleFallbackAutoScroll), un(document, "mousemove", this._handleFallbackAutoScroll)), I6(), qv(), Epe();
    },
    nulling: function() {
      Xm = MS = o0 = RS = i0 = Cx = Ex = null, Ir.length = 0;
    },
    _handleFallbackAutoScroll: function(n) {
      this._handleAutoScroll(n, !0);
    },
    _handleAutoScroll: function(n, r) {
      var a = this, o = (n.touches ? n.touches[0] : n).clientX, i = (n.touches ? n.touches[0] : n).clientY, s = document.elementFromPoint(o, i);
      if (Xm = n, r || this.options.forceAutoScrollFallback || oh || ll || A0) {
        Tx(n, this.options, s, r);
        var l = Ll(s, !0);
        RS && (!i0 || o !== Cx || i !== Ex) && (i0 && I6(), i0 = setInterval(function() {
          var u = Ll(document.elementFromPoint(o, i), !0);
          u !== l && (l = u, qv()), Tx(n, a.options, u, r);
        }, 10), Cx = o, Ex = i);
      } else {
        if (!this.options.bubbleScroll || Ll(s, !0) === ds()) {
          qv();
          return;
        }
        Tx(n, this.options, Ll(s, !1), !1);
      }
    }
  }, di(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function qv() {
  Ir.forEach(function(e) {
    clearInterval(e.pid);
  }), Ir = [];
}
function I6() {
  clearInterval(i0);
}
var Tx = wM(function(e, t, n, r) {
  if (t.scroll) {
    var a = (e.touches ? e.touches[0] : e).clientX, o = (e.touches ? e.touches[0] : e).clientY, i = t.scrollSensitivity, s = t.scrollSpeed, l = ds(), u = !1, c;
    MS !== n && (MS = n, qv(), o0 = t.scroll, c = t.scrollFn, o0 === !0 && (o0 = Ll(n, !0)));
    var f = 0, d = o0;
    do {
      var p = d, v = Jn(p), h = v.top, m = v.bottom, y = v.left, x = v.right, g = v.width, S = v.height, w = void 0, _ = void 0, b = p.scrollWidth, E = p.scrollHeight, C = $t(p), T = p.scrollLeft, O = p.scrollTop;
      p === l ? (w = g < b && (C.overflowX === "auto" || C.overflowX === "scroll" || C.overflowX === "visible"), _ = S < E && (C.overflowY === "auto" || C.overflowY === "scroll" || C.overflowY === "visible")) : (w = g < b && (C.overflowX === "auto" || C.overflowX === "scroll"), _ = S < E && (C.overflowY === "auto" || C.overflowY === "scroll"));
      var I = w && (Math.abs(x - a) <= i && T + g < b) - (Math.abs(y - a) <= i && !!T), k = _ && (Math.abs(m - o) <= i && O + S < E) - (Math.abs(h - o) <= i && !!O);
      if (!Ir[f])
        for (var B = 0; B <= f; B++)
          Ir[B] || (Ir[B] = {});
      (Ir[f].vx != I || Ir[f].vy != k || Ir[f].el !== p) && (Ir[f].el = p, Ir[f].vx = I, Ir[f].vy = k, clearInterval(Ir[f].pid), (I != 0 || k != 0) && (u = !0, Ir[f].pid = setInterval((function() {
        r && this.layer === 0 && Bt.active._onTouchMove(Xm);
        var P = Ir[this.layer].vy ? Ir[this.layer].vy * s : 0, N = Ir[this.layer].vx ? Ir[this.layer].vx * s : 0;
        typeof c == "function" && c.call(Bt.dragged.parentNode[Ta], N, P, e, Xm, Ir[this.layer].el) !== "continue" || SM(Ir[this.layer].el, N, P);
      }).bind({
        layer: f
      }), 24))), f++;
    } while (t.bubbleScroll && d !== l && (d = Ll(d, !1)));
    RS = u;
  }
}, 30), OM = function(t) {
  var n = t.originalEvent, r = t.putSortable, a = t.dragEl, o = t.activeSortable, i = t.dispatchSortableEvent, s = t.hideGhostForTarget, l = t.unhideGhostForTarget;
  if (n) {
    var u = r || o;
    s();
    var c = n.changedTouches && n.changedTouches.length ? n.changedTouches[0] : n, f = document.elementFromPoint(c.clientX, c.clientY);
    l(), u && !u.el.contains(f) && (i("spill"), this.onSpill({
      dragEl: a,
      putSortable: r
    }));
  }
};
function M4() {
}
M4.prototype = {
  startIndex: null,
  dragStart: function(t) {
    var n = t.oldDraggableIndex;
    this.startIndex = n;
  },
  onSpill: function(t) {
    var n = t.dragEl, r = t.putSortable;
    this.sortable.captureAnimationState(), r && r.captureAnimationState();
    var a = ad(this.sortable.el, this.startIndex, this.options);
    a ? this.sortable.el.insertBefore(n, a) : this.sortable.el.appendChild(n), this.sortable.animateAll(), r && r.animateAll();
  },
  drop: OM
};
di(M4, {
  pluginName: "revertOnSpill"
});
function R4() {
}
R4.prototype = {
  onSpill: function(t) {
    var n = t.dragEl, r = t.putSortable, a = r || this.sortable;
    a.captureAnimationState(), n.parentNode && n.parentNode.removeChild(n), a.animateAll();
  },
  drop: OM
};
di(R4, {
  pluginName: "removeOnSpill"
});
var Ko;
function Upe() {
  function e() {
    this.defaults = {
      swapClass: "sortable-swap-highlight"
    };
  }
  return e.prototype = {
    dragStart: function(n) {
      var r = n.dragEl;
      Ko = r;
    },
    dragOverValid: function(n) {
      var r = n.completed, a = n.target, o = n.onMove, i = n.activeSortable, s = n.changed, l = n.cancel;
      if (i.options.swap) {
        var u = this.sortable.el, c = this.options;
        if (a && a !== u) {
          var f = Ko;
          o(a) !== !1 ? (ar(a, c.swapClass, !0), Ko = a) : Ko = null, f && f !== Ko && ar(f, c.swapClass, !1);
        }
        s(), r(!0), l();
      }
    },
    drop: function(n) {
      var r = n.activeSortable, a = n.putSortable, o = n.dragEl, i = a || this.sortable, s = this.options;
      Ko && ar(Ko, s.swapClass, !1), Ko && (s.swap || a && a.options.swap) && o !== Ko && (i.captureAnimationState(), i !== r && r.captureAnimationState(), zpe(o, Ko), i.animateAll(), i !== r && r.animateAll());
    },
    nulling: function() {
      Ko = null;
    }
  }, di(e, {
    pluginName: "swap",
    eventProperties: function() {
      return {
        swapItem: Ko
      };
    }
  });
}
function zpe(e, t) {
  var n = e.parentNode, r = t.parentNode, a, o;
  !n || !r || n.isEqualNode(t) || r.isEqualNode(e) || (a = pr(e), o = pr(t), n.isEqualNode(r) && a < o && o++, n.insertBefore(t, n.children[a]), r.insertBefore(e, r.children[o]));
}
var Gt = [], _o = [], Wd, Si, Gd = !1, no = !1, Jc = !1, Un, Kd, sv;
function Wpe() {
  function e(t) {
    for (var n in this)
      n.charAt(0) === "_" && typeof this[n] == "function" && (this[n] = this[n].bind(this));
    t.options.supportPointer ? gn(document, "pointerup", this._deselectMultiDrag) : (gn(document, "mouseup", this._deselectMultiDrag), gn(document, "touchend", this._deselectMultiDrag)), gn(document, "keydown", this._checkKeyDown), gn(document, "keyup", this._checkKeyUp), this.defaults = {
      selectedClass: "sortable-selected",
      multiDragKey: null,
      setData: function(a, o) {
        var i = "";
        Gt.length && Si === t ? Gt.forEach(function(s, l) {
          i += (l ? ", " : "") + s.textContent;
        }) : i = o.textContent, a.setData("Text", i);
      }
    };
  }
  return e.prototype = {
    multiDragKeyDown: !1,
    isMultiDrag: !1,
    delayStartGlobal: function(n) {
      var r = n.dragEl;
      Un = r;
    },
    delayEnded: function() {
      this.isMultiDrag = ~Gt.indexOf(Un);
    },
    setupClone: function(n) {
      var r = n.sortable, a = n.cancel;
      if (this.isMultiDrag) {
        for (var o = 0; o < Gt.length; o++)
          _o.push(k4(Gt[o])), _o[o].sortableIndex = Gt[o].sortableIndex, _o[o].draggable = !1, _o[o].style["will-change"] = "", ar(_o[o], this.options.selectedClass, !1), Gt[o] === Un && ar(_o[o], this.options.chosenClass, !1);
        r._hideClone(), a();
      }
    },
    clone: function(n) {
      var r = n.sortable, a = n.rootEl, o = n.dispatchSortableEvent, i = n.cancel;
      this.isMultiDrag && (this.options.removeCloneOnHide || Gt.length && Si === r && (P6(!0, a), o("clone"), i()));
    },
    showClone: function(n) {
      var r = n.cloneNowShown, a = n.rootEl, o = n.cancel;
      this.isMultiDrag && (P6(!1, a), _o.forEach(function(i) {
        $t(i, "display", "");
      }), r(), sv = !1, o());
    },
    hideClone: function(n) {
      var r = this;
      n.sortable;
      var a = n.cloneNowHidden, o = n.cancel;
      this.isMultiDrag && (_o.forEach(function(i) {
        $t(i, "display", "none"), r.options.removeCloneOnHide && i.parentNode && i.parentNode.removeChild(i);
      }), a(), sv = !0, o());
    },
    dragStartGlobal: function(n) {
      n.sortable, !this.isMultiDrag && Si && Si.multiDrag._deselectMultiDrag(), Gt.forEach(function(r) {
        r.sortableIndex = pr(r);
      }), Gt = Gt.sort(function(r, a) {
        return r.sortableIndex - a.sortableIndex;
      }), Jc = !0;
    },
    dragStarted: function(n) {
      var r = this, a = n.sortable;
      if (this.isMultiDrag) {
        if (this.options.sort && (a.captureAnimationState(), this.options.animation)) {
          Gt.forEach(function(i) {
            i !== Un && $t(i, "position", "absolute");
          });
          var o = Jn(Un, !1, !0, !0);
          Gt.forEach(function(i) {
            i !== Un && T6(i, o);
          }), no = !0, Gd = !0;
        }
        a.animateAll(function() {
          no = !1, Gd = !1, r.options.animation && Gt.forEach(function(i) {
            yx(i);
          }), r.options.sort && lv();
        });
      }
    },
    dragOver: function(n) {
      var r = n.target, a = n.completed, o = n.cancel;
      no && ~Gt.indexOf(r) && (a(!1), o());
    },
    revert: function(n) {
      var r = n.fromSortable, a = n.rootEl, o = n.sortable, i = n.dragRect;
      Gt.length > 1 && (Gt.forEach(function(s) {
        o.addAnimationState({
          target: s,
          rect: no ? Jn(s) : i
        }), yx(s), s.fromRect = i, r.removeAnimationState(s);
      }), no = !1, Gpe(!this.options.removeCloneOnHide, a));
    },
    dragOverCompleted: function(n) {
      var r = n.sortable, a = n.isOwner, o = n.insertion, i = n.activeSortable, s = n.parentEl, l = n.putSortable, u = this.options;
      if (o) {
        if (a && i._hideClone(), Gd = !1, u.animation && Gt.length > 1 && (no || !a && !i.options.sort && !l)) {
          var c = Jn(Un, !1, !0, !0);
          Gt.forEach(function(d) {
            d !== Un && (T6(d, c), s.appendChild(d));
          }), no = !0;
        }
        if (!a)
          if (no || lv(), Gt.length > 1) {
            var f = sv;
            i._showClone(r), i.options.animation && !sv && f && _o.forEach(function(d) {
              i.addAnimationState({
                target: d,
                rect: Kd
              }), d.fromRect = Kd, d.thisAnimationDuration = null;
            });
          } else
            i._showClone(r);
      }
    },
    dragOverAnimationCapture: function(n) {
      var r = n.dragRect, a = n.isOwner, o = n.activeSortable;
      if (Gt.forEach(function(s) {
        s.thisAnimationDuration = null;
      }), o.options.animation && !a && o.multiDrag.isMultiDrag) {
        Kd = di({}, r);
        var i = Ju(Un, !0);
        Kd.top -= i.f, Kd.left -= i.e;
      }
    },
    dragOverAnimationComplete: function() {
      no && (no = !1, lv());
    },
    drop: function(n) {
      var r = n.originalEvent, a = n.rootEl, o = n.parentEl, i = n.sortable, s = n.dispatchSortableEvent, l = n.oldIndex, u = n.putSortable, c = u || this.sortable;
      if (r) {
        var f = this.options, d = o.children;
        if (!Jc)
          if (f.multiDragKey && !this.multiDragKeyDown && this._deselectMultiDrag(), ar(Un, f.selectedClass, !~Gt.indexOf(Un)), ~Gt.indexOf(Un))
            Gt.splice(Gt.indexOf(Un), 1), Wd = null, r0({
              sortable: i,
              rootEl: a,
              name: "deselect",
              targetEl: Un,
              originalEvt: r
            });
          else {
            if (Gt.push(Un), r0({
              sortable: i,
              rootEl: a,
              name: "select",
              targetEl: Un,
              originalEvt: r
            }), r.shiftKey && Wd && i.el.contains(Wd)) {
              var p = pr(Wd), v = pr(Un);
              if (~p && ~v && p !== v) {
                var h, m;
                for (v > p ? (m = p, h = v) : (m = v, h = p + 1); m < h; m++)
                  ~Gt.indexOf(d[m]) || (ar(d[m], f.selectedClass, !0), Gt.push(d[m]), r0({
                    sortable: i,
                    rootEl: a,
                    name: "select",
                    targetEl: d[m],
                    originalEvt: r
                  }));
              }
            } else
              Wd = Un;
            Si = c;
          }
        if (Jc && this.isMultiDrag) {
          if (no = !1, (o[Ta].options.sort || o !== a) && Gt.length > 1) {
            var y = Jn(Un), x = pr(Un, ":not(." + this.options.selectedClass + ")");
            if (!Gd && f.animation && (Un.thisAnimationDuration = null), c.captureAnimationState(), !Gd && (f.animation && (Un.fromRect = y, Gt.forEach(function(S) {
              if (S.thisAnimationDuration = null, S !== Un) {
                var w = no ? Jn(S) : y;
                S.fromRect = w, c.addAnimationState({
                  target: S,
                  rect: w
                });
              }
            })), lv(), Gt.forEach(function(S) {
              d[x] ? o.insertBefore(S, d[x]) : o.appendChild(S), x++;
            }), l === pr(Un))) {
              var g = !1;
              Gt.forEach(function(S) {
                if (S.sortableIndex !== pr(S)) {
                  g = !0;
                  return;
                }
              }), g && s("update");
            }
            Gt.forEach(function(S) {
              yx(S);
            }), c.animateAll();
          }
          Si = c;
        }
        (a === o || u && u.lastPutMode !== "clone") && _o.forEach(function(S) {
          S.parentNode && S.parentNode.removeChild(S);
        });
      }
    },
    nullingGlobal: function() {
      this.isMultiDrag = Jc = !1, _o.length = 0;
    },
    destroyGlobal: function() {
      this._deselectMultiDrag(), un(document, "pointerup", this._deselectMultiDrag), un(document, "mouseup", this._deselectMultiDrag), un(document, "touchend", this._deselectMultiDrag), un(document, "keydown", this._checkKeyDown), un(document, "keyup", this._checkKeyUp);
    },
    _deselectMultiDrag: function(n) {
      if (!(typeof Jc < "u" && Jc) && Si === this.sortable && !(n && Ii(n.target, this.options.draggable, this.sortable.el, !1)) && !(n && n.button !== 0))
        for (; Gt.length; ) {
          var r = Gt[0];
          ar(r, this.options.selectedClass, !1), Gt.shift(), r0({
            sortable: this.sortable,
            rootEl: this.sortable.el,
            name: "deselect",
            targetEl: r,
            originalEvt: n
          });
        }
    },
    _checkKeyDown: function(n) {
      n.key === this.options.multiDragKey && (this.multiDragKeyDown = !0);
    },
    _checkKeyUp: function(n) {
      n.key === this.options.multiDragKey && (this.multiDragKeyDown = !1);
    }
  }, di(e, {
    // Static methods & properties
    pluginName: "multiDrag",
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function(n) {
        var r = n.parentNode[Ta];
        !r || !r.options.multiDrag || ~Gt.indexOf(n) || (Si && Si !== r && (Si.multiDrag._deselectMultiDrag(), Si = r), ar(n, r.options.selectedClass, !0), Gt.push(n));
      },
      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function(n) {
        var r = n.parentNode[Ta], a = Gt.indexOf(n);
        !r || !r.options.multiDrag || !~a || (ar(n, r.options.selectedClass, !1), Gt.splice(a, 1));
      }
    },
    eventProperties: function() {
      var n = this, r = [], a = [];
      return Gt.forEach(function(o) {
        r.push({
          multiDragElement: o,
          index: o.sortableIndex
        });
        var i;
        no && o !== Un ? i = -1 : no ? i = pr(o, ":not(." + n.options.selectedClass + ")") : i = pr(o), a.push({
          multiDragElement: o,
          index: i
        });
      }), {
        items: vpe(Gt),
        clones: [].concat(_o),
        oldIndicies: r,
        newIndicies: a
      };
    },
    optionListeners: {
      multiDragKey: function(n) {
        return n = n.toLowerCase(), n === "ctrl" ? n = "Control" : n.length > 1 && (n = n.charAt(0).toUpperCase() + n.substr(1)), n;
      }
    }
  });
}
function Gpe(e, t) {
  Gt.forEach(function(n, r) {
    var a = t.children[n.sortableIndex + (e ? Number(r) : 0)];
    a ? t.insertBefore(n, a) : t.appendChild(n);
  });
}
function P6(e, t) {
  _o.forEach(function(n, r) {
    var a = t.children[n.sortableIndex + (e ? Number(r) : 0)];
    a ? t.insertBefore(n, a) : t.appendChild(n);
  });
}
function lv() {
  Gt.forEach(function(e) {
    e !== Un && e.parentNode && e.parentNode.removeChild(e);
  });
}
Bt.mount(new Vpe());
Bt.mount(R4, M4);
const Kpe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MultiDrag: Wpe,
  Sortable: Bt,
  Swap: Upe,
  default: Bt
}, Symbol.toStringTag, { value: "Module" })), Ype = /* @__PURE__ */ Z8(Kpe);
(function(e, t) {
  (function(r, a) {
    e.exports = a(fpe, Ype);
  })(typeof self < "u" ? self : ra, function(n, r) {
    return (
      /******/
      function(a) {
        var o = {};
        function i(s) {
          if (o[s])
            return o[s].exports;
          var l = o[s] = {
            /******/
            i: s,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return a[s].call(l.exports, l, l.exports, i), l.l = !0, l.exports;
        }
        return i.m = a, i.c = o, i.d = function(s, l, u) {
          i.o(s, l) || Object.defineProperty(s, l, { enumerable: !0, get: u });
        }, i.r = function(s) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
        }, i.t = function(s, l) {
          if (l & 1 && (s = i(s)), l & 8 || l & 4 && typeof s == "object" && s && s.__esModule) return s;
          var u = /* @__PURE__ */ Object.create(null);
          if (i.r(u), Object.defineProperty(u, "default", { enumerable: !0, value: s }), l & 2 && typeof s != "string") for (var c in s) i.d(u, c, (function(f) {
            return s[f];
          }).bind(null, c));
          return u;
        }, i.n = function(s) {
          var l = s && s.__esModule ? (
            /******/
            function() {
              return s.default;
            }
          ) : (
            /******/
            function() {
              return s;
            }
          );
          return i.d(l, "a", l), l;
        }, i.o = function(s, l) {
          return Object.prototype.hasOwnProperty.call(s, l);
        }, i.p = "", i(i.s = "fb15");
      }({
        /***/
        "00ee": (
          /***/
          function(a, o, i) {
            var s = i("b622"), l = s("toStringTag"), u = {};
            u[l] = "z", a.exports = String(u) === "[object z]";
          }
        ),
        /***/
        "0366": (
          /***/
          function(a, o, i) {
            var s = i("1c0b");
            a.exports = function(l, u, c) {
              if (s(l), u === void 0) return l;
              switch (c) {
                case 0:
                  return function() {
                    return l.call(u);
                  };
                case 1:
                  return function(f) {
                    return l.call(u, f);
                  };
                case 2:
                  return function(f, d) {
                    return l.call(u, f, d);
                  };
                case 3:
                  return function(f, d, p) {
                    return l.call(u, f, d, p);
                  };
              }
              return function() {
                return l.apply(u, arguments);
              };
            };
          }
        ),
        /***/
        "057f": (
          /***/
          function(a, o, i) {
            var s = i("fc6a"), l = i("241c").f, u = {}.toString, c = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], f = function(d) {
              try {
                return l(d);
              } catch {
                return c.slice();
              }
            };
            a.exports.f = function(p) {
              return c && u.call(p) == "[object Window]" ? f(p) : l(s(p));
            };
          }
        ),
        /***/
        "06cf": (
          /***/
          function(a, o, i) {
            var s = i("83ab"), l = i("d1e7"), u = i("5c6c"), c = i("fc6a"), f = i("c04e"), d = i("5135"), p = i("0cfb"), v = Object.getOwnPropertyDescriptor;
            o.f = s ? v : function(m, y) {
              if (m = c(m), y = f(y, !0), p) try {
                return v(m, y);
              } catch {
              }
              if (d(m, y)) return u(!l.f.call(m, y), m[y]);
            };
          }
        ),
        /***/
        "0cfb": (
          /***/
          function(a, o, i) {
            var s = i("83ab"), l = i("d039"), u = i("cc12");
            a.exports = !s && !l(function() {
              return Object.defineProperty(u("div"), "a", {
                get: function() {
                  return 7;
                }
              }).a != 7;
            });
          }
        ),
        /***/
        "13d5": (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("d58f").left, u = i("a640"), c = i("ae40"), f = u("reduce"), d = c("reduce", { 1: 0 });
            s({ target: "Array", proto: !0, forced: !f || !d }, {
              reduce: function(v) {
                return l(this, v, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
              }
            });
          }
        ),
        /***/
        "14c3": (
          /***/
          function(a, o, i) {
            var s = i("c6b6"), l = i("9263");
            a.exports = function(u, c) {
              var f = u.exec;
              if (typeof f == "function") {
                var d = f.call(u, c);
                if (typeof d != "object")
                  throw TypeError("RegExp exec method returned something other than an Object or null");
                return d;
              }
              if (s(u) !== "RegExp")
                throw TypeError("RegExp#exec called on incompatible receiver");
              return l.call(u, c);
            };
          }
        ),
        /***/
        "159b": (
          /***/
          function(a, o, i) {
            var s = i("da84"), l = i("fdbc"), u = i("17c2"), c = i("9112");
            for (var f in l) {
              var d = s[f], p = d && d.prototype;
              if (p && p.forEach !== u) try {
                c(p, "forEach", u);
              } catch {
                p.forEach = u;
              }
            }
          }
        ),
        /***/
        "17c2": (
          /***/
          function(a, o, i) {
            var s = i("b727").forEach, l = i("a640"), u = i("ae40"), c = l("forEach"), f = u("forEach");
            a.exports = !c || !f ? function(p) {
              return s(this, p, arguments.length > 1 ? arguments[1] : void 0);
            } : [].forEach;
          }
        ),
        /***/
        "1be4": (
          /***/
          function(a, o, i) {
            var s = i("d066");
            a.exports = s("document", "documentElement");
          }
        ),
        /***/
        "1c0b": (
          /***/
          function(a, o) {
            a.exports = function(i) {
              if (typeof i != "function")
                throw TypeError(String(i) + " is not a function");
              return i;
            };
          }
        ),
        /***/
        "1c7e": (
          /***/
          function(a, o, i) {
            var s = i("b622"), l = s("iterator"), u = !1;
            try {
              var c = 0, f = {
                next: function() {
                  return { done: !!c++ };
                },
                return: function() {
                  u = !0;
                }
              };
              f[l] = function() {
                return this;
              }, Array.from(f, function() {
                throw 2;
              });
            } catch {
            }
            a.exports = function(d, p) {
              if (!p && !u) return !1;
              var v = !1;
              try {
                var h = {};
                h[l] = function() {
                  return {
                    next: function() {
                      return { done: v = !0 };
                    }
                  };
                }, d(h);
              } catch {
              }
              return v;
            };
          }
        ),
        /***/
        "1d80": (
          /***/
          function(a, o) {
            a.exports = function(i) {
              if (i == null) throw TypeError("Can't call method on " + i);
              return i;
            };
          }
        ),
        /***/
        "1dde": (
          /***/
          function(a, o, i) {
            var s = i("d039"), l = i("b622"), u = i("2d00"), c = l("species");
            a.exports = function(f) {
              return u >= 51 || !s(function() {
                var d = [], p = d.constructor = {};
                return p[c] = function() {
                  return { foo: 1 };
                }, d[f](Boolean).foo !== 1;
              });
            };
          }
        ),
        /***/
        "23cb": (
          /***/
          function(a, o, i) {
            var s = i("a691"), l = Math.max, u = Math.min;
            a.exports = function(c, f) {
              var d = s(c);
              return d < 0 ? l(d + f, 0) : u(d, f);
            };
          }
        ),
        /***/
        "23e7": (
          /***/
          function(a, o, i) {
            var s = i("da84"), l = i("06cf").f, u = i("9112"), c = i("6eeb"), f = i("ce4e"), d = i("e893"), p = i("94ca");
            a.exports = function(v, h) {
              var m = v.target, y = v.global, x = v.stat, g, S, w, _, b, E;
              if (y ? S = s : x ? S = s[m] || f(m, {}) : S = (s[m] || {}).prototype, S) for (w in h) {
                if (b = h[w], v.noTargetGet ? (E = l(S, w), _ = E && E.value) : _ = S[w], g = p(y ? w : m + (x ? "." : "#") + w, v.forced), !g && _ !== void 0) {
                  if (typeof b == typeof _) continue;
                  d(b, _);
                }
                (v.sham || _ && _.sham) && u(b, "sham", !0), c(S, w, b, v);
              }
            };
          }
        ),
        /***/
        "241c": (
          /***/
          function(a, o, i) {
            var s = i("ca84"), l = i("7839"), u = l.concat("length", "prototype");
            o.f = Object.getOwnPropertyNames || function(f) {
              return s(f, u);
            };
          }
        ),
        /***/
        "25f0": (
          /***/
          function(a, o, i) {
            var s = i("6eeb"), l = i("825a"), u = i("d039"), c = i("ad6d"), f = "toString", d = RegExp.prototype, p = d[f], v = u(function() {
              return p.call({ source: "a", flags: "b" }) != "/a/b";
            }), h = p.name != f;
            (v || h) && s(RegExp.prototype, f, function() {
              var y = l(this), x = String(y.source), g = y.flags, S = String(g === void 0 && y instanceof RegExp && !("flags" in d) ? c.call(y) : g);
              return "/" + x + "/" + S;
            }, { unsafe: !0 });
          }
        ),
        /***/
        "2ca0": (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("06cf").f, u = i("50c4"), c = i("5a34"), f = i("1d80"), d = i("ab13"), p = i("c430"), v = "".startsWith, h = Math.min, m = d("startsWith"), y = !p && !m && !!function() {
              var x = l(String.prototype, "startsWith");
              return x && !x.writable;
            }();
            s({ target: "String", proto: !0, forced: !y && !m }, {
              startsWith: function(g) {
                var S = String(f(this));
                c(g);
                var w = u(h(arguments.length > 1 ? arguments[1] : void 0, S.length)), _ = String(g);
                return v ? v.call(S, _, w) : S.slice(w, w + _.length) === _;
              }
            });
          }
        ),
        /***/
        "2d00": (
          /***/
          function(a, o, i) {
            var s = i("da84"), l = i("342f"), u = s.process, c = u && u.versions, f = c && c.v8, d, p;
            f ? (d = f.split("."), p = d[0] + d[1]) : l && (d = l.match(/Edge\/(\d+)/), (!d || d[1] >= 74) && (d = l.match(/Chrome\/(\d+)/), d && (p = d[1]))), a.exports = p && +p;
          }
        ),
        /***/
        "342f": (
          /***/
          function(a, o, i) {
            var s = i("d066");
            a.exports = s("navigator", "userAgent") || "";
          }
        ),
        /***/
        "35a1": (
          /***/
          function(a, o, i) {
            var s = i("f5df"), l = i("3f8c"), u = i("b622"), c = u("iterator");
            a.exports = function(f) {
              if (f != null) return f[c] || f["@@iterator"] || l[s(f)];
            };
          }
        ),
        /***/
        "37e8": (
          /***/
          function(a, o, i) {
            var s = i("83ab"), l = i("9bf2"), u = i("825a"), c = i("df75");
            a.exports = s ? Object.defineProperties : function(d, p) {
              u(d);
              for (var v = c(p), h = v.length, m = 0, y; h > m; ) l.f(d, y = v[m++], p[y]);
              return d;
            };
          }
        ),
        /***/
        "3bbe": (
          /***/
          function(a, o, i) {
            var s = i("861d");
            a.exports = function(l) {
              if (!s(l) && l !== null)
                throw TypeError("Can't set " + String(l) + " as a prototype");
              return l;
            };
          }
        ),
        /***/
        "3ca3": (
          /***/
          function(a, o, i) {
            var s = i("6547").charAt, l = i("69f3"), u = i("7dd0"), c = "String Iterator", f = l.set, d = l.getterFor(c);
            u(String, "String", function(p) {
              f(this, {
                type: c,
                string: String(p),
                index: 0
              });
            }, function() {
              var v = d(this), h = v.string, m = v.index, y;
              return m >= h.length ? { value: void 0, done: !0 } : (y = s(h, m), v.index += y.length, { value: y, done: !1 });
            });
          }
        ),
        /***/
        "3f8c": (
          /***/
          function(a, o) {
            a.exports = {};
          }
        ),
        /***/
        4160: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("17c2");
            s({ target: "Array", proto: !0, forced: [].forEach != l }, {
              forEach: l
            });
          }
        ),
        /***/
        "428f": (
          /***/
          function(a, o, i) {
            var s = i("da84");
            a.exports = s;
          }
        ),
        /***/
        "44ad": (
          /***/
          function(a, o, i) {
            var s = i("d039"), l = i("c6b6"), u = "".split;
            a.exports = s(function() {
              return !Object("z").propertyIsEnumerable(0);
            }) ? function(c) {
              return l(c) == "String" ? u.call(c, "") : Object(c);
            } : Object;
          }
        ),
        /***/
        "44d2": (
          /***/
          function(a, o, i) {
            var s = i("b622"), l = i("7c73"), u = i("9bf2"), c = s("unscopables"), f = Array.prototype;
            f[c] == null && u.f(f, c, {
              configurable: !0,
              value: l(null)
            }), a.exports = function(d) {
              f[c][d] = !0;
            };
          }
        ),
        /***/
        "44e7": (
          /***/
          function(a, o, i) {
            var s = i("861d"), l = i("c6b6"), u = i("b622"), c = u("match");
            a.exports = function(f) {
              var d;
              return s(f) && ((d = f[c]) !== void 0 ? !!d : l(f) == "RegExp");
            };
          }
        ),
        /***/
        4930: (
          /***/
          function(a, o, i) {
            var s = i("d039");
            a.exports = !!Object.getOwnPropertySymbols && !s(function() {
              return !String(Symbol());
            });
          }
        ),
        /***/
        "4d64": (
          /***/
          function(a, o, i) {
            var s = i("fc6a"), l = i("50c4"), u = i("23cb"), c = function(f) {
              return function(d, p, v) {
                var h = s(d), m = l(h.length), y = u(v, m), x;
                if (f && p != p) {
                  for (; m > y; )
                    if (x = h[y++], x != x) return !0;
                } else for (; m > y; y++)
                  if ((f || y in h) && h[y] === p) return f || y || 0;
                return !f && -1;
              };
            };
            a.exports = {
              // `Array.prototype.includes` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.includes
              includes: c(!0),
              // `Array.prototype.indexOf` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
              indexOf: c(!1)
            };
          }
        ),
        /***/
        "4de4": (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("b727").filter, u = i("1dde"), c = i("ae40"), f = u("filter"), d = c("filter");
            s({ target: "Array", proto: !0, forced: !f || !d }, {
              filter: function(v) {
                return l(this, v, arguments.length > 1 ? arguments[1] : void 0);
              }
            });
          }
        ),
        /***/
        "4df4": (
          /***/
          function(a, o, i) {
            var s = i("0366"), l = i("7b0b"), u = i("9bdd"), c = i("e95a"), f = i("50c4"), d = i("8418"), p = i("35a1");
            a.exports = function(h) {
              var m = l(h), y = typeof this == "function" ? this : Array, x = arguments.length, g = x > 1 ? arguments[1] : void 0, S = g !== void 0, w = p(m), _ = 0, b, E, C, T, O, I;
              if (S && (g = s(g, x > 2 ? arguments[2] : void 0, 2)), w != null && !(y == Array && c(w)))
                for (T = w.call(m), O = T.next, E = new y(); !(C = O.call(T)).done; _++)
                  I = S ? u(T, g, [C.value, _], !0) : C.value, d(E, _, I);
              else
                for (b = f(m.length), E = new y(b); b > _; _++)
                  I = S ? g(m[_], _) : m[_], d(E, _, I);
              return E.length = _, E;
            };
          }
        ),
        /***/
        "4fad": (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("6f53").entries;
            s({ target: "Object", stat: !0 }, {
              entries: function(c) {
                return l(c);
              }
            });
          }
        ),
        /***/
        "50c4": (
          /***/
          function(a, o, i) {
            var s = i("a691"), l = Math.min;
            a.exports = function(u) {
              return u > 0 ? l(s(u), 9007199254740991) : 0;
            };
          }
        ),
        /***/
        5135: (
          /***/
          function(a, o) {
            var i = {}.hasOwnProperty;
            a.exports = function(s, l) {
              return i.call(s, l);
            };
          }
        ),
        /***/
        5319: (
          /***/
          function(a, o, i) {
            var s = i("d784"), l = i("825a"), u = i("7b0b"), c = i("50c4"), f = i("a691"), d = i("1d80"), p = i("8aa5"), v = i("14c3"), h = Math.max, m = Math.min, y = Math.floor, x = /\$([$&'`]|\d\d?|<[^>]*>)/g, g = /\$([$&'`]|\d\d?)/g, S = function(w) {
              return w === void 0 ? w : String(w);
            };
            s("replace", 2, function(w, _, b, E) {
              var C = E.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE, T = E.REPLACE_KEEPS_$0, O = C ? "$" : "$0";
              return [
                // `String.prototype.replace` method
                // https://tc39.github.io/ecma262/#sec-string.prototype.replace
                function(B, P) {
                  var N = d(this), M = B == null ? void 0 : B[w];
                  return M !== void 0 ? M.call(B, N, P) : _.call(String(N), B, P);
                },
                // `RegExp.prototype[@@replace]` method
                // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
                function(k, B) {
                  if (!C && T || typeof B == "string" && B.indexOf(O) === -1) {
                    var P = b(_, k, this, B);
                    if (P.done) return P.value;
                  }
                  var N = l(k), M = String(this), H = typeof B == "function";
                  H || (B = String(B));
                  var R = N.global;
                  if (R) {
                    var z = N.unicode;
                    N.lastIndex = 0;
                  }
                  for (var W = []; ; ) {
                    var F = v(N, M);
                    if (F === null || (W.push(F), !R)) break;
                    var Y = String(F[0]);
                    Y === "" && (N.lastIndex = p(M, c(N.lastIndex), z));
                  }
                  for (var X = "", q = 0, Q = 0; Q < W.length; Q++) {
                    F = W[Q];
                    for (var ue = String(F[0]), le = h(m(f(F.index), M.length), 0), te = [], G = 1; G < F.length; G++) te.push(S(F[G]));
                    var oe = F.groups;
                    if (H) {
                      var L = [ue].concat(te, le, M);
                      oe !== void 0 && L.push(oe);
                      var re = String(B.apply(void 0, L));
                    } else
                      re = I(ue, M, le, te, oe, B);
                    le >= q && (X += M.slice(q, le) + re, q = le + ue.length);
                  }
                  return X + M.slice(q);
                }
              ];
              function I(k, B, P, N, M, H) {
                var R = P + k.length, z = N.length, W = g;
                return M !== void 0 && (M = u(M), W = x), _.call(H, W, function(F, Y) {
                  var X;
                  switch (Y.charAt(0)) {
                    case "$":
                      return "$";
                    case "&":
                      return k;
                    case "`":
                      return B.slice(0, P);
                    case "'":
                      return B.slice(R);
                    case "<":
                      X = M[Y.slice(1, -1)];
                      break;
                    default:
                      var q = +Y;
                      if (q === 0) return F;
                      if (q > z) {
                        var Q = y(q / 10);
                        return Q === 0 ? F : Q <= z ? N[Q - 1] === void 0 ? Y.charAt(1) : N[Q - 1] + Y.charAt(1) : F;
                      }
                      X = N[q - 1];
                  }
                  return X === void 0 ? "" : X;
                });
              }
            });
          }
        ),
        /***/
        5692: (
          /***/
          function(a, o, i) {
            var s = i("c430"), l = i("c6cd");
            (a.exports = function(u, c) {
              return l[u] || (l[u] = c !== void 0 ? c : {});
            })("versions", []).push({
              version: "3.6.5",
              mode: s ? "pure" : "global",
              copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
            });
          }
        ),
        /***/
        "56ef": (
          /***/
          function(a, o, i) {
            var s = i("d066"), l = i("241c"), u = i("7418"), c = i("825a");
            a.exports = s("Reflect", "ownKeys") || function(d) {
              var p = l.f(c(d)), v = u.f;
              return v ? p.concat(v(d)) : p;
            };
          }
        ),
        /***/
        "5a34": (
          /***/
          function(a, o, i) {
            var s = i("44e7");
            a.exports = function(l) {
              if (s(l))
                throw TypeError("The method doesn't accept regular expressions");
              return l;
            };
          }
        ),
        /***/
        "5c6c": (
          /***/
          function(a, o) {
            a.exports = function(i, s) {
              return {
                enumerable: !(i & 1),
                configurable: !(i & 2),
                writable: !(i & 4),
                value: s
              };
            };
          }
        ),
        /***/
        "5db7": (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("a2bf"), u = i("7b0b"), c = i("50c4"), f = i("1c0b"), d = i("65f0");
            s({ target: "Array", proto: !0 }, {
              flatMap: function(v) {
                var h = u(this), m = c(h.length), y;
                return f(v), y = d(h, 0), y.length = l(y, h, h, m, 0, 1, v, arguments.length > 1 ? arguments[1] : void 0), y;
              }
            });
          }
        ),
        /***/
        6547: (
          /***/
          function(a, o, i) {
            var s = i("a691"), l = i("1d80"), u = function(c) {
              return function(f, d) {
                var p = String(l(f)), v = s(d), h = p.length, m, y;
                return v < 0 || v >= h ? c ? "" : void 0 : (m = p.charCodeAt(v), m < 55296 || m > 56319 || v + 1 === h || (y = p.charCodeAt(v + 1)) < 56320 || y > 57343 ? c ? p.charAt(v) : m : c ? p.slice(v, v + 2) : (m - 55296 << 10) + (y - 56320) + 65536);
              };
            };
            a.exports = {
              // `String.prototype.codePointAt` method
              // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
              codeAt: u(!1),
              // `String.prototype.at` method
              // https://github.com/mathiasbynens/String.prototype.at
              charAt: u(!0)
            };
          }
        ),
        /***/
        "65f0": (
          /***/
          function(a, o, i) {
            var s = i("861d"), l = i("e8b5"), u = i("b622"), c = u("species");
            a.exports = function(f, d) {
              var p;
              return l(f) && (p = f.constructor, typeof p == "function" && (p === Array || l(p.prototype)) ? p = void 0 : s(p) && (p = p[c], p === null && (p = void 0))), new (p === void 0 ? Array : p)(d === 0 ? 0 : d);
            };
          }
        ),
        /***/
        "69f3": (
          /***/
          function(a, o, i) {
            var s = i("7f9a"), l = i("da84"), u = i("861d"), c = i("9112"), f = i("5135"), d = i("f772"), p = i("d012"), v = l.WeakMap, h, m, y, x = function(C) {
              return y(C) ? m(C) : h(C, {});
            }, g = function(C) {
              return function(T) {
                var O;
                if (!u(T) || (O = m(T)).type !== C)
                  throw TypeError("Incompatible receiver, " + C + " required");
                return O;
              };
            };
            if (s) {
              var S = new v(), w = S.get, _ = S.has, b = S.set;
              h = function(C, T) {
                return b.call(S, C, T), T;
              }, m = function(C) {
                return w.call(S, C) || {};
              }, y = function(C) {
                return _.call(S, C);
              };
            } else {
              var E = d("state");
              p[E] = !0, h = function(C, T) {
                return c(C, E, T), T;
              }, m = function(C) {
                return f(C, E) ? C[E] : {};
              }, y = function(C) {
                return f(C, E);
              };
            }
            a.exports = {
              set: h,
              get: m,
              has: y,
              enforce: x,
              getterFor: g
            };
          }
        ),
        /***/
        "6eeb": (
          /***/
          function(a, o, i) {
            var s = i("da84"), l = i("9112"), u = i("5135"), c = i("ce4e"), f = i("8925"), d = i("69f3"), p = d.get, v = d.enforce, h = String(String).split("String");
            (a.exports = function(m, y, x, g) {
              var S = g ? !!g.unsafe : !1, w = g ? !!g.enumerable : !1, _ = g ? !!g.noTargetGet : !1;
              if (typeof x == "function" && (typeof y == "string" && !u(x, "name") && l(x, "name", y), v(x).source = h.join(typeof y == "string" ? y : "")), m === s) {
                w ? m[y] = x : c(y, x);
                return;
              } else S ? !_ && m[y] && (w = !0) : delete m[y];
              w ? m[y] = x : l(m, y, x);
            })(Function.prototype, "toString", function() {
              return typeof this == "function" && p(this).source || f(this);
            });
          }
        ),
        /***/
        "6f53": (
          /***/
          function(a, o, i) {
            var s = i("83ab"), l = i("df75"), u = i("fc6a"), c = i("d1e7").f, f = function(d) {
              return function(p) {
                for (var v = u(p), h = l(v), m = h.length, y = 0, x = [], g; m > y; )
                  g = h[y++], (!s || c.call(v, g)) && x.push(d ? [g, v[g]] : v[g]);
                return x;
              };
            };
            a.exports = {
              // `Object.entries` method
              // https://tc39.github.io/ecma262/#sec-object.entries
              entries: f(!0),
              // `Object.values` method
              // https://tc39.github.io/ecma262/#sec-object.values
              values: f(!1)
            };
          }
        ),
        /***/
        "73d9": (
          /***/
          function(a, o, i) {
            var s = i("44d2");
            s("flatMap");
          }
        ),
        /***/
        7418: (
          /***/
          function(a, o) {
            o.f = Object.getOwnPropertySymbols;
          }
        ),
        /***/
        "746f": (
          /***/
          function(a, o, i) {
            var s = i("428f"), l = i("5135"), u = i("e538"), c = i("9bf2").f;
            a.exports = function(f) {
              var d = s.Symbol || (s.Symbol = {});
              l(d, f) || c(d, f, {
                value: u.f(f)
              });
            };
          }
        ),
        /***/
        7839: (
          /***/
          function(a, o) {
            a.exports = [
              "constructor",
              "hasOwnProperty",
              "isPrototypeOf",
              "propertyIsEnumerable",
              "toLocaleString",
              "toString",
              "valueOf"
            ];
          }
        ),
        /***/
        "7b0b": (
          /***/
          function(a, o, i) {
            var s = i("1d80");
            a.exports = function(l) {
              return Object(s(l));
            };
          }
        ),
        /***/
        "7c73": (
          /***/
          function(a, o, i) {
            var s = i("825a"), l = i("37e8"), u = i("7839"), c = i("d012"), f = i("1be4"), d = i("cc12"), p = i("f772"), v = ">", h = "<", m = "prototype", y = "script", x = p("IE_PROTO"), g = function() {
            }, S = function(C) {
              return h + y + v + C + h + "/" + y + v;
            }, w = function(C) {
              C.write(S("")), C.close();
              var T = C.parentWindow.Object;
              return C = null, T;
            }, _ = function() {
              var C = d("iframe"), T = "java" + y + ":", O;
              return C.style.display = "none", f.appendChild(C), C.src = String(T), O = C.contentWindow.document, O.open(), O.write(S("document.F=Object")), O.close(), O.F;
            }, b, E = function() {
              try {
                b = document.domain && new ActiveXObject("htmlfile");
              } catch {
              }
              E = b ? w(b) : _();
              for (var C = u.length; C--; ) delete E[m][u[C]];
              return E();
            };
            c[x] = !0, a.exports = Object.create || function(T, O) {
              var I;
              return T !== null ? (g[m] = s(T), I = new g(), g[m] = null, I[x] = T) : I = E(), O === void 0 ? I : l(I, O);
            };
          }
        ),
        /***/
        "7dd0": (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("9ed3"), u = i("e163"), c = i("d2bb"), f = i("d44e"), d = i("9112"), p = i("6eeb"), v = i("b622"), h = i("c430"), m = i("3f8c"), y = i("ae93"), x = y.IteratorPrototype, g = y.BUGGY_SAFARI_ITERATORS, S = v("iterator"), w = "keys", _ = "values", b = "entries", E = function() {
              return this;
            };
            a.exports = function(C, T, O, I, k, B, P) {
              l(O, T, I);
              var N = function(Q) {
                if (Q === k && W) return W;
                if (!g && Q in R) return R[Q];
                switch (Q) {
                  case w:
                    return function() {
                      return new O(this, Q);
                    };
                  case _:
                    return function() {
                      return new O(this, Q);
                    };
                  case b:
                    return function() {
                      return new O(this, Q);
                    };
                }
                return function() {
                  return new O(this);
                };
              }, M = T + " Iterator", H = !1, R = C.prototype, z = R[S] || R["@@iterator"] || k && R[k], W = !g && z || N(k), F = T == "Array" && R.entries || z, Y, X, q;
              if (F && (Y = u(F.call(new C())), x !== Object.prototype && Y.next && (!h && u(Y) !== x && (c ? c(Y, x) : typeof Y[S] != "function" && d(Y, S, E)), f(Y, M, !0, !0), h && (m[M] = E))), k == _ && z && z.name !== _ && (H = !0, W = function() {
                return z.call(this);
              }), (!h || P) && R[S] !== W && d(R, S, W), m[T] = W, k)
                if (X = {
                  values: N(_),
                  keys: B ? W : N(w),
                  entries: N(b)
                }, P) for (q in X)
                  (g || H || !(q in R)) && p(R, q, X[q]);
                else s({ target: T, proto: !0, forced: g || H }, X);
              return X;
            };
          }
        ),
        /***/
        "7f9a": (
          /***/
          function(a, o, i) {
            var s = i("da84"), l = i("8925"), u = s.WeakMap;
            a.exports = typeof u == "function" && /native code/.test(l(u));
          }
        ),
        /***/
        "825a": (
          /***/
          function(a, o, i) {
            var s = i("861d");
            a.exports = function(l) {
              if (!s(l))
                throw TypeError(String(l) + " is not an object");
              return l;
            };
          }
        ),
        /***/
        "83ab": (
          /***/
          function(a, o, i) {
            var s = i("d039");
            a.exports = !s(function() {
              return Object.defineProperty({}, 1, { get: function() {
                return 7;
              } })[1] != 7;
            });
          }
        ),
        /***/
        8418: (
          /***/
          function(a, o, i) {
            var s = i("c04e"), l = i("9bf2"), u = i("5c6c");
            a.exports = function(c, f, d) {
              var p = s(f);
              p in c ? l.f(c, p, u(0, d)) : c[p] = d;
            };
          }
        ),
        /***/
        "861d": (
          /***/
          function(a, o) {
            a.exports = function(i) {
              return typeof i == "object" ? i !== null : typeof i == "function";
            };
          }
        ),
        /***/
        8875: (
          /***/
          function(a, o, i) {
            var s, l, u;
            (function(c, f) {
              l = [], s = f, u = typeof s == "function" ? s.apply(o, l) : s, u !== void 0 && (a.exports = u);
            })(typeof self < "u" ? self : this, function() {
              function c() {
                var f = Object.getOwnPropertyDescriptor(document, "currentScript");
                if (!f && "currentScript" in document && document.currentScript || f && f.get !== c && document.currentScript)
                  return document.currentScript;
                try {
                  throw new Error();
                } catch (b) {
                  var d = /.*at [^(]*\((.*):(.+):(.+)\)$/ig, p = /@([^@]*):(\d+):(\d+)\s*$/ig, v = d.exec(b.stack) || p.exec(b.stack), h = v && v[1] || !1, m = v && v[2] || !1, y = document.location.href.replace(document.location.hash, ""), x, g, S, w = document.getElementsByTagName("script");
                  h === y && (x = document.documentElement.outerHTML, g = new RegExp("(?:[^\\n]+?\\n){0," + (m - 2) + "}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*", "i"), S = x.replace(g, "$1").trim());
                  for (var _ = 0; _ < w.length; _++)
                    if (w[_].readyState === "interactive" || w[_].src === h || h === y && w[_].innerHTML && w[_].innerHTML.trim() === S)
                      return w[_];
                  return null;
                }
              }
              return c;
            });
          }
        ),
        /***/
        8925: (
          /***/
          function(a, o, i) {
            var s = i("c6cd"), l = Function.toString;
            typeof s.inspectSource != "function" && (s.inspectSource = function(u) {
              return l.call(u);
            }), a.exports = s.inspectSource;
          }
        ),
        /***/
        "8aa5": (
          /***/
          function(a, o, i) {
            var s = i("6547").charAt;
            a.exports = function(l, u, c) {
              return u + (c ? s(l, u).length : 1);
            };
          }
        ),
        /***/
        "8bbf": (
          /***/
          function(a, o) {
            a.exports = n;
          }
        ),
        /***/
        "90e3": (
          /***/
          function(a, o) {
            var i = 0, s = Math.random();
            a.exports = function(l) {
              return "Symbol(" + String(l === void 0 ? "" : l) + ")_" + (++i + s).toString(36);
            };
          }
        ),
        /***/
        9112: (
          /***/
          function(a, o, i) {
            var s = i("83ab"), l = i("9bf2"), u = i("5c6c");
            a.exports = s ? function(c, f, d) {
              return l.f(c, f, u(1, d));
            } : function(c, f, d) {
              return c[f] = d, c;
            };
          }
        ),
        /***/
        9263: (
          /***/
          function(a, o, i) {
            var s = i("ad6d"), l = i("9f7f"), u = RegExp.prototype.exec, c = String.prototype.replace, f = u, d = function() {
              var m = /a/, y = /b*/g;
              return u.call(m, "a"), u.call(y, "a"), m.lastIndex !== 0 || y.lastIndex !== 0;
            }(), p = l.UNSUPPORTED_Y || l.BROKEN_CARET, v = /()??/.exec("")[1] !== void 0, h = d || v || p;
            h && (f = function(y) {
              var x = this, g, S, w, _, b = p && x.sticky, E = s.call(x), C = x.source, T = 0, O = y;
              return b && (E = E.replace("y", ""), E.indexOf("g") === -1 && (E += "g"), O = String(y).slice(x.lastIndex), x.lastIndex > 0 && (!x.multiline || x.multiline && y[x.lastIndex - 1] !== `
`) && (C = "(?: " + C + ")", O = " " + O, T++), S = new RegExp("^(?:" + C + ")", E)), v && (S = new RegExp("^" + C + "$(?!\\s)", E)), d && (g = x.lastIndex), w = u.call(b ? S : x, O), b ? w ? (w.input = w.input.slice(T), w[0] = w[0].slice(T), w.index = x.lastIndex, x.lastIndex += w[0].length) : x.lastIndex = 0 : d && w && (x.lastIndex = x.global ? w.index + w[0].length : g), v && w && w.length > 1 && c.call(w[0], S, function() {
                for (_ = 1; _ < arguments.length - 2; _++)
                  arguments[_] === void 0 && (w[_] = void 0);
              }), w;
            }), a.exports = f;
          }
        ),
        /***/
        "94ca": (
          /***/
          function(a, o, i) {
            var s = i("d039"), l = /#|\.prototype\./, u = function(v, h) {
              var m = f[c(v)];
              return m == p ? !0 : m == d ? !1 : typeof h == "function" ? s(h) : !!h;
            }, c = u.normalize = function(v) {
              return String(v).replace(l, ".").toLowerCase();
            }, f = u.data = {}, d = u.NATIVE = "N", p = u.POLYFILL = "P";
            a.exports = u;
          }
        ),
        /***/
        "99af": (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("d039"), u = i("e8b5"), c = i("861d"), f = i("7b0b"), d = i("50c4"), p = i("8418"), v = i("65f0"), h = i("1dde"), m = i("b622"), y = i("2d00"), x = m("isConcatSpreadable"), g = 9007199254740991, S = "Maximum allowed index exceeded", w = y >= 51 || !l(function() {
              var C = [];
              return C[x] = !1, C.concat()[0] !== C;
            }), _ = h("concat"), b = function(C) {
              if (!c(C)) return !1;
              var T = C[x];
              return T !== void 0 ? !!T : u(C);
            }, E = !w || !_;
            s({ target: "Array", proto: !0, forced: E }, {
              concat: function(T) {
                var O = f(this), I = v(O, 0), k = 0, B, P, N, M, H;
                for (B = -1, N = arguments.length; B < N; B++)
                  if (H = B === -1 ? O : arguments[B], b(H)) {
                    if (M = d(H.length), k + M > g) throw TypeError(S);
                    for (P = 0; P < M; P++, k++) P in H && p(I, k, H[P]);
                  } else {
                    if (k >= g) throw TypeError(S);
                    p(I, k++, H);
                  }
                return I.length = k, I;
              }
            });
          }
        ),
        /***/
        "9bdd": (
          /***/
          function(a, o, i) {
            var s = i("825a");
            a.exports = function(l, u, c, f) {
              try {
                return f ? u(s(c)[0], c[1]) : u(c);
              } catch (p) {
                var d = l.return;
                throw d !== void 0 && s(d.call(l)), p;
              }
            };
          }
        ),
        /***/
        "9bf2": (
          /***/
          function(a, o, i) {
            var s = i("83ab"), l = i("0cfb"), u = i("825a"), c = i("c04e"), f = Object.defineProperty;
            o.f = s ? f : function(p, v, h) {
              if (u(p), v = c(v, !0), u(h), l) try {
                return f(p, v, h);
              } catch {
              }
              if ("get" in h || "set" in h) throw TypeError("Accessors not supported");
              return "value" in h && (p[v] = h.value), p;
            };
          }
        ),
        /***/
        "9ed3": (
          /***/
          function(a, o, i) {
            var s = i("ae93").IteratorPrototype, l = i("7c73"), u = i("5c6c"), c = i("d44e"), f = i("3f8c"), d = function() {
              return this;
            };
            a.exports = function(p, v, h) {
              var m = v + " Iterator";
              return p.prototype = l(s, { next: u(1, h) }), c(p, m, !1, !0), f[m] = d, p;
            };
          }
        ),
        /***/
        "9f7f": (
          /***/
          function(a, o, i) {
            var s = i("d039");
            function l(u, c) {
              return RegExp(u, c);
            }
            o.UNSUPPORTED_Y = s(function() {
              var u = l("a", "y");
              return u.lastIndex = 2, u.exec("abcd") != null;
            }), o.BROKEN_CARET = s(function() {
              var u = l("^r", "gy");
              return u.lastIndex = 2, u.exec("str") != null;
            });
          }
        ),
        /***/
        a2bf: (
          /***/
          function(a, o, i) {
            var s = i("e8b5"), l = i("50c4"), u = i("0366"), c = function(f, d, p, v, h, m, y, x) {
              for (var g = h, S = 0, w = y ? u(y, x, 3) : !1, _; S < v; ) {
                if (S in p) {
                  if (_ = w ? w(p[S], S, d) : p[S], m > 0 && s(_))
                    g = c(f, d, _, l(_.length), g, m - 1) - 1;
                  else {
                    if (g >= 9007199254740991) throw TypeError("Exceed the acceptable array length");
                    f[g] = _;
                  }
                  g++;
                }
                S++;
              }
              return g;
            };
            a.exports = c;
          }
        ),
        /***/
        a352: (
          /***/
          function(a, o) {
            a.exports = r;
          }
        ),
        /***/
        a434: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("23cb"), u = i("a691"), c = i("50c4"), f = i("7b0b"), d = i("65f0"), p = i("8418"), v = i("1dde"), h = i("ae40"), m = v("splice"), y = h("splice", { ACCESSORS: !0, 0: 0, 1: 2 }), x = Math.max, g = Math.min, S = 9007199254740991, w = "Maximum allowed length exceeded";
            s({ target: "Array", proto: !0, forced: !m || !y }, {
              splice: function(b, E) {
                var C = f(this), T = c(C.length), O = l(b, T), I = arguments.length, k, B, P, N, M, H;
                if (I === 0 ? k = B = 0 : I === 1 ? (k = 0, B = T - O) : (k = I - 2, B = g(x(u(E), 0), T - O)), T + k - B > S)
                  throw TypeError(w);
                for (P = d(C, B), N = 0; N < B; N++)
                  M = O + N, M in C && p(P, N, C[M]);
                if (P.length = B, k < B) {
                  for (N = O; N < T - B; N++)
                    M = N + B, H = N + k, M in C ? C[H] = C[M] : delete C[H];
                  for (N = T; N > T - B + k; N--) delete C[N - 1];
                } else if (k > B)
                  for (N = T - B; N > O; N--)
                    M = N + B - 1, H = N + k - 1, M in C ? C[H] = C[M] : delete C[H];
                for (N = 0; N < k; N++)
                  C[N + O] = arguments[N + 2];
                return C.length = T - B + k, P;
              }
            });
          }
        ),
        /***/
        a4d3: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("da84"), u = i("d066"), c = i("c430"), f = i("83ab"), d = i("4930"), p = i("fdbf"), v = i("d039"), h = i("5135"), m = i("e8b5"), y = i("861d"), x = i("825a"), g = i("7b0b"), S = i("fc6a"), w = i("c04e"), _ = i("5c6c"), b = i("7c73"), E = i("df75"), C = i("241c"), T = i("057f"), O = i("7418"), I = i("06cf"), k = i("9bf2"), B = i("d1e7"), P = i("9112"), N = i("6eeb"), M = i("5692"), H = i("f772"), R = i("d012"), z = i("90e3"), W = i("b622"), F = i("e538"), Y = i("746f"), X = i("d44e"), q = i("69f3"), Q = i("b727").forEach, ue = H("hidden"), le = "Symbol", te = "prototype", G = W("toPrimitive"), oe = q.set, L = q.getterFor(le), re = Object[te], j = l.Symbol, J = u("JSON", "stringify"), ae = I.f, he = k.f, K = T.f, Z = B.f, se = M("symbols"), me = M("op-symbols"), xe = M("string-to-symbol-registry"), be = M("symbol-to-string-registry"), Te = M("wks"), Ie = l.QObject, Ve = !Ie || !Ie[te] || !Ie[te].findChild, tt = f && v(function() {
              return b(he({}, "a", {
                get: function() {
                  return he(this, "a", { value: 7 }).a;
                }
              })).a != 7;
            }) ? function(yt, gt, ct) {
              var Ht = ae(re, gt);
              Ht && delete re[gt], he(yt, gt, ct), Ht && yt !== re && he(re, gt, Ht);
            } : he, it = function(yt, gt) {
              var ct = se[yt] = b(j[te]);
              return oe(ct, {
                type: le,
                tag: yt,
                description: gt
              }), f || (ct.description = gt), ct;
            }, Se = p ? function(yt) {
              return typeof yt == "symbol";
            } : function(yt) {
              return Object(yt) instanceof j;
            }, ge = function(gt, ct, Ht) {
              gt === re && ge(me, ct, Ht), x(gt);
              var Ut = w(ct, !0);
              return x(Ht), h(se, Ut) ? (Ht.enumerable ? (h(gt, ue) && gt[ue][Ut] && (gt[ue][Ut] = !1), Ht = b(Ht, { enumerable: _(0, !1) })) : (h(gt, ue) || he(gt, ue, _(1, {})), gt[ue][Ut] = !0), tt(gt, Ut, Ht)) : he(gt, Ut, Ht);
            }, pe = function(gt, ct) {
              x(gt);
              var Ht = S(ct), Ut = E(Ht).concat(xt(Ht));
              return Q(Ut, function(In) {
                (!f || Ue.call(Ht, In)) && ge(gt, In, Ht[In]);
              }), gt;
            }, De = function(gt, ct) {
              return ct === void 0 ? b(gt) : pe(b(gt), ct);
            }, Ue = function(gt) {
              var ct = w(gt, !0), Ht = Z.call(this, ct);
              return this === re && h(se, ct) && !h(me, ct) ? !1 : Ht || !h(this, ct) || !h(se, ct) || h(this, ue) && this[ue][ct] ? Ht : !0;
            }, Xe = function(gt, ct) {
              var Ht = S(gt), Ut = w(ct, !0);
              if (!(Ht === re && h(se, Ut) && !h(me, Ut))) {
                var In = ae(Ht, Ut);
                return In && h(se, Ut) && !(h(Ht, ue) && Ht[ue][Ut]) && (In.enumerable = !0), In;
              }
            }, ut = function(gt) {
              var ct = K(S(gt)), Ht = [];
              return Q(ct, function(Ut) {
                !h(se, Ut) && !h(R, Ut) && Ht.push(Ut);
              }), Ht;
            }, xt = function(gt) {
              var ct = gt === re, Ht = K(ct ? me : S(gt)), Ut = [];
              return Q(Ht, function(In) {
                h(se, In) && (!ct || h(re, In)) && Ut.push(se[In]);
              }), Ut;
            };
            if (d || (j = function() {
              if (this instanceof j) throw TypeError("Symbol is not a constructor");
              var gt = !arguments.length || arguments[0] === void 0 ? void 0 : String(arguments[0]), ct = z(gt), Ht = function(Ut) {
                this === re && Ht.call(me, Ut), h(this, ue) && h(this[ue], ct) && (this[ue][ct] = !1), tt(this, ct, _(1, Ut));
              };
              return f && Ve && tt(re, ct, { configurable: !0, set: Ht }), it(ct, gt);
            }, N(j[te], "toString", function() {
              return L(this).tag;
            }), N(j, "withoutSetter", function(yt) {
              return it(z(yt), yt);
            }), B.f = Ue, k.f = ge, I.f = Xe, C.f = T.f = ut, O.f = xt, F.f = function(yt) {
              return it(W(yt), yt);
            }, f && (he(j[te], "description", {
              configurable: !0,
              get: function() {
                return L(this).description;
              }
            }), c || N(re, "propertyIsEnumerable", Ue, { unsafe: !0 }))), s({ global: !0, wrap: !0, forced: !d, sham: !d }, {
              Symbol: j
            }), Q(E(Te), function(yt) {
              Y(yt);
            }), s({ target: le, stat: !0, forced: !d }, {
              // `Symbol.for` method
              // https://tc39.github.io/ecma262/#sec-symbol.for
              for: function(yt) {
                var gt = String(yt);
                if (h(xe, gt)) return xe[gt];
                var ct = j(gt);
                return xe[gt] = ct, be[ct] = gt, ct;
              },
              // `Symbol.keyFor` method
              // https://tc39.github.io/ecma262/#sec-symbol.keyfor
              keyFor: function(gt) {
                if (!Se(gt)) throw TypeError(gt + " is not a symbol");
                if (h(be, gt)) return be[gt];
              },
              useSetter: function() {
                Ve = !0;
              },
              useSimple: function() {
                Ve = !1;
              }
            }), s({ target: "Object", stat: !0, forced: !d, sham: !f }, {
              // `Object.create` method
              // https://tc39.github.io/ecma262/#sec-object.create
              create: De,
              // `Object.defineProperty` method
              // https://tc39.github.io/ecma262/#sec-object.defineproperty
              defineProperty: ge,
              // `Object.defineProperties` method
              // https://tc39.github.io/ecma262/#sec-object.defineproperties
              defineProperties: pe,
              // `Object.getOwnPropertyDescriptor` method
              // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
              getOwnPropertyDescriptor: Xe
            }), s({ target: "Object", stat: !0, forced: !d }, {
              // `Object.getOwnPropertyNames` method
              // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
              getOwnPropertyNames: ut,
              // `Object.getOwnPropertySymbols` method
              // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
              getOwnPropertySymbols: xt
            }), s({ target: "Object", stat: !0, forced: v(function() {
              O.f(1);
            }) }, {
              getOwnPropertySymbols: function(gt) {
                return O.f(g(gt));
              }
            }), J) {
              var Mt = !d || v(function() {
                var yt = j();
                return J([yt]) != "[null]" || J({ a: yt }) != "{}" || J(Object(yt)) != "{}";
              });
              s({ target: "JSON", stat: !0, forced: Mt }, {
                // eslint-disable-next-line no-unused-vars
                stringify: function(gt, ct, Ht) {
                  for (var Ut = [gt], In = 1, wr; arguments.length > In; ) Ut.push(arguments[In++]);
                  if (wr = ct, !(!y(ct) && gt === void 0 || Se(gt)))
                    return m(ct) || (ct = function(eo, ur) {
                      if (typeof wr == "function" && (ur = wr.call(this, eo, ur)), !Se(ur)) return ur;
                    }), Ut[1] = ct, J.apply(null, Ut);
                }
              });
            }
            j[te][G] || P(j[te], G, j[te].valueOf), X(j, le), R[ue] = !0;
          }
        ),
        /***/
        a630: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("4df4"), u = i("1c7e"), c = !u(function(f) {
              Array.from(f);
            });
            s({ target: "Array", stat: !0, forced: c }, {
              from: l
            });
          }
        ),
        /***/
        a640: (
          /***/
          function(a, o, i) {
            var s = i("d039");
            a.exports = function(l, u) {
              var c = [][l];
              return !!c && s(function() {
                c.call(null, u || function() {
                  throw 1;
                }, 1);
              });
            };
          }
        ),
        /***/
        a691: (
          /***/
          function(a, o) {
            var i = Math.ceil, s = Math.floor;
            a.exports = function(l) {
              return isNaN(l = +l) ? 0 : (l > 0 ? s : i)(l);
            };
          }
        ),
        /***/
        ab13: (
          /***/
          function(a, o, i) {
            var s = i("b622"), l = s("match");
            a.exports = function(u) {
              var c = /./;
              try {
                "/./"[u](c);
              } catch {
                try {
                  return c[l] = !1, "/./"[u](c);
                } catch {
                }
              }
              return !1;
            };
          }
        ),
        /***/
        ac1f: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("9263");
            s({ target: "RegExp", proto: !0, forced: /./.exec !== l }, {
              exec: l
            });
          }
        ),
        /***/
        ad6d: (
          /***/
          function(a, o, i) {
            var s = i("825a");
            a.exports = function() {
              var l = s(this), u = "";
              return l.global && (u += "g"), l.ignoreCase && (u += "i"), l.multiline && (u += "m"), l.dotAll && (u += "s"), l.unicode && (u += "u"), l.sticky && (u += "y"), u;
            };
          }
        ),
        /***/
        ae40: (
          /***/
          function(a, o, i) {
            var s = i("83ab"), l = i("d039"), u = i("5135"), c = Object.defineProperty, f = {}, d = function(p) {
              throw p;
            };
            a.exports = function(p, v) {
              if (u(f, p)) return f[p];
              v || (v = {});
              var h = [][p], m = u(v, "ACCESSORS") ? v.ACCESSORS : !1, y = u(v, 0) ? v[0] : d, x = u(v, 1) ? v[1] : void 0;
              return f[p] = !!h && !l(function() {
                if (m && !s) return !0;
                var g = { length: -1 };
                m ? c(g, 1, { enumerable: !0, get: d }) : g[1] = 1, h.call(g, y, x);
              });
            };
          }
        ),
        /***/
        ae93: (
          /***/
          function(a, o, i) {
            var s = i("e163"), l = i("9112"), u = i("5135"), c = i("b622"), f = i("c430"), d = c("iterator"), p = !1, v = function() {
              return this;
            }, h, m, y;
            [].keys && (y = [].keys(), "next" in y ? (m = s(s(y)), m !== Object.prototype && (h = m)) : p = !0), h == null && (h = {}), !f && !u(h, d) && l(h, d, v), a.exports = {
              IteratorPrototype: h,
              BUGGY_SAFARI_ITERATORS: p
            };
          }
        ),
        /***/
        b041: (
          /***/
          function(a, o, i) {
            var s = i("00ee"), l = i("f5df");
            a.exports = s ? {}.toString : function() {
              return "[object " + l(this) + "]";
            };
          }
        ),
        /***/
        b0c0: (
          /***/
          function(a, o, i) {
            var s = i("83ab"), l = i("9bf2").f, u = Function.prototype, c = u.toString, f = /^\s*function ([^ (]*)/, d = "name";
            s && !(d in u) && l(u, d, {
              configurable: !0,
              get: function() {
                try {
                  return c.call(this).match(f)[1];
                } catch {
                  return "";
                }
              }
            });
          }
        ),
        /***/
        b622: (
          /***/
          function(a, o, i) {
            var s = i("da84"), l = i("5692"), u = i("5135"), c = i("90e3"), f = i("4930"), d = i("fdbf"), p = l("wks"), v = s.Symbol, h = d ? v : v && v.withoutSetter || c;
            a.exports = function(m) {
              return u(p, m) || (f && u(v, m) ? p[m] = v[m] : p[m] = h("Symbol." + m)), p[m];
            };
          }
        ),
        /***/
        b64b: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("7b0b"), u = i("df75"), c = i("d039"), f = c(function() {
              u(1);
            });
            s({ target: "Object", stat: !0, forced: f }, {
              keys: function(p) {
                return u(l(p));
              }
            });
          }
        ),
        /***/
        b727: (
          /***/
          function(a, o, i) {
            var s = i("0366"), l = i("44ad"), u = i("7b0b"), c = i("50c4"), f = i("65f0"), d = [].push, p = function(v) {
              var h = v == 1, m = v == 2, y = v == 3, x = v == 4, g = v == 6, S = v == 5 || g;
              return function(w, _, b, E) {
                for (var C = u(w), T = l(C), O = s(_, b, 3), I = c(T.length), k = 0, B = E || f, P = h ? B(w, I) : m ? B(w, 0) : void 0, N, M; I > k; k++) if ((S || k in T) && (N = T[k], M = O(N, k, C), v)) {
                  if (h) P[k] = M;
                  else if (M) switch (v) {
                    case 3:
                      return !0;
                    case 5:
                      return N;
                    case 6:
                      return k;
                    case 2:
                      d.call(P, N);
                  }
                  else if (x) return !1;
                }
                return g ? -1 : y || x ? x : P;
              };
            };
            a.exports = {
              // `Array.prototype.forEach` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
              forEach: p(0),
              // `Array.prototype.map` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.map
              map: p(1),
              // `Array.prototype.filter` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.filter
              filter: p(2),
              // `Array.prototype.some` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.some
              some: p(3),
              // `Array.prototype.every` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.every
              every: p(4),
              // `Array.prototype.find` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.find
              find: p(5),
              // `Array.prototype.findIndex` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
              findIndex: p(6)
            };
          }
        ),
        /***/
        c04e: (
          /***/
          function(a, o, i) {
            var s = i("861d");
            a.exports = function(l, u) {
              if (!s(l)) return l;
              var c, f;
              if (u && typeof (c = l.toString) == "function" && !s(f = c.call(l)) || typeof (c = l.valueOf) == "function" && !s(f = c.call(l)) || !u && typeof (c = l.toString) == "function" && !s(f = c.call(l))) return f;
              throw TypeError("Can't convert object to primitive value");
            };
          }
        ),
        /***/
        c430: (
          /***/
          function(a, o) {
            a.exports = !1;
          }
        ),
        /***/
        c6b6: (
          /***/
          function(a, o) {
            var i = {}.toString;
            a.exports = function(s) {
              return i.call(s).slice(8, -1);
            };
          }
        ),
        /***/
        c6cd: (
          /***/
          function(a, o, i) {
            var s = i("da84"), l = i("ce4e"), u = "__core-js_shared__", c = s[u] || l(u, {});
            a.exports = c;
          }
        ),
        /***/
        c740: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("b727").findIndex, u = i("44d2"), c = i("ae40"), f = "findIndex", d = !0, p = c(f);
            f in [] && Array(1)[f](function() {
              d = !1;
            }), s({ target: "Array", proto: !0, forced: d || !p }, {
              findIndex: function(h) {
                return l(this, h, arguments.length > 1 ? arguments[1] : void 0);
              }
            }), u(f);
          }
        ),
        /***/
        c8ba: (
          /***/
          function(a, o) {
            var i;
            i = /* @__PURE__ */ function() {
              return this;
            }();
            try {
              i = i || new Function("return this")();
            } catch {
              typeof window == "object" && (i = window);
            }
            a.exports = i;
          }
        ),
        /***/
        c975: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("4d64").indexOf, u = i("a640"), c = i("ae40"), f = [].indexOf, d = !!f && 1 / [1].indexOf(1, -0) < 0, p = u("indexOf"), v = c("indexOf", { ACCESSORS: !0, 1: 0 });
            s({ target: "Array", proto: !0, forced: d || !p || !v }, {
              indexOf: function(m) {
                return d ? f.apply(this, arguments) || 0 : l(this, m, arguments.length > 1 ? arguments[1] : void 0);
              }
            });
          }
        ),
        /***/
        ca84: (
          /***/
          function(a, o, i) {
            var s = i("5135"), l = i("fc6a"), u = i("4d64").indexOf, c = i("d012");
            a.exports = function(f, d) {
              var p = l(f), v = 0, h = [], m;
              for (m in p) !s(c, m) && s(p, m) && h.push(m);
              for (; d.length > v; ) s(p, m = d[v++]) && (~u(h, m) || h.push(m));
              return h;
            };
          }
        ),
        /***/
        caad: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("4d64").includes, u = i("44d2"), c = i("ae40"), f = c("indexOf", { ACCESSORS: !0, 1: 0 });
            s({ target: "Array", proto: !0, forced: !f }, {
              includes: function(p) {
                return l(this, p, arguments.length > 1 ? arguments[1] : void 0);
              }
            }), u("includes");
          }
        ),
        /***/
        cc12: (
          /***/
          function(a, o, i) {
            var s = i("da84"), l = i("861d"), u = s.document, c = l(u) && l(u.createElement);
            a.exports = function(f) {
              return c ? u.createElement(f) : {};
            };
          }
        ),
        /***/
        ce4e: (
          /***/
          function(a, o, i) {
            var s = i("da84"), l = i("9112");
            a.exports = function(u, c) {
              try {
                l(s, u, c);
              } catch {
                s[u] = c;
              }
              return c;
            };
          }
        ),
        /***/
        d012: (
          /***/
          function(a, o) {
            a.exports = {};
          }
        ),
        /***/
        d039: (
          /***/
          function(a, o) {
            a.exports = function(i) {
              try {
                return !!i();
              } catch {
                return !0;
              }
            };
          }
        ),
        /***/
        d066: (
          /***/
          function(a, o, i) {
            var s = i("428f"), l = i("da84"), u = function(c) {
              return typeof c == "function" ? c : void 0;
            };
            a.exports = function(c, f) {
              return arguments.length < 2 ? u(s[c]) || u(l[c]) : s[c] && s[c][f] || l[c] && l[c][f];
            };
          }
        ),
        /***/
        d1e7: (
          /***/
          function(a, o, i) {
            var s = {}.propertyIsEnumerable, l = Object.getOwnPropertyDescriptor, u = l && !s.call({ 1: 2 }, 1);
            o.f = u ? function(f) {
              var d = l(this, f);
              return !!d && d.enumerable;
            } : s;
          }
        ),
        /***/
        d28b: (
          /***/
          function(a, o, i) {
            var s = i("746f");
            s("iterator");
          }
        ),
        /***/
        d2bb: (
          /***/
          function(a, o, i) {
            var s = i("825a"), l = i("3bbe");
            a.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
              var u = !1, c = {}, f;
              try {
                f = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set, f.call(c, []), u = c instanceof Array;
              } catch {
              }
              return function(p, v) {
                return s(p), l(v), u ? f.call(p, v) : p.__proto__ = v, p;
              };
            }() : void 0);
          }
        ),
        /***/
        d3b7: (
          /***/
          function(a, o, i) {
            var s = i("00ee"), l = i("6eeb"), u = i("b041");
            s || l(Object.prototype, "toString", u, { unsafe: !0 });
          }
        ),
        /***/
        d44e: (
          /***/
          function(a, o, i) {
            var s = i("9bf2").f, l = i("5135"), u = i("b622"), c = u("toStringTag");
            a.exports = function(f, d, p) {
              f && !l(f = p ? f : f.prototype, c) && s(f, c, { configurable: !0, value: d });
            };
          }
        ),
        /***/
        d58f: (
          /***/
          function(a, o, i) {
            var s = i("1c0b"), l = i("7b0b"), u = i("44ad"), c = i("50c4"), f = function(d) {
              return function(p, v, h, m) {
                s(v);
                var y = l(p), x = u(y), g = c(y.length), S = d ? g - 1 : 0, w = d ? -1 : 1;
                if (h < 2) for (; ; ) {
                  if (S in x) {
                    m = x[S], S += w;
                    break;
                  }
                  if (S += w, d ? S < 0 : g <= S)
                    throw TypeError("Reduce of empty array with no initial value");
                }
                for (; d ? S >= 0 : g > S; S += w) S in x && (m = v(m, x[S], S, y));
                return m;
              };
            };
            a.exports = {
              // `Array.prototype.reduce` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
              left: f(!1),
              // `Array.prototype.reduceRight` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
              right: f(!0)
            };
          }
        ),
        /***/
        d784: (
          /***/
          function(a, o, i) {
            i("ac1f");
            var s = i("6eeb"), l = i("d039"), u = i("b622"), c = i("9263"), f = i("9112"), d = u("species"), p = !l(function() {
              var x = /./;
              return x.exec = function() {
                var g = [];
                return g.groups = { a: "7" }, g;
              }, "".replace(x, "$<a>") !== "7";
            }), v = function() {
              return "a".replace(/./, "$0") === "$0";
            }(), h = u("replace"), m = function() {
              return /./[h] ? /./[h]("a", "$0") === "" : !1;
            }(), y = !l(function() {
              var x = /(?:)/, g = x.exec;
              x.exec = function() {
                return g.apply(this, arguments);
              };
              var S = "ab".split(x);
              return S.length !== 2 || S[0] !== "a" || S[1] !== "b";
            });
            a.exports = function(x, g, S, w) {
              var _ = u(x), b = !l(function() {
                var k = {};
                return k[_] = function() {
                  return 7;
                }, ""[x](k) != 7;
              }), E = b && !l(function() {
                var k = !1, B = /a/;
                return x === "split" && (B = {}, B.constructor = {}, B.constructor[d] = function() {
                  return B;
                }, B.flags = "", B[_] = /./[_]), B.exec = function() {
                  return k = !0, null;
                }, B[_](""), !k;
              });
              if (!b || !E || x === "replace" && !(p && v && !m) || x === "split" && !y) {
                var C = /./[_], T = S(_, ""[x], function(k, B, P, N, M) {
                  return B.exec === c ? b && !M ? { done: !0, value: C.call(B, P, N) } : { done: !0, value: k.call(P, B, N) } : { done: !1 };
                }, {
                  REPLACE_KEEPS_$0: v,
                  REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: m
                }), O = T[0], I = T[1];
                s(String.prototype, x, O), s(
                  RegExp.prototype,
                  _,
                  g == 2 ? function(k, B) {
                    return I.call(k, this, B);
                  } : function(k) {
                    return I.call(k, this);
                  }
                );
              }
              w && f(RegExp.prototype[_], "sham", !0);
            };
          }
        ),
        /***/
        d81d: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("b727").map, u = i("1dde"), c = i("ae40"), f = u("map"), d = c("map");
            s({ target: "Array", proto: !0, forced: !f || !d }, {
              map: function(v) {
                return l(this, v, arguments.length > 1 ? arguments[1] : void 0);
              }
            });
          }
        ),
        /***/
        da84: (
          /***/
          function(a, o, i) {
            (function(s) {
              var l = function(u) {
                return u && u.Math == Math && u;
              };
              a.exports = // eslint-disable-next-line no-undef
              l(typeof globalThis == "object" && globalThis) || l(typeof window == "object" && window) || l(typeof self == "object" && self) || l(typeof s == "object" && s) || // eslint-disable-next-line no-new-func
              Function("return this")();
            }).call(this, i("c8ba"));
          }
        ),
        /***/
        dbb4: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("83ab"), u = i("56ef"), c = i("fc6a"), f = i("06cf"), d = i("8418");
            s({ target: "Object", stat: !0, sham: !l }, {
              getOwnPropertyDescriptors: function(v) {
                for (var h = c(v), m = f.f, y = u(h), x = {}, g = 0, S, w; y.length > g; )
                  w = m(h, S = y[g++]), w !== void 0 && d(x, S, w);
                return x;
              }
            });
          }
        ),
        /***/
        dbf1: (
          /***/
          function(a, o, i) {
            (function(s) {
              i.d(o, "a", function() {
                return u;
              });
              function l() {
                return typeof window < "u" ? window.console : s.console;
              }
              var u = l();
            }).call(this, i("c8ba"));
          }
        ),
        /***/
        ddb0: (
          /***/
          function(a, o, i) {
            var s = i("da84"), l = i("fdbc"), u = i("e260"), c = i("9112"), f = i("b622"), d = f("iterator"), p = f("toStringTag"), v = u.values;
            for (var h in l) {
              var m = s[h], y = m && m.prototype;
              if (y) {
                if (y[d] !== v) try {
                  c(y, d, v);
                } catch {
                  y[d] = v;
                }
                if (y[p] || c(y, p, h), l[h]) {
                  for (var x in u)
                    if (y[x] !== u[x]) try {
                      c(y, x, u[x]);
                    } catch {
                      y[x] = u[x];
                    }
                }
              }
            }
          }
        ),
        /***/
        df75: (
          /***/
          function(a, o, i) {
            var s = i("ca84"), l = i("7839");
            a.exports = Object.keys || function(c) {
              return s(c, l);
            };
          }
        ),
        /***/
        e01a: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("83ab"), u = i("da84"), c = i("5135"), f = i("861d"), d = i("9bf2").f, p = i("e893"), v = u.Symbol;
            if (l && typeof v == "function" && (!("description" in v.prototype) || // Safari 12 bug
            v().description !== void 0)) {
              var h = {}, m = function() {
                var _ = arguments.length < 1 || arguments[0] === void 0 ? void 0 : String(arguments[0]), b = this instanceof m ? new v(_) : _ === void 0 ? v() : v(_);
                return _ === "" && (h[b] = !0), b;
              };
              p(m, v);
              var y = m.prototype = v.prototype;
              y.constructor = m;
              var x = y.toString, g = String(v("test")) == "Symbol(test)", S = /^Symbol\((.*)\)[^)]+$/;
              d(y, "description", {
                configurable: !0,
                get: function() {
                  var _ = f(this) ? this.valueOf() : this, b = x.call(_);
                  if (c(h, _)) return "";
                  var E = g ? b.slice(7, -1) : b.replace(S, "$1");
                  return E === "" ? void 0 : E;
                }
              }), s({ global: !0, forced: !0 }, {
                Symbol: m
              });
            }
          }
        ),
        /***/
        e163: (
          /***/
          function(a, o, i) {
            var s = i("5135"), l = i("7b0b"), u = i("f772"), c = i("e177"), f = u("IE_PROTO"), d = Object.prototype;
            a.exports = c ? Object.getPrototypeOf : function(p) {
              return p = l(p), s(p, f) ? p[f] : typeof p.constructor == "function" && p instanceof p.constructor ? p.constructor.prototype : p instanceof Object ? d : null;
            };
          }
        ),
        /***/
        e177: (
          /***/
          function(a, o, i) {
            var s = i("d039");
            a.exports = !s(function() {
              function l() {
              }
              return l.prototype.constructor = null, Object.getPrototypeOf(new l()) !== l.prototype;
            });
          }
        ),
        /***/
        e260: (
          /***/
          function(a, o, i) {
            var s = i("fc6a"), l = i("44d2"), u = i("3f8c"), c = i("69f3"), f = i("7dd0"), d = "Array Iterator", p = c.set, v = c.getterFor(d);
            a.exports = f(Array, "Array", function(h, m) {
              p(this, {
                type: d,
                target: s(h),
                // target
                index: 0,
                // next index
                kind: m
                // kind
              });
            }, function() {
              var h = v(this), m = h.target, y = h.kind, x = h.index++;
              return !m || x >= m.length ? (h.target = void 0, { value: void 0, done: !0 }) : y == "keys" ? { value: x, done: !1 } : y == "values" ? { value: m[x], done: !1 } : { value: [x, m[x]], done: !1 };
            }, "values"), u.Arguments = u.Array, l("keys"), l("values"), l("entries");
          }
        ),
        /***/
        e439: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("d039"), u = i("fc6a"), c = i("06cf").f, f = i("83ab"), d = l(function() {
              c(1);
            }), p = !f || d;
            s({ target: "Object", stat: !0, forced: p, sham: !f }, {
              getOwnPropertyDescriptor: function(h, m) {
                return c(u(h), m);
              }
            });
          }
        ),
        /***/
        e538: (
          /***/
          function(a, o, i) {
            var s = i("b622");
            o.f = s;
          }
        ),
        /***/
        e893: (
          /***/
          function(a, o, i) {
            var s = i("5135"), l = i("56ef"), u = i("06cf"), c = i("9bf2");
            a.exports = function(f, d) {
              for (var p = l(d), v = c.f, h = u.f, m = 0; m < p.length; m++) {
                var y = p[m];
                s(f, y) || v(f, y, h(d, y));
              }
            };
          }
        ),
        /***/
        e8b5: (
          /***/
          function(a, o, i) {
            var s = i("c6b6");
            a.exports = Array.isArray || function(u) {
              return s(u) == "Array";
            };
          }
        ),
        /***/
        e95a: (
          /***/
          function(a, o, i) {
            var s = i("b622"), l = i("3f8c"), u = s("iterator"), c = Array.prototype;
            a.exports = function(f) {
              return f !== void 0 && (l.Array === f || c[u] === f);
            };
          }
        ),
        /***/
        f5df: (
          /***/
          function(a, o, i) {
            var s = i("00ee"), l = i("c6b6"), u = i("b622"), c = u("toStringTag"), f = l(/* @__PURE__ */ function() {
              return arguments;
            }()) == "Arguments", d = function(p, v) {
              try {
                return p[v];
              } catch {
              }
            };
            a.exports = s ? l : function(p) {
              var v, h, m;
              return p === void 0 ? "Undefined" : p === null ? "Null" : typeof (h = d(v = Object(p), c)) == "string" ? h : f ? l(v) : (m = l(v)) == "Object" && typeof v.callee == "function" ? "Arguments" : m;
            };
          }
        ),
        /***/
        f772: (
          /***/
          function(a, o, i) {
            var s = i("5692"), l = i("90e3"), u = s("keys");
            a.exports = function(c) {
              return u[c] || (u[c] = l(c));
            };
          }
        ),
        /***/
        fb15: (
          /***/
          function(a, o, i) {
            if (i.r(o), typeof window < "u") {
              var s = window.document.currentScript;
              {
                var l = i("8875");
                s = l(), "currentScript" in document || Object.defineProperty(document, "currentScript", { get: l });
              }
              var u = s && s.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);
              u && (i.p = u[1]);
            }
            i("99af"), i("4de4"), i("4160"), i("c975"), i("d81d"), i("a434"), i("159b"), i("a4d3"), i("e439"), i("dbb4"), i("b64b");
            function c(Se, ge, pe) {
              return ge in Se ? Object.defineProperty(Se, ge, {
                value: pe,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }) : Se[ge] = pe, Se;
            }
            function f(Se, ge) {
              var pe = Object.keys(Se);
              if (Object.getOwnPropertySymbols) {
                var De = Object.getOwnPropertySymbols(Se);
                ge && (De = De.filter(function(Ue) {
                  return Object.getOwnPropertyDescriptor(Se, Ue).enumerable;
                })), pe.push.apply(pe, De);
              }
              return pe;
            }
            function d(Se) {
              for (var ge = 1; ge < arguments.length; ge++) {
                var pe = arguments[ge] != null ? arguments[ge] : {};
                ge % 2 ? f(Object(pe), !0).forEach(function(De) {
                  c(Se, De, pe[De]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Se, Object.getOwnPropertyDescriptors(pe)) : f(Object(pe)).forEach(function(De) {
                  Object.defineProperty(Se, De, Object.getOwnPropertyDescriptor(pe, De));
                });
              }
              return Se;
            }
            function p(Se) {
              if (Array.isArray(Se)) return Se;
            }
            i("e01a"), i("d28b"), i("e260"), i("d3b7"), i("3ca3"), i("ddb0");
            function v(Se, ge) {
              if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(Se)))) {
                var pe = [], De = !0, Ue = !1, Xe = void 0;
                try {
                  for (var ut = Se[Symbol.iterator](), xt; !(De = (xt = ut.next()).done) && (pe.push(xt.value), !(ge && pe.length === ge)); De = !0)
                    ;
                } catch (Mt) {
                  Ue = !0, Xe = Mt;
                } finally {
                  try {
                    !De && ut.return != null && ut.return();
                  } finally {
                    if (Ue) throw Xe;
                  }
                }
                return pe;
              }
            }
            i("a630"), i("fb6a"), i("b0c0"), i("25f0");
            function h(Se, ge) {
              (ge == null || ge > Se.length) && (ge = Se.length);
              for (var pe = 0, De = new Array(ge); pe < ge; pe++)
                De[pe] = Se[pe];
              return De;
            }
            function m(Se, ge) {
              if (Se) {
                if (typeof Se == "string") return h(Se, ge);
                var pe = Object.prototype.toString.call(Se).slice(8, -1);
                if (pe === "Object" && Se.constructor && (pe = Se.constructor.name), pe === "Map" || pe === "Set") return Array.from(Se);
                if (pe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(pe)) return h(Se, ge);
              }
            }
            function y() {
              throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function x(Se, ge) {
              return p(Se) || v(Se, ge) || m(Se, ge) || y();
            }
            function g(Se) {
              if (Array.isArray(Se)) return h(Se);
            }
            function S(Se) {
              if (typeof Symbol < "u" && Symbol.iterator in Object(Se)) return Array.from(Se);
            }
            function w() {
              throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function _(Se) {
              return g(Se) || S(Se) || m(Se) || w();
            }
            var b = i("a352"), E = /* @__PURE__ */ i.n(b);
            function C(Se) {
              Se.parentElement !== null && Se.parentElement.removeChild(Se);
            }
            function T(Se, ge, pe) {
              var De = pe === 0 ? Se.children[0] : Se.children[pe - 1].nextSibling;
              Se.insertBefore(ge, De);
            }
            var O = i("dbf1");
            i("13d5"), i("4fad"), i("ac1f"), i("5319");
            function I(Se) {
              var ge = /* @__PURE__ */ Object.create(null);
              return function(De) {
                var Ue = ge[De];
                return Ue || (ge[De] = Se(De));
              };
            }
            var k = /-(\w)/g, B = I(function(Se) {
              return Se.replace(k, function(ge, pe) {
                return pe.toUpperCase();
              });
            });
            i("5db7"), i("73d9");
            var P = ["Start", "Add", "Remove", "Update", "End"], N = ["Choose", "Unchoose", "Sort", "Filter", "Clone"], M = ["Move"], H = [M, P, N].flatMap(function(Se) {
              return Se;
            }).map(function(Se) {
              return "on".concat(Se);
            }), R = {
              manage: M,
              manageAndEmit: P,
              emit: N
            };
            function z(Se) {
              return H.indexOf(Se) !== -1;
            }
            i("caad"), i("2ca0");
            var W = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "link", "main", "map", "mark", "math", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp", "script", "section", "select", "slot", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr"];
            function F(Se) {
              return W.includes(Se);
            }
            function Y(Se) {
              return ["transition-group", "TransitionGroup"].includes(Se);
            }
            function X(Se) {
              return ["id", "class", "role", "style"].includes(Se) || Se.startsWith("data-") || Se.startsWith("aria-") || Se.startsWith("on");
            }
            function q(Se) {
              return Se.reduce(function(ge, pe) {
                var De = x(pe, 2), Ue = De[0], Xe = De[1];
                return ge[Ue] = Xe, ge;
              }, {});
            }
            function Q(Se) {
              var ge = Se.$attrs, pe = Se.componentData, De = pe === void 0 ? {} : pe, Ue = q(Object.entries(ge).filter(function(Xe) {
                var ut = x(Xe, 2), xt = ut[0];
                return ut[1], X(xt);
              }));
              return d(d({}, Ue), De);
            }
            function ue(Se) {
              var ge = Se.$attrs, pe = Se.callBackBuilder, De = q(le(ge));
              Object.entries(pe).forEach(function(Xe) {
                var ut = x(Xe, 2), xt = ut[0], Mt = ut[1];
                R[xt].forEach(function(yt) {
                  De["on".concat(yt)] = Mt(yt);
                });
              });
              var Ue = "[data-draggable]".concat(De.draggable || "");
              return d(d({}, De), {}, {
                draggable: Ue
              });
            }
            function le(Se) {
              return Object.entries(Se).filter(function(ge) {
                var pe = x(ge, 2), De = pe[0];
                return pe[1], !X(De);
              }).map(function(ge) {
                var pe = x(ge, 2), De = pe[0], Ue = pe[1];
                return [B(De), Ue];
              }).filter(function(ge) {
                var pe = x(ge, 2), De = pe[0];
                return pe[1], !z(De);
              });
            }
            i("c740");
            function te(Se, ge) {
              if (!(Se instanceof ge))
                throw new TypeError("Cannot call a class as a function");
            }
            function G(Se, ge) {
              for (var pe = 0; pe < ge.length; pe++) {
                var De = ge[pe];
                De.enumerable = De.enumerable || !1, De.configurable = !0, "value" in De && (De.writable = !0), Object.defineProperty(Se, De.key, De);
              }
            }
            function oe(Se, ge, pe) {
              return ge && G(Se.prototype, ge), Se;
            }
            var L = function(ge) {
              var pe = ge.el;
              return pe;
            }, re = function(ge, pe) {
              return ge.__draggable_context = pe;
            }, j = function(ge) {
              return ge.__draggable_context;
            }, J = /* @__PURE__ */ function() {
              function Se(ge) {
                var pe = ge.nodes, De = pe.header, Ue = pe.default, Xe = pe.footer, ut = ge.root, xt = ge.realList;
                te(this, Se), this.defaultNodes = Ue, this.children = [].concat(_(De), _(Ue), _(Xe)), this.externalComponent = ut.externalComponent, this.rootTransition = ut.transition, this.tag = ut.tag, this.realList = xt;
              }
              return oe(Se, [{
                key: "render",
                value: function(pe, De) {
                  var Ue = this.tag, Xe = this.children, ut = this._isRootComponent, xt = ut ? {
                    default: function() {
                      return Xe;
                    }
                  } : Xe;
                  return pe(Ue, De, xt);
                }
              }, {
                key: "updated",
                value: function() {
                  var pe = this.defaultNodes, De = this.realList;
                  pe.forEach(function(Ue, Xe) {
                    re(L(Ue), {
                      element: De[Xe],
                      index: Xe
                    });
                  });
                }
              }, {
                key: "getUnderlyingVm",
                value: function(pe) {
                  return j(pe);
                }
              }, {
                key: "getVmIndexFromDomIndex",
                value: function(pe, De) {
                  var Ue = this.defaultNodes, Xe = Ue.length, ut = De.children, xt = ut.item(pe);
                  if (xt === null)
                    return Xe;
                  var Mt = j(xt);
                  if (Mt)
                    return Mt.index;
                  if (Xe === 0)
                    return 0;
                  var yt = L(Ue[0]), gt = _(ut).findIndex(function(ct) {
                    return ct === yt;
                  });
                  return pe < gt ? 0 : Xe;
                }
              }, {
                key: "_isRootComponent",
                get: function() {
                  return this.externalComponent || this.rootTransition;
                }
              }]), Se;
            }(), ae = i("8bbf");
            function he(Se, ge) {
              var pe = Se[ge];
              return pe ? pe() : [];
            }
            function K(Se) {
              var ge = Se.$slots, pe = Se.realList, De = Se.getKey, Ue = pe || [], Xe = ["header", "footer"].map(function(ct) {
                return he(ge, ct);
              }), ut = x(Xe, 2), xt = ut[0], Mt = ut[1], yt = ge.item;
              if (!yt)
                throw new Error("draggable element must have an item slot");
              var gt = Ue.flatMap(function(ct, Ht) {
                return yt({
                  element: ct,
                  index: Ht
                }).map(function(Ut) {
                  return Ut.key = De(ct), Ut.props = d(d({}, Ut.props || {}), {}, {
                    "data-draggable": !0
                  }), Ut;
                });
              });
              if (gt.length !== Ue.length)
                throw new Error("Item slot must have only one child");
              return {
                header: xt,
                footer: Mt,
                default: gt
              };
            }
            function Z(Se) {
              var ge = Y(Se), pe = !F(Se) && !ge;
              return {
                transition: ge,
                externalComponent: pe,
                tag: pe ? Object(ae.resolveComponent)(Se) : ge ? ae.TransitionGroup : Se
              };
            }
            function se(Se) {
              var ge = Se.$slots, pe = Se.tag, De = Se.realList, Ue = Se.getKey, Xe = K({
                $slots: ge,
                realList: De,
                getKey: Ue
              }), ut = Z(pe);
              return new J({
                nodes: Xe,
                root: ut,
                realList: De
              });
            }
            function me(Se, ge) {
              var pe = this;
              Object(ae.nextTick)(function() {
                return pe.$emit(Se.toLowerCase(), ge);
              });
            }
            function xe(Se) {
              var ge = this;
              return function(pe, De) {
                if (ge.realList !== null)
                  return ge["onDrag".concat(Se)](pe, De);
              };
            }
            function be(Se) {
              var ge = this, pe = xe.call(this, Se);
              return function(De, Ue) {
                pe.call(ge, De, Ue), me.call(ge, Se, De);
              };
            }
            var Te = null, Ie = {
              list: {
                type: Array,
                required: !1,
                default: null
              },
              modelValue: {
                type: Array,
                required: !1,
                default: null
              },
              itemKey: {
                type: [String, Function],
                required: !0
              },
              clone: {
                type: Function,
                default: function(ge) {
                  return ge;
                }
              },
              tag: {
                type: String,
                default: "div"
              },
              move: {
                type: Function,
                default: null
              },
              componentData: {
                type: Object,
                required: !1,
                default: null
              }
            }, Ve = ["update:modelValue", "change"].concat(_([].concat(_(R.manageAndEmit), _(R.emit)).map(function(Se) {
              return Se.toLowerCase();
            }))), tt = Object(ae.defineComponent)({
              name: "draggable",
              inheritAttrs: !1,
              props: Ie,
              emits: Ve,
              data: function() {
                return {
                  error: !1
                };
              },
              render: function() {
                try {
                  this.error = !1;
                  var ge = this.$slots, pe = this.$attrs, De = this.tag, Ue = this.componentData, Xe = this.realList, ut = this.getKey, xt = se({
                    $slots: ge,
                    tag: De,
                    realList: Xe,
                    getKey: ut
                  });
                  this.componentStructure = xt;
                  var Mt = Q({
                    $attrs: pe,
                    componentData: Ue
                  });
                  return xt.render(ae.h, Mt);
                } catch (yt) {
                  return this.error = !0, Object(ae.h)("pre", {
                    style: {
                      color: "red"
                    }
                  }, yt.stack);
                }
              },
              created: function() {
                this.list !== null && this.modelValue !== null && O.a.error("modelValue and list props are mutually exclusive! Please set one or another.");
              },
              mounted: function() {
                var ge = this;
                if (!this.error) {
                  var pe = this.$attrs, De = this.$el, Ue = this.componentStructure;
                  Ue.updated();
                  var Xe = ue({
                    $attrs: pe,
                    callBackBuilder: {
                      manageAndEmit: function(Mt) {
                        return be.call(ge, Mt);
                      },
                      emit: function(Mt) {
                        return me.bind(ge, Mt);
                      },
                      manage: function(Mt) {
                        return xe.call(ge, Mt);
                      }
                    }
                  }), ut = De.nodeType === 1 ? De : De.parentElement;
                  this._sortable = new E.a(ut, Xe), this.targetDomElement = ut, ut.__draggable_component__ = this;
                }
              },
              updated: function() {
                this.componentStructure.updated();
              },
              beforeUnmount: function() {
                this._sortable !== void 0 && this._sortable.destroy();
              },
              computed: {
                realList: function() {
                  var ge = this.list;
                  return ge || this.modelValue;
                },
                getKey: function() {
                  var ge = this.itemKey;
                  return typeof ge == "function" ? ge : function(pe) {
                    return pe[ge];
                  };
                }
              },
              watch: {
                $attrs: {
                  handler: function(ge) {
                    var pe = this._sortable;
                    pe && le(ge).forEach(function(De) {
                      var Ue = x(De, 2), Xe = Ue[0], ut = Ue[1];
                      pe.option(Xe, ut);
                    });
                  },
                  deep: !0
                }
              },
              methods: {
                getUnderlyingVm: function(ge) {
                  return this.componentStructure.getUnderlyingVm(ge) || null;
                },
                getUnderlyingPotencialDraggableComponent: function(ge) {
                  return ge.__draggable_component__;
                },
                emitChanges: function(ge) {
                  var pe = this;
                  Object(ae.nextTick)(function() {
                    return pe.$emit("change", ge);
                  });
                },
                alterList: function(ge) {
                  if (this.list) {
                    ge(this.list);
                    return;
                  }
                  var pe = _(this.modelValue);
                  ge(pe), this.$emit("update:modelValue", pe);
                },
                spliceList: function() {
                  var ge = arguments, pe = function(Ue) {
                    return Ue.splice.apply(Ue, _(ge));
                  };
                  this.alterList(pe);
                },
                updatePosition: function(ge, pe) {
                  var De = function(Xe) {
                    return Xe.splice(pe, 0, Xe.splice(ge, 1)[0]);
                  };
                  this.alterList(De);
                },
                getRelatedContextFromMoveEvent: function(ge) {
                  var pe = ge.to, De = ge.related, Ue = this.getUnderlyingPotencialDraggableComponent(pe);
                  if (!Ue)
                    return {
                      component: Ue
                    };
                  var Xe = Ue.realList, ut = {
                    list: Xe,
                    component: Ue
                  };
                  if (pe !== De && Xe) {
                    var xt = Ue.getUnderlyingVm(De) || {};
                    return d(d({}, xt), ut);
                  }
                  return ut;
                },
                getVmIndexFromDomIndex: function(ge) {
                  return this.componentStructure.getVmIndexFromDomIndex(ge, this.targetDomElement);
                },
                onDragStart: function(ge) {
                  this.context = this.getUnderlyingVm(ge.item), ge.item._underlying_vm_ = this.clone(this.context.element), Te = ge.item;
                },
                onDragAdd: function(ge) {
                  var pe = ge.item._underlying_vm_;
                  if (pe !== void 0) {
                    C(ge.item);
                    var De = this.getVmIndexFromDomIndex(ge.newIndex);
                    this.spliceList(De, 0, pe);
                    var Ue = {
                      element: pe,
                      newIndex: De
                    };
                    this.emitChanges({
                      added: Ue
                    });
                  }
                },
                onDragRemove: function(ge) {
                  if (T(this.$el, ge.item, ge.oldIndex), ge.pullMode === "clone") {
                    C(ge.clone);
                    return;
                  }
                  var pe = this.context, De = pe.index, Ue = pe.element;
                  this.spliceList(De, 1);
                  var Xe = {
                    element: Ue,
                    oldIndex: De
                  };
                  this.emitChanges({
                    removed: Xe
                  });
                },
                onDragUpdate: function(ge) {
                  C(ge.item), T(ge.from, ge.item, ge.oldIndex);
                  var pe = this.context.index, De = this.getVmIndexFromDomIndex(ge.newIndex);
                  this.updatePosition(pe, De);
                  var Ue = {
                    element: this.context.element,
                    oldIndex: pe,
                    newIndex: De
                  };
                  this.emitChanges({
                    moved: Ue
                  });
                },
                computeFutureIndex: function(ge, pe) {
                  if (!ge.element)
                    return 0;
                  var De = _(pe.to.children).filter(function(xt) {
                    return xt.style.display !== "none";
                  }), Ue = De.indexOf(pe.related), Xe = ge.component.getVmIndexFromDomIndex(Ue), ut = De.indexOf(Te) !== -1;
                  return ut || !pe.willInsertAfter ? Xe : Xe + 1;
                },
                onDragMove: function(ge, pe) {
                  var De = this.move, Ue = this.realList;
                  if (!De || !Ue)
                    return !0;
                  var Xe = this.getRelatedContextFromMoveEvent(ge), ut = this.computeFutureIndex(Xe, ge), xt = d(d({}, this.context), {}, {
                    futureIndex: ut
                  }), Mt = d(d({}, ge), {}, {
                    relatedContext: Xe,
                    draggedContext: xt
                  });
                  return De(Mt, pe);
                },
                onDragEnd: function() {
                  Te = null;
                }
              }
            }), it = tt;
            o.default = it;
          }
        ),
        /***/
        fb6a: (
          /***/
          function(a, o, i) {
            var s = i("23e7"), l = i("861d"), u = i("e8b5"), c = i("23cb"), f = i("50c4"), d = i("fc6a"), p = i("8418"), v = i("b622"), h = i("1dde"), m = i("ae40"), y = h("slice"), x = m("slice", { ACCESSORS: !0, 0: 0, 1: 2 }), g = v("species"), S = [].slice, w = Math.max;
            s({ target: "Array", proto: !0, forced: !y || !x }, {
              slice: function(b, E) {
                var C = d(this), T = f(C.length), O = c(b, T), I = c(E === void 0 ? T : E, T), k, B, P;
                if (u(C) && (k = C.constructor, typeof k == "function" && (k === Array || u(k.prototype)) ? k = void 0 : l(k) && (k = k[g], k === null && (k = void 0)), k === Array || k === void 0))
                  return S.call(C, O, I);
                for (B = new (k === void 0 ? Array : k)(w(I - O, 0)), P = 0; O < I; O++, P++) O in C && p(B, P, C[O]);
                return B.length = P, B;
              }
            });
          }
        ),
        /***/
        fc6a: (
          /***/
          function(a, o, i) {
            var s = i("44ad"), l = i("1d80");
            a.exports = function(u) {
              return s(l(u));
            };
          }
        ),
        /***/
        fdbc: (
          /***/
          function(a, o) {
            a.exports = {
              CSSRuleList: 0,
              CSSStyleDeclaration: 0,
              CSSValueList: 0,
              ClientRectList: 0,
              DOMRectList: 0,
              DOMStringList: 0,
              DOMTokenList: 1,
              DataTransferItemList: 0,
              FileList: 0,
              HTMLAllCollection: 0,
              HTMLCollection: 0,
              HTMLFormElement: 0,
              HTMLSelectElement: 0,
              MediaList: 0,
              MimeTypeArray: 0,
              NamedNodeMap: 0,
              NodeList: 1,
              PaintRequestList: 0,
              Plugin: 0,
              PluginArray: 0,
              SVGLengthList: 0,
              SVGNumberList: 0,
              SVGPathSegList: 0,
              SVGPointList: 0,
              SVGStringList: 0,
              SVGTransformList: 0,
              SourceBufferList: 0,
              StyleSheetList: 0,
              TextTrackCueList: 0,
              TextTrackList: 0,
              TouchList: 0
            };
          }
        ),
        /***/
        fdbf: (
          /***/
          function(a, o, i) {
            var s = i("4930");
            a.exports = s && !Symbol.sham && typeof Symbol.iterator == "symbol";
          }
        )
        /******/
      }).default
    );
  });
})(gM);
var qpe = gM.exports;
const AM = /* @__PURE__ */ Ki(qpe), IM = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2016%2016'%20class='e6ds30x1w__design-iconfont'%20width='128'%20height='128'%3e%3cpath%20d='M5.4453125,3.5L5.4453125,3.5Q5.4453125,3.426131,5.4597235,3.353682Q5.4741346,3.281233,5.5024028,3.212987Q5.5306711,3.144742,5.5717105,3.083322Q5.6127495,3.021903,5.6649825,2.96967Q5.7172155,2.917437,5.7786345,2.876398Q5.8400545,2.8353586,5.9082995,2.8070903Q5.9765455,2.7788221,6.0489945,2.764411Q6.1214435,2.75,6.1953125,2.75L10.6953125,2.75Q10.7691825,2.75,10.8416325,2.764411Q10.9140825,2.7788221,10.9823225,2.8070903Q11.050572500000001,2.8353586,11.1119925,2.876398Q11.173412500000001,2.917437,11.2256425,2.96967Q11.2778725,3.021903,11.3189125,3.083322Q11.3599525,3.144742,11.388222500000001,3.212987Q11.4164925,3.281233,11.4309025,3.353682Q11.4453125,3.426131,11.4453125,3.5L11.4453125,3.5Q11.4453125,3.573869,11.4309025,3.646318Q11.4164925,3.718767,11.388222500000001,3.78701Q11.3599525,3.85526,11.3189125,3.91668Q11.2778725,3.9781,11.2256425,4.03033Q11.173412500000001,4.08256,11.1119925,4.1236Q11.050572500000001,4.16464,10.9823225,4.1929099999999995Q10.9140825,4.22118,10.8416325,4.23559Q10.7691825,4.25,10.6953125,4.25L6.1953125,4.25Q6.1214435,4.25,6.0489945,4.23559Q5.9765455,4.22118,5.9082995,4.1929099999999995Q5.8400545,4.16464,5.7786345,4.1236Q5.7172155,4.08256,5.6649825,4.03033Q5.6127495,3.9781,5.5717105,3.91668Q5.5306711,3.85526,5.5024028,3.78701Q5.4741346,3.718767,5.4597235,3.646318Q5.4453125,3.573869,5.4453125,3.5ZM5.4453125,6.5L5.4453125,6.5Q5.4453125,6.426130000000001,5.4597235,6.353680000000001Q5.4741346,6.28123,5.5024028,6.21299Q5.5306711,6.1447400000000005,5.5717105,6.0833200000000005Q5.6127495,6.0219000000000005,5.6649825,5.96967Q5.7172155,5.91744,5.7786345,5.8764Q5.8400545,5.83536,5.9082995,5.8070900000000005Q5.9765455,5.77882,6.0489945,5.76441Q6.1214435,5.75,6.1953125,5.75L10.6953125,5.75Q10.7691825,5.75,10.8416325,5.76441Q10.9140825,5.77882,10.9823225,5.8070900000000005Q11.050572500000001,5.83536,11.1119925,5.8764Q11.173412500000001,5.91744,11.2256425,5.96967Q11.2778725,6.0219000000000005,11.3189125,6.0833200000000005Q11.3599525,6.1447400000000005,11.388222500000001,6.21299Q11.4164925,6.28123,11.4309025,6.353680000000001Q11.4453125,6.426130000000001,11.4453125,6.5L11.4453125,6.5Q11.4453125,6.573869999999999,11.4309025,6.646319999999999Q11.4164925,6.71877,11.388222500000001,6.78701Q11.3599525,6.85526,11.3189125,6.91668Q11.2778725,6.9781,11.2256425,7.03033Q11.173412500000001,7.08256,11.1119925,7.1236Q11.050572500000001,7.16464,10.9823225,7.19291Q10.9140825,7.22118,10.8416325,7.23559Q10.7691825,7.25,10.6953125,7.25L6.1953125,7.25Q6.1214435,7.25,6.0489945,7.23559Q5.9765455,7.22118,5.9082995,7.19291Q5.8400545,7.16464,5.7786345,7.1236Q5.7172155,7.08256,5.6649825,7.03033Q5.6127495,6.9781,5.5717105,6.91668Q5.5306711,6.85526,5.5024028,6.78701Q5.4741346,6.71877,5.4597235,6.646319999999999Q5.4453125,6.573869999999999,5.4453125,6.5ZM5.4453125,9.5L5.4453125,9.5Q5.4453125,9.42613,5.4597235,9.35368Q5.4741346,9.28123,5.5024028,9.21299Q5.5306711,9.144739999999999,5.5717105,9.08332Q5.6127495,9.021899999999999,5.6649825,8.96967Q5.7172155,8.91744,5.7786345,8.8764Q5.8400545,8.83536,5.9082995,8.807089999999999Q5.9765455,8.77882,6.0489945,8.76441Q6.1214435,8.75,6.1953125,8.75L10.6953125,8.75Q10.7691825,8.75,10.8416325,8.76441Q10.9140825,8.77882,10.9823225,8.807089999999999Q11.050572500000001,8.83536,11.1119925,8.8764Q11.173412500000001,8.91744,11.2256425,8.96967Q11.2778725,9.021899999999999,11.3189125,9.08332Q11.3599525,9.144739999999999,11.388222500000001,9.21299Q11.4164925,9.28123,11.4309025,9.35368Q11.4453125,9.42613,11.4453125,9.5L11.4453125,9.5Q11.4453125,9.57387,11.4309025,9.64632Q11.4164925,9.71877,11.388222500000001,9.78701Q11.3599525,9.855260000000001,11.3189125,9.91668Q11.2778725,9.978100000000001,11.2256425,10.03033Q11.173412500000001,10.08256,11.1119925,10.1236Q11.050572500000001,10.16464,10.9823225,10.192910000000001Q10.9140825,10.22118,10.8416325,10.23559Q10.7691825,10.25,10.6953125,10.25L6.1953125,10.25Q6.1214435,10.25,6.0489945,10.23559Q5.9765455,10.22118,5.9082995,10.192910000000001Q5.8400545,10.16464,5.7786345,10.1236Q5.7172155,10.08256,5.6649825,10.03033Q5.6127495,9.978100000000001,5.5717105,9.91668Q5.5306711,9.855260000000001,5.5024028,9.78701Q5.4741346,9.71877,5.4597235,9.64632Q5.4453125,9.57387,5.4453125,9.5ZM5.4453125,12.5L5.4453125,12.5Q5.4453125,12.42613,5.4597235,12.35368Q5.4741346,12.28123,5.5024028,12.21299Q5.5306711,12.14474,5.5717105,12.08332Q5.6127495,12.0219,5.6649825,11.96967Q5.7172155,11.91744,5.7786345,11.8764Q5.8400545,11.83536,5.9082995,11.80709Q5.9765455,11.77882,6.0489945,11.76441Q6.1214435,11.75,6.1953125,11.75L10.6953125,11.75Q10.7691825,11.75,10.8416325,11.76441Q10.9140825,11.77882,10.9823225,11.80709Q11.050572500000001,11.83536,11.1119925,11.8764Q11.173412500000001,11.91744,11.2256425,11.96967Q11.2778725,12.0219,11.3189125,12.08332Q11.3599525,12.14474,11.388222500000001,12.21299Q11.4164925,12.28123,11.4309025,12.35368Q11.4453125,12.42613,11.4453125,12.5L11.4453125,12.5Q11.4453125,12.57387,11.4309025,12.64632Q11.4164925,12.71877,11.388222500000001,12.787Q11.3599525,12.8553,11.3189125,12.9167Q11.2778725,12.9781,11.2256425,13.0303Q11.173412500000001,13.0826,11.1119925,13.1236Q11.050572500000001,13.1646,10.9823225,13.1929Q10.9140825,13.2212,10.8416325,13.2356Q10.7691825,13.25,10.6953125,13.25L6.1953125,13.25Q6.1214435,13.25,6.0489945,13.2356Q5.9765455,13.2212,5.9082995,13.1929Q5.8400545,13.1646,5.7786345,13.1236Q5.7172155,13.0826,5.6649825,13.0303Q5.6127495,12.9781,5.5717105,12.9167Q5.5306711,12.8553,5.5024028,12.787Q5.4741346,12.71877,5.4597235,12.64632Q5.4453125,12.57387,5.4453125,12.5Z'%3e%3c/path%3e%3c/svg%3e", Zm = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20class='3wqhceydv__design-iconfont'%3e%3cpath%20fill='currentColor'%20fill-rule='evenodd'%20d='M6.194%201.153q-.07%200-.14.014t-.136.04q-.066.028-.125.068-.059.04-.11.09-.05.05-.09.109-.039.059-.066.125-.027.065-.041.135-.014.07-.014.141%200%20.071.014.141.014.07.041.135.027.066.067.125.04.06.09.11.05.05.11.09.058.04.124.066.066.028.135.041.07.014.141.014h3.612q.07%200%20.14-.014.07-.013.136-.04.066-.028.125-.067.059-.04.11-.09.05-.05.089-.11.04-.059.067-.125.027-.065.04-.135.015-.07.015-.14%200-.072-.014-.142-.014-.07-.041-.135-.027-.066-.067-.125-.04-.06-.09-.11-.05-.05-.11-.09-.058-.039-.124-.066-.066-.027-.136-.041-.07-.014-.14-.014H6.194ZM2.222%205.486a.722.722%200%200%201%200-1.444h11.556a.722.722%200%201%201%200%201.444h-.907q-.007.953.001%206.852a2.172%202.172%200%200%201-2.167%202.176H5.292a2.167%202.167%200%200%201-2.167-2.166V5.486h-.903Zm4.334%207.164a.722.722%200%200%200%20.722-.722V7.291a.722.722%200%201%200-1.444%200v4.637c0%20.399.323.722.722.722Zm3.614-.722a.722.722%200%200%201-1.444%200V7.291a.722.722%200%201%201%201.445%200v4.637Z'/%3e%3c/svg%3e", Xpe = (e) => (Xa("data-v-a5b29bf2"), e = e(), Za(), e), Zpe = { class: "nc-select-option" }, Qpe = ["src"], Jpe = ["onClick"], ehe = ["src"], the = {
  key: 0,
  class: "nc-col-select-option-error-message"
}, nhe = /* @__PURE__ */ Xpe(() => /* @__PURE__ */ ke("span", null, "+ 添加选项", -1)), D6 = 20, rhe = /* @__PURE__ */ Me({
  __name: "SelectOptions",
  props: {
    value: {},
    fromTableExplorer: { type: Boolean }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const a = Ra(e, "value", t), { setAdditionalValidations: o, validateInfos: i } = O4(), s = ne(), l = ne([]), u = ne(!1), c = ne(D6), f = ne(!1), d = ne([]), p = ne(null), v = ne(null), h = ne(rd.light), m = ne();
    o({
      ...{
        colOptions: [
          {
            type: "object",
            fields: {
              options: {
                validator: (b, E) => new Promise((C, T) => {
                  for (const O of l.value)
                    if (O.status !== "remove") {
                      if (!O.title.length)
                        return T(new Error("选择选项不能为空"));
                      if (a.value.uidt === we.MultiSelect && O.title.includes(","))
                        return T(new Error("多选字段不能使用逗号(',')"));
                      if (l.value.filter(
                        (I) => I.title === O.title && I.status !== "remove"
                      ).length > 1)
                        return T(new Error("选择选项不能重复"));
                    }
                  C();
                })
              }
            }
          }
        ]
      }
    }), Lt(() => {
      var C;
      (C = a.value.colOptions) != null && C.options || (a.value.colOptions = {
        options: []
      }), f.value = !1, l.value = a.value.colOptions.options;
      let b = 0;
      l.value.map((T) => (T.index = b++, T)), c.value = Math.min(c.value, l.value.length), d.value = [...l.value].slice(0, c.value);
      for (const T of l.value.filter((O) => O.order === null))
        T.title = T.title.replace(/^'/, "").replace(/'$/, "");
      a.value.cdf && typeof a.value.cdf == "string" && (l.value.find((O) => O.title === a.value.cdf) || (a.value.cdf = a.value.cdf.replace(/^'/, "").replace(/'$/, "")));
      const E = l.value.find((T) => T.title === a.value.cdf);
      E && (m.value = E);
    });
    const x = () => {
      let b = h.value[0];
      if (l.value.length && l.value[l.value.length - 1].color) {
        const E = h.value.indexOf(l.value[l.value.length - 1].color);
        b = h.value[(E + 1) % h.value.length];
      }
      return b;
    }, g = () => {
      u.value = !0;
      const b = {
        title: "",
        color: x(),
        index: l.value.length
      };
      l.value.push(b), f.value = !0, c.value = l.value.length - D6, c.value = Math.max(c.value, 0), d.value = l.value.slice(c.value, l.value.length), s.value.scrollTop = s.value.scrollHeight, nn(() => {
        setTimeout(() => {
          const E = document.querySelectorAll(
            ".nc-col-option-select-option .nc-select-col-option-select-option"
          ), C = E[E.length - 1];
          C && C.focus();
        }, 150), s.value.scrollTop = s.value.scrollHeight, u.value = !1;
      });
    }, S = () => {
      a.value.colOptions = a.value.colOptions || {}, a.value.colOptions.options = l.value.filter((b) => b.status !== "remove").sort((b, E) => {
        const C = d.value.findIndex(
          (O) => b.index !== void 0 && O.index === b.index
        ), T = d.value.findIndex(
          (O) => b.index !== void 0 && O.index === E.index
        );
        return C === -1 || T === -1 ? 0 : C - T;
      }).map((b) => {
        const { index: E, status: C, ...T } = b;
        return T;
      });
    }, w = (b) => {
      var O, I;
      const E = d.value[b];
      if (E.index === void 0 || isNaN(E.index)) return;
      const C = l.value[E.index];
      E.status = "remove", C.status = "remove", S(), ((O = d.value[b]) == null ? void 0 : O.id) === ((I = m.value) == null ? void 0 : I.id) && (p.value = { ...m.value }, v.value = a.value.cdf, m.value = null, a.value.cdf = null);
    }, _ = (b) => {
      var E;
      b && b === ((E = m.value) == null ? void 0 : E.id) && (a.value.cdf = m.value.title), S();
    };
    return He(a.value, (b) => {
      const E = (b.cdf ?? "").toString().split(","), C = (b.colOptions.options ?? []).map((O) => O.title.replace(/^'/, "").replace(/'$/, "")), T = E.filter((O) => C.includes(O)).join(",");
      b.cdf = T.length === 0 ? null : T;
    }), (b, E) => {
      var C, T, O, I;
      return Ce(), rt("div", null, [
        ke("div", {
          ref_key: "optionsWrapperDomRef",
          ref: s,
          class: "nc-col-option-select-option"
        }, [
          A(U(AM), {
            list: d.value,
            "item-key": "id",
            handle: ".nc-child-draggable-icon",
            onChange: S
          }, {
            item: Fe(({ element: k, index: B }) => [
              ke("div", Zpe, [
                ke("div", {
                  class: tn(["option-content", { removed: k.status === "remove" }])
                }, [
                  ke("img", {
                    class: "nc-child-draggable-icon handle",
                    src: U(IM)
                  }, null, 8, Qpe),
                  A(U(dr), {
                    value: k.title,
                    "onUpdate:value": (P) => k.title = P,
                    class: "nc-select-col-option-select-option",
                    disabled: k.status === "remove",
                    onKeydown: zt(ft((P) => {
                      var N;
                      return ((N = k.title) == null ? void 0 : N.trim()) && g();
                    }, ["prevent"]), ["enter"]),
                    onChange: (P) => _(k.id)
                  }, null, 8, ["value", "onUpdate:value", "disabled", "onKeydown", "onChange"])
                ], 2),
                ke("div", {
                  class: "remove-icon",
                  onClick: (P) => w(B)
                }, [
                  ke("img", {
                    class: "trash-icon",
                    src: U(Zm)
                  }, null, 8, ehe)
                ], 8, Jpe)
              ])
            ]),
            _: 1
          }, 8, ["list"])
        ], 512),
        (I = (O = (T = (C = U(i)) == null ? void 0 : C.colOptions) == null ? void 0 : T.help) == null ? void 0 : O[0]) != null && I[0] ? (Ce(), rt("div", the, Wt(U(i).colOptions.help[0][0]), 1)) : bt("", !0),
        A(U(fn), {
          type: "dashed",
          class: "nc-col-select-option-add-btn",
          onClick: g
        }, {
          default: Fe(() => [
            nhe
          ]),
          _: 1
        })
      ]);
    };
  }
}), ahe = /* @__PURE__ */ Cn(rhe, [["__scopeId", "data-v-a5b29bf2"]]), ohe = ["tabindex"], ihe = /* @__PURE__ */ Me({
  __name: "Checkbox",
  props: {
    value: { type: [String, Boolean] },
    valueModifiers: {}
  },
  emits: ["update:value"],
  setup(e) {
    const t = Fr(e, "value"), n = Ke(Cc, ne(!1)), r = Ke(jo, ne(!1)), a = Ke(vi), o = V({
      get: () => !!t.value && t.value !== "false",
      set: (s) => t.value = s
    });
    function i(s, l) {
      var u, c, f;
      (c = (u = l == null ? void 0 : l.target) == null ? void 0 : u.classList) != null && c.contains("nc-checkbox") || (f = l == null ? void 0 : l.target) != null && f.closest(".nc-checkbox") || !(a != null && a.value) && (s || n.value) && (o.value = !o.value);
    }
    return (s, l) => (Ce(), rt("div", {
      class: tn(["nc-cell-checkbox", {
        "nc-cell-hover-show": !o.value && !U(a),
        "nc-cell-checkbox-op-0": U(a) && !o.value,
        "nc-cell-checkbox-readonly": U(a)
      }]),
      style: _r({ height: U(r) ? void 0 : "max(1.8rem, 41px)" }),
      tabindex: U(a) ? -1 : 0,
      onClick: l[1] || (l[1] = (u) => i(!1, u)),
      onKeydown: l[2] || (l[2] = zt(ft((u) => i(!0, u), ["stop"]), ["enter"]))
    }, [
      A(U(aa), {
        checked: o.value,
        "onUpdate:checked": l[0] || (l[0] = (u) => o.value = u)
      }, null, 8, ["checked"])
    ], 46, ohe));
  }
}), she = /* @__PURE__ */ Cn(ihe, [["__scopeId", "data-v-50c71815"]]);
function Qm(e) {
  "@babel/helpers - typeof";
  return Qm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qm(e);
}
var lhe = /^\s+/, uhe = /\s+$/;
function Ct(e, t) {
  if (e = e || "", t = t || {}, e instanceof Ct)
    return e;
  if (!(this instanceof Ct))
    return new Ct(e, t);
  var n = che(e);
  this._originalInput = e, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || n.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
Ct.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  },
  getLuminance: function() {
    var t = this.toRgb(), n, r, a, o, i, s;
    return n = t.r / 255, r = t.g / 255, a = t.b / 255, n <= 0.03928 ? o = n / 12.92 : o = Math.pow((n + 0.055) / 1.055, 2.4), r <= 0.03928 ? i = r / 12.92 : i = Math.pow((r + 0.055) / 1.055, 2.4), a <= 0.03928 ? s = a / 12.92 : s = Math.pow((a + 0.055) / 1.055, 2.4), 0.2126 * o + 0.7152 * i + 0.0722 * s;
  },
  setAlpha: function(t) {
    return this._a = PM(t), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var t = M6(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      v: t.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var t = M6(this._r, this._g, this._b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), a = Math.round(t.v * 100);
    return this._a == 1 ? "hsv(" + n + ", " + r + "%, " + a + "%)" : "hsva(" + n + ", " + r + "%, " + a + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var t = k6(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      l: t.l,
      a: this._a
    };
  },
  toHslString: function() {
    var t = k6(this._r, this._g, this._b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), a = Math.round(t.l * 100);
    return this._a == 1 ? "hsl(" + n + ", " + r + "%, " + a + "%)" : "hsla(" + n + ", " + r + "%, " + a + "%, " + this._roundA + ")";
  },
  toHex: function(t) {
    return R6(this._r, this._g, this._b, t);
  },
  toHexString: function(t) {
    return "#" + this.toHex(t);
  },
  toHex8: function(t) {
    return hhe(this._r, this._g, this._b, this._a, t);
  },
  toHex8String: function(t) {
    return "#" + this.toHex8(t);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(Qn(this._r, 255) * 100) + "%",
      g: Math.round(Qn(this._g, 255) * 100) + "%",
      b: Math.round(Qn(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(Qn(this._r, 255) * 100) + "%, " + Math.round(Qn(this._g, 255) * 100) + "%, " + Math.round(Qn(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(Qn(this._r, 255) * 100) + "%, " + Math.round(Qn(this._g, 255) * 100) + "%, " + Math.round(Qn(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : The[R6(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(t) {
    var n = "#" + N6(this._r, this._g, this._b, this._a), r = n, a = this._gradientType ? "GradientType = 1, " : "";
    if (t) {
      var o = Ct(t);
      r = "#" + N6(o._r, o._g, o._b, o._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + a + "startColorstr=" + n + ",endColorstr=" + r + ")";
  },
  toString: function(t) {
    var n = !!t;
    t = t || this._format;
    var r = !1, a = this._a < 1 && this._a >= 0, o = !n && a && (t === "hex" || t === "hex6" || t === "hex3" || t === "hex4" || t === "hex8" || t === "name");
    return o ? t === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
  },
  clone: function() {
    return Ct(this.toString());
  },
  _applyModification: function(t, n) {
    var r = t.apply(null, [this].concat([].slice.call(n)));
    return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
  },
  lighten: function() {
    return this._applyModification(yhe, arguments);
  },
  brighten: function() {
    return this._applyModification(xhe, arguments);
  },
  darken: function() {
    return this._applyModification(bhe, arguments);
  },
  desaturate: function() {
    return this._applyModification(vhe, arguments);
  },
  saturate: function() {
    return this._applyModification(mhe, arguments);
  },
  greyscale: function() {
    return this._applyModification(ghe, arguments);
  },
  spin: function() {
    return this._applyModification(whe, arguments);
  },
  _applyCombination: function(t, n) {
    return t.apply(null, [this].concat([].slice.call(n)));
  },
  analogous: function() {
    return this._applyCombination(Che, arguments);
  },
  complement: function() {
    return this._applyCombination(She, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(Ehe, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(_he, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(F6, [3]);
  },
  tetrad: function() {
    return this._applyCombination(F6, [4]);
  }
};
Ct.fromRatio = function(e, t) {
  if (Qm(e) == "object") {
    var n = {};
    for (var r in e)
      e.hasOwnProperty(r) && (r === "a" ? n[r] = e[r] : n[r] = s0(e[r]));
    e = n;
  }
  return Ct(e, t);
};
function che(e) {
  var t = {
    r: 0,
    g: 0,
    b: 0
  }, n = 1, r = null, a = null, o = null, i = !1, s = !1;
  return typeof e == "string" && (e = Ihe(e)), Qm(e) == "object" && (Ps(e.r) && Ps(e.g) && Ps(e.b) ? (t = fhe(e.r, e.g, e.b), i = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Ps(e.h) && Ps(e.s) && Ps(e.v) ? (r = s0(e.s), a = s0(e.v), t = phe(e.h, r, a), i = !0, s = "hsv") : Ps(e.h) && Ps(e.s) && Ps(e.l) && (r = s0(e.s), o = s0(e.l), t = dhe(e.h, r, o), i = !0, s = "hsl"), e.hasOwnProperty("a") && (n = e.a)), n = PM(n), {
    ok: i,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
function fhe(e, t, n) {
  return {
    r: Qn(e, 255) * 255,
    g: Qn(t, 255) * 255,
    b: Qn(n, 255) * 255
  };
}
function k6(e, t, n) {
  e = Qn(e, 255), t = Qn(t, 255), n = Qn(n, 255);
  var r = Math.max(e, t, n), a = Math.min(e, t, n), o, i, s = (r + a) / 2;
  if (r == a)
    o = i = 0;
  else {
    var l = r - a;
    switch (i = s > 0.5 ? l / (2 - r - a) : l / (r + a), r) {
      case e:
        o = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        o = (n - e) / l + 2;
        break;
      case n:
        o = (e - t) / l + 4;
        break;
    }
    o /= 6;
  }
  return {
    h: o,
    s: i,
    l: s
  };
}
function dhe(e, t, n) {
  var r, a, o;
  e = Qn(e, 360), t = Qn(t, 100), n = Qn(n, 100);
  function i(u, c, f) {
    return f < 0 && (f += 1), f > 1 && (f -= 1), f < 1 / 6 ? u + (c - u) * 6 * f : f < 1 / 2 ? c : f < 2 / 3 ? u + (c - u) * (2 / 3 - f) * 6 : u;
  }
  if (t === 0)
    r = a = o = n;
  else {
    var s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    r = i(l, s, e + 1 / 3), a = i(l, s, e), o = i(l, s, e - 1 / 3);
  }
  return {
    r: r * 255,
    g: a * 255,
    b: o * 255
  };
}
function M6(e, t, n) {
  e = Qn(e, 255), t = Qn(t, 255), n = Qn(n, 255);
  var r = Math.max(e, t, n), a = Math.min(e, t, n), o, i, s = r, l = r - a;
  if (i = r === 0 ? 0 : l / r, r == a)
    o = 0;
  else {
    switch (r) {
      case e:
        o = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        o = (n - e) / l + 2;
        break;
      case n:
        o = (e - t) / l + 4;
        break;
    }
    o /= 6;
  }
  return {
    h: o,
    s: i,
    v: s
  };
}
function phe(e, t, n) {
  e = Qn(e, 360) * 6, t = Qn(t, 100), n = Qn(n, 100);
  var r = Math.floor(e), a = e - r, o = n * (1 - t), i = n * (1 - a * t), s = n * (1 - (1 - a) * t), l = r % 6, u = [n, i, o, o, s, n][l], c = [s, n, n, i, o, o][l], f = [o, o, s, n, n, i][l];
  return {
    r: u * 255,
    g: c * 255,
    b: f * 255
  };
}
function R6(e, t, n, r) {
  var a = [Ni(Math.round(e).toString(16)), Ni(Math.round(t).toString(16)), Ni(Math.round(n).toString(16))];
  return r && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
}
function hhe(e, t, n, r, a) {
  var o = [Ni(Math.round(e).toString(16)), Ni(Math.round(t).toString(16)), Ni(Math.round(n).toString(16)), Ni(DM(r))];
  return a && o[0].charAt(0) == o[0].charAt(1) && o[1].charAt(0) == o[1].charAt(1) && o[2].charAt(0) == o[2].charAt(1) && o[3].charAt(0) == o[3].charAt(1) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0) : o.join("");
}
function N6(e, t, n, r) {
  var a = [Ni(DM(r)), Ni(Math.round(e).toString(16)), Ni(Math.round(t).toString(16)), Ni(Math.round(n).toString(16))];
  return a.join("");
}
Ct.equals = function(e, t) {
  return !e || !t ? !1 : Ct(e).toRgbString() == Ct(t).toRgbString();
};
Ct.random = function() {
  return Ct.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function vhe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = Ct(e).toHsl();
  return n.s -= t / 100, n.s = L1(n.s), Ct(n);
}
function mhe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = Ct(e).toHsl();
  return n.s += t / 100, n.s = L1(n.s), Ct(n);
}
function ghe(e) {
  return Ct(e).desaturate(100);
}
function yhe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = Ct(e).toHsl();
  return n.l += t / 100, n.l = L1(n.l), Ct(n);
}
function xhe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = Ct(e).toRgb();
  return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), Ct(n);
}
function bhe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = Ct(e).toHsl();
  return n.l -= t / 100, n.l = L1(n.l), Ct(n);
}
function whe(e, t) {
  var n = Ct(e).toHsl(), r = (n.h + t) % 360;
  return n.h = r < 0 ? 360 + r : r, Ct(n);
}
function She(e) {
  var t = Ct(e).toHsl();
  return t.h = (t.h + 180) % 360, Ct(t);
}
function F6(e, t) {
  if (isNaN(t) || t <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var n = Ct(e).toHsl(), r = [Ct(e)], a = 360 / t, o = 1; o < t; o++)
    r.push(Ct({
      h: (n.h + o * a) % 360,
      s: n.s,
      l: n.l
    }));
  return r;
}
function _he(e) {
  var t = Ct(e).toHsl(), n = t.h;
  return [Ct(e), Ct({
    h: (n + 72) % 360,
    s: t.s,
    l: t.l
  }), Ct({
    h: (n + 216) % 360,
    s: t.s,
    l: t.l
  })];
}
function Che(e, t, n) {
  t = t || 6, n = n || 30;
  var r = Ct(e).toHsl(), a = 360 / n, o = [Ct(e)];
  for (r.h = (r.h - (a * t >> 1) + 720) % 360; --t; )
    r.h = (r.h + a) % 360, o.push(Ct(r));
  return o;
}
function Ehe(e, t) {
  t = t || 6;
  for (var n = Ct(e).toHsv(), r = n.h, a = n.s, o = n.v, i = [], s = 1 / t; t--; )
    i.push(Ct({
      h: r,
      s: a,
      v: o
    })), o = (o + s) % 1;
  return i;
}
Ct.mix = function(e, t, n) {
  n = n === 0 ? 0 : n || 50;
  var r = Ct(e).toRgb(), a = Ct(t).toRgb(), o = n / 100, i = {
    r: (a.r - r.r) * o + r.r,
    g: (a.g - r.g) * o + r.g,
    b: (a.b - r.b) * o + r.b,
    a: (a.a - r.a) * o + r.a
  };
  return Ct(i);
};
Ct.readability = function(e, t) {
  var n = Ct(e), r = Ct(t);
  return (Math.max(n.getLuminance(), r.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), r.getLuminance()) + 0.05);
};
Ct.isReadable = function(e, t, n) {
  var r = Ct.readability(e, t), a, o;
  switch (o = !1, a = Phe(n), a.level + a.size) {
    case "AAsmall":
    case "AAAlarge":
      o = r >= 4.5;
      break;
    case "AAlarge":
      o = r >= 3;
      break;
    case "AAAsmall":
      o = r >= 7;
      break;
  }
  return o;
};
Ct.mostReadable = function(e, t, n) {
  var r = null, a = 0, o, i, s, l;
  n = n || {}, i = n.includeFallbackColors, s = n.level, l = n.size;
  for (var u = 0; u < t.length; u++)
    o = Ct.readability(e, t[u]), o > a && (a = o, r = Ct(t[u]));
  return Ct.isReadable(e, r, {
    level: s,
    size: l
  }) || !i ? r : (n.includeFallbackColors = !1, Ct.mostReadable(e, ["#fff", "#000"], n));
};
var NS = Ct.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, The = Ct.hexNames = $he(NS);
function $he(e) {
  var t = {};
  for (var n in e)
    e.hasOwnProperty(n) && (t[e[n]] = n);
  return t;
}
function PM(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Qn(e, t) {
  Ohe(e) && (e = "100%");
  var n = Ahe(e);
  return e = Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(e * t, 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function L1(e) {
  return Math.min(1, Math.max(0, e));
}
function Co(e) {
  return parseInt(e, 16);
}
function Ohe(e) {
  return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function Ahe(e) {
  return typeof e == "string" && e.indexOf("%") != -1;
}
function Ni(e) {
  return e.length == 1 ? "0" + e : "" + e;
}
function s0(e) {
  return e <= 1 && (e = e * 100 + "%"), e;
}
function DM(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function L6(e) {
  return Co(e) / 255;
}
var Ti = function() {
  var e = "[-\\+]?\\d+%?", t = "[-\\+]?\\d*\\.\\d+%?", n = "(?:" + t + ")|(?:" + e + ")", r = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?", a = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(n),
    rgb: new RegExp("rgb" + r),
    rgba: new RegExp("rgba" + a),
    hsl: new RegExp("hsl" + r),
    hsla: new RegExp("hsla" + a),
    hsv: new RegExp("hsv" + r),
    hsva: new RegExp("hsva" + a),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function Ps(e) {
  return !!Ti.CSS_UNIT.exec(e);
}
function Ihe(e) {
  e = e.replace(lhe, "").replace(uhe, "").toLowerCase();
  var t = !1;
  if (NS[e])
    e = NS[e], t = !0;
  else if (e == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var n;
  return (n = Ti.rgb.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3]
  } : (n = Ti.rgba.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3],
    a: n[4]
  } : (n = Ti.hsl.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3]
  } : (n = Ti.hsla.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3],
    a: n[4]
  } : (n = Ti.hsv.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3]
  } : (n = Ti.hsva.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3],
    a: n[4]
  } : (n = Ti.hex8.exec(e)) ? {
    r: Co(n[1]),
    g: Co(n[2]),
    b: Co(n[3]),
    a: L6(n[4]),
    format: t ? "name" : "hex8"
  } : (n = Ti.hex6.exec(e)) ? {
    r: Co(n[1]),
    g: Co(n[2]),
    b: Co(n[3]),
    format: t ? "name" : "hex"
  } : (n = Ti.hex4.exec(e)) ? {
    r: Co(n[1] + "" + n[1]),
    g: Co(n[2] + "" + n[2]),
    b: Co(n[3] + "" + n[3]),
    a: L6(n[4] + "" + n[4]),
    format: t ? "name" : "hex8"
  } : (n = Ti.hex3.exec(e)) ? {
    r: Co(n[1] + "" + n[1]),
    g: Co(n[2] + "" + n[2]),
    b: Co(n[3] + "" + n[3]),
    format: t ? "name" : "hex"
  } : !1;
}
function Phe(e) {
  var t, n;
  return e = e || {
    level: "AA",
    size: "small"
  }, t = (e.level || "AA").toUpperCase(), n = (e.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), n !== "small" && n !== "large" && (n = "small"), {
    level: t,
    size: n
  };
}
const Lu = /* @__PURE__ */ Me({
  __name: "NcSelect",
  props: {
    value: {},
    placeholder: {},
    mode: {},
    popupClassName: {},
    showSearch: { type: Boolean },
    filterOption: { type: Function },
    dropdownMatchSelectWidth: { type: Boolean },
    allowClear: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["update:value", "change"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = V(() => n.placeholder), o = V(() => {
      let p = "nc-select-dropdown";
      return n.popupClassName && (p += ` ${n.popupClassName}`), p;
    }), i = V(() => n.showSearch), s = V(() => n.filterOption), l = V(() => n.dropdownMatchSelectWidth), u = V(() => n.loading), c = V(() => n.mode), f = Ra(n, "value", r), d = (p) => {
      r("change", p);
    };
    return (p, v) => (Ce(), et(U(fo), {
      value: U(f),
      "onUpdate:value": v[0] || (v[0] = (h) => Ft(f) ? f.value = h : null),
      "allow-clear": p.allowClear,
      disabled: u.value,
      "popup-class-name": o.value,
      "dropdown-match-select-width": l.value,
      "filter-option": s.value,
      loading: u.value,
      mode: c.value,
      placeholder: a.value,
      "show-search": i.value,
      class: "nc-select",
      onChange: d
    }, {
      suffixIcon: Fe(() => []),
      default: Fe(() => [
        uo(p.$slots, "default")
      ]),
      _: 3
    }, 8, ["value", "allow-clear", "disabled", "popup-class-name", "dropdown-match-select-width", "filter-option", "loading", "mode", "placeholder", "show-search"]));
  }
}), Dhe = ["onKeydown"], khe = {
  key: 0,
  class: "nc-single-select-tags"
}, Mhe = { style: {
  overflow: "hidden",
  "text-overflow": "ellipsis",
  wordBreak: "keep-all",
  whiteSpace: "nowrap",
  display: "inline"
} }, Rhe = { style: {
  overflow: "hidden",
  "text-overflow": "ellipsis",
  wordBreak: "keep-all",
  whiteSpace: "nowrap",
  display: "inline"
} }, Nhe = { class: "nc-single-select-add" }, Fhe = { class: "nc-single-select-add-label" }, Lhe = /* @__PURE__ */ Me({
  __name: "SingleSelect",
  props: /* @__PURE__ */ Zl({
    rowIndex: {},
    disableOptionCreation: { type: Boolean }
  }, {
    value: {},
    valueModifiers: {}
  }),
  emits: ["update:value"],
  setup(e) {
    const t = Fr(e, "value"), { disableOptionCreation: n } = e, r = Ke(bs), a = Ke(vi), o = Ke(gd, ne(!1)), i = Ke(Cc, ne(!1)), s = V(() => i.value || o.value), l = ne(), u = ne(!1), c = Ke(_c, ne(!1));
    Ke(jo, ne(!1));
    const { api: f } = Na(), d = ne(), p = ne(), v = ne(!1), h = V(() => !c.value && !n), m = V(() => {
      if (r != null && r.value.colOptions) {
        const O = r.value.colOptions ? (
          // todo: fix colOptions type, options does not exist as a property
          r.value.colOptions.options.filter(
            (I) => I.title !== ""
          ) || []
        ) : [];
        for (const I of O.filter((k) => k.order === null))
          I.title = I.title.replace(/^'/, "").replace(/'$/, "");
        return O.map((I) => ({ ...I, value: I.title }));
      }
      return [];
    }), y = V(() => (m.value ?? []).every((O) => O.title !== d.value)), x = V({
      get: () => p.value ?? t.value,
      set: (O) => {
        if (O && h.value && (m.value ?? []).every((I) => I.title !== O))
          return p.value = O, g();
        t.value = O || void 0;
      }
    });
    He(u, (O) => {
      var I, k, B, P, N, M;
      O ? (M = (N = (P = l.value) == null ? void 0 : P.$el) == null ? void 0 : N.querySelector("input")) == null || M.focus() : (B = (k = (I = l.value) == null ? void 0 : I.$el) == null ? void 0 : k.querySelector("input")) == null || B.blur();
    });
    async function g() {
      var I, k;
      if (!p.value || c.value) return !1;
      const O = p.value;
      if (d.value = "", p.value = void 0, O && !m.value.some((B) => B.title === O))
        try {
          m.value.push({
            title: O,
            value: O,
            color: rd.light[(m.value.length + 1) % rd.light.length]
          }), r.value.colOptions = { options: m.value.map(({ value: P, ...N }) => N) };
          const B = { ...r.value };
          B.cdf && (B.cdf = B.cdf.substring(
            B.cdf.indexOf("'") + 1,
            B.cdf.lastIndexOf("'")
          )), await f.dbTableColumn.update(
            ((I = r.value) == null ? void 0 : I.fk_column_id) || ((k = r.value) == null ? void 0 : k.id),
            B
          ), x.value = O;
        } catch (B) {
          console.log(B), wt.error(await Pn(B));
        }
    }
    const S = () => {
      var O, I, k;
      d.value = (k = (I = (O = l.value) == null ? void 0 : O.$el) == null ? void 0 : I.querySelector(".ant-select-selection-search-input")) == null ? void 0 : k.value;
    }, w = (O) => {
      u.value && s.value && O.stopPropagation(), O.key === "Enter" && O.stopPropagation(), O.key === "Escape" && (u.value = !1, setTimeout(() => {
        var I;
        (I = l.value) == null || I.$el.querySelector(".ant-select-selection-search > input").focus();
      }, 100));
    }, _ = () => {
      u.value = !1, o.value = !1;
    }, b = (O) => {
      var I, k;
      if ((I = O.target) != null && I.classList.contains("ant-select-clear") || (k = O.target) != null && k.closest(".ant-select-clear"))
        return x.value = "", O.stopPropagation();
      v.value || (u.value = !u.value);
    };
    or(document, "click", (O) => {
      u.value && l.value && !l.value.$el.contains(O.target) && (u.value = !1);
    }, !0);
    const C = V(() => m.value.find(
      (O) => {
        var I, k;
        return O.value === x.value || O.value === ((k = (I = x.value) == null ? void 0 : I.toString()) == null ? void 0 : k.trim());
      }
    )), T = () => {
      v.value = !0, setTimeout(() => {
        v.value = !1;
      }, 250), u.value = !0;
    };
    return (O, I) => (Ce(), rt("div", {
      class: tn(["nc-cell-field nc-single-select", { "read-only": U(a) }]),
      onClick: b,
      onKeydown: zt(ft(b, ["stop", "prevent"]), ["enter"])
    }, [
      s.value || U(o) ? (Ce(), et(Lu, {
        key: 1,
        ref_key: "aselect",
        ref: l,
        value: x.value,
        "onUpdate:value": I[1] || (I[1] = (k) => x.value = k),
        style: { width: "100%", overflow: "hidden" },
        "allow-clear": !U(r).rqd,
        bordered: !1,
        open: u.value,
        disabled: U(a),
        "show-search": u.value && s.value,
        "show-arrow": !U(a) && s.value && (x.value === null || x.value === void 0),
        "popup-class-name": `nc-dropdown-single-select-cell ${u.value && s.value ? "active" : ""}`,
        "dropdown-match-select-width": !0,
        onSelect: _,
        onKeydown: I[2] || (I[2] = (k) => w(k)),
        onSearch: S,
        onBlur: I[3] || (I[3] = (k) => u.value = !1),
        onFocus: T
      }, {
        default: Fe(() => [
          (Ce(!0), rt(dt, null, Vn(m.value, (k) => (Ce(), et(U(ia), {
            key: k.title,
            value: k.title,
            class: tn(`nc-select-option-${U(r).title}-${k.title}`),
            onClick: I[0] || (I[0] = ft(() => {
            }, ["stop"]))
          }, {
            default: Fe(() => [
              A(U(fs), {
                class: "rounded-tag",
                color: k.color
              }, {
                default: Fe(() => [
                  ke("span", {
                    style: _r({
                      color: U(Ct).isReadable(k.color || "#ccc", "#fff", {
                        level: "AA",
                        size: "large"
                      }) ? "#fff" : U(Ct).mostReadable(k.color || "#ccc", ["#0b1d05", "#fff"]).toHex8String(),
                      "font-size": "12px",
                      "line-height": "20px"
                    })
                  }, [
                    ke("span", Rhe, Wt(k.title), 1)
                  ], 4)
                ]),
                _: 2
              }, 1032, ["color"])
            ]),
            _: 2
          }, 1032, ["value", "class"]))), 128)),
          d.value && y.value && h.value ? (Ce(), et(U(ia), {
            key: d.value,
            value: d.value
          }, {
            default: Fe(() => [
              ke("div", Nhe, [
                ke("div", Fhe, [
                  Jt(" 创建新的选项名称 "),
                  ke("strong", null, Wt(d.value), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["value"])) : bt("", !0)
        ]),
        _: 1
      }, 8, ["value", "allow-clear", "open", "disabled", "show-search", "show-arrow", "popup-class-name"])) : (Ce(), rt("div", khe, [
        C.value ? (Ce(), et(U(fs), {
          key: 0,
          class: "rounded-tag",
          color: C.value.color
        }, {
          default: Fe(() => [
            ke("span", {
              style: _r({
                color: U(Ct).isReadable(C.value.color || "#ccc", "#fff", {
                  level: "AA",
                  size: "large"
                }) ? "#fff" : U(Ct).mostReadable(C.value.color || "#ccc", ["#0b1d05", "#fff"]).toHex8String(),
                "font-size": "12px",
                "line-height": "20px"
              })
            }, [
              ke("span", Mhe, Wt(C.value.title), 1)
            ], 4)
          ]),
          _: 1
        }, 8, ["color"])) : bt("", !0)
      ]))
    ], 42, Dhe));
  }
}), kM = /* @__PURE__ */ Cn(Lhe, [["__scopeId", "data-v-249e5e7a"]]), Bhe = {
  key: 0,
  class: "tags-wrapper",
  style: { display: "-webkit-box", "max-width": "100%", "-webkit-line-clamp": "1", "-webkit-box-orient": "vertical", overflow: "hidden" }
}, Hhe = { style: {
  overflow: "hidden",
  "text-overflow": "ellipsis",
  wordBreak: "keep-all",
  whiteSpace: "nowrap",
  display: "inline"
} }, jhe = { style: {
  overflow: "hidden",
  "text-overflow": "ellipsis",
  wordBreak: "keep-all",
  whiteSpace: "nowrap",
  display: "inline"
} }, Vhe = { class: "nc-single-select-add" }, Uhe = { class: "nc-single-select-add-label" }, zhe = /* @__PURE__ */ Me({
  __name: "MultiSelect",
  props: /* @__PURE__ */ Zl({
    rowIndex: {},
    disableOptionCreation: { type: Boolean },
    location: {}
  }, {
    value: {},
    valueModifiers: {}
  }),
  emits: ["update:value"],
  setup(e) {
    const t = Fr(e, "value"), n = Ke(bs), r = Ke(vi), a = Ke(gd, ne(!1)), o = Ke(Cc, ne(!1)), i = V(() => o.value || a.value), s = Ke(_c, ne(!1));
    Ke(jo, ne(!1));
    const l = ne([]), u = ne(), c = ne(!1), f = ne(!1), d = ne(), { api: p } = Na(), v = Wn([]), h = V(() => {
      var k;
      if (n != null && n.value.colOptions) {
        const B = n.value.colOptions ? n.value.colOptions.options.filter(
          (P) => P.title !== ""
        ) || [] : [];
        for (const P of B.filter((N) => N.order === null))
          P.title = (k = P.title) == null ? void 0 : k.replace(/^'/, "").replace(/'$/, "");
        return B.map((P) => ({ ...P, value: P.title }));
      }
      return [];
    }), m = V(() => (h.value ?? []).every((k) => k.title !== d.value)), y = V(() => i.value), x = V({
      get: () => {
        const k = l.value.reduce((B, P) => {
          var M;
          const N = (M = h.value.find((H) => H.id === P) || h.value.find((H) => H.title === P)) == null ? void 0 : M.title;
          return N && B.push(N), B;
        }, []);
        return v.length && k.push(...v), k;
      },
      set: (k) => {
        if (m.value && k.length && k[k.length - 1] === d.value)
          return w();
        t.value = k.length === 0 ? void 0 : k.join(",");
      }
    }), g = V(() => {
      const k = t.value;
      return k ? Array.isArray(k) ? k : k.toString().split(",") : [];
    });
    Lt(() => {
      l.value = g.value.flatMap((k) => {
        const B = h.value.find((N) => N.title === k || N.title === (k == null ? void 0 : k.trim())), P = (B == null ? void 0 : B.id) || (B == null ? void 0 : B.title);
        return P ? [P] : [];
      });
    }), He(t, () => {
      l.value = g.value.flatMap((k) => {
        const B = h.value.find((P) => P.title === k || P.title === (k == null ? void 0 : k.trim()));
        return B && (B.id || B.title) ? [B.id || B.title] : [];
      });
    }), He(c, (k) => {
      var B, P, N;
      k || (d.value = ""), k && ((N = (P = (B = u.value) == null ? void 0 : B.$el) == null ? void 0 : P.querySelector("input")) == null || N.focus());
    });
    const S = ne(0);
    async function w() {
      var k, B;
      if (!d.value || s.value) return !1;
      try {
        v.push(d.value);
        const P = d == null ? void 0 : d.value;
        if (d.value = "", S.value++, P && !h.value.some((N) => N.title === P)) {
          const N = [...h.value];
          N.push({
            title: P,
            value: P,
            color: rd.light[(h.value.length + 1) % rd.light.length]
          }), n.value.colOptions = { options: N.map(({ value: H, ...R }) => R) };
          const M = { ...n.value };
          M.cdf && (M.cdf = M.cdf.substring(
            M.cdf.indexOf("'") + 1,
            M.cdf.lastIndexOf("'")
          )), await p.dbTableColumn.update(
            ((k = n.value) == null ? void 0 : k.fk_column_id) || ((B = n.value) == null ? void 0 : B.id),
            M
          ), S.value--, S.value || (x.value = [...x.value], v.splice(0, v.length));
        } else
          S.value--;
      } catch (P) {
        console.log(P), S.value--, wt.error(await Pn(P));
      }
    }
    const _ = () => {
      var k, B, P;
      d.value = (P = (B = (k = u.value) == null ? void 0 : k.$el) == null ? void 0 : B.querySelector(".ant-select-selection-search-input")) == null ? void 0 : P.value;
    }, b = (k, B) => {
      var P, N;
      ((P = k.target) != null && P.classList.contains("ant-tag-close-icon") || (N = k.target) != null && N.closest(".ant-tag-close-icon")) && (k.stopPropagation(), B());
    }, E = () => {
      f.value || (c.value = y.value && !c.value);
    };
    or(document, "click", (k) => {
      var B;
      c.value && u.value && !u.value.$el.contains(k.target) && !((B = document.querySelector(".nc-dropdown-multi-select-cell.active")) != null && B.contains(k.target)) && (a.value = !1, c.value = !1);
    }, !0);
    const T = V(() => x.value.reduce((k, B) => {
      const P = h.value.find((N) => N.value === B);
      return P && k.push(P), k;
    }, [])), O = (k) => {
      if (k.key === "Tab") {
        c.value = !1;
        return;
      }
      k.stopPropagation();
    }, I = () => {
      f.value = !0, setTimeout(() => {
        f.value = !1;
      }, 250), c.value = !0;
    };
    return (k, B) => (Ce(), rt("div", {
      class: tn(["nc-cell-field nc-multi-select", { "read-only": U(r) }]),
      onClick: E
    }, [
      i.value ? (Ce(), et(U(fo), {
        key: 1,
        ref_key: "aselect",
        ref: u,
        value: x.value,
        "onUpdate:value": B[1] || (B[1] = (P) => x.value = P),
        mode: "multiple",
        style: { width: "100%", overflow: "hidden" },
        bordered: !1,
        "clear-icon": "",
        "show-search": "",
        "show-arrow": !U(r),
        open: c.value,
        disabled: U(r),
        "popup-class-name": `nc-dropdown-multi-select-cell ${c.value ? "active" : ""}`,
        onSearch: _,
        onKeydown: O,
        onFocus: I,
        onBlur: B[2] || (B[2] = (P) => c.value = !1)
      }, {
        suffixIcon: Fe(() => []),
        tagRender: Fe(({ value: P, onClose: N }) => {
          var M, H;
          return [
            h.value.find((R) => R.title === P) ? (Ce(), et(U(fs), {
              key: 0,
              class: "rounded-tag nc-selected-option",
              style: { display: "flex", alignItems: "center" },
              color: (M = h.value.find((R) => R.title === P)) == null ? void 0 : M.color,
              closable: x.value.length > 1 || !((H = U(n)) != null && H.rqd),
              onClick: (R) => b(R, N),
              onClose: N
            }, {
              default: Fe(() => {
                var R, z;
                return [
                  ke("span", {
                    style: _r({
                      color: U(Ct).isReadable(
                        ((R = h.value.find((W) => W.title === P)) == null ? void 0 : R.color) || "#ccc",
                        "#fff",
                        {
                          level: "AA",
                          size: "large"
                        }
                      ) ? "#fff" : U(Ct).mostReadable(((z = h.value.find((W) => W.title === P)) == null ? void 0 : z.color) || "#ccc", [
                        "#0b1d05",
                        "#fff"
                      ]).toHex8String(),
                      "font-size": "12px",
                      "line-height": "20px"
                    })
                  }, Wt(P), 5)
                ];
              }),
              _: 2
            }, 1032, ["color", "closable", "onClick", "onClose"])) : bt("", !0)
          ];
        }),
        default: Fe(() => [
          (Ce(!0), rt(dt, null, Vn(h.value, (P) => (Ce(), et(U(ia), {
            key: P.id || P.title,
            value: P.title,
            class: tn(`nc-select-option-${U(n).title}-${P.title}`),
            onClick: B[0] || (B[0] = ft(() => {
            }, ["stop"]))
          }, {
            default: Fe(() => [
              A(U(fs), {
                class: "rounded-tag",
                color: P.color
              }, {
                default: Fe(() => [
                  ke("span", {
                    style: _r({
                      color: U(Ct).isReadable(P.color || "#ccc", "#fff", {
                        level: "AA",
                        size: "large"
                      }) ? "#fff" : U(Ct).mostReadable(P.color || "#ccc", ["#0b1d05", "#fff"]).toHex8String(),
                      "font-size": "12px",
                      "line-height": "20px"
                    })
                  }, [
                    ke("span", jhe, Wt(P.title), 1)
                  ], 4)
                ]),
                _: 2
              }, 1032, ["color"])
            ]),
            _: 2
          }, 1032, ["value", "class"]))), 128)),
          d.value && m.value && !U(s) && !k.disableOptionCreation ? (Ce(), et(U(ia), {
            key: d.value,
            value: d.value
          }, {
            default: Fe(() => [
              ke("div", Vhe, [
                ke("div", Uhe, [
                  Jt(" 创建新的选项名称 "),
                  ke("strong", null, Wt(d.value), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["value"])) : bt("", !0)
        ]),
        _: 1
      }, 8, ["value", "show-arrow", "open", "disabled", "popup-class-name"])) : (Ce(), rt("div", Bhe, [
        (Ce(!0), rt(dt, null, Vn(T.value, (P) => (Ce(), et(U(fs), {
          key: P.value,
          class: "rounded-tag",
          color: P.color
        }, {
          default: Fe(() => [
            ke("span", {
              style: _r({
                color: U(Ct).isReadable(P.color || "#ccc", "#fff", {
                  level: "AA",
                  size: "large"
                }) ? "#fff" : U(Ct).mostReadable(P.color || "#ccc", ["#0b1d05", "#fff"]).toHex8String(),
                "font-size": "12px",
                "line-height": "20px"
              })
            }, [
              ke("span", Hhe, Wt(P.title), 1)
            ], 4)
          ]),
          _: 2
        }, 1032, ["color"]))), 128))
      ]))
    ], 2));
  }
}), FS = /* @__PURE__ */ Cn(zhe, [["__scopeId", "data-v-61621992"]]), Whe = /* @__PURE__ */ Me({
  __name: "DatePicker",
  props: /* @__PURE__ */ Zl({
    isPk: { type: Boolean }
  }, {
    value: {},
    valueModifiers: {}
  }),
  emits: ["update:value"],
  setup(e) {
    const t = Fr(e, "value"), { isPk: n } = e, r = Ke(bs, null), a = Ke(vi, ne(!1)), o = Ke(jo, ne(!1)), i = Ke(Cc, ne(!1)), s = Ke(gd, ne(!1)), l = ne(!1), u = V(() => {
      var w, _;
      return ((_ = Ga((w = r == null ? void 0 : r.value) == null ? void 0 : w.meta)) == null ? void 0 : _.date_format) ?? "YYYY-MM-DD";
    }), c = V(() => F_(u.value) ? "month" : "date"), f = (w) => w ? It(w).isValid() ? !0 : (l.value = !0, !1) : !1, d = V({
      get() {
        const w = t.value;
        if (!f(w))
          return;
        const _ = c.value === "month" ? u.value : "YYYY-MM-DD";
        return It(/^\d+$/.test(w) ? +w : w, _);
      },
      set(w) {
        if (!w) {
          t.value = null;
          return;
        }
        c.value === "month" && (w = It(w).date(1)), w.isValid() && (t.value = w.format("YYYY-MM-DD"));
      }
    }), p = ne(!1), v = `picker_${Math.floor(Math.random() * 99999)}`;
    He(
      p,
      (w) => {
        w ? Np(
          document.querySelector(`.${v}`),
          () => p.value = !1
        ) : s.value = !1;
      },
      { flush: "post" }
    );
    const h = V(() => o.value && (t.value === "" || t.value === null) ? "" : l.value ? "无效的日期" : ""), m = V(() => a.value || (a.value || d.value && n) && !i.value && !s.value ? !1 : p.value), y = (w) => {
      p.value && !w && (p.value = !1);
    }, x = Ke(Hg, null), g = () => {
      p.value = (i.value || s.value) && !p.value;
    };
    Lt(() => {
      x == null || x.on(g);
    }), Bo(() => {
      x == null || x.on(g);
    });
    const S = () => {
      x || g();
    };
    return (w, _) => (Ce(), et(U($7), {
      value: d.value,
      "onUpdate:value": _[0] || (_[0] = (b) => d.value = b),
      disabled: U(a),
      picker: c.value,
      tabindex: 0,
      bordered: !1,
      class: "nc-cell-field nc-cell-date-picker",
      format: u.value,
      placeholder: h.value,
      "allow-clear": !U(a) && !d.value && !w.isPk,
      "input-read-only": !0,
      "popup-class-name": `${v} nc-picker-date ${p.value ? "active" : ""} `,
      open: m.value,
      onClick: S,
      "onUpdate:open": y,
      onKeydown: _[1] || (_[1] = zt((b) => p.value = !p.value, ["enter"]))
    }, null, 8, ["value", "disabled", "picker", "format", "placeholder", "allow-clear", "popup-class-name", "open"]));
  }
}), MM = /* @__PURE__ */ Cn(Whe, [["__scopeId", "data-v-7f591ef7"]]), Ghe = /* @__PURE__ */ Me({
  __name: "DateTimePicker",
  props: /* @__PURE__ */ Zl({
    isPk: { type: Boolean },
    isUpdatedFromCopyNPaste: {}
  }, {
    value: {},
    valueModifiers: {}
  }),
  emits: ["update:value"],
  setup(e) {
    const t = Fr(e, "value"), { isPk: n, isUpdatedFromCopyNPaste: r } = e, a = Ke(vi, ne(!1)), o = Ke(Cc, ne(!1)), i = Ke(gd, ne(!1)), s = Ke(jo, ne(!1)), l = Ke(bs), u = ne(!1), c = V(() => {
      var T, O, I, k;
      const E = ((O = Ga((T = l == null ? void 0 : l.value) == null ? void 0 : T.meta)) == null ? void 0 : O.date_format) ?? Bf[0], C = ((k = Ga((I = l == null ? void 0 : l.value) == null ? void 0 : I.meta)) == null ? void 0 : k.time_format) ?? hm[0];
      return `${E} ${C}`;
    });
    let f = t.value ? It(t.value).utc().local() : void 0;
    const d = ne(), p = (E) => E ? It(E).isValid() ? !0 : (u.value = !0, !1) : !1, v = V({
      get() {
        var C;
        const E = t.value;
        if (!E && d.value)
          return d.value;
        if (p(E)) {
          if (l.value.title in (r ?? {}))
            return f = It(E).utc().local(), f;
          if ((C = l == null ? void 0 : l.value) != null && C.cdf)
            return It(E).utc().local();
          if (f) {
            const T = f;
            return f = void 0, T;
          }
          return It(E).utc().local();
        }
      },
      set(E) {
        if (!E) {
          t.value = null;
          return;
        }
        E.isValid() && (f = It(E), t.value = It(E).utc().format("YYYY-MM-DD HH:mm:ssZ"));
      }
    }), h = ne(!1), m = V(() => a.value || a.value || v.value && n ? !1 : h.value && (o.value || i.value)), y = `picker_${Math.floor(Math.random() * 99999)}`;
    He(
      h,
      (E) => {
        E ? (Np(
          document.querySelector(`.${y}`),
          () => h.value = !1
        ), t.value ? d.value = void 0 : d.value = It(/* @__PURE__ */ new Date()).utc().local()) : (i.value = !1, d.value = void 0);
      },
      { flush: "post" }
    );
    const x = V(() => s.value && (t.value === "" || t.value === null) ? "" : u.value ? "无效的日期" : ""), g = Ke(Hg, null), S = () => {
      a.value || (h.value = (o.value || i.value) && !h.value);
    };
    function w(E) {
      if (!E) {
        t.value = null;
        return;
      }
      It(E).isValid() && (f = It(E), t.value = It(E).utc().format("YYYY-MM-DD HH:mm:ssZ")), h.value = !h.value;
    }
    Lt(() => {
      g == null || g.on(S);
    }), Bo(() => {
      g == null || g.on(S);
    });
    const _ = () => {
      g || S();
    }, b = V(() => Gr(l.value) || a.value || v.value && n);
    return (E, C) => (Ce(), et(U($7), {
      value: v.value,
      disabled: b.value,
      "show-time": !0,
      bordered: !1,
      class: "nc-cell-field nc-cell-date-time-picker",
      format: c.value,
      placeholder: x.value,
      "allow-clear": !U(a) && !v.value && !E.isPk,
      "input-read-only": !0,
      "popup-class-name": `${y} nc-picker-datetime ${h.value ? "active" : ""}`,
      open: m.value,
      onClick: _,
      onOk: w,
      onKeydown: C[0] || (C[0] = zt((T) => h.value = !h.value, ["enter"]))
    }, null, 8, ["value", "disabled", "format", "placeholder", "allow-clear", "popup-class-name", "open"]));
  }
}), Khe = /* @__PURE__ */ Cn(Ghe, [["__scopeId", "data-v-c63acd7e"]]), od = /* @__PURE__ */ Me({
  __name: "ClampedText",
  props: {
    value: {},
    lines: {}
  },
  setup(e) {
    const t = e;
    return (n, r) => (Ce(), rt("div", {
      style: _r({
        display: "-webkit-box",
        "max-width": "100%",
        "-webkit-line-clamp": t.lines || 1,
        "-webkit-box-orient": "vertical",
        overflow: "hidden",
        "word-break": "break-all"
      })
    }, Wt(t.value || ""), 5));
  }
}), Yhe = (e) => (Xa("data-v-ed0a3325"), e = e(), Za(), e), qhe = { class: "nc-cell-url" }, Xhe = ["href", "tabindex"], Zhe = {
  key: 2,
  class: "nc-cell-text-wrapper"
}, Qhe = {
  key: 3,
  style: { marginRight: "1px", width: "10%" }
}, Jhe = /* @__PURE__ */ Yhe(() => /* @__PURE__ */ ke("div", { class: "flex flex-row items-center" }, null, -1)), eve = /* @__PURE__ */ Me({
  __name: "Url",
  props: {
    value: {},
    valueModifiers: {},
    editable: { type: Boolean },
    editableModifiers: {}
  },
  emits: ["update:value", "update:editable"],
  setup(e) {
    const t = Fr(e, "value"), n = Fr(e, "editable"), r = Ke(bs);
    Ke(jo, ne(!1));
    const a = Ke(vi, ne(!1)), o = ne(t.value), i = V({
      get: () => t.value,
      set: (c) => {
        var f;
        o.value = c, (!((f = Ga(r.value.meta)) != null && f.validate) || c && tv(c) || !c) && (t.value = c);
      }
    }), s = V(() => t.value && tv(t.value)), l = V(() => {
      const c = t.value;
      return !c || !tv(c) ? "" : /^https?:\/\//.test(c) ? c : `https://${c}`;
    });
    He(
      () => n.value,
      () => {
        var c;
        if ((c = Ga(r.value.meta)) != null && c.validate && !n.value && o.value && !tv(o.value)) {
          wt.error("无效的 URL"), o.value = void 0;
          return;
        }
        o.value = t.value;
      }
    );
    const u = ne();
    return Qa(() => {
      u.value && n.value && u.value.focus();
    }), (c, f) => {
      var d, p;
      return Ce(), rt("div", qhe, [
        !U(a) && n.value ? Yn((Ce(), rt("input", {
          key: 0,
          ref_key: "input",
          ref: u,
          "onUpdate:modelValue": f[0] || (f[0] = (v) => i.value = v),
          class: "nc-cell-field nc-cell-url-input",
          onBlur: f[1] || (f[1] = (v) => n.value = !1),
          onKeydown: [
            f[2] || (f[2] = zt(ft(() => {
            }, ["stop"]), ["down"])),
            f[3] || (f[3] = zt(ft(() => {
            }, ["stop"]), ["left"])),
            f[4] || (f[4] = zt(ft(() => {
            }, ["stop"]), ["right"])),
            f[5] || (f[5] = zt(ft(() => {
            }, ["stop"]), ["up"])),
            f[6] || (f[6] = zt(ft(() => {
            }, ["stop"]), ["delete"]))
          ],
          onSelectstartCapture: f[7] || (f[7] = ft(() => {
          }, ["stop"])),
          onMousedown: f[8] || (f[8] = ft(() => {
          }, ["stop"]))
        }, null, 544)), [
          [zi, i.value]
        ]) : s.value ? (Ce(), rt("a", {
          key: 1,
          class: "nc-cell-url-archor",
          href: l.value,
          target: "_blank",
          tabindex: U(a) ? -1 : 0
        }, [
          A(od, {
            value: e.value,
            lines: 1,
            class: "nc-cell-field",
            style: { color: "rgb(67, 81, 232)" }
          }, null, 8, ["value"])
        ], 8, Xhe)) : (Ce(), rt("span", Zhe, [
          A(od, {
            value: t.value,
            lines: 1,
            class: "nc-cell-field"
          }, null, 8, ["value"])
        ])),
        (d = U(r).meta) != null && d.validate && !s.value && ((p = e.value) != null && p.length) && !n.value ? (Ce(), rt("div", Qhe, [
          A(U(b1), { placement: "top" }, {
            title: Fe(() => [
              Jt(" 无效的 URL ")
            ]),
            default: Fe(() => [
              Jhe
            ]),
            _: 1
          })
        ])) : bt("", !0)
      ]);
    };
  }
}), tve = /* @__PURE__ */ Cn(eve, [["__scopeId", "data-v-ed0a3325"]]), nve = ["step", "onKeydown"], rve = {
  key: 1,
  class: "nc-cell-field",
  style: { "font-size": "14px", "line-height": "20px" }
}, ave = /* @__PURE__ */ Me({
  __name: "Decimal",
  props: {
    value: {},
    valueModifiers: {},
    editable: { type: Boolean },
    editableModifiers: {}
  },
  emits: ["update:value", "update:editable"],
  setup(e) {
    const t = Fr(e, "value"), n = Fr(e, "editable"), r = Ke(bs, null);
    Ke(jo, ne(!1));
    const a = Ke(vi, ne(!1)), o = V(() => typeof (r == null ? void 0 : r.value.meta) == "string" ? JSON.parse(r.value.meta) : (r == null ? void 0 : r.value.meta) ?? {}), i = V(() => t.value === null || isNaN(Number(t.value)) ? null : Number(t.value).toFixed(o.value.precision ?? 1)), s = V({
      get: () => t.value,
      set: (f) => {
        f === "" ? t.value = null : t.value = f;
      }
    }), l = V(() => {
      const d = (typeof (r == null ? void 0 : r.value.meta) == "string" ? JSON.parse(r.value.meta) : (r == null ? void 0 : r.value.meta) ?? {}).precision ?? 1;
      return Number(0.1 ** d).toFixed(d);
    }), u = (f) => {
      var d, p;
      f.key === "ArrowDown" ? (f.preventDefault(), f.target.type = "text", (d = f.target) == null || d.setSelectionRange(f.target.value.length, f.target.value.length), f.target.type = "number") : f.key === "ArrowUp" && (f.preventDefault(), f.target.type = "text", (p = f.target) == null || p.setSelectionRange(0, 0), f.target.type = "number");
    }, c = ne();
    return Qa(() => {
      c.value && n.value && c.value.focus();
    }), (f, d) => !U(a) && n.value ? Yn((Ce(), rt("input", {
      key: 0,
      ref_key: "input",
      ref: c,
      "onUpdate:modelValue": d[0] || (d[0] = (p) => s.value = p),
      class: "nc-cell-field nc-cell-decimal",
      type: "number",
      step: l.value,
      style: { "letter-spacing": "0.06rem" },
      onBlur: d[1] || (d[1] = (p) => n.value = !1),
      onKeydown: [
        zt(ft(u, ["stop"]), ["down"]),
        d[2] || (d[2] = zt(ft(() => {
        }, ["stop"]), ["left"])),
        d[3] || (d[3] = zt(ft(() => {
        }, ["stop"]), ["right"])),
        zt(ft(u, ["stop"]), ["up"]),
        d[4] || (d[4] = zt(ft(() => {
        }, ["stop"]), ["delete"]))
      ],
      onSelectstartCapture: d[5] || (d[5] = ft(() => {
      }, ["stop"])),
      onMousedown: d[6] || (d[6] = ft(() => {
      }, ["stop"]))
    }, null, 40, nve)), [
      [zi, s.value]
    ]) : (Ce(), rt("span", rve, Wt(i.value), 1));
  }
}), LS = /* @__PURE__ */ Cn(ave, [["__scopeId", "data-v-18fdb108"]]), ove = {
  key: 1,
  class: "nc-cell-field",
  style: { "font-size": "14px", "line-height": "20px" }
}, ive = /* @__PURE__ */ Me({
  __name: "Float",
  props: {
    value: {},
    valueModifiers: {},
    editable: { type: Boolean },
    editableModifiers: {}
  },
  emits: ["update:value", "update:editable"],
  setup(e) {
    const t = Fr(e, "value"), n = Fr(e, "editable");
    Ke(jo, ne(!1));
    const r = V({
      get: () => t.value,
      set: (o) => {
        o === "" ? t.value = null : t.value = o;
      }
    }), a = ne();
    return Qa(() => {
      a.value && n.value && a.value.focus();
    }), (o, i) => n.value ? Yn((Ce(), rt("input", {
      key: 0,
      ref_key: "input",
      ref: a,
      "onUpdate:modelValue": i[0] || (i[0] = (s) => r.value = s),
      class: "nc-cell-field nc-cell-float",
      type: "number",
      step: "0.1",
      onBlur: i[1] || (i[1] = (s) => n.value = !1),
      onKeydown: [
        i[2] || (i[2] = zt(ft(() => {
        }, ["stop"]), ["down"])),
        i[3] || (i[3] = zt(ft(() => {
        }, ["stop"]), ["left"])),
        i[4] || (i[4] = zt(ft(() => {
        }, ["stop"]), ["right"])),
        i[5] || (i[5] = zt(ft(() => {
        }, ["stop"]), ["up"])),
        i[6] || (i[6] = zt(ft(() => {
        }, ["stop"]), ["delete"]))
      ],
      onSelectstartCapture: i[7] || (i[7] = ft(() => {
      }, ["stop"])),
      onMousedown: i[8] || (i[8] = ft(() => {
      }, ["stop"]))
    }, null, 544)), [
      [zi, r.value]
    ]) : (Ce(), rt("span", ove, Wt(r.value), 1));
  }
}), RM = /* @__PURE__ */ Cn(ive, [["__scopeId", "data-v-884ae096"]]), sve = /* @__PURE__ */ Me({
  __name: "Text",
  props: {
    value: {},
    valueModifiers: {},
    editable: { type: Boolean },
    editableModifiers: {}
  },
  emits: ["update:value", "update:editable"],
  setup(e) {
    const t = Fr(e, "value"), n = Fr(e, "editable");
    Ke(jo, ne(!1));
    const r = Ke(vi, ne(!1)), a = ne();
    return He([a, n], ([o, i]) => {
      i && o && o.focus();
    }), (o, i) => !U(r) && n.value ? Yn((Ce(), rt("input", {
      key: 0,
      ref_key: "input",
      ref: a,
      "onUpdate:modelValue": i[0] || (i[0] = (s) => t.value = s),
      class: "nc-cell-field nc-cell-text",
      onBlur: i[1] || (i[1] = (s) => n.value = !1),
      onKeydown: [
        i[2] || (i[2] = zt(ft(() => {
        }, ["stop"]), ["down"])),
        i[3] || (i[3] = zt(ft(() => {
        }, ["stop"]), ["left"])),
        i[4] || (i[4] = zt(ft(() => {
        }, ["stop"]), ["right"])),
        i[5] || (i[5] = zt(ft(() => {
        }, ["stop"]), ["up"])),
        i[6] || (i[6] = zt(ft(() => {
        }, ["stop"]), ["delete"]))
      ],
      onSelectstartCapture: i[7] || (i[7] = ft(() => {
      }, ["stop"])),
      onMousedown: i[8] || (i[8] = ft(() => {
      }, ["stop"]))
    }, null, 544)), [
      [zi, t.value]
    ]) : (Ce(), et(od, {
      key: 1,
      class: "nc-cell-field",
      value: t.value,
      lines: 1,
      style: { "word-break": "break-word" }
    }, null, 8, ["value"]));
  }
}), BS = /* @__PURE__ */ Cn(sve, [["__scopeId", "data-v-dc6b77f3"]]), NM = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2020%2020'%20class='xygr4kl4a__design-iconfont'%20width='128'%20height='128'%3e%3cdefs%3e%3cclipPath%20id='xygr4kl4a__wolj1cn3w__z178zhvm7a'%3e%3crect%20width='20'%20height='20'%20rx='0'%3e%3c/rect%3e%3c/clipPath%3e%3c/defs%3e%3cg%20clip-path='url(%23xygr4kl4a__wolj1cn3w__z178zhvm7a)'%3e%3cpath%20d='M14,3L10,3Q9.90151,3,9.80491,3.019215Q9.70831,3.03843,9.61732,3.076121Q9.52632,3.1138120000000002,9.44443,3.16853Q9.36254,3.223249,9.29289,3.292893Q9.22325,3.362537,9.16853,3.44443Q9.11381,3.526322,9.07612,3.617317Q9.03843,3.708311,9.019210000000001,3.80491Q9,3.9015086,9,4Q9,4.0984914,9.019210000000001,4.19509Q9.03843,4.291689,9.07612,4.382683Q9.11381,4.473678,9.16853,4.55557Q9.22325,4.637463,9.29289,4.707107Q9.36254,4.776751,9.44443,4.83147Q9.52632,4.886188,9.61732,4.923879Q9.70831,4.96157,9.80491,4.980785Q9.90151,5,10,5L14,5Q14.4142,5,14.7071,5.29289Q15,5.58579,15,6L15,10Q15,10.09849,15.0192,10.19509Q15.0384,10.29169,15.0761,10.38268Q15.1138,10.47368,15.1685,10.55557Q15.2232,10.63746,15.2929,10.70711Q15.3625,10.77675,15.4444,10.83147Q15.5263,10.88619,15.6173,10.92388Q15.7083,10.96157,15.8049,10.98078Q15.9015,11,16,11Q16.0985,11,16.1951,10.98078Q16.2917,10.96157,16.3827,10.92388Q16.4737,10.88619,16.5556,10.83147Q16.6375,10.77675,16.7071,10.70711Q16.776699999999998,10.63746,16.8315,10.55557Q16.886200000000002,10.47368,16.9239,10.38268Q16.9616,10.29169,16.980800000000002,10.19509Q17,10.09849,17,10L17,6Q17,4.75736,16.121299999999998,3.87868Q15.2426,3,14,3ZM5,14L5,10Q5,9.90151,4.980785,9.80491Q4.96157,9.70831,4.923879,9.61732Q4.886188,9.52632,4.83147,9.44443Q4.776751,9.36254,4.707107,9.29289Q4.637463,9.22325,4.55557,9.16853Q4.473678,9.11381,4.382683,9.07612Q4.291689,9.03843,4.19509,9.019210000000001Q4.0984914,9,4,9Q3.9015086,9,3.80491,9.019210000000001Q3.708311,9.03843,3.617317,9.07612Q3.526322,9.11381,3.44443,9.16853Q3.362537,9.22325,3.292893,9.29289Q3.223249,9.36254,3.16853,9.44443Q3.1138120000000002,9.52632,3.076121,9.61732Q3.03843,9.70831,3.019215,9.80491Q3,9.90151,3,10L3,14Q3,15.2426,3.87868,16.121299999999998Q4.75736,17,6,17L10,17Q10.09849,17,10.19509,16.980800000000002Q10.29169,16.9616,10.38268,16.9239Q10.47368,16.886200000000002,10.55557,16.8315Q10.63746,16.776699999999998,10.70711,16.7071Q10.77675,16.6375,10.83147,16.5556Q10.88619,16.4737,10.92388,16.3827Q10.96157,16.2917,10.98078,16.1951Q11,16.0985,11,16Q11,15.9015,10.98078,15.8049Q10.96157,15.7083,10.92388,15.6173Q10.88619,15.5263,10.83147,15.4444Q10.77675,15.3625,10.70711,15.2929Q10.63746,15.2232,10.55557,15.1685Q10.47368,15.1138,10.38268,15.0761Q10.29169,15.0384,10.19509,15.0192Q10.09849,15,10,15L6,15Q5.58579,15,5.29289,14.7071Q5,14.4142,5,14Z'%20fill-rule='evenodd'%3e%3c/path%3e%3c/g%3e%3c/svg%3e", lve = { class: "nc-long-text-wrapper long-text-wrapper" }, uve = ["disabled"], cve = ["src"], fve = {
  key: 0,
  class: "header"
}, dve = ["innerHTML"], pve = { class: "content" }, hve = /* @__PURE__ */ Me({
  __name: "TextArea",
  props: /* @__PURE__ */ Zl({
    modelValue: {},
    isFocus: { type: Boolean },
    virtual: { type: Boolean }
  }, {
    value: {},
    valueModifiers: {},
    editable: { type: Boolean },
    editableModifiers: {}
  }),
  emits: ["update:value", "update:editable"],
  setup(e) {
    const t = e, n = Fr(e, "value"), r = Fr(e, "editable"), a = Ke(bs), o = Ke(jo, ne(!1)), i = ne(!1), s = ne(null), l = ne(null), u = Ke(vi), c = ne();
    Qa(() => {
      c.value && r.value && c.value.focus();
    }), He(i, () => {
      i.value && setTimeout(() => {
        var v;
        (v = l.value) == null || v.focus();
      }, 100);
    });
    const f = () => {
      t.virtual && (i.value = !0, r.value = !0);
    }, d = () => {
      i.value = !0;
    }, p = (v) => {
      v.stopPropagation();
    };
    return He(s, () => {
      if (!o.value) return;
      const v = document.querySelector(".nc-long-text-expanded-modal");
      i.value && (v != null && v.parentElement) ? (v.parentElement.addEventListener("click", p), v.parentElement.addEventListener("mousedown", p), v.parentElement.addEventListener("mouseup", p)) : v != null && v.parentElement && (v.parentElement.removeEventListener("click", p), v.parentElement.removeEventListener("mousedown", p), v.parentElement.removeEventListener("mouseup", p));
    }), (v, h) => (Ce(), rt(dt, null, [
      ke("div", lve, [
        r.value && !i.value ? Yn((Ce(), rt("textarea", {
          key: 0,
          ref_key: "textarea",
          ref: c,
          "onUpdate:modelValue": h[0] || (h[0] = (m) => n.value = m),
          rows: 4,
          class: tn(["nc-long-text nc-longtext-scrollbar", { editable: r.value }]),
          disabled: U(u),
          onBlur: h[1] || (h[1] = (m) => r.value = !1),
          onKeydown: [
            h[2] || (h[2] = zt(ft(() => {
            }, ["alt", "stop"]), ["enter"])),
            h[3] || (h[3] = zt(ft(() => {
            }, ["shift", "stop"]), ["enter"])),
            h[4] || (h[4] = zt(ft(() => {
            }, ["stop"]), ["down"])),
            h[5] || (h[5] = zt(ft(() => {
            }, ["stop"]), ["left"])),
            h[6] || (h[6] = zt(ft(() => {
            }, ["stop"]), ["right"])),
            h[7] || (h[7] = zt(ft(() => {
            }, ["stop"]), ["up"])),
            h[8] || (h[8] = zt(ft(() => {
            }, ["stop"]), ["delete"]))
          ],
          onSelectstartCapture: h[9] || (h[9] = ft(() => {
          }, ["stop"])),
          onMousedown: h[10] || (h[10] = ft(() => {
          }, ["stop"]))
        }, null, 42, uve)), [
          [zi, n.value]
        ]) : (Ce(), et(od, {
          key: 1,
          value: n.value,
          lines: 1,
          class: "nc-text-area-clamped-text",
          style: {
            "word-break": "break-word",
            "max-height": "25px"
          },
          onClick: f
        }, null, 8, ["value"])),
        i.value ? bt("", !0) : (Ce(), et(IS, {
          key: 2,
          placement: "bottom"
        }, {
          title: Fe(() => [
            Jt("展开")
          ]),
          default: Fe(() => [
            ke("button", {
              class: "nc-text-area-expand-btn",
              size: "small",
              onClick: ft(d, ["stop"])
            }, [
              ke("img", {
                class: "expand-icon",
                src: U(NM)
              }, null, 8, cve)
            ])
          ]),
          _: 1
        }))
      ]),
      i.value ? (Ce(), et(U(Ka), {
        key: 0,
        visible: i.value,
        "onUpdate:visible": h[14] || (h[14] = (m) => i.value = m),
        "wrap-class-name": "nc-long-text-expanded-modal",
        width: 1e3,
        closable: !1,
        footer: null,
        mask: !0,
        "mask-style": { zIndex: 1051 },
        "z-index": 1052,
        centered: ""
      }, {
        default: Fe(() => [
          ke("div", {
            ref_key: "inputWrapperRef",
            ref: s,
            class: "expanded-cell-input",
            onKeydown: h[13] || (h[13] = zt(ft(() => {
            }, ["stop"]), ["enter"]))
          }, [
            U(a) ? (Ce(), rt("div", fve, [
              ke("span", {
                innerHTML: U(C4)[U(we).LongText]
              }, null, 8, dve),
              ke("span", null, Wt(U(a).title), 1)
            ])) : bt("", !0),
            ke("div", pve, [
              A(U(k7), {
                ref_key: "inputRef",
                ref: l,
                value: n.value,
                "onUpdate:value": h[11] || (h[11] = (m) => n.value = m),
                class: "nc-text-area-expanded nc-longtext-scrollbar",
                placeholder: "输入文本",
                disabled: U(u),
                onKeydown: h[12] || (h[12] = zt((m) => i.value = !1, ["escape"]))
              }, null, 8, ["value", "disabled"])
            ])
          ], 544)
        ]),
        _: 1
      }, 8, ["visible"])) : bt("", !0)
    ], 64));
  }
}), vve = /* @__PURE__ */ Cn(hve, [["__scopeId", "data-v-2a33a11a"]]), mve = {
  key: 1,
  class: "nc-cell-field",
  style: { "font-size": "14px", "line-height": "20px" }
}, gve = /* @__PURE__ */ Me({
  __name: "Integer",
  props: {
    value: {},
    valueModifiers: {},
    editable: { type: Boolean },
    editableModifiers: {}
  },
  emits: ["update:value", "update:editable"],
  setup(e) {
    const t = Fr(e, "value"), n = Fr(e, "editable");
    Ke(jo, ne(!1));
    const r = Ke(vi, ne(!1)), a = V(() => t.value === null || isNaN(Number(t.value)) ? null : Number(t.value)), o = V({
      get: () => t.value,
      set: (l) => {
        l === "" ? t.value = null : t.value = l;
      }
    });
    function i(l) {
      var c, f;
      if ((nd() ? l.metaKey : l.ctrlKey) && !l.altKey)
        switch (l.keyCode) {
          case 90: {
            l.stopPropagation();
            break;
          }
        }
      if (l.key === ".")
        return l.preventDefault();
      l.key === "ArrowDown" ? (l.preventDefault(), l.target.type = "text", (c = l.target) == null || c.setSelectionRange(l.target.value.length, l.target.value.length), l.target.type = "number") : l.key === "ArrowUp" && (l.preventDefault(), l.target.type = "text", (f = l.target) == null || f.setSelectionRange(0, 0), l.target.type = "number");
    }
    const s = ne();
    return Qa(() => {
      s.value && n.value && s.value.focus();
    }), (l, u) => !U(r) && n.value ? Yn((Ce(), rt("input", {
      key: 0,
      ref_key: "input",
      ref: s,
      "onUpdate:modelValue": u[0] || (u[0] = (c) => o.value = c),
      class: "nc-cell-field nc-cell-integer",
      type: "number",
      onBlur: u[1] || (u[1] = (c) => n.value = !1),
      onKeydown: [
        i,
        u[2] || (u[2] = zt(ft(() => {
        }, ["stop"]), ["down"])),
        u[3] || (u[3] = zt(ft(() => {
        }, ["stop"]), ["left"])),
        u[4] || (u[4] = zt(ft(() => {
        }, ["stop"]), ["right"])),
        u[5] || (u[5] = zt(ft(() => {
        }, ["stop"]), ["up"])),
        u[6] || (u[6] = zt(ft(() => {
        }, ["stop"]), ["delete"]))
      ],
      onSelectstartCapture: u[7] || (u[7] = ft(() => {
      }, ["stop"])),
      onMousedown: u[8] || (u[8] = ft(() => {
      }, ["stop"]))
    }, null, 544)), [
      [zi, o.value]
    ]) : (Ce(), rt("span", mve, Wt(a.value), 1));
  }
}), FM = /* @__PURE__ */ Cn(gve, [["__scopeId", "data-v-9a0c901b"]]), yve = {
  key: 14,
  class: "nc-locked-overlay"
}, xve = /* @__PURE__ */ Me({
  __name: "Cell",
  props: {
    column: {},
    modelValue: {},
    editEnabled: { type: Boolean },
    readOnly: { type: Boolean },
    rowIndex: {},
    active: { type: Boolean },
    virtual: { type: Boolean }
  },
  emits: [
    "update:modelValue",
    "save",
    "navigate",
    "update:editEnabled",
    "update:cdf"
  ],
  setup(e, { emit: t }) {
    const n = e, r = t, a = Tt(n, "column"), o = Tt(n, "active", !1), i = Tt(n, "readOnly", !1);
    kt(bs, a);
    const s = Ra(n, "editEnabled", r);
    kt(gd, s), kt(Cc, o), kt(vi, i);
    const l = Ke(_c, ne(!1)), u = Ke(jo, ne(!1)), { currentRow: c } = MU(), { sqlUis: f } = Fn(ws()), d = V(() => {
      var b;
      const _ = (b = a.value) == null ? void 0 : b.source_id;
      return _ ? f.value[_] : Object.values(f.value)[0];
    }), p = V(() => {
      var _;
      return a.value && ((_ = d.value) == null ? void 0 : _.getAbstractType(a.value));
    }), v = V8(
      () => {
        c.value.rowMeta.changed = !1, r("save");
      },
      500,
      { maxWait: 2e3 }
    ), h = V({
      get: () => n.modelValue,
      set: (_) => {
        u.value ? r("update:cdf", _) : _ !== n.modelValue && (c.value.rowMeta.changed = !0, r("update:modelValue", _), u0e(a.value) ? v() : r("save"));
      }
    }), m = V(() => Um(a.value, p.value) || CS(a.value, p.value) || $S(a.value)), y = (_) => {
      n.editEnabled && M2(a.value) && _.stopPropagation();
    }, x = ne(!1), g = ne(), S = ne();
    function w() {
      g.value = new IntersectionObserver((_) => {
        _.forEach((b) => {
          var E;
          b.isIntersecting && (x.value = !0, (E = g.value) == null || E.disconnect(), g.value = void 0);
        });
      });
    }
    return Lt(() => {
      var _;
      w(), (_ = g.value) == null || _.observe(S.value);
    }), Bo(() => {
      var _;
      (_ = g.value) == null || _.disconnect();
    }), (_, b) => {
      var E;
      return Ce(), rt("div", {
        ref_key: "elementToObserve",
        ref: S,
        class: tn(["nc-cell", [
          `nc-cell-${(((E = a.value) == null ? void 0 : E.uidt) || "default").toLowerCase()}`,
          {
            "nc-cell-primary": U(c0e)(a.value) && !n.virtual,
            "nc-grid-numeric-cell-right": m.value && !U(u),
            "nc-grid-numeric-cell-left": U(u)
          }
        ]]),
        onContextmenu: y
      }, [
        a.value ? (Ce(), rt(dt, { key: 0 }, [
          x.value ? (Ce(), rt(dt, { key: 0 }, [
            U(i0e)(a.value) ? (Ce(), et(od, {
              key: 0,
              value: h.value
            }, null, 8, ["value"])) : U(s0e)(a.value) ? (Ce(), et(od, {
              key: 1,
              value: h.value ? U(It)(h.value).format("YYYY-MM-DD HH:mm:ss") : ""
            }, null, 8, ["value"])) : U(a0e)(a.value) ? (Ce(), et(vve, {
              key: 2,
              value: h.value,
              "onUpdate:value": b[0] || (b[0] = (C) => h.value = C),
              editable: U(s),
              "onUpdate:editable": b[1] || (b[1] = (C) => Ft(s) ? s.value = C : null)
            }, null, 8, ["value", "editable"])) : U(sM)(a.value, p.value) ? (Ce(), et(she, {
              key: 3,
              value: h.value,
              "onUpdate:value": b[2] || (b[2] = (C) => h.value = C)
            }, null, 8, ["value"])) : U(lM)(a.value) ? (Ce(), et(kM, {
              key: 4,
              value: h.value,
              "onUpdate:value": b[3] || (b[3] = (C) => h.value = C),
              "disable-option-creation": !!U(u),
              "row-index": n.rowIndex
            }, null, 8, ["value", "disable-option-creation", "row-index"])) : U(uM)(a.value) ? (Ce(), et(FS, {
              key: 5,
              value: h.value,
              "onUpdate:value": b[4] || (b[4] = (C) => h.value = C),
              "disable-option-creation": !!U(u),
              "row-index": n.rowIndex
            }, null, 8, ["value", "disable-option-creation", "row-index"])) : U(ES)(a.value, p.value) ? (Ce(), et(MM, {
              key: 6,
              value: h.value,
              "onUpdate:value": b[5] || (b[5] = (C) => h.value = C),
              "is-pk": U(x6)(a.value)
            }, null, 8, ["value", "is-pk"])) : U(TS)(a.value, p.value) ? (Ce(), et(Khe, {
              key: 7,
              value: h.value,
              "onUpdate:value": b[6] || (b[6] = (C) => h.value = C),
              "is-pk": U(x6)(a.value),
              "is-updated-from-copy-n-paste": U(c).rowMeta.isUpdatedFromCopyNPaste
            }, null, 8, ["value", "is-pk", "is-updated-from-copy-n-paste"])) : U(l0e)(a.value) ? (Ce(), et(tve, {
              key: 8,
              value: h.value,
              "onUpdate:value": b[7] || (b[7] = (C) => h.value = C),
              editable: U(s),
              "onUpdate:editable": b[8] || (b[8] = (C) => Ft(s) ? s.value = C : null)
            }, null, 8, ["value", "editable"])) : U($S)(a.value) ? (Ce(), et(LS, {
              key: 9,
              value: h.value,
              "onUpdate:value": b[9] || (b[9] = (C) => h.value = C),
              editable: U(s),
              "onUpdate:editable": b[10] || (b[10] = (C) => Ft(s) ? s.value = C : null)
            }, null, 8, ["value", "editable"])) : U(CS)(a.value, p.value) ? (Ce(), et(RM, {
              key: 10,
              value: h.value,
              "onUpdate:value": b[11] || (b[11] = (C) => h.value = C),
              editable: U(s),
              "onUpdate:editable": b[12] || (b[12] = (C) => Ft(s) ? s.value = C : null)
            }, null, 8, ["value", "editable"])) : U(o0e)(a.value, p.value) ? (Ce(), et(BS, {
              key: 11,
              value: h.value,
              "onUpdate:value": b[13] || (b[13] = (C) => h.value = C),
              editable: U(s),
              "onUpdate:editable": b[14] || (b[14] = (C) => Ft(s) ? s.value = C : null)
            }, null, 8, ["value", "editable"])) : U(Um)(a.value, p.value) ? (Ce(), et(FM, {
              key: 12,
              value: h.value,
              "onUpdate:value": b[15] || (b[15] = (C) => h.value = C),
              editable: U(s),
              "onUpdate:editable": b[16] || (b[16] = (C) => Ft(s) ? s.value = C : null)
            }, null, 8, ["value", "editable"])) : (Ce(), et(BS, {
              key: 13,
              value: h.value,
              "onUpdate:value": b[17] || (b[17] = (C) => h.value = C)
            }, null, 8, ["value"])),
            U(l) && i.value || U(Gr)(a.value) && !U(cM)(a.value) ? (Ce(), rt("div", yve)) : bt("", !0)
          ], 64)) : bt("", !0)
        ], 64)) : bt("", !0)
      ], 34);
    };
  }
}), N4 = /* @__PURE__ */ Cn(xve, [["__scopeId", "data-v-593d64ad"]]), bve = (e) => (Xa("data-v-f841a0de"), e = e(), Za(), e), wve = { class: "nc-column-default-value" }, Sve = /* @__PURE__ */ bve(() => /* @__PURE__ */ ke("div", { class: "label" }, "默认值", -1)), _ve = /* @__PURE__ */ Me({
  __name: "DefaultValue",
  props: {
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    var u;
    const n = e, r = t;
    kt(jo, ne(!0));
    const a = Ra(n, "value", r), o = ne({
      row: {},
      oldRow: {},
      rowMeta: {
        isUpdatedFromCopyNPaste: [(u = a.value) == null ? void 0 : u.title]
      }
    });
    B_(ne(void 0), o);
    const i = ne(null), s = ne(!1), l = (c) => {
      a.value = { ...a.value, cdf: c }, i.value = c;
    };
    return Lt(() => {
      var c;
      l((c = a.value) != null && c.cdf ? a.value.cdf : null);
    }), He(
      () => a.value.cdf,
      (c) => {
        i.value = c;
      }
    ), (c, f) => (Ce(), rt("div", wve, [
      Sve,
      ke("div", {
        class: tn(["content", { edit: s.value }])
      }, [
        A(N4, {
          "edit-enabled": !0,
          "model-value": i.value,
          column: U(a),
          "onUpdate:cdf": l,
          "onUpdate:editEnabled": f[0] || (f[0] = (d) => s.value = d),
          onClick: f[1] || (f[1] = (d) => s.value = !0)
        }, null, 8, ["model-value", "column"])
      ], 2)
    ]));
  }
}), Cve = /* @__PURE__ */ Cn(_ve, [["__scopeId", "data-v-f841a0de"]]), Eve = { class: "nc-column-advanced-options" }, Tve = { class: "checkboxs" }, $ve = /* @__PURE__ */ Me({
  __name: "AdvancedOptions",
  props: {
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const a = Ra(e, "value", t), { onAlter: o, onDataTypeChange: i, validateInfos: s, sqlUi: l } = O4(), u = V(
      () => {
        var f;
        return (f = l.value) == null ? void 0 : f.getDataTypeListForUiType(a.value, "");
      }
    ), c = V(() => [we.SingleSelect, we.MultiSelect].includes(a.value.uidt));
    return (f, d) => {
      var p, v, h, m;
      return Ce(), rt("div", Eve, [
        ke("div", Tve, [
          A(U(Jr), { label: "NN" }, {
            default: Fe(() => {
              var y;
              return [
                A(U(aa), {
                  checked: U(a).rqd,
                  "onUpdate:checked": d[0] || (d[0] = (x) => U(a).rqd = x),
                  disabled: U(a).pk || !((y = U(l)) != null && y.columnEditable(U(a))),
                  class: "nc-column-checkbox-NN",
                  onChange: U(o)
                }, null, 8, ["checked", "disabled", "onChange"])
              ];
            }),
            _: 1
          }),
          A(U(Jr), { label: "PK" }, {
            default: Fe(() => {
              var y;
              return [
                A(U(aa), {
                  checked: U(a).pk,
                  "onUpdate:checked": d[1] || (d[1] = (x) => U(a).pk = x),
                  disabled: !((y = U(l)) != null && y.columnEditable(U(a))),
                  class: "nc-column-checkbox-PK",
                  onChange: U(o)
                }, null, 8, ["checked", "disabled", "onChange"])
              ];
            }),
            _: 1
          }),
          A(U(Jr), { label: "AI" }, {
            default: Fe(() => {
              var y, x;
              return [
                A(U(aa), {
                  checked: U(a).ai,
                  "onUpdate:checked": d[2] || (d[2] = (g) => U(a).ai = g),
                  disabled: ((y = U(l)) == null ? void 0 : y.colPropUNDisabled(U(a))) || !((x = U(l)) != null && x.columnEditable(U(a))),
                  class: "nc-column-checkbox-AI",
                  onChange: U(o)
                }, null, 8, ["checked", "disabled", "onChange"])
              ];
            }),
            _: 1
          }),
          A(U(Jr), {
            label: "UN",
            disabled: ((p = U(l)) == null ? void 0 : p.colPropUNDisabled(U(a))) || !((v = U(l)) != null && v.columnEditable(U(a))),
            onChange: U(o)
          }, {
            default: Fe(() => [
              A(U(aa), {
                checked: U(a).un,
                "onUpdate:checked": d[3] || (d[3] = (y) => U(a).un = y),
                class: "nc-column-checkbox-UN"
              }, null, 8, ["checked"])
            ]),
            _: 1
          }, 8, ["disabled", "onChange"]),
          A(U(Jr), {
            label: "AU",
            disabled: ((h = U(l)) == null ? void 0 : h.colPropAuDisabled(U(a))) || !((m = U(l)) != null && m.columnEditable(U(a))),
            onChange: U(o)
          }, {
            default: Fe(() => [
              A(U(aa), {
                checked: U(a).au,
                "onUpdate:checked": d[4] || (d[4] = (y) => U(a).au = y),
                class: "nc-column-checkbox-AU"
              }, null, 8, ["checked"])
            ]),
            _: 1
          }, 8, ["disabled", "onChange"])
        ]),
        A(U(Jr), sc({ label: "数据库中的类型" }, U(s).dt), {
          default: Fe(() => [
            A(U(fo), {
              style: { "margin-top": "8px" },
              value: U(a).dt,
              "onUpdate:value": d[5] || (d[5] = (y) => U(a).dt = y),
              "popup-class-name": "nc-dropdown-db-type",
              onChange: U(i)
            }, {
              default: Fe(() => [
                (Ce(!0), rt(dt, null, Vn(u.value, (y, x) => (Ce(), et(U(ia), {
                  key: x,
                  value: y
                }, {
                  default: Fe(() => [
                    Jt(Wt(y), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))), 128))
              ]),
              _: 1
            }, 8, ["value", "onChange"])
          ]),
          _: 1
        }, 16),
        c.value ? bt("", !0) : (Ce(), et(U(Jr), {
          key: 0,
          label: "长度/值"
        }, {
          default: Fe(() => {
            var y, x;
            return [
              A(U(dr), {
                value: U(a).dtxp,
                "onUpdate:value": d[6] || (d[6] = (g) => U(a).dtxp = g),
                style: { "border-radius": "6px !important", "margin-top": "2px !important" },
                disabled: ((y = U(l)) == null ? void 0 : y.getDefaultLengthIsDisabled(U(a).dt)) || !((x = U(l)) != null && x.columnEditable(U(a))),
                onInput: U(o)
              }, null, 8, ["value", "disabled", "onInput"])
            ];
          }),
          _: 1
        }))
      ]);
    };
  }
}), Ove = /* @__PURE__ */ Cn($ve, [["__scopeId", "data-v-9533a548"]]), Ave = (e) => (Xa("data-v-d2b18213"), e = e(), Za(), e), Ive = { class: "form-items" }, Pve = ["innerHTML"], Dve = { class: "item-label" }, kve = { class: "label" }, Mve = /* @__PURE__ */ Ave(() => /* @__PURE__ */ ke("span", { class: "label" }, "必填", -1)), Rve = { class: "actions" }, Nve = /* @__PURE__ */ Me({
  __name: "EditOrAdd",
  props: {
    table: {},
    preload: {},
    columnPosition: {}
  },
  emits: ["submit", "cancel", "mounted", "add", "update"],
  setup(e, { emit: t }) {
    const n = e, r = t, {
      formState: a,
      generateNewColumnMeta: o,
      addOrUpdate: i,
      onAlter: s,
      onUidtOrIdTypeChange: l,
      validateInfos: u,
      setAdditionalValidations: c,
      isEdit: f
    } = O4(), d = Tt(n, "table"), p = Ke(vo), v = ne(!1), h = ne(!1), m = ne(!1), y = V(() => {
      var b, E;
      return [
        ...Ace,
        ...!f.value && ((E = (b = d.value) == null ? void 0 : b.columns) != null && E.every((C) => !C.pk)) ? [{ label: "ID", name: we.ID, iconfont: "", virtual: 0 }] : []
      ];
    }), x = ne(!1);
    async function g() {
      x.value = !0;
      const b = await i(async () => {
        p == null || p.trigger();
      }, n.columnPosition);
      x.value = !1, b && (setTimeout(() => {
        v.value = !1;
      }, 500), r("submit"));
    }
    const S = ne();
    _n(() => {
      S.value && a.value && setTimeout(() => {
        var b, E;
        (document.activeElement === document.body || document.activeElement === null) && ((b = S.value) == null || b.focus(), (E = S.value) == null || E.select());
      }, 300), v.value = !1;
    }), Lt(() => {
      var b;
      if (f.value ? a.value.pk ? (wt.info("不支持编辑主键"), r("cancel")) : Gr(a.value) && (wt.info("不支持编辑系统密钥"), r("cancel")) : o(), n.preload) {
        const { colOptions: E, ...C } = n.preload;
        a.value = {
          ...a.value,
          ...C
        }, E && (l(), a.value = {
          ...a.value,
          colOptions: {
            ...E
          }
        });
      }
      a.value && !a.value.column_name && (a.value.column_name = (b = a.value) == null ? void 0 : b.title), nn(() => {
        var E;
        h.value = !0, r("mounted"), f.value || (E = a.value) != null && E.temp_id || r("add", a.value);
      });
    });
    const w = (b) => {
      m.value || b.key === "Escape" && r("cancel");
    }, _ = (b) => {
      b ? m.value = b : setTimeout(() => {
        m.value = b;
      }, 300);
    };
    return He(
      () => a.value.rqd,
      (b) => {
        c(b ? {
          cdf: [
            {
              required: !0,
              message: "必填字段需要有默认值"
            }
          ]
        } : {
          cdf: [
            {
              required: !1
            }
          ]
        });
      }
    ), (b, E) => (Ce(), rt("div", {
      class: tn(["nc-edit-or-add-column", { "is-attachment": U(a).uidt === U(we).Attachment }]),
      onKeydown: w,
      onClick: E[12] || (E[12] = ft(() => {
      }, ["stop"]))
    }, [
      A(U(Bs), {
        model: U(a),
        "no-style": "",
        name: "column-create-or-edit",
        layout: "vertical"
      }, {
        default: Fe(() => [
          ke("div", Ive, [
            A(U(Jr), sc({ label: "字段名称" }, U(u).title, { required: !1 }), {
              default: Fe(() => [
                A(U(dr), {
                  ref_key: "antInput",
                  ref: S,
                  value: U(a).title,
                  "onUpdate:value": E[0] || (E[0] = (C) => U(a).title = C),
                  class: "nc-column-name-input",
                  onInput: E[1] || (E[1] = (C) => U(s)(8))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 16),
            A(U(Jr), { label: "字段类型" }, {
              default: Fe(() => [
                A(U(fo), {
                  class: "nc-column-type-select",
                  value: U(a).uidt,
                  "onUpdate:value": E[2] || (E[2] = (C) => U(a).uidt = C),
                  "show-search": "",
                  "popup-class-name": "nc-dropdown-column-type",
                  onDropdownVisibleChange: _,
                  onChange: U(l)
                }, {
                  suffixIcon: Fe(() => []),
                  default: Fe(() => [
                    (Ce(!0), rt(dt, null, Vn(y.value, (C) => (Ce(), et(U(ia), sc({
                      key: C.name,
                      value: C.name,
                      ref_for: !0
                    }, U(u).uidt), {
                      default: Fe(() => [
                        ke("div", {
                          innerHTML: U(C4)[C.name]
                        }, null, 8, Pve),
                        ke("div", Dve, Wt(C.label), 1)
                      ]),
                      _: 2
                    }, 1040, ["value"]))), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onChange"])
              ]),
              _: 1
            }),
            U(a).uidt === U(we).Date ? (Ce(), et(lpe, {
              key: 0,
              value: U(a),
              "onUpdate:value": E[3] || (E[3] = (C) => Ft(a) ? a.value = C : null)
            }, null, 8, ["value"])) : bt("", !0),
            U(a).uidt === U(we).Decimal ? (Ce(), et(upe, {
              key: 1,
              value: U(a),
              "onUpdate:value": E[4] || (E[4] = (C) => Ft(a) ? a.value = C : null)
            }, null, 8, ["value"])) : bt("", !0),
            U(a).uidt === U(we).DateTime ? (Ce(), et(cpe, {
              key: 2,
              value: U(a),
              "onUpdate:value": E[5] || (E[5] = (C) => Ft(a) ? a.value = C : null)
            }, null, 8, ["value"])) : bt("", !0),
            U(a).uidt === U(we).SingleSelect || U(a).uidt === U(we).MultiSelect ? (Ce(), et(ahe, {
              key: 3,
              value: U(a),
              "onUpdate:value": E[6] || (E[6] = (C) => Ft(a) ? a.value = C : null),
              "from-table-explorer": !1
            }, null, 8, ["value"])) : bt("", !0)
          ]),
          U(a).meta && U(OS).includes(U(a).uidt) ? (Ce(), et(U(aa), {
            key: 0,
            checked: U(a).meta.validate,
            "onUpdate:checked": E[7] || (E[7] = (C) => U(a).meta.validate = C),
            class: "nc-column-checkbox"
          }, {
            default: Fe(() => [
              ke("span", kve, Wt(`仅接受 ${U(a).uidt}`), 1)
            ]),
            _: 1
          }, 8, ["checked"])) : bt("", !0),
          A(U(Jr), XO(E_(U(u).cdf)), {
            default: Fe(() => [
              U(cM)(U(a)) ? bt("", !0) : (Ce(), et(Cve, {
                key: 0,
                value: U(a),
                "onUpdate:value": E[8] || (E[8] = (C) => Ft(a) ? a.value = C : null)
              }, null, 8, ["value"]))
            ]),
            _: 1
          }, 16),
          A(U(Jr), null, {
            default: Fe(() => [
              A(U(aa), {
                checked: U(a).rqd,
                "onUpdate:checked": E[9] || (E[9] = (C) => U(a).rqd = C)
              }, {
                default: Fe(() => [
                  Mve
                ]),
                _: 1
              }, 8, ["checked"])
            ]),
            _: 1
          }),
          A(Ho, {
            name: "layout",
            mode: "out-in"
          }, {
            default: Fe(() => [
              v.value && U(a).uidt !== U(we).Attachment ? (Ce(), et(Ove, {
                key: 0,
                value: U(a),
                "onUpdate:value": E[10] || (E[10] = (C) => Ft(a) ? a.value = C : null)
              }, null, 8, ["value"])) : bt("", !0)
            ]),
            _: 1
          }),
          A(U(Jr), null, {
            default: Fe(() => [
              ke("div", Rve, [
                A(U(fn), {
                  class: "cancel",
                  "html-type": "button",
                  onClick: E[11] || (E[11] = (C) => r("cancel"))
                }, {
                  default: Fe(() => [
                    Jt(" 取消 ")
                  ]),
                  _: 1
                }),
                A(U(fn), {
                  class: "save",
                  "html-type": "submit",
                  type: "primary",
                  loading: x.value,
                  onClick: ft(g, ["prevent"])
                }, {
                  default: Fe(() => [
                    Jt(" 保存 ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ], 34));
  }
}), Fve = /* @__PURE__ */ Cn(Nve, [["__scopeId", "data-v-d2b18213"]]), LM = /* @__PURE__ */ Me({
  __name: "EditOrAddProvider",
  props: {
    column: {},
    columnPosition: {},
    preload: {}
  },
  emits: ["submit", "cancel", "mounted"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = Tt(n, "column"), o = Tt(n, "preload"), { tableActivated: i } = Fn(mo());
    return v0e(i, a), (s, l) => (Ce(), et(Fve, {
      table: U(i),
      preload: o.value,
      "column-position": n.columnPosition,
      onSubmit: l[0] || (l[0] = (u) => r("submit")),
      onCancel: l[1] || (l[1] = (u) => r("cancel")),
      onMounted: l[2] || (l[2] = (u) => r("mounted"))
    }, null, 8, ["table", "preload", "column-position"]));
  }
}), Lve = (e) => (Xa("data-v-9aa40cfb"), e = e(), Za(), e), Bve = ["innerHTML"], Hve = {
  key: 0,
  class: "wtf"
}, jve = /* @__PURE__ */ Lve(() => /* @__PURE__ */ ke("div", null, null, -1)), Vve = /* @__PURE__ */ Me({
  __name: "HeaderCell",
  props: {
    column: {},
    required: { type: [Boolean, Number] },
    hideMenu: { type: Boolean },
    hideIcon: { type: Boolean }
  },
  setup(e) {
    const t = e, n = Tt(t, "hideMenu"), r = ne(!1), a = Tt(t, "column");
    kt(bs, a);
    const o = ne(!1), i = ne(null), s = V(() => {
      var p, v;
      return a.value.uidt === we.LongText && ((v = Ga((p = a == null ? void 0 : a.value) == null ? void 0 : p.meta)) != null && v.richMode) ? L3.RichText : a.value.uidt ? L3[a.value.uidt] : "";
    }), l = async (p) => {
      i.value = p, o.value = !0;
    }, u = () => {
      i.value = null, o.value = !1;
    }, c = () => {
      o.value = !0;
    }, f = (p) => {
      p.preventDefault(), p.stopPropagation(), r.value = !r.value;
    }, d = (p) => {
      r.value && (p.preventDefault(), p.stopPropagation()), r.value = !1;
    };
    return (p, v) => (Ce(), rt("div", {
      class: "nc-header-cell",
      onDblclick: c,
      onContextmenu: ft(f, ["right"]),
      onClick: d
    }, [
      a.value && a.value.uidt && !t.hideIcon ? (Ce(), et(IS, {
        key: 0,
        class: "tooltip",
        placement: "bottom"
      }, {
        title: Fe(() => [
          Jt(Wt(s.value), 1)
        ]),
        default: Fe(() => [
          ke("div", {
            class: "column-icon",
            innerHTML: U(C4)[a.value.uidt]
          }, null, 8, Bve)
        ]),
        _: 1
      })) : bt("", !0),
      a.value ? (Ce(), et(IS, {
        key: 1,
        class: tn([{ show: !n.value, hide: n.value }, "name"]),
        placement: "bottom",
        "show-on-truncate-only": ""
      }, {
        title: Fe(() => [
          Jt(Wt(a.value.column_name), 1)
        ]),
        default: Fe(() => [
          ke("span", null, [
            a.value.rqd && !a.value.cdf || p.required ? (Ce(), rt("span", Hve, "  * ")) : bt("", !0),
            Jt(" " + Wt(a.value.column_name), 1)
          ])
        ]),
        _: 1
      }, 8, ["class"])) : bt("", !0),
      n.value ? bt("", !0) : (Ce(), et(spe, {
        key: 2,
        column: a.value,
        "is-open": r.value,
        "onUpdate:isOpen": v[0] || (v[0] = (h) => r.value = h),
        onAddColumn: l,
        onEdit: c
      }, null, 8, ["column", "is-open"])),
      A(U(cs), {
        open: o.value,
        "onUpdate:open": v[3] || (v[3] = (h) => o.value = h),
        style: { height: "100%" },
        trigger: ["click"],
        placement: "bottomRight",
        "overlay-class-name": "nc-dropdown-edit-column"
      }, {
        overlay: Fe(() => [
          o.value ? (Ce(), et(LM, {
            key: 0,
            column: i.value ? null : a.value,
            "column-position": i.value,
            onSubmit: u,
            onCancel: u,
            onClick: v[1] || (v[1] = ft(() => {
            }, ["stop"])),
            onKeydown: v[2] || (v[2] = ft(() => {
            }, ["stop"]))
          }, null, 8, ["column", "column-position"])) : bt("", !0)
        ]),
        default: Fe(() => [
          jve
        ]),
        _: 1
      }, 8, ["open"])
    ], 32));
  }
}), BM = /* @__PURE__ */ Cn(Vve, [["__scopeId", "data-v-9aa40cfb"]]), Uve = /* @__PURE__ */ Me({
  __name: "Row",
  props: {
    row: {}
  },
  setup(e) {
    const n = Tt(e, "row"), { meta: r } = Ss(), { isNew: a, state: o } = B_(
      r,
      n
    ), i = Ke(vo), s = Qs();
    return s.on((l) => {
      a.value || i == null || i.trigger({
        shouldShowLoading: (l == null ? void 0 : l.shouldShowLoading) ?? !1
      });
    }), kt(Bg, s), (l, u) => uo(l.$slots, "default", { state: U(o) });
  }
}), zve = /* @__PURE__ */ Me({
  __name: "TableDataCell",
  setup(e, { expose: t }) {
    const n = ne(), r = Qs();
    return kt(Hg, r), kt(W8, n), t({ el: n }), (a, o) => (Ce(), rt("td", {
      ref_key: "el",
      ref: n,
      class: "select-none",
      onClick: o[0] || (o[0] = (i) => U(r).trigger(i))
    }, [
      uo(a.$slots, "default")
    ], 512));
  }
}), id = /* @__PURE__ */ Me({
  __name: "NcDropdown",
  props: {
    trigger: { default: () => ["click"] },
    visible: { type: Boolean, default: void 0 },
    overlayClassName: { default: void 0 },
    autoClose: { type: Boolean, default: !0 }
  },
  emits: ["update:visible"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = Tt(n, "trigger"), o = Tt(n, "overlayClassName"), i = V(() => n.autoClose), s = V(() => {
      let f = "nc-dropdown";
      return o.value && (f += ` ${o.value}`), f;
    }), l = Ra(n, "visible", r);
    Hf("Escape", () => {
      l.value && i.value && (l.value = !1);
    });
    const u = ne(null);
    Np(u, () => {
      i.value && (l.value = !1);
    });
    const c = (f) => {
      l !== void 0 ? l.value = f : r("update:visible", f);
    };
    return (f, d) => (Ce(), et(U(cs), {
      open: U(l),
      trigger: a.value,
      "overlay-class-name": s.value,
      "onUpdate:open": c
    }, {
      overlay: Fe(() => [
        uo(f.$slots, "overlay", {
          ref_key: "overlayWrapperDomRef",
          ref: u
        })
      ]),
      default: Fe(() => [
        uo(f.$slots, "default")
      ]),
      _: 3
    }, 8, ["open", "trigger", "overlay-class-name"]));
  }
}), Wve = /* @__PURE__ */ Me({
  __name: "NcDivider",
  setup(e) {
    return (t, n) => (Ce(), et(U(E0), { class: "nc-divider" }));
  }
}), Gve = {
  created: (e) => {
    const t = document.createElement("div");
    t.className = "resizer", t.style.position = "absolute", t.style.height = "100%", t.style.width = "3px", t.style.top = "0", t.style.right = "-1px", t.style.zIndex = "999", e.appendChild(t), t.addEventListener("mousedown", i, !1);
    const n = jn(), r = (n == null ? void 0 : n.emit) ?? ((c, f) => {
      const d = new CustomEvent(c, { detail: f });
      e.dispatchEvent(d);
    });
    let a, o;
    function i(c) {
      var f, d;
      document.body.style.cursor = "col-resize", a = c.clientX, o = parseInt(((d = (f = document.defaultView) == null ? void 0 : f.getComputedStyle(e)) == null ? void 0 : d.width) || "0", 10), document.documentElement.addEventListener("mousemove", l, !1), document.documentElement.addEventListener("mouseup", u, !1), r("xcstartresizing", o);
    }
    e.initDrag = i;
    let s;
    function l(c) {
      s = `${o + c.clientX - a}px`, r("xcresizing", s);
    }
    function u() {
      t.classList.remove("primary"), document.body.style.cursor = "", document.documentElement.removeEventListener("mousemove", l, !1), document.documentElement.removeEventListener("mouseup", u, !1), r("xcresize", s), r("xcresized");
    }
  },
  beforeUnmount: (e) => {
    const t = e.querySelector(".resizer");
    t && t.removeEventListener("mousedown", e.initDrag, !1);
  }
}, Kve = /* @__PURE__ */ Me({
  __name: "DivDataCell",
  props: {
    open: { type: Boolean }
  },
  setup(e) {
    const t = e, n = ne();
    kt(W8, n);
    const r = () => {
      var o;
      if (!t.open) return;
      const a = document.activeElement;
      a && a.closest(".nc-data-cell") === n.value && ((o = n.value) == null || o.scrollIntoView({ block: "center" }));
    };
    return (a, o) => (Ce(), rt("div", {
      ref_key: "el",
      ref: n,
      class: "nc-data-cell",
      onKeydown: zt(r, ["tab"])
    }, [
      uo(a.$slots, "default", {}, void 0, !0)
    ], 544));
  }
}), Yve = /* @__PURE__ */ Cn(Kve, [["__scopeId", "data-v-29ef8152"]]), qve = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20class='nkxe8gwx6__design-iconfont'%3e%3cpath%20fill='%23374151'%20fill-rule='evenodd'%20d='M12.007%203.026q-.4%200-.684.284L8%206.632%204.677%203.31q-.284-.284-.684-.284-.4%200-.684.284-.283.283-.283.683%200%20.4.284.684L6.633%208l-3.324%203.323q-.283.284-.283.684%200%20.4.283.683.284.284.684.284.4%200%20.684-.284L8%209.367l3.323%203.323q.284.284.684.284.4%200%20.683-.284.284-.283.284-.683%200-.4-.284-.684L9.367%208l3.323-3.323q.284-.284.284-.684%200-.4-.284-.683-.283-.284-.683-.284Z'/%3e%3c/svg%3e", Xve = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20class='nm8pbtej0__design-iconfont'%3e%3cdefs%3e%3cclipPath%20id='a'%3e%3crect%20width='16'%20height='16'%20rx='0'/%3e%3c/clipPath%3e%3c/defs%3e%3cg%20clip-path='url(%23a)'%3e%3cpath%20d='M4.667%208q0%20.066-.007.13-.006.066-.019.13t-.032.127q-.019.063-.044.123-.025.06-.056.119-.03.057-.067.112-.036.054-.078.105-.042.05-.088.097-.046.046-.097.088-.05.041-.105.078-.054.036-.112.067-.058.03-.118.056-.06.025-.124.044-.062.019-.127.032-.064.013-.129.019t-.13.006q-.066%200-.131-.006-.066-.006-.13-.02-.064-.012-.127-.031-.062-.019-.123-.044-.06-.025-.118-.056-.058-.03-.112-.067-.055-.037-.106-.078-.05-.042-.096-.088-.047-.046-.088-.097-.042-.05-.078-.105-.037-.055-.068-.112-.03-.058-.056-.119-.025-.06-.044-.123-.019-.063-.031-.127-.013-.064-.02-.13Q2%208.067%202%208q0-.065.006-.13.007-.066.02-.13.012-.064.031-.127.02-.063.044-.123.026-.06.056-.118.031-.058.068-.113.036-.054.078-.105.041-.05.088-.097.046-.046.096-.088.051-.041.106-.078.054-.036.112-.067.058-.03.118-.056.06-.025.123-.044.063-.019.127-.032.064-.012.13-.019.065-.006.13-.006.066%200%20.131.006.065.007.13.02.064.012.126.031.063.02.124.044.06.025.118.056.058.031.112.067.055.037.105.078.05.042.097.088.046.047.088.097.042.05.078.105.036.055.067.113.031.057.056.118.025.06.044.123.02.063.032.127.013.064.02.13.006.065.006.13Zm4.666%200q0%20.066-.006.13-.007.066-.02.13-.012.064-.031.127-.02.063-.044.123-.025.06-.056.119-.031.057-.068.112-.036.054-.077.105-.042.05-.088.097-.047.046-.097.088-.05.041-.105.078-.055.036-.113.067-.057.03-.118.056-.06.025-.123.044-.063.019-.127.032-.064.013-.13.019-.065.006-.13.006-.066%200-.13-.006-.066-.006-.13-.02-.065-.012-.127-.031-.063-.019-.123-.044-.06-.025-.119-.056-.057-.03-.112-.067-.054-.037-.105-.078-.05-.042-.097-.088-.046-.046-.088-.097-.041-.05-.078-.105-.036-.055-.067-.112-.03-.058-.056-.119-.025-.06-.044-.123-.02-.063-.032-.127-.013-.064-.02-.13-.005-.064-.005-.13%200-.065.006-.13.006-.066.02-.13.012-.064.03-.127.02-.063.045-.123.025-.06.056-.118.03-.058.067-.113.037-.054.078-.105.042-.05.088-.097.046-.046.097-.088.05-.041.105-.078.055-.036.112-.067.058-.03.119-.056.06-.025.123-.044.062-.019.127-.032.064-.012.13-.019.064-.006.13-.006.065%200%20.13.006.066.007.13.02.064.012.127.031.063.02.123.044.06.025.118.056.058.031.113.067.054.037.105.078.05.042.097.088.046.047.088.097.041.05.077.105.037.055.068.113.03.057.056.118.025.06.044.123.019.063.032.127.012.064.019.13.006.065.006.13ZM14%208q0%20.066-.006.13-.007.066-.02.13-.012.064-.031.127-.02.063-.044.123-.025.06-.056.119-.031.057-.068.112-.036.054-.078.105-.041.05-.087.097-.047.046-.097.088-.05.041-.105.078-.055.036-.113.067-.057.03-.118.056-.06.025-.123.044-.063.019-.127.032-.064.013-.13.019-.065.006-.13.006-.066%200-.13-.006-.066-.006-.13-.02-.065-.012-.127-.031-.063-.019-.123-.044-.06-.025-.119-.056-.057-.03-.112-.067-.054-.037-.105-.078-.05-.042-.097-.088-.046-.046-.088-.097-.041-.05-.078-.105-.036-.055-.067-.112-.03-.058-.056-.119-.025-.06-.044-.123-.02-.063-.032-.127-.013-.064-.02-.13-.005-.064-.005-.13%200-.065.006-.13.006-.066.02-.13.012-.064.03-.127.02-.063.045-.123.025-.06.056-.118.03-.058.067-.113.037-.054.078-.105.042-.05.088-.097.046-.046.097-.088.05-.041.105-.078.055-.036.112-.067.058-.03.119-.056.06-.025.123-.044.063-.019.127-.032.064-.012.13-.019.064-.006.13-.006.065%200%20.13.006.066.007.13.02.064.012.127.031.063.02.123.044.06.025.118.056.058.031.113.067.054.037.105.078.05.042.097.088.046.047.088.097.041.05.077.105.037.055.068.113.03.057.056.118.025.06.044.123.019.063.032.127.012.064.019.13Q14%207.934%2014%208Z'/%3e%3c/g%3e%3c/svg%3e", Zve = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20class='o16qtq9z2__design-iconfont'%20viewBox='0%200%2012%2012'%3e%3cdefs%3e%3cclipPath%20id='a'%3e%3crect%20width='12'%20height='12'%20rx='0'/%3e%3c/clipPath%3e%3c/defs%3e%3cg%20clip-path='url(%23a)'%3e%3cpath%20fill-rule='evenodd'%20d='M11.143%204.502V2.504q0-.293-.186-.48-.185-.185-.479-.185-.293%200-.478.186-.186.186-.186.479v.022q-.73-.834-1.766-1.224-1.93-.85-3.912-.076Q2.153%202%201.302%203.936q-.85%201.935-.077%203.922.772%201.987%202.705%202.839%201.932.851%203.916.077t2.834-2.71l.102-.231h-.154q-.04-.184-.17-.314-.185-.186-.478-.186T9.5%207.52q-.135.135-.172.327l-.04.067q-.684%201.143-1.865%201.63-1.464.608-2.913-.011-1.444-.617-2.056-2.097-.61-1.47.012-2.938.62-1.465%202.089-2.04h.003l.002-.001q1.306-.566%202.665-.084%201.196.425%201.905%201.465h-.647q-.293%200-.479.186-.185.185-.185.479%200%20.293.185.478.186.186.48.186h1.993q.294%200%20.48-.186.185-.185.185-.478Z'/%3e%3c/g%3e%3c/svg%3e", Qve = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20class='7pg9exq48__design-iconfont'%3e%3cpath%20fill-rule='evenodd'%20d='M2%208.989c0%20.834.677%201.511%201.511%201.511h.69V7.034A2.833%202.833%200%200%201%207.033%204.2H10.5v-.689C10.5%202.677%209.823%202%208.989%202H3.51C2.677%202%202%202.677%202%203.511V8.99Zm3.5-1.6v4.722q0%20.093.01.185.008.093.026.184.018.09.045.18.027.088.063.174.035.086.079.168.044.081.095.159.052.077.11.148.06.072.125.138.066.065.138.124.071.06.148.11.078.052.16.096.081.044.167.08.086.035.175.062.088.027.18.045.09.018.183.027.092.009.185.009h4.722q.093%200%20.185-.01.093-.008.184-.026.09-.018.18-.045.088-.027.174-.063.086-.035.168-.079.081-.044.159-.095.077-.052.148-.11.072-.06.138-.125.065-.066.124-.138.06-.071.11-.148.052-.078.096-.16.044-.081.08-.167.035-.086.062-.175.027-.088.045-.18.018-.09.027-.183.009-.092.009-.185V7.39q0-.093-.01-.185-.008-.093-.026-.184-.018-.09-.045-.18-.027-.088-.063-.174-.035-.086-.079-.168-.044-.081-.095-.159-.052-.077-.11-.148-.06-.072-.125-.138-.066-.065-.138-.124-.071-.06-.148-.11-.078-.052-.16-.096-.081-.044-.167-.08-.086-.035-.175-.062-.088-.027-.18-.045-.09-.018-.183-.027-.092-.009-.185-.009H7.39q-.093%200-.185.01-.093.008-.184.026-.09.018-.18.045-.088.027-.174.063-.086.035-.168.079-.081.044-.159.095-.077.052-.148.11-.072.06-.138.125-.065.066-.124.138-.06.071-.11.148-.052.078-.096.16-.044.081-.08.167-.035.086-.062.175-.027.088-.045.18-.018.09-.027.183-.009.092-.009.185Z'/%3e%3c/svg%3e", Jve = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="3wqhceydv__design-iconfont"><path fill="currentColor" fill-rule="evenodd" d="M6.194 1.153q-.07 0-.14.014t-.136.04q-.066.028-.125.068-.059.04-.11.09-.05.05-.09.109-.039.059-.066.125-.027.065-.041.135-.014.07-.014.141 0 .071.014.141.014.07.041.135.027.066.067.125.04.06.09.11.05.05.11.09.058.04.124.066.066.028.135.041.07.014.141.014h3.612q.07 0 .14-.014.07-.013.136-.04.066-.028.125-.067.059-.04.11-.09.05-.05.089-.11.04-.059.067-.125.027-.065.04-.135.015-.07.015-.14 0-.072-.014-.142-.014-.07-.041-.135-.027-.066-.067-.125-.04-.06-.09-.11-.05-.05-.11-.09-.058-.039-.124-.066-.066-.027-.136-.041-.07-.014-.14-.014H6.194ZM2.222 5.486a.722.722 0 0 1 0-1.444h11.556a.722.722 0 1 1 0 1.444h-.907q-.007.953.001 6.852a2.172 2.172 0 0 1-2.167 2.176H5.292a2.167 2.167 0 0 1-2.167-2.166V5.486h-.903Zm4.334 7.164a.722.722 0 0 0 .722-.722V7.291a.722.722 0 1 0-1.444 0v4.637c0 .399.323.722.722.722Zm3.614-.722a.722.722 0 0 1-1.444 0V7.291a.722.722 0 1 1 1.445 0v4.637Z"/></svg>', HM = (e) => (Xa("data-v-f2ab5d16"), e = e(), Za(), e), eme = { class: "body" }, tme = { class: "nc-expanded-form-header" }, nme = { class: "left-part" }, rme = ["src"], ame = ["src"], ome = {
  key: 2,
  class: "flex items-center font-bold text-gray-800 text-xl w-64"
}, ime = { class: "truncate" }, sme = ["src"], lme = { class: "nc-expand-form-menu-item-content" }, ume = ["src"], cme = { class: "nc-expand-form-menu-item-content" }, fme = ["src"], dme = { class: "nc-expand-form-menu-item-content danger" }, pme = ["innerHTML"], hme = ["src"], vme = { class: "nc-expand-form-content" }, mme = ["col-id"], gme = { class: "nc-expanded-cell" }, yme = { class: "nc-expand-form-actions" }, xme = { class: "nc-expand-form-delete-field" }, bme = { class: "nc-expand-form-save-confirm" }, wme = /* @__PURE__ */ HM(() => /* @__PURE__ */ ke("div", { class: "title" }, "保存更改", -1)), Sme = /* @__PURE__ */ HM(() => /* @__PURE__ */ ke("div", { class: "desc" }, "您要保存这些更改吗？", -1)), _me = { class: "actions" }, Cme = /* @__PURE__ */ Me({
  __name: "RowForm",
  props: /* @__PURE__ */ Zl({
    state: {},
    meta: {},
    loadRow: { type: Boolean },
    useMetaFields: { type: Boolean },
    row: {},
    rowId: {},
    view: {},
    showNextPrevIcons: { type: Boolean },
    firstRow: { type: Boolean },
    lastRow: { type: Boolean },
    closeAfterSave: { type: Boolean }
  }, {
    open: { type: Boolean },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Zl(["update:modelValue", "cancel", "next", "prev", "createdRecord"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = e, r = t, a = Tt(n, "rowId"), o = Tt(n, "row"), i = Tt(n, "meta"), s = Tt(n, "lastRow"), l = Tt(n, "firstRow"), u = Ke(_c, ne(!1)), c = ne(!1), f = V(() => u.value), d = ne(), p = Ke(Bg, Qs()), v = Ke(vo);
    kt(Hg, void 0);
    const h = Ke(jg, ne(!1)), m = V(() => i.value.columns), y = V(() => {
      var G;
      if (!((G = m.value) != null && G.length))
        return [];
      const le = m.value.filter(
        (oe) => {
          var L, re;
          return oe.system ? h.value && ((L = oe.grid_column_meta) == null ? void 0 : L.show) === !0 : ((re = oe.grid_column_meta) == null ? void 0 : re.show) === !0;
        }
      ), te = le.findIndex((oe) => oe.pv);
      if (te !== void 0 && te >= 0) {
        const oe = le.splice(te, 1);
        le.unshift(oe[0]);
      }
      return le;
    }), x = ne(!0), g = ne(!1), {
      changedColumns: S,
      deleteRowById: w,
      displayValue: _,
      // state: rowState,
      // isNew,
      loadRow: b,
      primaryKey: E,
      // saveRowAndStay,
      row: C,
      save: T,
      clearColumns: O
    } = O0e(i, o), I = Fr(e, "open"), k = () => {
      var le, te;
      S.value.size > 0 ? H.value = !0 : ((te = (le = C.value) == null ? void 0 : le.rowMeta) != null && te.new && r("cancel"), I.value = !1);
    }, B = ne(!1), P = () => {
      if (g.value)
        return;
      B.value = !0, c.value = !0;
      const le = { ...C.value.row };
      delete le.ncRecordId;
      const te = Object.assign(
        {},
        {
          row: le,
          oldRow: {},
          rowMeta: { new: !0 }
        }
      );
      setTimeout(async () => {
        C.value = te, B.value = !1, wt.success("该行已复制（未保存）");
      }, 500);
    }, N = async () => {
      g.value ? (await T(), p == null || p.trigger(), v == null || v.trigger()) : (await T(), b(), p == null || p.trigger(), v == null || v.trigger()), c.value = !1, I.value = !1, r("createdRecord", C.value.row);
    }, M = ne(!1), H = ne(!1), R = () => {
      var le, te, G, oe;
      M.value && (r("next"), (te = (le = C.value) == null ? void 0 : le.rowMeta) != null && te.new && r("cancel"), M.value = !1), H.value && (H.value = !1, (oe = (G = C.value) == null ? void 0 : G.rowMeta) != null && oe.new && r("cancel"), I.value = !1), O();
    }, z = async () => {
      if (S.value.size > 0) {
        M.value = !0;
        return;
      }
      r("next");
    }, W = async () => {
      M.value && (c.value = !1, await N(), r("next"), M.value = !1), H.value && (H.value = !1, await N(), I.value = !1);
    }, F = ne();
    Lt(async () => {
      var le;
      if (x.value = !0, n.loadRow && await b(), n.rowId)
        try {
          await b(n.rowId);
        } catch (te) {
          if (((le = te.response) == null ? void 0 : le.status) === 404)
            wt.error("未找到记录");
          else throw te;
        }
      x.value = !1, setTimeout(() => {
        var te, G, oe;
        (oe = (G = (te = F.value) == null ? void 0 : te.$el) == null ? void 0 : G.querySelector("input,select,textarea")) == null || oe.focus();
      }, 300);
    });
    const Y = ne(!1), X = () => {
      g.value || (Y.value = !0);
    }, q = async () => {
      Y.value = !1, await w(E.value), wt.success("记录已删除"), p.trigger(), k(), Y.value = !1;
    };
    He(a, async (le) => {
      await b(le);
    });
    const Q = V({
      get: () => H.value || M.value,
      set: (le) => {
        H.value = le;
      }
    }), ue = (le) => {
      let te = !1;
      document.querySelectorAll(".ant-select-dropdown").forEach((G) => {
        te = te || G.checkVisibility();
      }), !te && (S.value.size === 0 && !c.value || le ? I.value = le : Q.value = !0);
    };
    return (le, te) => (Ce(), rt(dt, null, [
      A(zm, {
        class: tn(["nc-drawer-expanded-form", { active: I.value }]),
        "body-style": { padding: "24px" },
        closable: !1,
        footer: null,
        visible: I.value ?? !1,
        width: "min(80vw,800px)",
        size: "small",
        "onUpdate:visible": ue
      }, {
        default: Fe(() => {
          var G;
          return [
            ke("div", eme, [
              ke("div", tme, [
                ke("div", nme, [
                  n.showNextPrevIcons ? (Ce(), et(U(fn), {
                    key: 0,
                    disabled: l.value,
                    class: "nc-prev-arrow",
                    onClick: te[0] || (te[0] = (oe) => le.$emit("prev"))
                  }, {
                    default: Fe(() => [
                      ke("img", {
                        class: "prev-icon",
                        src: U(Wm)
                      }, null, 8, rme)
                    ]),
                    _: 1
                  }, 8, ["disabled"])) : bt("", !0),
                  n.showNextPrevIcons ? (Ce(), et(U(fn), {
                    key: 1,
                    disabled: s.value,
                    class: "nc-next-arrow",
                    onClick: z
                  }, {
                    default: Fe(() => [
                      ke("img", {
                        class: "next-icon",
                        src: U(Wm)
                      }, null, 8, ame)
                    ]),
                    _: 1
                  }, 8, ["disabled"])) : bt("", !0),
                  U(_) && !((G = o.value.rowMeta) != null && G.new) ? (Ce(), rt("div", ome, [
                    ke("span", ime, Wt(U(_)), 1)
                  ])) : bt("", !0)
                ]),
                !g.value && a.value ? (Ce(), et(id, {
                  key: 0,
                  placement: "bottomRight"
                }, {
                  overlay: Fe(() => [
                    A(I4, null, {
                      default: Fe(() => [
                        A(ea, {
                          onClick: te[1] || (te[1] = (oe) => U(b)())
                        }, {
                          default: Fe(() => [
                            ke("div", lme, [
                              ke("img", { src: U(Zve) }, null, 8, ume),
                              Jt(" 重新加载 ")
                            ])
                          ]),
                          _: 1
                        }),
                        A(ea, { onClick: P }, {
                          default: Fe(() => [
                            ke("div", cme, [
                              ke("img", { src: U(Qve) }, null, 8, fme),
                              Jt(" 复制该行 ")
                            ])
                          ]),
                          _: 1
                        }),
                        A(ea, {
                          class: "!text-red-500 !hover:bg-red-50",
                          onClick: X
                        }, {
                          default: Fe(() => [
                            ke("div", dme, [
                              ke("span", { innerHTML: U(Jve) }, null, 8, pme),
                              Jt(" 删除记录 ")
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: Fe(() => [
                    A(U(fn), {
                      class: "nc-expand-form-more-actions",
                      disabled: x.value
                    }, {
                      default: Fe(() => [
                        ke("img", {
                          class: "more-icon",
                          src: U(Xve)
                        }, null, 8, sme)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })) : bt("", !0),
                A(U(fn), {
                  class: "nc-expand-form-close-btn",
                  onClick: k
                }, {
                  default: Fe(() => [
                    ke("img", {
                      class: "close-icon",
                      src: U(qve)
                    }, null, 8, hme)
                  ]),
                  _: 1
                })
              ]),
              ke("div", vme, [
                ke("div", {
                  ref_key: "expandedFormScrollWrapper",
                  ref: d,
                  class: "scroller nc-scrollbar-md"
                }, [
                  (Ce(!0), rt(dt, null, Vn(y.value, (oe, L) => Yn((Ce(), rt("div", {
                    key: oe.title,
                    class: tn([`nc-expand-col-${oe.title}`, "nc-expanded-form-row"]),
                    "col-id": oe.id
                  }, [
                    ke("div", gme, [
                      A(BM, {
                        class: "field-name",
                        column: oe,
                        "hide-menu": ""
                      }, null, 8, ["column"]),
                      oe.title ? (Ce(), et(Yve, {
                        key: 0,
                        ref_for: !0,
                        ref: L ? void 0 : (re) => F.value = re,
                        class: tn({ "nc-system-field": U(Gr)(oe) }),
                        open: I.value
                      }, {
                        default: Fe(() => [
                          A(N4, {
                            modelValue: U(C).row[oe.title],
                            "onUpdate:modelValue": [(re) => U(C).row[oe.title] = re, (re) => U(S).add(oe.title)],
                            column: oe,
                            "read-only": f.value,
                            active: "",
                            "edit-enabled": ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "column", "read-only"])
                        ]),
                        _: 2
                      }, 1032, ["class", "open"])) : bt("", !0)
                    ])
                  ], 10, mme)), [
                    [ko, !g.value]
                  ])), 128))
                ], 512),
                ke("div", yme, [
                  A(U(fn), {
                    disabled: U(S).size === 0 && !c.value,
                    class: "nc-expand-form-save-btn",
                    type: "primary",
                    size: "large",
                    onClick: N
                  }, {
                    default: Fe(() => [
                      Jt(" 保存 ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ])
            ])
          ];
        }),
        _: 1
      }, 8, ["class", "visible"]),
      A(mM, {
        visible: Y.value,
        "onUpdate:visible": te[2] || (te[2] = (G) => Y.value = G),
        "entity-name": "Record",
        "on-delete": q
      }, {
        "entity-preview": Fe(() => [
          ke("div", xme, Wt(U(_)), 1)
        ]),
        _: 1
      }, 8, ["visible"]),
      A(zm, {
        visible: Q.value,
        "onUpdate:visible": te[3] || (te[3] = (G) => Q.value = G),
        size: "small"
      }, {
        default: Fe(() => [
          ke("div", bme, [
            wme,
            Sme,
            ke("div", _me, [
              A(U(fn), { onClick: R }, {
                default: Fe(() => [
                  Jt("舍弃")
                ]),
                _: 1
              }),
              A(U(fn), {
                key: "submit",
                type: "primary",
                onClick: W
              }, {
                default: Fe(() => [
                  Jt("保存更改")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ], 64));
  }
}), Eme = /* @__PURE__ */ Cn(Cme, [["__scopeId", "data-v-f2ab5d16"]]), ul = (e) => (Xa("data-v-cdf44d1a"), e = e(), Za(), e), Tme = { class: "nc-wrapper" }, $me = /* @__PURE__ */ ul(() => /* @__PURE__ */ ke("div", { class: "drag-placeholder" }, null, -1)), Ome = { class: "nc-wrapper-loading" }, Ame = { key: 0 }, Ime = { class: "nc-grid-header" }, Pme = ["data-col", "data-title", "onXcstartresizing", "onXcresizing", "onXcresize", "onClick"], Dme = /* @__PURE__ */ ul(() => /* @__PURE__ */ ke("div", { class: "nc-grid-add-cell" }, [
  /* @__PURE__ */ ke("span", { class: "label" }, "+")
], -1)), kme = { class: "nc-grid-row" }, Mme = { class: "nc-grid-row-index-inner" }, Rme = ["onClick"], Nme = ["src"], Fme = { class: "nc-grid-cell-inner" }, Lme = /* @__PURE__ */ ul(() => /* @__PURE__ */ ke("td", { class: "add-new-cell" }, "+", -1)), Bme = [
  Lme
], Hme = /* @__PURE__ */ ul(() => /* @__PURE__ */ ke("div", { class: "nc-base-menu-item-label" }, "更新选定记录", -1)), jme = {
  key: 0,
  class: "nc-base-menu-item-label"
}, Vme = {
  key: 1,
  class: "nc-base-menu-item-label"
}, Ume = /* @__PURE__ */ ul(() => /* @__PURE__ */ ke("div", { class: "nc-base-menu-item-label" }, "复制", -1)), zme = /* @__PURE__ */ ul(() => /* @__PURE__ */ ke("div", { class: "nc-base-menu-item-label" }, "粘贴", -1)), Wme = /* @__PURE__ */ ul(() => /* @__PURE__ */ ke("div", { class: "nc-base-menu-item-label" }, "清空", -1)), Gme = /* @__PURE__ */ ul(() => /* @__PURE__ */ ke("div", { class: "nc-base-menu-item-label" }, "删除行", -1)), Kme = /* @__PURE__ */ ul(() => /* @__PURE__ */ ke("div", { class: "nc-base-menu-item-label" }, "删除记录", -1)), $x = !1, Yme = /* @__PURE__ */ Me({
  __name: "Table",
  props: {
    table: {},
    data: {},
    paginationData: {},
    loadData: { type: Function },
    changePage: { type: Function },
    callAddEmptyRow: { type: Function },
    deleteRow: { type: Function },
    updateOrSaveRow: { type: Function },
    selectedAllRecords: { type: Boolean },
    deleteRangeOfRows: { type: Function },
    expandForm: { type: Function },
    deleteSelectedRows: { type: Function },
    removeRowIfNew: { type: Function },
    bulkUpdateRows: { type: Function },
    pagination: {},
    tableMetaUpdate: {}
  },
  emits: ["update:selectedAllRecords", "bulkUpdateDlg", "toggleOptimisedQuery"],
  setup(e, { expose: t, emit: n }) {
    const r = e, a = n, o = Ra(r, "selectedAllRecords", a), i = Tt(r, "paginationData"), s = Tt(r, "data"), l = Tt(r, "pagination"), {
      tableMetaUpdate: u,
      loadData: c,
      changePage: f,
      callAddEmptyRow: d,
      updateOrSaveRow: p,
      deleteRow: v,
      expandForm: h,
      deleteSelectedRows: m,
      deleteRangeOfRows: y,
      removeRowIfNew: x,
      bulkUpdateRows: g
    } = r, S = Tt(r, "table"), w = V(() => {
      var _e;
      return (_e = S.value.views) == null ? void 0 : _e[0];
    }), _ = Ke(jg, ne(!1)), b = V(() => {
      const _e = S.value.columns;
      if (!(_e != null && _e.length))
        return [];
      const Ee = _e.filter(
        (lt) => {
          var Rt, nt;
          return lt.system ? _.value && ((Rt = lt.grid_column_meta) == null ? void 0 : Rt.show) === !0 : ((nt = lt.grid_column_meta) == null ? void 0 : nt.show) === !0;
        }
      ), Le = Ee.findIndex((lt) => lt.pv);
      if (Le !== void 0 && Le >= 0) {
        const lt = Ee.splice(Le, 1);
        Ee.unshift(lt[0]);
      }
      return Ee;
    }), E = Ke(_c, ne(!1)), C = Ke(AU, ne(!1)), T = Ke(vo, Qs());
    kt(Bg, T);
    const O = Ke(IU, ne()), { isPkAvail: I, eventBus: k } = Ss(), { isViewDataLoading: B, isPaginationLoading: P } = Fn(pd()), {
      // isViewColumnsLoading: _isViewColumnsLoading,
      updateGridViewColumn: N,
      resizingColOldWith: M
    } = Od(), { paste: H } = y0e(), R = ne(), z = ne(null), W = ne(), F = ne(), Y = ne(), X = ne(), q = EU(W), Q = ne(!1), ue = ne(!1), le = ne(!1), te = ne(!1), G = ne(), oe = ne(!1), L = ne(null), re = ne(!1), j = ne(!1), J = V({
      get: () => j.value,
      set: (_e) => {
        j.value = _e;
      }
    }), ae = ne(!1), he = ne(null), K = (_e, Ee) => {
      _e.preventDefault(), Ee && (he.value = Ee);
    };
    async function Z(_e, Ee = !1) {
      if (!_e) return;
      const Le = s.value[_e.row], lt = b.value[_e.col];
      if (lt.title)
        switch (lt.uidt) {
          case we.Checkbox:
            Le.row[lt.title] = !1;
            break;
          default:
            Le.row[lt.title] = null;
            break;
        }
      Ee || await (p == null ? void 0 : p(Le, lt.title));
    }
    function se(_e, Ee) {
      if (!(re.value || Gr(Ee))) {
        if (!I.value && !_e.rowMeta.new) {
          wt.info("不允许更新没有主键的表");
          return;
        }
        if (Ee.ai) {
          wt.info("自动增量字段不可编辑");
          return;
        }
        if (Ee.pk && !_e.rowMeta.new) {
          wt.info("不支持编辑主键");
          return;
        }
        if (![we.SingleSelect, we.MultiSelect].includes(Ee.uidt))
          return re.value = !0;
      }
    }
    const me = V(() => !E.value), xe = V(() => {
      var _e;
      return (_e = b.value) == null ? void 0 : _e.length;
    }), be = V(() => {
      const _e = [];
      return O.value || _e.push("nc-scrollbar-x-lg overflow-auto"), B.value && _e.push("overflow-hidden"), _e.join(" ");
    }), Te = V(() => {
      var Ee;
      let _e = ((Ee = b.value) == null ? void 0 : Ee.length) ?? 40;
      return _e = _e || 40, Array.from({ length: _e + 1 }).map(() => ({}));
    }), Ie = V(() => Array.from({ length: 40 }).map(() => ({}))), Ve = V(
      () => B.value || P.value || $x.value || !S.value
    );
    function tt(_e) {
      var Ee, Le;
      (Le = (Ee = F.value) == null ? void 0 : Ee.querySelector("th:last-child")) == null || Le.scrollIntoView({ behavior: "smooth" }), setTimeout(() => {
        Q.value = !0, G.value = _e;
      }, 500);
    }
    const it = (_e = !1) => {
      L.value = null, Q.value = !1, G.value = {}, _e && setTimeout(() => {
        var Le, lt;
        const Ee = ((Le = F.value) == null ? void 0 : Le.querySelector(".nc-grid-add-cell")) ?? ((lt = F.value) == null ? void 0 : lt.querySelector("th:last-child"));
        Ee && Ee.scrollIntoView({ behavior: "smooth" });
      }, 200);
    }, Se = (_e, Ee, Le) => {
      var Or, xi;
      const lt = _e.getBoundingClientRect(), Rt = Ee.getBoundingClientRect(), nt = 15, Ot = ((Or = Ee.querySelector("thead th:nth-child(1)")) == null ? void 0 : Or.getBoundingClientRect().width) ?? 0, sn = ((xi = Ee.querySelector("thead th:nth-child(2)")) == null ? void 0 : xi.getBoundingClientRect().width) ?? 0, Tn = Ot + sn, Xt = {
        top: lt.top - Rt.top,
        right: lt.right - Rt.right,
        bottom: lt.bottom - Rt.bottom,
        left: lt.left - Rt.left - Tn
      }, bn = {
        top: 0,
        left: 0
      };
      return bn.left = Xt.right + ((Le == null ? void 0 : Le.right) || 0) > 0 ? Ee.scrollLeft + Xt.right + ((Le == null ? void 0 : Le.right) || 0) + nt : Xt.left - ((Le == null ? void 0 : Le.left) || 0) < 0 ? Ee.scrollLeft + Xt.left - ((Le == null ? void 0 : Le.left) || 0) - nt : Ee.scrollLeft, bn.top = Xt.bottom + ((Le == null ? void 0 : Le.bottom) || 0) > 0 ? Ee.scrollTop + Xt.bottom + ((Le == null ? void 0 : Le.bottom) || 0) + nt : Xt.top - ((Le == null ? void 0 : Le.top) || 0) < 0 ? Ee.scrollTop + Xt.top - ((Le == null ? void 0 : Le.top) || 0) - nt : Ee.scrollTop, bn;
    }, {
      isCellSelected: ge,
      activeCell: pe,
      handleMouseDown: De,
      handleMouseOver: Ue,
      handleCellClick: Xe,
      clearSelectedRange: ut,
      copyValue: xt,
      isCellActive: Mt,
      resetSelectedRange: yt,
      makeActive: gt,
      selectedRange: ct,
      isCellInFillRange: Ht,
      isFillMode: Ut
    } = S0e(
      S,
      b,
      s,
      re,
      I,
      J,
      Z,
      yi,
      se,
      An,
      async (_e) => {
        var Rt, nt, Ot, sn, Tn, Xt, bn, Or, xi, pl, hl;
        if (document.querySelector(
          ".nc-picker-datetime.active,.nc-dropdown-single-select-cell.active,.nc-dropdown-multi-select-cell.active,.nc-picker-date.active,.nc-picker-year.active,.nc-picker-time.active"
        ))
          return _e.preventDefault(), !0;
        if (ku()) return;
        if (jm())
          return !0;
        const Le = nd() ? _e.metaKey : _e.ctrlKey, lt = _e.altKey;
        if (_e.key === " ") {
          const bi = ku();
          if (Mt.value && !re.value && pe.row !== null && !bi) {
            _e.preventDefault();
            const vl = s.value[pe.row];
            return h == null || h(vl), !0;
          }
        } else if (_e.key === "Escape") {
          if (re.value)
            return re.value = !1, !0;
        } else if (_e.key === "Enter") {
          if (_e.shiftKey)
            return !0;
          if (re.value)
            return re.value = !1, !0;
        } else if (_e.key === "Tab") {
          if (_e.shiftKey && pe.row === 0 && pe.col === 0 && !((Rt = i.value) != null && Rt.isFirstPage))
            return _e.preventDefault(), await va(
              (((nt = i.value) == null ? void 0 : nt.pageSize) ?? 25) - 1,
              ((Ot = b.value) == null ? void 0 : Ot.length) - 1,
              -1
            ), !0;
          if (!_e.shiftKey && pe.row === s.value.length - 1 && pe.col === ((sn = b.value) == null ? void 0 : sn.length) - 1) {
            if (_e.preventDefault(), (Tn = i.value) != null && Tn.isLastPage && me.value)
              return wr(), await va(s.value.length - 1, 0), !0;
            if (!((Xt = i.value) != null && Xt.isLastPage))
              return await va(0, 0, 1), !0;
          }
        } else if (!Le && !_e.shiftKey && _e.key === "ArrowUp") {
          if (pe.row === 0 && !((bn = i.value) != null && bn.isFirstPage))
            return _e.preventDefault(), await va((((Or = i.value) == null ? void 0 : Or.pageSize) ?? 25) - 1, pe.col, -1), !0;
        } else if (!Le && !_e.shiftKey && _e.key === "ArrowDown" && pe.row === s.value.length - 1) {
          if (_e.preventDefault(), (xi = i.value) != null && xi.isLastPage && me.value)
            return wr(), await va(s.value.length - 1, pe.col), !0;
          if (!((pl = i.value) != null && pl.isLastPage))
            return await va(0, pe.col, 1), !0;
        }
        if (Le) {
          if (!Mt.value || _e.shiftKey) return;
          switch (_e.key) {
            case "ArrowUp":
              return _e.preventDefault(), ut(), pe.row = 0, pe.col = pe.col ?? 0, An == null || An(), re.value = !1, !0;
            case "ArrowDown":
              return _e.preventDefault(), ut(), pe.row = s.value.length - 1, pe.col = pe.col ?? 0, An == null || An(), re.value = !1, !0;
            case "ArrowRight":
              return _e.preventDefault(), ut(), pe.row = pe.row ?? 0, pe.col = ((hl = b.value) == null ? void 0 : hl.length) - 1, An == null || An(), re.value = !1, !0;
            case "ArrowLeft":
              return _e.preventDefault(), ut(), pe.row = pe.row ?? 0, pe.col = 0, An == null || An(), re.value = !1, !0;
          }
        }
        if (lt)
          switch (_e.keyCode) {
            case 82: {
              me.value && (wr(), pe.row = s.value.length - 1, pe.col = 0, yt(), nn(() => {
                var bi;
                (bi = document.querySelector("td.cell.active")) == null || bi.scrollIntoView({
                  behavior: "smooth"
                });
              }));
              break;
            }
            case 67: {
              Q.value = !0;
              break;
            }
          }
      },
      async (_e) => {
        const Ee = s.value[_e.row], Le = _e.col !== void 0 ? b.value[_e.col] : null;
        !Ee || !Le || (s.value[_e.row].rowMeta.isUpdatedFromCopyNPaste = {
          ...s.value[_e.row].rowMeta.isUpdatedFromCopyNPaste,
          [_e.updatedColumnTitle || Le.title]: !0
        }, await (p == null ? void 0 : p(Ee, _e.updatedColumnTitle || Le.title)));
      },
      g,
      X
    );
    function In(_e) {
      ut(), gt(_e ?? s.value.length - 1, 0), ct.startRange({ row: pe.row, col: pe.col }), An == null || An();
    }
    function wr(_e, Ee = !1) {
      const Le = d == null ? void 0 : d(_e);
      return !Ee && Le && (p == null || p(Le)), nn().then(() => {
        console.log("====== dataRef", s.value), In(s.value.length - 1);
      }), Le;
    }
    const eo = (_e) => {
      try {
        v == null || v(_e), ct.isRowInRange(_e) && ut(), pe.row === _e && (pe.row = null, pe.col = null);
      } catch (Ee) {
        wt.error(Ee.message);
      }
    }, ur = () => {
      y(ct).then(() => {
        ut(), pe.row = null, pe.col = null;
      });
    }, rr = (_e) => {
      const Ee = b.value.findIndex((Le) => Le.id === _e);
      Ee !== -1 && (gt(0, Ee), ct.startRange({ row: 0, col: Ee }), ct.endRange({ row: s.value.length - 1, col: Ee }));
    };
    Np(Y, (_e) => {
      if (oe.value || J.value || pe.row === null || pe.col === null || ku()) return;
      const Le = b.value[pe.col];
      if (re.value && Le.uidt === we.JSON || Ut.value) return;
      const lt = document.querySelector(
        ".nc-picker-datetime.active,.nc-dropdown-single-select-cell.active,.nc-dropdown-multi-select-cell.active,.nc-dropdown-user-select-cell.active,.nc-picker-date.active,.nc-picker-year.active,.nc-picker-time.active"
      );
      _e.target && lt && (lt === _e.target || lt != null && lt.contains(_e.target)) || jm() || (ut(), pe.row = null, pe.col = null);
    });
    const gi = (_e) => {
      if (!(pe.row === null || pe.col === null)) {
        switch (re.value = !1, ut(), _e) {
          case $u.NEXT:
            pe.row < s.value.length - 1 || wr(), pe.row++;
            break;
          case $u.PREV:
            pe.row > 0 && pe.row--;
            break;
        }
        nn(() => {
          An();
        });
      }
    };
    async function yi() {
      const _e = ct.start, Ee = ct.end, Le = Math.min(_e.row, Ee.row), lt = Math.max(_e.row, Ee.row), Rt = Math.min(_e.col, Ee.col), nt = Math.max(_e.col, Ee.col), Ot = b.value.slice(Rt, nt + 1), sn = s.value.slice(Le, lt + 1), Tn = [];
      for (const Xt of sn)
        for (const bn of Ot)
          !Xt || !bn || !bn.title || (Xt.row[bn.title] = null, Tn.push(bn.title));
      try {
        await (g == null ? void 0 : g(sn, Tn));
      } catch {
        wt.error("清空数据失败");
      }
    }
    const $r = V(() => O.value || W.value);
    function An(_e, Ee) {
      var Le, lt;
      if (_e = _e ?? pe.row, Ee = Ee ?? pe.col, _e !== null && Ee !== null) {
        const Rt = (Le = Y.value) == null ? void 0 : Le.querySelectorAll("tr"), nt = (lt = Rt == null ? void 0 : Rt[_e]) == null ? void 0 : lt.querySelectorAll("td"), Ot = nt == null ? void 0 : nt[Ee === 0 ? 0 : Ee + 1];
        if (!Ot || !$r.value) return;
        const { height: sn } = F.value.getBoundingClientRect(), Tn = Se(Ot, $r.value, {
          top: sn || 40,
          bottom: 9,
          right: 9
        });
        if (Ee === 0 && (Tn.left = 0), Rt && _e === Rt.length - 2) {
          const Xt = Rt[Rt.length - 1] || Rt[Rt.length - 2], bn = Se(Xt, $r.value, {
            top: sn || 40,
            bottom: 9,
            right: 9
          });
          $r.value.scrollTo({
            top: bn.top,
            left: nt && Ee === nt.length - 2 ? $r.value.scrollWidth : Tn.left,
            behavior: "smooth"
          });
          return;
        }
        if (nt && Ee === nt.length - 2) {
          $r.value.scrollTo({
            top: Tn.top,
            left: $r.value.scrollWidth,
            behavior: "smooth"
          });
          return;
        }
        $r.value.scrollTo({
          top: Tn.top,
          left: Tn.left,
          behavior: "smooth"
        });
      }
    }
    async function va(_e, Ee, Le) {
      var lt;
      ut(), Le !== void 0 && ((lt = i.value) != null && lt.page) ? (await (f == null ? void 0 : f(i.value.page + Le)), await nn(), gt(_e, Ee)) : (gt(_e, Ee), await nn()), An == null || An();
    }
    const Ze = async (_e = {}) => {
      var Le, lt, Rt;
      let Ee = -1;
      for (const nt of _e.data) {
        if (Ee++, nt.rowMeta.new) {
          const Ot = (lt = (Le = R.value) == null ? void 0 : Le[Ee]) == null ? void 0 : lt.syncLTARRefs, sn = await (p == null ? void 0 : p(nt, "", {}, _e));
          await (Ot == null ? void 0 : Ot(sn, _e)), nt.rowMeta.changed = !1;
          continue;
        }
        if (nt.rowMeta.changed) {
          nt.rowMeta.changed = !1;
          for (const Ot of ((Rt = _e.metaValue || S.value) == null ? void 0 : Rt.columns) ?? [])
            Ot.uidt !== we.Attachment && Ot.title in nt.row && nt.row[Ot.title] !== nt.oldRow[Ot.title] && await (p == null ? void 0 : p(nt, Ot.title, {}, _e));
        }
      }
    }, Et = (_e, Ee) => {
      if (!_e)
        return;
      const Le = b.value.find((lt) => lt.id === _e);
      Le != null && Le.grid_column_meta && (Le.grid_column_meta.width = `${Ee.detail}`, N(Le.grid_column_meta.id, { width: Ee.detail }));
    }, _t = (_e, Ee) => {
      if (!_e) return;
      const Le = b.value.find((lt) => lt.id === _e);
      Le != null && Le.grid_column_meta && (Le.grid_column_meta.width = `${Ee.detail}`);
    }, ee = (_e, Ee) => {
      _e && (M.value = Ee.detail);
    }, fe = ne(), ie = ne(), ce = () => {
      nn(() => {
        const _e = document.querySelector(".last-cell");
        if (_e) {
          const Ee = _e.getBoundingClientRect();
          if (!Ee || !W.value) return;
          fe.value = Ee.top + Ee.height - q.top.value + W.value.scrollTop, ie.value = Ee.left + Ee.width - q.left.value + W.value.scrollLeft;
        }
      });
    }, de = ne(!1), ye = ne(), Pe = ne(), je = ne(), Ae = (_e, Ee, Le) => {
      if (S.value.columns) {
        const lt = Mi(_e.row, S.value.columns);
        lt && (de.value = !0, ye.value = lt, Pe.value = Le, je.value = Ee);
      }
      pe.row = null, pe.col = null, ct.clear();
    }, Re = V(
      () => {
        var _e, Ee;
        return !re.value && (!ct.isEmpty() || pe.row !== null && pe.col !== null) && !((Ee = (_e = s.value[(isNaN(ct.end.row) ? pe.row : ct.end.row) ?? -1]) == null ? void 0 : _e.rowMeta) != null && Ee.new) && pe.col !== null;
      }
    );
    He(
      [
        () => ct.end.row,
        () => ct.end.col,
        () => pe.row,
        () => pe.col
      ],
      ([_e, Ee, Le, lt], [Rt, nt, Ot, sn]) => {
        (_e !== Rt || Ee !== nt || Le !== Ot || lt !== sn) && ce();
      }
    ), Lt(() => {
      const _e = new ResizeObserver(() => {
        var Ee;
        ce(), pe.row !== null && !((Ee = s.value) != null && Ee[pe.row]) && (ut(), pe.row = null, pe.col = null);
      });
      z.value && _e.observe(z.value);
    }), k.on(async (_e, Ee) => {
      _e === Ws.FIELD_ADD && (L.value = Ee, Q.value = !0), _e === Ws.CLEAR_NEW_ROW && (ut(), pe.row = null, pe.col = null, x == null || x(Ee));
    });
    async function Ne(_e) {
      B.value = !0, (_e == null ? void 0 : _e.ignoreTableMetaUpdate) !== !0 && (u == null || u()), await Ze({
        data: s.value
      }), await (c == null ? void 0 : c({ ...(_e == null ? void 0 : _e.offset) !== void 0 ? { offset: _e.offset } : {} })), B.value = !1;
    }
    or($r, "scroll", () => {
      ce();
    }), or(document, "mousedown", (_e) => {
      var Ee, Le;
      (_e.offsetX > ((Ee = _e.target) == null ? void 0 : Ee.clientWidth) || _e.offsetY > ((Le = _e.target) == null ? void 0 : Le.clientHeight)) && (oe.value = !0);
    }), or(document, "mouseup", () => {
      setTimeout(() => {
        oe.value = !1;
      }, 100);
    }), or(document, "keydown", async (_e) => {
      const Ee = ku();
      _e.key === "Alt" && !Ee && (ue.value = !0);
    }), or(document, "keyup", async (_e) => {
      const Ee = ku();
      _e.key === "Alt" && !Ee && (ue.value = !1, te.value = !1);
    }), or(document, "keydown", async (_e) => {
      const Ee = nd() ? _e.metaKey : _e.ctrlKey;
      if (_e.altKey && !_e.shiftKey && !Ee)
        switch (_e.keyCode) {
          case 78: {
            me.value && wr();
            break;
          }
        }
    }), T == null || T.on(Ne), He(J, () => {
      J.value ? ae.value = !1 : (ae.value = !0, he.value = null);
    });
    const { loadMeta: Qe } = hce();
    He(
      w,
      async (_e, Ee) => {
        try {
          if ((_e == null ? void 0 : _e.id) !== (Ee == null ? void 0 : Ee.id)) {
            if (Ee != null && Ee.id) {
              const Le = await Qe(Ee.fk_model_id);
              Le && await Ze({
                viewMetaValue: Ee,
                metaValue: Le,
                data: s.value
              });
            }
            B.value = !0;
            try {
              await (c == null ? void 0 : c());
            } catch (Le) {
              lr.isCancel(Le) || (console.log(Le), wt.error("加载数据时错误"));
            } finally {
              B.value = !1;
            }
          }
        } catch (Le) {
          console.log(Le);
        }
      },
      { immediate: !0 }
    );
    const $e = Ke(q8, ne(!1));
    _n(() => {
      $e.value && (Ne(), $e.value = !1);
    }), Sn(async () => {
      const _e = w.value, Ee = s.value;
      _e && Qe(_e.fk_model_id).then((Le) => {
        const lt = Le;
        lt && Ze({
          metaValue: lt,
          viewMetaValue: _e,
          data: Ee
        });
      }), T == null || T.off(Ne);
    });
    const ht = async (_e, Ee) => {
      var nt, Ot, sn, Tn, Xt;
      let Le = _e + (Ee === $u.NEXT ? 1 : -1);
      for (; (Ot = (nt = s.value[Le]) == null ? void 0 : nt.rowMeta) != null && Ot.new; )
        Le = Le + (Ee === $u.NEXT ? 1 : -1);
      const lt = ((sn = i == null ? void 0 : i.value) == null ? void 0 : sn.page) || 1;
      if (Le < 0) {
        if (lt === 1) return wt.info("暂无数据");
        await f(lt - 1), Le = s.value.length - 1;
      } else if (Le >= s.value.length) {
        if ((Tn = i == null ? void 0 : i.value) != null && Tn.isLastPage) return wt.info("暂无数据");
        await f(lt + 1), Le = 0;
      }
      const Rt = Mi(s.value[Le].row, (Xt = S.value) == null ? void 0 : Xt.columns) ?? void 0;
      Pe.value = Le, ye.value = Rt;
    }, ot = () => {
      var Ee, Le, lt, Rt;
      const _e = Pe.value;
      if (_e !== void 0) {
        if (!((Ee = i.value) != null && Ee.isLastPage) && _e === ((Le = i.value) == null ? void 0 : Le.pageSize)) {
          const nt = (lt = i.value) != null && lt.page ? ((Rt = i.value) == null ? void 0 : Rt.page) + 1 : 1;
          f(nt);
        }
        ht(_e, $u.NEXT);
      }
    }, Je = () => {
      var Ee, Le, lt;
      const _e = Pe.value;
      if (_e !== void 0) {
        if (!((Ee = i.value) != null && Ee.isFirstPage) && _e === 1) {
          const Rt = (Le = i.value) != null && Le.page ? ((lt = i.value) == null ? void 0 : lt.page) - 1 : 1;
          f(Rt);
        }
        ht(_e, $u.PREV);
      }
    };
    return t({
      scrollToRow: In,
      openColumnCreate: tt
    }), (_e, Ee) => {
      var Le, lt, Rt;
      return Ce(), rt("div", Tme, [
        $me,
        ke("div", {
          ref_key: "gridWrapper",
          ref: W,
          class: tn(["nc-grid-wrapper", be.value])
        }, [
          Yn(ke("div", Ome, [
            A(U(O0), { tip: "加载中..." })
          ], 512), [
            [ko, U(P)]
          ]),
          A(id, {
            visible: J.value,
            "onUpdate:visible": Ee[19] || (Ee[19] = (nt) => J.value = nt),
            trigger: ["contextmenu"]
          }, {
            overlay: Fe(() => [
              A(I4, {
                class: "nc-grid-menu",
                onClick: Ee[18] || (Ee[18] = (nt) => J.value = !1)
              }, {
                default: Fe(() => [
                  U(d0e) && !ae.value && !he.value && _e.data.some((nt) => nt.rowMeta.selected) ? (Ce(), et(ea, {
                    key: 0,
                    onClick: Ee[14] || (Ee[14] = (nt) => a("bulkUpdateDlg"))
                  }, {
                    default: Fe(() => [
                      Hme
                    ]),
                    _: 1
                  })) : bt("", !0),
                  !ae.value && !he.value && _e.data.some((nt) => nt.rowMeta.selected) ? (Ce(), et(ea, {
                    key: 1,
                    class: "nc-base-menu-item nc-base-menu-item-danger",
                    onClick: U(m)
                  }, {
                    default: Fe(() => [
                      _e.data.filter((nt) => nt.rowMeta.selected).length === 1 ? (Ce(), rt("div", jme, " 删除所选行 ")) : (Ce(), rt("div", Vme, "删除所选行"))
                    ]),
                    _: 1
                  }, 8, ["onClick"])) : bt("", !0),
                  he.value ? (Ce(), et(ea, {
                    key: 2,
                    class: "nc-base-menu-item",
                    onClick: Ee[15] || (Ee[15] = (nt) => U(xt)(he.value))
                  }, {
                    default: Fe(() => [
                      Ume
                    ]),
                    _: 1
                  })) : bt("", !0),
                  he.value ? (Ce(), et(ea, {
                    key: 3,
                    class: "nc-base-menu-item",
                    disabled: U(Gr)(b.value[he.value.col]),
                    onClick: U(H)
                  }, {
                    default: Fe(() => [
                      zme
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])) : bt("", !0),
                  he.value ? (Ce(), et(ea, {
                    key: 4,
                    class: "nc-base-menu-item",
                    disabled: U(Gr)(b.value[he.value.col]),
                    onClick: Ee[16] || (Ee[16] = (nt) => yi())
                  }, {
                    default: Fe(() => [
                      Wme
                    ]),
                    _: 1
                  }, 8, ["disabled"])) : bt("", !0),
                  !ae.value && !he.value && _e.data.some((nt) => nt.rowMeta.selected) ? bt("", !0) : (Ce(), et(Wve, { key: 5 })),
                  he.value && (U(ct).isSingleCell() || U(ct).isSingleRow()) ? (Ce(), et(ea, {
                    key: 6,
                    class: "nc-base-menu-item nc-base-menu-item-danger",
                    onClick: Ee[17] || (Ee[17] = (nt) => eo(he.value.row))
                  }, {
                    default: Fe(() => [
                      Gme
                    ]),
                    _: 1
                  })) : he.value ? (Ce(), et(ea, {
                    key: 7,
                    class: "nc-base-menu-item nc-base-menu-item-danger",
                    onClick: ur
                  }, {
                    default: Fe(() => [
                      Kme
                    ]),
                    _: 1
                  })) : bt("", !0)
                ]),
                _: 1
              })
            ]),
            default: Fe(() => [
              ke("div", null, [
                ke("table", {
                  ref_key: "smartTable",
                  ref: z,
                  class: "nc-grid",
                  onContextmenu: K
                }, [
                  ke("thead", {
                    ref_key: "tableHeadEl",
                    ref: F
                  }, [
                    $x ? (Ce(), rt("tr", Ame, [
                      (Ce(!0), rt(dt, null, Vn(Te.value, (nt, Ot) => (Ce(), rt("td", {
                        key: Ot,
                        class: "nc-grid-header-loading",
                        style: _r({ "min-width": Ot === 0 ? "5.3125rem" : "12.5rem" })
                      }, [
                        A(U(oo), {
                          class: tn(["nc-grid-header-loading-skeleton", { first: Ot === 0 }]),
                          paragraph: !1,
                          active: "",
                          title: ""
                        }, null, 8, ["class"])
                      ], 4))), 128))
                    ])) : bt("", !0),
                    Yn(ke("tr", Ime, [
                      ke("th", {
                        class: "checkbox-column",
                        onDblclick: () => {
                        }
                      }, [
                        ke("div", {
                          class: tn(["nc-no-label", { hidden: U(o) }])
                        }, "#", 2),
                        ke("div", {
                          class: tn(["nc-check-all", {
                            hidden: !U(o),
                            flex: U(o)
                          }])
                        }, [
                          A(U(aa), {
                            checked: U(o),
                            "onUpdate:checked": Ee[0] || (Ee[0] = (nt) => Ft(o) ? o.value = nt : null)
                          }, null, 8, ["checked"])
                        ], 2)
                      ], 32),
                      (Ce(!0), rt(dt, null, Vn(b.value, (nt) => {
                        var Ot, sn, Tn;
                        return Yn((Ce(), rt("th", {
                          key: nt.title,
                          "data-col": nt.id,
                          "data-title": nt.title,
                          style: _r({
                            "min-width": ((Ot = nt.grid_column_meta) == null ? void 0 : Ot.width) || "200px",
                            "max-width": ((sn = nt.grid_column_meta) == null ? void 0 : sn.width) || "200px",
                            width: ((Tn = nt.grid_column_meta) == null ? void 0 : Tn.width) || "200px"
                          }),
                          class: "nc-grid-column-header",
                          onXcstartresizing: (Xt) => ee(nt.id, Xt),
                          onXcresizing: (Xt) => _t(nt.id, Xt),
                          onXcresize: (Xt) => Et(nt.id, Xt),
                          onClick: (Xt) => rr(nt.id)
                        }, [
                          A(BM, { column: nt }, null, 8, ["column"])
                        ], 44, Pme)), [
                          [U(Gve)]
                        ]);
                      }), 128)),
                      ke("th", {
                        onClick: Ee[8] || (Ee[8] = ft((nt) => Q.value = !0, ["stop"]))
                      }, [
                        A(U(cs), {
                          open: Q.value,
                          "onUpdate:open": Ee[6] || (Ee[6] = (nt) => Q.value = nt),
                          trigger: ["click"],
                          "overlay-class-name": "nc-dropdown-grid-add-column",
                          onOpenChange: Ee[7] || (Ee[7] = (nt) => le.value = ue.value)
                        }, {
                          overlay: Fe(() => [
                            Q.value ? (Ce(), et(LM, {
                              key: 0,
                              preload: G.value,
                              "column-position": L.value,
                              onSubmit: Ee[1] || (Ee[1] = (nt) => it(!0)),
                              onCancel: Ee[2] || (Ee[2] = (nt) => it()),
                              onClick: Ee[3] || (Ee[3] = ft(() => {
                              }, ["stop"])),
                              onKeydown: Ee[4] || (Ee[4] = ft(() => {
                              }, ["stop"])),
                              onMounted: Ee[5] || (Ee[5] = (nt) => G.value = void 0)
                            }, null, 8, ["preload", "column-position"])) : bt("", !0)
                          ]),
                          default: Fe(() => [
                            Dme
                          ]),
                          _: 1
                        }, 8, ["open"])
                      ])
                    ], 512), [
                      [ko, !$x]
                    ])
                  ], 512),
                  ke("tbody", {
                    ref_key: "tableBodyEl",
                    ref: Y
                  }, [
                    Ve.value ? (Ce(!0), rt(dt, { key: 0 }, Vn(Ie.value, (nt, Ot) => (Ce(), rt("tr", { key: Ot }, [
                      (Ce(!0), rt(dt, null, Vn(Te.value, (sn, Tn) => (Ce(), rt("td", {
                        key: Tn,
                        style: _r({ "min-width": Tn === 0 ? "5.3125rem" : "12.5rem" })
                      }, null, 4))), 128))
                    ]))), 128)) : bt("", !0),
                    (Ce(!0), rt(dt, null, Vn(s.value, (nt, Ot) => (Ce(), et(Uve, {
                      ref_for: !0,
                      ref_key: "rowRefs",
                      ref: R,
                      key: Ot,
                      row: nt
                    }, {
                      default: Fe(({ state: sn }) => {
                        var Tn, Xt;
                        return [
                          Yn(ke("tr", kme, [
                            (Ce(), rt("td", {
                              key: Ot,
                              class: "nc-grid-row-index",
                              onContextmenu: Ee[9] || (Ee[9] = (bn) => he.value = null)
                            }, [
                              ke("div", Mme, [
                                ke("div", {
                                  class: tn(["nc-row-no", { toggle: !0, "nc-row-no-hide": nt.rowMeta.selected }])
                                }, Wt(((((Tn = i.value) == null ? void 0 : Tn.page) ?? 1) - 1) * (((Xt = i.value) == null ? void 0 : Xt.pageSize) ?? 25) + Ot + 1), 3),
                                ke("div", {
                                  class: tn(["nc-row-expand-and-checkbox", {
                                    hidden: !nt.rowMeta.selected,
                                    flex: nt.rowMeta.selected
                                  }])
                                }, [
                                  A(U(aa), {
                                    checked: nt.rowMeta.selected,
                                    "onUpdate:checked": (bn) => nt.rowMeta.selected = bn
                                  }, null, 8, ["checked", "onUpdate:checked"])
                                ], 2),
                                ke("button", {
                                  class: "nc-grid-row-expand",
                                  size: "small",
                                  onClick: ft((bn) => Ae(nt, sn, Ot), ["stop"])
                                }, [
                                  ke("img", {
                                    class: "expand-icon",
                                    src: U(NM)
                                  }, null, 8, Nme)
                                ], 8, Rme)
                              ])
                            ], 32)),
                            (Ce(!0), rt(dt, null, Vn(b.value, (bn, Or) => {
                              var xi, pl, hl, bi, vl;
                              return Ce(), et(zve, {
                                key: bn.id,
                                class: tn(["cell nc-grid-cell", {
                                  active: U(ge)(Ot, Or),
                                  "active-cell": U(pe).row === Ot && U(pe).col === Or || ((xi = U(ct)._start) == null ? void 0 : xi.row) === Ot && ((pl = U(ct)._start) == null ? void 0 : pl.col) === Or,
                                  "last-cell": Ot === (Number.isNaN(U(ct).end.row) ? U(pe).row : U(ct).end.row) && Or === (isNaN(U(ct).end.col) ? U(pe).col : U(ct).end.col),
                                  "nc-required-cell": U(V7)(bn, nt.row) && !U(E),
                                  filling: U(Ht)(Ot, Or),
                                  readonly: bn.system === !0
                                }]),
                                style: _r({
                                  "min-width": ((hl = bn.grid_column_meta) == null ? void 0 : hl.width) || "200px",
                                  "max-width": ((bi = bn.grid_column_meta) == null ? void 0 : bi.width) || "200px",
                                  width: ((vl = bn.grid_column_meta) == null ? void 0 : vl.width) || "200px",
                                  "vertical-align": "middle"
                                }),
                                "data-key": `data-key-${Ot}-${bn.id}`,
                                "data-col": bn.id,
                                "data-title": bn.title,
                                "data-row-index": Ot,
                                "data-col-index": Or,
                                onMousedown: (ma) => U(De)(ma, Ot, Or),
                                onMouseover: (ma) => U(Ue)(ma, Ot, Or),
                                onClick: (ma) => U(Xe)(ma, Ot, Or),
                                onDblclick: (ma) => se(nt, bn),
                                onContextmenu: (ma) => K(ma, { row: Ot, col: Or })
                              }, {
                                default: Fe(() => [
                                  ke("div", Fme, [
                                    bn.title ? (Ce(), et(N4, {
                                      key: 0,
                                      modelValue: nt.row[bn.title],
                                      "onUpdate:modelValue": (ma) => nt.row[bn.title] = ma,
                                      column: bn,
                                      "edit-enabled": !!re.value && U(pe).col === Or && U(pe).row === Ot,
                                      "row-index": Ot,
                                      active: U(pe).col === Or && U(pe).row === Ot,
                                      "read-only": !1,
                                      "onUpdate:editEnabled": Ee[10] || (Ee[10] = (ma) => re.value = ma),
                                      onSave: (ma) => {
                                        var qr;
                                        return (qr = U(p)) == null ? void 0 : qr(nt, bn.title, sn);
                                      },
                                      onNavigate: gi,
                                      onCancel: Ee[11] || (Ee[11] = (ma) => re.value = !1)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "column", "edit-enabled", "row-index", "active", "onSave"])) : bt("", !0)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["class", "style", "data-key", "data-col", "data-title", "data-row-index", "data-col-index", "onMousedown", "onMouseover", "onClick", "onDblclick", "onContextmenu"]);
                            }), 128))
                          ], 512), [
                            [ko, !Ve.value]
                          ])
                        ];
                      }),
                      _: 2
                    }, 1032, ["row"]))), 128)),
                    me.value && !U(C) ? (Ce(), rt("tr", {
                      key: 1,
                      class: tn(["nc-grid-row nc-grid-add-new-row", { "right-border": xe.value === 1 }]),
                      onMouseup: Ee[12] || (Ee[12] = ft(() => {
                      }, ["stop"])),
                      onClick: Ee[13] || (Ee[13] = (nt) => wr())
                    }, Bme, 34)) : bt("", !0)
                  ], 512)
                ], 544),
                Yn(ke("div", {
                  ref_key: "fillHandle",
                  ref: X,
                  class: "nc-fill-handle",
                  style: _r({
                    "z-index": !U(ct).isEmpty() && U(ct).end.col !== 0 || U(ct).isEmpty() && U(pe).col !== 0 ? 3 : 4,
                    top: `${fe.value}px`,
                    left: `${ie.value}px`,
                    cursor: "crosshair"
                  })
                }, null, 4), [
                  [ko, Re.value]
                ])
              ])
            ]),
            _: 1
          }, 8, ["visible"])
        ], 2),
        A(k0e, {
          "pagination-data": i.value,
          "onUpdate:paginationData": Ee[20] || (Ee[20] = (nt) => i.value = nt),
          "change-page": U(f),
          "hide-sidebars": ((Le = l.value) == null ? void 0 : Le.hideSidebars) === !0,
          "fixed-size": (lt = l.value) == null ? void 0 : lt.fixedSize,
          "extra-style": (Rt = l.value) == null ? void 0 : Rt.extraStyle
        }, null, 8, ["pagination-data", "change-page", "hide-sidebars", "fixed-size", "extra-style"]),
        A(Eme, {
          open: de.value,
          "onUpdate:open": Ee[21] || (Ee[21] = (nt) => de.value = nt),
          meta: S.value,
          row: { row: {}, oldRow: {}, rowMeta: {} },
          "row-id": ye.value,
          "first-row": Pe.value === 0,
          "last-row": Pe.value === s.value.length - 1,
          "show-next-prev-icons": "",
          onNext: Ee[22] || (Ee[22] = (nt) => ot()),
          onPrev: Ee[23] || (Ee[23] = (nt) => Je())
        }, null, 8, ["open", "meta", "row-id", "first-row", "last-row"])
      ]);
    };
  }
}), qme = /* @__PURE__ */ Cn(Yme, [["__scopeId", "data-v-cdf44d1a"]]);
var jM = { exports: {} };
(function(e, t) {
  (function(n, r) {
    r();
  })(ra, function() {
    function n(u, c) {
      return typeof c > "u" ? c = { autoBom: !1 } : typeof c != "object" && (console.warn("Deprecated: Expected third argument to be a object"), c = { autoBom: !c }), c.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(u.type) ? new Blob(["\uFEFF", u], { type: u.type }) : u;
    }
    function r(u, c, f) {
      var d = new XMLHttpRequest();
      d.open("GET", u), d.responseType = "blob", d.onload = function() {
        l(d.response, c, f);
      }, d.onerror = function() {
        console.error("could not download file");
      }, d.send();
    }
    function a(u) {
      var c = new XMLHttpRequest();
      c.open("HEAD", u, !1);
      try {
        c.send();
      } catch {
      }
      return 200 <= c.status && 299 >= c.status;
    }
    function o(u) {
      try {
        u.dispatchEvent(new MouseEvent("click"));
      } catch {
        var c = document.createEvent("MouseEvents");
        c.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), u.dispatchEvent(c);
      }
    }
    var i = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof ra == "object" && ra.global === ra ? ra : void 0, s = i.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), l = i.saveAs || (typeof window != "object" || window !== i ? function() {
    } : "download" in HTMLAnchorElement.prototype && !s ? function(u, c, f) {
      var d = i.URL || i.webkitURL, p = document.createElement("a");
      c = c || u.name || "download", p.download = c, p.rel = "noopener", typeof u == "string" ? (p.href = u, p.origin === location.origin ? o(p) : a(p.href) ? r(u, c, f) : o(p, p.target = "_blank")) : (p.href = d.createObjectURL(u), setTimeout(function() {
        d.revokeObjectURL(p.href);
      }, 4e4), setTimeout(function() {
        o(p);
      }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(u, c, f) {
      if (c = c || u.name || "download", typeof u != "string") navigator.msSaveOrOpenBlob(n(u, f), c);
      else if (a(u)) r(u, c, f);
      else {
        var d = document.createElement("a");
        d.href = u, d.target = "_blank", setTimeout(function() {
          o(d);
        });
      }
    } : function(u, c, f, d) {
      if (d = d || open("", "_blank"), d && (d.document.title = d.document.body.innerText = "downloading..."), typeof u == "string") return r(u, c, f);
      var p = u.type === "application/octet-stream", v = /constructor/i.test(i.HTMLElement) || i.safari, h = /CriOS\/[\d]+/.test(navigator.userAgent);
      if ((h || p && v || s) && typeof FileReader < "u") {
        var m = new FileReader();
        m.onloadend = function() {
          var g = m.result;
          g = h ? g : g.replace(/^data:[^;]*;/, "data:attachment/file;"), d ? d.location.href = g : location = g, d = null;
        }, m.readAsDataURL(u);
      } else {
        var y = i.URL || i.webkitURL, x = y.createObjectURL(u);
        d ? d.location = x : location.href = x, d = null, setTimeout(function() {
          y.revokeObjectURL(x);
        }, 4e4);
      }
    });
    i.saveAs = l.saveAs = l, e.exports = l;
  });
})(jM);
var vTe = jM.exports;
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
var Jm = {};
Jm.version = "0.18.5";
var VM = 1252, Xme = [874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 1e4], F4 = {
  /*::[*/
  0: 1252,
  /* ANSI */
  /*::[*/
  1: 65001,
  /* DEFAULT */
  /*::[*/
  2: 65001,
  /* SYMBOL */
  /*::[*/
  77: 1e4,
  /* MAC */
  /*::[*/
  128: 932,
  /* SHIFTJIS */
  /*::[*/
  129: 949,
  /* HANGUL */
  /*::[*/
  130: 1361,
  /* JOHAB */
  /*::[*/
  134: 936,
  /* GB2312 */
  /*::[*/
  136: 950,
  /* CHINESEBIG5 */
  /*::[*/
  161: 1253,
  /* GREEK */
  /*::[*/
  162: 1254,
  /* TURKISH */
  /*::[*/
  163: 1258,
  /* VIETNAMESE */
  /*::[*/
  177: 1255,
  /* HEBREW */
  /*::[*/
  178: 1256,
  /* ARABIC */
  /*::[*/
  186: 1257,
  /* BALTIC */
  /*::[*/
  204: 1251,
  /* RUSSIAN */
  /*::[*/
  222: 874,
  /* THAI */
  /*::[*/
  238: 1250,
  /* EASTEUROPE */
  /*::[*/
  255: 1252,
  /* OEM */
  /*::[*/
  69: 6969
  /* MISC */
}, L4 = function(e) {
  Xme.indexOf(e) != -1 && (VM = F4[0] = e);
};
function Zme() {
  L4(1252);
}
var Fi = function(e) {
  L4(e);
};
function B4() {
  Fi(1200), Zme();
}
function B6(e) {
  for (var t = [], n = 0, r = e.length; n < r; ++n) t[n] = e.charCodeAt(n);
  return t;
}
function Qme(e) {
  for (var t = [], n = 0; n < e.length >> 1; ++n) t[n] = String.fromCharCode(e.charCodeAt(2 * n) + (e.charCodeAt(2 * n + 1) << 8));
  return t.join("");
}
function UM(e) {
  for (var t = [], n = 0; n < e.length >> 1; ++n) t[n] = String.fromCharCode(e.charCodeAt(2 * n + 1) + (e.charCodeAt(2 * n) << 8));
  return t.join("");
}
var l0 = function(e) {
  var t = e.charCodeAt(0), n = e.charCodeAt(1);
  return t == 255 && n == 254 ? Qme(e.slice(2)) : t == 254 && n == 255 ? UM(e.slice(2)) : t == 65279 ? e.slice(1) : e;
}, uv = function(t) {
  return String.fromCharCode(t);
}, H6 = function(t) {
  return String.fromCharCode(t);
}, kl, Bl = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function vp(e) {
  for (var t = "", n = 0, r = 0, a = 0, o = 0, i = 0, s = 0, l = 0, u = 0; u < e.length; )
    n = e.charCodeAt(u++), o = n >> 2, r = e.charCodeAt(u++), i = (n & 3) << 4 | r >> 4, a = e.charCodeAt(u++), s = (r & 15) << 2 | a >> 6, l = a & 63, isNaN(r) ? s = l = 64 : isNaN(a) && (l = 64), t += Bl.charAt(o) + Bl.charAt(i) + Bl.charAt(s) + Bl.charAt(l);
  return t;
}
function Fo(e) {
  var t = "", n = 0, r = 0, a = 0, o = 0, i = 0, s = 0, l = 0;
  e = e.replace(/[^\w\+\/\=]/g, "");
  for (var u = 0; u < e.length; )
    o = Bl.indexOf(e.charAt(u++)), i = Bl.indexOf(e.charAt(u++)), n = o << 2 | i >> 4, t += String.fromCharCode(n), s = Bl.indexOf(e.charAt(u++)), r = (i & 15) << 4 | s >> 2, s !== 64 && (t += String.fromCharCode(r)), l = Bl.indexOf(e.charAt(u++)), a = (s & 3) << 6 | l, l !== 64 && (t += String.fromCharCode(a));
  return t;
}
var on = /* @__PURE__ */ function() {
  return typeof Buffer < "u" && typeof process < "u" && typeof process.versions < "u" && !!process.versions.node;
}(), cl = /* @__PURE__ */ function() {
  if (typeof Buffer < "u") {
    var e = !Buffer.from;
    if (!e) try {
      Buffer.from("foo", "utf8");
    } catch {
      e = !0;
    }
    return e ? function(t, n) {
      return n ? new Buffer(t, n) : new Buffer(t);
    } : Buffer.from.bind(Buffer);
  }
  return function() {
  };
}();
function ru(e) {
  return on ? Buffer.alloc ? Buffer.alloc(e) : new Buffer(e) : typeof Uint8Array < "u" ? new Uint8Array(e) : new Array(e);
}
function j6(e) {
  return on ? Buffer.allocUnsafe ? Buffer.allocUnsafe(e) : new Buffer(e) : typeof Uint8Array < "u" ? new Uint8Array(e) : new Array(e);
}
var Po = function(t) {
  return on ? cl(t, "binary") : t.split("").map(function(n) {
    return n.charCodeAt(0) & 255;
  });
};
function B1(e) {
  if (typeof ArrayBuffer > "u") return Po(e);
  for (var t = new ArrayBuffer(e.length), n = new Uint8Array(t), r = 0; r != e.length; ++r) n[r] = e.charCodeAt(r) & 255;
  return t;
}
function vu(e) {
  if (Array.isArray(e)) return e.map(function(r) {
    return String.fromCharCode(r);
  }).join("");
  for (var t = [], n = 0; n < e.length; ++n) t[n] = String.fromCharCode(e[n]);
  return t.join("");
}
function Jme(e) {
  if (typeof Uint8Array > "u") throw new Error("Unsupported");
  return new Uint8Array(e);
}
function H4(e) {
  if (typeof ArrayBuffer > "u") throw new Error("Unsupported");
  if (e instanceof ArrayBuffer) return H4(new Uint8Array(e));
  for (var t = new Array(e.length), n = 0; n < e.length; ++n) t[n] = e[n];
  return t;
}
var zr = on ? function(e) {
  return Buffer.concat(e.map(function(t) {
    return Buffer.isBuffer(t) ? t : cl(t);
  }));
} : function(e) {
  if (typeof Uint8Array < "u") {
    var t = 0, n = 0;
    for (t = 0; t < e.length; ++t) n += e[t].length;
    var r = new Uint8Array(n), a = 0;
    for (t = 0, n = 0; t < e.length; n += a, ++t)
      if (a = e[t].length, e[t] instanceof Uint8Array) r.set(e[t], n);
      else {
        if (typeof e[t] == "string")
          throw "wtf";
        r.set(new Uint8Array(e[t]), n);
      }
    return r;
  }
  return [].concat.apply([], e.map(function(o) {
    return Array.isArray(o) ? o : [].slice.call(o);
  }));
};
function ege(e) {
  for (var t = [], n = 0, r = e.length + 250, a = ru(e.length + 255), o = 0; o < e.length; ++o) {
    var i = e.charCodeAt(o);
    if (i < 128) a[n++] = i;
    else if (i < 2048)
      a[n++] = 192 | i >> 6 & 31, a[n++] = 128 | i & 63;
    else if (i >= 55296 && i < 57344) {
      i = (i & 1023) + 64;
      var s = e.charCodeAt(++o) & 1023;
      a[n++] = 240 | i >> 8 & 7, a[n++] = 128 | i >> 2 & 63, a[n++] = 128 | s >> 6 & 15 | (i & 3) << 4, a[n++] = 128 | s & 63;
    } else
      a[n++] = 224 | i >> 12 & 15, a[n++] = 128 | i >> 6 & 63, a[n++] = 128 | i & 63;
    n > r && (t.push(a.slice(0, n)), n = 0, a = ru(65535), r = 65530);
  }
  return t.push(a.slice(0, n)), zr(t);
}
var Ya = /\u0000/g, u0 = /[\u0001-\u0006]/g;
function If(e) {
  for (var t = "", n = e.length - 1; n >= 0; ) t += e.charAt(n--);
  return t;
}
function Li(e, t) {
  var n = "" + e;
  return n.length >= t ? n : hr("0", t - n.length) + n;
}
function j4(e, t) {
  var n = "" + e;
  return n.length >= t ? n : hr(" ", t - n.length) + n;
}
function eg(e, t) {
  var n = "" + e;
  return n.length >= t ? n : n + hr(" ", t - n.length);
}
function tge(e, t) {
  var n = "" + Math.round(e);
  return n.length >= t ? n : hr("0", t - n.length) + n;
}
function nge(e, t) {
  var n = "" + e;
  return n.length >= t ? n : hr("0", t - n.length) + n;
}
var V6 = /* @__PURE__ */ Math.pow(2, 32);
function ef(e, t) {
  if (e > V6 || e < -V6) return tge(e, t);
  var n = Math.round(e);
  return nge(n, t);
}
function tg(e, t) {
  return t = t || 0, e.length >= 7 + t && (e.charCodeAt(t) | 32) === 103 && (e.charCodeAt(t + 1) | 32) === 101 && (e.charCodeAt(t + 2) | 32) === 110 && (e.charCodeAt(t + 3) | 32) === 101 && (e.charCodeAt(t + 4) | 32) === 114 && (e.charCodeAt(t + 5) | 32) === 97 && (e.charCodeAt(t + 6) | 32) === 108;
}
var U6 = [
  ["Sun", "Sunday"],
  ["Mon", "Monday"],
  ["Tue", "Tuesday"],
  ["Wed", "Wednesday"],
  ["Thu", "Thursday"],
  ["Fri", "Friday"],
  ["Sat", "Saturday"]
], Ox = [
  ["J", "Jan", "January"],
  ["F", "Feb", "February"],
  ["M", "Mar", "March"],
  ["A", "Apr", "April"],
  ["M", "May", "May"],
  ["J", "Jun", "June"],
  ["J", "Jul", "July"],
  ["A", "Aug", "August"],
  ["S", "Sep", "September"],
  ["O", "Oct", "October"],
  ["N", "Nov", "November"],
  ["D", "Dec", "December"]
];
function rge(e) {
  return e || (e = {}), e[0] = "General", e[1] = "0", e[2] = "0.00", e[3] = "#,##0", e[4] = "#,##0.00", e[9] = "0%", e[10] = "0.00%", e[11] = "0.00E+00", e[12] = "# ?/?", e[13] = "# ??/??", e[14] = "m/d/yy", e[15] = "d-mmm-yy", e[16] = "d-mmm", e[17] = "mmm-yy", e[18] = "h:mm AM/PM", e[19] = "h:mm:ss AM/PM", e[20] = "h:mm", e[21] = "h:mm:ss", e[22] = "m/d/yy h:mm", e[37] = "#,##0 ;(#,##0)", e[38] = "#,##0 ;[Red](#,##0)", e[39] = "#,##0.00;(#,##0.00)", e[40] = "#,##0.00;[Red](#,##0.00)", e[45] = "mm:ss", e[46] = "[h]:mm:ss", e[47] = "mmss.0", e[48] = "##0.0E+0", e[49] = "@", e[56] = '"上午/下午 "hh"時"mm"分"ss"秒 "', e;
}
var jt = {
  0: "General",
  1: "0",
  2: "0.00",
  3: "#,##0",
  4: "#,##0.00",
  9: "0%",
  10: "0.00%",
  11: "0.00E+00",
  12: "# ?/?",
  13: "# ??/??",
  14: "m/d/yy",
  15: "d-mmm-yy",
  16: "d-mmm",
  17: "mmm-yy",
  18: "h:mm AM/PM",
  19: "h:mm:ss AM/PM",
  20: "h:mm",
  21: "h:mm:ss",
  22: "m/d/yy h:mm",
  37: "#,##0 ;(#,##0)",
  38: "#,##0 ;[Red](#,##0)",
  39: "#,##0.00;(#,##0.00)",
  40: "#,##0.00;[Red](#,##0.00)",
  45: "mm:ss",
  46: "[h]:mm:ss",
  47: "mmss.0",
  48: "##0.0E+0",
  49: "@",
  56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
}, z6 = {
  5: 37,
  6: 38,
  7: 39,
  8: 40,
  //  5 -> 37 ...  8 -> 40
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  // 23 ->  0 ... 26 ->  0
  27: 14,
  28: 14,
  29: 14,
  30: 14,
  31: 14,
  // 27 -> 14 ... 31 -> 14
  50: 14,
  51: 14,
  52: 14,
  53: 14,
  54: 14,
  // 50 -> 14 ... 58 -> 14
  55: 14,
  56: 14,
  57: 14,
  58: 14,
  59: 1,
  60: 2,
  61: 3,
  62: 4,
  // 59 ->  1 ... 62 ->  4
  67: 9,
  68: 10,
  // 67 ->  9 ... 68 -> 10
  69: 12,
  70: 13,
  71: 14,
  // 69 -> 12 ... 71 -> 14
  72: 14,
  73: 15,
  74: 16,
  75: 17,
  // 72 -> 14 ... 75 -> 17
  76: 20,
  77: 21,
  78: 22,
  // 76 -> 20 ... 78 -> 22
  79: 45,
  80: 46,
  81: 47,
  // 79 -> 45 ... 81 -> 47
  82: 0
  // 82 ->  0 ... 65536 -> 0 (omitted)
}, age = {
  //  5 -- Currency,   0 decimal, black negative
  5: '"$"#,##0_);\\("$"#,##0\\)',
  63: '"$"#,##0_);\\("$"#,##0\\)',
  //  6 -- Currency,   0 decimal, red   negative
  6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  //  7 -- Currency,   2 decimal, black negative
  7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  //  8 -- Currency,   2 decimal, red   negative
  8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  // 41 -- Accounting, 0 decimal, No Symbol
  41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
  // 42 -- Accounting, 0 decimal, $  Symbol
  42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
  // 43 -- Accounting, 2 decimal, No Symbol
  43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
  // 44 -- Accounting, 2 decimal, $  Symbol
  44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function ng(e, t, n) {
  for (var r = e < 0 ? -1 : 1, a = e * r, o = 0, i = 1, s = 0, l = 1, u = 0, c = 0, f = Math.floor(a); u < t && (f = Math.floor(a), s = f * i + o, c = f * u + l, !(a - f < 5e-8)); )
    a = 1 / (a - f), o = i, i = s, l = u, u = c;
  if (c > t && (u > t ? (c = l, s = o) : (c = u, s = i)), !n) return [0, r * s, c];
  var d = Math.floor(r * s / c);
  return [d, r * s - d * c, c];
}
function Bu(e, t, n) {
  if (e > 2958465 || e < 0) return null;
  var r = e | 0, a = Math.floor(86400 * (e - r)), o = 0, i = [], s = { D: r, T: a, u: 86400 * (e - r) - a, y: 0, m: 0, d: 0, H: 0, M: 0, S: 0, q: 0 };
  if (Math.abs(s.u) < 1e-6 && (s.u = 0), t && t.date1904 && (r += 1462), s.u > 0.9999 && (s.u = 0, ++a == 86400 && (s.T = a = 0, ++r, ++s.D)), r === 60)
    i = n ? [1317, 10, 29] : [1900, 2, 29], o = 3;
  else if (r === 0)
    i = n ? [1317, 8, 29] : [1900, 1, 0], o = 6;
  else {
    r > 60 && --r;
    var l = new Date(1900, 0, 1);
    l.setDate(l.getDate() + r - 1), i = [l.getFullYear(), l.getMonth() + 1, l.getDate()], o = l.getDay(), r < 60 && (o = (o + 6) % 7), n && (o = cge(l, i));
  }
  return s.y = i[0], s.m = i[1], s.d = i[2], s.S = a % 60, a = Math.floor(a / 60), s.M = a % 60, a = Math.floor(a / 60), s.H = a, s.q = o, s;
}
var zM = /* @__PURE__ */ new Date(1899, 11, 31, 0, 0, 0), oge = /* @__PURE__ */ zM.getTime(), ige = /* @__PURE__ */ new Date(1900, 2, 1, 0, 0, 0);
function WM(e, t) {
  var n = /* @__PURE__ */ e.getTime();
  return t ? n -= 1461 * 24 * 60 * 60 * 1e3 : e >= ige && (n += 24 * 60 * 60 * 1e3), (n - (oge + (/* @__PURE__ */ e.getTimezoneOffset() - /* @__PURE__ */ zM.getTimezoneOffset()) * 6e4)) / (24 * 60 * 60 * 1e3);
}
function V4(e) {
  return e.indexOf(".") == -1 ? e : e.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
function sge(e) {
  return e.indexOf("E") == -1 ? e : e.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
function lge(e) {
  var t = e < 0 ? 12 : 11, n = V4(e.toFixed(12));
  return n.length <= t || (n = e.toPrecision(10), n.length <= t) ? n : e.toExponential(5);
}
function uge(e) {
  var t = V4(e.toFixed(11));
  return t.length > (e < 0 ? 12 : 11) || t === "0" || t === "-0" ? e.toPrecision(6) : t;
}
function mp(e) {
  var t = Math.floor(Math.log(Math.abs(e)) * Math.LOG10E), n;
  return t >= -4 && t <= -1 ? n = e.toPrecision(10 + t) : Math.abs(t) <= 9 ? n = lge(e) : t === 10 ? n = e.toFixed(10).substr(0, 12) : n = uge(e), V4(sge(n.toUpperCase()));
}
function vc(e, t) {
  switch (typeof e) {
    case "string":
      return e;
    case "boolean":
      return e ? "TRUE" : "FALSE";
    case "number":
      return (e | 0) === e ? e.toString(10) : mp(e);
    case "undefined":
      return "";
    case "object":
      if (e == null) return "";
      if (e instanceof Date) return pi(14, WM(e, t && t.date1904), t);
  }
  throw new Error("unsupported value in General format: " + e);
}
function cge(e, t) {
  t[0] -= 581;
  var n = e.getDay();
  return e < 60 && (n = (n + 6) % 7), n;
}
function fge(e, t, n, r) {
  var a = "", o = 0, i = 0, s = n.y, l, u = 0;
  switch (e) {
    case 98:
      s = n.y + 543;
    case 121:
      switch (t.length) {
        case 1:
        case 2:
          l = s % 100, u = 2;
          break;
        default:
          l = s % 1e4, u = 4;
          break;
      }
      break;
    case 109:
      switch (t.length) {
        case 1:
        case 2:
          l = n.m, u = t.length;
          break;
        case 3:
          return Ox[n.m - 1][1];
        case 5:
          return Ox[n.m - 1][0];
        default:
          return Ox[n.m - 1][2];
      }
      break;
    case 100:
      switch (t.length) {
        case 1:
        case 2:
          l = n.d, u = t.length;
          break;
        case 3:
          return U6[n.q][0];
        default:
          return U6[n.q][1];
      }
      break;
    case 104:
      switch (t.length) {
        case 1:
        case 2:
          l = 1 + (n.H + 11) % 12, u = t.length;
          break;
        default:
          throw "bad hour format: " + t;
      }
      break;
    case 72:
      switch (t.length) {
        case 1:
        case 2:
          l = n.H, u = t.length;
          break;
        default:
          throw "bad hour format: " + t;
      }
      break;
    case 77:
      switch (t.length) {
        case 1:
        case 2:
          l = n.M, u = t.length;
          break;
        default:
          throw "bad minute format: " + t;
      }
      break;
    case 115:
      if (t != "s" && t != "ss" && t != ".0" && t != ".00" && t != ".000") throw "bad second format: " + t;
      return n.u === 0 && (t == "s" || t == "ss") ? Li(n.S, t.length) : (r >= 2 ? i = r === 3 ? 1e3 : 100 : i = r === 1 ? 10 : 1, o = Math.round(i * (n.S + n.u)), o >= 60 * i && (o = 0), t === "s" ? o === 0 ? "0" : "" + o / i : (a = Li(o, 2 + r), t === "ss" ? a.substr(0, 2) : "." + a.substr(2, t.length - 1)));
    case 90:
      switch (t) {
        case "[h]":
        case "[hh]":
          l = n.D * 24 + n.H;
          break;
        case "[m]":
        case "[mm]":
          l = (n.D * 24 + n.H) * 60 + n.M;
          break;
        case "[s]":
        case "[ss]":
          l = ((n.D * 24 + n.H) * 60 + n.M) * 60 + Math.round(n.S + n.u);
          break;
        default:
          throw "bad abstime format: " + t;
      }
      u = t.length === 3 ? 1 : 2;
      break;
    case 101:
      l = s, u = 1;
      break;
  }
  var c = u > 0 ? Li(l, u) : "";
  return c;
}
function Hl(e) {
  var t = 3;
  if (e.length <= t) return e;
  for (var n = e.length % t, r = e.substr(0, n); n != e.length; n += t) r += (r.length > 0 ? "," : "") + e.substr(n, t);
  return r;
}
var GM = /%/g;
function dge(e, t, n) {
  var r = t.replace(GM, ""), a = t.length - r.length;
  return Ys(e, r, n * Math.pow(10, 2 * a)) + hr("%", a);
}
function pge(e, t, n) {
  for (var r = t.length - 1; t.charCodeAt(r - 1) === 44; ) --r;
  return Ys(e, t.substr(0, r), n / Math.pow(10, 3 * (t.length - r)));
}
function KM(e, t) {
  var n, r = e.indexOf("E") - e.indexOf(".") - 1;
  if (e.match(/^#+0.0E\+0$/)) {
    if (t == 0) return "0.0E+0";
    if (t < 0) return "-" + KM(e, -t);
    var a = e.indexOf(".");
    a === -1 && (a = e.indexOf("E"));
    var o = Math.floor(Math.log(t) * Math.LOG10E) % a;
    if (o < 0 && (o += a), n = (t / Math.pow(10, o)).toPrecision(r + 1 + (a + o) % a), n.indexOf("e") === -1) {
      var i = Math.floor(Math.log(t) * Math.LOG10E);
      for (n.indexOf(".") === -1 ? n = n.charAt(0) + "." + n.substr(1) + "E+" + (i - n.length + o) : n += "E+" + (i - o); n.substr(0, 2) === "0."; )
        n = n.charAt(0) + n.substr(2, a) + "." + n.substr(2 + a), n = n.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
      n = n.replace(/\+-/, "-");
    }
    n = n.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(s, l, u, c) {
      return l + u + c.substr(0, (a + o) % a) + "." + c.substr(o) + "E";
    });
  } else n = t.toExponential(r);
  return e.match(/E\+00$/) && n.match(/e[+-]\d$/) && (n = n.substr(0, n.length - 1) + "0" + n.charAt(n.length - 1)), e.match(/E\-/) && n.match(/e\+/) && (n = n.replace(/e\+/, "e")), n.replace("e", "E");
}
var YM = /# (\?+)( ?)\/( ?)(\d+)/;
function hge(e, t, n) {
  var r = parseInt(e[4], 10), a = Math.round(t * r), o = Math.floor(a / r), i = a - o * r, s = r;
  return n + (o === 0 ? "" : "" + o) + " " + (i === 0 ? hr(" ", e[1].length + 1 + e[4].length) : j4(i, e[1].length) + e[2] + "/" + e[3] + Li(s, e[4].length));
}
function vge(e, t, n) {
  return n + (t === 0 ? "" : "" + t) + hr(" ", e[1].length + 2 + e[4].length);
}
var qM = /^#*0*\.([0#]+)/, XM = /\).*[0#]/, ZM = /\(###\) ###\\?-####/;
function ja(e) {
  for (var t = "", n, r = 0; r != e.length; ++r) switch (n = e.charCodeAt(r)) {
    case 35:
      break;
    case 63:
      t += " ";
      break;
    case 48:
      t += "0";
      break;
    default:
      t += String.fromCharCode(n);
  }
  return t;
}
function W6(e, t) {
  var n = Math.pow(10, t);
  return "" + Math.round(e * n) / n;
}
function G6(e, t) {
  var n = e - Math.floor(e), r = Math.pow(10, t);
  return t < ("" + Math.round(n * r)).length ? 0 : Math.round(n * r);
}
function mge(e, t) {
  return t < ("" + Math.round((e - Math.floor(e)) * Math.pow(10, t))).length ? 1 : 0;
}
function gge(e) {
  return e < 2147483647 && e > -2147483648 ? "" + (e >= 0 ? e | 0 : e - 1 | 0) : "" + Math.floor(e);
}
function qo(e, t, n) {
  if (e.charCodeAt(0) === 40 && !t.match(XM)) {
    var r = t.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return n >= 0 ? qo("n", r, n) : "(" + qo("n", r, -n) + ")";
  }
  if (t.charCodeAt(t.length - 1) === 44) return pge(e, t, n);
  if (t.indexOf("%") !== -1) return dge(e, t, n);
  if (t.indexOf("E") !== -1) return KM(t, n);
  if (t.charCodeAt(0) === 36) return "$" + qo(e, t.substr(t.charAt(1) == " " ? 2 : 1), n);
  var a, o, i, s, l = Math.abs(n), u = n < 0 ? "-" : "";
  if (t.match(/^00+$/)) return u + ef(l, t.length);
  if (t.match(/^[#?]+$/))
    return a = ef(n, 0), a === "0" && (a = ""), a.length > t.length ? a : ja(t.substr(0, t.length - a.length)) + a;
  if (o = t.match(YM)) return hge(o, l, u);
  if (t.match(/^#+0+$/)) return u + ef(l, t.length - t.indexOf("0"));
  if (o = t.match(qM))
    return a = W6(n, o[1].length).replace(/^([^\.]+)$/, "$1." + ja(o[1])).replace(/\.$/, "." + ja(o[1])).replace(/\.(\d*)$/, function(v, h) {
      return "." + h + hr("0", ja(
        /*::(*/
        o[1]
      ).length - h.length);
    }), t.indexOf("0.") !== -1 ? a : a.replace(/^0\./, ".");
  if (t = t.replace(/^#+([0.])/, "$1"), o = t.match(/^(0*)\.(#*)$/))
    return u + W6(l, o[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, o[1].length ? "0." : ".");
  if (o = t.match(/^#{1,3},##0(\.?)$/)) return u + Hl(ef(l, 0));
  if (o = t.match(/^#,##0\.([#0]*0)$/))
    return n < 0 ? "-" + qo(e, t, -n) : Hl("" + (Math.floor(n) + mge(n, o[1].length))) + "." + Li(G6(n, o[1].length), o[1].length);
  if (o = t.match(/^#,#*,#0/)) return qo(e, t.replace(/^#,#*,/, ""), n);
  if (o = t.match(/^([0#]+)(\\?-([0#]+))+$/))
    return a = If(qo(e, t.replace(/[\\-]/g, ""), n)), i = 0, If(If(t.replace(/\\/g, "")).replace(/[0#]/g, function(v) {
      return i < a.length ? a.charAt(i++) : v === "0" ? "0" : "";
    }));
  if (t.match(ZM))
    return a = qo(e, "##########", n), "(" + a.substr(0, 3) + ") " + a.substr(3, 3) + "-" + a.substr(6);
  var c = "";
  if (o = t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return i = Math.min(
      /*::String(*/
      o[4].length,
      7
    ), s = ng(l, Math.pow(10, i) - 1, !1), a = "" + u, c = Ys(
      "n",
      /*::String(*/
      o[1],
      s[1]
    ), c.charAt(c.length - 1) == " " && (c = c.substr(0, c.length - 1) + "0"), a += c + /*::String(*/
    o[2] + "/" + /*::String(*/
    o[3], c = eg(s[2], i), c.length < o[4].length && (c = ja(o[4].substr(o[4].length - c.length)) + c), a += c, a;
  if (o = t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return i = Math.min(Math.max(o[1].length, o[4].length), 7), s = ng(l, Math.pow(10, i) - 1, !0), u + (s[0] || (s[1] ? "" : "0")) + " " + (s[1] ? j4(s[1], i) + o[2] + "/" + o[3] + eg(s[2], i) : hr(" ", 2 * i + 1 + o[2].length + o[3].length));
  if (o = t.match(/^[#0?]+$/))
    return a = ef(n, 0), t.length <= a.length ? a : ja(t.substr(0, t.length - a.length)) + a;
  if (o = t.match(/^([#0?]+)\.([#0]+)$/)) {
    a = "" + n.toFixed(Math.min(o[2].length, 10)).replace(/([^0])0+$/, "$1"), i = a.indexOf(".");
    var f = t.indexOf(".") - i, d = t.length - a.length - f;
    return ja(t.substr(0, f) + a + t.substr(t.length - d));
  }
  if (o = t.match(/^00,000\.([#0]*0)$/))
    return i = G6(n, o[1].length), n < 0 ? "-" + qo(e, t, -n) : Hl(gge(n)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(v) {
      return "00," + (v.length < 3 ? Li(0, 3 - v.length) : "") + v;
    }) + "." + Li(i, o[1].length);
  switch (t) {
    case "###,##0.00":
      return qo(e, "#,##0.00", n);
    case "###,###":
    case "##,###":
    case "#,###":
      var p = Hl(ef(l, 0));
      return p !== "0" ? u + p : "";
    case "###,###.00":
      return qo(e, "###,##0.00", n).replace(/^0\./, ".");
    case "#,###.00":
      return qo(e, "#,##0.00", n).replace(/^0\./, ".");
  }
  throw new Error("unsupported format |" + t + "|");
}
function yge(e, t, n) {
  for (var r = t.length - 1; t.charCodeAt(r - 1) === 44; ) --r;
  return Ys(e, t.substr(0, r), n / Math.pow(10, 3 * (t.length - r)));
}
function xge(e, t, n) {
  var r = t.replace(GM, ""), a = t.length - r.length;
  return Ys(e, r, n * Math.pow(10, 2 * a)) + hr("%", a);
}
function QM(e, t) {
  var n, r = e.indexOf("E") - e.indexOf(".") - 1;
  if (e.match(/^#+0.0E\+0$/)) {
    if (t == 0) return "0.0E+0";
    if (t < 0) return "-" + QM(e, -t);
    var a = e.indexOf(".");
    a === -1 && (a = e.indexOf("E"));
    var o = Math.floor(Math.log(t) * Math.LOG10E) % a;
    if (o < 0 && (o += a), n = (t / Math.pow(10, o)).toPrecision(r + 1 + (a + o) % a), !n.match(/[Ee]/)) {
      var i = Math.floor(Math.log(t) * Math.LOG10E);
      n.indexOf(".") === -1 ? n = n.charAt(0) + "." + n.substr(1) + "E+" + (i - n.length + o) : n += "E+" + (i - o), n = n.replace(/\+-/, "-");
    }
    n = n.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(s, l, u, c) {
      return l + u + c.substr(0, (a + o) % a) + "." + c.substr(o) + "E";
    });
  } else n = t.toExponential(r);
  return e.match(/E\+00$/) && n.match(/e[+-]\d$/) && (n = n.substr(0, n.length - 1) + "0" + n.charAt(n.length - 1)), e.match(/E\-/) && n.match(/e\+/) && (n = n.replace(/e\+/, "e")), n.replace("e", "E");
}
function Zi(e, t, n) {
  if (e.charCodeAt(0) === 40 && !t.match(XM)) {
    var r = t.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return n >= 0 ? Zi("n", r, n) : "(" + Zi("n", r, -n) + ")";
  }
  if (t.charCodeAt(t.length - 1) === 44) return yge(e, t, n);
  if (t.indexOf("%") !== -1) return xge(e, t, n);
  if (t.indexOf("E") !== -1) return QM(t, n);
  if (t.charCodeAt(0) === 36) return "$" + Zi(e, t.substr(t.charAt(1) == " " ? 2 : 1), n);
  var a, o, i, s, l = Math.abs(n), u = n < 0 ? "-" : "";
  if (t.match(/^00+$/)) return u + Li(l, t.length);
  if (t.match(/^[#?]+$/))
    return a = "" + n, n === 0 && (a = ""), a.length > t.length ? a : ja(t.substr(0, t.length - a.length)) + a;
  if (o = t.match(YM)) return vge(o, l, u);
  if (t.match(/^#+0+$/)) return u + Li(l, t.length - t.indexOf("0"));
  if (o = t.match(qM))
    return a = ("" + n).replace(/^([^\.]+)$/, "$1." + ja(o[1])).replace(/\.$/, "." + ja(o[1])), a = a.replace(/\.(\d*)$/, function(v, h) {
      return "." + h + hr("0", ja(o[1]).length - h.length);
    }), t.indexOf("0.") !== -1 ? a : a.replace(/^0\./, ".");
  if (t = t.replace(/^#+([0.])/, "$1"), o = t.match(/^(0*)\.(#*)$/))
    return u + ("" + l).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, o[1].length ? "0." : ".");
  if (o = t.match(/^#{1,3},##0(\.?)$/)) return u + Hl("" + l);
  if (o = t.match(/^#,##0\.([#0]*0)$/))
    return n < 0 ? "-" + Zi(e, t, -n) : Hl("" + n) + "." + hr("0", o[1].length);
  if (o = t.match(/^#,#*,#0/)) return Zi(e, t.replace(/^#,#*,/, ""), n);
  if (o = t.match(/^([0#]+)(\\?-([0#]+))+$/))
    return a = If(Zi(e, t.replace(/[\\-]/g, ""), n)), i = 0, If(If(t.replace(/\\/g, "")).replace(/[0#]/g, function(v) {
      return i < a.length ? a.charAt(i++) : v === "0" ? "0" : "";
    }));
  if (t.match(ZM))
    return a = Zi(e, "##########", n), "(" + a.substr(0, 3) + ") " + a.substr(3, 3) + "-" + a.substr(6);
  var c = "";
  if (o = t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return i = Math.min(
      /*::String(*/
      o[4].length,
      7
    ), s = ng(l, Math.pow(10, i) - 1, !1), a = "" + u, c = Ys(
      "n",
      /*::String(*/
      o[1],
      s[1]
    ), c.charAt(c.length - 1) == " " && (c = c.substr(0, c.length - 1) + "0"), a += c + /*::String(*/
    o[2] + "/" + /*::String(*/
    o[3], c = eg(s[2], i), c.length < o[4].length && (c = ja(o[4].substr(o[4].length - c.length)) + c), a += c, a;
  if (o = t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return i = Math.min(Math.max(o[1].length, o[4].length), 7), s = ng(l, Math.pow(10, i) - 1, !0), u + (s[0] || (s[1] ? "" : "0")) + " " + (s[1] ? j4(s[1], i) + o[2] + "/" + o[3] + eg(s[2], i) : hr(" ", 2 * i + 1 + o[2].length + o[3].length));
  if (o = t.match(/^[#0?]+$/))
    return a = "" + n, t.length <= a.length ? a : ja(t.substr(0, t.length - a.length)) + a;
  if (o = t.match(/^([#0]+)\.([#0]+)$/)) {
    a = "" + n.toFixed(Math.min(o[2].length, 10)).replace(/([^0])0+$/, "$1"), i = a.indexOf(".");
    var f = t.indexOf(".") - i, d = t.length - a.length - f;
    return ja(t.substr(0, f) + a + t.substr(t.length - d));
  }
  if (o = t.match(/^00,000\.([#0]*0)$/))
    return n < 0 ? "-" + Zi(e, t, -n) : Hl("" + n).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(v) {
      return "00," + (v.length < 3 ? Li(0, 3 - v.length) : "") + v;
    }) + "." + Li(0, o[1].length);
  switch (t) {
    case "###,###":
    case "##,###":
    case "#,###":
      var p = Hl("" + l);
      return p !== "0" ? u + p : "";
    default:
      if (t.match(/\.[0#?]*$/)) return Zi(e, t.slice(0, t.lastIndexOf(".")), n) + ja(t.slice(t.lastIndexOf(".")));
  }
  throw new Error("unsupported format |" + t + "|");
}
function Ys(e, t, n) {
  return (n | 0) === n ? Zi(e, t, n) : qo(e, t, n);
}
function bge(e) {
  for (var t = [], n = !1, r = 0, a = 0; r < e.length; ++r) switch (
    /*cc=*/
    e.charCodeAt(r)
  ) {
    case 34:
      n = !n;
      break;
    case 95:
    case 42:
    case 92:
      ++r;
      break;
    case 59:
      t[t.length] = e.substr(a, r - a), a = r + 1;
  }
  if (t[t.length] = e.substr(a), n === !0) throw new Error("Format |" + e + "| unterminated string ");
  return t;
}
var JM = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function Ad(e) {
  for (var t = 0, n = "", r = ""; t < e.length; )
    switch (n = e.charAt(t)) {
      case "G":
        tg(e, t) && (t += 6), t++;
        break;
      case '"':
        for (
          ;
          /*cc=*/
          e.charCodeAt(++t) !== 34 && t < e.length;
        )
          ;
        ++t;
        break;
      case "\\":
        t += 2;
        break;
      case "_":
        t += 2;
        break;
      case "@":
        ++t;
        break;
      case "B":
      case "b":
        if (e.charAt(t + 1) === "1" || e.charAt(t + 1) === "2") return !0;
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        return !0;
      case "A":
      case "a":
      case "上":
        if (e.substr(t, 3).toUpperCase() === "A/P" || e.substr(t, 5).toUpperCase() === "AM/PM" || e.substr(t, 5).toUpperCase() === "上午/下午") return !0;
        ++t;
        break;
      case "[":
        for (r = n; e.charAt(t++) !== "]" && t < e.length; ) r += e.charAt(t);
        if (r.match(JM)) return !0;
        break;
      case ".":
      case "0":
      case "#":
        for (; t < e.length && ("0#?.,E+-%".indexOf(n = e.charAt(++t)) > -1 || n == "\\" && e.charAt(t + 1) == "-" && "0#".indexOf(e.charAt(t + 2)) > -1); )
          ;
        break;
      case "?":
        for (; e.charAt(++t) === n; )
          ;
        break;
      case "*":
        ++t, (e.charAt(t) == " " || e.charAt(t) == "*") && ++t;
        break;
      case "(":
      case ")":
        ++t;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (; t < e.length && "0123456789".indexOf(e.charAt(++t)) > -1; )
          ;
        break;
      case " ":
        ++t;
        break;
      default:
        ++t;
        break;
    }
  return !1;
}
function wge(e, t, n, r) {
  for (var a = [], o = "", i = 0, s = "", l = "t", u, c, f, d = "H"; i < e.length; )
    switch (s = e.charAt(i)) {
      case "G":
        if (!tg(e, i)) throw new Error("unrecognized character " + s + " in " + e);
        a[a.length] = { t: "G", v: "General" }, i += 7;
        break;
      case '"':
        for (o = ""; (f = e.charCodeAt(++i)) !== 34 && i < e.length; ) o += String.fromCharCode(f);
        a[a.length] = { t: "t", v: o }, ++i;
        break;
      case "\\":
        var p = e.charAt(++i), v = p === "(" || p === ")" ? p : "t";
        a[a.length] = { t: v, v: p }, ++i;
        break;
      case "_":
        a[a.length] = { t: "t", v: " " }, i += 2;
        break;
      case "@":
        a[a.length] = { t: "T", v: t }, ++i;
        break;
      case "B":
      case "b":
        if (e.charAt(i + 1) === "1" || e.charAt(i + 1) === "2") {
          if (u == null && (u = Bu(t, n, e.charAt(i + 1) === "2"), u == null))
            return "";
          a[a.length] = { t: "X", v: e.substr(i, 2) }, l = s, i += 2;
          break;
        }
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
        s = s.toLowerCase();
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        if (t < 0 || u == null && (u = Bu(t, n), u == null))
          return "";
        for (o = s; ++i < e.length && e.charAt(i).toLowerCase() === s; ) o += s;
        s === "m" && l.toLowerCase() === "h" && (s = "M"), s === "h" && (s = d), a[a.length] = { t: s, v: o }, l = s;
        break;
      case "A":
      case "a":
      case "上":
        var h = { t: s, v: s };
        if (u == null && (u = Bu(t, n)), e.substr(i, 3).toUpperCase() === "A/P" ? (u != null && (h.v = u.H >= 12 ? "P" : "A"), h.t = "T", d = "h", i += 3) : e.substr(i, 5).toUpperCase() === "AM/PM" ? (u != null && (h.v = u.H >= 12 ? "PM" : "AM"), h.t = "T", i += 5, d = "h") : e.substr(i, 5).toUpperCase() === "上午/下午" ? (u != null && (h.v = u.H >= 12 ? "下午" : "上午"), h.t = "T", i += 5, d = "h") : (h.t = "t", ++i), u == null && h.t === "T") return "";
        a[a.length] = h, l = s;
        break;
      case "[":
        for (o = s; e.charAt(i++) !== "]" && i < e.length; ) o += e.charAt(i);
        if (o.slice(-1) !== "]") throw 'unterminated "[" block: |' + o + "|";
        if (o.match(JM)) {
          if (u == null && (u = Bu(t, n), u == null))
            return "";
          a[a.length] = { t: "Z", v: o.toLowerCase() }, l = o.charAt(1);
        } else o.indexOf("$") > -1 && (o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$", Ad(e) || (a[a.length] = { t: "t", v: o }));
        break;
      case ".":
        if (u != null) {
          for (o = s; ++i < e.length && (s = e.charAt(i)) === "0"; ) o += s;
          a[a.length] = { t: "s", v: o };
          break;
        }
      case "0":
      case "#":
        for (o = s; ++i < e.length && "0#?.,E+-%".indexOf(s = e.charAt(i)) > -1; ) o += s;
        a[a.length] = { t: "n", v: o };
        break;
      case "?":
        for (o = s; e.charAt(++i) === s; ) o += s;
        a[a.length] = { t: s, v: o }, l = s;
        break;
      case "*":
        ++i, (e.charAt(i) == " " || e.charAt(i) == "*") && ++i;
        break;
      case "(":
      case ")":
        a[a.length] = { t: r === 1 ? "t" : s, v: s }, ++i;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (o = s; i < e.length && "0123456789".indexOf(e.charAt(++i)) > -1; ) o += e.charAt(i);
        a[a.length] = { t: "D", v: o };
        break;
      case " ":
        a[a.length] = { t: s, v: s }, ++i;
        break;
      case "$":
        a[a.length] = { t: "t", v: "$" }, ++i;
        break;
      default:
        if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(s) === -1) throw new Error("unrecognized character " + s + " in " + e);
        a[a.length] = { t: "t", v: s }, ++i;
        break;
    }
  var m = 0, y = 0, x;
  for (i = a.length - 1, l = "t"; i >= 0; --i)
    switch (a[i].t) {
      case "h":
      case "H":
        a[i].t = d, l = "h", m < 1 && (m = 1);
        break;
      case "s":
        (x = a[i].v.match(/\.0+$/)) && (y = Math.max(y, x[0].length - 1)), m < 3 && (m = 3);
      case "d":
      case "y":
      case "M":
      case "e":
        l = a[i].t;
        break;
      case "m":
        l === "s" && (a[i].t = "M", m < 2 && (m = 2));
        break;
      case "X":
        break;
      case "Z":
        m < 1 && a[i].v.match(/[Hh]/) && (m = 1), m < 2 && a[i].v.match(/[Mm]/) && (m = 2), m < 3 && a[i].v.match(/[Ss]/) && (m = 3);
    }
  switch (m) {
    case 0:
      break;
    case 1:
      u.u >= 0.5 && (u.u = 0, ++u.S), u.S >= 60 && (u.S = 0, ++u.M), u.M >= 60 && (u.M = 0, ++u.H);
      break;
    case 2:
      u.u >= 0.5 && (u.u = 0, ++u.S), u.S >= 60 && (u.S = 0, ++u.M);
      break;
  }
  var g = "", S;
  for (i = 0; i < a.length; ++i)
    switch (a[i].t) {
      case "t":
      case "T":
      case " ":
      case "D":
        break;
      case "X":
        a[i].v = "", a[i].t = ";";
        break;
      case "d":
      case "m":
      case "y":
      case "h":
      case "H":
      case "M":
      case "s":
      case "e":
      case "b":
      case "Z":
        a[i].v = fge(a[i].t.charCodeAt(0), a[i].v, u, y), a[i].t = "t";
        break;
      case "n":
      case "?":
        for (S = i + 1; a[S] != null && ((s = a[S].t) === "?" || s === "D" || (s === " " || s === "t") && a[S + 1] != null && (a[S + 1].t === "?" || a[S + 1].t === "t" && a[S + 1].v === "/") || a[i].t === "(" && (s === " " || s === "n" || s === ")") || s === "t" && (a[S].v === "/" || a[S].v === " " && a[S + 1] != null && a[S + 1].t == "?")); )
          a[i].v += a[S].v, a[S] = { v: "", t: ";" }, ++S;
        g += a[i].v, i = S - 1;
        break;
      case "G":
        a[i].t = "t", a[i].v = vc(t, n);
        break;
    }
  var w = "", _, b;
  if (g.length > 0) {
    g.charCodeAt(0) == 40 ? (_ = t < 0 && g.charCodeAt(0) === 45 ? -t : t, b = Ys("n", g, _)) : (_ = t < 0 && r > 1 ? -t : t, b = Ys("n", g, _), _ < 0 && a[0] && a[0].t == "t" && (b = b.substr(1), a[0].v = "-" + a[0].v)), S = b.length - 1;
    var E = a.length;
    for (i = 0; i < a.length; ++i) if (a[i] != null && a[i].t != "t" && a[i].v.indexOf(".") > -1) {
      E = i;
      break;
    }
    var C = a.length;
    if (E === a.length && b.indexOf("E") === -1) {
      for (i = a.length - 1; i >= 0; --i)
        a[i] == null || "n?".indexOf(a[i].t) === -1 || (S >= a[i].v.length - 1 ? (S -= a[i].v.length, a[i].v = b.substr(S + 1, a[i].v.length)) : S < 0 ? a[i].v = "" : (a[i].v = b.substr(0, S + 1), S = -1), a[i].t = "t", C = i);
      S >= 0 && C < a.length && (a[C].v = b.substr(0, S + 1) + a[C].v);
    } else if (E !== a.length && b.indexOf("E") === -1) {
      for (S = b.indexOf(".") - 1, i = E; i >= 0; --i)
        if (!(a[i] == null || "n?".indexOf(a[i].t) === -1)) {
          for (c = a[i].v.indexOf(".") > -1 && i === E ? a[i].v.indexOf(".") - 1 : a[i].v.length - 1, w = a[i].v.substr(c + 1); c >= 0; --c)
            S >= 0 && (a[i].v.charAt(c) === "0" || a[i].v.charAt(c) === "#") && (w = b.charAt(S--) + w);
          a[i].v = w, a[i].t = "t", C = i;
        }
      for (S >= 0 && C < a.length && (a[C].v = b.substr(0, S + 1) + a[C].v), S = b.indexOf(".") + 1, i = E; i < a.length; ++i)
        if (!(a[i] == null || "n?(".indexOf(a[i].t) === -1 && i !== E)) {
          for (c = a[i].v.indexOf(".") > -1 && i === E ? a[i].v.indexOf(".") + 1 : 0, w = a[i].v.substr(0, c); c < a[i].v.length; ++c)
            S < b.length && (w += b.charAt(S++));
          a[i].v = w, a[i].t = "t", C = i;
        }
    }
  }
  for (i = 0; i < a.length; ++i) a[i] != null && "n?".indexOf(a[i].t) > -1 && (_ = r > 1 && t < 0 && i > 0 && a[i - 1].v === "-" ? -t : t, a[i].v = Ys(a[i].t, a[i].v, _), a[i].t = "t");
  var T = "";
  for (i = 0; i !== a.length; ++i) a[i] != null && (T += a[i].v);
  return T;
}
var K6 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function Y6(e, t) {
  if (t == null) return !1;
  var n = parseFloat(t[2]);
  switch (t[1]) {
    case "=":
      if (e == n) return !0;
      break;
    case ">":
      if (e > n) return !0;
      break;
    case "<":
      if (e < n) return !0;
      break;
    case "<>":
      if (e != n) return !0;
      break;
    case ">=":
      if (e >= n) return !0;
      break;
    case "<=":
      if (e <= n) return !0;
      break;
  }
  return !1;
}
function Sge(e, t) {
  var n = bge(e), r = n.length, a = n[r - 1].indexOf("@");
  if (r < 4 && a > -1 && --r, n.length > 4) throw new Error("cannot find right format for |" + n.join("|") + "|");
  if (typeof t != "number") return [4, n.length === 4 || a > -1 ? n[n.length - 1] : "@"];
  switch (n.length) {
    case 1:
      n = a > -1 ? ["General", "General", "General", n[0]] : [n[0], n[0], n[0], "@"];
      break;
    case 2:
      n = a > -1 ? [n[0], n[0], n[0], n[1]] : [n[0], n[1], n[0], "@"];
      break;
    case 3:
      n = a > -1 ? [n[0], n[1], n[0], n[2]] : [n[0], n[1], n[2], "@"];
      break;
  }
  var o = t > 0 ? n[0] : t < 0 ? n[1] : n[2];
  if (n[0].indexOf("[") === -1 && n[1].indexOf("[") === -1) return [r, o];
  if (n[0].match(/\[[=<>]/) != null || n[1].match(/\[[=<>]/) != null) {
    var i = n[0].match(K6), s = n[1].match(K6);
    return Y6(t, i) ? [r, n[0]] : Y6(t, s) ? [r, n[1]] : [r, n[i != null && s != null ? 2 : 1]];
  }
  return [r, o];
}
function pi(e, t, n) {
  n == null && (n = {});
  var r = "";
  switch (typeof e) {
    case "string":
      e == "m/d/yy" && n.dateNF ? r = n.dateNF : r = e;
      break;
    case "number":
      e == 14 && n.dateNF ? r = n.dateNF : r = (n.table != null ? n.table : jt)[e], r == null && (r = n.table && n.table[z6[e]] || jt[z6[e]]), r == null && (r = age[e] || "General");
      break;
  }
  if (tg(r, 0)) return vc(t, n);
  t instanceof Date && (t = WM(t, n.date1904));
  var a = Sge(r, t);
  if (tg(a[1])) return vc(t, n);
  if (t === !0) t = "TRUE";
  else if (t === !1) t = "FALSE";
  else if (t === "" || t == null) return "";
  return wge(a[1], t, n, a[0]);
}
function qs(e, t) {
  if (typeof t != "number") {
    t = +t || -1;
    for (var n = 0; n < 392; ++n) {
      if (jt[n] == null) {
        t < 0 && (t = n);
        continue;
      }
      if (jt[n] == e) {
        t = n;
        break;
      }
    }
    t < 0 && (t = 391);
  }
  return jt[t] = e, t;
}
function H1(e) {
  for (var t = 0; t != 392; ++t)
    e[t] !== void 0 && qs(e[t], t);
}
function Id() {
  jt = rge();
}
var _ge = {
  5: '"$"#,##0_);\\("$"#,##0\\)',
  6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  23: "General",
  24: "General",
  25: "General",
  26: "General",
  27: "m/d/yy",
  28: "m/d/yy",
  29: "m/d/yy",
  30: "m/d/yy",
  31: "m/d/yy",
  32: "h:mm:ss",
  33: "h:mm:ss",
  34: "h:mm:ss",
  35: "h:mm:ss",
  36: "m/d/yy",
  41: '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',
  42: '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',
  43: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',
  44: '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
  50: "m/d/yy",
  51: "m/d/yy",
  52: "m/d/yy",
  53: "m/d/yy",
  54: "m/d/yy",
  55: "m/d/yy",
  56: "m/d/yy",
  57: "m/d/yy",
  58: "m/d/yy",
  59: "0",
  60: "0.00",
  61: "#,##0",
  62: "#,##0.00",
  63: '"$"#,##0_);\\("$"#,##0\\)',
  64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  67: "0%",
  68: "0.00%",
  69: "# ?/?",
  70: "# ??/??",
  71: "m/d/yy",
  72: "m/d/yy",
  73: "d-mmm-yy",
  74: "d-mmm",
  75: "mmm-yy",
  76: "h:mm",
  77: "h:mm:ss",
  78: "m/d/yy h:mm",
  79: "mm:ss",
  80: "[h]:mm:ss",
  81: "mmss.0"
}, eR = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function Cge(e) {
  var t = typeof e == "number" ? jt[e] : e;
  return t = t.replace(eR, "(\\d+)"), new RegExp("^" + t + "$");
}
function Ege(e, t, n) {
  var r = -1, a = -1, o = -1, i = -1, s = -1, l = -1;
  (t.match(eR) || []).forEach(function(f, d) {
    var p = parseInt(n[d + 1], 10);
    switch (f.toLowerCase().charAt(0)) {
      case "y":
        r = p;
        break;
      case "d":
        o = p;
        break;
      case "h":
        i = p;
        break;
      case "s":
        l = p;
        break;
      case "m":
        i >= 0 ? s = p : a = p;
        break;
    }
  }), l >= 0 && s == -1 && a >= 0 && (s = a, a = -1);
  var u = ("" + (r >= 0 ? r : (/* @__PURE__ */ new Date()).getFullYear())).slice(-4) + "-" + ("00" + (a >= 1 ? a : 1)).slice(-2) + "-" + ("00" + (o >= 1 ? o : 1)).slice(-2);
  u.length == 7 && (u = "0" + u), u.length == 8 && (u = "20" + u);
  var c = ("00" + (i >= 0 ? i : 0)).slice(-2) + ":" + ("00" + (s >= 0 ? s : 0)).slice(-2) + ":" + ("00" + (l >= 0 ? l : 0)).slice(-2);
  return i == -1 && s == -1 && l == -1 ? u : r == -1 && a == -1 && o == -1 ? c : u + "T" + c;
}
var Tge = /* @__PURE__ */ function() {
  var e = {};
  e.version = "1.2.0";
  function t() {
    for (var b = 0, E = new Array(256), C = 0; C != 256; ++C)
      b = C, b = b & 1 ? -306674912 ^ b >>> 1 : b >>> 1, b = b & 1 ? -306674912 ^ b >>> 1 : b >>> 1, b = b & 1 ? -306674912 ^ b >>> 1 : b >>> 1, b = b & 1 ? -306674912 ^ b >>> 1 : b >>> 1, b = b & 1 ? -306674912 ^ b >>> 1 : b >>> 1, b = b & 1 ? -306674912 ^ b >>> 1 : b >>> 1, b = b & 1 ? -306674912 ^ b >>> 1 : b >>> 1, b = b & 1 ? -306674912 ^ b >>> 1 : b >>> 1, E[C] = b;
    return typeof Int32Array < "u" ? new Int32Array(E) : E;
  }
  var n = t();
  function r(b) {
    var E = 0, C = 0, T = 0, O = typeof Int32Array < "u" ? new Int32Array(4096) : new Array(4096);
    for (T = 0; T != 256; ++T) O[T] = b[T];
    for (T = 0; T != 256; ++T)
      for (C = b[T], E = 256 + T; E < 4096; E += 256) C = O[E] = C >>> 8 ^ b[C & 255];
    var I = [];
    for (T = 1; T != 16; ++T) I[T - 1] = typeof Int32Array < "u" ? O.subarray(T * 256, T * 256 + 256) : O.slice(T * 256, T * 256 + 256);
    return I;
  }
  var a = r(n), o = a[0], i = a[1], s = a[2], l = a[3], u = a[4], c = a[5], f = a[6], d = a[7], p = a[8], v = a[9], h = a[10], m = a[11], y = a[12], x = a[13], g = a[14];
  function S(b, E) {
    for (var C = E ^ -1, T = 0, O = b.length; T < O; ) C = C >>> 8 ^ n[(C ^ b.charCodeAt(T++)) & 255];
    return ~C;
  }
  function w(b, E) {
    for (var C = E ^ -1, T = b.length - 15, O = 0; O < T; ) C = g[b[O++] ^ C & 255] ^ x[b[O++] ^ C >> 8 & 255] ^ y[b[O++] ^ C >> 16 & 255] ^ m[b[O++] ^ C >>> 24] ^ h[b[O++]] ^ v[b[O++]] ^ p[b[O++]] ^ d[b[O++]] ^ f[b[O++]] ^ c[b[O++]] ^ u[b[O++]] ^ l[b[O++]] ^ s[b[O++]] ^ i[b[O++]] ^ o[b[O++]] ^ n[b[O++]];
    for (T += 15; O < T; ) C = C >>> 8 ^ n[(C ^ b[O++]) & 255];
    return ~C;
  }
  function _(b, E) {
    for (var C = E ^ -1, T = 0, O = b.length, I = 0, k = 0; T < O; )
      I = b.charCodeAt(T++), I < 128 ? C = C >>> 8 ^ n[(C ^ I) & 255] : I < 2048 ? (C = C >>> 8 ^ n[(C ^ (192 | I >> 6 & 31)) & 255], C = C >>> 8 ^ n[(C ^ (128 | I & 63)) & 255]) : I >= 55296 && I < 57344 ? (I = (I & 1023) + 64, k = b.charCodeAt(T++) & 1023, C = C >>> 8 ^ n[(C ^ (240 | I >> 8 & 7)) & 255], C = C >>> 8 ^ n[(C ^ (128 | I >> 2 & 63)) & 255], C = C >>> 8 ^ n[(C ^ (128 | k >> 6 & 15 | (I & 3) << 4)) & 255], C = C >>> 8 ^ n[(C ^ (128 | k & 63)) & 255]) : (C = C >>> 8 ^ n[(C ^ (224 | I >> 12 & 15)) & 255], C = C >>> 8 ^ n[(C ^ (128 | I >> 6 & 63)) & 255], C = C >>> 8 ^ n[(C ^ (128 | I & 63)) & 255]);
    return ~C;
  }
  return e.table = n, e.bstr = S, e.buf = w, e.str = _, e;
}(), Dt = /* @__PURE__ */ function() {
  var t = {};
  t.version = "1.2.1";
  function n(ee, fe) {
    for (var ie = ee.split("/"), ce = fe.split("/"), de = 0, ye = 0, Pe = Math.min(ie.length, ce.length); de < Pe; ++de) {
      if (ye = ie[de].length - ce[de].length) return ye;
      if (ie[de] != ce[de]) return ie[de] < ce[de] ? -1 : 1;
    }
    return ie.length - ce.length;
  }
  function r(ee) {
    if (ee.charAt(ee.length - 1) == "/") return ee.slice(0, -1).indexOf("/") === -1 ? ee : r(ee.slice(0, -1));
    var fe = ee.lastIndexOf("/");
    return fe === -1 ? ee : ee.slice(0, fe + 1);
  }
  function a(ee) {
    if (ee.charAt(ee.length - 1) == "/") return a(ee.slice(0, -1));
    var fe = ee.lastIndexOf("/");
    return fe === -1 ? ee : ee.slice(fe + 1);
  }
  function o(ee, fe) {
    typeof fe == "string" && (fe = new Date(fe));
    var ie = fe.getHours();
    ie = ie << 6 | fe.getMinutes(), ie = ie << 5 | fe.getSeconds() >>> 1, ee.write_shift(2, ie);
    var ce = fe.getFullYear() - 1980;
    ce = ce << 4 | fe.getMonth() + 1, ce = ce << 5 | fe.getDate(), ee.write_shift(2, ce);
  }
  function i(ee) {
    var fe = ee.read_shift(2) & 65535, ie = ee.read_shift(2) & 65535, ce = /* @__PURE__ */ new Date(), de = ie & 31;
    ie >>>= 5;
    var ye = ie & 15;
    ie >>>= 4, ce.setMilliseconds(0), ce.setFullYear(ie + 1980), ce.setMonth(ye - 1), ce.setDate(de);
    var Pe = fe & 31;
    fe >>>= 5;
    var je = fe & 63;
    return fe >>>= 6, ce.setHours(fe), ce.setMinutes(je), ce.setSeconds(Pe << 1), ce;
  }
  function s(ee) {
    ta(ee, 0);
    for (var fe = (
      /*::(*/
      {}
    ), ie = 0; ee.l <= ee.length - 4; ) {
      var ce = ee.read_shift(2), de = ee.read_shift(2), ye = ee.l + de, Pe = {};
      switch (ce) {
        case 21589:
          ie = ee.read_shift(1), ie & 1 && (Pe.mtime = ee.read_shift(4)), de > 5 && (ie & 2 && (Pe.atime = ee.read_shift(4)), ie & 4 && (Pe.ctime = ee.read_shift(4))), Pe.mtime && (Pe.mt = new Date(Pe.mtime * 1e3));
          break;
      }
      ee.l = ye, fe[ce] = Pe;
    }
    return fe;
  }
  var l;
  function u() {
    return l || (l = {});
  }
  function c(ee, fe) {
    if (ee[0] == 80 && ee[1] == 75) return ct(ee, fe);
    if ((ee[0] | 32) == 109 && (ee[1] | 32) == 105) return yi(ee, fe);
    if (ee.length < 512) throw new Error("CFB file size " + ee.length + " < 512");
    var ie = 3, ce = 512, de = 0, ye = 0, Pe = 0, je = 0, Ae = 0, Re = [], Ne = (
      /*::(*/
      ee.slice(0, 512)
    );
    ta(Ne, 0);
    var Qe = f(Ne);
    switch (ie = Qe[0], ie) {
      case 3:
        ce = 512;
        break;
      case 4:
        ce = 4096;
        break;
      case 0:
        if (Qe[1] == 0) return ct(ee, fe);
      default:
        throw new Error("Major Version: Expected 3 or 4 saw " + ie);
    }
    ce !== 512 && (Ne = /*::(*/
    ee.slice(0, ce), ta(
      Ne,
      28
      /* blob.l */
    ));
    var $e = ee.slice(0, ce);
    d(Ne, ie);
    var ht = Ne.read_shift(4, "i");
    if (ie === 3 && ht !== 0) throw new Error("# Directory Sectors: Expected 0 saw " + ht);
    Ne.l += 4, Pe = Ne.read_shift(4, "i"), Ne.l += 4, Ne.chk("00100000", "Mini Stream Cutoff Size: "), je = Ne.read_shift(4, "i"), de = Ne.read_shift(4, "i"), Ae = Ne.read_shift(4, "i"), ye = Ne.read_shift(4, "i");
    for (var ot = -1, Je = 0; Je < 109 && (ot = Ne.read_shift(4, "i"), !(ot < 0)); ++Je)
      Re[Je] = ot;
    var _e = p(ee, ce);
    m(Ae, ye, _e, ce, Re);
    var Ee = x(_e, Pe, Re, ce);
    Ee[Pe].name = "!Directory", de > 0 && je !== k && (Ee[je].name = "!MiniFAT"), Ee[Re[0]].name = "!FAT", Ee.fat_addrs = Re, Ee.ssz = ce;
    var Le = {}, lt = [], Rt = [], nt = [];
    g(Pe, Ee, _e, lt, de, Le, Rt, je), v(Rt, nt, lt), lt.shift();
    var Ot = {
      FileIndex: Rt,
      FullPaths: nt
    };
    return fe && fe.raw && (Ot.raw = { header: $e, sectors: _e }), Ot;
  }
  function f(ee) {
    if (ee[ee.l] == 80 && ee[ee.l + 1] == 75) return [0, 0];
    ee.chk(B, "Header Signature: "), ee.l += 16;
    var fe = ee.read_shift(2, "u");
    return [ee.read_shift(2, "u"), fe];
  }
  function d(ee, fe) {
    var ie = 9;
    switch (ee.l += 2, ie = ee.read_shift(2)) {
      case 9:
        if (fe != 3) throw new Error("Sector Shift: Expected 9 saw " + ie);
        break;
      case 12:
        if (fe != 4) throw new Error("Sector Shift: Expected 12 saw " + ie);
        break;
      default:
        throw new Error("Sector Shift: Expected 9 or 12 saw " + ie);
    }
    ee.chk("0600", "Mini Sector Shift: "), ee.chk("000000000000", "Reserved: ");
  }
  function p(ee, fe) {
    for (var ie = Math.ceil(ee.length / fe) - 1, ce = [], de = 1; de < ie; ++de) ce[de - 1] = ee.slice(de * fe, (de + 1) * fe);
    return ce[ie - 1] = ee.slice(ie * fe), ce;
  }
  function v(ee, fe, ie) {
    for (var ce = 0, de = 0, ye = 0, Pe = 0, je = 0, Ae = ie.length, Re = [], Ne = []; ce < Ae; ++ce)
      Re[ce] = Ne[ce] = ce, fe[ce] = ie[ce];
    for (; je < Ne.length; ++je)
      ce = Ne[je], de = ee[ce].L, ye = ee[ce].R, Pe = ee[ce].C, Re[ce] === ce && (de !== -1 && Re[de] !== de && (Re[ce] = Re[de]), ye !== -1 && Re[ye] !== ye && (Re[ce] = Re[ye])), Pe !== -1 && (Re[Pe] = ce), de !== -1 && ce != Re[ce] && (Re[de] = Re[ce], Ne.lastIndexOf(de) < je && Ne.push(de)), ye !== -1 && ce != Re[ce] && (Re[ye] = Re[ce], Ne.lastIndexOf(ye) < je && Ne.push(ye));
    for (ce = 1; ce < Ae; ++ce) Re[ce] === ce && (ye !== -1 && Re[ye] !== ye ? Re[ce] = Re[ye] : de !== -1 && Re[de] !== de && (Re[ce] = Re[de]));
    for (ce = 1; ce < Ae; ++ce)
      if (ee[ce].type !== 0) {
        if (je = ce, je != Re[je]) do
          je = Re[je], fe[ce] = fe[je] + "/" + fe[ce];
        while (je !== 0 && Re[je] !== -1 && je != Re[je]);
        Re[ce] = -1;
      }
    for (fe[0] += "/", ce = 1; ce < Ae; ++ce)
      ee[ce].type !== 2 && (fe[ce] += "/");
  }
  function h(ee, fe, ie) {
    for (var ce = ee.start, de = ee.size, ye = [], Pe = ce; ie && de > 0 && Pe >= 0; )
      ye.push(fe.slice(Pe * I, Pe * I + I)), de -= I, Pe = Mu(ie, Pe * 4);
    return ye.length === 0 ? We(0) : zr(ye).slice(0, ee.size);
  }
  function m(ee, fe, ie, ce, de) {
    var ye = k;
    if (ee === k) {
      if (fe !== 0) throw new Error("DIFAT chain shorter than expected");
    } else if (ee !== -1) {
      var Pe = ie[ee], je = (ce >>> 2) - 1;
      if (!Pe) return;
      for (var Ae = 0; Ae < je && (ye = Mu(Pe, Ae * 4)) !== k; ++Ae)
        de.push(ye);
      m(Mu(Pe, ce - 4), fe - 1, ie, ce, de);
    }
  }
  function y(ee, fe, ie, ce, de) {
    var ye = [], Pe = [];
    de || (de = []);
    var je = ce - 1, Ae = 0, Re = 0;
    for (Ae = fe; Ae >= 0; ) {
      de[Ae] = !0, ye[ye.length] = Ae, Pe.push(ee[Ae]);
      var Ne = ie[Math.floor(Ae * 4 / ce)];
      if (Re = Ae * 4 & je, ce < 4 + Re) throw new Error("FAT boundary crossed: " + Ae + " 4 " + ce);
      if (!ee[Ne]) break;
      Ae = Mu(ee[Ne], Re);
    }
    return { nodes: ye, data: iO([Pe]) };
  }
  function x(ee, fe, ie, ce) {
    var de = ee.length, ye = [], Pe = [], je = [], Ae = [], Re = ce - 1, Ne = 0, Qe = 0, $e = 0, ht = 0;
    for (Ne = 0; Ne < de; ++Ne)
      if (je = [], $e = Ne + fe, $e >= de && ($e -= de), !Pe[$e]) {
        Ae = [];
        var ot = [];
        for (Qe = $e; Qe >= 0; ) {
          ot[Qe] = !0, Pe[Qe] = !0, je[je.length] = Qe, Ae.push(ee[Qe]);
          var Je = ie[Math.floor(Qe * 4 / ce)];
          if (ht = Qe * 4 & Re, ce < 4 + ht) throw new Error("FAT boundary crossed: " + Qe + " 4 " + ce);
          if (!ee[Je] || (Qe = Mu(ee[Je], ht), ot[Qe])) break;
        }
        ye[$e] = { nodes: je, data: iO([Ae]) };
      }
    return ye;
  }
  function g(ee, fe, ie, ce, de, ye, Pe, je) {
    for (var Ae = 0, Re = ce.length ? 2 : 0, Ne = fe[ee].data, Qe = 0, $e = 0, ht; Qe < Ne.length; Qe += 128) {
      var ot = (
        /*::(*/
        Ne.slice(Qe, Qe + 128)
      );
      ta(ot, 64), $e = ot.read_shift(2), ht = q4(ot, 0, $e - Re), ce.push(ht);
      var Je = {
        name: ht,
        type: ot.read_shift(1),
        color: ot.read_shift(1),
        L: ot.read_shift(4, "i"),
        R: ot.read_shift(4, "i"),
        C: ot.read_shift(4, "i"),
        clsid: ot.read_shift(16),
        state: ot.read_shift(4, "i"),
        start: 0,
        size: 0
      }, _e = ot.read_shift(2) + ot.read_shift(2) + ot.read_shift(2) + ot.read_shift(2);
      _e !== 0 && (Je.ct = S(ot, ot.l - 8));
      var Ee = ot.read_shift(2) + ot.read_shift(2) + ot.read_shift(2) + ot.read_shift(2);
      Ee !== 0 && (Je.mt = S(ot, ot.l - 8)), Je.start = ot.read_shift(4, "i"), Je.size = ot.read_shift(4, "i"), Je.size < 0 && Je.start < 0 && (Je.size = Je.type = 0, Je.start = k, Je.name = ""), Je.type === 5 ? (Ae = Je.start, de > 0 && Ae !== k && (fe[Ae].name = "!StreamData")) : Je.size >= 4096 ? (Je.storage = "fat", fe[Je.start] === void 0 && (fe[Je.start] = y(ie, Je.start, fe.fat_addrs, fe.ssz)), fe[Je.start].name = Je.name, Je.content = fe[Je.start].data.slice(0, Je.size)) : (Je.storage = "minifat", Je.size < 0 ? Je.size = 0 : Ae !== k && Je.start !== k && fe[Ae] && (Je.content = h(Je, fe[Ae].data, (fe[je] || {}).data))), Je.content && ta(Je.content, 0), ye[ht] = Je, Pe.push(Je);
    }
  }
  function S(ee, fe) {
    return new Date((Ao(ee, fe + 4) / 1e7 * Math.pow(2, 32) + Ao(ee, fe) / 1e7 - 11644473600) * 1e3);
  }
  function w(ee, fe) {
    return u(), c(l.readFileSync(ee), fe);
  }
  function _(ee, fe) {
    var ie = fe && fe.type;
    switch (ie || on && Buffer.isBuffer(ee) && (ie = "buffer"), ie || "base64") {
      case "file":
        return w(ee, fe);
      case "base64":
        return c(Po(Fo(ee)), fe);
      case "binary":
        return c(Po(ee), fe);
    }
    return c(
      /*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */
      ee,
      fe
    );
  }
  function b(ee, fe) {
    var ie = fe || {}, ce = ie.root || "Root Entry";
    if (ee.FullPaths || (ee.FullPaths = []), ee.FileIndex || (ee.FileIndex = []), ee.FullPaths.length !== ee.FileIndex.length) throw new Error("inconsistent CFB structure");
    ee.FullPaths.length === 0 && (ee.FullPaths[0] = ce + "/", ee.FileIndex[0] = { name: ce, type: 5 }), ie.CLSID && (ee.FileIndex[0].clsid = ie.CLSID), E(ee);
  }
  function E(ee) {
    var fe = "Sh33tJ5";
    if (!Dt.find(ee, "/" + fe)) {
      var ie = We(4);
      ie[0] = 55, ie[1] = ie[3] = 50, ie[2] = 54, ee.FileIndex.push({ name: fe, type: 2, content: ie, size: 4, L: 69, R: 69, C: 69 }), ee.FullPaths.push(ee.FullPaths[0] + fe), C(ee);
    }
  }
  function C(ee, fe) {
    b(ee);
    for (var ie = !1, ce = !1, de = ee.FullPaths.length - 1; de >= 0; --de) {
      var ye = ee.FileIndex[de];
      switch (ye.type) {
        case 0:
          ce ? ie = !0 : (ee.FileIndex.pop(), ee.FullPaths.pop());
          break;
        case 1:
        case 2:
        case 5:
          ce = !0, isNaN(ye.R * ye.L * ye.C) && (ie = !0), ye.R > -1 && ye.L > -1 && ye.R == ye.L && (ie = !0);
          break;
        default:
          ie = !0;
          break;
      }
    }
    if (!(!ie && !fe)) {
      var Pe = new Date(1987, 1, 19), je = 0, Ae = Object.create ? /* @__PURE__ */ Object.create(null) : {}, Re = [];
      for (de = 0; de < ee.FullPaths.length; ++de)
        Ae[ee.FullPaths[de]] = !0, ee.FileIndex[de].type !== 0 && Re.push([ee.FullPaths[de], ee.FileIndex[de]]);
      for (de = 0; de < Re.length; ++de) {
        var Ne = r(Re[de][0]);
        ce = Ae[Ne], ce || (Re.push([Ne, {
          name: a(Ne).replace("/", ""),
          type: 1,
          clsid: N,
          ct: Pe,
          mt: Pe,
          content: null
        }]), Ae[Ne] = !0);
      }
      for (Re.sort(function(ht, ot) {
        return n(ht[0], ot[0]);
      }), ee.FullPaths = [], ee.FileIndex = [], de = 0; de < Re.length; ++de)
        ee.FullPaths[de] = Re[de][0], ee.FileIndex[de] = Re[de][1];
      for (de = 0; de < Re.length; ++de) {
        var Qe = ee.FileIndex[de], $e = ee.FullPaths[de];
        if (Qe.name = a($e).replace("/", ""), Qe.L = Qe.R = Qe.C = -(Qe.color = 1), Qe.size = Qe.content ? Qe.content.length : 0, Qe.start = 0, Qe.clsid = Qe.clsid || N, de === 0)
          Qe.C = Re.length > 1 ? 1 : -1, Qe.size = 0, Qe.type = 5;
        else if ($e.slice(-1) == "/") {
          for (je = de + 1; je < Re.length && r(ee.FullPaths[je]) != $e; ++je) ;
          for (Qe.C = je >= Re.length ? -1 : je, je = de + 1; je < Re.length && r(ee.FullPaths[je]) != r($e); ++je) ;
          Qe.R = je >= Re.length ? -1 : je, Qe.type = 1;
        } else
          r(ee.FullPaths[de + 1] || "") == r($e) && (Qe.R = de + 1), Qe.type = 2;
      }
    }
  }
  function T(ee, fe) {
    var ie = fe || {};
    if (ie.fileType == "mad") return $r(ee, ie);
    switch (C(ee), ie.fileType) {
      case "zip":
        return Ut(ee, ie);
    }
    var ce = function(ht) {
      for (var ot = 0, Je = 0, _e = 0; _e < ht.FileIndex.length; ++_e) {
        var Ee = ht.FileIndex[_e];
        if (Ee.content) {
          var Le = Ee.content.length;
          Le > 0 && (Le < 4096 ? ot += Le + 63 >> 6 : Je += Le + 511 >> 9);
        }
      }
      for (var lt = ht.FullPaths.length + 3 >> 2, Rt = ot + 7 >> 3, nt = ot + 127 >> 7, Ot = Rt + Je + lt + nt, sn = Ot + 127 >> 7, Tn = sn <= 109 ? 0 : Math.ceil((sn - 109) / 127); Ot + sn + Tn + 127 >> 7 > sn; ) Tn = ++sn <= 109 ? 0 : Math.ceil((sn - 109) / 127);
      var Xt = [1, Tn, sn, nt, lt, Je, ot, 0];
      return ht.FileIndex[0].size = ot << 6, Xt[7] = (ht.FileIndex[0].start = Xt[0] + Xt[1] + Xt[2] + Xt[3] + Xt[4] + Xt[5]) + (Xt[6] + 7 >> 3), Xt;
    }(ee), de = We(ce[7] << 9), ye = 0, Pe = 0;
    {
      for (ye = 0; ye < 8; ++ye) de.write_shift(1, P[ye]);
      for (ye = 0; ye < 8; ++ye) de.write_shift(2, 0);
      for (de.write_shift(2, 62), de.write_shift(2, 3), de.write_shift(2, 65534), de.write_shift(2, 9), de.write_shift(2, 6), ye = 0; ye < 3; ++ye) de.write_shift(2, 0);
      for (de.write_shift(4, 0), de.write_shift(4, ce[2]), de.write_shift(4, ce[0] + ce[1] + ce[2] + ce[3] - 1), de.write_shift(4, 0), de.write_shift(4, 4096), de.write_shift(4, ce[3] ? ce[0] + ce[1] + ce[2] - 1 : k), de.write_shift(4, ce[3]), de.write_shift(-4, ce[1] ? ce[0] - 1 : k), de.write_shift(4, ce[1]), ye = 0; ye < 109; ++ye) de.write_shift(-4, ye < ce[2] ? ce[1] + ye : -1);
    }
    if (ce[1])
      for (Pe = 0; Pe < ce[1]; ++Pe) {
        for (; ye < 236 + Pe * 127; ++ye) de.write_shift(-4, ye < ce[2] ? ce[1] + ye : -1);
        de.write_shift(-4, Pe === ce[1] - 1 ? k : Pe + 1);
      }
    var je = function(ht) {
      for (Pe += ht; ye < Pe - 1; ++ye) de.write_shift(-4, ye + 1);
      ht && (++ye, de.write_shift(-4, k));
    };
    for (Pe = ye = 0, Pe += ce[1]; ye < Pe; ++ye) de.write_shift(-4, M.DIFSECT);
    for (Pe += ce[2]; ye < Pe; ++ye) de.write_shift(-4, M.FATSECT);
    je(ce[3]), je(ce[4]);
    for (var Ae = 0, Re = 0, Ne = ee.FileIndex[0]; Ae < ee.FileIndex.length; ++Ae)
      Ne = ee.FileIndex[Ae], Ne.content && (Re = Ne.content.length, !(Re < 4096) && (Ne.start = Pe, je(Re + 511 >> 9)));
    for (je(ce[6] + 7 >> 3); de.l & 511; ) de.write_shift(-4, M.ENDOFCHAIN);
    for (Pe = ye = 0, Ae = 0; Ae < ee.FileIndex.length; ++Ae)
      Ne = ee.FileIndex[Ae], Ne.content && (Re = Ne.content.length, !(!Re || Re >= 4096) && (Ne.start = Pe, je(Re + 63 >> 6)));
    for (; de.l & 511; ) de.write_shift(-4, M.ENDOFCHAIN);
    for (ye = 0; ye < ce[4] << 2; ++ye) {
      var Qe = ee.FullPaths[ye];
      if (!Qe || Qe.length === 0) {
        for (Ae = 0; Ae < 17; ++Ae) de.write_shift(4, 0);
        for (Ae = 0; Ae < 3; ++Ae) de.write_shift(4, -1);
        for (Ae = 0; Ae < 12; ++Ae) de.write_shift(4, 0);
        continue;
      }
      Ne = ee.FileIndex[ye], ye === 0 && (Ne.start = Ne.size ? Ne.start - 1 : k);
      var $e = ye === 0 && ie.root || Ne.name;
      if (Re = 2 * ($e.length + 1), de.write_shift(64, $e, "utf16le"), de.write_shift(2, Re), de.write_shift(1, Ne.type), de.write_shift(1, Ne.color), de.write_shift(-4, Ne.L), de.write_shift(-4, Ne.R), de.write_shift(-4, Ne.C), Ne.clsid) de.write_shift(16, Ne.clsid, "hex");
      else for (Ae = 0; Ae < 4; ++Ae) de.write_shift(4, 0);
      de.write_shift(4, Ne.state || 0), de.write_shift(4, 0), de.write_shift(4, 0), de.write_shift(4, 0), de.write_shift(4, 0), de.write_shift(4, Ne.start), de.write_shift(4, Ne.size), de.write_shift(4, 0);
    }
    for (ye = 1; ye < ee.FileIndex.length; ++ye)
      if (Ne = ee.FileIndex[ye], Ne.size >= 4096)
        if (de.l = Ne.start + 1 << 9, on && Buffer.isBuffer(Ne.content))
          Ne.content.copy(de, de.l, 0, Ne.size), de.l += Ne.size + 511 & -512;
        else {
          for (Ae = 0; Ae < Ne.size; ++Ae) de.write_shift(1, Ne.content[Ae]);
          for (; Ae & 511; ++Ae) de.write_shift(1, 0);
        }
    for (ye = 1; ye < ee.FileIndex.length; ++ye)
      if (Ne = ee.FileIndex[ye], Ne.size > 0 && Ne.size < 4096)
        if (on && Buffer.isBuffer(Ne.content))
          Ne.content.copy(de, de.l, 0, Ne.size), de.l += Ne.size + 63 & -64;
        else {
          for (Ae = 0; Ae < Ne.size; ++Ae) de.write_shift(1, Ne.content[Ae]);
          for (; Ae & 63; ++Ae) de.write_shift(1, 0);
        }
    if (on)
      de.l = de.length;
    else
      for (; de.l < de.length; ) de.write_shift(1, 0);
    return de;
  }
  function O(ee, fe) {
    var ie = ee.FullPaths.map(function(Ae) {
      return Ae.toUpperCase();
    }), ce = ie.map(function(Ae) {
      var Re = Ae.split("/");
      return Re[Re.length - (Ae.slice(-1) == "/" ? 2 : 1)];
    }), de = !1;
    fe.charCodeAt(0) === 47 ? (de = !0, fe = ie[0].slice(0, -1) + fe) : de = fe.indexOf("/") !== -1;
    var ye = fe.toUpperCase(), Pe = de === !0 ? ie.indexOf(ye) : ce.indexOf(ye);
    if (Pe !== -1) return ee.FileIndex[Pe];
    var je = !ye.match(u0);
    for (ye = ye.replace(Ya, ""), je && (ye = ye.replace(u0, "!")), Pe = 0; Pe < ie.length; ++Pe)
      if ((je ? ie[Pe].replace(u0, "!") : ie[Pe]).replace(Ya, "") == ye || (je ? ce[Pe].replace(u0, "!") : ce[Pe]).replace(Ya, "") == ye) return ee.FileIndex[Pe];
    return null;
  }
  var I = 64, k = -2, B = "d0cf11e0a1b11ae1", P = [208, 207, 17, 224, 161, 177, 26, 225], N = "00000000000000000000000000000000", M = {
    /* 2.1 Compund File Sector Numbers and Types */
    MAXREGSECT: -6,
    DIFSECT: -4,
    FATSECT: -3,
    ENDOFCHAIN: k,
    FREESECT: -1,
    /* 2.2 Compound File Header */
    HEADER_SIGNATURE: B,
    HEADER_MINOR_VERSION: "3e00",
    MAXREGSID: -6,
    NOSTREAM: -1,
    HEADER_CLSID: N,
    /* 2.6.1 Compound File Directory Entry */
    EntryTypes: ["unknown", "storage", "stream", "lockbytes", "property", "root"]
  };
  function H(ee, fe, ie) {
    u();
    var ce = T(ee, ie);
    l.writeFileSync(fe, ce);
  }
  function R(ee) {
    for (var fe = new Array(ee.length), ie = 0; ie < ee.length; ++ie) fe[ie] = String.fromCharCode(ee[ie]);
    return fe.join("");
  }
  function z(ee, fe) {
    var ie = T(ee, fe);
    switch (fe && fe.type || "buffer") {
      case "file":
        return u(), l.writeFileSync(fe.filename, ie), ie;
      case "binary":
        return typeof ie == "string" ? ie : R(ie);
      case "base64":
        return vp(typeof ie == "string" ? ie : R(ie));
      case "buffer":
        if (on) return Buffer.isBuffer(ie) ? ie : cl(ie);
      case "array":
        return typeof ie == "string" ? Po(ie) : ie;
    }
    return ie;
  }
  var W;
  function F(ee) {
    try {
      var fe = ee.InflateRaw, ie = new fe();
      if (ie._processChunk(new Uint8Array([3, 0]), ie._finishFlushFlag), ie.bytesRead) W = ee;
      else throw new Error("zlib does not expose bytesRead");
    } catch (ce) {
      console.error("cannot use native zlib: " + (ce.message || ce));
    }
  }
  function Y(ee, fe) {
    if (!W) return yt(ee, fe);
    var ie = W.InflateRaw, ce = new ie(), de = ce._processChunk(ee.slice(ee.l), ce._finishFlushFlag);
    return ee.l += ce.bytesRead, de;
  }
  function X(ee) {
    return W ? W.deflateRawSync(ee) : ge(ee);
  }
  var q = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], Q = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258], ue = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577];
  function le(ee) {
    var fe = (ee << 1 | ee << 11) & 139536 | (ee << 5 | ee << 15) & 558144;
    return (fe >> 16 | fe >> 8 | fe) & 255;
  }
  for (var te = typeof Uint8Array < "u", G = te ? new Uint8Array(256) : [], oe = 0; oe < 256; ++oe) G[oe] = le(oe);
  function L(ee, fe) {
    var ie = G[ee & 255];
    return fe <= 8 ? ie >>> 8 - fe : (ie = ie << 8 | G[ee >> 8 & 255], fe <= 16 ? ie >>> 16 - fe : (ie = ie << 8 | G[ee >> 16 & 255], ie >>> 24 - fe));
  }
  function re(ee, fe) {
    var ie = fe & 7, ce = fe >>> 3;
    return (ee[ce] | (ie <= 6 ? 0 : ee[ce + 1] << 8)) >>> ie & 3;
  }
  function j(ee, fe) {
    var ie = fe & 7, ce = fe >>> 3;
    return (ee[ce] | (ie <= 5 ? 0 : ee[ce + 1] << 8)) >>> ie & 7;
  }
  function J(ee, fe) {
    var ie = fe & 7, ce = fe >>> 3;
    return (ee[ce] | (ie <= 4 ? 0 : ee[ce + 1] << 8)) >>> ie & 15;
  }
  function ae(ee, fe) {
    var ie = fe & 7, ce = fe >>> 3;
    return (ee[ce] | (ie <= 3 ? 0 : ee[ce + 1] << 8)) >>> ie & 31;
  }
  function he(ee, fe) {
    var ie = fe & 7, ce = fe >>> 3;
    return (ee[ce] | (ie <= 1 ? 0 : ee[ce + 1] << 8)) >>> ie & 127;
  }
  function K(ee, fe, ie) {
    var ce = fe & 7, de = fe >>> 3, ye = (1 << ie) - 1, Pe = ee[de] >>> ce;
    return ie < 8 - ce || (Pe |= ee[de + 1] << 8 - ce, ie < 16 - ce) || (Pe |= ee[de + 2] << 16 - ce, ie < 24 - ce) || (Pe |= ee[de + 3] << 24 - ce), Pe & ye;
  }
  function Z(ee, fe, ie) {
    var ce = fe & 7, de = fe >>> 3;
    return ce <= 5 ? ee[de] |= (ie & 7) << ce : (ee[de] |= ie << ce & 255, ee[de + 1] = (ie & 7) >> 8 - ce), fe + 3;
  }
  function se(ee, fe, ie) {
    var ce = fe & 7, de = fe >>> 3;
    return ie = (ie & 1) << ce, ee[de] |= ie, fe + 1;
  }
  function me(ee, fe, ie) {
    var ce = fe & 7, de = fe >>> 3;
    return ie <<= ce, ee[de] |= ie & 255, ie >>>= 8, ee[de + 1] = ie, fe + 8;
  }
  function xe(ee, fe, ie) {
    var ce = fe & 7, de = fe >>> 3;
    return ie <<= ce, ee[de] |= ie & 255, ie >>>= 8, ee[de + 1] = ie & 255, ee[de + 2] = ie >>> 8, fe + 16;
  }
  function be(ee, fe) {
    var ie = ee.length, ce = 2 * ie > fe ? 2 * ie : fe + 5, de = 0;
    if (ie >= fe) return ee;
    if (on) {
      var ye = j6(ce);
      if (ee.copy) ee.copy(ye);
      else for (; de < ee.length; ++de) ye[de] = ee[de];
      return ye;
    } else if (te) {
      var Pe = new Uint8Array(ce);
      if (Pe.set) Pe.set(ee);
      else for (; de < ie; ++de) Pe[de] = ee[de];
      return Pe;
    }
    return ee.length = ce, ee;
  }
  function Te(ee) {
    for (var fe = new Array(ee), ie = 0; ie < ee; ++ie) fe[ie] = 0;
    return fe;
  }
  function Ie(ee, fe, ie) {
    var ce = 1, de = 0, ye = 0, Pe = 0, je = 0, Ae = ee.length, Re = te ? new Uint16Array(32) : Te(32);
    for (ye = 0; ye < 32; ++ye) Re[ye] = 0;
    for (ye = Ae; ye < ie; ++ye) ee[ye] = 0;
    Ae = ee.length;
    var Ne = te ? new Uint16Array(Ae) : Te(Ae);
    for (ye = 0; ye < Ae; ++ye)
      Re[de = ee[ye]]++, ce < de && (ce = de), Ne[ye] = 0;
    for (Re[0] = 0, ye = 1; ye <= ce; ++ye) Re[ye + 16] = je = je + Re[ye - 1] << 1;
    for (ye = 0; ye < Ae; ++ye)
      je = ee[ye], je != 0 && (Ne[ye] = Re[je + 16]++);
    var Qe = 0;
    for (ye = 0; ye < Ae; ++ye)
      if (Qe = ee[ye], Qe != 0)
        for (je = L(Ne[ye], ce) >> ce - Qe, Pe = (1 << ce + 4 - Qe) - 1; Pe >= 0; --Pe)
          fe[je | Pe << Qe] = Qe & 15 | ye << 4;
    return ce;
  }
  var Ve = te ? new Uint16Array(512) : Te(512), tt = te ? new Uint16Array(32) : Te(32);
  if (!te) {
    for (var it = 0; it < 512; ++it) Ve[it] = 0;
    for (it = 0; it < 32; ++it) tt[it] = 0;
  }
  (function() {
    for (var ee = [], fe = 0; fe < 32; fe++) ee.push(5);
    Ie(ee, tt, 32);
    var ie = [];
    for (fe = 0; fe <= 143; fe++) ie.push(8);
    for (; fe <= 255; fe++) ie.push(9);
    for (; fe <= 279; fe++) ie.push(7);
    for (; fe <= 287; fe++) ie.push(8);
    Ie(ie, Ve, 288);
  })();
  var Se = /* @__PURE__ */ function() {
    for (var fe = te ? new Uint8Array(32768) : [], ie = 0, ce = 0; ie < ue.length - 1; ++ie)
      for (; ce < ue[ie + 1]; ++ce) fe[ce] = ie;
    for (; ce < 32768; ++ce) fe[ce] = 29;
    var de = te ? new Uint8Array(259) : [];
    for (ie = 0, ce = 0; ie < Q.length - 1; ++ie)
      for (; ce < Q[ie + 1]; ++ce) de[ce] = ie;
    function ye(je, Ae) {
      for (var Re = 0; Re < je.length; ) {
        var Ne = Math.min(65535, je.length - Re), Qe = Re + Ne == je.length;
        for (Ae.write_shift(1, +Qe), Ae.write_shift(2, Ne), Ae.write_shift(2, ~Ne & 65535); Ne-- > 0; ) Ae[Ae.l++] = je[Re++];
      }
      return Ae.l;
    }
    function Pe(je, Ae) {
      for (var Re = 0, Ne = 0, Qe = te ? new Uint16Array(32768) : []; Ne < je.length; ) {
        var $e = (
          /* data.length - boff; */
          Math.min(65535, je.length - Ne)
        );
        if ($e < 10) {
          for (Re = Z(Ae, Re, +(Ne + $e == je.length)), Re & 7 && (Re += 8 - (Re & 7)), Ae.l = Re / 8 | 0, Ae.write_shift(2, $e), Ae.write_shift(2, ~$e & 65535); $e-- > 0; ) Ae[Ae.l++] = je[Ne++];
          Re = Ae.l * 8;
          continue;
        }
        Re = Z(Ae, Re, +(Ne + $e == je.length) + 2);
        for (var ht = 0; $e-- > 0; ) {
          var ot = je[Ne];
          ht = (ht << 5 ^ ot) & 32767;
          var Je = -1, _e = 0;
          if ((Je = Qe[ht]) && (Je |= Ne & -32768, Je > Ne && (Je -= 32768), Je < Ne))
            for (; je[Je + _e] == je[Ne + _e] && _e < 250; ) ++_e;
          if (_e > 2) {
            ot = de[_e], ot <= 22 ? Re = me(Ae, Re, G[ot + 1] >> 1) - 1 : (me(Ae, Re, 3), Re += 5, me(Ae, Re, G[ot - 23] >> 5), Re += 3);
            var Ee = ot < 8 ? 0 : ot - 4 >> 2;
            Ee > 0 && (xe(Ae, Re, _e - Q[ot]), Re += Ee), ot = fe[Ne - Je], Re = me(Ae, Re, G[ot] >> 3), Re -= 3;
            var Le = ot < 4 ? 0 : ot - 2 >> 1;
            Le > 0 && (xe(Ae, Re, Ne - Je - ue[ot]), Re += Le);
            for (var lt = 0; lt < _e; ++lt)
              Qe[ht] = Ne & 32767, ht = (ht << 5 ^ je[Ne]) & 32767, ++Ne;
            $e -= _e - 1;
          } else
            ot <= 143 ? ot = ot + 48 : Re = se(Ae, Re, 1), Re = me(Ae, Re, G[ot]), Qe[ht] = Ne & 32767, ++Ne;
        }
        Re = me(Ae, Re, 0) - 1;
      }
      return Ae.l = (Re + 7) / 8 | 0, Ae.l;
    }
    return function(Ae, Re) {
      return Ae.length < 8 ? ye(Ae, Re) : Pe(Ae, Re);
    };
  }();
  function ge(ee) {
    var fe = We(50 + Math.floor(ee.length * 1.1)), ie = Se(ee, fe);
    return fe.slice(0, ie);
  }
  var pe = te ? new Uint16Array(32768) : Te(32768), De = te ? new Uint16Array(32768) : Te(32768), Ue = te ? new Uint16Array(128) : Te(128), Xe = 1, ut = 1;
  function xt(ee, fe) {
    var ie = ae(ee, fe) + 257;
    fe += 5;
    var ce = ae(ee, fe) + 1;
    fe += 5;
    var de = J(ee, fe) + 4;
    fe += 4;
    for (var ye = 0, Pe = te ? new Uint8Array(19) : Te(19), je = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], Ae = 1, Re = te ? new Uint8Array(8) : Te(8), Ne = te ? new Uint8Array(8) : Te(8), Qe = Pe.length, $e = 0; $e < de; ++$e)
      Pe[q[$e]] = ye = j(ee, fe), Ae < ye && (Ae = ye), Re[ye]++, fe += 3;
    var ht = 0;
    for (Re[0] = 0, $e = 1; $e <= Ae; ++$e) Ne[$e] = ht = ht + Re[$e - 1] << 1;
    for ($e = 0; $e < Qe; ++$e) (ht = Pe[$e]) != 0 && (je[$e] = Ne[ht]++);
    var ot = 0;
    for ($e = 0; $e < Qe; ++$e)
      if (ot = Pe[$e], ot != 0) {
        ht = G[je[$e]] >> 8 - ot;
        for (var Je = (1 << 7 - ot) - 1; Je >= 0; --Je) Ue[ht | Je << ot] = ot & 7 | $e << 3;
      }
    var _e = [];
    for (Ae = 1; _e.length < ie + ce; )
      switch (ht = Ue[he(ee, fe)], fe += ht & 7, ht >>>= 3) {
        case 16:
          for (ye = 3 + re(ee, fe), fe += 2, ht = _e[_e.length - 1]; ye-- > 0; ) _e.push(ht);
          break;
        case 17:
          for (ye = 3 + j(ee, fe), fe += 3; ye-- > 0; ) _e.push(0);
          break;
        case 18:
          for (ye = 11 + he(ee, fe), fe += 7; ye-- > 0; ) _e.push(0);
          break;
        default:
          _e.push(ht), Ae < ht && (Ae = ht);
          break;
      }
    var Ee = _e.slice(0, ie), Le = _e.slice(ie);
    for ($e = ie; $e < 286; ++$e) Ee[$e] = 0;
    for ($e = ce; $e < 30; ++$e) Le[$e] = 0;
    return Xe = Ie(Ee, pe, 286), ut = Ie(Le, De, 30), fe;
  }
  function Mt(ee, fe) {
    if (ee[0] == 3 && !(ee[1] & 3))
      return [ru(fe), 2];
    for (var ie = 0, ce = 0, de = j6(fe || 1 << 18), ye = 0, Pe = de.length >>> 0, je = 0, Ae = 0; !(ce & 1); ) {
      if (ce = j(ee, ie), ie += 3, ce >>> 1)
        ce >> 1 == 1 ? (je = 9, Ae = 5) : (ie = xt(ee, ie), je = Xe, Ae = ut);
      else {
        ie & 7 && (ie += 8 - (ie & 7));
        var Re = ee[ie >>> 3] | ee[(ie >>> 3) + 1] << 8;
        if (ie += 32, Re > 0)
          for (!fe && Pe < ye + Re && (de = be(de, ye + Re), Pe = de.length); Re-- > 0; )
            de[ye++] = ee[ie >>> 3], ie += 8;
        continue;
      }
      for (; ; ) {
        !fe && Pe < ye + 32767 && (de = be(de, ye + 32767), Pe = de.length);
        var Ne = K(ee, ie, je), Qe = ce >>> 1 == 1 ? Ve[Ne] : pe[Ne];
        if (ie += Qe & 15, Qe >>>= 4, !(Qe >>> 8 & 255)) de[ye++] = Qe;
        else {
          if (Qe == 256) break;
          Qe -= 257;
          var $e = Qe < 8 ? 0 : Qe - 4 >> 2;
          $e > 5 && ($e = 0);
          var ht = ye + Q[Qe];
          $e > 0 && (ht += K(ee, ie, $e), ie += $e), Ne = K(ee, ie, Ae), Qe = ce >>> 1 == 1 ? tt[Ne] : De[Ne], ie += Qe & 15, Qe >>>= 4;
          var ot = Qe < 4 ? 0 : Qe - 2 >> 1, Je = ue[Qe];
          for (ot > 0 && (Je += K(ee, ie, ot), ie += ot), !fe && Pe < ht && (de = be(de, ht + 100), Pe = de.length); ye < ht; )
            de[ye] = de[ye - Je], ++ye;
        }
      }
    }
    return fe ? [de, ie + 7 >>> 3] : [de.slice(0, ye), ie + 7 >>> 3];
  }
  function yt(ee, fe) {
    var ie = ee.slice(ee.l || 0), ce = Mt(ie, fe);
    return ee.l += ce[1], ce[0];
  }
  function gt(ee, fe) {
    if (ee)
      typeof console < "u" && console.error(fe);
    else throw new Error(fe);
  }
  function ct(ee, fe) {
    var ie = (
      /*::(*/
      ee
    );
    ta(ie, 0);
    var ce = [], de = [], ye = {
      FileIndex: ce,
      FullPaths: de
    };
    b(ye, { root: fe.root });
    for (var Pe = ie.length - 4; (ie[Pe] != 80 || ie[Pe + 1] != 75 || ie[Pe + 2] != 5 || ie[Pe + 3] != 6) && Pe >= 0; ) --Pe;
    ie.l = Pe + 4, ie.l += 4;
    var je = ie.read_shift(2);
    ie.l += 6;
    var Ae = ie.read_shift(4);
    for (ie.l = Ae, Pe = 0; Pe < je; ++Pe) {
      ie.l += 20;
      var Re = ie.read_shift(4), Ne = ie.read_shift(4), Qe = ie.read_shift(2), $e = ie.read_shift(2), ht = ie.read_shift(2);
      ie.l += 8;
      var ot = ie.read_shift(4), Je = s(
        /*::(*/
        ie.slice(ie.l + Qe, ie.l + Qe + $e)
        /*:: :any)*/
      );
      ie.l += Qe + $e + ht;
      var _e = ie.l;
      ie.l = ot + 4, Ht(ie, Re, Ne, ye, Je), ie.l = _e;
    }
    return ye;
  }
  function Ht(ee, fe, ie, ce, de) {
    ee.l += 2;
    var ye = ee.read_shift(2), Pe = ee.read_shift(2), je = i(ee);
    if (ye & 8257) throw new Error("Unsupported ZIP encryption");
    for (var Ae = ee.read_shift(4), Re = ee.read_shift(4), Ne = ee.read_shift(4), Qe = ee.read_shift(2), $e = ee.read_shift(2), ht = "", ot = 0; ot < Qe; ++ot) ht += String.fromCharCode(ee[ee.l++]);
    if ($e) {
      var Je = s(
        /*::(*/
        ee.slice(ee.l, ee.l + $e)
        /*:: :any)*/
      );
      (Je[21589] || {}).mt && (je = Je[21589].mt), ((de || {})[21589] || {}).mt && (je = de[21589].mt);
    }
    ee.l += $e;
    var _e = ee.slice(ee.l, ee.l + Re);
    switch (Pe) {
      case 8:
        _e = Y(ee, Ne);
        break;
      case 0:
        break;
      default:
        throw new Error("Unsupported ZIP Compression method " + Pe);
    }
    var Ee = !1;
    ye & 8 && (Ae = ee.read_shift(4), Ae == 134695760 && (Ae = ee.read_shift(4), Ee = !0), Re = ee.read_shift(4), Ne = ee.read_shift(4)), Re != fe && gt(Ee, "Bad compressed size: " + fe + " != " + Re), Ne != ie && gt(Ee, "Bad uncompressed size: " + ie + " != " + Ne), va(ce, ht, _e, { unsafe: !0, mt: je });
  }
  function Ut(ee, fe) {
    var ie = fe || {}, ce = [], de = [], ye = We(1), Pe = ie.compression ? 8 : 0, je = 0, Ae = 0, Re = 0, Ne = 0, Qe = 0, $e = ee.FullPaths[0], ht = $e, ot = ee.FileIndex[0], Je = [], _e = 0;
    for (Ae = 1; Ae < ee.FullPaths.length; ++Ae)
      if (ht = ee.FullPaths[Ae].slice($e.length), ot = ee.FileIndex[Ae], !(!ot.size || !ot.content || ht == "Sh33tJ5")) {
        var Ee = Ne, Le = We(ht.length);
        for (Re = 0; Re < ht.length; ++Re) Le.write_shift(1, ht.charCodeAt(Re) & 127);
        Le = Le.slice(0, Le.l), Je[Qe] = Tge.buf(
          /*::((*/
          ot.content,
          0
        );
        var lt = ot.content;
        Pe == 8 && (lt = X(lt)), ye = We(30), ye.write_shift(4, 67324752), ye.write_shift(2, 20), ye.write_shift(2, je), ye.write_shift(2, Pe), ot.mt ? o(ye, ot.mt) : ye.write_shift(4, 0), ye.write_shift(-4, Je[Qe]), ye.write_shift(4, lt.length), ye.write_shift(
          4,
          /*::(*/
          ot.content.length
        ), ye.write_shift(2, Le.length), ye.write_shift(2, 0), Ne += ye.length, ce.push(ye), Ne += Le.length, ce.push(Le), Ne += lt.length, ce.push(lt), ye = We(46), ye.write_shift(4, 33639248), ye.write_shift(2, 0), ye.write_shift(2, 20), ye.write_shift(2, je), ye.write_shift(2, Pe), ye.write_shift(4, 0), ye.write_shift(-4, Je[Qe]), ye.write_shift(4, lt.length), ye.write_shift(
          4,
          /*::(*/
          ot.content.length
        ), ye.write_shift(2, Le.length), ye.write_shift(2, 0), ye.write_shift(2, 0), ye.write_shift(2, 0), ye.write_shift(2, 0), ye.write_shift(4, 0), ye.write_shift(4, Ee), _e += ye.l, de.push(ye), _e += Le.length, de.push(Le), ++Qe;
      }
    return ye = We(22), ye.write_shift(4, 101010256), ye.write_shift(2, 0), ye.write_shift(2, 0), ye.write_shift(2, Qe), ye.write_shift(2, Qe), ye.write_shift(4, _e), ye.write_shift(4, Ne), ye.write_shift(2, 0), zr([zr(ce), zr(de), ye]);
  }
  var In = {
    htm: "text/html",
    xml: "text/xml",
    gif: "image/gif",
    jpg: "image/jpeg",
    png: "image/png",
    mso: "application/x-mso",
    thmx: "application/vnd.ms-officetheme",
    sh33tj5: "application/octet-stream"
  };
  function wr(ee, fe) {
    if (ee.ctype) return ee.ctype;
    var ie = ee.name || "", ce = ie.match(/\.([^\.]+)$/);
    return ce && In[ce[1]] || fe && (ce = (ie = fe).match(/[\.\\]([^\.\\])+$/), ce && In[ce[1]]) ? In[ce[1]] : "application/octet-stream";
  }
  function eo(ee) {
    for (var fe = vp(ee), ie = [], ce = 0; ce < fe.length; ce += 76) ie.push(fe.slice(ce, ce + 76));
    return ie.join(`\r
`) + `\r
`;
  }
  function ur(ee) {
    var fe = ee.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(Re) {
      var Ne = Re.charCodeAt(0).toString(16).toUpperCase();
      return "=" + (Ne.length == 1 ? "0" + Ne : Ne);
    });
    fe = fe.replace(/ $/mg, "=20").replace(/\t$/mg, "=09"), fe.charAt(0) == `
` && (fe = "=0D" + fe.slice(1)), fe = fe.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, `
=0A`).replace(/([^\r\n])\n/mg, "$1=0A");
    for (var ie = [], ce = fe.split(`\r
`), de = 0; de < ce.length; ++de) {
      var ye = ce[de];
      if (ye.length == 0) {
        ie.push("");
        continue;
      }
      for (var Pe = 0; Pe < ye.length; ) {
        var je = 76, Ae = ye.slice(Pe, Pe + je);
        Ae.charAt(je - 1) == "=" ? je-- : Ae.charAt(je - 2) == "=" ? je -= 2 : Ae.charAt(je - 3) == "=" && (je -= 3), Ae = ye.slice(Pe, Pe + je), Pe += je, Pe < ye.length && (Ae += "="), ie.push(Ae);
      }
    }
    return ie.join(`\r
`);
  }
  function rr(ee) {
    for (var fe = [], ie = 0; ie < ee.length; ++ie) {
      for (var ce = ee[ie]; ie <= ee.length && ce.charAt(ce.length - 1) == "="; ) ce = ce.slice(0, ce.length - 1) + ee[++ie];
      fe.push(ce);
    }
    for (var de = 0; de < fe.length; ++de) fe[de] = fe[de].replace(/[=][0-9A-Fa-f]{2}/g, function(ye) {
      return String.fromCharCode(parseInt(ye.slice(1), 16));
    });
    return Po(fe.join(`\r
`));
  }
  function gi(ee, fe, ie) {
    for (var ce = "", de = "", ye = "", Pe, je = 0; je < 10; ++je) {
      var Ae = fe[je];
      if (!Ae || Ae.match(/^\s*$/)) break;
      var Re = Ae.match(/^(.*?):\s*([^\s].*)$/);
      if (Re) switch (Re[1].toLowerCase()) {
        case "content-location":
          ce = Re[2].trim();
          break;
        case "content-type":
          ye = Re[2].trim();
          break;
        case "content-transfer-encoding":
          de = Re[2].trim();
          break;
      }
    }
    switch (++je, de.toLowerCase()) {
      case "base64":
        Pe = Po(Fo(fe.slice(je).join("")));
        break;
      case "quoted-printable":
        Pe = rr(fe.slice(je));
        break;
      default:
        throw new Error("Unsupported Content-Transfer-Encoding " + de);
    }
    var Ne = va(ee, ce.slice(ie.length), Pe, { unsafe: !0 });
    ye && (Ne.ctype = ye);
  }
  function yi(ee, fe) {
    if (R(ee.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
    var ie = fe && fe.root || "", ce = (on && Buffer.isBuffer(ee) ? ee.toString("binary") : R(ee)).split(`\r
`), de = 0, ye = "";
    for (de = 0; de < ce.length; ++de)
      if (ye = ce[de], !!/^Content-Location:/i.test(ye) && (ye = ye.slice(ye.indexOf("file")), ie || (ie = ye.slice(0, ye.lastIndexOf("/") + 1)), ye.slice(0, ie.length) != ie))
        for (; ie.length > 0 && (ie = ie.slice(0, ie.length - 1), ie = ie.slice(0, ie.lastIndexOf("/") + 1), ye.slice(0, ie.length) != ie); )
          ;
    var Pe = (ce[1] || "").match(/boundary="(.*?)"/);
    if (!Pe) throw new Error("MAD cannot find boundary");
    var je = "--" + (Pe[1] || ""), Ae = [], Re = [], Ne = {
      FileIndex: Ae,
      FullPaths: Re
    };
    b(Ne);
    var Qe, $e = 0;
    for (de = 0; de < ce.length; ++de) {
      var ht = ce[de];
      ht !== je && ht !== je + "--" || ($e++ && gi(Ne, ce.slice(Qe, de), ie), Qe = de);
    }
    return Ne;
  }
  function $r(ee, fe) {
    var ie = fe || {}, ce = ie.boundary || "SheetJS";
    ce = "------=" + ce;
    for (var de = [
      "MIME-Version: 1.0",
      'Content-Type: multipart/related; boundary="' + ce.slice(2) + '"',
      "",
      "",
      ""
    ], ye = ee.FullPaths[0], Pe = ye, je = ee.FileIndex[0], Ae = 1; Ae < ee.FullPaths.length; ++Ae)
      if (Pe = ee.FullPaths[Ae].slice(ye.length), je = ee.FileIndex[Ae], !(!je.size || !je.content || Pe == "Sh33tJ5")) {
        Pe = Pe.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(_e) {
          return "_x" + _e.charCodeAt(0).toString(16) + "_";
        }).replace(/[\u0080-\uFFFF]/g, function(_e) {
          return "_u" + _e.charCodeAt(0).toString(16) + "_";
        });
        for (var Re = je.content, Ne = on && Buffer.isBuffer(Re) ? Re.toString("binary") : R(Re), Qe = 0, $e = Math.min(1024, Ne.length), ht = 0, ot = 0; ot <= $e; ++ot) (ht = Ne.charCodeAt(ot)) >= 32 && ht < 128 && ++Qe;
        var Je = Qe >= $e * 4 / 5;
        de.push(ce), de.push("Content-Location: " + (ie.root || "file:///C:/SheetJS/") + Pe), de.push("Content-Transfer-Encoding: " + (Je ? "quoted-printable" : "base64")), de.push("Content-Type: " + wr(je, Pe)), de.push(""), de.push(Je ? ur(Ne) : eo(Ne));
      }
    return de.push(ce + `--\r
`), de.join(`\r
`);
  }
  function An(ee) {
    var fe = {};
    return b(fe, ee), fe;
  }
  function va(ee, fe, ie, ce) {
    var de = ce && ce.unsafe;
    de || b(ee);
    var ye = !de && Dt.find(ee, fe);
    if (!ye) {
      var Pe = ee.FullPaths[0];
      fe.slice(0, Pe.length) == Pe ? Pe = fe : (Pe.slice(-1) != "/" && (Pe += "/"), Pe = (Pe + fe).replace("//", "/")), ye = { name: a(fe), type: 2 }, ee.FileIndex.push(ye), ee.FullPaths.push(Pe), de || Dt.utils.cfb_gc(ee);
    }
    return ye.content = ie, ye.size = ie ? ie.length : 0, ce && (ce.CLSID && (ye.clsid = ce.CLSID), ce.mt && (ye.mt = ce.mt), ce.ct && (ye.ct = ce.ct)), ye;
  }
  function Ze(ee, fe) {
    b(ee);
    var ie = Dt.find(ee, fe);
    if (ie) {
      for (var ce = 0; ce < ee.FileIndex.length; ++ce) if (ee.FileIndex[ce] == ie)
        return ee.FileIndex.splice(ce, 1), ee.FullPaths.splice(ce, 1), !0;
    }
    return !1;
  }
  function Et(ee, fe, ie) {
    b(ee);
    var ce = Dt.find(ee, fe);
    if (ce) {
      for (var de = 0; de < ee.FileIndex.length; ++de) if (ee.FileIndex[de] == ce)
        return ee.FileIndex[de].name = a(ie), ee.FullPaths[de] = ie, !0;
    }
    return !1;
  }
  function _t(ee) {
    C(ee, !0);
  }
  return t.find = O, t.read = _, t.parse = c, t.write = z, t.writeFile = H, t.utils = {
    cfb_new: An,
    cfb_add: va,
    cfb_del: Ze,
    cfb_mov: Et,
    cfb_gc: _t,
    ReadShift: M0,
    CheckField: wR,
    prep_blob: ta,
    bconcat: zr,
    use_zlib: F,
    _deflateRaw: ge,
    _inflateRaw: yt,
    consts: M
  }, t;
}();
function $ge(e) {
  return typeof e == "string" ? B1(e) : Array.isArray(e) ? Jme(e) : e;
}
function sh(e, t, n) {
  if (typeof Deno < "u") {
    if (n && typeof t == "string") switch (n) {
      case "utf8":
        t = new TextEncoder(n).encode(t);
        break;
      case "binary":
        t = B1(t);
        break;
      default:
        throw new Error("Unsupported encoding " + n);
    }
    return Deno.writeFileSync(e, t);
  }
  var r = n == "utf8" ? as(t) : t;
  if (typeof IE_SaveFile < "u") return IE_SaveFile(r, e);
  if (typeof Blob < "u") {
    var a = new Blob([$ge(r)], { type: "application/octet-stream" });
    if (typeof navigator < "u" && navigator.msSaveBlob) return navigator.msSaveBlob(a, e);
    if (typeof saveAs < "u") return saveAs(a, e);
    if (typeof URL < "u" && typeof document < "u" && document.createElement && URL.createObjectURL) {
      var o = URL.createObjectURL(a);
      if (typeof chrome == "object" && typeof (chrome.downloads || {}).download == "function")
        return URL.revokeObjectURL && typeof setTimeout < "u" && setTimeout(function() {
          URL.revokeObjectURL(o);
        }, 6e4), chrome.downloads.download({ url: o, filename: e, saveAs: !0 });
      var i = document.createElement("a");
      if (i.download != null)
        return i.download = e, i.href = o, document.body.appendChild(i), i.click(), document.body.removeChild(i), URL.revokeObjectURL && typeof setTimeout < "u" && setTimeout(function() {
          URL.revokeObjectURL(o);
        }, 6e4), o;
    }
  }
  if (typeof $ < "u" && typeof File < "u" && typeof Folder < "u") try {
    var s = File(e);
    return s.open("w"), s.encoding = "binary", Array.isArray(t) && (t = vu(t)), s.write(t), s.close(), t;
  } catch (l) {
    if (!l.message || !l.message.match(/onstruct/)) throw l;
  }
  throw new Error("cannot save file " + e);
}
function Oge(e) {
  if (typeof Deno < "u") return Deno.readFileSync(e);
  if (typeof $ < "u" && typeof File < "u" && typeof Folder < "u") try {
    var t = File(e);
    t.open("r"), t.encoding = "binary";
    var n = t.read();
    return t.close(), n;
  } catch (r) {
    if (!r.message || !r.message.match(/onstruct/)) throw r;
  }
  throw new Error("Cannot access file " + e);
}
function Er(e) {
  for (var t = Object.keys(e), n = [], r = 0; r < t.length; ++r) Object.prototype.hasOwnProperty.call(e, t[r]) && n.push(t[r]);
  return n;
}
function q6(e, t) {
  for (var n = [], r = Er(e), a = 0; a !== r.length; ++a) n[e[r[a]][t]] == null && (n[e[r[a]][t]] = r[a]);
  return n;
}
function j1(e) {
  for (var t = [], n = Er(e), r = 0; r !== n.length; ++r) t[e[n[r]]] = n[r];
  return t;
}
function V1(e) {
  for (var t = [], n = Er(e), r = 0; r !== n.length; ++r) t[e[n[r]]] = parseInt(n[r], 10);
  return t;
}
function Age(e) {
  for (var t = [], n = Er(e), r = 0; r !== n.length; ++r)
    t[e[n[r]]] == null && (t[e[n[r]]] = []), t[e[n[r]]].push(n[r]);
  return t;
}
var rg = /* @__PURE__ */ new Date(1899, 11, 30, 0, 0, 0);
function pa(e, t) {
  var n = /* @__PURE__ */ e.getTime(), r = /* @__PURE__ */ rg.getTime() + (/* @__PURE__ */ e.getTimezoneOffset() - /* @__PURE__ */ rg.getTimezoneOffset()) * 6e4;
  return (n - r) / (24 * 60 * 60 * 1e3);
}
var tR = /* @__PURE__ */ new Date(), Ige = /* @__PURE__ */ rg.getTime() + (/* @__PURE__ */ tR.getTimezoneOffset() - /* @__PURE__ */ rg.getTimezoneOffset()) * 6e4, X6 = /* @__PURE__ */ tR.getTimezoneOffset();
function U1(e) {
  var t = /* @__PURE__ */ new Date();
  return t.setTime(e * 24 * 60 * 60 * 1e3 + Ige), t.getTimezoneOffset() !== X6 && t.setTime(t.getTime() + (t.getTimezoneOffset() - X6) * 6e4), t;
}
function Pge(e) {
  var t = 0, n = 0, r = !1, a = e.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
  if (!a) throw new Error("|" + e + "| is not an ISO8601 Duration");
  for (var o = 1; o != a.length; ++o)
    if (a[o]) {
      switch (n = 1, o > 3 && (r = !0), a[o].slice(a[o].length - 1)) {
        case "Y":
          throw new Error("Unsupported ISO Duration Field: " + a[o].slice(a[o].length - 1));
        case "D":
          n *= 24;
        case "H":
          n *= 60;
        case "M":
          if (r) n *= 60;
          else throw new Error("Unsupported ISO Duration Field: M");
      }
      t += n * parseInt(a[o], 10);
    }
  return t;
}
var Z6 = /* @__PURE__ */ new Date("2017-02-19T19:06:09.000Z"), nR = /* @__PURE__ */ isNaN(/* @__PURE__ */ Z6.getFullYear()) ? /* @__PURE__ */ new Date("2/19/17") : Z6, Dge = /* @__PURE__ */ nR.getFullYear() == 2017;
function nr(e, t) {
  var n = new Date(e);
  if (Dge)
    return t > 0 ? n.setTime(n.getTime() + n.getTimezoneOffset() * 60 * 1e3) : t < 0 && n.setTime(n.getTime() - n.getTimezoneOffset() * 60 * 1e3), n;
  if (e instanceof Date) return e;
  if (nR.getFullYear() == 1917 && !isNaN(n.getFullYear())) {
    var r = n.getFullYear();
    return e.indexOf("" + r) > -1 || n.setFullYear(n.getFullYear() + 100), n;
  }
  var a = e.match(/\d+/g) || ["2017", "2", "19", "0", "0", "0"], o = new Date(+a[0], +a[1] - 1, +a[2], +a[3] || 0, +a[4] || 0, +a[5] || 0);
  return e.indexOf("Z") > -1 && (o = new Date(o.getTime() - o.getTimezoneOffset() * 60 * 1e3)), o;
}
function mc(e, t) {
  if (on && Buffer.isBuffer(e)) {
    if (t) {
      if (e[0] == 255 && e[1] == 254) return as(e.slice(2).toString("utf16le"));
      if (e[1] == 254 && e[2] == 255) return as(UM(e.slice(2).toString("binary")));
    }
    return e.toString("binary");
  }
  if (typeof TextDecoder < "u") try {
    if (t) {
      if (e[0] == 255 && e[1] == 254) return as(new TextDecoder("utf-16le").decode(e.slice(2)));
      if (e[0] == 254 && e[1] == 255) return as(new TextDecoder("utf-16be").decode(e.slice(2)));
    }
    var n = {
      "€": "",
      "‚": "",
      ƒ: "",
      "„": "",
      "…": "",
      "†": "",
      "‡": "",
      "ˆ": "",
      "‰": "",
      Š: "",
      "‹": "",
      Œ: "",
      Ž: "",
      "‘": "",
      "’": "",
      "“": "",
      "”": "",
      "•": "",
      "–": "",
      "—": "",
      "˜": "",
      "™": "",
      š: "",
      "›": "",
      œ: "",
      ž: "",
      Ÿ: ""
    };
    return Array.isArray(e) && (e = new Uint8Array(e)), new TextDecoder("latin1").decode(e).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(o) {
      return n[o] || o;
    });
  } catch {
  }
  for (var r = [], a = 0; a != e.length; ++a) r.push(String.fromCharCode(e[a]));
  return r.join("");
}
function qn(e) {
  if (typeof JSON < "u" && !Array.isArray(e)) return JSON.parse(JSON.stringify(e));
  if (typeof e != "object" || e == null) return e;
  if (e instanceof Date) return new Date(e.getTime());
  var t = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = qn(e[n]));
  return t;
}
function hr(e, t) {
  for (var n = ""; n.length < t; ) n += e;
  return n;
}
function Xs(e) {
  var t = Number(e);
  if (!isNaN(t)) return isFinite(t) ? t : NaN;
  if (!/\d/.test(e)) return t;
  var n = 1, r = e.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
    return n *= 100, "";
  });
  return !isNaN(t = Number(r)) || (r = r.replace(/[(](.*)[)]/, function(a, o) {
    return n = -n, o;
  }), !isNaN(t = Number(r))) ? t / n : t;
}
var kge = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
function gp(e) {
  var t = new Date(e), n = /* @__PURE__ */ new Date(NaN), r = t.getYear(), a = t.getMonth(), o = t.getDate();
  if (isNaN(o)) return n;
  var i = e.toLowerCase();
  if (i.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
    if (i = i.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, ""), i.length > 3 && kge.indexOf(i) == -1) return n;
  } else if (i.match(/[a-z]/)) return n;
  return r < 0 || r > 8099 ? n : (a > 0 || o > 1) && r != 101 ? t : e.match(/[^-0-9:,\/\\]/) ? n : t;
}
var Mge = /* @__PURE__ */ function() {
  var e = "abacaba".split(/(:?b)/i).length == 5;
  return function(n, r, a) {
    if (e || typeof r == "string") return n.split(r);
    for (var o = n.split(r), i = [o[0]], s = 1; s < o.length; ++s)
      i.push(a), i.push(o[s]);
    return i;
  };
}();
function rR(e) {
  return e ? e.content && e.type ? mc(e.content, !0) : e.data ? l0(e.data) : e.asNodeBuffer && on ? l0(e.asNodeBuffer().toString("binary")) : e.asBinary ? l0(e.asBinary()) : e._data && e._data.getContent ? l0(mc(Array.prototype.slice.call(e._data.getContent(), 0))) : null : null;
}
function aR(e) {
  if (!e) return null;
  if (e.data) return B6(e.data);
  if (e.asNodeBuffer && on) return e.asNodeBuffer();
  if (e._data && e._data.getContent) {
    var t = e._data.getContent();
    return typeof t == "string" ? B6(t) : Array.prototype.slice.call(t);
  }
  return e.content && e.type ? e.content : null;
}
function Rge(e) {
  return e && e.name.slice(-4) === ".bin" ? aR(e) : rR(e);
}
function ei(e, t) {
  for (var n = e.FullPaths || Er(e.files), r = t.toLowerCase().replace(/[\/]/g, "\\"), a = r.replace(/\\/g, "/"), o = 0; o < n.length; ++o) {
    var i = n[o].replace(/^Root Entry[\/]/, "").toLowerCase();
    if (r == i || a == i) return e.files ? e.files[n[o]] : e.FileIndex[o];
  }
  return null;
}
function U4(e, t) {
  var n = ei(e, t);
  if (n == null) throw new Error("Cannot find file " + t + " in zip");
  return n;
}
function Pr(e, t, n) {
  if (!n) return Rge(U4(e, t));
  if (!t) return null;
  try {
    return Pr(e, t);
  } catch {
    return null;
  }
}
function Do(e, t, n) {
  if (!n) return rR(U4(e, t));
  if (!t) return null;
  try {
    return Do(e, t);
  } catch {
    return null;
  }
}
function Nge(e, t, n) {
  return aR(U4(e, t));
}
function Q6(e) {
  for (var t = e.FullPaths || Er(e.files), n = [], r = 0; r < t.length; ++r) t[r].slice(-1) != "/" && n.push(t[r].replace(/^Root Entry[\/]/, ""));
  return n.sort();
}
function en(e, t, n) {
  if (e.FullPaths) {
    if (typeof n == "string") {
      var r;
      return on ? r = cl(n) : r = ege(n), Dt.utils.cfb_add(e, t, r);
    }
    Dt.utils.cfb_add(e, t, n);
  } else e.file(t, n);
}
function z4() {
  return Dt.utils.cfb_new();
}
function oR(e, t) {
  switch (t.type) {
    case "base64":
      return Dt.read(e, { type: "base64" });
    case "binary":
      return Dt.read(e, { type: "binary" });
    case "buffer":
    case "array":
      return Dt.read(e, { type: "buffer" });
  }
  throw new Error("Unrecognized type " + t.type);
}
function c0(e, t) {
  if (e.charAt(0) == "/") return e.slice(1);
  var n = t.split("/");
  t.slice(-1) != "/" && n.pop();
  for (var r = e.split("/"); r.length !== 0; ) {
    var a = r.shift();
    a === ".." ? n.pop() : a !== "." && n.push(a);
  }
  return n.join("/");
}
var Tr = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r
`, Fge = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g, J6 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, Lge = /<[^>]*>/g, Fa = /* @__PURE__ */ Tr.match(J6) ? J6 : Lge, Bge = /<\w*:/, Hge = /<(\/?)\w+:/;
function Vt(e, t, n) {
  for (var r = {}, a = 0, o = 0; a !== e.length && !((o = e.charCodeAt(a)) === 32 || o === 10 || o === 13); ++a) ;
  if (t || (r[0] = e.slice(0, a)), a === e.length) return r;
  var i = e.match(Fge), s = 0, l = "", u = 0, c = "", f = "", d = 1;
  if (i) for (u = 0; u != i.length; ++u) {
    for (f = i[u], o = 0; o != f.length && f.charCodeAt(o) !== 61; ++o) ;
    for (c = f.slice(0, o).trim(); f.charCodeAt(o + 1) == 32; ) ++o;
    for (d = (a = f.charCodeAt(o + 1)) == 34 || a == 39 ? 1 : 0, l = f.slice(o + 1 + d, f.length - d), s = 0; s != c.length && c.charCodeAt(s) !== 58; ++s) ;
    if (s === c.length)
      c.indexOf("_") > 0 && (c = c.slice(0, c.indexOf("_"))), r[c] = l, r[c.toLowerCase()] = l;
    else {
      var p = (s === 5 && c.slice(0, 5) === "xmlns" ? "xmlns" : "") + c.slice(s + 1);
      if (r[p] && c.slice(s - 3, s) == "ext") continue;
      r[p] = l, r[p.toLowerCase()] = l;
    }
  }
  return r;
}
function Es(e) {
  return e.replace(Hge, "<$1");
}
var iR = {
  "&quot;": '"',
  "&apos;": "'",
  "&gt;": ">",
  "&lt;": "<",
  "&amp;": "&"
}, W4 = /* @__PURE__ */ j1(iR), En = /* @__PURE__ */ function() {
  var e = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, t = /_x([\da-fA-F]{4})_/ig;
  return function n(r) {
    var a = r + "", o = a.indexOf("<![CDATA[");
    if (o == -1) return a.replace(e, function(s, l) {
      return iR[s] || String.fromCharCode(parseInt(l, s.indexOf("x") > -1 ? 16 : 10)) || s;
    }).replace(t, function(s, l) {
      return String.fromCharCode(parseInt(l, 16));
    });
    var i = a.indexOf("]]>");
    return n(a.slice(0, o)) + a.slice(o + 9, i) + n(a.slice(i + 3));
  };
}(), G4 = /[&<>'"]/g, jge = /[\u0000-\u0008\u000b-\u001f]/g;
function Nn(e) {
  var t = e + "";
  return t.replace(G4, function(n) {
    return W4[n];
  }).replace(jge, function(n) {
    return "_x" + ("000" + n.charCodeAt(0).toString(16)).slice(-4) + "_";
  });
}
function eO(e) {
  return Nn(e).replace(/ /g, "_x0020_");
}
var sR = /[\u0000-\u001f]/g;
function K4(e) {
  var t = e + "";
  return t.replace(G4, function(n) {
    return W4[n];
  }).replace(/\n/g, "<br/>").replace(sR, function(n) {
    return "&#x" + ("000" + n.charCodeAt(0).toString(16)).slice(-4) + ";";
  });
}
function Vge(e) {
  var t = e + "";
  return t.replace(G4, function(n) {
    return W4[n];
  }).replace(sR, function(n) {
    return "&#x" + n.charCodeAt(0).toString(16).toUpperCase() + ";";
  });
}
var tO = /* @__PURE__ */ function() {
  var e = /&#(\d+);/g;
  function t(n, r) {
    return String.fromCharCode(parseInt(r, 10));
  }
  return function(r) {
    return r.replace(e, t);
  };
}();
function Uge(e) {
  return e.replace(/(\r\n|[\r\n])/g, "&#10;");
}
function Kn(e) {
  switch (e) {
    case 1:
    case !0:
    case "1":
    case "true":
    case "TRUE":
      return !0;
    default:
      return !1;
  }
}
function Ax(e) {
  for (var t = "", n = 0, r = 0, a = 0, o = 0, i = 0, s = 0; n < e.length; ) {
    if (r = e.charCodeAt(n++), r < 128) {
      t += String.fromCharCode(r);
      continue;
    }
    if (a = e.charCodeAt(n++), r > 191 && r < 224) {
      i = (r & 31) << 6, i |= a & 63, t += String.fromCharCode(i);
      continue;
    }
    if (o = e.charCodeAt(n++), r < 240) {
      t += String.fromCharCode((r & 15) << 12 | (a & 63) << 6 | o & 63);
      continue;
    }
    i = e.charCodeAt(n++), s = ((r & 7) << 18 | (a & 63) << 12 | (o & 63) << 6 | i & 63) - 65536, t += String.fromCharCode(55296 + (s >>> 10 & 1023)), t += String.fromCharCode(56320 + (s & 1023));
  }
  return t;
}
function nO(e) {
  var t = ru(2 * e.length), n, r, a = 1, o = 0, i = 0, s;
  for (r = 0; r < e.length; r += a)
    a = 1, (s = e.charCodeAt(r)) < 128 ? n = s : s < 224 ? (n = (s & 31) * 64 + (e.charCodeAt(r + 1) & 63), a = 2) : s < 240 ? (n = (s & 15) * 4096 + (e.charCodeAt(r + 1) & 63) * 64 + (e.charCodeAt(r + 2) & 63), a = 3) : (a = 4, n = (s & 7) * 262144 + (e.charCodeAt(r + 1) & 63) * 4096 + (e.charCodeAt(r + 2) & 63) * 64 + (e.charCodeAt(r + 3) & 63), n -= 65536, i = 55296 + (n >>> 10 & 1023), n = 56320 + (n & 1023)), i !== 0 && (t[o++] = i & 255, t[o++] = i >>> 8, i = 0), t[o++] = n % 256, t[o++] = n >>> 8;
  return t.slice(0, o).toString("ucs2");
}
function rO(e) {
  return cl(e, "binary").toString("utf8");
}
var cv = "foo bar bazâð£", Hn = on && (/* @__PURE__ */ rO(cv) == /* @__PURE__ */ Ax(cv) && rO || /* @__PURE__ */ nO(cv) == /* @__PURE__ */ Ax(cv) && nO) || Ax, as = on ? function(e) {
  return cl(e, "utf8").toString("binary");
} : function(e) {
  for (var t = [], n = 0, r = 0, a = 0; n < e.length; )
    switch (r = e.charCodeAt(n++), !0) {
      case r < 128:
        t.push(String.fromCharCode(r));
        break;
      case r < 2048:
        t.push(String.fromCharCode(192 + (r >> 6))), t.push(String.fromCharCode(128 + (r & 63)));
        break;
      case (r >= 55296 && r < 57344):
        r -= 55296, a = e.charCodeAt(n++) - 56320 + (r << 10), t.push(String.fromCharCode(240 + (a >> 18 & 7))), t.push(String.fromCharCode(144 + (a >> 12 & 63))), t.push(String.fromCharCode(128 + (a >> 6 & 63))), t.push(String.fromCharCode(128 + (a & 63)));
        break;
      default:
        t.push(String.fromCharCode(224 + (r >> 12))), t.push(String.fromCharCode(128 + (r >> 6 & 63))), t.push(String.fromCharCode(128 + (r & 63)));
    }
  return t.join("");
}, yp = /* @__PURE__ */ function() {
  var e = {};
  return function(n, r) {
    var a = n + "|" + (r || "");
    return e[a] ? e[a] : e[a] = new RegExp("<(?:\\w+:)?" + n + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + n + ">", r || "");
  };
}(), zge = /* @__PURE__ */ function() {
  var e = [
    ["nbsp", " "],
    ["middot", "·"],
    ["quot", '"'],
    ["apos", "'"],
    ["gt", ">"],
    ["lt", "<"],
    ["amp", "&"]
  ].map(function(t) {
    return [new RegExp("&" + t[0] + ";", "ig"), t[1]];
  });
  return function(n) {
    for (var r = n.replace(/^[\t\n\r ]+/, "").replace(/[\t\n\r ]+$/, "").replace(/>\s+/g, ">").replace(/\s+</g, "<").replace(/[\t\n\r ]+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g, `
`).replace(/<[^>]*>/g, ""), a = 0; a < e.length; ++a) r = r.replace(e[a][0], e[a][1]);
    return r;
  };
}(), Wge = /* @__PURE__ */ function() {
  var e = {};
  return function(n) {
    return e[n] !== void 0 ? e[n] : e[n] = new RegExp("<(?:vt:)?" + n + ">([\\s\\S]*?)</(?:vt:)?" + n + ">", "g");
  };
}(), Gge = /<\/?(?:vt:)?variant>/g, Kge = /<(?:vt:)([^>]*)>([\s\S]*)</;
function aO(e, t) {
  var n = Vt(e), r = e.match(Wge(n.baseType)) || [], a = [];
  if (r.length != n.size) {
    if (t.WTF) throw new Error("unexpected vector length " + r.length + " != " + n.size);
    return a;
  }
  return r.forEach(function(o) {
    var i = o.replace(Gge, "").match(Kge);
    i && a.push({ v: Hn(i[2]), t: i[1] });
  }), a;
}
var lR = /(^\s|\s$|\n)/;
function oa(e, t) {
  return "<" + e + (t.match(lR) ? ' xml:space="preserve"' : "") + ">" + t + "</" + e + ">";
}
function xp(e) {
  return Er(e).map(function(t) {
    return " " + t + '="' + e[t] + '"';
  }).join("");
}
function pt(e, t, n) {
  return "<" + e + (n != null ? xp(n) : "") + (t != null ? (t.match(lR) ? ' xml:space="preserve"' : "") + ">" + t + "</" + e : "/") + ">";
}
function HS(e, t) {
  try {
    return e.toISOString().replace(/\.\d*/, "");
  } catch (n) {
    if (t) throw n;
  }
  return "";
}
function Yge(e, t) {
  switch (typeof e) {
    case "string":
      var n = pt("vt:lpwstr", Nn(e));
      return n = n.replace(/&quot;/g, "_x0022_"), n;
    case "number":
      return pt((e | 0) == e ? "vt:i4" : "vt:r8", Nn(String(e)));
    case "boolean":
      return pt("vt:bool", e ? "true" : "false");
  }
  if (e instanceof Date) return pt("vt:filetime", HS(e));
  throw new Error("Unable to serialize " + e);
}
function Y4(e) {
  if (on && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/
  Buffer.isBuffer(e)) return e.toString("utf8");
  if (typeof e == "string") return e;
  if (typeof Uint8Array < "u" && e instanceof Uint8Array) return Hn(vu(H4(e)));
  throw new Error("Bad input format: expected Buffer or string");
}
var bp = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg, Rr = {
  CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
  CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
  EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
  CT: "http://schemas.openxmlformats.org/package/2006/content-types",
  RELS: "http://schemas.openxmlformats.org/package/2006/relationships",
  TCMNT: "http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments",
  dc: "http://purl.org/dc/elements/1.1/",
  dcterms: "http://purl.org/dc/terms/",
  dcmitype: "http://purl.org/dc/dcmitype/",
  mx: "http://schemas.microsoft.com/office/mac/excel/2008/main",
  r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
  sjs: "http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",
  vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",
  xsi: "http://www.w3.org/2001/XMLSchema-instance",
  xsd: "http://www.w3.org/2001/XMLSchema"
}, Nc = [
  "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
  "http://purl.oclc.org/ooxml/spreadsheetml/main",
  "http://schemas.microsoft.com/office/excel/2006/main",
  "http://schemas.microsoft.com/office/excel/2006/2"
], Oo = {
  o: "urn:schemas-microsoft-com:office:office",
  x: "urn:schemas-microsoft-com:office:excel",
  ss: "urn:schemas-microsoft-com:office:spreadsheet",
  dt: "uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",
  mv: "http://macVmlSchemaUri",
  v: "urn:schemas-microsoft-com:vml",
  html: "http://www.w3.org/TR/REC-html40"
};
function qge(e, t) {
  for (var n = 1 - 2 * (e[t + 7] >>> 7), r = ((e[t + 7] & 127) << 4) + (e[t + 6] >>> 4 & 15), a = e[t + 6] & 15, o = 5; o >= 0; --o) a = a * 256 + e[t + o];
  return r == 2047 ? a == 0 ? n * (1 / 0) : NaN : (r == 0 ? r = -1022 : (r -= 1023, a += Math.pow(2, 52)), n * Math.pow(2, r - 52) * a);
}
function Xge(e, t, n) {
  var r = (t < 0 || 1 / t == -1 / 0 ? 1 : 0) << 7, a = 0, o = 0, i = r ? -t : t;
  isFinite(i) ? i == 0 ? a = o = 0 : (a = Math.floor(Math.log(i) / Math.LN2), o = i * Math.pow(2, 52 - a), a <= -1023 && (!isFinite(o) || o < Math.pow(2, 52)) ? a = -1022 : (o -= Math.pow(2, 52), a += 1023)) : (a = 2047, o = isNaN(t) ? 26985 : 0);
  for (var s = 0; s <= 5; ++s, o /= 256) e[n + s] = o & 255;
  e[n + 6] = (a & 15) << 4 | o & 15, e[n + 7] = a >> 4 | r;
}
var oO = function(e) {
  for (var t = [], n = 10240, r = 0; r < e[0].length; ++r) if (e[0][r]) for (var a = 0, o = e[0][r].length; a < o; a += n) t.push.apply(t, e[0][r].slice(a, a + n));
  return t;
}, iO = on ? function(e) {
  return e[0].length > 0 && Buffer.isBuffer(e[0][0]) ? Buffer.concat(e[0].map(function(t) {
    return Buffer.isBuffer(t) ? t : cl(t);
  })) : oO(e);
} : oO, sO = function(e, t, n) {
  for (var r = [], a = t; a < n; a += 2) r.push(String.fromCharCode(zs(e, a)));
  return r.join("").replace(Ya, "");
}, q4 = on ? function(e, t, n) {
  return Buffer.isBuffer(e) ? e.toString("utf16le", t, n).replace(Ya, "") : sO(e, t, n);
} : sO, lO = function(e, t, n) {
  for (var r = [], a = t; a < t + n; ++a) r.push(("0" + e[a].toString(16)).slice(-2));
  return r.join("");
}, uR = on ? function(e, t, n) {
  return Buffer.isBuffer(e) ? e.toString("hex", t, t + n) : lO(e, t, n);
} : lO, uO = function(e, t, n) {
  for (var r = [], a = t; a < n; a++) r.push(String.fromCharCode(cf(e, a)));
  return r.join("");
}, lh = on ? function(t, n, r) {
  return Buffer.isBuffer(t) ? t.toString("utf8", n, r) : uO(t, n, r);
} : uO, cR = function(e, t) {
  var n = Ao(e, t);
  return n > 0 ? lh(e, t + 4, t + 4 + n - 1) : "";
}, fR = cR, dR = function(e, t) {
  var n = Ao(e, t);
  return n > 0 ? lh(e, t + 4, t + 4 + n - 1) : "";
}, pR = dR, hR = function(e, t) {
  var n = 2 * Ao(e, t);
  return n > 0 ? lh(e, t + 4, t + 4 + n - 1) : "";
}, vR = hR, mR = function(t, n) {
  var r = Ao(t, n);
  return r > 0 ? q4(t, n + 4, n + 4 + r) : "";
}, gR = mR, yR = function(e, t) {
  var n = Ao(e, t);
  return n > 0 ? lh(e, t + 4, t + 4 + n) : "";
}, xR = yR, bR = function(e, t) {
  return qge(e, t);
}, ag = bR, X4 = function(t) {
  return Array.isArray(t) || typeof Uint8Array < "u" && t instanceof Uint8Array;
};
on && (fR = function(t, n) {
  if (!Buffer.isBuffer(t)) return cR(t, n);
  var r = t.readUInt32LE(n);
  return r > 0 ? t.toString("utf8", n + 4, n + 4 + r - 1) : "";
}, pR = function(t, n) {
  if (!Buffer.isBuffer(t)) return dR(t, n);
  var r = t.readUInt32LE(n);
  return r > 0 ? t.toString("utf8", n + 4, n + 4 + r - 1) : "";
}, vR = function(t, n) {
  if (!Buffer.isBuffer(t)) return hR(t, n);
  var r = 2 * t.readUInt32LE(n);
  return t.toString("utf16le", n + 4, n + 4 + r - 1);
}, gR = function(t, n) {
  if (!Buffer.isBuffer(t)) return mR(t, n);
  var r = t.readUInt32LE(n);
  return t.toString("utf16le", n + 4, n + 4 + r);
}, xR = function(t, n) {
  if (!Buffer.isBuffer(t)) return yR(t, n);
  var r = t.readUInt32LE(n);
  return t.toString("utf8", n + 4, n + 4 + r);
}, ag = function(t, n) {
  return Buffer.isBuffer(t) ? t.readDoubleLE(n) : bR(t, n);
}, X4 = function(t) {
  return Buffer.isBuffer(t) || Array.isArray(t) || typeof Uint8Array < "u" && t instanceof Uint8Array;
});
var cf = function(e, t) {
  return e[t];
}, zs = function(e, t) {
  return e[t + 1] * 256 + e[t];
}, Zge = function(e, t) {
  var n = e[t + 1] * 256 + e[t];
  return n < 32768 ? n : (65535 - n + 1) * -1;
}, Ao = function(e, t) {
  return e[t + 3] * (1 << 24) + (e[t + 2] << 16) + (e[t + 1] << 8) + e[t];
}, Mu = function(e, t) {
  return e[t + 3] << 24 | e[t + 2] << 16 | e[t + 1] << 8 | e[t];
}, Qge = function(e, t) {
  return e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3];
};
function M0(e, t) {
  var n = "", r, a, o = [], i, s, l, u;
  switch (t) {
    case "dbcs":
      if (u = this.l, on && Buffer.isBuffer(this)) n = this.slice(this.l, this.l + 2 * e).toString("utf16le");
      else for (l = 0; l < e; ++l)
        n += String.fromCharCode(zs(this, u)), u += 2;
      e *= 2;
      break;
    case "utf8":
      n = lh(this, this.l, this.l + e);
      break;
    case "utf16le":
      e *= 2, n = q4(this, this.l, this.l + e);
      break;
    case "wstr":
      return M0.call(this, e, "dbcs");
    case "lpstr-ansi":
      n = fR(this, this.l), e = 4 + Ao(this, this.l);
      break;
    case "lpstr-cp":
      n = pR(this, this.l), e = 4 + Ao(this, this.l);
      break;
    case "lpwstr":
      n = vR(this, this.l), e = 4 + 2 * Ao(this, this.l);
      break;
    case "lpp4":
      e = 4 + Ao(this, this.l), n = gR(this, this.l), e & 2 && (e += 2);
      break;
    case "8lpp4":
      e = 4 + Ao(this, this.l), n = xR(this, this.l), e & 3 && (e += 4 - (e & 3));
      break;
    case "cstr":
      for (e = 0, n = ""; (i = cf(this, this.l + e++)) !== 0; ) o.push(uv(i));
      n = o.join("");
      break;
    case "_wstr":
      for (e = 0, n = ""; (i = zs(this, this.l + e)) !== 0; )
        o.push(uv(i)), e += 2;
      e += 2, n = o.join("");
      break;
    case "dbcs-cont":
      for (n = "", u = this.l, l = 0; l < e; ++l) {
        if (this.lens && this.lens.indexOf(u) !== -1)
          return i = cf(this, u), this.l = u + 1, s = M0.call(this, e - l, i ? "dbcs-cont" : "sbcs-cont"), o.join("") + s;
        o.push(uv(zs(this, u))), u += 2;
      }
      n = o.join(""), e *= 2;
      break;
    case "cpstr":
    case "sbcs-cont":
      for (n = "", u = this.l, l = 0; l != e; ++l) {
        if (this.lens && this.lens.indexOf(u) !== -1)
          return i = cf(this, u), this.l = u + 1, s = M0.call(this, e - l, i ? "dbcs-cont" : "sbcs-cont"), o.join("") + s;
        o.push(uv(cf(this, u))), u += 1;
      }
      n = o.join("");
      break;
    default:
      switch (e) {
        case 1:
          return r = cf(this, this.l), this.l++, r;
        case 2:
          return r = (t === "i" ? Zge : zs)(this, this.l), this.l += 2, r;
        case 4:
        case -4:
          return t === "i" || !(this[this.l + 3] & 128) ? (r = (e > 0 ? Mu : Qge)(this, this.l), this.l += 4, r) : (a = Ao(this, this.l), this.l += 4, a);
        case 8:
        case -8:
          if (t === "f")
            return e == 8 ? a = ag(this, this.l) : a = ag([this[this.l + 7], this[this.l + 6], this[this.l + 5], this[this.l + 4], this[this.l + 3], this[this.l + 2], this[this.l + 1], this[this.l + 0]], 0), this.l += 8, a;
          e = 8;
        case 16:
          n = uR(this, this.l, e);
          break;
      }
  }
  return this.l += e, n;
}
var Jge = function(e, t, n) {
  e[n] = t & 255, e[n + 1] = t >>> 8 & 255, e[n + 2] = t >>> 16 & 255, e[n + 3] = t >>> 24 & 255;
}, e1e = function(e, t, n) {
  e[n] = t & 255, e[n + 1] = t >> 8 & 255, e[n + 2] = t >> 16 & 255, e[n + 3] = t >> 24 & 255;
}, t1e = function(e, t, n) {
  e[n] = t & 255, e[n + 1] = t >>> 8 & 255;
};
function n1e(e, t, n) {
  var r = 0, a = 0;
  if (n === "dbcs") {
    for (a = 0; a != t.length; ++a) t1e(this, t.charCodeAt(a), this.l + 2 * a);
    r = 2 * t.length;
  } else if (n === "sbcs") {
    for (t = t.replace(/[^\x00-\x7F]/g, "_"), a = 0; a != t.length; ++a) this[this.l + a] = t.charCodeAt(a) & 255;
    r = t.length;
  } else if (n === "hex") {
    for (; a < e; ++a)
      this[this.l++] = parseInt(t.slice(2 * a, 2 * a + 2), 16) || 0;
    return this;
  } else if (n === "utf16le") {
    var o = Math.min(this.l + e, this.length);
    for (a = 0; a < Math.min(t.length, e); ++a) {
      var i = t.charCodeAt(a);
      this[this.l++] = i & 255, this[this.l++] = i >> 8;
    }
    for (; this.l < o; ) this[this.l++] = 0;
    return this;
  } else switch (e) {
    case 1:
      r = 1, this[this.l] = t & 255;
      break;
    case 2:
      r = 2, this[this.l] = t & 255, t >>>= 8, this[this.l + 1] = t & 255;
      break;
    case 3:
      r = 3, this[this.l] = t & 255, t >>>= 8, this[this.l + 1] = t & 255, t >>>= 8, this[this.l + 2] = t & 255;
      break;
    case 4:
      r = 4, Jge(this, t, this.l);
      break;
    case 8:
      if (r = 8, n === "f") {
        Xge(this, t, this.l);
        break;
      }
    case 16:
      break;
    case -4:
      r = 4, e1e(this, t, this.l);
      break;
  }
  return this.l += r, this;
}
function wR(e, t) {
  var n = uR(this, this.l, e.length >> 1);
  if (n !== e) throw new Error(t + "Expected " + e + " saw " + n);
  this.l += e.length >> 1;
}
function ta(e, t) {
  e.l = t, e.read_shift = /*::(*/
  M0, e.chk = wR, e.write_shift = n1e;
}
function Ma(e, t) {
  e.l += t;
}
function We(e) {
  var t = ru(e);
  return ta(t, 0), t;
}
function fl(e, t, n) {
  if (e) {
    var r, a, o;
    ta(e, e.l || 0);
    for (var i = e.length, s = 0, l = 0; e.l < i; ) {
      s = e.read_shift(1), s & 128 && (s = (s & 127) + ((e.read_shift(1) & 127) << 7));
      var u = Tp[s] || Tp[65535];
      for (r = e.read_shift(1), o = r & 127, a = 1; a < 4 && r & 128; ++a) o += ((r = e.read_shift(1)) & 127) << 7 * a;
      l = e.l + o;
      var c = u.f && u.f(e, o, n);
      if (e.l = l, t(c, u, s)) return;
    }
  }
}
function lo() {
  var e = [], t = on ? 256 : 2048, n = function(u) {
    var c = We(u);
    return ta(c, 0), c;
  }, r = n(t), a = function() {
    r && (r.length > r.l && (r = r.slice(0, r.l), r.l = r.length), r.length > 0 && e.push(r), r = null);
  }, o = function(u) {
    return r && u < r.length - r.l ? r : (a(), r = n(Math.max(u + 1, t)));
  }, i = function() {
    return a(), zr(e);
  }, s = function(u) {
    a(), r = u, r.l == null && (r.l = r.length), o(t);
  };
  return { next: o, push: s, end: i, _bufs: e };
}
function at(e, t, n, r) {
  var a = +t, o;
  if (!isNaN(a)) {
    r || (r = Tp[a].p || (n || []).length || 0), o = 1 + (a >= 128 ? 1 : 0) + 1, r >= 128 && ++o, r >= 16384 && ++o, r >= 2097152 && ++o;
    var i = e.next(o);
    a <= 127 ? i.write_shift(1, a) : (i.write_shift(1, (a & 127) + 128), i.write_shift(1, a >> 7));
    for (var s = 0; s != 4; ++s)
      if (r >= 128)
        i.write_shift(1, (r & 127) + 128), r >>= 7;
      else {
        i.write_shift(1, r);
        break;
      }
    /*:: length != null &&*/
    r > 0 && X4(n) && e.push(n);
  }
}
function R0(e, t, n) {
  var r = qn(e);
  if (t.s ? (r.cRel && (r.c += t.s.c), r.rRel && (r.r += t.s.r)) : (r.cRel && (r.c += t.c), r.rRel && (r.r += t.r)), !n || n.biff < 12) {
    for (; r.c >= 256; ) r.c -= 256;
    for (; r.r >= 65536; ) r.r -= 65536;
  }
  return r;
}
function cO(e, t, n) {
  var r = qn(e);
  return r.s = R0(r.s, t.s, n), r.e = R0(r.e, t.s, n), r;
}
function N0(e, t) {
  if (e.cRel && e.c < 0)
    for (e = qn(e); e.c < 0; ) e.c += t > 8 ? 16384 : 256;
  if (e.rRel && e.r < 0)
    for (e = qn(e); e.r < 0; ) e.r += t > 8 ? 1048576 : t > 5 ? 65536 : 16384;
  var n = Kt(e);
  return !e.cRel && e.cRel != null && (n = o1e(n)), !e.rRel && e.rRel != null && (n = r1e(n)), n;
}
function Ix(e, t) {
  return e.s.r == 0 && !e.s.rRel && e.e.r == (t.biff >= 12 ? 1048575 : t.biff >= 8 ? 65536 : 16384) && !e.e.rRel ? (e.s.cRel ? "" : "$") + Mr(e.s.c) + ":" + (e.e.cRel ? "" : "$") + Mr(e.e.c) : e.s.c == 0 && !e.s.cRel && e.e.c == (t.biff >= 12 ? 16383 : 255) && !e.e.cRel ? (e.s.rRel ? "" : "$") + Kr(e.s.r) + ":" + (e.e.rRel ? "" : "$") + Kr(e.e.r) : N0(e.s, t.biff) + ":" + N0(e.e, t.biff);
}
function SR(e) {
  return parseInt(a1e(e), 10) - 1;
}
function Kr(e) {
  return "" + (e + 1);
}
function r1e(e) {
  return e.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function a1e(e) {
  return e.replace(/\$(\d+)$/, "$1");
}
function _R(e) {
  for (var t = i1e(e), n = 0, r = 0; r !== t.length; ++r) n = 26 * n + t.charCodeAt(r) - 64;
  return n - 1;
}
function Mr(e) {
  if (e < 0) throw new Error("invalid column " + e);
  var t = "";
  for (++e; e; e = Math.floor((e - 1) / 26)) t = String.fromCharCode((e - 1) % 26 + 65) + t;
  return t;
}
function o1e(e) {
  return e.replace(/^([A-Z])/, "$$$1");
}
function i1e(e) {
  return e.replace(/^\$([A-Z])/, "$1");
}
function Nr(e) {
  for (var t = 0, n = 0, r = 0; r < e.length; ++r) {
    var a = e.charCodeAt(r);
    a >= 48 && a <= 57 ? t = 10 * t + (a - 48) : a >= 65 && a <= 90 && (n = 26 * n + (a - 64));
  }
  return { c: n - 1, r: t - 1 };
}
function Kt(e) {
  for (var t = e.c + 1, n = ""; t; t = (t - 1) / 26 | 0) n = String.fromCharCode((t - 1) % 26 + 65) + n;
  return n + (e.r + 1);
}
function hi(e) {
  var t = e.indexOf(":");
  return t == -1 ? { s: Nr(e), e: Nr(e) } : { s: Nr(e.slice(0, t)), e: Nr(e.slice(t + 1)) };
}
function vn(e, t) {
  return typeof t > "u" || typeof t == "number" ? vn(e.s, e.e) : (typeof e != "string" && (e = Kt(e)), typeof t != "string" && (t = Kt(t)), e == t ? e : e + ":" + t);
}
function kn(e) {
  var t = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } }, n = 0, r = 0, a = 0, o = e.length;
  for (n = 0; r < o && !((a = e.charCodeAt(r) - 64) < 1 || a > 26); ++r)
    n = 26 * n + a;
  for (t.s.c = --n, n = 0; r < o && !((a = e.charCodeAt(r) - 48) < 0 || a > 9); ++r)
    n = 10 * n + a;
  if (t.s.r = --n, r === o || a != 10)
    return t.e.c = t.s.c, t.e.r = t.s.r, t;
  for (++r, n = 0; r != o && !((a = e.charCodeAt(r) - 64) < 1 || a > 26); ++r)
    n = 26 * n + a;
  for (t.e.c = --n, n = 0; r != o && !((a = e.charCodeAt(r) - 48) < 0 || a > 9); ++r)
    n = 10 * n + a;
  return t.e.r = --n, t;
}
function fO(e, t) {
  var n = e.t == "d" && t instanceof Date;
  if (e.z != null) try {
    return e.w = pi(e.z, n ? pa(t) : t);
  } catch {
  }
  try {
    return e.w = pi((e.XF || {}).numFmtId || (n ? 14 : 0), n ? pa(t) : t);
  } catch {
    return "" + t;
  }
}
function au(e, t, n) {
  return e == null || e.t == null || e.t == "z" ? "" : e.w !== void 0 ? e.w : (e.t == "d" && !e.z && n && n.dateNF && (e.z = n.dateNF), e.t == "e" ? dl[e.v] || e.v : t == null ? fO(e, e.v) : fO(e, t));
}
function Fc(e, t) {
  var n = t && t.sheet ? t.sheet : "Sheet1", r = {};
  return r[n] = e, { SheetNames: [n], Sheets: r };
}
function s1e(e, t, n) {
  var r = n || {}, a = e ? Array.isArray(e) : r.dense, o = e || (a ? [] : {}), i = 0, s = 0;
  if (o && r.origin != null) {
    if (typeof r.origin == "number") i = r.origin;
    else {
      var l = typeof r.origin == "string" ? Nr(r.origin) : r.origin;
      i = l.r, s = l.c;
    }
    o["!ref"] || (o["!ref"] = "A1:A1");
  }
  var u = { s: { c: 1e7, r: 1e7 }, e: { c: 0, r: 0 } };
  if (o["!ref"]) {
    var c = kn(o["!ref"]);
    u.s.c = c.s.c, u.s.r = c.s.r, u.e.c = Math.max(u.e.c, c.e.c), u.e.r = Math.max(u.e.r, c.e.r), i == -1 && (u.e.r = i = c.e.r + 1);
  }
  for (var f = 0; f != t.length; ++f)
    if (t[f]) {
      if (!Array.isArray(t[f])) throw new Error("aoa_to_sheet expects an array of arrays");
      for (var d = 0; d != t[f].length; ++d)
        if (!(typeof t[f][d] > "u")) {
          var p = { v: t[f][d] }, v = i + f, h = s + d;
          if (u.s.r > v && (u.s.r = v), u.s.c > h && (u.s.c = h), u.e.r < v && (u.e.r = v), u.e.c < h && (u.e.c = h), t[f][d] && typeof t[f][d] == "object" && !Array.isArray(t[f][d]) && !(t[f][d] instanceof Date)) p = t[f][d];
          else if (Array.isArray(p.v) && (p.f = t[f][d][1], p.v = p.v[0]), p.v === null)
            if (p.f) p.t = "n";
            else if (r.nullError)
              p.t = "e", p.v = 0;
            else if (r.sheetStubs) p.t = "z";
            else continue;
          else typeof p.v == "number" ? p.t = "n" : typeof p.v == "boolean" ? p.t = "b" : p.v instanceof Date ? (p.z = r.dateNF || jt[14], r.cellDates ? (p.t = "d", p.w = pi(p.z, pa(p.v))) : (p.t = "n", p.v = pa(p.v), p.w = pi(p.z, p.v))) : p.t = "s";
          if (a)
            o[v] || (o[v] = []), o[v][h] && o[v][h].z && (p.z = o[v][h].z), o[v][h] = p;
          else {
            var m = Kt({ c: h, r: v });
            o[m] && o[m].z && (p.z = o[m].z), o[m] = p;
          }
        }
    }
  return u.s.c < 1e7 && (o["!ref"] = vn(u)), o;
}
function uh(e, t) {
  return s1e(null, e, t);
}
function l1e(e) {
  return e.read_shift(4, "i");
}
function Vi(e, t) {
  return t || (t = We(4)), t.write_shift(4, e), t;
}
function Da(e) {
  var t = e.read_shift(4);
  return t === 0 ? "" : e.read_shift(t, "dbcs");
}
function Wr(e, t) {
  var n = !1;
  return t == null && (n = !0, t = We(4 + 2 * e.length)), t.write_shift(4, e.length), e.length > 0 && t.write_shift(0, e, "dbcs"), n ? t.slice(0, t.l) : t;
}
function u1e(e) {
  return { ich: e.read_shift(2), ifnt: e.read_shift(2) };
}
function c1e(e, t) {
  return t || (t = We(4)), t.write_shift(2, 0), t.write_shift(2, 0), t;
}
function Z4(e, t) {
  var n = e.l, r = e.read_shift(1), a = Da(e), o = [], i = { t: a, h: a };
  if (r & 1) {
    for (var s = e.read_shift(4), l = 0; l != s; ++l) o.push(u1e(e));
    i.r = o;
  } else i.r = [{ ich: 0, ifnt: 0 }];
  return e.l = n + t, i;
}
function f1e(e, t) {
  var n = !1;
  return t == null && (n = !0, t = We(15 + 4 * e.t.length)), t.write_shift(1, 0), Wr(e.t, t), n ? t.slice(0, t.l) : t;
}
var d1e = Z4;
function p1e(e, t) {
  var n = !1;
  return t == null && (n = !0, t = We(23 + 4 * e.t.length)), t.write_shift(1, 1), Wr(e.t, t), t.write_shift(4, 1), c1e({ ich: 0, ifnt: 0 }, t), n ? t.slice(0, t.l) : t;
}
function mi(e) {
  var t = e.read_shift(4), n = e.read_shift(2);
  return n += e.read_shift(1) << 16, e.l++, { c: t, iStyleRef: n };
}
function Lc(e, t) {
  return t == null && (t = We(8)), t.write_shift(-4, e.c), t.write_shift(3, e.iStyleRef || e.s), t.write_shift(1, 0), t;
}
function Bc(e) {
  var t = e.read_shift(2);
  return t += e.read_shift(1) << 16, e.l++, { c: -1, iStyleRef: t };
}
function Hc(e, t) {
  return t == null && (t = We(4)), t.write_shift(3, e.iStyleRef || e.s), t.write_shift(1, 0), t;
}
var h1e = Da, CR = Wr;
function Q4(e) {
  var t = e.read_shift(4);
  return t === 0 || t === 4294967295 ? "" : e.read_shift(t, "dbcs");
}
function og(e, t) {
  var n = !1;
  return t == null && (n = !0, t = We(127)), t.write_shift(4, e.length > 0 ? e.length : 4294967295), e.length > 0 && t.write_shift(0, e, "dbcs"), n ? t.slice(0, t.l) : t;
}
var v1e = Da, jS = Q4, J4 = og;
function eE(e) {
  var t = e.slice(e.l, e.l + 4), n = t[0] & 1, r = t[0] & 2;
  e.l += 4;
  var a = r === 0 ? ag([0, 0, 0, 0, t[0] & 252, t[1], t[2], t[3]], 0) : Mu(t, 0) >> 2;
  return n ? a / 100 : a;
}
function ER(e, t) {
  t == null && (t = We(4));
  var n = 0, r = 0, a = e * 100;
  if (e == (e | 0) && e >= -(1 << 29) && e < 1 << 29 ? r = 1 : a == (a | 0) && a >= -(1 << 29) && a < 1 << 29 && (r = 1, n = 1), r) t.write_shift(-4, ((n ? a : e) << 2) + (n + 2));
  else throw new Error("unsupported RkNumber " + e);
}
function TR(e) {
  var t = { s: {}, e: {} };
  return t.s.r = e.read_shift(4), t.e.r = e.read_shift(4), t.s.c = e.read_shift(4), t.e.c = e.read_shift(4), t;
}
function m1e(e, t) {
  return t || (t = We(16)), t.write_shift(4, e.s.r), t.write_shift(4, e.e.r), t.write_shift(4, e.s.c), t.write_shift(4, e.e.c), t;
}
var jc = TR, Pd = m1e;
function $a(e) {
  if (e.length - e.l < 8) throw "XLS Xnum Buffer underflow";
  return e.read_shift(8, "f");
}
function gc(e, t) {
  return (t || We(8)).write_shift(8, e, "f");
}
function g1e(e) {
  var t = {}, n = e.read_shift(1), r = n >>> 1, a = e.read_shift(1), o = e.read_shift(2, "i"), i = e.read_shift(1), s = e.read_shift(1), l = e.read_shift(1);
  switch (e.l++, r) {
    case 0:
      t.auto = 1;
      break;
    case 1:
      t.index = a;
      var u = ec[a];
      u && (t.rgb = Sp(u));
      break;
    case 2:
      t.rgb = Sp([i, s, l]);
      break;
    case 3:
      t.theme = a;
      break;
  }
  return o != 0 && (t.tint = o > 0 ? o / 32767 : o / 32768), t;
}
function ig(e, t) {
  if (t || (t = We(8)), !e || e.auto)
    return t.write_shift(4, 0), t.write_shift(4, 0), t;
  e.index != null ? (t.write_shift(1, 2), t.write_shift(1, e.index)) : e.theme != null ? (t.write_shift(1, 6), t.write_shift(1, e.theme)) : (t.write_shift(1, 5), t.write_shift(1, 0));
  var n = e.tint || 0;
  if (n > 0 ? n *= 32767 : n < 0 && (n *= 32768), t.write_shift(2, n), !e.rgb || e.theme != null)
    t.write_shift(2, 0), t.write_shift(1, 0), t.write_shift(1, 0);
  else {
    var r = e.rgb || "FFFFFF";
    typeof r == "number" && (r = ("000000" + r.toString(16)).slice(-6)), t.write_shift(1, parseInt(r.slice(0, 2), 16)), t.write_shift(1, parseInt(r.slice(2, 4), 16)), t.write_shift(1, parseInt(r.slice(4, 6), 16)), t.write_shift(1, 255);
  }
  return t;
}
function y1e(e) {
  var t = e.read_shift(1);
  e.l++;
  var n = {
    fBold: t & 1,
    fItalic: t & 2,
    fUnderline: t & 4,
    fStrikeout: t & 8,
    fOutline: t & 16,
    fShadow: t & 32,
    fCondense: t & 64,
    fExtend: t & 128
  };
  return n;
}
function x1e(e, t) {
  t || (t = We(2));
  var n = (e.italic ? 2 : 0) | (e.strike ? 8 : 0) | (e.outline ? 16 : 0) | (e.shadow ? 32 : 0) | (e.condense ? 64 : 0) | (e.extend ? 128 : 0);
  return t.write_shift(1, n), t.write_shift(1, 0), t;
}
function $R(e, t) {
  var n = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" }, r = e.read_shift(4);
  switch (r) {
    case 0:
      return "";
    case 4294967295:
    case 4294967294:
      return n[e.read_shift(4)] || "";
  }
  if (r > 400) throw new Error("Unsupported Clipboard: " + r.toString(16));
  return e.l -= 4, e.read_shift(0, t == 1 ? "lpstr" : "lpwstr");
}
function b1e(e) {
  return $R(e, 1);
}
function w1e(e) {
  return $R(e, 2);
}
var tE = 2, ao = 3, fv = 11, dO = 12, sg = 19, dv = 64, S1e = 65, _1e = 71, C1e = 4108, E1e = 4126, jr = 80, OR = 81, T1e = [jr, OR], VS = {
  /*::[*/
  1: { n: "CodePage", t: tE },
  /*::[*/
  2: { n: "Category", t: jr },
  /*::[*/
  3: { n: "PresentationFormat", t: jr },
  /*::[*/
  4: { n: "ByteCount", t: ao },
  /*::[*/
  5: { n: "LineCount", t: ao },
  /*::[*/
  6: { n: "ParagraphCount", t: ao },
  /*::[*/
  7: { n: "SlideCount", t: ao },
  /*::[*/
  8: { n: "NoteCount", t: ao },
  /*::[*/
  9: { n: "HiddenCount", t: ao },
  /*::[*/
  10: { n: "MultimediaClipCount", t: ao },
  /*::[*/
  11: { n: "ScaleCrop", t: fv },
  /*::[*/
  12: {
    n: "HeadingPairs",
    t: C1e
    /* VT_VECTOR | VT_VARIANT */
  },
  /*::[*/
  13: {
    n: "TitlesOfParts",
    t: E1e
    /* VT_VECTOR | VT_LPSTR */
  },
  /*::[*/
  14: { n: "Manager", t: jr },
  /*::[*/
  15: { n: "Company", t: jr },
  /*::[*/
  16: { n: "LinksUpToDate", t: fv },
  /*::[*/
  17: { n: "CharacterCount", t: ao },
  /*::[*/
  19: { n: "SharedDoc", t: fv },
  /*::[*/
  22: { n: "HyperlinksChanged", t: fv },
  /*::[*/
  23: { n: "AppVersion", t: ao, p: "version" },
  /*::[*/
  24: { n: "DigSig", t: S1e },
  /*::[*/
  26: { n: "ContentType", t: jr },
  /*::[*/
  27: { n: "ContentStatus", t: jr },
  /*::[*/
  28: { n: "Language", t: jr },
  /*::[*/
  29: { n: "Version", t: jr },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: sg },
  /*::[*/
  2147483651: { n: "Behavior", t: sg },
  /*::[*/
  1919054434: {}
}, US = {
  /*::[*/
  1: { n: "CodePage", t: tE },
  /*::[*/
  2: { n: "Title", t: jr },
  /*::[*/
  3: { n: "Subject", t: jr },
  /*::[*/
  4: { n: "Author", t: jr },
  /*::[*/
  5: { n: "Keywords", t: jr },
  /*::[*/
  6: { n: "Comments", t: jr },
  /*::[*/
  7: { n: "Template", t: jr },
  /*::[*/
  8: { n: "LastAuthor", t: jr },
  /*::[*/
  9: { n: "RevNumber", t: jr },
  /*::[*/
  10: { n: "EditTime", t: dv },
  /*::[*/
  11: { n: "LastPrinted", t: dv },
  /*::[*/
  12: { n: "CreatedDate", t: dv },
  /*::[*/
  13: { n: "ModifiedDate", t: dv },
  /*::[*/
  14: { n: "PageCount", t: ao },
  /*::[*/
  15: { n: "WordCount", t: ao },
  /*::[*/
  16: { n: "CharCount", t: ao },
  /*::[*/
  17: { n: "Thumbnail", t: _1e },
  /*::[*/
  18: { n: "Application", t: jr },
  /*::[*/
  19: { n: "DocSecurity", t: ao },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: sg },
  /*::[*/
  2147483651: { n: "Behavior", t: sg },
  /*::[*/
  1919054434: {}
}, pO = {
  /*::[*/
  1: "US",
  // United States
  /*::[*/
  2: "CA",
  // Canada
  /*::[*/
  3: "",
  // Latin America (except Brazil)
  /*::[*/
  7: "RU",
  // Russia
  /*::[*/
  20: "EG",
  // Egypt
  /*::[*/
  30: "GR",
  // Greece
  /*::[*/
  31: "NL",
  // Netherlands
  /*::[*/
  32: "BE",
  // Belgium
  /*::[*/
  33: "FR",
  // France
  /*::[*/
  34: "ES",
  // Spain
  /*::[*/
  36: "HU",
  // Hungary
  /*::[*/
  39: "IT",
  // Italy
  /*::[*/
  41: "CH",
  // Switzerland
  /*::[*/
  43: "AT",
  // Austria
  /*::[*/
  44: "GB",
  // United Kingdom
  /*::[*/
  45: "DK",
  // Denmark
  /*::[*/
  46: "SE",
  // Sweden
  /*::[*/
  47: "NO",
  // Norway
  /*::[*/
  48: "PL",
  // Poland
  /*::[*/
  49: "DE",
  // Germany
  /*::[*/
  52: "MX",
  // Mexico
  /*::[*/
  55: "BR",
  // Brazil
  /*::[*/
  61: "AU",
  // Australia
  /*::[*/
  64: "NZ",
  // New Zealand
  /*::[*/
  66: "TH",
  // Thailand
  /*::[*/
  81: "JP",
  // Japan
  /*::[*/
  82: "KR",
  // Korea
  /*::[*/
  84: "VN",
  // Viet Nam
  /*::[*/
  86: "CN",
  // China
  /*::[*/
  90: "TR",
  // Turkey
  /*::[*/
  105: "JS",
  // Ramastan
  /*::[*/
  213: "DZ",
  // Algeria
  /*::[*/
  216: "MA",
  // Morocco
  /*::[*/
  218: "LY",
  // Libya
  /*::[*/
  351: "PT",
  // Portugal
  /*::[*/
  354: "IS",
  // Iceland
  /*::[*/
  358: "FI",
  // Finland
  /*::[*/
  420: "CZ",
  // Czech Republic
  /*::[*/
  886: "TW",
  // Taiwan
  /*::[*/
  961: "LB",
  // Lebanon
  /*::[*/
  962: "JO",
  // Jordan
  /*::[*/
  963: "SY",
  // Syria
  /*::[*/
  964: "IQ",
  // Iraq
  /*::[*/
  965: "KW",
  // Kuwait
  /*::[*/
  966: "SA",
  // Saudi Arabia
  /*::[*/
  971: "AE",
  // United Arab Emirates
  /*::[*/
  972: "IL",
  // Israel
  /*::[*/
  974: "QA",
  // Qatar
  /*::[*/
  981: "IR",
  // Iran
  /*::[*/
  65535: "US"
  // United States
}, $1e = [
  null,
  "solid",
  "mediumGray",
  "darkGray",
  "lightGray",
  "darkHorizontal",
  "darkVertical",
  "darkDown",
  "darkUp",
  "darkGrid",
  "darkTrellis",
  "lightHorizontal",
  "lightVertical",
  "lightDown",
  "lightUp",
  "lightGrid",
  "lightTrellis",
  "gray125",
  "gray0625"
];
function O1e(e) {
  return e.map(function(t) {
    return [t >> 16 & 255, t >> 8 & 255, t & 255];
  });
}
var A1e = /* @__PURE__ */ O1e([
  /* Color Constants */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  /* Overridable Defaults */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  8388608,
  32768,
  128,
  8421376,
  8388736,
  32896,
  12632256,
  8421504,
  10066431,
  10040166,
  16777164,
  13434879,
  6684774,
  16744576,
  26316,
  13421823,
  128,
  16711935,
  16776960,
  65535,
  8388736,
  8388608,
  32896,
  255,
  52479,
  13434879,
  13434828,
  16777113,
  10079487,
  16751052,
  13408767,
  16764057,
  3368703,
  3394764,
  10079232,
  16763904,
  16750848,
  16737792,
  6710937,
  9868950,
  13158,
  3381606,
  13056,
  3355392,
  10040064,
  10040166,
  3355545,
  3355443,
  /* Other entries to appease BIFF8/12 */
  16777215,
  /* 0x40 icvForeground ?? */
  0,
  /* 0x41 icvBackground ?? */
  0,
  /* 0x42 icvFrame ?? */
  0,
  /* 0x43 icv3D ?? */
  0,
  /* 0x44 icv3DText ?? */
  0,
  /* 0x45 icv3DHilite ?? */
  0,
  /* 0x46 icv3DShadow ?? */
  0,
  /* 0x47 icvHilite ?? */
  0,
  /* 0x48 icvCtlText ?? */
  0,
  /* 0x49 icvCtlScrl ?? */
  0,
  /* 0x4A icvCtlInv ?? */
  0,
  /* 0x4B icvCtlBody ?? */
  0,
  /* 0x4C icvCtlFrame ?? */
  0,
  /* 0x4D icvCtlFore ?? */
  0,
  /* 0x4E icvCtlBack ?? */
  0,
  /* 0x4F icvCtlNeutral */
  0,
  /* 0x50 icvInfoBk ?? */
  0
  /* 0x51 icvInfoText ?? */
]), ec = /* @__PURE__ */ qn(A1e), dl = {
  /*::[*/
  0: "#NULL!",
  /*::[*/
  7: "#DIV/0!",
  /*::[*/
  15: "#VALUE!",
  /*::[*/
  23: "#REF!",
  /*::[*/
  29: "#NAME?",
  /*::[*/
  36: "#NUM!",
  /*::[*/
  42: "#N/A",
  /*::[*/
  43: "#GETTING_DATA",
  /*::[*/
  255: "#WTF?"
}, AR = {
  "#NULL!": 0,
  "#DIV/0!": 7,
  "#VALUE!": 15,
  "#REF!": 23,
  "#NAME?": 29,
  "#NUM!": 36,
  "#N/A": 42,
  "#GETTING_DATA": 43,
  "#WTF?": 255
}, zS = {
  /* Workbook */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
  "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
  /* Worksheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
  "application/vnd.ms-excel.worksheet": "sheets",
  "application/vnd.ms-excel.binIndexWs": "TODO",
  /* Binary Index */
  /* Chartsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
  "application/vnd.ms-excel.chartsheet": "charts",
  /* Macrosheet */
  "application/vnd.ms-excel.macrosheet+xml": "macros",
  "application/vnd.ms-excel.macrosheet": "macros",
  "application/vnd.ms-excel.intlmacrosheet": "TODO",
  "application/vnd.ms-excel.binIndexMs": "TODO",
  /* Binary Index */
  /* Dialogsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
  "application/vnd.ms-excel.dialogsheet": "dialogs",
  /* Shared Strings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
  "application/vnd.ms-excel.sharedStrings": "strs",
  /* Styles */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
  "application/vnd.ms-excel.styles": "styles",
  /* File Properties */
  "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
  /* Custom Data Properties */
  "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
  /* Comments */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
  "application/vnd.ms-excel.comments": "comments",
  "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
  "application/vnd.ms-excel.person+xml": "people",
  /* Metadata (Stock/Geography and Dynamic Array) */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
  "application/vnd.ms-excel.sheetMetadata": "metadata",
  /* PivotTable */
  "application/vnd.ms-excel.pivotTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
  /* Chart Objects */
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
  /* Chart Colors */
  "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
  /* Chart Style */
  "application/vnd.ms-office.chartstyle+xml": "TODO",
  /* Chart Advanced */
  "application/vnd.ms-office.chartex+xml": "TODO",
  /* Calculation Chain */
  "application/vnd.ms-excel.calcChain": "calcchains",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
  /* Printer Settings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
  /* ActiveX */
  "application/vnd.ms-office.activeX": "TODO",
  "application/vnd.ms-office.activeX+xml": "TODO",
  /* Custom Toolbars */
  "application/vnd.ms-excel.attachedToolbars": "TODO",
  /* External Data Connections */
  "application/vnd.ms-excel.connections": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
  /* External Links */
  "application/vnd.ms-excel.externalLink": "links",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
  /* PivotCache */
  "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
  "application/vnd.ms-excel.pivotCacheRecords": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
  /* Query Table */
  "application/vnd.ms-excel.queryTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
  /* Shared Workbook */
  "application/vnd.ms-excel.userNames": "TODO",
  "application/vnd.ms-excel.revisionHeaders": "TODO",
  "application/vnd.ms-excel.revisionLog": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
  /* Single Cell Table */
  "application/vnd.ms-excel.tableSingleCells": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
  /* Slicer */
  "application/vnd.ms-excel.slicer": "TODO",
  "application/vnd.ms-excel.slicerCache": "TODO",
  "application/vnd.ms-excel.slicer+xml": "TODO",
  "application/vnd.ms-excel.slicerCache+xml": "TODO",
  /* Sort Map */
  "application/vnd.ms-excel.wsSortMap": "TODO",
  /* Table */
  "application/vnd.ms-excel.table": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
  /* Themes */
  "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
  /* Theme Override */
  "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
  /* Timeline */
  "application/vnd.ms-excel.Timeline+xml": "TODO",
  /* verify */
  "application/vnd.ms-excel.TimelineCache+xml": "TODO",
  /* verify */
  /* VBA */
  "application/vnd.ms-office.vbaProject": "vba",
  "application/vnd.ms-office.vbaProjectSignature": "TODO",
  /* Volatile Dependencies */
  "application/vnd.ms-office.volatileDependencies": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
  /* Control Properties */
  "application/vnd.ms-excel.controlproperties+xml": "TODO",
  /* Data Model */
  "application/vnd.openxmlformats-officedocument.model+data": "TODO",
  /* Survey */
  "application/vnd.ms-excel.Survey+xml": "TODO",
  /* Drawing */
  "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
  /* VML */
  "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
  "application/vnd.openxmlformats-package.relationships+xml": "rels",
  "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
  /* Image */
  "image/png": "TODO",
  sheet: "js"
}, pv = {
  workbooks: {
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
    xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
    xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
    xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
    xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
  },
  strs: {
    /* Shared Strings */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
    xlsb: "application/vnd.ms-excel.sharedStrings"
  },
  comments: {
    /* Comments */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
    xlsb: "application/vnd.ms-excel.comments"
  },
  sheets: {
    /* Worksheet */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
    xlsb: "application/vnd.ms-excel.worksheet"
  },
  charts: {
    /* Chartsheet */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
    xlsb: "application/vnd.ms-excel.chartsheet"
  },
  dialogs: {
    /* Dialogsheet */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
    xlsb: "application/vnd.ms-excel.dialogsheet"
  },
  macros: {
    /* Macrosheet (Excel 4.0 Macros) */
    xlsx: "application/vnd.ms-excel.macrosheet+xml",
    xlsb: "application/vnd.ms-excel.macrosheet"
  },
  metadata: {
    /* Metadata (Stock/Geography and Dynamic Array) */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
    xlsb: "application/vnd.ms-excel.sheetMetadata"
  },
  styles: {
    /* Styles */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
    xlsb: "application/vnd.ms-excel.styles"
  }
};
function nE() {
  return {
    workbooks: [],
    sheets: [],
    charts: [],
    dialogs: [],
    macros: [],
    rels: [],
    strs: [],
    comments: [],
    threadedcomments: [],
    links: [],
    coreprops: [],
    extprops: [],
    custprops: [],
    themes: [],
    styles: [],
    calcchains: [],
    vba: [],
    drawings: [],
    metadata: [],
    people: [],
    TODO: [],
    xmlns: ""
  };
}
function I1e(e) {
  var t = nE();
  if (!e || !e.match) return t;
  var n = {};
  if ((e.match(Fa) || []).forEach(function(r) {
    var a = Vt(r);
    switch (a[0].replace(Bge, "<")) {
      case "<?xml":
        break;
      case "<Types":
        t.xmlns = a["xmlns" + (a[0].match(/<(\w+):/) || ["", ""])[1]];
        break;
      case "<Default":
        n[a.Extension] = a.ContentType;
        break;
      case "<Override":
        t[zS[a.ContentType]] !== void 0 && t[zS[a.ContentType]].push(a.PartName);
        break;
    }
  }), t.xmlns !== Rr.CT) throw new Error("Unknown Namespace: " + t.xmlns);
  return t.calcchain = t.calcchains.length > 0 ? t.calcchains[0] : "", t.sst = t.strs.length > 0 ? t.strs[0] : "", t.style = t.styles.length > 0 ? t.styles[0] : "", t.defaults = n, delete t.calcchains, t;
}
function IR(e, t) {
  var n = Age(zS), r = [], a;
  r[r.length] = Tr, r[r.length] = pt("Types", null, {
    xmlns: Rr.CT,
    "xmlns:xsd": Rr.xsd,
    "xmlns:xsi": Rr.xsi
  }), r = r.concat([
    ["xml", "application/xml"],
    ["bin", "application/vnd.ms-excel.sheet.binary.macroEnabled.main"],
    ["vml", "application/vnd.openxmlformats-officedocument.vmlDrawing"],
    ["data", "application/vnd.openxmlformats-officedocument.model+data"],
    /* from test files */
    ["bmp", "image/bmp"],
    ["png", "image/png"],
    ["gif", "image/gif"],
    ["emf", "image/x-emf"],
    ["wmf", "image/x-wmf"],
    ["jpg", "image/jpeg"],
    ["jpeg", "image/jpeg"],
    ["tif", "image/tiff"],
    ["tiff", "image/tiff"],
    ["pdf", "application/pdf"],
    ["rels", "application/vnd.openxmlformats-package.relationships+xml"]
  ].map(function(l) {
    return pt("Default", null, { Extension: l[0], ContentType: l[1] });
  }));
  var o = function(l) {
    e[l] && e[l].length > 0 && (a = e[l][0], r[r.length] = pt("Override", null, {
      PartName: (a[0] == "/" ? "" : "/") + a,
      ContentType: pv[l][t.bookType] || pv[l].xlsx
    }));
  }, i = function(l) {
    (e[l] || []).forEach(function(u) {
      r[r.length] = pt("Override", null, {
        PartName: (u[0] == "/" ? "" : "/") + u,
        ContentType: pv[l][t.bookType] || pv[l].xlsx
      });
    });
  }, s = function(l) {
    (e[l] || []).forEach(function(u) {
      r[r.length] = pt("Override", null, {
        PartName: (u[0] == "/" ? "" : "/") + u,
        ContentType: n[l][0]
      });
    });
  };
  return o("workbooks"), i("sheets"), i("charts"), s("themes"), ["strs", "styles"].forEach(o), ["coreprops", "extprops", "custprops"].forEach(s), s("vba"), s("comments"), s("threadedcomments"), s("drawings"), i("metadata"), s("people"), r.length > 2 && (r[r.length] = "</Types>", r[1] = r[1].replace("/>", ">")), r.join("");
}
var cn = {
  WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
  VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
  XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
  XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
  XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
  CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
  CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
  CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
  CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
  EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
  CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",
  SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
  STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
  THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
  CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
  CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
  CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
  WS: [
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
    "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
  ],
  DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
  MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
  IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
  DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
  XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
  TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
  PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
  VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
};
function wp(e) {
  var t = e.lastIndexOf("/");
  return e.slice(0, t + 1) + "_rels/" + e.slice(t + 1) + ".rels";
}
function F0(e, t) {
  var n = { "!id": {} };
  if (!e) return n;
  t.charAt(0) !== "/" && (t = "/" + t);
  var r = {};
  return (e.match(Fa) || []).forEach(function(a) {
    var o = Vt(a);
    if (o[0] === "<Relationship") {
      var i = {};
      i.Type = o.Type, i.Target = o.Target, i.Id = o.Id, o.TargetMode && (i.TargetMode = o.TargetMode);
      var s = o.TargetMode === "External" ? o.Target : c0(o.Target, t);
      n[s] = i, r[o.Id] = i;
    }
  }), n["!id"] = r, n;
}
function Pf(e) {
  var t = [Tr, pt("Relationships", null, {
    //'xmlns:ns0': XMLNS.RELS,
    xmlns: Rr.RELS
  })];
  return Er(e["!id"]).forEach(function(n) {
    t[t.length] = pt("Relationship", null, e["!id"][n]);
  }), t.length > 2 && (t[t.length] = "</Relationships>", t[1] = t[1].replace("/>", ">")), t.join("");
}
function Rn(e, t, n, r, a, o) {
  if (a || (a = {}), e["!id"] || (e["!id"] = {}), e["!idx"] || (e["!idx"] = 1), t < 0) for (t = e["!idx"]; e["!id"]["rId" + t]; ++t)
    ;
  if (e["!idx"] = t + 1, a.Id = "rId" + t, a.Type = r, a.Target = n, [cn.HLINK, cn.XPATH, cn.XMISS].indexOf(a.Type) > -1 && (a.TargetMode = "External"), e["!id"][a.Id]) throw new Error("Cannot rewrite rId " + t);
  return e["!id"][a.Id] = a, e[("/" + a.Target).replace("//", "/")] = a, t;
}
var P1e = "application/vnd.oasis.opendocument.spreadsheet";
function D1e(e, t) {
  for (var n = Y4(e), r, a; r = bp.exec(n); ) switch (r[3]) {
    case "manifest":
      break;
    case "file-entry":
      if (a = Vt(r[0], !1), a.path == "/" && a.type !== P1e) throw new Error("This OpenDocument is not a spreadsheet");
      break;
    case "encryption-data":
    case "algorithm":
    case "start-key-generation":
    case "key-derivation":
      throw new Error("Unsupported ODS Encryption");
    default:
      if (t && t.WTF) throw r;
  }
}
function k1e(e) {
  var t = [Tr];
  t.push(`<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">
`), t.push(`  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>
`);
  for (var n = 0; n < e.length; ++n) t.push('  <manifest:file-entry manifest:full-path="' + e[n][0] + '" manifest:media-type="' + e[n][1] + `"/>
`);
  return t.push("</manifest:manifest>"), t.join("");
}
function hO(e, t, n) {
  return [
    '  <rdf:Description rdf:about="' + e + `">
`,
    '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (n || "odf") + "#" + t + `"/>
`,
    `  </rdf:Description>
`
  ].join("");
}
function M1e(e, t) {
  return [
    '  <rdf:Description rdf:about="' + e + `">
`,
    '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + t + `"/>
`,
    `  </rdf:Description>
`
  ].join("");
}
function R1e(e) {
  var t = [Tr];
  t.push(`<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
`);
  for (var n = 0; n != e.length; ++n)
    t.push(hO(e[n][0], e[n][1])), t.push(M1e("", e[n][0]));
  return t.push(hO("", "Document", "pkg")), t.push("</rdf:RDF>"), t.join("");
}
function PR() {
  return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + Jm.version + "</meta:generator></office:meta></office:document-meta>";
}
var si = [
  ["cp:category", "Category"],
  ["cp:contentStatus", "ContentStatus"],
  ["cp:keywords", "Keywords"],
  ["cp:lastModifiedBy", "LastAuthor"],
  ["cp:lastPrinted", "LastPrinted"],
  ["cp:revision", "RevNumber"],
  ["cp:version", "Version"],
  ["dc:creator", "Author"],
  ["dc:description", "Comments"],
  ["dc:identifier", "Identifier"],
  ["dc:language", "Language"],
  ["dc:subject", "Subject"],
  ["dc:title", "Title"],
  ["dcterms:created", "CreatedDate", "date"],
  ["dcterms:modified", "ModifiedDate", "date"]
], N1e = /* @__PURE__ */ function() {
  for (var e = new Array(si.length), t = 0; t < si.length; ++t) {
    var n = si[t], r = "(?:" + n[0].slice(0, n[0].indexOf(":")) + ":)" + n[0].slice(n[0].indexOf(":") + 1);
    e[t] = new RegExp("<" + r + "[^>]*>([\\s\\S]*?)</" + r + ">");
  }
  return e;
}();
function DR(e) {
  var t = {};
  e = Hn(e);
  for (var n = 0; n < si.length; ++n) {
    var r = si[n], a = e.match(N1e[n]);
    a != null && a.length > 0 && (t[r[1]] = En(a[1])), r[2] === "date" && t[r[1]] && (t[r[1]] = nr(t[r[1]]));
  }
  return t;
}
function Px(e, t, n, r, a) {
  a[e] != null || t == null || t === "" || (a[e] = t, t = Nn(t), r[r.length] = n ? pt(e, t, n) : oa(e, t));
}
function kR(e, t) {
  var n = t || {}, r = [Tr, pt("cp:coreProperties", null, {
    //'xmlns': XMLNS.CORE_PROPS,
    "xmlns:cp": Rr.CORE_PROPS,
    "xmlns:dc": Rr.dc,
    "xmlns:dcterms": Rr.dcterms,
    "xmlns:dcmitype": Rr.dcmitype,
    "xmlns:xsi": Rr.xsi
  })], a = {};
  if (!e && !n.Props) return r.join("");
  e && (e.CreatedDate != null && Px("dcterms:created", typeof e.CreatedDate == "string" ? e.CreatedDate : HS(e.CreatedDate, n.WTF), { "xsi:type": "dcterms:W3CDTF" }, r, a), e.ModifiedDate != null && Px("dcterms:modified", typeof e.ModifiedDate == "string" ? e.ModifiedDate : HS(e.ModifiedDate, n.WTF), { "xsi:type": "dcterms:W3CDTF" }, r, a));
  for (var o = 0; o != si.length; ++o) {
    var i = si[o], s = n.Props && n.Props[i[1]] != null ? n.Props[i[1]] : e ? e[i[1]] : null;
    s === !0 ? s = "1" : s === !1 ? s = "0" : typeof s == "number" && (s = String(s)), s != null && Px(i[0], s, null, r, a);
  }
  return r.length > 2 && (r[r.length] = "</cp:coreProperties>", r[1] = r[1].replace("/>", ">")), r.join("");
}
var tc = [
  ["Application", "Application", "string"],
  ["AppVersion", "AppVersion", "string"],
  ["Company", "Company", "string"],
  ["DocSecurity", "DocSecurity", "string"],
  ["Manager", "Manager", "string"],
  ["HyperlinksChanged", "HyperlinksChanged", "bool"],
  ["SharedDoc", "SharedDoc", "bool"],
  ["LinksUpToDate", "LinksUpToDate", "bool"],
  ["ScaleCrop", "ScaleCrop", "bool"],
  ["HeadingPairs", "HeadingPairs", "raw"],
  ["TitlesOfParts", "TitlesOfParts", "raw"]
], MR = [
  "Worksheets",
  "SheetNames",
  "NamedRanges",
  "DefinedNames",
  "Chartsheets",
  "ChartNames"
];
function RR(e, t, n, r) {
  var a = [];
  if (typeof e == "string") a = aO(e, r);
  else for (var o = 0; o < e.length; ++o) a = a.concat(e[o].map(function(c) {
    return { v: c };
  }));
  var i = typeof t == "string" ? aO(t, r).map(function(c) {
    return c.v;
  }) : t, s = 0, l = 0;
  if (i.length > 0) for (var u = 0; u !== a.length; u += 2) {
    switch (l = +a[u + 1].v, a[u].v) {
      case "Worksheets":
      case "工作表":
      case "Листы":
      case "أوراق العمل":
      case "ワークシート":
      case "גליונות עבודה":
      case "Arbeitsblätter":
      case "Çalışma Sayfaları":
      case "Feuilles de calcul":
      case "Fogli di lavoro":
      case "Folhas de cálculo":
      case "Planilhas":
      case "Regneark":
      case "Hojas de cálculo":
      case "Werkbladen":
        n.Worksheets = l, n.SheetNames = i.slice(s, s + l);
        break;
      case "Named Ranges":
      case "Rangos con nombre":
      case "名前付き一覧":
      case "Benannte Bereiche":
      case "Navngivne områder":
        n.NamedRanges = l, n.DefinedNames = i.slice(s, s + l);
        break;
      case "Charts":
      case "Diagramme":
        n.Chartsheets = l, n.ChartNames = i.slice(s, s + l);
        break;
    }
    s += l;
  }
}
function F1e(e, t, n) {
  var r = {};
  return t || (t = {}), e = Hn(e), tc.forEach(function(a) {
    var o = (e.match(yp(a[0])) || [])[1];
    switch (a[2]) {
      case "string":
        o && (t[a[1]] = En(o));
        break;
      case "bool":
        t[a[1]] = o === "true";
        break;
      case "raw":
        var i = e.match(new RegExp("<" + a[0] + "[^>]*>([\\s\\S]*?)</" + a[0] + ">"));
        i && i.length > 0 && (r[a[1]] = i[1]);
        break;
    }
  }), r.HeadingPairs && r.TitlesOfParts && RR(r.HeadingPairs, r.TitlesOfParts, t, n), t;
}
function NR(e) {
  var t = [], n = pt;
  return e || (e = {}), e.Application = "SheetJS", t[t.length] = Tr, t[t.length] = pt("Properties", null, {
    xmlns: Rr.EXT_PROPS,
    "xmlns:vt": Rr.vt
  }), tc.forEach(function(r) {
    if (e[r[1]] !== void 0) {
      var a;
      switch (r[2]) {
        case "string":
          a = Nn(String(e[r[1]]));
          break;
        case "bool":
          a = e[r[1]] ? "true" : "false";
          break;
      }
      a !== void 0 && (t[t.length] = n(r[0], a));
    }
  }), t[t.length] = n("HeadingPairs", n("vt:vector", n("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") + n("vt:variant", n("vt:i4", String(e.Worksheets))), { size: 2, baseType: "variant" })), t[t.length] = n("TitlesOfParts", n("vt:vector", e.SheetNames.map(function(r) {
    return "<vt:lpstr>" + Nn(r) + "</vt:lpstr>";
  }).join(""), { size: e.Worksheets, baseType: "lpstr" })), t.length > 2 && (t[t.length] = "</Properties>", t[1] = t[1].replace("/>", ">")), t.join("");
}
var L1e = /<[^>]+>[^<]*/g;
function B1e(e, t) {
  var n = {}, r = "", a = e.match(L1e);
  if (a) for (var o = 0; o != a.length; ++o) {
    var i = a[o], s = Vt(i);
    switch (s[0]) {
      case "<?xml":
        break;
      case "<Properties":
        break;
      case "<property":
        r = En(s.name);
        break;
      case "</property>":
        r = null;
        break;
      default:
        if (i.indexOf("<vt:") === 0) {
          var l = i.split(">"), u = l[0].slice(4), c = l[1];
          switch (u) {
            case "lpstr":
            case "bstr":
            case "lpwstr":
              n[r] = En(c);
              break;
            case "bool":
              n[r] = Kn(c);
              break;
            case "i1":
            case "i2":
            case "i4":
            case "i8":
            case "int":
            case "uint":
              n[r] = parseInt(c, 10);
              break;
            case "r4":
            case "r8":
            case "decimal":
              n[r] = parseFloat(c);
              break;
            case "filetime":
            case "date":
              n[r] = nr(c);
              break;
            case "cy":
            case "error":
              n[r] = En(c);
              break;
            default:
              if (u.slice(-1) == "/") break;
              t.WTF && typeof console < "u" && console.warn("Unexpected", i, u, l);
          }
        } else if (i.slice(0, 2) !== "</") {
          if (t.WTF) throw new Error(i);
        }
    }
  }
  return n;
}
function FR(e) {
  var t = [Tr, pt("Properties", null, {
    xmlns: Rr.CUST_PROPS,
    "xmlns:vt": Rr.vt
  })];
  if (!e) return t.join("");
  var n = 1;
  return Er(e).forEach(function(a) {
    ++n, t[t.length] = pt("property", Yge(e[a]), {
      fmtid: "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
      pid: n,
      name: Nn(a)
    });
  }), t.length > 2 && (t[t.length] = "</Properties>", t[1] = t[1].replace("/>", ">")), t.join("");
}
var WS = {
  Title: "Title",
  Subject: "Subject",
  Author: "Author",
  Keywords: "Keywords",
  Comments: "Description",
  LastAuthor: "LastAuthor",
  RevNumber: "Revision",
  Application: "AppName",
  /* TotalTime: 'TotalTime', */
  LastPrinted: "LastPrinted",
  CreatedDate: "Created",
  ModifiedDate: "LastSaved",
  /* Pages */
  /* Words */
  /* Characters */
  Category: "Category",
  /* PresentationFormat */
  Manager: "Manager",
  Company: "Company",
  /* Guid */
  /* HyperlinkBase */
  /* Bytes */
  /* Lines */
  /* Paragraphs */
  /* CharactersWithSpaces */
  AppVersion: "Version",
  ContentStatus: "ContentStatus",
  /* NOTE: missing from schema */
  Identifier: "Identifier",
  /* NOTE: missing from schema */
  Language: "Language"
  /* NOTE: missing from schema */
}, Dx;
function H1e(e, t, n) {
  Dx || (Dx = j1(WS)), t = Dx[t] || t, e[t] = n;
}
function j1e(e, t) {
  var n = [];
  return Er(WS).map(function(r) {
    for (var a = 0; a < si.length; ++a) if (si[a][1] == r) return si[a];
    for (a = 0; a < tc.length; ++a) if (tc[a][1] == r) return tc[a];
    throw r;
  }).forEach(function(r) {
    if (e[r[1]] != null) {
      var a = t && t.Props && t.Props[r[1]] != null ? t.Props[r[1]] : e[r[1]];
      switch (r[2]) {
        case "date":
          a = new Date(a).toISOString().replace(/\.\d*Z/, "Z");
          break;
      }
      typeof a == "number" ? a = String(a) : a === !0 || a === !1 ? a = a ? "1" : "0" : a instanceof Date && (a = new Date(a).toISOString().replace(/\.\d*Z/, "")), n.push(oa(WS[r[1]] || r[1], a));
    }
  }), pt("DocumentProperties", n.join(""), { xmlns: Oo.o });
}
function V1e(e, t) {
  var n = ["Worksheets", "SheetNames"], r = "CustomDocumentProperties", a = [];
  return e && Er(e).forEach(function(o) {
    if (Object.prototype.hasOwnProperty.call(e, o)) {
      for (var i = 0; i < si.length; ++i) if (o == si[i][1]) return;
      for (i = 0; i < tc.length; ++i) if (o == tc[i][1]) return;
      for (i = 0; i < n.length; ++i) if (o == n[i]) return;
      var s = e[o], l = "string";
      typeof s == "number" ? (l = "float", s = String(s)) : s === !0 || s === !1 ? (l = "boolean", s = s ? "1" : "0") : s = String(s), a.push(pt(eO(o), s, { "dt:dt": l }));
    }
  }), t && Er(t).forEach(function(o) {
    if (Object.prototype.hasOwnProperty.call(t, o) && !(e && Object.prototype.hasOwnProperty.call(e, o))) {
      var i = t[o], s = "string";
      typeof i == "number" ? (s = "float", i = String(i)) : i === !0 || i === !1 ? (s = "boolean", i = i ? "1" : "0") : i instanceof Date ? (s = "dateTime.tz", i = i.toISOString()) : i = String(i), a.push(pt(eO(o), i, { "dt:dt": s }));
    }
  }), "<" + r + ' xmlns="' + Oo.o + '">' + a.join("") + "</" + r + ">";
}
function rE(e) {
  var t = e.read_shift(4), n = e.read_shift(4);
  return new Date((n / 1e7 * Math.pow(2, 32) + t / 1e7 - 11644473600) * 1e3).toISOString().replace(/\.000/, "");
}
function U1e(e) {
  var t = typeof e == "string" ? new Date(Date.parse(e)) : e, n = t.getTime() / 1e3 + 11644473600, r = n % Math.pow(2, 32), a = (n - r) / Math.pow(2, 32);
  r *= 1e7, a *= 1e7;
  var o = r / Math.pow(2, 32) | 0;
  o > 0 && (r = r % Math.pow(2, 32), a += o);
  var i = We(8);
  return i.write_shift(4, r), i.write_shift(4, a), i;
}
function LR(e, t, n) {
  var r = e.l, a = e.read_shift(0, "lpstr-cp");
  if (n) for (; e.l - r & 3; ) ++e.l;
  return a;
}
function BR(e, t, n) {
  var r = e.read_shift(0, "lpwstr");
  return r;
}
function HR(e, t, n) {
  return t === 31 ? BR(e) : LR(e, t, n);
}
function GS(e, t, n) {
  return HR(e, t, n === !1 ? 0 : 4);
}
function z1e(e, t) {
  if (!t) throw new Error("VtUnalignedString must have positive length");
  return HR(e, t, 0);
}
function W1e(e) {
  for (var t = e.read_shift(4), n = [], r = 0; r != t; ++r) {
    var a = e.l;
    n[r] = e.read_shift(0, "lpwstr").replace(Ya, ""), e.l - a & 2 && (e.l += 2);
  }
  return n;
}
function G1e(e) {
  for (var t = e.read_shift(4), n = [], r = 0; r != t; ++r) n[r] = e.read_shift(0, "lpstr-cp").replace(Ya, "");
  return n;
}
function K1e(e) {
  var t = e.l, n = lg(e, OR);
  e[e.l] == 0 && e[e.l + 1] == 0 && e.l - t & 2 && (e.l += 2);
  var r = lg(e, ao);
  return [n, r];
}
function Y1e(e) {
  for (var t = e.read_shift(4), n = [], r = 0; r < t / 2; ++r) n.push(K1e(e));
  return n;
}
function vO(e, t) {
  for (var n = e.read_shift(4), r = {}, a = 0; a != n; ++a) {
    var o = e.read_shift(4), i = e.read_shift(4);
    r[o] = e.read_shift(i, t === 1200 ? "utf16le" : "utf8").replace(Ya, "").replace(u0, "!"), t === 1200 && i % 2 && (e.l += 2);
  }
  return e.l & 3 && (e.l = e.l >> 3 << 2), r;
}
function jR(e) {
  var t = e.read_shift(4), n = e.slice(e.l, e.l + t);
  return e.l += t, (t & 3) > 0 && (e.l += 4 - (t & 3) & 3), n;
}
function q1e(e) {
  var t = {};
  return t.Size = e.read_shift(4), e.l += t.Size + 3 - (t.Size - 1) % 4, t;
}
function lg(e, t, n) {
  var r = e.read_shift(2), a, o = n || {};
  if (e.l += 2, t !== dO && r !== t && T1e.indexOf(t) === -1 && !((t & 65534) == 4126 && (r & 65534) == 4126))
    throw new Error("Expected type " + t + " saw " + r);
  switch (t === dO ? r : t) {
    case 2:
      return a = e.read_shift(2, "i"), o.raw || (e.l += 2), a;
    case 3:
      return a = e.read_shift(4, "i"), a;
    case 11:
      return e.read_shift(4) !== 0;
    case 19:
      return a = e.read_shift(4), a;
    case 30:
      return LR(e, r, 4).replace(Ya, "");
    case 31:
      return BR(e);
    case 64:
      return rE(e);
    case 65:
      return jR(e);
    case 71:
      return q1e(e);
    case 80:
      return GS(e, r, !o.raw).replace(Ya, "");
    case 81:
      return z1e(
        e,
        r
        /*, 4*/
      ).replace(Ya, "");
    case 4108:
      return Y1e(e);
    case 4126:
    case 4127:
      return r == 4127 ? W1e(e) : G1e(e);
    default:
      throw new Error("TypedPropertyValue unrecognized type " + t + " " + r);
  }
}
function mO(e, t) {
  var n = We(4), r = We(4);
  switch (n.write_shift(4, e == 80 ? 31 : e), e) {
    case 3:
      r.write_shift(-4, t);
      break;
    case 5:
      r = We(8), r.write_shift(8, t, "f");
      break;
    case 11:
      r.write_shift(4, t ? 1 : 0);
      break;
    case 64:
      r = U1e(t);
      break;
    case 31:
    case 80:
      for (r = We(4 + 2 * (t.length + 1) + (t.length % 2 ? 0 : 2)), r.write_shift(4, t.length + 1), r.write_shift(0, t, "dbcs"); r.l != r.length; ) r.write_shift(1, 0);
      break;
    default:
      throw new Error("TypedPropertyValue unrecognized type " + e + " " + t);
  }
  return zr([n, r]);
}
function gO(e, t) {
  var n = e.l, r = e.read_shift(4), a = e.read_shift(4), o = [], i = 0, s = 0, l = -1, u = {};
  for (i = 0; i != a; ++i) {
    var c = e.read_shift(4), f = e.read_shift(4);
    o[i] = [c, f + n];
  }
  o.sort(function(x, g) {
    return x[1] - g[1];
  });
  var d = {};
  for (i = 0; i != a; ++i) {
    if (e.l !== o[i][1]) {
      var p = !0;
      if (i > 0 && t) switch (t[o[i - 1][0]].t) {
        case 2:
          e.l + 2 === o[i][1] && (e.l += 2, p = !1);
          break;
        case 80:
          e.l <= o[i][1] && (e.l = o[i][1], p = !1);
          break;
        case 4108:
          e.l <= o[i][1] && (e.l = o[i][1], p = !1);
          break;
      }
      if ((!t || i == 0) && e.l <= o[i][1] && (p = !1, e.l = o[i][1]), p) throw new Error("Read Error: Expected address " + o[i][1] + " at " + e.l + " :" + i);
    }
    if (t) {
      var v = t[o[i][0]];
      if (d[v.n] = lg(e, v.t, { raw: !0 }), v.p === "version" && (d[v.n] = String(d[v.n] >> 16) + "." + ("0000" + String(d[v.n] & 65535)).slice(-4)), v.n == "CodePage") switch (d[v.n]) {
        case 0:
          d[v.n] = 1252;
        case 874:
        case 932:
        case 936:
        case 949:
        case 950:
        case 1250:
        case 1251:
        case 1253:
        case 1254:
        case 1255:
        case 1256:
        case 1257:
        case 1258:
        case 1e4:
        case 1200:
        case 1201:
        case 1252:
        case 65e3:
        case -536:
        case 65001:
        case -535:
          Fi(s = d[v.n] >>> 0 & 65535);
          break;
        default:
          throw new Error("Unsupported CodePage: " + d[v.n]);
      }
    } else if (o[i][0] === 1) {
      if (s = d.CodePage = lg(e, tE), Fi(s), l !== -1) {
        var h = e.l;
        e.l = o[l][1], u = vO(e, s), e.l = h;
      }
    } else if (o[i][0] === 0) {
      if (s === 0) {
        l = i, e.l = o[i + 1][1];
        continue;
      }
      u = vO(e, s);
    } else {
      var m = u[o[i][0]], y;
      switch (e[e.l]) {
        case 65:
          e.l += 4, y = jR(e);
          break;
        case 30:
          e.l += 4, y = GS(e, e[e.l - 4]).replace(/\u0000+$/, "");
          break;
        case 31:
          e.l += 4, y = GS(e, e[e.l - 4]).replace(/\u0000+$/, "");
          break;
        case 3:
          e.l += 4, y = e.read_shift(4, "i");
          break;
        case 19:
          e.l += 4, y = e.read_shift(4);
          break;
        case 5:
          e.l += 4, y = e.read_shift(8, "f");
          break;
        case 11:
          e.l += 4, y = Sr(e, 4);
          break;
        case 64:
          e.l += 4, y = nr(rE(e));
          break;
        default:
          throw new Error("unparsed value: " + e[e.l]);
      }
      d[m] = y;
    }
  }
  return e.l = n + r, d;
}
var VR = ["CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID"];
function X1e(e) {
  switch (typeof e) {
    case "boolean":
      return 11;
    case "number":
      return (e | 0) == e ? 3 : 5;
    case "string":
      return 31;
    case "object":
      if (e instanceof Date) return 64;
      break;
  }
  return -1;
}
function yO(e, t, n) {
  var r = We(8), a = [], o = [], i = 8, s = 0, l = We(8), u = We(8);
  if (l.write_shift(4, 2), l.write_shift(4, 1200), u.write_shift(4, 1), o.push(l), a.push(u), i += 8 + l.length, !t) {
    u = We(8), u.write_shift(4, 0), a.unshift(u);
    var c = [We(4)];
    for (c[0].write_shift(4, e.length), s = 0; s < e.length; ++s) {
      var f = e[s][0];
      for (l = We(8 + 2 * (f.length + 1) + (f.length % 2 ? 0 : 2)), l.write_shift(4, s + 2), l.write_shift(4, f.length + 1), l.write_shift(0, f, "dbcs"); l.l != l.length; ) l.write_shift(1, 0);
      c.push(l);
    }
    l = zr(c), o.unshift(l), i += 8 + l.length;
  }
  for (s = 0; s < e.length; ++s)
    if (!(t && !t[e[s][0]]) && !(VR.indexOf(e[s][0]) > -1 || MR.indexOf(e[s][0]) > -1) && e[s][1] != null) {
      var d = e[s][1], p = 0;
      if (t) {
        p = +t[e[s][0]];
        var v = n[p];
        if (v.p == "version" && typeof d == "string") {
          var h = d.split(".");
          d = (+h[0] << 16) + (+h[1] || 0);
        }
        l = mO(v.t, d);
      } else {
        var m = X1e(d);
        m == -1 && (m = 31, d = String(d)), l = mO(m, d);
      }
      o.push(l), u = We(8), u.write_shift(4, t ? p : 2 + s), a.push(u), i += 8 + l.length;
    }
  var y = 8 * (o.length + 1);
  for (s = 0; s < o.length; ++s)
    a[s].write_shift(4, y), y += o[s].length;
  return r.write_shift(4, i), r.write_shift(4, o.length), zr([r].concat(a).concat(o));
}
function xO(e, t, n) {
  var r = e.content;
  if (!r) return {};
  ta(r, 0);
  var a, o, i, s, l = 0;
  r.chk("feff", "Byte Order: "), r.read_shift(2);
  var u = r.read_shift(4), c = r.read_shift(16);
  if (c !== Dt.utils.consts.HEADER_CLSID && c !== n) throw new Error("Bad PropertySet CLSID " + c);
  if (a = r.read_shift(4), a !== 1 && a !== 2) throw new Error("Unrecognized #Sets: " + a);
  if (o = r.read_shift(16), s = r.read_shift(4), a === 1 && s !== r.l) throw new Error("Length mismatch: " + s + " !== " + r.l);
  a === 2 && (i = r.read_shift(16), l = r.read_shift(4));
  var f = gO(r, t), d = { SystemIdentifier: u };
  for (var p in f) d[p] = f[p];
  if (d.FMTID = o, a === 1) return d;
  if (l - r.l == 2 && (r.l += 2), r.l !== l) throw new Error("Length mismatch 2: " + r.l + " !== " + l);
  var v;
  try {
    v = gO(r, null);
  } catch {
  }
  for (p in v) d[p] = v[p];
  return d.FMTID = [o, i], d;
}
function bO(e, t, n, r, a, o) {
  var i = We(a ? 68 : 48), s = [i];
  i.write_shift(2, 65534), i.write_shift(2, 0), i.write_shift(4, 842412599), i.write_shift(16, Dt.utils.consts.HEADER_CLSID, "hex"), i.write_shift(4, a ? 2 : 1), i.write_shift(16, t, "hex"), i.write_shift(4, a ? 68 : 48);
  var l = yO(e, n, r);
  if (s.push(l), a) {
    var u = yO(a, null, null);
    i.write_shift(16, o, "hex"), i.write_shift(4, 68 + l.length), s.push(u);
  }
  return zr(s);
}
function Sl(e, t) {
  return e.read_shift(t), null;
}
function Z1e(e, t) {
  t || (t = We(e));
  for (var n = 0; n < e; ++n) t.write_shift(1, 0);
  return t;
}
function Q1e(e, t, n) {
  for (var r = [], a = e.l + t; e.l < a; ) r.push(n(e, a - e.l));
  if (a !== e.l) throw new Error("Slurp error");
  return r;
}
function Sr(e, t) {
  return e.read_shift(t) === 1;
}
function Va(e, t) {
  return t || (t = We(2)), t.write_shift(2, +!!e), t;
}
function Dr(e) {
  return e.read_shift(2, "u");
}
function ti(e, t) {
  return t || (t = We(2)), t.write_shift(2, e), t;
}
function UR(e, t) {
  return Q1e(e, t, Dr);
}
function J1e(e) {
  var t = e.read_shift(1), n = e.read_shift(1);
  return n === 1 ? t : t === 1;
}
function zR(e, t, n) {
  return n || (n = We(2)), n.write_shift(1, t == "e" ? +e : +!!e), n.write_shift(1, t == "e" ? 1 : 0), n;
}
function ch(e, t, n) {
  var r = e.read_shift(n && n.biff >= 12 ? 2 : 1), a = "sbcs-cont";
  if (n && n.biff >= 8, !n || n.biff == 8) {
    var o = e.read_shift(1);
    o && (a = "dbcs-cont");
  } else n.biff == 12 && (a = "wstr");
  n.biff >= 2 && n.biff <= 5 && (a = "cpstr");
  var i = r ? e.read_shift(r, a) : "";
  return i;
}
function eye(e) {
  var t = e.read_shift(2), n = e.read_shift(1), r = n & 4, a = n & 8, o = 1 + (n & 1), i = 0, s, l = {};
  a && (i = e.read_shift(2)), r && (s = e.read_shift(4));
  var u = o == 2 ? "dbcs-cont" : "sbcs-cont", c = t === 0 ? "" : e.read_shift(t, u);
  return a && (e.l += 4 * i), r && (e.l += s), l.t = c, a || (l.raw = "<t>" + l.t + "</t>", l.r = l.t), l;
}
function tye(e) {
  var t = e.t || "", n = We(3);
  n.write_shift(2, t.length), n.write_shift(1, 1);
  var r = We(2 * t.length);
  r.write_shift(2 * t.length, t, "utf16le");
  var a = [n, r];
  return zr(a);
}
function yc(e, t, n) {
  var r;
  if (n) {
    if (n.biff >= 2 && n.biff <= 5) return e.read_shift(t, "cpstr");
    if (n.biff >= 12) return e.read_shift(t, "dbcs-cont");
  }
  var a = e.read_shift(1);
  return a === 0 ? r = e.read_shift(t, "sbcs-cont") : r = e.read_shift(t, "dbcs-cont"), r;
}
function fh(e, t, n) {
  var r = e.read_shift(n && n.biff == 2 ? 1 : 2);
  return r === 0 ? (e.l++, "") : yc(e, r, n);
}
function Vc(e, t, n) {
  if (n.biff > 5) return fh(e, t, n);
  var r = e.read_shift(1);
  return r === 0 ? (e.l++, "") : e.read_shift(r, n.biff <= 4 || !e.lens ? "cpstr" : "sbcs-cont");
}
function WR(e, t, n) {
  return n || (n = We(3 + 2 * e.length)), n.write_shift(2, e.length), n.write_shift(1, 1), n.write_shift(31, e, "utf16le"), n;
}
function nye(e) {
  var t = e.read_shift(1);
  e.l++;
  var n = e.read_shift(2);
  return e.l += 2, [t, n];
}
function rye(e) {
  var t = e.read_shift(4), n = e.l, r = !1;
  t > 24 && (e.l += t - 24, e.read_shift(16) === "795881f43b1d7f48af2c825dc4852763" && (r = !0), e.l = n);
  var a = e.read_shift((r ? t - 24 : t) >> 1, "utf16le").replace(Ya, "");
  return r && (e.l += 24), a;
}
function aye(e) {
  for (var t = e.read_shift(2), n = ""; t-- > 0; ) n += "../";
  var r = e.read_shift(0, "lpstr-ansi");
  if (e.l += 2, e.read_shift(2) != 57005) throw new Error("Bad FileMoniker");
  var a = e.read_shift(4);
  if (a === 0) return n + r.replace(/\\/g, "/");
  var o = e.read_shift(4);
  if (e.read_shift(2) != 3) throw new Error("Bad FileMoniker");
  var i = e.read_shift(o >> 1, "utf16le").replace(Ya, "");
  return n + i;
}
function oye(e, t) {
  var n = e.read_shift(16);
  switch (n) {
    case "e0c9ea79f9bace118c8200aa004ba90b":
      return rye(e);
    case "0303000000000000c000000000000046":
      return aye(e);
    default:
      throw new Error("Unsupported Moniker " + n);
  }
}
function hv(e) {
  var t = e.read_shift(4), n = t > 0 ? e.read_shift(t, "utf16le").replace(Ya, "") : "";
  return n;
}
function wO(e, t) {
  t || (t = We(6 + e.length * 2)), t.write_shift(4, 1 + e.length);
  for (var n = 0; n < e.length; ++n) t.write_shift(2, e.charCodeAt(n));
  return t.write_shift(2, 0), t;
}
function iye(e, t) {
  var n = e.l + t, r = e.read_shift(4);
  if (r !== 2) throw new Error("Unrecognized streamVersion: " + r);
  var a = e.read_shift(2);
  e.l += 2;
  var o, i, s, l, u = "", c, f;
  a & 16 && (o = hv(e, n - e.l)), a & 128 && (i = hv(e, n - e.l)), (a & 257) === 257 && (s = hv(e, n - e.l)), (a & 257) === 1 && (l = oye(e, n - e.l)), a & 8 && (u = hv(e, n - e.l)), a & 32 && (c = e.read_shift(16)), a & 64 && (f = rE(
    e
    /*, 8*/
  )), e.l = n;
  var d = i || s || l || "";
  d && u && (d += "#" + u), d || (d = "#" + u), a & 2 && d.charAt(0) == "/" && d.charAt(1) != "/" && (d = "file://" + d);
  var p = { Target: d };
  return c && (p.guid = c), f && (p.time = f), o && (p.Tooltip = o), p;
}
function sye(e) {
  var t = We(512), n = 0, r = e.Target;
  r.slice(0, 7) == "file://" && (r = r.slice(7));
  var a = r.indexOf("#"), o = a > -1 ? 31 : 23;
  switch (r.charAt(0)) {
    case "#":
      o = 28;
      break;
    case ".":
      o &= -3;
      break;
  }
  t.write_shift(4, 2), t.write_shift(4, o);
  var i = [8, 6815827, 6619237, 4849780, 83];
  for (n = 0; n < i.length; ++n) t.write_shift(4, i[n]);
  if (o == 28)
    r = r.slice(1), wO(r, t);
  else if (o & 2) {
    for (i = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "), n = 0; n < i.length; ++n) t.write_shift(1, parseInt(i[n], 16));
    var s = a > -1 ? r.slice(0, a) : r;
    for (t.write_shift(4, 2 * (s.length + 1)), n = 0; n < s.length; ++n) t.write_shift(2, s.charCodeAt(n));
    t.write_shift(2, 0), o & 8 && wO(a > -1 ? r.slice(a + 1) : "", t);
  } else {
    for (i = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" "), n = 0; n < i.length; ++n) t.write_shift(1, parseInt(i[n], 16));
    for (var l = 0; r.slice(l * 3, l * 3 + 3) == "../" || r.slice(l * 3, l * 3 + 3) == "..\\"; ) ++l;
    for (t.write_shift(2, l), t.write_shift(4, r.length - 3 * l + 1), n = 0; n < r.length - 3 * l; ++n) t.write_shift(1, r.charCodeAt(n + 3 * l) & 255);
    for (t.write_shift(1, 0), t.write_shift(2, 65535), t.write_shift(2, 57005), n = 0; n < 6; ++n) t.write_shift(4, 0);
  }
  return t.slice(0, t.l);
}
function GR(e) {
  var t = e.read_shift(1), n = e.read_shift(1), r = e.read_shift(1), a = e.read_shift(1);
  return [t, n, r, a];
}
function KR(e, t) {
  var n = GR(e);
  return n[3] = 0, n;
}
function Ts(e) {
  var t = e.read_shift(2), n = e.read_shift(2), r = e.read_shift(2);
  return { r: t, c: n, ixfe: r };
}
function xc(e, t, n, r) {
  return r || (r = We(6)), r.write_shift(2, e), r.write_shift(2, t), r.write_shift(2, n || 0), r;
}
function lye(e) {
  var t = e.read_shift(2), n = e.read_shift(2);
  return e.l += 8, { type: t, flags: n };
}
function uye(e, t, n) {
  return t === 0 ? "" : Vc(e, t, n);
}
function cye(e, t, n) {
  var r = n.biff > 8 ? 4 : 2, a = e.read_shift(r), o = e.read_shift(r, "i"), i = e.read_shift(r, "i");
  return [a, o, i];
}
function YR(e) {
  var t = e.read_shift(2), n = eE(e);
  return [t, n];
}
function fye(e, t, n) {
  e.l += 4, t -= 4;
  var r = e.l + t, a = ch(e, t, n), o = e.read_shift(2);
  if (r -= e.l, o !== r) throw new Error("Malformed AddinUdf: padding = " + r + " != " + o);
  return e.l += o, a;
}
function z1(e) {
  var t = e.read_shift(2), n = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(2);
  return { s: { c: r, r: t }, e: { c: a, r: n } };
}
function qR(e, t) {
  return t || (t = We(8)), t.write_shift(2, e.s.r), t.write_shift(2, e.e.r), t.write_shift(2, e.s.c), t.write_shift(2, e.e.c), t;
}
function XR(e) {
  var t = e.read_shift(2), n = e.read_shift(2), r = e.read_shift(1), a = e.read_shift(1);
  return { s: { c: r, r: t }, e: { c: a, r: n } };
}
var dye = XR;
function ZR(e) {
  e.l += 4;
  var t = e.read_shift(2), n = e.read_shift(2), r = e.read_shift(2);
  return e.l += 12, [n, t, r];
}
function pye(e) {
  var t = {};
  return e.l += 4, e.l += 16, t.fSharedNote = e.read_shift(2), e.l += 4, t;
}
function hye(e) {
  var t = {};
  return e.l += 4, e.cf = e.read_shift(2), t;
}
function ya(e) {
  e.l += 2, e.l += e.read_shift(2);
}
var vye = {
  /*::[*/
  0: ya,
  /* FtEnd */
  /*::[*/
  4: ya,
  /* FtMacro */
  /*::[*/
  5: ya,
  /* FtButton */
  /*::[*/
  6: ya,
  /* FtGmo */
  /*::[*/
  7: hye,
  /* FtCf */
  /*::[*/
  8: ya,
  /* FtPioGrbit */
  /*::[*/
  9: ya,
  /* FtPictFmla */
  /*::[*/
  10: ya,
  /* FtCbls */
  /*::[*/
  11: ya,
  /* FtRbo */
  /*::[*/
  12: ya,
  /* FtSbs */
  /*::[*/
  13: pye,
  /* FtNts */
  /*::[*/
  14: ya,
  /* FtSbsFmla */
  /*::[*/
  15: ya,
  /* FtGboData */
  /*::[*/
  16: ya,
  /* FtEdoData */
  /*::[*/
  17: ya,
  /* FtRboData */
  /*::[*/
  18: ya,
  /* FtCblsData */
  /*::[*/
  19: ya,
  /* FtLbsData */
  /*::[*/
  20: ya,
  /* FtCblsFmla */
  /*::[*/
  21: ZR
};
function mye(e, t) {
  for (var n = e.l + t, r = []; e.l < n; ) {
    var a = e.read_shift(2);
    e.l -= 2;
    try {
      r.push(vye[a](e, n - e.l));
    } catch {
      return e.l = n, r;
    }
  }
  return e.l != n && (e.l = n), r;
}
function vv(e, t) {
  var n = { BIFFVer: 0, dt: 0 };
  switch (n.BIFFVer = e.read_shift(2), t -= 2, t >= 2 && (n.dt = e.read_shift(2), e.l -= 2), n.BIFFVer) {
    case 1536:
    case 1280:
    case 1024:
    case 768:
    case 512:
    case 2:
    case 7:
      break;
    default:
      if (t > 6) throw new Error("Unexpected BIFF Ver " + n.BIFFVer);
  }
  return e.read_shift(t), n;
}
function aE(e, t, n) {
  var r = 1536, a = 16;
  switch (n.bookType) {
    case "biff8":
      break;
    case "biff5":
      r = 1280, a = 8;
      break;
    case "biff4":
      r = 4, a = 6;
      break;
    case "biff3":
      r = 3, a = 6;
      break;
    case "biff2":
      r = 2, a = 4;
      break;
    case "xla":
      break;
    default:
      throw new Error("unsupported BIFF version");
  }
  var o = We(a);
  return o.write_shift(2, r), o.write_shift(2, t), a > 4 && o.write_shift(2, 29282), a > 6 && o.write_shift(2, 1997), a > 8 && (o.write_shift(2, 49161), o.write_shift(2, 1), o.write_shift(2, 1798), o.write_shift(2, 0)), o;
}
function gye(e, t) {
  return t === 0 || e.read_shift(2), 1200;
}
function yye(e, t, n) {
  if (n.enc)
    return e.l += t, "";
  var r = e.l, a = Vc(e, 0, n);
  return e.read_shift(t + r - e.l), a;
}
function xye(e, t) {
  var n = !t || t.biff == 8, r = We(n ? 112 : 54);
  for (r.write_shift(t.biff == 8 ? 2 : 1, 7), n && r.write_shift(1, 0), r.write_shift(4, 859007059), r.write_shift(4, 5458548 | (n ? 0 : 536870912)); r.l < r.length; ) r.write_shift(1, n ? 0 : 32);
  return r;
}
function bye(e, t, n) {
  var r = n && n.biff == 8 || t == 2 ? e.read_shift(2) : (e.l += t, 0);
  return { fDialog: r & 16, fBelow: r & 64, fRight: r & 128 };
}
function wye(e, t, n) {
  var r = e.read_shift(4), a = e.read_shift(1) & 3, o = e.read_shift(1);
  switch (o) {
    case 0:
      o = "Worksheet";
      break;
    case 1:
      o = "Macrosheet";
      break;
    case 2:
      o = "Chartsheet";
      break;
    case 6:
      o = "VBAModule";
      break;
  }
  var i = ch(e, 0, n);
  return i.length === 0 && (i = "Sheet1"), { pos: r, hs: a, dt: o, name: i };
}
function Sye(e, t) {
  var n = !t || t.biff >= 8 ? 2 : 1, r = We(8 + n * e.name.length);
  r.write_shift(4, e.pos), r.write_shift(1, e.hs || 0), r.write_shift(1, e.dt), r.write_shift(1, e.name.length), t.biff >= 8 && r.write_shift(1, 1), r.write_shift(n * e.name.length, e.name, t.biff < 8 ? "sbcs" : "utf16le");
  var a = r.slice(0, r.l);
  return a.l = r.l, a;
}
function _ye(e, t) {
  for (var n = e.l + t, r = e.read_shift(4), a = e.read_shift(4), o = [], i = 0; i != a && e.l < n; ++i)
    o.push(eye(e));
  return o.Count = r, o.Unique = a, o;
}
function Cye(e, t) {
  var n = We(8);
  n.write_shift(4, e.Count), n.write_shift(4, e.Unique);
  for (var r = [], a = 0; a < e.length; ++a) r[a] = tye(e[a]);
  var o = zr([n].concat(r));
  return o.parts = [n.length].concat(r.map(function(i) {
    return i.length;
  })), o;
}
function Eye(e, t) {
  var n = {};
  return n.dsst = e.read_shift(2), e.l += t - 2, n;
}
function Tye(e) {
  var t = {};
  t.r = e.read_shift(2), t.c = e.read_shift(2), t.cnt = e.read_shift(2) - t.c;
  var n = e.read_shift(2);
  e.l += 4;
  var r = e.read_shift(1);
  return e.l += 3, r & 7 && (t.level = r & 7), r & 32 && (t.hidden = !0), r & 64 && (t.hpt = n / 20), t;
}
function $ye(e) {
  var t = lye(e);
  if (t.type != 2211) throw new Error("Invalid Future Record " + t.type);
  var n = e.read_shift(4);
  return n !== 0;
}
function Oye(e) {
  return e.read_shift(2), e.read_shift(4);
}
function SO(e, t, n) {
  var r = 0;
  n && n.biff == 2 || (r = e.read_shift(2));
  var a = e.read_shift(2);
  n && n.biff == 2 && (r = 1 - (a >> 15), a &= 32767);
  var o = { Unsynced: r & 1, DyZero: (r & 2) >> 1, ExAsc: (r & 4) >> 2, ExDsc: (r & 8) >> 3 };
  return [o, a];
}
function Aye(e) {
  var t = e.read_shift(2), n = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(2), o = e.read_shift(2), i = e.read_shift(2), s = e.read_shift(2), l = e.read_shift(2), u = e.read_shift(2);
  return {
    Pos: [t, n],
    Dim: [r, a],
    Flags: o,
    CurTab: i,
    FirstTab: s,
    Selected: l,
    TabRatio: u
  };
}
function Iye() {
  var e = We(18);
  return e.write_shift(2, 0), e.write_shift(2, 0), e.write_shift(2, 29280), e.write_shift(2, 17600), e.write_shift(2, 56), e.write_shift(2, 0), e.write_shift(2, 0), e.write_shift(2, 1), e.write_shift(2, 500), e;
}
function Pye(e, t, n) {
  if (n && n.biff >= 2 && n.biff < 5) return {};
  var r = e.read_shift(2);
  return { RTL: r & 64 };
}
function Dye(e) {
  var t = We(18), n = 1718;
  return e && e.RTL && (n |= 64), t.write_shift(2, n), t.write_shift(4, 0), t.write_shift(4, 64), t.write_shift(4, 0), t.write_shift(4, 0), t;
}
function kye() {
}
function Mye(e, t, n) {
  var r = {
    dyHeight: e.read_shift(2),
    fl: e.read_shift(2)
  };
  switch (n && n.biff || 8) {
    case 2:
      break;
    case 3:
    case 4:
      e.l += 2;
      break;
    default:
      e.l += 10;
      break;
  }
  return r.name = ch(e, 0, n), r;
}
function Rye(e, t) {
  var n = e.name || "Arial", r = t && t.biff == 5, a = r ? 15 + n.length : 16 + 2 * n.length, o = We(a);
  return o.write_shift(2, (e.sz || 12) * 20), o.write_shift(4, 0), o.write_shift(2, 400), o.write_shift(4, 0), o.write_shift(2, 0), o.write_shift(1, n.length), r || o.write_shift(1, 1), o.write_shift((r ? 1 : 2) * n.length, n, r ? "sbcs" : "utf16le"), o;
}
function Nye(e) {
  var t = Ts(e);
  return t.isst = e.read_shift(4), t;
}
function Fye(e, t, n, r) {
  var a = We(10);
  return xc(e, t, r, a), a.write_shift(4, n), a;
}
function Lye(e, t, n) {
  n.biffguess && n.biff == 2 && (n.biff = 5);
  var r = e.l + t, a = Ts(e);
  n.biff == 2 && e.l++;
  var o = fh(e, r - e.l, n);
  return a.val = o, a;
}
function Bye(e, t, n, r, a) {
  var o = !a || a.biff == 8, i = We(8 + +o + (1 + o) * n.length);
  return xc(e, t, r, i), i.write_shift(2, n.length), o && i.write_shift(1, 1), i.write_shift((1 + o) * n.length, n, o ? "utf16le" : "sbcs"), i;
}
function Hye(e, t, n) {
  var r = e.read_shift(2), a = Vc(e, 0, n);
  return [r, a];
}
function jye(e, t, n, r) {
  var a = n && n.biff == 5;
  r || (r = We(a ? 3 + t.length : 5 + 2 * t.length)), r.write_shift(2, e), r.write_shift(a ? 1 : 2, t.length), a || r.write_shift(1, 1), r.write_shift((a ? 1 : 2) * t.length, t, a ? "sbcs" : "utf16le");
  var o = r.length > r.l ? r.slice(0, r.l) : r;
  return o.l == null && (o.l = o.length), o;
}
var Vye = Vc;
function _O(e, t, n) {
  var r = e.l + t, a = n.biff == 8 || !n.biff ? 4 : 2, o = e.read_shift(a), i = e.read_shift(a), s = e.read_shift(2), l = e.read_shift(2);
  return e.l = r, { s: { r: o, c: s }, e: { r: i, c: l } };
}
function Uye(e, t) {
  var n = t.biff == 8 || !t.biff ? 4 : 2, r = We(2 * n + 6);
  return r.write_shift(n, e.s.r), r.write_shift(n, e.e.r + 1), r.write_shift(2, e.s.c), r.write_shift(2, e.e.c + 1), r.write_shift(2, 0), r;
}
function zye(e) {
  var t = e.read_shift(2), n = e.read_shift(2), r = YR(e);
  return { r: t, c: n, ixfe: r[0], rknum: r[1] };
}
function Wye(e, t) {
  for (var n = e.l + t - 2, r = e.read_shift(2), a = e.read_shift(2), o = []; e.l < n; ) o.push(YR(e));
  if (e.l !== n) throw new Error("MulRK read error");
  var i = e.read_shift(2);
  if (o.length != i - a + 1) throw new Error("MulRK length mismatch");
  return { r, c: a, C: i, rkrec: o };
}
function Gye(e, t) {
  for (var n = e.l + t - 2, r = e.read_shift(2), a = e.read_shift(2), o = []; e.l < n; ) o.push(e.read_shift(2));
  if (e.l !== n) throw new Error("MulBlank read error");
  var i = e.read_shift(2);
  if (o.length != i - a + 1) throw new Error("MulBlank length mismatch");
  return { r, c: a, C: i, ixfe: o };
}
function Kye(e, t, n, r) {
  var a = {}, o = e.read_shift(4), i = e.read_shift(4), s = e.read_shift(4), l = e.read_shift(2);
  return a.patternType = $1e[s >> 26], r.cellStyles && (a.alc = o & 7, a.fWrap = o >> 3 & 1, a.alcV = o >> 4 & 7, a.fJustLast = o >> 7 & 1, a.trot = o >> 8 & 255, a.cIndent = o >> 16 & 15, a.fShrinkToFit = o >> 20 & 1, a.iReadOrder = o >> 22 & 2, a.fAtrNum = o >> 26 & 1, a.fAtrFnt = o >> 27 & 1, a.fAtrAlc = o >> 28 & 1, a.fAtrBdr = o >> 29 & 1, a.fAtrPat = o >> 30 & 1, a.fAtrProt = o >> 31 & 1, a.dgLeft = i & 15, a.dgRight = i >> 4 & 15, a.dgTop = i >> 8 & 15, a.dgBottom = i >> 12 & 15, a.icvLeft = i >> 16 & 127, a.icvRight = i >> 23 & 127, a.grbitDiag = i >> 30 & 3, a.icvTop = s & 127, a.icvBottom = s >> 7 & 127, a.icvDiag = s >> 14 & 127, a.dgDiag = s >> 21 & 15, a.icvFore = l & 127, a.icvBack = l >> 7 & 127, a.fsxButton = l >> 14 & 1), a;
}
function Yye(e, t, n) {
  var r = {};
  return r.ifnt = e.read_shift(2), r.numFmtId = e.read_shift(2), r.flags = e.read_shift(2), r.fStyle = r.flags >> 2 & 1, t -= 6, r.data = Kye(e, t, r.fStyle, n), r;
}
function CO(e, t, n, r) {
  var a = n && n.biff == 5;
  r || (r = We(a ? 16 : 20)), r.write_shift(2, 0), e.style ? (r.write_shift(2, e.numFmtId || 0), r.write_shift(2, 65524)) : (r.write_shift(2, e.numFmtId || 0), r.write_shift(2, t << 4));
  var o = 0;
  return e.numFmtId > 0 && a && (o |= 1024), r.write_shift(4, o), r.write_shift(4, 0), a || r.write_shift(4, 0), r.write_shift(2, 0), r;
}
function qye(e) {
  e.l += 4;
  var t = [e.read_shift(2), e.read_shift(2)];
  if (t[0] !== 0 && t[0]--, t[1] !== 0 && t[1]--, t[0] > 7 || t[1] > 7) throw new Error("Bad Gutters: " + t.join("|"));
  return t;
}
function Xye(e) {
  var t = We(8);
  return t.write_shift(4, 0), t.write_shift(2, 0), t.write_shift(2, 0), t;
}
function EO(e, t, n) {
  var r = Ts(e);
  (n.biff == 2 || t == 9) && ++e.l;
  var a = J1e(e);
  return r.val = a, r.t = a === !0 || a === !1 ? "b" : "e", r;
}
function Zye(e, t, n, r, a, o) {
  var i = We(8);
  return xc(e, t, r, i), zR(n, o, i), i;
}
function Qye(e, t, n) {
  n.biffguess && n.biff == 2 && (n.biff = 5);
  var r = Ts(e), a = $a(e);
  return r.val = a, r;
}
function Jye(e, t, n, r) {
  var a = We(14);
  return xc(e, t, r, a), gc(n, a), a;
}
var TO = uye;
function exe(e, t, n) {
  var r = e.l + t, a = e.read_shift(2), o = e.read_shift(2);
  if (n.sbcch = o, o == 1025 || o == 14849) return [o, a];
  if (o < 1 || o > 255) throw new Error("Unexpected SupBook type: " + o);
  for (var i = yc(e, o), s = []; r > e.l; ) s.push(fh(e));
  return [o, a, i, s];
}
function $O(e, t, n) {
  var r = e.read_shift(2), a, o = {
    fBuiltIn: r & 1,
    fWantAdvise: r >>> 1 & 1,
    fWantPict: r >>> 2 & 1,
    fOle: r >>> 3 & 1,
    fOleLink: r >>> 4 & 1,
    cf: r >>> 5 & 1023,
    fIcon: r >>> 15 & 1
  };
  return n.sbcch === 14849 && (a = fye(e, t - 2, n)), o.body = a || e.read_shift(t - 2), typeof a == "string" && (o.Name = a), o;
}
var txe = [
  "_xlnm.Consolidate_Area",
  "_xlnm.Auto_Open",
  "_xlnm.Auto_Close",
  "_xlnm.Extract",
  "_xlnm.Database",
  "_xlnm.Criteria",
  "_xlnm.Print_Area",
  "_xlnm.Print_Titles",
  "_xlnm.Recorder",
  "_xlnm.Data_Form",
  "_xlnm.Auto_Activate",
  "_xlnm.Auto_Deactivate",
  "_xlnm.Sheet_Title",
  "_xlnm._FilterDatabase"
];
function OO(e, t, n) {
  var r = e.l + t, a = e.read_shift(2), o = e.read_shift(1), i = e.read_shift(1), s = e.read_shift(n && n.biff == 2 ? 1 : 2), l = 0;
  (!n || n.biff >= 5) && (n.biff != 5 && (e.l += 2), l = e.read_shift(2), n.biff == 5 && (e.l += 2), e.l += 4);
  var u = yc(e, i, n);
  a & 32 && (u = txe[u.charCodeAt(0)]);
  var c = r - e.l;
  n && n.biff == 2 && --c;
  var f = r == e.l || s === 0 || !(c > 0) ? [] : mSe(e, c, n, s);
  return {
    chKey: o,
    Name: u,
    itab: l,
    rgce: f
  };
}
function QR(e, t, n) {
  if (n.biff < 8) return nxe(e, t, n);
  for (var r = [], a = e.l + t, o = e.read_shift(n.biff > 8 ? 4 : 2); o-- !== 0; ) r.push(cye(e, n.biff > 8 ? 12 : 6, n));
  if (e.l != a) throw new Error("Bad ExternSheet: " + e.l + " != " + a);
  return r;
}
function nxe(e, t, n) {
  e[e.l + 1] == 3 && e[e.l]++;
  var r = ch(e, t, n);
  return r.charCodeAt(0) == 3 ? r.slice(1) : r;
}
function rxe(e, t, n) {
  if (n.biff < 8) {
    e.l += t;
    return;
  }
  var r = e.read_shift(2), a = e.read_shift(2), o = yc(e, r, n), i = yc(e, a, n);
  return [o, i];
}
function axe(e, t, n) {
  var r = XR(e);
  e.l++;
  var a = e.read_shift(1);
  return t -= 8, [gSe(e, t, n), a, r];
}
function AO(e, t, n) {
  var r = dye(e);
  switch (n.biff) {
    case 2:
      e.l++, t -= 7;
      break;
    case 3:
    case 4:
      e.l += 2, t -= 8;
      break;
    default:
      e.l += 6, t -= 12;
  }
  return [r, hSe(e, t, n)];
}
function oxe(e) {
  var t = e.read_shift(4) !== 0, n = e.read_shift(4) !== 0, r = e.read_shift(4);
  return [t, n, r];
}
function ixe(e, t, n) {
  if (!(n.biff < 8)) {
    var r = e.read_shift(2), a = e.read_shift(2), o = e.read_shift(2), i = e.read_shift(2), s = Vc(e, 0, n);
    return n.biff < 8 && e.read_shift(1), [{ r, c: a }, s, i, o];
  }
}
function sxe(e, t, n) {
  return ixe(e, t, n);
}
function lxe(e, t) {
  for (var n = [], r = e.read_shift(2); r--; ) n.push(z1(e));
  return n;
}
function uxe(e) {
  var t = We(2 + e.length * 8);
  t.write_shift(2, e.length);
  for (var n = 0; n < e.length; ++n) qR(e[n], t);
  return t;
}
function cxe(e, t, n) {
  if (n && n.biff < 8) return dxe(e, t, n);
  var r = ZR(e), a = mye(e, t - 22, r[1]);
  return { cmo: r, ft: a };
}
var fxe = {
  8: function(e, t) {
    var n = e.l + t;
    e.l += 10;
    var r = e.read_shift(2);
    e.l += 4, e.l += 2, e.l += 2, e.l += 2, e.l += 4;
    var a = e.read_shift(1);
    return e.l += a, e.l = n, { fmt: r };
  }
};
function dxe(e, t, n) {
  e.l += 4;
  var r = e.read_shift(2), a = e.read_shift(2), o = e.read_shift(2);
  e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 6, t -= 36;
  var i = [];
  return i.push((fxe[r] || Ma)(e, t, n)), { cmo: [a, r, o], ft: i };
}
function pxe(e, t, n) {
  var r = e.l, a = "";
  try {
    e.l += 4;
    var o = (n.lastobj || { cmo: [0, 0] }).cmo[1], i;
    [0, 5, 7, 11, 12, 14].indexOf(o) == -1 ? e.l += 6 : i = nye(e, 6, n);
    var s = e.read_shift(2);
    e.read_shift(2), Dr(e, 2);
    var l = e.read_shift(2);
    e.l += l;
    for (var u = 1; u < e.lens.length - 1; ++u) {
      if (e.l - r != e.lens[u]) throw new Error("TxO: bad continue record");
      var c = e[e.l], f = yc(e, e.lens[u + 1] - e.lens[u] - 1);
      if (a += f, a.length >= (c ? s : 2 * s)) break;
    }
    if (a.length !== s && a.length !== s * 2)
      throw new Error("cchText: " + s + " != " + a.length);
    return e.l = r + t, { t: a };
  } catch {
    return e.l = r + t, { t: a };
  }
}
function hxe(e, t) {
  var n = z1(e);
  e.l += 16;
  var r = iye(e, t - 24);
  return [n, r];
}
function vxe(e) {
  var t = We(24), n = Nr(e[0]);
  t.write_shift(2, n.r), t.write_shift(2, n.r), t.write_shift(2, n.c), t.write_shift(2, n.c);
  for (var r = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "), a = 0; a < 16; ++a) t.write_shift(1, parseInt(r[a], 16));
  return zr([t, sye(e[1])]);
}
function mxe(e, t) {
  e.read_shift(2);
  var n = z1(e), r = e.read_shift((t - 10) / 2, "dbcs-cont");
  return r = r.replace(Ya, ""), [n, r];
}
function gxe(e) {
  var t = e[1].Tooltip, n = We(10 + 2 * (t.length + 1));
  n.write_shift(2, 2048);
  var r = Nr(e[0]);
  n.write_shift(2, r.r), n.write_shift(2, r.r), n.write_shift(2, r.c), n.write_shift(2, r.c);
  for (var a = 0; a < t.length; ++a) n.write_shift(2, t.charCodeAt(a));
  return n.write_shift(2, 0), n;
}
function yxe(e) {
  var t = [0, 0], n;
  return n = e.read_shift(2), t[0] = pO[n] || n, n = e.read_shift(2), t[1] = pO[n] || n, t;
}
function xxe(e) {
  return e || (e = We(4)), e.write_shift(2, 1), e.write_shift(2, 1), e;
}
function bxe(e) {
  for (var t = e.read_shift(2), n = []; t-- > 0; ) n.push(KR(e));
  return n;
}
function wxe(e) {
  for (var t = e.read_shift(2), n = []; t-- > 0; ) n.push(KR(e));
  return n;
}
function Sxe(e) {
  e.l += 2;
  var t = { cxfs: 0, crc: 0 };
  return t.cxfs = e.read_shift(2), t.crc = e.read_shift(4), t;
}
function JR(e, t, n) {
  if (!n.cellStyles) return Ma(e, t);
  var r = n && n.biff >= 12 ? 4 : 2, a = e.read_shift(r), o = e.read_shift(r), i = e.read_shift(r), s = e.read_shift(r), l = e.read_shift(2);
  r == 2 && (e.l += 2);
  var u = { s: a, e: o, w: i, ixfe: s, flags: l };
  return (n.biff >= 5 || !n.biff) && (u.level = l >> 8 & 7), u;
}
function _xe(e, t) {
  var n = We(12);
  n.write_shift(2, t), n.write_shift(2, t), n.write_shift(2, e.width * 256), n.write_shift(2, 0);
  var r = 0;
  return e.hidden && (r |= 1), n.write_shift(1, r), r = e.level || 0, n.write_shift(1, r), n.write_shift(2, 0), n;
}
function Cxe(e, t) {
  var n = {};
  return t < 32 || (e.l += 16, n.header = $a(e), n.footer = $a(e), e.l += 2), n;
}
function Exe(e, t, n) {
  var r = { area: !1 };
  if (n.biff != 5)
    return e.l += t, r;
  var a = e.read_shift(1);
  return e.l += 3, a & 16 && (r.area = !0), r;
}
function Txe(e) {
  for (var t = We(2 * e), n = 0; n < e; ++n) t.write_shift(2, n + 1);
  return t;
}
var $xe = Ts, Oxe = UR, Axe = fh;
function Ixe(e) {
  var t = e.read_shift(2), n = e.read_shift(2), r = e.read_shift(4), a = { fmt: t, env: n, len: r, data: e.slice(e.l, e.l + r) };
  return e.l += r, a;
}
function Pxe(e, t, n) {
  n.biffguess && n.biff == 5 && (n.biff = 2);
  var r = Ts(e);
  ++e.l;
  var a = Vc(e, t - 7, n);
  return r.t = "str", r.val = a, r;
}
function Dxe(e) {
  var t = Ts(e);
  ++e.l;
  var n = $a(e);
  return t.t = "n", t.val = n, t;
}
function kxe(e, t, n) {
  var r = We(15);
  return vh(r, e, t), r.write_shift(8, n, "f"), r;
}
function Mxe(e) {
  var t = Ts(e);
  ++e.l;
  var n = e.read_shift(2);
  return t.t = "n", t.val = n, t;
}
function Rxe(e, t, n) {
  var r = We(9);
  return vh(r, e, t), r.write_shift(2, n), r;
}
function Nxe(e) {
  var t = e.read_shift(1);
  return t === 0 ? (e.l++, "") : e.read_shift(t, "sbcs-cont");
}
function Fxe(e, t) {
  e.l += 6, e.l += 2, e.l += 1, e.l += 3, e.l += 1, e.l += t - 13;
}
function Lxe(e, t, n) {
  var r = e.l + t, a = Ts(e), o = e.read_shift(2), i = yc(e, o, n);
  return e.l = r, a.t = "str", a.val = i, a;
}
var Bxe = [2, 3, 48, 49, 131, 139, 140, 245], KS = /* @__PURE__ */ function() {
  var e = {
    /* Code Pages Supported by Visual FoxPro */
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /* shapefile DBF extension */
    /*::[*/
    0: 20127,
    /*::[*/
    8: 865,
    /*::[*/
    9: 437,
    /*::[*/
    10: 850,
    /*::[*/
    11: 437,
    /*::[*/
    13: 437,
    /*::[*/
    14: 850,
    /*::[*/
    15: 437,
    /*::[*/
    16: 850,
    /*::[*/
    17: 437,
    /*::[*/
    18: 850,
    /*::[*/
    19: 932,
    /*::[*/
    20: 850,
    /*::[*/
    21: 437,
    /*::[*/
    22: 850,
    /*::[*/
    23: 865,
    /*::[*/
    24: 437,
    /*::[*/
    25: 437,
    /*::[*/
    26: 850,
    /*::[*/
    27: 437,
    /*::[*/
    28: 863,
    /*::[*/
    29: 850,
    /*::[*/
    31: 852,
    /*::[*/
    34: 852,
    /*::[*/
    35: 852,
    /*::[*/
    36: 860,
    /*::[*/
    37: 850,
    /*::[*/
    38: 866,
    /*::[*/
    55: 850,
    /*::[*/
    64: 852,
    /*::[*/
    77: 936,
    /*::[*/
    78: 949,
    /*::[*/
    79: 950,
    /*::[*/
    80: 874,
    /*::[*/
    87: 1252,
    /*::[*/
    88: 1252,
    /*::[*/
    89: 1252,
    /*::[*/
    108: 863,
    /*::[*/
    134: 737,
    /*::[*/
    135: 852,
    /*::[*/
    136: 857,
    /*::[*/
    204: 1257,
    /*::[*/
    255: 16969
  }, t = j1({
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /*::[*/
    0: 20127
  });
  function n(s, l) {
    var u = [], c = ru(1);
    switch (l.type) {
      case "base64":
        c = Po(Fo(s));
        break;
      case "binary":
        c = Po(s);
        break;
      case "buffer":
      case "array":
        c = s;
        break;
    }
    ta(c, 0);
    var f = c.read_shift(1), d = !!(f & 136), p = !1, v = !1;
    switch (f) {
      case 2:
        break;
      case 3:
        break;
      case 48:
        p = !0, d = !0;
        break;
      case 49:
        p = !0, d = !0;
        break;
      case 131:
        break;
      case 139:
        break;
      case 140:
        v = !0;
        break;
      case 245:
        break;
      default:
        throw new Error("DBF Unsupported Version: " + f.toString(16));
    }
    var h = 0, m = 521;
    f == 2 && (h = c.read_shift(2)), c.l += 3, f != 2 && (h = c.read_shift(4)), h > 1048576 && (h = 1e6), f != 2 && (m = c.read_shift(2));
    var y = c.read_shift(2), x = l.codepage || 1252;
    f != 2 && (c.l += 16, c.read_shift(1), c[c.l] !== 0 && (x = e[c[c.l]]), c.l += 1, c.l += 2), v && (c.l += 36);
    for (var g = [], S = {}, w = Math.min(c.length, f == 2 ? 521 : m - 10 - (p ? 264 : 0)), _ = v ? 32 : 11; c.l < w && c[c.l] != 13; )
      switch (S = {}, S.name = kl.utils.decode(x, c.slice(c.l, c.l + _)).replace(/[\u0000\r\n].*$/g, ""), c.l += _, S.type = String.fromCharCode(c.read_shift(1)), f != 2 && !v && (S.offset = c.read_shift(4)), S.len = c.read_shift(1), f == 2 && (S.offset = c.read_shift(2)), S.dec = c.read_shift(1), S.name.length && g.push(S), f != 2 && (c.l += v ? 13 : 14), S.type) {
        case "B":
          (!p || S.len != 8) && l.WTF && console.log("Skipping " + S.name + ":" + S.type);
          break;
        case "G":
        case "P":
          l.WTF && console.log("Skipping " + S.name + ":" + S.type);
          break;
        case "+":
        case "0":
        case "@":
        case "C":
        case "D":
        case "F":
        case "I":
        case "L":
        case "M":
        case "N":
        case "O":
        case "T":
        case "Y":
          break;
        default:
          throw new Error("Unknown Field Type: " + S.type);
      }
    if (c[c.l] !== 13 && (c.l = m - 1), c.read_shift(1) !== 13) throw new Error("DBF Terminator not found " + c.l + " " + c[c.l]);
    c.l = m;
    var b = 0, E = 0;
    for (u[0] = [], E = 0; E != g.length; ++E) u[0][E] = g[E].name;
    for (; h-- > 0; ) {
      if (c[c.l] === 42) {
        c.l += y;
        continue;
      }
      for (++c.l, u[++b] = [], E = 0, E = 0; E != g.length; ++E) {
        var C = c.slice(c.l, c.l + g[E].len);
        c.l += g[E].len, ta(C, 0);
        var T = kl.utils.decode(x, C);
        switch (g[E].type) {
          case "C":
            T.trim().length && (u[b][E] = T.replace(/\s+$/, ""));
            break;
          case "D":
            T.length === 8 ? u[b][E] = new Date(+T.slice(0, 4), +T.slice(4, 6) - 1, +T.slice(6, 8)) : u[b][E] = T;
            break;
          case "F":
            u[b][E] = parseFloat(T.trim());
            break;
          case "+":
          case "I":
            u[b][E] = v ? C.read_shift(-4, "i") ^ 2147483648 : C.read_shift(4, "i");
            break;
          case "L":
            switch (T.trim().toUpperCase()) {
              case "Y":
              case "T":
                u[b][E] = !0;
                break;
              case "N":
              case "F":
                u[b][E] = !1;
                break;
              case "":
              case "?":
                break;
              default:
                throw new Error("DBF Unrecognized L:|" + T + "|");
            }
            break;
          case "M":
            if (!d) throw new Error("DBF Unexpected MEMO for type " + f.toString(16));
            u[b][E] = "##MEMO##" + (v ? parseInt(T.trim(), 10) : C.read_shift(4));
            break;
          case "N":
            T = T.replace(/\u0000/g, "").trim(), T && T != "." && (u[b][E] = +T || 0);
            break;
          case "@":
            u[b][E] = new Date(C.read_shift(-8, "f") - 621356832e5);
            break;
          case "T":
            u[b][E] = new Date((C.read_shift(4) - 2440588) * 864e5 + C.read_shift(4));
            break;
          case "Y":
            u[b][E] = C.read_shift(4, "i") / 1e4 + C.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
            break;
          case "O":
            u[b][E] = -C.read_shift(-8, "f");
            break;
          case "B":
            if (p && g[E].len == 8) {
              u[b][E] = C.read_shift(8, "f");
              break;
            }
          case "G":
          case "P":
            C.l += g[E].len;
            break;
          case "0":
            if (g[E].name === "_NullFlags") break;
          default:
            throw new Error("DBF Unsupported data type " + g[E].type);
        }
      }
    }
    if (f != 2 && c.l < c.length && c[c.l++] != 26) throw new Error("DBF EOF Marker missing " + (c.l - 1) + " of " + c.length + " " + c[c.l - 1].toString(16));
    return l && l.sheetRows && (u = u.slice(0, l.sheetRows)), l.DBF = g, u;
  }
  function r(s, l) {
    var u = l || {};
    u.dateNF || (u.dateNF = "yyyymmdd");
    var c = uh(n(s, u), u);
    return c["!cols"] = u.DBF.map(function(f) {
      return {
        wch: f.len,
        DBF: f
      };
    }), delete u.DBF, c;
  }
  function a(s, l) {
    try {
      return Fc(r(s, l), l);
    } catch (u) {
      if (l && l.WTF) throw u;
    }
    return { SheetNames: [], Sheets: {} };
  }
  var o = { B: 8, C: 250, L: 1, D: 8, "?": 0, "": 0 };
  function i(s, l) {
    var u = l || {};
    if (+u.codepage >= 0 && Fi(+u.codepage), u.type == "string") throw new Error("Cannot write DBF to JS string");
    var c = lo(), f = WN(s, { header: 1, raw: !0, cellDates: !0 }), d = f[0], p = f.slice(1), v = s["!cols"] || [], h = 0, m = 0, y = 0, x = 1;
    for (h = 0; h < d.length; ++h) {
      if (((v[h] || {}).DBF || {}).name) {
        d[h] = v[h].DBF.name, ++y;
        continue;
      }
      if (d[h] != null) {
        if (++y, typeof d[h] == "number" && (d[h] = d[h].toString(10)), typeof d[h] != "string") throw new Error("DBF Invalid column name " + d[h] + " |" + typeof d[h] + "|");
        if (d.indexOf(d[h]) !== h) {
          for (m = 0; m < 1024; ++m)
            if (d.indexOf(d[h] + "_" + m) == -1) {
              d[h] += "_" + m;
              break;
            }
        }
      }
    }
    var g = kn(s["!ref"]), S = [], w = [], _ = [];
    for (h = 0; h <= g.e.c - g.s.c; ++h) {
      var b = "", E = "", C = 0, T = [];
      for (m = 0; m < p.length; ++m)
        p[m][h] != null && T.push(p[m][h]);
      if (T.length == 0 || d[h] == null) {
        S[h] = "?";
        continue;
      }
      for (m = 0; m < T.length; ++m) {
        switch (typeof T[m]) {
          case "number":
            E = "B";
            break;
          case "string":
            E = "C";
            break;
          case "boolean":
            E = "L";
            break;
          case "object":
            E = T[m] instanceof Date ? "D" : "C";
            break;
          default:
            E = "C";
        }
        C = Math.max(C, String(T[m]).length), b = b && b != E ? "C" : E;
      }
      C > 250 && (C = 250), E = ((v[h] || {}).DBF || {}).type, E == "C" && v[h].DBF.len > C && (C = v[h].DBF.len), b == "B" && E == "N" && (b = "N", _[h] = v[h].DBF.dec, C = v[h].DBF.len), w[h] = b == "C" || E == "N" ? C : o[b] || 0, x += w[h], S[h] = b;
    }
    var O = c.next(32);
    for (O.write_shift(4, 318902576), O.write_shift(4, p.length), O.write_shift(2, 296 + 32 * y), O.write_shift(2, x), h = 0; h < 4; ++h) O.write_shift(4, 0);
    for (O.write_shift(4, 0 | (+t[
      /*::String(*/
      VM
      /*::)*/
    ] || 3) << 8), h = 0, m = 0; h < d.length; ++h)
      if (d[h] != null) {
        var I = c.next(32), k = (d[h].slice(-10) + "\0\0\0\0\0\0\0\0\0\0\0").slice(0, 11);
        I.write_shift(1, k, "sbcs"), I.write_shift(1, S[h] == "?" ? "C" : S[h], "sbcs"), I.write_shift(4, m), I.write_shift(1, w[h] || o[S[h]] || 0), I.write_shift(1, _[h] || 0), I.write_shift(1, 2), I.write_shift(4, 0), I.write_shift(1, 0), I.write_shift(4, 0), I.write_shift(4, 0), m += w[h] || o[S[h]] || 0;
      }
    var B = c.next(264);
    for (B.write_shift(4, 13), h = 0; h < 65; ++h) B.write_shift(4, 0);
    for (h = 0; h < p.length; ++h) {
      var P = c.next(x);
      for (P.write_shift(1, 0), m = 0; m < d.length; ++m)
        if (d[m] != null)
          switch (S[m]) {
            case "L":
              P.write_shift(1, p[h][m] == null ? 63 : p[h][m] ? 84 : 70);
              break;
            case "B":
              P.write_shift(8, p[h][m] || 0, "f");
              break;
            case "N":
              var N = "0";
              for (typeof p[h][m] == "number" && (N = p[h][m].toFixed(_[m] || 0)), y = 0; y < w[m] - N.length; ++y) P.write_shift(1, 32);
              P.write_shift(1, N, "sbcs");
              break;
            case "D":
              p[h][m] ? (P.write_shift(4, ("0000" + p[h][m].getFullYear()).slice(-4), "sbcs"), P.write_shift(2, ("00" + (p[h][m].getMonth() + 1)).slice(-2), "sbcs"), P.write_shift(2, ("00" + p[h][m].getDate()).slice(-2), "sbcs")) : P.write_shift(8, "00000000", "sbcs");
              break;
            case "C":
              var M = String(p[h][m] != null ? p[h][m] : "").slice(0, w[m]);
              for (P.write_shift(1, M, "sbcs"), y = 0; y < w[m] - M.length; ++y) P.write_shift(1, 32);
              break;
          }
    }
    return c.next(1).write_shift(1, 26), c.end();
  }
  return {
    to_workbook: a,
    to_sheet: r,
    from_sheet: i
  };
}(), eN = /* @__PURE__ */ function() {
  var e = {
    AA: "À",
    BA: "Á",
    CA: "Â",
    DA: 195,
    HA: "Ä",
    JA: 197,
    AE: "È",
    BE: "É",
    CE: "Ê",
    HE: "Ë",
    AI: "Ì",
    BI: "Í",
    CI: "Î",
    HI: "Ï",
    AO: "Ò",
    BO: "Ó",
    CO: "Ô",
    DO: 213,
    HO: "Ö",
    AU: "Ù",
    BU: "Ú",
    CU: "Û",
    HU: "Ü",
    Aa: "à",
    Ba: "á",
    Ca: "â",
    Da: 227,
    Ha: "ä",
    Ja: 229,
    Ae: "è",
    Be: "é",
    Ce: "ê",
    He: "ë",
    Ai: "ì",
    Bi: "í",
    Ci: "î",
    Hi: "ï",
    Ao: "ò",
    Bo: "ó",
    Co: "ô",
    Do: 245,
    Ho: "ö",
    Au: "ù",
    Bu: "ú",
    Cu: "û",
    Hu: "ü",
    KC: "Ç",
    Kc: "ç",
    q: "æ",
    z: "œ",
    a: "Æ",
    j: "Œ",
    DN: 209,
    Dn: 241,
    Hy: 255,
    S: 169,
    c: 170,
    R: 174,
    "B ": 180,
    /*::[*/
    0: 176,
    /*::[*/
    1: 177,
    /*::[*/
    2: 178,
    /*::[*/
    3: 179,
    /*::[*/
    5: 181,
    /*::[*/
    6: 182,
    /*::[*/
    7: 183,
    Q: 185,
    k: 186,
    b: 208,
    i: 216,
    l: 222,
    s: 240,
    y: 248,
    "!": 161,
    '"': 162,
    "#": 163,
    "(": 164,
    "%": 165,
    "'": 167,
    "H ": 168,
    "+": 171,
    ";": 187,
    "<": 188,
    "=": 189,
    ">": 190,
    "?": 191,
    "{": 223
  }, t = new RegExp("\x1BN(" + Er(e).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm"), n = function(d, p) {
    var v = e[p];
    return typeof v == "number" ? H6(v) : v;
  }, r = function(d, p, v) {
    var h = p.charCodeAt(0) - 32 << 4 | v.charCodeAt(0) - 48;
    return h == 59 ? d : H6(h);
  };
  e["|"] = 254;
  function a(d, p) {
    switch (p.type) {
      case "base64":
        return o(Fo(d), p);
      case "binary":
        return o(d, p);
      case "buffer":
        return o(on && Buffer.isBuffer(d) ? d.toString("binary") : vu(d), p);
      case "array":
        return o(mc(d), p);
    }
    throw new Error("Unrecognized type " + p.type);
  }
  function o(d, p) {
    var v = d.split(/[\n\r]+/), h = -1, m = -1, y = 0, x = 0, g = [], S = [], w = null, _ = {}, b = [], E = [], C = [], T = 0, O;
    for (+p.codepage >= 0 && Fi(+p.codepage); y !== v.length; ++y) {
      T = 0;
      var I = v[y].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, r).replace(t, n), k = I.replace(/;;/g, "\0").split(";").map(function(q) {
        return q.replace(/\u0000/g, ";");
      }), B = k[0], P;
      if (I.length > 0) switch (B) {
        case "ID":
          break;
        case "E":
          break;
        case "B":
          break;
        case "O":
          break;
        case "W":
          break;
        case "P":
          k[1].charAt(0) == "P" && S.push(I.slice(3).replace(/;;/g, ";"));
          break;
        case "C":
          var N = !1, M = !1, H = !1, R = !1, z = -1, W = -1;
          for (x = 1; x < k.length; ++x) switch (k[x].charAt(0)) {
            case "A":
              break;
            case "X":
              m = parseInt(k[x].slice(1)) - 1, M = !0;
              break;
            case "Y":
              for (h = parseInt(k[x].slice(1)) - 1, M || (m = 0), O = g.length; O <= h; ++O) g[O] = [];
              break;
            case "K":
              P = k[x].slice(1), P.charAt(0) === '"' ? P = P.slice(1, P.length - 1) : P === "TRUE" ? P = !0 : P === "FALSE" ? P = !1 : isNaN(Xs(P)) ? isNaN(gp(P).getDate()) || (P = nr(P)) : (P = Xs(P), w !== null && Ad(w) && (P = U1(P))), N = !0;
              break;
            case "E":
              R = !0;
              var F = Df(k[x].slice(1), { r: h, c: m });
              g[h][m] = [g[h][m], F];
              break;
            case "S":
              H = !0, g[h][m] = [g[h][m], "S5S"];
              break;
            case "G":
              break;
            case "R":
              z = parseInt(k[x].slice(1)) - 1;
              break;
            case "C":
              W = parseInt(k[x].slice(1)) - 1;
              break;
            default:
              if (p && p.WTF) throw new Error("SYLK bad record " + I);
          }
          if (N && (g[h][m] && g[h][m].length == 2 ? g[h][m][0] = P : g[h][m] = P, w = null), H) {
            if (R) throw new Error("SYLK shared formula cannot have own formula");
            var Y = z > -1 && g[z][W];
            if (!Y || !Y[1]) throw new Error("SYLK shared formula cannot find base");
            g[h][m][1] = yN(Y[1], { r: h - z, c: m - W });
          }
          break;
        case "F":
          var X = 0;
          for (x = 1; x < k.length; ++x) switch (k[x].charAt(0)) {
            case "X":
              m = parseInt(k[x].slice(1)) - 1, ++X;
              break;
            case "Y":
              for (h = parseInt(k[x].slice(1)) - 1, O = g.length; O <= h; ++O) g[O] = [];
              break;
            case "M":
              T = parseInt(k[x].slice(1)) / 20;
              break;
            case "F":
              break;
            case "G":
              break;
            case "P":
              w = S[parseInt(k[x].slice(1))];
              break;
            case "S":
              break;
            case "D":
              break;
            case "N":
              break;
            case "W":
              for (C = k[x].slice(1).split(" "), O = parseInt(C[0], 10); O <= parseInt(C[1], 10); ++O)
                T = parseInt(C[2], 10), E[O - 1] = T === 0 ? { hidden: !0 } : { wch: T }, ou(E[O - 1]);
              break;
            case "C":
              m = parseInt(k[x].slice(1)) - 1, E[m] || (E[m] = {});
              break;
            case "R":
              h = parseInt(k[x].slice(1)) - 1, b[h] || (b[h] = {}), T > 0 ? (b[h].hpt = T, b[h].hpx = ld(T)) : T === 0 && (b[h].hidden = !0);
              break;
            default:
              if (p && p.WTF) throw new Error("SYLK bad record " + I);
          }
          X < 1 && (w = null);
          break;
        default:
          if (p && p.WTF) throw new Error("SYLK bad record " + I);
      }
    }
    return b.length > 0 && (_["!rows"] = b), E.length > 0 && (_["!cols"] = E), p && p.sheetRows && (g = g.slice(0, p.sheetRows)), [g, _];
  }
  function i(d, p) {
    var v = a(d, p), h = v[0], m = v[1], y = uh(h, p);
    return Er(m).forEach(function(x) {
      y[x] = m[x];
    }), y;
  }
  function s(d, p) {
    return Fc(i(d, p), p);
  }
  function l(d, p, v, h) {
    var m = "C;Y" + (v + 1) + ";X" + (h + 1) + ";K";
    switch (d.t) {
      case "n":
        m += d.v || 0, d.f && !d.F && (m += ";E" + cE(d.f, { r: v, c: h }));
        break;
      case "b":
        m += d.v ? "TRUE" : "FALSE";
        break;
      case "e":
        m += d.w || d.v;
        break;
      case "d":
        m += '"' + (d.w || d.v) + '"';
        break;
      case "s":
        m += '"' + d.v.replace(/"/g, "").replace(/;/g, ";;") + '"';
        break;
    }
    return m;
  }
  function u(d, p) {
    p.forEach(function(v, h) {
      var m = "F;W" + (h + 1) + " " + (h + 1) + " ";
      v.hidden ? m += "0" : (typeof v.width == "number" && !v.wpx && (v.wpx = _p(v.width)), typeof v.wpx == "number" && !v.wch && (v.wch = Cp(v.wpx)), typeof v.wch == "number" && (m += Math.round(v.wch))), m.charAt(m.length - 1) != " " && d.push(m);
    });
  }
  function c(d, p) {
    p.forEach(function(v, h) {
      var m = "F;";
      v.hidden ? m += "M0;" : v.hpt ? m += "M" + 20 * v.hpt + ";" : v.hpx && (m += "M" + 20 * Ep(v.hpx) + ";"), m.length > 2 && d.push(m + "R" + (h + 1));
    });
  }
  function f(d, p) {
    var v = ["ID;PWXL;N;E"], h = [], m = kn(d["!ref"]), y, x = Array.isArray(d), g = `\r
`;
    v.push("P;PGeneral"), v.push("F;P0;DG0G8;M255"), d["!cols"] && u(v, d["!cols"]), d["!rows"] && c(v, d["!rows"]), v.push("B;Y" + (m.e.r - m.s.r + 1) + ";X" + (m.e.c - m.s.c + 1) + ";D" + [m.s.c, m.s.r, m.e.c, m.e.r].join(" "));
    for (var S = m.s.r; S <= m.e.r; ++S)
      for (var w = m.s.c; w <= m.e.c; ++w) {
        var _ = Kt({ r: S, c: w });
        y = x ? (d[S] || [])[w] : d[_], !(!y || y.v == null && (!y.f || y.F)) && h.push(l(y, d, S, w));
      }
    return v.join(g) + g + h.join(g) + g + "E" + g;
  }
  return {
    to_workbook: s,
    to_sheet: i,
    from_sheet: f
  };
}(), tN = /* @__PURE__ */ function() {
  function e(o, i) {
    switch (i.type) {
      case "base64":
        return t(Fo(o), i);
      case "binary":
        return t(o, i);
      case "buffer":
        return t(on && Buffer.isBuffer(o) ? o.toString("binary") : vu(o), i);
      case "array":
        return t(mc(o), i);
    }
    throw new Error("Unrecognized type " + i.type);
  }
  function t(o, i) {
    for (var s = o.split(`
`), l = -1, u = -1, c = 0, f = []; c !== s.length; ++c) {
      if (s[c].trim() === "BOT") {
        f[++l] = [], u = 0;
        continue;
      }
      if (!(l < 0)) {
        var d = s[c].trim().split(","), p = d[0], v = d[1];
        ++c;
        for (var h = s[c] || ""; (h.match(/["]/g) || []).length & 1 && c < s.length - 1; ) h += `
` + s[++c];
        switch (h = h.trim(), +p) {
          case -1:
            if (h === "BOT") {
              f[++l] = [], u = 0;
              continue;
            } else if (h !== "EOD") throw new Error("Unrecognized DIF special command " + h);
            break;
          case 0:
            h === "TRUE" ? f[l][u] = !0 : h === "FALSE" ? f[l][u] = !1 : isNaN(Xs(v)) ? isNaN(gp(v).getDate()) ? f[l][u] = v : f[l][u] = nr(v) : f[l][u] = Xs(v), ++u;
            break;
          case 1:
            h = h.slice(1, h.length - 1), h = h.replace(/""/g, '"'), h && h.match(/^=".*"$/) && (h = h.slice(2, -1)), f[l][u++] = h !== "" ? h : null;
            break;
        }
        if (h === "EOD") break;
      }
    }
    return i && i.sheetRows && (f = f.slice(0, i.sheetRows)), f;
  }
  function n(o, i) {
    return uh(e(o, i), i);
  }
  function r(o, i) {
    return Fc(n(o, i), i);
  }
  var a = /* @__PURE__ */ function() {
    var o = function(l, u, c, f, d) {
      l.push(u), l.push(c + "," + f), l.push('"' + d.replace(/"/g, '""') + '"');
    }, i = function(l, u, c, f) {
      l.push(u + "," + c), l.push(u == 1 ? '"' + f.replace(/"/g, '""') + '"' : f);
    };
    return function(l) {
      var u = [], c = kn(l["!ref"]), f, d = Array.isArray(l);
      o(u, "TABLE", 0, 1, "sheetjs"), o(u, "VECTORS", 0, c.e.r - c.s.r + 1, ""), o(u, "TUPLES", 0, c.e.c - c.s.c + 1, ""), o(u, "DATA", 0, 0, "");
      for (var p = c.s.r; p <= c.e.r; ++p) {
        i(u, -1, 0, "BOT");
        for (var v = c.s.c; v <= c.e.c; ++v) {
          var h = Kt({ r: p, c: v });
          if (f = d ? (l[p] || [])[v] : l[h], !f) {
            i(u, 1, 0, "");
            continue;
          }
          switch (f.t) {
            case "n":
              var m = f.w;
              !m && f.v != null && (m = f.v), m == null ? f.f && !f.F ? i(u, 1, 0, "=" + f.f) : i(u, 1, 0, "") : i(u, 0, m, "V");
              break;
            case "b":
              i(u, 0, f.v ? 1 : 0, f.v ? "TRUE" : "FALSE");
              break;
            case "s":
              i(u, 1, 0, isNaN(f.v) ? f.v : '="' + f.v + '"');
              break;
            case "d":
              f.w || (f.w = pi(f.z || jt[14], pa(nr(f.v)))), i(u, 0, f.w, "V");
              break;
            default:
              i(u, 1, 0, "");
          }
        }
      }
      i(u, -1, 0, "EOD");
      var y = `\r
`, x = u.join(y);
      return x;
    };
  }();
  return {
    to_workbook: r,
    to_sheet: n,
    from_sheet: a
  };
}(), nN = /* @__PURE__ */ function() {
  function e(f) {
    return f.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, `
`);
  }
  function t(f) {
    return f.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
  }
  function n(f, d) {
    for (var p = f.split(`
`), v = -1, h = -1, m = 0, y = []; m !== p.length; ++m) {
      var x = p[m].trim().split(":");
      if (x[0] === "cell") {
        var g = Nr(x[1]);
        if (y.length <= g.r) for (v = y.length; v <= g.r; ++v) y[v] || (y[v] = []);
        switch (v = g.r, h = g.c, x[2]) {
          case "t":
            y[v][h] = e(x[3]);
            break;
          case "v":
            y[v][h] = +x[3];
            break;
          case "vtf":
            var S = x[x.length - 1];
          case "vtc":
            switch (x[3]) {
              case "nl":
                y[v][h] = !!+x[4];
                break;
              default:
                y[v][h] = +x[4];
                break;
            }
            x[2] == "vtf" && (y[v][h] = [y[v][h], S]);
        }
      }
    }
    return d && d.sheetRows && (y = y.slice(0, d.sheetRows)), y;
  }
  function r(f, d) {
    return uh(n(f, d), d);
  }
  function a(f, d) {
    return Fc(r(f, d), d);
  }
  var o = [
    "socialcalc:version:1.5",
    "MIME-Version: 1.0",
    "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
  ].join(`
`), i = [
    "--SocialCalcSpreadsheetControlSave",
    "Content-type: text/plain; charset=UTF-8"
  ].join(`
`) + `
`, s = [
    "# SocialCalc Spreadsheet Control Save",
    "part:sheet"
  ].join(`
`), l = "--SocialCalcSpreadsheetControlSave--";
  function u(f) {
    if (!f || !f["!ref"]) return "";
    for (var d = [], p = [], v, h = "", m = hi(f["!ref"]), y = Array.isArray(f), x = m.s.r; x <= m.e.r; ++x)
      for (var g = m.s.c; g <= m.e.c; ++g)
        if (h = Kt({ r: x, c: g }), v = y ? (f[x] || [])[g] : f[h], !(!v || v.v == null || v.t === "z")) {
          switch (p = ["cell", h, "t"], v.t) {
            case "s":
            case "str":
              p.push(t(v.v));
              break;
            case "n":
              v.f ? (p[2] = "vtf", p[3] = "n", p[4] = v.v, p[5] = t(v.f)) : (p[2] = "v", p[3] = v.v);
              break;
            case "b":
              p[2] = "vt" + (v.f ? "f" : "c"), p[3] = "nl", p[4] = v.v ? "1" : "0", p[5] = t(v.f || (v.v ? "TRUE" : "FALSE"));
              break;
            case "d":
              var S = pa(nr(v.v));
              p[2] = "vtc", p[3] = "nd", p[4] = "" + S, p[5] = v.w || pi(v.z || jt[14], S);
              break;
            case "e":
              continue;
          }
          d.push(p.join(":"));
        }
    return d.push("sheet:c:" + (m.e.c - m.s.c + 1) + ":r:" + (m.e.r - m.s.r + 1) + ":tvf:1"), d.push("valueformat:1:text-wiki"), d.join(`
`);
  }
  function c(f) {
    return [o, i, s, i, u(f), l].join(`
`);
  }
  return {
    to_workbook: a,
    to_sheet: r,
    from_sheet: c
  };
}(), sd = /* @__PURE__ */ function() {
  function e(c, f, d, p, v) {
    v.raw ? f[d][p] = c : c === "" || (c === "TRUE" ? f[d][p] = !0 : c === "FALSE" ? f[d][p] = !1 : isNaN(Xs(c)) ? isNaN(gp(c).getDate()) ? f[d][p] = c : f[d][p] = nr(c) : f[d][p] = Xs(c));
  }
  function t(c, f) {
    var d = f || {}, p = [];
    if (!c || c.length === 0) return p;
    for (var v = c.split(/[\r\n]/), h = v.length - 1; h >= 0 && v[h].length === 0; ) --h;
    for (var m = 10, y = 0, x = 0; x <= h; ++x)
      y = v[x].indexOf(" "), y == -1 ? y = v[x].length : y++, m = Math.max(m, y);
    for (x = 0; x <= h; ++x) {
      p[x] = [];
      var g = 0;
      for (e(v[x].slice(0, m).trim(), p, x, g, d), g = 1; g <= (v[x].length - m) / 10 + 1; ++g)
        e(v[x].slice(m + (g - 1) * 10, m + g * 10).trim(), p, x, g, d);
    }
    return d.sheetRows && (p = p.slice(0, d.sheetRows)), p;
  }
  var n = {
    /*::[*/
    44: ",",
    /*::[*/
    9: "	",
    /*::[*/
    59: ";",
    /*::[*/
    124: "|"
  }, r = {
    /*::[*/
    44: 3,
    /*::[*/
    9: 2,
    /*::[*/
    59: 1,
    /*::[*/
    124: 0
  };
  function a(c) {
    for (var f = {}, d = !1, p = 0, v = 0; p < c.length; ++p)
      (v = c.charCodeAt(p)) == 34 ? d = !d : !d && v in n && (f[v] = (f[v] || 0) + 1);
    v = [];
    for (p in f) Object.prototype.hasOwnProperty.call(f, p) && v.push([f[p], p]);
    if (!v.length) {
      f = r;
      for (p in f) Object.prototype.hasOwnProperty.call(f, p) && v.push([f[p], p]);
    }
    return v.sort(function(h, m) {
      return h[0] - m[0] || r[h[1]] - r[m[1]];
    }), n[v.pop()[1]] || 44;
  }
  function o(c, f) {
    var d = f || {}, p = "", v = d.dense ? [] : {}, h = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    c.slice(0, 4) == "sep=" ? c.charCodeAt(5) == 13 && c.charCodeAt(6) == 10 ? (p = c.charAt(4), c = c.slice(7)) : c.charCodeAt(5) == 13 || c.charCodeAt(5) == 10 ? (p = c.charAt(4), c = c.slice(6)) : p = a(c.slice(0, 1024)) : d && d.FS ? p = d.FS : p = a(c.slice(0, 1024));
    var m = 0, y = 0, x = 0, g = 0, S = 0, w = p.charCodeAt(0), _ = !1, b = 0, E = c.charCodeAt(0);
    c = c.replace(/\r\n/mg, `
`);
    var C = d.dateNF != null ? Cge(d.dateNF) : null;
    function T() {
      var O = c.slice(g, S), I = {};
      if (O.charAt(0) == '"' && O.charAt(O.length - 1) == '"' && (O = O.slice(1, -1).replace(/""/g, '"')), O.length === 0) I.t = "z";
      else if (d.raw)
        I.t = "s", I.v = O;
      else if (O.trim().length === 0)
        I.t = "s", I.v = O;
      else if (O.charCodeAt(0) == 61)
        O.charCodeAt(1) == 34 && O.charCodeAt(O.length - 1) == 34 ? (I.t = "s", I.v = O.slice(2, -1).replace(/""/g, '"')) : ewe(O) ? (I.t = "n", I.f = O.slice(1)) : (I.t = "s", I.v = O);
      else if (O == "TRUE")
        I.t = "b", I.v = !0;
      else if (O == "FALSE")
        I.t = "b", I.v = !1;
      else if (!isNaN(x = Xs(O)))
        I.t = "n", d.cellText !== !1 && (I.w = O), I.v = x;
      else if (!isNaN(gp(O).getDate()) || C && O.match(C)) {
        I.z = d.dateNF || jt[14];
        var k = 0;
        C && O.match(C) && (O = Ege(O, d.dateNF, O.match(C) || []), k = 1), d.cellDates ? (I.t = "d", I.v = nr(O, k)) : (I.t = "n", I.v = pa(nr(O, k))), d.cellText !== !1 && (I.w = pi(I.z, I.v instanceof Date ? pa(I.v) : I.v)), d.cellNF || delete I.z;
      } else
        I.t = "s", I.v = O;
      if (I.t == "z" || (d.dense ? (v[m] || (v[m] = []), v[m][y] = I) : v[Kt({ c: y, r: m })] = I), g = S + 1, E = c.charCodeAt(g), h.e.c < y && (h.e.c = y), h.e.r < m && (h.e.r = m), b == w) ++y;
      else if (y = 0, ++m, d.sheetRows && d.sheetRows <= m) return !0;
    }
    e: for (; S < c.length; ++S) switch (b = c.charCodeAt(S)) {
      case 34:
        E === 34 && (_ = !_);
        break;
      case w:
      case 10:
      case 13:
        if (!_ && T()) break e;
        break;
    }
    return S - g > 0 && T(), v["!ref"] = vn(h), v;
  }
  function i(c, f) {
    return !(f && f.PRN) || f.FS || c.slice(0, 4) == "sep=" || c.indexOf("	") >= 0 || c.indexOf(",") >= 0 || c.indexOf(";") >= 0 ? o(c, f) : uh(t(c, f), f);
  }
  function s(c, f) {
    var d = "", p = f.type == "string" ? [0, 0, 0, 0] : yE(c, f);
    switch (f.type) {
      case "base64":
        d = Fo(c);
        break;
      case "binary":
        d = c;
        break;
      case "buffer":
        f.codepage == 65001 ? d = c.toString("utf8") : f.codepage && typeof kl < "u" ? d = kl.utils.decode(f.codepage, c) : d = on && Buffer.isBuffer(c) ? c.toString("binary") : vu(c);
        break;
      case "array":
        d = mc(c);
        break;
      case "string":
        d = c;
        break;
      default:
        throw new Error("Unrecognized type " + f.type);
    }
    return p[0] == 239 && p[1] == 187 && p[2] == 191 ? d = Hn(d.slice(3)) : f.type != "string" && f.type != "buffer" && f.codepage == 65001 ? d = Hn(d) : f.type == "binary" && typeof kl < "u" && f.codepage && (d = kl.utils.decode(f.codepage, kl.utils.encode(28591, d))), d.slice(0, 19) == "socialcalc:version:" ? nN.to_sheet(f.type == "string" ? d : Hn(d), f) : i(d, f);
  }
  function l(c, f) {
    return Fc(s(c, f), f);
  }
  function u(c) {
    for (var f = [], d = kn(c["!ref"]), p, v = Array.isArray(c), h = d.s.r; h <= d.e.r; ++h) {
      for (var m = [], y = d.s.c; y <= d.e.c; ++y) {
        var x = Kt({ r: h, c: y });
        if (p = v ? (c[h] || [])[y] : c[x], !p || p.v == null) {
          m.push("          ");
          continue;
        }
        for (var g = (p.w || (au(p), p.w) || "").slice(0, 10); g.length < 10; ) g += " ";
        m.push(g + (y === 0 ? " " : ""));
      }
      f.push(m.join(""));
    }
    return f.join(`
`);
  }
  return {
    to_workbook: l,
    to_sheet: s,
    from_sheet: u
  };
}();
function Hxe(e, t) {
  var n = t || {}, r = !!n.WTF;
  n.WTF = !0;
  try {
    var a = eN.to_workbook(e, n);
    return n.WTF = r, a;
  } catch (o) {
    if (n.WTF = r, !o.message.match(/SYLK bad record ID/) && r) throw o;
    return sd.to_workbook(e, t);
  }
}
var nc = /* @__PURE__ */ function() {
  function e(F, Y, X) {
    if (F) {
      ta(F, F.l || 0);
      for (var q = X.Enum || z; F.l < F.length; ) {
        var Q = F.read_shift(2), ue = q[Q] || q[65535], le = F.read_shift(2), te = F.l + le, G = ue.f && ue.f(F, le, X);
        if (F.l = te, Y(G, ue, Q)) return;
      }
    }
  }
  function t(F, Y) {
    switch (Y.type) {
      case "base64":
        return n(Po(Fo(F)), Y);
      case "binary":
        return n(Po(F), Y);
      case "buffer":
      case "array":
        return n(F, Y);
    }
    throw "Unsupported type " + Y.type;
  }
  function n(F, Y) {
    if (!F) return F;
    var X = Y || {}, q = X.dense ? [] : {}, Q = "Sheet1", ue = "", le = 0, te = {}, G = [], oe = [], L = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, re = X.sheetRows || 0;
    if (F[2] == 0 && (F[3] == 8 || F[3] == 9) && F.length >= 16 && F[14] == 5 && F[15] === 108)
      throw new Error("Unsupported Works 3 for Mac file");
    if (F[2] == 2)
      X.Enum = z, e(F, function(he, K, Z) {
        switch (Z) {
          case 0:
            X.vers = he, he >= 4096 && (X.qpro = !0);
            break;
          case 6:
            L = he;
            break;
          case 204:
            he && (ue = he);
            break;
          case 222:
            ue = he;
            break;
          case 15:
          case 51:
            X.qpro || (he[1].v = he[1].v.slice(1));
          case 13:
          case 14:
          case 16:
            Z == 14 && (he[2] & 112) == 112 && (he[2] & 15) > 1 && (he[2] & 15) < 15 && (he[1].z = X.dateNF || jt[14], X.cellDates && (he[1].t = "d", he[1].v = U1(he[1].v))), X.qpro && he[3] > le && (q["!ref"] = vn(L), te[Q] = q, G.push(Q), q = X.dense ? [] : {}, L = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, le = he[3], Q = ue || "Sheet" + (le + 1), ue = "");
            var se = X.dense ? (q[he[0].r] || [])[he[0].c] : q[Kt(he[0])];
            if (se) {
              se.t = he[1].t, se.v = he[1].v, he[1].z != null && (se.z = he[1].z), he[1].f != null && (se.f = he[1].f);
              break;
            }
            X.dense ? (q[he[0].r] || (q[he[0].r] = []), q[he[0].r][he[0].c] = he[1]) : q[Kt(he[0])] = he[1];
            break;
        }
      }, X);
    else if (F[2] == 26 || F[2] == 14)
      X.Enum = W, F[2] == 14 && (X.qpro = !0, F.l = 0), e(F, function(he, K, Z) {
        switch (Z) {
          case 204:
            Q = he;
            break;
          case 22:
            he[1].v = he[1].v.slice(1);
          case 23:
          case 24:
          case 25:
          case 37:
          case 39:
          case 40:
            if (he[3] > le && (q["!ref"] = vn(L), te[Q] = q, G.push(Q), q = X.dense ? [] : {}, L = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, le = he[3], Q = "Sheet" + (le + 1)), re > 0 && he[0].r >= re) break;
            X.dense ? (q[he[0].r] || (q[he[0].r] = []), q[he[0].r][he[0].c] = he[1]) : q[Kt(he[0])] = he[1], L.e.c < he[0].c && (L.e.c = he[0].c), L.e.r < he[0].r && (L.e.r = he[0].r);
            break;
          case 27:
            he[14e3] && (oe[he[14e3][0]] = he[14e3][1]);
            break;
          case 1537:
            oe[he[0]] = he[1], he[0] == le && (Q = he[1]);
            break;
        }
      }, X);
    else throw new Error("Unrecognized LOTUS BOF " + F[2]);
    if (q["!ref"] = vn(L), te[ue || Q] = q, G.push(ue || Q), !oe.length) return { SheetNames: G, Sheets: te };
    for (var j = {}, J = [], ae = 0; ae < oe.length; ++ae) te[G[ae]] ? (J.push(oe[ae] || G[ae]), j[oe[ae]] = te[oe[ae]] || te[G[ae]]) : (J.push(oe[ae]), j[oe[ae]] = { "!ref": "A1" });
    return { SheetNames: J, Sheets: j };
  }
  function r(F, Y) {
    var X = Y || {};
    if (+X.codepage >= 0 && Fi(+X.codepage), X.type == "string") throw new Error("Cannot write WK1 to JS string");
    var q = lo(), Q = kn(F["!ref"]), ue = Array.isArray(F), le = [];
    vt(q, 0, o(1030)), vt(q, 6, l(Q));
    for (var te = Math.min(Q.e.r, 8191), G = Q.s.r; G <= te; ++G)
      for (var oe = Kr(G), L = Q.s.c; L <= Q.e.c; ++L) {
        G === Q.s.r && (le[L] = Mr(L));
        var re = le[L] + oe, j = ue ? (F[G] || [])[L] : F[re];
        if (!(!j || j.t == "z"))
          if (j.t == "n")
            (j.v | 0) == j.v && j.v >= -32768 && j.v <= 32767 ? vt(q, 13, p(G, L, j.v)) : vt(q, 14, h(G, L, j.v));
          else {
            var J = au(j);
            vt(q, 15, f(G, L, J.slice(0, 239)));
          }
      }
    return vt(q, 1), q.end();
  }
  function a(F, Y) {
    var X = Y || {};
    if (+X.codepage >= 0 && Fi(+X.codepage), X.type == "string") throw new Error("Cannot write WK3 to JS string");
    var q = lo();
    vt(q, 0, i(F));
    for (var Q = 0, ue = 0; Q < F.SheetNames.length; ++Q) (F.Sheets[F.SheetNames[Q]] || {})["!ref"] && vt(q, 27, R(F.SheetNames[Q], ue++));
    var le = 0;
    for (Q = 0; Q < F.SheetNames.length; ++Q) {
      var te = F.Sheets[F.SheetNames[Q]];
      if (!(!te || !te["!ref"])) {
        for (var G = kn(te["!ref"]), oe = Array.isArray(te), L = [], re = Math.min(G.e.r, 8191), j = G.s.r; j <= re; ++j)
          for (var J = Kr(j), ae = G.s.c; ae <= G.e.c; ++ae) {
            j === G.s.r && (L[ae] = Mr(ae));
            var he = L[ae] + J, K = oe ? (te[j] || [])[ae] : te[he];
            if (!(!K || K.t == "z"))
              if (K.t == "n")
                vt(q, 23, T(j, ae, le, K.v));
              else {
                var Z = au(K);
                vt(q, 22, b(j, ae, le, Z.slice(0, 239)));
              }
          }
        ++le;
      }
    }
    return vt(q, 1), q.end();
  }
  function o(F) {
    var Y = We(2);
    return Y.write_shift(2, F), Y;
  }
  function i(F) {
    var Y = We(26);
    Y.write_shift(2, 4096), Y.write_shift(2, 4), Y.write_shift(4, 0);
    for (var X = 0, q = 0, Q = 0, ue = 0; ue < F.SheetNames.length; ++ue) {
      var le = F.SheetNames[ue], te = F.Sheets[le];
      if (!(!te || !te["!ref"])) {
        ++Q;
        var G = hi(te["!ref"]);
        X < G.e.r && (X = G.e.r), q < G.e.c && (q = G.e.c);
      }
    }
    return X > 8191 && (X = 8191), Y.write_shift(2, X), Y.write_shift(1, Q), Y.write_shift(1, q), Y.write_shift(2, 0), Y.write_shift(2, 0), Y.write_shift(1, 1), Y.write_shift(1, 2), Y.write_shift(4, 0), Y.write_shift(4, 0), Y;
  }
  function s(F, Y, X) {
    var q = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    return Y == 8 && X.qpro ? (q.s.c = F.read_shift(1), F.l++, q.s.r = F.read_shift(2), q.e.c = F.read_shift(1), F.l++, q.e.r = F.read_shift(2), q) : (q.s.c = F.read_shift(2), q.s.r = F.read_shift(2), Y == 12 && X.qpro && (F.l += 2), q.e.c = F.read_shift(2), q.e.r = F.read_shift(2), Y == 12 && X.qpro && (F.l += 2), q.s.c == 65535 && (q.s.c = q.e.c = q.s.r = q.e.r = 0), q);
  }
  function l(F) {
    var Y = We(8);
    return Y.write_shift(2, F.s.c), Y.write_shift(2, F.s.r), Y.write_shift(2, F.e.c), Y.write_shift(2, F.e.r), Y;
  }
  function u(F, Y, X) {
    var q = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0, 0];
    return X.qpro && X.vers != 20768 ? (q[0].c = F.read_shift(1), q[3] = F.read_shift(1), q[0].r = F.read_shift(2), F.l += 2) : (q[2] = F.read_shift(1), q[0].c = F.read_shift(2), q[0].r = F.read_shift(2)), q;
  }
  function c(F, Y, X) {
    var q = F.l + Y, Q = u(F, Y, X);
    if (Q[1].t = "s", X.vers == 20768) {
      F.l++;
      var ue = F.read_shift(1);
      return Q[1].v = F.read_shift(ue, "utf8"), Q;
    }
    return X.qpro && F.l++, Q[1].v = F.read_shift(q - F.l, "cstr"), Q;
  }
  function f(F, Y, X) {
    var q = We(7 + X.length);
    q.write_shift(1, 255), q.write_shift(2, Y), q.write_shift(2, F), q.write_shift(1, 39);
    for (var Q = 0; Q < q.length; ++Q) {
      var ue = X.charCodeAt(Q);
      q.write_shift(1, ue >= 128 ? 95 : ue);
    }
    return q.write_shift(1, 0), q;
  }
  function d(F, Y, X) {
    var q = u(F, Y, X);
    return q[1].v = F.read_shift(2, "i"), q;
  }
  function p(F, Y, X) {
    var q = We(7);
    return q.write_shift(1, 255), q.write_shift(2, Y), q.write_shift(2, F), q.write_shift(2, X, "i"), q;
  }
  function v(F, Y, X) {
    var q = u(F, Y, X);
    return q[1].v = F.read_shift(8, "f"), q;
  }
  function h(F, Y, X) {
    var q = We(13);
    return q.write_shift(1, 255), q.write_shift(2, Y), q.write_shift(2, F), q.write_shift(8, X, "f"), q;
  }
  function m(F, Y, X) {
    var q = F.l + Y, Q = u(F, Y, X);
    if (Q[1].v = F.read_shift(8, "f"), X.qpro) F.l = q;
    else {
      var ue = F.read_shift(2);
      S(F.slice(F.l, F.l + ue), Q), F.l += ue;
    }
    return Q;
  }
  function y(F, Y, X) {
    var q = Y & 32768;
    return Y &= -32769, Y = (q ? F : 0) + (Y >= 8192 ? Y - 16384 : Y), (q ? "" : "$") + (X ? Mr(Y) : Kr(Y));
  }
  var x = {
    51: ["FALSE", 0],
    52: ["TRUE", 0],
    70: ["LEN", 1],
    80: ["SUM", 69],
    81: ["AVERAGEA", 69],
    82: ["COUNTA", 69],
    83: ["MINA", 69],
    84: ["MAXA", 69],
    111: ["T", 1]
  }, g = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "",
    "+",
    "-",
    "*",
    "/",
    "^",
    "=",
    "<>",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "<=",
    ">=",
    "<",
    ">",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "&",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
    // eslint-disable-line no-mixed-spaces-and-tabs
  ];
  function S(F, Y) {
    ta(F, 0);
    for (var X = [], q = 0, Q = "", ue = "", le = "", te = ""; F.l < F.length; ) {
      var G = F[F.l++];
      switch (G) {
        case 0:
          X.push(F.read_shift(8, "f"));
          break;
        case 1:
          ue = y(Y[0].c, F.read_shift(2), !0), Q = y(Y[0].r, F.read_shift(2), !1), X.push(ue + Q);
          break;
        case 2:
          {
            var oe = y(Y[0].c, F.read_shift(2), !0), L = y(Y[0].r, F.read_shift(2), !1);
            ue = y(Y[0].c, F.read_shift(2), !0), Q = y(Y[0].r, F.read_shift(2), !1), X.push(oe + L + ":" + ue + Q);
          }
          break;
        case 3:
          if (F.l < F.length) {
            console.error("WK1 premature formula end");
            return;
          }
          break;
        case 4:
          X.push("(" + X.pop() + ")");
          break;
        case 5:
          X.push(F.read_shift(2));
          break;
        case 6:
          {
            for (var re = ""; G = F[F.l++]; ) re += String.fromCharCode(G);
            X.push('"' + re.replace(/"/g, '""') + '"');
          }
          break;
        case 8:
          X.push("-" + X.pop());
          break;
        case 23:
          X.push("+" + X.pop());
          break;
        case 22:
          X.push("NOT(" + X.pop() + ")");
          break;
        case 20:
        case 21:
          te = X.pop(), le = X.pop(), X.push(["AND", "OR"][G - 20] + "(" + le + "," + te + ")");
          break;
        default:
          if (G < 32 && g[G])
            te = X.pop(), le = X.pop(), X.push(le + g[G] + te);
          else if (x[G]) {
            if (q = x[G][1], q == 69 && (q = F[F.l++]), q > X.length) {
              console.error("WK1 bad formula parse 0x" + G.toString(16) + ":|" + X.join("|") + "|");
              return;
            }
            var j = X.slice(-q);
            X.length -= q, X.push(x[G][0] + "(" + j.join(",") + ")");
          } else return G <= 7 ? console.error("WK1 invalid opcode " + G.toString(16)) : G <= 24 ? console.error("WK1 unsupported op " + G.toString(16)) : G <= 30 ? console.error("WK1 invalid opcode " + G.toString(16)) : G <= 115 ? console.error("WK1 unsupported function opcode " + G.toString(16)) : console.error("WK1 unrecognized opcode " + G.toString(16));
      }
    }
    X.length == 1 ? Y[1].f = "" + X[0] : console.error("WK1 bad formula parse |" + X.join("|") + "|");
  }
  function w(F) {
    var Y = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0];
    return Y[0].r = F.read_shift(2), Y[3] = F[F.l++], Y[0].c = F[F.l++], Y;
  }
  function _(F, Y) {
    var X = w(F);
    return X[1].t = "s", X[1].v = F.read_shift(Y - 4, "cstr"), X;
  }
  function b(F, Y, X, q) {
    var Q = We(6 + q.length);
    Q.write_shift(2, F), Q.write_shift(1, X), Q.write_shift(1, Y), Q.write_shift(1, 39);
    for (var ue = 0; ue < q.length; ++ue) {
      var le = q.charCodeAt(ue);
      Q.write_shift(1, le >= 128 ? 95 : le);
    }
    return Q.write_shift(1, 0), Q;
  }
  function E(F, Y) {
    var X = w(F);
    X[1].v = F.read_shift(2);
    var q = X[1].v >> 1;
    if (X[1].v & 1)
      switch (q & 7) {
        case 0:
          q = (q >> 3) * 5e3;
          break;
        case 1:
          q = (q >> 3) * 500;
          break;
        case 2:
          q = (q >> 3) / 20;
          break;
        case 3:
          q = (q >> 3) / 200;
          break;
        case 4:
          q = (q >> 3) / 2e3;
          break;
        case 5:
          q = (q >> 3) / 2e4;
          break;
        case 6:
          q = (q >> 3) / 16;
          break;
        case 7:
          q = (q >> 3) / 64;
          break;
      }
    return X[1].v = q, X;
  }
  function C(F, Y) {
    var X = w(F), q = F.read_shift(4), Q = F.read_shift(4), ue = F.read_shift(2);
    if (ue == 65535)
      return q === 0 && Q === 3221225472 ? (X[1].t = "e", X[1].v = 15) : q === 0 && Q === 3489660928 ? (X[1].t = "e", X[1].v = 42) : X[1].v = 0, X;
    var le = ue & 32768;
    return ue = (ue & 32767) - 16446, X[1].v = (1 - le * 2) * (Q * Math.pow(2, ue + 32) + q * Math.pow(2, ue)), X;
  }
  function T(F, Y, X, q) {
    var Q = We(14);
    if (Q.write_shift(2, F), Q.write_shift(1, X), Q.write_shift(1, Y), q == 0)
      return Q.write_shift(4, 0), Q.write_shift(4, 0), Q.write_shift(2, 65535), Q;
    var ue = 0, le = 0, te = 0, G = 0;
    return q < 0 && (ue = 1, q = -q), le = Math.log2(q) | 0, q /= Math.pow(2, le - 31), G = q >>> 0, G & 2147483648 || (q /= 2, ++le, G = q >>> 0), q -= G, G |= 2147483648, G >>>= 0, q *= Math.pow(2, 32), te = q >>> 0, Q.write_shift(4, te), Q.write_shift(4, G), le += 16383 + (ue ? 32768 : 0), Q.write_shift(2, le), Q;
  }
  function O(F, Y) {
    var X = C(F);
    return F.l += Y - 14, X;
  }
  function I(F, Y) {
    var X = w(F), q = F.read_shift(4);
    return X[1].v = q >> 6, X;
  }
  function k(F, Y) {
    var X = w(F), q = F.read_shift(8, "f");
    return X[1].v = q, X;
  }
  function B(F, Y) {
    var X = k(F);
    return F.l += Y - 10, X;
  }
  function P(F, Y) {
    return F[F.l + Y - 1] == 0 ? F.read_shift(Y, "cstr") : "";
  }
  function N(F, Y) {
    var X = F[F.l++];
    X > Y - 1 && (X = Y - 1);
    for (var q = ""; q.length < X; ) q += String.fromCharCode(F[F.l++]);
    return q;
  }
  function M(F, Y, X) {
    if (!(!X.qpro || Y < 21)) {
      var q = F.read_shift(1);
      F.l += 17, F.l += 1, F.l += 2;
      var Q = F.read_shift(Y - 21, "cstr");
      return [q, Q];
    }
  }
  function H(F, Y) {
    for (var X = {}, q = F.l + Y; F.l < q; ) {
      var Q = F.read_shift(2);
      if (Q == 14e3) {
        for (X[Q] = [0, ""], X[Q][0] = F.read_shift(2); F[F.l]; )
          X[Q][1] += String.fromCharCode(F[F.l]), F.l++;
        F.l++;
      }
    }
    return X;
  }
  function R(F, Y) {
    var X = We(5 + F.length);
    X.write_shift(2, 14e3), X.write_shift(2, Y);
    for (var q = 0; q < F.length; ++q) {
      var Q = F.charCodeAt(q);
      X[X.l++] = Q > 127 ? 95 : Q;
    }
    return X[X.l++] = 0, X;
  }
  var z = {
    /*::[*/
    0: { n: "BOF", f: Dr },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "CALCMODE" },
    /*::[*/
    3: { n: "CALCORDER" },
    /*::[*/
    4: { n: "SPLIT" },
    /*::[*/
    5: { n: "SYNC" },
    /*::[*/
    6: { n: "RANGE", f: s },
    /*::[*/
    7: { n: "WINDOW1" },
    /*::[*/
    8: { n: "COLW1" },
    /*::[*/
    9: { n: "WINTWO" },
    /*::[*/
    10: { n: "COLW2" },
    /*::[*/
    11: { n: "NAME" },
    /*::[*/
    12: { n: "BLANK" },
    /*::[*/
    13: { n: "INTEGER", f: d },
    /*::[*/
    14: { n: "NUMBER", f: v },
    /*::[*/
    15: { n: "LABEL", f: c },
    /*::[*/
    16: { n: "FORMULA", f: m },
    /*::[*/
    24: { n: "TABLE" },
    /*::[*/
    25: { n: "ORANGE" },
    /*::[*/
    26: { n: "PRANGE" },
    /*::[*/
    27: { n: "SRANGE" },
    /*::[*/
    28: { n: "FRANGE" },
    /*::[*/
    29: { n: "KRANGE1" },
    /*::[*/
    32: { n: "HRANGE" },
    /*::[*/
    35: { n: "KRANGE2" },
    /*::[*/
    36: { n: "PROTEC" },
    /*::[*/
    37: { n: "FOOTER" },
    /*::[*/
    38: { n: "HEADER" },
    /*::[*/
    39: { n: "SETUP" },
    /*::[*/
    40: { n: "MARGINS" },
    /*::[*/
    41: { n: "LABELFMT" },
    /*::[*/
    42: { n: "TITLES" },
    /*::[*/
    43: { n: "SHEETJS" },
    /*::[*/
    45: { n: "GRAPH" },
    /*::[*/
    46: { n: "NGRAPH" },
    /*::[*/
    47: { n: "CALCCOUNT" },
    /*::[*/
    48: { n: "UNFORMATTED" },
    /*::[*/
    49: { n: "CURSORW12" },
    /*::[*/
    50: { n: "WINDOW" },
    /*::[*/
    51: { n: "STRING", f: c },
    /*::[*/
    55: { n: "PASSWORD" },
    /*::[*/
    56: { n: "LOCKED" },
    /*::[*/
    60: { n: "QUERY" },
    /*::[*/
    61: { n: "QUERYNAME" },
    /*::[*/
    62: { n: "PRINT" },
    /*::[*/
    63: { n: "PRINTNAME" },
    /*::[*/
    64: { n: "GRAPH2" },
    /*::[*/
    65: { n: "GRAPHNAME" },
    /*::[*/
    66: { n: "ZOOM" },
    /*::[*/
    67: { n: "SYMSPLIT" },
    /*::[*/
    68: { n: "NSROWS" },
    /*::[*/
    69: { n: "NSCOLS" },
    /*::[*/
    70: { n: "RULER" },
    /*::[*/
    71: { n: "NNAME" },
    /*::[*/
    72: { n: "ACOMM" },
    /*::[*/
    73: { n: "AMACRO" },
    /*::[*/
    74: { n: "PARSE" },
    /*::[*/
    102: { n: "PRANGES??" },
    /*::[*/
    103: { n: "RRANGES??" },
    /*::[*/
    104: { n: "FNAME??" },
    /*::[*/
    105: { n: "MRANGES??" },
    /*::[*/
    204: { n: "SHEETNAMECS", f: P },
    /*::[*/
    222: { n: "SHEETNAMELP", f: N },
    /*::[*/
    65535: { n: "" }
  }, W = {
    /*::[*/
    0: { n: "BOF" },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "PASSWORD" },
    /*::[*/
    3: { n: "CALCSET" },
    /*::[*/
    4: { n: "WINDOWSET" },
    /*::[*/
    5: { n: "SHEETCELLPTR" },
    /*::[*/
    6: { n: "SHEETLAYOUT" },
    /*::[*/
    7: { n: "COLUMNWIDTH" },
    /*::[*/
    8: { n: "HIDDENCOLUMN" },
    /*::[*/
    9: { n: "USERRANGE" },
    /*::[*/
    10: { n: "SYSTEMRANGE" },
    /*::[*/
    11: { n: "ZEROFORCE" },
    /*::[*/
    12: { n: "SORTKEYDIR" },
    /*::[*/
    13: { n: "FILESEAL" },
    /*::[*/
    14: { n: "DATAFILLNUMS" },
    /*::[*/
    15: { n: "PRINTMAIN" },
    /*::[*/
    16: { n: "PRINTSTRING" },
    /*::[*/
    17: { n: "GRAPHMAIN" },
    /*::[*/
    18: { n: "GRAPHSTRING" },
    /*::[*/
    19: { n: "??" },
    /*::[*/
    20: { n: "ERRCELL" },
    /*::[*/
    21: { n: "NACELL" },
    /*::[*/
    22: { n: "LABEL16", f: _ },
    /*::[*/
    23: { n: "NUMBER17", f: C },
    /*::[*/
    24: { n: "NUMBER18", f: E },
    /*::[*/
    25: { n: "FORMULA19", f: O },
    /*::[*/
    26: { n: "FORMULA1A" },
    /*::[*/
    27: { n: "XFORMAT", f: H },
    /*::[*/
    28: { n: "DTLABELMISC" },
    /*::[*/
    29: { n: "DTLABELCELL" },
    /*::[*/
    30: { n: "GRAPHWINDOW" },
    /*::[*/
    31: { n: "CPA" },
    /*::[*/
    32: { n: "LPLAUTO" },
    /*::[*/
    33: { n: "QUERY" },
    /*::[*/
    34: { n: "HIDDENSHEET" },
    /*::[*/
    35: { n: "??" },
    /*::[*/
    37: { n: "NUMBER25", f: I },
    /*::[*/
    38: { n: "??" },
    /*::[*/
    39: { n: "NUMBER27", f: k },
    /*::[*/
    40: { n: "FORMULA28", f: B },
    /*::[*/
    142: { n: "??" },
    /*::[*/
    147: { n: "??" },
    /*::[*/
    150: { n: "??" },
    /*::[*/
    151: { n: "??" },
    /*::[*/
    152: { n: "??" },
    /*::[*/
    153: { n: "??" },
    /*::[*/
    154: { n: "??" },
    /*::[*/
    155: { n: "??" },
    /*::[*/
    156: { n: "??" },
    /*::[*/
    163: { n: "??" },
    /*::[*/
    174: { n: "??" },
    /*::[*/
    175: { n: "??" },
    /*::[*/
    176: { n: "??" },
    /*::[*/
    177: { n: "??" },
    /*::[*/
    184: { n: "??" },
    /*::[*/
    185: { n: "??" },
    /*::[*/
    186: { n: "??" },
    /*::[*/
    187: { n: "??" },
    /*::[*/
    188: { n: "??" },
    /*::[*/
    195: { n: "??" },
    /*::[*/
    201: { n: "??" },
    /*::[*/
    204: { n: "SHEETNAMECS", f: P },
    /*::[*/
    205: { n: "??" },
    /*::[*/
    206: { n: "??" },
    /*::[*/
    207: { n: "??" },
    /*::[*/
    208: { n: "??" },
    /*::[*/
    256: { n: "??" },
    /*::[*/
    259: { n: "??" },
    /*::[*/
    260: { n: "??" },
    /*::[*/
    261: { n: "??" },
    /*::[*/
    262: { n: "??" },
    /*::[*/
    263: { n: "??" },
    /*::[*/
    265: { n: "??" },
    /*::[*/
    266: { n: "??" },
    /*::[*/
    267: { n: "??" },
    /*::[*/
    268: { n: "??" },
    /*::[*/
    270: { n: "??" },
    /*::[*/
    271: { n: "??" },
    /*::[*/
    384: { n: "??" },
    /*::[*/
    389: { n: "??" },
    /*::[*/
    390: { n: "??" },
    /*::[*/
    393: { n: "??" },
    /*::[*/
    396: { n: "??" },
    /*::[*/
    512: { n: "??" },
    /*::[*/
    514: { n: "??" },
    /*::[*/
    513: { n: "??" },
    /*::[*/
    516: { n: "??" },
    /*::[*/
    517: { n: "??" },
    /*::[*/
    640: { n: "??" },
    /*::[*/
    641: { n: "??" },
    /*::[*/
    642: { n: "??" },
    /*::[*/
    643: { n: "??" },
    /*::[*/
    644: { n: "??" },
    /*::[*/
    645: { n: "??" },
    /*::[*/
    646: { n: "??" },
    /*::[*/
    647: { n: "??" },
    /*::[*/
    648: { n: "??" },
    /*::[*/
    658: { n: "??" },
    /*::[*/
    659: { n: "??" },
    /*::[*/
    660: { n: "??" },
    /*::[*/
    661: { n: "??" },
    /*::[*/
    662: { n: "??" },
    /*::[*/
    665: { n: "??" },
    /*::[*/
    666: { n: "??" },
    /*::[*/
    768: { n: "??" },
    /*::[*/
    772: { n: "??" },
    /*::[*/
    1537: { n: "SHEETINFOQP", f: M },
    /*::[*/
    1600: { n: "??" },
    /*::[*/
    1602: { n: "??" },
    /*::[*/
    1793: { n: "??" },
    /*::[*/
    1794: { n: "??" },
    /*::[*/
    1795: { n: "??" },
    /*::[*/
    1796: { n: "??" },
    /*::[*/
    1920: { n: "??" },
    /*::[*/
    2048: { n: "??" },
    /*::[*/
    2049: { n: "??" },
    /*::[*/
    2052: { n: "??" },
    /*::[*/
    2688: { n: "??" },
    /*::[*/
    10998: { n: "??" },
    /*::[*/
    12849: { n: "??" },
    /*::[*/
    28233: { n: "??" },
    /*::[*/
    28484: { n: "??" },
    /*::[*/
    65535: { n: "" }
  };
  return {
    sheet_to_wk1: r,
    book_to_wk3: a,
    to_workbook: t
  };
}();
function jxe(e) {
  var t = {}, n = e.match(Fa), r = 0, a = !1;
  if (n) for (; r != n.length; ++r) {
    var o = Vt(n[r]);
    switch (o[0].replace(/\w*:/g, "")) {
      case "<condense":
        break;
      case "<extend":
        break;
      case "<shadow":
        if (!o.val) break;
      case "<shadow>":
      case "<shadow/>":
        t.shadow = 1;
        break;
      case "</shadow>":
        break;
      case "<charset":
        if (o.val == "1") break;
        t.cp = F4[parseInt(o.val, 10)];
        break;
      case "<outline":
        if (!o.val) break;
      case "<outline>":
      case "<outline/>":
        t.outline = 1;
        break;
      case "</outline>":
        break;
      case "<rFont":
        t.name = o.val;
        break;
      case "<sz":
        t.sz = o.val;
        break;
      case "<strike":
        if (!o.val) break;
      case "<strike>":
      case "<strike/>":
        t.strike = 1;
        break;
      case "</strike>":
        break;
      case "<u":
        if (!o.val) break;
        switch (o.val) {
          case "double":
            t.uval = "double";
            break;
          case "singleAccounting":
            t.uval = "single-accounting";
            break;
          case "doubleAccounting":
            t.uval = "double-accounting";
            break;
        }
      case "<u>":
      case "<u/>":
        t.u = 1;
        break;
      case "</u>":
        break;
      case "<b":
        if (o.val == "0") break;
      case "<b>":
      case "<b/>":
        t.b = 1;
        break;
      case "</b>":
        break;
      case "<i":
        if (o.val == "0") break;
      case "<i>":
      case "<i/>":
        t.i = 1;
        break;
      case "</i>":
        break;
      case "<color":
        o.rgb && (t.color = o.rgb.slice(2, 8));
        break;
      case "<color>":
      case "<color/>":
      case "</color>":
        break;
      case "<family":
        t.family = o.val;
        break;
      case "<family>":
      case "<family/>":
      case "</family>":
        break;
      case "<vertAlign":
        t.valign = o.val;
        break;
      case "<vertAlign>":
      case "<vertAlign/>":
      case "</vertAlign>":
        break;
      case "<scheme":
        break;
      case "<scheme>":
      case "<scheme/>":
      case "</scheme>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      default:
        if (o[0].charCodeAt(1) !== 47 && !a) throw new Error("Unrecognized rich format " + o[0]);
    }
  }
  return t;
}
var Vxe = /* @__PURE__ */ function() {
  var e = yp("t"), t = yp("rPr");
  function n(o) {
    var i = o.match(e);
    if (!i) return { t: "s", v: "" };
    var s = { t: "s", v: En(i[1]) }, l = o.match(t);
    return l && (s.s = jxe(l[1])), s;
  }
  var r = /<(?:\w+:)?r>/g, a = /<\/(?:\w+:)?r>/;
  return function(i) {
    return i.replace(r, "").split(a).map(n).filter(function(s) {
      return s.v;
    });
  };
}(), Uxe = /* @__PURE__ */ function() {
  var t = /(\r\n|\n)/g;
  function n(a, o, i) {
    var s = [];
    a.u && s.push("text-decoration: underline;"), a.uval && s.push("text-underline-style:" + a.uval + ";"), a.sz && s.push("font-size:" + a.sz + "pt;"), a.outline && s.push("text-effect: outline;"), a.shadow && s.push("text-shadow: auto;"), o.push('<span style="' + s.join("") + '">'), a.b && (o.push("<b>"), i.push("</b>")), a.i && (o.push("<i>"), i.push("</i>")), a.strike && (o.push("<s>"), i.push("</s>"));
    var l = a.valign || "";
    return l == "superscript" || l == "super" ? l = "sup" : l == "subscript" && (l = "sub"), l != "" && (o.push("<" + l + ">"), i.push("</" + l + ">")), i.push("</span>"), a;
  }
  function r(a) {
    var o = [[], a.v, []];
    return a.v ? (a.s && n(a.s, o[0], o[2]), o[0].join("") + o[1].replace(t, "<br/>") + o[2].join("")) : "";
  }
  return function(o) {
    return o.map(r).join("");
  };
}(), zxe = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, Wxe = /<(?:\w+:)?r>/, Gxe = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function oE(e, t) {
  var n = t ? t.cellHTML : !0, r = {};
  return e ? (e.match(/^\s*<(?:\w+:)?t[^>]*>/) ? (r.t = En(Hn(e.slice(e.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || "")), r.r = Hn(e), n && (r.h = K4(r.t))) : (
    /*y = */
    e.match(Wxe) && (r.r = Hn(e), r.t = En(Hn((e.replace(Gxe, "").match(zxe) || []).join("").replace(Fa, ""))), n && (r.h = Uxe(Vxe(r.r))))
  ), r) : { t: "" };
}
var Kxe = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/, Yxe = /<(?:\w+:)?(?:si|sstItem)>/g, qxe = /<\/(?:\w+:)?(?:si|sstItem)>/;
function Xxe(e, t) {
  var n = [], r = "";
  if (!e) return n;
  var a = e.match(Kxe);
  if (a) {
    r = a[2].replace(Yxe, "").split(qxe);
    for (var o = 0; o != r.length; ++o) {
      var i = oE(r[o].trim(), t);
      i != null && (n[n.length] = i);
    }
    a = Vt(a[1]), n.Count = a.count, n.Unique = a.uniqueCount;
  }
  return n;
}
var Zxe = /^\s|\s$|[\t\n\r]/;
function rN(e, t) {
  if (!t.bookSST) return "";
  var n = [Tr];
  n[n.length] = pt("sst", null, {
    xmlns: Nc[0],
    count: e.Count,
    uniqueCount: e.Unique
  });
  for (var r = 0; r != e.length; ++r)
    if (e[r] != null) {
      var a = e[r], o = "<si>";
      a.r ? o += a.r : (o += "<t", a.t || (a.t = ""), a.t.match(Zxe) && (o += ' xml:space="preserve"'), o += ">" + Nn(a.t) + "</t>"), o += "</si>", n[n.length] = o;
    }
  return n.length > 2 && (n[n.length] = "</sst>", n[1] = n[1].replace("/>", ">")), n.join("");
}
function Qxe(e) {
  return [e.read_shift(4), e.read_shift(4)];
}
function Jxe(e, t) {
  var n = [], r = !1;
  return fl(e, function(o, i, s) {
    switch (s) {
      case 159:
        n.Count = o[0], n.Unique = o[1];
        break;
      case 19:
        n.push(o);
        break;
      case 160:
        return !0;
      case 35:
        r = !0;
        break;
      case 36:
        r = !1;
        break;
      default:
        if (i.T, !r || t.WTF) throw new Error("Unexpected record 0x" + s.toString(16));
    }
  }), n;
}
function ebe(e, t) {
  return t || (t = We(8)), t.write_shift(4, e.Count), t.write_shift(4, e.Unique), t;
}
var tbe = f1e;
function nbe(e) {
  var t = lo();
  at(t, 159, ebe(e));
  for (var n = 0; n < e.length; ++n) at(t, 19, tbe(e[n]));
  return at(
    t,
    160
    /* BrtEndSst */
  ), t.end();
}
function aN(e) {
  for (var t = [], n = e.split(""), r = 0; r < n.length; ++r) t[r] = n[r].charCodeAt(0);
  return t;
}
function Zs(e, t) {
  var n = {};
  return n.Major = e.read_shift(2), n.Minor = e.read_shift(2), t >= 4 && (e.l += t - 4), n;
}
function rbe(e) {
  var t = {};
  return t.id = e.read_shift(0, "lpp4"), t.R = Zs(e, 4), t.U = Zs(e, 4), t.W = Zs(e, 4), t;
}
function abe(e) {
  for (var t = e.read_shift(4), n = e.l + t - 4, r = {}, a = e.read_shift(4), o = []; a-- > 0; ) o.push({ t: e.read_shift(4), v: e.read_shift(0, "lpp4") });
  if (r.name = e.read_shift(0, "lpp4"), r.comps = o, e.l != n) throw new Error("Bad DataSpaceMapEntry: " + e.l + " != " + n);
  return r;
}
function obe(e) {
  var t = [];
  e.l += 4;
  for (var n = e.read_shift(4); n-- > 0; ) t.push(abe(e));
  return t;
}
function ibe(e) {
  var t = [];
  e.l += 4;
  for (var n = e.read_shift(4); n-- > 0; ) t.push(e.read_shift(0, "lpp4"));
  return t;
}
function sbe(e) {
  var t = {};
  return e.read_shift(4), e.l += 4, t.id = e.read_shift(0, "lpp4"), t.name = e.read_shift(0, "lpp4"), t.R = Zs(e, 4), t.U = Zs(e, 4), t.W = Zs(e, 4), t;
}
function lbe(e) {
  var t = sbe(e);
  if (t.ename = e.read_shift(0, "8lpp4"), t.blksz = e.read_shift(4), t.cmode = e.read_shift(4), e.read_shift(4) != 4) throw new Error("Bad !Primary record");
  return t;
}
function oN(e, t) {
  var n = e.l + t, r = {};
  r.Flags = e.read_shift(4) & 63, e.l += 4, r.AlgID = e.read_shift(4);
  var a = !1;
  switch (r.AlgID) {
    case 26126:
    case 26127:
    case 26128:
      a = r.Flags == 36;
      break;
    case 26625:
      a = r.Flags == 4;
      break;
    case 0:
      a = r.Flags == 16 || r.Flags == 4 || r.Flags == 36;
      break;
    default:
      throw "Unrecognized encryption algorithm: " + r.AlgID;
  }
  if (!a) throw new Error("Encryption Flags/AlgID mismatch");
  return r.AlgIDHash = e.read_shift(4), r.KeySize = e.read_shift(4), r.ProviderType = e.read_shift(4), e.l += 8, r.CSPName = e.read_shift(n - e.l >> 1, "utf16le"), e.l = n, r;
}
function iN(e, t) {
  var n = {}, r = e.l + t;
  return e.l += 4, n.Salt = e.slice(e.l, e.l + 16), e.l += 16, n.Verifier = e.slice(e.l, e.l + 16), e.l += 16, e.read_shift(4), n.VerifierHash = e.slice(e.l, r), e.l = r, n;
}
function ube(e) {
  var t = Zs(e);
  switch (t.Minor) {
    case 2:
      return [t.Minor, cbe(e)];
    case 3:
      return [t.Minor, fbe()];
    case 4:
      return [t.Minor, dbe(e)];
  }
  throw new Error("ECMA-376 Encrypted file unrecognized Version: " + t.Minor);
}
function cbe(e) {
  var t = e.read_shift(4);
  if ((t & 63) != 36) throw new Error("EncryptionInfo mismatch");
  var n = e.read_shift(4), r = oN(e, n), a = iN(e, e.length - e.l);
  return { t: "Std", h: r, v: a };
}
function fbe() {
  throw new Error("File is password-protected: ECMA-376 Extensible");
}
function dbe(e) {
  var t = ["saltSize", "blockSize", "keyBits", "hashSize", "cipherAlgorithm", "cipherChaining", "hashAlgorithm", "saltValue"];
  e.l += 4;
  var n = e.read_shift(e.length - e.l, "utf8"), r = {};
  return n.replace(Fa, function(o) {
    var i = Vt(o);
    switch (Es(i[0])) {
      case "<?xml":
        break;
      case "<encryption":
      case "</encryption>":
        break;
      case "<keyData":
        t.forEach(function(s) {
          r[s] = i[s];
        });
        break;
      case "<dataIntegrity":
        r.encryptedHmacKey = i.encryptedHmacKey, r.encryptedHmacValue = i.encryptedHmacValue;
        break;
      case "<keyEncryptors>":
      case "<keyEncryptors":
        r.encs = [];
        break;
      case "</keyEncryptors>":
        break;
      case "<keyEncryptor":
        r.uri = i.uri;
        break;
      case "</keyEncryptor>":
        break;
      case "<encryptedKey":
        r.encs.push(i);
        break;
      default:
        throw i[0];
    }
  }), r;
}
function pbe(e, t) {
  var n = {}, r = n.EncryptionVersionInfo = Zs(e, 4);
  if (t -= 4, r.Minor != 2) throw new Error("unrecognized minor version code: " + r.Minor);
  if (r.Major > 4 || r.Major < 2) throw new Error("unrecognized major version code: " + r.Major);
  n.Flags = e.read_shift(4), t -= 4;
  var a = e.read_shift(4);
  return t -= 4, n.EncryptionHeader = oN(e, a), t -= a, n.EncryptionVerifier = iN(e, t), n;
}
function hbe(e) {
  var t = {}, n = t.EncryptionVersionInfo = Zs(e, 4);
  if (n.Major != 1 || n.Minor != 1) throw "unrecognized version code " + n.Major + " : " + n.Minor;
  return t.Salt = e.read_shift(16), t.EncryptedVerifier = e.read_shift(16), t.EncryptedVerifierHash = e.read_shift(16), t;
}
function iE(e) {
  var t = 0, n, r = aN(e), a = r.length + 1, o, i, s, l, u;
  for (n = ru(a), n[0] = r.length, o = 1; o != a; ++o) n[o] = r[o - 1];
  for (o = a - 1; o >= 0; --o)
    i = n[o], s = t & 16384 ? 1 : 0, l = t << 1 & 32767, u = s | l, t = u ^ i;
  return t ^ 52811;
}
var sN = /* @__PURE__ */ function() {
  var e = [187, 255, 255, 186, 255, 255, 185, 128, 0, 190, 15, 0, 191, 15, 0], t = [57840, 7439, 52380, 33984, 4364, 3600, 61902, 12606, 6258, 57657, 54287, 34041, 10252, 43370, 20163], n = [44796, 19929, 39858, 10053, 20106, 40212, 10761, 31585, 63170, 64933, 60267, 50935, 40399, 11199, 17763, 35526, 1453, 2906, 5812, 11624, 23248, 885, 1770, 3540, 7080, 14160, 28320, 56640, 55369, 41139, 20807, 41614, 21821, 43642, 17621, 28485, 56970, 44341, 19019, 38038, 14605, 29210, 60195, 50791, 40175, 10751, 21502, 43004, 24537, 18387, 36774, 3949, 7898, 15796, 31592, 63184, 47201, 24803, 49606, 37805, 14203, 28406, 56812, 17824, 35648, 1697, 3394, 6788, 13576, 27152, 43601, 17539, 35078, 557, 1114, 2228, 4456, 30388, 60776, 51953, 34243, 7079, 14158, 28316, 14128, 28256, 56512, 43425, 17251, 34502, 7597, 13105, 26210, 52420, 35241, 883, 1766, 3532, 4129, 8258, 16516, 33032, 4657, 9314, 18628], r = function(i) {
    return (i / 2 | i * 128) & 255;
  }, a = function(i, s) {
    return r(i ^ s);
  }, o = function(i) {
    for (var s = t[i.length - 1], l = 104, u = i.length - 1; u >= 0; --u)
      for (var c = i[u], f = 0; f != 7; ++f)
        c & 64 && (s ^= n[l]), c *= 2, --l;
    return s;
  };
  return function(i) {
    for (var s = aN(i), l = o(s), u = s.length, c = ru(16), f = 0; f != 16; ++f) c[f] = 0;
    var d, p, v;
    for ((u & 1) === 1 && (d = l >> 8, c[u] = a(e[0], d), --u, d = l & 255, p = s[s.length - 1], c[u] = a(p, d)); u > 0; )
      --u, d = l >> 8, c[u] = a(s[u], d), --u, d = l & 255, c[u] = a(s[u], d);
    for (u = 15, v = 15 - s.length; v > 0; )
      d = l >> 8, c[u] = a(e[v], d), --u, --v, d = l & 255, c[u] = a(s[u], d), --u, --v;
    return c;
  };
}(), vbe = function(e, t, n, r, a) {
  a || (a = t), r || (r = sN(e));
  var o, i;
  for (o = 0; o != t.length; ++o)
    i = t[o], i ^= r[n], i = (i >> 5 | i << 3) & 255, a[o] = i, ++n;
  return [a, n, r];
}, mbe = function(e) {
  var t = 0, n = sN(e);
  return function(r) {
    var a = vbe("", r, t, n);
    return t = a[1], a[0];
  };
};
function gbe(e, t, n, r) {
  var a = { key: Dr(e), verificationBytes: Dr(e) };
  return n.password && (a.verifier = iE(n.password)), r.valid = a.verificationBytes === a.verifier, r.valid && (r.insitu = mbe(n.password)), a;
}
function ybe(e, t, n) {
  var r = n || {};
  return r.Info = e.read_shift(2), e.l -= 2, r.Info === 1 ? r.Data = hbe(e) : r.Data = pbe(e, t), r;
}
function xbe(e, t, n) {
  var r = { Type: n.biff >= 8 ? e.read_shift(2) : 0 };
  return r.Type ? ybe(e, t - 2, r) : gbe(e, n.biff >= 8 ? t : t - 2, n, r), r;
}
var lN = /* @__PURE__ */ function() {
  function e(a, o) {
    switch (o.type) {
      case "base64":
        return t(Fo(a), o);
      case "binary":
        return t(a, o);
      case "buffer":
        return t(on && Buffer.isBuffer(a) ? a.toString("binary") : vu(a), o);
      case "array":
        return t(mc(a), o);
    }
    throw new Error("Unrecognized type " + o.type);
  }
  function t(a, o) {
    var i = o || {}, s = i.dense ? [] : {}, l = a.match(/\\trowd.*?\\row\b/g);
    if (!l.length) throw new Error("RTF missing table");
    var u = { s: { c: 0, r: 0 }, e: { c: 0, r: l.length - 1 } };
    return l.forEach(function(c, f) {
      Array.isArray(s) && (s[f] = []);
      for (var d = /\\\w+\b/g, p = 0, v, h = -1; v = d.exec(c); ) {
        switch (v[0]) {
          case "\\cell":
            var m = c.slice(p, d.lastIndex - v[0].length);
            if (m[0] == " " && (m = m.slice(1)), ++h, m.length) {
              var y = { v: m, t: "s" };
              Array.isArray(s) ? s[f][h] = y : s[Kt({ r: f, c: h })] = y;
            }
            break;
        }
        p = d.lastIndex;
      }
      h > u.e.c && (u.e.c = h);
    }), s["!ref"] = vn(u), s;
  }
  function n(a, o) {
    return Fc(e(a, o), o);
  }
  function r(a) {
    for (var o = ["{\\rtf1\\ansi"], i = kn(a["!ref"]), s, l = Array.isArray(a), u = i.s.r; u <= i.e.r; ++u) {
      o.push("\\trowd\\trautofit1");
      for (var c = i.s.c; c <= i.e.c; ++c) o.push("\\cellx" + (c + 1));
      for (o.push("\\pard\\intbl"), c = i.s.c; c <= i.e.c; ++c) {
        var f = Kt({ r: u, c });
        s = l ? (a[u] || [])[c] : a[f], !(!s || s.v == null && (!s.f || s.F)) && (o.push(" " + (s.w || (au(s), s.w))), o.push("\\cell"));
      }
      o.push("\\pard\\intbl\\row");
    }
    return o.join("") + "}";
  }
  return {
    to_workbook: n,
    to_sheet: e,
    from_sheet: r
  };
}();
function bbe(e) {
  var t = e.slice(e[0] === "#" ? 1 : 0).slice(0, 6);
  return [parseInt(t.slice(0, 2), 16), parseInt(t.slice(2, 4), 16), parseInt(t.slice(4, 6), 16)];
}
function Sp(e) {
  for (var t = 0, n = 1; t != 3; ++t) n = n * 256 + (e[t] > 255 ? 255 : e[t] < 0 ? 0 : e[t]);
  return n.toString(16).toUpperCase().slice(1);
}
function wbe(e) {
  var t = e[0] / 255, n = e[1] / 255, r = e[2] / 255, a = Math.max(t, n, r), o = Math.min(t, n, r), i = a - o;
  if (i === 0) return [0, 0, t];
  var s = 0, l = 0, u = a + o;
  switch (l = i / (u > 1 ? 2 - u : u), a) {
    case t:
      s = ((n - r) / i + 6) % 6;
      break;
    case n:
      s = (r - t) / i + 2;
      break;
    case r:
      s = (t - n) / i + 4;
      break;
  }
  return [s / 6, l, u / 2];
}
function Sbe(e) {
  var t = e[0], n = e[1], r = e[2], a = n * 2 * (r < 0.5 ? r : 1 - r), o = r - a / 2, i = [o, o, o], s = 6 * t, l;
  if (n !== 0) switch (s | 0) {
    case 0:
    case 6:
      l = a * s, i[0] += a, i[1] += l;
      break;
    case 1:
      l = a * (2 - s), i[0] += l, i[1] += a;
      break;
    case 2:
      l = a * (s - 2), i[1] += a, i[2] += l;
      break;
    case 3:
      l = a * (4 - s), i[1] += l, i[2] += a;
      break;
    case 4:
      l = a * (s - 4), i[2] += a, i[0] += l;
      break;
    case 5:
      l = a * (6 - s), i[2] += l, i[0] += a;
      break;
  }
  for (var u = 0; u != 3; ++u) i[u] = Math.round(i[u] * 255);
  return i;
}
function ug(e, t) {
  if (t === 0) return e;
  var n = wbe(bbe(e));
  return t < 0 ? n[2] = n[2] * (1 + t) : n[2] = 1 - (1 - n[2]) * (1 - t), Sp(Sbe(n));
}
var uN = 6, _be = 15, Cbe = 1, _a = uN;
function _p(e) {
  return Math.floor((e + Math.round(128 / _a) / 256) * _a);
}
function Cp(e) {
  return Math.floor((e - 5) / _a * 100 + 0.5) / 100;
}
function cg(e) {
  return Math.round((e * _a + 5) / _a * 256) / 256;
}
function kx(e) {
  return cg(Cp(_p(e)));
}
function sE(e) {
  var t = Math.abs(e - kx(e)), n = _a;
  if (t > 5e-3) for (_a = Cbe; _a < _be; ++_a) Math.abs(e - kx(e)) <= t && (t = Math.abs(e - kx(e)), n = _a);
  _a = n;
}
function ou(e) {
  e.width ? (e.wpx = _p(e.width), e.wch = Cp(e.wpx), e.MDW = _a) : e.wpx ? (e.wch = Cp(e.wpx), e.width = cg(e.wch), e.MDW = _a) : typeof e.wch == "number" && (e.width = cg(e.wch), e.wpx = _p(e.width), e.MDW = _a), e.customWidth && delete e.customWidth;
}
var Ebe = 96, cN = Ebe;
function Ep(e) {
  return e * 96 / cN;
}
function ld(e) {
  return e * cN / 96;
}
var Tbe = {
  None: "none",
  Solid: "solid",
  Gray50: "mediumGray",
  Gray75: "darkGray",
  Gray25: "lightGray",
  HorzStripe: "darkHorizontal",
  VertStripe: "darkVertical",
  ReverseDiagStripe: "darkDown",
  DiagStripe: "darkUp",
  DiagCross: "darkGrid",
  ThickDiagCross: "darkTrellis",
  ThinHorzStripe: "lightHorizontal",
  ThinVertStripe: "lightVertical",
  ThinReverseDiagStripe: "lightDown",
  ThinHorzCross: "lightGrid"
};
function $be(e, t, n, r) {
  t.Borders = [];
  var a = {}, o = !1;
  (e[0].match(Fa) || []).forEach(function(i) {
    var s = Vt(i);
    switch (Es(s[0])) {
      case "<borders":
      case "<borders>":
      case "</borders>":
        break;
      case "<border":
      case "<border>":
      case "<border/>":
        a = /*::(*/
        {}, s.diagonalUp && (a.diagonalUp = Kn(s.diagonalUp)), s.diagonalDown && (a.diagonalDown = Kn(s.diagonalDown)), t.Borders.push(a);
        break;
      case "</border>":
        break;
      case "<left/>":
        break;
      case "<left":
      case "<left>":
        break;
      case "</left>":
        break;
      case "<right/>":
        break;
      case "<right":
      case "<right>":
        break;
      case "</right>":
        break;
      case "<top/>":
        break;
      case "<top":
      case "<top>":
        break;
      case "</top>":
        break;
      case "<bottom/>":
        break;
      case "<bottom":
      case "<bottom>":
        break;
      case "</bottom>":
        break;
      case "<diagonal":
      case "<diagonal>":
      case "<diagonal/>":
        break;
      case "</diagonal>":
        break;
      case "<horizontal":
      case "<horizontal>":
      case "<horizontal/>":
        break;
      case "</horizontal>":
        break;
      case "<vertical":
      case "<vertical>":
      case "<vertical/>":
        break;
      case "</vertical>":
        break;
      case "<start":
      case "<start>":
      case "<start/>":
        break;
      case "</start>":
        break;
      case "<end":
      case "<end>":
      case "<end/>":
        break;
      case "</end>":
        break;
      case "<color":
      case "<color>":
        break;
      case "<color/>":
      case "</color>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        o = !0;
        break;
      case "</ext>":
        o = !1;
        break;
      default:
        if (r && r.WTF && !o)
          throw new Error("unrecognized " + s[0] + " in borders");
    }
  });
}
function Obe(e, t, n, r) {
  t.Fills = [];
  var a = {}, o = !1;
  (e[0].match(Fa) || []).forEach(function(i) {
    var s = Vt(i);
    switch (Es(s[0])) {
      case "<fills":
      case "<fills>":
      case "</fills>":
        break;
      case "<fill>":
      case "<fill":
      case "<fill/>":
        a = {}, t.Fills.push(a);
        break;
      case "</fill>":
        break;
      case "<gradientFill>":
        break;
      case "<gradientFill":
      case "</gradientFill>":
        t.Fills.push(a), a = {};
        break;
      case "<patternFill":
      case "<patternFill>":
        s.patternType && (a.patternType = s.patternType);
        break;
      case "<patternFill/>":
      case "</patternFill>":
        break;
      case "<bgColor":
        a.bgColor || (a.bgColor = {}), s.indexed && (a.bgColor.indexed = parseInt(s.indexed, 10)), s.theme && (a.bgColor.theme = parseInt(s.theme, 10)), s.tint && (a.bgColor.tint = parseFloat(s.tint)), s.rgb && (a.bgColor.rgb = s.rgb.slice(-6));
        break;
      case "<bgColor/>":
      case "</bgColor>":
        break;
      case "<fgColor":
        a.fgColor || (a.fgColor = {}), s.theme && (a.fgColor.theme = parseInt(s.theme, 10)), s.tint && (a.fgColor.tint = parseFloat(s.tint)), s.rgb != null && (a.fgColor.rgb = s.rgb.slice(-6));
        break;
      case "<fgColor/>":
      case "</fgColor>":
        break;
      case "<stop":
      case "<stop/>":
        break;
      case "</stop>":
        break;
      case "<color":
      case "<color/>":
        break;
      case "</color>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        o = !0;
        break;
      case "</ext>":
        o = !1;
        break;
      default:
        if (r && r.WTF && !o)
          throw new Error("unrecognized " + s[0] + " in fills");
    }
  });
}
function Abe(e, t, n, r) {
  t.Fonts = [];
  var a = {}, o = !1;
  (e[0].match(Fa) || []).forEach(function(i) {
    var s = Vt(i);
    switch (Es(s[0])) {
      case "<fonts":
      case "<fonts>":
      case "</fonts>":
        break;
      case "<font":
      case "<font>":
        break;
      case "</font>":
      case "<font/>":
        t.Fonts.push(a), a = {};
        break;
      case "<name":
        s.val && (a.name = Hn(s.val));
        break;
      case "<name/>":
      case "</name>":
        break;
      case "<b":
        a.bold = s.val ? Kn(s.val) : 1;
        break;
      case "<b/>":
        a.bold = 1;
        break;
      case "<i":
        a.italic = s.val ? Kn(s.val) : 1;
        break;
      case "<i/>":
        a.italic = 1;
        break;
      case "<u":
        switch (s.val) {
          case "none":
            a.underline = 0;
            break;
          case "single":
            a.underline = 1;
            break;
          case "double":
            a.underline = 2;
            break;
          case "singleAccounting":
            a.underline = 33;
            break;
          case "doubleAccounting":
            a.underline = 34;
            break;
        }
        break;
      case "<u/>":
        a.underline = 1;
        break;
      case "<strike":
        a.strike = s.val ? Kn(s.val) : 1;
        break;
      case "<strike/>":
        a.strike = 1;
        break;
      case "<outline":
        a.outline = s.val ? Kn(s.val) : 1;
        break;
      case "<outline/>":
        a.outline = 1;
        break;
      case "<shadow":
        a.shadow = s.val ? Kn(s.val) : 1;
        break;
      case "<shadow/>":
        a.shadow = 1;
        break;
      case "<condense":
        a.condense = s.val ? Kn(s.val) : 1;
        break;
      case "<condense/>":
        a.condense = 1;
        break;
      case "<extend":
        a.extend = s.val ? Kn(s.val) : 1;
        break;
      case "<extend/>":
        a.extend = 1;
        break;
      case "<sz":
        s.val && (a.sz = +s.val);
        break;
      case "<sz/>":
      case "</sz>":
        break;
      case "<vertAlign":
        s.val && (a.vertAlign = s.val);
        break;
      case "<vertAlign/>":
      case "</vertAlign>":
        break;
      case "<family":
        s.val && (a.family = parseInt(s.val, 10));
        break;
      case "<family/>":
      case "</family>":
        break;
      case "<scheme":
        s.val && (a.scheme = s.val);
        break;
      case "<scheme/>":
      case "</scheme>":
        break;
      case "<charset":
        if (s.val == "1") break;
        s.codepage = F4[parseInt(s.val, 10)];
        break;
      case "<color":
        if (a.color || (a.color = {}), s.auto && (a.color.auto = Kn(s.auto)), s.rgb) a.color.rgb = s.rgb.slice(-6);
        else if (s.indexed) {
          a.color.index = parseInt(s.indexed, 10);
          var l = ec[a.color.index];
          a.color.index == 81 && (l = ec[1]), l || (l = ec[1]), a.color.rgb = l[0].toString(16) + l[1].toString(16) + l[2].toString(16);
        } else s.theme && (a.color.theme = parseInt(s.theme, 10), s.tint && (a.color.tint = parseFloat(s.tint)), s.theme && n.themeElements && n.themeElements.clrScheme && (a.color.rgb = ug(n.themeElements.clrScheme[a.color.theme].rgb, a.color.tint || 0)));
        break;
      case "<color/>":
      case "</color>":
        break;
      case "<AlternateContent":
        o = !0;
        break;
      case "</AlternateContent>":
        o = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        o = !0;
        break;
      case "</ext>":
        o = !1;
        break;
      default:
        if (r && r.WTF && !o)
          throw new Error("unrecognized " + s[0] + " in fonts");
    }
  });
}
function Ibe(e, t, n) {
  t.NumberFmt = [];
  for (var r = Er(jt), a = 0; a < r.length; ++a) t.NumberFmt[r[a]] = jt[r[a]];
  var o = e[0].match(Fa);
  if (o)
    for (a = 0; a < o.length; ++a) {
      var i = Vt(o[a]);
      switch (Es(i[0])) {
        case "<numFmts":
        case "</numFmts>":
        case "<numFmts/>":
        case "<numFmts>":
          break;
        case "<numFmt":
          {
            var s = En(Hn(i.formatCode)), l = parseInt(i.numFmtId, 10);
            if (t.NumberFmt[l] = s, l > 0) {
              if (l > 392) {
                for (l = 392; l > 60 && t.NumberFmt[l] != null; --l) ;
                t.NumberFmt[l] = s;
              }
              qs(s, l);
            }
          }
          break;
        case "</numFmt>":
          break;
        default:
          if (n.WTF) throw new Error("unrecognized " + i[0] + " in numFmts");
      }
    }
}
function Pbe(e) {
  var t = ["<numFmts>"];
  return [[5, 8], [23, 26], [41, 44], [
    /*63*/
    50,
    /*66],[164,*/
    392
  ]].forEach(function(n) {
    for (var r = n[0]; r <= n[1]; ++r) e[r] != null && (t[t.length] = pt("numFmt", null, { numFmtId: r, formatCode: Nn(e[r]) }));
  }), t.length === 1 ? "" : (t[t.length] = "</numFmts>", t[0] = pt("numFmts", null, { count: t.length - 2 }).replace("/>", ">"), t.join(""));
}
var mv = ["numFmtId", "fillId", "fontId", "borderId", "xfId"], gv = ["applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix"];
function Dbe(e, t, n) {
  t.CellXf = [];
  var r, a = !1;
  (e[0].match(Fa) || []).forEach(function(o) {
    var i = Vt(o), s = 0;
    switch (Es(i[0])) {
      case "<cellXfs":
      case "<cellXfs>":
      case "<cellXfs/>":
      case "</cellXfs>":
        break;
      case "<xf":
      case "<xf/>":
        for (r = i, delete r[0], s = 0; s < mv.length; ++s) r[mv[s]] && (r[mv[s]] = parseInt(r[mv[s]], 10));
        for (s = 0; s < gv.length; ++s) r[gv[s]] && (r[gv[s]] = Kn(r[gv[s]]));
        if (t.NumberFmt && r.numFmtId > 392) {
          for (s = 392; s > 60; --s) if (t.NumberFmt[r.numFmtId] == t.NumberFmt[s]) {
            r.numFmtId = s;
            break;
          }
        }
        t.CellXf.push(r);
        break;
      case "</xf>":
        break;
      case "<alignment":
      case "<alignment/>":
        var l = {};
        i.vertical && (l.vertical = i.vertical), i.horizontal && (l.horizontal = i.horizontal), i.textRotation != null && (l.textRotation = i.textRotation), i.indent && (l.indent = i.indent), i.wrapText && (l.wrapText = Kn(i.wrapText)), r.alignment = l;
        break;
      case "</alignment>":
        break;
      case "<protection":
        break;
      case "</protection>":
      case "<protection/>":
        break;
      case "<AlternateContent":
        a = !0;
        break;
      case "</AlternateContent>":
        a = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      default:
        if (n && n.WTF && !a)
          throw new Error("unrecognized " + i[0] + " in cellXfs");
    }
  });
}
function kbe(e) {
  var t = [];
  return t[t.length] = pt("cellXfs", null), e.forEach(function(n) {
    t[t.length] = pt("xf", null, n);
  }), t[t.length] = "</cellXfs>", t.length === 2 ? "" : (t[0] = pt("cellXfs", null, { count: t.length - 2 }).replace("/>", ">"), t.join(""));
}
var Mbe = /* @__PURE__ */ function() {
  var t = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/, n = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/, r = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/, a = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/, o = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
  return function(s, l, u) {
    var c = {};
    if (!s) return c;
    s = s.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    var f;
    return (f = s.match(t)) && Ibe(f, c, u), (f = s.match(a)) && Abe(f, c, l, u), (f = s.match(r)) && Obe(f, c, l, u), (f = s.match(o)) && $be(f, c, l, u), (f = s.match(n)) && Dbe(f, c, u), c;
  };
}();
function fN(e, t) {
  var n = [Tr, pt("styleSheet", null, {
    xmlns: Nc[0],
    "xmlns:vt": Rr.vt
  })], r;
  return e.SSF && (r = Pbe(e.SSF)) != null && (n[n.length] = r), n[n.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>', n[n.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>', n[n.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>', n[n.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>', (r = kbe(t.cellXfs)) && (n[n.length] = r), n[n.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>', n[n.length] = '<dxfs count="0"/>', n[n.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>', n.length > 2 && (n[n.length] = "</styleSheet>", n[1] = n[1].replace("/>", ">")), n.join("");
}
function Rbe(e, t) {
  var n = e.read_shift(2), r = Da(e);
  return [n, r];
}
function Nbe(e, t, n) {
  n || (n = We(6 + 4 * t.length)), n.write_shift(2, e), Wr(t, n);
  var r = n.length > n.l ? n.slice(0, n.l) : n;
  return n.l == null && (n.l = n.length), r;
}
function Fbe(e, t, n) {
  var r = {};
  r.sz = e.read_shift(2) / 20;
  var a = y1e(e);
  a.fItalic && (r.italic = 1), a.fCondense && (r.condense = 1), a.fExtend && (r.extend = 1), a.fShadow && (r.shadow = 1), a.fOutline && (r.outline = 1), a.fStrikeout && (r.strike = 1);
  var o = e.read_shift(2);
  switch (o === 700 && (r.bold = 1), e.read_shift(2)) {
    case 1:
      r.vertAlign = "superscript";
      break;
    case 2:
      r.vertAlign = "subscript";
      break;
  }
  var i = e.read_shift(1);
  i != 0 && (r.underline = i);
  var s = e.read_shift(1);
  s > 0 && (r.family = s);
  var l = e.read_shift(1);
  switch (l > 0 && (r.charset = l), e.l++, r.color = g1e(e), e.read_shift(1)) {
    case 1:
      r.scheme = "major";
      break;
    case 2:
      r.scheme = "minor";
      break;
  }
  return r.name = Da(e), r;
}
function Lbe(e, t) {
  t || (t = We(25 + 4 * 32)), t.write_shift(2, e.sz * 20), x1e(e, t), t.write_shift(2, e.bold ? 700 : 400);
  var n = 0;
  e.vertAlign == "superscript" ? n = 1 : e.vertAlign == "subscript" && (n = 2), t.write_shift(2, n), t.write_shift(1, e.underline || 0), t.write_shift(1, e.family || 0), t.write_shift(1, e.charset || 0), t.write_shift(1, 0), ig(e.color, t);
  var r = 0;
  return e.scheme == "major" && (r = 1), e.scheme == "minor" && (r = 2), t.write_shift(1, r), Wr(e.name, t), t.length > t.l ? t.slice(0, t.l) : t;
}
var Bbe = [
  "none",
  "solid",
  "mediumGray",
  "darkGray",
  "lightGray",
  "darkHorizontal",
  "darkVertical",
  "darkDown",
  "darkUp",
  "darkGrid",
  "darkTrellis",
  "lightHorizontal",
  "lightVertical",
  "lightDown",
  "lightUp",
  "lightGrid",
  "lightTrellis",
  "gray125",
  "gray0625"
], Mx, Hbe = Ma;
function IO(e, t) {
  t || (t = We(4 * 3 + 8 * 7 + 16 * 1)), Mx || (Mx = j1(Bbe));
  var n = Mx[e.patternType];
  n == null && (n = 40), t.write_shift(4, n);
  var r = 0;
  if (n != 40)
    for (ig({ auto: 1 }, t), ig({ auto: 1 }, t); r < 12; ++r) t.write_shift(4, 0);
  else {
    for (; r < 4; ++r) t.write_shift(4, 0);
    for (; r < 12; ++r) t.write_shift(4, 0);
  }
  return t.length > t.l ? t.slice(0, t.l) : t;
}
function jbe(e, t) {
  var n = e.l + t, r = e.read_shift(2), a = e.read_shift(2);
  return e.l = n, { ixfe: r, numFmtId: a };
}
function dN(e, t, n) {
  n || (n = We(16)), n.write_shift(2, t || 0), n.write_shift(2, e.numFmtId || 0), n.write_shift(2, 0), n.write_shift(2, 0), n.write_shift(2, 0), n.write_shift(1, 0), n.write_shift(1, 0);
  var r = 0;
  return n.write_shift(1, r), n.write_shift(1, 0), n.write_shift(1, 0), n.write_shift(1, 0), n;
}
function Yd(e, t) {
  return t || (t = We(10)), t.write_shift(1, 0), t.write_shift(1, 0), t.write_shift(4, 0), t.write_shift(4, 0), t;
}
var Vbe = Ma;
function Ube(e, t) {
  return t || (t = We(51)), t.write_shift(1, 0), Yd(null, t), Yd(null, t), Yd(null, t), Yd(null, t), Yd(null, t), t.length > t.l ? t.slice(0, t.l) : t;
}
function zbe(e, t) {
  return t || (t = We(12 + 4 * 10)), t.write_shift(4, e.xfId), t.write_shift(2, 1), t.write_shift(1, +e.builtinId), t.write_shift(1, 0), og(e.name || "", t), t.length > t.l ? t.slice(0, t.l) : t;
}
function Wbe(e, t, n) {
  var r = We(2052);
  return r.write_shift(4, e), og(t, r), og(n, r), r.length > r.l ? r.slice(0, r.l) : r;
}
function Gbe(e, t, n) {
  var r = {};
  r.NumberFmt = [];
  for (var a in jt) r.NumberFmt[a] = jt[a];
  r.CellXf = [], r.Fonts = [];
  var o = [], i = !1;
  return fl(e, function(l, u, c) {
    switch (c) {
      case 44:
        r.NumberFmt[l[0]] = l[1], qs(l[1], l[0]);
        break;
      case 43:
        r.Fonts.push(l), l.color.theme != null && t && t.themeElements && t.themeElements.clrScheme && (l.color.rgb = ug(t.themeElements.clrScheme[l.color.theme].rgb, l.color.tint || 0));
        break;
      case 1025:
        break;
      case 45:
        break;
      case 46:
        break;
      case 47:
        o[o.length - 1] == 617 && r.CellXf.push(l);
        break;
      case 48:
      case 507:
      case 572:
      case 475:
        break;
      case 1171:
      case 2102:
      case 1130:
      case 512:
      case 2095:
      case 3072:
        break;
      case 35:
        i = !0;
        break;
      case 36:
        i = !1;
        break;
      case 37:
        o.push(c), i = !0;
        break;
      case 38:
        o.pop(), i = !1;
        break;
      default:
        if (u.T > 0) o.push(c);
        else if (u.T < 0) o.pop();
        else if (!i || n.WTF && o[o.length - 1] != 37) throw new Error("Unexpected record 0x" + c.toString(16));
    }
  }), r;
}
function Kbe(e, t) {
  if (t) {
    var n = 0;
    [[5, 8], [23, 26], [41, 44], [
      /*63*/
      50,
      /*66],[164,*/
      392
    ]].forEach(function(r) {
      for (var a = r[0]; a <= r[1]; ++a) t[a] != null && ++n;
    }), n != 0 && (at(e, 615, Vi(n)), [[5, 8], [23, 26], [41, 44], [
      /*63*/
      50,
      /*66],[164,*/
      392
    ]].forEach(function(r) {
      for (var a = r[0]; a <= r[1]; ++a) t[a] != null && at(e, 44, Nbe(a, t[a]));
    }), at(
      e,
      616
      /* BrtEndFmts */
    ));
  }
}
function Ybe(e) {
  var t = 1;
  at(e, 611, Vi(t)), at(e, 43, Lbe({
    sz: 12,
    color: { theme: 1 },
    name: "Calibri",
    family: 2,
    scheme: "minor"
  })), at(
    e,
    612
    /* BrtEndFonts */
  );
}
function qbe(e) {
  var t = 2;
  at(e, 603, Vi(t)), at(e, 45, IO({ patternType: "none" })), at(e, 45, IO({ patternType: "gray125" })), at(
    e,
    604
    /* BrtEndFills */
  );
}
function Xbe(e) {
  var t = 1;
  at(e, 613, Vi(t)), at(e, 46, Ube()), at(
    e,
    614
    /* BrtEndBorders */
  );
}
function Zbe(e) {
  var t = 1;
  at(e, 626, Vi(t)), at(e, 47, dN({
    numFmtId: 0,
    fontId: 0,
    fillId: 0,
    borderId: 0
  }, 65535)), at(
    e,
    627
    /* BrtEndCellStyleXFs */
  );
}
function Qbe(e, t) {
  at(e, 617, Vi(t.length)), t.forEach(function(n) {
    at(e, 47, dN(n, 0));
  }), at(
    e,
    618
    /* BrtEndCellXFs */
  );
}
function Jbe(e) {
  var t = 1;
  at(e, 619, Vi(t)), at(e, 48, zbe({
    xfId: 0,
    builtinId: 0,
    name: "Normal"
  })), at(
    e,
    620
    /* BrtEndStyles */
  );
}
function e2e(e) {
  var t = 0;
  at(e, 505, Vi(t)), at(
    e,
    506
    /* BrtEndDXFs */
  );
}
function t2e(e) {
  var t = 0;
  at(e, 508, Wbe(t, "TableStyleMedium9", "PivotStyleMedium4")), at(
    e,
    509
    /* BrtEndTableStyles */
  );
}
function n2e(e, t) {
  var n = lo();
  return at(
    n,
    278
    /* BrtBeginStyleSheet */
  ), Kbe(n, e.SSF), Ybe(n), qbe(n), Xbe(n), Zbe(n), Qbe(n, t.cellXfs), Jbe(n), e2e(n), t2e(n), at(
    n,
    279
    /* BrtEndStyleSheet */
  ), n.end();
}
var r2e = [
  "</a:lt1>",
  "</a:dk1>",
  "</a:lt2>",
  "</a:dk2>",
  "</a:accent1>",
  "</a:accent2>",
  "</a:accent3>",
  "</a:accent4>",
  "</a:accent5>",
  "</a:accent6>",
  "</a:hlink>",
  "</a:folHlink>"
];
function a2e(e, t, n) {
  t.themeElements.clrScheme = [];
  var r = {};
  (e[0].match(Fa) || []).forEach(function(a) {
    var o = Vt(a);
    switch (o[0]) {
      case "<a:clrScheme":
      case "</a:clrScheme>":
        break;
      case "<a:srgbClr":
        r.rgb = o.val;
        break;
      case "<a:sysClr":
        r.rgb = o.lastClr;
        break;
      case "<a:dk1>":
      case "</a:dk1>":
      case "<a:lt1>":
      case "</a:lt1>":
      case "<a:dk2>":
      case "</a:dk2>":
      case "<a:lt2>":
      case "</a:lt2>":
      case "<a:accent1>":
      case "</a:accent1>":
      case "<a:accent2>":
      case "</a:accent2>":
      case "<a:accent3>":
      case "</a:accent3>":
      case "<a:accent4>":
      case "</a:accent4>":
      case "<a:accent5>":
      case "</a:accent5>":
      case "<a:accent6>":
      case "</a:accent6>":
      case "<a:hlink>":
      case "</a:hlink>":
      case "<a:folHlink>":
      case "</a:folHlink>":
        o[0].charAt(1) === "/" ? (t.themeElements.clrScheme[r2e.indexOf(o[0])] = r, r = {}) : r.name = o[0].slice(3, o[0].length - 1);
        break;
      default:
        if (n && n.WTF) throw new Error("Unrecognized " + o[0] + " in clrScheme");
    }
  });
}
function o2e() {
}
function i2e() {
}
var s2e = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/, l2e = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/, u2e = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
function c2e(e, t, n) {
  t.themeElements = {};
  var r;
  [
    /* clrScheme CT_ColorScheme */
    ["clrScheme", s2e, a2e],
    /* fontScheme CT_FontScheme */
    ["fontScheme", l2e, o2e],
    /* fmtScheme CT_StyleMatrix */
    ["fmtScheme", u2e, i2e]
  ].forEach(function(a) {
    if (!(r = e.match(a[1]))) throw new Error(a[0] + " not found in themeElements");
    a[2](r, t, n);
  });
}
var f2e = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
function pN(e, t) {
  (!e || e.length === 0) && (e = lE());
  var n, r = {};
  if (!(n = e.match(f2e))) throw new Error("themeElements not found in theme");
  return c2e(n[0], r, t), r.raw = e, r;
}
function lE(e, t) {
  if (t && t.themeXLSX) return t.themeXLSX;
  if (e && typeof e.raw == "string") return e.raw;
  var n = [Tr];
  return n[n.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">', n[n.length] = "<a:themeElements>", n[n.length] = '<a:clrScheme name="Office">', n[n.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>', n[n.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>', n[n.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>', n[n.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>', n[n.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>', n[n.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>', n[n.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>', n[n.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>', n[n.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>', n[n.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>', n[n.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>', n[n.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>', n[n.length] = "</a:clrScheme>", n[n.length] = '<a:fontScheme name="Office">', n[n.length] = "<a:majorFont>", n[n.length] = '<a:latin typeface="Cambria"/>', n[n.length] = '<a:ea typeface=""/>', n[n.length] = '<a:cs typeface=""/>', n[n.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', n[n.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', n[n.length] = '<a:font script="Hans" typeface="宋体"/>', n[n.length] = '<a:font script="Hant" typeface="新細明體"/>', n[n.length] = '<a:font script="Arab" typeface="Times New Roman"/>', n[n.length] = '<a:font script="Hebr" typeface="Times New Roman"/>', n[n.length] = '<a:font script="Thai" typeface="Tahoma"/>', n[n.length] = '<a:font script="Ethi" typeface="Nyala"/>', n[n.length] = '<a:font script="Beng" typeface="Vrinda"/>', n[n.length] = '<a:font script="Gujr" typeface="Shruti"/>', n[n.length] = '<a:font script="Khmr" typeface="MoolBoran"/>', n[n.length] = '<a:font script="Knda" typeface="Tunga"/>', n[n.length] = '<a:font script="Guru" typeface="Raavi"/>', n[n.length] = '<a:font script="Cans" typeface="Euphemia"/>', n[n.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', n[n.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', n[n.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', n[n.length] = '<a:font script="Thaa" typeface="MV Boli"/>', n[n.length] = '<a:font script="Deva" typeface="Mangal"/>', n[n.length] = '<a:font script="Telu" typeface="Gautami"/>', n[n.length] = '<a:font script="Taml" typeface="Latha"/>', n[n.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', n[n.length] = '<a:font script="Orya" typeface="Kalinga"/>', n[n.length] = '<a:font script="Mlym" typeface="Kartika"/>', n[n.length] = '<a:font script="Laoo" typeface="DokChampa"/>', n[n.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', n[n.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', n[n.length] = '<a:font script="Viet" typeface="Times New Roman"/>', n[n.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', n[n.length] = '<a:font script="Geor" typeface="Sylfaen"/>', n[n.length] = "</a:majorFont>", n[n.length] = "<a:minorFont>", n[n.length] = '<a:latin typeface="Calibri"/>', n[n.length] = '<a:ea typeface=""/>', n[n.length] = '<a:cs typeface=""/>', n[n.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', n[n.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', n[n.length] = '<a:font script="Hans" typeface="宋体"/>', n[n.length] = '<a:font script="Hant" typeface="新細明體"/>', n[n.length] = '<a:font script="Arab" typeface="Arial"/>', n[n.length] = '<a:font script="Hebr" typeface="Arial"/>', n[n.length] = '<a:font script="Thai" typeface="Tahoma"/>', n[n.length] = '<a:font script="Ethi" typeface="Nyala"/>', n[n.length] = '<a:font script="Beng" typeface="Vrinda"/>', n[n.length] = '<a:font script="Gujr" typeface="Shruti"/>', n[n.length] = '<a:font script="Khmr" typeface="DaunPenh"/>', n[n.length] = '<a:font script="Knda" typeface="Tunga"/>', n[n.length] = '<a:font script="Guru" typeface="Raavi"/>', n[n.length] = '<a:font script="Cans" typeface="Euphemia"/>', n[n.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', n[n.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', n[n.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', n[n.length] = '<a:font script="Thaa" typeface="MV Boli"/>', n[n.length] = '<a:font script="Deva" typeface="Mangal"/>', n[n.length] = '<a:font script="Telu" typeface="Gautami"/>', n[n.length] = '<a:font script="Taml" typeface="Latha"/>', n[n.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', n[n.length] = '<a:font script="Orya" typeface="Kalinga"/>', n[n.length] = '<a:font script="Mlym" typeface="Kartika"/>', n[n.length] = '<a:font script="Laoo" typeface="DokChampa"/>', n[n.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', n[n.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', n[n.length] = '<a:font script="Viet" typeface="Arial"/>', n[n.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', n[n.length] = '<a:font script="Geor" typeface="Sylfaen"/>', n[n.length] = "</a:minorFont>", n[n.length] = "</a:fontScheme>", n[n.length] = '<a:fmtScheme name="Office">', n[n.length] = "<a:fillStyleLst>", n[n.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', n[n.length] = '<a:gradFill rotWithShape="1">', n[n.length] = "<a:gsLst>", n[n.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', n[n.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', n[n.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', n[n.length] = "</a:gsLst>", n[n.length] = '<a:lin ang="16200000" scaled="1"/>', n[n.length] = "</a:gradFill>", n[n.length] = '<a:gradFill rotWithShape="1">', n[n.length] = "<a:gsLst>", n[n.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>', n[n.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', n[n.length] = "</a:gsLst>", n[n.length] = '<a:lin ang="16200000" scaled="0"/>', n[n.length] = "</a:gradFill>", n[n.length] = "</a:fillStyleLst>", n[n.length] = "<a:lnStyleLst>", n[n.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>', n[n.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', n[n.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', n[n.length] = "</a:lnStyleLst>", n[n.length] = "<a:effectStyleLst>", n[n.length] = "<a:effectStyle>", n[n.length] = "<a:effectLst>", n[n.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>', n[n.length] = "</a:effectLst>", n[n.length] = "</a:effectStyle>", n[n.length] = "<a:effectStyle>", n[n.length] = "<a:effectLst>", n[n.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', n[n.length] = "</a:effectLst>", n[n.length] = "</a:effectStyle>", n[n.length] = "<a:effectStyle>", n[n.length] = "<a:effectLst>", n[n.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', n[n.length] = "</a:effectLst>", n[n.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>', n[n.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>', n[n.length] = "</a:effectStyle>", n[n.length] = "</a:effectStyleLst>", n[n.length] = "<a:bgFillStyleLst>", n[n.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', n[n.length] = '<a:gradFill rotWithShape="1">', n[n.length] = "<a:gsLst>", n[n.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', n[n.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', n[n.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>', n[n.length] = "</a:gsLst>", n[n.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>', n[n.length] = "</a:gradFill>", n[n.length] = '<a:gradFill rotWithShape="1">', n[n.length] = "<a:gsLst>", n[n.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', n[n.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>', n[n.length] = "</a:gsLst>", n[n.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>', n[n.length] = "</a:gradFill>", n[n.length] = "</a:bgFillStyleLst>", n[n.length] = "</a:fmtScheme>", n[n.length] = "</a:themeElements>", n[n.length] = "<a:objectDefaults>", n[n.length] = "<a:spDef>", n[n.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>', n[n.length] = "</a:spDef>", n[n.length] = "<a:lnDef>", n[n.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>', n[n.length] = "</a:lnDef>", n[n.length] = "</a:objectDefaults>", n[n.length] = "<a:extraClrSchemeLst/>", n[n.length] = "</a:theme>", n.join("");
}
function d2e(e, t, n) {
  var r = e.l + t, a = e.read_shift(4);
  if (a !== 124226) {
    if (!n.cellStyles) {
      e.l = r;
      return;
    }
    var o = e.slice(e.l);
    e.l = r;
    var i;
    try {
      i = oR(o, { type: "array" });
    } catch {
      return;
    }
    var s = Do(i, "theme/theme/theme1.xml", !0);
    if (s)
      return pN(s, n);
  }
}
function p2e(e) {
  return e.read_shift(4);
}
function h2e(e) {
  var t = {};
  switch (t.xclrType = e.read_shift(2), t.nTintShade = e.read_shift(2), t.xclrType) {
    case 0:
      e.l += 4;
      break;
    case 1:
      t.xclrValue = v2e(e, 4);
      break;
    case 2:
      t.xclrValue = GR(e);
      break;
    case 3:
      t.xclrValue = p2e(e);
      break;
    case 4:
      e.l += 4;
      break;
  }
  return e.l += 8, t;
}
function v2e(e, t) {
  return Ma(e, t);
}
function m2e(e, t) {
  return Ma(e, t);
}
function g2e(e) {
  var t = e.read_shift(2), n = e.read_shift(2) - 4, r = [t];
  switch (t) {
    case 4:
    case 5:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 13:
      r[1] = h2e(e);
      break;
    case 6:
      r[1] = m2e(e, n);
      break;
    case 14:
    case 15:
      r[1] = e.read_shift(n === 1 ? 1 : 2);
      break;
    default:
      throw new Error("Unrecognized ExtProp type: " + t + " " + n);
  }
  return r;
}
function y2e(e, t) {
  var n = e.l + t;
  e.l += 2;
  var r = e.read_shift(2);
  e.l += 2;
  for (var a = e.read_shift(2), o = []; a-- > 0; ) o.push(g2e(e, n - e.l));
  return { ixfe: r, ext: o };
}
function x2e(e, t) {
  t.forEach(function(n) {
    switch (n[0]) {
    }
  });
}
function b2e(e, t) {
  return {
    flags: e.read_shift(4),
    version: e.read_shift(4),
    name: Da(e)
  };
}
function w2e(e) {
  var t = We(12 + 2 * e.name.length);
  return t.write_shift(4, e.flags), t.write_shift(4, e.version), Wr(e.name, t), t.slice(0, t.l);
}
function S2e(e) {
  for (var t = [], n = e.read_shift(4); n-- > 0; )
    t.push([e.read_shift(4), e.read_shift(4)]);
  return t;
}
function _2e(e) {
  var t = We(4 + 8 * e.length);
  t.write_shift(4, e.length);
  for (var n = 0; n < e.length; ++n)
    t.write_shift(4, e[n][0]), t.write_shift(4, e[n][1]);
  return t;
}
function C2e(e, t) {
  var n = We(8 + 2 * t.length);
  return n.write_shift(4, e), Wr(t, n), n.slice(0, n.l);
}
function E2e(e) {
  return e.l += 4, e.read_shift(4) != 0;
}
function T2e(e, t) {
  var n = We(8);
  return n.write_shift(4, e), n.write_shift(4, 1), n;
}
function $2e(e, t, n) {
  var r = { Types: [], Cell: [], Value: [] }, a = n || {}, o = [], i = !1, s = 2;
  return fl(e, function(l, u, c) {
    switch (c) {
      case 335:
        r.Types.push({ name: l.name });
        break;
      case 51:
        l.forEach(function(f) {
          s == 1 ? r.Cell.push({ type: r.Types[f[0] - 1].name, index: f[1] }) : s == 0 && r.Value.push({ type: r.Types[f[0] - 1].name, index: f[1] });
        });
        break;
      case 337:
        s = l ? 1 : 0;
        break;
      case 338:
        s = 2;
        break;
      case 35:
        o.push(c), i = !0;
        break;
      case 36:
        o.pop(), i = !1;
        break;
      default:
        if (!u.T) {
          if (!i || a.WTF && o[o.length - 1] != 35)
            throw new Error("Unexpected record 0x" + c.toString(16));
        }
    }
  }), r;
}
function O2e() {
  var e = lo();
  return at(e, 332), at(e, 334, Vi(1)), at(e, 335, w2e({
    name: "XLDAPR",
    version: 12e4,
    flags: 3496657072
  })), at(e, 336), at(e, 339, C2e(1, "XLDAPR")), at(e, 52), at(e, 35, Vi(514)), at(e, 4096, Vi(0)), at(e, 4097, ti(1)), at(e, 36), at(e, 53), at(e, 340), at(e, 337, T2e(1)), at(e, 51, _2e([[1, 0]])), at(e, 338), at(e, 333), e.end();
}
function A2e(e, t, n) {
  var r = { Types: [], Cell: [], Value: [] };
  if (!e)
    return r;
  var a = !1, o = 2, i;
  return e.replace(Fa, function(s) {
    var l = Vt(s);
    switch (Es(l[0])) {
      case "<?xml":
        break;
      case "<metadata":
      case "</metadata>":
        break;
      case "<metadataTypes":
      case "</metadataTypes>":
        break;
      case "<metadataType":
        r.Types.push({ name: l.name });
        break;
      case "</metadataType>":
        break;
      case "<futureMetadata":
        for (var u = 0; u < r.Types.length; ++u)
          r.Types[u].name == l.name && (i = r.Types[u]);
        break;
      case "</futureMetadata>":
        break;
      case "<bk>":
        break;
      case "</bk>":
        break;
      case "<rc":
        o == 1 ? r.Cell.push({ type: r.Types[l.t - 1].name, index: +l.v }) : o == 0 && r.Value.push({ type: r.Types[l.t - 1].name, index: +l.v });
        break;
      case "</rc>":
        break;
      case "<cellMetadata":
        o = 1;
        break;
      case "</cellMetadata>":
        o = 2;
        break;
      case "<valueMetadata":
        o = 0;
        break;
      case "</valueMetadata>":
        o = 2;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      case "<rvb":
        if (!i)
          break;
        i.offsets || (i.offsets = []), i.offsets.push(+l.i);
        break;
      default:
        if (!a && n.WTF)
          throw new Error("unrecognized " + l[0] + " in metadata");
    }
    return s;
  }), r;
}
function hN() {
  var e = [Tr];
  return e.push(`<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">
  <metadataTypes count="1">
    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>
  </metadataTypes>
  <futureMetadata name="XLDAPR" count="1">
    <bk>
      <extLst>
        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">
          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>
        </ext>
      </extLst>
    </bk>
  </futureMetadata>
  <cellMetadata count="1">
    <bk>
      <rc t="1" v="0"/>
    </bk>
  </cellMetadata>
</metadata>`), e.join("");
}
function I2e(e) {
  var t = [];
  if (!e) return t;
  var n = 1;
  return (e.match(Fa) || []).forEach(function(r) {
    var a = Vt(r);
    switch (a[0]) {
      case "<?xml":
        break;
      case "<calcChain":
      case "<calcChain>":
      case "</calcChain>":
        break;
      case "<c":
        delete a[0], a.i ? n = a.i : a.i = n, t.push(a);
        break;
    }
  }), t;
}
function P2e(e) {
  var t = {};
  t.i = e.read_shift(4);
  var n = {};
  n.r = e.read_shift(4), n.c = e.read_shift(4), t.r = Kt(n);
  var r = e.read_shift(1);
  return r & 2 && (t.l = "1"), r & 8 && (t.a = "1"), t;
}
function D2e(e, t, n) {
  var r = [];
  return fl(e, function(o, i, s) {
    switch (s) {
      case 63:
        r.push(o);
        break;
      default:
        if (!i.T) throw new Error("Unexpected record 0x" + s.toString(16));
    }
  }), r;
}
function k2e(e, t, n, r) {
  if (!e) return e;
  var a = r || {}, o = !1;
  fl(e, function(s, l, u) {
    switch (u) {
      case 359:
      case 363:
      case 364:
      case 366:
      case 367:
      case 368:
      case 369:
      case 370:
      case 371:
      case 472:
      case 577:
      case 578:
      case 579:
      case 580:
      case 581:
      case 582:
      case 583:
      case 584:
      case 585:
      case 586:
      case 587:
        break;
      case 35:
        o = !0;
        break;
      case 36:
        o = !1;
        break;
      default:
        if (!l.T) {
          if (!o || a.WTF) throw new Error("Unexpected record 0x" + u.toString(16));
        }
    }
  }, a);
}
function M2e(e, t) {
  if (!e) return "??";
  var n = (e.match(/<c:chart [^>]*r:id="([^"]*)"/) || ["", ""])[1];
  return t["!id"][n].Target;
}
var mf = 1024;
function vN(e, t) {
  for (var n = [21600, 21600], r = ["m0,0l0", n[1], n[0], n[1], n[0], "0xe"].join(","), a = [
    pt("xml", null, { "xmlns:v": Oo.v, "xmlns:o": Oo.o, "xmlns:x": Oo.x, "xmlns:mv": Oo.mv }).replace(/\/>/, ">"),
    pt("o:shapelayout", pt("o:idmap", null, { "v:ext": "edit", data: e }), { "v:ext": "edit" }),
    pt("v:shapetype", [
      pt("v:stroke", null, { joinstyle: "miter" }),
      pt("v:path", null, { gradientshapeok: "t", "o:connecttype": "rect" })
    ].join(""), { id: "_x0000_t202", "o:spt": 202, coordsize: n.join(","), path: r })
  ]; mf < e * 1e3; ) mf += 1e3;
  return t.forEach(function(o) {
    var i = Nr(o[0]), s = (
      /*::(*/
      { color2: "#BEFF82", type: "gradient" }
    );
    s.type == "gradient" && (s.angle = "-180");
    var l = s.type == "gradient" ? pt("o:fill", null, { type: "gradientUnscaled", "v:ext": "view" }) : null, u = pt("v:fill", l, s), c = { on: "t", obscured: "t" };
    ++mf, a = a.concat([
      "<v:shape" + xp({
        id: "_x0000_s" + mf,
        type: "#_x0000_t202",
        style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (o[1].hidden ? ";visibility:hidden" : ""),
        fillcolor: "#ECFAD4",
        strokecolor: "#edeaa1"
      }) + ">",
      u,
      pt("v:shadow", null, c),
      pt("v:path", null, { "o:connecttype": "none" }),
      '<v:textbox><div style="text-align:left"></div></v:textbox>',
      '<x:ClientData ObjectType="Note">',
      "<x:MoveWithCells/>",
      "<x:SizeWithCells/>",
      /* Part 4 19.4.2.3 Anchor (Anchor) */
      oa("x:Anchor", [i.c + 1, 0, i.r + 1, 0, i.c + 3, 20, i.r + 5, 20].join(",")),
      oa("x:AutoFill", "False"),
      oa("x:Row", String(i.r)),
      oa("x:Column", String(i.c)),
      o[1].hidden ? "" : "<x:Visible/>",
      "</x:ClientData>",
      "</v:shape>"
    ]);
  }), a.push("</xml>"), a.join("");
}
function PO(e, t, n, r) {
  var a = Array.isArray(e), o;
  t.forEach(function(i) {
    var s = Nr(i.ref);
    if (a ? (e[s.r] || (e[s.r] = []), o = e[s.r][s.c]) : o = e[i.ref], !o) {
      o = { t: "z" }, a ? e[s.r][s.c] = o : e[i.ref] = o;
      var l = kn(e["!ref"] || "BDWGO1000001:A1");
      l.s.r > s.r && (l.s.r = s.r), l.e.r < s.r && (l.e.r = s.r), l.s.c > s.c && (l.s.c = s.c), l.e.c < s.c && (l.e.c = s.c);
      var u = vn(l);
      u !== e["!ref"] && (e["!ref"] = u);
    }
    o.c || (o.c = []);
    var c = { a: i.author, t: i.t, r: i.r, T: n };
    i.h && (c.h = i.h);
    for (var f = o.c.length - 1; f >= 0; --f) {
      if (!n && o.c[f].T) return;
      n && !o.c[f].T && o.c.splice(f, 1);
    }
    if (n && r) {
      for (f = 0; f < r.length; ++f)
        if (c.a == r[f].id) {
          c.a = r[f].name || c.a;
          break;
        }
    }
    o.c.push(c);
  });
}
function R2e(e, t) {
  if (e.match(/<(?:\w+:)?comments *\/>/)) return [];
  var n = [], r = [], a = e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
  a && a[1] && a[1].split(/<\/\w*:?author>/).forEach(function(i) {
    if (!(i === "" || i.trim() === "")) {
      var s = i.match(/<(?:\w+:)?author[^>]*>(.*)/);
      s && n.push(s[1]);
    }
  });
  var o = e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
  return o && o[1] && o[1].split(/<\/\w*:?comment>/).forEach(function(i) {
    if (!(i === "" || i.trim() === "")) {
      var s = i.match(/<(?:\w+:)?comment[^>]*>/);
      if (s) {
        var l = Vt(s[0]), u = { author: l.authorId && n[l.authorId] || "sheetjsghost", ref: l.ref, guid: l.guid }, c = Nr(l.ref);
        if (!(t.sheetRows && t.sheetRows <= c.r)) {
          var f = i.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/), d = !!f && !!f[1] && oE(f[1]) || { r: "", t: "", h: "" };
          u.r = d.r, d.r == "<t></t>" && (d.t = d.h = ""), u.t = (d.t || "").replace(/\r\n/g, `
`).replace(/\r/g, `
`), t.cellHTML && (u.h = d.h), r.push(u);
        }
      }
    }
  }), r;
}
function mN(e) {
  var t = [Tr, pt("comments", null, { xmlns: Nc[0] })], n = [];
  return t.push("<authors>"), e.forEach(function(r) {
    r[1].forEach(function(a) {
      var o = Nn(a.a);
      n.indexOf(o) == -1 && (n.push(o), t.push("<author>" + o + "</author>")), a.T && a.ID && n.indexOf("tc=" + a.ID) == -1 && (n.push("tc=" + a.ID), t.push("<author>tc=" + a.ID + "</author>"));
    });
  }), n.length == 0 && (n.push("SheetJ5"), t.push("<author>SheetJ5</author>")), t.push("</authors>"), t.push("<commentList>"), e.forEach(function(r) {
    var a = 0, o = [];
    if (r[1][0] && r[1][0].T && r[1][0].ID ? a = n.indexOf("tc=" + r[1][0].ID) : r[1].forEach(function(l) {
      l.a && (a = n.indexOf(Nn(l.a))), o.push(l.t || "");
    }), t.push('<comment ref="' + r[0] + '" authorId="' + a + '"><text>'), o.length <= 1) t.push(oa("t", Nn(o[0] || "")));
    else {
      for (var i = `Comment:
    ` + o[0] + `
`, s = 1; s < o.length; ++s) i += `Reply:
    ` + o[s] + `
`;
      t.push(oa("t", Nn(i)));
    }
    t.push("</text></comment>");
  }), t.push("</commentList>"), t.length > 2 && (t[t.length] = "</comments>", t[1] = t[1].replace("/>", ">")), t.join("");
}
function N2e(e, t) {
  var n = [], r = !1, a = {}, o = 0;
  return e.replace(Fa, function(s, l) {
    var u = Vt(s);
    switch (Es(u[0])) {
      case "<?xml":
        break;
      case "<ThreadedComments":
        break;
      case "</ThreadedComments>":
        break;
      case "<threadedComment":
        a = { author: u.personId, guid: u.id, ref: u.ref, T: 1 };
        break;
      case "</threadedComment>":
        a.t != null && n.push(a);
        break;
      case "<text>":
      case "<text":
        o = l + s.length;
        break;
      case "</text>":
        a.t = e.slice(o, l).replace(/\r\n/g, `
`).replace(/\r/g, `
`);
        break;
      case "<mentions":
      case "<mentions>":
        r = !0;
        break;
      case "</mentions>":
        r = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        r = !0;
        break;
      case "</ext>":
        r = !1;
        break;
      default:
        if (!r && t.WTF) throw new Error("unrecognized " + u[0] + " in threaded comments");
    }
    return s;
  }), n;
}
function F2e(e, t, n) {
  var r = [Tr, pt("ThreadedComments", null, { xmlns: Rr.TCMNT }).replace(/[\/]>/, ">")];
  return e.forEach(function(a) {
    var o = "";
    (a[1] || []).forEach(function(i, s) {
      if (!i.T) {
        delete i.ID;
        return;
      }
      i.a && t.indexOf(i.a) == -1 && t.push(i.a);
      var l = {
        ref: a[0],
        id: "{54EE7951-7262-4200-6969-" + ("000000000000" + n.tcid++).slice(-12) + "}"
      };
      s == 0 ? o = l.id : l.parentId = o, i.ID = l.id, i.a && (l.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + t.indexOf(i.a)).slice(-12) + "}"), r.push(pt("threadedComment", oa("text", i.t || ""), l));
    });
  }), r.push("</ThreadedComments>"), r.join("");
}
function L2e(e, t) {
  var n = [], r = !1;
  return e.replace(Fa, function(o) {
    var i = Vt(o);
    switch (Es(i[0])) {
      case "<?xml":
        break;
      case "<personList":
        break;
      case "</personList>":
        break;
      case "<person":
        n.push({ name: i.displayname, id: i.id });
        break;
      case "</person>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        r = !0;
        break;
      case "</ext>":
        r = !1;
        break;
      default:
        if (!r && t.WTF) throw new Error("unrecognized " + i[0] + " in threaded comments");
    }
    return o;
  }), n;
}
function B2e(e) {
  var t = [Tr, pt("personList", null, {
    xmlns: Rr.TCMNT,
    "xmlns:x": Nc[0]
  }).replace(/[\/]>/, ">")];
  return e.forEach(function(n, r) {
    t.push(pt("person", null, {
      displayName: n,
      id: "{54EE7950-7262-4200-6969-" + ("000000000000" + r).slice(-12) + "}",
      userId: n,
      providerId: "None"
    }));
  }), t.push("</personList>"), t.join("");
}
function H2e(e) {
  var t = {};
  t.iauthor = e.read_shift(4);
  var n = jc(e);
  return t.rfx = n.s, t.ref = Kt(n.s), e.l += 16, t;
}
function j2e(e, t) {
  return t == null && (t = We(36)), t.write_shift(4, e[1].iauthor), Pd(e[0], t), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(4, 0), t;
}
var V2e = Da;
function U2e(e) {
  return Wr(e.slice(0, 54));
}
function z2e(e, t) {
  var n = [], r = [], a = {}, o = !1;
  return fl(e, function(s, l, u) {
    switch (u) {
      case 632:
        r.push(s);
        break;
      case 635:
        a = s;
        break;
      case 637:
        a.t = s.t, a.h = s.h, a.r = s.r;
        break;
      case 636:
        if (a.author = r[a.iauthor], delete a.iauthor, t.sheetRows && a.rfx && t.sheetRows <= a.rfx.r) break;
        a.t || (a.t = ""), delete a.rfx, n.push(a);
        break;
      case 3072:
        break;
      case 35:
        o = !0;
        break;
      case 36:
        o = !1;
        break;
      case 37:
        break;
      case 38:
        break;
      default:
        if (!l.T) {
          if (!o || t.WTF) throw new Error("Unexpected record 0x" + u.toString(16));
        }
    }
  }), n;
}
function W2e(e) {
  var t = lo(), n = [];
  return at(
    t,
    628
    /* BrtBeginComments */
  ), at(
    t,
    630
    /* BrtBeginCommentAuthors */
  ), e.forEach(function(r) {
    r[1].forEach(function(a) {
      n.indexOf(a.a) > -1 || (n.push(a.a.slice(0, 54)), at(t, 632, U2e(a.a)));
    });
  }), at(
    t,
    631
    /* BrtEndCommentAuthors */
  ), at(
    t,
    633
    /* BrtBeginCommentList */
  ), e.forEach(function(r) {
    r[1].forEach(function(a) {
      a.iauthor = n.indexOf(a.a);
      var o = { s: Nr(r[0]), e: Nr(r[0]) };
      at(t, 635, j2e([o, a])), a.t && a.t.length > 0 && at(t, 637, p1e(a)), at(
        t,
        636
        /* BrtEndComment */
      ), delete a.iauthor;
    });
  }), at(
    t,
    634
    /* BrtEndCommentList */
  ), at(
    t,
    629
    /* BrtEndComments */
  ), t.end();
}
var G2e = "application/vnd.ms-office.vbaProject";
function K2e(e) {
  var t = Dt.utils.cfb_new({ root: "R" });
  return e.FullPaths.forEach(function(n, r) {
    if (!(n.slice(-1) === "/" || !n.match(/_VBA_PROJECT_CUR/))) {
      var a = n.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
      Dt.utils.cfb_add(t, a, e.FileIndex[r].content);
    }
  }), Dt.write(t);
}
function Y2e(e, t) {
  t.FullPaths.forEach(function(n, r) {
    if (r != 0) {
      var a = n.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
      a.slice(-1) !== "/" && Dt.utils.cfb_add(e, a, t.FileIndex[r].content);
    }
  });
}
var gN = ["xlsb", "xlsm", "xlam", "biff8", "xla"];
function q2e() {
  return { "!type": "dialog" };
}
function X2e() {
  return { "!type": "dialog" };
}
function Z2e() {
  return { "!type": "macro" };
}
function Q2e() {
  return { "!type": "macro" };
}
var Df = /* @__PURE__ */ function() {
  var e = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g, t = { r: 0, c: 0 };
  function n(r, a, o, i) {
    var s = !1, l = !1;
    o.length == 0 ? l = !0 : o.charAt(0) == "[" && (l = !0, o = o.slice(1, -1)), i.length == 0 ? s = !0 : i.charAt(0) == "[" && (s = !0, i = i.slice(1, -1));
    var u = o.length > 0 ? parseInt(o, 10) | 0 : 0, c = i.length > 0 ? parseInt(i, 10) | 0 : 0;
    return s ? c += t.c : --c, l ? u += t.r : --u, a + (s ? "" : "$") + Mr(c) + (l ? "" : "$") + Kr(u);
  }
  return function(a, o) {
    return t = o, a.replace(e, n);
  };
}(), uE = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g, cE = /* @__PURE__ */ function() {
  return function(t, n) {
    return t.replace(uE, function(r, a, o, i, s, l) {
      var u = _R(i) - (o ? 0 : n.c), c = SR(l) - (s ? 0 : n.r), f = c == 0 ? "" : s ? c + 1 : "[" + c + "]", d = u == 0 ? "" : o ? u + 1 : "[" + u + "]";
      return a + "R" + f + "C" + d;
    });
  };
}();
function yN(e, t) {
  return e.replace(uE, function(n, r, a, o, i, s) {
    return r + (a == "$" ? a + o : Mr(_R(o) + t.c)) + (i == "$" ? i + s : Kr(SR(s) + t.r));
  });
}
function J2e(e, t, n) {
  var r = hi(t), a = r.s, o = Nr(n), i = { r: o.r - a.r, c: o.c - a.c };
  return yN(e, i);
}
function ewe(e) {
  return e.length != 1;
}
function DO(e) {
  return e.replace(/_xlfn\./g, "");
}
function Ar(e) {
  e.l += 1;
}
function iu(e, t) {
  var n = e.read_shift(2);
  return [n & 16383, n >> 14 & 1, n >> 15 & 1];
}
function xN(e, t, n) {
  var r = 2;
  if (n) {
    if (n.biff >= 2 && n.biff <= 5) return bN(e);
    n.biff == 12 && (r = 4);
  }
  var a = e.read_shift(r), o = e.read_shift(r), i = iu(e), s = iu(e);
  return { s: { r: a, c: i[0], cRel: i[1], rRel: i[2] }, e: { r: o, c: s[0], cRel: s[1], rRel: s[2] } };
}
function bN(e) {
  var t = iu(e), n = iu(e), r = e.read_shift(1), a = e.read_shift(1);
  return { s: { r: t[0], c: r, cRel: t[1], rRel: t[2] }, e: { r: n[0], c: a, cRel: n[1], rRel: n[2] } };
}
function twe(e, t, n) {
  if (n.biff < 8) return bN(e);
  var r = e.read_shift(n.biff == 12 ? 4 : 2), a = e.read_shift(n.biff == 12 ? 4 : 2), o = iu(e), i = iu(e);
  return { s: { r, c: o[0], cRel: o[1], rRel: o[2] }, e: { r: a, c: i[0], cRel: i[1], rRel: i[2] } };
}
function wN(e, t, n) {
  if (n && n.biff >= 2 && n.biff <= 5) return nwe(e);
  var r = e.read_shift(n && n.biff == 12 ? 4 : 2), a = iu(e);
  return { r, c: a[0], cRel: a[1], rRel: a[2] };
}
function nwe(e) {
  var t = iu(e), n = e.read_shift(1);
  return { r: t[0], c: n, cRel: t[1], rRel: t[2] };
}
function rwe(e) {
  var t = e.read_shift(2), n = e.read_shift(2);
  return { r: t, c: n & 255, fQuoted: !!(n & 16384), cRel: n >> 15, rRel: n >> 15 };
}
function awe(e, t, n) {
  var r = n && n.biff ? n.biff : 8;
  if (r >= 2 && r <= 5) return owe(e);
  var a = e.read_shift(r >= 12 ? 4 : 2), o = e.read_shift(2), i = (o & 16384) >> 14, s = (o & 32768) >> 15;
  if (o &= 16383, s == 1) for (; a > 524287; ) a -= 1048576;
  if (i == 1) for (; o > 8191; ) o = o - 16384;
  return { r: a, c: o, cRel: i, rRel: s };
}
function owe(e) {
  var t = e.read_shift(2), n = e.read_shift(1), r = (t & 32768) >> 15, a = (t & 16384) >> 14;
  return t &= 16383, r == 1 && t >= 8192 && (t = t - 16384), a == 1 && n >= 128 && (n = n - 256), { r: t, c: n, cRel: a, rRel: r };
}
function iwe(e, t, n) {
  var r = (e[e.l++] & 96) >> 5, a = xN(e, n.biff >= 2 && n.biff <= 5 ? 6 : 8, n);
  return [r, a];
}
function swe(e, t, n) {
  var r = (e[e.l++] & 96) >> 5, a = e.read_shift(2, "i"), o = 8;
  if (n) switch (n.biff) {
    case 5:
      e.l += 12, o = 6;
      break;
    case 12:
      o = 12;
      break;
  }
  var i = xN(e, o, n);
  return [r, a, i];
}
function lwe(e, t, n) {
  var r = (e[e.l++] & 96) >> 5;
  return e.l += n && n.biff > 8 ? 12 : n.biff < 8 ? 6 : 8, [r];
}
function uwe(e, t, n) {
  var r = (e[e.l++] & 96) >> 5, a = e.read_shift(2), o = 8;
  if (n) switch (n.biff) {
    case 5:
      e.l += 12, o = 6;
      break;
    case 12:
      o = 12;
      break;
  }
  return e.l += o, [r, a];
}
function cwe(e, t, n) {
  var r = (e[e.l++] & 96) >> 5, a = twe(e, t - 1, n);
  return [r, a];
}
function fwe(e, t, n) {
  var r = (e[e.l++] & 96) >> 5;
  return e.l += n.biff == 2 ? 6 : n.biff == 12 ? 14 : 7, [r];
}
function kO(e) {
  var t = e[e.l + 1] & 1, n = 1;
  return e.l += 4, [t, n];
}
function dwe(e, t, n) {
  e.l += 2;
  for (var r = e.read_shift(n && n.biff == 2 ? 1 : 2), a = [], o = 0; o <= r; ++o) a.push(e.read_shift(n && n.biff == 2 ? 1 : 2));
  return a;
}
function pwe(e, t, n) {
  var r = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [r, e.read_shift(n && n.biff == 2 ? 1 : 2)];
}
function hwe(e, t, n) {
  var r = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [r, e.read_shift(n && n.biff == 2 ? 1 : 2)];
}
function vwe(e) {
  var t = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [t, e.read_shift(2)];
}
function mwe(e, t, n) {
  var r = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += n && n.biff == 2 ? 3 : 4, [r];
}
function SN(e) {
  var t = e.read_shift(1), n = e.read_shift(1);
  return [t, n];
}
function gwe(e) {
  return e.read_shift(2), SN(e);
}
function ywe(e) {
  return e.read_shift(2), SN(e);
}
function xwe(e, t, n) {
  var r = (e[e.l] & 96) >> 5;
  e.l += 1;
  var a = wN(e, 0, n);
  return [r, a];
}
function bwe(e, t, n) {
  var r = (e[e.l] & 96) >> 5;
  e.l += 1;
  var a = awe(e, 0, n);
  return [r, a];
}
function wwe(e, t, n) {
  var r = (e[e.l] & 96) >> 5;
  e.l += 1;
  var a = e.read_shift(2);
  n && n.biff == 5 && (e.l += 12);
  var o = wN(e, 0, n);
  return [r, a, o];
}
function Swe(e, t, n) {
  var r = (e[e.l] & 96) >> 5;
  e.l += 1;
  var a = e.read_shift(n && n.biff <= 3 ? 1 : 2);
  return [ESe[a], EN[a], r];
}
function _we(e, t, n) {
  var r = e[e.l++], a = e.read_shift(1), o = n && n.biff <= 3 ? [r == 88 ? -1 : 0, e.read_shift(1)] : Cwe(e);
  return [a, (o[0] === 0 ? EN : CSe)[o[1]]];
}
function Cwe(e) {
  return [e[e.l + 1] >> 7, e.read_shift(2) & 32767];
}
function Ewe(e, t, n) {
  e.l += n && n.biff == 2 ? 3 : 4;
}
function Twe(e, t, n) {
  if (e.l++, n && n.biff == 12) return [e.read_shift(4, "i"), 0];
  var r = e.read_shift(2), a = e.read_shift(n && n.biff == 2 ? 1 : 2);
  return [r, a];
}
function $we(e) {
  return e.l++, dl[e.read_shift(1)];
}
function Owe(e) {
  return e.l++, e.read_shift(2);
}
function Awe(e) {
  return e.l++, e.read_shift(1) !== 0;
}
function Iwe(e) {
  return e.l++, $a(e);
}
function Pwe(e, t, n) {
  return e.l++, ch(e, t - 1, n);
}
function Dwe(e, t) {
  var n = [e.read_shift(1)];
  if (t == 12) switch (n[0]) {
    case 2:
      n[0] = 4;
      break;
    case 4:
      n[0] = 16;
      break;
    case 0:
      n[0] = 1;
      break;
    case 1:
      n[0] = 2;
      break;
  }
  switch (n[0]) {
    case 4:
      n[1] = Sr(e, 1) ? "TRUE" : "FALSE", t != 12 && (e.l += 7);
      break;
    case 37:
    case 16:
      n[1] = dl[e[e.l]], e.l += t == 12 ? 4 : 8;
      break;
    case 0:
      e.l += 8;
      break;
    case 1:
      n[1] = $a(e);
      break;
    case 2:
      n[1] = Vc(e, 0, { biff: t > 0 && t < 8 ? 2 : t });
      break;
    default:
      throw new Error("Bad SerAr: " + n[0]);
  }
  return n;
}
function kwe(e, t, n) {
  for (var r = e.read_shift(n.biff == 12 ? 4 : 2), a = [], o = 0; o != r; ++o) a.push((n.biff == 12 ? jc : z1)(e));
  return a;
}
function Mwe(e, t, n) {
  var r = 0, a = 0;
  n.biff == 12 ? (r = e.read_shift(4), a = e.read_shift(4)) : (a = 1 + e.read_shift(1), r = 1 + e.read_shift(2)), n.biff >= 2 && n.biff < 8 && (--r, --a == 0 && (a = 256));
  for (var o = 0, i = []; o != r && (i[o] = []); ++o)
    for (var s = 0; s != a; ++s) i[o][s] = Dwe(e, n.biff);
  return i;
}
function Rwe(e, t, n) {
  var r = e.read_shift(1) >>> 5 & 3, a = !n || n.biff >= 8 ? 4 : 2, o = e.read_shift(a);
  switch (n.biff) {
    case 2:
      e.l += 5;
      break;
    case 3:
    case 4:
      e.l += 8;
      break;
    case 5:
      e.l += 12;
      break;
  }
  return [r, 0, o];
}
function Nwe(e, t, n) {
  if (n.biff == 5) return Fwe(e);
  var r = e.read_shift(1) >>> 5 & 3, a = e.read_shift(2), o = e.read_shift(4);
  return [r, a, o];
}
function Fwe(e) {
  var t = e.read_shift(1) >>> 5 & 3, n = e.read_shift(2, "i");
  e.l += 8;
  var r = e.read_shift(2);
  return e.l += 12, [t, n, r];
}
function Lwe(e, t, n) {
  var r = e.read_shift(1) >>> 5 & 3;
  e.l += n && n.biff == 2 ? 3 : 4;
  var a = e.read_shift(n && n.biff == 2 ? 1 : 2);
  return [r, a];
}
function Bwe(e, t, n) {
  var r = e.read_shift(1) >>> 5 & 3, a = e.read_shift(n && n.biff == 2 ? 1 : 2);
  return [r, a];
}
function Hwe(e, t, n) {
  var r = e.read_shift(1) >>> 5 & 3;
  return e.l += 4, n.biff < 8 && e.l--, n.biff == 12 && (e.l += 2), [r];
}
function jwe(e, t, n) {
  var r = (e[e.l++] & 96) >> 5, a = e.read_shift(2), o = 4;
  if (n) switch (n.biff) {
    case 5:
      o = 15;
      break;
    case 12:
      o = 6;
      break;
  }
  return e.l += o, [r, a];
}
var Vwe = Ma, Uwe = Ma, zwe = Ma;
function dh(e, t, n) {
  return e.l += 2, [rwe(e)];
}
function fE(e) {
  return e.l += 6, [];
}
var Wwe = dh, Gwe = fE, Kwe = fE, Ywe = dh;
function _N(e) {
  return e.l += 2, [Dr(e), e.read_shift(2) & 1];
}
var qwe = dh, Xwe = _N, Zwe = fE, Qwe = dh, Jwe = dh, eSe = [
  "Data",
  "All",
  "Headers",
  "??",
  "?Data2",
  "??",
  "?DataHeaders",
  "??",
  "Totals",
  "??",
  "??",
  "??",
  "?DataTotals",
  "??",
  "??",
  "??",
  "?Current"
];
function tSe(e) {
  e.l += 2;
  var t = e.read_shift(2), n = e.read_shift(2), r = e.read_shift(4), a = e.read_shift(2), o = e.read_shift(2), i = eSe[n >> 2 & 31];
  return { ixti: t, coltype: n & 3, rt: i, idx: r, c: a, C: o };
}
function nSe(e) {
  return e.l += 2, [e.read_shift(4)];
}
function rSe(e, t, n) {
  return e.l += 5, e.l += 2, e.l += n.biff == 2 ? 1 : 4, ["PTGSHEET"];
}
function aSe(e, t, n) {
  return e.l += n.biff == 2 ? 4 : 5, ["PTGENDSHEET"];
}
function oSe(e) {
  var t = e.read_shift(1) >>> 5 & 3, n = e.read_shift(2);
  return [t, n];
}
function iSe(e) {
  var t = e.read_shift(1) >>> 5 & 3, n = e.read_shift(2);
  return [t, n];
}
function sSe(e) {
  return e.l += 4, [0, 0];
}
var MO = {
  /*::[*/
  1: { n: "PtgExp", f: Twe },
  /*::[*/
  2: { n: "PtgTbl", f: zwe },
  /*::[*/
  3: { n: "PtgAdd", f: Ar },
  /*::[*/
  4: { n: "PtgSub", f: Ar },
  /*::[*/
  5: { n: "PtgMul", f: Ar },
  /*::[*/
  6: { n: "PtgDiv", f: Ar },
  /*::[*/
  7: { n: "PtgPower", f: Ar },
  /*::[*/
  8: { n: "PtgConcat", f: Ar },
  /*::[*/
  9: { n: "PtgLt", f: Ar },
  /*::[*/
  10: { n: "PtgLe", f: Ar },
  /*::[*/
  11: { n: "PtgEq", f: Ar },
  /*::[*/
  12: { n: "PtgGe", f: Ar },
  /*::[*/
  13: { n: "PtgGt", f: Ar },
  /*::[*/
  14: { n: "PtgNe", f: Ar },
  /*::[*/
  15: { n: "PtgIsect", f: Ar },
  /*::[*/
  16: { n: "PtgUnion", f: Ar },
  /*::[*/
  17: { n: "PtgRange", f: Ar },
  /*::[*/
  18: { n: "PtgUplus", f: Ar },
  /*::[*/
  19: { n: "PtgUminus", f: Ar },
  /*::[*/
  20: { n: "PtgPercent", f: Ar },
  /*::[*/
  21: { n: "PtgParen", f: Ar },
  /*::[*/
  22: { n: "PtgMissArg", f: Ar },
  /*::[*/
  23: { n: "PtgStr", f: Pwe },
  /*::[*/
  26: { n: "PtgSheet", f: rSe },
  /*::[*/
  27: { n: "PtgEndSheet", f: aSe },
  /*::[*/
  28: { n: "PtgErr", f: $we },
  /*::[*/
  29: { n: "PtgBool", f: Awe },
  /*::[*/
  30: { n: "PtgInt", f: Owe },
  /*::[*/
  31: { n: "PtgNum", f: Iwe },
  /*::[*/
  32: { n: "PtgArray", f: fwe },
  /*::[*/
  33: { n: "PtgFunc", f: Swe },
  /*::[*/
  34: { n: "PtgFuncVar", f: _we },
  /*::[*/
  35: { n: "PtgName", f: Rwe },
  /*::[*/
  36: { n: "PtgRef", f: xwe },
  /*::[*/
  37: { n: "PtgArea", f: iwe },
  /*::[*/
  38: { n: "PtgMemArea", f: Lwe },
  /*::[*/
  39: { n: "PtgMemErr", f: Vwe },
  /*::[*/
  40: { n: "PtgMemNoMem", f: Uwe },
  /*::[*/
  41: { n: "PtgMemFunc", f: Bwe },
  /*::[*/
  42: { n: "PtgRefErr", f: Hwe },
  /*::[*/
  43: { n: "PtgAreaErr", f: lwe },
  /*::[*/
  44: { n: "PtgRefN", f: bwe },
  /*::[*/
  45: { n: "PtgAreaN", f: cwe },
  /*::[*/
  46: { n: "PtgMemAreaN", f: oSe },
  /*::[*/
  47: { n: "PtgMemNoMemN", f: iSe },
  /*::[*/
  57: { n: "PtgNameX", f: Nwe },
  /*::[*/
  58: { n: "PtgRef3d", f: wwe },
  /*::[*/
  59: { n: "PtgArea3d", f: swe },
  /*::[*/
  60: { n: "PtgRefErr3d", f: jwe },
  /*::[*/
  61: { n: "PtgAreaErr3d", f: uwe },
  /*::[*/
  255: {}
}, lSe = {
  /*::[*/
  64: 32,
  /*::[*/
  96: 32,
  /*::[*/
  65: 33,
  /*::[*/
  97: 33,
  /*::[*/
  66: 34,
  /*::[*/
  98: 34,
  /*::[*/
  67: 35,
  /*::[*/
  99: 35,
  /*::[*/
  68: 36,
  /*::[*/
  100: 36,
  /*::[*/
  69: 37,
  /*::[*/
  101: 37,
  /*::[*/
  70: 38,
  /*::[*/
  102: 38,
  /*::[*/
  71: 39,
  /*::[*/
  103: 39,
  /*::[*/
  72: 40,
  /*::[*/
  104: 40,
  /*::[*/
  73: 41,
  /*::[*/
  105: 41,
  /*::[*/
  74: 42,
  /*::[*/
  106: 42,
  /*::[*/
  75: 43,
  /*::[*/
  107: 43,
  /*::[*/
  76: 44,
  /*::[*/
  108: 44,
  /*::[*/
  77: 45,
  /*::[*/
  109: 45,
  /*::[*/
  78: 46,
  /*::[*/
  110: 46,
  /*::[*/
  79: 47,
  /*::[*/
  111: 47,
  /*::[*/
  88: 34,
  /*::[*/
  120: 34,
  /*::[*/
  89: 57,
  /*::[*/
  121: 57,
  /*::[*/
  90: 58,
  /*::[*/
  122: 58,
  /*::[*/
  91: 59,
  /*::[*/
  123: 59,
  /*::[*/
  92: 60,
  /*::[*/
  124: 60,
  /*::[*/
  93: 61,
  /*::[*/
  125: 61
}, uSe = {
  /*::[*/
  1: { n: "PtgElfLel", f: _N },
  /*::[*/
  2: { n: "PtgElfRw", f: Qwe },
  /*::[*/
  3: { n: "PtgElfCol", f: Wwe },
  /*::[*/
  6: { n: "PtgElfRwV", f: Jwe },
  /*::[*/
  7: { n: "PtgElfColV", f: Ywe },
  /*::[*/
  10: { n: "PtgElfRadical", f: qwe },
  /*::[*/
  11: { n: "PtgElfRadicalS", f: Zwe },
  /*::[*/
  13: { n: "PtgElfColS", f: Gwe },
  /*::[*/
  15: { n: "PtgElfColSV", f: Kwe },
  /*::[*/
  16: { n: "PtgElfRadicalLel", f: Xwe },
  /*::[*/
  25: { n: "PtgList", f: tSe },
  /*::[*/
  29: { n: "PtgSxName", f: nSe },
  /*::[*/
  255: {}
}, cSe = {
  /*::[*/
  0: { n: "PtgAttrNoop", f: sSe },
  /*::[*/
  1: { n: "PtgAttrSemi", f: mwe },
  /*::[*/
  2: { n: "PtgAttrIf", f: hwe },
  /*::[*/
  4: { n: "PtgAttrChoose", f: dwe },
  /*::[*/
  8: { n: "PtgAttrGoto", f: pwe },
  /*::[*/
  16: { n: "PtgAttrSum", f: Ewe },
  /*::[*/
  32: { n: "PtgAttrBaxcel", f: kO },
  /*::[*/
  33: { n: "PtgAttrBaxcel", f: kO },
  /*::[*/
  64: { n: "PtgAttrSpace", f: gwe },
  /*::[*/
  65: { n: "PtgAttrSpaceSemi", f: ywe },
  /*::[*/
  128: { n: "PtgAttrIfError", f: vwe },
  /*::[*/
  255: {}
};
function ph(e, t, n, r) {
  if (r.biff < 8) return Ma(e, t);
  for (var a = e.l + t, o = [], i = 0; i !== n.length; ++i)
    switch (n[i][0]) {
      case "PtgArray":
        n[i][1] = Mwe(e, 0, r), o.push(n[i][1]);
        break;
      case "PtgMemArea":
        n[i][2] = kwe(e, n[i][1], r), o.push(n[i][2]);
        break;
      case "PtgExp":
        r && r.biff == 12 && (n[i][1][1] = e.read_shift(4), o.push(n[i][1]));
        break;
      case "PtgList":
      case "PtgElfRadicalS":
      case "PtgElfColS":
      case "PtgElfColSV":
        throw "Unsupported " + n[i][0];
    }
  return t = a - e.l, t !== 0 && o.push(Ma(e, t)), o;
}
function hh(e, t, n) {
  for (var r = e.l + t, a, o, i = []; r != e.l; )
    t = r - e.l, o = e[e.l], a = MO[o] || MO[lSe[o]], (o === 24 || o === 25) && (a = (o === 24 ? uSe : cSe)[e[e.l + 1]]), !a || !a.f ? Ma(e, t) : i.push([a.n, a.f(e, t, n)]);
  return i;
}
function fSe(e) {
  for (var t = [], n = 0; n < e.length; ++n) {
    for (var r = e[n], a = [], o = 0; o < r.length; ++o) {
      var i = r[o];
      if (i) switch (i[0]) {
        case 2:
          a.push('"' + i[1].replace(/"/g, '""') + '"');
          break;
        default:
          a.push(i[1]);
      }
      else a.push("");
    }
    t.push(a.join(","));
  }
  return t.join(";");
}
var dSe = {
  PtgAdd: "+",
  PtgConcat: "&",
  PtgDiv: "/",
  PtgEq: "=",
  PtgGe: ">=",
  PtgGt: ">",
  PtgLe: "<=",
  PtgLt: "<",
  PtgMul: "*",
  PtgNe: "<>",
  PtgPower: "^",
  PtgSub: "-"
};
function pSe(e, t) {
  if (!e && !(t && t.biff <= 5 && t.biff >= 2)) throw new Error("empty sheet name");
  return /[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(e) ? "'" + e + "'" : e;
}
function CN(e, t, n) {
  if (!e) return "SH33TJSERR0";
  if (n.biff > 8 && (!e.XTI || !e.XTI[t])) return e.SheetNames[t];
  if (!e.XTI) return "SH33TJSERR6";
  var r = e.XTI[t];
  if (n.biff < 8)
    return t > 1e4 && (t -= 65536), t < 0 && (t = -t), t == 0 ? "" : e.XTI[t - 1];
  if (!r) return "SH33TJSERR1";
  var a = "";
  if (n.biff > 8) switch (e[r[0]][0]) {
    case 357:
      return a = r[1] == -1 ? "#REF" : e.SheetNames[r[1]], r[1] == r[2] ? a : a + ":" + e.SheetNames[r[2]];
    case 358:
      return n.SID != null ? e.SheetNames[n.SID] : "SH33TJSSAME" + e[r[0]][0];
    case 355:
    default:
      return "SH33TJSSRC" + e[r[0]][0];
  }
  switch (e[r[0]][0][0]) {
    case 1025:
      return a = r[1] == -1 ? "#REF" : e.SheetNames[r[1]] || "SH33TJSERR3", r[1] == r[2] ? a : a + ":" + e.SheetNames[r[2]];
    case 14849:
      return e[r[0]].slice(1).map(function(o) {
        return o.Name;
      }).join(";;");
    default:
      return e[r[0]][0][3] ? (a = r[1] == -1 ? "#REF" : e[r[0]][0][3][r[1]] || "SH33TJSERR4", r[1] == r[2] ? a : a + ":" + e[r[0]][0][3][r[2]]) : "SH33TJSERR2";
  }
}
function RO(e, t, n) {
  var r = CN(e, t, n);
  return r == "#REF" ? r : pSe(r, n);
}
function wa(e, t, n, r, a) {
  var o = a && a.biff || 8, i = (
    /*range != null ? range :*/
    { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } }
  ), s = [], l, u, c, f = 0, d = 0, p, v = "";
  if (!e[0] || !e[0][0]) return "";
  for (var h = -1, m = "", y = 0, x = e[0].length; y < x; ++y) {
    var g = e[0][y];
    switch (g[0]) {
      case "PtgUminus":
        s.push("-" + s.pop());
        break;
      case "PtgUplus":
        s.push("+" + s.pop());
        break;
      case "PtgPercent":
        s.push(s.pop() + "%");
        break;
      case "PtgAdd":
      case "PtgConcat":
      case "PtgDiv":
      case "PtgEq":
      case "PtgGe":
      case "PtgGt":
      case "PtgLe":
      case "PtgLt":
      case "PtgMul":
      case "PtgNe":
      case "PtgPower":
      case "PtgSub":
        if (l = s.pop(), u = s.pop(), h >= 0) {
          switch (e[0][h][1][0]) {
            case 0:
              m = hr(" ", e[0][h][1][1]);
              break;
            case 1:
              m = hr("\r", e[0][h][1][1]);
              break;
            default:
              if (m = "", a.WTF) throw new Error("Unexpected PtgAttrSpaceType " + e[0][h][1][0]);
          }
          u = u + m, h = -1;
        }
        s.push(u + dSe[g[0]] + l);
        break;
      case "PtgIsect":
        l = s.pop(), u = s.pop(), s.push(u + " " + l);
        break;
      case "PtgUnion":
        l = s.pop(), u = s.pop(), s.push(u + "," + l);
        break;
      case "PtgRange":
        l = s.pop(), u = s.pop(), s.push(u + ":" + l);
        break;
      case "PtgAttrChoose":
        break;
      case "PtgAttrGoto":
        break;
      case "PtgAttrIf":
        break;
      case "PtgAttrIfError":
        break;
      case "PtgRef":
        c = R0(g[1][1], i, a), s.push(N0(c, o));
        break;
      case "PtgRefN":
        c = n ? R0(g[1][1], n, a) : g[1][1], s.push(N0(c, o));
        break;
      case "PtgRef3d":
        f = /*::Number(*/
        g[1][1], c = R0(g[1][2], i, a), v = RO(r, f, a), s.push(v + "!" + N0(c, o));
        break;
      case "PtgFunc":
      case "PtgFuncVar":
        var S = g[1][0], w = g[1][1];
        S || (S = 0), S &= 127;
        var _ = S == 0 ? [] : s.slice(-S);
        s.length -= S, w === "User" && (w = _.shift()), s.push(w + "(" + _.join(",") + ")");
        break;
      case "PtgBool":
        s.push(g[1] ? "TRUE" : "FALSE");
        break;
      case "PtgInt":
        s.push(
          /*::String(*/
          g[1]
          /*::)*/
        );
        break;
      case "PtgNum":
        s.push(String(g[1]));
        break;
      case "PtgStr":
        s.push('"' + g[1].replace(/"/g, '""') + '"');
        break;
      case "PtgErr":
        s.push(
          /*::String(*/
          g[1]
          /*::)*/
        );
        break;
      case "PtgAreaN":
        p = cO(g[1][1], n ? { s: n } : i, a), s.push(Ix(p, a));
        break;
      case "PtgArea":
        p = cO(g[1][1], i, a), s.push(Ix(p, a));
        break;
      case "PtgArea3d":
        f = /*::Number(*/
        g[1][1], p = g[1][2], v = RO(r, f, a), s.push(v + "!" + Ix(p, a));
        break;
      case "PtgAttrSum":
        s.push("SUM(" + s.pop() + ")");
        break;
      case "PtgAttrBaxcel":
      case "PtgAttrSemi":
        break;
      case "PtgName":
        d = g[1][2];
        var b = (r.names || [])[d - 1] || (r[0] || [])[d], E = b ? b.Name : "SH33TJSNAME" + String(d);
        E && E.slice(0, 6) == "_xlfn." && !a.xlfn && (E = E.slice(6)), s.push(E);
        break;
      case "PtgNameX":
        var C = g[1][1];
        d = g[1][2];
        var T;
        if (a.biff <= 5)
          C < 0 && (C = -C), r[C] && (T = r[C][d]);
        else {
          var O = "";
          if (((r[C] || [])[0] || [])[0] == 14849 || (((r[C] || [])[0] || [])[0] == 1025 ? r[C][d] && r[C][d].itab > 0 && (O = r.SheetNames[r[C][d].itab - 1] + "!") : O = r.SheetNames[d - 1] + "!"), r[C] && r[C][d]) O += r[C][d].Name;
          else if (r[0] && r[0][d]) O += r[0][d].Name;
          else {
            var I = (CN(r, C, a) || "").split(";;");
            I[d - 1] ? O = I[d - 1] : O += "SH33TJSERRX";
          }
          s.push(O);
          break;
        }
        T || (T = { Name: "SH33TJSERRY" }), s.push(T.Name);
        break;
      case "PtgParen":
        var k = "(", B = ")";
        if (h >= 0) {
          switch (m = "", e[0][h][1][0]) {
            case 2:
              k = hr(" ", e[0][h][1][1]) + k;
              break;
            case 3:
              k = hr("\r", e[0][h][1][1]) + k;
              break;
            case 4:
              B = hr(" ", e[0][h][1][1]) + B;
              break;
            case 5:
              B = hr("\r", e[0][h][1][1]) + B;
              break;
            default:
              if (a.WTF) throw new Error("Unexpected PtgAttrSpaceType " + e[0][h][1][0]);
          }
          h = -1;
        }
        s.push(k + s.pop() + B);
        break;
      case "PtgRefErr":
        s.push("#REF!");
        break;
      case "PtgRefErr3d":
        s.push("#REF!");
        break;
      case "PtgExp":
        c = { c: g[1][1], r: g[1][0] };
        var P = { c: n.c, r: n.r };
        if (r.sharedf[Kt(c)]) {
          var N = r.sharedf[Kt(c)];
          s.push(wa(N, i, P, r, a));
        } else {
          var M = !1;
          for (l = 0; l != r.arrayf.length; ++l)
            if (u = r.arrayf[l], !(c.c < u[0].s.c || c.c > u[0].e.c) && !(c.r < u[0].s.r || c.r > u[0].e.r)) {
              s.push(wa(u[1], i, P, r, a)), M = !0;
              break;
            }
          M || s.push(
            /*::String(*/
            g[1]
            /*::)*/
          );
        }
        break;
      case "PtgArray":
        s.push("{" + fSe(
          /*::(*/
          g[1]
          /*:: :any)*/
        ) + "}");
        break;
      case "PtgMemArea":
        break;
      case "PtgAttrSpace":
      case "PtgAttrSpaceSemi":
        h = y;
        break;
      case "PtgTbl":
        break;
      case "PtgMemErr":
        break;
      case "PtgMissArg":
        s.push("");
        break;
      case "PtgAreaErr":
        s.push("#REF!");
        break;
      case "PtgAreaErr3d":
        s.push("#REF!");
        break;
      case "PtgList":
        s.push("Table" + g[1].idx + "[#" + g[1].rt + "]");
        break;
      case "PtgMemAreaN":
      case "PtgMemNoMemN":
      case "PtgAttrNoop":
      case "PtgSheet":
      case "PtgEndSheet":
        break;
      case "PtgMemFunc":
        break;
      case "PtgMemNoMem":
        break;
      case "PtgElfCol":
      case "PtgElfColS":
      case "PtgElfColSV":
      case "PtgElfColV":
      case "PtgElfLel":
      case "PtgElfRadical":
      case "PtgElfRadicalLel":
      case "PtgElfRadicalS":
      case "PtgElfRw":
      case "PtgElfRwV":
        throw new Error("Unsupported ELFs");
      case "PtgSxName":
        throw new Error("Unrecognized Formula Token: " + String(g));
      default:
        throw new Error("Unrecognized Formula Token: " + String(g));
    }
    var H = ["PtgAttrSpace", "PtgAttrSpaceSemi", "PtgAttrGoto"];
    if (a.biff != 3 && h >= 0 && H.indexOf(e[0][y][0]) == -1) {
      g = e[0][h];
      var R = !0;
      switch (g[1][0]) {
        case 4:
          R = !1;
        case 0:
          m = hr(" ", g[1][1]);
          break;
        case 5:
          R = !1;
        case 1:
          m = hr("\r", g[1][1]);
          break;
        default:
          if (m = "", a.WTF) throw new Error("Unexpected PtgAttrSpaceType " + g[1][0]);
      }
      s.push((R ? m : "") + s.pop() + (R ? "" : m)), h = -1;
    }
  }
  if (s.length > 1 && a.WTF) throw new Error("bad formula stack");
  return s[0];
}
function hSe(e, t, n) {
  var r = e.l + t, a = n.biff == 2 ? 1 : 2, o, i = e.read_shift(a);
  if (i == 65535) return [[], Ma(e, t - 2)];
  var s = hh(e, i, n);
  return t !== i + a && (o = ph(e, t - i - a, s, n)), e.l = r, [s, o];
}
function vSe(e, t, n) {
  var r = e.l + t, a = n.biff == 2 ? 1 : 2, o, i = e.read_shift(a);
  if (i == 65535) return [[], Ma(e, t - 2)];
  var s = hh(e, i, n);
  return t !== i + a && (o = ph(e, t - i - a, s, n)), e.l = r, [s, o];
}
function mSe(e, t, n, r) {
  var a = e.l + t, o = hh(e, r, n), i;
  return a !== e.l && (i = ph(e, a - e.l, o, n)), [o, i];
}
function gSe(e, t, n) {
  var r = e.l + t, a, o = e.read_shift(2), i = hh(e, o, n);
  return o == 65535 ? [[], Ma(e, t - 2)] : (t !== o + 2 && (a = ph(e, r - o - 2, i, n)), [i, a]);
}
function ySe(e) {
  var t;
  if (zs(e, e.l + 6) !== 65535) return [$a(e), "n"];
  switch (e[e.l]) {
    case 0:
      return e.l += 8, ["String", "s"];
    case 1:
      return t = e[e.l + 2] === 1, e.l += 8, [t, "b"];
    case 2:
      return t = e[e.l + 2], e.l += 8, [t, "e"];
    case 3:
      return e.l += 8, ["", "s"];
  }
  return [];
}
function xSe(e) {
  if (e == null) {
    var t = We(8);
    return t.write_shift(1, 3), t.write_shift(1, 0), t.write_shift(2, 0), t.write_shift(2, 0), t.write_shift(2, 65535), t;
  } else if (typeof e == "number") return gc(e);
  return gc(0);
}
function Rx(e, t, n) {
  var r = e.l + t, a = Ts(e);
  n.biff == 2 && ++e.l;
  var o = ySe(e), i = e.read_shift(1);
  n.biff != 2 && (e.read_shift(1), n.biff >= 5 && e.read_shift(4));
  var s = vSe(e, r - e.l, n);
  return { cell: a, val: o[0], formula: s, shared: i >> 3 & 1, tt: o[1] };
}
function bSe(e, t, n, r, a) {
  var o = xc(t, n, a), i = xSe(e.v), s = We(6), l = 33;
  s.write_shift(2, l), s.write_shift(4, 0);
  for (var u = We(e.bf.length), c = 0; c < e.bf.length; ++c) u[c] = e.bf[c];
  var f = zr([o, i, s, u]);
  return f;
}
function W1(e, t, n) {
  var r = e.read_shift(4), a = hh(e, r, n), o = e.read_shift(4), i = o > 0 ? ph(e, o, a, n) : null;
  return [a, i];
}
var wSe = W1, G1 = W1, SSe = W1, _Se = W1, CSe = {
  0: "BEEP",
  1: "OPEN",
  2: "OPEN.LINKS",
  3: "CLOSE.ALL",
  4: "SAVE",
  5: "SAVE.AS",
  6: "FILE.DELETE",
  7: "PAGE.SETUP",
  8: "PRINT",
  9: "PRINTER.SETUP",
  10: "QUIT",
  11: "NEW.WINDOW",
  12: "ARRANGE.ALL",
  13: "WINDOW.SIZE",
  14: "WINDOW.MOVE",
  15: "FULL",
  16: "CLOSE",
  17: "RUN",
  22: "SET.PRINT.AREA",
  23: "SET.PRINT.TITLES",
  24: "SET.PAGE.BREAK",
  25: "REMOVE.PAGE.BREAK",
  26: "FONT",
  27: "DISPLAY",
  28: "PROTECT.DOCUMENT",
  29: "PRECISION",
  30: "A1.R1C1",
  31: "CALCULATE.NOW",
  32: "CALCULATION",
  34: "DATA.FIND",
  35: "EXTRACT",
  36: "DATA.DELETE",
  37: "SET.DATABASE",
  38: "SET.CRITERIA",
  39: "SORT",
  40: "DATA.SERIES",
  41: "TABLE",
  42: "FORMAT.NUMBER",
  43: "ALIGNMENT",
  44: "STYLE",
  45: "BORDER",
  46: "CELL.PROTECTION",
  47: "COLUMN.WIDTH",
  48: "UNDO",
  49: "CUT",
  50: "COPY",
  51: "PASTE",
  52: "CLEAR",
  53: "PASTE.SPECIAL",
  54: "EDIT.DELETE",
  55: "INSERT",
  56: "FILL.RIGHT",
  57: "FILL.DOWN",
  61: "DEFINE.NAME",
  62: "CREATE.NAMES",
  63: "FORMULA.GOTO",
  64: "FORMULA.FIND",
  65: "SELECT.LAST.CELL",
  66: "SHOW.ACTIVE.CELL",
  67: "GALLERY.AREA",
  68: "GALLERY.BAR",
  69: "GALLERY.COLUMN",
  70: "GALLERY.LINE",
  71: "GALLERY.PIE",
  72: "GALLERY.SCATTER",
  73: "COMBINATION",
  74: "PREFERRED",
  75: "ADD.OVERLAY",
  76: "GRIDLINES",
  77: "SET.PREFERRED",
  78: "AXES",
  79: "LEGEND",
  80: "ATTACH.TEXT",
  81: "ADD.ARROW",
  82: "SELECT.CHART",
  83: "SELECT.PLOT.AREA",
  84: "PATTERNS",
  85: "MAIN.CHART",
  86: "OVERLAY",
  87: "SCALE",
  88: "FORMAT.LEGEND",
  89: "FORMAT.TEXT",
  90: "EDIT.REPEAT",
  91: "PARSE",
  92: "JUSTIFY",
  93: "HIDE",
  94: "UNHIDE",
  95: "WORKSPACE",
  96: "FORMULA",
  97: "FORMULA.FILL",
  98: "FORMULA.ARRAY",
  99: "DATA.FIND.NEXT",
  100: "DATA.FIND.PREV",
  101: "FORMULA.FIND.NEXT",
  102: "FORMULA.FIND.PREV",
  103: "ACTIVATE",
  104: "ACTIVATE.NEXT",
  105: "ACTIVATE.PREV",
  106: "UNLOCKED.NEXT",
  107: "UNLOCKED.PREV",
  108: "COPY.PICTURE",
  109: "SELECT",
  110: "DELETE.NAME",
  111: "DELETE.FORMAT",
  112: "VLINE",
  113: "HLINE",
  114: "VPAGE",
  115: "HPAGE",
  116: "VSCROLL",
  117: "HSCROLL",
  118: "ALERT",
  119: "NEW",
  120: "CANCEL.COPY",
  121: "SHOW.CLIPBOARD",
  122: "MESSAGE",
  124: "PASTE.LINK",
  125: "APP.ACTIVATE",
  126: "DELETE.ARROW",
  127: "ROW.HEIGHT",
  128: "FORMAT.MOVE",
  129: "FORMAT.SIZE",
  130: "FORMULA.REPLACE",
  131: "SEND.KEYS",
  132: "SELECT.SPECIAL",
  133: "APPLY.NAMES",
  134: "REPLACE.FONT",
  135: "FREEZE.PANES",
  136: "SHOW.INFO",
  137: "SPLIT",
  138: "ON.WINDOW",
  139: "ON.DATA",
  140: "DISABLE.INPUT",
  142: "OUTLINE",
  143: "LIST.NAMES",
  144: "FILE.CLOSE",
  145: "SAVE.WORKBOOK",
  146: "DATA.FORM",
  147: "COPY.CHART",
  148: "ON.TIME",
  149: "WAIT",
  150: "FORMAT.FONT",
  151: "FILL.UP",
  152: "FILL.LEFT",
  153: "DELETE.OVERLAY",
  155: "SHORT.MENUS",
  159: "SET.UPDATE.STATUS",
  161: "COLOR.PALETTE",
  162: "DELETE.STYLE",
  163: "WINDOW.RESTORE",
  164: "WINDOW.MAXIMIZE",
  166: "CHANGE.LINK",
  167: "CALCULATE.DOCUMENT",
  168: "ON.KEY",
  169: "APP.RESTORE",
  170: "APP.MOVE",
  171: "APP.SIZE",
  172: "APP.MINIMIZE",
  173: "APP.MAXIMIZE",
  174: "BRING.TO.FRONT",
  175: "SEND.TO.BACK",
  185: "MAIN.CHART.TYPE",
  186: "OVERLAY.CHART.TYPE",
  187: "SELECT.END",
  188: "OPEN.MAIL",
  189: "SEND.MAIL",
  190: "STANDARD.FONT",
  191: "CONSOLIDATE",
  192: "SORT.SPECIAL",
  193: "GALLERY.3D.AREA",
  194: "GALLERY.3D.COLUMN",
  195: "GALLERY.3D.LINE",
  196: "GALLERY.3D.PIE",
  197: "VIEW.3D",
  198: "GOAL.SEEK",
  199: "WORKGROUP",
  200: "FILL.GROUP",
  201: "UPDATE.LINK",
  202: "PROMOTE",
  203: "DEMOTE",
  204: "SHOW.DETAIL",
  206: "UNGROUP",
  207: "OBJECT.PROPERTIES",
  208: "SAVE.NEW.OBJECT",
  209: "SHARE",
  210: "SHARE.NAME",
  211: "DUPLICATE",
  212: "APPLY.STYLE",
  213: "ASSIGN.TO.OBJECT",
  214: "OBJECT.PROTECTION",
  215: "HIDE.OBJECT",
  216: "SET.EXTRACT",
  217: "CREATE.PUBLISHER",
  218: "SUBSCRIBE.TO",
  219: "ATTRIBUTES",
  220: "SHOW.TOOLBAR",
  222: "PRINT.PREVIEW",
  223: "EDIT.COLOR",
  224: "SHOW.LEVELS",
  225: "FORMAT.MAIN",
  226: "FORMAT.OVERLAY",
  227: "ON.RECALC",
  228: "EDIT.SERIES",
  229: "DEFINE.STYLE",
  240: "LINE.PRINT",
  243: "ENTER.DATA",
  249: "GALLERY.RADAR",
  250: "MERGE.STYLES",
  251: "EDITION.OPTIONS",
  252: "PASTE.PICTURE",
  253: "PASTE.PICTURE.LINK",
  254: "SPELLING",
  256: "ZOOM",
  259: "INSERT.OBJECT",
  260: "WINDOW.MINIMIZE",
  265: "SOUND.NOTE",
  266: "SOUND.PLAY",
  267: "FORMAT.SHAPE",
  268: "EXTEND.POLYGON",
  269: "FORMAT.AUTO",
  272: "GALLERY.3D.BAR",
  273: "GALLERY.3D.SURFACE",
  274: "FILL.AUTO",
  276: "CUSTOMIZE.TOOLBAR",
  277: "ADD.TOOL",
  278: "EDIT.OBJECT",
  279: "ON.DOUBLECLICK",
  280: "ON.ENTRY",
  281: "WORKBOOK.ADD",
  282: "WORKBOOK.MOVE",
  283: "WORKBOOK.COPY",
  284: "WORKBOOK.OPTIONS",
  285: "SAVE.WORKSPACE",
  288: "CHART.WIZARD",
  289: "DELETE.TOOL",
  290: "MOVE.TOOL",
  291: "WORKBOOK.SELECT",
  292: "WORKBOOK.ACTIVATE",
  293: "ASSIGN.TO.TOOL",
  295: "COPY.TOOL",
  296: "RESET.TOOL",
  297: "CONSTRAIN.NUMERIC",
  298: "PASTE.TOOL",
  302: "WORKBOOK.NEW",
  305: "SCENARIO.CELLS",
  306: "SCENARIO.DELETE",
  307: "SCENARIO.ADD",
  308: "SCENARIO.EDIT",
  309: "SCENARIO.SHOW",
  310: "SCENARIO.SHOW.NEXT",
  311: "SCENARIO.SUMMARY",
  312: "PIVOT.TABLE.WIZARD",
  313: "PIVOT.FIELD.PROPERTIES",
  314: "PIVOT.FIELD",
  315: "PIVOT.ITEM",
  316: "PIVOT.ADD.FIELDS",
  318: "OPTIONS.CALCULATION",
  319: "OPTIONS.EDIT",
  320: "OPTIONS.VIEW",
  321: "ADDIN.MANAGER",
  322: "MENU.EDITOR",
  323: "ATTACH.TOOLBARS",
  324: "VBAActivate",
  325: "OPTIONS.CHART",
  328: "VBA.INSERT.FILE",
  330: "VBA.PROCEDURE.DEFINITION",
  336: "ROUTING.SLIP",
  338: "ROUTE.DOCUMENT",
  339: "MAIL.LOGON",
  342: "INSERT.PICTURE",
  343: "EDIT.TOOL",
  344: "GALLERY.DOUGHNUT",
  350: "CHART.TREND",
  352: "PIVOT.ITEM.PROPERTIES",
  354: "WORKBOOK.INSERT",
  355: "OPTIONS.TRANSITION",
  356: "OPTIONS.GENERAL",
  370: "FILTER.ADVANCED",
  373: "MAIL.ADD.MAILER",
  374: "MAIL.DELETE.MAILER",
  375: "MAIL.REPLY",
  376: "MAIL.REPLY.ALL",
  377: "MAIL.FORWARD",
  378: "MAIL.NEXT.LETTER",
  379: "DATA.LABEL",
  380: "INSERT.TITLE",
  381: "FONT.PROPERTIES",
  382: "MACRO.OPTIONS",
  383: "WORKBOOK.HIDE",
  384: "WORKBOOK.UNHIDE",
  385: "WORKBOOK.DELETE",
  386: "WORKBOOK.NAME",
  388: "GALLERY.CUSTOM",
  390: "ADD.CHART.AUTOFORMAT",
  391: "DELETE.CHART.AUTOFORMAT",
  392: "CHART.ADD.DATA",
  393: "AUTO.OUTLINE",
  394: "TAB.ORDER",
  395: "SHOW.DIALOG",
  396: "SELECT.ALL",
  397: "UNGROUP.SHEETS",
  398: "SUBTOTAL.CREATE",
  399: "SUBTOTAL.REMOVE",
  400: "RENAME.OBJECT",
  412: "WORKBOOK.SCROLL",
  413: "WORKBOOK.NEXT",
  414: "WORKBOOK.PREV",
  415: "WORKBOOK.TAB.SPLIT",
  416: "FULL.SCREEN",
  417: "WORKBOOK.PROTECT",
  420: "SCROLLBAR.PROPERTIES",
  421: "PIVOT.SHOW.PAGES",
  422: "TEXT.TO.COLUMNS",
  423: "FORMAT.CHARTTYPE",
  424: "LINK.FORMAT",
  425: "TRACER.DISPLAY",
  430: "TRACER.NAVIGATE",
  431: "TRACER.CLEAR",
  432: "TRACER.ERROR",
  433: "PIVOT.FIELD.GROUP",
  434: "PIVOT.FIELD.UNGROUP",
  435: "CHECKBOX.PROPERTIES",
  436: "LABEL.PROPERTIES",
  437: "LISTBOX.PROPERTIES",
  438: "EDITBOX.PROPERTIES",
  439: "PIVOT.REFRESH",
  440: "LINK.COMBO",
  441: "OPEN.TEXT",
  442: "HIDE.DIALOG",
  443: "SET.DIALOG.FOCUS",
  444: "ENABLE.OBJECT",
  445: "PUSHBUTTON.PROPERTIES",
  446: "SET.DIALOG.DEFAULT",
  447: "FILTER",
  448: "FILTER.SHOW.ALL",
  449: "CLEAR.OUTLINE",
  450: "FUNCTION.WIZARD",
  451: "ADD.LIST.ITEM",
  452: "SET.LIST.ITEM",
  453: "REMOVE.LIST.ITEM",
  454: "SELECT.LIST.ITEM",
  455: "SET.CONTROL.VALUE",
  456: "SAVE.COPY.AS",
  458: "OPTIONS.LISTS.ADD",
  459: "OPTIONS.LISTS.DELETE",
  460: "SERIES.AXES",
  461: "SERIES.X",
  462: "SERIES.Y",
  463: "ERRORBAR.X",
  464: "ERRORBAR.Y",
  465: "FORMAT.CHART",
  466: "SERIES.ORDER",
  467: "MAIL.LOGOFF",
  468: "CLEAR.ROUTING.SLIP",
  469: "APP.ACTIVATE.MICROSOFT",
  470: "MAIL.EDIT.MAILER",
  471: "ON.SHEET",
  472: "STANDARD.WIDTH",
  473: "SCENARIO.MERGE",
  474: "SUMMARY.INFO",
  475: "FIND.FILE",
  476: "ACTIVE.CELL.FONT",
  477: "ENABLE.TIPWIZARD",
  478: "VBA.MAKE.ADDIN",
  480: "INSERTDATATABLE",
  481: "WORKGROUP.OPTIONS",
  482: "MAIL.SEND.MAILER",
  485: "AUTOCORRECT",
  489: "POST.DOCUMENT",
  491: "PICKLIST",
  493: "VIEW.SHOW",
  494: "VIEW.DEFINE",
  495: "VIEW.DELETE",
  509: "SHEET.BACKGROUND",
  510: "INSERT.MAP.OBJECT",
  511: "OPTIONS.MENONO",
  517: "MSOCHECKS",
  518: "NORMAL",
  519: "LAYOUT",
  520: "RM.PRINT.AREA",
  521: "CLEAR.PRINT.AREA",
  522: "ADD.PRINT.AREA",
  523: "MOVE.BRK",
  545: "HIDECURR.NOTE",
  546: "HIDEALL.NOTES",
  547: "DELETE.NOTE",
  548: "TRAVERSE.NOTES",
  549: "ACTIVATE.NOTES",
  620: "PROTECT.REVISIONS",
  621: "UNPROTECT.REVISIONS",
  647: "OPTIONS.ME",
  653: "WEB.PUBLISH",
  667: "NEWWEBQUERY",
  673: "PIVOT.TABLE.CHART",
  753: "OPTIONS.SAVE",
  755: "OPTIONS.SPELL",
  808: "HIDEALL.INKANNOTS"
}, EN = {
  0: "COUNT",
  1: "IF",
  2: "ISNA",
  3: "ISERROR",
  4: "SUM",
  5: "AVERAGE",
  6: "MIN",
  7: "MAX",
  8: "ROW",
  9: "COLUMN",
  10: "NA",
  11: "NPV",
  12: "STDEV",
  13: "DOLLAR",
  14: "FIXED",
  15: "SIN",
  16: "COS",
  17: "TAN",
  18: "ATAN",
  19: "PI",
  20: "SQRT",
  21: "EXP",
  22: "LN",
  23: "LOG10",
  24: "ABS",
  25: "INT",
  26: "SIGN",
  27: "ROUND",
  28: "LOOKUP",
  29: "INDEX",
  30: "REPT",
  31: "MID",
  32: "LEN",
  33: "VALUE",
  34: "TRUE",
  35: "FALSE",
  36: "AND",
  37: "OR",
  38: "NOT",
  39: "MOD",
  40: "DCOUNT",
  41: "DSUM",
  42: "DAVERAGE",
  43: "DMIN",
  44: "DMAX",
  45: "DSTDEV",
  46: "VAR",
  47: "DVAR",
  48: "TEXT",
  49: "LINEST",
  50: "TREND",
  51: "LOGEST",
  52: "GROWTH",
  53: "GOTO",
  54: "HALT",
  55: "RETURN",
  56: "PV",
  57: "FV",
  58: "NPER",
  59: "PMT",
  60: "RATE",
  61: "MIRR",
  62: "IRR",
  63: "RAND",
  64: "MATCH",
  65: "DATE",
  66: "TIME",
  67: "DAY",
  68: "MONTH",
  69: "YEAR",
  70: "WEEKDAY",
  71: "HOUR",
  72: "MINUTE",
  73: "SECOND",
  74: "NOW",
  75: "AREAS",
  76: "ROWS",
  77: "COLUMNS",
  78: "OFFSET",
  79: "ABSREF",
  80: "RELREF",
  81: "ARGUMENT",
  82: "SEARCH",
  83: "TRANSPOSE",
  84: "ERROR",
  85: "STEP",
  86: "TYPE",
  87: "ECHO",
  88: "SET.NAME",
  89: "CALLER",
  90: "DEREF",
  91: "WINDOWS",
  92: "SERIES",
  93: "DOCUMENTS",
  94: "ACTIVE.CELL",
  95: "SELECTION",
  96: "RESULT",
  97: "ATAN2",
  98: "ASIN",
  99: "ACOS",
  100: "CHOOSE",
  101: "HLOOKUP",
  102: "VLOOKUP",
  103: "LINKS",
  104: "INPUT",
  105: "ISREF",
  106: "GET.FORMULA",
  107: "GET.NAME",
  108: "SET.VALUE",
  109: "LOG",
  110: "EXEC",
  111: "CHAR",
  112: "LOWER",
  113: "UPPER",
  114: "PROPER",
  115: "LEFT",
  116: "RIGHT",
  117: "EXACT",
  118: "TRIM",
  119: "REPLACE",
  120: "SUBSTITUTE",
  121: "CODE",
  122: "NAMES",
  123: "DIRECTORY",
  124: "FIND",
  125: "CELL",
  126: "ISERR",
  127: "ISTEXT",
  128: "ISNUMBER",
  129: "ISBLANK",
  130: "T",
  131: "N",
  132: "FOPEN",
  133: "FCLOSE",
  134: "FSIZE",
  135: "FREADLN",
  136: "FREAD",
  137: "FWRITELN",
  138: "FWRITE",
  139: "FPOS",
  140: "DATEVALUE",
  141: "TIMEVALUE",
  142: "SLN",
  143: "SYD",
  144: "DDB",
  145: "GET.DEF",
  146: "REFTEXT",
  147: "TEXTREF",
  148: "INDIRECT",
  149: "REGISTER",
  150: "CALL",
  151: "ADD.BAR",
  152: "ADD.MENU",
  153: "ADD.COMMAND",
  154: "ENABLE.COMMAND",
  155: "CHECK.COMMAND",
  156: "RENAME.COMMAND",
  157: "SHOW.BAR",
  158: "DELETE.MENU",
  159: "DELETE.COMMAND",
  160: "GET.CHART.ITEM",
  161: "DIALOG.BOX",
  162: "CLEAN",
  163: "MDETERM",
  164: "MINVERSE",
  165: "MMULT",
  166: "FILES",
  167: "IPMT",
  168: "PPMT",
  169: "COUNTA",
  170: "CANCEL.KEY",
  171: "FOR",
  172: "WHILE",
  173: "BREAK",
  174: "NEXT",
  175: "INITIATE",
  176: "REQUEST",
  177: "POKE",
  178: "EXECUTE",
  179: "TERMINATE",
  180: "RESTART",
  181: "HELP",
  182: "GET.BAR",
  183: "PRODUCT",
  184: "FACT",
  185: "GET.CELL",
  186: "GET.WORKSPACE",
  187: "GET.WINDOW",
  188: "GET.DOCUMENT",
  189: "DPRODUCT",
  190: "ISNONTEXT",
  191: "GET.NOTE",
  192: "NOTE",
  193: "STDEVP",
  194: "VARP",
  195: "DSTDEVP",
  196: "DVARP",
  197: "TRUNC",
  198: "ISLOGICAL",
  199: "DCOUNTA",
  200: "DELETE.BAR",
  201: "UNREGISTER",
  204: "USDOLLAR",
  205: "FINDB",
  206: "SEARCHB",
  207: "REPLACEB",
  208: "LEFTB",
  209: "RIGHTB",
  210: "MIDB",
  211: "LENB",
  212: "ROUNDUP",
  213: "ROUNDDOWN",
  214: "ASC",
  215: "DBCS",
  216: "RANK",
  219: "ADDRESS",
  220: "DAYS360",
  221: "TODAY",
  222: "VDB",
  223: "ELSE",
  224: "ELSE.IF",
  225: "END.IF",
  226: "FOR.CELL",
  227: "MEDIAN",
  228: "SUMPRODUCT",
  229: "SINH",
  230: "COSH",
  231: "TANH",
  232: "ASINH",
  233: "ACOSH",
  234: "ATANH",
  235: "DGET",
  236: "CREATE.OBJECT",
  237: "VOLATILE",
  238: "LAST.ERROR",
  239: "CUSTOM.UNDO",
  240: "CUSTOM.REPEAT",
  241: "FORMULA.CONVERT",
  242: "GET.LINK.INFO",
  243: "TEXT.BOX",
  244: "INFO",
  245: "GROUP",
  246: "GET.OBJECT",
  247: "DB",
  248: "PAUSE",
  251: "RESUME",
  252: "FREQUENCY",
  253: "ADD.TOOLBAR",
  254: "DELETE.TOOLBAR",
  255: "User",
  256: "RESET.TOOLBAR",
  257: "EVALUATE",
  258: "GET.TOOLBAR",
  259: "GET.TOOL",
  260: "SPELLING.CHECK",
  261: "ERROR.TYPE",
  262: "APP.TITLE",
  263: "WINDOW.TITLE",
  264: "SAVE.TOOLBAR",
  265: "ENABLE.TOOL",
  266: "PRESS.TOOL",
  267: "REGISTER.ID",
  268: "GET.WORKBOOK",
  269: "AVEDEV",
  270: "BETADIST",
  271: "GAMMALN",
  272: "BETAINV",
  273: "BINOMDIST",
  274: "CHIDIST",
  275: "CHIINV",
  276: "COMBIN",
  277: "CONFIDENCE",
  278: "CRITBINOM",
  279: "EVEN",
  280: "EXPONDIST",
  281: "FDIST",
  282: "FINV",
  283: "FISHER",
  284: "FISHERINV",
  285: "FLOOR",
  286: "GAMMADIST",
  287: "GAMMAINV",
  288: "CEILING",
  289: "HYPGEOMDIST",
  290: "LOGNORMDIST",
  291: "LOGINV",
  292: "NEGBINOMDIST",
  293: "NORMDIST",
  294: "NORMSDIST",
  295: "NORMINV",
  296: "NORMSINV",
  297: "STANDARDIZE",
  298: "ODD",
  299: "PERMUT",
  300: "POISSON",
  301: "TDIST",
  302: "WEIBULL",
  303: "SUMXMY2",
  304: "SUMX2MY2",
  305: "SUMX2PY2",
  306: "CHITEST",
  307: "CORREL",
  308: "COVAR",
  309: "FORECAST",
  310: "FTEST",
  311: "INTERCEPT",
  312: "PEARSON",
  313: "RSQ",
  314: "STEYX",
  315: "SLOPE",
  316: "TTEST",
  317: "PROB",
  318: "DEVSQ",
  319: "GEOMEAN",
  320: "HARMEAN",
  321: "SUMSQ",
  322: "KURT",
  323: "SKEW",
  324: "ZTEST",
  325: "LARGE",
  326: "SMALL",
  327: "QUARTILE",
  328: "PERCENTILE",
  329: "PERCENTRANK",
  330: "MODE",
  331: "TRIMMEAN",
  332: "TINV",
  334: "MOVIE.COMMAND",
  335: "GET.MOVIE",
  336: "CONCATENATE",
  337: "POWER",
  338: "PIVOT.ADD.DATA",
  339: "GET.PIVOT.TABLE",
  340: "GET.PIVOT.FIELD",
  341: "GET.PIVOT.ITEM",
  342: "RADIANS",
  343: "DEGREES",
  344: "SUBTOTAL",
  345: "SUMIF",
  346: "COUNTIF",
  347: "COUNTBLANK",
  348: "SCENARIO.GET",
  349: "OPTIONS.LISTS.GET",
  350: "ISPMT",
  351: "DATEDIF",
  352: "DATESTRING",
  353: "NUMBERSTRING",
  354: "ROMAN",
  355: "OPEN.DIALOG",
  356: "SAVE.DIALOG",
  357: "VIEW.GET",
  358: "GETPIVOTDATA",
  359: "HYPERLINK",
  360: "PHONETIC",
  361: "AVERAGEA",
  362: "MAXA",
  363: "MINA",
  364: "STDEVPA",
  365: "VARPA",
  366: "STDEVA",
  367: "VARA",
  368: "BAHTTEXT",
  369: "THAIDAYOFWEEK",
  370: "THAIDIGIT",
  371: "THAIMONTHOFYEAR",
  372: "THAINUMSOUND",
  373: "THAINUMSTRING",
  374: "THAISTRINGLENGTH",
  375: "ISTHAIDIGIT",
  376: "ROUNDBAHTDOWN",
  377: "ROUNDBAHTUP",
  378: "THAIYEAR",
  379: "RTD",
  380: "CUBEVALUE",
  381: "CUBEMEMBER",
  382: "CUBEMEMBERPROPERTY",
  383: "CUBERANKEDMEMBER",
  384: "HEX2BIN",
  385: "HEX2DEC",
  386: "HEX2OCT",
  387: "DEC2BIN",
  388: "DEC2HEX",
  389: "DEC2OCT",
  390: "OCT2BIN",
  391: "OCT2HEX",
  392: "OCT2DEC",
  393: "BIN2DEC",
  394: "BIN2OCT",
  395: "BIN2HEX",
  396: "IMSUB",
  397: "IMDIV",
  398: "IMPOWER",
  399: "IMABS",
  400: "IMSQRT",
  401: "IMLN",
  402: "IMLOG2",
  403: "IMLOG10",
  404: "IMSIN",
  405: "IMCOS",
  406: "IMEXP",
  407: "IMARGUMENT",
  408: "IMCONJUGATE",
  409: "IMAGINARY",
  410: "IMREAL",
  411: "COMPLEX",
  412: "IMSUM",
  413: "IMPRODUCT",
  414: "SERIESSUM",
  415: "FACTDOUBLE",
  416: "SQRTPI",
  417: "QUOTIENT",
  418: "DELTA",
  419: "GESTEP",
  420: "ISEVEN",
  421: "ISODD",
  422: "MROUND",
  423: "ERF",
  424: "ERFC",
  425: "BESSELJ",
  426: "BESSELK",
  427: "BESSELY",
  428: "BESSELI",
  429: "XIRR",
  430: "XNPV",
  431: "PRICEMAT",
  432: "YIELDMAT",
  433: "INTRATE",
  434: "RECEIVED",
  435: "DISC",
  436: "PRICEDISC",
  437: "YIELDDISC",
  438: "TBILLEQ",
  439: "TBILLPRICE",
  440: "TBILLYIELD",
  441: "PRICE",
  442: "YIELD",
  443: "DOLLARDE",
  444: "DOLLARFR",
  445: "NOMINAL",
  446: "EFFECT",
  447: "CUMPRINC",
  448: "CUMIPMT",
  449: "EDATE",
  450: "EOMONTH",
  451: "YEARFRAC",
  452: "COUPDAYBS",
  453: "COUPDAYS",
  454: "COUPDAYSNC",
  455: "COUPNCD",
  456: "COUPNUM",
  457: "COUPPCD",
  458: "DURATION",
  459: "MDURATION",
  460: "ODDLPRICE",
  461: "ODDLYIELD",
  462: "ODDFPRICE",
  463: "ODDFYIELD",
  464: "RANDBETWEEN",
  465: "WEEKNUM",
  466: "AMORDEGRC",
  467: "AMORLINC",
  468: "CONVERT",
  724: "SHEETJS",
  469: "ACCRINT",
  470: "ACCRINTM",
  471: "WORKDAY",
  472: "NETWORKDAYS",
  473: "GCD",
  474: "MULTINOMIAL",
  475: "LCM",
  476: "FVSCHEDULE",
  477: "CUBEKPIMEMBER",
  478: "CUBESET",
  479: "CUBESETCOUNT",
  480: "IFERROR",
  481: "COUNTIFS",
  482: "SUMIFS",
  483: "AVERAGEIF",
  484: "AVERAGEIFS"
}, ESe = {
  2: 1,
  3: 1,
  10: 0,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 0,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 2,
  30: 2,
  31: 3,
  32: 1,
  33: 1,
  34: 0,
  35: 0,
  38: 1,
  39: 2,
  40: 3,
  41: 3,
  42: 3,
  43: 3,
  44: 3,
  45: 3,
  47: 3,
  48: 2,
  53: 1,
  61: 3,
  63: 0,
  65: 3,
  66: 3,
  67: 1,
  68: 1,
  69: 1,
  70: 1,
  71: 1,
  72: 1,
  73: 1,
  74: 0,
  75: 1,
  76: 1,
  77: 1,
  79: 2,
  80: 2,
  83: 1,
  85: 0,
  86: 1,
  89: 0,
  90: 1,
  94: 0,
  95: 0,
  97: 2,
  98: 1,
  99: 1,
  101: 3,
  102: 3,
  105: 1,
  106: 1,
  108: 2,
  111: 1,
  112: 1,
  113: 1,
  114: 1,
  117: 2,
  118: 1,
  119: 4,
  121: 1,
  126: 1,
  127: 1,
  128: 1,
  129: 1,
  130: 1,
  131: 1,
  133: 1,
  134: 1,
  135: 1,
  136: 2,
  137: 2,
  138: 2,
  140: 1,
  141: 1,
  142: 3,
  143: 4,
  144: 4,
  161: 1,
  162: 1,
  163: 1,
  164: 1,
  165: 2,
  172: 1,
  175: 2,
  176: 2,
  177: 3,
  178: 2,
  179: 1,
  184: 1,
  186: 1,
  189: 3,
  190: 1,
  195: 3,
  196: 3,
  197: 1,
  198: 1,
  199: 3,
  201: 1,
  207: 4,
  210: 3,
  211: 1,
  212: 2,
  213: 2,
  214: 1,
  215: 1,
  225: 0,
  229: 1,
  230: 1,
  231: 1,
  232: 1,
  233: 1,
  234: 1,
  235: 3,
  244: 1,
  247: 4,
  252: 2,
  257: 1,
  261: 1,
  271: 1,
  273: 4,
  274: 2,
  275: 2,
  276: 2,
  277: 3,
  278: 3,
  279: 1,
  280: 3,
  281: 3,
  282: 3,
  283: 1,
  284: 1,
  285: 2,
  286: 4,
  287: 3,
  288: 2,
  289: 4,
  290: 3,
  291: 3,
  292: 3,
  293: 4,
  294: 1,
  295: 3,
  296: 1,
  297: 3,
  298: 1,
  299: 2,
  300: 3,
  301: 3,
  302: 4,
  303: 2,
  304: 2,
  305: 2,
  306: 2,
  307: 2,
  308: 2,
  309: 3,
  310: 2,
  311: 2,
  312: 2,
  313: 2,
  314: 2,
  315: 2,
  316: 4,
  325: 2,
  326: 2,
  327: 2,
  328: 2,
  331: 2,
  332: 2,
  337: 2,
  342: 1,
  343: 1,
  346: 2,
  347: 1,
  350: 4,
  351: 3,
  352: 1,
  353: 2,
  360: 1,
  368: 1,
  369: 1,
  370: 1,
  371: 1,
  372: 1,
  373: 1,
  374: 1,
  375: 1,
  376: 1,
  377: 1,
  378: 1,
  382: 3,
  385: 1,
  392: 1,
  393: 1,
  396: 2,
  397: 2,
  398: 2,
  399: 1,
  400: 1,
  401: 1,
  402: 1,
  403: 1,
  404: 1,
  405: 1,
  406: 1,
  407: 1,
  408: 1,
  409: 1,
  410: 1,
  414: 4,
  415: 1,
  416: 1,
  417: 2,
  420: 1,
  421: 1,
  422: 2,
  424: 1,
  425: 2,
  426: 2,
  427: 2,
  428: 2,
  430: 3,
  438: 3,
  439: 3,
  440: 3,
  443: 2,
  444: 2,
  445: 2,
  446: 2,
  447: 6,
  448: 6,
  449: 2,
  450: 2,
  464: 2,
  468: 3,
  476: 2,
  479: 1,
  480: 2,
  65535: 0
};
function NO(e) {
  return e.slice(0, 3) == "of:" && (e = e.slice(3)), e.charCodeAt(0) == 61 && (e = e.slice(1), e.charCodeAt(0) == 61 && (e = e.slice(1))), e = e.replace(/COM\.MICROSOFT\./g, ""), e = e.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function(t, n) {
    return n.replace(/\./g, "");
  }), e = e.replace(/\[.(#[A-Z]*[?!])\]/g, "$1"), e.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function TSe(e) {
  var t = "of:=" + e.replace(uE, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
  return t.replace(/;/g, "|").replace(/,/g, ";");
}
function Nx(e) {
  var t = e.split(":"), n = t[0].split(".")[0];
  return [n, t[0].split(".")[1] + (t.length > 1 ? ":" + (t[1].split(".")[1] || t[1].split(".")[0]) : "")];
}
function $Se(e) {
  return e.replace(/\./, "!");
}
var L0 = {}, kf = {}, B0 = typeof Map < "u";
function dE(e, t, n) {
  var r = 0, a = e.length;
  if (n) {
    if (B0 ? n.has(t) : Object.prototype.hasOwnProperty.call(n, t)) {
      for (var o = B0 ? n.get(t) : n[t]; r < o.length; ++r)
        if (e[o[r]].t === t)
          return e.Count++, o[r];
    }
  } else for (; r < a; ++r)
    if (e[r].t === t)
      return e.Count++, r;
  return e[a] = { t }, e.Count++, e.Unique++, n && (B0 ? (n.has(t) || n.set(t, []), n.get(t).push(a)) : (Object.prototype.hasOwnProperty.call(n, t) || (n[t] = []), n[t].push(a))), a;
}
function K1(e, t) {
  var n = { min: e + 1, max: e + 1 }, r = -1;
  return t.MDW && (_a = t.MDW), t.width != null ? n.customWidth = 1 : t.wpx != null ? r = Cp(t.wpx) : t.wch != null && (r = t.wch), r > -1 ? (n.width = cg(r), n.customWidth = 1) : t.width != null && (n.width = t.width), t.hidden && (n.hidden = !0), t.level != null && (n.outlineLevel = n.level = t.level), n;
}
function rc(e, t) {
  if (e) {
    var n = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
    t == "xlml" && (n = [1, 1, 1, 1, 0.5, 0.5]), e.left == null && (e.left = n[0]), e.right == null && (e.right = n[1]), e.top == null && (e.top = n[2]), e.bottom == null && (e.bottom = n[3]), e.header == null && (e.header = n[4]), e.footer == null && (e.footer = n[5]);
  }
}
function mu(e, t, n) {
  var r = n.revssf[t.z != null ? t.z : "General"], a = 60, o = e.length;
  if (r == null && n.ssf) {
    for (; a < 392; ++a) if (n.ssf[a] == null) {
      qs(t.z, a), n.ssf[a] = t.z, n.revssf[t.z] = r = a;
      break;
    }
  }
  for (a = 0; a != o; ++a) if (e[a].numFmtId === r) return a;
  return e[o] = {
    numFmtId: r,
    fontId: 0,
    fillId: 0,
    borderId: 0,
    xfId: 0,
    applyNumberFormat: 1
  }, o;
}
function TN(e, t, n, r, a, o) {
  try {
    r.cellNF && (e.z = jt[t]);
  } catch (s) {
    if (r.WTF) throw s;
  }
  if (!(e.t === "z" && !r.cellStyles)) {
    if (e.t === "d" && typeof e.v == "string" && (e.v = nr(e.v)), (!r || r.cellText !== !1) && e.t !== "z") try {
      if (jt[t] == null && qs(_ge[t] || "General", t), e.t === "e") e.w = e.w || dl[e.v];
      else if (t === 0)
        if (e.t === "n")
          (e.v | 0) === e.v ? e.w = e.v.toString(10) : e.w = mp(e.v);
        else if (e.t === "d") {
          var i = pa(e.v);
          (i | 0) === i ? e.w = i.toString(10) : e.w = mp(i);
        } else {
          if (e.v === void 0) return "";
          e.w = vc(e.v, kf);
        }
      else e.t === "d" ? e.w = pi(t, pa(e.v), kf) : e.w = pi(t, e.v, kf);
    } catch (s) {
      if (r.WTF) throw s;
    }
    if (r.cellStyles && n != null)
      try {
        e.s = o.Fills[n], e.s.fgColor && e.s.fgColor.theme && !e.s.fgColor.rgb && (e.s.fgColor.rgb = ug(a.themeElements.clrScheme[e.s.fgColor.theme].rgb, e.s.fgColor.tint || 0), r.WTF && (e.s.fgColor.raw_rgb = a.themeElements.clrScheme[e.s.fgColor.theme].rgb)), e.s.bgColor && e.s.bgColor.theme && (e.s.bgColor.rgb = ug(a.themeElements.clrScheme[e.s.bgColor.theme].rgb, e.s.bgColor.tint || 0), r.WTF && (e.s.bgColor.raw_rgb = a.themeElements.clrScheme[e.s.bgColor.theme].rgb));
      } catch (s) {
        if (r.WTF && o.Fills) throw s;
      }
  }
}
function OSe(e, t, n) {
  if (e && e["!ref"]) {
    var r = kn(e["!ref"]);
    if (r.e.c < r.s.c || r.e.r < r.s.r) throw new Error("Bad range (" + n + "): " + e["!ref"]);
  }
}
function ASe(e, t) {
  var n = kn(t);
  n.s.r <= n.e.r && n.s.c <= n.e.c && n.s.r >= 0 && n.s.c >= 0 && (e["!ref"] = vn(n));
}
var ISe = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g, PSe = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/, DSe = /<(?:\w:)?hyperlink [^>]*>/mg, kSe = /"(\w*:\w*)"/, MSe = /<(?:\w:)?col\b[^>]*[\/]?>/g, RSe = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g, NSe = /<(?:\w:)?pageMargins[^>]*\/>/g, $N = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/, FSe = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/, LSe = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
function BSe(e, t, n, r, a, o, i) {
  if (!e) return e;
  r || (r = { "!id": {} });
  var s = t.dense ? [] : {}, l = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, u = "", c = "", f = e.match(PSe);
  f ? (u = e.slice(0, f.index), c = e.slice(f.index + f[0].length)) : u = c = e;
  var d = u.match($N);
  d ? pE(d[0], s, a, n) : (d = u.match(FSe)) && jSe(d[0], d[1] || "", s, a, n);
  var p = (u.match(/<(?:\w*:)?dimension/) || { index: -1 }).index;
  if (p > 0) {
    var v = u.slice(p, p + 50).match(kSe);
    v && ASe(s, v[1]);
  }
  var h = u.match(LSe);
  h && h[1] && e_e(h[1], a);
  var m = [];
  if (t.cellStyles) {
    var y = u.match(MSe);
    y && qSe(m, y);
  }
  f && r_e(f[1], s, t, l, o, i);
  var x = c.match(RSe);
  x && (s["!autofilter"] = ZSe(x[0]));
  var g = [], S = c.match(ISe);
  if (S) for (p = 0; p != S.length; ++p)
    g[p] = kn(S[p].slice(S[p].indexOf('"') + 1));
  var w = c.match(DSe);
  w && GSe(s, w, r);
  var _ = c.match(NSe);
  if (_ && (s["!margins"] = KSe(Vt(_[0]))), !s["!ref"] && l.e.c >= l.s.c && l.e.r >= l.s.r && (s["!ref"] = vn(l)), t.sheetRows > 0 && s["!ref"]) {
    var b = kn(s["!ref"]);
    t.sheetRows <= +b.e.r && (b.e.r = t.sheetRows - 1, b.e.r > l.e.r && (b.e.r = l.e.r), b.e.r < b.s.r && (b.s.r = b.e.r), b.e.c > l.e.c && (b.e.c = l.e.c), b.e.c < b.s.c && (b.s.c = b.e.c), s["!fullref"] = s["!ref"], s["!ref"] = vn(b));
  }
  return m.length > 0 && (s["!cols"] = m), g.length > 0 && (s["!merges"] = g), s;
}
function HSe(e) {
  if (e.length === 0) return "";
  for (var t = '<mergeCells count="' + e.length + '">', n = 0; n != e.length; ++n) t += '<mergeCell ref="' + vn(e[n]) + '"/>';
  return t + "</mergeCells>";
}
function pE(e, t, n, r) {
  var a = Vt(e);
  n.Sheets[r] || (n.Sheets[r] = {}), a.codeName && (n.Sheets[r].CodeName = En(Hn(a.codeName)));
}
function jSe(e, t, n, r, a) {
  pE(e.slice(0, e.indexOf(">")), n, r, a);
}
function VSe(e, t, n, r, a) {
  var o = !1, i = {}, s = null;
  if (r.bookType !== "xlsx" && t.vbaraw) {
    var l = t.SheetNames[n];
    try {
      t.Workbook && (l = t.Workbook.Sheets[n].CodeName || l);
    } catch {
    }
    o = !0, i.codeName = as(Nn(l));
  }
  if (e && e["!outline"]) {
    var u = { summaryBelow: 1, summaryRight: 1 };
    e["!outline"].above && (u.summaryBelow = 0), e["!outline"].left && (u.summaryRight = 0), s = (s || "") + pt("outlinePr", null, u);
  }
  !o && !s || (a[a.length] = pt("sheetPr", s, i));
}
var USe = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"], zSe = [
  "formatColumns",
  "formatRows",
  "formatCells",
  "insertColumns",
  "insertRows",
  "insertHyperlinks",
  "deleteColumns",
  "deleteRows",
  "sort",
  "autoFilter",
  "pivotTables"
];
function WSe(e) {
  var t = { sheet: 1 };
  return USe.forEach(function(n) {
    e[n] != null && e[n] && (t[n] = "1");
  }), zSe.forEach(function(n) {
    e[n] != null && !e[n] && (t[n] = "0");
  }), e.password && (t.password = iE(e.password).toString(16).toUpperCase()), pt("sheetProtection", null, t);
}
function GSe(e, t, n) {
  for (var r = Array.isArray(e), a = 0; a != t.length; ++a) {
    var o = Vt(Hn(t[a]), !0);
    if (!o.ref) return;
    var i = ((n || {})["!id"] || [])[o.id];
    i ? (o.Target = i.Target, o.location && (o.Target += "#" + En(o.location))) : (o.Target = "#" + En(o.location), i = { Target: o.Target, TargetMode: "Internal" }), o.Rel = i, o.tooltip && (o.Tooltip = o.tooltip, delete o.tooltip);
    for (var s = kn(o.ref), l = s.s.r; l <= s.e.r; ++l) for (var u = s.s.c; u <= s.e.c; ++u) {
      var c = Kt({ c: u, r: l });
      r ? (e[l] || (e[l] = []), e[l][u] || (e[l][u] = { t: "z", v: void 0 }), e[l][u].l = o) : (e[c] || (e[c] = { t: "z", v: void 0 }), e[c].l = o);
    }
  }
}
function KSe(e) {
  var t = {};
  return ["left", "right", "top", "bottom", "header", "footer"].forEach(function(n) {
    e[n] && (t[n] = parseFloat(e[n]));
  }), t;
}
function YSe(e) {
  return rc(e), pt("pageMargins", null, e);
}
function qSe(e, t) {
  for (var n = !1, r = 0; r != t.length; ++r) {
    var a = Vt(t[r], !0);
    a.hidden && (a.hidden = Kn(a.hidden));
    var o = parseInt(a.min, 10) - 1, i = parseInt(a.max, 10) - 1;
    for (a.outlineLevel && (a.level = +a.outlineLevel || 0), delete a.min, delete a.max, a.width = +a.width, !n && a.width && (n = !0, sE(a.width)), ou(a); o <= i; ) e[o++] = qn(a);
  }
}
function XSe(e, t) {
  for (var n = ["<cols>"], r, a = 0; a != t.length; ++a)
    (r = t[a]) && (n[n.length] = pt("col", null, K1(a, r)));
  return n[n.length] = "</cols>", n.join("");
}
function ZSe(e) {
  var t = { ref: (e.match(/ref="([^"]*)"/) || [])[1] };
  return t;
}
function QSe(e, t, n, r) {
  var a = typeof e.ref == "string" ? e.ref : vn(e.ref);
  n.Workbook || (n.Workbook = { Sheets: [] }), n.Workbook.Names || (n.Workbook.Names = []);
  var o = n.Workbook.Names, i = hi(a);
  i.s.r == i.e.r && (i.e.r = hi(t["!ref"]).e.r, a = vn(i));
  for (var s = 0; s < o.length; ++s) {
    var l = o[s];
    if (l.Name == "_xlnm._FilterDatabase" && l.Sheet == r) {
      l.Ref = "'" + n.SheetNames[r] + "'!" + a;
      break;
    }
  }
  return s == o.length && o.push({ Name: "_xlnm._FilterDatabase", Sheet: r, Ref: "'" + n.SheetNames[r] + "'!" + a }), pt("autoFilter", null, { ref: a });
}
var JSe = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
function e_e(e, t) {
  t.Views || (t.Views = [{}]), (e.match(JSe) || []).forEach(function(n, r) {
    var a = Vt(n);
    t.Views[r] || (t.Views[r] = {}), +a.zoomScale && (t.Views[r].zoom = +a.zoomScale), Kn(a.rightToLeft) && (t.Views[r].RTL = !0);
  });
}
function t_e(e, t, n, r) {
  var a = { workbookViewId: "0" };
  return (((r || {}).Workbook || {}).Views || [])[0] && (a.rightToLeft = r.Workbook.Views[0].RTL ? "1" : "0"), pt("sheetViews", pt("sheetView", null, a), {});
}
function n_e(e, t, n, r) {
  if (e.c && n["!comments"].push([t, e.c]), e.v === void 0 && typeof e.f != "string" || e.t === "z" && !e.f) return "";
  var a = "", o = e.t, i = e.v;
  if (e.t !== "z") switch (e.t) {
    case "b":
      a = e.v ? "1" : "0";
      break;
    case "n":
      a = "" + e.v;
      break;
    case "e":
      a = dl[e.v];
      break;
    case "d":
      r && r.cellDates ? a = nr(e.v, -1).toISOString() : (e = qn(e), e.t = "n", a = "" + (e.v = pa(nr(e.v)))), typeof e.z > "u" && (e.z = jt[14]);
      break;
    default:
      a = e.v;
      break;
  }
  var s = oa("v", Nn(a)), l = { r: t }, u = mu(r.cellXfs, e, r);
  switch (u !== 0 && (l.s = u), e.t) {
    case "n":
      break;
    case "d":
      l.t = "d";
      break;
    case "b":
      l.t = "b";
      break;
    case "e":
      l.t = "e";
      break;
    case "z":
      break;
    default:
      if (e.v == null) {
        delete e.t;
        break;
      }
      if (e.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
      if (r && r.bookSST) {
        s = oa("v", "" + dE(r.Strings, e.v, r.revStrings)), l.t = "s";
        break;
      }
      l.t = "str";
      break;
  }
  if (e.t != o && (e.t = o, e.v = i), typeof e.f == "string" && e.f) {
    var c = e.F && e.F.slice(0, t.length) == t ? { t: "array", ref: e.F } : null;
    s = pt("f", Nn(e.f), c) + (e.v != null ? s : "");
  }
  return e.l && n["!links"].push([t, e.l]), e.D && (l.cm = 1), pt("c", s, l);
}
var r_e = /* @__PURE__ */ function() {
  var e = /<(?:\w+:)?c[ \/>]/, t = /<\/(?:\w+:)?row>/, n = /r=["']([^"']*)["']/, r = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/, a = /ref=["']([^"']*)["']/, o = yp("v"), i = yp("f");
  return function(l, u, c, f, d, p) {
    for (var v = 0, h = "", m = [], y = [], x = 0, g = 0, S = 0, w = "", _, b, E = 0, C = 0, T, O, I = 0, k = 0, B = Array.isArray(p.CellXf), P, N = [], M = [], H = Array.isArray(u), R = [], z = {}, W = !1, F = !!c.sheetStubs, Y = l.split(t), X = 0, q = Y.length; X != q; ++X) {
      h = Y[X].trim();
      var Q = h.length;
      if (Q !== 0) {
        var ue = 0;
        e: for (v = 0; v < Q; ++v) switch (
          /*x.charCodeAt(ri)*/
          h[v]
        ) {
          case ">":
            if (
              /*x.charCodeAt(ri-1) != 47*/
              h[v - 1] != "/"
            ) {
              ++v;
              break e;
            }
            if (c && c.cellStyles) {
              if (b = Vt(h.slice(ue, v), !0), E = b.r != null ? parseInt(b.r, 10) : E + 1, C = -1, c.sheetRows && c.sheetRows < E) continue;
              z = {}, W = !1, b.ht && (W = !0, z.hpt = parseFloat(b.ht), z.hpx = ld(z.hpt)), b.hidden == "1" && (W = !0, z.hidden = !0), b.outlineLevel != null && (W = !0, z.level = +b.outlineLevel), W && (R[E - 1] = z);
            }
            break;
          case "<":
            ue = v;
            break;
        }
        if (ue >= v) break;
        if (b = Vt(h.slice(ue, v), !0), E = b.r != null ? parseInt(b.r, 10) : E + 1, C = -1, !(c.sheetRows && c.sheetRows < E)) {
          f.s.r > E - 1 && (f.s.r = E - 1), f.e.r < E - 1 && (f.e.r = E - 1), c && c.cellStyles && (z = {}, W = !1, b.ht && (W = !0, z.hpt = parseFloat(b.ht), z.hpx = ld(z.hpt)), b.hidden == "1" && (W = !0, z.hidden = !0), b.outlineLevel != null && (W = !0, z.level = +b.outlineLevel), W && (R[E - 1] = z)), m = h.slice(v).split(e);
          for (var le = 0; le != m.length && m[le].trim().charAt(0) == "<"; ++le) ;
          for (m = m.slice(le), v = 0; v != m.length; ++v)
            if (h = m[v].trim(), h.length !== 0) {
              if (y = h.match(n), x = v, g = 0, S = 0, h = "<c " + (h.slice(0, 1) == "<" ? ">" : "") + h, y != null && y.length === 2) {
                for (x = 0, w = y[1], g = 0; g != w.length && !((S = w.charCodeAt(g) - 64) < 1 || S > 26); ++g)
                  x = 26 * x + S;
                --x, C = x;
              } else ++C;
              for (g = 0; g != h.length && h.charCodeAt(g) !== 62; ++g) ;
              if (++g, b = Vt(h.slice(0, g), !0), b.r || (b.r = Kt({ r: E - 1, c: C })), w = h.slice(g), _ = { t: "" }, (y = w.match(o)) != null && /*::cref != null && */
              y[1] !== "" && (_.v = En(y[1])), c.cellFormula) {
                if ((y = w.match(i)) != null && /*::cref != null && */
                y[1] !== "") {
                  if (_.f = En(Hn(y[1])).replace(/\r\n/g, `
`), c.xlfn || (_.f = DO(_.f)), /*::cref != null && cref[0] != null && */
                  y[0].indexOf('t="array"') > -1)
                    _.F = (w.match(a) || [])[1], _.F.indexOf(":") > -1 && N.push([kn(_.F), _.F]);
                  else if (
                    /*::cref != null && cref[0] != null && */
                    y[0].indexOf('t="shared"') > -1
                  ) {
                    O = Vt(y[0]);
                    var te = En(Hn(y[1]));
                    c.xlfn || (te = DO(te)), M[parseInt(O.si, 10)] = [O, te, b.r];
                  }
                } else (y = w.match(/<f[^>]*\/>/)) && (O = Vt(y[0]), M[O.si] && (_.f = J2e(M[O.si][1], M[O.si][2], b.r)));
                var G = Nr(b.r);
                for (g = 0; g < N.length; ++g)
                  G.r >= N[g][0].s.r && G.r <= N[g][0].e.r && G.c >= N[g][0].s.c && G.c <= N[g][0].e.c && (_.F = N[g][1]);
              }
              if (b.t == null && _.v === void 0)
                if (_.f || _.F)
                  _.v = 0, _.t = "n";
                else if (F) _.t = "z";
                else continue;
              else _.t = b.t || "n";
              switch (f.s.c > C && (f.s.c = C), f.e.c < C && (f.e.c = C), _.t) {
                case "n":
                  if (_.v == "" || _.v == null) {
                    if (!F) continue;
                    _.t = "z";
                  } else _.v = parseFloat(_.v);
                  break;
                case "s":
                  if (typeof _.v > "u") {
                    if (!F) continue;
                    _.t = "z";
                  } else
                    T = L0[parseInt(_.v, 10)], _.v = T.t, _.r = T.r, c.cellHTML && (_.h = T.h);
                  break;
                case "str":
                  _.t = "s", _.v = _.v != null ? Hn(_.v) : "", c.cellHTML && (_.h = K4(_.v));
                  break;
                case "inlineStr":
                  y = w.match(r), _.t = "s", y != null && (T = oE(y[1])) ? (_.v = T.t, c.cellHTML && (_.h = T.h)) : _.v = "";
                  break;
                case "b":
                  _.v = Kn(_.v);
                  break;
                case "d":
                  c.cellDates ? _.v = nr(_.v, 1) : (_.v = pa(nr(_.v, 1)), _.t = "n");
                  break;
                case "e":
                  (!c || c.cellText !== !1) && (_.w = _.v), _.v = AR[_.v];
                  break;
              }
              if (I = k = 0, P = null, B && b.s !== void 0 && (P = p.CellXf[b.s], P != null && (P.numFmtId != null && (I = P.numFmtId), c.cellStyles && P.fillId != null && (k = P.fillId))), TN(_, I, k, c, d, p), c.cellDates && B && _.t == "n" && Ad(jt[I]) && (_.t = "d", _.v = U1(_.v)), b.cm && c.xlmeta) {
                var oe = (c.xlmeta.Cell || [])[+b.cm - 1];
                oe && oe.type == "XLDAPR" && (_.D = !0);
              }
              if (H) {
                var L = Nr(b.r);
                u[L.r] || (u[L.r] = []), u[L.r][L.c] = _;
              } else u[b.r] = _;
            }
        }
      }
    }
    R.length > 0 && (u["!rows"] = R);
  };
}();
function a_e(e, t, n, r) {
  var a = [], o = [], i = kn(e["!ref"]), s = "", l, u = "", c = [], f = 0, d = 0, p = e["!rows"], v = Array.isArray(e), h = { r: u }, m, y = -1;
  for (d = i.s.c; d <= i.e.c; ++d) c[d] = Mr(d);
  for (f = i.s.r; f <= i.e.r; ++f) {
    for (o = [], u = Kr(f), d = i.s.c; d <= i.e.c; ++d) {
      l = c[d] + u;
      var x = v ? (e[f] || [])[d] : e[l];
      x !== void 0 && (s = n_e(x, l, e, t)) != null && o.push(s);
    }
    (o.length > 0 || p && p[f]) && (h = { r: u }, p && p[f] && (m = p[f], m.hidden && (h.hidden = 1), y = -1, m.hpx ? y = Ep(m.hpx) : m.hpt && (y = m.hpt), y > -1 && (h.ht = y, h.customHeight = 1), m.level && (h.outlineLevel = m.level)), a[a.length] = pt("row", o.join(""), h));
  }
  if (p) for (; f < p.length; ++f)
    p && p[f] && (h = { r: f + 1 }, m = p[f], m.hidden && (h.hidden = 1), y = -1, m.hpx ? y = Ep(m.hpx) : m.hpt && (y = m.hpt), y > -1 && (h.ht = y, h.customHeight = 1), m.level && (h.outlineLevel = m.level), a[a.length] = pt("row", "", h));
  return a.join("");
}
function ON(e, t, n, r) {
  var a = [Tr, pt("worksheet", null, {
    xmlns: Nc[0],
    "xmlns:r": Rr.r
  })], o = n.SheetNames[e], i = 0, s = "", l = n.Sheets[o];
  l == null && (l = {});
  var u = l["!ref"] || "A1", c = kn(u);
  if (c.e.c > 16383 || c.e.r > 1048575) {
    if (t.WTF) throw new Error("Range " + u + " exceeds format limit A1:XFD1048576");
    c.e.c = Math.min(c.e.c, 16383), c.e.r = Math.min(c.e.c, 1048575), u = vn(c);
  }
  r || (r = {}), l["!comments"] = [];
  var f = [];
  VSe(l, n, e, t, a), a[a.length] = pt("dimension", null, { ref: u }), a[a.length] = t_e(l, t, e, n), t.sheetFormat && (a[a.length] = pt("sheetFormatPr", null, {
    defaultRowHeight: t.sheetFormat.defaultRowHeight || "16",
    baseColWidth: t.sheetFormat.baseColWidth || "10",
    outlineLevelRow: t.sheetFormat.outlineLevelRow || "7"
  })), l["!cols"] != null && l["!cols"].length > 0 && (a[a.length] = XSe(l, l["!cols"])), a[i = a.length] = "<sheetData/>", l["!links"] = [], l["!ref"] != null && (s = a_e(l, t), s.length > 0 && (a[a.length] = s)), a.length > i + 1 && (a[a.length] = "</sheetData>", a[i] = a[i].replace("/>", ">")), l["!protect"] && (a[a.length] = WSe(l["!protect"])), l["!autofilter"] != null && (a[a.length] = QSe(l["!autofilter"], l, n, e)), l["!merges"] != null && l["!merges"].length > 0 && (a[a.length] = HSe(l["!merges"]));
  var d = -1, p, v = -1;
  return (
    /*::(*/
    l["!links"].length > 0 && (a[a.length] = "<hyperlinks>", l["!links"].forEach(function(h) {
      h[1].Target && (p = { ref: h[0] }, h[1].Target.charAt(0) != "#" && (v = Rn(r, -1, Nn(h[1].Target).replace(/#.*$/, ""), cn.HLINK), p["r:id"] = "rId" + v), (d = h[1].Target.indexOf("#")) > -1 && (p.location = Nn(h[1].Target.slice(d + 1))), h[1].Tooltip && (p.tooltip = Nn(h[1].Tooltip)), a[a.length] = pt("hyperlink", null, p));
    }), a[a.length] = "</hyperlinks>"), delete l["!links"], l["!margins"] != null && (a[a.length] = YSe(l["!margins"])), (!t || t.ignoreEC || t.ignoreEC == null) && (a[a.length] = oa("ignoredErrors", pt("ignoredError", null, { numberStoredAsText: 1, sqref: u }))), f.length > 0 && (v = Rn(r, -1, "../drawings/drawing" + (e + 1) + ".xml", cn.DRAW), a[a.length] = pt("drawing", null, { "r:id": "rId" + v }), l["!drawing"] = f), l["!comments"].length > 0 && (v = Rn(r, -1, "../drawings/vmlDrawing" + (e + 1) + ".vml", cn.VML), a[a.length] = pt("legacyDrawing", null, { "r:id": "rId" + v }), l["!legacy"] = v), a.length > 1 && (a[a.length] = "</worksheet>", a[1] = a[1].replace("/>", ">")), a.join("")
  );
}
function o_e(e, t) {
  var n = {}, r = e.l + t;
  n.r = e.read_shift(4), e.l += 4;
  var a = e.read_shift(2);
  e.l += 1;
  var o = e.read_shift(1);
  return e.l = r, o & 7 && (n.level = o & 7), o & 16 && (n.hidden = !0), o & 32 && (n.hpt = a / 20), n;
}
function i_e(e, t, n) {
  var r = We(145), a = (n["!rows"] || [])[e] || {};
  r.write_shift(4, e), r.write_shift(4, 0);
  var o = 320;
  a.hpx ? o = Ep(a.hpx) * 20 : a.hpt && (o = a.hpt * 20), r.write_shift(2, o), r.write_shift(1, 0);
  var i = 0;
  a.level && (i |= a.level), a.hidden && (i |= 16), (a.hpx || a.hpt) && (i |= 32), r.write_shift(1, i), r.write_shift(1, 0);
  var s = 0, l = r.l;
  r.l += 4;
  for (var u = { r: e, c: 0 }, c = 0; c < 16; ++c)
    if (!(t.s.c > c + 1 << 10 || t.e.c < c << 10)) {
      for (var f = -1, d = -1, p = c << 10; p < c + 1 << 10; ++p) {
        u.c = p;
        var v = Array.isArray(n) ? (n[u.r] || [])[u.c] : n[Kt(u)];
        v && (f < 0 && (f = p), d = p);
      }
      f < 0 || (++s, r.write_shift(4, f), r.write_shift(4, d));
    }
  var h = r.l;
  return r.l = l, r.write_shift(4, s), r.l = h, r.length > r.l ? r.slice(0, r.l) : r;
}
function s_e(e, t, n, r) {
  var a = i_e(r, n, t);
  (a.length > 17 || (t["!rows"] || [])[r]) && at(e, 0, a);
}
var l_e = jc, u_e = Pd;
function c_e() {
}
function f_e(e, t) {
  var n = {}, r = e[e.l];
  return ++e.l, n.above = !(r & 64), n.left = !(r & 128), e.l += 18, n.name = h1e(e), n;
}
function d_e(e, t, n) {
  n == null && (n = We(84 + 4 * e.length));
  var r = 192;
  t && (t.above && (r &= -65), t.left && (r &= -129)), n.write_shift(1, r);
  for (var a = 1; a < 3; ++a) n.write_shift(1, 0);
  return ig({ auto: 1 }, n), n.write_shift(-4, -1), n.write_shift(-4, -1), CR(e, n), n.slice(0, n.l);
}
function p_e(e) {
  var t = mi(e);
  return [t];
}
function h_e(e, t, n) {
  return n == null && (n = We(8)), Lc(t, n);
}
function v_e(e) {
  var t = Bc(e);
  return [t];
}
function m_e(e, t, n) {
  return n == null && (n = We(4)), Hc(t, n);
}
function g_e(e) {
  var t = mi(e), n = e.read_shift(1);
  return [t, n, "b"];
}
function y_e(e, t, n) {
  return n == null && (n = We(9)), Lc(t, n), n.write_shift(1, e.v ? 1 : 0), n;
}
function x_e(e) {
  var t = Bc(e), n = e.read_shift(1);
  return [t, n, "b"];
}
function b_e(e, t, n) {
  return n == null && (n = We(5)), Hc(t, n), n.write_shift(1, e.v ? 1 : 0), n;
}
function w_e(e) {
  var t = mi(e), n = e.read_shift(1);
  return [t, n, "e"];
}
function S_e(e, t, n) {
  return n == null && (n = We(9)), Lc(t, n), n.write_shift(1, e.v), n;
}
function __e(e) {
  var t = Bc(e), n = e.read_shift(1);
  return [t, n, "e"];
}
function C_e(e, t, n) {
  return n == null && (n = We(8)), Hc(t, n), n.write_shift(1, e.v), n.write_shift(2, 0), n.write_shift(1, 0), n;
}
function E_e(e) {
  var t = mi(e), n = e.read_shift(4);
  return [t, n, "s"];
}
function T_e(e, t, n) {
  return n == null && (n = We(12)), Lc(t, n), n.write_shift(4, t.v), n;
}
function $_e(e) {
  var t = Bc(e), n = e.read_shift(4);
  return [t, n, "s"];
}
function O_e(e, t, n) {
  return n == null && (n = We(8)), Hc(t, n), n.write_shift(4, t.v), n;
}
function A_e(e) {
  var t = mi(e), n = $a(e);
  return [t, n, "n"];
}
function I_e(e, t, n) {
  return n == null && (n = We(16)), Lc(t, n), gc(e.v, n), n;
}
function AN(e) {
  var t = Bc(e), n = $a(e);
  return [t, n, "n"];
}
function P_e(e, t, n) {
  return n == null && (n = We(12)), Hc(t, n), gc(e.v, n), n;
}
function D_e(e) {
  var t = mi(e), n = eE(e);
  return [t, n, "n"];
}
function k_e(e, t, n) {
  return n == null && (n = We(12)), Lc(t, n), ER(e.v, n), n;
}
function M_e(e) {
  var t = Bc(e), n = eE(e);
  return [t, n, "n"];
}
function R_e(e, t, n) {
  return n == null && (n = We(8)), Hc(t, n), ER(e.v, n), n;
}
function N_e(e) {
  var t = mi(e), n = Z4(e);
  return [t, n, "is"];
}
function F_e(e) {
  var t = mi(e), n = Da(e);
  return [t, n, "str"];
}
function L_e(e, t, n) {
  return n == null && (n = We(12 + 4 * e.v.length)), Lc(t, n), Wr(e.v, n), n.length > n.l ? n.slice(0, n.l) : n;
}
function B_e(e) {
  var t = Bc(e), n = Da(e);
  return [t, n, "str"];
}
function H_e(e, t, n) {
  return n == null && (n = We(8 + 4 * e.v.length)), Hc(t, n), Wr(e.v, n), n.length > n.l ? n.slice(0, n.l) : n;
}
function j_e(e, t, n) {
  var r = e.l + t, a = mi(e);
  a.r = n["!row"];
  var o = e.read_shift(1), i = [a, o, "b"];
  if (n.cellFormula) {
    e.l += 2;
    var s = G1(e, r - e.l, n);
    i[3] = wa(s, null, a, n.supbooks, n);
  } else e.l = r;
  return i;
}
function V_e(e, t, n) {
  var r = e.l + t, a = mi(e);
  a.r = n["!row"];
  var o = e.read_shift(1), i = [a, o, "e"];
  if (n.cellFormula) {
    e.l += 2;
    var s = G1(e, r - e.l, n);
    i[3] = wa(s, null, a, n.supbooks, n);
  } else e.l = r;
  return i;
}
function U_e(e, t, n) {
  var r = e.l + t, a = mi(e);
  a.r = n["!row"];
  var o = $a(e), i = [a, o, "n"];
  if (n.cellFormula) {
    e.l += 2;
    var s = G1(e, r - e.l, n);
    i[3] = wa(s, null, a, n.supbooks, n);
  } else e.l = r;
  return i;
}
function z_e(e, t, n) {
  var r = e.l + t, a = mi(e);
  a.r = n["!row"];
  var o = Da(e), i = [a, o, "str"];
  if (n.cellFormula) {
    e.l += 2;
    var s = G1(e, r - e.l, n);
    i[3] = wa(s, null, a, n.supbooks, n);
  } else e.l = r;
  return i;
}
var W_e = jc, G_e = Pd;
function K_e(e, t) {
  return t == null && (t = We(4)), t.write_shift(4, e), t;
}
function Y_e(e, t) {
  var n = e.l + t, r = jc(e), a = Q4(e), o = Da(e), i = Da(e), s = Da(e);
  e.l = n;
  var l = { rfx: r, relId: a, loc: o, display: s };
  return i && (l.Tooltip = i), l;
}
function q_e(e, t) {
  var n = We(50 + 4 * (e[1].Target.length + (e[1].Tooltip || "").length));
  Pd({ s: Nr(e[0]), e: Nr(e[0]) }, n), J4("rId" + t, n);
  var r = e[1].Target.indexOf("#"), a = r == -1 ? "" : e[1].Target.slice(r + 1);
  return Wr(a || "", n), Wr(e[1].Tooltip || "", n), Wr("", n), n.slice(0, n.l);
}
function X_e() {
}
function Z_e(e, t, n) {
  var r = e.l + t, a = TR(e), o = e.read_shift(1), i = [a];
  if (i[2] = o, n.cellFormula) {
    var s = wSe(e, r - e.l, n);
    i[1] = s;
  } else e.l = r;
  return i;
}
function Q_e(e, t, n) {
  var r = e.l + t, a = jc(e), o = [a];
  if (n.cellFormula) {
    var i = _Se(e, r - e.l, n);
    o[1] = i, e.l = r;
  } else e.l = r;
  return o;
}
function J_e(e, t, n) {
  n == null && (n = We(18));
  var r = K1(e, t);
  n.write_shift(-4, e), n.write_shift(-4, e), n.write_shift(4, (r.width || 10) * 256), n.write_shift(
    4,
    0
    /*ixfe*/
  );
  var a = 0;
  return t.hidden && (a |= 1), typeof r.width == "number" && (a |= 2), t.level && (a |= t.level << 8), n.write_shift(2, a), n;
}
var IN = ["left", "right", "top", "bottom", "header", "footer"];
function eCe(e) {
  var t = {};
  return IN.forEach(function(n) {
    t[n] = $a(e);
  }), t;
}
function tCe(e, t) {
  return t == null && (t = We(6 * 8)), rc(e), IN.forEach(function(n) {
    gc(e[n], t);
  }), t;
}
function nCe(e) {
  var t = e.read_shift(2);
  return e.l += 28, { RTL: t & 32 };
}
function rCe(e, t, n) {
  n == null && (n = We(30));
  var r = 924;
  return (((t || {}).Views || [])[0] || {}).RTL && (r |= 32), n.write_shift(2, r), n.write_shift(4, 0), n.write_shift(4, 0), n.write_shift(4, 0), n.write_shift(1, 0), n.write_shift(1, 0), n.write_shift(2, 0), n.write_shift(2, 100), n.write_shift(2, 0), n.write_shift(2, 0), n.write_shift(2, 0), n.write_shift(4, 0), n;
}
function aCe(e) {
  var t = We(24);
  return t.write_shift(4, 4), t.write_shift(4, 1), Pd(e, t), t;
}
function oCe(e, t) {
  return t == null && (t = We(16 * 4 + 2)), t.write_shift(2, e.password ? iE(e.password) : 0), t.write_shift(4, 1), [
    ["objects", !1],
    // fObjects
    ["scenarios", !1],
    // fScenarios
    ["formatCells", !0],
    // fFormatCells
    ["formatColumns", !0],
    // fFormatColumns
    ["formatRows", !0],
    // fFormatRows
    ["insertColumns", !0],
    // fInsertColumns
    ["insertRows", !0],
    // fInsertRows
    ["insertHyperlinks", !0],
    // fInsertHyperlinks
    ["deleteColumns", !0],
    // fDeleteColumns
    ["deleteRows", !0],
    // fDeleteRows
    ["selectLockedCells", !1],
    // fSelLockedCells
    ["sort", !0],
    // fSort
    ["autoFilter", !0],
    // fAutoFilter
    ["pivotTables", !0],
    // fPivotTables
    ["selectUnlockedCells", !1]
    // fSelUnlockedCells
  ].forEach(function(n) {
    n[1] ? t.write_shift(4, e[n[0]] != null && !e[n[0]] ? 1 : 0) : t.write_shift(4, e[n[0]] != null && e[n[0]] ? 0 : 1);
  }), t;
}
function iCe() {
}
function sCe() {
}
function lCe(e, t, n, r, a, o, i) {
  if (!e) return e;
  var s = t || {};
  r || (r = { "!id": {} });
  var l = s.dense ? [] : {}, u, c = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, f = !1, d = !1, p, v, h, m, y, x, g, S, w, _ = [];
  s.biff = 12, s["!row"] = 0;
  var b = 0, E = !1, C = [], T = {}, O = s.supbooks || /*::(*/
  a.supbooks || [[]];
  if (O.sharedf = T, O.arrayf = C, O.SheetNames = a.SheetNames || a.Sheets.map(function(H) {
    return H.name;
  }), !s.supbooks && (s.supbooks = O, a.Names))
    for (var I = 0; I < a.Names.length; ++I) O[0][I + 1] = a.Names[I];
  var k = [], B = [], P = !1;
  Tp[16] = { n: "BrtShortReal", f: AN };
  var N;
  if (fl(e, function(R, z, W) {
    if (!d)
      switch (W) {
        case 148:
          u = R;
          break;
        case 0:
          p = R, s.sheetRows && s.sheetRows <= p.r && (d = !0), S = Kr(m = p.r), s["!row"] = p.r, (R.hidden || R.hpt || R.level != null) && (R.hpt && (R.hpx = ld(R.hpt)), B[R.r] = R);
          break;
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 62:
          switch (v = { t: R[2] }, R[2]) {
            case "n":
              v.v = R[1];
              break;
            case "s":
              g = L0[R[1]], v.v = g.t, v.r = g.r;
              break;
            case "b":
              v.v = !!R[1];
              break;
            case "e":
              v.v = R[1], s.cellText !== !1 && (v.w = dl[v.v]);
              break;
            case "str":
              v.t = "s", v.v = R[1];
              break;
            case "is":
              v.t = "s", v.v = R[1].t;
              break;
          }
          if ((h = i.CellXf[R[0].iStyleRef]) && TN(v, h.numFmtId, null, s, o, i), y = R[0].c == -1 ? y + 1 : R[0].c, s.dense ? (l[m] || (l[m] = []), l[m][y] = v) : l[Mr(y) + S] = v, s.cellFormula) {
            for (E = !1, b = 0; b < C.length; ++b) {
              var F = C[b];
              p.r >= F[0].s.r && p.r <= F[0].e.r && y >= F[0].s.c && y <= F[0].e.c && (v.F = vn(F[0]), E = !0);
            }
            !E && R.length > 3 && (v.f = R[3]);
          }
          if (c.s.r > p.r && (c.s.r = p.r), c.s.c > y && (c.s.c = y), c.e.r < p.r && (c.e.r = p.r), c.e.c < y && (c.e.c = y), s.cellDates && h && v.t == "n" && Ad(jt[h.numFmtId])) {
            var Y = Bu(v.v);
            Y && (v.t = "d", v.v = new Date(Y.y, Y.m - 1, Y.d, Y.H, Y.M, Y.S, Y.u));
          }
          N && (N.type == "XLDAPR" && (v.D = !0), N = void 0);
          break;
        case 1:
        case 12:
          if (!s.sheetStubs || f) break;
          v = { t: "z", v: void 0 }, y = R[0].c == -1 ? y + 1 : R[0].c, s.dense ? (l[m] || (l[m] = []), l[m][y] = v) : l[Mr(y) + S] = v, c.s.r > p.r && (c.s.r = p.r), c.s.c > y && (c.s.c = y), c.e.r < p.r && (c.e.r = p.r), c.e.c < y && (c.e.c = y), N && (N.type == "XLDAPR" && (v.D = !0), N = void 0);
          break;
        case 176:
          _.push(R);
          break;
        case 49:
          N = ((s.xlmeta || {}).Cell || [])[R - 1];
          break;
        case 494:
          var X = r["!id"][R.relId];
          for (X ? (R.Target = X.Target, R.loc && (R.Target += "#" + R.loc), R.Rel = X) : R.relId == "" && (R.Target = "#" + R.loc), m = R.rfx.s.r; m <= R.rfx.e.r; ++m) for (y = R.rfx.s.c; y <= R.rfx.e.c; ++y)
            s.dense ? (l[m] || (l[m] = []), l[m][y] || (l[m][y] = { t: "z", v: void 0 }), l[m][y].l = R) : (x = Kt({ c: y, r: m }), l[x] || (l[x] = { t: "z", v: void 0 }), l[x].l = R);
          break;
        case 426:
          if (!s.cellFormula) break;
          C.push(R), w = s.dense ? l[m][y] : l[Mr(y) + S], w.f = wa(R[1], c, { r: p.r, c: y }, O, s), w.F = vn(R[0]);
          break;
        case 427:
          if (!s.cellFormula) break;
          T[Kt(R[0].s)] = R[1], w = s.dense ? l[m][y] : l[Mr(y) + S], w.f = wa(R[1], c, { r: p.r, c: y }, O, s);
          break;
        case 60:
          if (!s.cellStyles) break;
          for (; R.e >= R.s; )
            k[R.e--] = { width: R.w / 256, hidden: !!(R.flags & 1), level: R.level }, P || (P = !0, sE(R.w / 256)), ou(k[R.e + 1]);
          break;
        case 161:
          l["!autofilter"] = { ref: vn(R) };
          break;
        case 476:
          l["!margins"] = R;
          break;
        case 147:
          a.Sheets[n] || (a.Sheets[n] = {}), R.name && (a.Sheets[n].CodeName = R.name), (R.above || R.left) && (l["!outline"] = { above: R.above, left: R.left });
          break;
        case 137:
          a.Views || (a.Views = [{}]), a.Views[0] || (a.Views[0] = {}), R.RTL && (a.Views[0].RTL = !0);
          break;
        case 485:
          break;
        case 64:
        case 1053:
          break;
        case 151:
          break;
        case 152:
        case 175:
        case 644:
        case 625:
        case 562:
        case 396:
        case 1112:
        case 1146:
        case 471:
        case 1050:
        case 649:
        case 1105:
        case 589:
        case 607:
        case 564:
        case 1055:
        case 168:
        case 174:
        case 1180:
        case 499:
        case 507:
        case 550:
        case 171:
        case 167:
        case 1177:
        case 169:
        case 1181:
        case 551:
        case 552:
        case 661:
        case 639:
        case 478:
        case 537:
        case 477:
        case 536:
        case 1103:
        case 680:
        case 1104:
        case 1024:
        case 663:
        case 535:
        case 678:
        case 504:
        case 1043:
        case 428:
        case 170:
        case 3072:
        case 50:
        case 2070:
        case 1045:
          break;
        case 35:
          f = !0;
          break;
        case 36:
          f = !1;
          break;
        case 37:
          f = !0;
          break;
        case 38:
          f = !1;
          break;
        default:
          if (!z.T) {
            if (!f || s.WTF) throw new Error("Unexpected record 0x" + W.toString(16));
          }
      }
  }, s), delete s.supbooks, delete s["!row"], !l["!ref"] && (c.s.r < 2e6 || u && (u.e.r > 0 || u.e.c > 0 || u.s.r > 0 || u.s.c > 0)) && (l["!ref"] = vn(u || c)), s.sheetRows && l["!ref"]) {
    var M = kn(l["!ref"]);
    s.sheetRows <= +M.e.r && (M.e.r = s.sheetRows - 1, M.e.r > c.e.r && (M.e.r = c.e.r), M.e.r < M.s.r && (M.s.r = M.e.r), M.e.c > c.e.c && (M.e.c = c.e.c), M.e.c < M.s.c && (M.s.c = M.e.c), l["!fullref"] = l["!ref"], l["!ref"] = vn(M));
  }
  return _.length > 0 && (l["!merges"] = _), k.length > 0 && (l["!cols"] = k), B.length > 0 && (l["!rows"] = B), l;
}
function uCe(e, t, n, r, a, o, i) {
  if (t.v === void 0) return !1;
  var s = "";
  switch (t.t) {
    case "b":
      s = t.v ? "1" : "0";
      break;
    case "d":
      t = qn(t), t.z = t.z || jt[14], t.v = pa(nr(t.v)), t.t = "n";
      break;
    case "n":
    case "e":
      s = "" + t.v;
      break;
    default:
      s = t.v;
      break;
  }
  var l = { r: n, c: r };
  switch (l.s = mu(a.cellXfs, t, a), t.l && o["!links"].push([Kt(l), t.l]), t.c && o["!comments"].push([Kt(l), t.c]), t.t) {
    case "s":
    case "str":
      return a.bookSST ? (s = dE(a.Strings, t.v, a.revStrings), l.t = "s", l.v = s, i ? at(e, 18, O_e(t, l)) : at(e, 7, T_e(t, l))) : (l.t = "str", i ? at(e, 17, H_e(t, l)) : at(e, 6, L_e(t, l))), !0;
    case "n":
      return t.v == (t.v | 0) && t.v > -1e3 && t.v < 1e3 ? i ? at(e, 13, R_e(t, l)) : at(e, 2, k_e(t, l)) : i ? at(e, 16, P_e(t, l)) : at(e, 5, I_e(t, l)), !0;
    case "b":
      return l.t = "b", i ? at(e, 15, b_e(t, l)) : at(e, 4, y_e(t, l)), !0;
    case "e":
      return l.t = "e", i ? at(e, 14, C_e(t, l)) : at(e, 3, S_e(t, l)), !0;
  }
  return i ? at(e, 12, m_e(t, l)) : at(e, 1, h_e(t, l)), !0;
}
function cCe(e, t, n, r) {
  var a = kn(t["!ref"] || "A1"), o, i = "", s = [];
  at(
    e,
    145
    /* BrtBeginSheetData */
  );
  var l = Array.isArray(t), u = a.e.r;
  t["!rows"] && (u = Math.max(a.e.r, t["!rows"].length - 1));
  for (var c = a.s.r; c <= u; ++c) {
    i = Kr(c), s_e(e, t, a, c);
    var f = !1;
    if (c <= a.e.r) for (var d = a.s.c; d <= a.e.c; ++d) {
      c === a.s.r && (s[d] = Mr(d)), o = s[d] + i;
      var p = l ? (t[c] || [])[d] : t[o];
      if (!p) {
        f = !1;
        continue;
      }
      f = uCe(e, p, c, d, r, t, f);
    }
  }
  at(
    e,
    146
    /* BrtEndSheetData */
  );
}
function fCe(e, t) {
  !t || !t["!merges"] || (at(e, 177, K_e(t["!merges"].length)), t["!merges"].forEach(function(n) {
    at(e, 176, G_e(n));
  }), at(
    e,
    178
    /* BrtEndMergeCells */
  ));
}
function dCe(e, t) {
  !t || !t["!cols"] || (at(
    e,
    390
    /* BrtBeginColInfos */
  ), t["!cols"].forEach(function(n, r) {
    n && at(e, 60, J_e(r, n));
  }), at(
    e,
    391
    /* BrtEndColInfos */
  ));
}
function pCe(e, t) {
  !t || !t["!ref"] || (at(
    e,
    648
    /* BrtBeginCellIgnoreECs */
  ), at(e, 649, aCe(kn(t["!ref"]))), at(
    e,
    650
    /* BrtEndCellIgnoreECs */
  ));
}
function hCe(e, t, n) {
  t["!links"].forEach(function(r) {
    if (r[1].Target) {
      var a = Rn(n, -1, r[1].Target.replace(/#.*$/, ""), cn.HLINK);
      at(e, 494, q_e(r, a));
    }
  }), delete t["!links"];
}
function vCe(e, t, n, r) {
  if (t["!comments"].length > 0) {
    var a = Rn(r, -1, "../drawings/vmlDrawing" + (n + 1) + ".vml", cn.VML);
    at(e, 551, J4("rId" + a)), t["!legacy"] = a;
  }
}
function mCe(e, t, n, r) {
  if (t["!autofilter"]) {
    var a = t["!autofilter"], o = typeof a.ref == "string" ? a.ref : vn(a.ref);
    n.Workbook || (n.Workbook = { Sheets: [] }), n.Workbook.Names || (n.Workbook.Names = []);
    var i = n.Workbook.Names, s = hi(o);
    s.s.r == s.e.r && (s.e.r = hi(t["!ref"]).e.r, o = vn(s));
    for (var l = 0; l < i.length; ++l) {
      var u = i[l];
      if (u.Name == "_xlnm._FilterDatabase" && u.Sheet == r) {
        u.Ref = "'" + n.SheetNames[r] + "'!" + o;
        break;
      }
    }
    l == i.length && i.push({ Name: "_xlnm._FilterDatabase", Sheet: r, Ref: "'" + n.SheetNames[r] + "'!" + o }), at(e, 161, Pd(kn(o))), at(
      e,
      162
      /* BrtEndAFilter */
    );
  }
}
function gCe(e, t, n) {
  at(
    e,
    133
    /* BrtBeginWsViews */
  ), at(e, 137, rCe(t, n)), at(
    e,
    138
    /* BrtEndWsView */
  ), at(
    e,
    134
    /* BrtEndWsViews */
  );
}
function yCe(e, t) {
  t["!protect"] && at(e, 535, oCe(t["!protect"]));
}
function xCe(e, t, n, r) {
  var a = lo(), o = n.SheetNames[e], i = n.Sheets[o] || {}, s = o;
  try {
    n && n.Workbook && (s = n.Workbook.Sheets[e].CodeName || s);
  } catch {
  }
  var l = kn(i["!ref"] || "A1");
  if (l.e.c > 16383 || l.e.r > 1048575) {
    if (t.WTF) throw new Error("Range " + (i["!ref"] || "A1") + " exceeds format limit A1:XFD1048576");
    l.e.c = Math.min(l.e.c, 16383), l.e.r = Math.min(l.e.c, 1048575);
  }
  return i["!links"] = [], i["!comments"] = [], at(
    a,
    129
    /* BrtBeginSheet */
  ), (n.vbaraw || i["!outline"]) && at(a, 147, d_e(s, i["!outline"])), at(a, 148, u_e(l)), gCe(a, i, n.Workbook), dCe(a, i), cCe(a, i, e, t), yCe(a, i), mCe(a, i, n, e), fCe(a, i), hCe(a, i, r), i["!margins"] && at(a, 476, tCe(i["!margins"])), (!t || t.ignoreEC || t.ignoreEC == null) && pCe(a, i), vCe(a, i, e, r), at(
    a,
    130
    /* BrtEndSheet */
  ), a.end();
}
function bCe(e) {
  var t = [], n = e.match(/^<c:numCache>/), r;
  (e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(o) {
    var i = o.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
    i && (t[+i[1]] = n ? +i[2] : i[2]);
  });
  var a = En((e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["", "General"])[1]);
  return (e.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(o) {
    r = o.replace(/<.*?>/g, "");
  }), [t, a, r];
}
function wCe(e, t, n, r, a, o) {
  var i = o || { "!type": "chart" };
  if (!e) return o;
  var s = 0, l = 0, u = "A", c = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
  return (e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(f) {
    var d = bCe(f);
    c.s.r = c.s.c = 0, c.e.c = s, u = Mr(s), d[0].forEach(function(p, v) {
      i[u + Kr(v)] = { t: "n", v: p, z: d[1] }, l = v;
    }), c.e.r < l && (c.e.r = l), ++s;
  }), s > 0 && (i["!ref"] = vn(c)), i;
}
function SCe(e, t, n, r, a) {
  if (!e) return e;
  r || (r = { "!id": {} });
  var o = { "!type": "chart", "!drawel": null, "!rel": "" }, i, s = e.match($N);
  return s && pE(s[0], o, a, n), (i = e.match(/drawing r:id="(.*?)"/)) && (o["!rel"] = i[1]), r["!id"][o["!rel"]] && (o["!drawel"] = r["!id"][o["!rel"]]), o;
}
function _Ce(e, t) {
  e.l += 10;
  var n = Da(e);
  return { name: n };
}
function CCe(e, t, n, r, a) {
  if (!e) return e;
  r || (r = { "!id": {} });
  var o = { "!type": "chart", "!drawel": null, "!rel": "" }, i = !1;
  return fl(e, function(l, u, c) {
    switch (c) {
      case 550:
        o["!rel"] = l;
        break;
      case 651:
        a.Sheets[n] || (a.Sheets[n] = {}), l.name && (a.Sheets[n].CodeName = l.name);
        break;
      case 562:
      case 652:
      case 669:
      case 679:
      case 551:
      case 552:
      case 476:
      case 3072:
        break;
      case 35:
        i = !0;
        break;
      case 36:
        i = !1;
        break;
      case 37:
        break;
      case 38:
        break;
      default:
        if (!(u.T > 0)) {
          if (!(u.T < 0)) {
            if (!i || t.WTF) throw new Error("Unexpected record 0x" + c.toString(16));
          }
        }
    }
  }, t), r["!id"][o["!rel"]] && (o["!drawel"] = r["!id"][o["!rel"]]), o;
}
var hE = [
  ["allowRefreshQuery", !1, "bool"],
  ["autoCompressPictures", !0, "bool"],
  ["backupFile", !1, "bool"],
  ["checkCompatibility", !1, "bool"],
  ["CodeName", ""],
  ["date1904", !1, "bool"],
  ["defaultThemeVersion", 0, "int"],
  ["filterPrivacy", !1, "bool"],
  ["hidePivotFieldList", !1, "bool"],
  ["promptedSolutions", !1, "bool"],
  ["publishItems", !1, "bool"],
  ["refreshAllConnections", !1, "bool"],
  ["saveExternalLinkValues", !0, "bool"],
  ["showBorderUnselectedTables", !0, "bool"],
  ["showInkAnnotation", !0, "bool"],
  ["showObjects", "all"],
  ["showPivotChartFilter", !1, "bool"],
  ["updateLinks", "userSet"]
], ECe = [
  ["activeTab", 0, "int"],
  ["autoFilterDateGrouping", !0, "bool"],
  ["firstSheet", 0, "int"],
  ["minimized", !1, "bool"],
  ["showHorizontalScroll", !0, "bool"],
  ["showSheetTabs", !0, "bool"],
  ["showVerticalScroll", !0, "bool"],
  ["tabRatio", 600, "int"],
  ["visibility", "visible"]
  //window{Height,Width}, {x,y}Window
], TCe = [
  //['state', 'visible']
], $Ce = [
  ["calcCompleted", "true"],
  ["calcMode", "auto"],
  ["calcOnSave", "true"],
  ["concurrentCalc", "true"],
  ["fullCalcOnLoad", "false"],
  ["fullPrecision", "true"],
  ["iterate", "false"],
  ["iterateCount", "100"],
  ["iterateDelta", "0.001"],
  ["refMode", "A1"]
];
function FO(e, t) {
  for (var n = 0; n != e.length; ++n)
    for (var r = e[n], a = 0; a != t.length; ++a) {
      var o = t[a];
      if (r[o[0]] == null) r[o[0]] = o[1];
      else switch (o[2]) {
        case "bool":
          typeof r[o[0]] == "string" && (r[o[0]] = Kn(r[o[0]]));
          break;
        case "int":
          typeof r[o[0]] == "string" && (r[o[0]] = parseInt(r[o[0]], 10));
          break;
      }
    }
}
function LO(e, t) {
  for (var n = 0; n != t.length; ++n) {
    var r = t[n];
    if (e[r[0]] == null) e[r[0]] = r[1];
    else switch (r[2]) {
      case "bool":
        typeof e[r[0]] == "string" && (e[r[0]] = Kn(e[r[0]]));
        break;
      case "int":
        typeof e[r[0]] == "string" && (e[r[0]] = parseInt(e[r[0]], 10));
        break;
    }
  }
}
function PN(e) {
  LO(e.WBProps, hE), LO(e.CalcPr, $Ce), FO(e.WBView, ECe), FO(e.Sheets, TCe), kf.date1904 = Kn(e.WBProps.date1904);
}
function OCe(e) {
  return !e.Workbook || !e.Workbook.WBProps ? "false" : Kn(e.Workbook.WBProps.date1904) ? "true" : "false";
}
var ACe = /* @__PURE__ */ "][*?/\\".split("");
function DN(e, t) {
  if (e.length > 31)
    throw new Error("Sheet names cannot exceed 31 chars");
  var n = !0;
  return ACe.forEach(function(r) {
    if (e.indexOf(r) != -1)
      throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
  }), n;
}
function ICe(e, t, n) {
  e.forEach(function(r, a) {
    DN(r);
    for (var o = 0; o < a; ++o) if (r == e[o]) throw new Error("Duplicate Sheet Name: " + r);
    if (n) {
      var i = t && t[a] && t[a].CodeName || r;
      if (i.charCodeAt(0) == 95 && i.length > 22) throw new Error("Bad Code Name: Worksheet" + i);
    }
  });
}
function PCe(e) {
  if (!e || !e.SheetNames || !e.Sheets) throw new Error("Invalid Workbook");
  if (!e.SheetNames.length) throw new Error("Workbook is empty");
  var t = e.Workbook && e.Workbook.Sheets || [];
  ICe(e.SheetNames, t, !!e.vbaraw);
  for (var n = 0; n < e.SheetNames.length; ++n) OSe(e.Sheets[e.SheetNames[n]], e.SheetNames[n], n);
}
var DCe = /<\w+:workbook/;
function kCe(e, t) {
  if (!e) throw new Error("Could not find file");
  var n = (
    /*::(*/
    { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, Names: [], xmlns: "" }
  ), r = !1, a = "xmlns", o = {}, i = 0;
  if (e.replace(Fa, function(l, u) {
    var c = Vt(l);
    switch (Es(c[0])) {
      case "<?xml":
        break;
      case "<workbook":
        l.match(DCe) && (a = "xmlns" + l.match(/<(\w+):/)[1]), n.xmlns = c[a];
        break;
      case "</workbook>":
        break;
      case "<fileVersion":
        delete c[0], n.AppVersion = c;
        break;
      case "<fileVersion/>":
      case "</fileVersion>":
        break;
      case "<fileSharing":
        break;
      case "<fileSharing/>":
        break;
      case "<workbookPr":
      case "<workbookPr/>":
        hE.forEach(function(f) {
          if (c[f[0]] != null)
            switch (f[2]) {
              case "bool":
                n.WBProps[f[0]] = Kn(c[f[0]]);
                break;
              case "int":
                n.WBProps[f[0]] = parseInt(c[f[0]], 10);
                break;
              default:
                n.WBProps[f[0]] = c[f[0]];
            }
        }), c.codeName && (n.WBProps.CodeName = Hn(c.codeName));
        break;
      case "</workbookPr>":
        break;
      case "<workbookProtection":
        break;
      case "<workbookProtection/>":
        break;
      case "<bookViews":
      case "<bookViews>":
      case "</bookViews>":
        break;
      case "<workbookView":
      case "<workbookView/>":
        delete c[0], n.WBView.push(c);
        break;
      case "</workbookView>":
        break;
      case "<sheets":
      case "<sheets>":
      case "</sheets>":
        break;
      case "<sheet":
        switch (c.state) {
          case "hidden":
            c.Hidden = 1;
            break;
          case "veryHidden":
            c.Hidden = 2;
            break;
          default:
            c.Hidden = 0;
        }
        delete c.state, c.name = En(Hn(c.name)), delete c[0], n.Sheets.push(c);
        break;
      case "</sheet>":
        break;
      case "<functionGroups":
      case "<functionGroups/>":
        break;
      case "<functionGroup":
        break;
      case "<externalReferences":
      case "</externalReferences>":
      case "<externalReferences>":
        break;
      case "<externalReference":
        break;
      case "<definedNames/>":
        break;
      case "<definedNames>":
      case "<definedNames":
        r = !0;
        break;
      case "</definedNames>":
        r = !1;
        break;
      case "<definedName":
        o = {}, o.Name = Hn(c.name), c.comment && (o.Comment = c.comment), c.localSheetId && (o.Sheet = +c.localSheetId), Kn(c.hidden || "0") && (o.Hidden = !0), i = u + l.length;
        break;
      case "</definedName>":
        o.Ref = En(Hn(e.slice(i, u))), n.Names.push(o);
        break;
      case "<definedName/>":
        break;
      case "<calcPr":
        delete c[0], n.CalcPr = c;
        break;
      case "<calcPr/>":
        delete c[0], n.CalcPr = c;
        break;
      case "</calcPr>":
        break;
      case "<oleSize":
        break;
      case "<customWorkbookViews>":
      case "</customWorkbookViews>":
      case "<customWorkbookViews":
        break;
      case "<customWorkbookView":
      case "</customWorkbookView>":
        break;
      case "<pivotCaches>":
      case "</pivotCaches>":
      case "<pivotCaches":
        break;
      case "<pivotCache":
        break;
      case "<smartTagPr":
      case "<smartTagPr/>":
        break;
      case "<smartTagTypes":
      case "<smartTagTypes>":
      case "</smartTagTypes>":
        break;
      case "<smartTagType":
        break;
      case "<webPublishing":
      case "<webPublishing/>":
        break;
      case "<fileRecoveryPr":
      case "<fileRecoveryPr/>":
        break;
      case "<webPublishObjects>":
      case "<webPublishObjects":
      case "</webPublishObjects>":
        break;
      case "<webPublishObject":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        r = !0;
        break;
      case "</ext>":
        r = !1;
        break;
      case "<ArchID":
        break;
      case "<AlternateContent":
      case "<AlternateContent>":
        r = !0;
        break;
      case "</AlternateContent>":
        r = !1;
        break;
      case "<revisionPtr":
        break;
      default:
        if (!r && t.WTF) throw new Error("unrecognized " + c[0] + " in workbook");
    }
    return l;
  }), Nc.indexOf(n.xmlns) === -1) throw new Error("Unknown Namespace: " + n.xmlns);
  return PN(n), n;
}
function kN(e) {
  var t = [Tr];
  t[t.length] = pt("workbook", null, {
    xmlns: Nc[0],
    //'xmlns:mx': XMLNS.mx,
    //'xmlns:s': XMLNS_main[0],
    "xmlns:r": Rr.r
  });
  var n = e.Workbook && (e.Workbook.Names || []).length > 0, r = { codeName: "ThisWorkbook" };
  e.Workbook && e.Workbook.WBProps && (hE.forEach(function(s) {
    e.Workbook.WBProps[s[0]] != null && e.Workbook.WBProps[s[0]] != s[1] && (r[s[0]] = e.Workbook.WBProps[s[0]]);
  }), e.Workbook.WBProps.CodeName && (r.codeName = e.Workbook.WBProps.CodeName, delete r.CodeName)), t[t.length] = pt("workbookPr", null, r);
  var a = e.Workbook && e.Workbook.Sheets || [], o = 0;
  if (a && a[0] && a[0].Hidden) {
    for (t[t.length] = "<bookViews>", o = 0; o != e.SheetNames.length && !(!a[o] || !a[o].Hidden); ++o)
      ;
    o == e.SheetNames.length && (o = 0), t[t.length] = '<workbookView firstSheet="' + o + '" activeTab="' + o + '"/>', t[t.length] = "</bookViews>";
  }
  for (t[t.length] = "<sheets>", o = 0; o != e.SheetNames.length; ++o) {
    var i = { name: Nn(e.SheetNames[o].slice(0, 31)) };
    if (i.sheetId = "" + (o + 1), i["r:id"] = "rId" + (o + 1), a[o]) switch (a[o].Hidden) {
      case 1:
        i.state = "hidden";
        break;
      case 2:
        i.state = "veryHidden";
        break;
    }
    t[t.length] = pt("sheet", null, i);
  }
  return t[t.length] = "</sheets>", n && (t[t.length] = "<definedNames>", e.Workbook && e.Workbook.Names && e.Workbook.Names.forEach(function(s) {
    var l = { name: s.Name };
    s.Comment && (l.comment = s.Comment), s.Sheet != null && (l.localSheetId = "" + s.Sheet), s.Hidden && (l.hidden = "1"), s.Ref && (t[t.length] = pt("definedName", Nn(s.Ref), l));
  }), t[t.length] = "</definedNames>"), t.length > 2 && (t[t.length] = "</workbook>", t[1] = t[1].replace("/>", ">")), t.join("");
}
function MCe(e, t) {
  var n = {};
  return n.Hidden = e.read_shift(4), n.iTabID = e.read_shift(4), n.strRelID = jS(e), n.name = Da(e), n;
}
function RCe(e, t) {
  return t || (t = We(127)), t.write_shift(4, e.Hidden), t.write_shift(4, e.iTabID), J4(e.strRelID, t), Wr(e.name.slice(0, 31), t), t.length > t.l ? t.slice(0, t.l) : t;
}
function NCe(e, t) {
  var n = {}, r = e.read_shift(4);
  n.defaultThemeVersion = e.read_shift(4);
  var a = t > 8 ? Da(e) : "";
  return a.length > 0 && (n.CodeName = a), n.autoCompressPictures = !!(r & 65536), n.backupFile = !!(r & 64), n.checkCompatibility = !!(r & 4096), n.date1904 = !!(r & 1), n.filterPrivacy = !!(r & 8), n.hidePivotFieldList = !!(r & 1024), n.promptedSolutions = !!(r & 16), n.publishItems = !!(r & 2048), n.refreshAllConnections = !!(r & 262144), n.saveExternalLinkValues = !!(r & 128), n.showBorderUnselectedTables = !!(r & 4), n.showInkAnnotation = !!(r & 32), n.showObjects = ["all", "placeholders", "none"][r >> 13 & 3], n.showPivotChartFilter = !!(r & 32768), n.updateLinks = ["userSet", "never", "always"][r >> 8 & 3], n;
}
function FCe(e, t) {
  t || (t = We(72));
  var n = 0;
  return e && e.filterPrivacy && (n |= 8), t.write_shift(4, n), t.write_shift(4, 0), CR(e && e.CodeName || "ThisWorkbook", t), t.slice(0, t.l);
}
function LCe(e, t) {
  var n = {};
  return e.read_shift(4), n.ArchID = e.read_shift(4), e.l += t - 8, n;
}
function BCe(e, t, n) {
  var r = e.l + t;
  e.l += 4, e.l += 1;
  var a = e.read_shift(4), o = v1e(e), i = SSe(e, 0, n), s = Q4(e);
  e.l = r;
  var l = { Name: o, Ptg: i };
  return a < 268435455 && (l.Sheet = a), s && (l.Comment = s), l;
}
function HCe(e, t) {
  var n = { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, xmlns: "" }, r = [], a = !1;
  t || (t = {}), t.biff = 12;
  var o = [], i = [[]];
  return i.SheetNames = [], i.XTI = [], Tp[16] = { n: "BrtFRTArchID$", f: LCe }, fl(e, function(l, u, c) {
    switch (c) {
      case 156:
        i.SheetNames.push(l.name), n.Sheets.push(l);
        break;
      case 153:
        n.WBProps = l;
        break;
      case 39:
        l.Sheet != null && (t.SID = l.Sheet), l.Ref = wa(l.Ptg, null, null, i, t), delete t.SID, delete l.Ptg, o.push(l);
        break;
      case 1036:
        break;
      case 357:
      case 358:
      case 355:
      case 667:
        i[0].length ? i.push([c, l]) : i[0] = [c, l], i[i.length - 1].XTI = [];
        break;
      case 362:
        i.length === 0 && (i[0] = [], i[0].XTI = []), i[i.length - 1].XTI = i[i.length - 1].XTI.concat(l), i.XTI = i.XTI.concat(l);
        break;
      case 361:
        break;
      case 2071:
      case 158:
      case 143:
      case 664:
      case 353:
        break;
      case 3072:
      case 3073:
      case 534:
      case 677:
      case 157:
      case 610:
      case 2050:
      case 155:
      case 548:
      case 676:
      case 128:
      case 665:
      case 2128:
      case 2125:
      case 549:
      case 2053:
      case 596:
      case 2076:
      case 2075:
      case 2082:
      case 397:
      case 154:
      case 1117:
      case 553:
      case 2091:
        break;
      case 35:
        r.push(c), a = !0;
        break;
      case 36:
        r.pop(), a = !1;
        break;
      case 37:
        r.push(c), a = !0;
        break;
      case 38:
        r.pop(), a = !1;
        break;
      case 16:
        break;
      default:
        if (!u.T) {
          if (!a || t.WTF && r[r.length - 1] != 37 && r[r.length - 1] != 35) throw new Error("Unexpected record 0x" + c.toString(16));
        }
    }
  }, t), PN(n), n.Names = o, n.supbooks = i, n;
}
function jCe(e, t) {
  at(
    e,
    143
    /* BrtBeginBundleShs */
  );
  for (var n = 0; n != t.SheetNames.length; ++n) {
    var r = t.Workbook && t.Workbook.Sheets && t.Workbook.Sheets[n] && t.Workbook.Sheets[n].Hidden || 0, a = { Hidden: r, iTabID: n + 1, strRelID: "rId" + (n + 1), name: t.SheetNames[n] };
    at(e, 156, RCe(a));
  }
  at(
    e,
    144
    /* BrtEndBundleShs */
  );
}
function VCe(e, t) {
  t || (t = We(127));
  for (var n = 0; n != 4; ++n) t.write_shift(4, 0);
  return Wr("SheetJS", t), Wr(Jm.version, t), Wr(Jm.version, t), Wr("7262", t), t.length > t.l ? t.slice(0, t.l) : t;
}
function UCe(e, t) {
  t || (t = We(29)), t.write_shift(-4, 0), t.write_shift(-4, 460), t.write_shift(4, 28800), t.write_shift(4, 17600), t.write_shift(4, 500), t.write_shift(4, e), t.write_shift(4, e);
  var n = 120;
  return t.write_shift(1, n), t.length > t.l ? t.slice(0, t.l) : t;
}
function zCe(e, t) {
  if (!(!t.Workbook || !t.Workbook.Sheets)) {
    for (var n = t.Workbook.Sheets, r = 0, a = -1, o = -1; r < n.length; ++r)
      !n[r] || !n[r].Hidden && a == -1 ? a = r : n[r].Hidden == 1 && o == -1 && (o = r);
    o > a || (at(
      e,
      135
      /* BrtBeginBookViews */
    ), at(e, 158, UCe(a)), at(
      e,
      136
      /* BrtEndBookViews */
    ));
  }
}
function WCe(e, t) {
  var n = lo();
  return at(
    n,
    131
    /* BrtBeginBook */
  ), at(n, 128, VCe()), at(n, 153, FCe(e.Workbook && e.Workbook.WBProps || null)), zCe(n, e), jCe(n, e), at(
    n,
    132
    /* BrtEndBook */
  ), n.end();
}
function GCe(e, t, n) {
  return t.slice(-4) === ".bin" ? HCe(e, n) : kCe(e, n);
}
function KCe(e, t, n, r, a, o, i, s) {
  return t.slice(-4) === ".bin" ? lCe(e, r, n, a, o, i, s) : BSe(e, r, n, a, o, i, s);
}
function YCe(e, t, n, r, a, o, i, s) {
  return t.slice(-4) === ".bin" ? CCe(e, r, n, a, o) : SCe(e, r, n, a, o);
}
function qCe(e, t, n, r, a, o, i, s) {
  return t.slice(-4) === ".bin" ? Z2e() : Q2e();
}
function XCe(e, t, n, r, a, o, i, s) {
  return t.slice(-4) === ".bin" ? q2e() : X2e();
}
function ZCe(e, t, n, r) {
  return t.slice(-4) === ".bin" ? Gbe(e, n, r) : Mbe(e, n, r);
}
function QCe(e, t, n) {
  return pN(e, n);
}
function JCe(e, t, n) {
  return t.slice(-4) === ".bin" ? Jxe(e, n) : Xxe(e, n);
}
function e4e(e, t, n) {
  return t.slice(-4) === ".bin" ? z2e(e, n) : R2e(e, n);
}
function t4e(e, t, n) {
  return t.slice(-4) === ".bin" ? D2e(e) : I2e(e);
}
function n4e(e, t, n, r) {
  return n.slice(-4) === ".bin" ? k2e(e, t, n, r) : void 0;
}
function r4e(e, t, n) {
  return t.slice(-4) === ".bin" ? $2e(e, t, n) : A2e(e, t, n);
}
function a4e(e, t, n) {
  return (t.slice(-4) === ".bin" ? WCe : kN)(e);
}
function o4e(e, t, n, r, a) {
  return (t.slice(-4) === ".bin" ? xCe : ON)(e, n, r, a);
}
function i4e(e, t, n) {
  return (t.slice(-4) === ".bin" ? n2e : fN)(e, n);
}
function s4e(e, t, n) {
  return (t.slice(-4) === ".bin" ? nbe : rN)(e, n);
}
function l4e(e, t, n) {
  return (t.slice(-4) === ".bin" ? W2e : mN)(e);
}
function u4e(e) {
  return (e.slice(-4) === ".bin" ? O2e : hN)();
}
var MN = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g, RN = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function _i(e, t) {
  var n = e.split(/\s+/), r = [];
  if (r[0] = n[0], n.length === 1) return r;
  var a = e.match(MN), o, i, s, l;
  if (a) for (l = 0; l != a.length; ++l)
    o = a[l].match(RN), (i = o[1].indexOf(":")) === -1 ? r[o[1]] = o[2].slice(1, o[2].length - 1) : (o[1].slice(0, 6) === "xmlns:" ? s = "xmlns" + o[1].slice(6) : s = o[1].slice(i + 1), r[s] = o[2].slice(1, o[2].length - 1));
  return r;
}
function c4e(e) {
  var t = e.split(/\s+/), n = {};
  if (t.length === 1) return n;
  var r = e.match(MN), a, o, i, s;
  if (r) for (s = 0; s != r.length; ++s)
    a = r[s].match(RN), (o = a[1].indexOf(":")) === -1 ? n[a[1]] = a[2].slice(1, a[2].length - 1) : (a[1].slice(0, 6) === "xmlns:" ? i = "xmlns" + a[1].slice(6) : i = a[1].slice(o + 1), n[i] = a[2].slice(1, a[2].length - 1));
  return n;
}
var H0;
function f4e(e, t) {
  var n = H0[e] || En(e);
  return n === "General" ? vc(t) : pi(n, t);
}
function d4e(e, t, n, r) {
  var a = r;
  switch ((n[0].match(/dt:dt="([\w.]+)"/) || ["", ""])[1]) {
    case "boolean":
      a = Kn(r);
      break;
    case "i2":
    case "int":
      a = parseInt(r, 10);
      break;
    case "r4":
    case "float":
      a = parseFloat(r);
      break;
    case "date":
    case "dateTime.tz":
      a = nr(r);
      break;
    case "i8":
    case "string":
    case "fixed":
    case "uuid":
    case "bin.base64":
      break;
    default:
      throw new Error("bad custprop:" + n[0]);
  }
  e[En(t)] = a;
}
function p4e(e, t, n) {
  if (e.t !== "z") {
    if (!n || n.cellText !== !1) try {
      e.t === "e" ? e.w = e.w || dl[e.v] : t === "General" ? e.t === "n" ? (e.v | 0) === e.v ? e.w = e.v.toString(10) : e.w = mp(e.v) : e.w = vc(e.v) : e.w = f4e(t || "General", e.v);
    } catch (o) {
      if (n.WTF) throw o;
    }
    try {
      var r = H0[t] || t || "General";
      if (n.cellNF && (e.z = r), n.cellDates && e.t == "n" && Ad(r)) {
        var a = Bu(e.v);
        a && (e.t = "d", e.v = new Date(a.y, a.m - 1, a.d, a.H, a.M, a.S, a.u));
      }
    } catch (o) {
      if (n.WTF) throw o;
    }
  }
}
function h4e(e, t, n) {
  if (n.cellStyles && t.Interior) {
    var r = t.Interior;
    r.Pattern && (r.patternType = Tbe[r.Pattern] || r.Pattern);
  }
  e[t.ID] = t;
}
function v4e(e, t, n, r, a, o, i, s, l, u) {
  var c = "General", f = r.StyleID, d = {};
  u = u || {};
  var p = [], v = 0;
  for (f === void 0 && s && (f = s.StyleID), f === void 0 && i && (f = i.StyleID); o[f] !== void 0 && (o[f].nf && (c = o[f].nf), o[f].Interior && p.push(o[f].Interior), !!o[f].Parent); )
    f = o[f].Parent;
  switch (n.Type) {
    case "Boolean":
      r.t = "b", r.v = Kn(e);
      break;
    case "String":
      r.t = "s", r.r = tO(En(e)), r.v = e.indexOf("<") > -1 ? En(t || e).replace(/<.*?>/g, "") : r.r;
      break;
    case "DateTime":
      e.slice(-1) != "Z" && (e += "Z"), r.v = (nr(e) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1e3), r.v !== r.v ? r.v = En(e) : r.v < 60 && (r.v = r.v - 1), (!c || c == "General") && (c = "yyyy-mm-dd");
    case "Number":
      r.v === void 0 && (r.v = +e), r.t || (r.t = "n");
      break;
    case "Error":
      r.t = "e", r.v = AR[e], u.cellText !== !1 && (r.w = e);
      break;
    default:
      e == "" && t == "" ? r.t = "z" : (r.t = "s", r.v = tO(t || e));
      break;
  }
  if (p4e(r, c, u), u.cellFormula !== !1)
    if (r.Formula) {
      var h = En(r.Formula);
      h.charCodeAt(0) == 61 && (h = h.slice(1)), r.f = Df(h, a), delete r.Formula, r.ArrayRange == "RC" ? r.F = Df("RC:RC", a) : r.ArrayRange && (r.F = Df(r.ArrayRange, a), l.push([kn(r.F), r.F]));
    } else
      for (v = 0; v < l.length; ++v)
        a.r >= l[v][0].s.r && a.r <= l[v][0].e.r && a.c >= l[v][0].s.c && a.c <= l[v][0].e.c && (r.F = l[v][1]);
  u.cellStyles && (p.forEach(function(m) {
    !d.patternType && m.patternType && (d.patternType = m.patternType);
  }), r.s = d), r.StyleID !== void 0 && (r.ixfe = r.StyleID);
}
function m4e(e) {
  e.t = e.v || "", e.t = e.t.replace(/\r\n/g, `
`).replace(/\r/g, `
`), e.v = e.w = e.ixfe = void 0;
}
function Fx(e, t) {
  var n = t || {};
  Id();
  var r = l0(Y4(e));
  (n.type == "binary" || n.type == "array" || n.type == "base64") && (r = Hn(r));
  var a = r.slice(0, 1024).toLowerCase(), o = !1;
  if (a = a.replace(/".*?"/g, ""), (a.indexOf(">") & 1023) > Math.min(a.indexOf(",") & 1023, a.indexOf(";") & 1023)) {
    var i = qn(n);
    return i.type = "string", sd.to_workbook(r, i);
  }
  if (a.indexOf("<?xml") == -1 && ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(K) {
    a.indexOf("<" + K) >= 0 && (o = !0);
  }), o) return tEe(r, n);
  H0 = {
    "General Number": "General",
    "General Date": jt[22],
    "Long Date": "dddd, mmmm dd, yyyy",
    "Medium Date": jt[15],
    "Short Date": jt[14],
    "Long Time": jt[19],
    "Medium Time": jt[18],
    "Short Time": jt[20],
    Currency: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    Fixed: jt[2],
    Standard: jt[4],
    Percent: jt[10],
    Scientific: jt[11],
    "Yes/No": '"Yes";"Yes";"No";@',
    "True/False": '"True";"True";"False";@',
    "On/Off": '"Yes";"Yes";"No";@'
  };
  var s, l = [], u, c = {}, f = [], d = n.dense ? [] : {}, p = "", v = {}, h = {}, m = _i('<Data ss:Type="String">'), y = 0, x = 0, g = 0, S = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, w = {}, _ = {}, b = "", E = 0, C = [], T = {}, O = {}, I = 0, k = [], B = [], P = {}, N = [], M, H = !1, R = [], z = [], W = {}, F = 0, Y = 0, X = { Sheets: [], WBProps: { date1904: !1 } }, q = {};
  bp.lastIndex = 0, r = r.replace(/<!--([\s\S]*?)-->/mg, "");
  for (var Q = ""; s = bp.exec(r); ) switch (s[3] = (Q = s[3]).toLowerCase()) {
    case "data":
      if (Q == "data") {
        if (s[1] === "/") {
          if ((u = l.pop())[0] !== s[3]) throw new Error("Bad state: " + u.join("|"));
        } else s[0].charAt(s[0].length - 2) !== "/" && l.push([s[3], !0]);
        break;
      }
      if (l[l.length - 1][1]) break;
      s[1] === "/" ? v4e(r.slice(y, s.index), b, m, l[l.length - 1][0] == /*"Comment"*/
      "comment" ? P : v, { c: x, r: g }, w, N[x], h, R, n) : (b = "", m = _i(s[0]), y = s.index + s[0].length);
      break;
    case "cell":
      if (s[1] === "/")
        if (B.length > 0 && (v.c = B), (!n.sheetRows || n.sheetRows > g) && v.v !== void 0 && (n.dense ? (d[g] || (d[g] = []), d[g][x] = v) : d[Mr(x) + Kr(g)] = v), v.HRef && (v.l = { Target: En(v.HRef) }, v.HRefScreenTip && (v.l.Tooltip = v.HRefScreenTip), delete v.HRef, delete v.HRefScreenTip), (v.MergeAcross || v.MergeDown) && (F = x + (parseInt(v.MergeAcross, 10) | 0), Y = g + (parseInt(v.MergeDown, 10) | 0), C.push({ s: { c: x, r: g }, e: { c: F, r: Y } })), !n.sheetStubs)
          v.MergeAcross ? x = F + 1 : ++x;
        else if (v.MergeAcross || v.MergeDown) {
          for (var ue = x; ue <= F; ++ue)
            for (var le = g; le <= Y; ++le)
              (ue > x || le > g) && (n.dense ? (d[le] || (d[le] = []), d[le][ue] = { t: "z" }) : d[Mr(ue) + Kr(le)] = { t: "z" });
          x = F + 1;
        } else ++x;
      else
        v = c4e(s[0]), v.Index && (x = +v.Index - 1), x < S.s.c && (S.s.c = x), x > S.e.c && (S.e.c = x), s[0].slice(-2) === "/>" && ++x, B = [];
      break;
    case "row":
      s[1] === "/" || s[0].slice(-2) === "/>" ? (g < S.s.r && (S.s.r = g), g > S.e.r && (S.e.r = g), s[0].slice(-2) === "/>" && (h = _i(s[0]), h.Index && (g = +h.Index - 1)), x = 0, ++g) : (h = _i(s[0]), h.Index && (g = +h.Index - 1), W = {}, (h.AutoFitHeight == "0" || h.Height) && (W.hpx = parseInt(h.Height, 10), W.hpt = Ep(W.hpx), z[g] = W), h.Hidden == "1" && (W.hidden = !0, z[g] = W));
      break;
    case "worksheet":
      if (s[1] === "/") {
        if ((u = l.pop())[0] !== s[3]) throw new Error("Bad state: " + u.join("|"));
        f.push(p), S.s.r <= S.e.r && S.s.c <= S.e.c && (d["!ref"] = vn(S), n.sheetRows && n.sheetRows <= S.e.r && (d["!fullref"] = d["!ref"], S.e.r = n.sheetRows - 1, d["!ref"] = vn(S))), C.length && (d["!merges"] = C), N.length > 0 && (d["!cols"] = N), z.length > 0 && (d["!rows"] = z), c[p] = d;
      } else
        S = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, g = x = 0, l.push([s[3], !1]), u = _i(s[0]), p = En(u.Name), d = n.dense ? [] : {}, C = [], R = [], z = [], q = { name: p, Hidden: 0 }, X.Sheets.push(q);
      break;
    case "table":
      if (s[1] === "/") {
        if ((u = l.pop())[0] !== s[3]) throw new Error("Bad state: " + u.join("|"));
      } else {
        if (s[0].slice(-2) == "/>") break;
        l.push([s[3], !1]), N = [], H = !1;
      }
      break;
    case "style":
      s[1] === "/" ? h4e(w, _, n) : _ = _i(s[0]);
      break;
    case "numberformat":
      _.nf = En(_i(s[0]).Format || "General"), H0[_.nf] && (_.nf = H0[_.nf]);
      for (var te = 0; te != 392 && jt[te] != _.nf; ++te) ;
      if (te == 392) {
        for (te = 57; te != 392; ++te) if (jt[te] == null) {
          qs(_.nf, te);
          break;
        }
      }
      break;
    case "column":
      if (l[l.length - 1][0] !== /*'Table'*/
      "table") break;
      if (M = _i(s[0]), M.Hidden && (M.hidden = !0, delete M.Hidden), M.Width && (M.wpx = parseInt(M.Width, 10)), !H && M.wpx > 10) {
        H = !0, _a = uN;
        for (var G = 0; G < N.length; ++G) N[G] && ou(N[G]);
      }
      H && ou(M), N[M.Index - 1 || N.length] = M;
      for (var oe = 0; oe < +M.Span; ++oe) N[N.length] = qn(M);
      break;
    case "namedrange":
      if (s[1] === "/") break;
      X.Names || (X.Names = []);
      var L = Vt(s[0]), re = {
        Name: L.Name,
        Ref: Df(L.RefersTo.slice(1), { r: 0, c: 0 })
      };
      X.Sheets.length > 0 && (re.Sheet = X.Sheets.length - 1), X.Names.push(re);
      break;
    case "namedcell":
      break;
    case "b":
      break;
    case "i":
      break;
    case "u":
      break;
    case "s":
      break;
    case "em":
      break;
    case "h2":
      break;
    case "h3":
      break;
    case "sub":
      break;
    case "sup":
      break;
    case "span":
      break;
    case "alignment":
      break;
    case "borders":
      break;
    case "border":
      break;
    case "font":
      if (s[0].slice(-2) === "/>") break;
      s[1] === "/" ? b += r.slice(E, s.index) : E = s.index + s[0].length;
      break;
    case "interior":
      if (!n.cellStyles) break;
      _.Interior = _i(s[0]);
      break;
    case "protection":
      break;
    case "author":
    case "title":
    case "description":
    case "created":
    case "keywords":
    case "subject":
    case "category":
    case "company":
    case "lastauthor":
    case "lastsaved":
    case "lastprinted":
    case "version":
    case "revision":
    case "totaltime":
    case "hyperlinkbase":
    case "manager":
    case "contentstatus":
    case "identifier":
    case "language":
    case "appname":
      if (s[0].slice(-2) === "/>") break;
      s[1] === "/" ? H1e(T, Q, r.slice(I, s.index)) : I = s.index + s[0].length;
      break;
    case "paragraphs":
      break;
    case "styles":
    case "workbook":
      if (s[1] === "/") {
        if ((u = l.pop())[0] !== s[3]) throw new Error("Bad state: " + u.join("|"));
      } else l.push([s[3], !1]);
      break;
    case "comment":
      if (s[1] === "/") {
        if ((u = l.pop())[0] !== s[3]) throw new Error("Bad state: " + u.join("|"));
        m4e(P), B.push(P);
      } else
        l.push([s[3], !1]), u = _i(s[0]), P = { a: u.Author };
      break;
    case "autofilter":
      if (s[1] === "/") {
        if ((u = l.pop())[0] !== s[3]) throw new Error("Bad state: " + u.join("|"));
      } else if (s[0].charAt(s[0].length - 2) !== "/") {
        var j = _i(s[0]);
        d["!autofilter"] = { ref: Df(j.Range).replace(/\$/g, "") }, l.push([s[3], !0]);
      }
      break;
    case "name":
      break;
    case "datavalidation":
      if (s[1] === "/") {
        if ((u = l.pop())[0] !== s[3]) throw new Error("Bad state: " + u.join("|"));
      } else
        s[0].charAt(s[0].length - 2) !== "/" && l.push([s[3], !0]);
      break;
    case "pixelsperinch":
      break;
    case "componentoptions":
    case "documentproperties":
    case "customdocumentproperties":
    case "officedocumentsettings":
    case "pivottable":
    case "pivotcache":
    case "names":
    case "mapinfo":
    case "pagebreaks":
    case "querytable":
    case "sorting":
    case "schema":
    case "conditionalformatting":
    case "smarttagtype":
    case "smarttags":
    case "excelworkbook":
    case "workbookoptions":
    case "worksheetoptions":
      if (s[1] === "/") {
        if ((u = l.pop())[0] !== s[3]) throw new Error("Bad state: " + u.join("|"));
      } else s[0].charAt(s[0].length - 2) !== "/" && l.push([s[3], !0]);
      break;
    case "null":
      break;
    default:
      if (l.length == 0 && s[3] == "document" || l.length == 0 && s[3] == "uof") return VO(r, n);
      var J = !0;
      switch (l[l.length - 1][0]) {
        case "officedocumentsettings":
          switch (s[3]) {
            case "allowpng":
              break;
            case "removepersonalinformation":
              break;
            case "downloadcomponents":
              break;
            case "locationofcomponents":
              break;
            case "colors":
              break;
            case "color":
              break;
            case "index":
              break;
            case "rgb":
              break;
            case "targetscreensize":
              break;
            case "readonlyrecommended":
              break;
            default:
              J = !1;
          }
          break;
        case "componentoptions":
          switch (s[3]) {
            case "toolbar":
              break;
            case "hideofficelogo":
              break;
            case "spreadsheetautofit":
              break;
            case "label":
              break;
            case "caption":
              break;
            case "maxheight":
              break;
            case "maxwidth":
              break;
            case "nextsheetnumber":
              break;
            default:
              J = !1;
          }
          break;
        case "excelworkbook":
          switch (s[3]) {
            case "date1904":
              X.WBProps.date1904 = !0;
              break;
            case "windowheight":
              break;
            case "windowwidth":
              break;
            case "windowtopx":
              break;
            case "windowtopy":
              break;
            case "tabratio":
              break;
            case "protectstructure":
              break;
            case "protectwindow":
              break;
            case "protectwindows":
              break;
            case "activesheet":
              break;
            case "displayinknotes":
              break;
            case "firstvisiblesheet":
              break;
            case "supbook":
              break;
            case "sheetname":
              break;
            case "sheetindex":
              break;
            case "sheetindexfirst":
              break;
            case "sheetindexlast":
              break;
            case "dll":
              break;
            case "acceptlabelsinformulas":
              break;
            case "donotsavelinkvalues":
              break;
            case "iteration":
              break;
            case "maxiterations":
              break;
            case "maxchange":
              break;
            case "path":
              break;
            case "xct":
              break;
            case "count":
              break;
            case "selectedsheets":
              break;
            case "calculation":
              break;
            case "uncalced":
              break;
            case "startupprompt":
              break;
            case "crn":
              break;
            case "externname":
              break;
            case "formula":
              break;
            case "colfirst":
              break;
            case "collast":
              break;
            case "wantadvise":
              break;
            case "boolean":
              break;
            case "error":
              break;
            case "text":
              break;
            case "ole":
              break;
            case "noautorecover":
              break;
            case "publishobjects":
              break;
            case "donotcalculatebeforesave":
              break;
            case "number":
              break;
            case "refmoder1c1":
              break;
            case "embedsavesmarttags":
              break;
            default:
              J = !1;
          }
          break;
        case "workbookoptions":
          switch (s[3]) {
            case "owcversion":
              break;
            case "height":
              break;
            case "width":
              break;
            default:
              J = !1;
          }
          break;
        case "worksheetoptions":
          switch (s[3]) {
            case "visible":
              if (s[0].slice(-2) !== "/>") if (s[1] === "/") switch (r.slice(I, s.index)) {
                case "SheetHidden":
                  q.Hidden = 1;
                  break;
                case "SheetVeryHidden":
                  q.Hidden = 2;
                  break;
              }
              else I = s.index + s[0].length;
              break;
            case "header":
              d["!margins"] || rc(d["!margins"] = {}, "xlml"), isNaN(+Vt(s[0]).Margin) || (d["!margins"].header = +Vt(s[0]).Margin);
              break;
            case "footer":
              d["!margins"] || rc(d["!margins"] = {}, "xlml"), isNaN(+Vt(s[0]).Margin) || (d["!margins"].footer = +Vt(s[0]).Margin);
              break;
            case "pagemargins":
              var ae = Vt(s[0]);
              d["!margins"] || rc(d["!margins"] = {}, "xlml"), isNaN(+ae.Top) || (d["!margins"].top = +ae.Top), isNaN(+ae.Left) || (d["!margins"].left = +ae.Left), isNaN(+ae.Right) || (d["!margins"].right = +ae.Right), isNaN(+ae.Bottom) || (d["!margins"].bottom = +ae.Bottom);
              break;
            case "displayrighttoleft":
              X.Views || (X.Views = []), X.Views[0] || (X.Views[0] = {}), X.Views[0].RTL = !0;
              break;
            case "freezepanes":
              break;
            case "frozennosplit":
              break;
            case "splithorizontal":
            case "splitvertical":
              break;
            case "donotdisplaygridlines":
              break;
            case "activerow":
              break;
            case "activecol":
              break;
            case "toprowbottompane":
              break;
            case "leftcolumnrightpane":
              break;
            case "unsynced":
              break;
            case "print":
              break;
            case "printerrors":
              break;
            case "panes":
              break;
            case "scale":
              break;
            case "pane":
              break;
            case "number":
              break;
            case "layout":
              break;
            case "pagesetup":
              break;
            case "selected":
              break;
            case "protectobjects":
              break;
            case "enableselection":
              break;
            case "protectscenarios":
              break;
            case "validprinterinfo":
              break;
            case "horizontalresolution":
              break;
            case "verticalresolution":
              break;
            case "numberofcopies":
              break;
            case "activepane":
              break;
            case "toprowvisible":
              break;
            case "leftcolumnvisible":
              break;
            case "fittopage":
              break;
            case "rangeselection":
              break;
            case "papersizeindex":
              break;
            case "pagelayoutzoom":
              break;
            case "pagebreakzoom":
              break;
            case "filteron":
              break;
            case "fitwidth":
              break;
            case "fitheight":
              break;
            case "commentslayout":
              break;
            case "zoom":
              break;
            case "lefttoright":
              break;
            case "gridlines":
              break;
            case "allowsort":
              break;
            case "allowfilter":
              break;
            case "allowinsertrows":
              break;
            case "allowdeleterows":
              break;
            case "allowinsertcols":
              break;
            case "allowdeletecols":
              break;
            case "allowinserthyperlinks":
              break;
            case "allowformatcells":
              break;
            case "allowsizecols":
              break;
            case "allowsizerows":
              break;
            case "nosummaryrowsbelowdetail":
              d["!outline"] || (d["!outline"] = {}), d["!outline"].above = !0;
              break;
            case "tabcolorindex":
              break;
            case "donotdisplayheadings":
              break;
            case "showpagelayoutzoom":
              break;
            case "nosummarycolumnsrightdetail":
              d["!outline"] || (d["!outline"] = {}), d["!outline"].left = !0;
              break;
            case "blackandwhite":
              break;
            case "donotdisplayzeros":
              break;
            case "displaypagebreak":
              break;
            case "rowcolheadings":
              break;
            case "donotdisplayoutline":
              break;
            case "noorientation":
              break;
            case "allowusepivottables":
              break;
            case "zeroheight":
              break;
            case "viewablerange":
              break;
            case "selection":
              break;
            case "protectcontents":
              break;
            default:
              J = !1;
          }
          break;
        case "pivottable":
        case "pivotcache":
          switch (s[3]) {
            case "immediateitemsondrop":
              break;
            case "showpagemultipleitemlabel":
              break;
            case "compactrowindent":
              break;
            case "location":
              break;
            case "pivotfield":
              break;
            case "orientation":
              break;
            case "layoutform":
              break;
            case "layoutsubtotallocation":
              break;
            case "layoutcompactrow":
              break;
            case "position":
              break;
            case "pivotitem":
              break;
            case "datatype":
              break;
            case "datafield":
              break;
            case "sourcename":
              break;
            case "parentfield":
              break;
            case "ptlineitems":
              break;
            case "ptlineitem":
              break;
            case "countofsameitems":
              break;
            case "item":
              break;
            case "itemtype":
              break;
            case "ptsource":
              break;
            case "cacheindex":
              break;
            case "consolidationreference":
              break;
            case "filename":
              break;
            case "reference":
              break;
            case "nocolumngrand":
              break;
            case "norowgrand":
              break;
            case "blanklineafteritems":
              break;
            case "hidden":
              break;
            case "subtotal":
              break;
            case "basefield":
              break;
            case "mapchilditems":
              break;
            case "function":
              break;
            case "refreshonfileopen":
              break;
            case "printsettitles":
              break;
            case "mergelabels":
              break;
            case "defaultversion":
              break;
            case "refreshname":
              break;
            case "refreshdate":
              break;
            case "refreshdatecopy":
              break;
            case "versionlastrefresh":
              break;
            case "versionlastupdate":
              break;
            case "versionupdateablemin":
              break;
            case "versionrefreshablemin":
              break;
            case "calculation":
              break;
            default:
              J = !1;
          }
          break;
        case "pagebreaks":
          switch (s[3]) {
            case "colbreaks":
              break;
            case "colbreak":
              break;
            case "rowbreaks":
              break;
            case "rowbreak":
              break;
            case "colstart":
              break;
            case "colend":
              break;
            case "rowend":
              break;
            default:
              J = !1;
          }
          break;
        case "autofilter":
          switch (s[3]) {
            case "autofiltercolumn":
              break;
            case "autofiltercondition":
              break;
            case "autofilterand":
              break;
            case "autofilteror":
              break;
            default:
              J = !1;
          }
          break;
        case "querytable":
          switch (s[3]) {
            case "id":
              break;
            case "autoformatfont":
              break;
            case "autoformatpattern":
              break;
            case "querysource":
              break;
            case "querytype":
              break;
            case "enableredirections":
              break;
            case "refreshedinxl9":
              break;
            case "urlstring":
              break;
            case "htmltables":
              break;
            case "connection":
              break;
            case "commandtext":
              break;
            case "refreshinfo":
              break;
            case "notitles":
              break;
            case "nextid":
              break;
            case "columninfo":
              break;
            case "overwritecells":
              break;
            case "donotpromptforfile":
              break;
            case "textwizardsettings":
              break;
            case "source":
              break;
            case "number":
              break;
            case "decimal":
              break;
            case "thousandseparator":
              break;
            case "trailingminusnumbers":
              break;
            case "formatsettings":
              break;
            case "fieldtype":
              break;
            case "delimiters":
              break;
            case "tab":
              break;
            case "comma":
              break;
            case "autoformatname":
              break;
            case "versionlastedit":
              break;
            case "versionlastrefresh":
              break;
            default:
              J = !1;
          }
          break;
        case "datavalidation":
          switch (s[3]) {
            case "range":
              break;
            case "type":
              break;
            case "min":
              break;
            case "max":
              break;
            case "sort":
              break;
            case "descending":
              break;
            case "order":
              break;
            case "casesensitive":
              break;
            case "value":
              break;
            case "errorstyle":
              break;
            case "errormessage":
              break;
            case "errortitle":
              break;
            case "inputmessage":
              break;
            case "inputtitle":
              break;
            case "combohide":
              break;
            case "inputhide":
              break;
            case "condition":
              break;
            case "qualifier":
              break;
            case "useblank":
              break;
            case "value1":
              break;
            case "value2":
              break;
            case "format":
              break;
            case "cellrangelist":
              break;
            default:
              J = !1;
          }
          break;
        case "sorting":
        case "conditionalformatting":
          switch (s[3]) {
            case "range":
              break;
            case "type":
              break;
            case "min":
              break;
            case "max":
              break;
            case "sort":
              break;
            case "descending":
              break;
            case "order":
              break;
            case "casesensitive":
              break;
            case "value":
              break;
            case "errorstyle":
              break;
            case "errormessage":
              break;
            case "errortitle":
              break;
            case "cellrangelist":
              break;
            case "inputmessage":
              break;
            case "inputtitle":
              break;
            case "combohide":
              break;
            case "inputhide":
              break;
            case "condition":
              break;
            case "qualifier":
              break;
            case "useblank":
              break;
            case "value1":
              break;
            case "value2":
              break;
            case "format":
              break;
            default:
              J = !1;
          }
          break;
        case "mapinfo":
        case "schema":
        case "data":
          switch (s[3]) {
            case "map":
              break;
            case "entry":
              break;
            case "range":
              break;
            case "xpath":
              break;
            case "field":
              break;
            case "xsdtype":
              break;
            case "filteron":
              break;
            case "aggregate":
              break;
            case "elementtype":
              break;
            case "attributetype":
              break;
            case "schema":
            case "element":
            case "complextype":
            case "datatype":
            case "all":
            case "attribute":
            case "extends":
              break;
            case "row":
              break;
            default:
              J = !1;
          }
          break;
        case "smarttags":
          break;
        default:
          J = !1;
          break;
      }
      if (J || s[3].match(/!\[CDATA/)) break;
      if (!l[l.length - 1][1]) throw "Unrecognized tag: " + s[3] + "|" + l.join("|");
      if (l[l.length - 1][0] === /*'CustomDocumentProperties'*/
      "customdocumentproperties") {
        if (s[0].slice(-2) === "/>") break;
        s[1] === "/" ? d4e(O, Q, k, r.slice(I, s.index)) : (k = s, I = s.index + s[0].length);
        break;
      }
      if (n.WTF) throw "Unrecognized tag: " + s[3] + "|" + l.join("|");
  }
  var he = {};
  return !n.bookSheets && !n.bookProps && (he.Sheets = c), he.SheetNames = f, he.Workbook = X, he.SSF = qn(jt), he.Props = T, he.Custprops = O, he;
}
function YS(e, t) {
  switch (mE(t = t || {}), t.type || "base64") {
    case "base64":
      return Fx(Fo(e), t);
    case "binary":
    case "buffer":
    case "file":
      return Fx(e, t);
    case "array":
      return Fx(vu(e), t);
  }
}
function g4e(e, t) {
  var n = [];
  return e.Props && n.push(j1e(e.Props, t)), e.Custprops && n.push(V1e(e.Props, e.Custprops)), n.join("");
}
function y4e() {
  return "";
}
function x4e(e, t) {
  var n = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
  return t.cellXfs.forEach(function(r, a) {
    var o = [];
    o.push(pt("NumberFormat", null, { "ss:Format": Nn(jt[r.numFmtId]) }));
    var i = (
      /*::(*/
      { "ss:ID": "s" + (21 + a) }
    );
    n.push(pt("Style", o.join(""), i));
  }), pt("Styles", n.join(""));
}
function NN(e) {
  return pt("NamedRange", null, { "ss:Name": e.Name, "ss:RefersTo": "=" + cE(e.Ref, { r: 0, c: 0 }) });
}
function b4e(e) {
  if (!((e || {}).Workbook || {}).Names) return "";
  for (var t = e.Workbook.Names, n = [], r = 0; r < t.length; ++r) {
    var a = t[r];
    a.Sheet == null && (a.Name.match(/^_xlfn\./) || n.push(NN(a)));
  }
  return pt("Names", n.join(""));
}
function w4e(e, t, n, r) {
  if (!e || !((r || {}).Workbook || {}).Names) return "";
  for (var a = r.Workbook.Names, o = [], i = 0; i < a.length; ++i) {
    var s = a[i];
    s.Sheet == n && (s.Name.match(/^_xlfn\./) || o.push(NN(s)));
  }
  return o.join("");
}
function S4e(e, t, n, r) {
  if (!e) return "";
  var a = [];
  if (e["!margins"] && (a.push("<PageSetup>"), e["!margins"].header && a.push(pt("Header", null, { "x:Margin": e["!margins"].header })), e["!margins"].footer && a.push(pt("Footer", null, { "x:Margin": e["!margins"].footer })), a.push(pt("PageMargins", null, {
    "x:Bottom": e["!margins"].bottom || "0.75",
    "x:Left": e["!margins"].left || "0.7",
    "x:Right": e["!margins"].right || "0.7",
    "x:Top": e["!margins"].top || "0.75"
  })), a.push("</PageSetup>")), r && r.Workbook && r.Workbook.Sheets && r.Workbook.Sheets[n])
    if (r.Workbook.Sheets[n].Hidden) a.push(pt("Visible", r.Workbook.Sheets[n].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
    else {
      for (var o = 0; o < n && !(r.Workbook.Sheets[o] && !r.Workbook.Sheets[o].Hidden); ++o) ;
      o == n && a.push("<Selected/>");
    }
  return ((((r || {}).Workbook || {}).Views || [])[0] || {}).RTL && a.push("<DisplayRightToLeft/>"), e["!protect"] && (a.push(oa("ProtectContents", "True")), e["!protect"].objects && a.push(oa("ProtectObjects", "True")), e["!protect"].scenarios && a.push(oa("ProtectScenarios", "True")), e["!protect"].selectLockedCells != null && !e["!protect"].selectLockedCells ? a.push(oa("EnableSelection", "NoSelection")) : e["!protect"].selectUnlockedCells != null && !e["!protect"].selectUnlockedCells && a.push(oa("EnableSelection", "UnlockedCells")), [
    ["formatCells", "AllowFormatCells"],
    ["formatColumns", "AllowSizeCols"],
    ["formatRows", "AllowSizeRows"],
    ["insertColumns", "AllowInsertCols"],
    ["insertRows", "AllowInsertRows"],
    ["insertHyperlinks", "AllowInsertHyperlinks"],
    ["deleteColumns", "AllowDeleteCols"],
    ["deleteRows", "AllowDeleteRows"],
    ["sort", "AllowSort"],
    ["autoFilter", "AllowFilter"],
    ["pivotTables", "AllowUsePivotTables"]
  ].forEach(function(i) {
    e["!protect"][i[0]] && a.push("<" + i[1] + "/>");
  })), a.length == 0 ? "" : pt("WorksheetOptions", a.join(""), { xmlns: Oo.x });
}
function _4e(e) {
  return e.map(function(t) {
    var n = Uge(t.t || ""), r = pt("ss:Data", n, { xmlns: "http://www.w3.org/TR/REC-html40" });
    return pt("Comment", r, { "ss:Author": t.a });
  }).join("");
}
function C4e(e, t, n, r, a, o, i) {
  if (!e || e.v == null && e.f == null) return "";
  var s = {};
  if (e.f && (s["ss:Formula"] = "=" + Nn(cE(e.f, i))), e.F && e.F.slice(0, t.length) == t) {
    var l = Nr(e.F.slice(t.length + 1));
    s["ss:ArrayRange"] = "RC:R" + (l.r == i.r ? "" : "[" + (l.r - i.r) + "]") + "C" + (l.c == i.c ? "" : "[" + (l.c - i.c) + "]");
  }
  if (e.l && e.l.Target && (s["ss:HRef"] = Nn(e.l.Target), e.l.Tooltip && (s["x:HRefScreenTip"] = Nn(e.l.Tooltip))), n["!merges"])
    for (var u = n["!merges"], c = 0; c != u.length; ++c)
      u[c].s.c != i.c || u[c].s.r != i.r || (u[c].e.c > u[c].s.c && (s["ss:MergeAcross"] = u[c].e.c - u[c].s.c), u[c].e.r > u[c].s.r && (s["ss:MergeDown"] = u[c].e.r - u[c].s.r));
  var f = "", d = "";
  switch (e.t) {
    case "z":
      if (!r.sheetStubs) return "";
      break;
    case "n":
      f = "Number", d = String(e.v);
      break;
    case "b":
      f = "Boolean", d = e.v ? "1" : "0";
      break;
    case "e":
      f = "Error", d = dl[e.v];
      break;
    case "d":
      f = "DateTime", d = new Date(e.v).toISOString(), e.z == null && (e.z = e.z || jt[14]);
      break;
    case "s":
      f = "String", d = Vge(e.v || "");
      break;
  }
  var p = mu(r.cellXfs, e, r);
  s["ss:StyleID"] = "s" + (21 + p), s["ss:Index"] = i.c + 1;
  var v = e.v != null ? d : "", h = e.t == "z" ? "" : '<Data ss:Type="' + f + '">' + v + "</Data>";
  return (e.c || []).length > 0 && (h += _4e(e.c)), pt("Cell", h, s);
}
function E4e(e, t) {
  var n = '<Row ss:Index="' + (e + 1) + '"';
  return t && (t.hpt && !t.hpx && (t.hpx = ld(t.hpt)), t.hpx && (n += ' ss:AutoFitHeight="0" ss:Height="' + t.hpx + '"'), t.hidden && (n += ' ss:Hidden="1"')), n + ">";
}
function T4e(e, t, n, r) {
  if (!e["!ref"]) return "";
  var a = kn(e["!ref"]), o = e["!merges"] || [], i = 0, s = [];
  e["!cols"] && e["!cols"].forEach(function(m, y) {
    ou(m);
    var x = !!m.width, g = K1(y, m), S = { "ss:Index": y + 1 };
    x && (S["ss:Width"] = _p(g.width)), m.hidden && (S["ss:Hidden"] = "1"), s.push(pt("Column", null, S));
  });
  for (var l = Array.isArray(e), u = a.s.r; u <= a.e.r; ++u) {
    for (var c = [E4e(u, (e["!rows"] || [])[u])], f = a.s.c; f <= a.e.c; ++f) {
      var d = !1;
      for (i = 0; i != o.length; ++i)
        if (!(o[i].s.c > f) && !(o[i].s.r > u) && !(o[i].e.c < f) && !(o[i].e.r < u)) {
          (o[i].s.c != f || o[i].s.r != u) && (d = !0);
          break;
        }
      if (!d) {
        var p = { r: u, c: f }, v = Kt(p), h = l ? (e[u] || [])[f] : e[v];
        c.push(C4e(h, v, e, t, n, r, p));
      }
    }
    c.push("</Row>"), c.length > 2 && s.push(c.join(""));
  }
  return s.join("");
}
function $4e(e, t, n) {
  var r = [], a = n.SheetNames[e], o = n.Sheets[a], i = o ? w4e(o, t, e, n) : "";
  return i.length > 0 && r.push("<Names>" + i + "</Names>"), i = o ? T4e(o, t, e, n) : "", i.length > 0 && r.push("<Table>" + i + "</Table>"), r.push(S4e(o, t, e, n)), r.join("");
}
function O4e(e, t) {
  t || (t = {}), e.SSF || (e.SSF = qn(jt)), e.SSF && (Id(), H1(e.SSF), t.revssf = V1(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF, t.cellXfs = [], mu(t.cellXfs, {}, { revssf: { General: 0 } }));
  var n = [];
  n.push(g4e(e, t)), n.push(y4e()), n.push(""), n.push("");
  for (var r = 0; r < e.SheetNames.length; ++r)
    n.push(pt("Worksheet", $4e(r, t, e), { "ss:Name": Nn(e.SheetNames[r]) }));
  return n[2] = x4e(e, t), n[3] = b4e(e), Tr + pt("Workbook", n.join(""), {
    xmlns: Oo.ss,
    "xmlns:o": Oo.o,
    "xmlns:x": Oo.x,
    "xmlns:ss": Oo.ss,
    "xmlns:dt": Oo.dt,
    "xmlns:html": Oo.html
  });
}
function A4e(e) {
  var t = {}, n = e.content;
  if (n.l = 28, t.AnsiUserType = n.read_shift(0, "lpstr-ansi"), t.AnsiClipboardFormat = b1e(n), n.length - n.l <= 4) return t;
  var r = n.read_shift(4);
  if (r == 0 || r > 40 || (n.l -= 4, t.Reserved1 = n.read_shift(0, "lpstr-ansi"), n.length - n.l <= 4) || (r = n.read_shift(4), r !== 1907505652) || (t.UnicodeClipboardFormat = w1e(n), r = n.read_shift(4), r == 0 || r > 40)) return t;
  n.l -= 4, t.Reserved2 = n.read_shift(0, "lpwstr");
}
var I4e = [60, 1084, 2066, 2165, 2175];
function P4e(e, t, n, r, a) {
  var o = r, i = [], s = n.slice(n.l, n.l + o);
  if (a && a.enc && a.enc.insitu && s.length > 0) switch (e) {
    case 9:
    case 521:
    case 1033:
    case 2057:
    case 47:
    case 405:
    case 225:
    case 406:
    case 312:
    case 404:
    case 10:
      break;
    case 133:
      break;
    default:
      a.enc.insitu(s);
  }
  i.push(s), n.l += o;
  for (var l = zs(n, n.l), u = qS[l], c = 0; u != null && I4e.indexOf(l) > -1; )
    o = zs(n, n.l + 2), c = n.l + 4, l == 2066 ? c += 4 : (l == 2165 || l == 2175) && (c += 12), s = n.slice(c, n.l + 4 + o), i.push(s), n.l += 4 + o, u = qS[l = zs(n, n.l)];
  var f = zr(i);
  ta(f, 0);
  var d = 0;
  f.lens = [];
  for (var p = 0; p < i.length; ++p)
    f.lens.push(d), d += i[p].length;
  if (f.length < r) throw "XLS Record 0x" + e.toString(16) + " Truncated: " + f.length + " < " + r;
  return t.f(f, f.length, a);
}
function qi(e, t, n) {
  if (e.t !== "z" && e.XF) {
    var r = 0;
    try {
      r = e.z || e.XF.numFmtId || 0, t.cellNF && (e.z = jt[r]);
    } catch (o) {
      if (t.WTF) throw o;
    }
    if (!t || t.cellText !== !1) try {
      e.t === "e" ? e.w = e.w || dl[e.v] : r === 0 || r == "General" ? e.t === "n" ? (e.v | 0) === e.v ? e.w = e.v.toString(10) : e.w = mp(e.v) : e.w = vc(e.v) : e.w = pi(r, e.v, { date1904: !!n, dateNF: t && t.dateNF });
    } catch (o) {
      if (t.WTF) throw o;
    }
    if (t.cellDates && r && e.t == "n" && Ad(jt[r] || String(r))) {
      var a = Bu(e.v);
      a && (e.t = "d", e.v = new Date(a.y, a.m - 1, a.d, a.H, a.M, a.S, a.u));
    }
  }
}
function yv(e, t, n) {
  return { v: e, ixfe: t, t: n };
}
function D4e(e, t) {
  var n = { opts: {} }, r = {}, a = t.dense ? [] : {}, o = {}, i = {}, s = null, l = [], u = "", c = {}, f, d = "", p, v, h, m, y = {}, x = [], g, S, w = [], _ = [], b = { Sheets: [], WBProps: { date1904: !1 }, Views: [{}] }, E = {}, C = function(ge) {
    return ge < 8 ? ec[ge] : ge < 64 && _[ge - 8] || ec[ge];
  }, T = function(ge, pe, De) {
    var Ue = pe.XF.data;
    if (!(!Ue || !Ue.patternType || !De || !De.cellStyles)) {
      pe.s = {}, pe.s.patternType = Ue.patternType;
      var Xe;
      (Xe = Sp(C(Ue.icvFore))) && (pe.s.fgColor = { rgb: Xe }), (Xe = Sp(C(Ue.icvBack))) && (pe.s.bgColor = { rgb: Xe });
    }
  }, O = function(ge, pe, De) {
    if (!(W > 1) && !(De.sheetRows && ge.r >= De.sheetRows)) {
      if (De.cellStyles && pe.XF && pe.XF.data && T(ge, pe, De), delete pe.ixfe, delete pe.XF, f = ge, d = Kt(ge), (!i || !i.s || !i.e) && (i = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }), ge.r < i.s.r && (i.s.r = ge.r), ge.c < i.s.c && (i.s.c = ge.c), ge.r + 1 > i.e.r && (i.e.r = ge.r + 1), ge.c + 1 > i.e.c && (i.e.c = ge.c + 1), De.cellFormula && pe.f) {
        for (var Ue = 0; Ue < x.length; ++Ue)
          if (!(x[Ue][0].s.c > ge.c || x[Ue][0].s.r > ge.r) && !(x[Ue][0].e.c < ge.c || x[Ue][0].e.r < ge.r)) {
            pe.F = vn(x[Ue][0]), (x[Ue][0].s.c != ge.c || x[Ue][0].s.r != ge.r) && delete pe.f, pe.f && (pe.f = "" + wa(x[Ue][1], i, ge, R, I));
            break;
          }
      }
      De.dense ? (a[ge.r] || (a[ge.r] = []), a[ge.r][ge.c] = pe) : a[d] = pe;
    }
  }, I = {
    enc: !1,
    // encrypted
    sbcch: 0,
    // cch in the preceding SupBook
    snames: [],
    // sheetnames
    sharedf: y,
    // shared formulae by address
    arrayf: x,
    // array formulae array
    rrtabid: [],
    // RRTabId
    lastuser: "",
    // Last User from WriteAccess
    biff: 8,
    // BIFF version
    codepage: 0,
    // CP from CodePage record
    winlocked: 0,
    // fLockWn from WinProtect
    cellStyles: !!t && !!t.cellStyles,
    WTF: !!t && !!t.wtf
  };
  t.password && (I.password = t.password);
  var k, B = [], P = [], N = [], M = [], H = !1, R = [];
  R.SheetNames = I.snames, R.sharedf = I.sharedf, R.arrayf = I.arrayf, R.names = [], R.XTI = [];
  var z = 0, W = 0, F = 0, Y = [], X = [], q;
  I.codepage = 1200, Fi(1200);
  for (var Q = !1; e.l < e.length - 1; ) {
    var ue = e.l, le = e.read_shift(2);
    if (le === 0 && z === 10) break;
    var te = e.l === e.length ? 0 : e.read_shift(2), G = qS[le];
    if (G && G.f) {
      if (t.bookSheets && z === 133 && le !== 133)
        break;
      if (z = le, G.r === 2 || G.r == 12) {
        var oe = e.read_shift(2);
        if (te -= 2, !I.enc && oe !== le && ((oe & 255) << 8 | oe >> 8) !== le) throw new Error("rt mismatch: " + oe + "!=" + le);
        G.r == 12 && (e.l += 10, te -= 10);
      }
      var L = {};
      if (le === 10 ? L = /*::(*/
      G.f(e, te, I) : L = /*::(*/
      P4e(le, G, e, te, I), W == 0 && [9, 521, 1033, 2057].indexOf(z) === -1) continue;
      switch (le) {
        case 34:
          n.opts.Date1904 = b.WBProps.date1904 = L;
          break;
        case 134:
          n.opts.WriteProtect = !0;
          break;
        case 47:
          if (I.enc || (e.l = 0), I.enc = L, !t.password) throw new Error("File is password-protected");
          if (L.valid == null) throw new Error("Encryption scheme unsupported");
          if (!L.valid) throw new Error("Password is incorrect");
          break;
        case 92:
          I.lastuser = L;
          break;
        case 66:
          var re = Number(L);
          switch (re) {
            case 21010:
              re = 1200;
              break;
            case 32768:
              re = 1e4;
              break;
            case 32769:
              re = 1252;
              break;
          }
          Fi(I.codepage = re), Q = !0;
          break;
        case 317:
          I.rrtabid = L;
          break;
        case 25:
          I.winlocked = L;
          break;
        case 439:
          n.opts.RefreshAll = L;
          break;
        case 12:
          n.opts.CalcCount = L;
          break;
        case 16:
          n.opts.CalcDelta = L;
          break;
        case 17:
          n.opts.CalcIter = L;
          break;
        case 13:
          n.opts.CalcMode = L;
          break;
        case 14:
          n.opts.CalcPrecision = L;
          break;
        case 95:
          n.opts.CalcSaveRecalc = L;
          break;
        case 15:
          I.CalcRefMode = L;
          break;
        case 2211:
          n.opts.FullCalc = L;
          break;
        case 129:
          L.fDialog && (a["!type"] = "dialog"), L.fBelow || ((a["!outline"] || (a["!outline"] = {})).above = !0), L.fRight || ((a["!outline"] || (a["!outline"] = {})).left = !0);
          break;
        case 224:
          w.push(L);
          break;
        case 430:
          R.push([L]), R[R.length - 1].XTI = [];
          break;
        case 35:
        case 547:
          R[R.length - 1].push(L);
          break;
        case 24:
        case 536:
          q = {
            Name: L.Name,
            Ref: wa(L.rgce, i, null, R, I)
          }, L.itab > 0 && (q.Sheet = L.itab - 1), R.names.push(q), R[0] || (R[0] = [], R[0].XTI = []), R[R.length - 1].push(L), L.Name == "_xlnm._FilterDatabase" && L.itab > 0 && L.rgce && L.rgce[0] && L.rgce[0][0] && L.rgce[0][0][0] == "PtgArea3d" && (X[L.itab - 1] = { ref: vn(L.rgce[0][0][1][2]) });
          break;
        case 22:
          I.ExternCount = L;
          break;
        case 23:
          R.length == 0 && (R[0] = [], R[0].XTI = []), R[R.length - 1].XTI = R[R.length - 1].XTI.concat(L), R.XTI = R.XTI.concat(L);
          break;
        case 2196:
          if (I.biff < 8) break;
          q != null && (q.Comment = L[1]);
          break;
        case 18:
          a["!protect"] = L;
          break;
        case 19:
          L !== 0 && I.WTF && console.error("Password verifier: " + L);
          break;
        case 133:
          o[L.pos] = L, I.snames.push(L.name);
          break;
        case 10:
          {
            if (--W) break;
            if (i.e) {
              if (i.e.r > 0 && i.e.c > 0) {
                if (i.e.r--, i.e.c--, a["!ref"] = vn(i), t.sheetRows && t.sheetRows <= i.e.r) {
                  var j = i.e.r;
                  i.e.r = t.sheetRows - 1, a["!fullref"] = a["!ref"], a["!ref"] = vn(i), i.e.r = j;
                }
                i.e.r++, i.e.c++;
              }
              B.length > 0 && (a["!merges"] = B), P.length > 0 && (a["!objects"] = P), N.length > 0 && (a["!cols"] = N), M.length > 0 && (a["!rows"] = M), b.Sheets.push(E);
            }
            u === "" ? c = a : r[u] = a, a = t.dense ? [] : {};
          }
          break;
        case 9:
        case 521:
        case 1033:
        case 2057:
          {
            if (I.biff === 8 && (I.biff = {
              /*::[*/
              9: 2,
              /*::[*/
              521: 3,
              /*::[*/
              1033: 4
            }[le] || {
              /*::[*/
              512: 2,
              /*::[*/
              768: 3,
              /*::[*/
              1024: 4,
              /*::[*/
              1280: 5,
              /*::[*/
              1536: 8,
              /*::[*/
              2: 2,
              /*::[*/
              7: 2
            }[L.BIFFVer] || 8), I.biffguess = L.BIFFVer == 0, L.BIFFVer == 0 && L.dt == 4096 && (I.biff = 5, Q = !0, Fi(I.codepage = 28591)), I.biff == 8 && L.BIFFVer == 0 && L.dt == 16 && (I.biff = 2), W++) break;
            if (a = t.dense ? [] : {}, I.biff < 8 && !Q && (Q = !0, Fi(I.codepage = t.codepage || 1252)), I.biff < 5 || L.BIFFVer == 0 && L.dt == 4096) {
              u === "" && (u = "Sheet1"), i = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
              var J = { pos: e.l - te, name: u };
              o[J.pos] = J, I.snames.push(u);
            } else u = (o[ue] || { name: "" }).name;
            L.dt == 32 && (a["!type"] = "chart"), L.dt == 64 && (a["!type"] = "macro"), B = [], P = [], I.arrayf = x = [], N = [], M = [], H = !1, E = { Hidden: (o[ue] || { hs: 0 }).hs, name: u };
          }
          break;
        case 515:
        case 3:
        case 2:
          a["!type"] == "chart" && (t.dense ? (a[L.r] || [])[L.c] : a[Kt({ c: L.c, r: L.r })]) && ++L.c, g = { ixfe: L.ixfe, XF: w[L.ixfe] || {}, v: L.val, t: "n" }, F > 0 && (g.z = Y[g.ixfe >> 8 & 63]), qi(g, t, n.opts.Date1904), O({ c: L.c, r: L.r }, g, t);
          break;
        case 5:
        case 517:
          g = { ixfe: L.ixfe, XF: w[L.ixfe], v: L.val, t: L.t }, F > 0 && (g.z = Y[g.ixfe >> 8 & 63]), qi(g, t, n.opts.Date1904), O({ c: L.c, r: L.r }, g, t);
          break;
        case 638:
          g = { ixfe: L.ixfe, XF: w[L.ixfe], v: L.rknum, t: "n" }, F > 0 && (g.z = Y[g.ixfe >> 8 & 63]), qi(g, t, n.opts.Date1904), O({ c: L.c, r: L.r }, g, t);
          break;
        case 189:
          for (var ae = L.c; ae <= L.C; ++ae) {
            var he = L.rkrec[ae - L.c][0];
            g = { ixfe: he, XF: w[he], v: L.rkrec[ae - L.c][1], t: "n" }, F > 0 && (g.z = Y[g.ixfe >> 8 & 63]), qi(g, t, n.opts.Date1904), O({ c: ae, r: L.r }, g, t);
          }
          break;
        case 6:
        case 518:
        case 1030:
          {
            if (L.val == "String") {
              s = L;
              break;
            }
            if (g = yv(L.val, L.cell.ixfe, L.tt), g.XF = w[g.ixfe], t.cellFormula) {
              var K = L.formula;
              if (K && K[0] && K[0][0] && K[0][0][0] == "PtgExp") {
                var Z = K[0][0][1][0], se = K[0][0][1][1], me = Kt({ r: Z, c: se });
                y[me] ? g.f = "" + wa(L.formula, i, L.cell, R, I) : g.F = ((t.dense ? (a[Z] || [])[se] : a[me]) || {}).F;
              } else g.f = "" + wa(L.formula, i, L.cell, R, I);
            }
            F > 0 && (g.z = Y[g.ixfe >> 8 & 63]), qi(g, t, n.opts.Date1904), O(L.cell, g, t), s = L;
          }
          break;
        case 7:
        case 519:
          if (s)
            s.val = L, g = yv(L, s.cell.ixfe, "s"), g.XF = w[g.ixfe], t.cellFormula && (g.f = "" + wa(s.formula, i, s.cell, R, I)), F > 0 && (g.z = Y[g.ixfe >> 8 & 63]), qi(g, t, n.opts.Date1904), O(s.cell, g, t), s = null;
          else throw new Error("String record expects Formula");
          break;
        case 33:
        case 545:
          {
            x.push(L);
            var xe = Kt(L[0].s);
            if (p = t.dense ? (a[L[0].s.r] || [])[L[0].s.c] : a[xe], t.cellFormula && p) {
              if (!s || !xe || !p) break;
              p.f = "" + wa(L[1], i, L[0], R, I), p.F = vn(L[0]);
            }
          }
          break;
        case 1212:
          {
            if (!t.cellFormula) break;
            if (d) {
              if (!s) break;
              y[Kt(s.cell)] = L[0], p = t.dense ? (a[s.cell.r] || [])[s.cell.c] : a[Kt(s.cell)], (p || {}).f = "" + wa(L[0], i, f, R, I);
            }
          }
          break;
        case 253:
          g = yv(l[L.isst].t, L.ixfe, "s"), l[L.isst].h && (g.h = l[L.isst].h), g.XF = w[g.ixfe], F > 0 && (g.z = Y[g.ixfe >> 8 & 63]), qi(g, t, n.opts.Date1904), O({ c: L.c, r: L.r }, g, t);
          break;
        case 513:
          t.sheetStubs && (g = { ixfe: L.ixfe, XF: w[L.ixfe], t: "z" }, F > 0 && (g.z = Y[g.ixfe >> 8 & 63]), qi(g, t, n.opts.Date1904), O({ c: L.c, r: L.r }, g, t));
          break;
        case 190:
          if (t.sheetStubs)
            for (var be = L.c; be <= L.C; ++be) {
              var Te = L.ixfe[be - L.c];
              g = { ixfe: Te, XF: w[Te], t: "z" }, F > 0 && (g.z = Y[g.ixfe >> 8 & 63]), qi(g, t, n.opts.Date1904), O({ c: be, r: L.r }, g, t);
            }
          break;
        case 214:
        case 516:
        case 4:
          g = yv(L.val, L.ixfe, "s"), g.XF = w[g.ixfe], F > 0 && (g.z = Y[g.ixfe >> 8 & 63]), qi(g, t, n.opts.Date1904), O({ c: L.c, r: L.r }, g, t);
          break;
        case 0:
        case 512:
          W === 1 && (i = L);
          break;
        case 252:
          l = L;
          break;
        case 1054:
          if (I.biff == 4) {
            Y[F++] = L[1];
            for (var Ie = 0; Ie < F + 163 && jt[Ie] != L[1]; ++Ie) ;
            Ie >= 163 && qs(L[1], F + 163);
          } else qs(L[1], L[0]);
          break;
        case 30:
          {
            Y[F++] = L;
            for (var Ve = 0; Ve < F + 163 && jt[Ve] != L; ++Ve) ;
            Ve >= 163 && qs(L, F + 163);
          }
          break;
        case 229:
          B = B.concat(L);
          break;
        case 93:
          P[L.cmo[0]] = I.lastobj = L;
          break;
        case 438:
          I.lastobj.TxO = L;
          break;
        case 127:
          I.lastobj.ImData = L;
          break;
        case 440:
          for (m = L[0].s.r; m <= L[0].e.r; ++m)
            for (h = L[0].s.c; h <= L[0].e.c; ++h)
              p = t.dense ? (a[m] || [])[h] : a[Kt({ c: h, r: m })], p && (p.l = L[1]);
          break;
        case 2048:
          for (m = L[0].s.r; m <= L[0].e.r; ++m)
            for (h = L[0].s.c; h <= L[0].e.c; ++h)
              p = t.dense ? (a[m] || [])[h] : a[Kt({ c: h, r: m })], p && p.l && (p.l.Tooltip = L[1]);
          break;
        case 28:
          {
            if (I.biff <= 5 && I.biff >= 2) break;
            p = t.dense ? (a[L[0].r] || [])[L[0].c] : a[Kt(L[0])];
            var tt = P[L[2]];
            p || (t.dense ? (a[L[0].r] || (a[L[0].r] = []), p = a[L[0].r][L[0].c] = { t: "z" }) : p = a[Kt(L[0])] = { t: "z" }, i.e.r = Math.max(i.e.r, L[0].r), i.s.r = Math.min(i.s.r, L[0].r), i.e.c = Math.max(i.e.c, L[0].c), i.s.c = Math.min(i.s.c, L[0].c)), p.c || (p.c = []), v = { a: L[1], t: tt.TxO.t }, p.c.push(v);
          }
          break;
        case 2173:
          x2e(w[L.ixfe], L.ext);
          break;
        case 125:
          {
            if (!I.cellStyles) break;
            for (; L.e >= L.s; )
              N[L.e--] = { width: L.w / 256, level: L.level || 0, hidden: !!(L.flags & 1) }, H || (H = !0, sE(L.w / 256)), ou(N[L.e + 1]);
          }
          break;
        case 520:
          {
            var it = {};
            L.level != null && (M[L.r] = it, it.level = L.level), L.hidden && (M[L.r] = it, it.hidden = !0), L.hpt && (M[L.r] = it, it.hpt = L.hpt, it.hpx = ld(L.hpt));
          }
          break;
        case 38:
        case 39:
        case 40:
        case 41:
          a["!margins"] || rc(a["!margins"] = {}), a["!margins"][{ 38: "left", 39: "right", 40: "top", 41: "bottom" }[le]] = L;
          break;
        case 161:
          a["!margins"] || rc(a["!margins"] = {}), a["!margins"].header = L.header, a["!margins"].footer = L.footer;
          break;
        case 574:
          L.RTL && (b.Views[0].RTL = !0);
          break;
        case 146:
          _ = L;
          break;
        case 2198:
          k = L;
          break;
        case 140:
          S = L;
          break;
        case 442:
          u ? E.CodeName = L || E.name : b.WBProps.CodeName = L || "ThisWorkbook";
          break;
      }
    } else
      G || console.error("Missing Info for XLS Record 0x" + le.toString(16)), e.l += te;
  }
  return n.SheetNames = Er(o).sort(function(Se, ge) {
    return Number(Se) - Number(ge);
  }).map(function(Se) {
    return o[Se].name;
  }), t.bookSheets || (n.Sheets = r), !n.SheetNames.length && c["!ref"] ? (n.SheetNames.push("Sheet1"), n.Sheets && (n.Sheets.Sheet1 = c)) : n.Preamble = c, n.Sheets && X.forEach(function(Se, ge) {
    n.Sheets[n.SheetNames[ge]]["!autofilter"] = Se;
  }), n.Strings = l, n.SSF = qn(jt), I.enc && (n.Encryption = I.enc), k && (n.Themes = k), n.Metadata = {}, S !== void 0 && (n.Metadata.Country = S), R.names.length > 0 && (b.Names = R.names), n.Workbook = b, n;
}
var j0 = {
  SI: "e0859ff2f94f6810ab9108002b27b3d9",
  DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
  UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function k4e(e, t, n) {
  var r = Dt.find(e, "/!DocumentSummaryInformation");
  if (r && r.size > 0) try {
    var a = xO(r, VS, j0.DSI);
    for (var o in a) t[o] = a[o];
  } catch (u) {
    if (n.WTF) throw u;
  }
  var i = Dt.find(e, "/!SummaryInformation");
  if (i && i.size > 0) try {
    var s = xO(i, US, j0.SI);
    for (var l in s) t[l] == null && (t[l] = s[l]);
  } catch (u) {
    if (n.WTF) throw u;
  }
  t.HeadingPairs && t.TitlesOfParts && (RR(t.HeadingPairs, t.TitlesOfParts, t, n), delete t.HeadingPairs, delete t.TitlesOfParts);
}
function M4e(e, t) {
  var n = [], r = [], a = [], o = 0, i, s = q6(VS, "n"), l = q6(US, "n");
  if (e.Props)
    for (i = Er(e.Props), o = 0; o < i.length; ++o) (Object.prototype.hasOwnProperty.call(s, i[o]) ? n : Object.prototype.hasOwnProperty.call(l, i[o]) ? r : a).push([i[o], e.Props[i[o]]]);
  if (e.Custprops)
    for (i = Er(e.Custprops), o = 0; o < i.length; ++o) Object.prototype.hasOwnProperty.call(e.Props || {}, i[o]) || (Object.prototype.hasOwnProperty.call(s, i[o]) ? n : Object.prototype.hasOwnProperty.call(l, i[o]) ? r : a).push([i[o], e.Custprops[i[o]]]);
  var u = [];
  for (o = 0; o < a.length; ++o)
    VR.indexOf(a[o][0]) > -1 || MR.indexOf(a[o][0]) > -1 || a[o][1] != null && u.push(a[o]);
  r.length && Dt.utils.cfb_add(t, "/SummaryInformation", bO(r, j0.SI, l, US)), (n.length || u.length) && Dt.utils.cfb_add(t, "/DocumentSummaryInformation", bO(n, j0.DSI, s, VS, u.length ? u : null, j0.UDI));
}
function FN(e, t) {
  t || (t = {}), mE(t), B4(), t.codepage && L4(t.codepage);
  var n, r;
  if (e.FullPaths) {
    if (Dt.find(e, "/encryption")) throw new Error("File is password-protected");
    n = Dt.find(e, "!CompObj"), r = Dt.find(e, "/Workbook") || Dt.find(e, "/Book");
  } else {
    switch (t.type) {
      case "base64":
        e = Po(Fo(e));
        break;
      case "binary":
        e = Po(e);
        break;
      case "buffer":
        break;
      case "array":
        Array.isArray(e) || (e = Array.prototype.slice.call(e));
        break;
    }
    ta(e, 0), r = { content: e };
  }
  var a, o;
  if (n && A4e(n), t.bookProps && !t.bookSheets) a = {};
  else {
    var i = on ? "buffer" : "array";
    if (r && r.content) a = D4e(r.content, t);
    else if ((o = Dt.find(e, "PerfectOffice_MAIN")) && o.content) a = nc.to_workbook(o.content, (t.type = i, t));
    else if ((o = Dt.find(e, "NativeContent_MAIN")) && o.content) a = nc.to_workbook(o.content, (t.type = i, t));
    else throw (o = Dt.find(e, "MN0")) && o.content ? new Error("Unsupported Works 4 for Mac file") : new Error("Cannot find Workbook stream");
    t.bookVBA && e.FullPaths && Dt.find(e, "/_VBA_PROJECT_CUR/VBA/dir") && (a.vbaraw = K2e(e));
  }
  var s = {};
  return e.FullPaths && k4e(
    /*::((*/
    e,
    s,
    t
  ), a.Props = a.Custprops = s, t.bookFiles && (a.cfb = e), a;
}
function R4e(e, t) {
  var n = t || {}, r = Dt.utils.cfb_new({ root: "R" }), a = "/Workbook";
  switch (n.bookType || "xls") {
    case "xls":
      n.bookType = "biff8";
    case "xla":
      n.bookType || (n.bookType = "xla");
    case "biff8":
      a = "/Workbook", n.biff = 8;
      break;
    case "biff5":
      a = "/Book", n.biff = 5;
      break;
    default:
      throw new Error("invalid type " + n.bookType + " for XLS CFB");
  }
  return Dt.utils.cfb_add(r, a, LN(e, n)), n.biff == 8 && (e.Props || e.Custprops) && M4e(e, r), n.biff == 8 && e.vbaraw && Y2e(r, Dt.read(e.vbaraw, { type: typeof e.vbaraw == "string" ? "binary" : "buffer" })), r;
}
var Tp = {
  /*::[*/
  0: {
    /* n:"BrtRowHdr", */
    f: o_e
  },
  /*::[*/
  1: {
    /* n:"BrtCellBlank", */
    f: p_e
  },
  /*::[*/
  2: {
    /* n:"BrtCellRk", */
    f: D_e
  },
  /*::[*/
  3: {
    /* n:"BrtCellError", */
    f: w_e
  },
  /*::[*/
  4: {
    /* n:"BrtCellBool", */
    f: g_e
  },
  /*::[*/
  5: {
    /* n:"BrtCellReal", */
    f: A_e
  },
  /*::[*/
  6: {
    /* n:"BrtCellSt", */
    f: F_e
  },
  /*::[*/
  7: {
    /* n:"BrtCellIsst", */
    f: E_e
  },
  /*::[*/
  8: {
    /* n:"BrtFmlaString", */
    f: z_e
  },
  /*::[*/
  9: {
    /* n:"BrtFmlaNum", */
    f: U_e
  },
  /*::[*/
  10: {
    /* n:"BrtFmlaBool", */
    f: j_e
  },
  /*::[*/
  11: {
    /* n:"BrtFmlaError", */
    f: V_e
  },
  /*::[*/
  12: {
    /* n:"BrtShortBlank", */
    f: v_e
  },
  /*::[*/
  13: {
    /* n:"BrtShortRk", */
    f: M_e
  },
  /*::[*/
  14: {
    /* n:"BrtShortError", */
    f: __e
  },
  /*::[*/
  15: {
    /* n:"BrtShortBool", */
    f: x_e
  },
  /*::[*/
  16: {
    /* n:"BrtShortReal", */
    f: AN
  },
  /*::[*/
  17: {
    /* n:"BrtShortSt", */
    f: B_e
  },
  /*::[*/
  18: {
    /* n:"BrtShortIsst", */
    f: $_e
  },
  /*::[*/
  19: {
    /* n:"BrtSSTItem", */
    f: Z4
  },
  /*::[*/
  20: {
    /* n:"BrtPCDIMissing" */
  },
  /*::[*/
  21: {
    /* n:"BrtPCDINumber" */
  },
  /*::[*/
  22: {
    /* n:"BrtPCDIBoolean" */
  },
  /*::[*/
  23: {
    /* n:"BrtPCDIError" */
  },
  /*::[*/
  24: {
    /* n:"BrtPCDIString" */
  },
  /*::[*/
  25: {
    /* n:"BrtPCDIDatetime" */
  },
  /*::[*/
  26: {
    /* n:"BrtPCDIIndex" */
  },
  /*::[*/
  27: {
    /* n:"BrtPCDIAMissing" */
  },
  /*::[*/
  28: {
    /* n:"BrtPCDIANumber" */
  },
  /*::[*/
  29: {
    /* n:"BrtPCDIABoolean" */
  },
  /*::[*/
  30: {
    /* n:"BrtPCDIAError" */
  },
  /*::[*/
  31: {
    /* n:"BrtPCDIAString" */
  },
  /*::[*/
  32: {
    /* n:"BrtPCDIADatetime" */
  },
  /*::[*/
  33: {
    /* n:"BrtPCRRecord" */
  },
  /*::[*/
  34: {
    /* n:"BrtPCRRecordDt" */
  },
  /*::[*/
  35: {
    /* n:"BrtFRTBegin", */
    T: 1
  },
  /*::[*/
  36: {
    /* n:"BrtFRTEnd", */
    T: -1
  },
  /*::[*/
  37: {
    /* n:"BrtACBegin", */
    T: 1
  },
  /*::[*/
  38: {
    /* n:"BrtACEnd", */
    T: -1
  },
  /*::[*/
  39: {
    /* n:"BrtName", */
    f: BCe
  },
  /*::[*/
  40: {
    /* n:"BrtIndexRowBlock" */
  },
  /*::[*/
  42: {
    /* n:"BrtIndexBlock" */
  },
  /*::[*/
  43: {
    /* n:"BrtFont", */
    f: Fbe
  },
  /*::[*/
  44: {
    /* n:"BrtFmt", */
    f: Rbe
  },
  /*::[*/
  45: {
    /* n:"BrtFill", */
    f: Hbe
  },
  /*::[*/
  46: {
    /* n:"BrtBorder", */
    f: Vbe
  },
  /*::[*/
  47: {
    /* n:"BrtXF", */
    f: jbe
  },
  /*::[*/
  48: {
    /* n:"BrtStyle" */
  },
  /*::[*/
  49: {
    /* n:"BrtCellMeta", */
    f: l1e
  },
  /*::[*/
  50: {
    /* n:"BrtValueMeta" */
  },
  /*::[*/
  51: {
    /* n:"BrtMdb" */
    f: S2e
  },
  /*::[*/
  52: {
    /* n:"BrtBeginFmd", */
    T: 1
  },
  /*::[*/
  53: {
    /* n:"BrtEndFmd", */
    T: -1
  },
  /*::[*/
  54: {
    /* n:"BrtBeginMdx", */
    T: 1
  },
  /*::[*/
  55: {
    /* n:"BrtEndMdx", */
    T: -1
  },
  /*::[*/
  56: {
    /* n:"BrtBeginMdxTuple", */
    T: 1
  },
  /*::[*/
  57: {
    /* n:"BrtEndMdxTuple", */
    T: -1
  },
  /*::[*/
  58: {
    /* n:"BrtMdxMbrIstr" */
  },
  /*::[*/
  59: {
    /* n:"BrtStr" */
  },
  /*::[*/
  60: {
    /* n:"BrtColInfo", */
    f: JR
  },
  /*::[*/
  62: {
    /* n:"BrtCellRString", */
    f: N_e
  },
  /*::[*/
  63: {
    /* n:"BrtCalcChainItem$", */
    f: P2e
  },
  /*::[*/
  64: {
    /* n:"BrtDVal", */
    f: iCe
  },
  /*::[*/
  65: {
    /* n:"BrtSxvcellNum" */
  },
  /*::[*/
  66: {
    /* n:"BrtSxvcellStr" */
  },
  /*::[*/
  67: {
    /* n:"BrtSxvcellBool" */
  },
  /*::[*/
  68: {
    /* n:"BrtSxvcellErr" */
  },
  /*::[*/
  69: {
    /* n:"BrtSxvcellDate" */
  },
  /*::[*/
  70: {
    /* n:"BrtSxvcellNil" */
  },
  /*::[*/
  128: {
    /* n:"BrtFileVersion" */
  },
  /*::[*/
  129: {
    /* n:"BrtBeginSheet", */
    T: 1
  },
  /*::[*/
  130: {
    /* n:"BrtEndSheet", */
    T: -1
  },
  /*::[*/
  131: {
    /* n:"BrtBeginBook", */
    T: 1,
    f: Ma,
    p: 0
  },
  /*::[*/
  132: {
    /* n:"BrtEndBook", */
    T: -1
  },
  /*::[*/
  133: {
    /* n:"BrtBeginWsViews", */
    T: 1
  },
  /*::[*/
  134: {
    /* n:"BrtEndWsViews", */
    T: -1
  },
  /*::[*/
  135: {
    /* n:"BrtBeginBookViews", */
    T: 1
  },
  /*::[*/
  136: {
    /* n:"BrtEndBookViews", */
    T: -1
  },
  /*::[*/
  137: {
    /* n:"BrtBeginWsView", */
    T: 1,
    f: nCe
  },
  /*::[*/
  138: {
    /* n:"BrtEndWsView", */
    T: -1
  },
  /*::[*/
  139: {
    /* n:"BrtBeginCsViews", */
    T: 1
  },
  /*::[*/
  140: {
    /* n:"BrtEndCsViews", */
    T: -1
  },
  /*::[*/
  141: {
    /* n:"BrtBeginCsView", */
    T: 1
  },
  /*::[*/
  142: {
    /* n:"BrtEndCsView", */
    T: -1
  },
  /*::[*/
  143: {
    /* n:"BrtBeginBundleShs", */
    T: 1
  },
  /*::[*/
  144: {
    /* n:"BrtEndBundleShs", */
    T: -1
  },
  /*::[*/
  145: {
    /* n:"BrtBeginSheetData", */
    T: 1
  },
  /*::[*/
  146: {
    /* n:"BrtEndSheetData", */
    T: -1
  },
  /*::[*/
  147: {
    /* n:"BrtWsProp", */
    f: f_e
  },
  /*::[*/
  148: {
    /* n:"BrtWsDim", */
    f: l_e,
    p: 16
  },
  /*::[*/
  151: {
    /* n:"BrtPane", */
    f: X_e
  },
  /*::[*/
  152: {
    /* n:"BrtSel" */
  },
  /*::[*/
  153: {
    /* n:"BrtWbProp", */
    f: NCe
  },
  /*::[*/
  154: {
    /* n:"BrtWbFactoid" */
  },
  /*::[*/
  155: {
    /* n:"BrtFileRecover" */
  },
  /*::[*/
  156: {
    /* n:"BrtBundleSh", */
    f: MCe
  },
  /*::[*/
  157: {
    /* n:"BrtCalcProp" */
  },
  /*::[*/
  158: {
    /* n:"BrtBookView" */
  },
  /*::[*/
  159: {
    /* n:"BrtBeginSst", */
    T: 1,
    f: Qxe
  },
  /*::[*/
  160: {
    /* n:"BrtEndSst", */
    T: -1
  },
  /*::[*/
  161: {
    /* n:"BrtBeginAFilter", */
    T: 1,
    f: jc
  },
  /*::[*/
  162: {
    /* n:"BrtEndAFilter", */
    T: -1
  },
  /*::[*/
  163: {
    /* n:"BrtBeginFilterColumn", */
    T: 1
  },
  /*::[*/
  164: {
    /* n:"BrtEndFilterColumn", */
    T: -1
  },
  /*::[*/
  165: {
    /* n:"BrtBeginFilters", */
    T: 1
  },
  /*::[*/
  166: {
    /* n:"BrtEndFilters", */
    T: -1
  },
  /*::[*/
  167: {
    /* n:"BrtFilter" */
  },
  /*::[*/
  168: {
    /* n:"BrtColorFilter" */
  },
  /*::[*/
  169: {
    /* n:"BrtIconFilter" */
  },
  /*::[*/
  170: {
    /* n:"BrtTop10Filter" */
  },
  /*::[*/
  171: {
    /* n:"BrtDynamicFilter" */
  },
  /*::[*/
  172: {
    /* n:"BrtBeginCustomFilters", */
    T: 1
  },
  /*::[*/
  173: {
    /* n:"BrtEndCustomFilters", */
    T: -1
  },
  /*::[*/
  174: {
    /* n:"BrtCustomFilter" */
  },
  /*::[*/
  175: {
    /* n:"BrtAFilterDateGroupItem" */
  },
  /*::[*/
  176: {
    /* n:"BrtMergeCell", */
    f: W_e
  },
  /*::[*/
  177: {
    /* n:"BrtBeginMergeCells", */
    T: 1
  },
  /*::[*/
  178: {
    /* n:"BrtEndMergeCells", */
    T: -1
  },
  /*::[*/
  179: {
    /* n:"BrtBeginPivotCacheDef", */
    T: 1
  },
  /*::[*/
  180: {
    /* n:"BrtEndPivotCacheDef", */
    T: -1
  },
  /*::[*/
  181: {
    /* n:"BrtBeginPCDFields", */
    T: 1
  },
  /*::[*/
  182: {
    /* n:"BrtEndPCDFields", */
    T: -1
  },
  /*::[*/
  183: {
    /* n:"BrtBeginPCDField", */
    T: 1
  },
  /*::[*/
  184: {
    /* n:"BrtEndPCDField", */
    T: -1
  },
  /*::[*/
  185: {
    /* n:"BrtBeginPCDSource", */
    T: 1
  },
  /*::[*/
  186: {
    /* n:"BrtEndPCDSource", */
    T: -1
  },
  /*::[*/
  187: {
    /* n:"BrtBeginPCDSRange", */
    T: 1
  },
  /*::[*/
  188: {
    /* n:"BrtEndPCDSRange", */
    T: -1
  },
  /*::[*/
  189: {
    /* n:"BrtBeginPCDFAtbl", */
    T: 1
  },
  /*::[*/
  190: {
    /* n:"BrtEndPCDFAtbl", */
    T: -1
  },
  /*::[*/
  191: {
    /* n:"BrtBeginPCDIRun", */
    T: 1
  },
  /*::[*/
  192: {
    /* n:"BrtEndPCDIRun", */
    T: -1
  },
  /*::[*/
  193: {
    /* n:"BrtBeginPivotCacheRecords", */
    T: 1
  },
  /*::[*/
  194: {
    /* n:"BrtEndPivotCacheRecords", */
    T: -1
  },
  /*::[*/
  195: {
    /* n:"BrtBeginPCDHierarchies", */
    T: 1
  },
  /*::[*/
  196: {
    /* n:"BrtEndPCDHierarchies", */
    T: -1
  },
  /*::[*/
  197: {
    /* n:"BrtBeginPCDHierarchy", */
    T: 1
  },
  /*::[*/
  198: {
    /* n:"BrtEndPCDHierarchy", */
    T: -1
  },
  /*::[*/
  199: {
    /* n:"BrtBeginPCDHFieldsUsage", */
    T: 1
  },
  /*::[*/
  200: {
    /* n:"BrtEndPCDHFieldsUsage", */
    T: -1
  },
  /*::[*/
  201: {
    /* n:"BrtBeginExtConnection", */
    T: 1
  },
  /*::[*/
  202: {
    /* n:"BrtEndExtConnection", */
    T: -1
  },
  /*::[*/
  203: {
    /* n:"BrtBeginECDbProps", */
    T: 1
  },
  /*::[*/
  204: {
    /* n:"BrtEndECDbProps", */
    T: -1
  },
  /*::[*/
  205: {
    /* n:"BrtBeginECOlapProps", */
    T: 1
  },
  /*::[*/
  206: {
    /* n:"BrtEndECOlapProps", */
    T: -1
  },
  /*::[*/
  207: {
    /* n:"BrtBeginPCDSConsol", */
    T: 1
  },
  /*::[*/
  208: {
    /* n:"BrtEndPCDSConsol", */
    T: -1
  },
  /*::[*/
  209: {
    /* n:"BrtBeginPCDSCPages", */
    T: 1
  },
  /*::[*/
  210: {
    /* n:"BrtEndPCDSCPages", */
    T: -1
  },
  /*::[*/
  211: {
    /* n:"BrtBeginPCDSCPage", */
    T: 1
  },
  /*::[*/
  212: {
    /* n:"BrtEndPCDSCPage", */
    T: -1
  },
  /*::[*/
  213: {
    /* n:"BrtBeginPCDSCPItem", */
    T: 1
  },
  /*::[*/
  214: {
    /* n:"BrtEndPCDSCPItem", */
    T: -1
  },
  /*::[*/
  215: {
    /* n:"BrtBeginPCDSCSets", */
    T: 1
  },
  /*::[*/
  216: {
    /* n:"BrtEndPCDSCSets", */
    T: -1
  },
  /*::[*/
  217: {
    /* n:"BrtBeginPCDSCSet", */
    T: 1
  },
  /*::[*/
  218: {
    /* n:"BrtEndPCDSCSet", */
    T: -1
  },
  /*::[*/
  219: {
    /* n:"BrtBeginPCDFGroup", */
    T: 1
  },
  /*::[*/
  220: {
    /* n:"BrtEndPCDFGroup", */
    T: -1
  },
  /*::[*/
  221: {
    /* n:"BrtBeginPCDFGItems", */
    T: 1
  },
  /*::[*/
  222: {
    /* n:"BrtEndPCDFGItems", */
    T: -1
  },
  /*::[*/
  223: {
    /* n:"BrtBeginPCDFGRange", */
    T: 1
  },
  /*::[*/
  224: {
    /* n:"BrtEndPCDFGRange", */
    T: -1
  },
  /*::[*/
  225: {
    /* n:"BrtBeginPCDFGDiscrete", */
    T: 1
  },
  /*::[*/
  226: {
    /* n:"BrtEndPCDFGDiscrete", */
    T: -1
  },
  /*::[*/
  227: {
    /* n:"BrtBeginPCDSDTupleCache", */
    T: 1
  },
  /*::[*/
  228: {
    /* n:"BrtEndPCDSDTupleCache", */
    T: -1
  },
  /*::[*/
  229: {
    /* n:"BrtBeginPCDSDTCEntries", */
    T: 1
  },
  /*::[*/
  230: {
    /* n:"BrtEndPCDSDTCEntries", */
    T: -1
  },
  /*::[*/
  231: {
    /* n:"BrtBeginPCDSDTCEMembers", */
    T: 1
  },
  /*::[*/
  232: {
    /* n:"BrtEndPCDSDTCEMembers", */
    T: -1
  },
  /*::[*/
  233: {
    /* n:"BrtBeginPCDSDTCEMember", */
    T: 1
  },
  /*::[*/
  234: {
    /* n:"BrtEndPCDSDTCEMember", */
    T: -1
  },
  /*::[*/
  235: {
    /* n:"BrtBeginPCDSDTCQueries", */
    T: 1
  },
  /*::[*/
  236: {
    /* n:"BrtEndPCDSDTCQueries", */
    T: -1
  },
  /*::[*/
  237: {
    /* n:"BrtBeginPCDSDTCQuery", */
    T: 1
  },
  /*::[*/
  238: {
    /* n:"BrtEndPCDSDTCQuery", */
    T: -1
  },
  /*::[*/
  239: {
    /* n:"BrtBeginPCDSDTCSets", */
    T: 1
  },
  /*::[*/
  240: {
    /* n:"BrtEndPCDSDTCSets", */
    T: -1
  },
  /*::[*/
  241: {
    /* n:"BrtBeginPCDSDTCSet", */
    T: 1
  },
  /*::[*/
  242: {
    /* n:"BrtEndPCDSDTCSet", */
    T: -1
  },
  /*::[*/
  243: {
    /* n:"BrtBeginPCDCalcItems", */
    T: 1
  },
  /*::[*/
  244: {
    /* n:"BrtEndPCDCalcItems", */
    T: -1
  },
  /*::[*/
  245: {
    /* n:"BrtBeginPCDCalcItem", */
    T: 1
  },
  /*::[*/
  246: {
    /* n:"BrtEndPCDCalcItem", */
    T: -1
  },
  /*::[*/
  247: {
    /* n:"BrtBeginPRule", */
    T: 1
  },
  /*::[*/
  248: {
    /* n:"BrtEndPRule", */
    T: -1
  },
  /*::[*/
  249: {
    /* n:"BrtBeginPRFilters", */
    T: 1
  },
  /*::[*/
  250: {
    /* n:"BrtEndPRFilters", */
    T: -1
  },
  /*::[*/
  251: {
    /* n:"BrtBeginPRFilter", */
    T: 1
  },
  /*::[*/
  252: {
    /* n:"BrtEndPRFilter", */
    T: -1
  },
  /*::[*/
  253: {
    /* n:"BrtBeginPNames", */
    T: 1
  },
  /*::[*/
  254: {
    /* n:"BrtEndPNames", */
    T: -1
  },
  /*::[*/
  255: {
    /* n:"BrtBeginPName", */
    T: 1
  },
  /*::[*/
  256: {
    /* n:"BrtEndPName", */
    T: -1
  },
  /*::[*/
  257: {
    /* n:"BrtBeginPNPairs", */
    T: 1
  },
  /*::[*/
  258: {
    /* n:"BrtEndPNPairs", */
    T: -1
  },
  /*::[*/
  259: {
    /* n:"BrtBeginPNPair", */
    T: 1
  },
  /*::[*/
  260: {
    /* n:"BrtEndPNPair", */
    T: -1
  },
  /*::[*/
  261: {
    /* n:"BrtBeginECWebProps", */
    T: 1
  },
  /*::[*/
  262: {
    /* n:"BrtEndECWebProps", */
    T: -1
  },
  /*::[*/
  263: {
    /* n:"BrtBeginEcWpTables", */
    T: 1
  },
  /*::[*/
  264: {
    /* n:"BrtEndECWPTables", */
    T: -1
  },
  /*::[*/
  265: {
    /* n:"BrtBeginECParams", */
    T: 1
  },
  /*::[*/
  266: {
    /* n:"BrtEndECParams", */
    T: -1
  },
  /*::[*/
  267: {
    /* n:"BrtBeginECParam", */
    T: 1
  },
  /*::[*/
  268: {
    /* n:"BrtEndECParam", */
    T: -1
  },
  /*::[*/
  269: {
    /* n:"BrtBeginPCDKPIs", */
    T: 1
  },
  /*::[*/
  270: {
    /* n:"BrtEndPCDKPIs", */
    T: -1
  },
  /*::[*/
  271: {
    /* n:"BrtBeginPCDKPI", */
    T: 1
  },
  /*::[*/
  272: {
    /* n:"BrtEndPCDKPI", */
    T: -1
  },
  /*::[*/
  273: {
    /* n:"BrtBeginDims", */
    T: 1
  },
  /*::[*/
  274: {
    /* n:"BrtEndDims", */
    T: -1
  },
  /*::[*/
  275: {
    /* n:"BrtBeginDim", */
    T: 1
  },
  /*::[*/
  276: {
    /* n:"BrtEndDim", */
    T: -1
  },
  /*::[*/
  277: {
    /* n:"BrtIndexPartEnd" */
  },
  /*::[*/
  278: {
    /* n:"BrtBeginStyleSheet", */
    T: 1
  },
  /*::[*/
  279: {
    /* n:"BrtEndStyleSheet", */
    T: -1
  },
  /*::[*/
  280: {
    /* n:"BrtBeginSXView", */
    T: 1
  },
  /*::[*/
  281: {
    /* n:"BrtEndSXVI", */
    T: -1
  },
  /*::[*/
  282: {
    /* n:"BrtBeginSXVI", */
    T: 1
  },
  /*::[*/
  283: {
    /* n:"BrtBeginSXVIs", */
    T: 1
  },
  /*::[*/
  284: {
    /* n:"BrtEndSXVIs", */
    T: -1
  },
  /*::[*/
  285: {
    /* n:"BrtBeginSXVD", */
    T: 1
  },
  /*::[*/
  286: {
    /* n:"BrtEndSXVD", */
    T: -1
  },
  /*::[*/
  287: {
    /* n:"BrtBeginSXVDs", */
    T: 1
  },
  /*::[*/
  288: {
    /* n:"BrtEndSXVDs", */
    T: -1
  },
  /*::[*/
  289: {
    /* n:"BrtBeginSXPI", */
    T: 1
  },
  /*::[*/
  290: {
    /* n:"BrtEndSXPI", */
    T: -1
  },
  /*::[*/
  291: {
    /* n:"BrtBeginSXPIs", */
    T: 1
  },
  /*::[*/
  292: {
    /* n:"BrtEndSXPIs", */
    T: -1
  },
  /*::[*/
  293: {
    /* n:"BrtBeginSXDI", */
    T: 1
  },
  /*::[*/
  294: {
    /* n:"BrtEndSXDI", */
    T: -1
  },
  /*::[*/
  295: {
    /* n:"BrtBeginSXDIs", */
    T: 1
  },
  /*::[*/
  296: {
    /* n:"BrtEndSXDIs", */
    T: -1
  },
  /*::[*/
  297: {
    /* n:"BrtBeginSXLI", */
    T: 1
  },
  /*::[*/
  298: {
    /* n:"BrtEndSXLI", */
    T: -1
  },
  /*::[*/
  299: {
    /* n:"BrtBeginSXLIRws", */
    T: 1
  },
  /*::[*/
  300: {
    /* n:"BrtEndSXLIRws", */
    T: -1
  },
  /*::[*/
  301: {
    /* n:"BrtBeginSXLICols", */
    T: 1
  },
  /*::[*/
  302: {
    /* n:"BrtEndSXLICols", */
    T: -1
  },
  /*::[*/
  303: {
    /* n:"BrtBeginSXFormat", */
    T: 1
  },
  /*::[*/
  304: {
    /* n:"BrtEndSXFormat", */
    T: -1
  },
  /*::[*/
  305: {
    /* n:"BrtBeginSXFormats", */
    T: 1
  },
  /*::[*/
  306: {
    /* n:"BrtEndSxFormats", */
    T: -1
  },
  /*::[*/
  307: {
    /* n:"BrtBeginSxSelect", */
    T: 1
  },
  /*::[*/
  308: {
    /* n:"BrtEndSxSelect", */
    T: -1
  },
  /*::[*/
  309: {
    /* n:"BrtBeginISXVDRws", */
    T: 1
  },
  /*::[*/
  310: {
    /* n:"BrtEndISXVDRws", */
    T: -1
  },
  /*::[*/
  311: {
    /* n:"BrtBeginISXVDCols", */
    T: 1
  },
  /*::[*/
  312: {
    /* n:"BrtEndISXVDCols", */
    T: -1
  },
  /*::[*/
  313: {
    /* n:"BrtEndSXLocation", */
    T: -1
  },
  /*::[*/
  314: {
    /* n:"BrtBeginSXLocation", */
    T: 1
  },
  /*::[*/
  315: {
    /* n:"BrtEndSXView", */
    T: -1
  },
  /*::[*/
  316: {
    /* n:"BrtBeginSXTHs", */
    T: 1
  },
  /*::[*/
  317: {
    /* n:"BrtEndSXTHs", */
    T: -1
  },
  /*::[*/
  318: {
    /* n:"BrtBeginSXTH", */
    T: 1
  },
  /*::[*/
  319: {
    /* n:"BrtEndSXTH", */
    T: -1
  },
  /*::[*/
  320: {
    /* n:"BrtBeginISXTHRws", */
    T: 1
  },
  /*::[*/
  321: {
    /* n:"BrtEndISXTHRws", */
    T: -1
  },
  /*::[*/
  322: {
    /* n:"BrtBeginISXTHCols", */
    T: 1
  },
  /*::[*/
  323: {
    /* n:"BrtEndISXTHCols", */
    T: -1
  },
  /*::[*/
  324: {
    /* n:"BrtBeginSXTDMPS", */
    T: 1
  },
  /*::[*/
  325: {
    /* n:"BrtEndSXTDMPs", */
    T: -1
  },
  /*::[*/
  326: {
    /* n:"BrtBeginSXTDMP", */
    T: 1
  },
  /*::[*/
  327: {
    /* n:"BrtEndSXTDMP", */
    T: -1
  },
  /*::[*/
  328: {
    /* n:"BrtBeginSXTHItems", */
    T: 1
  },
  /*::[*/
  329: {
    /* n:"BrtEndSXTHItems", */
    T: -1
  },
  /*::[*/
  330: {
    /* n:"BrtBeginSXTHItem", */
    T: 1
  },
  /*::[*/
  331: {
    /* n:"BrtEndSXTHItem", */
    T: -1
  },
  /*::[*/
  332: {
    /* n:"BrtBeginMetadata", */
    T: 1
  },
  /*::[*/
  333: {
    /* n:"BrtEndMetadata", */
    T: -1
  },
  /*::[*/
  334: {
    /* n:"BrtBeginEsmdtinfo", */
    T: 1
  },
  /*::[*/
  335: {
    /* n:"BrtMdtinfo", */
    f: b2e
  },
  /*::[*/
  336: {
    /* n:"BrtEndEsmdtinfo", */
    T: -1
  },
  /*::[*/
  337: {
    /* n:"BrtBeginEsmdb", */
    f: E2e,
    T: 1
  },
  /*::[*/
  338: {
    /* n:"BrtEndEsmdb", */
    T: -1
  },
  /*::[*/
  339: {
    /* n:"BrtBeginEsfmd", */
    T: 1
  },
  /*::[*/
  340: {
    /* n:"BrtEndEsfmd", */
    T: -1
  },
  /*::[*/
  341: {
    /* n:"BrtBeginSingleCells", */
    T: 1
  },
  /*::[*/
  342: {
    /* n:"BrtEndSingleCells", */
    T: -1
  },
  /*::[*/
  343: {
    /* n:"BrtBeginList", */
    T: 1
  },
  /*::[*/
  344: {
    /* n:"BrtEndList", */
    T: -1
  },
  /*::[*/
  345: {
    /* n:"BrtBeginListCols", */
    T: 1
  },
  /*::[*/
  346: {
    /* n:"BrtEndListCols", */
    T: -1
  },
  /*::[*/
  347: {
    /* n:"BrtBeginListCol", */
    T: 1
  },
  /*::[*/
  348: {
    /* n:"BrtEndListCol", */
    T: -1
  },
  /*::[*/
  349: {
    /* n:"BrtBeginListXmlCPr", */
    T: 1
  },
  /*::[*/
  350: {
    /* n:"BrtEndListXmlCPr", */
    T: -1
  },
  /*::[*/
  351: {
    /* n:"BrtListCCFmla" */
  },
  /*::[*/
  352: {
    /* n:"BrtListTrFmla" */
  },
  /*::[*/
  353: {
    /* n:"BrtBeginExternals", */
    T: 1
  },
  /*::[*/
  354: {
    /* n:"BrtEndExternals", */
    T: -1
  },
  /*::[*/
  355: {
    /* n:"BrtSupBookSrc", */
    f: jS
  },
  /*::[*/
  357: {
    /* n:"BrtSupSelf" */
  },
  /*::[*/
  358: {
    /* n:"BrtSupSame" */
  },
  /*::[*/
  359: {
    /* n:"BrtSupTabs" */
  },
  /*::[*/
  360: {
    /* n:"BrtBeginSupBook", */
    T: 1
  },
  /*::[*/
  361: {
    /* n:"BrtPlaceholderName" */
  },
  /*::[*/
  362: {
    /* n:"BrtExternSheet", */
    f: QR
  },
  /*::[*/
  363: {
    /* n:"BrtExternTableStart" */
  },
  /*::[*/
  364: {
    /* n:"BrtExternTableEnd" */
  },
  /*::[*/
  366: {
    /* n:"BrtExternRowHdr" */
  },
  /*::[*/
  367: {
    /* n:"BrtExternCellBlank" */
  },
  /*::[*/
  368: {
    /* n:"BrtExternCellReal" */
  },
  /*::[*/
  369: {
    /* n:"BrtExternCellBool" */
  },
  /*::[*/
  370: {
    /* n:"BrtExternCellError" */
  },
  /*::[*/
  371: {
    /* n:"BrtExternCellString" */
  },
  /*::[*/
  372: {
    /* n:"BrtBeginEsmdx", */
    T: 1
  },
  /*::[*/
  373: {
    /* n:"BrtEndEsmdx", */
    T: -1
  },
  /*::[*/
  374: {
    /* n:"BrtBeginMdxSet", */
    T: 1
  },
  /*::[*/
  375: {
    /* n:"BrtEndMdxSet", */
    T: -1
  },
  /*::[*/
  376: {
    /* n:"BrtBeginMdxMbrProp", */
    T: 1
  },
  /*::[*/
  377: {
    /* n:"BrtEndMdxMbrProp", */
    T: -1
  },
  /*::[*/
  378: {
    /* n:"BrtBeginMdxKPI", */
    T: 1
  },
  /*::[*/
  379: {
    /* n:"BrtEndMdxKPI", */
    T: -1
  },
  /*::[*/
  380: {
    /* n:"BrtBeginEsstr", */
    T: 1
  },
  /*::[*/
  381: {
    /* n:"BrtEndEsstr", */
    T: -1
  },
  /*::[*/
  382: {
    /* n:"BrtBeginPRFItem", */
    T: 1
  },
  /*::[*/
  383: {
    /* n:"BrtEndPRFItem", */
    T: -1
  },
  /*::[*/
  384: {
    /* n:"BrtBeginPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  385: {
    /* n:"BrtEndPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  386: {
    /* n:"BrtBeginPivotCacheID", */
    T: 1
  },
  /*::[*/
  387: {
    /* n:"BrtEndPivotCacheID", */
    T: -1
  },
  /*::[*/
  388: {
    /* n:"BrtBeginISXVIs", */
    T: 1
  },
  /*::[*/
  389: {
    /* n:"BrtEndISXVIs", */
    T: -1
  },
  /*::[*/
  390: {
    /* n:"BrtBeginColInfos", */
    T: 1
  },
  /*::[*/
  391: {
    /* n:"BrtEndColInfos", */
    T: -1
  },
  /*::[*/
  392: {
    /* n:"BrtBeginRwBrk", */
    T: 1
  },
  /*::[*/
  393: {
    /* n:"BrtEndRwBrk", */
    T: -1
  },
  /*::[*/
  394: {
    /* n:"BrtBeginColBrk", */
    T: 1
  },
  /*::[*/
  395: {
    /* n:"BrtEndColBrk", */
    T: -1
  },
  /*::[*/
  396: {
    /* n:"BrtBrk" */
  },
  /*::[*/
  397: {
    /* n:"BrtUserBookView" */
  },
  /*::[*/
  398: {
    /* n:"BrtInfo" */
  },
  /*::[*/
  399: {
    /* n:"BrtCUsr" */
  },
  /*::[*/
  400: {
    /* n:"BrtUsr" */
  },
  /*::[*/
  401: {
    /* n:"BrtBeginUsers", */
    T: 1
  },
  /*::[*/
  403: {
    /* n:"BrtEOF" */
  },
  /*::[*/
  404: {
    /* n:"BrtUCR" */
  },
  /*::[*/
  405: {
    /* n:"BrtRRInsDel" */
  },
  /*::[*/
  406: {
    /* n:"BrtRREndInsDel" */
  },
  /*::[*/
  407: {
    /* n:"BrtRRMove" */
  },
  /*::[*/
  408: {
    /* n:"BrtRREndMove" */
  },
  /*::[*/
  409: {
    /* n:"BrtRRChgCell" */
  },
  /*::[*/
  410: {
    /* n:"BrtRREndChgCell" */
  },
  /*::[*/
  411: {
    /* n:"BrtRRHeader" */
  },
  /*::[*/
  412: {
    /* n:"BrtRRUserView" */
  },
  /*::[*/
  413: {
    /* n:"BrtRRRenSheet" */
  },
  /*::[*/
  414: {
    /* n:"BrtRRInsertSh" */
  },
  /*::[*/
  415: {
    /* n:"BrtRRDefName" */
  },
  /*::[*/
  416: {
    /* n:"BrtRRNote" */
  },
  /*::[*/
  417: {
    /* n:"BrtRRConflict" */
  },
  /*::[*/
  418: {
    /* n:"BrtRRTQSIF" */
  },
  /*::[*/
  419: {
    /* n:"BrtRRFormat" */
  },
  /*::[*/
  420: {
    /* n:"BrtRREndFormat" */
  },
  /*::[*/
  421: {
    /* n:"BrtRRAutoFmt" */
  },
  /*::[*/
  422: {
    /* n:"BrtBeginUserShViews", */
    T: 1
  },
  /*::[*/
  423: {
    /* n:"BrtBeginUserShView", */
    T: 1
  },
  /*::[*/
  424: {
    /* n:"BrtEndUserShView", */
    T: -1
  },
  /*::[*/
  425: {
    /* n:"BrtEndUserShViews", */
    T: -1
  },
  /*::[*/
  426: {
    /* n:"BrtArrFmla", */
    f: Z_e
  },
  /*::[*/
  427: {
    /* n:"BrtShrFmla", */
    f: Q_e
  },
  /*::[*/
  428: {
    /* n:"BrtTable" */
  },
  /*::[*/
  429: {
    /* n:"BrtBeginExtConnections", */
    T: 1
  },
  /*::[*/
  430: {
    /* n:"BrtEndExtConnections", */
    T: -1
  },
  /*::[*/
  431: {
    /* n:"BrtBeginPCDCalcMems", */
    T: 1
  },
  /*::[*/
  432: {
    /* n:"BrtEndPCDCalcMems", */
    T: -1
  },
  /*::[*/
  433: {
    /* n:"BrtBeginPCDCalcMem", */
    T: 1
  },
  /*::[*/
  434: {
    /* n:"BrtEndPCDCalcMem", */
    T: -1
  },
  /*::[*/
  435: {
    /* n:"BrtBeginPCDHGLevels", */
    T: 1
  },
  /*::[*/
  436: {
    /* n:"BrtEndPCDHGLevels", */
    T: -1
  },
  /*::[*/
  437: {
    /* n:"BrtBeginPCDHGLevel", */
    T: 1
  },
  /*::[*/
  438: {
    /* n:"BrtEndPCDHGLevel", */
    T: -1
  },
  /*::[*/
  439: {
    /* n:"BrtBeginPCDHGLGroups", */
    T: 1
  },
  /*::[*/
  440: {
    /* n:"BrtEndPCDHGLGroups", */
    T: -1
  },
  /*::[*/
  441: {
    /* n:"BrtBeginPCDHGLGroup", */
    T: 1
  },
  /*::[*/
  442: {
    /* n:"BrtEndPCDHGLGroup", */
    T: -1
  },
  /*::[*/
  443: {
    /* n:"BrtBeginPCDHGLGMembers", */
    T: 1
  },
  /*::[*/
  444: {
    /* n:"BrtEndPCDHGLGMembers", */
    T: -1
  },
  /*::[*/
  445: {
    /* n:"BrtBeginPCDHGLGMember", */
    T: 1
  },
  /*::[*/
  446: {
    /* n:"BrtEndPCDHGLGMember", */
    T: -1
  },
  /*::[*/
  447: {
    /* n:"BrtBeginQSI", */
    T: 1
  },
  /*::[*/
  448: {
    /* n:"BrtEndQSI", */
    T: -1
  },
  /*::[*/
  449: {
    /* n:"BrtBeginQSIR", */
    T: 1
  },
  /*::[*/
  450: {
    /* n:"BrtEndQSIR", */
    T: -1
  },
  /*::[*/
  451: {
    /* n:"BrtBeginDeletedNames", */
    T: 1
  },
  /*::[*/
  452: {
    /* n:"BrtEndDeletedNames", */
    T: -1
  },
  /*::[*/
  453: {
    /* n:"BrtBeginDeletedName", */
    T: 1
  },
  /*::[*/
  454: {
    /* n:"BrtEndDeletedName", */
    T: -1
  },
  /*::[*/
  455: {
    /* n:"BrtBeginQSIFs", */
    T: 1
  },
  /*::[*/
  456: {
    /* n:"BrtEndQSIFs", */
    T: -1
  },
  /*::[*/
  457: {
    /* n:"BrtBeginQSIF", */
    T: 1
  },
  /*::[*/
  458: {
    /* n:"BrtEndQSIF", */
    T: -1
  },
  /*::[*/
  459: {
    /* n:"BrtBeginAutoSortScope", */
    T: 1
  },
  /*::[*/
  460: {
    /* n:"BrtEndAutoSortScope", */
    T: -1
  },
  /*::[*/
  461: {
    /* n:"BrtBeginConditionalFormatting", */
    T: 1
  },
  /*::[*/
  462: {
    /* n:"BrtEndConditionalFormatting", */
    T: -1
  },
  /*::[*/
  463: {
    /* n:"BrtBeginCFRule", */
    T: 1
  },
  /*::[*/
  464: {
    /* n:"BrtEndCFRule", */
    T: -1
  },
  /*::[*/
  465: {
    /* n:"BrtBeginIconSet", */
    T: 1
  },
  /*::[*/
  466: {
    /* n:"BrtEndIconSet", */
    T: -1
  },
  /*::[*/
  467: {
    /* n:"BrtBeginDatabar", */
    T: 1
  },
  /*::[*/
  468: {
    /* n:"BrtEndDatabar", */
    T: -1
  },
  /*::[*/
  469: {
    /* n:"BrtBeginColorScale", */
    T: 1
  },
  /*::[*/
  470: {
    /* n:"BrtEndColorScale", */
    T: -1
  },
  /*::[*/
  471: {
    /* n:"BrtCFVO" */
  },
  /*::[*/
  472: {
    /* n:"BrtExternValueMeta" */
  },
  /*::[*/
  473: {
    /* n:"BrtBeginColorPalette", */
    T: 1
  },
  /*::[*/
  474: {
    /* n:"BrtEndColorPalette", */
    T: -1
  },
  /*::[*/
  475: {
    /* n:"BrtIndexedColor" */
  },
  /*::[*/
  476: {
    /* n:"BrtMargins", */
    f: eCe
  },
  /*::[*/
  477: {
    /* n:"BrtPrintOptions" */
  },
  /*::[*/
  478: {
    /* n:"BrtPageSetup" */
  },
  /*::[*/
  479: {
    /* n:"BrtBeginHeaderFooter", */
    T: 1
  },
  /*::[*/
  480: {
    /* n:"BrtEndHeaderFooter", */
    T: -1
  },
  /*::[*/
  481: {
    /* n:"BrtBeginSXCrtFormat", */
    T: 1
  },
  /*::[*/
  482: {
    /* n:"BrtEndSXCrtFormat", */
    T: -1
  },
  /*::[*/
  483: {
    /* n:"BrtBeginSXCrtFormats", */
    T: 1
  },
  /*::[*/
  484: {
    /* n:"BrtEndSXCrtFormats", */
    T: -1
  },
  /*::[*/
  485: {
    /* n:"BrtWsFmtInfo", */
    f: c_e
  },
  /*::[*/
  486: {
    /* n:"BrtBeginMgs", */
    T: 1
  },
  /*::[*/
  487: {
    /* n:"BrtEndMGs", */
    T: -1
  },
  /*::[*/
  488: {
    /* n:"BrtBeginMGMaps", */
    T: 1
  },
  /*::[*/
  489: {
    /* n:"BrtEndMGMaps", */
    T: -1
  },
  /*::[*/
  490: {
    /* n:"BrtBeginMG", */
    T: 1
  },
  /*::[*/
  491: {
    /* n:"BrtEndMG", */
    T: -1
  },
  /*::[*/
  492: {
    /* n:"BrtBeginMap", */
    T: 1
  },
  /*::[*/
  493: {
    /* n:"BrtEndMap", */
    T: -1
  },
  /*::[*/
  494: {
    /* n:"BrtHLink", */
    f: Y_e
  },
  /*::[*/
  495: {
    /* n:"BrtBeginDCon", */
    T: 1
  },
  /*::[*/
  496: {
    /* n:"BrtEndDCon", */
    T: -1
  },
  /*::[*/
  497: {
    /* n:"BrtBeginDRefs", */
    T: 1
  },
  /*::[*/
  498: {
    /* n:"BrtEndDRefs", */
    T: -1
  },
  /*::[*/
  499: {
    /* n:"BrtDRef" */
  },
  /*::[*/
  500: {
    /* n:"BrtBeginScenMan", */
    T: 1
  },
  /*::[*/
  501: {
    /* n:"BrtEndScenMan", */
    T: -1
  },
  /*::[*/
  502: {
    /* n:"BrtBeginSct", */
    T: 1
  },
  /*::[*/
  503: {
    /* n:"BrtEndSct", */
    T: -1
  },
  /*::[*/
  504: {
    /* n:"BrtSlc" */
  },
  /*::[*/
  505: {
    /* n:"BrtBeginDXFs", */
    T: 1
  },
  /*::[*/
  506: {
    /* n:"BrtEndDXFs", */
    T: -1
  },
  /*::[*/
  507: {
    /* n:"BrtDXF" */
  },
  /*::[*/
  508: {
    /* n:"BrtBeginTableStyles", */
    T: 1
  },
  /*::[*/
  509: {
    /* n:"BrtEndTableStyles", */
    T: -1
  },
  /*::[*/
  510: {
    /* n:"BrtBeginTableStyle", */
    T: 1
  },
  /*::[*/
  511: {
    /* n:"BrtEndTableStyle", */
    T: -1
  },
  /*::[*/
  512: {
    /* n:"BrtTableStyleElement" */
  },
  /*::[*/
  513: {
    /* n:"BrtTableStyleClient" */
  },
  /*::[*/
  514: {
    /* n:"BrtBeginVolDeps", */
    T: 1
  },
  /*::[*/
  515: {
    /* n:"BrtEndVolDeps", */
    T: -1
  },
  /*::[*/
  516: {
    /* n:"BrtBeginVolType", */
    T: 1
  },
  /*::[*/
  517: {
    /* n:"BrtEndVolType", */
    T: -1
  },
  /*::[*/
  518: {
    /* n:"BrtBeginVolMain", */
    T: 1
  },
  /*::[*/
  519: {
    /* n:"BrtEndVolMain", */
    T: -1
  },
  /*::[*/
  520: {
    /* n:"BrtBeginVolTopic", */
    T: 1
  },
  /*::[*/
  521: {
    /* n:"BrtEndVolTopic", */
    T: -1
  },
  /*::[*/
  522: {
    /* n:"BrtVolSubtopic" */
  },
  /*::[*/
  523: {
    /* n:"BrtVolRef" */
  },
  /*::[*/
  524: {
    /* n:"BrtVolNum" */
  },
  /*::[*/
  525: {
    /* n:"BrtVolErr" */
  },
  /*::[*/
  526: {
    /* n:"BrtVolStr" */
  },
  /*::[*/
  527: {
    /* n:"BrtVolBool" */
  },
  /*::[*/
  528: {
    /* n:"BrtBeginCalcChain$", */
    T: 1
  },
  /*::[*/
  529: {
    /* n:"BrtEndCalcChain$", */
    T: -1
  },
  /*::[*/
  530: {
    /* n:"BrtBeginSortState", */
    T: 1
  },
  /*::[*/
  531: {
    /* n:"BrtEndSortState", */
    T: -1
  },
  /*::[*/
  532: {
    /* n:"BrtBeginSortCond", */
    T: 1
  },
  /*::[*/
  533: {
    /* n:"BrtEndSortCond", */
    T: -1
  },
  /*::[*/
  534: {
    /* n:"BrtBookProtection" */
  },
  /*::[*/
  535: {
    /* n:"BrtSheetProtection" */
  },
  /*::[*/
  536: {
    /* n:"BrtRangeProtection" */
  },
  /*::[*/
  537: {
    /* n:"BrtPhoneticInfo" */
  },
  /*::[*/
  538: {
    /* n:"BrtBeginECTxtWiz", */
    T: 1
  },
  /*::[*/
  539: {
    /* n:"BrtEndECTxtWiz", */
    T: -1
  },
  /*::[*/
  540: {
    /* n:"BrtBeginECTWFldInfoLst", */
    T: 1
  },
  /*::[*/
  541: {
    /* n:"BrtEndECTWFldInfoLst", */
    T: -1
  },
  /*::[*/
  542: {
    /* n:"BrtBeginECTwFldInfo", */
    T: 1
  },
  /*::[*/
  548: {
    /* n:"BrtFileSharing" */
  },
  /*::[*/
  549: {
    /* n:"BrtOleSize" */
  },
  /*::[*/
  550: {
    /* n:"BrtDrawing", */
    f: jS
  },
  /*::[*/
  551: {
    /* n:"BrtLegacyDrawing" */
  },
  /*::[*/
  552: {
    /* n:"BrtLegacyDrawingHF" */
  },
  /*::[*/
  553: {
    /* n:"BrtWebOpt" */
  },
  /*::[*/
  554: {
    /* n:"BrtBeginWebPubItems", */
    T: 1
  },
  /*::[*/
  555: {
    /* n:"BrtEndWebPubItems", */
    T: -1
  },
  /*::[*/
  556: {
    /* n:"BrtBeginWebPubItem", */
    T: 1
  },
  /*::[*/
  557: {
    /* n:"BrtEndWebPubItem", */
    T: -1
  },
  /*::[*/
  558: {
    /* n:"BrtBeginSXCondFmt", */
    T: 1
  },
  /*::[*/
  559: {
    /* n:"BrtEndSXCondFmt", */
    T: -1
  },
  /*::[*/
  560: {
    /* n:"BrtBeginSXCondFmts", */
    T: 1
  },
  /*::[*/
  561: {
    /* n:"BrtEndSXCondFmts", */
    T: -1
  },
  /*::[*/
  562: {
    /* n:"BrtBkHim" */
  },
  /*::[*/
  564: {
    /* n:"BrtColor" */
  },
  /*::[*/
  565: {
    /* n:"BrtBeginIndexedColors", */
    T: 1
  },
  /*::[*/
  566: {
    /* n:"BrtEndIndexedColors", */
    T: -1
  },
  /*::[*/
  569: {
    /* n:"BrtBeginMRUColors", */
    T: 1
  },
  /*::[*/
  570: {
    /* n:"BrtEndMRUColors", */
    T: -1
  },
  /*::[*/
  572: {
    /* n:"BrtMRUColor" */
  },
  /*::[*/
  573: {
    /* n:"BrtBeginDVals", */
    T: 1
  },
  /*::[*/
  574: {
    /* n:"BrtEndDVals", */
    T: -1
  },
  /*::[*/
  577: {
    /* n:"BrtSupNameStart" */
  },
  /*::[*/
  578: {
    /* n:"BrtSupNameValueStart" */
  },
  /*::[*/
  579: {
    /* n:"BrtSupNameValueEnd" */
  },
  /*::[*/
  580: {
    /* n:"BrtSupNameNum" */
  },
  /*::[*/
  581: {
    /* n:"BrtSupNameErr" */
  },
  /*::[*/
  582: {
    /* n:"BrtSupNameSt" */
  },
  /*::[*/
  583: {
    /* n:"BrtSupNameNil" */
  },
  /*::[*/
  584: {
    /* n:"BrtSupNameBool" */
  },
  /*::[*/
  585: {
    /* n:"BrtSupNameFmla" */
  },
  /*::[*/
  586: {
    /* n:"BrtSupNameBits" */
  },
  /*::[*/
  587: {
    /* n:"BrtSupNameEnd" */
  },
  /*::[*/
  588: {
    /* n:"BrtEndSupBook", */
    T: -1
  },
  /*::[*/
  589: {
    /* n:"BrtCellSmartTagProperty" */
  },
  /*::[*/
  590: {
    /* n:"BrtBeginCellSmartTag", */
    T: 1
  },
  /*::[*/
  591: {
    /* n:"BrtEndCellSmartTag", */
    T: -1
  },
  /*::[*/
  592: {
    /* n:"BrtBeginCellSmartTags", */
    T: 1
  },
  /*::[*/
  593: {
    /* n:"BrtEndCellSmartTags", */
    T: -1
  },
  /*::[*/
  594: {
    /* n:"BrtBeginSmartTags", */
    T: 1
  },
  /*::[*/
  595: {
    /* n:"BrtEndSmartTags", */
    T: -1
  },
  /*::[*/
  596: {
    /* n:"BrtSmartTagType" */
  },
  /*::[*/
  597: {
    /* n:"BrtBeginSmartTagTypes", */
    T: 1
  },
  /*::[*/
  598: {
    /* n:"BrtEndSmartTagTypes", */
    T: -1
  },
  /*::[*/
  599: {
    /* n:"BrtBeginSXFilters", */
    T: 1
  },
  /*::[*/
  600: {
    /* n:"BrtEndSXFilters", */
    T: -1
  },
  /*::[*/
  601: {
    /* n:"BrtBeginSXFILTER", */
    T: 1
  },
  /*::[*/
  602: {
    /* n:"BrtEndSXFilter", */
    T: -1
  },
  /*::[*/
  603: {
    /* n:"BrtBeginFills", */
    T: 1
  },
  /*::[*/
  604: {
    /* n:"BrtEndFills", */
    T: -1
  },
  /*::[*/
  605: {
    /* n:"BrtBeginCellWatches", */
    T: 1
  },
  /*::[*/
  606: {
    /* n:"BrtEndCellWatches", */
    T: -1
  },
  /*::[*/
  607: {
    /* n:"BrtCellWatch" */
  },
  /*::[*/
  608: {
    /* n:"BrtBeginCRErrs", */
    T: 1
  },
  /*::[*/
  609: {
    /* n:"BrtEndCRErrs", */
    T: -1
  },
  /*::[*/
  610: {
    /* n:"BrtCrashRecErr" */
  },
  /*::[*/
  611: {
    /* n:"BrtBeginFonts", */
    T: 1
  },
  /*::[*/
  612: {
    /* n:"BrtEndFonts", */
    T: -1
  },
  /*::[*/
  613: {
    /* n:"BrtBeginBorders", */
    T: 1
  },
  /*::[*/
  614: {
    /* n:"BrtEndBorders", */
    T: -1
  },
  /*::[*/
  615: {
    /* n:"BrtBeginFmts", */
    T: 1
  },
  /*::[*/
  616: {
    /* n:"BrtEndFmts", */
    T: -1
  },
  /*::[*/
  617: {
    /* n:"BrtBeginCellXFs", */
    T: 1
  },
  /*::[*/
  618: {
    /* n:"BrtEndCellXFs", */
    T: -1
  },
  /*::[*/
  619: {
    /* n:"BrtBeginStyles", */
    T: 1
  },
  /*::[*/
  620: {
    /* n:"BrtEndStyles", */
    T: -1
  },
  /*::[*/
  625: {
    /* n:"BrtBigName" */
  },
  /*::[*/
  626: {
    /* n:"BrtBeginCellStyleXFs", */
    T: 1
  },
  /*::[*/
  627: {
    /* n:"BrtEndCellStyleXFs", */
    T: -1
  },
  /*::[*/
  628: {
    /* n:"BrtBeginComments", */
    T: 1
  },
  /*::[*/
  629: {
    /* n:"BrtEndComments", */
    T: -1
  },
  /*::[*/
  630: {
    /* n:"BrtBeginCommentAuthors", */
    T: 1
  },
  /*::[*/
  631: {
    /* n:"BrtEndCommentAuthors", */
    T: -1
  },
  /*::[*/
  632: {
    /* n:"BrtCommentAuthor", */
    f: V2e
  },
  /*::[*/
  633: {
    /* n:"BrtBeginCommentList", */
    T: 1
  },
  /*::[*/
  634: {
    /* n:"BrtEndCommentList", */
    T: -1
  },
  /*::[*/
  635: {
    /* n:"BrtBeginComment", */
    T: 1,
    f: H2e
  },
  /*::[*/
  636: {
    /* n:"BrtEndComment", */
    T: -1
  },
  /*::[*/
  637: {
    /* n:"BrtCommentText", */
    f: d1e
  },
  /*::[*/
  638: {
    /* n:"BrtBeginOleObjects", */
    T: 1
  },
  /*::[*/
  639: {
    /* n:"BrtOleObject" */
  },
  /*::[*/
  640: {
    /* n:"BrtEndOleObjects", */
    T: -1
  },
  /*::[*/
  641: {
    /* n:"BrtBeginSxrules", */
    T: 1
  },
  /*::[*/
  642: {
    /* n:"BrtEndSxRules", */
    T: -1
  },
  /*::[*/
  643: {
    /* n:"BrtBeginActiveXControls", */
    T: 1
  },
  /*::[*/
  644: {
    /* n:"BrtActiveX" */
  },
  /*::[*/
  645: {
    /* n:"BrtEndActiveXControls", */
    T: -1
  },
  /*::[*/
  646: {
    /* n:"BrtBeginPCDSDTCEMembersSortBy", */
    T: 1
  },
  /*::[*/
  648: {
    /* n:"BrtBeginCellIgnoreECs", */
    T: 1
  },
  /*::[*/
  649: {
    /* n:"BrtCellIgnoreEC" */
  },
  /*::[*/
  650: {
    /* n:"BrtEndCellIgnoreECs", */
    T: -1
  },
  /*::[*/
  651: {
    /* n:"BrtCsProp", */
    f: _Ce
  },
  /*::[*/
  652: {
    /* n:"BrtCsPageSetup" */
  },
  /*::[*/
  653: {
    /* n:"BrtBeginUserCsViews", */
    T: 1
  },
  /*::[*/
  654: {
    /* n:"BrtEndUserCsViews", */
    T: -1
  },
  /*::[*/
  655: {
    /* n:"BrtBeginUserCsView", */
    T: 1
  },
  /*::[*/
  656: {
    /* n:"BrtEndUserCsView", */
    T: -1
  },
  /*::[*/
  657: {
    /* n:"BrtBeginPcdSFCIEntries", */
    T: 1
  },
  /*::[*/
  658: {
    /* n:"BrtEndPCDSFCIEntries", */
    T: -1
  },
  /*::[*/
  659: {
    /* n:"BrtPCDSFCIEntry" */
  },
  /*::[*/
  660: {
    /* n:"BrtBeginListParts", */
    T: 1
  },
  /*::[*/
  661: {
    /* n:"BrtListPart" */
  },
  /*::[*/
  662: {
    /* n:"BrtEndListParts", */
    T: -1
  },
  /*::[*/
  663: {
    /* n:"BrtSheetCalcProp" */
  },
  /*::[*/
  664: {
    /* n:"BrtBeginFnGroup", */
    T: 1
  },
  /*::[*/
  665: {
    /* n:"BrtFnGroup" */
  },
  /*::[*/
  666: {
    /* n:"BrtEndFnGroup", */
    T: -1
  },
  /*::[*/
  667: {
    /* n:"BrtSupAddin" */
  },
  /*::[*/
  668: {
    /* n:"BrtSXTDMPOrder" */
  },
  /*::[*/
  669: {
    /* n:"BrtCsProtection" */
  },
  /*::[*/
  671: {
    /* n:"BrtBeginWsSortMap", */
    T: 1
  },
  /*::[*/
  672: {
    /* n:"BrtEndWsSortMap", */
    T: -1
  },
  /*::[*/
  673: {
    /* n:"BrtBeginRRSort", */
    T: 1
  },
  /*::[*/
  674: {
    /* n:"BrtEndRRSort", */
    T: -1
  },
  /*::[*/
  675: {
    /* n:"BrtRRSortItem" */
  },
  /*::[*/
  676: {
    /* n:"BrtFileSharingIso" */
  },
  /*::[*/
  677: {
    /* n:"BrtBookProtectionIso" */
  },
  /*::[*/
  678: {
    /* n:"BrtSheetProtectionIso" */
  },
  /*::[*/
  679: {
    /* n:"BrtCsProtectionIso" */
  },
  /*::[*/
  680: {
    /* n:"BrtRangeProtectionIso" */
  },
  /*::[*/
  681: {
    /* n:"BrtDValList" */
  },
  /*::[*/
  1024: {
    /* n:"BrtRwDescent" */
  },
  /*::[*/
  1025: {
    /* n:"BrtKnownFonts" */
  },
  /*::[*/
  1026: {
    /* n:"BrtBeginSXTupleSet", */
    T: 1
  },
  /*::[*/
  1027: {
    /* n:"BrtEndSXTupleSet", */
    T: -1
  },
  /*::[*/
  1028: {
    /* n:"BrtBeginSXTupleSetHeader", */
    T: 1
  },
  /*::[*/
  1029: {
    /* n:"BrtEndSXTupleSetHeader", */
    T: -1
  },
  /*::[*/
  1030: {
    /* n:"BrtSXTupleSetHeaderItem" */
  },
  /*::[*/
  1031: {
    /* n:"BrtBeginSXTupleSetData", */
    T: 1
  },
  /*::[*/
  1032: {
    /* n:"BrtEndSXTupleSetData", */
    T: -1
  },
  /*::[*/
  1033: {
    /* n:"BrtBeginSXTupleSetRow", */
    T: 1
  },
  /*::[*/
  1034: {
    /* n:"BrtEndSXTupleSetRow", */
    T: -1
  },
  /*::[*/
  1035: {
    /* n:"BrtSXTupleSetRowItem" */
  },
  /*::[*/
  1036: {
    /* n:"BrtNameExt" */
  },
  /*::[*/
  1037: {
    /* n:"BrtPCDH14" */
  },
  /*::[*/
  1038: {
    /* n:"BrtBeginPCDCalcMem14", */
    T: 1
  },
  /*::[*/
  1039: {
    /* n:"BrtEndPCDCalcMem14", */
    T: -1
  },
  /*::[*/
  1040: {
    /* n:"BrtSXTH14" */
  },
  /*::[*/
  1041: {
    /* n:"BrtBeginSparklineGroup", */
    T: 1
  },
  /*::[*/
  1042: {
    /* n:"BrtEndSparklineGroup", */
    T: -1
  },
  /*::[*/
  1043: {
    /* n:"BrtSparkline" */
  },
  /*::[*/
  1044: {
    /* n:"BrtSXDI14" */
  },
  /*::[*/
  1045: {
    /* n:"BrtWsFmtInfoEx14" */
  },
  /*::[*/
  1046: {
    /* n:"BrtBeginConditionalFormatting14", */
    T: 1
  },
  /*::[*/
  1047: {
    /* n:"BrtEndConditionalFormatting14", */
    T: -1
  },
  /*::[*/
  1048: {
    /* n:"BrtBeginCFRule14", */
    T: 1
  },
  /*::[*/
  1049: {
    /* n:"BrtEndCFRule14", */
    T: -1
  },
  /*::[*/
  1050: {
    /* n:"BrtCFVO14" */
  },
  /*::[*/
  1051: {
    /* n:"BrtBeginDatabar14", */
    T: 1
  },
  /*::[*/
  1052: {
    /* n:"BrtBeginIconSet14", */
    T: 1
  },
  /*::[*/
  1053: {
    /* n:"BrtDVal14", */
    f: sCe
  },
  /*::[*/
  1054: {
    /* n:"BrtBeginDVals14", */
    T: 1
  },
  /*::[*/
  1055: {
    /* n:"BrtColor14" */
  },
  /*::[*/
  1056: {
    /* n:"BrtBeginSparklines", */
    T: 1
  },
  /*::[*/
  1057: {
    /* n:"BrtEndSparklines", */
    T: -1
  },
  /*::[*/
  1058: {
    /* n:"BrtBeginSparklineGroups", */
    T: 1
  },
  /*::[*/
  1059: {
    /* n:"BrtEndSparklineGroups", */
    T: -1
  },
  /*::[*/
  1061: {
    /* n:"BrtSXVD14" */
  },
  /*::[*/
  1062: {
    /* n:"BrtBeginSXView14", */
    T: 1
  },
  /*::[*/
  1063: {
    /* n:"BrtEndSXView14", */
    T: -1
  },
  /*::[*/
  1064: {
    /* n:"BrtBeginSXView16", */
    T: 1
  },
  /*::[*/
  1065: {
    /* n:"BrtEndSXView16", */
    T: -1
  },
  /*::[*/
  1066: {
    /* n:"BrtBeginPCD14", */
    T: 1
  },
  /*::[*/
  1067: {
    /* n:"BrtEndPCD14", */
    T: -1
  },
  /*::[*/
  1068: {
    /* n:"BrtBeginExtConn14", */
    T: 1
  },
  /*::[*/
  1069: {
    /* n:"BrtEndExtConn14", */
    T: -1
  },
  /*::[*/
  1070: {
    /* n:"BrtBeginSlicerCacheIDs", */
    T: 1
  },
  /*::[*/
  1071: {
    /* n:"BrtEndSlicerCacheIDs", */
    T: -1
  },
  /*::[*/
  1072: {
    /* n:"BrtBeginSlicerCacheID", */
    T: 1
  },
  /*::[*/
  1073: {
    /* n:"BrtEndSlicerCacheID", */
    T: -1
  },
  /*::[*/
  1075: {
    /* n:"BrtBeginSlicerCache", */
    T: 1
  },
  /*::[*/
  1076: {
    /* n:"BrtEndSlicerCache", */
    T: -1
  },
  /*::[*/
  1077: {
    /* n:"BrtBeginSlicerCacheDef", */
    T: 1
  },
  /*::[*/
  1078: {
    /* n:"BrtEndSlicerCacheDef", */
    T: -1
  },
  /*::[*/
  1079: {
    /* n:"BrtBeginSlicersEx", */
    T: 1
  },
  /*::[*/
  1080: {
    /* n:"BrtEndSlicersEx", */
    T: -1
  },
  /*::[*/
  1081: {
    /* n:"BrtBeginSlicerEx", */
    T: 1
  },
  /*::[*/
  1082: {
    /* n:"BrtEndSlicerEx", */
    T: -1
  },
  /*::[*/
  1083: {
    /* n:"BrtBeginSlicer", */
    T: 1
  },
  /*::[*/
  1084: {
    /* n:"BrtEndSlicer", */
    T: -1
  },
  /*::[*/
  1085: {
    /* n:"BrtSlicerCachePivotTables" */
  },
  /*::[*/
  1086: {
    /* n:"BrtBeginSlicerCacheOlapImpl", */
    T: 1
  },
  /*::[*/
  1087: {
    /* n:"BrtEndSlicerCacheOlapImpl", */
    T: -1
  },
  /*::[*/
  1088: {
    /* n:"BrtBeginSlicerCacheLevelsData", */
    T: 1
  },
  /*::[*/
  1089: {
    /* n:"BrtEndSlicerCacheLevelsData", */
    T: -1
  },
  /*::[*/
  1090: {
    /* n:"BrtBeginSlicerCacheLevelData", */
    T: 1
  },
  /*::[*/
  1091: {
    /* n:"BrtEndSlicerCacheLevelData", */
    T: -1
  },
  /*::[*/
  1092: {
    /* n:"BrtBeginSlicerCacheSiRanges", */
    T: 1
  },
  /*::[*/
  1093: {
    /* n:"BrtEndSlicerCacheSiRanges", */
    T: -1
  },
  /*::[*/
  1094: {
    /* n:"BrtBeginSlicerCacheSiRange", */
    T: 1
  },
  /*::[*/
  1095: {
    /* n:"BrtEndSlicerCacheSiRange", */
    T: -1
  },
  /*::[*/
  1096: {
    /* n:"BrtSlicerCacheOlapItem" */
  },
  /*::[*/
  1097: {
    /* n:"BrtBeginSlicerCacheSelections", */
    T: 1
  },
  /*::[*/
  1098: {
    /* n:"BrtSlicerCacheSelection" */
  },
  /*::[*/
  1099: {
    /* n:"BrtEndSlicerCacheSelections", */
    T: -1
  },
  /*::[*/
  1100: {
    /* n:"BrtBeginSlicerCacheNative", */
    T: 1
  },
  /*::[*/
  1101: {
    /* n:"BrtEndSlicerCacheNative", */
    T: -1
  },
  /*::[*/
  1102: {
    /* n:"BrtSlicerCacheNativeItem" */
  },
  /*::[*/
  1103: {
    /* n:"BrtRangeProtection14" */
  },
  /*::[*/
  1104: {
    /* n:"BrtRangeProtectionIso14" */
  },
  /*::[*/
  1105: {
    /* n:"BrtCellIgnoreEC14" */
  },
  /*::[*/
  1111: {
    /* n:"BrtList14" */
  },
  /*::[*/
  1112: {
    /* n:"BrtCFIcon" */
  },
  /*::[*/
  1113: {
    /* n:"BrtBeginSlicerCachesPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  1114: {
    /* n:"BrtEndSlicerCachesPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  1115: {
    /* n:"BrtBeginSlicers", */
    T: 1
  },
  /*::[*/
  1116: {
    /* n:"BrtEndSlicers", */
    T: -1
  },
  /*::[*/
  1117: {
    /* n:"BrtWbProp14" */
  },
  /*::[*/
  1118: {
    /* n:"BrtBeginSXEdit", */
    T: 1
  },
  /*::[*/
  1119: {
    /* n:"BrtEndSXEdit", */
    T: -1
  },
  /*::[*/
  1120: {
    /* n:"BrtBeginSXEdits", */
    T: 1
  },
  /*::[*/
  1121: {
    /* n:"BrtEndSXEdits", */
    T: -1
  },
  /*::[*/
  1122: {
    /* n:"BrtBeginSXChange", */
    T: 1
  },
  /*::[*/
  1123: {
    /* n:"BrtEndSXChange", */
    T: -1
  },
  /*::[*/
  1124: {
    /* n:"BrtBeginSXChanges", */
    T: 1
  },
  /*::[*/
  1125: {
    /* n:"BrtEndSXChanges", */
    T: -1
  },
  /*::[*/
  1126: {
    /* n:"BrtSXTupleItems" */
  },
  /*::[*/
  1128: {
    /* n:"BrtBeginSlicerStyle", */
    T: 1
  },
  /*::[*/
  1129: {
    /* n:"BrtEndSlicerStyle", */
    T: -1
  },
  /*::[*/
  1130: {
    /* n:"BrtSlicerStyleElement" */
  },
  /*::[*/
  1131: {
    /* n:"BrtBeginStyleSheetExt14", */
    T: 1
  },
  /*::[*/
  1132: {
    /* n:"BrtEndStyleSheetExt14", */
    T: -1
  },
  /*::[*/
  1133: {
    /* n:"BrtBeginSlicerCachesPivotCacheID", */
    T: 1
  },
  /*::[*/
  1134: {
    /* n:"BrtEndSlicerCachesPivotCacheID", */
    T: -1
  },
  /*::[*/
  1135: {
    /* n:"BrtBeginConditionalFormattings", */
    T: 1
  },
  /*::[*/
  1136: {
    /* n:"BrtEndConditionalFormattings", */
    T: -1
  },
  /*::[*/
  1137: {
    /* n:"BrtBeginPCDCalcMemExt", */
    T: 1
  },
  /*::[*/
  1138: {
    /* n:"BrtEndPCDCalcMemExt", */
    T: -1
  },
  /*::[*/
  1139: {
    /* n:"BrtBeginPCDCalcMemsExt", */
    T: 1
  },
  /*::[*/
  1140: {
    /* n:"BrtEndPCDCalcMemsExt", */
    T: -1
  },
  /*::[*/
  1141: {
    /* n:"BrtPCDField14" */
  },
  /*::[*/
  1142: {
    /* n:"BrtBeginSlicerStyles", */
    T: 1
  },
  /*::[*/
  1143: {
    /* n:"BrtEndSlicerStyles", */
    T: -1
  },
  /*::[*/
  1144: {
    /* n:"BrtBeginSlicerStyleElements", */
    T: 1
  },
  /*::[*/
  1145: {
    /* n:"BrtEndSlicerStyleElements", */
    T: -1
  },
  /*::[*/
  1146: {
    /* n:"BrtCFRuleExt" */
  },
  /*::[*/
  1147: {
    /* n:"BrtBeginSXCondFmt14", */
    T: 1
  },
  /*::[*/
  1148: {
    /* n:"BrtEndSXCondFmt14", */
    T: -1
  },
  /*::[*/
  1149: {
    /* n:"BrtBeginSXCondFmts14", */
    T: 1
  },
  /*::[*/
  1150: {
    /* n:"BrtEndSXCondFmts14", */
    T: -1
  },
  /*::[*/
  1152: {
    /* n:"BrtBeginSortCond14", */
    T: 1
  },
  /*::[*/
  1153: {
    /* n:"BrtEndSortCond14", */
    T: -1
  },
  /*::[*/
  1154: {
    /* n:"BrtEndDVals14", */
    T: -1
  },
  /*::[*/
  1155: {
    /* n:"BrtEndIconSet14", */
    T: -1
  },
  /*::[*/
  1156: {
    /* n:"BrtEndDatabar14", */
    T: -1
  },
  /*::[*/
  1157: {
    /* n:"BrtBeginColorScale14", */
    T: 1
  },
  /*::[*/
  1158: {
    /* n:"BrtEndColorScale14", */
    T: -1
  },
  /*::[*/
  1159: {
    /* n:"BrtBeginSxrules14", */
    T: 1
  },
  /*::[*/
  1160: {
    /* n:"BrtEndSxrules14", */
    T: -1
  },
  /*::[*/
  1161: {
    /* n:"BrtBeginPRule14", */
    T: 1
  },
  /*::[*/
  1162: {
    /* n:"BrtEndPRule14", */
    T: -1
  },
  /*::[*/
  1163: {
    /* n:"BrtBeginPRFilters14", */
    T: 1
  },
  /*::[*/
  1164: {
    /* n:"BrtEndPRFilters14", */
    T: -1
  },
  /*::[*/
  1165: {
    /* n:"BrtBeginPRFilter14", */
    T: 1
  },
  /*::[*/
  1166: {
    /* n:"BrtEndPRFilter14", */
    T: -1
  },
  /*::[*/
  1167: {
    /* n:"BrtBeginPRFItem14", */
    T: 1
  },
  /*::[*/
  1168: {
    /* n:"BrtEndPRFItem14", */
    T: -1
  },
  /*::[*/
  1169: {
    /* n:"BrtBeginCellIgnoreECs14", */
    T: 1
  },
  /*::[*/
  1170: {
    /* n:"BrtEndCellIgnoreECs14", */
    T: -1
  },
  /*::[*/
  1171: {
    /* n:"BrtDxf14" */
  },
  /*::[*/
  1172: {
    /* n:"BrtBeginDxF14s", */
    T: 1
  },
  /*::[*/
  1173: {
    /* n:"BrtEndDxf14s", */
    T: -1
  },
  /*::[*/
  1177: {
    /* n:"BrtFilter14" */
  },
  /*::[*/
  1178: {
    /* n:"BrtBeginCustomFilters14", */
    T: 1
  },
  /*::[*/
  1180: {
    /* n:"BrtCustomFilter14" */
  },
  /*::[*/
  1181: {
    /* n:"BrtIconFilter14" */
  },
  /*::[*/
  1182: {
    /* n:"BrtPivotCacheConnectionName" */
  },
  /*::[*/
  2048: {
    /* n:"BrtBeginDecoupledPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2049: {
    /* n:"BrtEndDecoupledPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2050: {
    /* n:"BrtDecoupledPivotCacheID" */
  },
  /*::[*/
  2051: {
    /* n:"BrtBeginPivotTableRefs", */
    T: 1
  },
  /*::[*/
  2052: {
    /* n:"BrtEndPivotTableRefs", */
    T: -1
  },
  /*::[*/
  2053: {
    /* n:"BrtPivotTableRef" */
  },
  /*::[*/
  2054: {
    /* n:"BrtSlicerCacheBookPivotTables" */
  },
  /*::[*/
  2055: {
    /* n:"BrtBeginSxvcells", */
    T: 1
  },
  /*::[*/
  2056: {
    /* n:"BrtEndSxvcells", */
    T: -1
  },
  /*::[*/
  2057: {
    /* n:"BrtBeginSxRow", */
    T: 1
  },
  /*::[*/
  2058: {
    /* n:"BrtEndSxRow", */
    T: -1
  },
  /*::[*/
  2060: {
    /* n:"BrtPcdCalcMem15" */
  },
  /*::[*/
  2067: {
    /* n:"BrtQsi15" */
  },
  /*::[*/
  2068: {
    /* n:"BrtBeginWebExtensions", */
    T: 1
  },
  /*::[*/
  2069: {
    /* n:"BrtEndWebExtensions", */
    T: -1
  },
  /*::[*/
  2070: {
    /* n:"BrtWebExtension" */
  },
  /*::[*/
  2071: {
    /* n:"BrtAbsPath15" */
  },
  /*::[*/
  2072: {
    /* n:"BrtBeginPivotTableUISettings", */
    T: 1
  },
  /*::[*/
  2073: {
    /* n:"BrtEndPivotTableUISettings", */
    T: -1
  },
  /*::[*/
  2075: {
    /* n:"BrtTableSlicerCacheIDs" */
  },
  /*::[*/
  2076: {
    /* n:"BrtTableSlicerCacheID" */
  },
  /*::[*/
  2077: {
    /* n:"BrtBeginTableSlicerCache", */
    T: 1
  },
  /*::[*/
  2078: {
    /* n:"BrtEndTableSlicerCache", */
    T: -1
  },
  /*::[*/
  2079: {
    /* n:"BrtSxFilter15" */
  },
  /*::[*/
  2080: {
    /* n:"BrtBeginTimelineCachePivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2081: {
    /* n:"BrtEndTimelineCachePivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2082: {
    /* n:"BrtTimelineCachePivotCacheID" */
  },
  /*::[*/
  2083: {
    /* n:"BrtBeginTimelineCacheIDs", */
    T: 1
  },
  /*::[*/
  2084: {
    /* n:"BrtEndTimelineCacheIDs", */
    T: -1
  },
  /*::[*/
  2085: {
    /* n:"BrtBeginTimelineCacheID", */
    T: 1
  },
  /*::[*/
  2086: {
    /* n:"BrtEndTimelineCacheID", */
    T: -1
  },
  /*::[*/
  2087: {
    /* n:"BrtBeginTimelinesEx", */
    T: 1
  },
  /*::[*/
  2088: {
    /* n:"BrtEndTimelinesEx", */
    T: -1
  },
  /*::[*/
  2089: {
    /* n:"BrtBeginTimelineEx", */
    T: 1
  },
  /*::[*/
  2090: {
    /* n:"BrtEndTimelineEx", */
    T: -1
  },
  /*::[*/
  2091: {
    /* n:"BrtWorkBookPr15" */
  },
  /*::[*/
  2092: {
    /* n:"BrtPCDH15" */
  },
  /*::[*/
  2093: {
    /* n:"BrtBeginTimelineStyle", */
    T: 1
  },
  /*::[*/
  2094: {
    /* n:"BrtEndTimelineStyle", */
    T: -1
  },
  /*::[*/
  2095: {
    /* n:"BrtTimelineStyleElement" */
  },
  /*::[*/
  2096: {
    /* n:"BrtBeginTimelineStylesheetExt15", */
    T: 1
  },
  /*::[*/
  2097: {
    /* n:"BrtEndTimelineStylesheetExt15", */
    T: -1
  },
  /*::[*/
  2098: {
    /* n:"BrtBeginTimelineStyles", */
    T: 1
  },
  /*::[*/
  2099: {
    /* n:"BrtEndTimelineStyles", */
    T: -1
  },
  /*::[*/
  2100: {
    /* n:"BrtBeginTimelineStyleElements", */
    T: 1
  },
  /*::[*/
  2101: {
    /* n:"BrtEndTimelineStyleElements", */
    T: -1
  },
  /*::[*/
  2102: {
    /* n:"BrtDxf15" */
  },
  /*::[*/
  2103: {
    /* n:"BrtBeginDxfs15", */
    T: 1
  },
  /*::[*/
  2104: {
    /* n:"BrtEndDxfs15", */
    T: -1
  },
  /*::[*/
  2105: {
    /* n:"BrtSlicerCacheHideItemsWithNoData" */
  },
  /*::[*/
  2106: {
    /* n:"BrtBeginItemUniqueNames", */
    T: 1
  },
  /*::[*/
  2107: {
    /* n:"BrtEndItemUniqueNames", */
    T: -1
  },
  /*::[*/
  2108: {
    /* n:"BrtItemUniqueName" */
  },
  /*::[*/
  2109: {
    /* n:"BrtBeginExtConn15", */
    T: 1
  },
  /*::[*/
  2110: {
    /* n:"BrtEndExtConn15", */
    T: -1
  },
  /*::[*/
  2111: {
    /* n:"BrtBeginOledbPr15", */
    T: 1
  },
  /*::[*/
  2112: {
    /* n:"BrtEndOledbPr15", */
    T: -1
  },
  /*::[*/
  2113: {
    /* n:"BrtBeginDataFeedPr15", */
    T: 1
  },
  /*::[*/
  2114: {
    /* n:"BrtEndDataFeedPr15", */
    T: -1
  },
  /*::[*/
  2115: {
    /* n:"BrtTextPr15" */
  },
  /*::[*/
  2116: {
    /* n:"BrtRangePr15" */
  },
  /*::[*/
  2117: {
    /* n:"BrtDbCommand15" */
  },
  /*::[*/
  2118: {
    /* n:"BrtBeginDbTables15", */
    T: 1
  },
  /*::[*/
  2119: {
    /* n:"BrtEndDbTables15", */
    T: -1
  },
  /*::[*/
  2120: {
    /* n:"BrtDbTable15" */
  },
  /*::[*/
  2121: {
    /* n:"BrtBeginDataModel", */
    T: 1
  },
  /*::[*/
  2122: {
    /* n:"BrtEndDataModel", */
    T: -1
  },
  /*::[*/
  2123: {
    /* n:"BrtBeginModelTables", */
    T: 1
  },
  /*::[*/
  2124: {
    /* n:"BrtEndModelTables", */
    T: -1
  },
  /*::[*/
  2125: {
    /* n:"BrtModelTable" */
  },
  /*::[*/
  2126: {
    /* n:"BrtBeginModelRelationships", */
    T: 1
  },
  /*::[*/
  2127: {
    /* n:"BrtEndModelRelationships", */
    T: -1
  },
  /*::[*/
  2128: {
    /* n:"BrtModelRelationship" */
  },
  /*::[*/
  2129: {
    /* n:"BrtBeginECTxtWiz15", */
    T: 1
  },
  /*::[*/
  2130: {
    /* n:"BrtEndECTxtWiz15", */
    T: -1
  },
  /*::[*/
  2131: {
    /* n:"BrtBeginECTWFldInfoLst15", */
    T: 1
  },
  /*::[*/
  2132: {
    /* n:"BrtEndECTWFldInfoLst15", */
    T: -1
  },
  /*::[*/
  2133: {
    /* n:"BrtBeginECTWFldInfo15", */
    T: 1
  },
  /*::[*/
  2134: {
    /* n:"BrtFieldListActiveItem" */
  },
  /*::[*/
  2135: {
    /* n:"BrtPivotCacheIdVersion" */
  },
  /*::[*/
  2136: {
    /* n:"BrtSXDI15" */
  },
  /*::[*/
  2137: {
    /* n:"BrtBeginModelTimeGroupings", */
    T: 1
  },
  /*::[*/
  2138: {
    /* n:"BrtEndModelTimeGroupings", */
    T: -1
  },
  /*::[*/
  2139: {
    /* n:"BrtBeginModelTimeGrouping", */
    T: 1
  },
  /*::[*/
  2140: {
    /* n:"BrtEndModelTimeGrouping", */
    T: -1
  },
  /*::[*/
  2141: {
    /* n:"BrtModelTimeGroupingCalcCol" */
  },
  /*::[*/
  3072: {
    /* n:"BrtUid" */
  },
  /*::[*/
  3073: {
    /* n:"BrtRevisionPtr" */
  },
  /*::[*/
  4096: {
    /* n:"BrtBeginDynamicArrayPr", */
    T: 1
  },
  /*::[*/
  4097: {
    /* n:"BrtEndDynamicArrayPr", */
    T: -1
  },
  /*::[*/
  5002: {
    /* n:"BrtBeginRichValueBlock", */
    T: 1
  },
  /*::[*/
  5003: {
    /* n:"BrtEndRichValueBlock", */
    T: -1
  },
  /*::[*/
  5081: {
    /* n:"BrtBeginRichFilters", */
    T: 1
  },
  /*::[*/
  5082: {
    /* n:"BrtEndRichFilters", */
    T: -1
  },
  /*::[*/
  5083: {
    /* n:"BrtRichFilter" */
  },
  /*::[*/
  5084: {
    /* n:"BrtBeginRichFilterColumn", */
    T: 1
  },
  /*::[*/
  5085: {
    /* n:"BrtEndRichFilterColumn", */
    T: -1
  },
  /*::[*/
  5086: {
    /* n:"BrtBeginCustomRichFilters", */
    T: 1
  },
  /*::[*/
  5087: {
    /* n:"BrtEndCustomRichFilters", */
    T: -1
  },
  /*::[*/
  5088: {
    /* n:"BrtCustomRichFilter" */
  },
  /*::[*/
  5089: {
    /* n:"BrtTop10RichFilter" */
  },
  /*::[*/
  5090: {
    /* n:"BrtDynamicRichFilter" */
  },
  /*::[*/
  5092: {
    /* n:"BrtBeginRichSortCondition", */
    T: 1
  },
  /*::[*/
  5093: {
    /* n:"BrtEndRichSortCondition", */
    T: -1
  },
  /*::[*/
  5094: {
    /* n:"BrtRichFilterDateGroupItem" */
  },
  /*::[*/
  5095: {
    /* n:"BrtBeginCalcFeatures", */
    T: 1
  },
  /*::[*/
  5096: {
    /* n:"BrtEndCalcFeatures", */
    T: -1
  },
  /*::[*/
  5097: {
    /* n:"BrtCalcFeature" */
  },
  /*::[*/
  5099: {
    /* n:"BrtExternalLinksPr" */
  },
  /*::[*/
  65535: { n: "" }
}, qS = {
  /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
  /*::[*/
  6: {
    /* n:"Formula", */
    f: Rx
  },
  /*::[*/
  10: {
    /* n:"EOF", */
    f: Sl
  },
  /*::[*/
  12: {
    /* n:"CalcCount", */
    f: Dr
  },
  //
  /*::[*/
  13: {
    /* n:"CalcMode", */
    f: Dr
  },
  //
  /*::[*/
  14: {
    /* n:"CalcPrecision", */
    f: Sr
  },
  //
  /*::[*/
  15: {
    /* n:"CalcRefMode", */
    f: Sr
  },
  //
  /*::[*/
  16: {
    /* n:"CalcDelta", */
    f: $a
  },
  //
  /*::[*/
  17: {
    /* n:"CalcIter", */
    f: Sr
  },
  //
  /*::[*/
  18: {
    /* n:"Protect", */
    f: Sr
  },
  /*::[*/
  19: {
    /* n:"Password", */
    f: Dr
  },
  /*::[*/
  20: {
    /* n:"Header", */
    f: TO
  },
  /*::[*/
  21: {
    /* n:"Footer", */
    f: TO
  },
  /*::[*/
  23: {
    /* n:"ExternSheet", */
    f: QR
  },
  /*::[*/
  24: {
    /* n:"Lbl", */
    f: OO
  },
  /*::[*/
  25: {
    /* n:"WinProtect", */
    f: Sr
  },
  /*::[*/
  26: {
    /* n:"VerticalPageBreaks", */
  },
  /*::[*/
  27: {
    /* n:"HorizontalPageBreaks", */
  },
  /*::[*/
  28: {
    /* n:"Note", */
    f: sxe
  },
  /*::[*/
  29: {
    /* n:"Selection", */
  },
  /*::[*/
  34: {
    /* n:"Date1904", */
    f: Sr
  },
  /*::[*/
  35: {
    /* n:"ExternName", */
    f: $O
  },
  /*::[*/
  38: {
    /* n:"LeftMargin", */
    f: $a
  },
  // *
  /*::[*/
  39: {
    /* n:"RightMargin", */
    f: $a
  },
  // *
  /*::[*/
  40: {
    /* n:"TopMargin", */
    f: $a
  },
  // *
  /*::[*/
  41: {
    /* n:"BottomMargin", */
    f: $a
  },
  // *
  /*::[*/
  42: {
    /* n:"PrintRowCol", */
    f: Sr
  },
  /*::[*/
  43: {
    /* n:"PrintGrid", */
    f: Sr
  },
  /*::[*/
  47: {
    /* n:"FilePass", */
    f: xbe
  },
  /*::[*/
  49: {
    /* n:"Font", */
    f: Mye
  },
  /*::[*/
  51: {
    /* n:"PrintSize", */
    f: Dr
  },
  /*::[*/
  60: {
    /* n:"Continue", */
  },
  /*::[*/
  61: {
    /* n:"Window1", */
    f: Aye
  },
  /*::[*/
  64: {
    /* n:"Backup", */
    f: Sr
  },
  /*::[*/
  65: {
    /* n:"Pane", */
    f: kye
  },
  /*::[*/
  66: {
    /* n:"CodePage", */
    f: Dr
  },
  /*::[*/
  77: {
    /* n:"Pls", */
  },
  /*::[*/
  80: {
    /* n:"DCon", */
  },
  /*::[*/
  81: {
    /* n:"DConRef", */
  },
  /*::[*/
  82: {
    /* n:"DConName", */
  },
  /*::[*/
  85: {
    /* n:"DefColWidth", */
    f: Dr
  },
  /*::[*/
  89: {
    /* n:"XCT", */
  },
  /*::[*/
  90: {
    /* n:"CRN", */
  },
  /*::[*/
  91: {
    /* n:"FileSharing", */
  },
  /*::[*/
  92: {
    /* n:"WriteAccess", */
    f: yye
  },
  /*::[*/
  93: {
    /* n:"Obj", */
    f: cxe
  },
  /*::[*/
  94: {
    /* n:"Uncalced", */
  },
  /*::[*/
  95: {
    /* n:"CalcSaveRecalc", */
    f: Sr
  },
  //
  /*::[*/
  96: {
    /* n:"Template", */
  },
  /*::[*/
  97: {
    /* n:"Intl", */
  },
  /*::[*/
  99: {
    /* n:"ObjProtect", */
    f: Sr
  },
  /*::[*/
  125: {
    /* n:"ColInfo", */
    f: JR
  },
  /*::[*/
  128: {
    /* n:"Guts", */
    f: qye
  },
  /*::[*/
  129: {
    /* n:"WsBool", */
    f: bye
  },
  /*::[*/
  130: {
    /* n:"GridSet", */
    f: Dr
  },
  /*::[*/
  131: {
    /* n:"HCenter", */
    f: Sr
  },
  /*::[*/
  132: {
    /* n:"VCenter", */
    f: Sr
  },
  /*::[*/
  133: {
    /* n:"BoundSheet8", */
    f: wye
  },
  /*::[*/
  134: {
    /* n:"WriteProtect", */
  },
  /*::[*/
  140: {
    /* n:"Country", */
    f: yxe
  },
  /*::[*/
  141: {
    /* n:"HideObj", */
    f: Dr
  },
  /*::[*/
  144: {
    /* n:"Sort", */
  },
  /*::[*/
  146: {
    /* n:"Palette", */
    f: wxe
  },
  /*::[*/
  151: {
    /* n:"Sync", */
  },
  /*::[*/
  152: {
    /* n:"LPr", */
  },
  /*::[*/
  153: {
    /* n:"DxGCol", */
  },
  /*::[*/
  154: {
    /* n:"FnGroupName", */
  },
  /*::[*/
  155: {
    /* n:"FilterMode", */
  },
  /*::[*/
  156: {
    /* n:"BuiltInFnGroupCount", */
    f: Dr
  },
  /*::[*/
  157: {
    /* n:"AutoFilterInfo", */
  },
  /*::[*/
  158: {
    /* n:"AutoFilter", */
  },
  /*::[*/
  160: {
    /* n:"Scl", */
    f: Oxe
  },
  /*::[*/
  161: {
    /* n:"Setup", */
    f: Cxe
  },
  /*::[*/
  174: {
    /* n:"ScenMan", */
  },
  /*::[*/
  175: {
    /* n:"SCENARIO", */
  },
  /*::[*/
  176: {
    /* n:"SxView", */
  },
  /*::[*/
  177: {
    /* n:"Sxvd", */
  },
  /*::[*/
  178: {
    /* n:"SXVI", */
  },
  /*::[*/
  180: {
    /* n:"SxIvd", */
  },
  /*::[*/
  181: {
    /* n:"SXLI", */
  },
  /*::[*/
  182: {
    /* n:"SXPI", */
  },
  /*::[*/
  184: {
    /* n:"DocRoute", */
  },
  /*::[*/
  185: {
    /* n:"RecipName", */
  },
  /*::[*/
  189: {
    /* n:"MulRk", */
    f: Wye
  },
  /*::[*/
  190: {
    /* n:"MulBlank", */
    f: Gye
  },
  /*::[*/
  193: {
    /* n:"Mms", */
    f: Sl
  },
  /*::[*/
  197: {
    /* n:"SXDI", */
  },
  /*::[*/
  198: {
    /* n:"SXDB", */
  },
  /*::[*/
  199: {
    /* n:"SXFDB", */
  },
  /*::[*/
  200: {
    /* n:"SXDBB", */
  },
  /*::[*/
  201: {
    /* n:"SXNum", */
  },
  /*::[*/
  202: {
    /* n:"SxBool", */
    f: Sr
  },
  /*::[*/
  203: {
    /* n:"SxErr", */
  },
  /*::[*/
  204: {
    /* n:"SXInt", */
  },
  /*::[*/
  205: {
    /* n:"SXString", */
  },
  /*::[*/
  206: {
    /* n:"SXDtr", */
  },
  /*::[*/
  207: {
    /* n:"SxNil", */
  },
  /*::[*/
  208: {
    /* n:"SXTbl", */
  },
  /*::[*/
  209: {
    /* n:"SXTBRGIITM", */
  },
  /*::[*/
  210: {
    /* n:"SxTbpg", */
  },
  /*::[*/
  211: {
    /* n:"ObProj", */
  },
  /*::[*/
  213: {
    /* n:"SXStreamID", */
  },
  /*::[*/
  215: {
    /* n:"DBCell", */
  },
  /*::[*/
  216: {
    /* n:"SXRng", */
  },
  /*::[*/
  217: {
    /* n:"SxIsxoper", */
  },
  /*::[*/
  218: {
    /* n:"BookBool", */
    f: Dr
  },
  /*::[*/
  220: {
    /* n:"DbOrParamQry", */
  },
  /*::[*/
  221: {
    /* n:"ScenarioProtect", */
    f: Sr
  },
  /*::[*/
  222: {
    /* n:"OleObjectSize", */
  },
  /*::[*/
  224: {
    /* n:"XF", */
    f: Yye
  },
  /*::[*/
  225: {
    /* n:"InterfaceHdr", */
    f: gye
  },
  /*::[*/
  226: {
    /* n:"InterfaceEnd", */
    f: Sl
  },
  /*::[*/
  227: {
    /* n:"SXVS", */
  },
  /*::[*/
  229: {
    /* n:"MergeCells", */
    f: lxe
  },
  /*::[*/
  233: {
    /* n:"BkHim", */
  },
  /*::[*/
  235: {
    /* n:"MsoDrawingGroup", */
  },
  /*::[*/
  236: {
    /* n:"MsoDrawing", */
  },
  /*::[*/
  237: {
    /* n:"MsoDrawingSelection", */
  },
  /*::[*/
  239: {
    /* n:"PhoneticInfo", */
  },
  /*::[*/
  240: {
    /* n:"SxRule", */
  },
  /*::[*/
  241: {
    /* n:"SXEx", */
  },
  /*::[*/
  242: {
    /* n:"SxFilt", */
  },
  /*::[*/
  244: {
    /* n:"SxDXF", */
  },
  /*::[*/
  245: {
    /* n:"SxItm", */
  },
  /*::[*/
  246: {
    /* n:"SxName", */
  },
  /*::[*/
  247: {
    /* n:"SxSelect", */
  },
  /*::[*/
  248: {
    /* n:"SXPair", */
  },
  /*::[*/
  249: {
    /* n:"SxFmla", */
  },
  /*::[*/
  251: {
    /* n:"SxFormat", */
  },
  /*::[*/
  252: {
    /* n:"SST", */
    f: _ye
  },
  /*::[*/
  253: {
    /* n:"LabelSst", */
    f: Nye
  },
  /*::[*/
  255: {
    /* n:"ExtSST", */
    f: Eye
  },
  /*::[*/
  256: {
    /* n:"SXVDEx", */
  },
  /*::[*/
  259: {
    /* n:"SXFormula", */
  },
  /*::[*/
  290: {
    /* n:"SXDBEx", */
  },
  /*::[*/
  311: {
    /* n:"RRDInsDel", */
  },
  /*::[*/
  312: {
    /* n:"RRDHead", */
  },
  /*::[*/
  315: {
    /* n:"RRDChgCell", */
  },
  /*::[*/
  317: {
    /* n:"RRTabId", */
    f: UR
  },
  /*::[*/
  318: {
    /* n:"RRDRenSheet", */
  },
  /*::[*/
  319: {
    /* n:"RRSort", */
  },
  /*::[*/
  320: {
    /* n:"RRDMove", */
  },
  /*::[*/
  330: {
    /* n:"RRFormat", */
  },
  /*::[*/
  331: {
    /* n:"RRAutoFmt", */
  },
  /*::[*/
  333: {
    /* n:"RRInsertSh", */
  },
  /*::[*/
  334: {
    /* n:"RRDMoveBegin", */
  },
  /*::[*/
  335: {
    /* n:"RRDMoveEnd", */
  },
  /*::[*/
  336: {
    /* n:"RRDInsDelBegin", */
  },
  /*::[*/
  337: {
    /* n:"RRDInsDelEnd", */
  },
  /*::[*/
  338: {
    /* n:"RRDConflict", */
  },
  /*::[*/
  339: {
    /* n:"RRDDefName", */
  },
  /*::[*/
  340: {
    /* n:"RRDRstEtxp", */
  },
  /*::[*/
  351: {
    /* n:"LRng", */
  },
  /*::[*/
  352: {
    /* n:"UsesELFs", */
    f: Sr
  },
  /*::[*/
  353: {
    /* n:"DSF", */
    f: Sl
  },
  /*::[*/
  401: {
    /* n:"CUsr", */
  },
  /*::[*/
  402: {
    /* n:"CbUsr", */
  },
  /*::[*/
  403: {
    /* n:"UsrInfo", */
  },
  /*::[*/
  404: {
    /* n:"UsrExcl", */
  },
  /*::[*/
  405: {
    /* n:"FileLock", */
  },
  /*::[*/
  406: {
    /* n:"RRDInfo", */
  },
  /*::[*/
  407: {
    /* n:"BCUsrs", */
  },
  /*::[*/
  408: {
    /* n:"UsrChk", */
  },
  /*::[*/
  425: {
    /* n:"UserBView", */
  },
  /*::[*/
  426: {
    /* n:"UserSViewBegin", */
  },
  /*::[*/
  427: {
    /* n:"UserSViewEnd", */
  },
  /*::[*/
  428: {
    /* n:"RRDUserView", */
  },
  /*::[*/
  429: {
    /* n:"Qsi", */
  },
  /*::[*/
  430: {
    /* n:"SupBook", */
    f: exe
  },
  /*::[*/
  431: {
    /* n:"Prot4Rev", */
    f: Sr
  },
  /*::[*/
  432: {
    /* n:"CondFmt", */
  },
  /*::[*/
  433: {
    /* n:"CF", */
  },
  /*::[*/
  434: {
    /* n:"DVal", */
  },
  /*::[*/
  437: {
    /* n:"DConBin", */
  },
  /*::[*/
  438: {
    /* n:"TxO", */
    f: pxe
  },
  /*::[*/
  439: {
    /* n:"RefreshAll", */
    f: Sr
  },
  //
  /*::[*/
  440: {
    /* n:"HLink", */
    f: hxe
  },
  /*::[*/
  441: {
    /* n:"Lel", */
  },
  /*::[*/
  442: {
    /* n:"CodeName", */
    f: fh
  },
  /*::[*/
  443: {
    /* n:"SXFDBType", */
  },
  /*::[*/
  444: {
    /* n:"Prot4RevPass", */
    f: Dr
  },
  /*::[*/
  445: {
    /* n:"ObNoMacros", */
  },
  /*::[*/
  446: {
    /* n:"Dv", */
  },
  /*::[*/
  448: {
    /* n:"Excel9File", */
    f: Sl
  },
  /*::[*/
  449: {
    /* n:"RecalcId", */
    f: Oye,
    r: 2
  },
  /*::[*/
  450: {
    /* n:"EntExU2", */
    f: Sl
  },
  /*::[*/
  512: {
    /* n:"Dimensions", */
    f: _O
  },
  /*::[*/
  513: {
    /* n:"Blank", */
    f: $xe
  },
  /*::[*/
  515: {
    /* n:"Number", */
    f: Qye
  },
  /*::[*/
  516: {
    /* n:"Label", */
    f: Lye
  },
  /*::[*/
  517: {
    /* n:"BoolErr", */
    f: EO
  },
  /*::[*/
  519: {
    /* n:"String", */
    f: Axe
  },
  /*::[*/
  520: {
    /* n:"Row", */
    f: Tye
  },
  /*::[*/
  523: {
    /* n:"Index", */
  },
  /*::[*/
  545: {
    /* n:"Array", */
    f: AO
  },
  /*::[*/
  549: {
    /* n:"DefaultRowHeight", */
    f: SO
  },
  /*::[*/
  566: {
    /* n:"Table", */
  },
  /*::[*/
  574: {
    /* n:"Window2", */
    f: Pye
  },
  /*::[*/
  638: {
    /* n:"RK", */
    f: zye
  },
  /*::[*/
  659: {
    /* n:"Style", */
  },
  /*::[*/
  1048: {
    /* n:"BigName", */
  },
  /*::[*/
  1054: {
    /* n:"Format", */
    f: Hye
  },
  /*::[*/
  1084: {
    /* n:"ContinueBigName", */
  },
  /*::[*/
  1212: {
    /* n:"ShrFmla", */
    f: axe
  },
  /*::[*/
  2048: {
    /* n:"HLinkTooltip", */
    f: mxe
  },
  /*::[*/
  2049: {
    /* n:"WebPub", */
  },
  /*::[*/
  2050: {
    /* n:"QsiSXTag", */
  },
  /*::[*/
  2051: {
    /* n:"DBQueryExt", */
  },
  /*::[*/
  2052: {
    /* n:"ExtString", */
  },
  /*::[*/
  2053: {
    /* n:"TxtQry", */
  },
  /*::[*/
  2054: {
    /* n:"Qsir", */
  },
  /*::[*/
  2055: {
    /* n:"Qsif", */
  },
  /*::[*/
  2056: {
    /* n:"RRDTQSIF", */
  },
  /*::[*/
  2057: {
    /* n:"BOF", */
    f: vv
  },
  /*::[*/
  2058: {
    /* n:"OleDbConn", */
  },
  /*::[*/
  2059: {
    /* n:"WOpt", */
  },
  /*::[*/
  2060: {
    /* n:"SXViewEx", */
  },
  /*::[*/
  2061: {
    /* n:"SXTH", */
  },
  /*::[*/
  2062: {
    /* n:"SXPIEx", */
  },
  /*::[*/
  2063: {
    /* n:"SXVDTEx", */
  },
  /*::[*/
  2064: {
    /* n:"SXViewEx9", */
  },
  /*::[*/
  2066: {
    /* n:"ContinueFrt", */
  },
  /*::[*/
  2067: {
    /* n:"RealTimeData", */
  },
  /*::[*/
  2128: {
    /* n:"ChartFrtInfo", */
  },
  /*::[*/
  2129: {
    /* n:"FrtWrapper", */
  },
  /*::[*/
  2130: {
    /* n:"StartBlock", */
  },
  /*::[*/
  2131: {
    /* n:"EndBlock", */
  },
  /*::[*/
  2132: {
    /* n:"StartObject", */
  },
  /*::[*/
  2133: {
    /* n:"EndObject", */
  },
  /*::[*/
  2134: {
    /* n:"CatLab", */
  },
  /*::[*/
  2135: {
    /* n:"YMult", */
  },
  /*::[*/
  2136: {
    /* n:"SXViewLink", */
  },
  /*::[*/
  2137: {
    /* n:"PivotChartBits", */
  },
  /*::[*/
  2138: {
    /* n:"FrtFontList", */
  },
  /*::[*/
  2146: {
    /* n:"SheetExt", */
  },
  /*::[*/
  2147: {
    /* n:"BookExt", */
    r: 12
  },
  /*::[*/
  2148: {
    /* n:"SXAddl", */
  },
  /*::[*/
  2149: {
    /* n:"CrErr", */
  },
  /*::[*/
  2150: {
    /* n:"HFPicture", */
  },
  /*::[*/
  2151: {
    /* n:"FeatHdr", */
    f: Sl
  },
  /*::[*/
  2152: {
    /* n:"Feat", */
  },
  /*::[*/
  2154: {
    /* n:"DataLabExt", */
  },
  /*::[*/
  2155: {
    /* n:"DataLabExtContents", */
  },
  /*::[*/
  2156: {
    /* n:"CellWatch", */
  },
  /*::[*/
  2161: {
    /* n:"FeatHdr11", */
  },
  /*::[*/
  2162: {
    /* n:"Feature11", */
  },
  /*::[*/
  2164: {
    /* n:"DropDownObjIds", */
  },
  /*::[*/
  2165: {
    /* n:"ContinueFrt11", */
  },
  /*::[*/
  2166: {
    /* n:"DConn", */
  },
  /*::[*/
  2167: {
    /* n:"List12", */
  },
  /*::[*/
  2168: {
    /* n:"Feature12", */
  },
  /*::[*/
  2169: {
    /* n:"CondFmt12", */
  },
  /*::[*/
  2170: {
    /* n:"CF12", */
  },
  /*::[*/
  2171: {
    /* n:"CFEx", */
  },
  /*::[*/
  2172: {
    /* n:"XFCRC", */
    f: Sxe,
    r: 12
  },
  /*::[*/
  2173: {
    /* n:"XFExt", */
    f: y2e,
    r: 12
  },
  /*::[*/
  2174: {
    /* n:"AutoFilter12", */
  },
  /*::[*/
  2175: {
    /* n:"ContinueFrt12", */
  },
  /*::[*/
  2180: {
    /* n:"MDTInfo", */
  },
  /*::[*/
  2181: {
    /* n:"MDXStr", */
  },
  /*::[*/
  2182: {
    /* n:"MDXTuple", */
  },
  /*::[*/
  2183: {
    /* n:"MDXSet", */
  },
  /*::[*/
  2184: {
    /* n:"MDXProp", */
  },
  /*::[*/
  2185: {
    /* n:"MDXKPI", */
  },
  /*::[*/
  2186: {
    /* n:"MDB", */
  },
  /*::[*/
  2187: {
    /* n:"PLV", */
  },
  /*::[*/
  2188: {
    /* n:"Compat12", */
    f: Sr,
    r: 12
  },
  /*::[*/
  2189: {
    /* n:"DXF", */
  },
  /*::[*/
  2190: {
    /* n:"TableStyles", */
    r: 12
  },
  /*::[*/
  2191: {
    /* n:"TableStyle", */
  },
  /*::[*/
  2192: {
    /* n:"TableStyleElement", */
  },
  /*::[*/
  2194: {
    /* n:"StyleExt", */
  },
  /*::[*/
  2195: {
    /* n:"NamePublish", */
  },
  /*::[*/
  2196: {
    /* n:"NameCmt", */
    f: rxe,
    r: 12
  },
  /*::[*/
  2197: {
    /* n:"SortData", */
  },
  /*::[*/
  2198: {
    /* n:"Theme", */
    f: d2e,
    r: 12
  },
  /*::[*/
  2199: {
    /* n:"GUIDTypeLib", */
  },
  /*::[*/
  2200: {
    /* n:"FnGrp12", */
  },
  /*::[*/
  2201: {
    /* n:"NameFnGrp12", */
  },
  /*::[*/
  2202: {
    /* n:"MTRSettings", */
    f: oxe,
    r: 12
  },
  /*::[*/
  2203: {
    /* n:"CompressPictures", */
    f: Sl
  },
  /*::[*/
  2204: {
    /* n:"HeaderFooter", */
  },
  /*::[*/
  2205: {
    /* n:"CrtLayout12", */
  },
  /*::[*/
  2206: {
    /* n:"CrtMlFrt", */
  },
  /*::[*/
  2207: {
    /* n:"CrtMlFrtContinue", */
  },
  /*::[*/
  2211: {
    /* n:"ForceFullCalculation", */
    f: $ye
  },
  /*::[*/
  2212: {
    /* n:"ShapePropsStream", */
  },
  /*::[*/
  2213: {
    /* n:"TextPropsStream", */
  },
  /*::[*/
  2214: {
    /* n:"RichTextStream", */
  },
  /*::[*/
  2215: {
    /* n:"CrtLayout12A", */
  },
  /*::[*/
  4097: {
    /* n:"Units", */
  },
  /*::[*/
  4098: {
    /* n:"Chart", */
  },
  /*::[*/
  4099: {
    /* n:"Series", */
  },
  /*::[*/
  4102: {
    /* n:"DataFormat", */
  },
  /*::[*/
  4103: {
    /* n:"LineFormat", */
  },
  /*::[*/
  4105: {
    /* n:"MarkerFormat", */
  },
  /*::[*/
  4106: {
    /* n:"AreaFormat", */
  },
  /*::[*/
  4107: {
    /* n:"PieFormat", */
  },
  /*::[*/
  4108: {
    /* n:"AttachedLabel", */
  },
  /*::[*/
  4109: {
    /* n:"SeriesText", */
  },
  /*::[*/
  4116: {
    /* n:"ChartFormat", */
  },
  /*::[*/
  4117: {
    /* n:"Legend", */
  },
  /*::[*/
  4118: {
    /* n:"SeriesList", */
  },
  /*::[*/
  4119: {
    /* n:"Bar", */
  },
  /*::[*/
  4120: {
    /* n:"Line", */
  },
  /*::[*/
  4121: {
    /* n:"Pie", */
  },
  /*::[*/
  4122: {
    /* n:"Area", */
  },
  /*::[*/
  4123: {
    /* n:"Scatter", */
  },
  /*::[*/
  4124: {
    /* n:"CrtLine", */
  },
  /*::[*/
  4125: {
    /* n:"Axis", */
  },
  /*::[*/
  4126: {
    /* n:"Tick", */
  },
  /*::[*/
  4127: {
    /* n:"ValueRange", */
  },
  /*::[*/
  4128: {
    /* n:"CatSerRange", */
  },
  /*::[*/
  4129: {
    /* n:"AxisLine", */
  },
  /*::[*/
  4130: {
    /* n:"CrtLink", */
  },
  /*::[*/
  4132: {
    /* n:"DefaultText", */
  },
  /*::[*/
  4133: {
    /* n:"Text", */
  },
  /*::[*/
  4134: {
    /* n:"FontX", */
    f: Dr
  },
  /*::[*/
  4135: {
    /* n:"ObjectLink", */
  },
  /*::[*/
  4146: {
    /* n:"Frame", */
  },
  /*::[*/
  4147: {
    /* n:"Begin", */
  },
  /*::[*/
  4148: {
    /* n:"End", */
  },
  /*::[*/
  4149: {
    /* n:"PlotArea", */
  },
  /*::[*/
  4154: {
    /* n:"Chart3d", */
  },
  /*::[*/
  4156: {
    /* n:"PicF", */
  },
  /*::[*/
  4157: {
    /* n:"DropBar", */
  },
  /*::[*/
  4158: {
    /* n:"Radar", */
  },
  /*::[*/
  4159: {
    /* n:"Surf", */
  },
  /*::[*/
  4160: {
    /* n:"RadarArea", */
  },
  /*::[*/
  4161: {
    /* n:"AxisParent", */
  },
  /*::[*/
  4163: {
    /* n:"LegendException", */
  },
  /*::[*/
  4164: {
    /* n:"ShtProps", */
    f: Exe
  },
  /*::[*/
  4165: {
    /* n:"SerToCrt", */
  },
  /*::[*/
  4166: {
    /* n:"AxesUsed", */
  },
  /*::[*/
  4168: {
    /* n:"SBaseRef", */
  },
  /*::[*/
  4170: {
    /* n:"SerParent", */
  },
  /*::[*/
  4171: {
    /* n:"SerAuxTrend", */
  },
  /*::[*/
  4174: {
    /* n:"IFmtRecord", */
  },
  /*::[*/
  4175: {
    /* n:"Pos", */
  },
  /*::[*/
  4176: {
    /* n:"AlRuns", */
  },
  /*::[*/
  4177: {
    /* n:"BRAI", */
  },
  /*::[*/
  4187: {
    /* n:"SerAuxErrBar", */
  },
  /*::[*/
  4188: {
    /* n:"ClrtClient", */
    f: bxe
  },
  /*::[*/
  4189: {
    /* n:"SerFmt", */
  },
  /*::[*/
  4191: {
    /* n:"Chart3DBarShape", */
  },
  /*::[*/
  4192: {
    /* n:"Fbi", */
  },
  /*::[*/
  4193: {
    /* n:"BopPop", */
  },
  /*::[*/
  4194: {
    /* n:"AxcExt", */
  },
  /*::[*/
  4195: {
    /* n:"Dat", */
  },
  /*::[*/
  4196: {
    /* n:"PlotGrowth", */
  },
  /*::[*/
  4197: {
    /* n:"SIIndex", */
  },
  /*::[*/
  4198: {
    /* n:"GelFrame", */
  },
  /*::[*/
  4199: {
    /* n:"BopPopCustom", */
  },
  /*::[*/
  4200: {
    /* n:"Fbi2", */
  },
  /*::[*/
  0: {
    /* n:"Dimensions", */
    f: _O
  },
  /*::[*/
  1: {
    /* n:"BIFF2BLANK", */
  },
  /*::[*/
  2: {
    /* n:"BIFF2INT", */
    f: Mxe
  },
  /*::[*/
  3: {
    /* n:"BIFF2NUM", */
    f: Dxe
  },
  /*::[*/
  4: {
    /* n:"BIFF2STR", */
    f: Pxe
  },
  /*::[*/
  5: {
    /* n:"BoolErr", */
    f: EO
  },
  /*::[*/
  7: {
    /* n:"String", */
    f: Nxe
  },
  /*::[*/
  8: {
    /* n:"BIFF2ROW", */
  },
  /*::[*/
  9: {
    /* n:"BOF", */
    f: vv
  },
  /*::[*/
  11: {
    /* n:"Index", */
  },
  /*::[*/
  22: {
    /* n:"ExternCount", */
    f: Dr
  },
  /*::[*/
  30: {
    /* n:"BIFF2FORMAT", */
    f: Vye
  },
  /*::[*/
  31: {
    /* n:"BIFF2FMTCNT", */
  },
  /* 16-bit cnt of BIFF2FORMAT records */
  /*::[*/
  32: {
    /* n:"BIFF2COLINFO", */
  },
  /*::[*/
  33: {
    /* n:"Array", */
    f: AO
  },
  /*::[*/
  36: {
    /* n:"COLWIDTH", */
  },
  /*::[*/
  37: {
    /* n:"DefaultRowHeight", */
    f: SO
  },
  // 0x2c ??
  // 0x2d ??
  // 0x2e ??
  // 0x30 FONTCOUNT: number of fonts
  /*::[*/
  50: {
    /* n:"BIFF2FONTXTRA", */
    f: Fxe
  },
  // 0x35: INFOOPTS
  // 0x36: TABLE (BIFF2 only)
  // 0x37: TABLE2 (BIFF2 only)
  // 0x38: WNDESK
  // 0x39 ??
  // 0x3a: BEGINPREF
  // 0x3b: ENDPREF
  /*::[*/
  62: {
    /* n:"BIFF2WINDOW2", */
  },
  // 0x3f ??
  // 0x46: SHOWSCROLL
  // 0x47: SHOWFORMULA
  // 0x48: STATUSBAR
  // 0x49: SHORTMENUS
  // 0x4A:
  // 0x4B:
  // 0x4C:
  // 0x4E:
  // 0x4F:
  // 0x58: TOOLBAR (BIFF3)
  /* - - - */
  /*::[*/
  52: {
    /* n:"DDEObjName", */
  },
  /*::[*/
  67: {
    /* n:"BIFF2XF", */
  },
  /*::[*/
  68: {
    /* n:"BIFF2XFINDEX", */
    f: Dr
  },
  /*::[*/
  69: {
    /* n:"BIFF2FONTCLR", */
  },
  /*::[*/
  86: {
    /* n:"BIFF4FMTCNT", */
  },
  /* 16-bit cnt, similar to BIFF2 */
  /*::[*/
  126: {
    /* n:"RK", */
  },
  /* Not necessarily same as 0x027e */
  /*::[*/
  127: {
    /* n:"ImData", */
    f: Ixe
  },
  /*::[*/
  135: {
    /* n:"Addin", */
  },
  /*::[*/
  136: {
    /* n:"Edg", */
  },
  /*::[*/
  137: {
    /* n:"Pub", */
  },
  // 0x8A
  // 0x8B LH: alternate menu key flag (BIFF3/4)
  // 0x8E
  // 0x8F
  /*::[*/
  145: {
    /* n:"Sub", */
  },
  // 0x93 STYLE
  /*::[*/
  148: {
    /* n:"LHRecord", */
  },
  /*::[*/
  149: {
    /* n:"LHNGraph", */
  },
  /*::[*/
  150: {
    /* n:"Sound", */
  },
  // 0xA2 FNPROTO: function prototypes (BIFF4)
  // 0xA3
  // 0xA8
  /*::[*/
  169: {
    /* n:"CoordList", */
  },
  /*::[*/
  171: {
    /* n:"GCW", */
  },
  /*::[*/
  188: {
    /* n:"ShrFmla", */
  },
  /* Not necessarily same as 0x04bc */
  /*::[*/
  191: {
    /* n:"ToolbarHdr", */
  },
  /*::[*/
  192: {
    /* n:"ToolbarEnd", */
  },
  /*::[*/
  194: {
    /* n:"AddMenu", */
  },
  /*::[*/
  195: {
    /* n:"DelMenu", */
  },
  /*::[*/
  214: {
    /* n:"RString", */
    f: Lxe
  },
  /*::[*/
  223: {
    /* n:"UDDesc", */
  },
  /*::[*/
  234: {
    /* n:"TabIdConf", */
  },
  /*::[*/
  354: {
    /* n:"XL5Modify", */
  },
  /*::[*/
  421: {
    /* n:"FileSharing2", */
  },
  /*::[*/
  518: {
    /* n:"Formula", */
    f: Rx
  },
  /*::[*/
  521: {
    /* n:"BOF", */
    f: vv
  },
  /*::[*/
  536: {
    /* n:"Lbl", */
    f: OO
  },
  /*::[*/
  547: {
    /* n:"ExternName", */
    f: $O
  },
  /*::[*/
  561: {
    /* n:"Font", */
  },
  /*::[*/
  579: {
    /* n:"BIFF3XF", */
  },
  /*::[*/
  1030: {
    /* n:"Formula", */
    f: Rx
  },
  /*::[*/
  1033: {
    /* n:"BOF", */
    f: vv
  },
  /*::[*/
  1091: {
    /* n:"BIFF4XF", */
  },
  /*::[*/
  2157: {
    /* n:"FeatInfo", */
  },
  /*::[*/
  2163: {
    /* n:"FeatInfo11", */
  },
  /*::[*/
  2177: {
    /* n:"SXAddl12", */
  },
  /*::[*/
  2240: {
    /* n:"AutoWebPub", */
  },
  /*::[*/
  2241: {
    /* n:"ListObj", */
  },
  /*::[*/
  2242: {
    /* n:"ListField", */
  },
  /*::[*/
  2243: {
    /* n:"ListDV", */
  },
  /*::[*/
  2244: {
    /* n:"ListCondFmt", */
  },
  /*::[*/
  2245: {
    /* n:"ListCF", */
  },
  /*::[*/
  2246: {
    /* n:"FMQry", */
  },
  /*::[*/
  2247: {
    /* n:"FMSQry", */
  },
  /*::[*/
  2248: {
    /* n:"PLV", */
  },
  /*::[*/
  2249: {
    /* n:"LnExt", */
  },
  /*::[*/
  2250: {
    /* n:"MkrExt", */
  },
  /*::[*/
  2251: {
    /* n:"CrtCoopt", */
  },
  /*::[*/
  2262: {
    /* n:"FRTArchId$", */
    r: 12
  },
  /*::[*/
  29282: {}
};
function vt(e, t, n, r) {
  var a = t;
  if (!isNaN(a)) {
    var o = r || (n || []).length || 0, i = e.next(4);
    i.write_shift(2, a), i.write_shift(2, o), /*:: len != null &&*/
    o > 0 && X4(n) && e.push(n);
  }
}
function N4e(e, t, n, r) {
  var a = (n || []).length || 0;
  if (a <= 8224) return vt(e, t, n, a);
  var o = t;
  if (!isNaN(o)) {
    for (var i = n.parts || [], s = 0, l = 0, u = 0; u + (i[s] || 8224) <= 8224; )
      u += i[s] || 8224, s++;
    var c = e.next(4);
    for (c.write_shift(2, o), c.write_shift(2, u), e.push(n.slice(l, l + u)), l += u; l < a; ) {
      for (c = e.next(4), c.write_shift(2, 60), u = 0; u + (i[s] || 8224) <= 8224; )
        u += i[s] || 8224, s++;
      c.write_shift(2, u), e.push(n.slice(l, l + u)), l += u;
    }
  }
}
function vh(e, t, n) {
  return e || (e = We(7)), e.write_shift(2, t), e.write_shift(2, n), e.write_shift(2, 0), e.write_shift(1, 0), e;
}
function F4e(e, t, n, r) {
  var a = We(9);
  return vh(a, e, t), zR(n, r || "b", a), a;
}
function L4e(e, t, n) {
  var r = We(8 + 2 * n.length);
  return vh(r, e, t), r.write_shift(1, n.length), r.write_shift(n.length, n, "sbcs"), r.l < r.length ? r.slice(0, r.l) : r;
}
function B4e(e, t, n, r) {
  if (t.v != null) switch (t.t) {
    case "d":
    case "n":
      var a = t.t == "d" ? pa(nr(t.v)) : t.v;
      a == (a | 0) && a >= 0 && a < 65536 ? vt(e, 2, Rxe(n, r, a)) : vt(e, 3, kxe(n, r, a));
      return;
    case "b":
    case "e":
      vt(e, 5, F4e(n, r, t.v, t.t));
      return;
    case "s":
    case "str":
      vt(e, 4, L4e(n, r, (t.v || "").slice(0, 255)));
      return;
  }
  vt(e, 1, vh(null, n, r));
}
function H4e(e, t, n, r) {
  var a = Array.isArray(t), o = kn(t["!ref"] || "A1"), i, s = "", l = [];
  if (o.e.c > 255 || o.e.r > 16383) {
    if (r.WTF) throw new Error("Range " + (t["!ref"] || "A1") + " exceeds format limit A1:IV16384");
    o.e.c = Math.min(o.e.c, 255), o.e.r = Math.min(o.e.c, 16383), i = vn(o);
  }
  for (var u = o.s.r; u <= o.e.r; ++u) {
    s = Kr(u);
    for (var c = o.s.c; c <= o.e.c; ++c) {
      u === o.s.r && (l[c] = Mr(c)), i = l[c] + s;
      var f = a ? (t[u] || [])[c] : t[i];
      f && B4e(e, f, u, c);
    }
  }
}
function j4e(e, t) {
  for (var n = t || {}, r = lo(), a = 0, o = 0; o < e.SheetNames.length; ++o) e.SheetNames[o] == n.sheet && (a = o);
  if (a == 0 && n.sheet && e.SheetNames[0] != n.sheet) throw new Error("Sheet not found: " + n.sheet);
  return vt(r, n.biff == 4 ? 1033 : n.biff == 3 ? 521 : 9, aE(e, 16, n)), H4e(r, e.Sheets[e.SheetNames[a]], a, n), vt(r, 10), r.end();
}
function V4e(e, t, n) {
  vt(e, 49, Rye({
    sz: 12,
    color: { theme: 1 },
    name: "Arial",
    family: 2,
    scheme: "minor"
  }, n));
}
function U4e(e, t, n) {
  t && [[5, 8], [23, 26], [41, 44], [
    /*63*/
    50,
    /*66],[164,*/
    392
  ]].forEach(function(r) {
    for (var a = r[0]; a <= r[1]; ++a) t[a] != null && vt(e, 1054, jye(a, t[a], n));
  });
}
function z4e(e, t) {
  var n = We(19);
  n.write_shift(4, 2151), n.write_shift(4, 0), n.write_shift(4, 0), n.write_shift(2, 3), n.write_shift(1, 1), n.write_shift(4, 0), vt(e, 2151, n), n = We(39), n.write_shift(4, 2152), n.write_shift(4, 0), n.write_shift(4, 0), n.write_shift(2, 3), n.write_shift(1, 0), n.write_shift(4, 0), n.write_shift(2, 1), n.write_shift(4, 4), n.write_shift(2, 0), qR(kn(t["!ref"] || "A1"), n), n.write_shift(4, 4), vt(e, 2152, n);
}
function W4e(e, t) {
  for (var n = 0; n < 16; ++n) vt(e, 224, CO({ numFmtId: 0, style: !0 }, 0, t));
  t.cellXfs.forEach(function(r) {
    vt(e, 224, CO(r, 0, t));
  });
}
function G4e(e, t) {
  for (var n = 0; n < t["!links"].length; ++n) {
    var r = t["!links"][n];
    vt(e, 440, vxe(r)), r[1].Tooltip && vt(e, 2048, gxe(r));
  }
  delete t["!links"];
}
function K4e(e, t) {
  if (t) {
    var n = 0;
    t.forEach(function(r, a) {
      ++n <= 256 && r && vt(e, 125, _xe(K1(a, r), a));
    });
  }
}
function Y4e(e, t, n, r, a) {
  var o = 16 + mu(a.cellXfs, t, a);
  if (t.v == null && !t.bf) {
    vt(e, 513, xc(n, r, o));
    return;
  }
  if (t.bf) vt(e, 6, bSe(t, n, r, a, o));
  else switch (t.t) {
    case "d":
    case "n":
      var i = t.t == "d" ? pa(nr(t.v)) : t.v;
      vt(e, 515, Jye(n, r, i, o));
      break;
    case "b":
    case "e":
      vt(e, 517, Zye(n, r, t.v, o, a, t.t));
      break;
    case "s":
    case "str":
      if (a.bookSST) {
        var s = dE(a.Strings, t.v, a.revStrings);
        vt(e, 253, Fye(n, r, s, o));
      } else vt(e, 516, Bye(n, r, (t.v || "").slice(0, 255), o, a));
      break;
    default:
      vt(e, 513, xc(n, r, o));
  }
}
function q4e(e, t, n) {
  var r = lo(), a = n.SheetNames[e], o = n.Sheets[a] || {}, i = (n || {}).Workbook || {}, s = (i.Sheets || [])[e] || {}, l = Array.isArray(o), u = t.biff == 8, c, f = "", d = [], p = kn(o["!ref"] || "A1"), v = u ? 65536 : 16384;
  if (p.e.c > 255 || p.e.r >= v) {
    if (t.WTF) throw new Error("Range " + (o["!ref"] || "A1") + " exceeds format limit A1:IV16384");
    p.e.c = Math.min(p.e.c, 255), p.e.r = Math.min(p.e.c, v - 1);
  }
  vt(r, 2057, aE(n, 16, t)), vt(r, 13, ti(1)), vt(r, 12, ti(100)), vt(r, 15, Va(!0)), vt(r, 17, Va(!1)), vt(r, 16, gc(1e-3)), vt(r, 95, Va(!0)), vt(r, 42, Va(!1)), vt(r, 43, Va(!1)), vt(r, 130, ti(1)), vt(r, 128, Xye()), vt(r, 131, Va(!1)), vt(r, 132, Va(!1)), u && K4e(r, o["!cols"]), vt(r, 512, Uye(p, t)), u && (o["!links"] = []);
  for (var h = p.s.r; h <= p.e.r; ++h) {
    f = Kr(h);
    for (var m = p.s.c; m <= p.e.c; ++m) {
      h === p.s.r && (d[m] = Mr(m)), c = d[m] + f;
      var y = l ? (o[h] || [])[m] : o[c];
      y && (Y4e(r, y, h, m, t), u && y.l && o["!links"].push([c, y.l]));
    }
  }
  var x = s.CodeName || s.name || a;
  return u && vt(r, 574, Dye((i.Views || [])[0])), u && (o["!merges"] || []).length && vt(r, 229, uxe(o["!merges"])), u && G4e(r, o), vt(r, 442, WR(x)), u && z4e(r, o), vt(
    r,
    10
    /* EOF */
  ), r.end();
}
function X4e(e, t, n) {
  var r = lo(), a = (e || {}).Workbook || {}, o = a.Sheets || [], i = (
    /*::((*/
    a.WBProps || {
      /*::CodeName:"ThisWorkbook"*/
    }
  ), s = n.biff == 8, l = n.biff == 5;
  if (vt(r, 2057, aE(e, 5, n)), n.bookType == "xla" && vt(
    r,
    135
    /* Addin */
  ), vt(r, 225, s ? ti(1200) : null), vt(r, 193, Z1e(2)), l && vt(
    r,
    191
    /* ToolbarHdr */
  ), l && vt(
    r,
    192
    /* ToolbarEnd */
  ), vt(
    r,
    226
    /* InterfaceEnd */
  ), vt(r, 92, xye("SheetJS", n)), vt(r, 66, ti(s ? 1200 : 1252)), s && vt(r, 353, ti(0)), s && vt(
    r,
    448
    /* Excel9File */
  ), vt(r, 317, Txe(e.SheetNames.length)), s && e.vbaraw && vt(
    r,
    211
    /* ObProj */
  ), s && e.vbaraw) {
    var u = i.CodeName || "ThisWorkbook";
    vt(r, 442, WR(u));
  }
  vt(r, 156, ti(17)), vt(r, 25, Va(!1)), vt(r, 18, Va(!1)), vt(r, 19, ti(0)), s && vt(r, 431, Va(!1)), s && vt(r, 444, ti(0)), vt(r, 61, Iye()), vt(r, 64, Va(!1)), vt(r, 141, ti(0)), vt(r, 34, Va(OCe(e) == "true")), vt(r, 14, Va(!0)), s && vt(r, 439, Va(!1)), vt(r, 218, ti(0)), V4e(r, e, n), U4e(r, e.SSF, n), W4e(r, n), s && vt(r, 352, Va(!1));
  var c = r.end(), f = lo();
  s && vt(f, 140, xxe()), s && n.Strings && N4e(f, 252, Cye(n.Strings)), vt(
    f,
    10
    /* EOF */
  );
  var d = f.end(), p = lo(), v = 0, h = 0;
  for (h = 0; h < e.SheetNames.length; ++h) v += (s ? 12 : 11) + (s ? 2 : 1) * e.SheetNames[h].length;
  var m = c.length + v + d.length;
  for (h = 0; h < e.SheetNames.length; ++h) {
    var y = o[h] || {};
    vt(p, 133, Sye({ pos: m, hs: y.Hidden || 0, dt: 0, name: e.SheetNames[h] }, n)), m += t[h].length;
  }
  var x = p.end();
  if (v != x.length) throw new Error("BS8 " + v + " != " + x.length);
  var g = [];
  return c.length && g.push(c), x.length && g.push(x), d.length && g.push(d), zr(g);
}
function Z4e(e, t) {
  var n = t || {}, r = [];
  e && !e.SSF && (e.SSF = qn(jt)), e && e.SSF && (Id(), H1(e.SSF), n.revssf = V1(e.SSF), n.revssf[e.SSF[65535]] = 0, n.ssf = e.SSF), n.Strings = /*::((*/
  [], n.Strings.Count = 0, n.Strings.Unique = 0, gE(n), n.cellXfs = [], mu(n.cellXfs, {}, { revssf: { General: 0 } }), e.Props || (e.Props = {});
  for (var a = 0; a < e.SheetNames.length; ++a) r[r.length] = q4e(a, n, e);
  return r.unshift(X4e(e, r, n)), zr(r);
}
function LN(e, t) {
  for (var n = 0; n <= e.SheetNames.length; ++n) {
    var r = e.Sheets[e.SheetNames[n]];
    if (!(!r || !r["!ref"])) {
      var a = hi(r["!ref"]);
      a.e.c > 255 && typeof console < "u" && console.error && console.error("Worksheet '" + e.SheetNames[n] + "' extends beyond column IV (255).  Data may be lost.");
    }
  }
  var o = t || {};
  switch (o.biff || 2) {
    case 8:
    case 5:
      return Z4e(e, t);
    case 4:
    case 3:
    case 2:
      return j4e(e, t);
  }
  throw new Error("invalid type " + o.bookType + " for BIFF");
}
function BO(e, t) {
  var n = t || {}, r = n.dense ? [] : {};
  e = e.replace(/<!--.*?-->/g, "");
  var a = e.match(/<table/i);
  if (!a) throw new Error("Invalid HTML: could not find <table>");
  var o = e.match(/<\/table/i), i = a.index, s = o && o.index || e.length, l = Mge(e.slice(i, s), /(:?<tr[^>]*>)/i, "<tr>"), u = -1, c = 0, f = 0, d = 0, p = { s: { r: 1e7, c: 1e7 }, e: { r: 0, c: 0 } }, v = [];
  for (i = 0; i < l.length; ++i) {
    var h = l[i].trim(), m = h.slice(0, 3).toLowerCase();
    if (m == "<tr") {
      if (++u, n.sheetRows && n.sheetRows <= u) {
        --u;
        break;
      }
      c = 0;
      continue;
    }
    if (!(m != "<td" && m != "<th")) {
      var y = h.split(/<\/t[dh]>/i);
      for (s = 0; s < y.length; ++s) {
        var x = y[s].trim();
        if (x.match(/<t[dh]/i)) {
          for (var g = x, S = 0; g.charAt(0) == "<" && (S = g.indexOf(">")) > -1; ) g = g.slice(S + 1);
          for (var w = 0; w < v.length; ++w) {
            var _ = v[w];
            _.s.c == c && _.s.r < u && u <= _.e.r && (c = _.e.c + 1, w = -1);
          }
          var b = Vt(x.slice(0, x.indexOf(">")));
          d = b.colspan ? +b.colspan : 1, ((f = +b.rowspan) > 1 || d > 1) && v.push({ s: { r: u, c }, e: { r: u + (f || 1) - 1, c: c + d - 1 } });
          var E = b.t || b["data-t"] || "";
          if (!g.length) {
            c += d;
            continue;
          }
          if (g = zge(g), p.s.r > u && (p.s.r = u), p.e.r < u && (p.e.r = u), p.s.c > c && (p.s.c = c), p.e.c < c && (p.e.c = c), !g.length) {
            c += d;
            continue;
          }
          var C = { t: "s", v: g };
          n.raw || !g.trim().length || E == "s" || (g === "TRUE" ? C = { t: "b", v: !0 } : g === "FALSE" ? C = { t: "b", v: !1 } : isNaN(Xs(g)) ? isNaN(gp(g).getDate()) || (C = { t: "d", v: nr(g) }, n.cellDates || (C = { t: "n", v: pa(C.v) }), C.z = n.dateNF || jt[14]) : C = { t: "n", v: Xs(g) }), n.dense ? (r[u] || (r[u] = []), r[u][c] = C) : r[Kt({ r: u, c })] = C, c += d;
        }
      }
    }
  }
  return r["!ref"] = vn(p), v.length && (r["!merges"] = v), r;
}
function Q4e(e, t, n, r) {
  for (var a = e["!merges"] || [], o = [], i = t.s.c; i <= t.e.c; ++i) {
    for (var s = 0, l = 0, u = 0; u < a.length; ++u)
      if (!(a[u].s.r > n || a[u].s.c > i) && !(a[u].e.r < n || a[u].e.c < i)) {
        if (a[u].s.r < n || a[u].s.c < i) {
          s = -1;
          break;
        }
        s = a[u].e.r - a[u].s.r + 1, l = a[u].e.c - a[u].s.c + 1;
        break;
      }
    if (!(s < 0)) {
      var c = Kt({ r: n, c: i }), f = r.dense ? (e[n] || [])[i] : e[c], d = f && f.v != null && (f.h || K4(f.w || (au(f), f.w) || "")) || "", p = {};
      s > 1 && (p.rowspan = s), l > 1 && (p.colspan = l), r.editable ? d = '<span contenteditable="true">' + d + "</span>" : f && (p["data-t"] = f && f.t || "z", f.v != null && (p["data-v"] = f.v), f.z != null && (p["data-z"] = f.z), f.l && (f.l.Target || "#").charAt(0) != "#" && (d = '<a href="' + f.l.Target + '">' + d + "</a>")), p.id = (r.id || "sjs") + "-" + c, o.push(pt("td", d, p));
    }
  }
  var v = "<tr>";
  return v + o.join("") + "</tr>";
}
var J4e = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>', eEe = "</body></html>";
function tEe(e, t) {
  var n = e.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
  if (!n || n.length == 0) throw new Error("Invalid HTML: could not find <table>");
  if (n.length == 1) return Fc(BO(n[0], t), t);
  var r = KN();
  return n.forEach(function(a, o) {
    YN(r, BO(a, t), "Sheet" + (o + 1));
  }), r;
}
function nEe(e, t, n) {
  var r = [];
  return r.join("") + "<table" + (n && n.id ? ' id="' + n.id + '"' : "") + ">";
}
function rEe(e, t) {
  var n = t || {}, r = n.header != null ? n.header : J4e, a = n.footer != null ? n.footer : eEe, o = [r], i = hi(e["!ref"]);
  n.dense = Array.isArray(e), o.push(nEe(e, i, n));
  for (var s = i.s.r; s <= i.e.r; ++s) o.push(Q4e(e, i, s, n));
  return o.push("</table>" + a), o.join("");
}
function aEe(e) {
  var t = e.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function(r, a) {
    return Array(parseInt(a, 10) + 1).join(" ");
  }).replace(/<text:tab[^>]*\/>/g, "	").replace(/<text:line-break\/>/g, `
`), n = En(t.replace(/<[^>]*>/g, ""));
  return [n];
}
var HO = {
  /* ods name: [short ssf fmt, long ssf fmt] */
  day: ["d", "dd"],
  month: ["m", "mm"],
  year: ["y", "yy"],
  hours: ["h", "hh"],
  minutes: ["m", "mm"],
  seconds: ["s", "ss"],
  "am-pm": ["A/P", "AM/PM"],
  "day-of-week": ["ddd", "dddd"],
  era: ["e", "ee"],
  /* there is no native representation of LO "Q" format */
  quarter: ["\\Qm", 'm\\"th quarter"']
};
function BN(e, t) {
  var n = t || {}, r = Y4(e), a = [], o, i, s = { name: "" }, l = "", u = 0, c, f, d = {}, p = [], v = n.dense ? [] : {}, h, m, y = { value: "" }, x = "", g = 0, S = [], w = -1, _ = -1, b = { s: { r: 1e6, c: 1e7 }, e: { r: 0, c: 0 } }, E = 0, C = {}, T = [], O = {}, I = 0, k = 0, B = [], P = 1, N = 1, M = [], H = { Names: [] }, R = {}, z = ["", ""], W = [], F = {}, Y = "", X = 0, q = !1, Q = !1, ue = 0;
  for (bp.lastIndex = 0, r = r.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, ""); h = bp.exec(r); ) switch (h[3] = h[3].replace(/_.*$/, "")) {
    case "table":
    case "工作表":
      h[1] === "/" ? (b.e.c >= b.s.c && b.e.r >= b.s.r ? v["!ref"] = vn(b) : v["!ref"] = "A1:A1", n.sheetRows > 0 && n.sheetRows <= b.e.r && (v["!fullref"] = v["!ref"], b.e.r = n.sheetRows - 1, v["!ref"] = vn(b)), T.length && (v["!merges"] = T), B.length && (v["!rows"] = B), c.name = c.名称 || c.name, typeof JSON < "u" && JSON.stringify(c), p.push(c.name), d[c.name] = v, Q = !1) : h[0].charAt(h[0].length - 2) !== "/" && (c = Vt(h[0], !1), w = _ = -1, b.s.r = b.s.c = 1e7, b.e.r = b.e.c = 0, v = n.dense ? [] : {}, T = [], B = [], Q = !0);
      break;
    case "table-row-group":
      h[1] === "/" ? --E : ++E;
      break;
    case "table-row":
    case "行":
      if (h[1] === "/") {
        w += P, P = 1;
        break;
      }
      if (f = Vt(h[0], !1), f.行号 ? w = f.行号 - 1 : w == -1 && (w = 0), P = +f["number-rows-repeated"] || 1, P < 10) for (ue = 0; ue < P; ++ue) E > 0 && (B[w + ue] = { level: E });
      _ = -1;
      break;
    case "covered-table-cell":
      h[1] !== "/" && ++_, n.sheetStubs && (n.dense ? (v[w] || (v[w] = []), v[w][_] = { t: "z" }) : v[Kt({ r: w, c: _ })] = { t: "z" }), x = "", S = [];
      break;
    case "table-cell":
    case "数据":
      if (h[0].charAt(h[0].length - 2) === "/")
        ++_, y = Vt(h[0], !1), N = parseInt(y["number-columns-repeated"] || "1", 10), m = {
          t: "z",
          v: null
          /*:: , z:null, w:"",c:[]*/
        }, y.formula && n.cellFormula != !1 && (m.f = NO(En(y.formula))), (y.数据类型 || y["value-type"]) == "string" && (m.t = "s", m.v = En(y["string-value"] || ""), n.dense ? (v[w] || (v[w] = []), v[w][_] = m) : v[Kt({ r: w, c: _ })] = m), _ += N - 1;
      else if (h[1] !== "/") {
        ++_, x = "", g = 0, S = [], N = 1;
        var le = P ? w + P - 1 : w;
        if (_ > b.e.c && (b.e.c = _), _ < b.s.c && (b.s.c = _), w < b.s.r && (b.s.r = w), le > b.e.r && (b.e.r = le), y = Vt(h[0], !1), W = [], F = {}, m = {
          t: y.数据类型 || y["value-type"],
          v: null
          /*:: , z:null, w:"",c:[]*/
        }, n.cellFormula)
          if (y.formula && (y.formula = En(y.formula)), y["number-matrix-columns-spanned"] && y["number-matrix-rows-spanned"] && (I = parseInt(y["number-matrix-rows-spanned"], 10) || 0, k = parseInt(y["number-matrix-columns-spanned"], 10) || 0, O = { s: { r: w, c: _ }, e: { r: w + I - 1, c: _ + k - 1 } }, m.F = vn(O), M.push([O, m.F])), y.formula) m.f = NO(y.formula);
          else for (ue = 0; ue < M.length; ++ue)
            w >= M[ue][0].s.r && w <= M[ue][0].e.r && _ >= M[ue][0].s.c && _ <= M[ue][0].e.c && (m.F = M[ue][1]);
        switch ((y["number-columns-spanned"] || y["number-rows-spanned"]) && (I = parseInt(y["number-rows-spanned"], 10) || 0, k = parseInt(y["number-columns-spanned"], 10) || 0, O = { s: { r: w, c: _ }, e: { r: w + I - 1, c: _ + k - 1 } }, T.push(O)), y["number-columns-repeated"] && (N = parseInt(y["number-columns-repeated"], 10)), m.t) {
          case "boolean":
            m.t = "b", m.v = Kn(y["boolean-value"]);
            break;
          case "float":
            m.t = "n", m.v = parseFloat(y.value);
            break;
          case "percentage":
            m.t = "n", m.v = parseFloat(y.value);
            break;
          case "currency":
            m.t = "n", m.v = parseFloat(y.value);
            break;
          case "date":
            m.t = "d", m.v = nr(y["date-value"]), n.cellDates || (m.t = "n", m.v = pa(m.v)), m.z = "m/d/yy";
            break;
          case "time":
            m.t = "n", m.v = Pge(y["time-value"]) / 86400, n.cellDates && (m.t = "d", m.v = U1(m.v)), m.z = "HH:MM:SS";
            break;
          case "number":
            m.t = "n", m.v = parseFloat(y.数据数值);
            break;
          default:
            if (m.t === "string" || m.t === "text" || !m.t)
              m.t = "s", y["string-value"] != null && (x = En(y["string-value"]), S = []);
            else throw new Error("Unsupported value type " + m.t);
        }
      } else {
        if (q = !1, m.t === "s" && (m.v = x || "", S.length && (m.R = S), q = g == 0), R.Target && (m.l = R), W.length > 0 && (m.c = W, W = []), x && n.cellText !== !1 && (m.w = x), q && (m.t = "z", delete m.v), (!q || n.sheetStubs) && !(n.sheetRows && n.sheetRows <= w))
          for (var te = 0; te < P; ++te) {
            if (N = parseInt(y["number-columns-repeated"] || "1", 10), n.dense)
              for (v[w + te] || (v[w + te] = []), v[w + te][_] = te == 0 ? m : qn(m); --N > 0; ) v[w + te][_ + N] = qn(m);
            else
              for (v[Kt({ r: w + te, c: _ })] = m; --N > 0; ) v[Kt({ r: w + te, c: _ + N })] = qn(m);
            b.e.c <= _ && (b.e.c = _);
          }
        N = parseInt(y["number-columns-repeated"] || "1", 10), _ += N - 1, N = 0, m = {
          /*:: t:"", v:null, z:null, w:"",c:[]*/
        }, x = "", S = [];
      }
      R = {};
      break;
    case "document":
    case "document-content":
    case "电子表格文档":
    case "spreadsheet":
    case "主体":
    case "scripts":
    case "styles":
    case "font-face-decls":
    case "master-styles":
      if (h[1] === "/") {
        if ((o = a.pop())[0] !== h[3]) throw "Bad state: " + o;
      } else h[0].charAt(h[0].length - 2) !== "/" && a.push([h[3], !0]);
      break;
    case "annotation":
      if (h[1] === "/") {
        if ((o = a.pop())[0] !== h[3]) throw "Bad state: " + o;
        F.t = x, S.length && (F.R = S), F.a = Y, W.push(F);
      } else h[0].charAt(h[0].length - 2) !== "/" && a.push([h[3], !1]);
      Y = "", X = 0, x = "", g = 0, S = [];
      break;
    case "creator":
      h[1] === "/" ? Y = r.slice(X, h.index) : X = h.index + h[0].length;
      break;
    case "meta":
    case "元数据":
    case "settings":
    case "config-item-set":
    case "config-item-map-indexed":
    case "config-item-map-entry":
    case "config-item-map-named":
    case "shapes":
    case "frame":
    case "text-box":
    case "image":
    case "data-pilot-tables":
    case "list-style":
    case "form":
    case "dde-links":
    case "event-listeners":
    case "chart":
      if (h[1] === "/") {
        if ((o = a.pop())[0] !== h[3]) throw "Bad state: " + o;
      } else h[0].charAt(h[0].length - 2) !== "/" && a.push([h[3], !1]);
      x = "", g = 0, S = [];
      break;
    case "scientific-number":
      break;
    case "currency-symbol":
      break;
    case "currency-style":
      break;
    case "number-style":
    case "percentage-style":
    case "date-style":
    case "time-style":
      if (h[1] === "/") {
        if (C[s.name] = l, (o = a.pop())[0] !== h[3]) throw "Bad state: " + o;
      } else h[0].charAt(h[0].length - 2) !== "/" && (l = "", s = Vt(h[0], !1), a.push([h[3], !0]));
      break;
    case "script":
      break;
    case "libraries":
      break;
    case "automatic-styles":
      break;
    case "default-style":
    case "page-layout":
      break;
    case "style":
      break;
    case "map":
      break;
    case "font-face":
      break;
    case "paragraph-properties":
      break;
    case "table-properties":
      break;
    case "table-column-properties":
      break;
    case "table-row-properties":
      break;
    case "table-cell-properties":
      break;
    case "number":
      switch (a[a.length - 1][0]) {
        case "time-style":
        case "date-style":
          i = Vt(h[0], !1), l += HO[h[3]][i.style === "long" ? 1 : 0];
          break;
      }
      break;
    case "fraction":
      break;
    case "day":
    case "month":
    case "year":
    case "era":
    case "day-of-week":
    case "week-of-year":
    case "quarter":
    case "hours":
    case "minutes":
    case "seconds":
    case "am-pm":
      switch (a[a.length - 1][0]) {
        case "time-style":
        case "date-style":
          i = Vt(h[0], !1), l += HO[h[3]][i.style === "long" ? 1 : 0];
          break;
      }
      break;
    case "boolean-style":
      break;
    case "boolean":
      break;
    case "text-style":
      break;
    case "text":
      if (h[0].slice(-2) === "/>") break;
      if (h[1] === "/") switch (a[a.length - 1][0]) {
        case "number-style":
        case "date-style":
        case "time-style":
          l += r.slice(u, h.index);
          break;
      }
      else u = h.index + h[0].length;
      break;
    case "named-range":
      i = Vt(h[0], !1), z = Nx(i["cell-range-address"]);
      var G = { Name: i.name, Ref: z[0] + "!" + z[1] };
      Q && (G.Sheet = p.length), H.Names.push(G);
      break;
    case "text-content":
      break;
    case "text-properties":
      break;
    case "embedded-text":
      break;
    case "body":
    case "电子表格":
      break;
    case "forms":
      break;
    case "table-column":
      break;
    case "table-header-rows":
      break;
    case "table-rows":
      break;
    case "table-column-group":
      break;
    case "table-header-columns":
      break;
    case "table-columns":
      break;
    case "null-date":
      break;
    case "graphic-properties":
      break;
    case "calculation-settings":
      break;
    case "named-expressions":
      break;
    case "label-range":
      break;
    case "label-ranges":
      break;
    case "named-expression":
      break;
    case "sort":
      break;
    case "sort-by":
      break;
    case "sort-groups":
      break;
    case "tab":
      break;
    case "line-break":
      break;
    case "span":
      break;
    case "p":
    case "文本串":
      if (["master-styles"].indexOf(a[a.length - 1][0]) > -1) break;
      if (h[1] === "/" && (!y || !y["string-value"])) {
        var oe = aEe(r.slice(g, h.index));
        x = (x.length > 0 ? x + `
` : "") + oe[0];
      } else
        Vt(h[0], !1), g = h.index + h[0].length;
      break;
    case "s":
      break;
    case "database-range":
      if (h[1] === "/") break;
      try {
        z = Nx(Vt(h[0])["target-range-address"]), d[z[0]]["!autofilter"] = { ref: z[1] };
      } catch {
      }
      break;
    case "date":
      break;
    case "object":
      break;
    case "title":
    case "标题":
      break;
    case "desc":
      break;
    case "binary-data":
      break;
    case "table-source":
      break;
    case "scenario":
      break;
    case "iteration":
      break;
    case "content-validations":
      break;
    case "content-validation":
      break;
    case "help-message":
      break;
    case "error-message":
      break;
    case "database-ranges":
      break;
    case "filter":
      break;
    case "filter-and":
      break;
    case "filter-or":
      break;
    case "filter-condition":
      break;
    case "list-level-style-bullet":
      break;
    case "list-level-style-number":
      break;
    case "list-level-properties":
      break;
    case "sender-firstname":
    case "sender-lastname":
    case "sender-initials":
    case "sender-title":
    case "sender-position":
    case "sender-email":
    case "sender-phone-private":
    case "sender-fax":
    case "sender-company":
    case "sender-phone-work":
    case "sender-street":
    case "sender-city":
    case "sender-postal-code":
    case "sender-country":
    case "sender-state-or-province":
    case "author-name":
    case "author-initials":
    case "chapter":
    case "file-name":
    case "template-name":
    case "sheet-name":
      break;
    case "event-listener":
      break;
    case "initial-creator":
    case "creation-date":
    case "print-date":
    case "generator":
    case "document-statistic":
    case "user-defined":
    case "editing-duration":
    case "editing-cycles":
      break;
    case "config-item":
      break;
    case "page-number":
      break;
    case "page-count":
      break;
    case "time":
      break;
    case "cell-range-source":
      break;
    case "detective":
      break;
    case "operation":
      break;
    case "highlighted-range":
      break;
    case "data-pilot-table":
    case "source-cell-range":
    case "source-service":
    case "data-pilot-field":
    case "data-pilot-level":
    case "data-pilot-subtotals":
    case "data-pilot-subtotal":
    case "data-pilot-members":
    case "data-pilot-member":
    case "data-pilot-display-info":
    case "data-pilot-sort-info":
    case "data-pilot-layout-info":
    case "data-pilot-field-reference":
    case "data-pilot-groups":
    case "data-pilot-group":
    case "data-pilot-group-member":
      break;
    case "rect":
      break;
    case "dde-connection-decls":
    case "dde-connection-decl":
    case "dde-link":
    case "dde-source":
      break;
    case "properties":
      break;
    case "property":
      break;
    case "a":
      if (h[1] !== "/") {
        if (R = Vt(h[0], !1), !R.href) break;
        R.Target = En(R.href), delete R.href, R.Target.charAt(0) == "#" && R.Target.indexOf(".") > -1 ? (z = Nx(R.Target.slice(1)), R.Target = "#" + z[0] + "!" + z[1]) : R.Target.match(/^\.\.[\\\/]/) && (R.Target = R.Target.slice(3));
      }
      break;
    case "table-protection":
      break;
    case "data-pilot-grand-total":
      break;
    case "office-document-common-attrs":
      break;
    default:
      switch (h[2]) {
        case "dc:":
        case "calcext:":
        case "loext:":
        case "ooo:":
        case "chartooo:":
        case "draw:":
        case "style:":
        case "chart:":
        case "form:":
        case "uof:":
        case "表:":
        case "字:":
          break;
        default:
          if (n.WTF) throw new Error(h);
      }
  }
  var L = {
    Sheets: d,
    SheetNames: p,
    Workbook: H
  };
  return n.bookSheets && delete /*::(*/
  L.Sheets, L;
}
function jO(e, t) {
  t = t || {}, ei(e, "META-INF/manifest.xml") && D1e(Pr(e, "META-INF/manifest.xml"), t);
  var n = Do(e, "content.xml");
  if (!n) throw new Error("Missing content.xml in ODS / UOF file");
  var r = BN(Hn(n), t);
  return ei(e, "meta.xml") && (r.Props = DR(Pr(e, "meta.xml"))), r;
}
function VO(e, t) {
  return BN(e, t);
}
var oEe = /* @__PURE__ */ function() {
  var e = [
    "<office:master-styles>",
    '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
    "<style:header/>",
    '<style:header-left style:display="false"/>',
    "<style:footer/>",
    '<style:footer-left style:display="false"/>',
    "</style:master-page>",
    "</office:master-styles>"
  ].join(""), t = "<office:document-styles " + xp({
    "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
    "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
    "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
    "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
    "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
    "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
    "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
    "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
    "office:version": "1.2"
  }) + ">" + e + "</office:document-styles>";
  return function() {
    return Tr + t;
  };
}(), UO = /* @__PURE__ */ function() {
  var e = function(o) {
    return Nn(o).replace(/  +/g, function(i) {
      return '<text:s text:c="' + i.length + '"/>';
    }).replace(/\t/g, "<text:tab/>").replace(/\n/g, "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
  }, t = `          <table:table-cell />
`, n = `          <table:covered-table-cell/>
`, r = function(o, i, s) {
    var l = [];
    l.push('      <table:table table:name="' + Nn(i.SheetNames[s]) + `" table:style-name="ta1">
`);
    var u = 0, c = 0, f = hi(o["!ref"] || "A1"), d = o["!merges"] || [], p = 0, v = Array.isArray(o);
    if (o["!cols"])
      for (c = 0; c <= f.e.c; ++c) l.push("        <table:table-column" + (o["!cols"][c] ? ' table:style-name="co' + o["!cols"][c].ods + '"' : "") + `></table:table-column>
`);
    var h = "", m = o["!rows"] || [];
    for (u = 0; u < f.s.r; ++u)
      h = m[u] ? ' table:style-name="ro' + m[u].ods + '"' : "", l.push("        <table:table-row" + h + `></table:table-row>
`);
    for (; u <= f.e.r; ++u) {
      for (h = m[u] ? ' table:style-name="ro' + m[u].ods + '"' : "", l.push("        <table:table-row" + h + `>
`), c = 0; c < f.s.c; ++c) l.push(t);
      for (; c <= f.e.c; ++c) {
        var y = !1, x = {}, g = "";
        for (p = 0; p != d.length; ++p)
          if (!(d[p].s.c > c) && !(d[p].s.r > u) && !(d[p].e.c < c) && !(d[p].e.r < u)) {
            (d[p].s.c != c || d[p].s.r != u) && (y = !0), x["table:number-columns-spanned"] = d[p].e.c - d[p].s.c + 1, x["table:number-rows-spanned"] = d[p].e.r - d[p].s.r + 1;
            break;
          }
        if (y) {
          l.push(n);
          continue;
        }
        var S = Kt({ r: u, c }), w = v ? (o[u] || [])[c] : o[S];
        if (w && w.f && (x["table:formula"] = Nn(TSe(w.f)), w.F && w.F.slice(0, S.length) == S)) {
          var _ = hi(w.F);
          x["table:number-matrix-columns-spanned"] = _.e.c - _.s.c + 1, x["table:number-matrix-rows-spanned"] = _.e.r - _.s.r + 1;
        }
        if (!w) {
          l.push(t);
          continue;
        }
        switch (w.t) {
          case "b":
            g = w.v ? "TRUE" : "FALSE", x["office:value-type"] = "boolean", x["office:boolean-value"] = w.v ? "true" : "false";
            break;
          case "n":
            g = w.w || String(w.v || 0), x["office:value-type"] = "float", x["office:value"] = w.v || 0;
            break;
          case "s":
          case "str":
            g = w.v == null ? "" : w.v, x["office:value-type"] = "string";
            break;
          case "d":
            g = w.w || nr(w.v).toISOString(), x["office:value-type"] = "date", x["office:date-value"] = nr(w.v).toISOString(), x["table:style-name"] = "ce1";
            break;
          default:
            l.push(t);
            continue;
        }
        var b = e(g);
        if (w.l && w.l.Target) {
          var E = w.l.Target;
          E = E.charAt(0) == "#" ? "#" + $Se(E.slice(1)) : E, E.charAt(0) != "#" && !E.match(/^\w+:/) && (E = "../" + E), b = pt("text:a", b, { "xlink:href": E.replace(/&/g, "&amp;") });
        }
        l.push("          " + pt("table:table-cell", pt("text:p", b, {}), x) + `
`);
      }
      l.push(`        </table:table-row>
`);
    }
    return l.push(`      </table:table>
`), l.join("");
  }, a = function(o, i) {
    o.push(` <office:automatic-styles>
`), o.push(`  <number:date-style style:name="N37" number:automatic-order="true">
`), o.push(`   <number:month number:style="long"/>
`), o.push(`   <number:text>/</number:text>
`), o.push(`   <number:day number:style="long"/>
`), o.push(`   <number:text>/</number:text>
`), o.push(`   <number:year/>
`), o.push(`  </number:date-style>
`);
    var s = 0;
    i.SheetNames.map(function(u) {
      return i.Sheets[u];
    }).forEach(function(u) {
      if (u && u["!cols"]) {
        for (var c = 0; c < u["!cols"].length; ++c) if (u["!cols"][c]) {
          var f = u["!cols"][c];
          if (f.width == null && f.wpx == null && f.wch == null) continue;
          ou(f), f.ods = s;
          var d = u["!cols"][c].wpx + "px";
          o.push('  <style:style style:name="co' + s + `" style:family="table-column">
`), o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + d + `"/>
`), o.push(`  </style:style>
`), ++s;
        }
      }
    });
    var l = 0;
    i.SheetNames.map(function(u) {
      return i.Sheets[u];
    }).forEach(function(u) {
      if (u && u["!rows"]) {
        for (var c = 0; c < u["!rows"].length; ++c) if (u["!rows"][c]) {
          u["!rows"][c].ods = l;
          var f = u["!rows"][c].hpx + "px";
          o.push('  <style:style style:name="ro' + l + `" style:family="table-row">
`), o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + f + `"/>
`), o.push(`  </style:style>
`), ++l;
        }
      }
    }), o.push(`  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">
`), o.push(`   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>
`), o.push(`  </style:style>
`), o.push(`  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>
`), o.push(` </office:automatic-styles>
`);
  };
  return function(i, s) {
    var l = [Tr], u = xp({
      "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
      "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
      "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
      "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
      "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
      "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xmlns:dc": "http://purl.org/dc/elements/1.1/",
      "xmlns:meta": "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
      "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
      "xmlns:presentation": "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
      "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
      "xmlns:chart": "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
      "xmlns:dr3d": "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
      "xmlns:math": "http://www.w3.org/1998/Math/MathML",
      "xmlns:form": "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
      "xmlns:script": "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
      "xmlns:ooo": "http://openoffice.org/2004/office",
      "xmlns:ooow": "http://openoffice.org/2004/writer",
      "xmlns:oooc": "http://openoffice.org/2004/calc",
      "xmlns:dom": "http://www.w3.org/2001/xml-events",
      "xmlns:xforms": "http://www.w3.org/2002/xforms",
      "xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
      "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
      "xmlns:sheet": "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
      "xmlns:rpt": "http://openoffice.org/2005/report",
      "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
      "xmlns:xhtml": "http://www.w3.org/1999/xhtml",
      "xmlns:grddl": "http://www.w3.org/2003/g/data-view#",
      "xmlns:tableooo": "http://openoffice.org/2009/table",
      "xmlns:drawooo": "http://openoffice.org/2010/draw",
      "xmlns:calcext": "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
      "xmlns:loext": "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
      "xmlns:field": "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
      "xmlns:formx": "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
      "xmlns:css3t": "http://www.w3.org/TR/css3-text/",
      "office:version": "1.2"
    }), c = xp({
      "xmlns:config": "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
      "office:mimetype": "application/vnd.oasis.opendocument.spreadsheet"
    });
    s.bookType == "fods" ? (l.push("<office:document" + u + c + `>
`), l.push(PR().replace(/office:document-meta/g, "office:meta"))) : l.push("<office:document-content" + u + `>
`), a(l, i), l.push(`  <office:body>
`), l.push(`    <office:spreadsheet>
`);
    for (var f = 0; f != i.SheetNames.length; ++f) l.push(r(i.Sheets[i.SheetNames[f]], i, f));
    return l.push(`    </office:spreadsheet>
`), l.push(`  </office:body>
`), s.bookType == "fods" ? l.push("</office:document>") : l.push("</office:document-content>"), l.join("");
  };
}();
function HN(e, t) {
  if (t.bookType == "fods") return UO(e, t);
  var n = z4(), r = "", a = [], o = [];
  return r = "mimetype", en(n, r, "application/vnd.oasis.opendocument.spreadsheet"), r = "content.xml", en(n, r, UO(e, t)), a.push([r, "text/xml"]), o.push([r, "ContentFile"]), r = "styles.xml", en(n, r, oEe(e, t)), a.push([r, "text/xml"]), o.push([r, "StylesFile"]), r = "meta.xml", en(n, r, Tr + PR(
    /*::wb, opts*/
  )), a.push([r, "text/xml"]), o.push([r, "MetadataFile"]), r = "manifest.rdf", en(n, r, R1e(
    o
    /*, opts*/
  )), a.push([r, "application/rdf+xml"]), r = "META-INF/manifest.xml", en(n, r, k1e(
    a
    /*, opts*/
  )), n;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
function bc(e) {
  return new DataView(e.buffer, e.byteOffset, e.byteLength);
}
function XS(e) {
  return typeof TextDecoder < "u" ? new TextDecoder().decode(e) : Hn(vu(e));
}
function iEe(e) {
  return typeof TextEncoder < "u" ? new TextEncoder().encode(e) : Po(as(e));
}
function sEe(e, t) {
  e:
    for (var n = 0; n <= e.length - t.length; ++n) {
      for (var r = 0; r < t.length; ++r)
        if (e[n + r] != t[r])
          continue e;
      return !0;
    }
  return !1;
}
function su(e) {
  var t = e.reduce(function(a, o) {
    return a + o.length;
  }, 0), n = new Uint8Array(t), r = 0;
  return e.forEach(function(a) {
    n.set(a, r), r += a.length;
  }), n;
}
function zO(e) {
  return e -= e >> 1 & 1431655765, e = (e & 858993459) + (e >> 2 & 858993459), (e + (e >> 4) & 252645135) * 16843009 >>> 24;
}
function lEe(e, t) {
  for (var n = (e[t + 15] & 127) << 7 | e[t + 14] >> 1, r = e[t + 14] & 1, a = t + 13; a >= t; --a)
    r = r * 256 + e[a];
  return (e[t + 15] & 128 ? -r : r) * Math.pow(10, n - 6176);
}
function uEe(e, t, n) {
  var r = Math.floor(n == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(n))) + 6176 - 20, a = n / Math.pow(10, r - 6176);
  e[t + 15] |= r >> 7, e[t + 14] |= (r & 127) << 1;
  for (var o = 0; a >= 1; ++o, a /= 256)
    e[t + o] = a & 255;
  e[t + 15] |= n >= 0 ? 0 : 128;
}
function $p(e, t) {
  var n = t ? t[0] : 0, r = e[n] & 127;
  e:
    if (e[n++] >= 128 && (r |= (e[n] & 127) << 7, e[n++] < 128 || (r |= (e[n] & 127) << 14, e[n++] < 128) || (r |= (e[n] & 127) << 21, e[n++] < 128) || (r += (e[n] & 127) * Math.pow(2, 28), ++n, e[n++] < 128) || (r += (e[n] & 127) * Math.pow(2, 35), ++n, e[n++] < 128) || (r += (e[n] & 127) * Math.pow(2, 42), ++n, e[n++] < 128)))
      break e;
  return t && (t[0] = n), r;
}
function Mn(e) {
  var t = new Uint8Array(7);
  t[0] = e & 127;
  var n = 1;
  e:
    if (e > 127) {
      if (t[n - 1] |= 128, t[n] = e >> 7 & 127, ++n, e <= 16383 || (t[n - 1] |= 128, t[n] = e >> 14 & 127, ++n, e <= 2097151) || (t[n - 1] |= 128, t[n] = e >> 21 & 127, ++n, e <= 268435455) || (t[n - 1] |= 128, t[n] = e / 256 >>> 21 & 127, ++n, e <= 34359738367) || (t[n - 1] |= 128, t[n] = e / 65536 >>> 21 & 127, ++n, e <= 4398046511103))
        break e;
      t[n - 1] |= 128, t[n] = e / 16777216 >>> 21 & 127, ++n;
    }
  return t.slice(0, n);
}
function yr(e) {
  var t = 0, n = e[t] & 127;
  e:
    if (e[t++] >= 128) {
      if (n |= (e[t] & 127) << 7, e[t++] < 128 || (n |= (e[t] & 127) << 14, e[t++] < 128) || (n |= (e[t] & 127) << 21, e[t++] < 128))
        break e;
      n |= (e[t] & 127) << 28;
    }
  return n;
}
function $n(e) {
  for (var t = [], n = [0]; n[0] < e.length; ) {
    var r = n[0], a = $p(e, n), o = a & 7;
    a = Math.floor(a / 8);
    var i = 0, s;
    if (a == 0)
      break;
    switch (o) {
      case 0:
        {
          for (var l = n[0]; e[n[0]++] >= 128; )
            ;
          s = e.slice(l, n[0]);
        }
        break;
      case 5:
        i = 4, s = e.slice(n[0], n[0] + i), n[0] += i;
        break;
      case 1:
        i = 8, s = e.slice(n[0], n[0] + i), n[0] += i;
        break;
      case 2:
        i = $p(e, n), s = e.slice(n[0], n[0] + i), n[0] += i;
        break;
      case 3:
      case 4:
      default:
        throw new Error("PB Type ".concat(o, " for Field ").concat(a, " at offset ").concat(r));
    }
    var u = { data: s, type: o };
    t[a] == null ? t[a] = [u] : t[a].push(u);
  }
  return t;
}
function Zr(e) {
  var t = [];
  return e.forEach(function(n, r) {
    n.forEach(function(a) {
      a.data && (t.push(Mn(r * 8 + a.type)), a.type == 2 && t.push(Mn(a.data.length)), t.push(a.data));
    });
  }), su(t);
}
function vE(e, t) {
  return (e == null ? void 0 : e.map(function(n) {
    return t(n.data);
  })) || [];
}
function Xo(e) {
  for (var t, n = [], r = [0]; r[0] < e.length; ) {
    var a = $p(e, r), o = $n(e.slice(r[0], r[0] + a));
    r[0] += a;
    var i = {
      id: yr(o[1][0].data),
      messages: []
    };
    o[2].forEach(function(s) {
      var l = $n(s.data), u = yr(l[3][0].data);
      i.messages.push({
        meta: l,
        data: e.slice(r[0], r[0] + u)
      }), r[0] += u;
    }), (t = o[3]) != null && t[0] && (i.merge = yr(o[3][0].data) >>> 0 > 0), n.push(i);
  }
  return n;
}
function tf(e) {
  var t = [];
  return e.forEach(function(n) {
    var r = [];
    r[1] = [{ data: Mn(n.id), type: 0 }], r[2] = [], n.merge != null && (r[3] = [{ data: Mn(+!!n.merge), type: 0 }]);
    var a = [];
    n.messages.forEach(function(i) {
      a.push(i.data), i.meta[3] = [{ type: 0, data: Mn(i.data.length) }], r[2].push({ data: Zr(i.meta), type: 2 });
    });
    var o = Zr(r);
    t.push(Mn(o.length)), t.push(o), a.forEach(function(i) {
      return t.push(i);
    });
  }), su(t);
}
function cEe(e, t) {
  if (e != 0)
    throw new Error("Unexpected Snappy chunk type ".concat(e));
  for (var n = [0], r = $p(t, n), a = []; n[0] < t.length; ) {
    var o = t[n[0]] & 3;
    if (o == 0) {
      var i = t[n[0]++] >> 2;
      if (i < 60)
        ++i;
      else {
        var s = i - 59;
        i = t[n[0]], s > 1 && (i |= t[n[0] + 1] << 8), s > 2 && (i |= t[n[0] + 2] << 16), s > 3 && (i |= t[n[0] + 3] << 24), i >>>= 0, i++, n[0] += s;
      }
      a.push(t.slice(n[0], n[0] + i)), n[0] += i;
      continue;
    } else {
      var l = 0, u = 0;
      if (o == 1 ? (u = (t[n[0]] >> 2 & 7) + 4, l = (t[n[0]++] & 224) << 3, l |= t[n[0]++]) : (u = (t[n[0]++] >> 2) + 1, o == 2 ? (l = t[n[0]] | t[n[0] + 1] << 8, n[0] += 2) : (l = (t[n[0]] | t[n[0] + 1] << 8 | t[n[0] + 2] << 16 | t[n[0] + 3] << 24) >>> 0, n[0] += 4)), a = [su(a)], l == 0)
        throw new Error("Invalid offset 0");
      if (l > a[0].length)
        throw new Error("Invalid offset beyond length");
      if (u >= l)
        for (a.push(a[0].slice(-l)), u -= l; u >= a[a.length - 1].length; )
          a.push(a[a.length - 1]), u -= a[a.length - 1].length;
      a.push(a[0].slice(-l, -l + u));
    }
  }
  var c = su(a);
  if (c.length != r)
    throw new Error("Unexpected length: ".concat(c.length, " != ").concat(r));
  return c;
}
function Zo(e) {
  for (var t = [], n = 0; n < e.length; ) {
    var r = e[n++], a = e[n] | e[n + 1] << 8 | e[n + 2] << 16;
    n += 3, t.push(cEe(r, e.slice(n, n + a))), n += a;
  }
  if (n !== e.length)
    throw new Error("data is not a valid framed stream!");
  return su(t);
}
function nf(e) {
  for (var t = [], n = 0; n < e.length; ) {
    var r = Math.min(e.length - n, 268435455), a = new Uint8Array(4);
    t.push(a);
    var o = Mn(r), i = o.length;
    t.push(o), r <= 60 ? (i++, t.push(new Uint8Array([r - 1 << 2]))) : r <= 256 ? (i += 2, t.push(new Uint8Array([240, r - 1 & 255]))) : r <= 65536 ? (i += 3, t.push(new Uint8Array([244, r - 1 & 255, r - 1 >> 8 & 255]))) : r <= 16777216 ? (i += 4, t.push(new Uint8Array([248, r - 1 & 255, r - 1 >> 8 & 255, r - 1 >> 16 & 255]))) : r <= 4294967296 && (i += 5, t.push(new Uint8Array([252, r - 1 & 255, r - 1 >> 8 & 255, r - 1 >> 16 & 255, r - 1 >>> 24 & 255]))), t.push(e.slice(n, n + r)), i += r, a[0] = 0, a[1] = i & 255, a[2] = i >> 8 & 255, a[3] = i >> 16 & 255, n += r;
  }
  return su(t);
}
function fEe(e, t, n, r) {
  var a = bc(e), o = a.getUint32(4, !0), i = (r > 1 ? 12 : 8) + zO(o & (r > 1 ? 3470 : 398)) * 4, s = -1, l = -1, u = NaN, c = new Date(2001, 0, 1);
  o & 512 && (s = a.getUint32(i, !0), i += 4), i += zO(o & (r > 1 ? 12288 : 4096)) * 4, o & 16 && (l = a.getUint32(i, !0), i += 4), o & 32 && (u = a.getFloat64(i, !0), i += 8), o & 64 && (c.setTime(c.getTime() + a.getFloat64(i, !0) * 1e3), i += 8);
  var f;
  switch (e[2]) {
    case 0:
      break;
    case 2:
      f = { t: "n", v: u };
      break;
    case 3:
      f = { t: "s", v: t[l] };
      break;
    case 5:
      f = { t: "d", v: c };
      break;
    case 6:
      f = { t: "b", v: u > 0 };
      break;
    case 7:
      f = { t: "n", v: u / 86400 };
      break;
    case 8:
      f = { t: "e", v: 0 };
      break;
    case 9:
      if (s > -1)
        f = { t: "s", v: n[s] };
      else if (l > -1)
        f = { t: "s", v: t[l] };
      else if (!isNaN(u))
        f = { t: "n", v: u };
      else
        throw new Error("Unsupported cell type ".concat(e.slice(0, 4)));
      break;
    default:
      throw new Error("Unsupported cell type ".concat(e.slice(0, 4)));
  }
  return f;
}
function dEe(e, t, n) {
  var r = bc(e), a = r.getUint32(8, !0), o = 12, i = -1, s = -1, l = NaN, u = NaN, c = new Date(2001, 0, 1);
  a & 1 && (l = lEe(e, o), o += 16), a & 2 && (u = r.getFloat64(o, !0), o += 8), a & 4 && (c.setTime(c.getTime() + r.getFloat64(o, !0) * 1e3), o += 8), a & 8 && (s = r.getUint32(o, !0), o += 4), a & 16 && (i = r.getUint32(o, !0), o += 4);
  var f;
  switch (e[1]) {
    case 0:
      break;
    case 2:
      f = { t: "n", v: l };
      break;
    case 3:
      f = { t: "s", v: t[s] };
      break;
    case 5:
      f = { t: "d", v: c };
      break;
    case 6:
      f = { t: "b", v: u > 0 };
      break;
    case 7:
      f = { t: "n", v: u / 86400 };
      break;
    case 8:
      f = { t: "e", v: 0 };
      break;
    case 9:
      if (i > -1)
        f = { t: "s", v: n[i] };
      else
        throw new Error("Unsupported cell type ".concat(e[1], " : ").concat(a & 31, " : ").concat(e.slice(0, 4)));
      break;
    case 10:
      f = { t: "n", v: l };
      break;
    default:
      throw new Error("Unsupported cell type ".concat(e[1], " : ").concat(a & 31, " : ").concat(e.slice(0, 4)));
  }
  return f;
}
function Lx(e, t) {
  var n = new Uint8Array(32), r = bc(n), a = 12, o = 0;
  switch (n[0] = 5, e.t) {
    case "n":
      n[1] = 2, uEe(n, a, e.v), o |= 1, a += 16;
      break;
    case "b":
      n[1] = 6, r.setFloat64(a, e.v ? 1 : 0, !0), o |= 2, a += 8;
      break;
    case "s":
      if (t.indexOf(e.v) == -1)
        throw new Error("Value ".concat(e.v, " missing from SST!"));
      n[1] = 3, r.setUint32(a, t.indexOf(e.v), !0), o |= 8, a += 4;
      break;
    default:
      throw "unsupported cell type " + e.t;
  }
  return r.setUint32(8, o, !0), n.slice(0, a);
}
function Bx(e, t) {
  var n = new Uint8Array(32), r = bc(n), a = 12, o = 0;
  switch (n[0] = 3, e.t) {
    case "n":
      n[2] = 2, r.setFloat64(a, e.v, !0), o |= 32, a += 8;
      break;
    case "b":
      n[2] = 6, r.setFloat64(a, e.v ? 1 : 0, !0), o |= 32, a += 8;
      break;
    case "s":
      if (t.indexOf(e.v) == -1)
        throw new Error("Value ".concat(e.v, " missing from SST!"));
      n[2] = 3, r.setUint32(a, t.indexOf(e.v), !0), o |= 16, a += 4;
      break;
    default:
      throw "unsupported cell type " + e.t;
  }
  return r.setUint32(4, o, !0), n.slice(0, a);
}
function pEe(e, t, n) {
  switch (e[0]) {
    case 0:
    case 1:
    case 2:
    case 3:
      return fEe(e, t, n, e[0]);
    case 5:
      return dEe(e, t, n);
    default:
      throw new Error("Unsupported payload version ".concat(e[0]));
  }
}
function ba(e) {
  var t = $n(e);
  return $p(t[1][0].data);
}
function WO(e, t) {
  var n = $n(t.data), r = yr(n[1][0].data), a = n[3], o = [];
  return (a || []).forEach(function(i) {
    var s = $n(i.data), l = yr(s[1][0].data) >>> 0;
    switch (r) {
      case 1:
        o[l] = XS(s[3][0].data);
        break;
      case 8:
        {
          var u = e[ba(s[9][0].data)][0], c = $n(u.data), f = e[ba(c[1][0].data)][0], d = yr(f.meta[1][0].data);
          if (d != 2001)
            throw new Error("2000 unexpected reference to ".concat(d));
          var p = $n(f.data);
          o[l] = p[3].map(function(v) {
            return XS(v.data);
          }).join("");
        }
        break;
    }
  }), o;
}
function hEe(e, t) {
  var n, r, a, o, i, s, l, u, c, f, d, p, v, h, m = $n(e), y = yr(m[1][0].data) >>> 0, x = yr(m[2][0].data) >>> 0, g = ((r = (n = m[8]) == null ? void 0 : n[0]) == null ? void 0 : r.data) && yr(m[8][0].data) > 0 || !1, S, w;
  if ((o = (a = m[7]) == null ? void 0 : a[0]) != null && o.data && t != 0)
    S = (s = (i = m[7]) == null ? void 0 : i[0]) == null ? void 0 : s.data, w = (u = (l = m[6]) == null ? void 0 : l[0]) == null ? void 0 : u.data;
  else if ((f = (c = m[4]) == null ? void 0 : c[0]) != null && f.data && t != 1)
    S = (p = (d = m[4]) == null ? void 0 : d[0]) == null ? void 0 : p.data, w = (h = (v = m[3]) == null ? void 0 : v[0]) == null ? void 0 : h.data;
  else
    throw "NUMBERS Tile missing ".concat(t, " cell storage");
  for (var _ = g ? 4 : 1, b = bc(S), E = [], C = 0; C < S.length / 2; ++C) {
    var T = b.getUint16(C * 2, !0);
    T < 65535 && E.push([C, T]);
  }
  if (E.length != x)
    throw "Expected ".concat(x, " cells, found ").concat(E.length);
  var O = [];
  for (C = 0; C < E.length - 1; ++C)
    O[E[C][0]] = w.subarray(E[C][1] * _, E[C + 1][1] * _);
  return E.length >= 1 && (O[E[E.length - 1][0]] = w.subarray(E[E.length - 1][1] * _)), { R: y, cells: O };
}
function vEe(e, t) {
  var n, r = $n(t.data), a = (n = r == null ? void 0 : r[7]) != null && n[0] ? yr(r[7][0].data) >>> 0 > 0 ? 1 : 0 : -1, o = vE(r[5], function(i) {
    return hEe(i, a);
  });
  return {
    nrows: yr(r[4][0].data) >>> 0,
    data: o.reduce(function(i, s) {
      return i[s.R] || (i[s.R] = []), s.cells.forEach(function(l, u) {
        if (i[s.R][u])
          throw new Error("Duplicate cell r=".concat(s.R, " c=").concat(u));
        i[s.R][u] = l;
      }), i;
    }, [])
  };
}
function mEe(e, t, n) {
  var r, a = $n(t.data), o = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
  if (o.e.r = (yr(a[6][0].data) >>> 0) - 1, o.e.r < 0)
    throw new Error("Invalid row varint ".concat(a[6][0].data));
  if (o.e.c = (yr(a[7][0].data) >>> 0) - 1, o.e.c < 0)
    throw new Error("Invalid col varint ".concat(a[7][0].data));
  n["!ref"] = vn(o);
  var i = $n(a[4][0].data), s = WO(e, e[ba(i[4][0].data)][0]), l = (r = i[17]) != null && r[0] ? WO(e, e[ba(i[17][0].data)][0]) : [], u = $n(i[3][0].data), c = 0;
  u[1].forEach(function(f) {
    var d = $n(f.data), p = e[ba(d[2][0].data)][0], v = yr(p.meta[1][0].data);
    if (v != 6002)
      throw new Error("6001 unexpected reference to ".concat(v));
    var h = vEe(e, p);
    h.data.forEach(function(m, y) {
      m.forEach(function(x, g) {
        var S = Kt({ r: c + y, c: g }), w = pEe(x, s, l);
        w && (n[S] = w);
      });
    }), c += h.nrows;
  });
}
function gEe(e, t) {
  var n = $n(t.data), r = { "!ref": "A1" }, a = e[ba(n[2][0].data)], o = yr(a[0].meta[1][0].data);
  if (o != 6001)
    throw new Error("6000 unexpected reference to ".concat(o));
  return mEe(e, a[0], r), r;
}
function yEe(e, t) {
  var n, r = $n(t.data), a = {
    name: (n = r[1]) != null && n[0] ? XS(r[1][0].data) : "",
    sheets: []
  }, o = vE(r[2], ba);
  return o.forEach(function(i) {
    e[i].forEach(function(s) {
      var l = yr(s.meta[1][0].data);
      l == 6e3 && a.sheets.push(gEe(e, s));
    });
  }), a;
}
function xEe(e, t) {
  var n = KN(), r = $n(t.data), a = vE(r[1], ba);
  if (a.forEach(function(o) {
    e[o].forEach(function(i) {
      var s = yr(i.meta[1][0].data);
      if (s == 2) {
        var l = yEe(e, i);
        l.sheets.forEach(function(u, c) {
          YN(n, u, c == 0 ? l.name : l.name + "_" + c, !0);
        });
      }
    });
  }), n.SheetNames.length == 0)
    throw new Error("Empty NUMBERS file");
  return n;
}
function Hx(e) {
  var t, n, r, a, o = {}, i = [];
  if (e.FullPaths.forEach(function(l) {
    if (l.match(/\.iwpv2/))
      throw new Error("Unsupported password protection");
  }), e.FileIndex.forEach(function(l) {
    if (l.name.match(/\.iwa$/)) {
      var u;
      try {
        u = Zo(l.content);
      } catch (f) {
        return console.log("?? " + l.content.length + " " + (f.message || f));
      }
      var c;
      try {
        c = Xo(u);
      } catch (f) {
        return console.log("## " + (f.message || f));
      }
      c.forEach(function(f) {
        o[f.id] = f.messages, i.push(f.id);
      });
    }
  }), !i.length)
    throw new Error("File has no messages");
  var s = ((a = (r = (n = (t = o == null ? void 0 : o[1]) == null ? void 0 : t[0]) == null ? void 0 : n.meta) == null ? void 0 : r[1]) == null ? void 0 : a[0].data) && yr(o[1][0].meta[1][0].data) == 1 && o[1][0];
  if (s || i.forEach(function(l) {
    o[l].forEach(function(u) {
      var c = yr(u.meta[1][0].data) >>> 0;
      if (c == 1)
        if (!s)
          s = u;
        else
          throw new Error("Document has multiple roots");
    });
  }), !s)
    throw new Error("Cannot find Document root");
  return xEe(o, s);
}
function bEe(e, t, n) {
  var r, a, o, i;
  if (!((r = e[6]) != null && r[0]) || !((a = e[7]) != null && a[0]))
    throw "Mutation only works on post-BNC storages!";
  var s = ((i = (o = e[8]) == null ? void 0 : o[0]) == null ? void 0 : i.data) && yr(e[8][0].data) > 0 || !1;
  if (s)
    throw "Math only works with normal offsets";
  for (var l = 0, u = bc(e[7][0].data), c = 0, f = [], d = bc(e[4][0].data), p = 0, v = [], h = 0; h < t.length; ++h) {
    if (t[h] == null) {
      u.setUint16(h * 2, 65535, !0), d.setUint16(h * 2, 65535);
      continue;
    }
    u.setUint16(h * 2, c, !0), d.setUint16(h * 2, p, !0);
    var m, y;
    switch (typeof t[h]) {
      case "string":
        m = Lx({ t: "s", v: t[h] }, n), y = Bx({ t: "s", v: t[h] }, n);
        break;
      case "number":
        m = Lx({ t: "n", v: t[h] }, n), y = Bx({ t: "n", v: t[h] }, n);
        break;
      case "boolean":
        m = Lx({ t: "b", v: t[h] }, n), y = Bx({ t: "b", v: t[h] }, n);
        break;
      default:
        throw new Error("Unsupported value " + t[h]);
    }
    f.push(m), c += m.length, v.push(y), p += y.length, ++l;
  }
  for (e[2][0].data = Mn(l); h < e[7][0].data.length / 2; ++h)
    u.setUint16(h * 2, 65535, !0), d.setUint16(h * 2, 65535, !0);
  return e[6][0].data = su(f), e[3][0].data = su(v), l;
}
function wEe(e, t) {
  if (!t || !t.numbers)
    throw new Error("Must pass a `numbers` option -- check the README");
  var n = e.Sheets[e.SheetNames[0]];
  e.SheetNames.length > 1 && console.error("The Numbers writer currently writes only the first table");
  var r = hi(n["!ref"]);
  r.s.r = r.s.c = 0;
  var a = !1;
  r.e.c > 9 && (a = !0, r.e.c = 9), r.e.r > 49 && (a = !0, r.e.r = 49), a && console.error("The Numbers writer is currently limited to ".concat(vn(r)));
  var o = WN(n, { range: r, header: 1 }), i = ["~Sh33tJ5~"];
  o.forEach(function(Y) {
    return Y.forEach(function(X) {
      typeof X == "string" && i.push(X);
    });
  });
  var s = {}, l = [], u = Dt.read(t.numbers, { type: "base64" });
  u.FileIndex.map(function(Y, X) {
    return [Y, u.FullPaths[X]];
  }).forEach(function(Y) {
    var X = Y[0], q = Y[1];
    if (X.type == 2 && X.name.match(/\.iwa/)) {
      var Q = X.content, ue = Zo(Q), le = Xo(ue);
      le.forEach(function(te) {
        l.push(te.id), s[te.id] = { deps: [], location: q, type: yr(te.messages[0].meta[1][0].data) };
      });
    }
  }), l.sort(function(Y, X) {
    return Y - X;
  });
  var c = l.filter(function(Y) {
    return Y > 1;
  }).map(function(Y) {
    return [Y, Mn(Y)];
  });
  u.FileIndex.map(function(Y, X) {
    return [Y, u.FullPaths[X]];
  }).forEach(function(Y) {
    var X = Y[0];
    if (Y[1], !!X.name.match(/\.iwa/)) {
      var q = Xo(Zo(X.content));
      q.forEach(function(Q) {
        Q.messages.forEach(function(ue) {
          c.forEach(function(le) {
            Q.messages.some(function(te) {
              return yr(te.meta[1][0].data) != 11006 && sEe(te.data, le[1]);
            }) && s[le[0]].deps.push(Q.id);
          });
        });
      });
    }
  });
  for (var f = Dt.find(u, s[1].location), d = Xo(Zo(f.content)), p, v = 0; v < d.length; ++v) {
    var h = d[v];
    h.id == 1 && (p = h);
  }
  var m = ba($n(p.messages[0].data)[1][0].data);
  for (f = Dt.find(u, s[m].location), d = Xo(Zo(f.content)), v = 0; v < d.length; ++v)
    h = d[v], h.id == m && (p = h);
  for (m = ba($n(p.messages[0].data)[2][0].data), f = Dt.find(u, s[m].location), d = Xo(Zo(f.content)), v = 0; v < d.length; ++v)
    h = d[v], h.id == m && (p = h);
  for (m = ba($n(p.messages[0].data)[2][0].data), f = Dt.find(u, s[m].location), d = Xo(Zo(f.content)), v = 0; v < d.length; ++v)
    h = d[v], h.id == m && (p = h);
  var y = $n(p.messages[0].data);
  {
    y[6][0].data = Mn(r.e.r + 1), y[7][0].data = Mn(r.e.c + 1);
    var x = ba(y[46][0].data), g = Dt.find(u, s[x].location), S = Xo(Zo(g.content));
    {
      for (var w = 0; w < S.length && S[w].id != x; ++w)
        ;
      if (S[w].id != x)
        throw "Bad ColumnRowUIDMapArchive";
      var _ = $n(S[w].messages[0].data);
      _[1] = [], _[2] = [], _[3] = [];
      for (var b = 0; b <= r.e.c; ++b) {
        var E = [];
        E[1] = E[2] = [{ type: 0, data: Mn(b + 420690) }], _[1].push({ type: 2, data: Zr(E) }), _[2].push({ type: 0, data: Mn(b) }), _[3].push({ type: 0, data: Mn(b) });
      }
      _[4] = [], _[5] = [], _[6] = [];
      for (var C = 0; C <= r.e.r; ++C)
        E = [], E[1] = E[2] = [{ type: 0, data: Mn(C + 726270) }], _[4].push({ type: 2, data: Zr(E) }), _[5].push({ type: 0, data: Mn(C) }), _[6].push({ type: 0, data: Mn(C) });
      S[w].messages[0].data = Zr(_);
    }
    g.content = nf(tf(S)), g.size = g.content.length, delete y[46];
    var T = $n(y[4][0].data);
    {
      T[7][0].data = Mn(r.e.r + 1);
      var O = $n(T[1][0].data), I = ba(O[2][0].data);
      g = Dt.find(u, s[I].location), S = Xo(Zo(g.content));
      {
        if (S[0].id != I)
          throw "Bad HeaderStorageBucket";
        var k = $n(S[0].messages[0].data);
        for (C = 0; C < o.length; ++C) {
          var B = $n(k[2][0].data);
          B[1][0].data = Mn(C), B[4][0].data = Mn(o[C].length), k[2][C] = { type: k[2][0].type, data: Zr(B) };
        }
        S[0].messages[0].data = Zr(k);
      }
      g.content = nf(tf(S)), g.size = g.content.length;
      var P = ba(T[2][0].data);
      g = Dt.find(u, s[P].location), S = Xo(Zo(g.content));
      {
        if (S[0].id != P)
          throw "Bad HeaderStorageBucket";
        for (k = $n(S[0].messages[0].data), b = 0; b <= r.e.c; ++b)
          B = $n(k[2][0].data), B[1][0].data = Mn(b), B[4][0].data = Mn(r.e.r + 1), k[2][b] = { type: k[2][0].type, data: Zr(B) };
        S[0].messages[0].data = Zr(k);
      }
      g.content = nf(tf(S)), g.size = g.content.length;
      var N = ba(T[4][0].data);
      (function() {
        for (var Y = Dt.find(u, s[N].location), X = Xo(Zo(Y.content)), q, Q = 0; Q < X.length; ++Q) {
          var ue = X[Q];
          ue.id == N && (q = ue);
        }
        var le = $n(q.messages[0].data);
        {
          le[3] = [];
          var te = [];
          i.forEach(function(L, re) {
            te[1] = [{ type: 0, data: Mn(re) }], te[2] = [{ type: 0, data: Mn(1) }], te[3] = [{ type: 2, data: iEe(L) }], le[3].push({ type: 2, data: Zr(te) });
          });
        }
        q.messages[0].data = Zr(le);
        var G = tf(X), oe = nf(G);
        Y.content = oe, Y.size = Y.content.length;
      })();
      var M = $n(T[3][0].data);
      {
        var H = M[1][0];
        delete M[2];
        var R = $n(H.data);
        {
          var z = ba(R[2][0].data);
          (function() {
            for (var Y = Dt.find(u, s[z].location), X = Xo(Zo(Y.content)), q, Q = 0; Q < X.length; ++Q) {
              var ue = X[Q];
              ue.id == z && (q = ue);
            }
            var le = $n(q.messages[0].data);
            {
              delete le[6], delete M[7];
              var te = new Uint8Array(le[5][0].data);
              le[5] = [];
              for (var G = 0, oe = 0; oe <= r.e.r; ++oe) {
                var L = $n(te);
                G += bEe(L, o[oe], i), L[1][0].data = Mn(oe), le[5].push({ data: Zr(L), type: 2 });
              }
              le[1] = [{ type: 0, data: Mn(r.e.c + 1) }], le[2] = [{ type: 0, data: Mn(r.e.r + 1) }], le[3] = [{ type: 0, data: Mn(G) }], le[4] = [{ type: 0, data: Mn(r.e.r + 1) }];
            }
            q.messages[0].data = Zr(le);
            var re = tf(X), j = nf(re);
            Y.content = j, Y.size = Y.content.length;
          })();
        }
        H.data = Zr(R);
      }
      T[3][0].data = Zr(M);
    }
    y[4][0].data = Zr(T);
  }
  p.messages[0].data = Zr(y);
  var W = tf(d), F = nf(W);
  return f.content = F, f.size = f.content.length, u;
}
function jN(e) {
  return function(n) {
    for (var r = 0; r != e.length; ++r) {
      var a = e[r];
      n[a[0]] === void 0 && (n[a[0]] = a[1]), a[2] === "n" && (n[a[0]] = Number(n[a[0]]));
    }
  };
}
function mE(e) {
  jN([
    ["cellNF", !1],
    /* emit cell number format string as .z */
    ["cellHTML", !0],
    /* emit html string as .h */
    ["cellFormula", !0],
    /* emit formulae as .f */
    ["cellStyles", !1],
    /* emits style/theme as .s */
    ["cellText", !0],
    /* emit formatted text as .w */
    ["cellDates", !1],
    /* emit date cells with type `d` */
    ["sheetStubs", !1],
    /* emit empty cells */
    ["sheetRows", 0, "n"],
    /* read n rows (0 = read all rows) */
    ["bookDeps", !1],
    /* parse calculation chains */
    ["bookSheets", !1],
    /* only try to get sheet names (no Sheets) */
    ["bookProps", !1],
    /* only try to get properties (no Sheets) */
    ["bookFiles", !1],
    /* include raw file structure (keys, files, cfb) */
    ["bookVBA", !1],
    /* include vba raw data (vbaraw) */
    ["password", ""],
    /* password */
    ["WTF", !1]
    /* WTF mode (throws errors) */
  ])(e);
}
function gE(e) {
  jN([
    ["cellDates", !1],
    /* write date cells with type `d` */
    ["bookSST", !1],
    /* Generate Shared String Table */
    ["bookType", "xlsx"],
    /* Type of workbook (xlsx/m/b) */
    ["compression", !1],
    /* Use file compression */
    ["WTF", !1]
    /* WTF mode (throws errors) */
  ])(e);
}
function SEe(e) {
  return cn.WS.indexOf(e) > -1 ? "sheet" : e == cn.CS ? "chart" : e == cn.DS ? "dialog" : e == cn.MS ? "macro" : e && e.length ? e : "sheet";
}
function _Ee(e, t) {
  if (!e) return 0;
  try {
    e = t.map(function(r) {
      return r.id || (r.id = r.strRelID), [r.name, e["!id"][r.id].Target, SEe(e["!id"][r.id].Type)];
    });
  } catch {
    return null;
  }
  return !e || e.length === 0 ? null : e;
}
function CEe(e, t, n, r, a, o, i, s, l, u, c, f) {
  try {
    o[r] = F0(Do(e, n, !0), t);
    var d = Pr(e, t), p;
    switch (s) {
      case "sheet":
        p = KCe(d, t, a, l, o[r], u, c, f);
        break;
      case "chart":
        if (p = YCe(d, t, a, l, o[r], u, c, f), !p || !p["!drawel"]) break;
        var v = c0(p["!drawel"].Target, t), h = wp(v), m = M2e(Do(e, v, !0), F0(Do(e, h, !0), v)), y = c0(m, v), x = wp(y);
        p = wCe(Do(e, y, !0), y, l, F0(Do(e, x, !0), y), u, p);
        break;
      case "macro":
        p = qCe(d, t, a, l, o[r], u, c, f);
        break;
      case "dialog":
        p = XCe(d, t, a, l, o[r], u, c, f);
        break;
      default:
        throw new Error("Unrecognized sheet type " + s);
    }
    i[r] = p;
    var g = [];
    o && o[r] && Er(o[r]).forEach(function(S) {
      var w = "";
      if (o[r][S].Type == cn.CMNT) {
        w = c0(o[r][S].Target, t);
        var _ = e4e(Pr(e, w, !0), w, l);
        if (!_ || !_.length) return;
        PO(p, _, !1);
      }
      o[r][S].Type == cn.TCMNT && (w = c0(o[r][S].Target, t), g = g.concat(N2e(Pr(e, w, !0), l)));
    }), g && g.length && PO(p, g, !0, l.people || []);
  } catch (S) {
    if (l.WTF) throw S;
  }
}
function Yo(e) {
  return e.charAt(0) == "/" ? e.slice(1) : e;
}
function EEe(e, t) {
  if (Id(), t = t || {}, mE(t), ei(e, "META-INF/manifest.xml") || ei(e, "objectdata.xml")) return jO(e, t);
  if (ei(e, "Index/Document.iwa")) {
    if (typeof Uint8Array > "u") throw new Error("NUMBERS file parsing requires Uint8Array support");
    if (typeof Hx < "u") {
      if (e.FileIndex) return Hx(e);
      var n = Dt.utils.cfb_new();
      return Q6(e).forEach(function(B) {
        en(n, B, Nge(e, B));
      }), Hx(n);
    }
    throw new Error("Unsupported NUMBERS file");
  }
  if (!ei(e, "[Content_Types].xml"))
    throw ei(e, "index.xml.gz") ? new Error("Unsupported NUMBERS 08 file") : ei(e, "index.xml") ? new Error("Unsupported NUMBERS 09 file") : new Error("Unsupported ZIP file");
  var r = Q6(e), a = I1e(Do(e, "[Content_Types].xml")), o = !1, i, s;
  if (a.workbooks.length === 0 && (s = "xl/workbook.xml", Pr(e, s, !0) && a.workbooks.push(s)), a.workbooks.length === 0) {
    if (s = "xl/workbook.bin", !Pr(e, s, !0)) throw new Error("Could not find workbook");
    a.workbooks.push(s), o = !0;
  }
  a.workbooks[0].slice(-3) == "bin" && (o = !0);
  var l = {}, u = {};
  if (!t.bookSheets && !t.bookProps) {
    if (L0 = [], a.sst) try {
      L0 = JCe(Pr(e, Yo(a.sst)), a.sst, t);
    } catch (B) {
      if (t.WTF) throw B;
    }
    t.cellStyles && a.themes.length && (l = QCe(Do(e, a.themes[0].replace(/^\//, ""), !0) || "", a.themes[0], t)), a.style && (u = ZCe(Pr(e, Yo(a.style)), a.style, l, t));
  }
  a.links.map(function(B) {
    try {
      var P = F0(Do(e, wp(Yo(B))), B);
      return n4e(Pr(e, Yo(B)), P, B, t);
    } catch {
    }
  });
  var c = GCe(Pr(e, Yo(a.workbooks[0])), a.workbooks[0], t), f = {}, d = "";
  a.coreprops.length && (d = Pr(e, Yo(a.coreprops[0]), !0), d && (f = DR(d)), a.extprops.length !== 0 && (d = Pr(e, Yo(a.extprops[0]), !0), d && F1e(d, f, t)));
  var p = {};
  (!t.bookSheets || t.bookProps) && a.custprops.length !== 0 && (d = Do(e, Yo(a.custprops[0]), !0), d && (p = B1e(d, t)));
  var v = {};
  if ((t.bookSheets || t.bookProps) && (c.Sheets ? i = c.Sheets.map(function(P) {
    return P.name;
  }) : f.Worksheets && f.SheetNames.length > 0 && (i = f.SheetNames), t.bookProps && (v.Props = f, v.Custprops = p), t.bookSheets && typeof i < "u" && (v.SheetNames = i), t.bookSheets ? v.SheetNames : t.bookProps))
    return v;
  i = {};
  var h = {};
  t.bookDeps && a.calcchain && (h = t4e(Pr(e, Yo(a.calcchain)), a.calcchain));
  var m = 0, y = {}, x, g;
  {
    var S = c.Sheets;
    f.Worksheets = S.length, f.SheetNames = [];
    for (var w = 0; w != S.length; ++w)
      f.SheetNames[w] = S[w].name;
  }
  var _ = o ? "bin" : "xml", b = a.workbooks[0].lastIndexOf("/"), E = (a.workbooks[0].slice(0, b + 1) + "_rels/" + a.workbooks[0].slice(b + 1) + ".rels").replace(/^\//, "");
  ei(e, E) || (E = "xl/_rels/workbook." + _ + ".rels");
  var C = F0(Do(e, E, !0), E.replace(/_rels.*/, "s5s"));
  (a.metadata || []).length >= 1 && (t.xlmeta = r4e(Pr(e, Yo(a.metadata[0])), a.metadata[0], t)), (a.people || []).length >= 1 && (t.people = L2e(Pr(e, Yo(a.people[0])), t)), C && (C = _Ee(C, c.Sheets));
  var T = Pr(e, "xl/worksheets/sheet.xml", !0) ? 1 : 0;
  e: for (m = 0; m != f.Worksheets; ++m) {
    var O = "sheet";
    if (C && C[m] ? (x = "xl/" + C[m][1].replace(/[\/]?xl\//, ""), ei(e, x) || (x = C[m][1]), ei(e, x) || (x = E.replace(/_rels\/.*$/, "") + C[m][1]), O = C[m][2]) : (x = "xl/worksheets/sheet" + (m + 1 - T) + "." + _, x = x.replace(/sheet0\./, "sheet.")), g = x.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels"), t && t.sheets != null) switch (typeof t.sheets) {
      case "number":
        if (m != t.sheets) continue e;
        break;
      case "string":
        if (f.SheetNames[m].toLowerCase() != t.sheets.toLowerCase()) continue e;
        break;
      default:
        if (Array.isArray && Array.isArray(t.sheets)) {
          for (var I = !1, k = 0; k != t.sheets.length; ++k)
            typeof t.sheets[k] == "number" && t.sheets[k] == m && (I = 1), typeof t.sheets[k] == "string" && t.sheets[k].toLowerCase() == f.SheetNames[m].toLowerCase() && (I = 1);
          if (!I) continue e;
        }
    }
    CEe(e, x, g, f.SheetNames[m], m, y, i, O, t, c, l, u);
  }
  return v = {
    Directory: a,
    Workbook: c,
    Props: f,
    Custprops: p,
    Deps: h,
    Sheets: i,
    SheetNames: f.SheetNames,
    Strings: L0,
    Styles: u,
    Themes: l,
    SSF: qn(jt)
  }, t && t.bookFiles && (e.files ? (v.keys = r, v.files = e.files) : (v.keys = [], v.files = {}, e.FullPaths.forEach(function(B, P) {
    B = B.replace(/^Root Entry[\/]/, ""), v.keys.push(B), v.files[B] = e.FileIndex[P];
  }))), t && t.bookVBA && (a.vba.length > 0 ? v.vbaraw = Pr(e, Yo(a.vba[0]), !0) : a.defaults && a.defaults.bin === G2e && (v.vbaraw = Pr(e, "xl/vbaProject.bin", !0))), v;
}
function TEe(e, t) {
  var n = t || {}, r = "Workbook", a = Dt.find(e, r);
  try {
    if (r = "/!DataSpaces/Version", a = Dt.find(e, r), !a || !a.content) throw new Error("ECMA-376 Encrypted file missing " + r);
    if (rbe(a.content), r = "/!DataSpaces/DataSpaceMap", a = Dt.find(e, r), !a || !a.content) throw new Error("ECMA-376 Encrypted file missing " + r);
    var o = obe(a.content);
    if (o.length !== 1 || o[0].comps.length !== 1 || o[0].comps[0].t !== 0 || o[0].name !== "StrongEncryptionDataSpace" || o[0].comps[0].v !== "EncryptedPackage")
      throw new Error("ECMA-376 Encrypted file bad " + r);
    if (r = "/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace", a = Dt.find(e, r), !a || !a.content) throw new Error("ECMA-376 Encrypted file missing " + r);
    var i = ibe(a.content);
    if (i.length != 1 || i[0] != "StrongEncryptionTransform")
      throw new Error("ECMA-376 Encrypted file bad " + r);
    if (r = "/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary", a = Dt.find(e, r), !a || !a.content) throw new Error("ECMA-376 Encrypted file missing " + r);
    lbe(a.content);
  } catch {
  }
  if (r = "/EncryptionInfo", a = Dt.find(e, r), !a || !a.content) throw new Error("ECMA-376 Encrypted file missing " + r);
  var s = ube(a.content);
  if (r = "/EncryptedPackage", a = Dt.find(e, r), !a || !a.content) throw new Error("ECMA-376 Encrypted file missing " + r);
  if (s[0] == 4 && typeof decrypt_agile < "u") return decrypt_agile(s[1], a.content, n.password || "", n);
  if (s[0] == 2 && typeof decrypt_std76 < "u") return decrypt_std76(s[1], a.content, n.password || "", n);
  throw new Error("File is password-protected");
}
function $Ee(e, t) {
  return t.bookType == "ods" ? HN(e, t) : t.bookType == "numbers" ? wEe(e, t) : t.bookType == "xlsb" ? OEe(e, t) : AEe(e, t);
}
function OEe(e, t) {
  mf = 1024, e && !e.SSF && (e.SSF = qn(jt)), e && e.SSF && (Id(), H1(e.SSF), t.revssf = V1(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF), t.rels = {}, t.wbrels = {}, t.Strings = /*::((*/
  [], t.Strings.Count = 0, t.Strings.Unique = 0, B0 ? t.revStrings = /* @__PURE__ */ new Map() : (t.revStrings = {}, t.revStrings.foo = [], delete t.revStrings.foo);
  var n = t.bookType == "xlsb" ? "bin" : "xml", r = gN.indexOf(t.bookType) > -1, a = nE();
  gE(t = t || {});
  var o = z4(), i = "", s = 0;
  if (t.cellXfs = [], mu(t.cellXfs, {}, { revssf: { General: 0 } }), e.Props || (e.Props = {}), i = "docProps/core.xml", en(o, i, kR(e.Props, t)), a.coreprops.push(i), Rn(t.rels, 2, i, cn.CORE_PROPS), i = "docProps/app.xml", !(e.Props && e.Props.SheetNames)) if (!e.Workbook || !e.Workbook.Sheets) e.Props.SheetNames = e.SheetNames;
  else {
    for (var l = [], u = 0; u < e.SheetNames.length; ++u)
      (e.Workbook.Sheets[u] || {}).Hidden != 2 && l.push(e.SheetNames[u]);
    e.Props.SheetNames = l;
  }
  for (e.Props.Worksheets = e.Props.SheetNames.length, en(o, i, NR(e.Props)), a.extprops.push(i), Rn(t.rels, 3, i, cn.EXT_PROPS), e.Custprops !== e.Props && Er(e.Custprops || {}).length > 0 && (i = "docProps/custom.xml", en(o, i, FR(e.Custprops)), a.custprops.push(i), Rn(t.rels, 4, i, cn.CUST_PROPS)), s = 1; s <= e.SheetNames.length; ++s) {
    var c = { "!id": {} }, f = e.Sheets[e.SheetNames[s - 1]], d = (f || {})["!type"] || "sheet";
    switch (d) {
      case "chart":
      default:
        i = "xl/worksheets/sheet" + s + "." + n, en(o, i, o4e(s - 1, i, t, e, c)), a.sheets.push(i), Rn(t.wbrels, -1, "worksheets/sheet" + s + "." + n, cn.WS[0]);
    }
    if (f) {
      var p = f["!comments"], v = !1, h = "";
      p && p.length > 0 && (h = "xl/comments" + s + "." + n, en(o, h, l4e(p, h)), a.comments.push(h), Rn(c, -1, "../comments" + s + "." + n, cn.CMNT), v = !0), f["!legacy"] && v && en(o, "xl/drawings/vmlDrawing" + s + ".vml", vN(s, f["!comments"])), delete f["!comments"], delete f["!legacy"];
    }
    c["!id"].rId1 && en(o, wp(i), Pf(c));
  }
  return t.Strings != null && t.Strings.length > 0 && (i = "xl/sharedStrings." + n, en(o, i, s4e(t.Strings, i, t)), a.strs.push(i), Rn(t.wbrels, -1, "sharedStrings." + n, cn.SST)), i = "xl/workbook." + n, en(o, i, a4e(e, i)), a.workbooks.push(i), Rn(t.rels, 1, i, cn.WB), i = "xl/theme/theme1.xml", en(o, i, lE(e.Themes, t)), a.themes.push(i), Rn(t.wbrels, -1, "theme/theme1.xml", cn.THEME), i = "xl/styles." + n, en(o, i, i4e(e, i, t)), a.styles.push(i), Rn(t.wbrels, -1, "styles." + n, cn.STY), e.vbaraw && r && (i = "xl/vbaProject.bin", en(o, i, e.vbaraw), a.vba.push(i), Rn(t.wbrels, -1, "vbaProject.bin", cn.VBA)), i = "xl/metadata." + n, en(o, i, u4e(i)), a.metadata.push(i), Rn(t.wbrels, -1, "metadata." + n, cn.XLMETA), en(o, "[Content_Types].xml", IR(a, t)), en(o, "_rels/.rels", Pf(t.rels)), en(o, "xl/_rels/workbook." + n + ".rels", Pf(t.wbrels)), delete t.revssf, delete t.ssf, o;
}
function AEe(e, t) {
  mf = 1024, e && !e.SSF && (e.SSF = qn(jt)), e && e.SSF && (Id(), H1(e.SSF), t.revssf = V1(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF), t.rels = {}, t.wbrels = {}, t.Strings = /*::((*/
  [], t.Strings.Count = 0, t.Strings.Unique = 0, B0 ? t.revStrings = /* @__PURE__ */ new Map() : (t.revStrings = {}, t.revStrings.foo = [], delete t.revStrings.foo);
  var n = "xml", r = gN.indexOf(t.bookType) > -1, a = nE();
  gE(t = t || {});
  var o = z4(), i = "", s = 0;
  if (t.cellXfs = [], mu(t.cellXfs, {}, { revssf: { General: 0 } }), e.Props || (e.Props = {}), i = "docProps/core.xml", en(o, i, kR(e.Props, t)), a.coreprops.push(i), Rn(t.rels, 2, i, cn.CORE_PROPS), i = "docProps/app.xml", !(e.Props && e.Props.SheetNames)) if (!e.Workbook || !e.Workbook.Sheets) e.Props.SheetNames = e.SheetNames;
  else {
    for (var l = [], u = 0; u < e.SheetNames.length; ++u)
      (e.Workbook.Sheets[u] || {}).Hidden != 2 && l.push(e.SheetNames[u]);
    e.Props.SheetNames = l;
  }
  e.Props.Worksheets = e.Props.SheetNames.length, en(o, i, NR(e.Props)), a.extprops.push(i), Rn(t.rels, 3, i, cn.EXT_PROPS), e.Custprops !== e.Props && Er(e.Custprops || {}).length > 0 && (i = "docProps/custom.xml", en(o, i, FR(e.Custprops)), a.custprops.push(i), Rn(t.rels, 4, i, cn.CUST_PROPS));
  var c = ["SheetJ5"];
  for (t.tcid = 0, s = 1; s <= e.SheetNames.length; ++s) {
    var f = { "!id": {} }, d = e.Sheets[e.SheetNames[s - 1]], p = (d || {})["!type"] || "sheet";
    switch (p) {
      case "chart":
      default:
        i = "xl/worksheets/sheet" + s + "." + n, en(o, i, ON(s - 1, t, e, f)), a.sheets.push(i), Rn(t.wbrels, -1, "worksheets/sheet" + s + "." + n, cn.WS[0]);
    }
    if (d) {
      var v = d["!comments"], h = !1, m = "";
      if (v && v.length > 0) {
        var y = !1;
        v.forEach(function(x) {
          x[1].forEach(function(g) {
            g.T == !0 && (y = !0);
          });
        }), y && (m = "xl/threadedComments/threadedComment" + s + "." + n, en(o, m, F2e(v, c, t)), a.threadedcomments.push(m), Rn(f, -1, "../threadedComments/threadedComment" + s + "." + n, cn.TCMNT)), m = "xl/comments" + s + "." + n, en(o, m, mN(v)), a.comments.push(m), Rn(f, -1, "../comments" + s + "." + n, cn.CMNT), h = !0;
      }
      d["!legacy"] && h && en(o, "xl/drawings/vmlDrawing" + s + ".vml", vN(s, d["!comments"])), delete d["!comments"], delete d["!legacy"];
    }
    f["!id"].rId1 && en(o, wp(i), Pf(f));
  }
  return t.Strings != null && t.Strings.length > 0 && (i = "xl/sharedStrings." + n, en(o, i, rN(t.Strings, t)), a.strs.push(i), Rn(t.wbrels, -1, "sharedStrings." + n, cn.SST)), i = "xl/workbook." + n, en(o, i, kN(e)), a.workbooks.push(i), Rn(t.rels, 1, i, cn.WB), i = "xl/theme/theme1.xml", en(o, i, lE(e.Themes, t)), a.themes.push(i), Rn(t.wbrels, -1, "theme/theme1.xml", cn.THEME), i = "xl/styles." + n, en(o, i, fN(e, t)), a.styles.push(i), Rn(t.wbrels, -1, "styles." + n, cn.STY), e.vbaraw && r && (i = "xl/vbaProject.bin", en(o, i, e.vbaraw), a.vba.push(i), Rn(t.wbrels, -1, "vbaProject.bin", cn.VBA)), i = "xl/metadata." + n, en(o, i, hN()), a.metadata.push(i), Rn(t.wbrels, -1, "metadata." + n, cn.XLMETA), c.length > 1 && (i = "xl/persons/person.xml", en(o, i, B2e(c)), a.people.push(i), Rn(t.wbrels, -1, "persons/person.xml", cn.PEOPLE)), en(o, "[Content_Types].xml", IR(a, t)), en(o, "_rels/.rels", Pf(t.rels)), en(o, "xl/_rels/workbook." + n + ".rels", Pf(t.wbrels)), delete t.revssf, delete t.ssf, o;
}
function yE(e, t) {
  var n = "";
  switch ((t || {}).type || "base64") {
    case "buffer":
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]];
    case "base64":
      n = Fo(e.slice(0, 12));
      break;
    case "binary":
      n = e;
      break;
    case "array":
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]];
    default:
      throw new Error("Unrecognized type " + (t && t.type || "undefined"));
  }
  return [n.charCodeAt(0), n.charCodeAt(1), n.charCodeAt(2), n.charCodeAt(3), n.charCodeAt(4), n.charCodeAt(5), n.charCodeAt(6), n.charCodeAt(7)];
}
function IEe(e, t) {
  return Dt.find(e, "EncryptedPackage") ? TEe(e, t) : FN(e, t);
}
function PEe(e, t) {
  var n, r = e, a = t || {};
  return a.type || (a.type = on && Buffer.isBuffer(e) ? "buffer" : "base64"), n = oR(r, a), EEe(n, a);
}
function VN(e, t) {
  var n = 0;
  e: for (; n < e.length; ) switch (e.charCodeAt(n)) {
    case 10:
    case 13:
    case 32:
      ++n;
      break;
    case 60:
      return YS(e.slice(n), t);
    default:
      break e;
  }
  return sd.to_workbook(e, t);
}
function DEe(e, t) {
  var n = "", r = yE(e, t);
  switch (t.type) {
    case "base64":
      n = Fo(e);
      break;
    case "binary":
      n = e;
      break;
    case "buffer":
      n = e.toString("binary");
      break;
    case "array":
      n = mc(e);
      break;
    default:
      throw new Error("Unrecognized type " + t.type);
  }
  return r[0] == 239 && r[1] == 187 && r[2] == 191 && (n = Hn(n)), t.type = "binary", VN(n, t);
}
function kEe(e, t) {
  var n = e;
  return t.type == "base64" && (n = Fo(n)), n = kl.utils.decode(1200, n.slice(2), "str"), t.type = "binary", VN(n, t);
}
function MEe(e) {
  return e.match(/[^\x00-\x7F]/) ? as(e) : e;
}
function jx(e, t, n, r) {
  return r ? (n.type = "string", sd.to_workbook(e, n)) : sd.to_workbook(t, n);
}
function ZS(e, t) {
  B4();
  var n = t || {};
  if (typeof ArrayBuffer < "u" && e instanceof ArrayBuffer) return ZS(new Uint8Array(e), (n = qn(n), n.type = "array", n));
  typeof Uint8Array < "u" && e instanceof Uint8Array && !n.type && (n.type = typeof Deno < "u" ? "buffer" : "array");
  var r = e, a = [0, 0, 0, 0], o = !1;
  if (n.cellStyles && (n.cellNF = !0, n.sheetStubs = !0), kf = {}, n.dateNF && (kf.dateNF = n.dateNF), n.type || (n.type = on && Buffer.isBuffer(e) ? "buffer" : "base64"), n.type == "file" && (n.type = on ? "buffer" : "binary", r = Oge(e), typeof Uint8Array < "u" && !on && (n.type = "array")), n.type == "string" && (o = !0, n.type = "binary", n.codepage = 65001, r = MEe(e)), n.type == "array" && typeof Uint8Array < "u" && e instanceof Uint8Array && typeof ArrayBuffer < "u") {
    var i = new ArrayBuffer(3), s = new Uint8Array(i);
    if (s.foo = "bar", !s.foo)
      return n = qn(n), n.type = "array", ZS(H4(r), n);
  }
  switch ((a = yE(r, n))[0]) {
    case 208:
      if (a[1] === 207 && a[2] === 17 && a[3] === 224 && a[4] === 161 && a[5] === 177 && a[6] === 26 && a[7] === 225) return IEe(Dt.read(r, n), n);
      break;
    case 9:
      if (a[1] <= 8) return FN(r, n);
      break;
    case 60:
      return YS(r, n);
    case 73:
      if (a[1] === 73 && a[2] === 42 && a[3] === 0) throw new Error("TIFF Image File is not a spreadsheet");
      if (a[1] === 68) return Hxe(r, n);
      break;
    case 84:
      if (a[1] === 65 && a[2] === 66 && a[3] === 76) return tN.to_workbook(r, n);
      break;
    case 80:
      return a[1] === 75 && a[2] < 9 && a[3] < 9 ? PEe(r, n) : jx(e, r, n, o);
    case 239:
      return a[3] === 60 ? YS(r, n) : jx(e, r, n, o);
    case 255:
      if (a[1] === 254)
        return kEe(r, n);
      if (a[1] === 0 && a[2] === 2 && a[3] === 0) return nc.to_workbook(r, n);
      break;
    case 0:
      if (a[1] === 0 && (a[2] >= 2 && a[3] === 0 || a[2] === 0 && (a[3] === 8 || a[3] === 9)))
        return nc.to_workbook(r, n);
      break;
    case 3:
    case 131:
    case 139:
    case 140:
      return KS.to_workbook(r, n);
    case 123:
      if (a[1] === 92 && a[2] === 114 && a[3] === 116) return lN.to_workbook(r, n);
      break;
    case 10:
    case 13:
    case 32:
      return DEe(r, n);
    case 137:
      if (a[1] === 80 && a[2] === 78 && a[3] === 71) throw new Error("PNG Image File is not a spreadsheet");
      break;
  }
  return Bxe.indexOf(a[0]) > -1 && a[2] <= 12 && a[3] <= 31 ? KS.to_workbook(r, n) : jx(e, r, n, o);
}
function UN(e, t) {
  switch (t.type) {
    case "base64":
    case "binary":
      break;
    case "buffer":
    case "array":
      t.type = "";
      break;
    case "file":
      return sh(t.file, Dt.write(e, { type: on ? "buffer" : "" }));
    case "string":
      throw new Error("'string' output type invalid for '" + t.bookType + "' files");
    default:
      throw new Error("Unrecognized type " + t.type);
  }
  return Dt.write(e, t);
}
function REe(e, t) {
  var n = qn(t || {}), r = $Ee(e, n);
  return NEe(r, n);
}
function NEe(e, t) {
  var n = {}, r = on ? "nodebuffer" : typeof Uint8Array < "u" ? "array" : "string";
  if (t.compression && (n.compression = "DEFLATE"), t.password) n.type = r;
  else switch (t.type) {
    case "base64":
      n.type = "base64";
      break;
    case "binary":
      n.type = "string";
      break;
    case "string":
      throw new Error("'string' output type invalid for '" + t.bookType + "' files");
    case "buffer":
    case "file":
      n.type = r;
      break;
    default:
      throw new Error("Unrecognized type " + t.type);
  }
  var a = e.FullPaths ? Dt.write(e, { fileType: "zip", type: (
    /*::(*/
    { nodebuffer: "buffer", string: "binary" }[n.type] || n.type
  ), compression: !!t.compression }) : e.generate(n);
  if (typeof Deno < "u" && typeof a == "string") {
    if (t.type == "binary" || t.type == "base64") return a;
    a = new Uint8Array(B1(a));
  }
  return t.password && typeof encrypt_agile < "u" ? UN(encrypt_agile(a, t.password), t) : t.type === "file" ? sh(t.file, a) : t.type == "string" ? Hn(
    /*::(*/
    a
    /*:: :any)*/
  ) : a;
}
function FEe(e, t) {
  var n = t || {}, r = R4e(e, n);
  return UN(r, n);
}
function Qi(e, t, n) {
  n || (n = "");
  var r = n + e;
  switch (t.type) {
    case "base64":
      return vp(as(r));
    case "binary":
      return as(r);
    case "string":
      return e;
    case "file":
      return sh(t.file, r, "utf8");
    case "buffer":
      return on ? cl(r, "utf8") : typeof TextEncoder < "u" ? new TextEncoder().encode(r) : Qi(r, { type: "binary" }).split("").map(function(a) {
        return a.charCodeAt(0);
      });
  }
  throw new Error("Unrecognized type " + t.type);
}
function LEe(e, t) {
  switch (t.type) {
    case "base64":
      return vp(e);
    case "binary":
      return e;
    case "string":
      return e;
    case "file":
      return sh(t.file, e, "binary");
    case "buffer":
      return on ? cl(e, "binary") : e.split("").map(function(n) {
        return n.charCodeAt(0);
      });
  }
  throw new Error("Unrecognized type " + t.type);
}
function xv(e, t) {
  switch (t.type) {
    case "string":
    case "base64":
    case "binary":
      for (var n = "", r = 0; r < e.length; ++r) n += String.fromCharCode(e[r]);
      return t.type == "base64" ? vp(n) : t.type == "string" ? Hn(n) : n;
    case "file":
      return sh(t.file, e);
    case "buffer":
      return e;
    default:
      throw new Error("Unrecognized type " + t.type);
  }
}
function zN(e, t) {
  B4(), PCe(e);
  var n = qn(t || {});
  if (n.cellStyles && (n.cellNF = !0, n.sheetStubs = !0), n.type == "array") {
    n.type = "binary";
    var r = zN(e, n);
    return n.type = "array", B1(r);
  }
  var a = 0;
  if (n.sheet && (typeof n.sheet == "number" ? a = n.sheet : a = e.SheetNames.indexOf(n.sheet), !e.SheetNames[a]))
    throw new Error("Sheet not found: " + n.sheet + " : " + typeof n.sheet);
  switch (n.bookType || "xlsb") {
    case "xml":
    case "xlml":
      return Qi(O4e(e, n), n);
    case "slk":
    case "sylk":
      return Qi(eN.from_sheet(e.Sheets[e.SheetNames[a]], n), n);
    case "htm":
    case "html":
      return Qi(rEe(e.Sheets[e.SheetNames[a]], n), n);
    case "txt":
      return LEe(UEe(e.Sheets[e.SheetNames[a]], n), n);
    case "csv":
      return Qi(GN(e.Sheets[e.SheetNames[a]], n), n, "\uFEFF");
    case "dif":
      return Qi(tN.from_sheet(e.Sheets[e.SheetNames[a]], n), n);
    case "dbf":
      return xv(KS.from_sheet(e.Sheets[e.SheetNames[a]], n), n);
    case "prn":
      return Qi(sd.from_sheet(e.Sheets[e.SheetNames[a]], n), n);
    case "rtf":
      return Qi(lN.from_sheet(e.Sheets[e.SheetNames[a]], n), n);
    case "eth":
      return Qi(nN.from_sheet(e.Sheets[e.SheetNames[a]], n), n);
    case "fods":
      return Qi(HN(e, n), n);
    case "wk1":
      return xv(nc.sheet_to_wk1(e.Sheets[e.SheetNames[a]], n), n);
    case "wk3":
      return xv(nc.book_to_wk3(e, n), n);
    case "biff2":
      n.biff || (n.biff = 2);
    case "biff3":
      n.biff || (n.biff = 3);
    case "biff4":
      return n.biff || (n.biff = 4), xv(LN(e, n), n);
    case "biff5":
      n.biff || (n.biff = 5);
    case "biff8":
    case "xla":
    case "xls":
      return n.biff || (n.biff = 8), FEe(e, n);
    case "xlsx":
    case "xlsm":
    case "xlam":
    case "xlsb":
    case "numbers":
    case "ods":
      return REe(e, n);
    default:
      throw new Error("Unrecognized bookType |" + n.bookType + "|");
  }
}
function BEe(e) {
  if (!e.bookType) {
    var t = {
      xls: "biff8",
      htm: "html",
      slk: "sylk",
      socialcalc: "eth",
      Sh33tJS: "WTF"
    }, n = e.file.slice(e.file.lastIndexOf(".")).toLowerCase();
    n.match(/^\.[a-z]+$/) && (e.bookType = n.slice(1)), e.bookType = t[e.bookType] || e.bookType;
  }
}
function HEe(e, t, n) {
  var r = {};
  return r.type = "file", r.file = t, BEe(r), zN(e, r);
}
function jEe(e, t, n, r, a, o, i, s) {
  var l = Kr(n), u = s.defval, c = s.raw || !Object.prototype.hasOwnProperty.call(s, "raw"), f = !0, d = a === 1 ? [] : {};
  if (a !== 1)
    if (Object.defineProperty) try {
      Object.defineProperty(d, "__rowNum__", { value: n, enumerable: !1 });
    } catch {
      d.__rowNum__ = n;
    }
    else d.__rowNum__ = n;
  if (!i || e[n]) for (var p = t.s.c; p <= t.e.c; ++p) {
    var v = i ? e[n][p] : e[r[p] + l];
    if (v === void 0 || v.t === void 0) {
      if (u === void 0) continue;
      o[p] != null && (d[o[p]] = u);
      continue;
    }
    var h = v.v;
    switch (v.t) {
      case "z":
        if (h == null) break;
        continue;
      case "e":
        h = h == 0 ? null : void 0;
        break;
      case "s":
      case "d":
      case "b":
      case "n":
        break;
      default:
        throw new Error("unrecognized type " + v.t);
    }
    if (o[p] != null) {
      if (h == null)
        if (v.t == "e" && h === null) d[o[p]] = null;
        else if (u !== void 0) d[o[p]] = u;
        else if (c && h === null) d[o[p]] = null;
        else continue;
      else
        d[o[p]] = c && (v.t !== "n" || v.t === "n" && s.rawNumbers !== !1) ? h : au(v, h, s);
      h != null && (f = !1);
    }
  }
  return { row: d, isempty: f };
}
function WN(e, t) {
  if (e == null || e["!ref"] == null) return [];
  var n = { t: "n", v: 0 }, r = 0, a = 1, o = [], i = 0, s = "", l = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, u = t || {}, c = u.range != null ? u.range : e["!ref"];
  switch (u.header === 1 ? r = 1 : u.header === "A" ? r = 2 : Array.isArray(u.header) ? r = 3 : u.header == null && (r = 0), typeof c) {
    case "string":
      l = kn(c);
      break;
    case "number":
      l = kn(e["!ref"]), l.s.r = c;
      break;
    default:
      l = c;
  }
  r > 0 && (a = 0);
  var f = Kr(l.s.r), d = [], p = [], v = 0, h = 0, m = Array.isArray(e), y = l.s.r, x = 0, g = {};
  m && !e[y] && (e[y] = []);
  var S = u.skipHidden && e["!cols"] || [], w = u.skipHidden && e["!rows"] || [];
  for (x = l.s.c; x <= l.e.c; ++x)
    if (!(S[x] || {}).hidden)
      switch (d[x] = Mr(x), n = m ? e[y][x] : e[d[x] + f], r) {
        case 1:
          o[x] = x - l.s.c;
          break;
        case 2:
          o[x] = d[x];
          break;
        case 3:
          o[x] = u.header[x - l.s.c];
          break;
        default:
          if (n == null && (n = { w: "__EMPTY", t: "s" }), s = i = au(n, null, u), h = g[i] || 0, !h) g[i] = 1;
          else {
            do
              s = i + "_" + h++;
            while (g[s]);
            g[i] = h, g[s] = 1;
          }
          o[x] = s;
      }
  for (y = l.s.r + a; y <= l.e.r; ++y)
    if (!(w[y] || {}).hidden) {
      var _ = jEe(e, l, y, d, r, o, m, u);
      (_.isempty === !1 || (r === 1 ? u.blankrows !== !1 : u.blankrows)) && (p[v++] = _.row);
    }
  return p.length = v, p;
}
var GO = /"/g;
function VEe(e, t, n, r, a, o, i, s) {
  for (var l = !0, u = [], c = "", f = Kr(n), d = t.s.c; d <= t.e.c; ++d)
    if (r[d]) {
      var p = s.dense ? (e[n] || [])[d] : e[r[d] + f];
      if (p == null) c = "";
      else if (p.v != null) {
        l = !1, c = "" + (s.rawNumbers && p.t == "n" ? p.v : au(p, null, s));
        for (var v = 0, h = 0; v !== c.length; ++v) if ((h = c.charCodeAt(v)) === a || h === o || h === 34 || s.forceQuotes) {
          c = '"' + c.replace(GO, '""') + '"';
          break;
        }
        c == "ID" && (c = '"ID"');
      } else p.f != null && !p.F ? (l = !1, c = "=" + p.f, c.indexOf(",") >= 0 && (c = '"' + c.replace(GO, '""') + '"')) : c = "";
      u.push(c);
    }
  return s.blankrows === !1 && l ? null : u.join(i);
}
function GN(e, t) {
  var n = [], r = t ?? {};
  if (e == null || e["!ref"] == null) return "";
  var a = kn(e["!ref"]), o = r.FS !== void 0 ? r.FS : ",", i = o.charCodeAt(0), s = r.RS !== void 0 ? r.RS : `
`, l = s.charCodeAt(0), u = new RegExp((o == "|" ? "\\|" : o) + "+$"), c = "", f = [];
  r.dense = Array.isArray(e);
  for (var d = r.skipHidden && e["!cols"] || [], p = r.skipHidden && e["!rows"] || [], v = a.s.c; v <= a.e.c; ++v) (d[v] || {}).hidden || (f[v] = Mr(v));
  for (var h = 0, m = a.s.r; m <= a.e.r; ++m)
    (p[m] || {}).hidden || (c = VEe(e, a, m, f, i, l, o, r), c != null && (r.strip && (c = c.replace(u, "")), (c || r.blankrows !== !1) && n.push((h++ ? s : "") + c)));
  return delete r.dense, n.join("");
}
function UEe(e, t) {
  t || (t = {}), t.FS = "	", t.RS = `
`;
  var n = GN(e, t);
  return n;
}
function KN() {
  return { SheetNames: [], Sheets: {} };
}
function YN(e, t, n, r) {
  var a = 1;
  if (!n) for (; a <= 65535 && e.SheetNames.indexOf(n = "Sheet" + a) != -1; ++a, n = void 0) ;
  if (!n || e.SheetNames.length >= 65535) throw new Error("Too many worksheets");
  if (r && e.SheetNames.indexOf(n) >= 0) {
    var o = n.match(/(^.*?)(\d+)$/);
    a = o && +o[2] || 0;
    var i = o && o[1] || n;
    for (++a; a <= 65535 && e.SheetNames.indexOf(n = i + a) != -1; ++a) ;
  }
  if (DN(n), e.SheetNames.indexOf(n) >= 0) throw new Error("Worksheet with name |" + n + "| already exists!");
  return e.SheetNames.push(n), e.Sheets[n] = t, n;
}
const zEe = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7.33333%2012.6667C10.2789%2012.6667%2012.6667%2010.2789%2012.6667%207.33333C12.6667%204.38781%2010.2789%202%207.33333%202C4.38781%202%202%204.38781%202%207.33333C2%2010.2789%204.38781%2012.6667%207.33333%2012.6667Z'%20stroke='%236a7184'%20stroke-width='1.33333'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M14.0001%2013.9996L11.1001%2011.0996'%20stroke='%236a7184'%20stroke-width='1.33333'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", WEe = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.3335 12H14.0002" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 12H2.00667" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.3335 8H14.0002" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 8H2.00667" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.3335 4H14.0002" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 4H2.00667" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, qN = (e) => (Xa("data-v-4a7be110"), e = e(), Za(), e), GEe = ["innerHTML"], KEe = /* @__PURE__ */ qN(() => /* @__PURE__ */ ke("span", { class: "label" }, "字段", -1)), YEe = {
  key: 0,
  class: "symbol"
}, qEe = ["src"], XEe = { class: "nc-fields-list-scroller" }, ZEe = { class: "nc-fields-list" }, QEe = {
  key: 0,
  class: "not-found"
}, JEe = { class: "nc-fields-list-drag-handle" }, e3e = ["src"], t3e = { class: "content" }, n3e = /* @__PURE__ */ qN(() => /* @__PURE__ */ ke("div", null, null, -1)), r3e = { class: "nc-fields-actions" }, a3e = /* @__PURE__ */ Me({
  __name: "FieldsMenu",
  setup(e) {
    var S;
    const t = Ke(jg, ne(!1)), { tableActivated: n } = Fn(mo()), r = V(() => {
      var w, _;
      return (_ = (w = n.value) == null ? void 0 : w.views) == null ? void 0 : _[0];
    }), a = V(() => {
      var w;
      return (w = n.value) == null ? void 0 : w.columns;
    }), o = ne(
      (S = a.value) == null ? void 0 : S.filter((w) => w.system ? t.value : !0).map((w) => ({ ...w }))
    );
    He(a, (w) => {
      o.value = w == null ? void 0 : w.filter((_) => _.system ? t.value : !0).map((_) => ({ ..._ }));
    });
    const i = Ke(vo), s = ne(""), { saveOrUpdate: l, loadViewColumns: u } = Od(), c = V(
      () => {
        var w;
        return ((w = o.value) == null ? void 0 : w.filter((_) => !t.value && Gr(_) ? !1 : s.value === "" ? !0 : _.column_name.toLowerCase().includes(s.value.toLowerCase()))) || [];
      }
    ), { eventBus: f } = Ss(), { addUndo: d, defineViewScope: p } = $d();
    f.on((w) => {
      (w === Ws.FIELD_RELOAD || w === Ws.MAPPED_BY_COLUMN_CHANGE) && u();
    });
    const v = V(
      () => {
        var w;
        return (w = c.value) == null ? void 0 : w.filter(
          (_) => _.grid_column_meta && !_.grid_column_meta.show
        ).length;
      }
    ), h = async (w, _ = !1) => {
      try {
        if (!o.value || (_ || d({
          undo: {
            fn: () => {
              if (!o.value) return;
              const b = o.value[w.moved.newIndex];
              o.value[w.moved.newIndex] = o.value[w.moved.oldIndex], o.value[w.moved.oldIndex] = b, h(
                {
                  moved: {
                    newIndex: w.moved.oldIndex,
                    oldIndex: w.moved.newIndex
                  }
                },
                !0
              );
            },
            args: []
          },
          redo: {
            fn: () => {
              if (!o.value) return;
              const b = o.value[w.moved.oldIndex];
              o.value[w.moved.oldIndex] = o.value[w.moved.newIndex], o.value[w.moved.newIndex] = b, h(w, !0);
            },
            args: []
          },
          scope: p({ view: r.value })
        }), o.value.length < 2)) return;
        await Promise.all(
          o.value.map(async (b, E) => {
            b.grid_column_meta && b.grid_column_meta.order !== E + 1 && (b.grid_column_meta.order = E + 1, await l(b.grid_column_meta, E, !0));
          })
        ), await u(), i == null || i.trigger();
      } catch (b) {
        wt.error(await Pn(b));
      }
    }, m = ne(!1), y = V({
      get: () => t.value,
      set: (w) => {
        d({
          undo: {
            fn: (_) => {
              t.value = !_;
            },
            args: [w]
          },
          redo: {
            fn: (_) => {
              t.value = _;
            },
            args: [w]
          },
          scope: p({ view: r.value })
        }), t.value = w;
      }
    }), { api: x } = Na();
    function g() {
      var b;
      const w = !y.value;
      y.value = w;
      const _ = (b = r.value) == null ? void 0 : b.id;
      _ && x.dbView.update(_, {
        show_system_fields: w
      }).finally(() => {
        i == null || i.trigger();
      });
    }
    return (w, _) => (Ce(), et(id, {
      visible: m.value,
      "onUpdate:visible": _[6] || (_[6] = (b) => m.value = b),
      trigger: ["click"],
      "overlay-class-name": "nc-dropdown-fields-menu nc-toolbar-dropdown"
    }, {
      overlay: Fe(() => {
        var b;
        return [
          ke("div", {
            class: "nc-fields-menu-dropdown nc-table-toolbar-menu",
            onClick: _[5] || (_[5] = ft(() => {
            }, ["stop"]))
          }, [
            ke("div", {
              class: "input-wrapper",
              onClick: _[1] || (_[1] = ft(() => {
              }, ["stop"]))
            }, [
              A(U(dr), {
                value: s.value,
                "onUpdate:value": _[0] || (_[0] = (E) => s.value = E),
                placeholder: "搜索字段",
                class: "search-input"
              }, {
                prefix: Fe(() => [
                  ke("img", {
                    class: "search-icon",
                    src: U(zEe)
                  }, null, 8, qEe)
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            ke("div", XEe, [
              ke("div", ZEe, [
                (b = o.value) != null && b.filter(
                  (E) => E.column_name.toLowerCase().includes(s.value.toLowerCase())
                ).length ? bt("", !0) : (Ce(), rt("div", QEe, " 无可用字段 ")),
                A(U(AM), {
                  modelValue: c.value,
                  "onUpdate:modelValue": _[3] || (_[3] = (E) => c.value = E),
                  "item-key": "id",
                  onChange: _[4] || (_[4] = (E) => h(E))
                }, {
                  item: Fe(({ element: E }) => [
                    (Ce(), rt("div", {
                      key: E.id,
                      class: "nc-fields-list-item",
                      onClick: _[2] || (_[2] = ft(() => {
                      }, ["stop"]))
                    }, [
                      ke("span", JEe, [
                        ke("img", {
                          style: { display: "block", width: "16px", "object-fit": "contain" },
                          src: U(IM)
                        }, null, 8, e3e)
                      ]),
                      ke("div", t3e, Wt(E.column_name), 1),
                      n3e
                    ]))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            ke("div", r3e, [
              s.value ? bt("", !0) : (Ce(), et(U(fn), {
                key: 0,
                class: "nc-fields-show-system-fields",
                onClick: g
              }, {
                default: Fe(() => [
                  Jt(Wt(y.value ? "隐藏系统字段" : "显示系统字段"), 1)
                ]),
                _: 1
              }))
            ])
          ])
        ];
      }),
      default: Fe(() => [
        ke("div", {
          class: tn({ "nc-active-btn": v.value })
        }, [
          A(U(fn), { class: "nc-fields-menu-btn nc-toolbar-btn" }, {
            default: Fe(() => [
              ke("span", { innerHTML: U(WEe) }, null, 8, GEe),
              KEe,
              v.value ? (Ce(), rt("span", YEe, Wt(v.value), 1)) : bt("", !0)
            ]),
            _: 1
          })
        ], 2)
      ]),
      _: 1
    }, 8, ["visible"]));
  }
}), o3e = /* @__PURE__ */ Cn(a3e, [["__scopeId", "data-v-4a7be110"]]), i3e = { class: "nc-field-list-select-item" }, s3e = /* @__PURE__ */ Me({
  __name: "FieldListAutoCompleteDropdown",
  props: {
    modelValue: {},
    isSort: { type: Boolean },
    columns: {},
    allowEmpty: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    var d;
    const { modelValue: n, isSort: r, allowEmpty: a, ...o } = e, i = t, s = Tt(o, "columns"), l = V({
      get: () => n,
      set: (p) => i("update:modelValue", p)
    }), { metaColumnById: u } = Od(), c = V(
      () => {
        var p, v;
        return (v = (p = s.value) == null ? void 0 : p.filter((h) => {
          var m;
          return Gr((m = u == null ? void 0 : u.value) == null ? void 0 : m[h.id]) ? (
            /** if the field is used in filter, then show it anyway */
            l.value === h.id || /** hide system columns if not enabled */
            !0
          ) : h.uidt === we.ID ? !1 : r ? !0 : !(h.colOptions && h.system);
        })) == null ? void 0 : v.map((h) => ({
          value: h.id,
          label: h.column_name,
          // icon: h(resolveComponent('SmartsheetHeaderCellIcon'), {
          //   columnMeta: c
          // }),
          c: h
        }));
      }
    ), f = (p, v) => {
      var h;
      return (h = v.label.toLowerCase()) == null ? void 0 : h.includes(p.toLowerCase());
    };
    return !l.value && a !== !0 && (l.value = ((d = c.value) == null ? void 0 : d[0].value) || ""), (p, v) => (Ce(), et(Lu, {
      value: l.value,
      "onUpdate:value": v[0] || (v[0] = (h) => l.value = h),
      "dropdown-match-select-width": !1,
      "show-search": "",
      placeholder: "选择字段",
      "filter-option": f,
      "popup-class-name": "nc-dropdown-toolbar-field-list"
    }, {
      default: Fe(() => [
        (Ce(!0), rt(dt, null, Vn(c.value, (h) => (Ce(), et(U(ia), {
          key: h.value,
          label: h.label,
          value: h.value
        }, {
          default: Fe(() => [
            ke("div", i3e, [
              ke("span", null, Wt(h.label), 1)
            ])
          ]),
          _: 2
        }, 1032, ["label", "value"]))), 128))
      ]),
      _: 1
    }, 8, ["value"]));
  }
}), XN = /* @__PURE__ */ Cn(s3e, [["__scopeId", "data-v-09dbb3be"]]), l3e = /* @__PURE__ */ Me({
  __name: "FilterInput",
  props: {
    column: {},
    filter: {}
  },
  emits: ["updateFilterValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = Tt(n, "column"), o = ne(!0);
    kt(bs, a), kt(gd, ql(o)), kt(vi, ne(!1));
    const i = {
      isSingleSelect: lM,
      isMultiSelect: uM,
      isDate: ES,
      isDateTime: TS,
      isDecimal: $S,
      isInt: Um,
      isFloat: CS
    }, { sqlUis: s } = Fn(ws()), l = V(() => {
      var _;
      const w = (_ = a.value) == null ? void 0 : _.source_id;
      return w ? s.value[w] : Object.values(s.value)[0];
    }), u = V(() => {
      var w;
      return a.value && ((w = l.value) == null ? void 0 : w.getAbstractType(a.value));
    }), c = (w) => {
      const _ = i[w];
      return !a.value || !_ ? !1 : _(a.value, u.value);
    }, f = V({
      get: () => n.filter.value,
      set: (w) => {
        r("updateFilterValue", w);
      }
    }), d = [
      { value: !0, label: "true" },
      { value: !1, label: "false" },
      { value: null, label: "unset" }
    ], p = (w) => ["anyof", "nanyof"].includes(w) ? FS : kM, v = (w) => ["daysAgo", "daysFromNow", "pastNumberOfDays", "nextNumberOfDays"].includes(w) ? LS : MM, h = V(() => ({
      isSingleSelect: p(n.filter.comparison_op),
      isMultiSelect: FS,
      isDate: v(n.filter.comparison_sub_op),
      isDateTime: v(n.filter.comparison_sub_op),
      isDecimal: LS,
      isInt: FM,
      isFloat: RM
    })), m = V(() => Object.keys(h.value).find((w) => c(w))), y = V(() => {
      switch (m.value) {
        case "isSingleSelect":
        case "isMultiSelect":
          return { disableOptionCreation: !0 };
        case "isDecimal":
        case "isFloat":
        case "isInt":
          return { style: "height:30px" };
        default:
          return {};
      }
    }), x = V(() => a.value && (Um(a.value, u) || ES(a.value, u) || TS(a.value, u))), g = ne(!1);
    kt(Cc, ne(!0));
    const S = ql(o);
    return (w, _) => a.value && U(sM)(a.value, u.value) ? (Ce(), et(U(fo), {
      key: 0,
      value: f.value,
      "onUpdate:value": _[0] || (_[0] = (b) => f.value = b),
      disabled: w.filter.readOnly,
      options: d
    }, null, 8, ["value", "disabled"])) : (Ce(), rt("div", {
      key: 1,
      class: tn(["nc-filter-input-wrapper", {
        "nc-filter-input-wrapper-has-padding": x.value,
        "nc-filter-input-wrapper-focus": g.value
      }]),
      onMouseup: _[6] || (_[6] = ft(() => {
      }, ["stop"]))
    }, [
      (Ce(), et(L9(m.value ? h.value[m.value] : BS), sc({
        modelValue: f.value,
        "onUpdate:modelValue": _[1] || (_[1] = (b) => f.value = b),
        value: f.value,
        "onUpdate:value": _[2] || (_[2] = (b) => f.value = b),
        editable: U(S),
        "onUpdate:editable": _[3] || (_[3] = (b) => Ft(S) ? S.value = b : null),
        disabled: w.filter.readOnly,
        placeholder: "请输入",
        column: a.value,
        style: { display: "flex", "border-radius": "8px !important" }
      }, y.value, {
        location: "filter",
        onFocus: _[4] || (_[4] = (b) => g.value = !0),
        onBlur: _[5] || (_[5] = (b) => g.value = !1)
      }), null, 16, ["modelValue", "value", "editable", "disabled", "column"]))
    ], 34));
  }
}), u3e = /* @__PURE__ */ Cn(l3e, [["__scopeId", "data-v-9a407ec5"]]), ZN = (e) => (Xa("data-v-e1e7dd9d"), e = e(), Za(), e), c3e = {
  key: 0,
  class: "nc-filter-is-group"
}, f3e = { class: "nc-filter-is-group-inner" }, d3e = {
  key: 0,
  class: "nc-filter-where"
}, p3e = { class: "nc-filter-select-item" }, h3e = ["src"], v3e = {
  key: 1,
  class: "nc-filter-not-group"
}, m3e = {
  key: 0,
  class: "nc-filter-where"
}, g3e = { class: "nc-filter-select-item" }, y3e = { class: "nc-filter-select-item" }, x3e = {
  key: 2,
  style: { display: "flex", "flex-group": "1" }
}, b3e = { class: "nc-filter-sub_operation-select-item" }, w3e = {
  key: 6,
  style: { "flex-grow": "1" }
}, S3e = ["src"], _3e = /* @__PURE__ */ ZN(() => /* @__PURE__ */ ke("span", null, " + 添加过滤器 ", -1)), C3e = /* @__PURE__ */ ZN(() => /* @__PURE__ */ ke("span", null, " + 添加筛选器组 ", -1)), E3e = {
  key: 1,
  style: { display: "flex", color: "rgba(154, 162, 175, 1)", "margin-top": "12px", "margin-left": "4px" }
}, T3e = /* @__PURE__ */ Me({
  __name: "ColumnFilter",
  props: {
    nestedLevel: { default: 0 },
    parentId: { default: void 0 },
    autoSave: { type: Boolean, default: !0 },
    showLoading: { type: Boolean, default: !0 },
    modelValue: {}
  },
  emits: ["update:filtersLength"],
  setup(e, { expose: t, emit: n }) {
    const r = e, a = n, { nestedLevel: o, parentId: i, autoSave: s, modelValue: l, showLoading: u } = ac(r), c = V(() => o.value > 0), f = [
      { value: "and", text: "And" },
      { value: "or", text: "Or" }
    ], d = Ke(vo), { nestedFilters: p } = Ss(), { tableActivated: v } = Fn(mo()), h = V(() => {
      var G, oe;
      return (oe = (G = v.value) == null ? void 0 : G.views) == null ? void 0 : oe[0];
    }), {
      filters: m,
      nonDeletedFilters: y,
      deleteFilter: x,
      saveOrUpdate: g,
      loadFilters: S,
      addFilter: w,
      addFilterGroup: _,
      sync: b,
      saveOrUpdateDebounced: E,
      isComparisonOpAllowed: C,
      isComparisonSubOpAllowed: T,
      types: O
    } = hM(
      h,
      i == null ? void 0 : i.value,
      V(() => s.value),
      () => {
        d.trigger({ shouldShowLoading: u.value, ignoreTableMetaUpdate: !0 });
      },
      l.value || p.value,
      !l.value
    ), I = ne(), k = ne(), B = ne(), P = V(() => {
      var G;
      return (G = v.value) == null ? void 0 : G.columns;
    }), N = (G) => {
      var oe;
      return (oe = P.value) == null ? void 0 : oe.find((L) => L.id === G.fk_column_id);
    }, M = ne({}), H = (G, oe) => {
      var L, re, j, J;
      return !(G.id || G.comparison_op && ((re = nv(G.comparison_op, (L = oe == null ? void 0 : oe.meta) == null ? void 0 : L.date_format).find(
        (ae) => ae.value === G.comparison_sub_op
      )) != null && re.ignoreVal) || (J = n0(O.value[oe.id], (j = oe == null ? void 0 : oe.meta) == null ? void 0 : j.date_format).find(
        (ae) => ae.value === G.comparison_op
      )) != null && J.ignoreVal || G.value);
    }, R = (G, oe) => {
      var re;
      const L = N(G);
      L && (L.uidt === we.SingleSelect && ["anyof", "nanyof"].includes(M.value[G.id]) && ["eq", "neq"].includes(G.comparison_op) ? G.value = null : ["blank", "notblank", "empty", "notempty", "null", "notnull"].includes(G.comparison_op) ? (G.value = null, G.comparison_sub_op = null) : te(O.value[L.id]) && (G.value = null, nv(G.comparison_op, (re = L == null ? void 0 : L.meta) == null ? void 0 : re.date_format).map((j) => j.value).includes(G.comparison_sub_op) || (G.comparison_op === "isWithin" ? G.comparison_sub_op = "pastNumberOfDays" : G.comparison_sub_op = "exactDate")), H(G, L) || g(G, oe), M.value[G.id] = G.comparison_op);
    };
    He(
      () => {
        var G;
        return (G = h.value) == null ? void 0 : G.id;
      },
      (G, oe) => {
        !c.value && G !== oe && S();
      }
    );
    const z = Ke(G8, ne({}));
    He(
      () => y.value.length,
      (G) => {
        z.value[(i == null ? void 0 : i.value) ?? "root"] = [...y.value], a("update:filtersLength", G ?? 0);
      }
    );
    const W = async (G, oe = !1, L = !0) => {
      var re;
      if (!L)
        for (let j = m.value.length - 1; j >= 0; j--)
          await x(m.value[j], j);
      if (await b(), !!((re = I.value) != null && re.length))
        for (const j of I.value)
          j.parentId && await j.applyChanges(G, !0);
    }, F = (G, oe) => {
      var re, j;
      const L = N(G);
      L && (G.comparison_op = (j = n0(
        O.value[L.id],
        (re = L == null ? void 0 : L.meta) == null ? void 0 : re.date_format
      ).find((J) => C(G, J))) == null ? void 0 : j.value, te(O.value[L.id]) && !["blank", "notblank"].includes(G.comparison_op) ? G.comparison_op === "isWithin" ? G.comparison_sub_op = "pastNumberOfDays" : G.comparison_sub_op = "exactDate" : G.comparison_sub_op = null, G.value = null, H(G, L) || g(G, oe));
    }, Y = (G, oe, L) => {
      oe.value = G, E(oe, L);
    };
    t({
      applyChanges: W,
      parentId: i == null ? void 0 : i.value
    });
    const X = () => {
      var G;
      (G = k.value) == null || G.scrollTo({
        top: k.value.scrollHeight,
        behavior: "smooth"
      });
    }, q = () => {
      var G;
      c.value && ((G = B == null ? void 0 : B.value) == null || G.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
      }));
    }, Q = async () => {
      await w(), c.value ? q() : X();
    }, ue = async () => {
      await _(), c.value ? q() : X();
    }, le = (G) => {
      var L, re, j, J, ae;
      const oe = N(G);
      return G.comparison_op ? G.comparison_sub_op ? !((j = nv(G.comparison_op, (re = (L = N(G)) == null ? void 0 : L.meta) == null ? void 0 : re.date_format).find(
        (he) => he.value === G.comparison_sub_op
      )) != null && j.ignoreVal) : !((ae = n0(O.value[oe == null ? void 0 : oe.id], (J = oe == null ? void 0 : oe.meta) == null ? void 0 : J.date_format).find(
        (he) => he.value === G.comparison_op
      )) != null && ae.ignoreVal) : !1;
    };
    Lt(() => {
      S();
    }), Sn(() => {
      i.value && delete z.value[i.value];
    });
    function te(G) {
      return [we.Date, we.DateTime].includes(G);
    }
    return (G, oe) => (Ce(), rt("div", {
      class: tn(["nc-filter-dropdown", {
        "nc-filter-dropdown-unnested": !c.value,
        "nc-filter-dropdown-nested": c.value
      }])
    }, [
      U(m) && U(m).length ? (Ce(), rt("div", {
        key: 0,
        ref_key: "wrapperDomRef",
        ref: k,
        class: tn(["nc-filter-grid", { "nc-scrollbar-md nc-filter-top-wrapper": !c.value }]),
        onClick: oe[4] || (oe[4] = ft(() => {
        }, ["stop"]))
      }, [
        (Ce(!0), rt(dt, null, Vn(U(m), (L, re) => (Ce(), rt(dt, { key: re }, [
          L.status !== "delete" ? (Ce(), rt(dt, { key: 0 }, [
            L.is_group ? (Ce(), rt("div", c3e, [
              ke("div", f3e, [
                re ? (Ce(), rt("div", {
                  key: `${re}nested`,
                  class: "nc-filter-logical-op"
                }, [
                  A(Lu, {
                    value: L.logical_op,
                    "onUpdate:value": (j) => L.logical_op = j,
                    "dropdown-match-select-width": !1,
                    class: "nc-filter-is-group-select",
                    placeholder: "Group op",
                    "popup-class-name": "nc-dropdown-filter-logical-op-group",
                    onClick: oe[0] || (oe[0] = ft(() => {
                    }, ["stop"])),
                    onChange: (j) => U(g)(L, re)
                  }, {
                    default: Fe(() => [
                      (Ce(), rt(dt, null, Vn(f, (j) => A(U(ia), {
                        key: j.value,
                        value: j.value
                      }, {
                        default: Fe(() => [
                          ke("div", p3e, Wt(j.value), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])), 64))
                    ]),
                    _: 2
                  }, 1032, ["value", "onUpdate:value", "onChange"])
                ])) : (Ce(), rt("span", d3e, "在哪里")),
                L.readOnly ? bt("", !0) : (Ce(), et(U(fn), {
                  key: re,
                  type: "text",
                  size: "small",
                  class: "nc-filter-item-remove-btn",
                  onClick: ft((j) => U(x)(L, re), ["stop"])
                }, {
                  default: Fe(() => [
                    ke("img", {
                      class: "trash-icon",
                      src: U(Zm)
                    }, null, 8, h3e)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              ]),
              ke("div", {
                class: "nc-filter-is-group-nest",
                style: _r({
                  backgroundColor: U(o) % 2 !== 0 ? "white" : "rgba(244, 244, 245, 1)"
                })
              }, [
                L.id || L.children ? (Ce(), et(QN, {
                  key: L.id ?? re,
                  ref_for: !0,
                  ref_key: "localNestedFilters",
                  ref: I,
                  modelValue: L.children,
                  "onUpdate:modelValue": (j) => L.children = j,
                  "nested-level": U(o) + 1,
                  "parent-id": L.id,
                  "auto-save": U(s)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "nested-level", "parent-id", "auto-save"])) : bt("", !0)
              ], 4)
            ])) : (Ce(), rt("div", v3e, [
              re ? (Ce(), et(Lu, {
                key: 1,
                value: L.logical_op,
                "onUpdate:value": (j) => L.logical_op = j,
                "dropdown-match-select-width": !1,
                class: "nc-filter-not-group-select",
                "hide-details": "",
                disabled: L.readOnly,
                "popup-class-name": "nc-dropdown-filter-logical-op",
                onChange: (j) => R(L, re),
                onClick: oe[1] || (oe[1] = ft(() => {
                }, ["stop"]))
              }, {
                default: Fe(() => [
                  (Ce(), rt(dt, null, Vn(f, (j) => A(U(ia), {
                    key: j.value,
                    value: j.value
                  }, {
                    default: Fe(() => [
                      ke("div", g3e, Wt(j.value), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"])), 64))
                ]),
                _: 2
              }, 1032, ["value", "onUpdate:value", "disabled", "onChange"])) : (Ce(), rt("span", m3e, "在哪里")),
              (Ce(), et(XN, {
                key: `${re}_6`,
                modelValue: L.fk_column_id,
                "onUpdate:modelValue": (j) => L.fk_column_id = j,
                class: "nc-filter-field-select",
                columns: P.value,
                disabled: L.readOnly,
                onClick: oe[2] || (oe[2] = ft(() => {
                }, ["stop"])),
                onChange: (j) => F(L, re)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "columns", "disabled", "onChange"])),
              A(Lu, {
                value: L.comparison_op,
                "onUpdate:value": (j) => L.comparison_op = j,
                "dropdown-match-select-width": !1,
                class: "caption nc-filter-operation-selects",
                placeholder: "操作",
                density: "compact",
                variant: "solo",
                disabled: L.readOnly,
                "hide-details": "",
                "popup-class-name": "nc-dropdown-filter-comp-op",
                onChange: (j) => R(L, re)
              }, {
                default: Fe(() => {
                  var j, J;
                  return [
                    (Ce(!0), rt(dt, null, Vn(U(n0)(
                      U(O)[L.fk_column_id],
                      (J = (j = N(L)) == null ? void 0 : j.meta) == null ? void 0 : J.date_format
                    ), (ae) => (Ce(), rt(dt, {
                      key: ae.value
                    }, [
                      U(C)(L, ae) ? (Ce(), et(U(ia), {
                        key: 0,
                        value: ae.value
                      }, {
                        default: Fe(() => [
                          ke("div", y3e, Wt(ae.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])) : bt("", !0)
                    ], 64))), 128))
                  ];
                }),
                _: 2
              }, 1032, ["value", "onUpdate:value", "disabled", "onChange"]),
              ["blank", "notblank"].includes(L.comparison_op) ? (Ce(), rt("div", x3e)) : te(U(O)[L.fk_column_id]) ? (Ce(), et(Lu, {
                key: 3,
                value: L.comparison_sub_op,
                "onUpdate:value": (j) => L.comparison_sub_op = j,
                "dropdown-match-select-width": !1,
                class: tn(["caption nc-filter-sub_operation-select", {
                  "hide-input": !le(L),
                  "show-input": le(L)
                }]),
                placeholder: "子操作",
                density: "compact",
                variant: "solo",
                disabled: L.readOnly,
                "hide-details": "",
                "popup-class-name": "nc-dropdown-filter-comp-sub-op",
                onChange: (j) => R(L, re)
              }, {
                default: Fe(() => {
                  var j, J;
                  return [
                    (Ce(!0), rt(dt, null, Vn(U(nv)(
                      L.comparison_op,
                      (J = (j = N(L)) == null ? void 0 : j.meta) == null ? void 0 : J.date_format
                    ), (ae) => (Ce(), rt(dt, {
                      key: ae.value
                    }, [
                      U(T)(L, ae) ? (Ce(), et(U(ia), {
                        key: 0,
                        value: ae.value
                      }, {
                        default: Fe(() => [
                          ke("div", b3e, Wt(ae.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])) : bt("", !0)
                    ], 64))), 128))
                  ];
                }),
                _: 2
              }, 1032, ["value", "onUpdate:value", "class", "disabled", "onChange"])) : bt("", !0),
              L.field && U(O)[L.field] === "boolean" ? (Ce(), et(U(aa), {
                key: 4,
                checked: L.value,
                "onUpdate:checked": (j) => L.value = j,
                dense: "",
                disabled: L.readOnly,
                onChange: (j) => U(g)(L, re)
              }, null, 8, ["checked", "onUpdate:checked", "disabled", "onChange"])) : bt("", !0),
              le(L) ? (Ce(), et(u3e, {
                key: 5,
                class: "nc-filter-value-select",
                column: { ...N(L), uidt: U(O)[L.fk_column_id] },
                filter: L,
                onUpdateFilterValue: (j) => Y(j, L, re),
                onClick: oe[3] || (oe[3] = ft(() => {
                }, ["stop"]))
              }, null, 8, ["column", "filter", "onUpdateFilterValue"])) : te(U(O)[L.fk_column_id]) ? bt("", !0) : (Ce(), rt("div", w3e)),
              L.readOnly ? bt("", !0) : (Ce(), et(U(fn), {
                key: 7,
                type: "text",
                size: "small",
                class: "nc-filter-item-remove-btn",
                style: { "align-self": "center" },
                onClick: ft((j) => U(x)(L, re), ["stop"])
              }, {
                default: Fe(() => [
                  ke("img", {
                    class: "trash-icon",
                    src: U(Zm)
                  }, null, 8, S3e)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            ]))
          ], 64)) : bt("", !0)
        ], 64))), 128))
      ], 2)) : bt("", !0),
      ke("div", {
        ref_key: "addFiltersRowDomRef",
        ref: B
      }, [
        A(U(fn), {
          size: "small",
          type: "text",
          style: { color: "rgba(51, 102, 255, 1) !important" },
          onClick: oe[5] || (oe[5] = ft((L) => Q(), ["stop"]))
        }, {
          default: Fe(() => [
            _3e
          ]),
          _: 1
        }),
        U(o) < 5 ? (Ce(), et(U(fn), {
          key: 0,
          type: "text",
          size: "small",
          onClick: oe[6] || (oe[6] = ft((L) => ue(), ["stop"]))
        }, {
          default: Fe(() => [
            C3e
          ]),
          _: 1
        })) : bt("", !0)
      ], 512),
      U(m).length ? bt("", !0) : (Ce(), rt("div", E3e, " 未添加过滤器 ")),
      uo(G.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), QN = /* @__PURE__ */ Cn(T3e, [["__scopeId", "data-v-e1e7dd9d"]]), $3e = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.6668 2H1.3335L6.66683 8.30667V12.6667L9.3335 14V8.30667L14.6668 2Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, O3e = (e) => (Xa("data-v-dcb23e6c"), e = e(), Za(), e), A3e = ["innerHTML"], I3e = /* @__PURE__ */ O3e(() => /* @__PURE__ */ ke("span", { class: "nc-filter-menu-btn-label" }, "筛选", -1)), P3e = {
  key: 0,
  class: "nc-filter-menu-btn-symbol"
}, D3e = /* @__PURE__ */ Me({
  __name: "ColumnFilterMenu",
  setup(e) {
    const { tableActivated: t } = Fn(mo()), n = V(() => {
      var f, d;
      return (d = (f = t.value) == null ? void 0 : f.views) == null ? void 0 : d[0];
    }), r = Ke(z8, ne(!1)), a = ne(), { nestedFilters: o } = Ss(), { nonDeletedFilters: i, loadFilters: s } = hM(
      n,
      void 0,
      V(() => !0),
      () => !1,
      o.value,
      !0
    ), l = ne(0);
    He(
      () => {
        var f;
        return (f = n.value) == null ? void 0 : f.id;
      },
      async (f) => {
        f && (await s(), l.value = i.value.length || 0);
      },
      { immediate: !0 }
    );
    const u = ne(!1), c = ne({});
    return kt(G8, c), (f, d) => (Ce(), et(id, {
      visible: u.value,
      "onUpdate:visible": d[1] || (d[1] = (p) => u.value = p),
      trigger: ["click"],
      "overlay-class-name": "nc-dropdown-filter-menu nc-toolbar-dropdown"
    }, {
      overlay: Fe(() => [
        A(QN, {
          ref_key: "filterComp",
          ref: a,
          class: "nc-table-toolbar-menu",
          "auto-save": !0,
          "onUpdate:filtersLength": d[0] || (d[0] = (p) => l.value = p)
        }, null, 512)
      ]),
      default: Fe(() => [
        ke("div", {
          class: tn({ "nc-active-btn": l.value })
        }, [
          A(U(fn), {
            class: "nc-filter-menu-btn nc-toolbar-btn",
            disabled: U(r)
          }, {
            default: Fe(() => [
              ke("span", { innerHTML: U($3e) }, null, 8, A3e),
              I3e,
              l.value ? (Ce(), rt("span", P3e, Wt(l.value), 1)) : bt("", !0)
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 2)
      ]),
      _: 1
    }, 8, ["visible"]));
  }
}), k3e = /* @__PURE__ */ Cn(D3e, [["__scopeId", "data-v-dcb23e6c"]]), M3e = ["onKeydown"], R3e = { class: "nc-sort-create-modal-header" }, N3e = { class: "nc-sort-create-modal-content" }, F3e = {
  key: 0,
  class: "nc-sort-create-modal-empty"
}, L3e = ["onClick"], B3e = /* @__PURE__ */ Me({
  __name: "CreateSort",
  props: {
    isParentOpen: { type: Boolean }
  },
  emits: ["created"],
  setup(e, { emit: t }) {
    const n = e, r = t, { isParentOpen: a } = ac(n), o = ne(), i = ne(""), s = ne(-1), { tableActivated: l } = Fn(mo()), u = V(() => {
      var m, y;
      return (y = (m = l.value) == null ? void 0 : m.views) == null ? void 0 : y[0];
    }), { metaColumnById: c } = Od(), { sorts: f } = A4(u), d = V(
      () => {
        var m, y;
        return ((y = (m = l.value) == null ? void 0 : m.columns) == null ? void 0 : y.filter((x) => {
          var g;
          return Gr((g = c == null ? void 0 : c.value) == null ? void 0 : g[x.id]) ? (
            /** hide system columns if not enabled */
            !0
          ) : x.uidt !== we.ID;
        }).filter((x) => !f.value.find((g) => g.fk_column_id === x.id)).filter((x) => {
          var g;
          return (g = x.title) == null ? void 0 : g.toLowerCase().includes(i.value.toLowerCase());
        })) ?? [];
      }
    ), p = (m) => {
      r("created", m);
    };
    He(
      a,
      () => {
        a.value && setTimeout(() => {
          var m;
          (m = o.value) == null || m.focus();
        }, 100);
      },
      {
        immediate: !0
      }
    ), Lt(() => {
      i.value = "", s.value = -1;
    });
    const v = () => {
      s.value = Math.min(s.value + 1, d.value.length - 1);
    }, h = () => {
      s.value = Math.max(s.value - 1, 0);
    };
    return (m, y) => {
      const x = Yx("SmartsheetHeaderIcon"), g = Yx("NcTooltip");
      return Ce(), rt("div", {
        class: "nc-sort-create-modal",
        onKeydown: [
          zt(ft(v, ["prevent"]), ["arrow-down"]),
          zt(ft(h, ["prevent"]), ["arrow-up"]),
          y[1] || (y[1] = zt(ft((S) => p(d.value[s.value]), ["prevent"]), ["enter"]))
        ]
      }, [
        ke("div", R3e, [
          Yn(ke("input", {
            ref_key: "inputRef",
            ref: o,
            "onUpdate:modelValue": y[0] || (y[0] = (S) => i.value = S),
            class: "nc-sort-create-modal-input",
            placeholder: "选择要排序的字段"
          }, null, 512), [
            [zi, i.value]
          ])
        ]),
        ke("div", N3e, [
          d.value.length ? bt("", !0) : (Ce(), rt("div", F3e, "空")),
          (Ce(!0), rt(dt, null, Vn(d.value, (S, w) => (Ce(), rt("div", {
            key: w,
            class: tn(["nc-sort-column-search-item", {
              actived: s.value === w
            }]),
            onClick: (_) => p(S)
          }, [
            A(x, { column: S }, null, 8, ["column"]),
            A(g, {
              class: "nc-sort-tooltip",
              "show-on-truncate-only": ""
            }, {
              title: Fe(() => [
                Jt(Wt(S.column_name), 1)
              ]),
              default: Fe(() => [
                Jt(Wt(S.column_name), 1)
              ]),
              _: 2
            }, 1024)
          ], 10, L3e))), 128))
        ])
      ], 40, M3e);
    };
  }
}), KO = /* @__PURE__ */ Cn(B3e, [["__scopeId", "data-v-39756d2b"]]), H3e = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 13.3334V10.6667" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 13.3334V6.66669" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 13.3334V2.66669" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, JN = (e) => (Xa("data-v-633e4a0e"), e = e(), Za(), e), j3e = ["innerHTML"], V3e = /* @__PURE__ */ JN(() => /* @__PURE__ */ ke("span", { class: "nc-sort-menu-btn-label" }, "排序", -1)), U3e = {
  key: 0,
  class: "nc-sort-menu-btn-label-symbol"
}, z3e = { class: "nc-sort-dir-select-item" }, W3e = ["src"], G3e = /* @__PURE__ */ JN(() => /* @__PURE__ */ ke("span", null, " + 添加排序选项 ", -1)), K3e = /* @__PURE__ */ Me({
  __name: "SortListMenu",
  setup(e) {
    const { tableActivated: t } = Fn(mo()), n = V(() => {
      var g, S;
      return (S = (g = t.value) == null ? void 0 : g.views) == null ? void 0 : S[0];
    }), r = Ke(z8, ne(!1)), a = Ke(vo), { eventBus: o } = Ss(), {
      sorts: i,
      saveOrUpdate: s,
      loadSorts: l,
      addSort: u,
      deleteSort: c
    } = A4(n, () => a == null ? void 0 : a.trigger()), { metaColumnById: f } = Od(), d = ne(!1);
    o.on((g) => {
      g === Ws.SORT_RELOAD && l();
    });
    const p = V(() => {
      var g;
      return ((g = t.value) == null ? void 0 : g.columns) || [];
    }), v = V(
      () => p.value.reduce(
        (g, S) => (g[S.id] = S, g),
        {}
      )
    ), h = V(() => {
      var g;
      return (g = p.value) == null ? void 0 : g.filter((S) => {
        var w;
        return Gr((w = f == null ? void 0 : f.value) == null ? void 0 : w[S.id]) ? (
          /** hide system columns if not enabled */
          !0
        ) : S.uidt !== we.ID;
      }).filter((S) => !i.value.find((w) => w.fk_column_id === S.id));
    }), m = (g) => !g || !v.value[g] ? "" : v.value[g].uidt || "", y = ne(!1), x = (g) => {
      u(!0, g);
      const S = i.value[i.value.length - 1];
      s(S, i.value.length - 1), d.value = !1;
    };
    return He(y, () => {
      y.value || (d.value = !1);
    }), He(
      () => {
        var g;
        return (g = n.value) == null ? void 0 : g.id;
      },
      (g) => {
        g && l();
      }
    ), Lt(() => {
      l();
    }), (g, S) => (Ce(), et(id, {
      visible: y.value,
      "onUpdate:visible": S[5] || (S[5] = (w) => y.value = w),
      trigger: ["click"],
      "overlay-class-name": "nc-dropdown-sort-menu nc-toolbar-dropdown"
    }, {
      overlay: Fe(() => [
        U(i).length ? (Ce(), rt("div", {
          key: 1,
          class: tn([{ "nc-sort-dropdown-content-has-length": U(i).length }, "nc-sort-dropdown-content nc-filter-list"])
        }, [
          ke("div", {
            class: "sort-grid nc-scrollbar-md",
            style: { "max-width": "30rem" },
            onClick: S[2] || (S[2] = ft(() => {
            }, ["stop"]))
          }, [
            (Ce(!0), rt(dt, null, Vn(U(i), (w, _) => (Ce(), rt(dt, { key: _ }, [
              A(XN, {
                modelValue: w.fk_column_id,
                "onUpdate:modelValue": [(b) => w.fk_column_id = b, (b) => U(s)(w, _)],
                class: "caption nc-sort-field-select",
                columns: p.value,
                "is-sort": "",
                onClick: S[0] || (S[0] = ft(() => {
                }, ["stop"]))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "columns"]),
              A(Lu, {
                value: w.direction,
                "onUpdate:value": (b) => w.direction = b,
                class: "nc-sort-dir-select",
                label: "操作",
                "popup-class-name": "sort-dir-dropdown nc-dropdown-sort-dir",
                onClick: S[1] || (S[1] = ft(() => {
                }, ["stop"])),
                onSelect: (b) => U(s)(w, _)
              }, {
                default: Fe(() => [
                  (Ce(!0), rt(dt, null, Vn(U(n0e)(m(w.fk_column_id)), (b, E) => (Ce(), et(U(ia), {
                    key: E,
                    value: b.value
                  }, {
                    default: Fe(() => [
                      ke("div", z3e, Wt(b.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))), 128))
                ]),
                _: 2
              }, 1032, ["value", "onUpdate:value", "onSelect"]),
              A(U(fn), {
                type: "text",
                size: "small",
                class: "nc-sort-item-remove-btn",
                onClick: ft((b) => U(c)(w, _), ["stop"])
              }, {
                default: Fe(() => [
                  ke("img", {
                    class: "trash-icon",
                    src: U(Zm)
                  }, null, 8, W3e)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 64))), 128))
          ]),
          h.value.length ? (Ce(), et(id, {
            key: 0,
            visible: d.value,
            "onUpdate:visible": S[4] || (S[4] = (w) => d.value = w),
            trigger: ["click"],
            style: { "margin-top": "0.75rem" },
            "overlay-class-name": "nc-toolbar-dropdown"
          }, {
            overlay: Fe(() => [
              A(KO, {
                "is-parent-open": d.value,
                onCreated: x
              }, null, 8, ["is-parent-open"])
            ]),
            default: Fe(() => [
              A(U(fn), {
                type: "text",
                size: "small",
                style: { color: "rgba(51, 102, 255, 1) !important", "margin-top": "12px" },
                onClick: S[3] || (S[3] = ft((w) => d.value = !0, ["stop"]))
              }, {
                default: Fe(() => [
                  G3e
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["visible"])) : bt("", !0)
        ], 2)) : (Ce(), et(KO, {
          key: 0,
          "is-parent-open": y.value,
          onCreated: x
        }, null, 8, ["is-parent-open"]))
      ]),
      default: Fe(() => {
        var w;
        return [
          ke("div", {
            class: tn({ "nc-active-btn": (w = U(i)) == null ? void 0 : w.length })
          }, [
            A(U(fn), {
              class: "nc-sort-menu-btn nc-toolbar-btn",
              disabled: U(r)
            }, {
              default: Fe(() => {
                var _;
                return [
                  ke("span", { innerHTML: U(H3e) }, null, 8, j3e),
                  V3e,
                  (_ = U(i)) != null && _.length ? (Ce(), rt("span", U3e, Wt(U(i).length), 1)) : bt("", !0)
                ];
              }),
              _: 1
            }, 8, ["disabled"])
          ], 2)
        ];
      }),
      _: 1
    }, 8, ["visible"]));
  }
}), Y3e = /* @__PURE__ */ Cn(K3e, [["__scopeId", "data-v-633e4a0e"]]), q3e = ["src"], X3e = /* @__PURE__ */ Me({
  __name: "SearchData",
  setup(e) {
    const t = Ke(vo), { tableActivated: n } = Fn(mo()), r = X8(), { search: a } = Fn(r), o = ne(!1), i = ne(!1), s = ne(null);
    Np(s, () => o.value = !1);
    const l = V(
      () => {
        var c, f, d;
        return (d = (f = (c = n.value) == null ? void 0 : c.columns) == null ? void 0 : f.filter((p) => !Gr(p))) == null ? void 0 : d.map((p) => ({
          value: p.id,
          label: p.column_name,
          column: p,
          primaryValue: p.pv
        }));
      }
    );
    Lt(() => {
      var c;
      (c = l.value) != null && c.length && (a.value.field = l.value[0].value);
    }), He(
      () => {
        var c;
        return (c = n.value) == null ? void 0 : c.id;
      },
      (c, f) => {
        var d;
        c !== f && r.loadFieldQuery((d = n.value) == null ? void 0 : d.id);
      },
      { immediate: !0 }
    );
    function u(c = !1) {
      c && !a.value.query || t.trigger({ shouldShowLoading: !1, offset: 0, ignoreTableMetaUpdate: !0 });
    }
    return gU(
      () => a.value.query,
      () => {
        u();
      },
      {
        debounce: 500,
        maxWait: 600
      }
    ), (c, f) => {
      var d;
      return Ce(), rt("div", {
        class: tn(["nc-toolbar-search", { highlight: ((d = U(a).query) == null ? void 0 : d.length) || i.value }])
      }, [
        ke("div", {
          ref_key: "searchDropdown",
          ref: s,
          class: tn(["nc-toolbar-search-dropdown", { open: o.value }]),
          onClick: f[2] || (f[2] = (p) => o.value = !o.value)
        }, [
          A(U(fo), {
            class: "field-select",
            value: U(a).field,
            "onUpdate:value": f[0] || (f[0] = (p) => U(a).field = p),
            open: o.value,
            placeholder: "搜索字段",
            size: "small",
            bordered: !1,
            "dropdown-match-select-width": !1,
            "popup-class-name": "nc-dropdown-toolbar-search-field-option",
            onChange: f[1] || (f[1] = (p) => u(!0))
          }, {
            suffixIcon: Fe(() => [
              ke("img", {
                class: "chevron-down",
                src: U(Wm)
              }, null, 8, q3e)
            ]),
            default: Fe(() => [
              (Ce(!0), rt(dt, null, Vn(l.value, (p) => (Ce(), et(U(ia), {
                key: p.value,
                value: p.value
              }, {
                default: Fe(() => [
                  Jt(Wt(p.label), 1)
                ]),
                _: 2
              }, 1032, ["value"]))), 128))
            ]),
            _: 1
          }, 8, ["value", "open"])
        ], 2),
        A(U(dr), {
          class: "nc-toolbar-search-input",
          value: U(a).query,
          "onUpdate:value": f[3] || (f[3] = (p) => U(a).query = p),
          size: "small",
          placeholder: "搜索",
          bordered: !1,
          onPressEnter: f[4] || (f[4] = (p) => u(!1)),
          onFocus: f[5] || (f[5] = (p) => i.value = !0),
          onBlur: f[6] || (f[6] = (p) => i.value = !1)
        }, null, 8, ["value"])
      ], 2);
    };
  }
}), Z3e = /* @__PURE__ */ Cn(X3e, [["__scopeId", "data-v-78cd3d50"]]), Q3e = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><defs><clipPath id="a"><rect width="16" height="16" rx="0"/></clipPath></defs><g clip-path="url(#a)"><circle cx="8" cy="8" r="6" fill="#7B61FF"/><path fill="#FFF" d="M7 11a1 1 0 1 0 2 0V5a1 1 0 0 0-2 0v6Z"/><path fill="#FFF" d="M5 7a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2H5Z"/></g></svg>', J3e = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none"><defs><clipPath id="a"><rect width="14" height="14" rx="0"/></clipPath></defs><g clip-path="url(#a)"><path fill="currentColor" fill-rule="evenodd" d="M2.79932,2.36267L2.79932,7.875L1.75,7.875L1.75,1.75C1.75,1.26675,2.14175,0.875,2.625,0.875L8.38756,0.875C8.61963,0.875,8.84219,0.9671875,9.00628,1.1312820000000001L11.9937,4.11872C12.1578,4.28281,12.25,4.50537,12.25,4.737439999999999L12.25,12.25C12.25,12.7332,11.8582,13.125,11.375,13.125L7.875,13.125L7.875,12.0752L10.76182,12.0752C11.0034,12.0752,11.1993,11.8793,11.1993,11.6377L11.1993,6.125L7.875,6.125C7.39175,6.125,7,5.73325,7,5.25L7,1.92517L3.23682,1.92517C2.99519,1.92517,2.79932,2.1210500000000003,2.79932,2.36267ZM8.04932,4.63767C8.04932,4.87929,8.245190000000001,5.07517,8.48682,5.07517L11.1993,5.07516L8.04932,1.92517L8.04932,4.63767ZM4.22081,13.1463L6.34204,11.025L4.22081,8.90381L3.47835,9.64627L4.3320799999999995,10.5L0.875,10.5L0.875,11.55L4.33216,11.55L3.47835,12.4038L4.22081,13.1463Z"/></g></svg>', eTe = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" class="ckxr3jobi__design-iconfont" viewBox="0 0 16 16"><defs><clipPath id="a"><rect width="16" height="16" rx="0"/></clipPath></defs><g clip-path="url(#a)"><path fill-rule="evenodd" d="M8.533910625,10.80687203125Q8.310410625,10.99219203125,8.020080625,10.99219203125Q7.729750625,10.99219203125,7.506250625,10.80687203125L7.501960625,10.80332203125L5.249090625,8.467742031250001L5.247640625,8.46610203125Q5.062000625,8.25602203125,5.070650625,7.97580203125Q5.079300625,7.69558203125,5.277540625,7.49734203125Q5.475770625,7.29911203125,5.755990625,7.29046203125Q6.036210625,7.28181203125,6.246290625,7.46745203125L6.248610625,7.46949203125L7.347580625,8.56847203125L7.347580625,1.85669903125L7.347780625,1.8535160312499999Q7.365810625,1.57119703125,7.572120625,1.37763903125Q7.778430625,1.18408203125,8.061330625,1.18408203125Q8.344220625,1.18408203125,8.550530625,1.37763903125Q8.756850625,1.57119703125,8.774870625,1.8535160312499999L8.775080625000001,1.85669903125L8.775080625000001,8.56847203125L9.874050625,7.46949203125L9.876360625,7.46745203125Q10.086450625,7.28181203125,10.366660625,7.29046203125Q10.646880625,7.29910203125,10.845120625,7.49734203125Q11.043360625,7.69558203125,11.052010625,7.97580203125Q11.060650625,8.25602203125,10.875010625,8.46610203125L10.872970625,8.46842203125L8.537490625,10.80389203125L8.533910625,10.80687203125ZM13.175790625,10.61009203125Q13.182690625,10.31884203125,13.388590625,10.11285203125Q13.594490625,9.90681203125,13.885690625,9.89993203125L13.888090625,9.89987203125L13.890490625,9.89993203125Q14.181690625,9.90681203125,14.387590625,10.11285203125Q14.593490625,10.31884203125,14.600390625,10.61009203125L14.600390625,10.61127203125L14.600390625,10.61245203125Q14.600390625,12.17888203125,13.614290625,13.28368203125Q12.626990625,14.38998203125,11.230860625,14.38998203125L4.769920625,14.38998203125Q3.373820625,14.38998203125,2.386487625,13.28368203125Q1.400390625,12.17888203125,1.400390625,10.61245203125L1.400390625,10.61127203125L1.4004185349,10.61009203125Q1.407301045,10.31884203125,1.613177625,10.11285203125Q1.819102625,9.90681203125,2.110332625,9.89993203125L2.1126956249999997,9.89987203125L2.115057625,9.89993203125Q2.406290625,9.90681203125,2.612210625,10.11285203125Q2.818090625,10.31884203125,2.8249706249999997,10.61009203125L2.825000625,10.61127203125L2.825000625,10.61245203125Q2.825000625,11.58968203125,3.395030625,12.27638203125Q3.960730625,12.95778203125,4.770790625,12.96488203125L11.230860625,12.96488203125Q12.038890625,12.96488203125,12.605690625,12.28018203125Q13.175790625,11.59148203125,13.175790625,10.61245203125L13.175790625,10.61127203125L13.175790625,10.61009203125Z"/></g></svg>', tTe = (e) => (Xa("data-v-2b4ac19d"), e = e(), Za(), e), nTe = { class: "nc-table-toolbar" }, rTe = ["innerHTML"], aTe = ["innerHTML"], oTe = ["innerHTML"], iTe = { class: "ss-toolbar-sort" }, sTe = /* @__PURE__ */ tTe(() => /* @__PURE__ */ ke("span", { class: "ss-toolbar-sep" }, null, -1)), lTe = /* @__PURE__ */ Me({
  __name: "Toolbar",
  props: {
    table: {},
    loadData: { type: Function },
    callAddEmptyRow: { type: Function },
    updateOrSaveRow: { type: Function },
    scrollToLastRow: { type: Function }
  },
  setup(e) {
    const { sorts: t, nestedFilters: n } = Ss(), { isViewsLoading: r } = Fn(pd()), { api: a } = Na(), o = Ke(K8), i = Ke(L_), s = e;
    function l() {
      var d, p;
      const f = (d = s.callAddEmptyRow) == null ? void 0 : d.call(s);
      f && ((p = s.updateOrSaveRow) == null || p.call(s, f)), nn().then(() => {
        var v;
        (v = s.scrollToLastRow) == null || v.call(s);
      });
    }
    const u = ne(!1), c = async (f) => {
      var g, S, w;
      const d = s.table.base_id, p = s.table.id, v = (S = (g = s.table.views) == null ? void 0 : g[0]) == null ? void 0 : S.id;
      if (!d || !p || !v)
        return;
      const h = (w = s.table.columns) == null ? void 0 : w.filter((_) => !_.system).map((_) => _.column_name);
      let m = 0, y = 1;
      const x = "base64";
      try {
        for (u.value = !0; !isNaN(m) && m > -1; ) {
          const _ = await a.dbViewRow.export("noco", d, p, v, f, {
            responseType: x,
            query: {
              fields: h,
              offset: m,
              sortArrJson: JSON.stringify(t.value),
              filterArrJson: JSON.stringify(n.value)
            }
          }), { data: b, headers: E } = _;
          if (f === "excel") {
            const C = ZS(b, { type: "base64" });
            HEe(C, `${s.table.title}_exported_${y++}.xlsx`);
          }
          m = +E["nc-export-offset"], m > -1 ? wt.info("下载更多文件") : (wt.success("成功导出所有表内数据"), u.value = !1);
        }
      } catch (_) {
        u.value = !1, wt.error(await Pn(_));
      }
    };
    return (f, d) => {
      var p;
      return Ce(), rt("div", nTe, [
        U(r) ? (Ce(), et(U(p4), {
          key: 0,
          active: "",
          class: "nc-table-toolbar-loading"
        })) : (Ce(), rt(dt, { key: 1 }, [
          ke("button", {
            class: "ss-toolbar-add-record",
            onClick: l
          }, [
            ke("span", { innerHTML: U(Q3e) }, null, 8, rTe),
            Jt(" 新增 ")
          ]),
          A(U(fn), {
            class: "ss-toolbar-import-record nc-toolbar-btn",
            onClick: d[0] || (d[0] = (v) => {
              var h, m;
              return (m = (h = U(i)).onImportRow) == null ? void 0 : m.call(h, f.table.id, f.table.base_id, f.table.source_id, f.loadData);
            })
          }, {
            default: Fe(() => [
              ke("span", { innerHTML: U(J3e) }, null, 8, aTe),
              Jt(" 导入 ")
            ]),
            _: 1
          }),
          A(U(fn), {
            class: "ss-toolbar-import-record nc-toolbar-btn",
            loading: u.value,
            onClick: d[1] || (d[1] = (v) => c(
              "excel"
              /* EXCEL */
            ))
          }, {
            default: Fe(() => [
              ke("span", { innerHTML: U(eTe) }, null, 8, oTe),
              Jt(" 导出 ")
            ]),
            _: 1
          }, 8, ["loading"]),
          A(o3e),
          A(k3e),
          ke("div", iTe, [
            A(Y3e)
          ]),
          A(Z3e),
          ((p = U(o)) == null ? void 0 : p.canUpdateTableMeta) !== !1 ? (Ce(), rt(dt, { key: 0 }, [
            sTe,
            ke("button", {
              class: "ss-toolbar-desc",
              onClick: d[2] || (d[2] = //@ts-ignore
              (...v) => U(i).onTableMetaUpdate && U(i).onTableMetaUpdate(...v))
            }, "调用配置")
          ], 64)) : bt("", !0)
        ], 64))
      ]);
    };
  }
}), uTe = /* @__PURE__ */ Cn(lTe, [["__scopeId", "data-v-2b4ac19d"]]), cTe = { class: "ss-wrapper" }, fTe = /* @__PURE__ */ Me({
  __name: "App",
  setup(e) {
    var S;
    const t = mo(), { tableActivated: n } = Fn(t), r = V(() => {
      var w, _;
      return (_ = (w = n.value) == null ? void 0 : w.views) == null ? void 0 : _[0];
    });
    PU(r, n);
    const a = Qs();
    kt(vo, a), T0e(r, n, () => a == null ? void 0 : a.trigger());
    const { xWhere: o } = Ss(), i = ne(null), {
      formattedData: s,
      paginationData: l,
      loadData: u,
      changePage: c,
      addEmptyRow: f,
      selectedAllRecords: d,
      updateOrSaveRow: p,
      bulkUpdateRows: v,
      deleteRow: h,
      deleteSelectedRows: m,
      deleteRangeOfRows: y
    } = E0e(n, r, o), x = ne(!!((S = r.value) != null && S.show_system_fields)), g = () => {
      var w;
      (w = i.value) == null || w.scrollToRow(s.value.length - 1);
    };
    return kt(jg, x), (w, _) => (Ce(), rt("div", cTe, [
      A(uTe, {
        table: U(n),
        "load-data": U(u),
        "scroll-to-last-row": g,
        "call-add-empty-row": U(f),
        "update-or-save-row": U(p)
      }, null, 8, ["table", "load-data", "call-add-empty-row", "update-or-save-row"]),
      A(qme, {
        ref_key: "tableInstance",
        ref: i,
        table: U(n),
        data: U(s),
        "selected-all-records": U(d),
        "onUpdate:selectedAllRecords": _[0] || (_[0] = (b) => Ft(d) ? d.value = b : null),
        "load-data": U(u),
        "pagination-data": U(l),
        "change-page": U(c),
        "call-add-empty-row": U(f),
        "update-or-save-row": U(p),
        "bulk-update-rows": U(v),
        "table-meta-update": U(t).updateTable,
        "delete-row": U(h),
        "delete-selected-rows": U(m),
        "delete-range-of-rows": U(y)
      }, null, 8, ["table", "data", "selected-all-records", "load-data", "pagination-data", "change-page", "call-add-empty-row", "update-or-save-row", "bulk-update-rows", "table-meta-update", "delete-row", "delete-selected-rows", "delete-range-of-rows"])
    ]));
  }
});
function mTe({
  dom: e,
  base: t,
  table: n,
  toolbar: r,
  onTableMetaUpdate: a,
  onTableMetaUpdated: o,
  onImportRow: i
}) {
  const s = qA(fTe), l = mj();
  s.use(l);
  const u = fM();
  s.provide("api", u);
  const c = qV(u.jobs.listen);
  s.provide(Y8, c), s.provide(L_, {
    onTableMetaUpdate: a,
    onTableMetaUpdated: o,
    onImportRow: i
  }), s.provide(K8, r);
  const f = ne(!1);
  s.provide(q8, f);
  const { setBase: d } = ws(), { activeTable: p } = mo(), v = ({ base: h, table: m }) => {
    h && d(h), h != null && h.id && m && p(h.id, m);
  };
  return v({ base: t, table: n }), s.mount(e), {
    reloadData: () => {
      f.value = !0;
    },
    update: v,
    unmount: () => {
      s.unmount();
    }
  };
}
export {
  xb as JobStatus,
  qV as JobSubscribe,
  YV as PgUi,
  mTe as Smartsheet,
  we as UITypes,
  Ace as uiTypes
};
